/**
 * tdesign v1.11.0
 * (c) 2025 tdesign
 * @license MIT
 */

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@vue/composition-api'), require('vue')) :
  typeof define === 'function' && define.amd ? define(['exports', '@vue/composition-api', 'vue'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.TDesign = {}, global.VueCompositionAPI, global.Vue));
})(this, (function (exports, VueCompositionAPI, Vue) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var VueCompositionAPI__default = /*#__PURE__*/_interopDefaultLegacy(VueCompositionAPI);
  var Vue__default = /*#__PURE__*/_interopDefaultLegacy(Vue);

  function _typeof$2(o) {
    "@babel/helpers - typeof";

    return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
      return typeof o;
    } : function (o) {
      return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof$2(o);
  }

  function toPrimitive(t, r) {
    if ("object" != _typeof$2(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r || "default");
      if ("object" != _typeof$2(i)) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
  }

  function toPropertyKey(t) {
    var i = toPrimitive(t, "string");
    return "symbol" == _typeof$2(i) ? i : i + "";
  }

  function _defineProperty$2(e, r, t) {
    return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = (typeof global === "undefined" ? "undefined" : _typeof$2(global)) == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof$2(self)) == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root$1 = freeGlobal || freeSelf || Function('return this')();

  /** Built-in value references. */
  var _Symbol = root$1.Symbol;

  /** Used for built-in method references. */
  var objectProto$i = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$g = objectProto$i.hasOwnProperty;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var nativeObjectToString$1 = objectProto$i.toString;

  /** Built-in value references. */
  var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

  /**
   * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the raw `toStringTag`.
   */
  function getRawTag(value) {
    var isOwn = hasOwnProperty$g.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];
    try {
      value[symToStringTag$1] = undefined;
      var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString$1.call(value);
    if (unmasked) {
      if (isOwn) {
        value[symToStringTag$1] = tag;
      } else {
        delete value[symToStringTag$1];
      }
    }
    return result;
  }

  /** Used for built-in method references. */
  var objectProto$h = Object.prototype;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var nativeObjectToString = objectProto$h.toString;

  /**
   * Converts `value` to a string using `Object.prototype.toString`.
   *
   * @private
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   */
  function objectToString(value) {
    return nativeObjectToString.call(value);
  }

  /** `Object#toString` result references. */
  var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

  /** Built-in value references. */
  var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

  /**
   * The base implementation of `getTag` without fallbacks for buggy environments.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */
  function baseGetTag(value) {
    if (value == null) {
      return value === undefined ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
  }

  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */
  function isObjectLike(value) {
    return value != null && _typeof$2(value) == 'object';
  }

  /** `Object#toString` result references. */
  var symbolTag$3 = '[object Symbol]';

  /**
   * Checks if `value` is classified as a `Symbol` primitive or object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
   * @example
   *
   * _.isSymbol(Symbol.iterator);
   * // => true
   *
   * _.isSymbol('abc');
   * // => false
   */
  function isSymbol(value) {
    return _typeof$2(value) == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag$3;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);
    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */
  var isArray = Array.isArray;
  var isArray$1 = isArray;

  /** Used as references for various `Number` constants. */
  var INFINITY$3 = 1 / 0;

  /** Used to convert symbols to primitives and strings. */
  var symbolProto$2 = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto$2 ? symbolProto$2.toString : undefined;

  /**
   * The base implementation of `_.toString` which doesn't convert nullish
   * values to empty strings.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */
  function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') {
      return value;
    }
    if (isArray$1(value)) {
      // Recursively convert values (susceptible to call stack limits).
      return arrayMap(value, baseToString) + '';
    }
    if (isSymbol(value)) {
      return symbolToString ? symbolToString.call(value) : '';
    }
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY$3 ? '-0' : result;
  }

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;
    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
  }

  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */
  function isObject(value) {
    var type = _typeof$2(value);
    return value != null && (type == 'object' || type == 'function');
  }

  /** Used as references for various `Number` constants. */
  var NAN = 0 / 0;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Built-in method references without a dependency on `root`. */
  var freeParseInt = parseInt;

  /**
   * Converts `value` to a number.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to process.
   * @returns {number} Returns the number.
   * @example
   *
   * _.toNumber(3.2);
   * // => 3.2
   *
   * _.toNumber(Number.MIN_VALUE);
   * // => 5e-324
   *
   * _.toNumber(Infinity);
   * // => Infinity
   *
   * _.toNumber('3.2');
   * // => 3.2
   */
  function toNumber$1(value) {
    if (typeof value == 'number') {
      return value;
    }
    if (isSymbol(value)) {
      return NAN;
    }
    if (isObject(value)) {
      var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
      value = isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') {
      return value === 0 ? value : +value;
    }
    value = baseTrim(value);
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
  }

  /** Used as references for various `Number` constants. */
  var INFINITY$2 = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

  /**
   * Converts `value` to a finite number.
   *
   * @static
   * @memberOf _
   * @since 4.12.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {number} Returns the converted number.
   * @example
   *
   * _.toFinite(3.2);
   * // => 3.2
   *
   * _.toFinite(Number.MIN_VALUE);
   * // => 5e-324
   *
   * _.toFinite(Infinity);
   * // => 1.7976931348623157e+308
   *
   * _.toFinite('3.2');
   * // => 3.2
   */
  function toFinite(value) {
    if (!value) {
      return value === 0 ? value : 0;
    }
    value = toNumber$1(value);
    if (value === INFINITY$2 || value === -INFINITY$2) {
      var sign = value < 0 ? -1 : 1;
      return sign * MAX_INTEGER;
    }
    return value === value ? value : 0;
  }

  /**
   * Converts `value` to an integer.
   *
   * **Note:** This method is loosely based on
   * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {number} Returns the converted integer.
   * @example
   *
   * _.toInteger(3.2);
   * // => 3
   *
   * _.toInteger(Number.MIN_VALUE);
   * // => 0
   *
   * _.toInteger(Infinity);
   * // => 1.7976931348623157e+308
   *
   * _.toInteger('3.2');
   * // => 3
   */
  function toInteger(value) {
    var result = toFinite(value),
      remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
  }

  /**
   * This method returns the first argument it receives.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Util
   * @param {*} value Any value.
   * @returns {*} Returns `value`.
   * @example
   *
   * var object = { 'a': 1 };
   *
   * console.log(_.identity(object) === object);
   * // => true
   */
  function identity(value) {
    return value;
  }

  /** `Object#toString` result references. */
  var asyncTag = '[object AsyncFunction]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */
  function isFunction(value) {
    if (!isObject(value)) {
      return false;
    }
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
  }

  /** Used to detect overreaching core-js shims. */
  var coreJsData = root$1['__core-js_shared__'];

  /** Used to detect methods masquerading as native. */
  var maskSrcKey = function () {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
  }();

  /**
   * Checks if `func` has its source masked.
   *
   * @private
   * @param {Function} func The function to check.
   * @returns {boolean} Returns `true` if `func` is masked, else `false`.
   */
  function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }

  /** Used for built-in method references. */
  var funcProto$2 = Function.prototype;

  /** Used to resolve the decompiled source of functions. */
  var funcToString$2 = funcProto$2.toString;

  /**
   * Converts `func` to its source code.
   *
   * @private
   * @param {Function} func The function to convert.
   * @returns {string} Returns the source code.
   */
  function toSource(func) {
    if (func != null) {
      try {
        return funcToString$2.call(func);
      } catch (e) {}
      try {
        return func + '';
      } catch (e) {}
    }
    return '';
  }

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar$1 = /[\\^$.*+?()[\]{}|]/g;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used for built-in method references. */
  var funcProto$1 = Function.prototype,
    objectProto$g = Object.prototype;

  /** Used to resolve the decompiled source of functions. */
  var funcToString$1 = funcProto$1.toString;

  /** Used to check objects for own properties. */
  var hasOwnProperty$f = objectProto$g.hasOwnProperty;

  /** Used to detect if a method is native. */
  var reIsNative = RegExp('^' + funcToString$1.call(hasOwnProperty$f).replace(reRegExpChar$1, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

  /**
   * The base implementation of `_.isNative` without bad shim checks.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a native function,
   *  else `false`.
   */
  function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) {
      return false;
    }
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Gets the native function at `key` of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the method to get.
   * @returns {*} Returns the function if it's native, else `undefined`.
   */
  function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
  }

  /* Built-in method references that are verified to be native. */
  var WeakMap$1 = getNative(root$1, 'WeakMap');

  /** Built-in value references. */
  var objectCreate = Object.create;

  /**
   * The base implementation of `_.create` without support for assigning
   * properties to the created object.
   *
   * @private
   * @param {Object} proto The object to inherit from.
   * @returns {Object} Returns the new object.
   */
  var baseCreate = function () {
    function object() {}
    return function (proto) {
      if (!isObject(proto)) {
        return {};
      }
      if (objectCreate) {
        return objectCreate(proto);
      }
      object.prototype = proto;
      var result = new object();
      object.prototype = undefined;
      return result;
    };
  }();

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0:
        return func.call(thisArg);
      case 1:
        return func.call(thisArg, args[0]);
      case 2:
        return func.call(thisArg, args[0], args[1]);
      case 3:
        return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * This method returns `undefined`.
   *
   * @static
   * @memberOf _
   * @since 2.3.0
   * @category Util
   * @example
   *
   * _.times(2, _.noop);
   * // => [undefined, undefined]
   */
  function noop() {
    // No operation performed.
  }

  /**
   * Copies the values of `source` to `array`.
   *
   * @private
   * @param {Array} source The array to copy values from.
   * @param {Array} [array=[]] The array to copy values to.
   * @returns {Array} Returns `array`.
   */
  function copyArray(source, array) {
    var index = -1,
      length = source.length;
    array || (array = Array(length));
    while (++index < length) {
      array[index] = source[index];
    }
    return array;
  }

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
    HOT_SPAN = 16;

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeNow = Date.now;

  /**
   * Creates a function that'll short out and invoke `identity` instead
   * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
   * milliseconds.
   *
   * @private
   * @param {Function} func The function to restrict.
   * @returns {Function} Returns the new shortable function.
   */
  function shortOut(func) {
    var count = 0,
      lastCalled = 0;
    return function () {
      var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);
      lastCalled = stamp;
      if (remaining > 0) {
        if (++count >= HOT_COUNT) {
          return arguments[0];
        }
      } else {
        count = 0;
      }
      return func.apply(undefined, arguments);
    };
  }

  /**
   * Creates a function that returns `value`.
   *
   * @static
   * @memberOf _
   * @since 2.4.0
   * @category Util
   * @param {*} value The value to return from the new function.
   * @returns {Function} Returns the new constant function.
   * @example
   *
   * var objects = _.times(2, _.constant({ 'a': 1 }));
   *
   * console.log(objects);
   * // => [{ 'a': 1 }, { 'a': 1 }]
   *
   * console.log(objects[0] === objects[1]);
   * // => true
   */
  function constant(value) {
    return function () {
      return value;
    };
  }

  var defineProperty = function () {
    try {
      var func = getNative(Object, 'defineProperty');
      func({}, '', {});
      return func;
    } catch (e) {}
  }();

  /**
   * The base implementation of `setToString` without support for hot loop shorting.
   *
   * @private
   * @param {Function} func The function to modify.
   * @param {Function} string The `toString` result.
   * @returns {Function} Returns `func`.
   */
  var baseSetToString = !defineProperty ? identity : function (func, string) {
    return defineProperty(func, 'toString', {
      'configurable': true,
      'enumerable': false,
      'value': constant(string),
      'writable': true
    });
  };

  /**
   * Sets the `toString` method of `func` to return `string`.
   *
   * @private
   * @param {Function} func The function to modify.
   * @param {Function} string The `toString` result.
   * @returns {Function} Returns `func`.
   */
  var setToString = shortOut(baseSetToString);

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
      length = array == null ? 0 : array.length;
    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);
    while (fromRight ? index-- : ++index < length) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
      length = array.length;
    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /** Used as references for various `Number` constants. */
  var MAX_SAFE_INTEGER$2 = 9007199254740991;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /**
   * Checks if `value` is a valid array-like index.
   *
   * @private
   * @param {*} value The value to check.
   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
   */
  function isIndex(value, length) {
    var type = _typeof$2(value);
    length = length == null ? MAX_SAFE_INTEGER$2 : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
  }

  /**
   * The base implementation of `assignValue` and `assignMergeValue` without
   * value checks.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */
  function baseAssignValue(object, key, value) {
    if (key == '__proto__' && defineProperty) {
      defineProperty(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
      });
    } else {
      object[key] = value;
    }
  }

  /**
   * Performs a
   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * comparison between two values to determine if they are equivalent.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.eq(object, object);
   * // => true
   *
   * _.eq(object, other);
   * // => false
   *
   * _.eq('a', 'a');
   * // => true
   *
   * _.eq('a', Object('a'));
   * // => false
   *
   * _.eq(NaN, NaN);
   * // => true
   */
  function eq(value, other) {
    return value === other || value !== value && other !== other;
  }

  /** Used for built-in method references. */
  var objectProto$f = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$e = objectProto$f.hasOwnProperty;

  /**
   * Assigns `value` to `key` of `object` if the existing value is not equivalent
   * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * for equality comparisons.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */
  function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty$e.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
      baseAssignValue(object, key, value);
    }
  }

  /**
   * Copies properties of `source` to `object`.
   *
   * @private
   * @param {Object} source The object to copy properties from.
   * @param {Array} props The property identifiers to copy.
   * @param {Object} [object={}] The object to copy properties to.
   * @param {Function} [customizer] The function to customize copied values.
   * @returns {Object} Returns `object`.
   */
  function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1,
      length = props.length;
    while (++index < length) {
      var key = props[index];
      var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
      if (newValue === undefined) {
        newValue = source[key];
      }
      if (isNew) {
        baseAssignValue(object, key, newValue);
      } else {
        assignValue(object, key, newValue);
      }
    }
    return object;
  }

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeMax$3 = Math.max;

  /**
   * A specialized version of `baseRest` which transforms the rest array.
   *
   * @private
   * @param {Function} func The function to apply a rest parameter to.
   * @param {number} [start=func.length-1] The start position of the rest parameter.
   * @param {Function} transform The rest array transform.
   * @returns {Function} Returns the new function.
   */
  function overRest(func, start, transform) {
    start = nativeMax$3(start === undefined ? func.length - 1 : start, 0);
    return function () {
      var args = arguments,
        index = -1,
        length = nativeMax$3(args.length - start, 0),
        array = Array(length);
      while (++index < length) {
        array[index] = args[start + index];
      }
      index = -1;
      var otherArgs = Array(start + 1);
      while (++index < start) {
        otherArgs[index] = args[index];
      }
      otherArgs[start] = transform(array);
      return apply(func, this, otherArgs);
    };
  }

  /**
   * The base implementation of `_.rest` which doesn't validate or coerce arguments.
   *
   * @private
   * @param {Function} func The function to apply a rest parameter to.
   * @param {number} [start=func.length-1] The start position of the rest parameter.
   * @returns {Function} Returns the new function.
   */
  function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + '');
  }

  /** Used as references for various `Number` constants. */
  var MAX_SAFE_INTEGER$1 = 9007199254740991;

  /**
   * Checks if `value` is a valid array-like length.
   *
   * **Note:** This method is loosely based on
   * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
   * @example
   *
   * _.isLength(3);
   * // => true
   *
   * _.isLength(Number.MIN_VALUE);
   * // => false
   *
   * _.isLength(Infinity);
   * // => false
   *
   * _.isLength('3');
   * // => false
   */
  function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
  }

  /**
   * Checks if `value` is array-like. A value is considered array-like if it's
   * not a function and has a `value.length` that's an integer greater than or
   * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
   * @example
   *
   * _.isArrayLike([1, 2, 3]);
   * // => true
   *
   * _.isArrayLike(document.body.children);
   * // => true
   *
   * _.isArrayLike('abc');
   * // => true
   *
   * _.isArrayLike(_.noop);
   * // => false
   */
  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
  }

  /**
   * Checks if the given arguments are from an iteratee call.
   *
   * @private
   * @param {*} value The potential iteratee value argument.
   * @param {*} index The potential iteratee index or key argument.
   * @param {*} object The potential iteratee object argument.
   * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
   *  else `false`.
   */
  function isIterateeCall(value, index, object) {
    if (!isObject(object)) {
      return false;
    }
    var type = _typeof$2(index);
    if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
      return eq(object[index], value);
    }
    return false;
  }

  /**
   * Creates a function like `_.assign`.
   *
   * @private
   * @param {Function} assigner The function to assign values.
   * @returns {Function} Returns the new assigner function.
   */
  function createAssigner(assigner) {
    return baseRest(function (object, sources) {
      var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;
      customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        customizer = length < 3 ? undefined : customizer;
        length = 1;
      }
      object = Object(object);
      while (++index < length) {
        var source = sources[index];
        if (source) {
          assigner(object, source, index, customizer);
        }
      }
      return object;
    });
  }

  /** Used for built-in method references. */
  var objectProto$e = Object.prototype;

  /**
   * Checks if `value` is likely a prototype object.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
   */
  function isPrototype(value) {
    var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$e;
    return value === proto;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
      result = Array(n);
    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /** `Object#toString` result references. */
  var argsTag$3 = '[object Arguments]';

  /**
   * The base implementation of `_.isArguments`.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   */
  function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag$3;
  }

  /** Used for built-in method references. */
  var objectProto$d = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$d = objectProto$d.hasOwnProperty;

  /** Built-in value references. */
  var propertyIsEnumerable$1 = objectProto$d.propertyIsEnumerable;

  /**
   * Checks if `value` is likely an `arguments` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   *  else `false`.
   * @example
   *
   * _.isArguments(function() { return arguments; }());
   * // => true
   *
   * _.isArguments([1, 2, 3]);
   * // => false
   */
  var isArguments = baseIsArguments(function () {
    return arguments;
  }()) ? baseIsArguments : function (value) {
    return isObjectLike(value) && hasOwnProperty$d.call(value, 'callee') && !propertyIsEnumerable$1.call(value, 'callee');
  };

  /**
   * This method returns `false`.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {boolean} Returns `false`.
   * @example
   *
   * _.times(2, _.stubFalse);
   * // => [false, false]
   */
  function stubFalse() {
    return false;
  }

  /** Detect free variable `exports`. */
  var freeExports$2 = (typeof exports === "undefined" ? "undefined" : _typeof$2(exports)) == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule$2 = freeExports$2 && (typeof module === "undefined" ? "undefined" : _typeof$2(module)) == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;

  /** Built-in value references. */
  var Buffer$1 = moduleExports$2 ? root$1.Buffer : undefined;

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeIsBuffer = Buffer$1 ? Buffer$1.isBuffer : undefined;

  /**
   * Checks if `value` is a buffer.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
   * @example
   *
   * _.isBuffer(new Buffer(2));
   * // => true
   *
   * _.isBuffer(new Uint8Array(2));
   * // => false
   */
  var isBuffer = nativeIsBuffer || stubFalse;

  /** `Object#toString` result references. */
  var argsTag$2 = '[object Arguments]',
    arrayTag$2 = '[object Array]',
    boolTag$4 = '[object Boolean]',
    dateTag$4 = '[object Date]',
    errorTag$3 = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag$6 = '[object Map]',
    numberTag$4 = '[object Number]',
    objectTag$4 = '[object Object]',
    regexpTag$3 = '[object RegExp]',
    setTag$6 = '[object Set]',
    stringTag$4 = '[object String]',
    weakMapTag$2 = '[object WeakMap]';
  var arrayBufferTag$3 = '[object ArrayBuffer]',
    dataViewTag$4 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] = typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] = typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] = typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] = typedArrayTags[uint32Tag$2] = true;
  typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] = typedArrayTags[arrayBufferTag$3] = typedArrayTags[boolTag$4] = typedArrayTags[dataViewTag$4] = typedArrayTags[dateTag$4] = typedArrayTags[errorTag$3] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$6] = typedArrayTags[numberTag$4] = typedArrayTags[objectTag$4] = typedArrayTags[regexpTag$3] = typedArrayTags[setTag$6] = typedArrayTags[stringTag$4] = typedArrayTags[weakMapTag$2] = false;

  /**
   * The base implementation of `_.isTypedArray` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   */
  function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function (value) {
      return func(value);
    };
  }

  /** Detect free variable `exports`. */
  var freeExports$1 = (typeof exports === "undefined" ? "undefined" : _typeof$2(exports)) == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule$1 = freeExports$1 && (typeof module === "undefined" ? "undefined" : _typeof$2(module)) == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports$1 && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = function () {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule$1 && freeModule$1.require && freeModule$1.require('util').types;
      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }();

  /* Node.js helper references. */
  var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /**
   * Checks if `value` is classified as a typed array.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   * @example
   *
   * _.isTypedArray(new Uint8Array);
   * // => true
   *
   * _.isTypedArray([]);
   * // => false
   */
  var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

  /** Used for built-in method references. */
  var objectProto$c = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$c = objectProto$c.hasOwnProperty;

  /**
   * Creates an array of the enumerable property names of the array-like `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @param {boolean} inherited Specify returning inherited property names.
   * @returns {Array} Returns the array of property names.
   */
  function arrayLikeKeys(value, inherited) {
    var isArr = isArray$1(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;
    for (var key in value) {
      if ((inherited || hasOwnProperty$c.call(value, key)) && !(skipIndexes && (
      // Safari 9 has enumerable `arguments.length` in strict mode.
      key == 'length' ||
      // Node.js 0.10 has enumerable non-index properties on buffers.
      isBuff && (key == 'offset' || key == 'parent') ||
      // PhantomJS 2 has enumerable non-index properties on typed arrays.
      isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
      // Skip index properties.
      isIndex(key, length)))) {
        result.push(key);
      }
    }
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function (arg) {
      return func(transform(arg));
    };
  }

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeKeys = overArg(Object.keys, Object);
  var nativeKeys$1 = nativeKeys;

  /** Used for built-in method references. */
  var objectProto$b = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$b = objectProto$b.hasOwnProperty;

  /**
   * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */
  function baseKeys(object) {
    if (!isPrototype(object)) {
      return nativeKeys$1(object);
    }
    var result = [];
    for (var key in Object(object)) {
      if (hasOwnProperty$b.call(object, key) && key != 'constructor') {
        result.push(key);
      }
    }
    return result;
  }

  /**
   * Creates an array of the own enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects. See the
   * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * for more details.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keys(new Foo);
   * // => ['a', 'b'] (iteration order is not guaranteed)
   *
   * _.keys('hi');
   * // => ['0', '1']
   */
  function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
  }

  /**
   * This function is like
   * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * except that it includes inherited enumerable properties.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */
  function nativeKeysIn(object) {
    var result = [];
    if (object != null) {
      for (var key in Object(object)) {
        result.push(key);
      }
    }
    return result;
  }

  /** Used for built-in method references. */
  var objectProto$a = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$a = objectProto$a.hasOwnProperty;

  /**
   * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */
  function baseKeysIn(object) {
    if (!isObject(object)) {
      return nativeKeysIn(object);
    }
    var isProto = isPrototype(object),
      result = [];
    for (var key in object) {
      if (!(key == 'constructor' && (isProto || !hasOwnProperty$a.call(object, key)))) {
        result.push(key);
      }
    }
    return result;
  }

  /**
   * Creates an array of the own and inherited enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keysIn(new Foo);
   * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
   */
  function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
  }

  /**
   * This method is like `_.assignIn` except that it accepts `customizer`
   * which is invoked to produce the assigned values. If `customizer` returns
   * `undefined`, assignment is handled by the method instead. The `customizer`
   * is invoked with five arguments: (objValue, srcValue, key, object, source).
   *
   * **Note:** This method mutates `object`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @alias extendWith
   * @category Object
   * @param {Object} object The destination object.
   * @param {...Object} sources The source objects.
   * @param {Function} [customizer] The function to customize assigned values.
   * @returns {Object} Returns `object`.
   * @see _.assignWith
   * @example
   *
   * function customizer(objValue, srcValue) {
   *   return _.isUndefined(objValue) ? srcValue : objValue;
   * }
   *
   * var defaults = _.partialRight(_.assignInWith, customizer);
   *
   * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
   * // => { 'a': 1, 'b': 2 }
   */
  var assignInWith = createAssigner(function (object, source, srcIndex, customizer) {
    copyObject(source, keysIn(source), object, customizer);
  });

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

  /**
   * Checks if `value` is a property name and not a property path.
   *
   * @private
   * @param {*} value The value to check.
   * @param {Object} [object] The object to query keys on.
   * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
   */
  function isKey(value, object) {
    if (isArray$1(value)) {
      return false;
    }
    var type = _typeof$2(value);
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
      return true;
    }
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
  }

  /* Built-in method references that are verified to be native. */
  var nativeCreate = getNative(Object, 'create');

  /**
   * Removes all key-value entries from the hash.
   *
   * @private
   * @name clear
   * @memberOf Hash
   */
  function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
  }

  /**
   * Removes `key` and its value from the hash.
   *
   * @private
   * @name delete
   * @memberOf Hash
   * @param {Object} hash The hash to modify.
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

  /** Used for built-in method references. */
  var objectProto$9 = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$9 = objectProto$9.hasOwnProperty;

  /**
   * Gets the hash value for `key`.
   *
   * @private
   * @name get
   * @memberOf Hash
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
      var result = data[key];
      return result === HASH_UNDEFINED$2 ? undefined : result;
    }
    return hasOwnProperty$9.call(data, key) ? data[key] : undefined;
  }

  /** Used for built-in method references. */
  var objectProto$8 = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$8 = objectProto$8.hasOwnProperty;

  /**
   * Checks if a hash value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Hash
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty$8.call(data, key);
  }

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

  /**
   * Sets the hash `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Hash
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the hash instance.
   */
  function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED$1 : value;
    return this;
  }

  /**
   * Creates a hash object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function Hash(entries) {
    var index = -1,
      length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  // Add methods to `Hash`.
  Hash.prototype.clear = hashClear;
  Hash.prototype['delete'] = hashDelete;
  Hash.prototype.get = hashGet;
  Hash.prototype.has = hashHas;
  Hash.prototype.set = hashSet;

  /**
   * Removes all key-value entries from the list cache.
   *
   * @private
   * @name clear
   * @memberOf ListCache
   */
  function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
  }

  /**
   * Gets the index at which the `key` is found in `array` of key-value pairs.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} key The key to search for.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function assocIndexOf(array, key) {
    var length = array.length;
    while (length--) {
      if (eq(array[length][0], key)) {
        return length;
      }
    }
    return -1;
  }

  /** Used for built-in method references. */
  var arrayProto$1 = Array.prototype;

  /** Built-in value references. */
  var splice$1 = arrayProto$1.splice;

  /**
   * Removes `key` and its value from the list cache.
   *
   * @private
   * @name delete
   * @memberOf ListCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function listCacheDelete(key) {
    var data = this.__data__,
      index = assocIndexOf(data, key);
    if (index < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
      data.pop();
    } else {
      splice$1.call(data, index, 1);
    }
    --this.size;
    return true;
  }

  /**
   * Gets the list cache value for `key`.
   *
   * @private
   * @name get
   * @memberOf ListCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function listCacheGet(key) {
    var data = this.__data__,
      index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
  }

  /**
   * Checks if a list cache value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf ListCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
  }

  /**
   * Sets the list cache `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf ListCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the list cache instance.
   */
  function listCacheSet(key, value) {
    var data = this.__data__,
      index = assocIndexOf(data, key);
    if (index < 0) {
      ++this.size;
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }
    return this;
  }

  /**
   * Creates an list cache object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function ListCache(entries) {
    var index = -1,
      length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  // Add methods to `ListCache`.
  ListCache.prototype.clear = listCacheClear;
  ListCache.prototype['delete'] = listCacheDelete;
  ListCache.prototype.get = listCacheGet;
  ListCache.prototype.has = listCacheHas;
  ListCache.prototype.set = listCacheSet;

  /* Built-in method references that are verified to be native. */
  var Map$1 = getNative(root$1, 'Map');

  /**
   * Removes all key-value entries from the map.
   *
   * @private
   * @name clear
   * @memberOf MapCache
   */
  function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
      'hash': new Hash(),
      'map': new (Map$1 || ListCache)(),
      'string': new Hash()
    };
  }

  /**
   * Checks if `value` is suitable for use as unique object key.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
   */
  function isKeyable(value) {
    var type = _typeof$2(value);
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
  }

  /**
   * Gets the data for `map`.
   *
   * @private
   * @param {Object} map The map to query.
   * @param {string} key The reference key.
   * @returns {*} Returns the map data.
   */
  function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
  }

  /**
   * Removes `key` and its value from the map.
   *
   * @private
   * @name delete
   * @memberOf MapCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
  }

  /**
   * Gets the map value for `key`.
   *
   * @private
   * @name get
   * @memberOf MapCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function mapCacheGet(key) {
    return getMapData(this, key).get(key);
  }

  /**
   * Checks if a map value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf MapCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function mapCacheHas(key) {
    return getMapData(this, key).has(key);
  }

  /**
   * Sets the map `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf MapCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the map cache instance.
   */
  function mapCacheSet(key, value) {
    var data = getMapData(this, key),
      size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
  }

  /**
   * Creates a map cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function MapCache(entries) {
    var index = -1,
      length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  // Add methods to `MapCache`.
  MapCache.prototype.clear = mapCacheClear;
  MapCache.prototype['delete'] = mapCacheDelete;
  MapCache.prototype.get = mapCacheGet;
  MapCache.prototype.has = mapCacheHas;
  MapCache.prototype.set = mapCacheSet;

  /** Error message constants. */
  var FUNC_ERROR_TEXT$2 = 'Expected a function';

  /**
   * Creates a function that memoizes the result of `func`. If `resolver` is
   * provided, it determines the cache key for storing the result based on the
   * arguments provided to the memoized function. By default, the first argument
   * provided to the memoized function is used as the map cache key. The `func`
   * is invoked with the `this` binding of the memoized function.
   *
   * **Note:** The cache is exposed as the `cache` property on the memoized
   * function. Its creation may be customized by replacing the `_.memoize.Cache`
   * constructor with one whose instances implement the
   * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
   * method interface of `clear`, `delete`, `get`, `has`, and `set`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Function
   * @param {Function} func The function to have its output memoized.
   * @param {Function} [resolver] The function to resolve the cache key.
   * @returns {Function} Returns the new memoized function.
   * @example
   *
   * var object = { 'a': 1, 'b': 2 };
   * var other = { 'c': 3, 'd': 4 };
   *
   * var values = _.memoize(_.values);
   * values(object);
   * // => [1, 2]
   *
   * values(other);
   * // => [3, 4]
   *
   * object.a = 2;
   * values(object);
   * // => [1, 2]
   *
   * // Modify the result cache.
   * values.cache.set(object, ['a', 'b']);
   * values(object);
   * // => ['a', 'b']
   *
   * // Replace `_.memoize.Cache`.
   * _.memoize.Cache = WeakMap;
   */
  function memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
      throw new TypeError(FUNC_ERROR_TEXT$2);
    }
    var _memoized = function memoized() {
      var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = _memoized.cache;
      if (cache.has(key)) {
        return cache.get(key);
      }
      var result = func.apply(this, args);
      _memoized.cache = cache.set(key, result) || cache;
      return result;
    };
    _memoized.cache = new (memoize.Cache || MapCache)();
    return _memoized;
  }

  // Expose `MapCache`.
  memoize.Cache = MapCache;

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /**
   * A specialized version of `_.memoize` which clears the memoized function's
   * cache when it exceeds `MAX_MEMOIZE_SIZE`.
   *
   * @private
   * @param {Function} func The function to have its output memoized.
   * @returns {Function} Returns the new memoized function.
   */
  function memoizeCapped(func) {
    var result = memoize(func, function (key) {
      if (cache.size === MAX_MEMOIZE_SIZE) {
        cache.clear();
      }
      return key;
    });
    var cache = result.cache;
    return result;
  }

  /** Used to match property names within property paths. */
  var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Converts `string` to a property path array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the property path array.
   */
  var stringToPath = memoizeCapped(function (string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */) {
      result.push('');
    }
    string.replace(rePropName, function (match, number, quote, subString) {
      result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
    });
    return result;
  });
  var stringToPath$1 = stringToPath;

  /**
   * Converts `value` to a string. An empty string is returned for `null`
   * and `undefined` values. The sign of `-0` is preserved.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   * @example
   *
   * _.toString(null);
   * // => ''
   *
   * _.toString(-0);
   * // => '-0'
   *
   * _.toString([1, 2, 3]);
   * // => '1,2,3'
   */
  function toString(value) {
    return value == null ? '' : baseToString(value);
  }

  /**
   * Casts `value` to a path array if it's not one.
   *
   * @private
   * @param {*} value The value to inspect.
   * @param {Object} [object] The object to query keys on.
   * @returns {Array} Returns the cast property path array.
   */
  function castPath(value, object) {
    if (isArray$1(value)) {
      return value;
    }
    return isKey(value, object) ? [value] : stringToPath$1(toString(value));
  }

  /** Used as references for various `Number` constants. */
  var INFINITY$1 = 1 / 0;

  /**
   * Converts `value` to a string key if it's not a string or symbol.
   *
   * @private
   * @param {*} value The value to inspect.
   * @returns {string|symbol} Returns the key.
   */
  function toKey(value) {
    if (typeof value == 'string' || isSymbol(value)) {
      return value;
    }
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY$1 ? '-0' : result;
  }

  /**
   * The base implementation of `_.get` without support for default values.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array|string} path The path of the property to get.
   * @returns {*} Returns the resolved value.
   */
  function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0,
      length = path.length;
    while (object != null && index < length) {
      object = object[toKey(path[index++])];
    }
    return index && index == length ? object : undefined;
  }

  /**
   * Gets the value at `path` of `object`. If the resolved value is
   * `undefined`, the `defaultValue` is returned in its place.
   *
   * @static
   * @memberOf _
   * @since 3.7.0
   * @category Object
   * @param {Object} object The object to query.
   * @param {Array|string} path The path of the property to get.
   * @param {*} [defaultValue] The value returned for `undefined` resolved values.
   * @returns {*} Returns the resolved value.
   * @example
   *
   * var object = { 'a': [{ 'b': { 'c': 3 } }] };
   *
   * _.get(object, 'a[0].b.c');
   * // => 3
   *
   * _.get(object, ['a', '0', 'b', 'c']);
   * // => 3
   *
   * _.get(object, 'a.b.c', 'default');
   * // => 'default'
   */
  function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
      length = values.length,
      offset = array.length;
    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /** Built-in value references. */
  var spreadableSymbol = _Symbol ? _Symbol.isConcatSpreadable : undefined;

  /**
   * Checks if `value` is a flattenable `arguments` object or array.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
   */
  function isFlattenable(value) {
    return isArray$1(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
  }

  /**
   * The base implementation of `_.flatten` with support for restricting flattening.
   *
   * @private
   * @param {Array} array The array to flatten.
   * @param {number} depth The maximum recursion depth.
   * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
   * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
   * @param {Array} [result=[]] The initial result value.
   * @returns {Array} Returns the new flattened array.
   */
  function baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1,
      length = array.length;
    predicate || (predicate = isFlattenable);
    result || (result = []);
    while (++index < length) {
      var value = array[index];
      if (depth > 0 && predicate(value)) {
        if (depth > 1) {
          // Recursively flatten arrays (susceptible to call stack limits).
          baseFlatten(value, depth - 1, predicate, isStrict, result);
        } else {
          arrayPush(result, value);
        }
      } else if (!isStrict) {
        result[result.length] = value;
      }
    }
    return result;
  }

  /**
   * Flattens `array` a single level deep.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Array
   * @param {Array} array The array to flatten.
   * @returns {Array} Returns the new flattened array.
   * @example
   *
   * _.flatten([1, [2, [3, [4]], 5]]);
   * // => [1, 2, [3, [4]], 5]
   */
  function flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseFlatten(array, 1) : [];
  }

  /**
   * A specialized version of `baseRest` which flattens the rest array.
   *
   * @private
   * @param {Function} func The function to apply a rest parameter to.
   * @returns {Function} Returns the new function.
   */
  function flatRest(func) {
    return setToString(overRest(func, undefined, flatten), func + '');
  }

  /** Built-in value references. */
  var getPrototype = overArg(Object.getPrototypeOf, Object);

  /** `Object#toString` result references. */
  var objectTag$3 = '[object Object]';

  /** Used for built-in method references. */
  var funcProto = Function.prototype,
    objectProto$7 = Object.prototype;

  /** Used to resolve the decompiled source of functions. */
  var funcToString = funcProto.toString;

  /** Used to check objects for own properties. */
  var hasOwnProperty$7 = objectProto$7.hasOwnProperty;

  /** Used to infer the `Object` constructor. */
  var objectCtorString = funcToString.call(Object);

  /**
   * Checks if `value` is a plain object, that is, an object created by the
   * `Object` constructor or one with a `[[Prototype]]` of `null`.
   *
   * @static
   * @memberOf _
   * @since 0.8.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   * }
   *
   * _.isPlainObject(new Foo);
   * // => false
   *
   * _.isPlainObject([1, 2, 3]);
   * // => false
   *
   * _.isPlainObject({ 'x': 0, 'y': 0 });
   * // => true
   *
   * _.isPlainObject(Object.create(null));
   * // => true
   */
  function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag$3) {
      return false;
    }
    var proto = getPrototype(value);
    if (proto === null) {
      return true;
    }
    var Ctor = hasOwnProperty$7.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
  }

  /** `Object#toString` result references. */
  var domExcTag = '[object DOMException]',
    errorTag$2 = '[object Error]';

  /**
   * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
   * `SyntaxError`, `TypeError`, or `URIError` object.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
   * @example
   *
   * _.isError(new Error);
   * // => true
   *
   * _.isError(Error);
   * // => false
   */
  function isError(value) {
    if (!isObjectLike(value)) {
      return false;
    }
    var tag = baseGetTag(value);
    return tag == errorTag$2 || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
  }

  /**
   * Attempts to invoke `func`, returning either the result or the caught error
   * object. Any additional arguments are provided to `func` when it's invoked.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Util
   * @param {Function} func The function to attempt.
   * @param {...*} [args] The arguments to invoke `func` with.
   * @returns {*} Returns the `func` result or error object.
   * @example
   *
   * // Avoid throwing errors for invalid selectors.
   * var elements = _.attempt(function(selector) {
   *   return document.querySelectorAll(selector);
   * }, '>_>');
   *
   * if (_.isError(elements)) {
   *   elements = [];
   * }
   */
  var attempt = baseRest(function (func, args) {
    try {
      return apply(func, undefined, args);
    } catch (e) {
      return isError(e) ? e : new Error(e);
    }
  });
  var attempt$1 = attempt;

  /**
   * The base implementation of `_.slice` without an iteratee call guard.
   *
   * @private
   * @param {Array} array The array to slice.
   * @param {number} [start=0] The start position.
   * @param {number} [end=array.length] The end position.
   * @returns {Array} Returns the slice of `array`.
   */
  function baseSlice(array, start, end) {
    var index = -1,
      length = array.length;
    if (start < 0) {
      start = -start > length ? 0 : length + start;
    }
    end = end > length ? length : end;
    if (end < 0) {
      end += length;
    }
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while (++index < length) {
      result[index] = array[index + start];
    }
    return result;
  }

  /**
   * Casts `array` to a slice if it's needed.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {number} start The start position.
   * @param {number} [end=array.length] The end position.
   * @returns {Array} Returns the cast slice.
   */
  function castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : baseSlice(array, start, end);
  }

  /** Used to compose unicode character classes. */
  var rsAstralRange$3 = "\\ud800-\\udfff",
    rsComboMarksRange$4 = "\\u0300-\\u036f",
    reComboHalfMarksRange$4 = "\\ufe20-\\ufe2f",
    rsComboSymbolsRange$4 = "\\u20d0-\\u20ff",
    rsComboRange$4 = rsComboMarksRange$4 + reComboHalfMarksRange$4 + rsComboSymbolsRange$4,
    rsVarRange$3 = "\\ufe0e\\ufe0f";

  /** Used to compose unicode capture groups. */
  var rsZWJ$3 = "\\u200d";

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ$3 + rsAstralRange$3 + rsComboRange$4 + rsVarRange$3 + ']');

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /** Used to compose unicode character classes. */
  var rsAstralRange$2 = "\\ud800-\\udfff",
    rsComboMarksRange$3 = "\\u0300-\\u036f",
    reComboHalfMarksRange$3 = "\\ufe20-\\ufe2f",
    rsComboSymbolsRange$3 = "\\u20d0-\\u20ff",
    rsComboRange$3 = rsComboMarksRange$3 + reComboHalfMarksRange$3 + rsComboSymbolsRange$3,
    rsVarRange$2 = "\\ufe0e\\ufe0f";

  /** Used to compose unicode capture groups. */
  var rsAstral$1 = '[' + rsAstralRange$2 + ']',
    rsCombo$3 = '[' + rsComboRange$3 + ']',
    rsFitz$2 = "\\ud83c[\\udffb-\\udfff]",
    rsModifier$2 = '(?:' + rsCombo$3 + '|' + rsFitz$2 + ')',
    rsNonAstral$2 = '[^' + rsAstralRange$2 + ']',
    rsRegional$2 = "(?:\\ud83c[\\udde6-\\uddff]){2}",
    rsSurrPair$2 = "[\\ud800-\\udbff][\\udc00-\\udfff]",
    rsZWJ$2 = "\\u200d";

  /** Used to compose unicode regexes. */
  var reOptMod$2 = rsModifier$2 + '?',
    rsOptVar$2 = '[' + rsVarRange$2 + ']?',
    rsOptJoin$2 = '(?:' + rsZWJ$2 + '(?:' + [rsNonAstral$2, rsRegional$2, rsSurrPair$2].join('|') + ')' + rsOptVar$2 + reOptMod$2 + ')*',
    rsSeq$2 = rsOptVar$2 + reOptMod$2 + rsOptJoin$2,
    rsSymbol$1 = '(?:' + [rsNonAstral$2 + rsCombo$3 + '?', rsCombo$3, rsRegional$2, rsSurrPair$2, rsAstral$1].join('|') + ')';

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode$1 = RegExp(rsFitz$2 + '(?=' + rsFitz$2 + ')|' + rsSymbol$1 + rsSeq$2, 'g');

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode$1) || [];
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
  }

  /**
   * Creates a function like `_.lowerFirst`.
   *
   * @private
   * @param {string} methodName The name of the `String` case method to use.
   * @returns {Function} Returns the new case function.
   */
  function createCaseFirst(methodName) {
    return function (string) {
      string = toString(string);
      var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
      var chr = strSymbols ? strSymbols[0] : string.charAt(0);
      var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
      return chr[methodName]() + trailing;
    };
  }

  /**
   * Converts the first character of `string` to upper case.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category String
   * @param {string} [string=''] The string to convert.
   * @returns {string} Returns the converted string.
   * @example
   *
   * _.upperFirst('fred');
   * // => 'Fred'
   *
   * _.upperFirst('FRED');
   * // => 'FRED'
   */
  var upperFirst = createCaseFirst('toUpperCase');
  var upperFirst$1 = upperFirst;

  /**
   * Converts the first character of `string` to upper case and the remaining
   * to lower case.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category String
   * @param {string} [string=''] The string to capitalize.
   * @returns {string} Returns the capitalized string.
   * @example
   *
   * _.capitalize('FRED');
   * // => 'Fred'
   */
  function capitalize(string) {
    return upperFirst$1(toString(string).toLowerCase());
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
      length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function (key) {
      return object == null ? undefined : object[key];
    };
  }

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    "\u0100": 'A',
    "\u0102": 'A',
    "\u0104": 'A',
    "\u0101": 'a',
    "\u0103": 'a',
    "\u0105": 'a',
    "\u0106": 'C',
    "\u0108": 'C',
    "\u010A": 'C',
    "\u010C": 'C',
    "\u0107": 'c',
    "\u0109": 'c',
    "\u010B": 'c',
    "\u010D": 'c',
    "\u010E": 'D',
    "\u0110": 'D',
    "\u010F": 'd',
    "\u0111": 'd',
    "\u0112": 'E',
    "\u0114": 'E',
    "\u0116": 'E',
    "\u0118": 'E',
    "\u011A": 'E',
    "\u0113": 'e',
    "\u0115": 'e',
    "\u0117": 'e',
    "\u0119": 'e',
    "\u011B": 'e',
    "\u011C": 'G',
    "\u011E": 'G',
    "\u0120": 'G',
    "\u0122": 'G',
    "\u011D": 'g',
    "\u011F": 'g',
    "\u0121": 'g',
    "\u0123": 'g',
    "\u0124": 'H',
    "\u0126": 'H',
    "\u0125": 'h',
    "\u0127": 'h',
    "\u0128": 'I',
    "\u012A": 'I',
    "\u012C": 'I',
    "\u012E": 'I',
    "\u0130": 'I',
    "\u0129": 'i',
    "\u012B": 'i',
    "\u012D": 'i',
    "\u012F": 'i',
    "\u0131": 'i',
    "\u0134": 'J',
    "\u0135": 'j',
    "\u0136": 'K',
    "\u0137": 'k',
    "\u0138": 'k',
    "\u0139": 'L',
    "\u013B": 'L',
    "\u013D": 'L',
    "\u013F": 'L',
    "\u0141": 'L',
    "\u013A": 'l',
    "\u013C": 'l',
    "\u013E": 'l',
    "\u0140": 'l',
    "\u0142": 'l',
    "\u0143": 'N',
    "\u0145": 'N',
    "\u0147": 'N',
    "\u014A": 'N',
    "\u0144": 'n',
    "\u0146": 'n',
    "\u0148": 'n',
    "\u014B": 'n',
    "\u014C": 'O',
    "\u014E": 'O',
    "\u0150": 'O',
    "\u014D": 'o',
    "\u014F": 'o',
    "\u0151": 'o',
    "\u0154": 'R',
    "\u0156": 'R',
    "\u0158": 'R',
    "\u0155": 'r',
    "\u0157": 'r',
    "\u0159": 'r',
    "\u015A": 'S',
    "\u015C": 'S',
    "\u015E": 'S',
    "\u0160": 'S',
    "\u015B": 's',
    "\u015D": 's',
    "\u015F": 's',
    "\u0161": 's',
    "\u0162": 'T',
    "\u0164": 'T',
    "\u0166": 'T',
    "\u0163": 't',
    "\u0165": 't',
    "\u0167": 't',
    "\u0168": 'U',
    "\u016A": 'U',
    "\u016C": 'U',
    "\u016E": 'U',
    "\u0170": 'U',
    "\u0172": 'U',
    "\u0169": 'u',
    "\u016B": 'u',
    "\u016D": 'u',
    "\u016F": 'u',
    "\u0171": 'u',
    "\u0173": 'u',
    "\u0174": 'W',
    "\u0175": 'w',
    "\u0176": 'Y',
    "\u0177": 'y',
    "\u0178": 'Y',
    "\u0179": 'Z',
    "\u017B": 'Z',
    "\u017D": 'Z',
    "\u017A": 'z',
    "\u017C": 'z',
    "\u017E": 'z',
    "\u0132": 'IJ',
    "\u0133": 'ij',
    "\u0152": 'Oe',
    "\u0153": 'oe',
    "\u0149": "'n",
    "\u017F": 's'
  };

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to compose unicode character classes. */
  var rsComboMarksRange$2 = "\\u0300-\\u036f",
    reComboHalfMarksRange$2 = "\\ufe20-\\ufe2f",
    rsComboSymbolsRange$2 = "\\u20d0-\\u20ff",
    rsComboRange$2 = rsComboMarksRange$2 + reComboHalfMarksRange$2 + rsComboSymbolsRange$2;

  /** Used to compose unicode capture groups. */
  var rsCombo$2 = '[' + rsComboRange$2 + ']';

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo$2, 'g');

  /**
   * Deburrs `string` by converting
   * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
   * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
   * letters to basic Latin letters and removing
   * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category String
   * @param {string} [string=''] The string to deburr.
   * @returns {string} Returns the deburred string.
   * @example
   *
   * _.deburr('déjà vu');
   * // => 'deja vu'
   */
  function deburr(string) {
    string = toString(string);
    return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
  }

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /** Used to compose unicode character classes. */
  var rsAstralRange$1 = "\\ud800-\\udfff",
    rsComboMarksRange$1 = "\\u0300-\\u036f",
    reComboHalfMarksRange$1 = "\\ufe20-\\ufe2f",
    rsComboSymbolsRange$1 = "\\u20d0-\\u20ff",
    rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1,
    rsDingbatRange = "\\u2700-\\u27bf",
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = "\\u2000-\\u206f",
    rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange$1 = "\\ufe0e\\ufe0f",
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos$1 = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo$1 = '[' + rsComboRange$1 + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange$1 + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz$1 = "\\ud83c[\\udffb-\\udfff]",
    rsModifier$1 = '(?:' + rsCombo$1 + '|' + rsFitz$1 + ')',
    rsNonAstral$1 = '[^' + rsAstralRange$1 + ']',
    rsRegional$1 = "(?:\\ud83c[\\udde6-\\uddff]){2}",
    rsSurrPair$1 = "[\\ud800-\\udbff][\\udc00-\\udfff]",
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ$1 = "\\u200d";

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos$1 + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos$1 + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod$1 = rsModifier$1 + '?',
    rsOptVar$1 = '[' + rsVarRange$1 + ']?',
    rsOptJoin$1 = '(?:' + rsZWJ$1 + '(?:' + [rsNonAstral$1, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsOptVar$1 + reOptMod$1 + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq$1 = rsOptVar$1 + reOptMod$1 + rsOptJoin$1,
    rsEmoji = '(?:' + [rsDingbat, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsSeq$1;

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')', rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')', rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower, rsUpper + '+' + rsOptContrUpper, rsOrdUpper, rsOrdLower, rsDigits, rsEmoji].join('|'), 'g');

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /**
   * Splits `string` into an array of its words.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category String
   * @param {string} [string=''] The string to inspect.
   * @param {RegExp|string} [pattern] The pattern to match words.
   * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
   * @returns {Array} Returns the words of `string`.
   * @example
   *
   * _.words('fred, barney, & pebbles');
   * // => ['fred', 'barney', 'pebbles']
   *
   * _.words('fred, barney, & pebbles', /[^, ]+/g);
   * // => ['fred', 'barney', '&', 'pebbles']
   */
  function words(string, pattern, guard) {
    string = toString(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) {
      return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
    }
    return string.match(pattern) || [];
  }

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]";

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Creates a function like `_.camelCase`.
   *
   * @private
   * @param {Function} callback The function to combine each word.
   * @returns {Function} Returns the new compounder function.
   */
  function createCompounder(callback) {
    return function (string) {
      return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
    };
  }

  /**
   * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category String
   * @param {string} [string=''] The string to convert.
   * @returns {string} Returns the camel cased string.
   * @example
   *
   * _.camelCase('Foo Bar');
   * // => 'fooBar'
   *
   * _.camelCase('--foo-bar--');
   * // => 'fooBar'
   *
   * _.camelCase('__FOO_BAR__');
   * // => 'fooBar'
   */
  var camelCase = createCompounder(function (result, word, index) {
    word = word.toLowerCase();
    return result + (index ? capitalize(word) : word);
  });
  var camelCase$1 = camelCase;

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeCeil$2 = Math.ceil,
    nativeMax$2 = Math.max;

  /**
   * Creates an array of elements split into groups the length of `size`.
   * If `array` can't be split evenly, the final chunk will be the remaining
   * elements.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Array
   * @param {Array} array The array to process.
   * @param {number} [size=1] The length of each chunk
   * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
   * @returns {Array} Returns the new array of chunks.
   * @example
   *
   * _.chunk(['a', 'b', 'c', 'd'], 2);
   * // => [['a', 'b'], ['c', 'd']]
   *
   * _.chunk(['a', 'b', 'c', 'd'], 3);
   * // => [['a', 'b', 'c'], ['d']]
   */
  function chunk(array, size, guard) {
    if (guard ? isIterateeCall(array, size, guard) : size === undefined) {
      size = 1;
    } else {
      size = nativeMax$2(toInteger(size), 0);
    }
    var length = array == null ? 0 : array.length;
    if (!length || size < 1) {
      return [];
    }
    var index = 0,
      resIndex = 0,
      result = Array(nativeCeil$2(length / size));
    while (index < length) {
      result[resIndex++] = baseSlice(array, index, index += size);
    }
    return result;
  }

  /**
   * Removes all key-value entries from the stack.
   *
   * @private
   * @name clear
   * @memberOf Stack
   */
  function stackClear() {
    this.__data__ = new ListCache();
    this.size = 0;
  }

  /**
   * Removes `key` and its value from the stack.
   *
   * @private
   * @name delete
   * @memberOf Stack
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function stackDelete(key) {
    var data = this.__data__,
      result = data['delete'](key);
    this.size = data.size;
    return result;
  }

  /**
   * Gets the stack value for `key`.
   *
   * @private
   * @name get
   * @memberOf Stack
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function stackGet(key) {
    return this.__data__.get(key);
  }

  /**
   * Checks if a stack value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Stack
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function stackHas(key) {
    return this.__data__.has(key);
  }

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE$2 = 200;

  /**
   * Sets the stack `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Stack
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the stack cache instance.
   */
  function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
      var pairs = data.__data__;
      if (!Map$1 || pairs.length < LARGE_ARRAY_SIZE$2 - 1) {
        pairs.push([key, value]);
        this.size = ++data.size;
        return this;
      }
      data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
  }

  /**
   * Creates a stack cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
  }

  // Add methods to `Stack`.
  Stack.prototype.clear = stackClear;
  Stack.prototype['delete'] = stackDelete;
  Stack.prototype.get = stackGet;
  Stack.prototype.has = stackHas;
  Stack.prototype.set = stackSet;

  /**
   * The base implementation of `_.assign` without support for multiple sources
   * or `customizer` functions.
   *
   * @private
   * @param {Object} object The destination object.
   * @param {Object} source The source object.
   * @returns {Object} Returns `object`.
   */
  function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
  }

  /**
   * The base implementation of `_.assignIn` without support for multiple sources
   * or `customizer` functions.
   *
   * @private
   * @param {Object} object The destination object.
   * @param {Object} source The source object.
   * @returns {Object} Returns `object`.
   */
  function baseAssignIn(object, source) {
    return object && copyObject(source, keysIn(source), object);
  }

  /** Detect free variable `exports`. */
  var freeExports = (typeof exports === "undefined" ? "undefined" : _typeof$2(exports)) == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && (typeof module === "undefined" ? "undefined" : _typeof$2(module)) == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Built-in value references. */
  var Buffer = moduleExports ? root$1.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

  /**
   * Creates a clone of  `buffer`.
   *
   * @private
   * @param {Buffer} buffer The buffer to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Buffer} Returns the cloned buffer.
   */
  function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }
    var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];
    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * This method returns a new empty array.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {Array} Returns the new empty array.
   * @example
   *
   * var arrays = _.times(2, _.stubArray);
   *
   * console.log(arrays);
   * // => [[], []]
   *
   * console.log(arrays[0] === arrays[1]);
   * // => false
   */
  function stubArray() {
    return [];
  }

  /** Used for built-in method references. */
  var objectProto$6 = Object.prototype;

  /** Built-in value references. */
  var propertyIsEnumerable = objectProto$6.propertyIsEnumerable;

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

  /**
   * Creates an array of the own enumerable symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of symbols.
   */
  var getSymbols = !nativeGetSymbols$1 ? stubArray : function (object) {
    if (object == null) {
      return [];
    }
    object = Object(object);
    return arrayFilter(nativeGetSymbols$1(object), function (symbol) {
      return propertyIsEnumerable.call(object, symbol);
    });
  };

  /**
   * Copies own symbols of `source` to `object`.
   *
   * @private
   * @param {Object} source The object to copy symbols from.
   * @param {Object} [object={}] The object to copy symbols to.
   * @returns {Object} Returns `object`.
   */
  function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
  }

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeGetSymbols = Object.getOwnPropertySymbols;

  /**
   * Creates an array of the own and inherited enumerable symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of symbols.
   */
  var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
    var result = [];
    while (object) {
      arrayPush(result, getSymbols(object));
      object = getPrototype(object);
    }
    return result;
  };

  /**
   * Copies own and inherited symbols of `source` to `object`.
   *
   * @private
   * @param {Object} source The object to copy symbols from.
   * @param {Object} [object={}] The object to copy symbols to.
   * @returns {Object} Returns `object`.
   */
  function copySymbolsIn(source, object) {
    return copyObject(source, getSymbolsIn(source), object);
  }

  /**
   * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
   * `keysFunc` and `symbolsFunc` to get the enumerable property names and
   * symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Function} keysFunc The function to get the keys of `object`.
   * @param {Function} symbolsFunc The function to get the symbols of `object`.
   * @returns {Array} Returns the array of property names and symbols.
   */
  function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray$1(object) ? result : arrayPush(result, symbolsFunc(object));
  }

  /**
   * Creates an array of own enumerable property names and symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names and symbols.
   */
  function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
  }

  /**
   * Creates an array of own and inherited enumerable property names and
   * symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names and symbols.
   */
  function getAllKeysIn(object) {
    return baseGetAllKeys(object, keysIn, getSymbolsIn);
  }

  /* Built-in method references that are verified to be native. */
  var DataView = getNative(root$1, 'DataView');

  /* Built-in method references that are verified to be native. */
  var Promise$1 = getNative(root$1, 'Promise');

  /* Built-in method references that are verified to be native. */
  var Set$1 = getNative(root$1, 'Set');

  /** `Object#toString` result references. */
  var mapTag$5 = '[object Map]',
    objectTag$2 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$5 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';
  var dataViewTag$3 = '[object DataView]';

  /** Used to detect maps, sets, and weakmaps. */
  var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map$1),
    promiseCtorString = toSource(Promise$1),
    setCtorString = toSource(Set$1),
    weakMapCtorString = toSource(WeakMap$1);

  /**
   * Gets the `toStringTag` of `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */
  var getTag = baseGetTag;

  // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
  if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag$3 || Map$1 && getTag(new Map$1()) != mapTag$5 || Promise$1 && getTag(Promise$1.resolve()) != promiseTag || Set$1 && getTag(new Set$1()) != setTag$5 || WeakMap$1 && getTag(new WeakMap$1()) != weakMapTag$1) {
    getTag = function getTag(value) {
      var result = baseGetTag(value),
        Ctor = result == objectTag$2 ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';
      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString:
            return dataViewTag$3;
          case mapCtorString:
            return mapTag$5;
          case promiseCtorString:
            return promiseTag;
          case setCtorString:
            return setTag$5;
          case weakMapCtorString:
            return weakMapTag$1;
        }
      }
      return result;
    };
  }
  var getTag$1 = getTag;

  /** Used for built-in method references. */
  var objectProto$5 = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$6 = objectProto$5.hasOwnProperty;

  /**
   * Initializes an array clone.
   *
   * @private
   * @param {Array} array The array to clone.
   * @returns {Array} Returns the initialized clone.
   */
  function initCloneArray(array) {
    var length = array.length,
      result = new array.constructor(length);

    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && hasOwnProperty$6.call(array, 'index')) {
      result.index = array.index;
      result.input = array.input;
    }
    return result;
  }

  /** Built-in value references. */
  var Uint8Array = root$1.Uint8Array;

  /**
   * Creates a clone of `arrayBuffer`.
   *
   * @private
   * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
   * @returns {ArrayBuffer} Returns the cloned array buffer.
   */
  function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
  }

  /**
   * Creates a clone of `dataView`.
   *
   * @private
   * @param {Object} dataView The data view to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Object} Returns the cloned data view.
   */
  function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
  }

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /**
   * Creates a clone of `regexp`.
   *
   * @private
   * @param {Object} regexp The regexp to clone.
   * @returns {Object} Returns the cloned regexp.
   */
  function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
  }

  /** Used to convert symbols to primitives and strings. */
  var symbolProto$1 = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf$1 = symbolProto$1 ? symbolProto$1.valueOf : undefined;

  /**
   * Creates a clone of the `symbol` object.
   *
   * @private
   * @param {Object} symbol The symbol object to clone.
   * @returns {Object} Returns the cloned symbol object.
   */
  function cloneSymbol(symbol) {
    return symbolValueOf$1 ? Object(symbolValueOf$1.call(symbol)) : {};
  }

  /**
   * Creates a clone of `typedArray`.
   *
   * @private
   * @param {Object} typedArray The typed array to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Object} Returns the cloned typed array.
   */
  function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
  }

  /** `Object#toString` result references. */
  var boolTag$3 = '[object Boolean]',
    dateTag$3 = '[object Date]',
    mapTag$4 = '[object Map]',
    numberTag$3 = '[object Number]',
    regexpTag$2 = '[object RegExp]',
    setTag$4 = '[object Set]',
    stringTag$3 = '[object String]',
    symbolTag$2 = '[object Symbol]';
  var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$2 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';

  /**
   * Initializes an object clone based on its `toStringTag`.
   *
   * **Note:** This function only supports cloning values with tags of
   * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {string} tag The `toStringTag` of the object to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Object} Returns the initialized clone.
   */
  function initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch (tag) {
      case arrayBufferTag$2:
        return cloneArrayBuffer(object);
      case boolTag$3:
      case dateTag$3:
        return new Ctor(+object);
      case dataViewTag$2:
        return cloneDataView(object, isDeep);
      case float32Tag$1:
      case float64Tag$1:
      case int8Tag$1:
      case int16Tag$1:
      case int32Tag$1:
      case uint8Tag$1:
      case uint8ClampedTag$1:
      case uint16Tag$1:
      case uint32Tag$1:
        return cloneTypedArray(object, isDeep);
      case mapTag$4:
        return new Ctor();
      case numberTag$3:
      case stringTag$3:
        return new Ctor(object);
      case regexpTag$2:
        return cloneRegExp(object);
      case setTag$4:
        return new Ctor();
      case symbolTag$2:
        return cloneSymbol(object);
    }
  }

  /**
   * Initializes an object clone.
   *
   * @private
   * @param {Object} object The object to clone.
   * @returns {Object} Returns the initialized clone.
   */
  function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
  }

  /** `Object#toString` result references. */
  var mapTag$3 = '[object Map]';

  /**
   * The base implementation of `_.isMap` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a map, else `false`.
   */
  function baseIsMap(value) {
    return isObjectLike(value) && getTag$1(value) == mapTag$3;
  }

  /* Node.js helper references. */
  var nodeIsMap = nodeUtil && nodeUtil.isMap;

  /**
   * Checks if `value` is classified as a `Map` object.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a map, else `false`.
   * @example
   *
   * _.isMap(new Map);
   * // => true
   *
   * _.isMap(new WeakMap);
   * // => false
   */
  var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

  /** `Object#toString` result references. */
  var setTag$3 = '[object Set]';

  /**
   * The base implementation of `_.isSet` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a set, else `false`.
   */
  function baseIsSet(value) {
    return isObjectLike(value) && getTag$1(value) == setTag$3;
  }

  /* Node.js helper references. */
  var nodeIsSet = nodeUtil && nodeUtil.isSet;

  /**
   * Checks if `value` is classified as a `Set` object.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a set, else `false`.
   * @example
   *
   * _.isSet(new Set);
   * // => true
   *
   * _.isSet(new WeakSet);
   * // => false
   */
  var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG$2 = 1,
    CLONE_FLAT_FLAG$1 = 2,
    CLONE_SYMBOLS_FLAG$2 = 4;

  /** `Object#toString` result references. */
  var argsTag$1 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag$2 = '[object Map]',
    numberTag$2 = '[object Number]',
    objectTag$1 = '[object Object]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$2 = '[object String]',
    symbolTag$1 = '[object Symbol]',
    weakMapTag = '[object WeakMap]';
  var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag$1] = cloneableTags[arrayTag$1] = cloneableTags[arrayBufferTag$1] = cloneableTags[dataViewTag$1] = cloneableTags[boolTag$2] = cloneableTags[dateTag$2] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag$2] = cloneableTags[numberTag$2] = cloneableTags[objectTag$1] = cloneableTags[regexpTag$1] = cloneableTags[setTag$2] = cloneableTags[stringTag$2] = cloneableTags[symbolTag$1] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag$1] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;

  /**
   * The base implementation of `_.clone` and `_.cloneDeep` which tracks
   * traversed objects.
   *
   * @private
   * @param {*} value The value to clone.
   * @param {boolean} bitmask The bitmask flags.
   *  1 - Deep clone
   *  2 - Flatten inherited properties
   *  4 - Clone symbols
   * @param {Function} [customizer] The function to customize cloning.
   * @param {string} [key] The key of `value`.
   * @param {Object} [object] The parent object of `value`.
   * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
   * @returns {*} Returns the cloned value.
   */
  function baseClone(value, bitmask, customizer, key, object, stack) {
    var result,
      isDeep = bitmask & CLONE_DEEP_FLAG$2,
      isFlat = bitmask & CLONE_FLAT_FLAG$1,
      isFull = bitmask & CLONE_SYMBOLS_FLAG$2;
    if (customizer) {
      result = object ? customizer(value, key, object, stack) : customizer(value);
    }
    if (result !== undefined) {
      return result;
    }
    if (!isObject(value)) {
      return value;
    }
    var isArr = isArray$1(value);
    if (isArr) {
      result = initCloneArray(value);
      if (!isDeep) {
        return copyArray(value, result);
      }
    } else {
      var tag = getTag$1(value),
        isFunc = tag == funcTag || tag == genTag;
      if (isBuffer(value)) {
        return cloneBuffer(value, isDeep);
      }
      if (tag == objectTag$1 || tag == argsTag$1 || isFunc && !object) {
        result = isFlat || isFunc ? {} : initCloneObject(value);
        if (!isDeep) {
          return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
        }
      } else {
        if (!cloneableTags[tag]) {
          return object ? value : {};
        }
        result = initCloneByTag(value, tag, isDeep);
      }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack());
    var stacked = stack.get(value);
    if (stacked) {
      return stacked;
    }
    stack.set(value, result);
    if (isSet(value)) {
      value.forEach(function (subValue) {
        result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
      });
    } else if (isMap(value)) {
      value.forEach(function (subValue, key) {
        result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
    }
    var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
    var props = isArr ? undefined : keysFunc(value);
    arrayEach(props || value, function (subValue, key) {
      if (props) {
        key = subValue;
        subValue = value[key];
      }
      // Recursively populate clone (susceptible to call stack limits).
      assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
  }

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG$1 = 1,
    CLONE_SYMBOLS_FLAG$1 = 4;

  /**
   * This method is like `_.clone` except that it recursively clones `value`.
   *
   * @static
   * @memberOf _
   * @since 1.0.0
   * @category Lang
   * @param {*} value The value to recursively clone.
   * @returns {*} Returns the deep cloned value.
   * @see _.clone
   * @example
   *
   * var objects = [{ 'a': 1 }, { 'b': 2 }];
   *
   * var deep = _.cloneDeep(objects);
   * console.log(deep[0] === objects[0]);
   * // => false
   */
  function cloneDeep(value) {
    return baseClone(value, CLONE_DEEP_FLAG$1 | CLONE_SYMBOLS_FLAG$1);
  }

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /**
   * Adds `value` to the array cache.
   *
   * @private
   * @name add
   * @memberOf SetCache
   * @alias push
   * @param {*} value The value to cache.
   * @returns {Object} Returns the cache instance.
   */
  function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
  }

  /**
   * Checks if `value` is in the array cache.
   *
   * @private
   * @name has
   * @memberOf SetCache
   * @param {*} value The value to search for.
   * @returns {number} Returns `true` if `value` is found, else `false`.
   */
  function setCacheHas(value) {
    return this.__data__.has(value);
  }

  /**
   *
   * Creates an array cache object to store unique values.
   *
   * @private
   * @constructor
   * @param {Array} [values] The values to cache.
   */
  function SetCache(values) {
    var index = -1,
      length = values == null ? 0 : values.length;
    this.__data__ = new MapCache();
    while (++index < length) {
      this.add(values[index]);
    }
  }

  // Add methods to `SetCache`.
  SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
  SetCache.prototype.has = setCacheHas;

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
      length = array == null ? 0 : array.length;
    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG$5 = 1,
    COMPARE_UNORDERED_FLAG$3 = 2;

  /**
   * A specialized version of `baseIsEqualDeep` for arrays with support for
   * partial deep comparisons.
   *
   * @private
   * @param {Array} array The array to compare.
   * @param {Array} other The other array to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `array` and `other` objects.
   * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
   */
  function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5,
      arrLength = array.length,
      othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
      return false;
    }
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) {
      return arrStacked == other && othStacked == array;
    }
    var index = -1,
      result = true,
      seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : undefined;
    stack.set(array, other);
    stack.set(other, array);

    // Ignore non-index properties.
    while (++index < arrLength) {
      var arrValue = array[index],
        othValue = other[index];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
      }
      if (compared !== undefined) {
        if (compared) {
          continue;
        }
        result = false;
        break;
      }
      // Recursively compare arrays (susceptible to call stack limits).
      if (seen) {
        if (!arraySome(other, function (othValue, othIndex) {
          if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            return seen.push(othIndex);
          }
        })) {
          result = false;
          break;
        }
      } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
        result = false;
        break;
      }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
      result = Array(map.size);
    map.forEach(function (value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
      result = Array(set.size);
    set.forEach(function (value) {
      result[++index] = value;
    });
    return result;
  }

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG$4 = 1,
    COMPARE_UNORDERED_FLAG$2 = 2;

  /** `Object#toString` result references. */
  var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    errorTag = '[object Error]',
    mapTag$1 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag$1 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag = '[object Symbol]';
  var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

  /** Used to convert symbols to primitives and strings. */
  var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

  /**
   * A specialized version of `baseIsEqualDeep` for comparing objects of
   * the same `toStringTag`.
   *
   * **Note:** This function only supports comparing values with tags of
   * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {string} tag The `toStringTag` of the objects to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */
  function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch (tag) {
      case dataViewTag:
        if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
          return false;
        }
        object = object.buffer;
        other = other.buffer;
      case arrayBufferTag:
        if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
          return false;
        }
        return true;
      case boolTag$1:
      case dateTag$1:
      case numberTag$1:
        // Coerce booleans to `1` or `0` and dates to milliseconds.
        // Invalid dates are coerced to `NaN`.
        return eq(+object, +other);
      case errorTag:
        return object.name == other.name && object.message == other.message;
      case regexpTag:
      case stringTag$1:
        // Coerce regexes to strings and treat strings, primitives and objects,
        // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
        // for more details.
        return object == other + '';
      case mapTag$1:
        var convert = mapToArray;
      case setTag$1:
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
        convert || (convert = setToArray);
        if (object.size != other.size && !isPartial) {
          return false;
        }
        // Assume cyclic values are equal.
        var stacked = stack.get(object);
        if (stacked) {
          return stacked == other;
        }
        bitmask |= COMPARE_UNORDERED_FLAG$2;

        // Recursively compare objects (susceptible to call stack limits).
        stack.set(object, other);
        var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
        stack['delete'](object);
        return result;
      case symbolTag:
        if (symbolValueOf) {
          return symbolValueOf.call(object) == symbolValueOf.call(other);
        }
    }
    return false;
  }

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG$3 = 1;

  /** Used for built-in method references. */
  var objectProto$4 = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$5 = objectProto$4.hasOwnProperty;

  /**
   * A specialized version of `baseIsEqualDeep` for objects with support for
   * partial deep comparisons.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */
  function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;
    if (objLength != othLength && !isPartial) {
      return false;
    }
    var index = objLength;
    while (index--) {
      var key = objProps[index];
      if (!(isPartial ? key in other : hasOwnProperty$5.call(other, key))) {
        return false;
      }
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) {
      return objStacked == other && othStacked == object;
    }
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while (++index < objLength) {
      key = objProps[index];
      var objValue = object[key],
        othValue = other[key];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
      }
      // Recursively compare objects (susceptible to call stack limits).
      if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
        result = false;
        break;
      }
      skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
      var objCtor = object.constructor,
        othCtor = other.constructor;

      // Non `Object` object instances with different constructors are not equal.
      if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
        result = false;
      }
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
  }

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG$2 = 1;

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

  /** Used for built-in method references. */
  var objectProto$3 = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$4 = objectProto$3.hasOwnProperty;

  /**
   * A specialized version of `baseIsEqual` for arrays and objects which performs
   * deep comparisons and tracks traversed objects enabling objects with circular
   * references to be compared.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} [stack] Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */
  function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray$1(object),
      othIsArr = isArray$1(other),
      objTag = objIsArr ? arrayTag : getTag$1(object),
      othTag = othIsArr ? arrayTag : getTag$1(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
      if (!isBuffer(other)) {
        return false;
      }
      objIsArr = true;
      objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
      stack || (stack = new Stack());
      return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
      var objIsWrapped = objIsObj && hasOwnProperty$4.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$4.call(other, '__wrapped__');
      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;
        stack || (stack = new Stack());
        return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
      }
    }
    if (!isSameTag) {
      return false;
    }
    stack || (stack = new Stack());
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
  }

  /**
   * The base implementation of `_.isEqual` which supports partial comparisons
   * and tracks traversed objects.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @param {boolean} bitmask The bitmask flags.
   *  1 - Unordered comparison
   *  2 - Partial comparison
   * @param {Function} [customizer] The function to customize comparisons.
   * @param {Object} [stack] Tracks traversed `value` and `other` objects.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   */
  function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) {
      return true;
    }
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
      return value !== value && other !== other;
    }
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
  }

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;

  /**
   * The base implementation of `_.isMatch` without support for iteratee shorthands.
   *
   * @private
   * @param {Object} object The object to inspect.
   * @param {Object} source The object of property values to match.
   * @param {Array} matchData The property names, values, and compare flags to match.
   * @param {Function} [customizer] The function to customize comparisons.
   * @returns {boolean} Returns `true` if `object` is a match, else `false`.
   */
  function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length,
      length = index,
      noCustomizer = !customizer;
    if (object == null) {
      return !length;
    }
    object = Object(object);
    while (index--) {
      var data = matchData[index];
      if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
        return false;
      }
    }
    while (++index < length) {
      data = matchData[index];
      var key = data[0],
        objValue = object[key],
        srcValue = data[1];
      if (noCustomizer && data[2]) {
        if (objValue === undefined && !(key in object)) {
          return false;
        }
      } else {
        var stack = new Stack();
        if (customizer) {
          var result = customizer(objValue, srcValue, key, object, source, stack);
        }
        if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack) : result)) {
          return false;
        }
      }
    }
    return true;
  }

  /**
   * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` if suitable for strict
   *  equality comparisons, else `false`.
   */
  function isStrictComparable(value) {
    return value === value && !isObject(value);
  }

  /**
   * Gets the property names, values, and compare flags of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the match data of `object`.
   */
  function getMatchData(object) {
    var result = keys(object),
      length = result.length;
    while (length--) {
      var key = result[length],
        value = object[key];
      result[length] = [key, value, isStrictComparable(value)];
    }
    return result;
  }

  /**
   * A specialized version of `matchesProperty` for source values suitable
   * for strict equality comparisons, i.e. `===`.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @param {*} srcValue The value to match.
   * @returns {Function} Returns the new spec function.
   */
  function matchesStrictComparable(key, srcValue) {
    return function (object) {
      if (object == null) {
        return false;
      }
      return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
  }

  /**
   * The base implementation of `_.matches` which doesn't clone `source`.
   *
   * @private
   * @param {Object} source The object of property values to match.
   * @returns {Function} Returns the new spec function.
   */
  function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) {
      return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    }
    return function (object) {
      return object === source || baseIsMatch(object, source, matchData);
    };
  }

  /**
   * The base implementation of `_.hasIn` without support for deep paths.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {Array|string} key The key to check.
   * @returns {boolean} Returns `true` if `key` exists, else `false`.
   */
  function baseHasIn(object, key) {
    return object != null && key in Object(object);
  }

  /**
   * Checks if `path` exists on `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array|string} path The path to check.
   * @param {Function} hasFunc The function to check properties.
   * @returns {boolean} Returns `true` if `path` exists, else `false`.
   */
  function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1,
      length = path.length,
      result = false;
    while (++index < length) {
      var key = toKey(path[index]);
      if (!(result = object != null && hasFunc(object, key))) {
        break;
      }
      object = object[key];
    }
    if (result || ++index != length) {
      return result;
    }
    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) && (isArray$1(object) || isArguments(object));
  }

  /**
   * Checks if `path` is a direct or inherited property of `object`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Object
   * @param {Object} object The object to query.
   * @param {Array|string} path The path to check.
   * @returns {boolean} Returns `true` if `path` exists, else `false`.
   * @example
   *
   * var object = _.create({ 'a': _.create({ 'b': 2 }) });
   *
   * _.hasIn(object, 'a');
   * // => true
   *
   * _.hasIn(object, 'a.b');
   * // => true
   *
   * _.hasIn(object, ['a', 'b']);
   * // => true
   *
   * _.hasIn(object, 'b');
   * // => false
   */
  function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
  }

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

  /**
   * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
   *
   * @private
   * @param {string} path The path of the property to get.
   * @param {*} srcValue The value to match.
   * @returns {Function} Returns the new spec function.
   */
  function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) {
      return matchesStrictComparable(toKey(path), srcValue);
    }
    return function (object) {
      var objValue = get(object, path);
      return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function (object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * A specialized version of `baseProperty` which supports deep paths.
   *
   * @private
   * @param {Array|string} path The path of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyDeep(path) {
    return function (object) {
      return baseGet(object, path);
    };
  }

  /**
   * Creates a function that returns the value at `path` of a given object.
   *
   * @static
   * @memberOf _
   * @since 2.4.0
   * @category Util
   * @param {Array|string} path The path of the property to get.
   * @returns {Function} Returns the new accessor function.
   * @example
   *
   * var objects = [
   *   { 'a': { 'b': 2 } },
   *   { 'a': { 'b': 1 } }
   * ];
   *
   * _.map(objects, _.property('a.b'));
   * // => [2, 1]
   *
   * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
   * // => [1, 2]
   */
  function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
  }

  /**
   * The base implementation of `_.iteratee`.
   *
   * @private
   * @param {*} [value=_.identity] The value to convert to an iteratee.
   * @returns {Function} Returns the iteratee.
   */
  function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') {
      return value;
    }
    if (value == null) {
      return identity;
    }
    if (_typeof$2(value) == 'object') {
      return isArray$1(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    }
    return property(value);
  }

  /**
   * Creates a base function for methods like `_.forIn` and `_.forOwn`.
   *
   * @private
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {Function} Returns the new base function.
   */
  function createBaseFor(fromRight) {
    return function (object, iteratee, keysFunc) {
      var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;
      while (length--) {
        var key = props[fromRight ? length : ++index];
        if (iteratee(iterable[key], key, iterable) === false) {
          break;
        }
      }
      return object;
    };
  }

  /**
   * The base implementation of `baseForOwn` which iterates over `object`
   * properties returned by `keysFunc` and invokes `iteratee` for each property.
   * Iteratee functions may exit iteration early by explicitly returning `false`.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {Function} keysFunc The function to get the keys of `object`.
   * @returns {Object} Returns `object`.
   */
  var baseFor = createBaseFor();

  /**
   * The base implementation of `_.forOwn` without support for iteratee shorthands.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Object} Returns `object`.
   */
  function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
  }

  /**
   * Creates a `baseEach` or `baseEachRight` function.
   *
   * @private
   * @param {Function} eachFunc The function to iterate over a collection.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {Function} Returns the new base function.
   */
  function createBaseEach(eachFunc, fromRight) {
    return function (collection, iteratee) {
      if (collection == null) {
        return collection;
      }
      if (!isArrayLike(collection)) {
        return eachFunc(collection, iteratee);
      }
      var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);
      while (fromRight ? index-- : ++index < length) {
        if (iteratee(iterable[index], index, iterable) === false) {
          break;
        }
      }
      return collection;
    };
  }

  /**
   * The base implementation of `_.forEach` without support for iteratee shorthands.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array|Object} Returns `collection`.
   */
  var baseEach = createBaseEach(baseForOwn);

  /**
   * Gets the timestamp of the number of milliseconds that have elapsed since
   * the Unix epoch (1 January 1970 00:00:00 UTC).
   *
   * @static
   * @memberOf _
   * @since 2.4.0
   * @category Date
   * @returns {number} Returns the timestamp.
   * @example
   *
   * _.defer(function(stamp) {
   *   console.log(_.now() - stamp);
   * }, _.now());
   * // => Logs the number of milliseconds it took for the deferred invocation.
   */
  var now = function now() {
    return root$1.Date.now();
  };
  var now$1 = now;

  /** Error message constants. */
  var FUNC_ERROR_TEXT$1 = 'Expected a function';

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeMax$1 = Math.max,
    nativeMin$1 = Math.min;

  /**
   * Creates a debounced function that delays invoking `func` until after `wait`
   * milliseconds have elapsed since the last time the debounced function was
   * invoked. The debounced function comes with a `cancel` method to cancel
   * delayed `func` invocations and a `flush` method to immediately invoke them.
   * Provide `options` to indicate whether `func` should be invoked on the
   * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
   * with the last arguments provided to the debounced function. Subsequent
   * calls to the debounced function return the result of the last `func`
   * invocation.
   *
   * **Note:** If `leading` and `trailing` options are `true`, `func` is
   * invoked on the trailing edge of the timeout only if the debounced function
   * is invoked more than once during the `wait` timeout.
   *
   * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
   * until to the next tick, similar to `setTimeout` with a timeout of `0`.
   *
   * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
   * for details over the differences between `_.debounce` and `_.throttle`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Function
   * @param {Function} func The function to debounce.
   * @param {number} [wait=0] The number of milliseconds to delay.
   * @param {Object} [options={}] The options object.
   * @param {boolean} [options.leading=false]
   *  Specify invoking on the leading edge of the timeout.
   * @param {number} [options.maxWait]
   *  The maximum time `func` is allowed to be delayed before it's invoked.
   * @param {boolean} [options.trailing=true]
   *  Specify invoking on the trailing edge of the timeout.
   * @returns {Function} Returns the new debounced function.
   * @example
   *
   * // Avoid costly calculations while the window size is in flux.
   * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
   *
   * // Invoke `sendMail` when clicked, debouncing subsequent calls.
   * jQuery(element).on('click', _.debounce(sendMail, 300, {
   *   'leading': true,
   *   'trailing': false
   * }));
   *
   * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
   * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
   * var source = new EventSource('/stream');
   * jQuery(source).on('message', debounced);
   *
   * // Cancel the trailing debounced invocation.
   * jQuery(window).on('popstate', debounced.cancel);
   */
  function debounce$1(func, wait, options) {
    var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;
    if (typeof func != 'function') {
      throw new TypeError(FUNC_ERROR_TEXT$1);
    }
    wait = toNumber$1(wait) || 0;
    if (isObject(options)) {
      leading = !!options.leading;
      maxing = 'maxWait' in options;
      maxWait = maxing ? nativeMax$1(toNumber$1(options.maxWait) || 0, wait) : maxWait;
      trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
      var args = lastArgs,
        thisArg = lastThis;
      lastArgs = lastThis = undefined;
      lastInvokeTime = time;
      result = func.apply(thisArg, args);
      return result;
    }
    function leadingEdge(time) {
      // Reset any `maxWait` timer.
      lastInvokeTime = time;
      // Start the timer for the trailing edge.
      timerId = setTimeout(timerExpired, wait);
      // Invoke the leading edge.
      return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
      var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;
      return maxing ? nativeMin$1(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
      var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

      // Either this is the first call, activity has stopped and we're at the
      // trailing edge, the system time has gone backwards and we're treating
      // it as the trailing edge, or we've hit the `maxWait` limit.
      return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
      var time = now$1();
      if (shouldInvoke(time)) {
        return trailingEdge(time);
      }
      // Restart the timer.
      timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
      timerId = undefined;

      // Only invoke if we have `lastArgs` which means `func` has been
      // debounced at least once.
      if (trailing && lastArgs) {
        return invokeFunc(time);
      }
      lastArgs = lastThis = undefined;
      return result;
    }
    function cancel() {
      if (timerId !== undefined) {
        clearTimeout(timerId);
      }
      lastInvokeTime = 0;
      lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
      return timerId === undefined ? result : trailingEdge(now$1());
    }
    function debounced() {
      var time = now$1(),
        isInvoking = shouldInvoke(time);
      lastArgs = arguments;
      lastThis = this;
      lastCallTime = time;
      if (isInvoking) {
        if (timerId === undefined) {
          return leadingEdge(lastCallTime);
        }
        if (maxing) {
          // Handle invocations in a tight loop.
          clearTimeout(timerId);
          timerId = setTimeout(timerExpired, wait);
          return invokeFunc(lastCallTime);
        }
      }
      if (timerId === undefined) {
        timerId = setTimeout(timerExpired, wait);
      }
      return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
  }

  /**
   * This function is like `assignValue` except that it doesn't assign
   * `undefined` values.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */
  function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) {
      baseAssignValue(object, key, value);
    }
  }

  /**
   * This method is like `_.isArrayLike` except that it also checks if `value`
   * is an object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array-like object,
   *  else `false`.
   * @example
   *
   * _.isArrayLikeObject([1, 2, 3]);
   * // => true
   *
   * _.isArrayLikeObject(document.body.children);
   * // => true
   *
   * _.isArrayLikeObject('abc');
   * // => false
   *
   * _.isArrayLikeObject(_.noop);
   * // => false
   */
  function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
  }

  /**
   * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') {
      return;
    }
    if (key == '__proto__') {
      return;
    }
    return object[key];
  }

  /**
   * Converts `value` to a plain object flattening inherited enumerable string
   * keyed properties of `value` to own properties of the plain object.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {Object} Returns the converted plain object.
   * @example
   *
   * function Foo() {
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.assign({ 'a': 1 }, new Foo);
   * // => { 'a': 1, 'b': 2 }
   *
   * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
   * // => { 'a': 1, 'b': 2, 'c': 3 }
   */
  function toPlainObject(value) {
    return copyObject(value, keysIn(value));
  }

  /**
   * A specialized version of `baseMerge` for arrays and objects which performs
   * deep merges and tracks traversed objects enabling objects with circular
   * references to be merged.
   *
   * @private
   * @param {Object} object The destination object.
   * @param {Object} source The source object.
   * @param {string} key The key of the value to merge.
   * @param {number} srcIndex The index of `source`.
   * @param {Function} mergeFunc The function to merge values.
   * @param {Function} [customizer] The function to customize assigned values.
   * @param {Object} [stack] Tracks traversed source values and their merged
   *  counterparts.
   */
  function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);
    if (stacked) {
      assignMergeValue(object, key, stacked);
      return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
      var isArr = isArray$1(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
      newValue = srcValue;
      if (isArr || isBuff || isTyped) {
        if (isArray$1(objValue)) {
          newValue = objValue;
        } else if (isArrayLikeObject(objValue)) {
          newValue = copyArray(objValue);
        } else if (isBuff) {
          isCommon = false;
          newValue = cloneBuffer(srcValue, true);
        } else if (isTyped) {
          isCommon = false;
          newValue = cloneTypedArray(srcValue, true);
        } else {
          newValue = [];
        }
      } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
        newValue = objValue;
        if (isArguments(objValue)) {
          newValue = toPlainObject(objValue);
        } else if (!isObject(objValue) || isFunction(objValue)) {
          newValue = initCloneObject(srcValue);
        }
      } else {
        isCommon = false;
      }
    }
    if (isCommon) {
      // Recursively merge objects and arrays (susceptible to call stack limits).
      stack.set(srcValue, newValue);
      mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
      stack['delete'](srcValue);
    }
    assignMergeValue(object, key, newValue);
  }

  /**
   * The base implementation of `_.merge` without support for multiple sources.
   *
   * @private
   * @param {Object} object The destination object.
   * @param {Object} source The source object.
   * @param {number} srcIndex The index of `source`.
   * @param {Function} [customizer] The function to customize merged values.
   * @param {Object} [stack] Tracks traversed source values and their merged
   *  counterparts.
   */
  function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) {
      return;
    }
    baseFor(source, function (srcValue, key) {
      stack || (stack = new Stack());
      if (isObject(srcValue)) {
        baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
      } else {
        var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
        if (newValue === undefined) {
          newValue = srcValue;
        }
        assignMergeValue(object, key, newValue);
      }
    }, keysIn);
  }

  /**
   * This method is like `_.merge` except that it accepts `customizer` which
   * is invoked to produce the merged values of the destination and source
   * properties. If `customizer` returns `undefined`, merging is handled by the
   * method instead. The `customizer` is invoked with six arguments:
   * (objValue, srcValue, key, object, source, stack).
   *
   * **Note:** This method mutates `object`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Object
   * @param {Object} object The destination object.
   * @param {...Object} sources The source objects.
   * @param {Function} customizer The function to customize assigned values.
   * @returns {Object} Returns `object`.
   * @example
   *
   * function customizer(objValue, srcValue) {
   *   if (_.isArray(objValue)) {
   *     return objValue.concat(srcValue);
   *   }
   * }
   *
   * var object = { 'a': [1], 'b': [2] };
   * var other = { 'a': [3], 'b': [4] };
   *
   * _.mergeWith(object, other, customizer);
   * // => { 'a': [1, 3], 'b': [2, 4] }
   */
  var mergeWith$1 = createAssigner(function (object, source, srcIndex, customizer) {
    baseMerge(object, source, srcIndex, customizer);
  });
  var mergeWith$2 = mergeWith$1;

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
      length = array == null ? 0 : array.length;
    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE$1 = 200;

  /**
   * The base implementation of methods like `_.difference` without support
   * for excluding multiple arrays or iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Array} values The values to exclude.
   * @param {Function} [iteratee] The iteratee invoked per element.
   * @param {Function} [comparator] The comparator invoked per element.
   * @returns {Array} Returns the new array of filtered values.
   */
  function baseDifference(array, values, iteratee, comparator) {
    var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;
    if (!length) {
      return result;
    }
    if (iteratee) {
      values = arrayMap(values, baseUnary(iteratee));
    }
    if (comparator) {
      includes = arrayIncludesWith;
      isCommon = false;
    } else if (values.length >= LARGE_ARRAY_SIZE$1) {
      includes = cacheHas;
      isCommon = false;
      values = new SetCache(values);
    }
    outer: while (++index < length) {
      var value = array[index],
        computed = iteratee == null ? value : iteratee(value);
      value = comparator || value !== 0 ? value : 0;
      if (isCommon && computed === computed) {
        var valuesIndex = valuesLength;
        while (valuesIndex--) {
          if (values[valuesIndex] === computed) {
            continue outer;
          }
        }
        result.push(value);
      } else if (!includes(values, computed, comparator)) {
        result.push(value);
      }
    }
    return result;
  }

  /**
   * Creates an array of `array` values not included in the other given arrays
   * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * for equality comparisons. The order and references of result values are
   * determined by the first array.
   *
   * **Note:** Unlike `_.pullAll`, this method returns a new array.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Array
   * @param {Array} array The array to inspect.
   * @param {...Array} [values] The values to exclude.
   * @returns {Array} Returns the new array of filtered values.
   * @see _.without, _.xor
   * @example
   *
   * _.difference([2, 1], [2, 3]);
   * // => [1]
   */
  var difference = baseRest(function (array, values) {
    return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
  });
  var difference$1 = difference;

  /**
   * Gets the last element of `array`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Array
   * @param {Array} array The array to query.
   * @returns {*} Returns the last element of `array`.
   * @example
   *
   * _.last([1, 2, 3]);
   * // => 3
   */
  function last$1(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
  }

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /** Used to match HTML entities and HTML characters. */
  var reUnescapedHtml = /[&<>"']/g,
    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /**
   * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
   * corresponding HTML entities.
   *
   * **Note:** No other characters are escaped. To escape additional
   * characters use a third-party library like [_he_](https://mths.be/he).
   *
   * Though the ">" character is escaped for symmetry, characters like
   * ">" and "/" don't need escaping in HTML and have no special meaning
   * unless they're part of a tag or unquoted attribute value. See
   * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
   * (under "semi-related fun fact") for more details.
   *
   * When working with HTML you should always
   * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
   * XSS vectors.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category String
   * @param {string} [string=''] The string to escape.
   * @returns {string} Returns the escaped string.
   * @example
   *
   * _.escape('fred, barney, & pebbles');
   * // => 'fred, barney, &amp; pebbles'
   */
  function escape$1(string) {
    string = toString(string);
    return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
  }

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
    reHasRegExpChar = RegExp(reRegExpChar.source);

  /**
   * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
   * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category String
   * @param {string} [string=''] The string to escape.
   * @returns {string} Returns the escaped string.
   * @example
   *
   * _.escapeRegExp('[lodash](https://lodash.com/)');
   * // => '\[lodash\]\(https://lodash\.com/\)'
   */
  function escapeRegExp(string) {
    string = toString(string);
    return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
  }

  /**
   * The base implementation of `_.filter` without support for iteratee shorthands.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function baseFilter(collection, predicate) {
    var result = [];
    baseEach(collection, function (value, index, collection) {
      if (predicate(value, index, collection)) {
        result.push(value);
      }
    });
    return result;
  }

  /**
   * Iterates over elements of `collection`, returning an array of all elements
   * `predicate` returns truthy for. The predicate is invoked with three
   * arguments: (value, index|key, collection).
   *
   * **Note:** Unlike `_.remove`, this method returns a new array.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Collection
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} [predicate=_.identity] The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   * @see _.reject
   * @example
   *
   * var users = [
   *   { 'user': 'barney', 'age': 36, 'active': true },
   *   { 'user': 'fred',   'age': 40, 'active': false }
   * ];
   *
   * _.filter(users, function(o) { return !o.active; });
   * // => objects for ['fred']
   *
   * // The `_.matches` iteratee shorthand.
   * _.filter(users, { 'age': 36, 'active': true });
   * // => objects for ['barney']
   *
   * // The `_.matchesProperty` iteratee shorthand.
   * _.filter(users, ['active', false]);
   * // => objects for ['fred']
   *
   * // The `_.property` iteratee shorthand.
   * _.filter(users, 'active');
   * // => objects for ['barney']
   *
   * // Combining several predicates using `_.overEvery` or `_.overSome`.
   * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
   * // => objects for ['fred', 'barney']
   */
  function filter(collection, predicate) {
    var func = isArray$1(collection) ? arrayFilter : baseFilter;
    return func(collection, baseIteratee(predicate));
  }

  /** `Object#toString` result references. */
  var stringTag = '[object String]';

  /**
   * Checks if `value` is classified as a `String` primitive or object.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a string, else `false`.
   * @example
   *
   * _.isString('abc');
   * // => true
   *
   * _.isString(1);
   * // => false
   */
  function isString(value) {
    return typeof value == 'string' || !isArray$1(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function (key) {
      return object[key];
    });
  }

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeMin = Math.min;

  /**
   * The base implementation of methods like `_.intersection`, without support
   * for iteratee shorthands, that accepts an array of arrays to inspect.
   *
   * @private
   * @param {Array} arrays The arrays to inspect.
   * @param {Function} [iteratee] The iteratee invoked per element.
   * @param {Function} [comparator] The comparator invoked per element.
   * @returns {Array} Returns the new array of shared values.
   */
  function baseIntersection(arrays, iteratee, comparator) {
    var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];
    while (othIndex--) {
      var array = arrays[othIndex];
      if (othIndex && iteratee) {
        array = arrayMap(array, baseUnary(iteratee));
      }
      maxLength = nativeMin(array.length, maxLength);
      caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
    }
    array = arrays[0];
    var index = -1,
      seen = caches[0];
    outer: while (++index < length && result.length < maxLength) {
      var value = array[index],
        computed = iteratee ? iteratee(value) : value;
      value = comparator || value !== 0 ? value : 0;
      if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
        othIndex = othLength;
        while (--othIndex) {
          var cache = caches[othIndex];
          if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) {
            continue outer;
          }
        }
        if (seen) {
          seen.push(computed);
        }
        result.push(value);
      }
    }
    return result;
  }

  /**
   * Casts `value` to an empty array if it's not an array like object.
   *
   * @private
   * @param {*} value The value to inspect.
   * @returns {Array|Object} Returns the cast array-like object.
   */
  function castArrayLikeObject(value) {
    return isArrayLikeObject(value) ? value : [];
  }

  /**
   * Creates an array of unique values that are included in all given arrays
   * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * for equality comparisons. The order and references of result values are
   * determined by the first array.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Array
   * @param {...Array} [arrays] The arrays to inspect.
   * @returns {Array} Returns the new array of intersecting values.
   * @example
   *
   * _.intersection([2, 1], [2, 3]);
   * // => [2]
   */
  var intersection = baseRest(function (arrays) {
    var mapped = arrayMap(arrays, castArrayLikeObject);
    return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
  });
  var intersection$1 = intersection;

  /**
   * Gets the parent value at `path` of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} path The path to get the parent value of.
   * @returns {*} Returns the parent value.
   */
  function parent(object, path) {
    return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
  }

  /** `Object#toString` result references. */
  var boolTag = '[object Boolean]';

  /**
   * Checks if `value` is classified as a boolean primitive or object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
   * @example
   *
   * _.isBoolean(false);
   * // => true
   *
   * _.isBoolean(null);
   * // => false
   */
  function isBoolean(value) {
    return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
  }

  /** `Object#toString` result references. */
  var dateTag = '[object Date]';

  /**
   * The base implementation of `_.isDate` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
   */
  function baseIsDate(value) {
    return isObjectLike(value) && baseGetTag(value) == dateTag;
  }

  /* Node.js helper references. */
  var nodeIsDate = nodeUtil && nodeUtil.isDate;

  /**
   * Checks if `value` is classified as a `Date` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
   * @example
   *
   * _.isDate(new Date);
   * // => true
   *
   * _.isDate('Mon April 23 2012');
   * // => false
   */
  var isDate$1 = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
  var isDate$2 = isDate$1;

  /** `Object#toString` result references. */
  var mapTag = '[object Map]',
    setTag = '[object Set]';

  /** Used for built-in method references. */
  var objectProto$2 = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$3 = objectProto$2.hasOwnProperty;

  /**
   * Checks if `value` is an empty object, collection, map, or set.
   *
   * Objects are considered empty if they have no own enumerable string keyed
   * properties.
   *
   * Array-like values such as `arguments` objects, arrays, buffers, strings, or
   * jQuery-like collections are considered empty if they have a `length` of `0`.
   * Similarly, maps and sets are considered empty if they have a `size` of `0`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is empty, else `false`.
   * @example
   *
   * _.isEmpty(null);
   * // => true
   *
   * _.isEmpty(true);
   * // => true
   *
   * _.isEmpty(1);
   * // => true
   *
   * _.isEmpty([1, 2, 3]);
   * // => false
   *
   * _.isEmpty({ 'a': 1 });
   * // => false
   */
  function isEmpty(value) {
    if (value == null) {
      return true;
    }
    if (isArrayLike(value) && (isArray$1(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
      return !value.length;
    }
    var tag = getTag$1(value);
    if (tag == mapTag || tag == setTag) {
      return !value.size;
    }
    if (isPrototype(value)) {
      return !baseKeys(value).length;
    }
    for (var key in value) {
      if (hasOwnProperty$3.call(value, key)) {
        return false;
      }
    }
    return true;
  }

  /**
   * Performs a deep comparison between two values to determine if they are
   * equivalent.
   *
   * **Note:** This method supports comparing arrays, array buffers, booleans,
   * date objects, error objects, maps, numbers, `Object` objects, regexes,
   * sets, strings, symbols, and typed arrays. `Object` objects are compared
   * by their own, not inherited, enumerable properties. Functions and DOM
   * nodes are compared by strict equality, i.e. `===`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.isEqual(object, other);
   * // => true
   *
   * object === other;
   * // => false
   */
  function isEqual(value, other) {
    return baseIsEqual(value, other);
  }

  /** `Object#toString` result references. */
  var numberTag = '[object Number]';

  /**
   * Checks if `value` is classified as a `Number` primitive or object.
   *
   * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
   * classified as numbers, use the `_.isFinite` method.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a number, else `false`.
   * @example
   *
   * _.isNumber(3);
   * // => true
   *
   * _.isNumber(Number.MIN_VALUE);
   * // => true
   *
   * _.isNumber(Infinity);
   * // => true
   *
   * _.isNumber('3');
   * // => false
   */
  function isNumber(value) {
    return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
  }

  /**
   * Checks if `value` is `null` or `undefined`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
   * @example
   *
   * _.isNil(null);
   * // => true
   *
   * _.isNil(void 0);
   * // => true
   *
   * _.isNil(NaN);
   * // => false
   */
  function isNil(value) {
    return value == null;
  }

  /**
   * Checks if `value` is `null`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
   * @example
   *
   * _.isNull(null);
   * // => true
   *
   * _.isNull(void 0);
   * // => false
   */
  function isNull(value) {
    return value === null;
  }

  /**
   * Checks if `value` is `undefined`.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
   * @example
   *
   * _.isUndefined(void 0);
   * // => true
   *
   * _.isUndefined(null);
   * // => false
   */
  function isUndefined(value) {
    return value === undefined;
  }

  /**
   * Converts `string` to
   * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category String
   * @param {string} [string=''] The string to convert.
   * @returns {string} Returns the kebab cased string.
   * @example
   *
   * _.kebabCase('Foo Bar');
   * // => 'foo-bar'
   *
   * _.kebabCase('fooBar');
   * // => 'foo-bar'
   *
   * _.kebabCase('__FOO_BAR__');
   * // => 'foo-bar'
   */
  var kebabCase = createCompounder(function (result, word, index) {
    return result + (index ? '-' : '') + word.toLowerCase();
  });
  var kebabCase$1 = kebabCase;

  /**
   * Converts the first character of `string` to lower case.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category String
   * @param {string} [string=''] The string to convert.
   * @returns {string} Returns the converted string.
   * @example
   *
   * _.lowerFirst('Fred');
   * // => 'fred'
   *
   * _.lowerFirst('FRED');
   * // => 'fRED'
   */
  var lowerFirst = createCaseFirst('toLowerCase');
  var lowerFirst$1 = lowerFirst;

  /**
   * The opposite of `_.mapValues`; this method creates an object with the
   * same values as `object` and keys generated by running each own enumerable
   * string keyed property of `object` thru `iteratee`. The iteratee is invoked
   * with three arguments: (value, key, object).
   *
   * @static
   * @memberOf _
   * @since 3.8.0
   * @category Object
   * @param {Object} object The object to iterate over.
   * @param {Function} [iteratee=_.identity] The function invoked per iteration.
   * @returns {Object} Returns the new mapped object.
   * @see _.mapValues
   * @example
   *
   * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
   *   return key + value;
   * });
   * // => { 'a1': 1, 'b2': 2 }
   */
  function mapKeys(object, iteratee) {
    var result = {};
    iteratee = baseIteratee(iteratee);
    baseForOwn(object, function (value, key, object) {
      baseAssignValue(result, iteratee(value, key, object), value);
    });
    return result;
  }

  /**
   * This method is like `_.assign` except that it recursively merges own and
   * inherited enumerable string keyed properties of source objects into the
   * destination object. Source properties that resolve to `undefined` are
   * skipped if a destination value exists. Array and plain object properties
   * are merged recursively. Other objects and value types are overridden by
   * assignment. Source objects are applied from left to right. Subsequent
   * sources overwrite property assignments of previous sources.
   *
   * **Note:** This method mutates `object`.
   *
   * @static
   * @memberOf _
   * @since 0.5.0
   * @category Object
   * @param {Object} object The destination object.
   * @param {...Object} [sources] The source objects.
   * @returns {Object} Returns `object`.
   * @example
   *
   * var object = {
   *   'a': [{ 'b': 2 }, { 'd': 4 }]
   * };
   *
   * var other = {
   *   'a': [{ 'c': 3 }, { 'e': 5 }]
   * };
   *
   * _.merge(object, other);
   * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
   */
  var merge = createAssigner(function (object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
  });
  var merge$1 = merge;

  /**
   * The base implementation of `_.unset`.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {Array|string} path The property path to unset.
   * @returns {boolean} Returns `true` if the property is deleted, else `false`.
   */
  function baseUnset(object, path) {
    path = castPath(path, object);
    object = parent(object, path);
    return object == null || delete object[toKey(last$1(path))];
  }

  /**
   * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
   * objects.
   *
   * @private
   * @param {*} value The value to inspect.
   * @param {string} key The key of the property to inspect.
   * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
   */
  function customOmitClone(value) {
    return isPlainObject(value) ? undefined : value;
  }

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

  /**
   * The opposite of `_.pick`; this method creates an object composed of the
   * own and inherited enumerable property paths of `object` that are not omitted.
   *
   * **Note:** This method is considerably slower than `_.pick`.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The source object.
   * @param {...(string|string[])} [paths] The property paths to omit.
   * @returns {Object} Returns the new object.
   * @example
   *
   * var object = { 'a': 1, 'b': '2', 'c': 3 };
   *
   * _.omit(object, ['a', 'c']);
   * // => { 'b': '2' }
   */
  var omit$1 = flatRest(function (object, paths) {
    var result = {};
    if (object == null) {
      return result;
    }
    var isDeep = false;
    paths = arrayMap(paths, function (path) {
      path = castPath(path, object);
      isDeep || (isDeep = path.length > 1);
      return path;
    });
    copyObject(object, getAllKeysIn(object), result);
    if (isDeep) {
      result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
    }
    var length = paths.length;
    while (length--) {
      baseUnset(result, paths[length]);
    }
    return result;
  });
  var omit$2 = omit$1;

  /**
   * The base implementation of `_.set`.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {*} value The value to set.
   * @param {Function} [customizer] The function to customize path creation.
   * @returns {Object} Returns `object`.
   */
  function baseSet(object, path, value, customizer) {
    if (!isObject(object)) {
      return object;
    }
    path = castPath(path, object);
    var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;
    while (nested != null && ++index < length) {
      var key = toKey(path[index]),
        newValue = value;
      if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
        return object;
      }
      if (index != lastIndex) {
        var objValue = nested[key];
        newValue = customizer ? customizer(objValue, key, nested) : undefined;
        if (newValue === undefined) {
          newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
        }
      }
      assignValue(nested, key, newValue);
      nested = nested[key];
    }
    return object;
  }

  /**
   * The base implementation of  `_.pickBy` without support for iteratee shorthands.
   *
   * @private
   * @param {Object} object The source object.
   * @param {string[]} paths The property paths to pick.
   * @param {Function} predicate The function invoked per property.
   * @returns {Object} Returns the new object.
   */
  function basePickBy(object, paths, predicate) {
    var index = -1,
      length = paths.length,
      result = {};
    while (++index < length) {
      var path = paths[index],
        value = baseGet(object, path);
      if (predicate(value, path)) {
        baseSet(result, castPath(path, object), value);
      }
    }
    return result;
  }

  /** Used as references for various `Number` constants. */
  var MAX_SAFE_INTEGER = 9007199254740991;

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeFloor = Math.floor;

  /**
   * The base implementation of `_.repeat` which doesn't coerce arguments.
   *
   * @private
   * @param {string} string The string to repeat.
   * @param {number} n The number of times to repeat the string.
   * @returns {string} Returns the repeated string.
   */
  function baseRepeat(string, n) {
    var result = '';
    if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
      return result;
    }
    // Leverage the exponentiation by squaring algorithm for a faster repeat.
    // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
    do {
      if (n % 2) {
        result += string;
      }
      n = nativeFloor(n / 2);
      if (n) {
        string += string;
      }
    } while (n);
    return result;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /** Used to compose unicode character classes. */
  var rsAstralRange = "\\ud800-\\udfff",
    rsComboMarksRange = "\\u0300-\\u036f",
    reComboHalfMarksRange = "\\ufe20-\\ufe2f",
    rsComboSymbolsRange = "\\u20d0-\\u20ff",
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = "\\ufe0e\\ufe0f";

  /** Used to compose unicode capture groups. */
  var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = "\\ud83c[\\udffb-\\udfff]",
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}",
    rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]",
    rsZWJ = "\\u200d";

  /** Used to compose unicode regexes. */
  var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
  }

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeCeil$1 = Math.ceil;

  /**
   * Creates the padding for `string` based on `length`. The `chars` string
   * is truncated if the number of characters exceeds `length`.
   *
   * @private
   * @param {number} length The padding length.
   * @param {string} [chars=' '] The string used as padding.
   * @returns {string} Returns the padding for `string`.
   */
  function createPadding(length, chars) {
    chars = chars === undefined ? ' ' : baseToString(chars);
    var charsLength = chars.length;
    if (charsLength < 2) {
      return charsLength ? baseRepeat(chars, length) : chars;
    }
    var result = baseRepeat(chars, nativeCeil$1(length / stringSize(chars)));
    return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
  }

  /**
   * Pads `string` on the left side if it's shorter than `length`. Padding
   * characters are truncated if they exceed `length`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category String
   * @param {string} [string=''] The string to pad.
   * @param {number} [length=0] The padding length.
   * @param {string} [chars=' '] The string used as padding.
   * @returns {string} Returns the padded string.
   * @example
   *
   * _.padStart('abc', 6);
   * // => '   abc'
   *
   * _.padStart('abc', 6, '_-');
   * // => '_-_abc'
   *
   * _.padStart('abc', 3);
   * // => 'abc'
   */
  function padStart(string, length, chars) {
    string = toString(string);
    length = toInteger(length);
    var strLength = length ? stringSize(string) : 0;
    return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
  }

  /**
   * The base implementation of `_.pick` without support for individual
   * property identifiers.
   *
   * @private
   * @param {Object} object The source object.
   * @param {string[]} paths The property paths to pick.
   * @returns {Object} Returns the new object.
   */
  function basePick(object, paths) {
    return basePickBy(object, paths, function (value, path) {
      return hasIn(object, path);
    });
  }

  /**
   * Creates an object composed of the picked `object` properties.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The source object.
   * @param {...(string|string[])} [paths] The property paths to pick.
   * @returns {Object} Returns the new object.
   * @example
   *
   * var object = { 'a': 1, 'b': '2', 'c': 3 };
   *
   * _.pick(object, ['a', 'c']);
   * // => { 'a': 1, 'c': 3 }
   */
  var pick = flatRest(function (object, paths) {
    return object == null ? {} : basePick(object, paths);
  });
  var pick$1 = pick;

  /** Used for built-in method references. */
  var arrayProto = Array.prototype;

  /** Built-in value references. */
  var splice = arrayProto.splice;

  /**
   * The base implementation of `_.pullAt` without support for individual
   * indexes or capturing the removed elements.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {number[]} indexes The indexes of elements to remove.
   * @returns {Array} Returns `array`.
   */
  function basePullAt(array, indexes) {
    var length = array ? indexes.length : 0,
      lastIndex = length - 1;
    while (length--) {
      var index = indexes[length];
      if (length == lastIndex || index !== previous) {
        var previous = index;
        if (isIndex(index)) {
          splice.call(array, index, 1);
        } else {
          baseUnset(array, index);
        }
      }
    }
    return array;
  }

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeCeil = Math.ceil,
    nativeMax = Math.max;

  /**
   * The base implementation of `_.range` and `_.rangeRight` which doesn't
   * coerce arguments.
   *
   * @private
   * @param {number} start The start of the range.
   * @param {number} end The end of the range.
   * @param {number} step The value to increment or decrement by.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {Array} Returns the range of numbers.
   */
  function baseRange(start, end, step, fromRight) {
    var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);
    while (length--) {
      result[fromRight ? length : ++index] = start;
      start += step;
    }
    return result;
  }

  /**
   * Creates a `_.range` or `_.rangeRight` function.
   *
   * @private
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {Function} Returns the new range function.
   */
  function createRange(fromRight) {
    return function (start, end, step) {
      if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
        end = step = undefined;
      }
      // Ensure the sign of `-0` is preserved.
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
      return baseRange(start, end, step, fromRight);
    };
  }

  /**
   * Creates an array of numbers (positive and/or negative) progressing from
   * `start` up to, but not including, `end`. A step of `-1` is used if a negative
   * `start` is specified without an `end` or `step`. If `end` is not specified,
   * it's set to `start` with `start` then set to `0`.
   *
   * **Note:** JavaScript follows the IEEE-754 standard for resolving
   * floating-point values which can produce unexpected results.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Util
   * @param {number} [start=0] The start of the range.
   * @param {number} end The end of the range.
   * @param {number} [step=1] The value to increment or decrement by.
   * @returns {Array} Returns the range of numbers.
   * @see _.inRange, _.rangeRight
   * @example
   *
   * _.range(4);
   * // => [0, 1, 2, 3]
   *
   * _.range(-4);
   * // => [0, -1, -2, -3]
   *
   * _.range(1, 5);
   * // => [1, 2, 3, 4]
   *
   * _.range(0, 20, 5);
   * // => [0, 5, 10, 15]
   *
   * _.range(0, -4, -1);
   * // => [0, -1, -2, -3]
   *
   * _.range(1, 4, 0);
   * // => [1, 1, 1]
   *
   * _.range(0);
   * // => []
   */
  var range = createRange();
  var range$1 = range;

  /**
   * Removes all elements from `array` that `predicate` returns truthy for
   * and returns an array of the removed elements. The predicate is invoked
   * with three arguments: (value, index, array).
   *
   * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
   * to pull elements from an array by value.
   *
   * @static
   * @memberOf _
   * @since 2.0.0
   * @category Array
   * @param {Array} array The array to modify.
   * @param {Function} [predicate=_.identity] The function invoked per iteration.
   * @returns {Array} Returns the new array of removed elements.
   * @example
   *
   * var array = [1, 2, 3, 4];
   * var evens = _.remove(array, function(n) {
   *   return n % 2 == 0;
   * });
   *
   * console.log(array);
   * // => [1, 3]
   *
   * console.log(evens);
   * // => [2, 4]
   */
  function remove(array, predicate) {
    var result = [];
    if (!(array && array.length)) {
      return result;
    }
    var index = -1,
      indexes = [],
      length = array.length;
    predicate = baseIteratee(predicate);
    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result.push(value);
        indexes.push(index);
      }
    }
    basePullAt(array, indexes);
    return result;
  }

  /**
   * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
   * it's created. Arrays are created for missing index properties while objects
   * are created for all other missing properties. Use `_.setWith` to customize
   * `path` creation.
   *
   * **Note:** This method mutates `object`.
   *
   * @static
   * @memberOf _
   * @since 3.7.0
   * @category Object
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns `object`.
   * @example
   *
   * var object = { 'a': [{ 'b': { 'c': 3 } }] };
   *
   * _.set(object, 'a[0].b.c', 4);
   * console.log(object.a[0].b.c);
   * // => 4
   *
   * _.set(object, ['x', '0', 'y', 'z'], 5);
   * console.log(object.x[0].y.z);
   * // => 5
   */
  function set(object, path, value) {
    return object == null ? object : baseSet(object, path, value);
  }

  /** Used for built-in method references. */
  var objectProto$1 = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$2 = objectProto$1.hasOwnProperty;

  /**
   * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
   * of source objects to the destination object for all destination properties
   * that resolve to `undefined`.
   *
   * @private
   * @param {*} objValue The destination value.
   * @param {*} srcValue The source value.
   * @param {string} key The key of the property to assign.
   * @param {Object} object The parent object of `objValue`.
   * @returns {*} Returns the value to assign.
   */
  function customDefaultsAssignIn(objValue, srcValue, key, object) {
    if (objValue === undefined || eq(objValue, objectProto$1[key]) && !hasOwnProperty$2.call(object, key)) {
      return srcValue;
    }
    return objValue;
  }

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    "\u2028": 'u2028',
    "\u2029": 'u2029'
  };

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /** Used to match template delimiters. */
  var reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g;

  /** Used to match template delimiters. */
  var reEvaluate = /<%([\s\S]+?)%>/g;

  /**
   * By default, the template delimiters used by lodash are like those in
   * embedded Ruby (ERB) as well as ES2015 template strings. Change the
   * following template settings to use alternative delimiters.
   *
   * @static
   * @memberOf _
   * @type {Object}
   */
  var templateSettings = {
    /**
     * Used to detect `data` property values to be HTML-escaped.
     *
     * @memberOf _.templateSettings
     * @type {RegExp}
     */
    'escape': reEscape,
    /**
     * Used to detect code to be evaluated.
     *
     * @memberOf _.templateSettings
     * @type {RegExp}
     */
    'evaluate': reEvaluate,
    /**
     * Used to detect `data` property values to inject.
     *
     * @memberOf _.templateSettings
     * @type {RegExp}
     */
    'interpolate': reInterpolate,
    /**
     * Used to reference the data object in the template text.
     *
     * @memberOf _.templateSettings
     * @type {string}
     */
    'variable': '',
    /**
     * Used to import variables into the compiled template.
     *
     * @memberOf _.templateSettings
     * @type {Object}
     */
    'imports': {
      /**
       * A reference to the `lodash` function.
       *
       * @memberOf _.templateSettings.imports
       * @type {Function}
       */
      '_': {
        'escape': escape$1
      }
    }
  };

  /** Error message constants. */
  var INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
    reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
    reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$1 = objectProto.hasOwnProperty;

  /**
   * Creates a compiled template function that can interpolate data properties
   * in "interpolate" delimiters, HTML-escape interpolated data properties in
   * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
   * properties may be accessed as free variables in the template. If a setting
   * object is given, it takes precedence over `_.templateSettings` values.
   *
   * **Note:** In the development build `_.template` utilizes
   * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
   * for easier debugging.
   *
   * For more information on precompiling templates see
   * [lodash's custom builds documentation](https://lodash.com/custom-builds).
   *
   * For more information on Chrome extension sandboxes see
   * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category String
   * @param {string} [string=''] The template string.
   * @param {Object} [options={}] The options object.
   * @param {RegExp} [options.escape=_.templateSettings.escape]
   *  The HTML "escape" delimiter.
   * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
   *  The "evaluate" delimiter.
   * @param {Object} [options.imports=_.templateSettings.imports]
   *  An object to import into the template as free variables.
   * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
   *  The "interpolate" delimiter.
   * @param {string} [options.sourceURL='templateSources[n]']
   *  The sourceURL of the compiled template.
   * @param {string} [options.variable='obj']
   *  The data object variable name.
   * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
   * @returns {Function} Returns the compiled template function.
   * @example
   *
   * // Use the "interpolate" delimiter to create a compiled template.
   * var compiled = _.template('hello <%= user %>!');
   * compiled({ 'user': 'fred' });
   * // => 'hello fred!'
   *
   * // Use the HTML "escape" delimiter to escape data property values.
   * var compiled = _.template('<b><%- value %></b>');
   * compiled({ 'value': '<script>' });
   * // => '<b>&lt;script&gt;</b>'
   *
   * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
   * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
   * compiled({ 'users': ['fred', 'barney'] });
   * // => '<li>fred</li><li>barney</li>'
   *
   * // Use the internal `print` function in "evaluate" delimiters.
   * var compiled = _.template('<% print("hello " + user); %>!');
   * compiled({ 'user': 'barney' });
   * // => 'hello barney!'
   *
   * // Use the ES template literal delimiter as an "interpolate" delimiter.
   * // Disable support by replacing the "interpolate" delimiter.
   * var compiled = _.template('hello ${ user }!');
   * compiled({ 'user': 'pebbles' });
   * // => 'hello pebbles!'
   *
   * // Use backslashes to treat delimiters as plain text.
   * var compiled = _.template('<%= "\\<%- value %\\>" %>');
   * compiled({ 'value': 'ignored' });
   * // => '<%- value %>'
   *
   * // Use the `imports` option to import `jQuery` as `jq`.
   * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
   * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
   * compiled({ 'users': ['fred', 'barney'] });
   * // => '<li>fred</li><li>barney</li>'
   *
   * // Use the `sourceURL` option to specify a custom sourceURL for the template.
   * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
   * compiled(data);
   * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
   *
   * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
   * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
   * compiled.source;
   * // => function(data) {
   * //   var __t, __p = '';
   * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
   * //   return __p;
   * // }
   *
   * // Use custom template delimiters.
   * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
   * var compiled = _.template('hello {{ user }}!');
   * compiled({ 'user': 'mustache' });
   * // => 'hello mustache!'
   *
   * // Use the `source` property to inline compiled templates for meaningful
   * // line numbers in error messages and stack traces.
   * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
   *   var JST = {\
   *     "main": ' + _.template(mainText).source + '\
   *   };\
   * ');
   */
  function template(string, options, guard) {
    // Based on John Resig's `tmpl` implementation
    // (http://ejohn.org/blog/javascript-micro-templating/)
    // and Laura Doktorova's doT.js (https://github.com/olado/doT).
    var settings = templateSettings.imports._.templateSettings || templateSettings;
    if (guard && isIterateeCall(string, options, guard)) {
      options = undefined;
    }
    string = toString(string);
    options = assignInWith({}, options, settings, customDefaultsAssignIn);
    var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
      importsKeys = keys(imports),
      importsValues = baseValues(imports, importsKeys);
    var isEscaping,
      isEvaluating,
      index = 0,
      interpolate = options.interpolate || reNoMatch,
      source = "__p += '";

    // Compile the regexp to match each delimiter.
    var reDelimiters = RegExp((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');

    // Use a sourceURL for easier debugging.
    // The sourceURL gets injected into the source that's eval-ed, so be careful
    // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
    // and escape the comment, thus injecting code that gets evaled.
    var sourceURL = hasOwnProperty$1.call(options, 'sourceURL') ? '//# sourceURL=' + (options.sourceURL + '').replace(/\s/g, ' ') + '\n' : '';
    string.replace(reDelimiters, function (match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
      interpolateValue || (interpolateValue = esTemplateValue);

      // Escape characters that can't be included in string literals.
      source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

      // Replace delimiters with snippets.
      if (escapeValue) {
        isEscaping = true;
        source += "' +\n__e(" + escapeValue + ") +\n'";
      }
      if (evaluateValue) {
        isEvaluating = true;
        source += "';\n" + evaluateValue + ";\n__p += '";
      }
      if (interpolateValue) {
        source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
      }
      index = offset + match.length;

      // The JS engine embedded in Adobe products needs `match` returned in
      // order to produce the correct `offset` value.
      return match;
    });
    source += "';\n";

    // If `variable` is not specified wrap a with-statement around the generated
    // code to add the data object to the top of the scope chain.
    var variable = hasOwnProperty$1.call(options, 'variable') && options.variable;
    if (!variable) {
      source = 'with (obj) {\n' + source + '\n}\n';
    }
    // Throw an error if a forbidden character was found in `variable`, to prevent
    // potential command injection attacks.
    else if (reForbiddenIdentifierChars.test(variable)) {
      throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
    }

    // Cleanup code by stripping empty strings.
    source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');

    // Frame code as the function body.
    source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ', __j = Array.prototype.join;\n' + "function print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
    var result = attempt$1(function () {
      return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
    });

    // Provide the compiled function's source by its `toString` method or
    // the `source` property as a convenience for inlining compiled templates.
    result.source = source;
    if (isError(result)) {
      throw result;
    }
    return result;
  }

  /** Error message constants. */
  var FUNC_ERROR_TEXT = 'Expected a function';

  /**
   * Creates a throttled function that only invokes `func` at most once per
   * every `wait` milliseconds. The throttled function comes with a `cancel`
   * method to cancel delayed `func` invocations and a `flush` method to
   * immediately invoke them. Provide `options` to indicate whether `func`
   * should be invoked on the leading and/or trailing edge of the `wait`
   * timeout. The `func` is invoked with the last arguments provided to the
   * throttled function. Subsequent calls to the throttled function return the
   * result of the last `func` invocation.
   *
   * **Note:** If `leading` and `trailing` options are `true`, `func` is
   * invoked on the trailing edge of the timeout only if the throttled function
   * is invoked more than once during the `wait` timeout.
   *
   * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
   * until to the next tick, similar to `setTimeout` with a timeout of `0`.
   *
   * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
   * for details over the differences between `_.throttle` and `_.debounce`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Function
   * @param {Function} func The function to throttle.
   * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
   * @param {Object} [options={}] The options object.
   * @param {boolean} [options.leading=true]
   *  Specify invoking on the leading edge of the timeout.
   * @param {boolean} [options.trailing=true]
   *  Specify invoking on the trailing edge of the timeout.
   * @returns {Function} Returns the new throttled function.
   * @example
   *
   * // Avoid excessively updating the position while scrolling.
   * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
   *
   * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
   * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
   * jQuery(element).on('click', throttled);
   *
   * // Cancel the trailing throttled invocation.
   * jQuery(window).on('popstate', throttled.cancel);
   */
  function throttle$1(func, wait, options) {
    var leading = true,
      trailing = true;
    if (typeof func != 'function') {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    if (isObject(options)) {
      leading = 'leading' in options ? !!options.leading : leading;
      trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return debounce$1(func, wait, {
      'leading': leading,
      'maxWait': wait,
      'trailing': trailing
    });
  }

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0;

  /**
   * Creates a set object of `values`.
   *
   * @private
   * @param {Array} values The values to add to the set.
   * @returns {Object} Returns the new set.
   */
  var createSet = !(Set$1 && 1 / setToArray(new Set$1([, -0]))[1] == INFINITY) ? noop : function (values) {
    return new Set$1(values);
  };

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /**
   * The base implementation of `_.uniqBy` without support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} [iteratee] The iteratee invoked per element.
   * @param {Function} [comparator] The comparator invoked per element.
   * @returns {Array} Returns the new duplicate free array.
   */
  function baseUniq(array, iteratee, comparator) {
    var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;
    if (comparator) {
      isCommon = false;
      includes = arrayIncludesWith;
    } else if (length >= LARGE_ARRAY_SIZE) {
      var set = iteratee ? null : createSet(array);
      if (set) {
        return setToArray(set);
      }
      isCommon = false;
      includes = cacheHas;
      seen = new SetCache();
    } else {
      seen = iteratee ? [] : result;
    }
    outer: while (++index < length) {
      var value = array[index],
        computed = iteratee ? iteratee(value) : value;
      value = comparator || value !== 0 ? value : 0;
      if (isCommon && computed === computed) {
        var seenIndex = seen.length;
        while (seenIndex--) {
          if (seen[seenIndex] === computed) {
            continue outer;
          }
        }
        if (iteratee) {
          seen.push(computed);
        }
        result.push(value);
      } else if (!includes(seen, computed, comparator)) {
        if (seen !== result) {
          seen.push(computed);
        }
        result.push(value);
      }
    }
    return result;
  }

  /** Used to generate unique IDs. */
  var idCounter = 0;

  /**
   * Generates a unique ID. If `prefix` is given, the ID is appended to it.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Util
   * @param {string} [prefix=''] The value to prefix the ID with.
   * @returns {string} Returns the unique ID.
   * @example
   *
   * _.uniqueId('contact_');
   * // => 'contact_104'
   *
   * _.uniqueId();
   * // => '105'
   */
  function uniqueId(prefix) {
    var id = ++idCounter;
    return toString(prefix) + id;
  }

  /**
   * Converts `string`, as space separated words, to upper case.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category String
   * @param {string} [string=''] The string to convert.
   * @returns {string} Returns the upper cased string.
   * @example
   *
   * _.upperCase('--foo-bar');
   * // => 'FOO BAR'
   *
   * _.upperCase('fooBar');
   * // => 'FOO BAR'
   *
   * _.upperCase('__foo_bar__');
   * // => 'FOO BAR'
   */
  var upperCase = createCompounder(function (result, word, index) {
    return result + (index ? ' ' : '') + word.toUpperCase();
  });
  var upperCase$1 = upperCase;

  /**
   * The base implementation of methods like `_.xor`, without support for
   * iteratee shorthands, that accepts an array of arrays to inspect.
   *
   * @private
   * @param {Array} arrays The arrays to inspect.
   * @param {Function} [iteratee] The iteratee invoked per element.
   * @param {Function} [comparator] The comparator invoked per element.
   * @returns {Array} Returns the new array of values.
   */
  function baseXor(arrays, iteratee, comparator) {
    var length = arrays.length;
    if (length < 2) {
      return length ? baseUniq(arrays[0]) : [];
    }
    var index = -1,
      result = Array(length);
    while (++index < length) {
      var array = arrays[index],
        othIndex = -1;
      while (++othIndex < length) {
        if (othIndex != index) {
          result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
        }
      }
    }
    return baseUniq(baseFlatten(result, 1), iteratee, comparator);
  }

  /**
   * This method is like `_.xor` except that it accepts `comparator` which is
   * invoked to compare elements of `arrays`. The order of result values is
   * determined by the order they occur in the arrays. The comparator is invoked
   * with two arguments: (arrVal, othVal).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Array
   * @param {...Array} [arrays] The arrays to inspect.
   * @param {Function} [comparator] The comparator invoked per element.
   * @returns {Array} Returns the new array of filtered values.
   * @example
   *
   * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
   * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
   *
   * _.xorWith(objects, others, _.isEqual);
   * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
   */
  var xorWith = baseRest(function (arrays) {
    var comparator = last$1(arrays);
    comparator = typeof comparator == 'function' ? comparator : undefined;
    return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
  });
  var xorWith$1 = xorWith;

  function setStyle(el, styles) {
    var keys = Object.keys(styles);
    keys.forEach(function (key) {
      el.style[key] = styles[key];
    });
  }

  function _arrayLikeToArray$1(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
    return n;
  }

  function _arrayWithoutHoles(r) {
    if (Array.isArray(r)) return _arrayLikeToArray$1(r);
  }

  function _iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
  }

  function _unsupportedIterableToArray$1(r, a) {
    if (r) {
      if ("string" == typeof r) return _arrayLikeToArray$1(r, a);
      var t = {}.toString.call(r).slice(8, -1);
      return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$1(r, a) : void 0;
    }
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _toConsumableArray(r) {
    return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray$1(r) || _nonIterableSpread();
  }

  function _objectWithoutPropertiesLoose$2(r, e) {
    if (null == r) return {};
    var t = {};
    for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
      if (-1 !== e.indexOf(n)) continue;
      t[n] = r[n];
    }
    return t;
  }

  function _objectWithoutProperties$2(e, t) {
    if (null == e) return {};
    var o,
      r,
      i = _objectWithoutPropertiesLoose$2(e, t);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
  }

  function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
  }

  function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
      var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;
      try {
        if (i = (t = t.call(r)).next, 0 === l) {
          if (Object(t) !== t) return;
          f = !1;
        } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
      } catch (r) {
        o = !0, n = r;
      } finally {
        try {
          if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
        } finally {
          if (o) throw n;
        }
      }
      return a;
    }
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _slicedToArray(r, e) {
    return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray$1(r, e) || _nonIterableRest();
  }

  function getIEVersion$1() {
    if (typeof navigator === "undefined" || !navigator) return Number.MAX_SAFE_INTEGER;
    var _navigator = navigator,
      userAgent = _navigator.userAgent;
    var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1;
    var isIE11 = userAgent.indexOf("Trident") > -1 && userAgent.indexOf("rv:11.0") > -1;
    if (isIE) {
      var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
      var match = userAgent.match(reIE);
      if (!match) return -1;
      var fIEVersion = parseFloat(match[1]);
      return fIEVersion < 7 ? 6 : fIEVersion;
    }
    if (isIE11) {
      return 11;
    }
    return Number.MAX_SAFE_INTEGER;
  }
  function getFlexGapPolyFill() {
    var _chromeMatch$, _safariMatch$, _fireFoxMatch$;
    if (typeof navigator === "undefined" || !navigator) return false;
    var ua = navigator.userAgent;
    var chromeMatch = ua.match(/AppleWebKit.+Chrome\/(.+) Safari\/.+/i);
    if (Number(chromeMatch === null || chromeMatch === void 0 || (_chromeMatch$ = chromeMatch[1]) === null || _chromeMatch$ === void 0 ? void 0 : _chromeMatch$.split(".")[0]) < 100) return true;
    var safariMatch = ua.match(/AppleWebKit.+Version\/(.+) Safari\/.+/i);
    if (Number(safariMatch === null || safariMatch === void 0 || (_safariMatch$ = safariMatch[1]) === null || _safariMatch$ === void 0 ? void 0 : _safariMatch$.split(".")[0]) < 12) return true;
    var ieVersion = getIEVersion$1();
    if (ieVersion <= 11) return true;
    var fireFoxMatch = ua.match(/Firefox\/(.+)/i);
    if (Number(fireFoxMatch === null || fireFoxMatch === void 0 || (_fireFoxMatch$ = fireFoxMatch[1]) === null || _fireFoxMatch$ === void 0 ? void 0 : _fireFoxMatch$.split(".")[0]) < 100) return true;
    return false;
  }
  function getUnicodeLength(str) {
    return _toConsumableArray(str !== null && str !== void 0 ? str : "").length;
  }
  function limitUnicodeMaxLength(str, maxLength, oldStr) {
    if (_toConsumableArray(oldStr !== null && oldStr !== void 0 ? oldStr : "").slice().length === maxLength) return oldStr || "";
    return _toConsumableArray(str !== null && str !== void 0 ? str : "").slice(0, maxLength).join("");
  }

  function ownKeys$3S(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$3R(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$3S(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3S(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function circleAdapter(circleElem) {
    var _window, _window$getComputedSt2, _window2;
    var basicStyle = {};
    if (!circleElem || typeof window === "undefined") {
      return;
    }
    var _window$getComputedSt = (_window = window) === null || _window === void 0 || (_window$getComputedSt2 = _window.getComputedStyle) === null || _window$getComputedSt2 === void 0 ? void 0 : _window$getComputedSt2.call(_window, circleElem),
      color = _window$getComputedSt.color,
      fontSize = _window$getComputedSt.fontSize;
    var ua = (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.navigator) === null || _window2 === void 0 ? void 0 : _window2.userAgent;
    var isSafari = /Safari/.test(ua) && !/Chrome/.test(ua);
    var isIosWechat = /(?=.*iPhone)[?=.*MicroMessenger]/.test(ua) && !/Chrome/.test(ua);
    if (isSafari || isIosWechat) {
      basicStyle = {
        transformOrigin: "0px 0px",
        transform: "scale(".concat(parseInt(fontSize, 10) / 12, ")")
      };
    }
    if (color && getIEVersion$1() > 11) {
      var matched = color.match(/[\d.]+/g);
      var endColor = matched ? "rgba(".concat(matched[0], ", ").concat(matched[1], ", ").concat(matched[2], ", 0)") : "";
      setStyle(circleElem, _objectSpread$3R(_objectSpread$3R({}, basicStyle), {}, {
        background: "conic-gradient(from 90deg at 50% 50%,".concat(endColor, " 0deg, ").concat(color, " 360deg)")
      }));
    } else {
      setStyle(circleElem, _objectSpread$3R(_objectSpread$3R({}, basicStyle), {}, {
        background: ""
      }));
    }
  }

  var defaultConfig = {
    classPrefix: "t",
    animation: {
      include: ["ripple", "expand", "fade"],
      exclude: []
    },
    attach: null,
    calendar: {
      firstDayOfWeek: 1,
      fillWithZero: true,
      controllerConfig: void 0
    },
    icon: {},
    input: {
      autocomplete: ""
    },
    dialog: {
      closeOnEscKeydown: true,
      closeOnOverlayClick: true,
      confirmBtnTheme: {
        "default": "primary",
        info: "primary",
        warning: "primary",
        danger: "primary",
        success: "primary"
      }
    },
    message: {},
    popconfirm: {
      confirmBtnTheme: {
        "default": "primary",
        warning: "primary",
        danger: "primary"
      }
    },
    table: {
      expandIcon: void 0,
      sortIcon: void 0,
      filterIcon: void 0,
      treeExpandAndFoldIcon: void 0,
      hideSortTips: false,
      size: "medium"
    },
    select: {
      clearIcon: void 0,
      filterable: false
    },
    drawer: {
      closeOnEscKeydown: true,
      closeOnOverlayClick: true,
      size: "small"
    },
    tree: {
      folderIcon: void 0
    },
    datePicker: {
      firstDayOfWeek: 1
    },
    steps: {
      checkIcon: void 0,
      errorIcon: void 0
    },
    tag: {
      closeIcon: void 0
    },
    form: {
      requiredMark: void 0
    },
    empty: {
      titleText: {
        maintenance: void 0,
        success: void 0,
        fail: void 0,
        empty: void 0,
        networkError: void 0
      },
      image: {
        maintenance: void 0,
        success: void 0,
        fail: void 0,
        empty: void 0,
        networkError: void 0
      }
    }
  };

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function getDefaultExportFromCjs (x) {
  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }

  function createCommonjsModule(fn) {
    var module = { exports: {} };
  	return fn(module, module.exports), module.exports;
  }

  var dayjs_min = createCommonjsModule(function (module, exports) {
    !function (t, e) {
      module.exports = e() ;
    }(commonjsGlobal, function () {

      var t = 1e3,
        e = 6e4,
        n = 36e5,
        r = "millisecond",
        i = "second",
        s = "minute",
        u = "hour",
        a = "day",
        o = "week",
        c = "month",
        f = "quarter",
        h = "year",
        d = "date",
        l = "Invalid Date",
        $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,
        y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,
        M = {
          name: "en",
          weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
          months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
          ordinal: function ordinal(t) {
            var e = ["th", "st", "nd", "rd"],
              n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
          }
        },
        m = function m(t, e, n) {
          var r = String(t);
          return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
        },
        v = {
          s: m,
          z: function z(t) {
            var e = -t.utcOffset(),
              n = Math.abs(e),
              r = Math.floor(n / 60),
              i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
          },
          m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()),
              i = e.clone().add(r, c),
              s = n - i < 0,
              u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
          },
          a: function a(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
          },
          p: function p(t) {
            return {
              M: c,
              y: h,
              w: o,
              d: a,
              D: d,
              h: u,
              m: s,
              s: i,
              ms: r,
              Q: f
            }[t] || String(t || "").toLowerCase().replace(/s$/, "");
          },
          u: function u(t) {
            return void 0 === t;
          }
        },
        g = "en",
        D = {};
      D[g] = M;
      var p = "$isDayjsObject",
        S = function S(t) {
          return t instanceof _ || !(!t || !t[p]);
        },
        w = function t(e, n, r) {
          var i;
          if (!e) return g;
          if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
          } else {
            var a = e.name;
            D[a] = e, i = a;
          }
          return !r && i && (g = i), i || !r && g;
        },
        O = function O(t, e) {
          if (S(t)) return t.clone();
          var n = "object" == _typeof$2(e) ? e : {};
          return n.date = t, n.args = arguments, new _(n);
        },
        b = v;
      b.l = w, b.i = S, b.w = function (t, e) {
        return O(t, {
          locale: e.$L,
          utc: e.$u,
          x: e.$x,
          $offset: e.$offset
        });
      };
      var _ = function () {
          function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
          }
          var m = M.prototype;
          return m.parse = function (t) {
            this.$d = function (t) {
              var e = t.date,
                n = t.utc;
              if (null === e) return new Date(NaN);
              if (b.u(e)) return new Date();
              if (e instanceof Date) return new Date(e);
              if ("string" == typeof e && !/Z$/i.test(e)) {
                var r = e.match($);
                if (r) {
                  var i = r[2] - 1 || 0,
                    s = (r[7] || "0").substring(0, 3);
                  return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                }
              }
              return new Date(e);
            }(t), this.init();
          }, m.init = function () {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
          }, m.$utils = function () {
            return b;
          }, m.isValid = function () {
            return !(this.$d.toString() === l);
          }, m.isSame = function (t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
          }, m.isAfter = function (t, e) {
            return O(t) < this.startOf(e);
          }, m.isBefore = function (t, e) {
            return this.endOf(e) < O(t);
          }, m.$g = function (t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
          }, m.unix = function () {
            return Math.floor(this.valueOf() / 1e3);
          }, m.valueOf = function () {
            return this.$d.getTime();
          }, m.startOf = function (t, e) {
            var n = this,
              r = !!b.u(e) || e,
              f = b.p(t),
              l = function l(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
              },
              $ = function $(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e)), n);
              },
              y = this.$W,
              M = this.$M,
              m = this.$D,
              v = "set" + (this.$u ? "UTC" : "");
            switch (f) {
              case h:
                return r ? l(1, 0) : l(31, 11);
              case c:
                return r ? l(1, M) : l(0, M + 1);
              case o:
                var g = this.$locale().weekStart || 0,
                  D = (y < g ? y + 7 : y) - g;
                return l(r ? m - D : m + (6 - D), M);
              case a:
              case d:
                return $(v + "Hours", 0);
              case u:
                return $(v + "Minutes", 1);
              case s:
                return $(v + "Seconds", 2);
              case i:
                return $(v + "Milliseconds", 3);
              default:
                return this.clone();
            }
          }, m.endOf = function (t) {
            return this.startOf(t, !1);
          }, m.$set = function (t, e) {
            var n,
              o = b.p(t),
              f = "set" + (this.$u ? "UTC" : ""),
              l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o],
              $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
              var y = this.clone().set(d, 1);
              y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
          }, m.set = function (t, e) {
            return this.clone().$set(t, e);
          }, m.get = function (t) {
            return this[b.p(t)]();
          }, m.add = function (r, f) {
            var d,
              l = this;
            r = Number(r);
            var $ = b.p(f),
              y = function y(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
              };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1,
              m = this.$d.getTime() + r * M;
            return b.w(m, this);
          }, m.subtract = function (t, e) {
            return this.add(-1 * t, e);
          }, m.format = function (t) {
            var e = this,
              n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ",
              i = b.z(this),
              s = this.$H,
              u = this.$m,
              a = this.$M,
              o = n.weekdays,
              c = n.months,
              f = n.meridiem,
              h = function h(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
              },
              d = function d(t) {
                return b.s(s % 12 || 12, t, "0");
              },
              $ = f || function (t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
              };
            return r.replace(y, function (t, r) {
              return r || function (t) {
                switch (t) {
                  case "YY":
                    return String(e.$y).slice(-2);
                  case "YYYY":
                    return b.s(e.$y, 4, "0");
                  case "M":
                    return a + 1;
                  case "MM":
                    return b.s(a + 1, 2, "0");
                  case "MMM":
                    return h(n.monthsShort, a, c, 3);
                  case "MMMM":
                    return h(c, a);
                  case "D":
                    return e.$D;
                  case "DD":
                    return b.s(e.$D, 2, "0");
                  case "d":
                    return String(e.$W);
                  case "dd":
                    return h(n.weekdaysMin, e.$W, o, 2);
                  case "ddd":
                    return h(n.weekdaysShort, e.$W, o, 3);
                  case "dddd":
                    return o[e.$W];
                  case "H":
                    return String(s);
                  case "HH":
                    return b.s(s, 2, "0");
                  case "h":
                    return d(1);
                  case "hh":
                    return d(2);
                  case "a":
                    return $(s, u, !0);
                  case "A":
                    return $(s, u, !1);
                  case "m":
                    return String(u);
                  case "mm":
                    return b.s(u, 2, "0");
                  case "s":
                    return String(e.$s);
                  case "ss":
                    return b.s(e.$s, 2, "0");
                  case "SSS":
                    return b.s(e.$ms, 3, "0");
                  case "Z":
                    return i;
                }
                return null;
              }(t) || i.replace(":", "");
            });
          }, m.utcOffset = function () {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
          }, m.diff = function (r, d, l) {
            var $,
              y = this,
              M = b.p(d),
              m = O(r),
              v = (m.utcOffset() - this.utcOffset()) * e,
              g = this - m,
              D = function D() {
                return b.m(y, m);
              };
            switch (M) {
              case h:
                $ = D() / 12;
                break;
              case c:
                $ = D();
                break;
              case f:
                $ = D() / 3;
                break;
              case o:
                $ = (g - v) / 6048e5;
                break;
              case a:
                $ = (g - v) / 864e5;
                break;
              case u:
                $ = g / n;
                break;
              case s:
                $ = g / e;
                break;
              case i:
                $ = g / t;
                break;
              default:
                $ = g;
            }
            return l ? $ : b.a($);
          }, m.daysInMonth = function () {
            return this.endOf(c).$D;
          }, m.$locale = function () {
            return D[this.$L];
          }, m.locale = function (t, e) {
            if (!t) return this.$L;
            var n = this.clone(),
              r = w(t, e, !0);
            return r && (n.$L = r), n;
          }, m.clone = function () {
            return b.w(this.$d, this);
          }, m.toDate = function () {
            return new Date(this.valueOf());
          }, m.toJSON = function () {
            return this.isValid() ? this.toISOString() : null;
          }, m.toISOString = function () {
            return this.$d.toISOString();
          }, m.toString = function () {
            return this.$d.toUTCString();
          }, M;
        }(),
        k = _.prototype;
      return O.prototype = k, [["$ms", r], ["$s", i], ["$m", s], ["$H", u], ["$W", a], ["$M", c], ["$y", h], ["$D", d]].forEach(function (t) {
        k[t[1]] = function (e) {
          return this.$g(e, t[0], t[1]);
        };
      }), O.extend = function (t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
      }, O.locale = w, O.isDayjs = S, O.unix = function (t) {
        return O(1e3 * t);
      }, O.en = D[g], O.Ls = D, O.p = {}, O;
    });
  });

  createCommonjsModule(function (module, exports) {
    !function (e, _) {
      module.exports = _(dayjs_min) ;
    }(commonjsGlobal, function (e) {

      function _(e) {
        return e && "object" == _typeof$2(e) && "default" in e ? e : {
          "default": e
        };
      }
      var t = _(e),
        d = {
          name: "zh-cn",
          weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),
          weekdaysShort: "周日_周一_周二_周三_周四_周五_周六".split("_"),
          weekdaysMin: "日_一_二_三_四_五_六".split("_"),
          months: "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),
          monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
          ordinal: function ordinal(e, _) {
            return "W" === _ ? e + "周" : e + "日";
          },
          weekStart: 1,
          yearStart: 4,
          formats: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY/MM/DD",
            LL: "YYYY年M月D日",
            LLL: "YYYY年M月D日Ah点mm分",
            LLLL: "YYYY年M月D日ddddAh点mm分",
            l: "YYYY/M/D",
            ll: "YYYY年M月D日",
            lll: "YYYY年M月D日 HH:mm",
            llll: "YYYY年M月D日dddd HH:mm"
          },
          relativeTime: {
            future: "%s内",
            past: "%s前",
            s: "几秒",
            m: "1 分钟",
            mm: "%d 分钟",
            h: "1 小时",
            hh: "%d 小时",
            d: "1 天",
            dd: "%d 天",
            M: "1 个月",
            MM: "%d 个月",
            y: "1 年",
            yy: "%d 年"
          },
          meridiem: function meridiem(e, _) {
            var t = 100 * e + _;
            return t < 600 ? "凌晨" : t < 900 ? "早上" : t < 1100 ? "上午" : t < 1300 ? "中午" : t < 1800 ? "下午" : "晚上";
          }
        };
      return t["default"].locale(d, null, !0), d;
    });
  });

  var defaultZhCN = {
    autoComplete: {
      empty: "\u6682\u65E0\u6570\u636E"
    },
    pagination: {
      itemsPerPage: "{size} \u6761/\u9875",
      jumpTo: "\u8DF3\u81F3",
      page: "\u9875",
      total: "\u5171 {total} \u6761\u6570\u636E"
    },
    cascader: {
      empty: "\u6682\u65E0\u6570\u636E",
      loadingText: "\u52A0\u8F7D\u4E2D",
      placeholder: "\u8BF7\u9009\u62E9"
    },
    calendar: {
      yearSelection: "{year} \u5E74",
      monthSelection: "{month} \u6708",
      yearRadio: "\u5E74",
      monthRadio: "\u6708",
      hideWeekend: "\u9690\u85CF\u5468\u672B",
      showWeekend: "\u663E\u793A\u5468\u672B",
      today: "\u4ECA\u5929",
      thisMonth: "\u672C\u6708",
      week: "\u4E00,\u4E8C,\u4E09,\u56DB,\u4E94,\u516D,\u65E5",
      cellMonth: "1 \u6708,2 \u6708,3 \u6708,4 \u6708,5 \u6708,6 \u6708,7 \u6708,8 \u6708,9 \u6708,10 \u6708,11 \u6708,12 \u6708"
    },
    transfer: {
      title: "{checked} / {total} \u9879",
      empty: "\u6682\u65E0\u6570\u636E",
      placeholder: "\u8BF7\u8F93\u5165\u5173\u952E\u8BCD\u641C\u7D22"
    },
    timePicker: {
      dayjsLocale: "zh-cn",
      now: "\u6B64\u523B",
      confirm: "\u786E\u5B9A",
      anteMeridiem: "\u4E0A\u5348",
      postMeridiem: "\u4E0B\u5348",
      placeholder: "\u9009\u62E9\u65F6\u95F4"
    },
    dialog: {
      confirm: "\u786E\u8BA4",
      cancel: "\u53D6\u6D88"
    },
    drawer: {
      confirm: "\u786E\u8BA4",
      cancel: "\u53D6\u6D88"
    },
    popconfirm: {
      confirm: {
        content: "\u786E\u5B9A"
      },
      cancel: {
        content: "\u53D6\u6D88"
      }
    },
    table: {
      empty: "\u6682\u65E0\u6570\u636E",
      loadingText: "\u6B63\u5728\u52A0\u8F7D\u4E2D\uFF0C\u8BF7\u7A0D\u540E",
      loadingMoreText: "\u70B9\u51FB\u52A0\u8F7D\u66F4\u591A",
      filterInputPlaceholder: "\u8BF7\u8F93\u5165\u5185\u5BB9\uFF08\u65E0\u9ED8\u8BA4\u503C\uFF09",
      sortAscendingOperationText: "\u70B9\u51FB\u5347\u5E8F",
      sortCancelOperationText: "\u70B9\u51FB\u53D6\u6D88\u6392\u5E8F",
      sortDescendingOperationText: "\u70B9\u51FB\u964D\u5E8F",
      clearFilterResultButtonText: "\u6E05\u7A7A\u7B5B\u9009",
      columnConfigButtonText: "\u5217\u914D\u7F6E",
      columnConfigTitleText: "\u8868\u683C\u5217\u914D\u7F6E",
      columnConfigDescriptionText: "\u8BF7\u9009\u62E9\u9700\u8981\u5728\u8868\u683C\u4E2D\u663E\u793A\u7684\u6570\u636E\u5217",
      confirmText: "\u786E\u8BA4",
      cancelText: "\u53D6\u6D88",
      resetText: "\u91CD\u7F6E",
      selectAllText: "\u5168\u9009",
      searchResultText: "\u641C\u7D22\u201C{result}\u201D\uFF0C\u627E\u5230 {count} \u6761\u7ED3\u679C"
    },
    select: {
      empty: "\u6682\u65E0\u6570\u636E",
      loadingText: "\u52A0\u8F7D\u4E2D",
      placeholder: "\u8BF7\u9009\u62E9"
    },
    tree: {
      empty: "\u6682\u65E0\u6570\u636E"
    },
    treeSelect: {
      empty: "\u6682\u65E0\u6570\u636E",
      loadingText: "\u52A0\u8F7D\u4E2D",
      placeholder: "\u8BF7\u9009\u62E9"
    },
    datePicker: {
      dayjsLocale: "zh-cn",
      placeholder: {
        date: "\u8BF7\u9009\u62E9\u65E5\u671F",
        month: "\u8BF7\u9009\u62E9\u6708\u4EFD",
        year: "\u8BF7\u9009\u62E9\u5E74\u4EFD",
        quarter: "\u8BF7\u9009\u62E9\u5B63\u5EA6",
        week: "\u8BF7\u9009\u62E9\u5468"
      },
      weekdays: ["\u4E00", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D", "\u65E5"],
      months: ["1 \u6708", "2 \u6708", "3 \u6708", "4 \u6708", "5 \u6708", "6 \u6708", "7 \u6708", "8 \u6708", "9 \u6708", "10 \u6708", "11 \u6708", "12 \u6708"],
      quarters: ["\u4E00\u5B63\u5EA6", "\u4E8C\u5B63\u5EA6", "\u4E09\u5B63\u5EA6", "\u56DB\u5B63\u5EA6"],
      rangeSeparator: " - ",
      direction: "ltr",
      format: "YYYY-MM-DD",
      dayAriaLabel: "\u65E5",
      weekAbbreviation: "\u5468",
      yearAriaLabel: "\u5E74",
      monthAriaLabel: "\u6708",
      confirm: "\u786E\u5B9A",
      selectTime: "\u9009\u62E9\u65F6\u95F4",
      selectDate: "\u9009\u62E9\u65E5\u671F",
      nextYear: "\u4E0B\u4E00\u5E74",
      preYear: "\u4E0A\u4E00\u5E74",
      nextMonth: "\u4E0B\u4E2A\u6708",
      preMonth: "\u4E0A\u4E2A\u6708",
      preDecade: "\u4E0A\u4E2A\u5341\u5E74",
      nextDecade: "\u4E0B\u4E2A\u5341\u5E74",
      now: "\u5F53\u524D"
    },
    upload: {
      sizeLimitMessage: "\u6587\u4EF6\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7 {sizeLimit}",
      cancelUploadText: "\u53D6\u6D88\u4E0A\u4F20",
      triggerUploadText: {
        fileInput: "\u9009\u62E9\u6587\u4EF6",
        image: "\u70B9\u51FB\u4E0A\u4F20\u56FE\u7247",
        normal: "\u70B9\u51FB\u4E0A\u4F20",
        reupload: "\u91CD\u65B0\u9009\u62E9",
        continueUpload: "\u7EE7\u7EED\u9009\u62E9",
        "delete": "\u5220\u9664",
        uploading: "\u4E0A\u4F20\u4E2D"
      },
      dragger: {
        dragDropText: "\u91CA\u653E\u9F20\u6807",
        draggingText: "\u62D6\u62FD\u5230\u6B64\u533A\u57DF",
        clickAndDragText: "\u70B9\u51FB\u4E0A\u65B9\u201C\u9009\u62E9\u6587\u4EF6\u201D\u6216\u5C06\u6587\u4EF6\u62D6\u62FD\u5230\u6B64\u533A\u57DF"
      },
      file: {
        fileNameText: "\u6587\u4EF6\u540D",
        fileSizeText: "\u6587\u4EF6\u5927\u5C0F",
        fileStatusText: "\u72B6\u6001",
        fileOperationText: "\u64CD\u4F5C",
        fileOperationDateText: "\u4E0A\u4F20\u65E5\u671F"
      },
      progress: {
        uploadingText: "\u4E0A\u4F20\u4E2D",
        waitingText: "\u5F85\u4E0A\u4F20",
        failText: "\u4E0A\u4F20\u5931\u8D25",
        successText: "\u4E0A\u4F20\u6210\u529F"
      }
    },
    form: {
      errorMessage: {
        date: "\u8BF7\u8F93\u5165\u6B63\u786E\u7684${name}",
        url: "\u8BF7\u8F93\u5165\u6B63\u786E\u7684${name}",
        required: "${name}\u5FC5\u586B",
        whitespace: "${name}\u4E0D\u80FD\u4E3A\u7A7A",
        max: "${name}\u5B57\u7B26\u957F\u5EA6\u4E0D\u80FD\u8D85\u8FC7 ${validate} \u4E2A\u5B57\u7B26\uFF0C\u4E00\u4E2A\u4E2D\u6587\u7B49\u4E8E\u4E24\u4E2A\u5B57\u7B26",
        min: "${name}\u5B57\u7B26\u957F\u5EA6\u4E0D\u80FD\u5C11\u4E8E ${validate} \u4E2A\u5B57\u7B26\uFF0C\u4E00\u4E2A\u4E2D\u6587\u7B49\u4E8E\u4E24\u4E2A\u5B57\u7B26",
        len: "${name}\u5B57\u7B26\u957F\u5EA6\u5FC5\u987B\u662F ${validate}",
        "enum": "${name}\u53EA\u80FD\u662F${validate}\u7B49",
        idcard: "\u8BF7\u8F93\u5165\u6B63\u786E\u7684${name}",
        telnumber: "\u8BF7\u8F93\u5165\u6B63\u786E\u7684${name}",
        pattern: "\u8BF7\u8F93\u5165\u6B63\u786E\u7684${name}",
        validator: "${name}\u4E0D\u7B26\u5408\u8981\u6C42",
        "boolean": "${name}\u6570\u636E\u7C7B\u578B\u5FC5\u987B\u662F\u5E03\u5C14\u7C7B\u578B",
        number: "${name}\u5FC5\u987B\u662F\u6570\u5B57"
      },
      colonText: "\uFF1A"
    },
    input: {
      placeholder: "\u8BF7\u8F93\u5165"
    },
    list: {
      loadingText: "\u6B63\u5728\u52A0\u8F7D\u4E2D\uFF0C\u8BF7\u7A0D\u7B49",
      loadingMoreText: "\u70B9\u51FB\u52A0\u8F7D\u66F4\u591A"
    },
    alert: {
      expandText: "\u5C55\u5F00\u66F4\u591A",
      collapseText: "\u6536\u8D77"
    },
    anchor: {
      copySuccessText: "\u94FE\u63A5\u590D\u5236\u6210\u529F",
      copyText: "\u590D\u5236\u94FE\u63A5"
    },
    colorPicker: {
      swatchColorTitle: "\u7CFB\u7EDF\u9884\u8BBE\u989C\u8272",
      recentColorTitle: "\u6700\u8FD1\u4F7F\u7528\u989C\u8272",
      clearConfirmText: "\u786E\u5B9A\u6E05\u7A7A\u6700\u8FD1\u4F7F\u7528\u7684\u989C\u8272\u5417\uFF1F",
      singleColor: "\u5355\u8272",
      gradientColor: "\u6E10\u53D8"
    },
    guide: {
      finishButtonProps: {
        content: "\u5B8C\u6210",
        theme: "primary"
      },
      nextButtonProps: {
        content: "\u4E0B\u4E00\u6B65",
        theme: "primary"
      },
      skipButtonProps: {
        content: "\u8DF3\u8FC7",
        theme: "default"
      },
      prevButtonProps: {
        content: "\u4E0A\u4E00\u6B65",
        theme: "default"
      }
    },
    image: {
      errorText: "\u56FE\u7247\u65E0\u6CD5\u663E\u793A",
      loadingText: "\u56FE\u7247\u52A0\u8F7D\u4E2D"
    },
    imageViewer: {
      errorText: "\u56FE\u7247\u52A0\u8F7D\u5931\u8D25\uFF0C\u53EF\u5C1D\u8BD5\u91CD\u65B0\u52A0\u8F7D",
      mirrorTipText: "\u955C\u50CF",
      rotateTipText: "\u65CB\u8F6C",
      originalSizeTipText: "\u539F\u59CB\u5927\u5C0F"
    },
    typography: {
      expandText: "\u5C55\u5F00",
      collapseText: "\u6536\u8D77",
      copiedText: "\u590D\u5236\u6210\u529F"
    },
    rate: {
      rateText: ["\u6781\u5DEE", "\u5931\u671B", "\u4E00\u822C", "\u6EE1\u610F", "\u60CA\u559C"]
    },
    empty: {
      titleText: {
        maintenance: "\u5EFA\u8BBE\u4E2D",
        success: "\u6210\u529F",
        fail: "\u5931\u8D25",
        empty: "\u6682\u65E0\u6570\u636E",
        networkError: "\u7F51\u7EDC\u9519\u8BEF"
      }
    },
    descriptions: {
      colonText: "\uFF1A"
    }
  };

  var defaultGlobalConfig = merge$1(defaultConfig, defaultZhCN);
  var mergeWith = function mergeWith(defaultGlobalConfig2, injectConfig) {
    return mergeWith$2(defaultGlobalConfig2, injectConfig, function (objValue, srcValue) {
      if (Array.isArray(objValue)) {
        return srcValue;
      }
    });
  };

  function getConfigReceiverMixins(_componentName) {
    return Vue__default["default"].extend({
      name: "TConfigProvider",
      inject: {
        globalConfig: {
          "default": void 0
        }
      },
      computed: {
        global: function global() {
          var data = this.globalConfig || defaultGlobalConfig;
          return data[_componentName];
        },
        classPrefix: function classPrefix() {
          var _this$globalConfig;
          return ((_this$globalConfig = this.globalConfig) === null || _this$globalConfig === void 0 ? void 0 : _this$globalConfig.classPrefix) || (defaultGlobalConfig === null || defaultGlobalConfig === void 0 ? void 0 : defaultGlobalConfig.classPrefix);
        },
        componentName: function componentName() {
          var _this$globalConfig2;
          var classPrefix = ((_this$globalConfig2 = this.globalConfig) === null || _this$globalConfig2 === void 0 ? void 0 : _this$globalConfig2.classPrefix) || (defaultGlobalConfig === null || defaultGlobalConfig === void 0 ? void 0 : defaultGlobalConfig.classPrefix);
          return "".concat(classPrefix, "-").concat(_componentName);
        },
        commonSizeClassName: function commonSizeClassName() {
          return {
            small: "".concat(this.classPrefix, "-size-s"),
            medium: "".concat(this.classPrefix, "-size-m"),
            large: "".concat(this.classPrefix, "-size-l"),
            "default": "",
            xs: "".concat(this.classPrefix, "-size-xs"),
            xl: "".concat(this.classPrefix, "-size-xl"),
            block: "".concat(this.classPrefix, "-size-full-width")
          };
        },
        commonStatusClassName: function commonStatusClassName() {
          return {
            loading: "".concat(this.classPrefix, "-is-loading"),
            loadMore: "".concat(this.classPrefix, "-is-load-more"),
            disabled: "".concat(this.classPrefix, "-is-disabled"),
            focused: "".concat(this.classPrefix, "-is-focused"),
            success: "".concat(this.classPrefix, "-is-success"),
            error: "".concat(this.classPrefix, "-is-error"),
            warning: "".concat(this.classPrefix, "-is-warning"),
            selected: "".concat(this.classPrefix, "-is-selected"),
            active: "".concat(this.classPrefix, "-is-active"),
            checked: "".concat(this.classPrefix, "-is-checked"),
            current: "".concat(this.classPrefix, "-is-current"),
            hidden: "".concat(this.classPrefix, "-is-hidden"),
            visible: "".concat(this.classPrefix, "-is-visible"),
            expanded: "".concat(this.classPrefix, "-is-expanded"),
            indeterminate: "".concat(this.classPrefix, "-is-indeterminate")
          };
        }
      },
      methods: {
        t: function t(pattern, placement) {
          if (typeof pattern === "string") {
            if (!placement) return pattern;
            var regexp = /\{\s*([\w-]+)\s*\}/g;
            var translated = pattern.replace(regexp, function (match, key) {
              if (placement) {
                return String(placement[key]);
              }
              return "";
            });
            return translated;
          }
          if (typeof pattern === "function") {
            return pattern(placement);
          }
          return "";
        }
      }
    });
  }
  function getGlobalIconMixins() {
    return Vue__default["default"].extend({
      name: "TGlobalIcon",
      inject: {
        globalConfig: {
          "default": void 0
        }
      },
      methods: {
        useGlobalIcon: function useGlobalIcon(tdIcon) {
          var iconGlobalData = (this.globalConfig || defaultGlobalConfig).icon;
          var resultIcon = {};
          Object.keys(tdIcon).forEach(function (key) {
            resultIcon[key] = (iconGlobalData === null || iconGlobalData === void 0 ? void 0 : iconGlobalData[key]) || tdIcon[key];
          });
          return resultIcon;
        }
      }
    });
  }
  function getKeepAnimationMixins() {
    return Vue__default["default"].extend({
      name: "TKeepAnimation",
      inject: {
        globalConfig: {
          "default": void 0
        }
      },
      computed: {
        keepAnimation: function keepAnimation() {
          var animationConfig = mergeWith$2({}, defaultGlobalConfig.animation);
          if (this.globalConfig && this.globalConfig.animation) {
            animationConfig = mergeWith$2(animationConfig, this.globalConfig.animation, function (objValue, srcValue) {
              if (Array.isArray(objValue)) {
                return srcValue;
              }
            });
          }
          var isKeep = function isKeep(type) {
            return animationConfig && !animationConfig.exclude.includes(type) && animationConfig.include.includes(type);
          };
          return {
            ripple: isKeep("ripple"),
            expand: isKeep("expand"),
            fade: isKeep("fade")
          };
        }
      }
    });
  }
  function getClassPrefixMixins(_componentName2) {
    return Vue__default["default"].extend({
      name: "TClassPrefixProvider",
      inject: {
        globalConfig: {
          "default": void 0
        }
      },
      computed: {
        classPrefix: function classPrefix() {
          var _this$globalConfig3;
          return ((_this$globalConfig3 = this.globalConfig) === null || _this$globalConfig3 === void 0 ? void 0 : _this$globalConfig3.classPrefix) || defaultGlobalConfig.classPrefix;
        },
        componentName: function componentName() {
          var _this$globalConfig4;
          var classPrefix = ((_this$globalConfig4 = this.globalConfig) === null || _this$globalConfig4 === void 0 ? void 0 : _this$globalConfig4.classPrefix) || defaultGlobalConfig.classPrefix;
          return "".concat(classPrefix, "-").concat(_componentName2);
        },
        commonSizeClassName: function commonSizeClassName() {
          return {
            small: "".concat(this.classPrefix, "-size-s"),
            medium: "".concat(this.classPrefix, "-size-m"),
            large: "".concat(this.classPrefix, "-size-l"),
            "default": "",
            xs: "".concat(this.classPrefix, "-size-xs"),
            xl: "".concat(this.classPrefix, "-size-xl"),
            block: "".concat(this.classPrefix, "-size-full-width")
          };
        },
        commonStatusClassName: function commonStatusClassName() {
          return {
            loading: "".concat(this.classPrefix, "-is-loading"),
            loadMore: "".concat(this.classPrefix, "-is-load-more"),
            disabled: "".concat(this.classPrefix, "-is-disabled"),
            focused: "".concat(this.classPrefix, "-is-focused"),
            success: "".concat(this.classPrefix, "-is-success"),
            error: "".concat(this.classPrefix, "-is-error"),
            warning: "".concat(this.classPrefix, "-is-warning"),
            selected: "".concat(this.classPrefix, "-is-selected"),
            active: "".concat(this.classPrefix, "-is-active"),
            checked: "".concat(this.classPrefix, "-is-checked"),
            current: "".concat(this.classPrefix, "-is-current"),
            hidden: "".concat(this.classPrefix, "-is-hidden"),
            visible: "".concat(this.classPrefix, "-is-visible"),
            expanded: "".concat(this.classPrefix, "-is-expanded"),
            indeterminate: "".concat(this.classPrefix, "-is-indeterminate")
          };
        }
      }
    });
  }
  function getAttachConfigMixins(componentName) {
    return Vue__default["default"].extend({
      name: "TAttachProvider",
      inject: {
        globalConfig: {
          "default": void 0
        }
      },
      methods: {
        globalAttach: function globalAttach() {
          var _this$globalConfig5;
          var globalConfigAttach = (_this$globalConfig5 = this.globalConfig) === null || _this$globalConfig5 === void 0 ? void 0 : _this$globalConfig5.attach;
          if (typeof globalConfigAttach === "string" || typeof globalConfigAttach === "function") {
            return globalConfigAttach;
          }
          return (globalConfigAttach === null || globalConfigAttach === void 0 ? void 0 : globalConfigAttach[componentName]) || "body";
        }
      }
    });
  }

  function mixins() {
    for (var _len = arguments.length, mixins2 = new Array(_len), _key = 0; _key < _len; _key++) {
      mixins2[_key] = arguments[_key];
    }
    return Vue__default["default"].extend({
      mixins: mixins2
    });
  }

  var classPrefixMixins$N = getClassPrefixMixins("loading");
  var GradientIcon = mixins(classPrefixMixins$N).extend({
    name: "TLoadingGradient",
    mounted: function mounted() {
      var _this = this;
      this.$nextTick(function () {
        _this.updateColor();
      });
    },
    updated: function updated() {
      this.updateColor();
    },
    methods: {
      updateColor: function updateColor() {
        var circleElem = this.$refs.circle;
        circleAdapter(circleElem);
      }
    },
    render: function render() {
      var h = arguments[0];
      var classes = ["".concat(this.classPrefix, "-loading__gradient"), "".concat(this.classPrefix, "-icon-loading")];
      return h("svg", {
        "class": classes,
        "attrs": {
          "viewBox": "0 0 12 12",
          "version": "1.1",
          "width": "1em",
          "height": "1em",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [h("foreignObject", {
        "attrs": {
          "x": "0",
          "y": "0",
          "width": "12",
          "height": "12"
        }
      }, [h("div", {
        "class": "".concat(this.classPrefix, "-loading__gradient-conic"),
        "ref": "circle"
      })])]);
    }
  });

  var performanceNow = createCommonjsModule(function (module) {
    // Generated by CoffeeScript 1.12.2
    (function () {
      var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
      if (typeof performance !== "undefined" && performance !== null && performance.now) {
        module.exports = function () {
          return performance.now();
        };
      } else if (typeof process !== "undefined" && process !== null && process.hrtime) {
        module.exports = function () {
          return (getNanoSeconds() - nodeLoadTime) / 1e6;
        };
        hrtime = process.hrtime;
        getNanoSeconds = function getNanoSeconds() {
          var hr;
          hr = hrtime();
          return hr[0] * 1e9 + hr[1];
        };
        moduleLoadTime = getNanoSeconds();
        upTime = process.uptime() * 1e9;
        nodeLoadTime = moduleLoadTime - upTime;
      } else if (Date.now) {
        module.exports = function () {
          return Date.now() - loadTime;
        };
        loadTime = Date.now();
      } else {
        module.exports = function () {
          return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
      }
    }).call(commonjsGlobal);
  });

  var root = typeof window === 'undefined' ? commonjsGlobal : window,
    vendors = ['moz', 'webkit'],
    suffix = 'AnimationFrame',
    raf = root['request' + suffix],
    caf = root['cancel' + suffix] || root['cancelRequest' + suffix];
  for (var i = 0; !raf && i < vendors.length; i++) {
    raf = root[vendors[i] + 'Request' + suffix];
    caf = root[vendors[i] + 'Cancel' + suffix] || root[vendors[i] + 'CancelRequest' + suffix];
  }

  // Some versions of FF have rAF but not cAF
  if (!raf || !caf) {
    var last = 0,
      id = 0,
      queue = [],
      frameDuration = 1000 / 60;
    raf = function raf(callback) {
      if (queue.length === 0) {
        var _now = performanceNow(),
          next = Math.max(0, frameDuration - (_now - last));
        last = next + _now;
        setTimeout(function () {
          var cp = queue.slice(0);
          // Clear queue here to prevent
          // callbacks from appending listeners
          // to the current frame's queue
          queue.length = 0;
          var _loop = function _loop() {
            if (!cp[i].cancelled) {
              try {
                cp[i].callback(last);
              } catch (e) {
                setTimeout(function () {
                  throw e;
                }, 0);
              }
            }
          };
          for (var i = 0; i < cp.length; i++) {
            _loop();
          }
        }, Math.round(next));
      }
      queue.push({
        handle: ++id,
        callback: callback,
        cancelled: false
      });
      return id;
    };
    caf = function caf(handle) {
      for (var i = 0; i < queue.length; i++) {
        if (queue[i].handle === handle) {
          queue[i].cancelled = true;
        }
      }
    };
  }
  var raf_1 = function raf_1(fn) {
    // Wrap in a new function to prevent
    // `cancel` potentially being assigned
    // to the native rAF function
    return raf.call(root, fn);
  };
  var cancel = function cancel() {
    caf.apply(root, arguments);
  };
  var polyfill = function polyfill(object) {
    if (!object) {
      object = root;
    }
    object.requestAnimationFrame = raf;
    object.cancelAnimationFrame = caf;
  };
  raf_1.cancel = cancel;
  raf_1.polyfill = polyfill;

  var easeInOutCubic = function easeInOutCubic(current, start, end, duration) {
    var change = (end - start) / 2;
    var time = current / (duration / 2);
    if (time < 1) {
      return change * time * time * time + start;
    }
    time -= 2;
    return change * (time * time * time + 2) + start;
  };

  var isServer = Vue__default["default"].prototype.$isServer || typeof window === "undefined";
  var trim = function trim(str) {
    return (str || "").replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, "");
  };
  var on$1 = function () {
    if (!isServer && document.addEventListener) {
      return function (element, event, handler, options) {
        if (element && event && handler) {
          element.addEventListener(event, handler, options);
          return function () {
            return off$1(element, event, handler, options);
          };
        }
      };
    }
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent("on".concat(event), handler);
        return function () {
          return off$1(element, event, handler);
        };
      }
    };
  }();
  var off$1 = function () {
    if (!isServer && document.removeEventListener) {
      return function (element, event, handler, options) {
        if (element && event) {
          element.removeEventListener(event, handler, options);
        }
      };
    }
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent("on".concat(event), handler);
      }
    };
  }();
  function once(element, event, handler, options) {
    var handlerFn = typeof handler === "function" ? handler : handler.handleEvent;
    var _callback = function callback(evt) {
      handlerFn(evt);
      off$1(element, event, _callback, options);
    };
    on$1(element, event, _callback, options);
  }
  function hasClass(el, cls) {
    if (!el || !cls) return false;
    if (cls.indexOf(" ") !== -1) throw new Error("className should not contain space.");
    if (el.classList) {
      return el.classList.contains(cls);
    }
    return " ".concat(el.className, " ").indexOf(" ".concat(cls, " ")) > -1;
  }
  function addClass(el, cls) {
    if (!el) return;
    var curClass = el.className;
    var classes = (cls || "").split(" ");
    for (var i = 0, j = classes.length; i < j; i++) {
      var clsName = classes[i];
      if (!clsName) continue;
      if (el.classList) {
        el.classList.add(clsName);
      } else if (!hasClass(el, clsName)) {
        curClass += " ".concat(clsName);
      }
    }
    if (!el.classList) {
      el.className = curClass;
    }
  }
  function removeClass(el, cls) {
    if (!el || !cls) return;
    var classes = cls.split(" ");
    var curClass = " ".concat(el.className, " ");
    for (var i = 0, j = classes.length; i < j; i++) {
      var clsName = classes[i];
      if (!clsName) continue;
      if (el.classList) {
        el.classList.remove(clsName);
      } else if (hasClass(el, clsName)) {
        curClass = curClass.replace(" ".concat(clsName, " "), " ");
      }
    }
    if (!el.classList) {
      el.className = trim(curClass);
    }
  }
  var getAttach = function getAttach(node, triggerNode) {
    var attachNode = typeof node === "function" ? node(triggerNode) : node;
    if (!attachNode) {
      return document.body;
    }
    if (isString(attachNode)) {
      return document.querySelector(attachNode);
    }
    if (attachNode instanceof HTMLElement) {
      return attachNode;
    }
    return document.body;
  };
  var getScrollContainer = function getScrollContainer() {
    var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "body";
    if (isString(container)) {
      return document.querySelector(container);
    }
    if (typeof container === "function") {
      return container();
    }
    return container;
  };
  function isWindow(obj) {
    return obj && obj === obj.window;
  }
  function getScroll(target, isLeft) {
    if (typeof window === "undefined" || !target) {
      return 0;
    }
    var method = isLeft ? "scrollLeft" : "scrollTop";
    var result = 0;
    if (isWindow(target)) {
      result = target[isLeft ? "pageXOffset" : "pageYOffset"];
    } else if (target instanceof Document) {
      result = target.documentElement[method];
    } else if (target) {
      result = target[method];
    }
    return result;
  }
  function scrollTo(target, opt) {
    var _opt$container = opt.container,
      container = _opt$container === void 0 ? window : _opt$container,
      _opt$duration = opt.duration,
      duration = _opt$duration === void 0 ? 450 : _opt$duration,
      _opt$easing = opt.easing,
      easing = _opt$easing === void 0 ? easeInOutCubic : _opt$easing;
    var scrollTop = getScroll(container);
    var startTime = Date.now();
    return new Promise(function (res) {
      var _fnc = function fnc() {
        var timestamp = Date.now();
        var time = timestamp - startTime;
        var nextScrollTop = easing(Math.min(time, duration), scrollTop, target, duration);
        if (isWindow(container)) {
          container.scrollTo(window.pageXOffset, nextScrollTop);
        } else if (container instanceof HTMLDocument || container.constructor.name === "HTMLDocument") {
          container.documentElement.scrollTop = nextScrollTop;
        } else {
          container.scrollTop = nextScrollTop;
        }
        if (time < duration) {
          raf_1(_fnc);
        } else {
          raf_1(res);
        }
      };
      raf_1(_fnc);
    });
  }
  var isNodeOverflow = function isNodeOverflow(ele) {
    var _ele$clientWidth = ele.clientWidth,
      clientWidth = _ele$clientWidth === void 0 ? 0 : _ele$clientWidth,
      _ele$scrollWidth = ele.scrollWidth,
      scrollWidth = _ele$scrollWidth === void 0 ? 0 : _ele$scrollWidth;
    return scrollWidth > clientWidth;
  };
  var removeDom = function removeDom(el) {
    if (el.remove) {
      el.remove();
    } else {
      el.parentNode.removeChild(el);
    }
  };
  function elementInViewport(elm, parent) {
    var rect = elm.getBoundingClientRect();
    if (parent) {
      var parentRect = parent.getBoundingClientRect();
      return rect.top >= parentRect.top && rect.left >= parentRect.left && rect.bottom <= parentRect.bottom && rect.right <= parentRect.right;
    }
    return rect.top >= 0 && rect.left >= 0 && rect.bottom + 80 <= window.innerHeight && rect.right <= window.innerWidth;
  }
  function getElmCssPropValue(element, propName) {
    var propValue = "";
    if (document.defaultView && document.defaultView.getComputedStyle) {
      propValue = document.defaultView.getComputedStyle(element, null).getPropertyValue(propName);
    }
    if (propValue && propValue.toLowerCase) {
      return propValue.toLowerCase();
    }
    return propValue;
  }
  function isFixed(element) {
    var p = element.parentNode;
    if (!p || p.nodeName === "HTML") {
      return false;
    }
    if (getElmCssPropValue(element, "position") === "fixed") {
      return true;
    }
    return isFixed(p);
  }
  function getWindowScroll$1() {
    var _document = document,
      body = _document.body;
    var docElm = document.documentElement;
    var scrollTop = window.pageYOffset || docElm.scrollTop || body.scrollTop;
    var scrollLeft = window.pageXOffset || docElm.scrollLeft || body.scrollLeft;
    return {
      scrollTop: scrollTop,
      scrollLeft: scrollLeft
    };
  }
  function getWindowSize() {
    if (window.innerWidth !== void 0) {
      return {
        width: window.innerWidth,
        height: window.innerHeight
      };
    }
    var doc = document.documentElement;
    return {
      width: doc.clientWidth,
      height: doc.clientHeight
    };
  }

  var RenderJsTypes = [Function, String, Number, Boolean, Object, Array];
  function handleSlots$1(vm, params, name) {
    var _vm$$scopedSlots$came, _vm$$scopedSlots, _vm$$scopedSlots$keba, _vm$$scopedSlots2;
    var finaleParams = VueCompositionAPI.h;
    if (params) {
      Object.assign(finaleParams, params);
    }
    var node = (_vm$$scopedSlots$came = (_vm$$scopedSlots = vm.$scopedSlots)[camelCase$1(name)]) === null || _vm$$scopedSlots$came === void 0 ? void 0 : _vm$$scopedSlots$came.call(_vm$$scopedSlots, finaleParams);
    if (node) return node;
    node = (_vm$$scopedSlots$keba = (_vm$$scopedSlots2 = vm.$scopedSlots)[kebabCase$1(name)]) === null || _vm$$scopedSlots$keba === void 0 ? void 0 : _vm$$scopedSlots$keba.call(_vm$$scopedSlots2, finaleParams);
    if (node) return node;
    return null;
  }
  var getValueRenderWay = function getValueRenderWay(value) {
    if (["string", "number", "boolean"].includes(_typeof$2(value))) return "text" /* Text */;
    if (_typeof$2(value) === "object") {
      if (!(value instanceof Array) && value && value.context instanceof Vue__default["default"]) {
        return "vnode" /* VNode */;
      }
      return "jsonstring" /* JsonString */;
    }
    return "unknown" /* Unknown */;
  };
  Vue__default["default"].extend({
    name: "render-tnode-template",
    functional: true,
    props: {
      render: RenderJsTypes,
      params: null
    },
    render: function render(h2, ctx) {
      var _ctx$props = ctx.props,
        render = _ctx$props.render,
        params = _ctx$props.params;
      var renderResult = typeof render === "function" ? render(h2, params) : render;
      var renderWay = getValueRenderWay(renderResult);
      var renderText = function renderText(c) {
        return ctx.__proto__._v(c);
      };
      var renderMap = _defineProperty$2(_defineProperty$2(_defineProperty$2({}, "text" /* Text */, function text(c) {
        return renderText(c);
      }), "jsonstring" /* JsonString */, function jsonstring(c) {
        return renderText(JSON.stringify(c, null, 2));
      }), "vnode" /* VNode */, function vnode(c) {
        return c;
      });
      return renderMap[renderWay] ? renderMap[renderWay](renderResult) : h2();
    }
  });
  var renderTNodeJSX = function renderTNodeJSX(vm, name, options) {
    var params = _typeof$2(options) === "object" && "params" in options ? options.params : null;
    var slotFirst = _typeof$2(options) === "object" && "slotFirst" in options ? options.slotFirst : false;
    var defaultNode = _typeof$2(options) === "object" && "defaultNode" in options ? options.defaultNode : options;
    var propsNode = vm[name];
    if (propsNode === false || propsNode === null) return;
    if (propsNode === true && defaultNode) {
      return handleSlots$1(vm, params, name) || defaultNode;
    }
    if (typeof propsNode === "function") {
      return propsNode(vm.$createElement, params);
    }
    var isPropsEmpty = [void 0, params, ""].includes(propsNode);
    if ((isPropsEmpty || slotFirst) && (vm.$scopedSlots[camelCase$1(name)] || vm.$scopedSlots[kebabCase$1(name)])) {
      return handleSlots$1(vm, params, name);
    }
    return propsNode;
  };
  var renderTNodeJSXDefault = function renderTNodeJSXDefault(vm, name, options) {
    var defaultNode = _typeof$2(options) === "object" && "defaultNode" in options ? options.defaultNode : options;
    return renderTNodeJSX(vm, name, options) || defaultNode;
  };
  var renderContent = function renderContent(vm, name1, name2, options) {
    var params = _typeof$2(options) === "object" && "params" in options ? options.params : null;
    var defaultNode = _typeof$2(options) === "object" && "defaultNode" in options && options.defaultNode;
    defaultNode = _typeof$2(options) === "object" && "context" in options && options;
    var toParams = params ? {
      params: params
    } : void 0;
    var node1 = renderTNodeJSX(vm, name1, toParams);
    var node2 = renderTNodeJSX(vm, name2, toParams);
    var r = [void 0, null, ""].includes(node1) ? node2 : node1;
    return [void 0, null, ""].includes(r) ? defaultNode : r;
  };

  var TransferDom = {
    inserted: function inserted(el, binding) {
      if (!binding.value) return;
      var parentNode = getAttach(binding.value);
      parentNode === null || parentNode === void 0 || parentNode.appendChild(el);
    }
  };

  var props$1q = {
    attach: {
      type: [String, Function],
      "default": ""
    },
    content: {
      type: [String, Function]
    },
    "default": {
      type: [String, Function]
    },
    delay: {
      type: Number,
      "default": 0
    },
    fullscreen: Boolean,
    indicator: {
      type: [Boolean, Function],
      "default": true
    },
    inheritColor: Boolean,
    loading: {
      type: Boolean,
      "default": true
    },
    preventScrollThrough: {
      type: Boolean,
      "default": true
    },
    showOverlay: {
      type: Boolean,
      "default": true
    },
    size: {
      type: String,
      "default": "medium"
    },
    text: {
      type: [String, Function]
    },
    zIndex: {
      type: Number
    }
  };

  function ownKeys$3R(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$3Q(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$3R(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3R(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$M = getClassPrefixMixins("loading");
  var _Loading = mixins(classPrefixMixins$M).extend({
    name: "TLoading",
    props: _objectSpread$3Q({}, props$1q),
    directives: {
      TransferDom: TransferDom
    },
    data: function data() {
      return {
        delayShowLoading: false
      };
    },
    created: function created() {
      this.delay && this.countDelay();
    },
    watch: {
      loading: {
        handler: function handler(value) {
          if (value) {
            this.countDelay();
            this.lockFullscreen && addClass(document.body, "".concat(this.componentName, "--lock"));
          } else {
            this.lockFullscreen && removeClass(document.body, "".concat(this.componentName, "--lock"));
          }
        },
        immediate: true
      }
    },
    computed: {
      styles: function styles() {
        var styles = {};
        if (this.zIndex !== void 0) {
          styles.zIndex = this.zIndex;
        }
        if (!["small", "medium", "large"].includes(this.size)) {
          styles["font-size"] = this.size;
        }
        return styles;
      },
      showText: function showText() {
        return Boolean(this.text || this.$scopedSlots.text);
      },
      baseClasses: function baseClasses() {
        return ["".concat(this.componentName, "--center"), this.commonSizeClassName[this.size], _defineProperty$2({}, "".concat(this.componentName, "--inherit-color"), this.inheritColor)];
      },
      hasContent: function hasContent() {
        return Boolean(this["default"] || this.$scopedSlots["default"] || this.content || this.$scopedSlots.content);
      },
      withContentClasses: function withContentClasses() {
        return this.baseClasses.concat([this.componentName, "".concat(this.componentName, "--full"), _defineProperty$2({}, "".concat(this.componentName, "__overlay"), this.showOverlay)]);
      },
      fullScreenClasses: function fullScreenClasses() {
        return [this.componentName, "".concat(this.componentName, "__fullscreen"), "".concat(this.componentName, "--center"), "".concat(this.componentName, "__overlay")];
      },
      attachClasses: function attachClasses() {
        return this.baseClasses.concat([this.componentName, "".concat(this.componentName, "--full"), _defineProperty$2({}, "".concat(this.componentName, "__overlay"), this.showOverlay)]);
      },
      normalClasses: function normalClasses() {
        return this.baseClasses.concat([this.componentName]);
      },
      lockFullscreen: function lockFullscreen() {
        return this.preventScrollThrough && this.fullscreen;
      },
      delayCounted: function delayCounted() {
        return Boolean(!this.delay || this.delay && this.delayShowLoading);
      },
      showWrapLoading: function showWrapLoading() {
        return this.hasContent && this.loading && this.delayCounted;
      },
      showFullScreenLoading: function showFullScreenLoading() {
        return this.fullscreen && this.loading && this.delayCounted;
      },
      showAttachedLoading: function showAttachedLoading() {
        return this.attach && this.loading && this.delayCounted;
      }
    },
    methods: {
      countDelay: function countDelay() {
        var _this = this;
        this.delayShowLoading = false;
        var timer = setTimeout(function () {
          _this.delayShowLoading = true;
          clearTimeout(timer);
        }, this.delay);
      }
    },
    render: function render() {
      var h = arguments[0];
      var defaultIndicator = h(GradientIcon, {
        "attrs": {
          "size": this.size
        }
      });
      var indicator = this.loading && renderTNodeJSX(this, "indicator", defaultIndicator);
      var text = this.showText && h("div", {
        "class": "".concat(this.classPrefix, "-loading__text")
      }, [renderTNodeJSX(this, "text")]);
      if (this.fullscreen) {
        if (!this.showFullScreenLoading || !this.loading) return null;
        return h("div", {
          "class": this.fullScreenClasses,
          "style": this.styles,
          "directives": [{
            name: "transfer-dom",
            value: this.attach
          }]
        }, [h("div", {
          "class": this.baseClasses
        }, [indicator, text])]);
      }
      if (this.hasContent) {
        return h("div", {
          "class": "".concat(this.componentName, "__parent")
        }, [renderContent(this, "default", "content"), this.showWrapLoading && h("div", {
          "class": this.withContentClasses,
          "style": this.styles
        }, [indicator, text])]);
      }
      if (this.attach) {
        if (!this.showAttachedLoading || !this.loading) return;
        return h("div", {
          "class": this.attachClasses,
          "style": this.styles,
          "directives": [{
            name: "transfer-dom",
            value: this.attach
          }]
        }, [indicator, text]);
      }
      if (this.loading) {
        return h("div", {
          "class": this.normalClasses,
          "style": this.styles
        }, [indicator, text]);
      }
      return null;
    }
  });

  var prefix = "t";

  function ownKeys$3Q(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$3P(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$3Q(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3Q(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var lockClass = "".concat(prefix, "-loading--lock");
  var fullScreenLoadingInstance = null;
  var normalLoadingInstance = null;
  function createLoading(options) {
    var props = _objectSpread$3P({}, options);
    var loading = new _Loading({
      propsData: _objectSpread$3P({}, props)
    }).$mount();
    var attach = getAttach(props.attach);
    if (attach) {
      attach.appendChild(loading.$el);
    } else {
      console.error("attach is not exist");
    }
    var loadingInstance = {
      hide: function hide() {
        var _loading$$el$parentNo;
        loading.loading = false;
        (_loading$$el$parentNo = loading.$el.parentNode) === null || _loading$$el$parentNo === void 0 || _loading$$el$parentNo.removeChild(loading.$el);
      }
    };
    return loadingInstance;
  }
  function produceLoading(props) {
    var destroyLoadingInstance = function destroyLoadingInstance() {
      removeClass(document.body, lockClass);
      fullScreenLoadingInstance.hide();
      fullScreenLoadingInstance = null;
    };
    var destroyNormalLoadingInstance = function destroyNormalLoadingInstance() {
      normalLoadingInstance.hide();
      normalLoadingInstance = null;
    };
    if (props === true) {
      if (fullScreenLoadingInstance) destroyLoadingInstance();
      fullScreenLoadingInstance = createLoading({
        fullscreen: true,
        loading: true,
        attach: "body"
      });
      return fullScreenLoadingInstance;
    }
    if (props === false) {
      fullScreenLoadingInstance && destroyLoadingInstance();
      normalLoadingInstance && destroyNormalLoadingInstance();
      return;
    }
    normalLoadingInstance = createLoading(props);
    return normalLoadingInstance;
  }
  var LoadingPlugin = produceLoading;
  LoadingPlugin.install = function () {
    Vue__default["default"].prototype.$loading = produceLoading;
  };

  var INSTANCE_KEY = Symbol("TdLoading");
  var createInstance = function createInstance(el, binding) {
    var _binding$modifiers = binding.modifiers,
      fullscreen = _binding$modifiers.fullscreen,
      inheritColor = _binding$modifiers.inheritColor;
    var options = {
      attach: function attach() {
        return el;
      },
      fullscreen: fullscreen !== null && fullscreen !== void 0 ? fullscreen : false,
      inheritColor: inheritColor !== null && inheritColor !== void 0 ? inheritColor : false,
      loading: binding.value
    };
    if (isObject(binding.value)) {
      mapKeys(binding.value, function (value, key) {
        options[key] = value;
      });
    }
    el[INSTANCE_KEY] = {
      options: options,
      instance: LoadingPlugin(options)
    };
  };
  var vLoading = {
    inserted: function inserted(el, binding) {
      if (binding.value) {
        createInstance(el, binding);
      }
    },
    update: function update(el, binding) {
      var instance = el[INSTANCE_KEY];
      var value = binding.value,
        oldValue = binding.oldValue;
      if (!isEqual(value, oldValue)) {
        var _value$loading;
        var loading = (_value$loading = value === null || value === void 0 ? void 0 : value.loading) !== null && _value$loading !== void 0 ? _value$loading : value;
        if (loading) {
          createInstance(el, binding);
        } else {
          instance === null || instance === void 0 || instance.instance.hide();
        }
      }
    },
    unbind: function unbind(el) {
      var _el$INSTANCE_KEY;
      (_el$INSTANCE_KEY = el[INSTANCE_KEY]) === null || _el$INSTANCE_KEY === void 0 || _el$INSTANCE_KEY.instance.hide();
    }
  };

  function ownKeys$3P(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$3O(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$3P(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3P(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function withInstall$1(comp, dep, directive) {
    var _c$options;
    var c = comp;
    var name = (c === null || c === void 0 || (_c$options = c.options) === null || _c$options === void 0 ? void 0 : _c$options.name) || c.name;
    c.install = function (Vue2, config) {
      var defaults = {
        prefix: "t"
      };
      var installConfig = _objectSpread$3O(_objectSpread$3O({}, defaults), config);
      var defaultPrefix = capitalize(defaults.prefix);
      var componentName = name.replace(defaultPrefix, "").replace("-mapprops", "");
      componentName = capitalize(installConfig.prefix) + componentName;
      Vue2.component(componentName, comp);
    };
    if (dep && Vue__default["default"] && (Vue__default["default"]._installedPlugins || []).indexOf(dep) === -1) {
      Vue__default["default"].use(dep);
    }
    if (directive) {
      Vue__default["default"].directive(directive.name, directive.comp);
    }
    return comp;
  }

  var Loading = withInstall$1(_Loading, null, {
    name: "loading",
    comp: vLoading
  });

  var props$1p = {
    block: Boolean,
    content: {
      type: [String, Function]
    },
    "default": {
      type: [String, Function]
    },
    disabled: Boolean,
    form: {
      type: String,
      "default": void 0
    },
    ghost: Boolean,
    href: {
      type: String,
      "default": ""
    },
    icon: {
      type: Function
    },
    loading: Boolean,
    shape: {
      type: String,
      "default": "rectangle",
      validator: function validator(val) {
        if (!val) return true;
        return ["rectangle", "square", "round", "circle"].includes(val);
      }
    },
    size: {
      type: String,
      "default": "medium",
      validator: function validator(val) {
        if (!val) return true;
        return ["small", "medium", "large"].includes(val);
      }
    },
    suffix: {
      type: Function
    },
    tag: {
      type: String,
      validator: function validator(val) {
        if (!val) return true;
        return ["button", "a", "div"].includes(val);
      }
    },
    theme: {
      type: String,
      validator: function validator(val) {
        if (!val) return true;
        return ["default", "primary", "danger", "warning", "success"].includes(val);
      }
    },
    type: {
      type: String,
      "default": "button",
      validator: function validator(val) {
        if (!val) return true;
        return ["submit", "reset", "button"].includes(val);
      }
    },
    variant: {
      type: String,
      "default": "base",
      validator: function validator(val) {
        if (!val) return true;
        return ["base", "outline", "dashed", "text"].includes(val);
      }
    },
    onClick: Function
  };

  var Ripple = {
    startTimeId: null,
    finishTimeId: null,
    inserted: function inserted(el, binding) {
      if (binding.value === false) return;
      var period = 200;
      var defaultBg = "rgba(0, 0, 0, 0.35)";
      var bg = binding.value === true || binding.value == null ? defaultBg : binding.value;
      var rippleContainer = document.createElement("div");
      var hasCreateContainer = false;
      var count = 0;
      el.addEventListener("pointerdown", function (e) {
        if (el.classList.contains("".concat(prefix, "-is-active")) || el.classList.contains("".concat(prefix, "-is-disabled")) || el.classList.contains("".concat(prefix, "-is-checked")) || el.classList.contains("".concat(prefix, "-is-loading"))) {
          return;
        }
        if (e.button !== 0) return;
        if (bg === defaultBg && el !== null && el !== void 0 && el.dataset.ripple) {
          bg = el.dataset.ripple;
        }
        var cssVariable = getComputedStyle(el).getPropertyValue("--ripple-color");
        if (cssVariable) {
          bg = cssVariable;
        }
        var elBorder = parseInt(getComputedStyle(el).borderWidth.replace("px", ""), 10);
        var border = elBorder > 0 ? elBorder : 0;
        var width = el.offsetWidth;
        var height = el.offsetHeight;
        var style = getComputedStyle(el);
        if (!hasCreateContainer) {
          hasCreateContainer = true;
          setStyle(rippleContainer, {
            position: "absolute",
            left: "".concat(0 - border, "px"),
            top: "".concat(0 - border, "px"),
            width: "".concat(width, "px"),
            height: "".concat(height, "px"),
            borderRadius: style.borderRadius,
            pointerEvents: "none",
            overflow: "hidden"
          });
          el.appendChild(rippleContainer);
        }
        var ripple = document.createElement("div");
        setStyle(ripple, {
          marginTop: "0",
          marginLeft: "0",
          right: "".concat(width, "px"),
          width: "".concat(width + 20, "px"),
          height: "100%",
          transition: "transform ".concat(period, "ms cubic-bezier(.38, 0, .24, 1), background ").concat(period * 2, "ms linear"),
          transform: "skewX(-8deg)",
          pointerEvents: "none",
          position: "absolute",
          zIndex: "0",
          backgroundColor: bg,
          opacity: "0.9"
        });
        var elMap = /* @__PURE__ */new WeakMap();
        for (var n = el.children.length, i = 0; i < n; ++i) {
          var child = el.children[i];
          if (child.style.zIndex === "" && child !== rippleContainer) {
            child.style.zIndex = "1";
            elMap.set(child, true);
          }
        }
        var initPosition = el.style.position ? el.style.position : getComputedStyle(el).position;
        if (initPosition === "" || initPosition === "static") {
          el.style.position = "relative";
        }
        rippleContainer.insertBefore(ripple, rippleContainer.firstChild);
        count += 1;
        clearTimeout(Ripple.startTimeId);
        Ripple.startTimeId = setTimeout(function () {
          ripple.style.transform = "translateX(".concat(width, "px)");
        }, 0);
        var _handleClearRipple = function handleClearRipple() {
          ripple.style.backgroundColor = "rgba(0, 0, 0, 0)";
          el.removeEventListener("pointerup", _handleClearRipple, false);
          el.removeEventListener("pointerleave", _handleClearRipple, false);
          setTimeout(function () {
            rippleContainer.removeChild(ripple);
            count -= 1;
            if (count > 0) return;
            el.style.position = initPosition !== "static" ? initPosition : "";
            for (var _n = el.children.length, _i = 0; _i < _n; ++_i) {
              var _child = el.children[_i];
              if (elMap.has(_child)) {
                _child.style.zIndex = "";
                elMap["delete"](_child);
              }
            }
            el.removeChild(rippleContainer);
            hasCreateContainer = false;
          }, period * 2 + 100);
        };
        el.addEventListener("pointerup", _handleClearRipple, false);
        el.addEventListener("pointerleave", _handleClearRipple, false);
      });
    }
  };

  function ownKeys$3O(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$3N(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$3O(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3O(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var keepAnimationMixins$7 = getKeepAnimationMixins();
  var classPrefixMixins$L = getClassPrefixMixins("button");
  var TButton = mixins(keepAnimationMixins$7, classPrefixMixins$L).extend({
    name: "TButton",
    props: props$1p,
    directives: {
      ripple: Ripple
    },
    render: function render(h) {
      var _this = this;
      var buttonContent = renderContent(this, "default", "content");
      var icon = this.loading ? h(Loading, {
        "attrs": {
          "inheritColor": true
        }
      }) : renderTNodeJSX(this, "icon");
      var disabled = this.disabled || this.loading;
      var suffix = this.suffix || this.$scopedSlots.suffix ? h("span", {
        "class": "".concat(this.componentName, "__suffix")
      }, [renderTNodeJSX(this, "suffix")]) : null;
      var theme = this.theme;
      if (!this.theme) {
        if (this.variant === "base") {
          theme = "primary";
        } else {
          theme = "default";
        }
      }
      var buttonClass = ["".concat(this.componentName), "".concat(this.componentName, "--variant-").concat(this.variant), "".concat(this.componentName, "--theme-").concat(theme), _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({}, this.commonSizeClassName[this.size], this.size !== "medium"), this.commonStatusClassName.disabled, this.disabled), this.commonStatusClassName.loading, this.loading), "".concat(this.componentName, "--shape-").concat(this.shape), this.shape !== "rectangle"), "".concat(this.componentName, "--ghost"), this.ghost), this.commonSizeClassName.block, this.block)];
      buttonContent = buttonContent ? h("span", {
        "class": "".concat(this.componentName, "__text")
      }, [buttonContent]) : "";
      if (icon) {
        buttonContent = [icon, buttonContent];
      }
      if (suffix) {
        buttonContent = [buttonContent].concat(suffix);
      }
      var on = _objectSpread$3N({}, this.$listeners);
      if (typeof this.onClick === "function") {
        on.click = this.onClick;
      }
      var buttonAttrs = {
        type: this.type,
        disabled: disabled,
        href: this.href || void 0
      };
      var renderTag = function renderTag() {
        if (!_this.tag && _this.href) return "a";
        return _this.tag || "button";
      };
      return h(renderTag(), {
        "class": buttonClass,
        attrs: buttonAttrs,
        on: on,
        directives: [{
          name: "ripple",
          value: this.keepAnimation.ripple
        }]
      }, [buttonContent]);
    }
  });

  var Button = withInstall$1(TButton);

  function _defineProperty$1(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }

  function _objectWithoutPropertiesLoose$1(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function _objectWithoutProperties$1(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose$1(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  var _excluded$_ = ["attrs"];
  function ownKeys$3N(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3M(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3N(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3N(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function renderFn(createElement, node, rootData) {
    var iconAttrs = _objectSpread$3M(_objectSpread$3M({}, node.attrs), rootData.attrs);
    rootData.attrs;
      var restProps = _objectWithoutProperties$1(rootData, _excluded$_);
    return createElement(node.tag, _objectSpread$3M({
      attrs: iconAttrs
    }, restProps), (node.children || []).map(function (child) {
      return renderFn(createElement, child, {});
    }));
  }

  var classnames = createCommonjsModule(function (module) {
    /* global define */

    (function () {

      var hasOwn = {}.hasOwnProperty;
      function classNames() {
        var classes = '';
        for (var i = 0; i < arguments.length; i++) {
          var arg = arguments[i];
          if (arg) {
            classes = appendClass(classes, parseValue(arg));
          }
        }
        return classes;
      }
      function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') {
          return arg;
        }
        if (_typeof$2(arg) !== 'object') {
          return '';
        }
        if (Array.isArray(arg)) {
          return classNames.apply(null, arg);
        }
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
          return arg.toString();
        }
        var classes = '';
        for (var key in arg) {
          if (hasOwn.call(arg, key) && arg[key]) {
            classes = appendClass(classes, key);
          }
        }
        return classes;
      }
      function appendClass(value, newClass) {
        if (!newClass) {
          return value;
        }
        if (value) {
          return value + ' ' + newClass;
        }
        return value + newClass;
      }
      if (module.exports) {
        classNames["default"] = classNames;
        module.exports = classNames;
      } else {
        window.classNames = classNames;
      }
    })();
  });

  var _excluded$Z = ["icon", "id"],
    _excluded2 = ["staticClass", "style", "icon", "id", "onClick"],
    _excluded3 = ["class", "staticClass", "style", "staticStyle", "attrs"];
  function ownKeys$3M(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3L(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3M(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3M(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function hump2Underline(s) {
    return s.replace(/([A-Z])/g, "-$1").toLowerCase().replace("view-box", "viewBox");
  }
  function jsonToUnderline(obj) {
    if (obj instanceof Array) {
      obj.forEach(function (v) {
        jsonToUnderline(v);
      });
    } else if (obj instanceof Object) {
      Object.keys(obj).forEach(function (key) {
        var newKey = hump2Underline(key);
        if (newKey !== key) {
          obj[newKey] = obj[key];
          delete obj[key];
        }
        jsonToUnderline(obj[newKey]);
      });
    }
  }
  var IconBase = Vue__default["default"].extend({
    functional: true,
    props: {
      icon: {
        type: Object
      },
      id: {
        type: String,
        "default": ""
      }
    },
    render: function render(createElement, context) {
      var _context$props = context.props,
        icon = _context$props.icon,
        id = _context$props.id,
        userProps = _objectWithoutProperties$1(_context$props, _excluded$Z);
      var _context$data$props = context.data.props,
        staticClass = _context$data$props.staticClass,
        style = _context$data$props.style;
        _context$data$props.icon;
        _context$data$props.id;
        var onClick = _context$data$props.onClick,
        otherProps = _objectWithoutProperties$1(_context$data$props, _excluded2);
      var _context$data = context.data,
        customClassName = _context$data["class"],
        customStaticClassName = _context$data.staticClass,
        customStyle = _context$data.style,
        customStaticStyle = _context$data.staticStyle,
        attrs = _context$data.attrs,
        otherBinds = _objectWithoutProperties$1(_context$data, _excluded3);
      var domProps = otherBinds.domProps,
        on = otherBinds.on,
        nativeOn = otherBinds.nativeOn,
        directives = otherBinds.directives,
        scopedSlots = otherBinds.scopedSlots,
        slot = otherBinds.slot,
        key = otherBinds.key,
        ref = otherBinds.ref,
        refInFor = otherBinds.refInFor;
      var finalCls = classnames("t-icon", "t-icon-".concat(id), staticClass, customClassName, customStaticClassName);
      var finalStyle = _objectSpread$3L(_objectSpread$3L(_objectSpread$3L({}, style), customStyle), customStaticStyle);
      jsonToUnderline(icon);
      var _click = onClick || (on === null || on === void 0 ? void 0 : on.click);
      return renderFn(createElement, icon, {
        "class": void 0,
        staticClass: finalCls,
        props: _objectSpread$3L(_objectSpread$3L({}, userProps), otherProps),
        attrs: attrs,
        style: finalStyle,
        on: _objectSpread$3L(_objectSpread$3L({}, on), {}, {
          click: function click(e) {
            return _click === null || _click === void 0 ? void 0 : _click({
              e: e
            });
          }
        }, nativeOn),
        directives: directives,
        scopedSlots: scopedSlots,
        slot: slot,
        key: key,
        ref: ref,
        refInFor: refInFor,
        domProps: domProps
      });
    }
  });

  var DEFAULT_CLASS_PREFIX = "t";
  var DEFAULT_LOCALE = "zh-CN";
  var ConfigContext = {
    classPrefix: DEFAULT_CLASS_PREFIX,
    locale: DEFAULT_LOCALE
  };

  function useCommonClassName$2() {
    var classPrefix = ConfigContext.classPrefix;
    return {
      SIZE: {
        "default": "",
        xs: "".concat(classPrefix, "-size-xs"),
        small: "".concat(classPrefix, "-size-s"),
        medium: "".concat(classPrefix, "-size-m"),
        large: "".concat(classPrefix, "-size-l"),
        xl: "".concat(classPrefix, "-size-xl"),
        block: "".concat(classPrefix, "-size-full-width")
      },
      STATUS: {
        loading: "".concat(classPrefix, "-is-loading"),
        disabled: "".concat(classPrefix, "-is-disabled"),
        focused: "".concat(classPrefix, "-is-focused"),
        success: "".concat(classPrefix, "-is-success"),
        error: "".concat(classPrefix, "-is-error"),
        warning: "".concat(classPrefix, "-is-warning"),
        selected: "".concat(classPrefix, "-is-selected"),
        active: "".concat(classPrefix, "-is-active"),
        checked: "".concat(classPrefix, "-is-checked"),
        current: "".concat(classPrefix, "-is-current"),
        hidden: "".concat(classPrefix, "-is-hidden"),
        visible: "".concat(classPrefix, "-is-visible"),
        expanded: "".concat(classPrefix, "-is-expanded"),
        indeterminate: "".concat(classPrefix, "-is-indeterminate")
      }
    };
  }

  function useSizeProps(size) {
    if (size === void 0) {
      return {
        className: "",
        style: {}
      };
    }
    var COMMON_SIZE_CLASS_NAMES = useCommonClassName$2().SIZE;
    if (!(size in COMMON_SIZE_CLASS_NAMES)) {
      return {
        className: "",
        style: {
          fontSize: size
        }
      };
    }
    return {
      className: COMMON_SIZE_CLASS_NAMES[size],
      style: {}
    };
  }

  var _excluded$Y = ["size"];
  function ownKeys$3L(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3K(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3L(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3L(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$Q = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M2 2h20v20H2V2zm2 2v16h16V4H4zm9 2.5V11h4.5v2H13v4.5h-2V13H6.5v-2H11V6.5h2z"
      }
    }]
  };
  var AddRectangle = Vue__default["default"].extend({
    name: "AddRectangleIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$Y);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3K(_objectSpread$3K({}, otherProps || {}), {}, {
        id: "add-rectangle",
        icon: element$Q,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdAddRectangleIcon = AddRectangle;

  var _excluded$X = ["size"];
  function ownKeys$3K(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3J(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3K(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3K(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$P = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M13 4v7h7v2h-7v7h-2v-7H4v-2h7V4h2z"
      }
    }]
  };
  var Add = Vue__default["default"].extend({
    name: "AddIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$X);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3J(_objectSpread$3J({}, otherProps || {}), {}, {
        id: "add",
        icon: element$P,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdAddIcon = Add;

  var _excluded$W = ["size"];
  function ownKeys$3J(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3I(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3J(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3J(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$O = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M15 12h4.5L12 22 4.5 12H9V2h6v10z"
      }
    }]
  };
  var ArrowTriangleDownFilled = Vue__default["default"].extend({
    name: "ArrowTriangleDownFilledIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$W);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3I(_objectSpread$3I({}, otherProps || {}), {}, {
        id: "arrow-triangle-down-filled",
        icon: element$O,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TDArrowTriangleDownFilledIcon = ArrowTriangleDownFilled;

  var _excluded$V = ["size"];
  function ownKeys$3I(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3H(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3I(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3I(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$N = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M15 12h4.5L12 2 4.5 12H9v10h6V12z"
      }
    }]
  };
  var ArrowTriangleUpFilled = Vue__default["default"].extend({
    name: "ArrowTriangleUpFilledIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$V);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3H(_objectSpread$3H({}, otherProps || {}), {}, {
        id: "arrow-triangle-up-filled",
        icon: element$N,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TDArrowTriangleUpFilledIcon = ArrowTriangleUpFilled;

  var _excluded$U = ["size"];
  function ownKeys$3H(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3G(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3H(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3H(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$M = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M4 4h16v2H4V4zm8 3.59l6.91 6.91-1.41 1.41-4.5-4.5V21h-2v-9.59l-4.5 4.5-1.41-1.41L12 7.59z"
      }
    }]
  };
  var Backtop = Vue__default["default"].extend({
    name: "BacktopIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$U);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3G(_objectSpread$3G({}, otherProps || {}), {}, {
        id: "backtop",
        icon: element$M,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdBackTopIcon = Backtop;

  var _excluded$T = ["size"];
  function ownKeys$3G(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3F(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3G(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3G(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$L = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 26 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M4 1.59l6.17 6.17 7.07 7.07L23.41 21 22 22.41l-2.97-2.96A12.5 12.5 0 011.08 12.3L1 12l.1-.3c.77-2.4 2.24-4.5 4.18-6.02L2.59 3 4 1.59zM6.7 7.1A10.53 10.53 0 003.1 12a10.5 10.5 0 0014.45 5.97l-1.8-1.8a5 5 0 01-6.93-6.93L6.7 7.11zm3.6 3.6a3 3 0 004 4l-4-4zM13 5c-.58 0-1.14.05-1.7.14l-.98.16L10 3.32l.99-.16A12.5 12.5 0 0124.9 11.7l.1.31-.1.3c-.41 1.3-1.03 2.5-1.82 3.58l-.59.8-1.61-1.18.59-.8c.6-.82 1.08-1.73 1.42-2.7A10.5 10.5 0 0013 5zm.51 1.93l.96.29a5 5 0 013.31 3.31l.3.96-1.92.58-.3-.95a3 3 0 00-1.98-1.99l-.95-.3.58-1.9z"
      }
    }]
  };
  var BrowseOff = Vue__default["default"].extend({
    name: "BrowseOffIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$T);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3F(_objectSpread$3F({}, otherProps || {}), {}, {
        id: "browse-off",
        icon: element$L,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdBrowseOffIcon = BrowseOff;

  var _excluded$S = ["size"];
  function ownKeys$3F(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3E(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3F(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3F(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$K = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "g",
      "attrs": {
        "clipPath": "url(#clip0_8726_7319)"
      },
      "children": [{
        "tag": "path",
        "attrs": {
          "fill": "currentColor",
          "d": "M2.1 12a10.5 10.5 0 0019.8 0 10.5 10.5 0 00-19.8 0zm-2.01-.3a12.5 12.5 0 0123.82 0l.1.3-.1.3a12.5 12.5 0 01-23.82 0l-.1-.3.1-.3zM12 9a3 3 0 100 6 3 3 0 000-6zm-5 3a5 5 0 1110 0 5 5 0 01-10 0z"
        }
      }]
    }]
  };
  var Browse = Vue__default["default"].extend({
    name: "BrowseIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$S);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3E(_objectSpread$3E({}, otherProps || {}), {}, {
        id: "browse",
        icon: element$K,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdBrowseIcon = Browse;

  var _excluded$R = ["size"];
  function ownKeys$3E(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3D(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3E(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3E(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$J = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M6 4V1.5h2V4h8V1.5h2V4h4v18H2V4h4zM4 6v3h16V6H4zm16 5H4v9h16v-9z"
      }
    }]
  };
  var Calendar$1 = Vue__default["default"].extend({
    name: "CalendarIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$R);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3D(_objectSpread$3D({}, otherProps || {}), {}, {
        id: "calendar",
        icon: element$J,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdCalendarIcon = Calendar$1;

  var _excluded$Q = ["size"];
  function ownKeys$3D(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3C(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3D(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3D(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$I = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M15 12L9.5 6.5v11L15 12z"
      }
    }]
  };
  var CaretRightSmall = Vue__default["default"].extend({
    name: "CaretRightSmallIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$Q);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3C(_objectSpread$3C({}, otherProps || {}), {}, {
        id: "caret-right-small",
        icon: element$I,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdCaretRightSmallIcon = CaretRightSmall;

  var _excluded$P = ["size"];
  function ownKeys$3C(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3B(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3C(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3C(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$H = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M12 23a11 11 0 100-22 11 11 0 000 22zM7.5 10.59l3 3 6-6L17.91 9l-7.41 7.41L6.09 12l1.41-1.41z"
      }
    }]
  };
  var CheckCircleFilled = Vue__default["default"].extend({
    name: "CheckCircleFilledIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$P);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3B(_objectSpread$3B({}, otherProps || {}), {}, {
        id: "check-circle-filled",
        icon: element$H,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdCheckCircleFilledIcon = CheckCircleFilled;

  var _excluded$O = ["size"];
  function ownKeys$3B(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3A(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3B(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3B(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$G = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M20.99 7.38l-10.61 10.6L4 11.63l1.42-1.41 4.95 4.95 9.2-9.2 1.4 1.42z"
      }
    }]
  };
  var Check = Vue__default["default"].extend({
    name: "CheckIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$O);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3A(_objectSpread$3A({}, otherProps || {}), {}, {
        id: "check",
        icon: element$G,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdCheckIcon = Check;

  var _excluded$N = ["size"];
  function ownKeys$3A(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3z(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3A(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3A(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$F = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M17.5 8.09l-5.5 5.5-5.5-5.5L5.09 9.5 12 16.41l6.91-6.91-1.41-1.41z"
      }
    }]
  };
  var ChevronDown = Vue__default["default"].extend({
    name: "ChevronDownIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$N);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3z(_objectSpread$3z({}, otherProps || {}), {}, {
        id: "chevron-down",
        icon: element$F,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdChevronDownIcon = ChevronDown;

  var _excluded$M = ["size"];
  function ownKeys$3z(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3y(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3z(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3z(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$E = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M18.41 7.5l-4.5 4.5 4.5 4.5L17 17.91 11.09 12 17 6.09l1.41 1.41zm-6.5 0L7.41 12l4.5 4.5-1.41 1.41L4.59 12l5.91-5.91 1.41 1.41z"
      }
    }]
  };
  var ChevronLeftDouble = Vue__default["default"].extend({
    name: "ChevronLeftDoubleIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$M);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3y(_objectSpread$3y({}, otherProps || {}), {}, {
        id: "chevron-left-double",
        icon: element$E,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdChevronLeftDoubleIcon = ChevronLeftDouble;

  var _excluded$L = ["size"];
  function ownKeys$3y(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3x(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3y(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3y(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$D = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M15.91 17.5l-5.5-5.5 5.5-5.5-1.41-1.41L7.59 12l6.91 6.91 1.41-1.41z"
      }
    }]
  };
  var ChevronLeft = Vue__default["default"].extend({
    name: "ChevronLeftIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$L);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3x(_objectSpread$3x({}, otherProps || {}), {}, {
        id: "chevron-left",
        icon: element$D,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdChevronLeftIcon = ChevronLeft;

  var _excluded$K = ["size"];
  function ownKeys$3x(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3w(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3x(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3x(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$C = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M12 3a9 9 0 100 18 9 9 0 000-18zM1 12a11 11 0 1122 0 11 11 0 01-22 0zm9.5-5.41L15.91 12l-5.41 5.41L9.09 16l4-4-4-4 1.41-1.41z"
      }
    }]
  };
  var ChevronRightCircle = Vue__default["default"].extend({
    name: "ChevronRightCircleIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$K);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3w(_objectSpread$3w({}, otherProps || {}), {}, {
        id: "chevron-right-circle",
        icon: element$C,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdChevronRightCircleIcon = ChevronRightCircle;

  var _excluded$J = ["size"];
  function ownKeys$3w(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3v(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3w(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3w(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$B = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M5.59 16.5l4.5-4.5-4.5-4.5L7 6.09 12.91 12 7 17.91 5.59 16.5zm6.5 0l4.5-4.5-4.5-4.5 1.41-1.41L19.41 12l-5.91 5.91-1.41-1.41z"
      }
    }]
  };
  var ChevronRightDouble = Vue__default["default"].extend({
    name: "ChevronRightDoubleIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$J);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3v(_objectSpread$3v({}, otherProps || {}), {}, {
        id: "chevron-right-double",
        icon: element$B,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdChevronRightDoubleIcon = ChevronRightDouble;

  var _excluded$I = ["size"];
  function ownKeys$3v(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3u(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3v(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3v(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$A = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M8.09 17.5l5.5-5.5-5.5-5.5L9.5 5.09 16.41 12 9.5 18.91 8.09 17.5z"
      }
    }]
  };
  var ChevronRight = Vue__default["default"].extend({
    name: "ChevronRightIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$I);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3u(_objectSpread$3u({}, otherProps || {}), {}, {
        id: "chevron-right",
        icon: element$A,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdChevronRightIcon = ChevronRight;

  var _excluded$H = ["size"];
  function ownKeys$3u(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3t(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3u(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3u(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$z = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M17.5 15.91l-5.5-5.5-5.5 5.5-1.41-1.41L12 7.59l6.91 6.91-1.41 1.41z"
      }
    }]
  };
  var ChevronUp = Vue__default["default"].extend({
    name: "ChevronUpIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$H);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3t(_objectSpread$3t({}, otherProps || {}), {}, {
        id: "chevron-up",
        icon: element$z,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdChevronUpIcon = ChevronUp;

  var _excluded$G = ["size"];
  function ownKeys$3t(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3s(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3t(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3t(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$y = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M12 23a11 11 0 100-22 11 11 0 000 22zM8.82 7.4L12 10.6l3.18-3.19 1.42 1.42L13.4 12l3.19 3.18-1.42 1.42L12 13.4 8.82 16.6 7.4 15.18 10.6 12 7.4 8.82 8.82 7.4z"
      }
    }]
  };
  var CloseCircleFilled = Vue__default["default"].extend({
    name: "CloseCircleFilledIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$G);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3s(_objectSpread$3s({}, otherProps || {}), {}, {
        id: "close-circle-filled",
        icon: element$y,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdCloseCircleFilledIcon = CloseCircleFilled;

  var _excluded$F = ["size"];
  function ownKeys$3s(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3r(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3s(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3s(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$x = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M7.05 5.64L12 10.59l4.95-4.95 1.41 1.41L13.41 12l4.95 4.95-1.41 1.41L12 13.41l-4.95 4.95-1.41-1.41L10.59 12 5.64 7.05l1.41-1.41z"
      }
    }]
  };
  var Close = Vue__default["default"].extend({
    name: "CloseIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$F);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3r(_objectSpread$3r({}, otherProps || {}), {}, {
        id: "close",
        icon: element$x,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdCloseIcon = Close;

  var _excluded$E = ["size"];
  function ownKeys$3r(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3q(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3r(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3r(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$w = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M7.5 1h9v3H22v2h-2.03l-.5 17H4.53l-.5-17H2V4h5.5V1zm2 3h5V3h-5v1zM6.03 6l.44 15h11.06l.44-15H6.03zM13 8v11h-2V8h2z"
      }
    }]
  };
  var Delete = Vue__default["default"].extend({
    name: "DeleteIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$E);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3q(_objectSpread$3q({}, otherProps || {}), {}, {
        id: "delete",
        icon: element$w,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdDeleteIcon = Delete;

  var _excluded$D = ["size"];
  function ownKeys$3q(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3p(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3q(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3q(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$v = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M13 3v9.59l3.5-3.5 1.41 1.41L12 16.41 6.09 10.5 7.5 9.09l3.5 3.5V3h2zM4.5 14v5h15v-5h2v7h-19v-7h2z"
      }
    }]
  };
  var Download = Vue__default["default"].extend({
    name: "DownloadIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$D);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3p(_objectSpread$3p({}, otherProps || {}), {}, {
        id: "download",
        icon: element$v,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var DownloadIcon = Download;

  var _excluded$C = ["size"];
  function ownKeys$3p(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3o(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3p(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3p(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$u = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M16.83 1.42l5.75 5.75L7.75 22H2v-5.75L16.83 1.42zm0 8.68l2.92-2.93-2.92-2.93-2.93 2.93 2.93 2.93zm-4.34-1.51L4 17.07V20h2.93l8.48-8.49L12.5 8.6z"
      }
    }]
  };
  var Edit1 = Vue__default["default"].extend({
    name: "Edit1Icon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$C);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3o(_objectSpread$3o({}, otherProps || {}), {}, {
        id: "edit-1",
        icon: element$u,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdEdit1Icon = Edit1;

  var _excluded$B = ["size"];
  function ownKeys$3o(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3n(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3o(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3o(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$t = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M3 10.5h3v3H3v-3zm7.5 0h3v3h-3v-3zm7.5 0h3v3h-3v-3z"
      }
    }]
  };
  var Ellipsis = Vue__default["default"].extend({
    name: "EllipsisIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$B);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3n(_objectSpread$3n({}, otherProps || {}), {}, {
        id: "ellipsis",
        icon: element$t,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdEllipsisIcon = Ellipsis;

  var _excluded$A = ["size"];
  function ownKeys$3n(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3m(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3n(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3n(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$s = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M12 1a11 11 0 110 22 11 11 0 010-22zm-1 13h2V6.5h-2V14zm2 1.5h-2v2h2v-2z"
      }
    }]
  };
  var ErrorCircleFilled = Vue__default["default"].extend({
    name: "ErrorCircleFilledIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$A);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3m(_objectSpread$3m({}, otherProps || {}), {}, {
        id: "error-circle-filled",
        icon: element$s,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdErrorCircleFilledIcon = ErrorCircleFilled;

  var _excluded$z = ["size"];
  function ownKeys$3m(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3l(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3m(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3m(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$r = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M13 2v14.5h-2V2h2zm-2 17h2v2h-2v-2z"
      }
    }]
  };
  var Error$1 = Vue__default["default"].extend({
    name: "ErrorIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$z);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3l(_objectSpread$3l({}, otherProps || {}), {}, {
        id: "error",
        icon: element$r,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdErrorIcon = Error$1;

  var _excluded$y = ["size"];
  function ownKeys$3l(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3k(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3l(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3l(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$q = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M6 1h9.41L21 6.59V19H6V1zm2 2v14h11V9h-6V3H8zm7 .41V7h3.59L15 3.41zM4 5v16h11v2H2V5h2z"
      }
    }]
  };
  var FileCopy = Vue__default["default"].extend({
    name: "FileCopyIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$y);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3k(_objectSpread$3k({}, otherProps || {}), {}, {
        id: "file-copy",
        icon: element$q,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdFileCopyIcon = FileCopy;

  var _excluded$x = ["size"];
  function ownKeys$3k(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3j(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3k(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3k(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$p = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M3 1h12.41L21 6.59V23H3V1zm2 2v18h14V9h-6V3H5zm10 .41V7h3.59L15 3.41zM15 10v1.65a2 2 0 01-.61 1.44l-.95.91.95.91c.39.38.61.9.61 1.44V18h-2v-1.65l-1-.96-1 .96V18H9v-1.65a2 2 0 01.61-1.44l.95-.91-.95-.91A2 2 0 019 11.65V10h2v1.65l1 .96 1-.96V10h2z"
      }
    }]
  };
  var FileExcel = Vue__default["default"].extend({
    name: "FileExcelIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$x);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3j(_objectSpread$3j({}, otherProps || {}), {}, {
        id: "file-excel",
        icon: element$p,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdFileExcelIcon = FileExcel;

  var _excluded$w = ["size"];
  function ownKeys$3j(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3i(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3j(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3j(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$o = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M3 1h12.41L21 6.59V11h-2V9h-6V3H5v18h16v2H3V1zm12 2.41V7h3.59L15 3.41zM6 12h3.71c.71 0 1.29.58 1.29 1.29v2.42c0 .71-.58 1.29-1.29 1.29H8v3H6v-8zm2 3h1v-1H8v1zm3.5-3h3.71c.71 0 1.29.58 1.29 1.29v5.42c0 .71-.58 1.29-1.29 1.29H11.5v-8zm2 2v4h1v-4h-1zm3.5-.71c0-.71.58-1.29 1.29-1.29h3.38v2H19v1h2.67v2H19v3h-2v-6.71z"
      }
    }]
  };
  var FilePdf = Vue__default["default"].extend({
    name: "FilePdfIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$w);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3i(_objectSpread$3i({}, otherProps || {}), {}, {
        id: "file-pdf",
        icon: element$o,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdFilePdfIcon = FilePdf;

  var _excluded$v = ["size"];
  function ownKeys$3i(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3h(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3i(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3i(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$n = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M3 1h12.41L21 6.59V23H3V1zm2 2v18h14V9h-6V3H5zm10 .41V7h3.59L15 3.41zM9 10h4a2 2 0 012 2v1.6a2 2 0 01-2 2h-2V18H9v-8zm2 3.6h2V12h-2v1.6z"
      }
    }]
  };
  var FilePowerpoint = Vue__default["default"].extend({
    name: "FilePowerpointIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$v);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3h(_objectSpread$3h({}, otherProps || {}), {}, {
        id: "file-powerpoint",
        icon: element$n,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdFilePowerpointIcon = FilePowerpoint;

  var _excluded$u = ["size"];
  function ownKeys$3h(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3g(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3h(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3h(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$m = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M3 1h12.41L21 6.59V23H3V1zm2 2v18h14V9h-6V3H5zm10 .41V7h3.59L15 3.41zM10 11v5h1v-5h2v5h1v-5h2v5a2 2 0 01-2 2h-4a2 2 0 01-2-2v-5h2z"
      }
    }]
  };
  var FileWord = Vue__default["default"].extend({
    name: "FileWordIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$u);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3g(_objectSpread$3g({}, otherProps || {}), {}, {
        id: "file-word",
        icon: element$m,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdFileWordIcon = FileWord;

  var _excluded$t = ["size"];
  function ownKeys$3g(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3f(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3g(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3g(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$l = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M3 1h12.41L21 6.59V23H3V1zm2 2v18h14V9h-6V3H5zm10 .41V7h3.59L15 3.41z"
      }
    }]
  };
  var File$1 = Vue__default["default"].extend({
    name: "FileIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$t);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3f(_objectSpread$3f({}, otherProps || {}), {}, {
        id: "file",
        icon: element$l,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdFileIcon = File$1;

  var _excluded$s = ["size"];
  function ownKeys$3f(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3e(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3f(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3f(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$k = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M2.57 3h18.86l-6.93 9.82V21h-5v-8.18L2.57 3zm3.86 2l5.07 7.18V19h1v-6.82L17.57 5H6.43z"
      }
    }]
  };
  var Filter = Vue__default["default"].extend({
    name: "FilterIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$s);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3e(_objectSpread$3e({}, otherProps || {}), {}, {
        id: "filter",
        icon: element$k,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdFilterIcon = Filter;

  var _excluded$r = ["size"];
  function ownKeys$3e(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3d(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3e(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3e(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$j = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M12 23a11 11 0 100-22 11 11 0 000 22zm-.17-11.11c.43-.53.97-.97 1.4-1.32A2 2 0 0012 7a2 2 0 00-1.89 1.33l-.33.95L7.9 8.6l.34-.94a4 4 0 116.24 4.47 7 7 0 00-1.1 1.01c-.27.34-.37.61-.37.85v1.25h-2V14c0-.87.39-1.57.83-2.11zM11 18.25v-2h2v2h-2z"
      }
    }]
  };
  var HelpCircleFilled = Vue__default["default"].extend({
    name: "HelpCircleFilledIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$r);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3d(_objectSpread$3d({}, otherProps || {}), {}, {
        id: "help-circle-filled",
        icon: element$j,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdHelpCircleFilledIcon = HelpCircleFilled;

  var _excluded$q = ["size"];
  function ownKeys$3d(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3c(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3d(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3d(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$i = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M2 2h20v10h-2V4H4v9.59l5-5L14.41 14 13 15.41l-4-4-5 5V20h8v2H2V2zm13.55 5a1 1 0 100 2 1 1 0 000-2zm-3 1a3 3 0 116 0 3 3 0 01-6 0zm3.62 6.76L19 17.59l2.83-2.83 1.41 1.41L20.41 19l2.83 2.83-1.41 1.41L19 20.41l-2.83 2.83-1.41-1.41L17.59 19l-2.83-2.83 1.41-1.41z"
      }
    }]
  };
  var ImageError = Vue__default["default"].extend({
    name: "ImageErrorIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$q);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3c(_objectSpread$3c({}, otherProps || {}), {}, {
        id: "image-error",
        icon: element$i,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var ImageErrorIcon = ImageError;

  var _excluded$p = ["size"];
  function ownKeys$3c(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3b(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3c(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3c(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$h = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M2 2h20v20H2V2zm2 18h13.59L9 11.41l-5 5V20zm16-.41V4H4v9.59l5-5 11 11zM15.55 7a1 1 0 100 2 1 1 0 000-2zm-3 1a3 3 0 116 0 3 3 0 01-6 0z"
      }
    }]
  };
  var Image$2 = Vue__default["default"].extend({
    name: "ImageIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$p);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3b(_objectSpread$3b({}, otherProps || {}), {}, {
        id: "image",
        icon: element$h,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var ImageIcon = Image$2;

  var _excluded$o = ["size"];
  function ownKeys$3b(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$3a(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3b(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3b(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$g = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M12 23a11 11 0 100-22 11 11 0 000 22zM11 8.5v-2h2v2h-2zm2 1.5v7.5h-2V10h2z"
      }
    }]
  };
  var InfoCircleFilled = Vue__default["default"].extend({
    name: "InfoCircleFilledIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$o);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$3a(_objectSpread$3a({}, otherProps || {}), {}, {
        id: "info-circle-filled",
        icon: element$g,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdInfoCircleFilledIcon = InfoCircleFilled;

  var _excluded$n = ["size"];
  function ownKeys$3a(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$39(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$3a(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3a(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$f = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M2 2h20v20H2V2zm2 2v16h16V4H4zm2.5 7h11v2h-11v-2z"
      }
    }]
  };
  var MinusRectangle = Vue__default["default"].extend({
    name: "MinusRectangleIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$n);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$39(_objectSpread$39({}, otherProps || {}), {}, {
        id: "minus-rectangle",
        icon: element$f,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdMinusRectangleIcon = MinusRectangle;

  var _excluded$m = ["size"];
  function ownKeys$39(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$38(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$39(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$39(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$e = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M13 2v20h-2V2h2zM9 4.64V18.5H1.3L9 4.64zm6 0l7.7 13.86H15V4.64zM4.7 16.5H7v-4.14L4.7 16.5zM17 12.36v4.14h2.3L17 12.36z"
      }
    }]
  };
  var Mirror = Vue__default["default"].extend({
    name: "MirrorIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$m);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$38(_objectSpread$38({}, otherProps || {}), {}, {
        id: "mirror",
        icon: element$e,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var MirrorIcon = Mirror;

  var _excluded$l = ["size"];
  function ownKeys$38(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$37(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$38(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$38(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$d = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M8.5 5v14h-2V5h2zm9.16 1.75L12.41 12l5.25 5.25-1.41 1.41L9.59 12l6.66-6.66 1.41 1.41z"
      }
    }]
  };
  var PageFirst = Vue__default["default"].extend({
    name: "PageFirstIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$l);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$37(_objectSpread$37({}, otherProps || {}), {}, {
        id: "page-first",
        icon: element$d,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdPageFirstIcon = PageFirst;

  var _excluded$k = ["size"];
  function ownKeys$37(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$36(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$37(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$37(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$c = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M17.5 5v14h-2V5h2zm-9.75.34L14.41 12l-6.66 6.66-1.41-1.41L11.59 12 6.34 6.75l1.41-1.41z"
      }
    }]
  };
  var PageLast = Vue__default["default"].extend({
    name: "PageLastIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$k);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$36(_objectSpread$36({}, otherProps || {}), {}, {
        id: "page-last",
        icon: element$c,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdPageLastIcon = PageLast;

  var _excluded$j = ["size"];
  function ownKeys$36(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$35(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$36(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$36(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$b = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M4 11h16v2H4v-2z"
      }
    }]
  };
  var Remove$1 = Vue__default["default"].extend({
    name: "RemoveIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$j);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$35(_objectSpread$35({}, otherProps || {}), {}, {
        id: "remove",
        icon: element$b,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdRemoveIcon = Remove$1;

  var _excluded$i = ["size"];
  function ownKeys$35(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$34(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$35(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$35(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$a = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M4 2v9a9 9 0 019 9h9v2H2V2h2zm0 18h7a7 7 0 00-7-7v7z"
      }
    }]
  };
  var Rotation = Vue__default["default"].extend({
    name: "RotationIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$i);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$34(_objectSpread$34({}, otherProps || {}), {}, {
        id: "rotation",
        icon: element$a,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var RotationIcon = Rotation;

  var _excluded$h = ["size"];
  function ownKeys$34(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$33(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$34(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$34(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$9 = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M12 6a6 6 0 100 12 6 6 0 000-12zm-8 6a8 8 0 1116 0 8 8 0 01-16 0z"
      }
    }]
  };
  var Round = Vue__default["default"].extend({
    name: "RoundIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$h);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$33(_objectSpread$33({}, otherProps || {}), {}, {
        id: "round",
        icon: element$9,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdRoundIcon = Round;

  var _excluded$g = ["size"];
  function ownKeys$33(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$32(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$33(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$33(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$8 = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M15.1 5.9a6.5 6.5 0 10-9.2 9.2 6.5 6.5 0 009.2-9.2zM4.49 4.5a8.5 8.5 0 0112.69 11.27l5.34 5.35-1.41 1.41-5.35-5.34A8.5 8.5 0 014.5 4.49z"
      }
    }]
  };
  var Search$1 = Vue__default["default"].extend({
    name: "SearchIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$g);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$32(_objectSpread$32({}, otherProps || {}), {}, {
        id: "search",
        icon: element$8,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var SearchIcon = Search$1;

  var _excluded$f = ["size"];
  function ownKeys$32(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$31(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$32(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$32(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$7 = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M12 .85l9.66 5.57v11.16L12 23.15l-9.66-5.57V6.42L12 .85zm0 2.3L4.34 7.58v8.84L12 20.85l7.66-4.43V7.58L12 3.15zM12 9a3 3 0 100 6 3 3 0 000-6zm-5 3a5 5 0 1110 0 5 5 0 01-10 0z"
      }
    }]
  };
  var Setting = Vue__default["default"].extend({
    name: "SettingIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$f);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$31(_objectSpread$31({}, otherProps || {}), {}, {
        id: "setting",
        icon: element$7,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdSettingIcon = Setting;

  var _excluded$e = ["size"];
  function ownKeys$31(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$30(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$31(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$31(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$6 = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M12 .63l2.9 8.35 8.84.18-7.04 5.34 2.56 8.46L12 17.91l-7.26 5.05L7.3 14.5.26 9.16l8.84-.18L12 .63z"
      }
    }]
  };
  var StarFilled = Vue__default["default"].extend({
    name: "StarFilledIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$e);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$30(_objectSpread$30({}, otherProps || {}), {}, {
        id: "star-filled",
        icon: element$6,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var StarFilledIcon = StarFilled;

  var _excluded$d = ["size"];
  function ownKeys$30(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$2$(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$30(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$30(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$5 = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M12 23a11 11 0 110-22 11 11 0 010 22zm1-17.5h-2v6.91l4 4L16.41 15 13 11.59V5.5z"
      }
    }]
  };
  var TimeFilled = Vue__default["default"].extend({
    name: "TimeFilledIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$d);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$2$(_objectSpread$2$({}, otherProps || {}), {}, {
        id: "time-filled",
        icon: element$5,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdTimeFilledIcon = TimeFilled;

  var _excluded$c = ["size"];
  function ownKeys$2$(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$2_(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$2$(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2$(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$4 = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M12 21a9 9 0 100-18 9 9 0 000 18zm11-9a11 11 0 11-22 0 11 11 0 0122 0zm-8 4.41l-4-4V5.5h2v6.09L16.41 15 15 16.41z"
      }
    }]
  };
  var Time = Vue__default["default"].extend({
    name: "TimeIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$c);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$2_(_objectSpread$2_({}, otherProps || {}), {}, {
        id: "time",
        icon: element$4,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdTimeIcon = Time;

  var _excluded$b = ["size"];
  function ownKeys$2_(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$2Z(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$2_(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2_(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$3 = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M12 2.59l5.91 5.91-1.41 1.41-3.5-3.5V16h-2V6.41l-3.5 3.5L6.09 8.5 12 2.59zM4.5 14v5h15v-5h2v7h-19v-7h2z"
      }
    }]
  };
  var Upload$1 = Vue__default["default"].extend({
    name: "UploadIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$b);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$2Z(_objectSpread$2Z({}, otherProps || {}), {}, {
        id: "upload",
        icon: element$3,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdUploadIcon = Upload$1;

  var _excluded$a = ["size"];
  function ownKeys$2Z(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$2Y(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$2Z(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2Z(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$2 = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M2 2h20v20H2V2zm2 2v16h16V4H4zm4 2.37L17.75 12 8 17.63V6.37zm2 3.46v4.34L13.75 12 10 9.83z"
      }
    }]
  };
  var Video = Vue__default["default"].extend({
    name: "VideoIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$a);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$2Y(_objectSpread$2Y({}, otherProps || {}), {}, {
        id: "video",
        icon: element$2,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var TdVideoIcon = Video;

  var _excluded$9 = ["size"];
  function ownKeys$2Y(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$2X(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$2Y(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2Y(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element$1 = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M15.1 5.9a6.5 6.5 0 10-9.2 9.2 6.5 6.5 0 009.2-9.2zM4.49 4.5a8.5 8.5 0 0112.69 11.27l5.34 5.35-1.41 1.41-5.35-5.34A8.5 8.5 0 014.5 4.49zM11.5 6.5v3h3v2h-3v3h-2v-3h-3v-2h3v-3h2z"
      }
    }]
  };
  var ZoomIn = Vue__default["default"].extend({
    name: "ZoomInIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$9);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$2X(_objectSpread$2X({}, otherProps || {}), {}, {
        id: "zoom-in",
        icon: element$1,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var ZoomInIcon = ZoomIn;

  var _excluded$8 = ["size"];
  function ownKeys$2X(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$2W(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$2X(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2X(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var element = {
    "tag": "svg",
    "attrs": {
      "fill": "none",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "fill": "currentColor",
        "d": "M15.1 5.9a6.5 6.5 0 10-9.2 9.2 6.5 6.5 0 009.2-9.2zM4.49 4.5a8.5 8.5 0 0112.69 11.27l5.34 5.35-1.41 1.41-5.35-5.34A8.5 8.5 0 014.5 4.49zM6.5 11.5v-2h8v2h-8z"
      }
    }]
  };
  var ZoomOut = Vue__default["default"].extend({
    name: "ZoomOutIcon",
    functional: true,
    props: {
      size: {
        type: String
      },
      onClick: {
        type: Function
      }
    },
    render: function render(createElement, context) {
      var props = context.props,
        data = context.data;
      var size = props.size,
        otherProps = _objectWithoutProperties$1(props, _excluded$8);
      var _useSizeProps = useSizeProps(size),
        className = _useSizeProps.className,
        style = _useSizeProps.style;
      var fullProps = _objectSpread$2W(_objectSpread$2W({}, otherProps || {}), {}, {
        id: "zoom-out",
        icon: element,
        staticClass: className,
        style: style
      });
      data.props = fullProps;
      return createElement(IconBase, data);
    }
  });
  var ZoomOutIcon = ZoomOut;

  function checkScriptAndLoad(url, className) {
    if (window) {
      if (!document || !url || typeof url !== "string") return;
      if (document.querySelectorAll(".".concat(className, "[src=\"").concat(url, "\"]")).length > 0) {
        return;
      }
      var svg = document.createElement("script");
      svg.setAttribute("class", className);
      svg.setAttribute("src", url);
      document.body.appendChild(svg);
    }
  }

  var props$1o = {
    name: {
      type: String,
      "default": ""
    },
    size: {
      type: String,
      "default": void 0
    },
    url: {
      type: [String, Array],
      "default": void 0
    },
    loadDefaultIcons: {
      type: Boolean,
      "default": true
    },
    onClick: Function
  };

  function ownKeys$2W(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread$2V(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$2W(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2W(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  var classPrefix = ConfigContext.classPrefix;
  var tName = "".concat(classPrefix, "-icon");
  var CDN_ICONFONT_URL = "https://tdesign.gtimg.com/icon/0.3.1/fonts/index.js";
  var _Icon = Vue__default["default"].extend({
    name: "Icon",
    props: props$1o,
    computed: {
      iconName: function iconName() {
        return this.url ? this.name : "".concat(tName, "-").concat(this.name);
      },
      classes: function classes() {
        var _useSizeProps = useSizeProps(this.size),
          sizeClassName = _useSizeProps.className;
        var iconName = this.url ? this.name : "".concat(tName, "-").concat(this.name);
        var arr = [tName, iconName, sizeClassName];
        return arr;
      },
      iconStyle: function iconStyle() {
        if (["small", "medium", "large"].includes(this.size)) return {};
        return {
          "font-size": this.size
        };
      }
    },
    methods: {
      handleClick: function handleClick(e) {
        var _this$onClick;
        this.$emit("click", {
          e: e
        });
        (_this$onClick = this.onClick) === null || _this$onClick === void 0 ? void 0 : _this$onClick.call(this, {
          e: e
        });
      }
    },
    mounted: function mounted() {
      var finalUrl = [];
      if (this.url) {
        finalUrl = this.url instanceof Array ? this.url.concat() : [this.url];
      }
      if (this.loadDefaultIcons) {
        finalUrl.push(CDN_ICONFONT_URL);
      }
      Array.from(new Set(finalUrl)).forEach(function (url) {
        checkScriptAndLoad(url, "".concat(classPrefix, "-svg-js-stylesheet--unique-class"));
      });
    },
    render: function render() {
      var h = arguments[0];
      var attrs = {
        href: "#".concat(this.iconName)
      };
      return h("svg", {
        "class": this.classes,
        "style": this.iconStyle,
        "on": {
          "click": this.handleClick
        }
      }, [h("use", {
        "attrs": _objectSpread$2V({}, attrs)
      })]);
    }
  });

  var Icon$1 = _Icon;

  var Icon = withInstall$1(Icon$1);

  var props$1n = {
    content: {
      type: [String, Function]
    },
    "default": {
      type: [String, Function]
    },
    disabled: Boolean,
    download: {
      type: [String, Boolean]
    },
    hover: {
      type: String,
      "default": "underline",
      validator: function validator(val) {
        if (!val) return true;
        return ["color", "underline"].includes(val);
      }
    },
    href: {
      type: String,
      "default": ""
    },
    prefixIcon: {
      type: Function
    },
    size: {
      type: String,
      "default": "medium",
      validator: function validator(val) {
        if (!val) return true;
        return ["small", "medium", "large"].includes(val);
      }
    },
    suffixIcon: {
      type: Function
    },
    target: {
      type: String,
      "default": ""
    },
    theme: {
      type: String,
      "default": "default",
      validator: function validator(val) {
        if (!val) return true;
        return ["default", "primary", "danger", "warning", "success"].includes(val);
      }
    },
    underline: Boolean,
    onClick: Function
  };

  var classPrefixMixins$K = getClassPrefixMixins("link");
  var _Link = mixins(classPrefixMixins$K).extend({
    name: "TLink",
    props: props$1n,
    methods: {
      handleClick: function handleClick(e) {
        var _this$onClick;
        if (this.disabled) return;
        this.$emit("click", e);
        (_this$onClick = this.onClick) === null || _this$onClick === void 0 || _this$onClick.call(this, e);
      }
    },
    render: function render() {
      var h = arguments[0];
      var linkContent = renderContent(this, "default", "content");
      var prefixContent = renderTNodeJSX(this, "prefixIcon");
      var suffixContent = renderTNodeJSX(this, "suffixIcon");
      var linkClass = [this.componentName, "".concat(this.componentName, "--theme-").concat(this.theme), _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({}, this.commonSizeClassName[this.size], this.size !== "medium"), this.commonStatusClassName.disabled, this.disabled), "".concat(this.classPrefix, "-is-underline"), this.underline), "".concat(this.componentName, "--hover-").concat(this.hover), !this.disabled)];
      return h("a", {
        "class": linkClass,
        "attrs": {
          "href": this.disabled || !this.href ? void 0 : this.href,
          "target": this.target,
          "download": this.download
        },
        "on": {
          "click": this.handleClick
        }
      }, [prefixContent && h("span", {
        "class": "".concat(this.componentName, "__prefix-icon")
      }, [prefixContent]), linkContent, suffixContent && h("span", {
        "class": "".concat(this.componentName, "__suffix-icon")
      }, [suffixContent])]);
    }
  });

  var Link = withInstall$1(_Link);

  var calcSize = function calcSize(width) {
    var size = "xs";
    if (width < 768) {
      size = "xs";
    } else if (width >= 768 && width < 992) {
      size = "sm";
    } else if (width >= 992 && width < 1200) {
      size = "md";
    } else if (width >= 1200 && width < 1400) {
      size = "lg";
    } else if (width >= 1400 && width < 1880) {
      size = "xl";
    } else {
      size = "xxl";
    }
    return size;
  };

  var props$1m = {
    flex: {
      type: [String, Number]
    },
    lg: {
      type: [Number, Object]
    },
    md: {
      type: [Number, Object]
    },
    offset: {
      type: Number,
      "default": 0
    },
    order: {
      type: Number,
      "default": 0
    },
    pull: {
      type: Number,
      "default": 0
    },
    push: {
      type: Number,
      "default": 0
    },
    sm: {
      type: [Number, Object]
    },
    span: {
      type: Number
    },
    tag: {
      type: String,
      "default": "div"
    },
    xl: {
      type: [Number, Object]
    },
    xs: {
      type: [Number, Object]
    },
    xxl: {
      type: [Number, Object]
    }
  };

  function ownKeys$2V(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2U(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2V(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2V(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$J = getClassPrefixMixins("col");
  var _Col = mixins(classPrefixMixins$J).extend({
    name: "TCol",
    props: _objectSpread$2U({}, props$1m),
    inject: ["rowContext"],
    data: function data() {
      return {
        size: "md"
      };
    },
    computed: {
      classes: function classes() {
        var _this = this;
        var span = this.span,
          order = this.order,
          offset = this.offset,
          push = this.push,
          pull = this.pull;
        var allSizes = ["xs", "sm", "md", "lg", "xl", "xxl"];
        var sizeClasses = allSizes.reduce(function (acc, currSize) {
          var sizeProp = _this[currSize];
          var sizeObject = {};
          if (typeof sizeProp === "number") {
            sizeObject.span = sizeProp;
          } else if (isObject(sizeProp)) {
            sizeObject = sizeProp || {};
          }
          return _objectSpread$2U(_objectSpread$2U({}, acc), {}, _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({}, "".concat(_this.componentName, "-").concat(currSize, "-").concat(sizeObject.span), sizeObject.span !== void 0), "".concat(_this.componentName, "-").concat(currSize, "-order-").concat(sizeObject.order), parseInt(sizeObject.order, 10) >= 0), "".concat(_this.componentName, "-").concat(currSize, "-offset-").concat(sizeObject.offset), parseInt(sizeObject.offset, 10) >= 0), "".concat(_this.componentName, "-").concat(currSize, "-push-").concat(sizeObject.push), parseInt(sizeObject.push, 10) >= 0), "".concat(_this.componentName, "-").concat(currSize, "-pull-").concat(sizeObject.pull), parseInt(sizeObject.pull, 10) >= 0));
        }, {});
        return _objectSpread$2U(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({}, "".concat(this.componentName), true), "".concat(this.componentName, "-").concat(span), span !== void 0), "".concat(this.componentName, "-order-").concat(order), order), "".concat(this.componentName, "-offset-").concat(offset), offset), "".concat(this.componentName, "-push-").concat(push), push), "".concat(this.componentName, "-pull-").concat(pull), pull), sizeClasses);
      }
    },
    mounted: function mounted() {
      this.updateSize();
      window.addEventListener("resize", this.updateSize);
    },
    beforeDestroy: function beforeDestroy() {
      window.removeEventListener("resize", this.updateSize);
    },
    methods: {
      updateSize: function updateSize() {
        this.size = calcSize(window.innerWidth);
      },
      parseFlex: function parseFlex(flex) {
        if (typeof flex === "number") {
          return "".concat(flex, " ").concat(flex, " 0");
        }
        if (/^\d+(\.\d+)?(px|r?em|%)$/.test(flex)) {
          return "0 0 ".concat(flex);
        }
        return flex;
      },
      calcColPadding: function calcColPadding(gutter, currentSize) {
        var paddingObj = {};
        if (typeof gutter === "number") {
          Object.assign(paddingObj, {
            paddingLeft: "".concat(gutter / 2, "px"),
            paddingRight: "".concat(gutter / 2, "px")
          });
        } else if (Array.isArray(gutter) && gutter.length) {
          if (typeof gutter[0] === "number") {
            Object.assign(paddingObj, {
              paddingLeft: "".concat(gutter[0] / 2, "px"),
              paddingRight: "".concat(gutter[0] / 2, "px")
            });
          }
          if (isObject(gutter[0]) && gutter[0][currentSize]) {
            Object.assign(paddingObj, {
              paddingLeft: "".concat(gutter[0][currentSize] / 2, "px"),
              paddingRight: "".concat(gutter[0][currentSize] / 2, "px")
            });
          }
        } else if (isObject(gutter) && gutter[currentSize]) {
          Object.assign(paddingObj, {
            paddingLeft: "".concat(gutter[currentSize] / 2, "px"),
            paddingRight: "".concat(gutter[currentSize] / 2, "px")
          });
        }
        return paddingObj;
      }
    },
    render: function render() {
      var h = arguments[0];
      var flex = this.flex,
        tag = this.tag,
        classes = this.classes;
      var colStyle = {};
      flex && (colStyle.flex = this.parseFlex(flex));
      var rowContext = this.rowContext;
      if (rowContext) {
        var rowGutter = rowContext.gutter;
        Object.assign(colStyle, this.calcColPadding(rowGutter, this.size));
      }
      return h(tag, {
        "class": classes,
        "style": colStyle
      }, [renderTNodeJSX(this, "default")]);
    }
  });

  function _extends$2() {
    return _extends$2 = Object.assign ? Object.assign.bind() : function (a) {
      for (var b, c = 1; c < arguments.length; c++) for (var d in b = arguments[c], b) Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      return a;
    }, _extends$2.apply(this, arguments);
  }
  var normalMerge = ["attrs", "props", "domProps"],
    toArrayMerge = ["class", "style", "directives"],
    functionalMerge = ["on", "nativeOn"],
    mergeJsxProps = function mergeJsxProps(a) {
      return a.reduce(function (c, a) {
        for (var b in a) if (!c[b]) c[b] = a[b];else if (-1 !== normalMerge.indexOf(b)) c[b] = _extends$2({}, c[b], a[b]);else if (-1 !== toArrayMerge.indexOf(b)) {
          var d = c[b] instanceof Array ? c[b] : [c[b]],
            e = a[b] instanceof Array ? a[b] : [a[b]];
          c[b] = [].concat(d, e);
        } else if (-1 !== functionalMerge.indexOf(b)) {
          for (var f in a[b]) if (c[b][f]) {
            var g = c[b][f] instanceof Array ? c[b][f] : [c[b][f]],
              h = a[b][f] instanceof Array ? a[b][f] : [a[b][f]];
            c[b][f] = [].concat(g, h);
          } else c[b][f] = a[b][f];
        } else if ("hook" === b) for (var i in a[b]) c[b][i] = c[b][i] ? mergeFn(c[b][i], a[b][i]) : a[b][i];else c[b] = a[b];
        return c;
      }, {});
    },
    mergeFn = function mergeFn(a, b) {
      return function () {
        a && a.apply(this, arguments), b && b.apply(this, arguments);
      };
    };
  var helper = mergeJsxProps;

  var props$1l = {
    align: {
      type: String,
      "default": "top",
      validator: function validator(val) {
        if (!val) return true;
        return ["start", "end", "center", "stretch", "baseline", "top", "middle", "bottom"].includes(val);
      }
    },
    gutter: {
      type: [Number, Object, Array],
      "default": 0
    },
    justify: {
      type: String,
      "default": "start",
      validator: function validator(val) {
        if (!val) return true;
        return ["start", "end", "center", "space-around", "space-between"].includes(val);
      }
    },
    tag: {
      type: String,
      "default": "div"
    }
  };

  function ownKeys$2U(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2T(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2U(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2U(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$I = getClassPrefixMixins("row");
  var _Row = mixins(classPrefixMixins$I).extend({
    name: "TRow",
    props: _objectSpread$2T({}, props$1l),
    data: function data() {
      return {
        size: "md"
      };
    },
    provide: function provide() {
      return {
        rowContext: {
          gutter: this.gutter
        }
      };
    },
    computed: {
      classes: function classes() {
        var justify = this.justify,
          align = this.align;
        return [this.componentName, _defineProperty$2(_defineProperty$2({}, "".concat(this.componentName, "--").concat(justify), justify), "".concat(this.componentName, "--align-").concat(align), align)];
      }
    },
    mounted: function mounted() {
      this.updateSize();
      this.handleIE();
      window.addEventListener("resize", this.updateSize);
    },
    watch: {
      gutter: function gutter() {
        this.handleIE();
      },
      size: function size() {
        this.handleIE();
      }
    },
    beforeDestroy: function beforeDestroy() {
      window.removeEventListener("resize", this.updateSize);
    },
    methods: {
      updateSize: function updateSize() {
        this.size = calcSize(window.innerWidth);
      },
      handleIE: function handleIE() {
        if (getIEVersion$1() <= 11) {
          var rowGap = this.rowGap(this.gutter, this.size);
          if (rowGap) {
            this.$el.setAttribute("row-gap", "".concat(rowGap));
          }
        }
      },
      calcRowStyle: function calcRowStyle(gutter, currentSize) {
        var rowStyle = {};
        if (typeof gutter === "number") {
          Object.assign(rowStyle, {
            marginLeft: "".concat(gutter / -2, "px"),
            marginRight: "".concat(gutter / -2, "px")
          });
        } else if (Array.isArray(gutter) && gutter.length) {
          if (typeof gutter[0] === "number") {
            Object.assign(rowStyle, {
              marginLeft: "".concat(gutter[0] / -2, "px"),
              marginRight: "".concat(gutter[0] / -2, "px")
            });
          }
          if (typeof gutter[1] === "number") {
            Object.assign(rowStyle, {
              rowGap: "".concat(gutter[1], "px")
            });
          }
          if (isObject(gutter[0]) && gutter[0][currentSize] !== void 0) {
            Object.assign(rowStyle, {
              marginLeft: "".concat(gutter[0][currentSize] / -2, "px"),
              marginRight: "".concat(gutter[0][currentSize] / -2, "px")
            });
          }
          if (isObject(gutter[1]) && gutter[1][currentSize] !== void 0) {
            Object.assign(rowStyle, {
              rowGap: "".concat(gutter[1][currentSize], "px")
            });
          }
        } else if (isObject(gutter) && gutter[currentSize]) {
          if (Array.isArray(gutter[currentSize]) && gutter[currentSize].length) {
            Object.assign(rowStyle, {
              marginLeft: "".concat(gutter[currentSize][0] / -2, "px"),
              marginRight: "".concat(gutter[currentSize][0] / -2, "px")
            });
            Object.assign(rowStyle, {
              rowGap: "".concat(gutter[currentSize][1], "px")
            });
          } else {
            Object.assign(rowStyle, {
              marginLeft: "".concat(gutter[currentSize] / -2, "px"),
              marginRight: "".concat(gutter[currentSize] / -2, "px")
            });
          }
        }
        return rowStyle;
      },
      rowGap: function rowGap(gutter, currentSize) {
        var rowGap;
        if (Array.isArray(gutter) && gutter.length) {
          if (typeof gutter[1] === "number") {
            var _gutter = _slicedToArray(gutter, 2);
            rowGap = _gutter[1];
          }
          if (isObject(gutter[1]) && gutter[1][currentSize] !== void 0) {
            rowGap = gutter[1][currentSize];
          }
        } else if (isObject(gutter) && gutter[currentSize]) {
          if (Array.isArray(gutter[currentSize]) && gutter[currentSize].length) {
            var _gutter$currentSize = _slicedToArray(gutter[currentSize], 2);
            rowGap = _gutter$currentSize[1];
          }
        }
        return rowGap;
      }
    },
    render: function render() {
      var h = arguments[0];
      var tag = this.tag,
        classes = this.classes;
      var rowStyle = this.calcRowStyle(this.gutter, this.size);
      var attributes = {
        "class": classes,
        style: rowStyle,
        attrs: {}
      };
      return h(tag, helper([{}, attributes]), [this.$slots["default"]]);
    }
  });

  var Col = withInstall$1(_Col);
  var Row = withInstall$1(_Row);

  var classPrefixMixins$H = getClassPrefixMixins("layout");
  var _Layout = mixins(classPrefixMixins$H).extend({
    name: "TLayout",
    data: function data() {
      return {
        hasSider: false
      };
    },
    provide: function provide() {
      return {
        layout: this
      };
    },
    methods: {
      renderContent: function renderContent() {
        return this.$scopedSlots["default"] ? this.$scopedSlots["default"](null) : "";
      }
    },
    computed: {
      classes: function classes() {
        return [this.componentName, _defineProperty$2({}, "".concat(this.componentName, "--with-sider"), this.hasSider)];
      }
    },
    render: function render() {
      var h = arguments[0];
      return h("section", {
        "class": this.classes
      }, [renderTNodeJSX(this, "default")]);
    }
  });

  var props$1k = {
    height: {
      type: String,
      "default": ""
    }
  };

  function ownKeys$2T(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2S(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2T(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2T(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$G = getClassPrefixMixins("header");
  var _Header = mixins(classPrefixMixins$G).extend({
    name: "THeader",
    props: _objectSpread$2S({}, props$1k),
    render: function render() {
      var h = arguments[0];
      var styles = this.height ? {
        height: this.height
      } : {};
      return h("header", {
        "class": "".concat(this.classPrefix, "-layout__header"),
        "style": styles
      }, [renderTNodeJSX(this, "default")]);
    }
  });

  var props$1j = {
    height: {
      type: String,
      "default": ""
    }
  };

  function ownKeys$2S(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2R(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2S(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2S(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$F = getClassPrefixMixins("footer");
  var _Footer = mixins(classPrefixMixins$F).extend({
    name: "TFooter",
    props: _objectSpread$2R({}, props$1j),
    methods: {
      renderContent: function renderContent() {
        return this.$scopedSlots["default"] ? this.$scopedSlots["default"](null) : "";
      }
    },
    render: function render() {
      var h = arguments[0];
      var styles = this.height ? {
        height: this.height
      } : {};
      return h("footer", {
        "class": "".concat(this.classPrefix, "-layout__footer"),
        "style": styles
      }, [renderTNodeJSX(this, "default")]);
    }
  });

  var props$1i = {
    width: {
      type: String,
      "default": ""
    }
  };

  function ownKeys$2R(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2Q(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2R(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2R(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$E = getClassPrefixMixins("aside");
  var _Aside = mixins(Vue__default["default"], classPrefixMixins$E).extend({
    name: "TAside",
    props: _objectSpread$2Q({}, props$1i),
    data: function data() {
      return {};
    },
    inject: {
      layout: {
        "default": void 0
      }
    },
    mounted: function mounted() {
      this.layout.hasSider = true;
    },
    destroyed: function destroyed() {
      this.layout.hasSider = false;
    },
    render: function render() {
      var h = arguments[0];
      var styles = this.width ? {
        width: this.width
      } : {};
      return h("aside", {
        "class": "".concat(this.classPrefix, "-layout__sider"),
        "style": styles
      }, [renderTNodeJSX(this, "default")]);
    }
  });

  var classPrefixMixins$D = getClassPrefixMixins("content");
  var _Content = mixins(classPrefixMixins$D).extend({
    name: "TContent",
    render: function render() {
      var h = arguments[0];
      return h("main", {
        "class": "".concat(this.classPrefix, "-layout__content")
      }, [renderTNodeJSX(this, "default")]);
    }
  });

  var Aside = withInstall$1(_Aside);
  var Layout = withInstall$1(_Layout);
  var Header = withInstall$1(_Header);
  var Footer = withInstall$1(_Footer);
  var Content = withInstall$1(_Content);

  var props$1h = {
    align: {
      type: String,
      "default": "center",
      validator: function validator(val) {
        if (!val) return true;
        return ["left", "right", "center"].includes(val);
      }
    },
    content: {
      type: [String, Function]
    },
    dashed: Boolean,
    "default": {
      type: [String, Function]
    },
    layout: {
      type: String,
      "default": "horizontal",
      validator: function validator(val) {
        if (!val) return true;
        return ["horizontal", "vertical"].includes(val);
      }
    },
    theme: {
      type: String,
      validator: function validator(val) {
        if (!val) return true;
        return ["horizontal", "vertical"].includes(val);
      }
    }
  };

  function ownKeys$2Q(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2P(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2Q(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2Q(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$C = getClassPrefixMixins("divider");
  var _Divider = mixins(classPrefixMixins$C).extend({
    name: "TDivider",
    props: _objectSpread$2P({}, props$1h),
    render: function render() {
      var h = arguments[0];
      var children = renderContent(this, "default", "content");
      if (this.theme) {
        console.warn("TDesign Divider Warn: `theme` is going to be deprecated, please use `layout` instead.");
      }
      var dividerClassNames = ["".concat(this.componentName), ["".concat(this.componentName, "--").concat(this.layout || this.theme || "horizontal")], _defineProperty$2(_defineProperty$2(_defineProperty$2({}, "".concat(this.componentName, "--dashed"), !!this.dashed), "".concat(this.componentName, "--with-text"), !!children), "".concat(this.componentName, "--with-text-").concat(this.align), !!children)];
      return h("div", {
        "class": dividerClassNames
      }, [children && h("span", {
        "class": "".concat(this.componentName, "__inner-text")
      }, [children])]);
    }
  });

  var Divider = withInstall$1(_Divider);

  var props$1g = {
    align: {
      type: String,
      validator: function validator(val) {
        if (!val) return true;
        return ["start", "end", "center", "baseline"].includes(val);
      }
    },
    breakLine: Boolean,
    direction: {
      type: String,
      "default": "horizontal",
      validator: function validator(val) {
        if (!val) return true;
        return ["vertical", "horizontal"].includes(val);
      }
    },
    separator: {
      type: [String, Function]
    },
    size: {
      type: [String, Number, Array],
      "default": "medium"
    }
  };

  var t = function t(pattern) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    var data = args[0];
    if (typeof pattern === "string") {
      if (!data) return pattern;
      var regular = /\{\s*([\w-]+)\s*\}/g;
      var translated = pattern.replace(regular, function (match, key) {
        if (data) {
          return String(data[key]);
        }
        return "";
      });
      return translated;
    }
    if (typeof pattern === "function") {
      if (!args.length) return pattern(VueCompositionAPI.h);
      return pattern.apply(void 0, args);
    }
    return "";
  };
  function useConfig() {
    var componentName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : void 0;
    var componentLocale = arguments.length > 1 ? arguments[1] : undefined;
    var injectGlobalConfig = VueCompositionAPI.inject("globalConfig", null);
    var mergedGlobalConfig = injectGlobalConfig || defaultGlobalConfig;
    var global = VueCompositionAPI.computed(function () {
      return Object.assign({}, mergedGlobalConfig[componentName], componentLocale);
    });
    var classPrefix = VueCompositionAPI.ref(mergedGlobalConfig.classPrefix);
    return {
      t: t,
      global: global,
      globalConfig: global,
      classPrefix: classPrefix
    };
  }
  function usePrefixClass$1(componentName) {
    var _useConfig = useConfig("classPrefix"),
      classPrefix = _useConfig.classPrefix;
    return VueCompositionAPI.ref(componentName ? "".concat(classPrefix.value, "-").concat(componentName) : classPrefix.value);
  }

  function usePrefixClass(componentName) {
    var _useConfig = useConfig("classPrefix"),
      classPrefix = _useConfig.classPrefix;
    return VueCompositionAPI.computed(function () {
      return componentName ? "".concat(classPrefix.value, "-").concat(componentName) : classPrefix.value;
    });
  }
  function useCommonClassName$1() {
    var _useConfig2 = useConfig("classPrefix"),
      classPrefix = _useConfig2.classPrefix;
    return {
      classPrefix: classPrefix,
      SIZE: VueCompositionAPI.computed(function () {
        return {
          small: "".concat(classPrefix.value, "-size-s"),
          medium: "".concat(classPrefix.value, "-size-m"),
          large: "".concat(classPrefix.value, "-size-l"),
          "default": "",
          xs: "".concat(classPrefix.value, "-size-xs"),
          xl: "".concat(classPrefix.value, "-size-xl"),
          block: "".concat(classPrefix.value, "-size-full-width")
        };
      }),
      STATUS: VueCompositionAPI.computed(function () {
        return {
          loading: "".concat(classPrefix.value, "-is-loading"),
          loadMore: "".concat(classPrefix.value, "-is-load-more"),
          disabled: "".concat(classPrefix.value, "-is-disabled"),
          focused: "".concat(classPrefix.value, "-is-focused"),
          success: "".concat(classPrefix.value, "-is-success"),
          error: "".concat(classPrefix.value, "-is-error"),
          warning: "".concat(classPrefix.value, "-is-warning"),
          selected: "".concat(classPrefix.value, "-is-selected"),
          active: "".concat(classPrefix.value, "-is-active"),
          checked: "".concat(classPrefix.value, "-is-checked"),
          current: "".concat(classPrefix.value, "-is-current"),
          hidden: "".concat(classPrefix.value, "-is-hidden"),
          visible: "".concat(classPrefix.value, "-is-visible"),
          expanded: "".concat(classPrefix.value, "-is-expanded"),
          indeterminate: "".concat(classPrefix.value, "-is-indeterminate")
        };
      })
    };
  }

  function ownKeys$2P(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2O(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2P(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2P(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var defaultNeedPolyfill = getFlexGapPolyFill();
  var sizeMap = {
    small: "8px",
    medium: "16px",
    large: "24px"
  };
  var _Space = VueCompositionAPI.defineComponent({
    name: "TSpace",
    props: _objectSpread$2O(_objectSpread$2O({}, props$1g), {}, {
      forceFlexGapPolyfill: Boolean
    }),
    setup: function setup(props2) {
      var COMPONENT_NAME = usePrefixClass("space");
      var needPolyfill = VueCompositionAPI.computed(function () {
        return props2.forceFlexGapPolyfill || defaultNeedPolyfill;
      });
      var renderStyle = VueCompositionAPI.computed(function () {
        var renderGap = "";
        if (Array.isArray(props2.size)) {
          renderGap = props2.size.map(function (s) {
            if (typeof s === "number") return "".concat(s, "px");
            if (typeof s === "string") return sizeMap[s] || s;
            return s;
          }).join(" ");
        } else if (typeof props2.size === "string") {
          renderGap = sizeMap[props2.size] || props2.size;
        } else if (typeof props2.size === "number") {
          renderGap = "".concat(props2.size, "px");
        }
        var style = {};
        if (needPolyfill.value) {
          var _renderGap$split = renderGap.split(" "),
            _renderGap$split2 = _slicedToArray(_renderGap$split, 2),
            columnGap = _renderGap$split2[0],
            rowGap = _renderGap$split2[1];
          style["--td-space-column-gap"] = columnGap;
          style["--td-space-row-gap"] = rowGap || columnGap;
        } else {
          style.gap = renderGap;
        }
        return style;
      });
      var spaceClassNames = VueCompositionAPI.computed(function () {
        return ["".concat(COMPONENT_NAME.value), _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({}, "".concat(COMPONENT_NAME.value, "-align-").concat(props2.align), props2.align), "".concat(COMPONENT_NAME.value, "-").concat(props2.direction), props2.direction), "".concat(COMPONENT_NAME.value, "--break-line"), props2.breakLine), "".concat(COMPONENT_NAME.value, "--polyfill"), needPolyfill.value)];
      });
      return {
        COMPONENT_NAME: COMPONENT_NAME,
        spaceClassNames: spaceClassNames,
        renderStyle: renderStyle
      };
    },
    render: function render() {
      var _this = this;
      var h = arguments[0];
      var COMPONENT_NAME = this.COMPONENT_NAME,
        spaceClassNames = this.spaceClassNames,
        renderStyle = this.renderStyle;
      var children = this.$slots["default"] || [];
      var childCount = children === null || children === void 0 ? void 0 : children.length;
      var renderChildren = function renderChildren() {
        return children.map(function (child, index) {
          if (!child.tag && !child.text) {
            return child;
          }
          var separatorNode = renderTNodeJSX(_this, "separator");
          var showSeparator = index + 1 !== childCount && separatorNode;
          return [h("div", {
            "class": "".concat(COMPONENT_NAME, "-item")
          }, [child]), showSeparator ? h("div", {
            "class": "".concat(COMPONENT_NAME, "-item-separator")
          }, [separatorNode]) : null];
        });
      };
      return h("div", {
        "class": spaceClassNames,
        "style": renderStyle
      }, [renderChildren()]);
    }
  });

  var Space = withInstall$1(_Space);

  var affixProps = {
    container: {
      type: [String, Function],
      "default": function _default() {
        return function () {
          return window;
        };
      }
    },
    content: {
      type: [String, Function]
    },
    "default": {
      type: [String, Function]
    },
    offsetBottom: {
      type: Number,
      "default": 0
    },
    offsetTop: {
      type: Number,
      "default": 0
    },
    zIndex: {
      type: Number
    },
    onFixedChange: Function
  };

  function ownKeys$2O(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2N(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2O(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2O(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classMixins = getClassPrefixMixins("affix");
  var _Affix = mixins(Vue__default["default"], classMixins).extend({
    name: "TAffix",
    props: _objectSpread$2N({}, affixProps),
    watch: {
      offsetTop: function offsetTop() {
        this.handleScroll();
      },
      offsetBottom: function offsetBottom() {
        this.handleScroll();
      },
      zIndex: function zIndex() {
        this.handleScroll();
      }
    },
    methods: {
      handleScroll: function handleScroll() {
        var _this = this;
        var scrollContainer = this.scrollContainer,
          offsetTop = this.offsetTop,
          offsetBottom = this.offsetBottom;
        var _this$$refs = this.$refs,
          affixWrapRef = _this$$refs.affixWrapRef,
          affixRef = _this$$refs.affixRef;
        if (!this.ticking) {
          window.requestAnimationFrame(function () {
            var _affixWrapRef$getBoun;
            var _ref = (_affixWrapRef$getBoun = affixWrapRef === null || affixWrapRef === void 0 ? void 0 : affixWrapRef.getBoundingClientRect()) !== null && _affixWrapRef$getBoun !== void 0 ? _affixWrapRef$getBoun : {
                top: 0,
                width: 0,
                height: 0
              },
              wrapToTop = _ref.top,
              wrapWidth = _ref.width,
              wrapHeight = _ref.height;
            var containerTop = 0;
            if (scrollContainer instanceof HTMLElement) {
              var _scrollContainer$getB;
              containerTop = scrollContainer === null || scrollContainer === void 0 || (_scrollContainer$getB = scrollContainer.getBoundingClientRect) === null || _scrollContainer$getB === void 0 ? void 0 : _scrollContainer$getB.call(scrollContainer).top;
            }
            var fixedTop;
            var calcTop = wrapToTop - containerTop;
            var containerHeight = (scrollContainer === null || scrollContainer === void 0 ? void 0 : scrollContainer[scrollContainer instanceof Window ? "innerHeight" : "clientHeight"]) - wrapHeight;
            var calcBottom = containerTop + containerHeight - offsetBottom;
            if (offsetTop !== void 0 && calcTop <= offsetTop) {
              fixedTop = containerTop + offsetTop;
            } else if (offsetBottom !== void 0 && wrapToTop >= calcBottom) {
              fixedTop = calcBottom;
            } else {
              fixedTop = false;
            }
            if (affixRef) {
              var affixed = fixedTop !== false;
              var placeholderStatus = affixWrapRef.contains(_this.placeholderEL);
              if (affixed) {
                affixRef.className = _this.componentName;
                affixRef.style.top = "".concat(fixedTop, "px");
                affixRef.style.width = "".concat(wrapWidth, "px");
                affixRef.style.height = "".concat(wrapHeight, "px");
                if (_this.zIndex) {
                  affixRef.style.zIndex = "".concat(_this.zIndex);
                }
                if (!placeholderStatus) {
                  _this.placeholderEL.style.width = "".concat(wrapWidth, "px");
                  _this.placeholderEL.style.height = "".concat(wrapHeight, "px");
                  affixWrapRef.appendChild(_this.placeholderEL);
                }
              } else {
                affixRef.removeAttribute("class");
                affixRef.removeAttribute("style");
                placeholderStatus && _this.placeholderEL.remove();
              }
              _this.$emit("fixedChange", affixed, {
                top: fixedTop
              });
              if (isFunction(_this.onFixedChange)) _this.onFixedChange(affixed, {
                top: Number(fixedTop)
              });
            }
            _this.ticking = false;
          });
          this.ticking = true;
        }
      }
    },
    mounted: function mounted() {
      var _this2 = this;
      this.placeholderEL = document.createElement("div");
      var timer = setTimeout(function () {
        _this2.scrollContainer = getScrollContainer(_this2.container);
        _this2.handleScroll();
        on$1(_this2.scrollContainer, "scroll", _this2.handleScroll);
        on$1(window, "resize", _this2.handleScroll);
        clearTimeout(timer);
      }, 0);
    },
    destroyed: function destroyed() {
      if (!this.scrollContainer) return;
      off$1(this.scrollContainer, "scroll", this.handleScroll);
      off$1(window, "resize", this.handleScroll);
    },
    render: function render() {
      var h = arguments[0];
      return h("div", {
        "ref": "affixWrapRef"
      }, [h("div", {
        "ref": "affixRef"
      }, [this.$slots["default"]])]);
    }
  });

  var Affix = withInstall$1(_Affix);

  function asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
      var i = n[a](c),
        u = i.value;
    } catch (n) {
      return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
  }
  function _asyncToGenerator(n) {
    return function () {
      var t = this,
        e = arguments;
      return new Promise(function (r, o) {
        var a = n.apply(t, e);
        function _next(n) {
          asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
        }
        function _throw(n) {
          asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
        }
        _next(void 0);
      });
    };
  }

  var _typeof_1 = createCommonjsModule(function (module) {
    function _typeof(o) {
      "@babel/helpers - typeof";

      return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
        return typeof o;
      } : function (o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
      }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
    }
    module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
  });

  var regeneratorRuntime$1 = createCommonjsModule(function (module) {
    var _typeof = _typeof_1["default"];
    function _regeneratorRuntime() {

      /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
      module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
        return e;
      }, module.exports.__esModule = true, module.exports["default"] = module.exports;
      var t,
        e = {},
        r = Object.prototype,
        n = r.hasOwnProperty,
        o = Object.defineProperty || function (t, e, r) {
          t[e] = r.value;
        },
        i = "function" == typeof Symbol ? Symbol : {},
        a = i.iterator || "@@iterator",
        c = i.asyncIterator || "@@asyncIterator",
        u = i.toStringTag || "@@toStringTag";
      function define(t, e, r) {
        return Object.defineProperty(t, e, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), t[e];
      }
      try {
        define({}, "");
      } catch (t) {
        define = function define(t, e, r) {
          return t[e] = r;
        };
      }
      function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator,
          a = Object.create(i.prototype),
          c = new Context(n || []);
        return o(a, "_invoke", {
          value: makeInvokeMethod(t, r, c)
        }), a;
      }
      function tryCatch(t, e, r) {
        try {
          return {
            type: "normal",
            arg: t.call(e, r)
          };
        } catch (t) {
          return {
            type: "throw",
            arg: t
          };
        }
      }
      e.wrap = wrap;
      var h = "suspendedStart",
        l = "suspendedYield",
        f = "executing",
        s = "completed",
        y = {};
      function Generator() {}
      function GeneratorFunction() {}
      function GeneratorFunctionPrototype() {}
      var p = {};
      define(p, a, function () {
        return this;
      });
      var d = Object.getPrototypeOf,
        v = d && d(d(values([])));
      v && v !== r && n.call(v, a) && (p = v);
      var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
      function defineIteratorMethods(t) {
        ["next", "throw", "return"].forEach(function (e) {
          define(t, e, function (t) {
            return this._invoke(e, t);
          });
        });
      }
      function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
          var c = tryCatch(t[r], t, o);
          if ("throw" !== c.type) {
            var u = c.arg,
              h = u.value;
            return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
              invoke("next", t, i, a);
            }, function (t) {
              invoke("throw", t, i, a);
            }) : e.resolve(h).then(function (t) {
              u.value = t, i(u);
            }, function (t) {
              return invoke("throw", t, i, a);
            });
          }
          a(c.arg);
        }
        var r;
        o(this, "_invoke", {
          value: function value(t, n) {
            function callInvokeWithMethodAndArg() {
              return new e(function (e, r) {
                invoke(t, n, e, r);
              });
            }
            return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
          }
        });
      }
      function makeInvokeMethod(e, r, n) {
        var o = h;
        return function (i, a) {
          if (o === f) throw Error("Generator is already running");
          if (o === s) {
            if ("throw" === i) throw a;
            return {
              value: t,
              done: !0
            };
          }
          for (n.method = i, n.arg = a;;) {
            var c = n.delegate;
            if (c) {
              var u = maybeInvokeDelegate(c, n);
              if (u) {
                if (u === y) continue;
                return u;
              }
            }
            if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
              if (o === h) throw o = s, n.arg;
              n.dispatchException(n.arg);
            } else "return" === n.method && n.abrupt("return", n.arg);
            o = f;
            var p = tryCatch(e, r, n);
            if ("normal" === p.type) {
              if (o = n.done ? s : l, p.arg === y) continue;
              return {
                value: p.arg,
                done: n.done
              };
            }
            "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
          }
        };
      }
      function maybeInvokeDelegate(e, r) {
        var n = r.method,
          o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
      }
      function pushTryEntry(t) {
        var e = {
          tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
      }
      function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
      }
      function Context(t) {
        this.tryEntries = [{
          tryLoc: "root"
        }], t.forEach(pushTryEntry, this), this.reset(!0);
      }
      function values(e) {
        if (e || "" === e) {
          var r = e[a];
          if (r) return r.call(e);
          if ("function" == typeof e.next) return e;
          if (!isNaN(e.length)) {
            var o = -1,
              i = function next() {
                for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                return next.value = t, next.done = !0, next;
              };
            return i.next = i;
          }
        }
        throw new TypeError(_typeof(e) + " is not iterable");
      }
      return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
      }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
      }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
      }, e.mark = function (t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
      }, e.awrap = function (t) {
        return {
          __await: t
        };
      }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
        return this;
      }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
          return t.done ? t.value : a.next();
        });
      }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
        return this;
      }), define(g, "toString", function () {
        return "[object Generator]";
      }), e.keys = function (t) {
        var e = Object(t),
          r = [];
        for (var n in e) r.push(n);
        return r.reverse(), function next() {
          for (; r.length;) {
            var t = r.pop();
            if (t in e) return next.value = t, next.done = !1, next;
          }
          return next.done = !0, next;
        };
      }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
          this.done = !0;
          var t = this.tryEntries[0].completion;
          if ("throw" === t.type) throw t.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e) {
          if (this.done) throw e;
          var r = this;
          function handle(n, o) {
            return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
          }
          for (var o = this.tryEntries.length - 1; o >= 0; --o) {
            var i = this.tryEntries[o],
              a = i.completion;
            if ("root" === i.tryLoc) return handle("end");
            if (i.tryLoc <= this.prev) {
              var c = n.call(i, "catchLoc"),
                u = n.call(i, "finallyLoc");
              if (c && u) {
                if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
              } else if (c) {
                if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
              } else {
                if (!u) throw Error("try statement without catch or finally");
                if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(t, e) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var o = this.tryEntries[r];
            if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }
          i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
          var a = i ? i.completion : {};
          return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
          if ("throw" === t.type) throw t.arg;
          return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];
            if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
          }
        },
        "catch": function _catch(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];
            if (r.tryLoc === t) {
              var n = r.completion;
              if ("throw" === n.type) {
                var o = n.arg;
                resetTryEntry(r);
              }
              return o;
            }
          }
          throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
          return this.delegate = {
            iterator: values(e),
            resultName: r,
            nextLoc: n
          }, "next" === this.method && (this.arg = t), y;
        }
      }, e;
    }
    module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;
  });

  // TODO(Babel 8): Remove this file.

  var runtime = regeneratorRuntime$1();
  var regenerator = runtime;

  // Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
  try {
    regeneratorRuntime = runtime;
  } catch (accidentalStrictMode) {
    if ((typeof globalThis === "undefined" ? "undefined" : _typeof$2(globalThis)) === "object") {
      globalThis.regeneratorRuntime = runtime;
    } else {
      Function("r", "regeneratorRuntime = r")(runtime);
    }
  }

  var ANCHOR_SHARP_REGEXP = /#(\S+)$/;
  function getOffsetTop(target, container) {
    var _target$getBoundingCl = target.getBoundingClientRect(),
      top = _target$getBoundingCl.top;
    if (container === window) {
      return top - document.documentElement.clientTop;
    }
    return top - container.getBoundingClientRect().top;
  }

  var props$1f = {
    affixProps: {
      type: Object
    },
    bounds: {
      type: Number,
      "default": 5
    },
    container: {
      type: [String, Function],
      "default": function _default() {
        return function () {
          return window;
        };
      }
    },
    cursor: {
      type: Function
    },
    getCurrentAnchor: {
      type: Function
    },
    size: {
      type: String,
      "default": "medium",
      validator: function validator(val) {
        if (!val) return true;
        return ["small", "medium", "large"].includes(val);
      }
    },
    targetOffset: {
      type: Number,
      "default": 0
    },
    onChange: Function,
    onClick: Function
  };

  function ownKeys$2N(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2M(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2N(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2N(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$B = getClassPrefixMixins("anchor");
  var _Anchor = mixins(Vue__default["default"], classPrefixMixins$B).extend({
    name: "TAnchor",
    props: _objectSpread$2M({}, props$1f),
    provide: function provide() {
      return {
        tAnchor: this
      };
    },
    data: function data() {
      return {
        links: [],
        active: "",
        activeLineStyle: false
      };
    },
    watch: {
      attach: function attach() {
        if (this.scrollContainer) {
          off$1(this.scrollContainer, "scroll", this.handleScroll);
        }
        this.getScrollContainer();
      }
    },
    methods: {
      getScrollContainer: function getScrollContainer$1() {
        var container = this.container;
        this.scrollContainer = getScrollContainer(container);
        on$1(this.scrollContainer, "scroll", this.handleScroll);
        this.handleScroll();
      },
      getAnchorTarget: function getAnchorTarget(link) {
        var matcher = link.match(ANCHOR_SHARP_REGEXP);
        if (!matcher) {
          return;
        }
        var anchor = document.getElementById(matcher[1]);
        if (!anchor) {
          return;
        }
        return anchor;
      },
      registerLink: function registerLink(link) {
        var links = this.links;
        if (!ANCHOR_SHARP_REGEXP.test(link) || links.indexOf(link) !== -1) {
          return;
        }
        links.push(link);
      },
      unregisterLink: function unregisterLink(link) {
        this.links = this.links.filter(function (each) {
          return each !== link;
        });
      },
      setCurrentActiveLink: function setCurrentActiveLink(link) {
        var _this = this;
        return _asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee() {
          var active;
          return regenerator.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                active = _this.active;
                if (!(active === link)) {
                  _context.next = 3;
                  break;
                }
                return _context.abrupt("return");
              case 3:
                _this.active = link;
                _this.emitChange(link, active);
                _context.next = 7;
                return Vue__default["default"].nextTick();
              case 7:
                _this.updateActiveLine();
              case 8:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }))();
      },
      updateActiveLine: function updateActiveLine() {
        var ele = this.$el.querySelector(".".concat(this.commonStatusClassName.active, ">a"));
        if (!ele) {
          this.activeLineStyle = false;
          return;
        }
        var top = ele.offsetTop,
          height = ele.offsetHeight;
        this.activeLineStyle = {
          top: "".concat(top, "px"),
          height: "".concat(height, "px"),
          opacity: 1
        };
      },
      emitChange: function emitChange(currentLink, prevLink) {
        this.$emit("change", currentLink, prevLink);
        if (this.onChange) {
          this.onChange(currentLink, prevLink);
        }
      },
      handleLinkClick: function handleLinkClick(link) {
        var _this$onClick;
        this.$emit("click", link);
        (_this$onClick = this.onClick) === null || _this$onClick === void 0 || _this$onClick.call(this, link);
        var getCurrentAnchor = this.$props.getCurrentAnchor;
        var newHref = isFunction(getCurrentAnchor) ? getCurrentAnchor(link.href) : link.href;
        this.handleScrollTo(newHref);
      },
      handleScrollTo: function handleScrollTo(link) {
        var _this2 = this;
        return _asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee2() {
          var anchor, scrollContainer, targetOffset, scrollTop, offsetTop, top;
          return regenerator.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                anchor = _this2.getAnchorTarget(link);
                _this2.setCurrentActiveLink(link);
                if (anchor) {
                  _context2.next = 4;
                  break;
                }
                return _context2.abrupt("return");
              case 4:
                _this2.handleScrollLock = true;
                scrollContainer = _this2.scrollContainer, targetOffset = _this2.targetOffset;
                scrollTop = getScroll(scrollContainer);
                offsetTop = getOffsetTop(anchor, scrollContainer);
                top = scrollTop + offsetTop - targetOffset;
                _context2.next = 11;
                return scrollTo(top, {
                  container: scrollContainer
                });
              case 11:
                _this2.handleScrollLock = false;
              case 12:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }))();
      },
      handleScroll: function handleScroll() {
        var _this3 = this;
        if (this.handleScrollLock) return;
        var links = this.links,
          bounds = this.bounds,
          targetOffset = this.targetOffset;
        var filters = [];
        var active = "";
        links.forEach(function (link) {
          var anchor = _this3.getAnchorTarget(link);
          if (!anchor) {
            return;
          }
          var top = getOffsetTop(anchor, _this3.scrollContainer);
          if (top < bounds + targetOffset) {
            filters.push({
              link: link,
              top: top
            });
          }
        });
        if (filters.length) {
          var latest = filters.reduce(function (prev, cur) {
            return prev.top > cur.top ? prev : cur;
          });
          active = latest.link;
        }
        this.setCurrentActiveLink(active);
      },
      renderCursor: function renderCursor() {
        var h = this.$createElement;
        var titleContent = renderTNodeJSX(this, "cursor");
        return titleContent || h("div", {
          "class": "".concat(this.componentName, "__line-cursor")
        });
      }
    },
    mounted: function mounted() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee3() {
        var getCurrentAnchor, _window, href;
        return regenerator.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.getScrollContainer();
              getCurrentAnchor = _this4.$props.getCurrentAnchor;
              if (isFunction(getCurrentAnchor)) {
                _this4.setCurrentActiveLink(getCurrentAnchor(_this4.active));
              } else {
                href = (_window = window) === null || _window === void 0 ? void 0 : _window.location.hash;
                _this4.setCurrentActiveLink(decodeURIComponent(href));
              }
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    destroyed: function destroyed() {
      if (!this.scrollContainer) return;
      off$1(this.scrollContainer, "scroll", this.handleScroll);
    },
    render: function render() {
      var h = arguments[0];
      var children = this.$scopedSlots["default"],
        size = this.size,
        affixProps = this.affixProps,
        activeLineStyle = this.activeLineStyle;
      var className = [this.componentName, this.commonSizeClassName[size]];
      var content = h("div", {
        "class": className
      }, [h("div", {
        "class": "".concat(this.componentName, "__line")
      }, [h("div", {
        "class": "".concat(this.componentName, "__line-cursor-wrapper"),
        "style": activeLineStyle
      }, [this.renderCursor()])]), children && children(null)]);
      if (affixProps) {
        return h(Affix, {
          "props": _objectSpread$2M({}, affixProps)
        }, [content]);
      }
      return content;
    }
  });

  var props$1e = {
    href: {
      type: String,
      "default": "",
      required: true
    },
    target: {
      type: String,
      "default": "_self",
      validator: function validator(val) {
        if (!val) return true;
        return ["_self", "_blank", "_parent", "_top"].includes(val);
      }
    },
    title: {
      type: [String, Function],
      "default": ""
    }
  };

  function ownKeys$2M(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2L(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2M(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2M(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$A = getClassPrefixMixins("anchor");
  var _AnchorItem = mixins(Vue__default["default"], classPrefixMixins$A).extend({
    name: "TAnchorItem",
    props: _objectSpread$2L(_objectSpread$2L({}, props$1e), {}, {
      _level: {
        type: Number,
        "default": 0
      },
      href: {
        type: String,
        required: true,
        validator: function validator(v) {
          return ANCHOR_SHARP_REGEXP.test(v);
        }
      }
    }),
    inject: {
      tAnchor: {
        "default": void 0
      }
    },
    watch: {
      href: {
        immediate: true,
        handler: function handler() {
          this.unregister();
          this.register();
        }
      }
    },
    destroyed: function destroyed() {
      this.unregister();
    },
    methods: {
      register: function register() {
        this.tAnchor.registerLink(this.href);
      },
      unregister: function unregister() {
        var href = this.href;
        if (!href) return;
        this.tAnchor.unregisterLink(href);
      },
      handleClick: function handleClick(e) {
        var href = this.href,
          tAnchor = this.tAnchor,
          title = this.title;
        tAnchor.handleLinkClick({
          href: href,
          title: typeof title === "string" ? title : void 0,
          e: e
        });
      },
      renderTitle: function renderTitle() {
        var title = this.title,
          $scopedSlots = this.$scopedSlots;
        var titleSlot = $scopedSlots.title;
        var titleVal;
        if (typeof title === "string") {
          titleVal = title;
        } else if (typeof title === "function") {
          titleVal = title(this.$createElement);
        } else if (titleSlot) {
          titleVal = titleSlot(null);
        }
        return titleVal;
      }
    },
    render: function render(h) {
      var href = this.href,
        target = this.target,
        $scopedSlots = this.$scopedSlots,
        tAnchor = this.tAnchor;
      var children = $scopedSlots["default"],
        titleSlot = $scopedSlots.title;
      var title = this.renderTitle();
      var titleAttr = typeof title === "string" ? title : null;
      var isActive = tAnchor.active === href;
      var wrapperClass = _defineProperty$2(_defineProperty$2({}, "".concat(this.componentName, "__item"), true), this.commonStatusClassName.active, isActive);
      var titleClass = _defineProperty$2({}, "".concat(this.componentName, "__item-link"), true);
      var newLevel = this.$props._level + 1;
      var h5Tags = [];
      var anchorItems = [];
      if (children) {
        children(null).forEach(function (child) {
          if (isEmpty(child.componentOptions)) {
            h5Tags.push(h(child.tag, child.data, child.children));
          } else {
            var _child$componentOptio, _child$componentOptio2, _child$componentOptio3;
            anchorItems.push(h((_child$componentOptio = child.componentOptions) === null || _child$componentOptio === void 0 ? void 0 : _child$componentOptio.Ctor, {
              props: _objectSpread$2L(_objectSpread$2L({}, (_child$componentOptio2 = child.componentOptions) === null || _child$componentOptio2 === void 0 ? void 0 : _child$componentOptio2.propsData), {}, {
                _level: newLevel
              })
            }, child === null || child === void 0 || (_child$componentOptio3 = child.componentOptions) === null || _child$componentOptio3 === void 0 ? void 0 : _child$componentOptio3.children));
          }
        });
      }
      return h("div", {
        "style": {
          display: "contents"
        }
      }, [h("div", {
        "class": wrapperClass,
        "style": {
          "--level": newLevel
        }
      }, [h("a", {
        "attrs": {
          "href": href,
          "title": titleAttr,
          "target": target
        },
        "class": titleClass,
        "on": {
          "click": this.handleClick
        }
      }, [titleSlot ? titleSlot(null) : title]), h5Tags]), anchorItems]);
    }
  });

  /*!
   * clipboard.js v2.0.11
   * https://clipboardjs.com/
   *
   * Licensed MIT © Zeno Rocha
   */
  var clipboard = createCommonjsModule(function (module, exports) {
    (function webpackUniversalModuleDefinition(root, factory) {
      module.exports = factory();
    })(commonjsGlobal, function () {
      return /******/function () {
        // webpackBootstrap
        /******/
        var __webpack_modules__ = {
          /***/686: (/***/function _(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

            // EXPORTS
            __webpack_require__.d(__webpack_exports__, {
              "default": function _default() {
                return /* binding */clipboard;
              }
            });

            // EXTERNAL MODULE: ./node_modules/tiny-emitter/index.js
            var tiny_emitter = __webpack_require__(279);
            var tiny_emitter_default = /*#__PURE__*/__webpack_require__.n(tiny_emitter);
            // EXTERNAL MODULE: ./node_modules/good-listener/src/listen.js
            var listen = __webpack_require__(370);
            var listen_default = /*#__PURE__*/__webpack_require__.n(listen);
            // EXTERNAL MODULE: ./node_modules/select/src/select.js
            var src_select = __webpack_require__(817);
            var select_default = /*#__PURE__*/__webpack_require__.n(src_select);
            /**
             * Executes a given operation type.
             * @param {String} type
             * @return {Boolean}
             */
            function command(type) {
              try {
                return document.execCommand(type);
              } catch (err) {
                return false;
              }
            }

            /**
             * Cut action wrapper.
             * @param {String|HTMLElement} target
             * @return {String}
             */

            var ClipboardActionCut = function ClipboardActionCut(target) {
              var selectedText = select_default()(target);
              command('cut');
              return selectedText;
            };

            /* harmony default export */
            var actions_cut = ClipboardActionCut;
            /**
             * Creates a fake textarea element with a value.
             * @param {String} value
             * @return {HTMLElement}
             */
            function createFakeElement(value) {
              var isRTL = document.documentElement.getAttribute('dir') === 'rtl';
              var fakeElement = document.createElement('textarea'); // Prevent zooming on iOS

              fakeElement.style.fontSize = '12pt'; // Reset box model

              fakeElement.style.border = '0';
              fakeElement.style.padding = '0';
              fakeElement.style.margin = '0'; // Move element out of screen horizontally

              fakeElement.style.position = 'absolute';
              fakeElement.style[isRTL ? 'right' : 'left'] = '-9999px'; // Move element to the same position vertically

              var yPosition = window.pageYOffset || document.documentElement.scrollTop;
              fakeElement.style.top = "".concat(yPosition, "px");
              fakeElement.setAttribute('readonly', '');
              fakeElement.value = value;
              return fakeElement;
            }

            /**
             * Create fake copy action wrapper using a fake element.
             * @param {String} target
             * @param {Object} options
             * @return {String}
             */

            var fakeCopyAction = function fakeCopyAction(value, options) {
              var fakeElement = createFakeElement(value);
              options.container.appendChild(fakeElement);
              var selectedText = select_default()(fakeElement);
              command('copy');
              fakeElement.remove();
              return selectedText;
            };
            /**
             * Copy action wrapper.
             * @param {String|HTMLElement} target
             * @param {Object} options
             * @return {String}
             */

            var ClipboardActionCopy = function ClipboardActionCopy(target) {
              var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                container: document.body
              };
              var selectedText = '';
              if (typeof target === 'string') {
                selectedText = fakeCopyAction(target, options);
              } else if (target instanceof HTMLInputElement && !['text', 'search', 'url', 'tel', 'password'].includes(target === null || target === void 0 ? void 0 : target.type)) {
                // If input type doesn't support `setSelectionRange`. Simulate it. https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setSelectionRange
                selectedText = fakeCopyAction(target.value, options);
              } else {
                selectedText = select_default()(target);
                command('copy');
              }
              return selectedText;
            };

            /* harmony default export */
            var actions_copy = ClipboardActionCopy;
            function _typeof(obj) {
              "@babel/helpers - typeof";

              if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
                _typeof = function _typeof(obj) {
                  return typeof obj;
                };
              } else {
                _typeof = function _typeof(obj) {
                  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
              }
              return _typeof(obj);
            }

            /**
             * Inner function which performs selection from either `text` or `target`
             * properties and then executes copy or cut operations.
             * @param {Object} options
             */

            var ClipboardActionDefault = function ClipboardActionDefault() {
              var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              // Defines base properties passed from constructor.
              var _options$action = options.action,
                action = _options$action === void 0 ? 'copy' : _options$action,
                container = options.container,
                target = options.target,
                text = options.text; // Sets the `action` to be performed which can be either 'copy' or 'cut'.

              if (action !== 'copy' && action !== 'cut') {
                throw new Error('Invalid "action" value, use either "copy" or "cut"');
              } // Sets the `target` property using an element that will be have its content copied.

              if (target !== undefined) {
                if (target && _typeof(target) === 'object' && target.nodeType === 1) {
                  if (action === 'copy' && target.hasAttribute('disabled')) {
                    throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                  }
                  if (action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
                    throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                  }
                } else {
                  throw new Error('Invalid "target" value, use a valid Element');
                }
              } // Define selection strategy based on `text` property.

              if (text) {
                return actions_copy(text, {
                  container: container
                });
              } // Defines which selection strategy based on `target` property.

              if (target) {
                return action === 'cut' ? actions_cut(target) : actions_copy(target, {
                  container: container
                });
              }
            };

            /* harmony default export */
            var actions_default = ClipboardActionDefault;
            function clipboard_typeof(obj) {
              "@babel/helpers - typeof";

              if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
                clipboard_typeof = function _typeof(obj) {
                  return typeof obj;
                };
              } else {
                clipboard_typeof = function _typeof(obj) {
                  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
              }
              return clipboard_typeof(obj);
            }
            function _classCallCheck(instance, Constructor) {
              if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
              }
            }
            function _defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            function _createClass(Constructor, protoProps, staticProps) {
              if (protoProps) _defineProperties(Constructor.prototype, protoProps);
              if (staticProps) _defineProperties(Constructor, staticProps);
              return Constructor;
            }
            function _inherits(subClass, superClass) {
              if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function");
              }
              subClass.prototype = Object.create(superClass && superClass.prototype, {
                constructor: {
                  value: subClass,
                  writable: true,
                  configurable: true
                }
              });
              if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
              _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                o.__proto__ = p;
                return o;
              };
              return _setPrototypeOf(o, p);
            }
            function _createSuper(Derived) {
              var hasNativeReflectConstruct = _isNativeReflectConstruct();
              return function _createSuperInternal() {
                var Super = _getPrototypeOf(Derived),
                  result;
                if (hasNativeReflectConstruct) {
                  var NewTarget = _getPrototypeOf(this).constructor;
                  result = Reflect.construct(Super, arguments, NewTarget);
                } else {
                  result = Super.apply(this, arguments);
                }
                return _possibleConstructorReturn(this, result);
              };
            }
            function _possibleConstructorReturn(self, call) {
              if (call && (clipboard_typeof(call) === "object" || typeof call === "function")) {
                return call;
              }
              return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
              if (self === void 0) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              }
              return self;
            }
            function _isNativeReflectConstruct() {
              if (typeof Reflect === "undefined" || !Reflect.construct) return false;
              if (Reflect.construct.sham) return false;
              if (typeof Proxy === "function") return true;
              try {
                Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
                return true;
              } catch (e) {
                return false;
              }
            }
            function _getPrototypeOf(o) {
              _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                return o.__proto__ || Object.getPrototypeOf(o);
              };
              return _getPrototypeOf(o);
            }

            /**
             * Helper function to retrieve attribute value.
             * @param {String} suffix
             * @param {Element} element
             */

            function getAttributeValue(suffix, element) {
              var attribute = "data-clipboard-".concat(suffix);
              if (!element.hasAttribute(attribute)) {
                return;
              }
              return element.getAttribute(attribute);
            }
            /**
             * Base class which takes one or more elements, adds event listeners to them,
             * and instantiates a new `ClipboardAction` on each click.
             */

            var Clipboard = /*#__PURE__*/function (_Emitter) {
              _inherits(Clipboard, _Emitter);
              var _super = _createSuper(Clipboard);

              /**
               * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
               * @param {Object} options
               */
              function Clipboard(trigger, options) {
                var _this;
                _classCallCheck(this, Clipboard);
                _this = _super.call(this);
                _this.resolveOptions(options);
                _this.listenClick(trigger);
                return _this;
              }
              /**
               * Defines if attributes would be resolved using internal setter functions
               * or custom functions that were passed in the constructor.
               * @param {Object} options
               */

              _createClass(Clipboard, [{
                key: "resolveOptions",
                value: function resolveOptions() {
                  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                  this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
                  this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
                  this.text = typeof options.text === 'function' ? options.text : this.defaultText;
                  this.container = clipboard_typeof(options.container) === 'object' ? options.container : document.body;
                }
                /**
                 * Adds a click event listener to the passed trigger.
                 * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
                 */
              }, {
                key: "listenClick",
                value: function listenClick(trigger) {
                  var _this2 = this;
                  this.listener = listen_default()(trigger, 'click', function (e) {
                    return _this2.onClick(e);
                  });
                }
                /**
                 * Defines a new `ClipboardAction` on each click event.
                 * @param {Event} e
                 */
              }, {
                key: "onClick",
                value: function onClick(e) {
                  var trigger = e.delegateTarget || e.currentTarget;
                  var action = this.action(trigger) || 'copy';
                  var text = actions_default({
                    action: action,
                    container: this.container,
                    target: this.target(trigger),
                    text: this.text(trigger)
                  }); // Fires an event based on the copy operation result.

                  this.emit(text ? 'success' : 'error', {
                    action: action,
                    text: text,
                    trigger: trigger,
                    clearSelection: function clearSelection() {
                      if (trigger) {
                        trigger.focus();
                      }
                      window.getSelection().removeAllRanges();
                    }
                  });
                }
                /**
                 * Default `action` lookup function.
                 * @param {Element} trigger
                 */
              }, {
                key: "defaultAction",
                value: function defaultAction(trigger) {
                  return getAttributeValue('action', trigger);
                }
                /**
                 * Default `target` lookup function.
                 * @param {Element} trigger
                 */
              }, {
                key: "defaultTarget",
                value: function defaultTarget(trigger) {
                  var selector = getAttributeValue('target', trigger);
                  if (selector) {
                    return document.querySelector(selector);
                  }
                }
                /**
                 * Allow fire programmatically a copy action
                 * @param {String|HTMLElement} target
                 * @param {Object} options
                 * @returns Text copied.
                 */
              }, {
                key: "defaultText",
                /**
                 * Default `text` lookup function.
                 * @param {Element} trigger
                 */
                value: function defaultText(trigger) {
                  return getAttributeValue('text', trigger);
                }
                /**
                 * Destroy lifecycle.
                 */
              }, {
                key: "destroy",
                value: function destroy() {
                  this.listener.destroy();
                }
              }], [{
                key: "copy",
                value: function copy(target) {
                  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    container: document.body
                  };
                  return actions_copy(target, options);
                }
                /**
                 * Allow fire programmatically a cut action
                 * @param {String|HTMLElement} target
                 * @returns Text cutted.
                 */
              }, {
                key: "cut",
                value: function cut(target) {
                  return actions_cut(target);
                }
                /**
                 * Returns the support of the given action, or all actions if no action is
                 * given.
                 * @param {String} [action]
                 */
              }, {
                key: "isSupported",
                value: function isSupported() {
                  var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];
                  var actions = typeof action === 'string' ? [action] : action;
                  var support = !!document.queryCommandSupported;
                  actions.forEach(function (action) {
                    support = support && !!document.queryCommandSupported(action);
                  });
                  return support;
                }
              }]);
              return Clipboard;
            }(tiny_emitter_default());

            /* harmony default export */
            var clipboard = Clipboard;

            /***/
          }),
          /***/828: (/***/function _(module) {
            var DOCUMENT_NODE_TYPE = 9;

            /**
             * A polyfill for Element.matches()
             */
            if (typeof Element !== 'undefined' && !Element.prototype.matches) {
              var proto = Element.prototype;
              proto.matches = proto.matchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector || proto.oMatchesSelector || proto.webkitMatchesSelector;
            }

            /**
             * Finds the closest parent that matches a selector.
             *
             * @param {Element} element
             * @param {String} selector
             * @return {Function}
             */
            function closest(element, selector) {
              while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
                if (typeof element.matches === 'function' && element.matches(selector)) {
                  return element;
                }
                element = element.parentNode;
              }
            }
            module.exports = closest;

            /***/
          }),
          /***/438: (/***/function _(module, __unused_webpack_exports, __webpack_require__) {
            var closest = __webpack_require__(828);

            /**
             * Delegates event to a selector.
             *
             * @param {Element} element
             * @param {String} selector
             * @param {String} type
             * @param {Function} callback
             * @param {Boolean} useCapture
             * @return {Object}
             */
            function _delegate(element, selector, type, callback, useCapture) {
              var listenerFn = listener.apply(this, arguments);
              element.addEventListener(type, listenerFn, useCapture);
              return {
                destroy: function destroy() {
                  element.removeEventListener(type, listenerFn, useCapture);
                }
              };
            }

            /**
             * Delegates event to a selector.
             *
             * @param {Element|String|Array} [elements]
             * @param {String} selector
             * @param {String} type
             * @param {Function} callback
             * @param {Boolean} useCapture
             * @return {Object}
             */
            function delegate(elements, selector, type, callback, useCapture) {
              // Handle the regular Element usage
              if (typeof elements.addEventListener === 'function') {
                return _delegate.apply(null, arguments);
              }

              // Handle Element-less usage, it defaults to global delegation
              if (typeof type === 'function') {
                // Use `document` as the first parameter, then apply arguments
                // This is a short way to .unshift `arguments` without running into deoptimizations
                return _delegate.bind(null, document).apply(null, arguments);
              }

              // Handle Selector-based usage
              if (typeof elements === 'string') {
                elements = document.querySelectorAll(elements);
              }

              // Handle Array-like based usage
              return Array.prototype.map.call(elements, function (element) {
                return _delegate(element, selector, type, callback, useCapture);
              });
            }

            /**
             * Finds closest match and invokes callback.
             *
             * @param {Element} element
             * @param {String} selector
             * @param {String} type
             * @param {Function} callback
             * @return {Function}
             */
            function listener(element, selector, type, callback) {
              return function (e) {
                e.delegateTarget = closest(e.target, selector);
                if (e.delegateTarget) {
                  callback.call(element, e);
                }
              };
            }
            module.exports = delegate;

            /***/
          }),
          /***/879: (/***/function _(__unused_webpack_module, exports) {
            /**
             * Check if argument is a HTML element.
             *
             * @param {Object} value
             * @return {Boolean}
             */
            exports.node = function (value) {
              return value !== undefined && value instanceof HTMLElement && value.nodeType === 1;
            };

            /**
             * Check if argument is a list of HTML elements.
             *
             * @param {Object} value
             * @return {Boolean}
             */
            exports.nodeList = function (value) {
              var type = Object.prototype.toString.call(value);
              return value !== undefined && (type === '[object NodeList]' || type === '[object HTMLCollection]') && 'length' in value && (value.length === 0 || exports.node(value[0]));
            };

            /**
             * Check if argument is a string.
             *
             * @param {Object} value
             * @return {Boolean}
             */
            exports.string = function (value) {
              return typeof value === 'string' || value instanceof String;
            };

            /**
             * Check if argument is a function.
             *
             * @param {Object} value
             * @return {Boolean}
             */
            exports.fn = function (value) {
              var type = Object.prototype.toString.call(value);
              return type === '[object Function]';
            };

            /***/
          }),
          /***/370: (/***/function _(module, __unused_webpack_exports, __webpack_require__) {
            var is = __webpack_require__(879);
            var delegate = __webpack_require__(438);

            /**
             * Validates all params and calls the right
             * listener function based on its target type.
             *
             * @param {String|HTMLElement|HTMLCollection|NodeList} target
             * @param {String} type
             * @param {Function} callback
             * @return {Object}
             */
            function listen(target, type, callback) {
              if (!target && !type && !callback) {
                throw new Error('Missing required arguments');
              }
              if (!is.string(type)) {
                throw new TypeError('Second argument must be a String');
              }
              if (!is.fn(callback)) {
                throw new TypeError('Third argument must be a Function');
              }
              if (is.node(target)) {
                return listenNode(target, type, callback);
              } else if (is.nodeList(target)) {
                return listenNodeList(target, type, callback);
              } else if (is.string(target)) {
                return listenSelector(target, type, callback);
              } else {
                throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
              }
            }

            /**
             * Adds an event listener to a HTML element
             * and returns a remove listener function.
             *
             * @param {HTMLElement} node
             * @param {String} type
             * @param {Function} callback
             * @return {Object}
             */
            function listenNode(node, type, callback) {
              node.addEventListener(type, callback);
              return {
                destroy: function destroy() {
                  node.removeEventListener(type, callback);
                }
              };
            }

            /**
             * Add an event listener to a list of HTML elements
             * and returns a remove listener function.
             *
             * @param {NodeList|HTMLCollection} nodeList
             * @param {String} type
             * @param {Function} callback
             * @return {Object}
             */
            function listenNodeList(nodeList, type, callback) {
              Array.prototype.forEach.call(nodeList, function (node) {
                node.addEventListener(type, callback);
              });
              return {
                destroy: function destroy() {
                  Array.prototype.forEach.call(nodeList, function (node) {
                    node.removeEventListener(type, callback);
                  });
                }
              };
            }

            /**
             * Add an event listener to a selector
             * and returns a remove listener function.
             *
             * @param {String} selector
             * @param {String} type
             * @param {Function} callback
             * @return {Object}
             */
            function listenSelector(selector, type, callback) {
              return delegate(document.body, selector, type, callback);
            }
            module.exports = listen;

            /***/
          }),
          /***/817: (/***/function _(module) {
            function select(element) {
              var selectedText;
              if (element.nodeName === 'SELECT') {
                element.focus();
                selectedText = element.value;
              } else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
                var isReadOnly = element.hasAttribute('readonly');
                if (!isReadOnly) {
                  element.setAttribute('readonly', '');
                }
                element.select();
                element.setSelectionRange(0, element.value.length);
                if (!isReadOnly) {
                  element.removeAttribute('readonly');
                }
                selectedText = element.value;
              } else {
                if (element.hasAttribute('contenteditable')) {
                  element.focus();
                }
                var selection = window.getSelection();
                var range = document.createRange();
                range.selectNodeContents(element);
                selection.removeAllRanges();
                selection.addRange(range);
                selectedText = selection.toString();
              }
              return selectedText;
            }
            module.exports = select;

            /***/
          }),
          /***/279: (/***/function _(module) {
            function E() {
              // Keep this empty so it's easier to inherit from
              // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
            }
            E.prototype = {
              on: function on(name, callback, ctx) {
                var e = this.e || (this.e = {});
                (e[name] || (e[name] = [])).push({
                  fn: callback,
                  ctx: ctx
                });
                return this;
              },
              once: function once(name, callback, ctx) {
                var self = this;
                function listener() {
                  self.off(name, listener);
                  callback.apply(ctx, arguments);
                }
                listener._ = callback;
                return this.on(name, listener, ctx);
              },
              emit: function emit(name) {
                var data = [].slice.call(arguments, 1);
                var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
                var i = 0;
                var len = evtArr.length;
                for (i; i < len; i++) {
                  evtArr[i].fn.apply(evtArr[i].ctx, data);
                }
                return this;
              },
              off: function off(name, callback) {
                var e = this.e || (this.e = {});
                var evts = e[name];
                var liveEvents = [];
                if (evts && callback) {
                  for (var i = 0, len = evts.length; i < len; i++) {
                    if (evts[i].fn !== callback && evts[i].fn._ !== callback) liveEvents.push(evts[i]);
                  }
                }

                // Remove event from queue to prevent memory leak
                // Suggested by https://github.com/lazd
                // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

                liveEvents.length ? e[name] = liveEvents : delete e[name];
                return this;
              }
            };
            module.exports = E;
            module.exports.TinyEmitter = E;

            /***/
          })

          /******/
        };
        /************************************************************************/
        /******/ // The module cache
        /******/
        var __webpack_module_cache__ = {};
        /******/
        /******/ // The require function
        /******/
        function __webpack_require__(moduleId) {
          /******/ // Check if module is in cache
          /******/if (__webpack_module_cache__[moduleId]) {
            /******/return __webpack_module_cache__[moduleId].exports;
            /******/
          }
          /******/ // Create a new module (and put it into the cache)
          /******/
          var module = __webpack_module_cache__[moduleId] = {
            /******/ // no module.id needed
            /******/ // no module.loaded needed
            /******/exports: {}
            /******/
          };
          /******/
          /******/ // Execute the module function
          /******/
          __webpack_modules__[moduleId](module, module.exports, __webpack_require__);
          /******/
          /******/ // Return the exports of the module
          /******/
          return module.exports;
          /******/
        }
        /******/
        /************************************************************************/
        /******/ /* webpack/runtime/compat get default export */
        /******/
        !function () {
          /******/ // getDefaultExport function for compatibility with non-harmony modules
          /******/__webpack_require__.n = function (module) {
            /******/var getter = module && module.__esModule ? /******/function () {
              return module['default'];
            } : /******/function () {
              return module;
            };
            /******/
            __webpack_require__.d(getter, {
              a: getter
            });
            /******/
            return getter;
            /******/
          };
          /******/
        }();
        /******/
        /******/ /* webpack/runtime/define property getters */
        /******/
        !function () {
          /******/ // define getter functions for harmony exports
          /******/__webpack_require__.d = function (exports, definition) {
            /******/for (var key in definition) {
              /******/if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
                /******/Object.defineProperty(exports, key, {
                  enumerable: true,
                  get: definition[key]
                });
                /******/
              }
              /******/
            }
            /******/
          };
          /******/
        }();
        /******/
        /******/ /* webpack/runtime/hasOwnProperty shorthand */
        /******/
        !function () {
          /******/__webpack_require__.o = function (obj, prop) {
            return Object.prototype.hasOwnProperty.call(obj, prop);
          };
          /******/
        }();
        /******/
        /************************************************************************/
        /******/ // module exports must be returned from runtime so entry inlining is disabled
        /******/ // startup
        /******/ // Load entry module and return exports
        /******/
        return __webpack_require__(686);
        /******/
      }()["default"];
    });
  });
  var clipboard$1 = /*@__PURE__*/getDefaultExportFromCjs(clipboard);

  function copyText(_text) {
    var div = document.createElement("div");
    var clip = new clipboard$1(div, {
      text: function text() {
        return _text;
      }
    });
    div.click();
    clip.destroy();
    div.remove();
  }

  var THEME_LIST = ["info", "success", "warning", "error", "question", "loading"];
  var DISTANCE$1 = "32px";
  var PLACEMENT_OFFSET$1 = {
    top: {
      top: DISTANCE$1,
      left: "50%",
      transform: "translateX(-50%)"
    },
    center: {
      left: "50%",
      top: "50%",
      transform: "translateX(-50%) translateY(-50%)"
    },
    left: {
      left: DISTANCE$1,
      top: "50%",
      transform: "translateY(-50%)"
    },
    bottom: {
      bottom: DISTANCE$1,
      left: "50%",
      transform: "translateX(-50%)"
    },
    right: {
      right: DISTANCE$1,
      top: "50%",
      transform: "translateY(-50%)",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end"
    },
    "top-left": {
      left: DISTANCE$1,
      top: DISTANCE$1
    },
    "top-right": {
      right: DISTANCE$1,
      top: DISTANCE$1,
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end"
    },
    "bottom-right": {
      right: DISTANCE$1,
      bottom: DISTANCE$1,
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end"
    },
    "bottom-left": {
      left: DISTANCE$1,
      bottom: DISTANCE$1
    }
  };
  var PLACEMENT_LIST = Object.keys(PLACEMENT_OFFSET$1);

  var props$1d = {
    closeBtn: {
      type: [String, Boolean, Function],
      "default": void 0
    },
    content: {
      type: [String, Function]
    },
    duration: {
      type: Number,
      "default": 3e3
    },
    icon: {
      type: [Boolean, Function],
      "default": true
    },
    theme: {
      type: String,
      "default": "info",
      validator: function validator(val) {
        if (!val) return true;
        return ["info", "success", "warning", "error", "question", "loading"].includes(val);
      }
    },
    onClose: Function,
    onCloseBtnClick: Function,
    onDurationEnd: Function
  };

  var ANIMATION_OPTION = {
    duration: 200,
    easing: "linear"
  };
  function fadeIn(dom, placement) {
    if (!dom) return;
    var offsetWidth = (dom === null || dom === void 0 ? void 0 : dom.offsetWidth) || 0;
    var offsetHeight = (dom === null || dom === void 0 ? void 0 : dom.offsetHeight) || 0;
    var fadeInKeyframes = getFadeInKeyframes(placement, offsetWidth, offsetHeight);
    if (!fadeInKeyframes) return;
    var styleAfterFadeIn = fadeInKeyframes[fadeInKeyframes.length - 1];
    setDomStyleAfterAnimation(dom, styleAfterFadeIn);
    dom.animate && dom.animate(fadeInKeyframes, ANIMATION_OPTION);
  }
  function fadeOut(dom, placement, onFinish) {
    if (!dom) return;
    var offsetHeight = (dom === null || dom === void 0 ? void 0 : dom.offsetHeight) || 0;
    var fadeOutKeyframes = getFadeOutKeyframes(placement, offsetHeight);
    if (!fadeOutKeyframes) return onFinish();
    var styleAfterFadeOut = fadeOutKeyframes[fadeOutKeyframes.length - 1];
    setDomStyleAfterAnimation(dom, styleAfterFadeOut);
    var animation = dom.animate && dom.animate(fadeOutKeyframes, ANIMATION_OPTION);
    if (animation) {
      animation.onfinish = function () {
        dom.style.display = "none";
        onFinish();
      };
    } else {
      dom.style.display = "none";
      onFinish();
    }
  }
  function setDomStyleAfterAnimation(dom, styleAfterAnimation) {
    var keys = Object.keys(styleAfterAnimation);
    for (var i = 0; i < keys.length; i += 1) {
      var key = keys[i];
      dom.style[key] = styleAfterAnimation[key];
    }
  }
  function getFadeInKeyframes(placement, offsetWidth, offsetHeight) {
    if (!PLACEMENT_LIST.includes(placement)) return null;
    if (["top-left", "left", "bottom-left"].includes(placement)) {
      return [{
        opacity: 0,
        marginLeft: "-".concat(offsetWidth, "px")
      }, {
        opacity: 1,
        marginLeft: "0"
      }];
    }
    if (["top-right", "right", "bottom-right"].includes(placement)) {
      return [{
        opacity: 0,
        marginRight: "-".concat(offsetWidth, "px")
      }, {
        opacity: 1,
        marginRight: "0"
      }];
    }
    if (["top", "center"].includes(placement)) {
      return [{
        opacity: 0,
        marginTop: "-".concat(offsetHeight, "px")
      }, {
        opacity: 1,
        marginTop: "0"
      }];
    }
    if (["bottom"].includes(placement)) {
      return [{
        opacity: 0,
        transform: "translate3d(0, ".concat(offsetHeight, "px, 0)")
      }, {
        opacity: 1,
        transform: "translate3d(0, 0, 0)"
      }];
    }
  }
  function getFadeOutKeyframes(placement, offsetHeight) {
    if (!PLACEMENT_LIST.includes(placement)) return null;
    if (["bottom-left", "bottom", "bottom-right"].includes(placement)) {
      var marginOffset2 = "".concat(offsetHeight, "px");
      return [{
        opacity: 1,
        marginTop: "0px"
      }, {
        opacity: 0,
        marginTop: marginOffset2
      }];
    }
    var marginOffset = "-".concat(offsetHeight, "px");
    return [{
      opacity: 1,
      marginTop: "0px"
    }, {
      opacity: 0,
      marginTop: marginOffset
    }];
  }

  function ownKeys$2L(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2K(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2L(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2L(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$z = getClassPrefixMixins("message");
  var _Message = mixins(classPrefixMixins$z, getGlobalIconMixins()).extend({
    name: "TMessage",
    props: _objectSpread$2K(_objectSpread$2K({}, props$1d), {}, {
      placement: String
    }),
    data: function data() {
      return {
        timer: null
      };
    },
    computed: {
      classes: function classes() {
        var _this = this;
        var status = {};
        THEME_LIST.forEach(function (t) {
          status["".concat(_this.classPrefix, "-is-").concat(t)] = _this.theme === t;
        });
        return [this.componentName, status, _defineProperty$2({}, "".concat(this.classPrefix, "-is-closable"), this.closeBtn || this.$scopedSlots.closeBtn)];
      }
    },
    created: function created() {
      this.duration && this.setTimer();
    },
    mounted: function mounted() {
      var msgDom = this.$refs.msg;
      fadeIn(msgDom, this.$props.placement);
    },
    methods: {
      setTimer: function setTimer() {
        var _this2 = this;
        if (!this.duration) {
          return;
        }
        this.timer = Number(setTimeout(function () {
          var _this2$onDurationEnd, _this2$onClose;
          _this2.clearTimer();
          var msgDom = _this2.$refs.msg;
          fadeOut(msgDom, _this2.$props.placement, function () {
            _this2.$emit("duration-end");
            _this2.$emit("close");
          });
          (_this2$onDurationEnd = _this2.onDurationEnd) === null || _this2$onDurationEnd === void 0 || _this2$onDurationEnd.call(_this2);
          (_this2$onClose = _this2.onClose) === null || _this2$onClose === void 0 || _this2$onClose.call(_this2, {
            trigger: "duration-end"
          });
        }, this.duration));
      },
      clearTimer: function clearTimer() {
        this.duration && clearTimeout(this.timer);
      },
      close: function close(e) {
        var _this$onCloseBtnClick, _this$onClose;
        this.$emit("close-btn-click", {
          e: e
        });
        this.$emit("close");
        (_this$onCloseBtnClick = this.onCloseBtnClick) === null || _this$onCloseBtnClick === void 0 || _this$onCloseBtnClick.call(this, {
          e: e
        });
        (_this$onClose = this.onClose) === null || _this$onClose === void 0 || _this$onClose.call(this, {
          trigger: "close-click",
          e: e
        });
      },
      renderClose: function renderClose() {
        var h = this.$createElement;
        var _this$useGlobalIcon = this.useGlobalIcon({
            CloseIcon: TdCloseIcon
          }),
          CloseIcon = _this$useGlobalIcon.CloseIcon;
        var defaultClose = h(CloseIcon);
        return h("span", {
          "class": "".concat(this.componentName, "__close"),
          "on": {
            "click": this.close
          }
        }, [renderTNodeJSX(this, "closeBtn", defaultClose)]);
      },
      renderIcon: function renderIcon() {
        var h = this.$createElement;
        if (this.icon === false) return;
        if (typeof this.icon === "function") return this.icon(this.$createElement);
        if (this.$scopedSlots.icon) {
          return this.$scopedSlots.icon(null);
        }
        var _this$useGlobalIcon2 = this.useGlobalIcon({
            InfoCircleFilledIcon: TdInfoCircleFilledIcon,
            CheckCircleFilledIcon: TdCheckCircleFilledIcon,
            ErrorCircleFilledIcon: TdErrorCircleFilledIcon,
            HelpCircleFilledIcon: TdHelpCircleFilledIcon
          }),
          InfoCircleFilledIcon = _this$useGlobalIcon2.InfoCircleFilledIcon,
          CheckCircleFilledIcon = _this$useGlobalIcon2.CheckCircleFilledIcon,
          ErrorCircleFilledIcon = _this$useGlobalIcon2.ErrorCircleFilledIcon,
          HelpCircleFilledIcon = _this$useGlobalIcon2.HelpCircleFilledIcon;
        var component = {
          info: InfoCircleFilledIcon,
          success: CheckCircleFilledIcon,
          warning: ErrorCircleFilledIcon,
          error: ErrorCircleFilledIcon,
          question: HelpCircleFilledIcon,
          loading: Loading
        }[this.theme];
        return h(component);
      }
    },
    render: function render() {
      var h = arguments[0];
      return h("div", {
        "ref": "msg",
        "class": this.classes,
        "on": {
          "mouseenter": this.clearTimer,
          "mouseleave": this.setTimer
        }
      }, [this.renderIcon(), renderContent(this, "default", "content"), this.renderClose()]);
    }
  });

  function ownKeys$2K(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2J(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2K(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2K(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$y = getClassPrefixMixins("message__list");
  var DEFAULT_Z_INDEX$1 = 5e3;
  var getUniqueId = function () {
    var id = 0;
    return function () {
      id += 1;
      return id;
    };
  }();
  var MessageList = mixins(classPrefixMixins$y).extend({
    name: "TMessageList",
    components: {
      TMessage: _Message
    },
    props: {
      zIndex: Number,
      placement: String
    },
    data: function data() {
      return {
        list: []
      };
    },
    computed: {
      styles: function styles() {
        return _objectSpread$2J(_objectSpread$2J({}, PLACEMENT_OFFSET$1[this.placement]), {}, {
          zIndex: this.zIndex !== DEFAULT_Z_INDEX$1 ? this.zIndex : DEFAULT_Z_INDEX$1
        });
      }
    },
    methods: {
      add: function add(msg) {
        var mg = _objectSpread$2J(_objectSpread$2J({}, msg), {}, {
          key: getUniqueId(),
          placement: this.placement
        });
        this.list.push(mg);
        return this.list.length - 1;
      },
      remove: function remove(index) {
        this.list.splice(index, 1);
      },
      removeAll: function removeAll() {
        this.list = [];
      },
      getOffset: function getOffset(val) {
        if (!val) return;
        return isNaN(Number(val)) ? val : "".concat(val, "px");
      },
      msgStyles: function msgStyles(item) {
        return item.offset ? _objectSpread$2J({
          position: "relative",
          left: this.getOffset(item.offset[0]),
          top: this.getOffset(item.offset[1])
        }, item.style) : item.style;
      },
      getListeners: function getListeners(index) {
        var _this = this;
        return {
          "close-btn-click": function closeBtnClick() {
            return _this.remove(index);
          },
          "duration-end": function durationEnd() {
            return _this.remove(index);
          }
        };
      }
    },
    render: function render() {
      var _this2 = this;
      var h = arguments[0];
      if (!this.list.length) return;
      return h("div", {
        "class": this.componentName,
        "style": this.styles
      }, [this.list.map(function (item, index) {
        return h("t-message", {
          "key": item.key,
          "style": _this2.msgStyles(item),
          "class": item.className,
          "props": _objectSpread$2J({}, item),
          "on": _objectSpread$2J({}, _this2.getListeners(index))
        });
      })]);
    }
  });

  function ownKeys$2J(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2I(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2J(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2J(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var instanceMap$1 = /* @__PURE__ */new Map();
  var defaultMessageOptions = {
    duration: 3e3,
    attach: "body",
    zIndex: DEFAULT_Z_INDEX$1,
    placement: "top"
  };
  function handleParams(params) {
    var options = _objectSpread$2I(_objectSpread$2I({}, defaultMessageOptions), params);
    options.content = params.content;
    return options;
  }
  var MessageFunction = function MessageFunction(props) {
    var options = handleParams(props);
    var attach = options.attach,
      placement = options.placement;
    var attachDom = getAttach(attach);
    if (!instanceMap$1.get(attachDom)) {
      instanceMap$1.set(attachDom, {});
    }
    var p = instanceMap$1.get(attachDom)[placement];
    if (!p || !attachDom.contains(p.$el)) {
      var instance = new MessageList({
        propsData: {
          zIndex: options.zIndex,
          placement: options.placement
        }
      }).$mount();
      instance.add(options);
      instanceMap$1.get(attachDom)[placement] = instance;
      attachDom.appendChild(instance.$el);
    } else {
      p.add(options);
    }
    return new Promise(function (resolve) {
      var ins = instanceMap$1.get(attachDom)[placement];
      ins.$nextTick(function () {
        var msg = ins.$children;
        resolve(msg[msg.length - 1]);
      });
    });
  };
  var showThemeMessage = function showThemeMessage(theme, params, duration) {
    var options = {
      theme: theme
    };
    if (typeof params === "string") {
      options.content = params;
    } else if (_typeof$2(params) === "object" && !(params instanceof Array)) {
      options = _objectSpread$2I(_objectSpread$2I({}, options), params);
    }
    (duration || duration === 0) && (options.duration = duration);
    return MessageFunction(options);
  };
  var setMessageConfig = function setMessageConfig(_ref) {
    var placement = _ref.placement,
      attach = _ref.attach,
      offset = _ref.offset,
      zIndex = _ref.zIndex;
    attach && (defaultMessageOptions.attach = attach);
    offset && (defaultMessageOptions.offset = offset);
    placement && (defaultMessageOptions.placement = placement);
    zIndex && (defaultMessageOptions.zIndex = zIndex);
  };
  var extraApi$2 = {
    info: function info(params, duration) {
      return showThemeMessage("info", params, duration);
    },
    success: function success(params, duration) {
      return showThemeMessage("success", params, duration);
    },
    warning: function warning(params, duration) {
      return showThemeMessage("warning", params, duration);
    },
    error: function error(params, duration) {
      return showThemeMessage("error", params, duration);
    },
    question: function question(params, duration) {
      return showThemeMessage("question", params, duration);
    },
    loading: function loading(params, duration) {
      return showThemeMessage("loading", params, duration);
    },
    close: function close(promise) {
      promise.then(function (instance) {
        return instance.close();
      });
    },
    closeAll: function closeAll() {
      if (instanceMap$1 instanceof Map) {
        instanceMap$1.forEach(function (attach) {
          Object.keys(attach).forEach(function (placement) {
            var instance = attach[placement];
            instance.list = [];
          });
        });
      }
    },
    config: setMessageConfig
  };
  var MessagePlugin = showThemeMessage;
  Object.keys(extraApi$2).forEach(function (funcName) {
    MessagePlugin[funcName] = extraApi$2[funcName];
  });
  MessagePlugin.install = function () {
    Vue__default["default"].prototype.$message = MessagePlugin;
  };
  var message = MessagePlugin;

  var props$1c = {
    id: {
      type: String,
      "default": "",
      required: true
    },
    tag: {
      type: String,
      "default": "div"
    }
  };

  var top = 'top';
  var bottom = 'bottom';
  var right = 'right';
  var left = 'left';
  var auto = 'auto';
  var basePlacements = [top, bottom, right, left];
  var start = 'start';
  var end = 'end';
  var clippingParents = 'clippingParents';
  var viewport = 'viewport';
  var popper = 'popper';
  var reference = 'reference';
  var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
    return acc.concat([placement + "-" + start, placement + "-" + end]);
  }, []);
  var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
    return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
  }, []); // modifiers that need to read the DOM

  var beforeRead = 'beforeRead';
  var read = 'read';
  var afterRead = 'afterRead'; // pure-logic modifiers

  var beforeMain = 'beforeMain';
  var main = 'main';
  var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

  var beforeWrite = 'beforeWrite';
  var write = 'write';
  var afterWrite = 'afterWrite';
  var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

  function getNodeName(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
  }

  function getWindow(node) {
    if (node == null) {
      return window;
    }
    if (node.toString() !== '[object Window]') {
      var ownerDocument = node.ownerDocument;
      return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
  }

  function isElement(node) {
    var OwnElement = getWindow(node).Element;
    return node instanceof OwnElement || node instanceof Element;
  }
  function isHTMLElement(node) {
    var OwnElement = getWindow(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
  }
  function isShadowRoot(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') {
      return false;
    }
    var OwnElement = getWindow(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
  }

  // and applies them to the HTMLElements such as popper and arrow

  function applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function (name) {
      var style = state.styles[name] || {};
      var attributes = state.attributes[name] || {};
      var element = state.elements[name]; // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      } // Flow doesn't support to extend this property, but it's the most
      // effective way to apply styles to an HTMLElement
      // $FlowFixMe[cannot-write]

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (name) {
        var value = attributes[name];
        if (value === false) {
          element.removeAttribute(name);
        } else {
          element.setAttribute(name, value === true ? '' : value);
        }
      });
    });
  }
  function effect$2(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
      popper: {
        position: state.options.strategy,
        left: '0',
        top: '0',
        margin: '0'
      },
      arrow: {
        position: 'absolute'
      },
      reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) {
      Object.assign(state.elements.arrow.style, initialStyles.arrow);
    }
    return function () {
      Object.keys(state.elements).forEach(function (name) {
        var element = state.elements[name];
        var attributes = state.attributes[name] || {};
        var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

        var style = styleProperties.reduce(function (style, property) {
          style[property] = '';
          return style;
        }, {}); // arrow is optional + virtual elements

        if (!isHTMLElement(element) || !getNodeName(element)) {
          return;
        }
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function (attribute) {
          element.removeAttribute(attribute);
        });
      });
    };
  } // eslint-disable-next-line import/no-unused-modules

  var applyStyles$1 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: applyStyles,
    effect: effect$2,
    requires: ['computeStyles']
  };

  function getBasePlacement(placement) {
    return placement.split('-')[0];
  }

  var max = Math.max;
  var min$1 = Math.min;
  var round = Math.round;

  function getUAString() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
      return uaData.brands.map(function (item) {
        return item.brand + "/" + item.version;
      }).join(' ');
    }
    return navigator.userAgent;
  }

  function isLayoutViewport() {
    return !/^((?!chrome|android).)*safari/i.test(getUAString());
  }

  function getBoundingClientRect(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) {
      includeScale = false;
    }
    if (isFixedStrategy === void 0) {
      isFixedStrategy = false;
    }
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && isHTMLElement(element)) {
      scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
      scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = isElement(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;
    var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
      width: width,
      height: height,
      top: y,
      right: x + width,
      bottom: y + height,
      left: x,
      x: x,
      y: y
    };
  }

  // means it doesn't take into account transforms.

  function getLayoutRect(element) {
    var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223

    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) {
      width = clientRect.width;
    }
    if (Math.abs(clientRect.height - height) <= 1) {
      height = clientRect.height;
    }
    return {
      x: element.offsetLeft,
      y: element.offsetTop,
      width: width,
      height: height
    };
  }

  function contains(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

    if (parent.contains(child)) {
      return true;
    } // then fallback to custom implementation with Shadow DOM support
    else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;
      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...

        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false

    return false;
  }

  function getComputedStyle$1(element) {
    return getWindow(element).getComputedStyle(element);
  }

  function isTableElement(element) {
    return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
  }

  function getDocumentElement(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return ((isElement(element) ? element.ownerDocument :
    // $FlowFixMe[prop-missing]
    element.document) || window.document).documentElement;
  }

  function getParentNode(element) {
    if (getNodeName(element) === 'html') {
      return element;
    }
    return (
      // this is a quicker (but less type safe) way to save quite some bytes from the bundle
      // $FlowFixMe[incompatible-return]
      // $FlowFixMe[prop-missing]
      element.assignedSlot ||
      // step into the shadow DOM of the parent of a slotted node
      element.parentNode || (
      // DOM Element detected
      isShadowRoot(element) ? element.host : null) ||
      // ShadowRoot detected
      // $FlowFixMe[incompatible-call]: HTMLElement is a Node
      getDocumentElement(element) // fallback
    );
  }

  function getTrueOffsetParent(element) {
    if (!isHTMLElement(element) ||
    // https://github.com/popperjs/popper-core/issues/837
    getComputedStyle$1(element).position === 'fixed') {
      return null;
    }
    return element.offsetParent;
  } // `.offsetParent` reports `null` for fixed elements, while absolute elements
  // return the containing block

  function getContainingBlock(element) {
    var isFirefox = /firefox/i.test(getUAString());
    var isIE = /Trident/i.test(getUAString());
    if (isIE && isHTMLElement(element)) {
      // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
      var elementCss = getComputedStyle$1(element);
      if (elementCss.position === 'fixed') {
        return null;
      }
    }
    var currentNode = getParentNode(element);
    if (isShadowRoot(currentNode)) {
      currentNode = currentNode.host;
    }
    while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
      var css = getComputedStyle$1(currentNode); // This is non-exhaustive but covers the most common CSS properties that
      // create a containing block.
      // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

      if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
        return currentNode;
      } else {
        currentNode = currentNode.parentNode;
      }
    }
    return null;
  } // Gets the closest ancestor positioned element. Handles some edge cases,
  // such as table ancestors and cross browser bugs.

  function getOffsetParent(element) {
    var window = getWindow(element);
    var offsetParent = getTrueOffsetParent(element);
    while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
      offsetParent = getTrueOffsetParent(offsetParent);
    }
    if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static')) {
      return window;
    }
    return offsetParent || getContainingBlock(element) || window;
  }

  function getMainAxisFromPlacement(placement) {
    return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
  }

  function within(min, value, max$1) {
    return max(min, min$1(value, max$1));
  }
  function withinMaxClamp(min, value, max) {
    var v = within(min, value, max);
    return v > max ? max : v;
  }

  function getFreshSideObject() {
    return {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    };
  }

  function mergePaddingObject(paddingObject) {
    return Object.assign({}, getFreshSideObject(), paddingObject);
  }

  function expandToHashMap(value, keys) {
    return keys.reduce(function (hashMap, key) {
      hashMap[key] = value;
      return hashMap;
    }, {});
  }

  var toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
      placement: state.placement
    })) : padding;
    return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  };
  function arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = getBasePlacement(state.placement);
    var axis = getMainAxisFromPlacement(basePlacement);
    var isVertical = [left, right].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) {
      return;
    }
    var paddingObject = toPaddingObject(options.padding, state);
    var arrowRect = getLayoutRect(arrowElement);
    var minProp = axis === 'y' ? top : left;
    var maxProp = axis === 'y' ? bottom : right;
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = getOffsetParent(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds

    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = within(min, center, max); // Prevents breaking syntax highlighting...

    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
  }
  function effect$1(_ref2) {
    var state = _ref2.state,
      options = _ref2.options;
    var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) {
      return;
    } // CSS selector

    if (typeof arrowElement === 'string') {
      arrowElement = state.elements.popper.querySelector(arrowElement);
      if (!arrowElement) {
        return;
      }
    }
    if (!contains(state.elements.popper, arrowElement)) {
      return;
    }
    state.elements.arrow = arrowElement;
  } // eslint-disable-next-line import/no-unused-modules

  var arrow$1 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: arrow,
    effect: effect$1,
    requires: ['popperOffsets'],
    requiresIfExists: ['preventOverflow']
  };

  function getVariation(placement) {
    return placement.split('-')[1];
  }

  var unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
  }; // Round the offsets to the nearest suitable subpixel based on the DPR.
  // Zooming can change the DPR, but it seems to report a value that will
  // cleanly divide the values into the appropriate subpixels.

  function roundOffsetsByDPR(_ref, win) {
    var x = _ref.x,
      y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
      x: round(x * dpr) / dpr || 0,
      y: round(y * dpr) / dpr || 0
    };
  }
  function mapToStyles(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
      x: x,
      y: y
    }) : {
      x: x,
      y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = left;
    var sideY = top;
    var win = window;
    if (adaptive) {
      var offsetParent = getOffsetParent(popper);
      var heightProp = 'clientHeight';
      var widthProp = 'clientWidth';
      if (offsetParent === getWindow(popper)) {
        offsetParent = getDocumentElement(popper);
        if (getComputedStyle$1(offsetParent).position !== 'static' && position === 'absolute') {
          heightProp = 'scrollHeight';
          widthProp = 'scrollWidth';
        }
      } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it

      offsetParent = offsetParent;
      if (placement === top || (placement === left || placement === right) && variation === end) {
        sideY = bottom;
        var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height :
        // $FlowFixMe[prop-missing]
        offsetParent[heightProp];
        y -= offsetY - popperRect.height;
        y *= gpuAcceleration ? 1 : -1;
      }
      if (placement === left || (placement === top || placement === bottom) && variation === end) {
        sideX = right;
        var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width :
        // $FlowFixMe[prop-missing]
        offsetParent[widthProp];
        x -= offsetX - popperRect.width;
        x *= gpuAcceleration ? 1 : -1;
      }
    }
    var commonStyles = Object.assign({
      position: position
    }, adaptive && unsetSides);
    var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
      x: x,
      y: y
    }, getWindow(popper)) : {
      x: x,
      y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
      var _Object$assign;
      return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
  }
  function computeStyles(_ref5) {
    var state = _ref5.state,
      options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
      placement: getBasePlacement(state.placement),
      variation: getVariation(state.placement),
      popper: state.elements.popper,
      popperRect: state.rects.popper,
      gpuAcceleration: gpuAcceleration,
      isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) {
      state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
      })));
    }
    if (state.modifiersData.arrow != null) {
      state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
      })));
    }
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
      'data-popper-placement': state.placement
    });
  } // eslint-disable-next-line import/no-unused-modules

  var computeStyles$1 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: computeStyles,
    data: {}
  };

  var passive = {
    passive: true
  };
  function effect(_ref) {
    var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
    var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
    var window = getWindow(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, passive);
      });
    }
    if (resize) {
      window.addEventListener('resize', instance.update, passive);
    }
    return function () {
      if (scroll) {
        scrollParents.forEach(function (scrollParent) {
          scrollParent.removeEventListener('scroll', instance.update, passive);
        });
      }
      if (resize) {
        window.removeEventListener('resize', instance.update, passive);
      }
    };
  } // eslint-disable-next-line import/no-unused-modules

  var eventListeners = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: effect,
    data: {}
  };

  var hash$1 = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
  };
  function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function (matched) {
      return hash$1[matched];
    });
  }

  var hash = {
    start: 'end',
    end: 'start'
  };
  function getOppositeVariationPlacement(placement) {
    return placement.replace(/start|end/g, function (matched) {
      return hash[matched];
    });
  }

  function getWindowScroll(node) {
    var win = getWindow(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
      scrollLeft: scrollLeft,
      scrollTop: scrollTop
    };
  }

  function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
  }

  function getViewportRect(element, strategy) {
    var win = getWindow(element);
    var html = getDocumentElement(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
      width = visualViewport.width;
      height = visualViewport.height;
      var layoutViewport = isLayoutViewport();
      if (layoutViewport || !layoutViewport && strategy === 'fixed') {
        x = visualViewport.offsetLeft;
        y = visualViewport.offsetTop;
      }
    }
    return {
      width: width,
      height: height,
      x: x + getWindowScrollBarX(element),
      y: y
    };
  }

  // of the `<html>` and `<body>` rect bounds if horizontally scrollable

  function getDocumentRect(element) {
    var _element$ownerDocumen;
    var html = getDocumentElement(element);
    var winScroll = getWindowScroll(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
    var y = -winScroll.scrollTop;
    if (getComputedStyle$1(body || html).direction === 'rtl') {
      x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
    }
    return {
      width: width,
      height: height,
      x: x,
      y: y
    };
  }

  function isScrollParent(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = getComputedStyle$1(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
  }

  function getScrollParent$1(node) {
    if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
      // $FlowFixMe[incompatible-return]: assume body is always available
      return node.ownerDocument.body;
    }
    if (isHTMLElement(node) && isScrollParent(node)) {
      return node;
    }
    return getScrollParent$1(getParentNode(node));
  }

  /*
  given a DOM element, return the list of all scroll parents, up the list of ancesors
  until we get to the top window object. This list is what we attach scroll listeners
  to, because if any of these parent elements scroll, we'll need to re-calculate the
  reference element's position.
  */

  function listScrollParents(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) {
      list = [];
    }
    var scrollParent = getScrollParent$1(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = getWindow(scrollParent);
    var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList :
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    updatedList.concat(listScrollParents(getParentNode(target)));
  }

  function rectToClientRect(rect) {
    return Object.assign({}, rect, {
      left: rect.x,
      top: rect.y,
      right: rect.x + rect.width,
      bottom: rect.y + rect.height
    });
  }

  function getInnerBoundingClientRect(element, strategy) {
    var rect = getBoundingClientRect(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
  }
  function getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
  } // A "clipping parent" is an overflowable container with the characteristic of
  // clipping (or hiding) overflowing elements with a position different from
  // `initial`

  function getClippingParents(element) {
    var clippingParents = listScrollParents(getParentNode(element));
    var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$1(element).position) >= 0;
    var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
    if (!isElement(clipperElement)) {
      return [];
    } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414

    return clippingParents.filter(function (clippingParent) {
      return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
    });
  } // Gets the maximum area that the element is visible in due to any number of
  // clipping parents

  function getClippingRect(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
      var rect = getClientRectFromMixedType(element, clippingParent, strategy);
      accRect.top = max(rect.top, accRect.top);
      accRect.right = min$1(rect.right, accRect.right);
      accRect.bottom = min$1(rect.bottom, accRect.bottom);
      accRect.left = max(rect.left, accRect.left);
      return accRect;
    }, getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
  }

  function computeOffsets(_ref) {
    var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
    var basePlacement = placement ? getBasePlacement(placement) : null;
    var variation = placement ? getVariation(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch (basePlacement) {
      case top:
        offsets = {
          x: commonX,
          y: reference.y - element.height
        };
        break;
      case bottom:
        offsets = {
          x: commonX,
          y: reference.y + reference.height
        };
        break;
      case right:
        offsets = {
          x: reference.x + reference.width,
          y: commonY
        };
        break;
      case left:
        offsets = {
          x: reference.x - element.width,
          y: commonY
        };
        break;
      default:
        offsets = {
          x: reference.x,
          y: reference.y
        };
    }
    var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
    if (mainAxis != null) {
      var len = mainAxis === 'y' ? 'height' : 'width';
      switch (variation) {
        case start:
          offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
          break;
        case end:
          offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
          break;
      }
    }
    return offsets;
  }

  function detectOverflow(state, options) {
    if (options === void 0) {
      options = {};
    }
    var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
    var altContext = elementContext === popper ? reference : popper;
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = getBoundingClientRect(state.elements.reference);
    var popperOffsets = computeOffsets({
      reference: referenceClientRect,
      element: popperRect,
      strategy: 'absolute',
      placement: placement
    });
    var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect

    var overflowOffsets = {
      top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
      bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
      left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
      right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

    if (elementContext === popper && offsetData) {
      var offset = offsetData[placement];
      Object.keys(overflowOffsets).forEach(function (key) {
        var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
        var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
        overflowOffsets[key] += offset[axis] * multiply;
      });
    }
    return overflowOffsets;
  }

  function computeAutoPlacement(state, options) {
    if (options === void 0) {
      options = {};
    }
    var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
    var variation = getVariation(placement);
    var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
      return getVariation(placement) === variation;
    }) : basePlacements;
    var allowedPlacements = placements$1.filter(function (placement) {
      return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) {
      allowedPlacements = placements$1;
    } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...

    var overflows = allowedPlacements.reduce(function (acc, placement) {
      acc[placement] = detectOverflow(state, {
        placement: placement,
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding
      })[getBasePlacement(placement)];
      return acc;
    }, {});
    return Object.keys(overflows).sort(function (a, b) {
      return overflows[a] - overflows[b];
    });
  }

  function getExpandedFallbackPlacements(placement) {
    if (getBasePlacement(placement) === auto) {
      return [];
    }
    var oppositePlacement = getOppositePlacement(placement);
    return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
  }
  function flip$1(_ref) {
    var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
    if (state.modifiersData[name]._skip) {
      return;
    }
    var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = getBasePlacement(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
    var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
      return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
        placement: placement,
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        flipVariations: flipVariations,
        allowedAutoPlacements: allowedAutoPlacements
      }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for (var i = 0; i < placements.length; i++) {
      var placement = placements[i];
      var _basePlacement = getBasePlacement(placement);
      var isStartVariation = getVariation(placement) === start;
      var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
      var len = isVertical ? 'width' : 'height';
      var overflow = detectOverflow(state, {
        placement: placement,
        boundary: boundary,
        rootBoundary: rootBoundary,
        altBoundary: altBoundary,
        padding: padding
      });
      var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
      if (referenceRect[len] > popperRect[len]) {
        mainVariationSide = getOppositePlacement(mainVariationSide);
      }
      var altVariationSide = getOppositePlacement(mainVariationSide);
      var checks = [];
      if (checkMainAxis) {
        checks.push(overflow[_basePlacement] <= 0);
      }
      if (checkAltAxis) {
        checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
      }
      if (checks.every(function (check) {
        return check;
      })) {
        firstFittingPlacement = placement;
        makeFallbackChecks = false;
        break;
      }
      checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
      // `2` may be desired in some cases – research later
      var numberOfChecks = flipVariations ? 3 : 1;
      var _loop = function _loop(_i) {
        var fittingPlacement = placements.find(function (placement) {
          var checks = checksMap.get(placement);
          if (checks) {
            return checks.slice(0, _i).every(function (check) {
              return check;
            });
          }
        });
        if (fittingPlacement) {
          firstFittingPlacement = fittingPlacement;
          return "break";
        }
      };
      for (var _i = numberOfChecks; _i > 0; _i--) {
        var _ret = _loop(_i);
        if (_ret === "break") break;
      }
    }
    if (state.placement !== firstFittingPlacement) {
      state.modifiersData[name]._skip = true;
      state.placement = firstFittingPlacement;
      state.reset = true;
    }
  } // eslint-disable-next-line import/no-unused-modules

  var flip$2 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: flip$1,
    requiresIfExists: ['offset'],
    data: {
      _skip: false
    }
  };

  function getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) {
      preventedOffsets = {
        x: 0,
        y: 0
      };
    }
    return {
      top: overflow.top - rect.height - preventedOffsets.y,
      right: overflow.right - rect.width + preventedOffsets.x,
      bottom: overflow.bottom - rect.height + preventedOffsets.y,
      left: overflow.left - rect.width - preventedOffsets.x
    };
  }
  function isAnySideFullyClipped(overflow) {
    return [top, right, bottom, left].some(function (side) {
      return overflow[side] >= 0;
    });
  }
  function hide(_ref) {
    var state = _ref.state,
      name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = detectOverflow(state, {
      elementContext: 'reference'
    });
    var popperAltOverflow = detectOverflow(state, {
      altBoundary: true
    });
    var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
      referenceClippingOffsets: referenceClippingOffsets,
      popperEscapeOffsets: popperEscapeOffsets,
      isReferenceHidden: isReferenceHidden,
      hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
      'data-popper-reference-hidden': isReferenceHidden,
      'data-popper-escaped': hasPopperEscaped
    });
  } // eslint-disable-next-line import/no-unused-modules

  var hide$1 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: ['preventOverflow'],
    fn: hide
  };

  function distanceAndSkiddingToXY(placement, rects, offset) {
    var basePlacement = getBasePlacement(placement);
    var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
      })) : offset,
      skidding = _ref[0],
      distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [left, right].indexOf(basePlacement) >= 0 ? {
      x: distance,
      y: skidding
    } : {
      x: skidding,
      y: distance
    };
  }
  function offset(_ref2) {
    var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
    var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
    var data = placements.reduce(function (acc, placement) {
      acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
      return acc;
    }, {});
    var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
      state.modifiersData.popperOffsets.x += x;
      state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
  } // eslint-disable-next-line import/no-unused-modules

  var offset$1 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: ['popperOffsets'],
    fn: offset
  };

  function popperOffsets(_ref) {
    var state = _ref.state,
      name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = computeOffsets({
      reference: state.rects.reference,
      element: state.rects.popper,
      strategy: 'absolute',
      placement: state.placement
    });
  } // eslint-disable-next-line import/no-unused-modules

  var popperOffsets$1 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: popperOffsets,
    data: {}
  };

  function getAltAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
  }

  function preventOverflow(_ref) {
    var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
    var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = detectOverflow(state, {
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      altBoundary: altBoundary
    });
    var basePlacement = getBasePlacement(state.placement);
    var variation = getVariation(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = getMainAxisFromPlacement(basePlacement);
    var altAxis = getAltAxis(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
      placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
      mainAxis: tetherOffsetValue,
      altAxis: tetherOffsetValue
    } : Object.assign({
      mainAxis: 0,
      altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
      x: 0,
      y: 0
    };
    if (!popperOffsets) {
      return;
    }
    if (checkMainAxis) {
      var _offsetModifierState$;
      var mainSide = mainAxis === 'y' ? top : left;
      var altSide = mainAxis === 'y' ? bottom : right;
      var len = mainAxis === 'y' ? 'height' : 'width';
      var offset = popperOffsets[mainAxis];
      var min = offset + overflow[mainSide];
      var max$1 = offset - overflow[altSide];
      var additive = tether ? -popperRect[len] / 2 : 0;
      var minLen = variation === start ? referenceRect[len] : popperRect[len];
      var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
      // outside the reference bounds

      var arrowElement = state.elements.arrow;
      var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
        width: 0,
        height: 0
      };
      var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
      var arrowPaddingMin = arrowPaddingObject[mainSide];
      var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
      // to include its full size in the calculation. If the reference is small
      // and near the edge of a boundary, the popper can overflow even if the
      // reference is not overflowing as well (e.g. virtual elements with no
      // width or height)

      var arrowLen = within(0, referenceRect[len], arrowRect[len]);
      var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
      var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
      var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
      var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
      var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
      var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
      var tetherMax = offset + maxOffset - offsetModifierValue;
      var preventedOffset = within(tether ? min$1(min, tetherMin) : min, offset, tether ? max(max$1, tetherMax) : max$1);
      popperOffsets[mainAxis] = preventedOffset;
      data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
      var _offsetModifierState$2;
      var _mainSide = mainAxis === 'x' ? top : left;
      var _altSide = mainAxis === 'x' ? bottom : right;
      var _offset = popperOffsets[altAxis];
      var _len = altAxis === 'y' ? 'height' : 'width';
      var _min = _offset + overflow[_mainSide];
      var _max = _offset - overflow[_altSide];
      var isOriginSide = [top, left].indexOf(basePlacement) !== -1;
      var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
      var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
      var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
      var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
      popperOffsets[altAxis] = _preventedOffset;
      data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
  } // eslint-disable-next-line import/no-unused-modules

  var preventOverflow$1 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: preventOverflow,
    requiresIfExists: ['offset']
  };

  function getHTMLElementScroll(element) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }

  function getNodeScroll(node) {
    if (node === getWindow(node) || !isHTMLElement(node)) {
      return getWindowScroll(node);
    } else {
      return getHTMLElementScroll(node);
    }
  }

  function isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = round(rect.width) / element.offsetWidth || 1;
    var scaleY = round(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
  } // Returns the composite rect of an element relative to its offsetParent.
  // Composite means it takes into account transforms as well as layout.

  function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) {
      isFixed = false;
    }
    var isOffsetParentAnElement = isHTMLElement(offsetParent);
    var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
    var documentElement = getDocumentElement(offsetParent);
    var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
      scrollLeft: 0,
      scrollTop: 0
    };
    var offsets = {
      x: 0,
      y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
      if (getNodeName(offsetParent) !== 'body' ||
      // https://github.com/popperjs/popper-core/issues/1078
      isScrollParent(documentElement)) {
        scroll = getNodeScroll(offsetParent);
      }
      if (isHTMLElement(offsetParent)) {
        offsets = getBoundingClientRect(offsetParent, true);
        offsets.x += offsetParent.clientLeft;
        offsets.y += offsetParent.clientTop;
      } else if (documentElement) {
        offsets.x = getWindowScrollBarX(documentElement);
      }
    }
    return {
      x: rect.left + scroll.scrollLeft - offsets.x,
      y: rect.top + scroll.scrollTop - offsets.y,
      width: rect.width,
      height: rect.height
    };
  }

  function order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function (modifier) {
      map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively

    function sort(modifier) {
      visited.add(modifier.name);
      var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
      requires.forEach(function (dep) {
        if (!visited.has(dep)) {
          var depModifier = map.get(dep);
          if (depModifier) {
            sort(depModifier);
          }
        }
      });
      result.push(modifier);
    }
    modifiers.forEach(function (modifier) {
      if (!visited.has(modifier.name)) {
        // check for visited object
        sort(modifier);
      }
    });
    return result;
  }
  function orderModifiers(modifiers) {
    // order based on dependencies
    var orderedModifiers = order(modifiers); // order based on phase

    return modifierPhases.reduce(function (acc, phase) {
      return acc.concat(orderedModifiers.filter(function (modifier) {
        return modifier.phase === phase;
      }));
    }, []);
  }

  function debounce(fn) {
    var pending;
    return function () {
      if (!pending) {
        pending = new Promise(function (resolve) {
          Promise.resolve().then(function () {
            pending = undefined;
            resolve(fn());
          });
        });
      }
      return pending;
    };
  }

  function mergeByName(modifiers) {
    var merged = modifiers.reduce(function (merged, current) {
      var existing = merged[current.name];
      merged[current.name] = existing ? Object.assign({}, existing, current, {
        options: Object.assign({}, existing.options, current.options),
        data: Object.assign({}, existing.data, current.data)
      }) : current;
      return merged;
    }, {}); // IE11 does not support Object.values

    return Object.keys(merged).map(function (key) {
      return merged[key];
    });
  }

  var DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
  };
  function areValidElements() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return !args.some(function (element) {
      return !(element && typeof element.getBoundingClientRect === 'function');
    });
  }
  function popperGenerator(generatorOptions) {
    if (generatorOptions === void 0) {
      generatorOptions = {};
    }
    var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
      if (options === void 0) {
        options = defaultOptions;
      }
      var state = {
        placement: 'bottom',
        orderedModifiers: [],
        options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
        modifiersData: {},
        elements: {
          reference: reference,
          popper: popper
        },
        attributes: {},
        styles: {}
      };
      var effectCleanupFns = [];
      var isDestroyed = false;
      var instance = {
        state: state,
        setOptions: function setOptions(setOptionsAction) {
          var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
          cleanupModifierEffects();
          state.options = Object.assign({}, defaultOptions, state.options, options);
          state.scrollParents = {
            reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
            popper: listScrollParents(popper)
          }; // Orders the modifiers based on their dependencies and `phase`
          // properties

          var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

          state.orderedModifiers = orderedModifiers.filter(function (m) {
            return m.enabled;
          });
          runModifierEffects();
          return instance.update();
        },
        // Sync update – it will always be executed, even if not necessary. This
        // is useful for low frequency updates where sync behavior simplifies the
        // logic.
        // For high frequency updates (e.g. `resize` and `scroll` events), always
        // prefer the async Popper#update method
        forceUpdate: function forceUpdate() {
          if (isDestroyed) {
            return;
          }
          var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
          // anymore

          if (!areValidElements(reference, popper)) {
            return;
          } // Store the reference and popper rects to be read by modifiers

          state.rects = {
            reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
            popper: getLayoutRect(popper)
          }; // Modifiers have the ability to reset the current update cycle. The
          // most common use case for this is the `flip` modifier changing the
          // placement, which then needs to re-run all the modifiers, because the
          // logic was previously ran for the previous placement and is therefore
          // stale/incorrect

          state.reset = false;
          state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
          // is filled with the initial data specified by the modifier. This means
          // it doesn't persist and is fresh on each update.
          // To ensure persistent data, use `${name}#persistent`

          state.orderedModifiers.forEach(function (modifier) {
            return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
          });
          for (var index = 0; index < state.orderedModifiers.length; index++) {
            if (state.reset === true) {
              state.reset = false;
              index = -1;
              continue;
            }
            var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;
            if (typeof fn === 'function') {
              state = fn({
                state: state,
                options: _options,
                name: name,
                instance: instance
              }) || state;
            }
          }
        },
        // Async and optimistically optimized update – it will not be executed if
        // not necessary (debounced to run at most once-per-tick)
        update: debounce(function () {
          return new Promise(function (resolve) {
            instance.forceUpdate();
            resolve(state);
          });
        }),
        destroy: function destroy() {
          cleanupModifierEffects();
          isDestroyed = true;
        }
      };
      if (!areValidElements(reference, popper)) {
        return instance;
      }
      instance.setOptions(options).then(function (state) {
        if (!isDestroyed && options.onFirstUpdate) {
          options.onFirstUpdate(state);
        }
      }); // Modifiers have the ability to execute arbitrary code before the first
      // update cycle runs. They will be executed in the same order as the update
      // cycle. This is useful when a modifier adds some persistent data that
      // other modifiers need to use, but the modifier is run after the dependent
      // one.

      function runModifierEffects() {
        state.orderedModifiers.forEach(function (_ref) {
          var name = _ref.name,
            _ref$options = _ref.options,
            options = _ref$options === void 0 ? {} : _ref$options,
            effect = _ref.effect;
          if (typeof effect === 'function') {
            var cleanupFn = effect({
              state: state,
              name: name,
              instance: instance,
              options: options
            });
            var noopFn = function noopFn() {};
            effectCleanupFns.push(cleanupFn || noopFn);
          }
        });
      }
      function cleanupModifierEffects() {
        effectCleanupFns.forEach(function (fn) {
          return fn();
        });
        effectCleanupFns = [];
      }
      return instance;
    };
  }

  var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$2, preventOverflow$1, arrow$1, hide$1];
  var createPopper = /*#__PURE__*/popperGenerator({
    defaultModifiers: defaultModifiers
  }); // eslint-disable-next-line import/no-unused-modules

  var _excluded$7 = ["from", "to", "direction"];
  function ownKeys$2I(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2H(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2I(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2I(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function omit(obj, fields) {
    var shallowCopy = _objectSpread$2H({}, obj);
    for (var i = 0; i < fields.length; i++) {
      var key = fields[i];
      delete shallowCopy[key];
    }
    return shallowCopy;
  }
  function firstUpperCase$1(str) {
    return str.toLowerCase().replace(/( |^)[a-z]/g, function (_char) {
      return _char.toUpperCase();
    });
  }
  function getBackgroundColor(color) {
    if (typeof color === "string") {
      return color;
    }
    if (Array.isArray(color)) {
      if (color[0] && color[0][0] === "#") {
        color.unshift("90deg");
      }
      return "linear-gradient( ".concat(color.join(","), " )");
    }
    var from = color.from,
      to = color.to,
      _color$direction = color.direction,
      direction = _color$direction === void 0 ? "to right" : _color$direction,
      rest = _objectWithoutProperties$2(color, _excluded$7);
    var keys = Object.keys(rest);
    if (keys.length) {
      keys = keys.sort(function (a, b) {
        return parseFloat(a.substr(0, a.length - 1)) - parseFloat(b.substr(0, b.length - 1));
      });
      var tempArr = keys.map(function (key) {
        return "".concat(rest[key], " ").concat(key);
      });
      return "linear-gradient(".concat(direction, ", ").concat(tempArr.join(","), ")");
    }
    return "linear-gradient(".concat(direction, ", ").concat(from, ", ").concat(to, ")");
  }
  function getPropsApiByEvent(eventName) {
    return camelCase$1("on-".concat(eventName));
  }
  function getIEVersion() {
    var _navigator = navigator,
      userAgent = _navigator.userAgent;
    var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1;
    var isIE11 = userAgent.indexOf("Trident") > -1 && userAgent.indexOf("rv:11.0") > -1;
    if (isIE) {
      var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
      var match = userAgent.match(reIE);
      if (!match) return -1;
      var fIEVersion = parseFloat(match[1]);
      return fIEVersion < 7 ? 6 : fIEVersion;
    }
    if (isIE11) {
      return 11;
    }
    return Number.MAX_SAFE_INTEGER;
  }
  function getCharacterLength(str, maxCharacter) {
    var hasMaxCharacter = typeof maxCharacter === "number";
    if (!str || str.length === 0) {
      if (hasMaxCharacter) {
        return {
          length: 0,
          characters: str
        };
      }
      return 0;
    }
    var len = 0;
    for (var i = 0; i < str.length; i++) {
      var currentStringLength = 0;
      if (str.charCodeAt(i) > 127) {
        currentStringLength = 2;
      } else {
        currentStringLength = 1;
      }
      if (hasMaxCharacter && len + currentStringLength > maxCharacter) {
        return {
          length: len,
          characters: str.slice(0, i)
        };
      }
      len += currentStringLength;
    }
    if (hasMaxCharacter) {
      return {
        length: len,
        characters: str
      };
    }
    return len;
  }
  function pxCompat(param) {
    return typeof param === "number" ? "".concat(param, "px") : param;
  }
  function setTransform(value) {
    return {
      transform: value,
      "-ms-transform": value,
      "-moz-transform": value,
      "-webkit-transform": value
    };
  }
  function getVueComponentName(component) {
    var _component$options;
    return (component === null || component === void 0 || (_component$options = component.options) === null || _component$options === void 0 ? void 0 : _component$options.name) || (component === null || component === void 0 ? void 0 : component.name);
  }
  function getVNodeComponentName(vnode) {
    var _vnode$componentOptio;
    return vnode === null || vnode === void 0 || (_vnode$componentOptio = vnode.componentOptions) === null || _vnode$componentOptio === void 0 || (_vnode$componentOptio = _vnode$componentOptio.Ctor) === null || _vnode$componentOptio === void 0 || (_vnode$componentOptio = _vnode$componentOptio.options) === null || _vnode$componentOptio === void 0 ? void 0 : _vnode$componentOptio.name;
  }

  var popupProps = {
    attach: {
      type: [String, Function]
    },
    content: {
      type: [String, Function]
    },
    "default": {
      type: [String, Function]
    },
    delay: {
      type: [Number, Array]
    },
    destroyOnClose: Boolean,
    disabled: Boolean,
    hideEmptyPopup: Boolean,
    overlayClassName: {
      type: [String, Object, Array]
    },
    overlayInnerClassName: {
      type: [String, Object, Array]
    },
    overlayInnerStyle: {
      type: [Boolean, Object, Function]
    },
    overlayStyle: {
      type: [Boolean, Object, Function]
    },
    placement: {
      type: String,
      "default": "top"
    },
    popperOptions: {
      type: Object
    },
    showArrow: Boolean,
    trigger: {
      type: String,
      "default": "hover",
      validator: function validator(val) {
        if (!val) return true;
        return ["hover", "click", "focus", "mousedown", "context-menu"].includes(val);
      }
    },
    triggerElement: {
      type: [String, Function]
    },
    visible: {
      type: Boolean,
      "default": void 0
    },
    defaultVisible: Boolean,
    zIndex: {
      type: Number
    },
    onScroll: Function,
    onScrollToBottom: Function,
    onVisibleChange: Function
  };

  function isContentRectChanged(rect1, rect2) {
    if (!rect1 || !rect2) return;
    if (["width", "height", "x", "y"].some(function (k) {
      return rect1[k] !== rect2[k];
    })) {
      return true;
    }
    return false;
  }
  function observeResize(elm, cb) {
    var _window;
    if (!((_window = window) !== null && _window !== void 0 && _window.ResizeObserver) || !elm) return;
    var prevContentRect = null;
    var ro = new ResizeObserver(function () {
      var entries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var _ref = entries[0] || {},
        contentRect = _ref.contentRect;
      if (isContentRectChanged(contentRect, prevContentRect)) {
        prevContentRect = contentRect;
        cb(contentRect);
        return;
      }
      if (!prevContentRect) {
        prevContentRect = contentRect;
      }
    });
    ro.observe(elm);
    return function () {
      ro.unobserve(elm);
    };
  }
  var Trigger = Vue__default["default"].extend({
    data: function data() {
      return {
        contentRect: null
      };
    },
    mounted: function mounted() {
      var _process$env,
        _this = this;
      if (!this.$el || typeof process !== "undefined" && ((_process$env = process.env) === null || _process$env === void 0 ? void 0 : _process$env.NODE_ENV) === "test") return;
      this.$on("hook:destroyed", observeResize(this.$el, function (ev) {
        _this.$emit("resize", ev);
      }));
    },
    render: function render() {
      var _children$;
      var h = arguments[0];
      var children = this.$slots["default"] || [];
      if (children.length > 1 || !((_children$ = children[0]) !== null && _children$ !== void 0 && _children$.tag)) {
        return h("span", [children]);
      }
      return children[0];
    }
  });
  var Container$1 = Vue__default["default"].extend({
    props: {
      parent: Object,
      visible: Boolean,
      attach: [Function]
    },
    data: function data() {
      return {
        content: null
      };
    },
    mounted: function mounted() {
      var _this2 = this;
      if (this.visible) {
        raf_1(this.mountContent);
      }
      this.$watch("visible", function (visible) {
        if (visible) {
          _this2.mountContent();
        }
      });
    },
    destroyed: function destroyed() {
      var _process$env2;
      if (typeof process !== "undefined" && ((_process$env2 = process.env) === null || _process$env2 === void 0 ? void 0 : _process$env2.NODE_ENV) === "test") return;
      this.unmountContent();
    },
    methods: {
      mountContent: function mountContent() {
        var _this$$refs;
        if (this.content) return;
        var parent = this;
        var elm = document.createElement("div");
        elm.style.cssText = "position: absolute; top: 0px; left: 0px; width: 100%";
        elm.appendChild(document.createElement("div"));
        this.content = new this.$root.constructor({
          parent: parent,
          render: function render() {
            return parent.$slots.content;
          },
          mounted: function mounted() {
            parent.$emit("contentMounted");
            var content = this.$el.children[0];
            if (content) {
              this.$on("hook:destroyed", observeResize(content, function () {
                parent.$emit("resize");
              }));
            }
          },
          destroyed: function destroyed() {
            parent.content = null;
            removeDom(elm);
          }
        });
        var _this$attach = this.attach(),
          attach = _this$attach.attach,
          current = _this$attach.current;
        var currentAttach = attach === "CURRENT_NODE" ? current : attach;
        getAttach(currentAttach, (_this$$refs = this.$refs) === null || _this$$refs === void 0 || (_this$$refs = _this$$refs.triggerRef) === null || _this$$refs === void 0 ? void 0 : _this$$refs.$el).appendChild(elm);
        this.content.$mount(elm.children[0]);
      },
      unmountContent: function unmountContent() {
        var _this$content;
        if (isFunction((_this$content = this.content) === null || _this$content === void 0 ? void 0 : _this$content.$destroy)) {
          this.content.$destroy();
        }
      },
      updateContent: function updateContent() {
        var _this$content2;
        (_this$content2 = this.content) === null || _this$content2 === void 0 || _this$content2.$forceUpdate();
      }
    },
    render: function render() {
      var _this3 = this;
      var h = arguments[0];
      return h(Trigger, {
        "ref": "triggerRef",
        "on": {
          "resize": function resize() {
            return _this3.$emit("resize");
          }
        }
      }, [this.$slots["default"]]);
    }
  });

  function emitEvent$1(vm, eventName) {
    var emitEventName;
    var emitEventMethodName;
    if (typeof eventName === "string") {
      emitEventName = eventName;
      emitEventMethodName = getPropsApiByEvent(eventName);
    } else {
      emitEventName = eventName.event;
      emitEventMethodName = eventName.method;
    }
    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }
    if (vm.$listeners["".concat(emitEventName)]) {
      vm.$emit.apply(vm, [emitEventName].concat(args));
    }
    if (typeof vm.$props[emitEventMethodName] === "function") {
      var _vm$$props;
      (_vm$$props = vm.$props)[emitEventMethodName].apply(_vm$$props, args);
    }
  }

  var triggers = ["click", "hover", "focus", "context-menu"];
  var defaultVisibleDelay = [250, 150];
  function getPopperPlacement(placement) {
    return placement.replace(/-(left|top)$/, "-start").replace(/-(right|bottom)$/, "-end");
  }
  function attachListeners(elm) {
    var offs = [];
    return {
      add: function add(type, listener) {
        on$1(elm, type, listener);
        offs.push(function () {
          off$1(elm, type, listener);
        });
      },
      clean: function clean() {
        offs.forEach(function (handler) {
          return handler === null || handler === void 0 ? void 0 : handler();
        });
        offs.length = 0;
      }
    };
  }

  function ownKeys$2H(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2G(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2H(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2H(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$x = getClassPrefixMixins("popup");
  var injectionKey = "__T_POPUP";
  var Popup$1 = mixins(classPrefixMixins$x, getAttachConfigMixins("popup")).extend({
    name: "TPopup",
    provide: function provide() {
      return _defineProperty$2({}, injectionKey, this);
    },
    inject: {
      popup: {
        from: injectionKey,
        "default": void 0
      }
    },
    props: _objectSpread$2G(_objectSpread$2G({}, popupProps), {}, {
      expandAnimation: {
        type: Boolean
      },
      updateScrollTop: {
        type: Function
      }
    }),
    data: function data() {
      return {
        popper: null,
        timeout: null,
        hasDocumentEvent: false,
        visibleState: 0,
        mouseInRange: false,
        contentClicked: false,
        isLeaving: false
      };
    },
    computed: {
      overlayClasses: function overlayClasses() {
        return ["".concat(this.componentName, "__content"), _defineProperty$2(_defineProperty$2(_defineProperty$2({}, "".concat(this.componentName, "__content--text"), this.content === "string"), "".concat(this.componentName, "__content--arrow"), this.showArrow), this.commonStatusClassName.disabled, this.disabled), this.overlayInnerClassName];
      },
      hasTrigger: function hasTrigger() {
        var _this = this;
        return triggers.reduce(function (map, trigger) {
          return _objectSpread$2G(_objectSpread$2G({}, map), {}, _defineProperty$2({}, trigger, _this.trigger.includes(trigger)));
        }, {});
      },
      normalizedDelay: function normalizedDelay() {
        var _this$delay, _delay$;
        var delay = [].concat((_this$delay = this.delay) !== null && _this$delay !== void 0 ? _this$delay : defaultVisibleDelay);
        return {
          open: delay[0],
          close: (_delay$ = delay[1]) !== null && _delay$ !== void 0 ? _delay$ : delay[0]
        };
      },
      computeAttach: function computeAttach() {
        return this.attach || this.globalAttach();
      }
    },
    watch: {
      visible: function visible(_visible) {
        var _this2 = this;
        var hasTrigger = this.hasTrigger,
          triggerEl = this.$el;
        if (_visible) {
          this.preventClosing(true);
          if (!this.hasDocumentEvent) {
            on$1(document, "mousedown", this.handleDocumentClick, true);
            this.hasDocumentEvent = true;
          }
          if (triggerEl && hasTrigger.focus) {
            once(triggerEl, "keydown", function (ev) {
              if (ev.code === "Escape") {
                _this2.handleClose({
                  trigger: "keydown-esc"
                });
              }
            });
          }
          this.$nextTick(function () {
            _this2.popupMounted();
            _this2.updateOverlayInnerStyle();
          });
        } else {
          this.preventClosing(false);
          off$1(document, "mousedown", this.handleDocumentClick, true);
          this.hasDocumentEvent = false;
          this.mouseInRange = false;
        }
      },
      overlayInnerStyle: function overlayInnerStyle() {
        this.updateOverlayInnerStyle();
        this.updatePopper();
      },
      placement: function placement() {
        var _this$popper;
        (_this$popper = this.popper) === null || _this$popper === void 0 || _this$popper.destroy();
        this.popper = null;
        this.updatePopper();
      },
      contentClicked: function contentClicked(clicked) {
        if (this.popup) {
          this.popup.contentClicked = clicked;
        }
      }
    },
    mounted: function mounted() {
      var _this3 = this;
      var trigger = attachListeners(this.$el);
      var updateTrigger = function updateTrigger() {
        trigger.clean();
        var hasTrigger = _this3.hasTrigger;
        if (hasTrigger.hover) {
          trigger.add("mouseenter", function () {
            return _this3.handleOpen({
              trigger: "trigger-element-hover"
            });
          });
          trigger.add("mouseleave", function () {
            return _this3.handleClose({
              trigger: "trigger-element-hover"
            });
          });
        } else if (hasTrigger.focus) {
          trigger.add("focusin", function () {
            return _this3.handleOpen({
              trigger: "trigger-element-focus"
            });
          });
          trigger.add("focusout", function () {
            return _this3.handleClose({
              trigger: "trigger-element-blur"
            });
          });
        } else if (hasTrigger.click) {
          trigger.add("click", function (e) {
            _this3.handleToggle({
              e: e,
              trigger: "trigger-element-click"
            });
            if (getIEVersion() < 11) {
              _this3.handleDocumentClick(e);
            }
          });
        } else if (hasTrigger["context-menu"]) {
          trigger.add("contextmenu", function (e) {
            e.preventDefault();
            e.button === 2 && _this3.handleToggle({
              trigger: "context-menu"
            });
          });
        }
      };
      updateTrigger();
      this.$watch("trigger", updateTrigger);
    },
    updated: function updated() {
      var _this$$refs$container;
      (_this$$refs$container = this.$refs.container) === null || _this$$refs$container === void 0 || _this$$refs$container.updateContent();
    },
    beforeDestroy: function beforeDestroy() {
      if (this.visible) {
        var _this$popup;
        (_this$popup = this.popup) === null || _this$popup === void 0 || _this$popup.preventClosing(false);
      }
      this.destroyPopper();
      off$1(document, "mousedown", this.handleDocumentClick, true);
      clearTimeout(this.timeout);
    },
    methods: {
      updatePopper: function updatePopper() {
        var _this4 = this;
        var triggerEl = this.$el;
        var popperEl = this.$refs.popper;
        if (!popperEl || !this.visible) return;
        if (this.popper) {
          this.popper.update();
          return;
        }
        this.popper = createPopper(triggerEl, popperEl, _objectSpread$2G({
          modifiers: getIEVersion() > 9 ? [] : [{
            name: "computeStyles",
            options: {
              gpuAcceleration: false
            }
          }],
          placement: getPopperPlacement(this.placement),
          onFirstUpdate: function onFirstUpdate() {
            _this4.$nextTick(_this4.updatePopper);
          }
        }, this.popperOptions));
      },
      popupMounted: function popupMounted() {
        var _this$$refs;
        var overlayEl = (_this$$refs = this.$refs) === null || _this$$refs === void 0 ? void 0 : _this$$refs.overlay;
        if (overlayEl) {
          var _this$updateScrollTop;
          (_this$updateScrollTop = this.updateScrollTop) === null || _this$updateScrollTop === void 0 || _this$updateScrollTop.call(this, overlayEl);
        }
      },
      getOverlayStyle: function getOverlayStyle() {
        var _this$$refs2;
        var overlayStyle = this.overlayStyle;
        var triggerEl = this.$el;
        var overlayEl = (_this$$refs2 = this.$refs) === null || _this$$refs2 === void 0 ? void 0 : _this$$refs2.overlay;
        if (typeof overlayStyle === "function") {
          return overlayStyle(triggerEl, overlayEl);
        }
        if (_typeof$2(overlayStyle) === "object") {
          return overlayStyle;
        }
      },
      updateOverlayInnerStyle: function updateOverlayInnerStyle() {
        var _this$$refs3;
        var overlayInnerStyle = this.overlayInnerStyle;
        var triggerEl = this.$el;
        var overlayEl = (_this$$refs3 = this.$refs) === null || _this$$refs3 === void 0 ? void 0 : _this$$refs3.overlay;
        if (!triggerEl || !overlayEl) return;
        if (typeof overlayInnerStyle === "function") {
          setStyle(overlayEl, overlayInnerStyle(triggerEl, overlayEl));
        } else if (_typeof$2(overlayInnerStyle) === "object") {
          setStyle(overlayEl, overlayInnerStyle);
        }
      },
      destroyPopper: function destroyPopper() {
        if (this.popper) {
          this.popper.destroy();
          this.popper = null;
        }
        if (this.destroyOnClose) {
          var _this$$refs$container2;
          (_this$$refs$container2 = this.$refs.container) === null || _this$$refs$container2 === void 0 || _this$$refs$container2.unmountContent();
        }
      },
      handleToggle: function handleToggle(context) {
        this.emitPopVisible(!this.visible, context);
      },
      handleOnScroll: function handleOnScroll(e) {
        var _this5 = this;
        var _e$target = e.target,
          scrollTop = _e$target.scrollTop,
          clientHeight = _e$target.clientHeight,
          scrollHeight = _e$target.scrollHeight;
        var debounceOnScrollBottom = debounce$1(function (e2) {
          return emitEvent$1(_this5, "scroll-to-bottom", {
            e: e2
          });
        }, 100);
        if (clientHeight + Math.floor(scrollTop) === scrollHeight) {
          debounceOnScrollBottom(e);
        }
        emitEvent$1(this, "scroll", {
          e: e
        });
      },
      handleOpen: function handleOpen(context) {
        var _this6 = this;
        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this6.emitPopVisible(true, context);
        }, this.hasTrigger.click ? 0 : this.normalizedDelay.open);
      },
      handleClose: function handleClose(context) {
        var _this7 = this;
        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this7.emitPopVisible(false, context);
        }, this.hasTrigger.click ? 0 : this.normalizedDelay.close);
      },
      handleDocumentClick: function handleDocumentClick(ev) {
        var _this8 = this;
        setTimeout(function () {
          if (_this8.contentClicked) {
            setTimeout(function () {
              _this8.contentClicked = false;
            });
            return;
          }
          var triggerEl = _this8.$el;
          if (triggerEl.contains(ev.target)) return;
          var popperEl = _this8.$refs.popper;
          if (popperEl !== null && popperEl !== void 0 && popperEl.contains(ev.target)) return;
          _this8.visibleState = 0;
          _this8.emitPopVisible(false, {
            trigger: "document",
            e: ev
          });
        });
      },
      emitPopVisible: function emitPopVisible(visible, context) {
        if (this.disabled || visible === !!this.visible) return;
        if (!visible && this.visibleState > 1) return;
        if (visible && this.mouseInRange) return;
        this.$emit("visible-change", visible, context);
        if (typeof this.onVisibleChange === "function") {
          this.onVisibleChange(visible, context);
        }
      },
      onMouseEnter: function onMouseEnter() {
        if (this.destroyOnClose && this.isLeaving) {
          return;
        }
        this.mouseInRange = true;
        this.handleOpen({});
      },
      onMouseLeave: function onMouseLeave(ev) {
        if (this.visibleState > 1) {
          var rect = this.$refs.popper.getBoundingClientRect();
          if (ev.x > rect.x && ev.x < rect.x + rect.width && ev.y > rect.y && ev.y < rect.y + rect.height) return;
        }
        this.mouseInRange = false;
        this.handleClose({});
        var parent = this.popup;
        if (parent !== null && parent !== void 0 && parent.mouseInRange) {
          parent.onMouseLeave(ev);
        }
      },
      onBeforeEnter: function onBeforeEnter() {
        if (this.visible) {
          this.updatePopper();
        }
      },
      onAfterEnter: function onAfterEnter() {
        if (this.visible) {
          this.updatePopper();
        }
      },
      onLeave: function onLeave() {
        this.isLeaving = true;
      },
      onAfterLeave: function onAfterLeave() {
        this.isLeaving = false;
        this.destroyPopper();
      },
      preventClosing: function preventClosing(preventing) {
        var parent = this.popup;
        parent === null || parent === void 0 || parent.preventClosing(preventing);
        if (preventing) {
          this.visibleState += 1;
        } else if (this.visibleState) {
          this.visibleState -= 1;
          if (!this.visibleState) {
            this.emitPopVisible(false, {});
            if (parent !== null && parent !== void 0 && parent.hasTrigger.hover && !(parent !== null && parent !== void 0 && parent.mouseInRange)) {
              parent.emitPopVisible(false, {});
            }
          }
        }
      }
    },
    render: function render(h) {
      var _this9 = this;
      var visible = this.visible,
        destroyOnClose = this.destroyOnClose,
        hasTrigger = this.hasTrigger,
        handleOnScroll = this.handleOnScroll;
      var ref = renderContent(this, "default", "triggerElement");
      var content = renderTNodeJSX(this, "content");
      var hidePopup = this.hideEmptyPopup && ["", void 0, null].includes(content);
      var overlay = visible || !destroyOnClose ? h("div", {
        "class": [this.componentName, this.overlayClassName],
        ref: "popper",
        style: [hidePopup && {
          visibility: "hidden",
          pointerEvents: "none"
        }, {
          zIndex: this.zIndex
        }, this.getOverlayStyle()],
        directives: destroyOnClose ? void 0 : [{
          name: "show",
          rawName: "v-show",
          value: visible && !hidePopup,
          expression: "visible"
        }],
        on: _objectSpread$2G({
          mousedown: function mousedown() {
            _this9.contentClicked = true;
          }
        }, hasTrigger.hover && {
          mouseenter: this.onMouseEnter,
          mouseleave: this.onMouseLeave
        })
      }, [h("div", {
        "class": this.overlayClasses,
        ref: "overlay",
        on: {
          scroll: function scroll(e) {
            handleOnScroll(e);
          }
        }
      }, [content, this.showArrow && h("div", {
        "class": "".concat(this.componentName, "__arrow")
      })])]) : null;
      return h(Container$1, {
        "ref": "container",
        "on": {
          "contentMounted": function contentMounted() {
            if (visible) {
              _this9.updatePopper();
              _this9.updateOverlayInnerStyle();
            }
          },
          "resize": function resize() {
            if (visible) {
              _this9.updatePopper();
              _this9.updateOverlayInnerStyle();
            }
          }
        },
        "attrs": {
          "parent": this,
          "visible": visible,
          "attach": function attach() {
            return {
              attach: _this9.computeAttach,
              current: _this9.$el
            };
          }
        }
      }, [h("transition", {
        "slot": "content",
        "attrs": {
          "name": this.expandAnimation ? "".concat(this.componentName, "--animation-expand") : "".concat(this.componentName, "--animation"),
          "appear": true
        },
        "on": {
          "beforeEnter": this.onBeforeEnter,
          "afterEnter": this.onAfterEnter,
          "leave": this.onLeave,
          "afterLeave": this.onAfterLeave
        }
      }, [overlay]), ref]);
    }
  });

  var _excluded$6 = ["name"];
  function ownKeys$2G(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2F(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2G(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2G(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var defaultModel = {
    prop: "value",
    event: "input"
  };
  function toCamel(str) {
    return str.replace(/-([a-z])/gi, function (m, letter) {
      return letter.toUpperCase();
    });
  }
  function getPropOptionMap(props) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var propOptionMap = {};
    var model = options.model;
    function parseProp(propOption) {
      var propName = propOption.name,
        others = _objectWithoutProperties$2(propOption, _excluded$6);
      var camelName = propName.replace(/^[a-z]/, function (letter) {
        return letter.toUpperCase();
      });
      var defaultName = "default".concat(camelName);
      var dataName = "data".concat(camelName);
      var events = [];
      if (propOption.event) {
        events = events.concat(propOption.event);
      } else if (model.prop === propName) {
        events = events.concat(model.event);
      } else {
        events = events.concat("update:".concat(propName));
      }
      return _objectSpread$2F({
        events: events,
        defaultName: defaultName,
        dataName: dataName
      }, others);
    }
    props.forEach(function (prop) {
      var defaultOption = {
        alias: []
      };
      var propOption;
      if (typeof prop === "string") {
        propOption = _objectSpread$2F(_objectSpread$2F({}, defaultOption), {}, {
          name: prop
        });
      } else {
        propOption = _objectSpread$2F(_objectSpread$2F({}, defaultOption), prop);
      }
      propOptionMap[propOption.name] = parseProp(propOption);
    });
    return propOptionMap;
  }
  function mapProps (props) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    function mapProps(componentConstructor) {
      var component = componentConstructor.prototype ? componentConstructor.prototype.constructor.options : componentConstructor;
      var model = options.model || defaultModel;
      var propOptionMap = getPropOptionMap(props, {
        model: model
      });
      var defineProps = _objectSpread$2F({}, component.props);
      var defineWatches = {};
      var defineEvents = [];
      var defineMethods = {};
      var propsKeys = Object.keys(component.props);
      var camelPropsKeys = propsKeys.map(function (key) {
        return toCamel(key);
      });
      Object.keys(propOptionMap).forEach(function (propName) {
        var _propOptionMap$propNa = propOptionMap[propName],
          events = _propOptionMap$propNa.events,
          alias = _propOptionMap$propNa.alias,
          defaultName = _propOptionMap$propNa.defaultName,
          dataName = _propOptionMap$propNa.dataName;
        defineProps[propName] = component.props[propName];
        defineProps[defaultName] = component.props[defaultName];
        if (alias) {
          alias.forEach(function (prop) {
            defineProps[prop] = defineProps[propName];
          });
        }
        defineEvents = defineEvents.concat(events);
        defineWatches[defaultName] = {
          handler: function handler(v) {
            if (defaultName in this.$vnode.componentOptions.propsData && !(propName in this.$vnode.componentOptions.propsData)) {
              this.$data[dataName] = v;
            }
          },
          immediate: true
        };
        alias.forEach(function (aliasItem) {
          defineWatches[aliasItem] = {
            handler: function handler(v) {
              if (aliasItem in this.$vnode.componentOptions.propsData && !(propName in this.$vnode.componentOptions.propsData)) {
                this.$data[dataName] = v;
              }
            },
            immediate: true
          };
        });
        defineWatches[propName] = {
          handler: function handler(v) {
            if (propName in this.$vnode.componentOptions.propsData) {
              this.$data[dataName] = v;
            }
          },
          immediate: true
        };
      });
      if (component.methods) {
        Object.keys(component.methods).forEach(function (key) {
          defineMethods[key] = function () {
            if (this.$refs.component) {
              var _this$$refs$component;
              return (_this$$refs$component = this.$refs.component)[key].apply(_this$$refs$component, arguments);
            }
          };
        });
      }
      var name = component.name;
      return Vue__default["default"].extend({
        name: "".concat(name, "-mapprops"),
        inheritAttrs: false,
        model: {
          prop: model.prop,
          event: Array.isArray(model.event) ? model.event[0] : model.event
        },
        data: function data() {
          var data = {};
          Object.keys(propOptionMap).forEach(function (propName) {
            var dataName = propOptionMap[propName].dataName;
            data[dataName] = void 0;
          });
          return _objectSpread$2F({}, data);
        },
        props: _objectSpread$2F({}, defineProps),
        computed: {
          _listeners: function _listeners() {
            var _this = this;
            var others = {};
            Object.keys(this.$listeners).forEach(function (event) {
              if (defineEvents.indexOf(event) === -1) {
                others[event] = function () {
                  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                  }
                  _this.$emit.apply(_this, [event].concat(args));
                };
              }
            });
            return others;
          }
        },
        watch: defineWatches,
        render: function render(h) {
          var _this2 = this;
          var propMap = {};
          var handlerMap = {};
          Object.keys(propOptionMap).forEach(function (propName) {
            var _propOptionMap$propNa2 = propOptionMap[propName],
              dataName = _propOptionMap$propNa2.dataName,
              events = _propOptionMap$propNa2.events;
            if (propName in _this2.$vnode.componentOptions.propsData || typeof _this2[dataName] !== "undefined") {
              propMap[propName] = _this2[dataName];
            }
            handlerMap[events[0]] = function (v) {
              for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                args[_key2 - 1] = arguments[_key2];
              }
              return _this2.updateData.apply(_this2, [propName, v].concat(args));
            };
          });
          var attrs = {};
          Object.keys(this.$attrs).forEach(function (attrName) {
            var camelAttrKey = toCamel(attrName);
            if (camelPropsKeys.indexOf(camelAttrKey) === -1) {
              attrs[attrName] = _this2.$attrs[attrName];
            }
          });
          return h(component, {
            props: _objectSpread$2F(_objectSpread$2F({}, this.$props), propMap),
            attrs: _objectSpread$2F({}, attrs),
            on: _objectSpread$2F(_objectSpread$2F({}, this._listeners), handlerMap),
            scopedSlots: _objectSpread$2F({}, this.$scopedSlots),
            ref: "component"
          });
        },
        methods: _objectSpread$2F({
          updateData: function updateData(propName, v) {
            var _this3 = this;
            for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
              args[_key3 - 2] = arguments[_key3];
            }
            propOptionMap[propName].events.forEach(function (event) {
              _this3.$emit.apply(_this3, [event, v].concat(args));
            });
            if (!(propName in this.$vnode.componentOptions.propsData)) {
              this[propOptionMap[propName].dataName] = v;
              return true;
            }
          }
        }, defineMethods)
      });
    }
    return mapProps;
  }

  var logSet = /* @__PURE__ */new Set();
  var log = {
    warn: function warn(componentName, message) {
      console.warn("TDesign ".concat(componentName, " Warn: ").concat(message));
    },
    warnOnce: function warnOnce(componentName, message) {
      var msgContent = "TDesign ".concat(componentName, " Warn: ").concat(message);
      if (logSet.has(msgContent)) return;
      logSet.add(msgContent);
      console.warn(msgContent);
    },
    error: function error(componentName, message) {
      console.error("TDesign ".concat(componentName, " Error: ").concat(message));
    },
    errorOnce: function errorOnce(componentName, message) {
      var msgContent = "TDesign ".concat(componentName, " Error: ").concat(message);
      if (logSet.has(msgContent)) return;
      logSet.add(msgContent);
      console.error(msgContent);
    },
    info: function info(componentName, message) {
      console.info("TDesign ".concat(componentName, " Info: ").concat(message));
    }
  };

  function ownKeys$2F(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2E(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2F(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2F(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$w = getClassPrefixMixins("popup");
  var popperInstance;
  var overlayInstance;
  var timeout;
  var triggerEl;
  var triggerType = function triggerType(triggerProps) {
    return triggers.reduce(function (map, trigger) {
      return _objectSpread$2E(_objectSpread$2E({}, map), {}, _defineProperty$2({}, trigger, triggerProps.includes(trigger)));
    }, {});
  };
  var Overlay = mixins(classPrefixMixins$w).extend({
    name: "TPopupOverlay",
    data: function data() {
      return {
        visibleState: false,
        contentClicked: false
      };
    },
    props: _objectSpread$2E(_objectSpread$2E({}, popupProps), {}, {
      triggerEl: {
        validator: function validator(value) {
          if (!(value instanceof HTMLElement)) {
            log.warn("Popup", "Invalid value for prop \"triggerEl\": expected an HTMLElement, but got ".concat(_typeof$2(value), "."));
            return false;
          }
          return true;
        },
        required: true
      }
    }),
    computed: {
      hasTrigger: function hasTrigger() {
        return triggerType(this.trigger);
      },
      overlayClasses: function overlayClasses() {
        return ["".concat(this.componentName, "__content"), _defineProperty$2(_defineProperty$2(_defineProperty$2({}, "".concat(this.componentName, "__content--text"), this.content === "string"), "".concat(this.componentName, "__content--arrow"), this.showArrow), this.commonStatusClassName.disabled, this.disabled), this.overlayInnerClassName];
      }
    },
    methods: {
      handleDocumentClick: function handleDocumentClick(e) {
        var _triggerEl,
          _this = this;
        if ((_triggerEl = triggerEl) !== null && _triggerEl !== void 0 && _triggerEl.contains(e.target)) return;
        if (this.contentClicked) {
          setTimeout(function () {
            _this.contentClicked = false;
          });
        } else {
          var _popperInstance;
          if (this.destroyOnClose) {
            this.visibleState = false;
          }
          (_popperInstance = popperInstance) === null || _popperInstance === void 0 || _popperInstance.destroy();
          popperInstance = null;
          triggerEl = null;
        }
      },
      handleMouseLeave: function handleMouseLeave() {
        var _popperInstance2;
        if (this.destroyOnClose) {
          this.visibleState = false;
        }
        (_popperInstance2 = popperInstance) === null || _popperInstance2 === void 0 || _popperInstance2.destroy();
        popperInstance = null;
      },
      handleMouseEnter: function handleMouseEnter() {
        clearTimeout(timeout);
      }
    },
    created: function created() {
      this.visibleState = true;
    },
    mounted: function mounted() {
      var _this2 = this;
      setTimeout(function () {
        on$1(document, "click", _this2.handleDocumentClick);
      });
    },
    beforeDestroy: function beforeDestroy() {
      off$1(document, "click", this.handleDocumentClick);
    },
    render: function render(h) {
      var _this3 = this;
      var content = renderTNodeJSX(this, "content");
      var hidePopup = this.hideEmptyPopup && ["", void 0, null].includes(content);
      var handleMouseLeave = this.handleMouseLeave,
        handleMouseEnter = this.handleMouseEnter,
        visibleState = this.visibleState,
        hasTrigger = this.hasTrigger;
      var renderNode = h("div", {
        "class": [this.componentName, this.overlayClassName],
        ref: "popper",
        style: [hidePopup && {
          visibility: "hidden",
          pointerEvents: "none"
        }, {
          zIndex: this.zIndex
        }, this.overlayStyle],
        on: _objectSpread$2E({
          mousedown: function mousedown() {
            _this3.contentClicked = true;
          }
        }, hasTrigger.hover && {
          mouseenter: handleMouseEnter,
          mouseleave: handleMouseLeave
        })
      }, [h("div", {
        ref: "overlay",
        "class": this.overlayClasses,
        style: this.overlayInnerStyle
      }, [content, this.showArrow && h("div", {
        "class": "".concat(this.componentName, "__arrow")
      })])]);
      return visibleState ? h("transition", {
        "slot": "content",
        "attrs": {
          "name": "".concat(this.componentName, "--animation"),
          "appear": true
        }
      }, [renderNode]) : null;
    }
  });
  var removeOverlayInstance = function removeOverlayInstance() {
    if (overlayInstance) {
      overlayInstance.remove();
      overlayInstance = null;
    }
    if (popperInstance) {
      popperInstance.destroy();
      popperInstance = null;
    }
  };
  var createPopupPlugin = function createPopupPlugin(trigger, content, popupProps) {
    var _popupProps$delay, _delay$;
    var hasTrigger = triggerType((popupProps === null || popupProps === void 0 ? void 0 : popupProps.trigger) || "hover");
    var currentTriggerEl = getAttach(trigger);
    if (triggerEl && hasTrigger.click) {
      return;
    }
    triggerEl = currentTriggerEl;
    removeOverlayInstance();
    var attach = getAttach((popupProps === null || popupProps === void 0 ? void 0 : popupProps.attach) || "body");
    var delay = [].concat((_popupProps$delay = popupProps === null || popupProps === void 0 ? void 0 : popupProps.delay) !== null && _popupProps$delay !== void 0 ? _popupProps$delay : [250, 150]);
    var closeDelay = (_delay$ = delay[1]) !== null && _delay$ !== void 0 ? _delay$ : delay[0];
    if (attach === document.body) {
      var popupDom = document.createElement("div");
      document.body.appendChild(popupDom);
      attach = popupDom;
    }
    overlayInstance = new Overlay({
      propsData: _objectSpread$2E(_objectSpread$2E({}, popupProps), {}, {
        content: content,
        triggerEl: triggerEl
      })
    }).$mount(attach).$el;
    if (hasTrigger.hover) {
      var mouseoutEvent = function mouseoutEvent() {
        timeout = setTimeout(removeOverlayInstance, closeDelay);
      };
      once(triggerEl, "mouseleave", mouseoutEvent);
    } else if (hasTrigger.focus) {
      var focusoutEvent = function focusoutEvent() {
        timeout = setTimeout(removeOverlayInstance, closeDelay);
      };
      once(triggerEl, "focusout", focusoutEvent);
    }
    popperInstance = createPopper(triggerEl, overlayInstance, _objectSpread$2E({
      placement: getPopperPlacement((popupProps === null || popupProps === void 0 ? void 0 : popupProps.placement) || "top")
    }, popupProps === null || popupProps === void 0 ? void 0 : popupProps.popperOptions));
    return popperInstance;
  };
  var PopupPlugin = createPopupPlugin;
  PopupPlugin.install = function () {
    Vue__default["default"].prototype.$popup = createPopupPlugin;
  };

  var Popup = withInstall$1(mapProps(["visible"], {
    model: {
      prop: "visible",
      event: "visible-change"
    }
  })(Popup$1));

  function ownKeys$2E(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2D(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2E(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2E(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _AnchorTarget = mixins(getConfigReceiverMixins("anchor"), getGlobalIconMixins()).extend({
    name: "TAnchorTarget",
    props: _objectSpread$2D({}, props$1c),
    methods: {
      copyText: function copyText$1() {
        var a = document.createElement("a");
        a.href = "#".concat(this.id);
        copyText(a.href);
        MessagePlugin.success(this.global.copySuccessText, 1e3);
      }
    },
    render: function render() {
      var h = arguments[0];
      var Tag = this.tag,
        children = this.$scopedSlots["default"],
        id = this.id;
      var _this$useGlobalIcon = this.useGlobalIcon({
          FileCopyIcon: TdFileCopyIcon
        }),
        FileCopyIcon = _this$useGlobalIcon.FileCopyIcon;
      var className = ["".concat(this.componentName, "__target")];
      var iconClassName = "".concat(this.componentName, "__copy");
      return h(Tag, {
        "attrs": {
          "id": id
        },
        "class": className
      }, [children && children(null), h(Popup, {
        "attrs": {
          "content": this.global.copyText,
          "placement": "top",
          "showArrow": true
        },
        "class": iconClassName
      }, [h(FileCopyIcon, {
        "nativeOn": {
          "click": this.copyText
        }
      })])]);
    }
  });

  var Anchor = withInstall$1(_Anchor);
  var AnchorItem = withInstall$1(_AnchorItem);
  var AnchorTarget = withInstall$1(_AnchorTarget);

  function useGlobalIcon(tdIcon) {
    var _useConfig = useConfig("icon"),
      global = _useConfig.global;
    var resultIcon = {};
    Object.keys(tdIcon).forEach(function (key) {
      var _global$value;
      resultIcon[key] = ((_global$value = global.value) === null || _global$value === void 0 ? void 0 : _global$value[key]) || tdIcon[key];
    });
    return resultIcon;
  }

  var props$1b = {
    container: {
      type: [String, Function],
      "default": "body"
    },
    content: {
      type: [String, Function]
    },
    "default": {
      type: [String, Function]
    },
    duration: {
      type: Number,
      "default": 200
    },
    offset: {
      type: Array,
      "default": function _default() {
        return ["24px", "80px"];
      }
    },
    shape: {
      type: String,
      "default": "square",
      validator: function validator(val) {
        if (!val) return true;
        return ["circle", "square"].includes(val);
      }
    },
    size: {
      type: String,
      "default": "medium",
      validator: function validator(val) {
        if (!val) return true;
        return ["medium", "small"].includes(val);
      }
    },
    target: {
      type: [String, Function],
      "default": "body"
    },
    theme: {
      type: String,
      "default": "light",
      validator: function validator(val) {
        if (!val) return true;
        return ["light", "primary", "dark"].includes(val);
      }
    },
    visibleHeight: {
      type: [String, Number],
      "default": "200px"
    },
    onClick: Function
  };

  function ownKeys$2D(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2C(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2D(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2D(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _BackTop = VueCompositionAPI.defineComponent({
    name: "TBackTop",
    props: _objectSpread$2C({}, props$1b),
    setup: function setup(props2) {
      var visible = VueCompositionAPI.ref(false);
      var containerRef = VueCompositionAPI.ref(null);
      var componentName = usePrefixClass("back-top");
      var classPrefix = usePrefixClass();
      var theme = props2.theme,
        shape = props2.shape,
        size = props2.size,
        target = props2.target,
        duration = props2.duration,
        offset = props2.offset,
        container = props2.container;
      var _useGlobalIcon = useGlobalIcon({
          BacktopIcon: TdBackTopIcon
        }),
        BacktopIcon = _useGlobalIcon.BacktopIcon;
      var getContainer = function getContainer(container2) {
        if (typeof container2 === "string" && (typeof document === "undefined" ? "undefined" : _typeof$2(document)) !== void 0) {
          if (container2 === "body") {
            return document;
          }
          return document.querySelector(container2);
        }
        if (typeof container2 === "function") {
          return container2();
        }
        return null;
      };
      var getBackTo = function getBackTo() {
        if (target === container) return 0;
        if (target === "body") return 0;
        if (!target) return 0;
        var targetNode = getContainer(target);
        if (!targetNode) return 0;
        var _targetNode$getBoundi = targetNode.getBoundingClientRect(),
          y = _targetNode$getBoundi.y;
        return y;
      };
      var handleClick = function handleClick(e) {
        var _props2$onClick;
        var y = getBackTo();
        scrollTo(y, {
          container: containerRef.value,
          duration: duration
        });
        (_props2$onClick = props2.onClick) === null || _props2$onClick === void 0 || _props2$onClick.call(props2, {
          e: e
        });
      };
      var cls = VueCompositionAPI.computed(function () {
        return _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({}, componentName.value, true), "".concat(componentName.value, "--theme-").concat(theme), true), "".concat(componentName.value, "--").concat(shape), true), "".concat(componentName.value, "--show"), visible.value), "".concat(classPrefix.value, "-size-s"), size === "small"), "".concat(classPrefix.value, "-size-m"), size === "medium");
      });
      var positionStyle = VueCompositionAPI.computed(function () {
        return {
          insetInlineEnd: offset[0],
          insetBlockEnd: offset[1]
        };
      });
      VueCompositionAPI.onMounted(function () {
        containerRef.value = getContainer(props2.container);
        var visibleHeight;
        if (typeof props2.visibleHeight === "string") {
          visibleHeight = Number(props2.visibleHeight.replace("px", ""));
        } else {
          visibleHeight = props2.visibleHeight;
        }
        if (visibleHeight === 0) {
          visible.value = true;
          return;
        }
        var scrollDOM;
        if (containerRef.value) {
          if (containerRef.value.scrollTop === void 0) {
            scrollDOM = document.documentElement;
          } else {
            scrollDOM = containerRef.value;
          }
          containerRef.value.onscroll = function () {
            var _scrollDOM = scrollDOM,
              scrollTop = _scrollDOM.scrollTop;
            if (scrollTop >= visibleHeight) {
              visible.value = true;
            }
            if (scrollTop < visibleHeight && visible.value) {
              visible.value = false;
            }
          };
        }
      });
      VueCompositionAPI.onBeforeUnmount(function () {
        containerRef.value.onscroll = null;
      });
      return {
        BacktopIcon: BacktopIcon,
        cls: cls,
        handleClick: handleClick,
        positionStyle: positionStyle,
        componentName: componentName
      };
    },
    render: function render() {
      var h = arguments[0];
      var BacktopIcon = this.BacktopIcon;
      var defaultContent = h("div", [h(BacktopIcon, {
        "class": "".concat(this.componentName, "__icon"),
        "attrs": {
          "size": "24"
        }
      }), h("span", {
        "class": "".concat(this.componentName, "__text")
      }, ["TOP"])]);
      return h("button", {
        "attrs": {
          "type": "button"
        },
        "class": this.cls,
        "style": this.positionStyle,
        "on": {
          "click": this.handleClick
        }
      }, [renderContent(this, "content", "default", defaultContent)]);
    }
  });

  var BackTop = withInstall$1(_BackTop);

  var props$1a = {
    maxItemWidth: {
      type: String,
      "default": void 0
    },
    options: {
      type: Array
    },
    separator: {
      type: [String, Function]
    },
    theme: {
      type: String,
      "default": "light",
      validator: function validator(val) {
        if (!val) return true;
        return ["light"].includes(val);
      }
    }
  };

  var props$19 = {
    delay: {
      type: Number
    },
    destroyOnClose: {
      type: Boolean,
      "default": true
    },
    duration: {
      type: Number
    },
    placement: {
      type: String,
      "default": "top"
    },
    showArrow: {
      type: Boolean,
      "default": true
    },
    theme: {
      type: String,
      "default": "default",
      validator: function validator(val) {
        if (!val) return true;
        return ["default", "primary", "success", "danger", "warning", "light"].includes(val);
      }
    }
  };

  function ownKeys$2C(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2B(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2C(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2C(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$v = getClassPrefixMixins("tooltip");
  var _Tooltip = mixins(classPrefixMixins$v).extend({
    name: "TTooltip",
    components: {
      Popup: Popup$1
    },
    props: _objectSpread$2B(_objectSpread$2B({}, popupProps), props$19),
    data: function data() {
      return {
        timer: null,
        x: 0,
        offsetX: 0,
        tooltipVisible: false
      };
    },
    computed: {
      tooltipOverlayClassName: function tooltipOverlayClassName() {
        return [this.componentName, _defineProperty$2({}, "".concat(this.componentName, "--").concat(this.theme), this.theme), this.overlayClassName];
      },
      tooltipOverlayInnerStyle: function tooltipOverlayInnerStyle() {
        var _this = this;
        if (this.placement !== "mouse" || this.offsetX === 0) {
          return this.overlayInnerStyle;
        }
        var offsetStyle = function offsetStyle(triggerEl) {
          return {
            transform: "translateX(".concat(_this.offsetX - triggerEl.getBoundingClientRect().left, "px)")
          };
        };
        if (this.overlayInnerStyle) {
          return function (triggerEl, popupEl) {
            return _objectSpread$2B(_objectSpread$2B({}, offsetStyle(triggerEl)), isFunction(_this.overlayInnerStyle) ? _this.overlayInnerStyle(triggerEl, popupEl) : _this.overlayInnerStyle);
          };
        }
        return offsetStyle;
      }
    },
    watch: {
      visible: function visible(_visible) {
        if (this.timer && !_visible) {
          clearTimeout(this.timer);
          this.timer = null;
        }
      }
    },
    created: function created() {
      var _this2 = this;
      if (this.duration && this.visible) {
        this.timer = setTimeout(function () {
          _this2.$emit("visible-change", false);
          clearTimeout(_this2.timer);
          _this2.timer = null;
        }, this.duration);
      }
    },
    mounted: function mounted() {
      var _window;
      (_window = window) === null || _window === void 0 || _window.addEventListener("mousemove", this.onMouseMove, {
        passive: true
      });
    },
    destroyed: function destroyed() {
      var _window2;
      (_window2 = window) === null || _window2 === void 0 || _window2.removeEventListener("mousemove", this.onMouseMove);
    },
    methods: {
      onMouseMove: function onMouseMove(e) {
        this.x = e.clientX;
      },
      onTipVisibleChange: function onTipVisibleChange(val, ctx) {
        if (this.timer && (ctx === null || ctx === void 0 ? void 0 : ctx.trigger) !== "document") return;
        if (val) this.offsetX = this.x;
        this.$emit("visible-change", val);
      },
      getPopupProps: function getPopupProps() {
        var _this3 = this;
        var r = _objectSpread$2B(_objectSpread$2B({}, this.$props), {}, {
          showArrow: this.placement === "mouse" ? false : this.showArrow,
          placement: this.placement === "mouse" ? "bottom-left" : this.placement,
          content: function content() {
            return renderTNodeJSX(_this3, "content");
          },
          "default": function _default() {
            return renderContent(_this3, "default", "triggerElement");
          },
          overlayClassName: this.tooltipOverlayClassName,
          overlayInnerStyle: this.tooltipOverlayInnerStyle
        });
        return r;
      },
      updatedTooltip: function updatedTooltip() {
        this.$refs.popup && this.$refs.popup.updatePopper();
      }
    },
    render: function render() {
      var h = arguments[0];
      return h(Popup$1, helper([{
        "ref": "popup",
        "attrs": {
          "visible": this.visible
        }
      }, {
        "props": this.getPopupProps()
      }, {}, {
        "on": {
          "visible-change": this.onTipVisibleChange
        }
      }]));
    }
  });

  var Tooltip = withInstall$1(mapProps(["visible"], {
    model: {
      prop: "visible",
      event: "visible-change"
    }
  })(_Tooltip));

  var props$18 = {
    content: {
      type: [String, Function]
    },
    "default": {
      type: [String, Function]
    },
    disabled: Boolean,
    href: {
      type: String,
      "default": ""
    },
    icon: {
      type: Function
    },
    maxWidth: {
      type: String,
      "default": void 0
    },
    replace: Boolean,
    router: {
      type: Object
    },
    target: {
      type: String,
      "default": "_self",
      validator: function validator(val) {
        if (!val) return true;
        return ["_blank", "_self", "_parent", "_top"].includes(val);
      }
    },
    to: {
      type: [String, Object]
    }
  };

  function ownKeys$2B(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2A(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2B(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2B(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$u = getClassPrefixMixins("breadcrumb");
  var localTBreadcrumbOrigin = {
    separator: "",
    theme: "light",
    $slots: {
      separator: ""
    },
    maxItemWidth: void 0
  };
  var _BreadcrumbItem = mixins(classPrefixMixins$u, getGlobalIconMixins()).extend({
    name: "TBreadcrumbItem",
    props: _objectSpread$2A({}, props$18),
    inject: ["tBreadcrumb"],
    data: function data() {
      return {
        localTBreadcrumb: localTBreadcrumbOrigin,
        themeClassName: "",
        $router: null,
        isCutOff: false
      };
    },
    components: {
      Tooltip: Tooltip
    },
    computed: {
      maxWithStyle: function maxWithStyle() {
        var localTBreadcrumb = this.localTBreadcrumb;
        var maxItemWidth = localTBreadcrumb.maxItemWidth;
        var maxWith = this.maxWidth || maxItemWidth || "120";
        return {
          "max-width": "".concat(maxWith, "px")
        };
      }
    },
    watch: {
      tBreadcrumb: {
        immediate: true,
        handler: function handler(v) {
          this.localTBreadcrumb = v;
        }
      }
    },
    created: function created() {
      var tBreadcrumb = this.localTBreadcrumb;
      this.themeClassName = tBreadcrumb.theme;
    },
    mounted: function mounted() {
      this.isCutOff = isNodeOverflow(this.$refs.breadcrumbText);
    },
    beforeUpdate: function beforeUpdate() {
      this.isCutOff = isNodeOverflow(this.$refs.breadcrumbText);
    },
    methods: {
      bindEvent: function bindEvent() {
        var to = this.to;
        var router = this.router || this.$router;
        if (to && router) {
          this.replace ? router.replace(to) : router.push(to);
        }
      }
    },
    render: function render() {
      var _this = this;
      var h = arguments[0];
      var localTBreadcrumb = this.localTBreadcrumb,
        href = this.href,
        target = this.target,
        to = this.to,
        disabled = this.disabled;
      var _this$useGlobalIcon = this.useGlobalIcon({
          ChevronRightIcon: TdChevronRightIcon
        }),
        ChevronRightIcon = _this$useGlobalIcon.ChevronRightIcon;
      var separator = localTBreadcrumb.separator;
      var separatorSlot = localTBreadcrumb.$slots.separator;
      var separatorPropContent = typeof separator === "function" ? separator() : separator;
      var separatorContent = separatorPropContent || separatorSlot || h(ChevronRightIcon);
      var itemClass = ["".concat(this.componentName, "__item"), this.themeClassName];
      var textClass = ["".concat(this.componentName, "--text-overflow")];
      if (disabled) {
        textClass.push("".concat(this.classPrefix, "-is-disabled"));
      }
      if (this.$listeners.click) {
        textClass.push("".concat(this.classPrefix, "-gestureClass"));
      }
      var clickEvent = to && !disabled ? {
        on: {
          click: this.bindEvent
        }
      } : {};
      var textContent = h("span", {
        "class": "".concat(this.componentName, "__inner"),
        "style": this.maxWithStyle
      }, [renderTNodeJSX(this, "icon"), h("span", {
        "ref": "breadcrumbText",
        "class": "".concat(this.componentName, "__inner-text")
      }, [this.$slots["default"]])]);
      var itemContent = h("span", helper([{
        "class": textClass,
        "on": _objectSpread$2A({}, this.$listeners)
      }, clickEvent]), [textContent]);
      if (href && !disabled) {
        textClass.push("".concat(this.classPrefix, "-link"));
        itemContent = h("a", {
          "class": textClass,
          "attrs": {
            "href": href,
            "target": target
          },
          "on": _objectSpread$2A({}, this.$listeners)
        }, [textContent]);
      }
      return h("div", {
        "class": itemClass
      }, [this.isCutOff ? h(Tooltip, {
        "attrs": {
          "content": function content() {
            return _this.$slots["default"];
          }
        }
      }, [itemContent]) : itemContent, h("span", {
        "class": "".concat(this.componentName, "__separator")
      }, [separatorContent])]);
    }
  });

  function ownKeys$2A(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2z(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2A(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2A(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$t = getClassPrefixMixins("breadcrumb");
  var _Breadcrumb = mixins(classPrefixMixins$t).extend({
    name: "TBreadcrumb",
    props: _objectSpread$2z({}, props$1a),
    components: {
      BreadcrumbItem: _BreadcrumbItem
    },
    provide: function provide() {
      return {
        tBreadcrumb: this
      };
    },
    render: function render() {
      var h = arguments[0];
      var content = this.$slots["default"];
      if (this.options && this.options.length) {
        content = this.options.map(function (option, index) {
          return h(_BreadcrumbItem, {
            "key": index,
            "attrs": {
              "maxWidth": option.maxWidth,
              "disabled": option.disabled,
              "href": option.href,
              "target": option.target,
              "to": option.to,
              "router": option.router,
              "replace": option.replace
            }
          }, [option["default"] || option.content]);
        });
      }
      return h("div", {
        "class": this.componentName
      }, [content]);
    }
  });

  var BreadcrumbItem = withInstall$1(_BreadcrumbItem);
  var Breadcrumb = withInstall$1(_Breadcrumb);

  var dropdownItemProps = {
    active: Boolean,
    content: {
      type: [String, Function],
      "default": ""
    },
    disabled: Boolean,
    divider: Boolean,
    prefixIcon: {
      type: Function
    },
    theme: {
      type: String,
      "default": "default",
      validator: function validator(val) {
        if (!val) return true;
        return ["default", "success", "warning", "error"].includes(val);
      }
    },
    value: {
      type: [String, Number, Object]
    },
    onClick: Function
  };

  var isVNode = function isVNode(obj) {
    var vNode = VueCompositionAPI.h("span", "");
    var VNode2 = vNode.constructor;
    return obj instanceof VNode2;
  };
  function getDefaultNode(options) {
    var defaultNode;
    if (isObject(options) && "defaultNode" in options) {
      defaultNode = options.defaultNode;
    } else if (isVNode(options) || isString(options)) {
      defaultNode = options;
    }
    return defaultNode;
  }
  function getParams(options) {
    return isObject(options) && "params" in options ? options.params : null;
  }

  function handleSlots(slots, name, params) {
    var _slots$camelCase, _slots$kebabCase;
    var finaleParams = VueCompositionAPI.h;
    if (params) {
      Object.assign(finaleParams, params);
    }
    var node = (_slots$camelCase = slots[camelCase$1(name)]) === null || _slots$camelCase === void 0 ? void 0 : _slots$camelCase.call(slots, finaleParams);
    if (node) return node;
    node = (_slots$kebabCase = slots[kebabCase$1(name)]) === null || _slots$kebabCase === void 0 ? void 0 : _slots$kebabCase.call(slots, finaleParams);
    if (node) return node;
    return null;
  }
  var useTNodeJSX = function useTNodeJSX() {
    var instance = VueCompositionAPI.getCurrentInstance();
    return function (name, options) {
      var params = getParams(options);
      var defaultNode = getDefaultNode(options);
      var slots = instance.setupContext.slots;
      var propsNode;
      if (Object.keys(instance.props).includes(name)) {
        propsNode = instance.props[name];
      }
      if (propsNode === false) return;
      if (propsNode === true) {
        return handleSlots(slots, name, params) || defaultNode;
      }
      if (isFunction(propsNode)) return propsNode(VueCompositionAPI.h, params);
      var isPropsEmpty = [void 0, params, ""].includes(propsNode);
      if (isPropsEmpty && (slots[camelCase$1(name)] || slots[kebabCase$1(name)])) {
        return handleSlots(slots, name, params);
      }
      return propsNode;
    };
  };
  var useTNodeDefault = function useTNodeDefault() {
    var renderTNodeJSX = useTNodeJSX();
    return function (name, options) {
      var defaultNode = getDefaultNode(options);
      return renderTNodeJSX(name, options) || defaultNode;
    };
  };
  var useContent = function useContent() {
    var renderTNodeJSX = useTNodeJSX();
    return function (name1, name2, options) {
      var params = getParams(options);
      var defaultNode = getDefaultNode(options);
      var toParams = params ? {
        params: params
      } : void 0;
      var node1 = renderTNodeJSX(name1, toParams);
      var node2 = renderTNodeJSX(name2, toParams);
      var res = isEmpty(node1) ? node2 : node1;
      return isEmpty(res) ? defaultNode : res;
    };
  };

  function ownKeys$2z(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2y(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2z(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2z(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var keepAnimationMixins$6 = getKeepAnimationMixins();
  var _DropdownItem = VueCompositionAPI.defineComponent({
    name: "TDropdownItem",
    mixins: [keepAnimationMixins$6],
    directives: {
      ripple: Ripple
    },
    props: _objectSpread$2y(_objectSpread$2y({}, dropdownItemProps), {}, {
      maxColumnWidth: {
        type: [String, Number],
        "default": 100
      },
      minColumnWidth: {
        type: [String, Number],
        "default": 10
      },
      isSubmenu: Boolean
    }),
    setup: function setup(props, _ref) {
      var emit = _ref.emit;
      var itemRef = VueCompositionAPI.ref();
      var dropdownItemClass = usePrefixClass("dropdown__item");
      var handleItemClick = function handleItemClick(e) {
        var _props$onClick;
        (_props$onClick = props.onClick) === null || _props$onClick === void 0 || _props$onClick.call(props, props.value, {
          e: e
        });
        emit("click", props.value, {
          e: e
        });
      };
      return {
        itemRef: itemRef,
        dropdownItemClass: dropdownItemClass,
        handleItemClick: handleItemClick
      };
    },
    render: function render() {
      var h = arguments[0];
      var classes = [this.dropdownItemClass, "".concat(this.dropdownItemClass, "--theme-").concat(this.theme), _defineProperty$2(_defineProperty$2({}, "".concat(this.dropdownItemClass, "--active"), this.active), "".concat(this.dropdownItemClass, "--disabled"), this.disabled)];
      var renderTNodeJSX = useTNodeJSX();
      var prefixIcon = renderTNodeJSX("prefixIcon");
      return h("li", {
        "class": classes,
        "on": {
          "click": this.handleItemClick
        },
        "style": {
          maxWidth: pxCompat(this.maxColumnWidth),
          minWidth: pxCompat(this.minColumnWidth)
        },
        "directives": [{
          name: "ripple",
          value: !this.isSubmenu && this.keepAnimation.ripple
        }],
        "ref": this.itemRef
      }, [this.prefixIcon ? h("div", {
        "class": "".concat(this.dropdownItemClass, "-icon")
      }, [prefixIcon]) : null, renderTNodeJSX("default")]);
    }
  });

  var props$17 = {
    direction: {
      type: String,
      "default": "right",
      validator: function validator(val) {
        if (!val) return true;
        return ["left", "right"].includes(val);
      }
    },
    disabled: Boolean,
    hideAfterItemClick: {
      type: Boolean,
      "default": true
    },
    maxColumnWidth: {
      type: [String, Number],
      "default": 100
    },
    maxHeight: {
      type: Number,
      "default": 300
    },
    minColumnWidth: {
      type: [String, Number],
      "default": 10
    },
    options: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    placement: {
      type: String,
      "default": "bottom-left",
      validator: function validator(val) {
        if (!val) return true;
        return ["top", "left", "right", "bottom", "top-left", "top-right", "bottom-left", "bottom-right", "left-top", "left-bottom", "right-top", "right-bottom"].includes(val);
      }
    },
    popupProps: {
      type: Object
    },
    trigger: {
      type: String,
      "default": "hover",
      validator: function validator(val) {
        if (!val) return true;
        return ["hover", "click", "focus", "context-menu"].includes(val);
      }
    },
    onClick: Function
  };

  function ownKeys$2y(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2x(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2y(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2y(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _DropdownMenu = VueCompositionAPI.defineComponent({
    name: "TDropdownMenu",
    props: _objectSpread$2x({}, props$17),
    setup: function setup(props, _ref) {
      var emit = _ref.emit;
      var dropdownClass = usePrefixClass("dropdown");
      var dropdownMenuClass = usePrefixClass("dropdown__menu");
      var menuRef = VueCompositionAPI.ref();
      var isOverMaxHeight = VueCompositionAPI.ref(false);
      var scrollTopMap = VueCompositionAPI.reactive({});
      var handleItemClick = function handleItemClick(optionItem, options) {
        var _data$onClick, _props$onClick;
        if (optionItem.disabled || optionItem.children) return;
        var data = options.data,
          context = options.context;
        data === null || data === void 0 || (_data$onClick = data.onClick) === null || _data$onClick === void 0 || _data$onClick.call(data, data, context);
        (_props$onClick = props.onClick) === null || _props$onClick === void 0 || _props$onClick.call(props, data, context);
        emit("click", data, context);
      };
      var handleScroll = function handleScroll(e, deep) {
        var scrollTop = e.target.scrollTop;
        VueCompositionAPI.set(scrollTopMap, deep, scrollTop);
      };
      VueCompositionAPI.onMounted(function () {
        if (menuRef.value) {
          var _window;
          var menuHeight = parseInt((_window = window) === null || _window === void 0 ? void 0 : _window.getComputedStyle(menuRef.value).height, 10);
          if (menuHeight >= props.maxHeight) isOverMaxHeight.value = true;
        }
      });
      return {
        dropdownClass: dropdownClass,
        dropdownMenuClass: dropdownMenuClass,
        handleItemClick: handleItemClick,
        menuRef: menuRef,
        isOverMaxHeight: isOverMaxHeight,
        handleScroll: handleScroll,
        scrollTopMap: scrollTopMap
      };
    },
    methods: {
      renderOptionContent: function renderOptionContent(content) {
        if (isFunction(content)) {
          return content(VueCompositionAPI.h);
        }
        return content;
      },
      renderOptions: function renderOptions(data, deep) {
        var _data$forEach,
          _this = this;
        var h = this.$createElement;
        var _useGlobalIcon = useGlobalIcon({
            ChevronRightIcon: TdChevronRightIcon
          }),
          ChevronRightIcon = _useGlobalIcon.ChevronRightIcon;
        var arr = [];
        var renderContent;
        (_data$forEach = data.forEach) === null || _data$forEach === void 0 || _data$forEach.call(data, function (menu, idx) {
          var optionItem = _objectSpread$2x({}, menu);
          var onViewIdx = idx - Math.ceil(_this.scrollTopMap[deep] / 30);
          var renderIdx = onViewIdx >= 0 ? onViewIdx : idx;
          if (optionItem.children) {
            optionItem.children = _this.renderOptions(optionItem.children, deep + 1);
            renderContent = h("div", {
              "key": idx
            }, [h(_DropdownItem, {
              "class": ["".concat(_this.dropdownClass, "__item"), "".concat(_this.dropdownClass, "__item--suffix"), optionItem["class"]],
              "props": _objectSpread$2x({}, {
                value: optionItem.value,
                theme: optionItem.theme,
                active: optionItem.active,
                prefixIcon: optionItem.prefixIcon,
                disabled: optionItem.disabled,
                minColumnWidth: _this.minColumnWidth,
                maxColumnWidth: _this.maxColumnWidth,
                isSubmenu: true
              })
            }, [h("div", {
              "class": "".concat(_this.dropdownClass, "__item-content")
            }, [h("span", {
              "class": "".concat(_this.dropdownClass, "__item-text")
            }, [_this.renderOptionContent(optionItem.content)]), h(ChevronRightIcon, {
              "class": "".concat(_this.dropdownClass, "__item-direction"),
              "attrs": {
                "size": "16"
              }
            })]), h("div", {
              "class": ["".concat(_this.dropdownClass, "__submenu-wrapper"), _defineProperty$2({}, "".concat(_this.dropdownClass, "__submenu-wrapper--").concat(_this.direction), _this.direction)],
              "style": {
                position: "absolute",
                top: "".concat(renderIdx * 30, "px")
              }
            }, [h("div", {
              "class": ["".concat(_this.dropdownClass, "__submenu"), _defineProperty$2({}, "".concat(_this.dropdownClass, "__submenu--disabled"), optionItem.disabled)],
              "style": {
                position: "static",
                maxHeight: "".concat(_this.maxHeight, "px")
              },
              "on": {
                "scroll": function scroll(e) {
                  return _this.handleScroll(e, deep + 1);
                }
              }
            }, [h("ul", [optionItem.children])])])]), optionItem.divider ? h(Divider) : null]);
          } else {
            renderContent = h("div", {
              "key": idx
            }, [h(_DropdownItem, {
              "class": ["".concat(_this.dropdownClass, "__item"), optionItem["class"]],
              "props": _objectSpread$2x({}, {
                value: optionItem.value,
                theme: optionItem.theme,
                active: optionItem.active,
                prefixIcon: optionItem.prefixIcon,
                disabled: optionItem.disabled,
                minColumnWidth: _this.minColumnWidth,
                maxColumnWidth: _this.maxColumnWidth,
                onClick: function onClick(value, context) {
                  return _this.handleItemClick({
                    disabled: optionItem.disabled,
                    children: optionItem.children
                  }, {
                    data: optionItem,
                    context: context
                  });
                }
              })
            }, [h("span", {
              "class": "".concat(_this.dropdownClass, "__item-text")
            }, [_this.renderOptionContent(optionItem.content)])]), optionItem.divider ? h(Divider) : null]);
          }
          arr.push(renderContent);
        });
        return arr;
      }
    },
    render: function render() {
      var _this2 = this;
      var h = arguments[0];
      return h("div", {
        "class": [this.dropdownMenuClass, "".concat(this.dropdownMenuClass, "--").concat(this.direction), _defineProperty$2({}, "".concat(this.dropdownMenuClass, "--overflow"), this.isOverMaxHeight)],
        "style": {
          maxHeight: "".concat(this.maxHeight, "px")
        },
        "ref": "menuRef",
        "on": {
          "scroll": function scroll(e) {
            return _this2.handleScroll(e, 0);
          }
        }
      }, [this.renderOptions(this.options, 0)]);
    }
  });

  function ownKeys$2x(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2w(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2x(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2x(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var DropdownMenuName = "TDropdownMenu";
  var DropdownItemName = "TDropdownItem";
  var _getOptionsFromChildren = function getOptionsFromChildren(menuGroup) {
    if (!menuGroup || (menuGroup === null || menuGroup === void 0 ? void 0 : menuGroup.length) === 0) return [];
    if (get(menuGroup, "Ctor.extendOptions.name") === DropdownMenuName) {
      var groupChildren = menuGroup.children;
      if (Array.isArray(groupChildren)) {
        return _getOptionsFromChildren(groupChildren);
      }
      return [];
    }
    if (Array.isArray(menuGroup)) {
      return menuGroup.map(function (item) {
        var _item$componentOption, _groupChildren$filter, _groupChildren$filter2, _item$componentOption2, _item$data, _item$data2, _item$componentOption3;
        var groupChildren = item === null || item === void 0 || (_item$componentOption = item.componentOptions) === null || _item$componentOption === void 0 ? void 0 : _item$componentOption.children;
        if (!groupChildren) return {};
        var contentCtx = groupChildren === null || groupChildren === void 0 || (_groupChildren$filter = groupChildren.filter) === null || _groupChildren$filter === void 0 ? void 0 : _groupChildren$filter.call(groupChildren, function (v) {
          return ![DropdownMenuName, DropdownItemName].includes(get(v, "componentOptions.Ctor.extendOptions.name"));
        });
        var childrenCtx = groupChildren === null || groupChildren === void 0 || (_groupChildren$filter2 = groupChildren.filter) === null || _groupChildren$filter2 === void 0 ? void 0 : _groupChildren$filter2.call(groupChildren, function (v) {
          return typeof v.text !== "string" && [DropdownMenuName, DropdownItemName].includes(get(v, "componentOptions.Ctor.extendOptions.name"));
        });
        var commonProps = _objectSpread$2w(_objectSpread$2w({}, (_item$componentOption2 = item.componentOptions) === null || _item$componentOption2 === void 0 ? void 0 : _item$componentOption2.propsData), {}, {
          style: item === null || item === void 0 || (_item$data = item.data) === null || _item$data === void 0 ? void 0 : _item$data.style,
          "class": item === null || item === void 0 || (_item$data2 = item.data) === null || _item$data2 === void 0 ? void 0 : _item$data2.staticClass,
          onClick: (_item$componentOption3 = item.componentOptions) === null || _item$componentOption3 === void 0 || (_item$componentOption3 = _item$componentOption3.listeners) === null || _item$componentOption3 === void 0 ? void 0 : _item$componentOption3.click,
          content: contentCtx || groupChildren
        });
        if (childrenCtx.length === 1) {
          return _objectSpread$2w(_objectSpread$2w({}, commonProps), {}, {
            children: childrenCtx.length > 0 ? _getOptionsFromChildren(childrenCtx[0].componentOptions) : null
          });
        }
        return _objectSpread$2w(_objectSpread$2w({}, commonProps), {}, {
          children: childrenCtx.length > 0 ? _getOptionsFromChildren(childrenCtx) : null
        });
      }).filter(function (v) {
        return !!v.content;
      });
    }
    return [];
  };
  function useDropdownOptions(props, slots) {
    var _slots$default, _slots$dropdown;
    var menuSlot = (slots === null || slots === void 0 || (_slots$default = slots["default"]) === null || _slots$default === void 0 || (_slots$default = _slots$default.filter(function (v) {
      return get(v, "componentOptions.Ctor.extendOptions.name") === DropdownMenuName;
    })) === null || _slots$default === void 0 || (_slots$default = _slots$default[0]) === null || _slots$default === void 0 ? void 0 : _slots$default.componentOptions) || (slots === null || slots === void 0 || (_slots$dropdown = slots.dropdown) === null || _slots$dropdown === void 0 || (_slots$dropdown = _slots$dropdown[0]) === null || _slots$dropdown === void 0 ? void 0 : _slots$dropdown.componentOptions);
    return VueCompositionAPI.computed(function () {
      if (props.options && props.options.length > 0) return props.options;
      return _getOptionsFromChildren(menuSlot);
    });
  }

  function ownKeys$2w(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2v(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2w(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2w(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _Dropdown = VueCompositionAPI.defineComponent({
    name: "TDropdown",
    props: _objectSpread$2v({}, props$17),
    setup: function setup(props2, _ref) {
      var emit = _ref.emit;
      var dropdownClass = usePrefixClass("dropdown");
      var isPopupVisible = VueCompositionAPI.ref(false);
      var invisibleDelay = VueCompositionAPI.computed(function () {
        var _props2$popupProps;
        var popupInvisibleDelay = (_props2$popupProps = props2.popupProps) === null || _props2$popupProps === void 0 ? void 0 : _props2$popupProps.delay;
        if (!popupInvisibleDelay) return defaultVisibleDelay[1] + 10;
        return popupInvisibleDelay[1] ? popupInvisibleDelay[1] + 10 : popupInvisibleDelay[0] + 10;
      });
      var handleMenuClick = function handleMenuClick(data, context) {
        var _props2$onClick;
        if (props2.hideAfterItemClick) {
          setTimeout(function () {
            var _props2$popupProps2, _props2$popupProps2$o, _props2$popupProps3, _props2$popupProps3$o;
            isPopupVisible.value = false;
            (_props2$popupProps2 = props2.popupProps) === null || _props2$popupProps2 === void 0 || (_props2$popupProps2$o = _props2$popupProps2.onVisibleChange) === null || _props2$popupProps2$o === void 0 || _props2$popupProps2$o.call(_props2$popupProps2, false, context);
            (_props2$popupProps3 = props2.popupProps) === null || _props2$popupProps3 === void 0 || (_props2$popupProps3$o = _props2$popupProps3["on-visible-change"]) === null || _props2$popupProps3$o === void 0 || _props2$popupProps3$o.call(_props2$popupProps3, false, context);
          }, invisibleDelay.value);
        }
        props2 === null || props2 === void 0 || (_props2$onClick = props2.onClick) === null || _props2$onClick === void 0 || _props2$onClick.call(props2, data, context);
        emit("click", data, context);
      };
      var handleVisibleChange = function handleVisibleChange(visible, context) {
        var _props2$popupProps4, _props2$popupProps4$o, _props2$popupProps5, _props2$popupProps5$o;
        if (!visible) {
          setTimeout(function () {
            isPopupVisible.value = visible;
          }, invisibleDelay.value);
        } else {
          isPopupVisible.value = visible;
        }
        (_props2$popupProps4 = props2.popupProps) === null || _props2$popupProps4 === void 0 || (_props2$popupProps4$o = _props2$popupProps4.onVisibleChange) === null || _props2$popupProps4$o === void 0 || _props2$popupProps4$o.call(_props2$popupProps4, visible, context);
        (_props2$popupProps5 = props2.popupProps) === null || _props2$popupProps5 === void 0 || (_props2$popupProps5$o = _props2$popupProps5["on-visible-change"]) === null || _props2$popupProps5$o === void 0 || _props2$popupProps5$o.call(_props2$popupProps5, visible, context);
      };
      return {
        dropdownClass: dropdownClass,
        handleMenuClick: handleMenuClick,
        isPopupVisible: isPopupVisible,
        handleVisibleChange: handleVisibleChange
      };
    },
    render: function render() {
      var _this$popupProps, _renderTNodeJSX;
      var h = arguments[0];
      var popupParams = _objectSpread$2v(_objectSpread$2v({
        disabled: this.disabled,
        placement: this.placement,
        trigger: this.trigger
      }, omit$2(this.popupProps, ["onVisibleChange", "on-visible-change"])), {}, {
        overlayInnerClassName: [this.dropdownClass, (_this$popupProps = this.popupProps) === null || _this$popupProps === void 0 ? void 0 : _this$popupProps.overlayInnerClassName]
      });
      var renderTNodeJSX = useTNodeJSX();
      var options = useDropdownOptions(this.$props, this.$slots);
      var trigger = (_renderTNodeJSX = renderTNodeJSX("default")) === null || _renderTNodeJSX === void 0 ? void 0 : _renderTNodeJSX[0];
      return h(Popup, {
        "props": _objectSpread$2v({}, _objectSpread$2v({
          destroyOnClose: true,
          visible: this.isPopupVisible,
          onVisibleChange: this.handleVisibleChange,
          expandAnimation: true
        }, popupParams))
      }, [h(_DropdownMenu, {
        "slot": "content",
        "props": _objectSpread$2v({}, _objectSpread$2v(_objectSpread$2v({}, this.$props), {}, {
          options: options.value,
          onClick: this.handleMenuClick
        }))
      }), trigger]);
    }
  });

  var Dropdown = withInstall$1(_Dropdown);
  var DropdownItem = withInstall$1(_DropdownItem);
  var DropdownMenu = withInstall$1(_DropdownMenu);

  var props$16 = {
    collapsed: Boolean,
    expanded: {
      type: Array
    },
    defaultExpanded: {
      type: Array
    },
    expandMutex: Boolean,
    expandType: {
      type: String,
      "default": "normal",
      validator: function validator(val) {
        return ["normal", "popup"].includes(val);
      }
    },
    logo: {
      type: Function
    },
    operations: {
      type: Function
    },
    theme: {
      type: String,
      "default": "light",
      validator: function validator(val) {
        return ["light", "dark"].includes(val);
      }
    },
    value: {
      type: [String, Number]
    },
    defaultValue: {
      type: [String, Number]
    },
    width: {
      type: [String, Number, Array],
      "default": "232px"
    },
    onChange: Function,
    onExpand: Function
  };

  function _classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
  }

  function _defineProperties(e, r) {
    for (var t = 0; t < r.length; t++) {
      var o = r[t];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
    }
  }
  function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
      writable: !1
    }), e;
  }

  var _getTreePaths = function getTreePaths(node, val, ans) {
    if (!node) return;
    for (var i = 0; i < node.children.length; ++i) {
      var child = node.children[i];
      if (child.value === val) return [].concat(_toConsumableArray(ans), [node.value]);
      var target = _getTreePaths(child, val, [].concat(_toConsumableArray(ans), [node.value]));
      if (target) return target;
    }
  };
  var _getTreeSameParentNodes = function getTreeSameParentNodes(node, val) {
    if (!node) return;
    for (var i = 0; i < node.children.length; ++i) {
      var child = node.children[i];
      if (child.value === val) return node.children;
      var target = _getTreeSameParentNodes(child, val);
      if (target) return target;
    }
  };
  var _DFS = function DFS(root, val) {
    if (root.value === val) return root;
    if (root.children.length > 0) {
      for (var i = 0, len = root.children.length; i < len; i++) {
        var res = _DFS(root.children[i], val);
        if (res) return res;
      }
    }
  };
  var VMenu = /*#__PURE__*/function () {
    function VMenu(options) {
      _classCallCheck(this, VMenu);
      _defineProperty$2(this, "data", null);
      _defineProperty$2(this, "cache", /* @__PURE__ */new Set());
      _defineProperty$2(this, "isMutex", false);
      _defineProperty$2(this, "expandValues", null);
      var root = {
        value: null,
        parent: null,
        children: []
      };
      this.data = root;
      this.isMutex = options === null || options === void 0 ? void 0 : options.isMutex;
      this.expandValues = new Set(options === null || options === void 0 ? void 0 : options.expandValues);
    }
    return _createClass(VMenu, [{
      key: "add",
      value: function add(item) {
        var value = item.value,
          parent = item.parent,
          vnode = item.vnode;
        var node = {
          value: value,
          parent: parent,
          vnode: vnode,
          children: []
        };
        this.cache.forEach(function (data, v2, set) {
          if (item.value === data.parent) {
            node.children.push(data);
            set["delete"](data);
          }
        });
        if (item.parent == null) {
          this.data.children.push(node);
          node.parent = this.data;
        } else if (this.data.children.length > 0) {
          var pNode = _DFS(this.data, parent);
          if (pNode) {
            pNode.children.push(node);
          } else {
            this.cache.add(node);
          }
        } else {
          this.cache.add(node);
        }
      }
    }, {
      key: "select",
      value: function select(val) {
        var activeValues = _getTreePaths(this.data, val, []) || [];
        activeValues.push(val);
        return activeValues.filter(function (val2) {
          return val2 != null;
        });
      }
    }, {
      key: "expand",
      value: function expand(val) {
        var _this = this;
        if (this.expandValues.has(val)) {
          this.expandValues["delete"](val);
          return _toConsumableArray(this.expandValues);
        }
        this.expandValues.add(val);
        if (!this.isMutex) {
          return _toConsumableArray(this.expandValues);
        }
        var sameParentNodes = _getTreeSameParentNodes(this.data, val);
        var sameLevelSubmenuValues = new Set(sameParentNodes.filter(function (node) {
          var _node$children;
          return ((_node$children = node.children) === null || _node$children === void 0 ? void 0 : _node$children.length) > 0 && node.value !== val;
        }).map(function (child) {
          return child.value;
        }));
        this.expandValues.forEach(function (val2) {
          var isHit = sameLevelSubmenuValues.has(val2);
          if (isHit) {
            _this.expandValues["delete"](val2);
          }
        });
        return _toConsumableArray(this.expandValues);
      }
    }, {
      key: "getChild",
      value: function getChild(value) {
        var target = _DFS(this.data, value);
        return target ? target.children : [];
      }
    }]);
  }();

  function ownKeys$2v(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2u(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2v(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2v(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _Menu = VueCompositionAPI.defineComponent({
    name: "TMenu",
    props: _objectSpread$2u({}, props$16),
    model: {
      prop: "value",
      event: "change"
    },
    setup: function setup(props2, ctx) {
      var mode = VueCompositionAPI.ref(props2.expandType);
      var theme = VueCompositionAPI.computed(function () {
        return props2.theme;
      });
      var isMutex = VueCompositionAPI.computed(function () {
        return props2.expandMutex;
      });
      var classPrefix = usePrefixClass();
      var collapsed = VueCompositionAPI.computed(function () {
        return props2.collapsed;
      });
      var menuClass = VueCompositionAPI.computed(function () {
        return ["".concat(classPrefix.value, "-default-menu"), "".concat(classPrefix.value, "-menu--").concat(props2.theme), _defineProperty$2({}, "".concat(classPrefix.value, "-is-collapsed"), props2.collapsed)];
      });
      var innerClasses = VueCompositionAPI.computed(function () {
        return ["".concat(classPrefix.value, "-menu"), "".concat(classPrefix.value, "-menu--scroll")];
      });
      var expandWidth = VueCompositionAPI.computed(function () {
        var width = props2.width;
        var format = function format(val) {
          return typeof val === "number" ? "".concat(val, "px") : val;
        };
        if (Array.isArray(width)) return width.map(function (item) {
          return format(item);
        });
        return [format(width), "64px"];
      });
      var styles = VueCompositionAPI.computed(function () {
        return {
          height: "100%",
          width: props2.collapsed ? expandWidth.value[1] : expandWidth.value[0]
        };
      });
      var activeValue = VueCompositionAPI.ref(props2.defaultValue || props2.value);
      var activeValues = VueCompositionAPI.ref([]);
      var expandValues = VueCompositionAPI.ref(props2.expanded || []);
      var deliver = function deliver(evt) {
        var func = "on".concat(evt[0].toUpperCase() + evt.slice(1));
        return function (val) {
          if (typeof props2[func] === "function") {
            props2[func](val);
          }
          ctx.emit(evt, val);
        };
      };
      var emitChange = deliver("change");
      var emitExpand = deliver("expand");
      VueCompositionAPI.watchEffect(function () {
        mode.value = props2.collapsed ? "popup" : props2.expandType;
      });
      var vMenu = new VMenu({
        isMutex: isMutex.value,
        expandValues: expandValues.value
      });
      VueCompositionAPI.provide("TdMenu", {
        activeValue: activeValue,
        activeValues: activeValues,
        expandValues: expandValues,
        mode: mode,
        theme: theme,
        isHead: false,
        vMenu: vMenu,
        collapsed: collapsed,
        select: function select(value) {
          emitChange(value);
        },
        open: function open(value, type) {
          var expanded = _toConsumableArray(expandValues.value);
          if (mode.value === "normal") {
            expanded = vMenu.expand(value);
          } else {
            var index = expanded.indexOf(value);
            if (type === "add") {
              if (index === -1) {
                expanded.push(value);
              }
            } else if (type === "remove") {
              expanded.splice(index, 1);
            }
          }
          emitExpand(expanded);
        }
      });
      VueCompositionAPI.watch(function () {
        return props2.expanded;
      }, function (value) {
        expandValues.value = value;
        vMenu.expandValues = new Set(value);
      });
      var updateActiveValues = function updateActiveValues(value) {
        activeValue.value = value;
        activeValues.value = vMenu.select(value);
      };
      VueCompositionAPI.watch(function () {
        return props2.value;
      }, updateActiveValues);
      VueCompositionAPI.watch(function () {
        return props2.defaultValue;
      }, updateActiveValues);
      VueCompositionAPI.onMounted(function () {
        activeValues.value = vMenu.select(activeValue.value);
      });
      return {
        styles: styles,
        menuClass: menuClass,
        innerClasses: innerClasses,
        activeValue: activeValue,
        activeValues: activeValues,
        expandValues: expandValues,
        classPrefix: classPrefix
      };
    },
    render: function render() {
      var h = arguments[0];
      if (this.$slots.options) {
        console.warn("TDesign Warn: `options` slot is going to be deprecated, please use `operations` for slot instead.");
      }
      var operations = renderContent(this, "operations", "options");
      var logo = renderTNodeJSX(this, "logo");
      return h("div", {
        "class": this.menuClass,
        "style": this.styles
      }, [h("div", {
        "class": "".concat(this.classPrefix, "-default-menu__inner")
      }, [logo && h("div", {
        "class": "".concat(this.classPrefix, "-menu__logo")
      }, [logo]), h("ul", {
        "class": this.innerClasses
      }, [renderContent(this, "default", "content")]), operations && h("div", {
        "class": "".concat(this.classPrefix, "-menu__operations")
      }, [operations])])]);
    }
  });

  var props$15 = {
    expanded: {
      type: Array
    },
    defaultExpanded: {
      type: Array
    },
    expandType: {
      type: String,
      "default": "normal",
      validator: function validator(val) {
        return ["normal", "popup"].includes(val);
      }
    },
    logo: {
      type: Function
    },
    operations: {
      type: Function
    },
    theme: {
      type: String,
      "default": "light",
      validator: function validator(val) {
        return ["light", "dark"].includes(val);
      }
    },
    value: {
      type: [String, Number]
    },
    defaultValue: {
      type: [String, Number]
    },
    onChange: Function,
    onExpand: Function
  };

  var props$14 = {
    addable: Boolean,
    disabled: Boolean,
    list: {
      type: Array
    },
    placement: {
      type: String,
      "default": "top",
      validator: function validator(val) {
        if (!val) return true;
        return ["left", "top", "bottom", "right"].includes(val);
      }
    },
    scrollPosition: {
      type: String,
      "default": "auto",
      validator: function validator(val) {
        if (!val) return true;
        return ["auto", "start", "center", "end"].includes(val);
      }
    },
    size: {
      type: String,
      "default": "medium",
      validator: function validator(val) {
        if (!val) return true;
        return ["medium", "large"].includes(val);
      }
    },
    theme: {
      type: String,
      "default": "normal",
      validator: function validator(val) {
        if (!val) return true;
        return ["normal", "card"].includes(val);
      }
    },
    value: {
      type: [String, Number]
    },
    defaultValue: {
      type: [String, Number]
    },
    onAdd: Function,
    onChange: Function,
    onRemove: Function
  };

  var tabPanelProps = {
    "default": {
      type: Function
    },
    destroyOnHide: {
      type: Boolean,
      "default": true
    },
    disabled: Boolean,
    label: {
      type: [String, Function]
    },
    panel: {
      type: [String, Function]
    },
    removable: Boolean,
    value: {
      type: [String, Number]
    },
    onRemove: Function,
    lazy: {
      type: Boolean,
      "default": false
    }
  };

  function updateTable(parentRef) {
    var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    if (!parentRef || !parentRef.$children || level >= 6) return;
    var children = parentRef.$children;
    for (var i = 0, len = children.length; i < len; i++) {
      var _node$$options, _node$$children;
      var node = children[i];
      var name = node === null || node === void 0 || (_node$$options = node.$options) === null || _node$$options === void 0 ? void 0 : _node$$options.name;
      if (name && /(TTable|TBaseTable|TPrimaryTable|TEnhancedTable)/i.test(name) && node.refreshTable) {
        node.refreshTable();
        return;
      }
      if (node !== null && node !== void 0 && (_node$$children = node.$children) !== null && _node$$children !== void 0 && _node$$children.length) {
        updateTable(node, level + 1);
      }
    }
  }
  function updateElement(parentRef) {
    updateTable(parentRef);
  }

  function ownKeys$2u(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2t(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2u(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2u(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$s = getClassPrefixMixins("tab-panel");
  var _TabPanel = mixins(Vue__default["default"], classPrefixMixins$s).extend({
    name: "TTabPanel",
    props: _objectSpread$2t({}, tabPanelProps),
    data: function data() {
      return {
        loaded: false
      };
    },
    inject: {
      parent: {
        "default": null
      }
    },
    computed: {
      active: function active() {
        var _ref = this.parent || {},
          value = _ref.value;
        var result = this.value === value;
        if (result) {
          this.loaded = true;
        }
        return result;
      }
    },
    updated: function updated() {
      var _this$parent,
        _this$parent$updatePa,
        _this = this;
      (_this$parent = this.parent) === null || _this$parent === void 0 || (_this$parent$updatePa = _this$parent.updatePanels) === null || _this$parent$updatePa === void 0 || _this$parent$updatePa.call(_this$parent, {
        force: true
      });
      if (!this.destroyOnHide) {
        var timer = setTimeout(function () {
          updateElement(_this);
          clearTimeout(timer);
        }, 0);
      }
    },
    render: function render() {
      var h = arguments[0];
      var destroyOnHide = this.destroyOnHide,
        active = this.active,
        lazy = this.lazy,
        loaded = this.loaded;
      if (destroyOnHide && !active || lazy && !loaded) return null;
      return h("div", {
        "class": this.componentName,
        "directives": [{
          name: "show",
          value: active
        }]
      }, [renderContent(this, "default", "panel")]);
    }
  });

  var classPrefixMixins$r = getClassPrefixMixins("tab-nav__item");
  var keepAnimationMixins$5 = getKeepAnimationMixins();
  var TTabNavItem = mixins(keepAnimationMixins$5, classPrefixMixins$r, getGlobalIconMixins()).extend({
    name: "TTabNavItem",
    directives: {
      ripple: Ripple
    },
    props: {
      index: Number,
      active: {
        type: Boolean
      },
      theme: props$14.theme,
      size: props$14.size,
      placement: props$14.placement,
      label: {
        type: null
      },
      disabled: tabPanelProps.disabled,
      removable: tabPanelProps.removable,
      value: tabPanelProps.value
    },
    computed: {
      navItemClass: function navItemClass() {
        return _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({}, "".concat(this.classPrefix, "-tabs__nav-item"), true), "".concat(this.classPrefix, "-tabs__nav--card"), this.theme === "card"), "".concat(this.classPrefix, "-is-disabled"), this.disabled), "".concat(this.classPrefix, "-is-active"), this.active), "".concat(this.classPrefix, "-is-left"), this.placement === "left"), "".concat(this.classPrefix, "-is-right"), this.placement === "right"), "".concat(this.classPrefix, "-size-m"), this.size === "medium"), "".concat(this.classPrefix, "-size-l"), this.size === "large");
      }
    },
    methods: {
      removeBtnClick: function removeBtnClick(e) {
        e.stopPropagation();
        emitEvent$1(this, "remove", {
          e: e,
          value: this.value,
          index: this.index
        });
      },
      onClickNav: function onClickNav(e) {
        if (this.disabled) return;
        e.stopPropagation();
        emitEvent$1(this, "click", e);
      },
      renderCardItem: function renderCardItem() {
        var h = this.$createElement;
        var _this$useGlobalIcon = this.useGlobalIcon({
            CloseIcon: TdCloseIcon
          }),
          CloseIcon = _this$useGlobalIcon.CloseIcon;
        return h("div", {
          "class": this.navItemClass,
          "on": {
            "click": this.onClickNav
          },
          "directives": [{
            name: "ripple",
            value: this.keepAnimation.ripple
          }]
        }, [h("span", {
          "class": "".concat(this.classPrefix, "-tabs__nav-item-text-wrapper")
        }, [this.label]), this.removable && !this.disabled ? h(CloseIcon, {
          "class": "remove-btn",
          "nativeOn": {
            "click": this.removeBtnClick
          }
        }) : null]);
      },
      renderNormalItem: function renderNormalItem() {
        var h = this.$createElement;
        var _this$useGlobalIcon2 = this.useGlobalIcon({
            CloseIcon: TdCloseIcon
          }),
          CloseIcon = _this$useGlobalIcon2.CloseIcon;
        return h("div", {
          "class": this.navItemClass,
          "on": {
            "click": this.onClickNav
          }
        }, [h("div", {
          "class": ["".concat(this.classPrefix, "-tabs__nav-item-wrapper"), _defineProperty$2(_defineProperty$2({}, "".concat(this.classPrefix, "-is-disabled"), this.disabled), "".concat(this.classPrefix, "-is-active"), this.active)],
          "directives": [{
            name: "ripple",
            value: this.keepAnimation.ripple
          }]
        }, [h("span", {
          "class": "".concat(this.classPrefix, "-tabs__nav-item-text-wrapper")
        }, [this.label])]), this.removable && !this.disabled ? h(CloseIcon, {
          "class": "remove-btn",
          "nativeOn": {
            "click": this.removeBtnClick
          }
        }) : null]);
      }
    },
    render: function render() {
      return this.theme === "card" ? this.renderCardItem() : this.renderNormalItem();
    }
  });

  var getDomWidth = function getDomWidth(dom) {
    return (dom === null || dom === void 0 ? void 0 : dom.offsetWidth) || 0;
  };
  var getDomOffsetLeft = function getDomOffsetLeft(dom) {
    return (dom === null || dom === void 0 ? void 0 : dom.offsetLeft) || 0;
  };
  function calculateOffset(depElement, offset, scrollPosition) {
    var navsContainer = depElement.navsContainer,
      activeTab = depElement.activeTab,
      rightOperations = depElement.rightOperations,
      leftOperations = depElement.leftOperations;
    var tabWidth = getDomWidth(activeTab);
    var wrapWidth = getDomWidth(navsContainer);
    var tabOffset = getDomOffsetLeft(activeTab);
    var rightOperationsWidth = getDomWidth(rightOperations);
    var leftOperationsWidth = getDomWidth(leftOperations);
    if (scrollPosition === "auto") {
      if (tabOffset - leftOperationsWidth < offset) {
        return tabOffset - leftOperationsWidth;
      }
      if (tabOffset + tabWidth > offset + wrapWidth - rightOperationsWidth) {
        return tabOffset + tabWidth - wrapWidth + rightOperationsWidth;
      }
    } else if (scrollPosition === "start") {
      return tabOffset - leftOperationsWidth;
    } else if (scrollPosition === "center") {
      return tabOffset + (tabWidth - wrapWidth) / 2;
    } else if (scrollPosition === "end") {
      return tabOffset + tabWidth - wrapWidth + rightOperationsWidth;
    }
    return offset;
  }
  function calcPrevOrNextOffset(elements, offset, action) {
    var navsContainer = elements.navsContainer,
      activeTab = elements.activeTab;
    var navsContainerWidth = getDomWidth(navsContainer);
    var activeTabWidth = getDomWidth(activeTab);
    if (action === "next") {
      return offset + navsContainerWidth - activeTabWidth;
    }
    return offset - navsContainerWidth + activeTabWidth;
  }
  function calcMaxOffset(elements) {
    var navsWrap = elements.navsWrap,
      navsContainer = elements.navsContainer,
      rightOperations = elements.rightOperations,
      toRightBtn = elements.toRightBtn;
    var wrapWidth = getDomWidth(navsWrap);
    var containerWidth = getDomWidth(navsContainer);
    var rightOperationsWidth = getDomWidth(rightOperations);
    var toRightBtnWidth = getDomWidth(toRightBtn);
    return wrapWidth - containerWidth + rightOperationsWidth - toRightBtnWidth;
  }
  function calcValidOffset(offset, maxOffset) {
    return Math.max(0, Math.min(offset, maxOffset));
  }

  function ownKeys$2t(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2s(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2t(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2t(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$q = getClassPrefixMixins("tab__nav");
  var TTabNav = mixins(classPrefixMixins$q, getGlobalIconMixins()).extend({
    name: "TTabNav",
    components: {
      TTabNavItem: TTabNavItem
    },
    props: {
      theme: props$14.theme,
      panels: {
        type: Array,
        "default": function _default() {
          return [];
        }
      },
      value: props$14.value,
      placement: props$14.placement,
      scrollPosition: props$14.scrollPosition,
      size: props$14.size,
      disabled: props$14.disabled,
      addable: props$14.addable
    },
    data: function data() {
      return {
        scrollLeft: 0,
        maxScrollLeft: 0,
        navBarStyle: {}
      };
    },
    computed: {
      navs: function navs() {
        var _this = this;
        return this.panels.map(function (panel, index) {
          return {
            ref: "tabItem".concat(index),
            key: panel.value,
            theme: _this.theme,
            size: _this.size,
            placement: _this.placement,
            active: panel.value === _this.value,
            disabled: _this.disabled || panel.disabled,
            removable: panel.removable,
            value: panel.value,
            panel: panel
          };
        });
      },
      wrapTransformStyle: function wrapTransformStyle() {
        if (["left", "right"].includes(this.placement.toLowerCase())) return {};
        return {
          transform: "translate(".concat(-this.scrollLeft, "px, 0)")
        };
      },
      dataCanUpdateNavBarStyle: function dataCanUpdateNavBarStyle() {
        return [this.scrollLeft, this.placement, this.theme, this.navs, this.value];
      },
      iconBaseClass: function iconBaseClass() {
        return _defineProperty$2(_defineProperty$2(_defineProperty$2({}, "".concat(this.classPrefix, "-tabs__btn"), true), "".concat(this.classPrefix, "-size-m"), this.size === "medium"), "".concat(this.classPrefix, "-size-l"), this.size === "large");
      },
      leftIconClass: function leftIconClass() {
        return _objectSpread$2s(_defineProperty$2({}, "".concat(this.classPrefix, "-tabs__btn--left"), true), this.iconBaseClass);
      },
      rightIconClass: function rightIconClass() {
        return _objectSpread$2s(_defineProperty$2({}, "".concat(this.classPrefix, "-tabs__btn--right"), true), this.iconBaseClass);
      },
      addIconClass: function addIconClass() {
        return _objectSpread$2s(_defineProperty$2({}, "".concat(this.classPrefix, "-tabs__add-btn"), true), this.iconBaseClass);
      },
      navContainerClass: function navContainerClass() {
        return _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({}, "".concat(this.classPrefix, "-tabs__nav-container"), true), "".concat(this.classPrefix, "-tabs__nav--card"), this.theme === "card"), "".concat(this.classPrefix, "-is-").concat(this.placement), true), "".concat(this.classPrefix, "-is-addable"), this.theme === "card" && this.addable);
      },
      navScrollContainerClass: function navScrollContainerClass() {
        return _defineProperty$2(_defineProperty$2({}, "".concat(this.classPrefix, "-tabs__nav-scroll"), true), "".concat(this.classPrefix, "-is-scrollable"), this.canToLeft || this.canToRight);
      },
      navsWrapClass: function navsWrapClass() {
        return ["".concat(this.classPrefix, "-tabs__nav-wrap"), "".concat(this.classPrefix, "-is-smooth"), _defineProperty$2({}, "".concat(this.classPrefix, "-is-vertical"), this.placement === "left" || this.placement === "right")];
      },
      navBarClass: function navBarClass() {
        return ["".concat(this.classPrefix, "-tabs__bar"), "".concat(this.classPrefix, "-is-").concat(this.placement)];
      },
      navsContainerStyle: function navsContainerStyle() {
        return this.addable ? {
          "min-height": "48px"
        } : null;
      },
      activeElement: function activeElement() {
        var activeIndx = this.navs.findIndex(function (nav) {
          return nav.active;
        });
        if (activeIndx > -1) {
          var _this$$refs;
          return (_this$$refs = this.$refs["tabItem".concat(activeIndx)]) === null || _this$$refs === void 0 ? void 0 : _this$$refs.$el;
        }
        return null;
      },
      canToLeft: function canToLeft() {
        return this.scrollLeft > 1;
      },
      canToRight: function canToRight() {
        return this.scrollLeft < this.maxScrollLeft - 1;
      }
    },
    watch: {
      dataCanUpdateNavBarStyle: function dataCanUpdateNavBarStyle() {
        var _this2 = this;
        this.$nextTick(function () {
          _this2.calculateNavBarStyle();
        });
      },
      value: function value() {
        var _this3 = this;
        this.$nextTick(function () {
          _this3.moveActiveTabIntoView();
        });
      },
      navs: function navs() {
        var _this4 = this;
        this.$nextTick(function () {
          _this4.getMaxScrollLeft();
          _this4.moveActiveTabIntoView();
        });
      }
    },
    methods: {
      calculateNavBarStyle: function calculateNavBarStyle() {
        var _this5 = this;
        var getNavBarStyle = function getNavBarStyle() {
          if (_this5.theme === "card") return {};
          var getPropName = function getPropName() {
            if (["left", "right"].includes(_this5.placement.toLowerCase())) {
              return ["height", "top"];
            }
            return ["width", "left"];
          };
          var offset = 0;
          var activeElement = _this5.activeElement;
          if (!activeElement) return {};
          var _getPropName = getPropName(),
            _getPropName2 = _slicedToArray(_getPropName, 2),
            sizePropName = _getPropName2[0],
            offsetPropName = _getPropName2[1];
          var i = 0;
          for (; i < _this5.navs.length; i++) {
            var _this5$$refs;
            if (_this5.navs[i].active) {
              break;
            }
            offset += ((_this5$$refs = _this5.$refs["tabItem".concat(i)]) === null || _this5$$refs === void 0 || (_this5$$refs = _this5$$refs.$el) === null || _this5$$refs === void 0 ? void 0 : _this5$$refs["client".concat(firstUpperCase$1(sizePropName))]) || 0;
          }
          return _defineProperty$2(_defineProperty$2({}, offsetPropName, "".concat(offset, "px")), sizePropName, "".concat((activeElement === null || activeElement === void 0 ? void 0 : activeElement["client".concat(firstUpperCase$1(sizePropName))]) || 0, "px"));
        };
        this.navBarStyle = getNavBarStyle();
      },
      watchDomChange: function watchDomChange() {
        var _this6 = this;
        var onResize = debounce$1(function () {
          _this6.getMaxScrollLeft();
        }, 300);
        window.addEventListener("resize", onResize);
        this.$once("beforeDestroy", function () {
          window.removeEventListener("resize", onResize);
        });
        if (!this.$refs.navsContainer) return;
        if (!window.ResizeObserver) return;
        var resizeObserver = new window.ResizeObserver(onResize);
        resizeObserver.observe(this.$refs.navsContainer);
        this.$once("beforeDestroy", function () {
          resizeObserver.disconnect();
        });
      },
      setOffset: function setOffset(offset) {
        this.scrollLeft = calcValidOffset(offset, this.maxScrollLeft);
      },
      getMaxScrollLeft: function getMaxScrollLeft() {
        this.maxScrollLeft = calcMaxOffset({
          navsWrap: this.$refs.navsWrap,
          navsContainer: this.$refs.navsContainer,
          rightOperations: this.$refs.rightOperationsZone,
          toRightBtn: this.$refs.rightIcon
        });
      },
      handleScroll: function handleScroll(action) {
        var offset = calcPrevOrNextOffset({
          navsContainer: this.$refs.navsContainer,
          activeTab: this.activeElement
        }, this.scrollLeft, action);
        this.setOffset(offset);
      },
      handleWheel: function handleWheel(e) {
        if (!this.canToLeft && !this.canToRight) return;
        e.preventDefault();
        var deltaX = e.deltaX,
          deltaY = e.deltaY;
        if (Math.abs(deltaX) > Math.abs(deltaY)) {
          this.setOffset(this.scrollLeft + deltaX);
        } else {
          this.setOffset(this.scrollLeft + deltaY);
        }
      },
      moveActiveTabIntoView: function moveActiveTabIntoView() {
        if (["left", "right"].includes(this.placement.toLowerCase())) return;
        this.setOffset(calculateOffset({
          activeTab: this.activeElement,
          navsContainer: this.$refs.navsContainer,
          leftOperations: this.$refs.leftOperationsZone,
          rightOperations: this.$refs.rightOperationsZone
        }, this.scrollLeft, this.scrollPosition));
      },
      handleAddTab: function handleAddTab(e) {
        emitEvent$1(this, "add", {
          e: e
        });
      },
      tabClick: function tabClick(event, nav) {
        var value = nav.value,
          disabled = nav.disabled;
        if (disabled || this.value === value) {
          return false;
        }
        emitEvent$1(this, "change", value);
      },
      removeBtnClick: function removeBtnClick(_ref6) {
        var e = _ref6.e,
          value = _ref6.value,
          index = _ref6.index;
        emitEvent$1(this, "remove", {
          e: e,
          value: value,
          index: index
        });
      },
      renderPanelContent: function renderPanelContent() {
        var _this7 = this;
        var h = this.$createElement;
        return this.navs.map(function (panel, index) {
          return h(TTabNavItem, {
            "ref": "tabItem".concat(index),
            "attrs": {
              "index": index,
              "theme": panel.theme,
              "size": panel.size,
              "placement": panel.placement,
              "active": panel.active,
              "disabled": panel.disabled,
              "removable": panel.removable,
              "value": panel.value,
              "label": renderTNodeJSX(panel.panel, "label", "\u9009\u9879\u5361".concat(index + 1))
            },
            "key": panel.value,
            "on": {
              "click": function click(e) {
                return _this7.tabClick(e, panel.panel);
              },
              "remove": _this7.removeBtnClick
            }
          });
        });
      },
      renderArrows: function renderArrows() {
        var _this8 = this;
        var h = this.$createElement;
        var _this$useGlobalIcon = this.useGlobalIcon({
            ChevronLeftIcon: TdChevronLeftIcon,
            ChevronRightIcon: TdChevronRightIcon,
            AddIcon: TdAddIcon
          }),
          ChevronLeftIcon = _this$useGlobalIcon.ChevronLeftIcon,
          ChevronRightIcon = _this$useGlobalIcon.ChevronRightIcon,
          AddIcon = _this$useGlobalIcon.AddIcon;
        return [h("div", {
          "ref": "leftOperationsZone",
          "class": ["".concat(this.classPrefix, "-tabs__operations"), "".concat(this.classPrefix, "-tabs__operations--left")]
        }, [h("transition", {
          "attrs": {
            "name": "fade",
            "mode": "out-in",
            "appear": true
          }
        }, [this.canToLeft ? h("div", {
          "ref": "leftIcon",
          "class": this.leftIconClass,
          "on": {
            "click": function click() {
              return _this8.handleScroll("prev");
            }
          }
        }, [h(ChevronLeftIcon)]) : null])]), h("div", {
          "ref": "rightOperationsZone",
          "class": ["".concat(this.classPrefix, "-tabs__operations"), "".concat(this.classPrefix, "-tabs__operations--right")]
        }, [h("transition", {
          "attrs": {
            "name": "fade",
            "mode": "out-in",
            "appear": true
          }
        }, [this.canToRight ? h("div", {
          "ref": "rightIcon",
          "class": this.rightIconClass,
          "on": {
            "click": function click() {
              return _this8.handleScroll("next");
            }
          }
        }, [h(ChevronRightIcon)]) : null]), this.addable ? h("div", {
          "class": this.addIconClass,
          "on": {
            "click": this.handleAddTab
          }
        }, [h(AddIcon)]) : null])];
      },
      renderNavs: function renderNavs() {
        var h = this.$createElement;
        return h("div", {
          "class": this.navContainerClass
        }, [h("div", {
          "class": this.navScrollContainerClass,
          "on": {
            "wheel": this.handleWheel
          }
        }, [h("div", {
          "ref": "navsWrap",
          "class": this.navsWrapClass,
          "style": this.wrapTransformStyle
        }, [this.renderNavBar(), this.renderPanelContent()])])]);
      },
      renderNavBar: function renderNavBar() {
        var h = this.$createElement;
        if (this.theme === "card") return null;
        return h("div", {
          "class": this.navBarClass,
          "style": this.navBarStyle
        });
      }
    },
    mounted: function mounted() {
      var _this9 = this;
      this.$nextTick(function () {
        _this9.watchDomChange();
        _this9.calculateNavBarStyle();
        _this9.getMaxScrollLeft();
      });
      setTimeout(function () {
        _this9.moveActiveTabIntoView();
      });
    },
    render: function render() {
      var h = arguments[0];
      return h("div", {
        "ref": "navsContainer",
        "class": ["".concat(this.classPrefix, "-tabs__nav")],
        "style": this.navsContainerStyle
      }, [this.renderArrows(), this.renderNavs()]);
    }
  });

  function ownKeys$2s(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2r(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2s(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2s(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$p = getClassPrefixMixins("tabs");
  var _Tabs = mixins(Vue__default["default"], classPrefixMixins$p).extend(_objectSpread$2r(_objectSpread$2r({
    name: "TTabs",
    model: {
      prop: "value",
      event: "change"
    },
    components: {
      TTabPanel: _TabPanel,
      TTabNav: TTabNav
    }
  }, {
    listPanels: null
  }), {}, {
    props: _objectSpread$2r({}, props$14),
    provide: function provide() {
      return {
        parent: this
      };
    },
    data: function data() {
      return {
        panels: []
      };
    },
    watch: {
      list: {
        handler: function handler() {
          this.listPanels = this.createListPanels();
        },
        deep: true
      }
    },
    mounted: function mounted() {
      this.updatePanels();
    },
    updated: function updated() {
      var _this = this;
      this.$nextTick(function () {
        _this.updatePanels();
      });
    },
    methods: {
      updatePanels: function updatePanels() {
        var _this2 = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$force = _ref.force,
          force = _ref$force === void 0 ? false : _ref$force;
        if (!this.listPanels) {
          this.panels = this.panels || [];
          return;
        }
        var newPanels = this.listPanels.filter(function (child) {
          return getVNodeComponentName(child) === getVueComponentName(_TabPanel);
        }).map(function (panel) {
          return panel.componentInstance;
        }).filter(Boolean);
        var isUnchanged = function isUnchanged() {
          return newPanels.length === _this2.panels.length && _this2.panels.every(function (panel, index) {
            return panel === newPanels[index];
          });
        };
        if (isUnchanged() && !force) return;
        this.panels = newPanels;
      },
      onAddTab: function onAddTab(e) {
        emitEvent$1(this, "add", {
          e: e
        });
      },
      onChangeTab: function onChangeTab(value) {
        emitEvent$1(this, "change", value);
      },
      onRemoveTab: function onRemoveTab(_ref2) {
        var e = _ref2.e,
          value = _ref2.value,
          index = _ref2.index;
        var panel = this.panels[index];
        var eventData = {
          value: value,
          index: index,
          e: e
        };
        emitEvent$1(this, "remove", eventData);
        if (!panel) return;
        emitEvent$1(panel, "remove", eventData);
      },
      renderHeader: function renderHeader() {
        var h = this.$createElement;
        var tabNavProps = {
          theme: this.theme,
          value: this.value,
          size: this.size,
          disabled: this.disabled,
          placement: this.placement,
          addable: this.addable,
          panels: this.panels,
          scrollPosition: this.scrollPosition
        };
        return h("div", {
          "class": _defineProperty$2(_defineProperty$2({}, "".concat(this.componentName, "__header"), true), "".concat(this.classPrefix, "-is-").concat(this.placement), true)
        }, [h(TTabNav, helper([{}, {
          "props": tabNavProps
        }, {
          "on": {
            "change": this.onChangeTab,
            "add": this.onAddTab,
            "remove": this.onRemoveTab
          }
        }]))]);
      },
      createListPanels: function createListPanels() {
        var h = this.$createElement;
        return this.list.map(function (item) {
          return h(_TabPanel, helper([{}, {
            "props": _objectSpread$2r({}, item)
          }]));
        });
      },
      renderList: function renderList() {
        if (!this.listPanels) {
          return this.createListPanels();
        }
        return this.listPanels;
      },
      renderContent: function renderContent() {
        var _this$$scopedSlots$de, _this$$scopedSlots;
        var h = this.$createElement;
        this.listPanels = this.list ? this.renderList() : ((_this$$scopedSlots$de = (_this$$scopedSlots = this.$scopedSlots)["default"]) === null || _this$$scopedSlots$de === void 0 ? void 0 : _this$$scopedSlots$de.call(_this$$scopedSlots, {})) || [];
        return h("div", {
          "class": ["".concat(this.componentName, "__content")]
        }, [this.listPanels]);
      }
    },
    render: function render() {
      var h = arguments[0];
      return h("div", {
        "class": this.componentName
      }, [this.placement !== "bottom" ? [this.renderHeader(), this.renderContent()] : [this.renderContent(), this.renderHeader()]]);
    }
  }));

  var Tabs = withInstall$1(mapProps(["value"], {
    model: {
      prop: "value",
      event: "change"
    }
  })(_Tabs));
  var TabPanel = withInstall$1(_TabPanel);

  var _HeadMenu = VueCompositionAPI.defineComponent({
    name: "THeadMenu",
    props: props$15,
    model: {
      prop: "value",
      event: "change"
    },
    components: {
      Tabs: Tabs,
      TabPanel: TabPanel
    },
    setup: function setup(props2, ctx) {
      var activeValue = VueCompositionAPI.ref(props2.defaultValue || props2.value);
      var activeValues = VueCompositionAPI.ref([]);
      var expandValues = VueCompositionAPI.ref(props2.defaultExpanded || props2.expanded || []);
      var classPrefix = usePrefixClass();
      var theme = VueCompositionAPI.computed(function () {
        return props2.theme;
      });
      var menuClass = VueCompositionAPI.computed(function () {
        return ["".concat(classPrefix.value, "-menu"), "".concat(classPrefix.value, "-head-menu"), "".concat(classPrefix.value, "-menu--").concat(props2.theme)];
      });
      var mode = VueCompositionAPI.ref(props2.expandType);
      var submenu = VueCompositionAPI.reactive([]);
      var deliver = function deliver(evt) {
        var func = "on".concat(evt[0].toUpperCase() + evt.slice(1));
        return function (val) {
          if (typeof props2[func] === "function") {
            props2[func](val);
          }
          ctx.emit(evt, val);
        };
      };
      var emitChange = deliver("change");
      var emitExpand = deliver("expand");
      var vMenu = new VMenu({
        isMutex: true,
        expandValues: expandValues.value
      });
      VueCompositionAPI.provide("TdMenu", {
        mode: mode,
        theme: theme,
        vMenu: vMenu,
        isHead: true,
        expandValues: expandValues,
        activeValue: activeValue,
        activeValues: activeValues,
        select: function select(value) {
          emitChange(value);
        },
        open: function open(value, type) {
          var expanded = _toConsumableArray(expandValues.value);
          var index = expanded.indexOf(value);
          if (mode.value === "popup") {
            if (type === "add") {
              if (index === -1) {
                expanded.push(value);
              }
            } else if (type === "remove") {
              expanded.splice(index, 1);
            }
          } else {
            expanded.splice(0, 1);
            if (index === -1) {
              expanded.push(value);
            }
          }
          emitExpand(expanded);
        }
      });
      var handleTabChange = function handleTabChange(value) {
        emitChange(value);
      };
      var handleSubmenuExpand = function handleSubmenuExpand(value) {
        var ans = vMenu.getChild(value);
        submenu.length = 0;
        submenu.push.apply(submenu, _toConsumableArray(ans));
      };
      VueCompositionAPI.watch(function () {
        return props2.expanded;
      }, function (value) {
        expandValues.value = value;
        if (mode.value === "normal") {
          handleSubmenuExpand(value[0]);
        }
      });
      var updateActiveValues = function updateActiveValues(value) {
        activeValue.value = value;
        activeValues.value = vMenu.select(value);
      };
      VueCompositionAPI.watch(function () {
        return props2.value;
      }, updateActiveValues);
      VueCompositionAPI.watch(function () {
        return props2.defaultValue;
      }, updateActiveValues);
      VueCompositionAPI.watch(function () {
        return props2.expandType;
      }, function (value) {
        mode.value = value;
      });
      VueCompositionAPI.onMounted(function () {
        var _expandValues$value;
        activeValues.value = vMenu.select(activeValue.value);
        if (((_expandValues$value = expandValues.value) === null || _expandValues$value === void 0 ? void 0 : _expandValues$value.length) > 0) {
          handleSubmenuExpand(expandValues.value[0]);
        }
      });
      return {
        mode: mode,
        menuClass: menuClass,
        expandValues: expandValues,
        activeValue: activeValue,
        activeValues: activeValues,
        submenu: submenu,
        handleTabChange: handleTabChange,
        classPrefix: classPrefix
      };
    },
    methods: {
      renderNormalSubmenu: function renderNormalSubmenu(node, depth) {
        var _this = this;
        var h = this.$createElement;
        if (node.length === 0) return null;
        return h("ul", {
          "class": ["".concat(this.classPrefix, "-head-menu__submenu"), "".concat(this.classPrefix, "-submenu")]
        }, [h("t-tabs", {
          "attrs": {
            "value": this.activeValues[depth]
          },
          "on": {
            "change": this.handleTabChange
          }
        }, [node.map(function (item) {
          return h("t-tab-panel", {
            "attrs": {
              "value": item.value,
              "label": typeof item.vnode === "string" ? item.vnode : item.vnode[0].text
            }
          }, [item.children && item.children.length > 0 ? _this.renderNormalSubmenu(item.children, depth + 1) : null]);
        })])]);
      }
    },
    render: function render() {
      var h = arguments[0];
      if (this.$slots.options) {
        console.warn("TDesign Warn: `options` slot is going to be deprecated, please use `operations` for slot instead.");
      }
      var operations = renderContent(this, "operations", "options");
      var logo = renderTNodeJSX(this, "logo");
      return h("div", {
        "class": this.menuClass
      }, [h("div", {
        "class": "".concat(this.classPrefix, "-head-menu__inner")
      }, [logo && h("div", {
        "class": "".concat(this.classPrefix, "-menu__logo")
      }, [logo]), h("ul", {
        "class": "".concat(this.classPrefix, "-menu")
      }, [renderContent(this, "default", "content")]), operations && h("div", {
        "class": "".concat(this.classPrefix, "-menu__operations")
      }, [operations])]), this.mode === "normal" && this.renderNormalSubmenu(this.submenu, 1)]);
    }
  });

  var props$13 = {
    content: {
      type: [String, Function]
    },
    "default": {
      type: [String, Function]
    },
    disabled: Boolean,
    icon: {
      type: Function
    },
    popupProps: {
      type: Object
    },
    title: {
      type: [String, Function]
    },
    value: {
      type: [String, Number]
    }
  };

  var classPrefixMixins$o = getClassPrefixMixins("fake-arrow");
  var FakeArrow = mixins(classPrefixMixins$o).extend({
    name: "TFakeArrow",
    props: {
      isActive: {
        type: Boolean
      },
      overlayClassName: {
        type: [String, Object, Array]
      },
      overlayStyle: {
        type: Object
      }
    },
    computed: {
      classes: function classes() {
        return [this.componentName, _defineProperty$2({}, "".concat(this.componentName, "--active"), this.isActive), this.overlayClassName];
      }
    },
    render: function render() {
      var h = arguments[0];
      return h("svg", {
        "class": this.classes,
        "attrs": {
          "width": "16",
          "height": "16",
          "viewBox": "0 0 16 16",
          "fill": "none",
          "xmlns": "http://www.w3.org/2000/svg"
        },
        "style": this.overlayStyle
      }, [h("path", {
        "attrs": {
          "d": "M3.75 5.7998L7.99274 10.0425L12.2361 5.79921",
          "stroke": "black",
          "stroke-opacity": "0.9",
          "stroke-width": "1.3"
        }
      })]);
    }
  });

  function useCollapseAnimation() {
    var beforeEnter = function beforeEnter(el) {
      el.dataset.oldPaddingTop = el.style.paddingTop;
      el.dataset.oldPaddingBottom = el.style.paddingBottom;
      el.style.height = "0";
      el.style.paddingTop = "0";
      el.style.paddingBottom = "0";
    };
    var enter = function enter(el) {
      el.dataset.oldOverflow = el.style.overflow;
      el.style.height = "".concat(el.scrollHeight, "px");
      el.style.paddingTop = el.dataset.oldPaddingTop;
      el.style.paddingBottom = el.dataset.oldPaddingBottom;
      el.style.overflow = "hidden";
    };
    var afterEnter = function afterEnter(el) {
      el.style.height = "";
      el.style.overflow = el.dataset.oldOverflow;
    };
    var beforeLeave = function beforeLeave(el) {
      el.dataset.oldPaddingTop = el.style.paddingTop;
      el.dataset.oldPaddingBottom = el.style.paddingBottom;
      el.dataset.oldOverflow = el.style.overflow;
      el.style.height = "".concat(el.scrollHeight, "px");
      el.style.overflow = "hidden";
    };
    var leave = function leave(el) {
      if (el.scrollHeight !== 0) {
        el.style.height = "0";
        el.style.paddingTop = "0";
        el.style.paddingBottom = "0";
      }
    };
    var afterLeave = function afterLeave(el) {
      el.style.height = "";
      el.style.overflow = el.dataset.oldOverflow;
      el.style.paddingTop = el.dataset.oldPaddingTop;
      el.style.paddingBottom = el.dataset.oldPaddingBottom;
    };
    return {
      beforeEnter: beforeEnter,
      enter: enter,
      afterEnter: afterEnter,
      beforeLeave: beforeLeave,
      leave: leave,
      afterLeave: afterLeave
    };
  }

  function ownKeys$2r(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2q(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2r(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2r(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var keepAnimationMixins$4 = getKeepAnimationMixins();
  var _Submenu = VueCompositionAPI.defineComponent({
    name: "TSubmenu",
    components: {
      FakeArrow: FakeArrow
    },
    mixins: [keepAnimationMixins$4],
    directives: {
      ripple: Ripple
    },
    props: props$13,
    setup: function setup(props2) {
      var menu = VueCompositionAPI.inject("TdMenu");
      var theme = menu.theme,
        activeValues = menu.activeValues,
        expandValues = menu.expandValues,
        mode = menu.mode,
        isHead = menu.isHead,
        open = menu.open;
      var submenu = VueCompositionAPI.inject("TdSubmenu", {});
      var setSubPopup = submenu.setSubPopup,
        closeParentPopup = submenu.closeParentPopup;
      var classPrefix = usePrefixClass();
      var isActive = VueCompositionAPI.computed(function () {
        return activeValues.value.indexOf(props2.value) > -1;
      });
      var popupVisible = VueCompositionAPI.ref(false);
      var isCursorInPopup = VueCompositionAPI.ref(false);
      var rippleColor = VueCompositionAPI.computed(function () {
        return theme.value === "light" ? "#E7E7E7" : "#383838";
      });
      var isOpen = VueCompositionAPI.computed(function () {
        if (mode.value === "popup") {
          return popupVisible.value;
        }
        return expandValues ? expandValues.value.includes(props2.value) : false;
      });
      var menuItems = VueCompositionAPI.ref([]);
      var isNested = VueCompositionAPI.ref(false);
      var popupWrapperRef = VueCompositionAPI.ref();
      var subPopupRef = VueCompositionAPI.ref();
      var submenuRef = VueCompositionAPI.ref();
      var transitionClass = usePrefixClass("slide-down");
      var classes = VueCompositionAPI.computed(function () {
        return ["".concat(classPrefix.value, "-submenu"), _defineProperty$2(_defineProperty$2({}, "".concat(classPrefix.value, "-is-disabled"), props2.disabled), "".concat(classPrefix.value, "-is-opened"), isOpen.value)];
      });
      var overlayInnerClassName = VueCompositionAPI.computed(function () {
        return ["".concat(classPrefix.value, "-menu__popup"), "".concat(classPrefix.value, "-is-").concat(isHead ? "horizontal" : "vertical"), _defineProperty$2({}, "".concat(classPrefix.value, "-is-opened"), popupVisible.value)];
      });
      var overlayClassName = VueCompositionAPI.computed(function () {
        var _props2$popupProps;
        return ["".concat(classPrefix.value, "-menu--").concat(theme.value), isHead && "".concat(classPrefix.value, "-is-head-menu"), _defineProperty$2({}, "".concat(classPrefix.value, "-menu-is-nested"), isNested.value), (_props2$popupProps = props2.popupProps) === null || _props2$popupProps === void 0 ? void 0 : _props2$popupProps.overlayClassName];
      });
      var submenuClass = VueCompositionAPI.computed(function () {
        return ["".concat(classPrefix.value, "-menu__item"), "".concat(classPrefix.value, "-menu__item-spacer"), "".concat(classPrefix.value, "-menu__item-spacer--").concat(isHead && !isNested.value ? "bottom" : "right"), _defineProperty$2(_defineProperty$2(_defineProperty$2({}, "".concat(classPrefix.value, "-is-disabled"), props2.disabled), "".concat(classPrefix.value, "-is-opened"), isOpen.value), "".concat(classPrefix.value, "-is-active"), isActive.value)];
      });
      var subClass = VueCompositionAPI.computed(function () {
        return ["".concat(classPrefix.value, "-menu__sub"), _defineProperty$2({}, "".concat(classPrefix.value, "-is-opened"), isOpen.value)];
      });
      var arrowClass = VueCompositionAPI.computed(function () {
        return [_defineProperty$2({}, "".concat(classPrefix.value, "-fake-arrow--active"), isOpen.value)];
      });
      var passSubPopupRefToParent = function passSubPopupRefToParent(val) {
        if (isFunction(setSubPopup)) {
          setSubPopup(val);
        }
      };
      var handleMouseEnter = function handleMouseEnter() {
        if (props2.disabled) return;
        setTimeout(function () {
          if (!popupVisible.value) {
            open(props2.value);
            VueCompositionAPI.nextTick(function () {
              passSubPopupRefToParent(popupWrapperRef.value);
            });
          }
          popupVisible.value = true;
        }, 0);
      };
      var targetInPopup = function targetInPopup(el) {
        return el === null || el === void 0 ? void 0 : el.classList.contains("".concat(classPrefix.value, "-menu__popup"));
      };
      var _loopInPopup = function loopInPopup(el) {
        if (!el) return false;
        return targetInPopup(el) || _loopInPopup(el.parentElement);
      };
      var handleMouseLeave = function handleMouseLeave(e) {
        setTimeout(function () {
          var inPopup = targetInPopup(e.relatedTarget);
          if (isCursorInPopup.value || inPopup) return;
          popupVisible.value = false;
        }, 0);
      };
      var handleMouseLeavePopup = function handleMouseLeavePopup(e) {
        var toElement = e.toElement,
          relatedTarget = e.relatedTarget;
        var target = toElement || relatedTarget;
        if (target === subPopupRef.value) return;
        var isSubmenu = function isSubmenu(el) {
          return el === submenuRef.value;
        };
        while (target !== null && target !== document && !isSubmenu(target)) {
          target = target.parentNode;
        }
        isCursorInPopup.value = false;
        if (!isSubmenu(target)) {
          popupVisible.value = false;
        }
        closeParentPopup === null || closeParentPopup === void 0 || closeParentPopup(e);
      };
      var handleEnterPopup = function handleEnterPopup() {
        isCursorInPopup.value = true;
      };
      var handleSubmenuItemClick = function handleSubmenuItemClick() {
        if (props2.disabled) return;
        open(props2.value);
      };
      VueCompositionAPI.watch(popupVisible, function (visible) {
        menu.open(props2.value, visible ? "add" : "remove");
      });
      var _toRefs = VueCompositionAPI.toRefs(props2),
        value = _toRefs.value;
      VueCompositionAPI.provide("TdSubmenu", VueCompositionAPI.reactive({
        value: value,
        addMenuItem: function addMenuItem(item) {
          menuItems.value.push(item);
          if (submenu) {
            submenu.addMenuItem(item);
          }
        },
        setSubPopup: function setSubPopup(ref2) {
          subPopupRef.value = ref2;
        },
        closeParentPopup: function closeParentPopup(e) {
          var related = e.relatedTarget;
          if (_loopInPopup(related)) return;
          handleMouseLeavePopup(e);
        }
      }));
      VueCompositionAPI.watch(popupWrapperRef, function () {
        passSubPopupRefToParent(popupWrapperRef.value);
      });
      VueCompositionAPI.onMounted(function () {
        var _menu$vMenu;
        menu === null || menu === void 0 || (_menu$vMenu = menu.vMenu) === null || _menu$vMenu === void 0 || _menu$vMenu.add({
          value: props2.value,
          parent: submenu === null || submenu === void 0 ? void 0 : submenu.value,
          vnode: isFunction(props2.title) ? [props2.title(VueCompositionAPI.h)] : props2.title
        });
        var instance = VueCompositionAPI.getCurrentInstance();
        var node = instance.parent;
        while (node && !/^t(head)?menu/i.test((_node$vnode = node.vnode) === null || _node$vnode === void 0 ? void 0 : _node$vnode.tag)) {
          var _node$vnode, _node$vnode2, _node;
          if (/submenu/i.test((_node$vnode2 = node.vnode) === null || _node$vnode2 === void 0 ? void 0 : _node$vnode2.tag)) {
            isNested.value = true;
            break;
          }
          node = (_node = node) === null || _node === void 0 ? void 0 : _node.parent;
        }
      });
      return {
        theme: theme,
        mode: mode,
        isHead: isHead,
        isNested: isNested,
        popupVisible: popupVisible,
        classes: classes,
        subClass: subClass,
        isOpen: isOpen,
        transitionClass: transitionClass,
        arrowClass: arrowClass,
        overlayInnerClassName: overlayInnerClassName,
        overlayClassName: overlayClassName,
        submenuClass: submenuClass,
        rippleColor: rippleColor,
        popupWrapperRef: popupWrapperRef,
        handleEnterPopup: handleEnterPopup,
        handleMouseEnter: handleMouseEnter,
        handleMouseLeave: handleMouseLeave,
        handleMouseLeavePopup: handleMouseLeavePopup,
        handleSubmenuItemClick: handleSubmenuItemClick,
        classPrefix: classPrefix
      };
    },
    methods: {
      renderPopup: function renderPopup(triggerElement) {
        var _this$popupProps, _this$popupProps$plac, _this$popupProps2;
        var h = this.$createElement;
        var placement = "right-top";
        if (!this.isNested && this.isHead) {
          placement = "bottom-left";
        }
        var popupWrapper = h("div", {
          "ref": "popupWrapperRef",
          "class": ["".concat(this.classPrefix, "-menu__spacer"), "".concat(this.classPrefix, "-menu__spacer--").concat(!this.isNested && this.isHead ? "top" : "left")],
          "on": {
            "mouseenter": this.handleEnterPopup,
            "mouseleave": this.handleMouseLeavePopup
          }
        }, [h("ul", {
          "class": "".concat(this.classPrefix, "-menu__popup-wrapper")
        }, [renderContent(this, "default", "content")])]);
        var realPopup = h(Popup, helper([{}, (_this$popupProps = this.popupProps) !== null && _this$popupProps !== void 0 ? _this$popupProps : {}, {
          "attrs": {
            "overlayInnerClassName": _toConsumableArray(this.overlayInnerClassName),
            "overlayClassName": _toConsumableArray(this.overlayClassName),
            "visible": this.popupVisible,
            "placement": (_this$popupProps$plac = (_this$popupProps2 = this.popupProps) === null || _this$popupProps2 === void 0 ? void 0 : _this$popupProps2.placement) !== null && _this$popupProps$plac !== void 0 ? _this$popupProps$plac : placement,
            "content": function content() {
              return popupWrapper;
            }
          }
        }]), [h("div", {
          "ref": "submenuRef",
          "class": this.submenuClass
        }, [triggerElement])]);
        return realPopup;
      },
      renderHeadSubmenu: function renderHeadSubmenu() {
        var h = this.$createElement;
        var icon = renderTNodeJSX(this, "icon");
        var rippleVal = this.keepAnimation.ripple ? this.rippleColor : false;
        var normalSubmenu = [h("div", {
          "directives": [{
            name: "ripple",
            value: rippleVal
          }],
          "class": this.submenuClass,
          "on": {
            "click": this.handleSubmenuItemClick
          }
        }, [renderTNodeJSX(this, "title")]), h("ul", {
          "style": "opacity: 0; width: 0; height: 0; overflow: hidden"
        }, [renderContent(this, "default", "content")])];
        var needRotate = this.mode === "popup" && this.isNested;
        var triggerElement = [icon, h("span", {
          "class": ["".concat(this.classPrefix, "-menu__content")]
        }, [renderTNodeJSX(this, "title", {
          silent: true
        })]), h(FakeArrow, {
          "attrs": {
            "overlayClassName": /menu/i.test(this.$parent.$options.name) ? this.arrowClass : null,
            "overlayStyle": {
              transform: "rotate(".concat(needRotate ? -90 : 0, "deg)")
            }
          }
        })];
        return this.mode === "normal" ? normalSubmenu : this.renderPopup(triggerElement);
      },
      renderSubmenu: function renderSubmenu() {
        var _this$$parent$$vnode;
        var h = this.$createElement;
        var hasContent = this.$slots.content || this.$slots["default"];
        var icon = renderTNodeJSX(this, "icon");
        var child = renderContent(this, "default", "content");
        var paddingLeft = 44;
        if (/submenu/i.test((_this$$parent$$vnode = this.$parent.$vnode) === null || _this$$parent$$vnode === void 0 ? void 0 : _this$$parent$$vnode.tag)) {
          paddingLeft += 16;
        }
        var _useCollapseAnimation = useCollapseAnimation(),
          beforeEnter = _useCollapseAnimation.beforeEnter,
          enter = _useCollapseAnimation.enter,
          afterEnter = _useCollapseAnimation.afterEnter,
          beforeLeave = _useCollapseAnimation.beforeLeave,
          leave = _useCollapseAnimation.leave,
          afterLeave = _useCollapseAnimation.afterLeave;
        var needRotate = this.mode === "popup";
        var rippleVal = this.keepAnimation.ripple ? this.rippleColor : false;
        var normalSubmenu = [h("div", {
          "directives": [{
            name: "ripple",
            value: rippleVal
          }],
          "class": this.submenuClass,
          "on": {
            "click": this.handleSubmenuItemClick
          }
        }, [icon, h("span", {
          "class": ["".concat(this.classPrefix, "-menu__content")]
        }, [renderTNodeJSX(this, "title")]), hasContent && h("fake-arrow", {
          "attrs": {
            "overlayClassName": this.arrowClass,
            "overlayStyle": {
              transform: "rotate(".concat(needRotate ? -90 : 0, "deg)")
            }
          }
        })]), h("transition", {
          "attrs": {
            "name": this.transitionClass
          },
          "on": {
            "beforeEnter": beforeEnter,
            "enter": enter,
            "afterEnter": afterEnter,
            "beforeLeave": beforeLeave,
            "leave": leave,
            "afterLeave": afterLeave
          }
        }, [h("ul", {
          "directives": [{
            name: "show",
            value: this.isOpen
          }],
          "attrs": {
            "level": this.level
          },
          "class": this.subClass,
          "style": {
            "--padding-left": "".concat(paddingLeft, "px")
          }
        }, [child])])];
        var triggerElement = [icon, h("span", {
          "class": ["".concat(this.classPrefix, "-menu__content")]
        }, [renderTNodeJSX(this, "title", {
          silent: true
        })]), h(FakeArrow, {
          "attrs": {
            "overlayClassName": /menu/i.test(this.$parent.$options.name) ? this.arrowClass : null,
            "overlayStyle": {
              transform: "rotate(".concat(needRotate ? -90 : 0, "deg)"),
              "margin-left": "auto"
            }
          }
        })];
        return this.mode === "normal" ? normalSubmenu : this.renderPopup(triggerElement);
      }
    },
    render: function render() {
      var h = arguments[0];
      var child = null;
      var events = {};
      if (this.mode === "popup") {
        events = {
          mouseenter: this.handleMouseEnter,
          mouseleave: this.handleMouseLeave
        };
      }
      if (Object.keys(this.$slots).length > 0) {
        child = this.isHead ? this.renderHeadSubmenu() : this.renderSubmenu();
      }
      return h("li", {
        "class": this.classes,
        "on": _objectSpread$2q({}, events)
      }, [child]);
    }
  });

  var props$12 = {
    content: {
      type: [String, Function]
    },
    "default": {
      type: [String, Function]
    },
    disabled: Boolean,
    href: {
      type: String,
      "default": ""
    },
    icon: {
      type: Function
    },
    replace: Boolean,
    router: {
      type: Object
    },
    routerLink: Boolean,
    target: {
      type: String,
      validator: function validator(val) {
        return ["_blank", "_self", "_parent", "_top"].includes(val);
      }
    },
    to: {
      type: [String, Object]
    },
    value: {
      type: [String, Number]
    },
    onClick: Function
  };

  function ownKeys$2q(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2p(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2q(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2q(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var keepAnimationMixins$3 = getKeepAnimationMixins();
  var _MenuItem = VueCompositionAPI.defineComponent({
    name: "TMenuItem",
    mixins: [keepAnimationMixins$3],
    props: _objectSpread$2p({}, props$12),
    directives: {
      ripple: Ripple
    },
    setup: function setup(props2, ctx) {
      var menu = VueCompositionAPI.inject("TdMenu");
      var submenu = VueCompositionAPI.inject("TdSubmenu", null);
      var active = VueCompositionAPI.computed(function () {
        return menu.activeValue.value === props2.value;
      });
      var collapsed = VueCompositionAPI.computed(function () {
        var _menu$collapsed;
        return (_menu$collapsed = menu.collapsed) === null || _menu$collapsed === void 0 ? void 0 : _menu$collapsed.value;
      });
      var classPrefix = usePrefixClass();
      var classes = VueCompositionAPI.computed(function () {
        return ["".concat(classPrefix.value, "-menu__item"), _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({}, "".concat(classPrefix.value, "-is-active"), active.value), "".concat(classPrefix.value, "-is-disabled"), props2.disabled), "".concat(classPrefix.value, "-menu__item--plain"), !ctx.slots.icon && !props2.icon), "".concat(classPrefix.value, "-submenu__item"), !!submenu && !menu.isHead)];
      });
      var handleClick = function handleClick(e) {
        var _props2$onClick, _submenu$closeParentP;
        e.stopPropagation();
        if (props2.disabled) return;
        if (menu.activeValue.value !== props2.value) {
          menu.select(props2.value);
        }
        ctx.emit("click", {
          e: e,
          value: props2.value
        });
        (_props2$onClick = props2.onClick) === null || _props2$onClick === void 0 || _props2$onClick.call(props2, {
          e: e,
          value: props2.value
        });
        if (props2.to || props2.routerLink && props2.href) {
          var router = props2.router || ctx.root.$router;
          var methods = props2.replace ? "replace" : "push";
          router[methods](props2.to || props2.href)["catch"](function (err) {
            if (err.name !== "NavigationDuplicated" && !err.message.includes("Avoided redundant navigation to current location")) {
              throw err;
            }
          });
        }
        submenu === null || submenu === void 0 || (_submenu$closeParentP = submenu.closeParentPopup) === null || _submenu$closeParentP === void 0 || _submenu$closeParentP.call(submenu, e);
      };
      VueCompositionAPI.onMounted(function () {
        var _menu$vMenu;
        menu === null || menu === void 0 || (_menu$vMenu = menu.vMenu) === null || _menu$vMenu === void 0 || _menu$vMenu.add({
          value: props2.value,
          parent: submenu === null || submenu === void 0 ? void 0 : submenu.value,
          vnode: ctx.slots["default"] && ctx.slots["default"]()
        });
      });
      return {
        menu: menu,
        active: active,
        collapsed: collapsed,
        classes: classes,
        handleClick: handleClick,
        classPrefix: classPrefix
      };
    },
    render: function render() {
      var _this = this,
        _this$$parent$$vnode;
      var h = arguments[0];
      var router = this.router || this.$router;
      var liContent = h("li", {
        "directives": [{
          name: "ripple",
          value: this.keepAnimation.ripple
        }],
        "class": this.classes,
        "on": {
          "click": this.handleClick
        }
      }, [renderTNodeJSX(this, "icon"), this.routerLink ? h("a", {
        "attrs": {
          "href": this.href ? this.href : this.to ? router === null || router === void 0 ? void 0 : router.resolve(this.to).href : "",
          "target": this.target
        },
        "class": "".concat(this.classPrefix, "-menu__item-link"),
        "on": {
          "click": function click(e) {
            return e.preventDefault();
          }
        }
      }, [h("span", {
        "class": "".concat(this.classPrefix, "-menu__content")
      }, [renderContent(this, "default", "content")])]) : this.href ? h("a", {
        "attrs": {
          "href": this.href,
          "target": this.target
        },
        "class": "".concat(this.classPrefix, "-menu__item-link"),
        "on": {
          "click": function click(e) {
            return _this.disabled && e.preventDefault();
          }
        }
      }, [h("span", {
        "class": "".concat(this.classPrefix, "-menu__content")
      }, [renderContent(this, "default", "content")])]) : h("span", {
        "class": "".concat(this.classPrefix, "-menu__content")
      }, [renderContent(this, "default", "content")])]);
      if (this.collapsed && /tmenu/i.test((_this$$parent$$vnode = this.$parent.$vnode) === null || _this$$parent$$vnode === void 0 ? void 0 : _this$$parent$$vnode.tag)) {
        return h(Tooltip, {
          "attrs": {
            "content": function content() {
              return renderContent(_this, "default", "content");
            },
            "placement": "right"
          }
        }, [liContent]);
      }
      return liContent;
    }
  });

  var props$11 = {
    title: {
      type: [String, Function]
    }
  };

  var _MenuGroup = VueCompositionAPI.defineComponent({
    name: "TMenuGroup",
    props: props$11,
    setup: function setup() {
      var classPrefix = usePrefixClass();
      return {
        classPrefix: classPrefix
      };
    },
    render: function render() {
      var h = arguments[0];
      return h("div", {
        "class": "".concat(this.classPrefix, "-menu-group")
      }, [h("div", {
        "class": "".concat(this.classPrefix, "-menu-group__title")
      }, [renderTNodeJSX(this, "title")]), this.$slots["default"]]);
    }
  });

  var Menu = withInstall$1(mapProps([{
    name: "value",
    event: ["change", "update:value"]
  }, {
    name: "expanded",
    event: ["expand", "update:expanded"]
  }], {
    model: {
      prop: "value",
      event: "change"
    }
  })(_Menu), VueCompositionAPI__default["default"]);
  var HeadMenu = withInstall$1(mapProps([{
    name: "value",
    event: ["change", "update:value"]
  }, {
    name: "expanded",
    event: ["expand", "update:expanded"]
  }], {
    model: {
      prop: "value",
      event: "change"
    }
  })(_HeadMenu), VueCompositionAPI__default["default"]);
  var Submenu = withInstall$1(_Submenu, VueCompositionAPI__default["default"]);
  var MenuItem = withInstall$1(_MenuItem, VueCompositionAPI__default["default"]);
  var MenuGroup = withInstall$1(_MenuGroup, VueCompositionAPI__default["default"]);

  var props$10 = {
    align: {
      type: String,
      "default": "left",
      validator: function validator(val) {
        if (!val) return true;
        return ["left", "center", "right"].includes(val);
      }
    },
    allowInputOverMax: Boolean,
    autoWidth: Boolean,
    autocomplete: {
      type: String,
      "default": void 0
    },
    autofocus: Boolean,
    borderless: Boolean,
    clearable: Boolean,
    disabled: {
      type: Boolean,
      "default": void 0
    },
    format: {
      type: Function
    },
    inputClass: {
      type: [String, Object, Array]
    },
    label: {
      type: [String, Function]
    },
    maxcharacter: {
      type: Number
    },
    maxlength: {
      type: [String, Number]
    },
    name: {
      type: String,
      "default": ""
    },
    placeholder: {
      type: String,
      "default": void 0
    },
    prefixIcon: {
      type: Function
    },
    readonly: {
      type: Boolean,
      "default": void 0
    },
    showClearIconOnEmpty: Boolean,
    showLimitNumber: Boolean,
    size: {
      type: String,
      "default": "medium",
      validator: function validator(val) {
        if (!val) return true;
        return ["small", "medium", "large"].includes(val);
      }
    },
    spellCheck: Boolean,
    status: {
      type: String,
      "default": "default",
      validator: function validator(val) {
        if (!val) return true;
        return ["default", "success", "warning", "error"].includes(val);
      }
    },
    suffix: {
      type: [String, Function]
    },
    suffixIcon: {
      type: Function
    },
    tips: {
      type: [String, Function]
    },
    type: {
      type: String,
      "default": "text",
      validator: function validator(val) {
        if (!val) return true;
        return ["text", "number", "url", "tel", "password", "search", "submit", "hidden"].includes(val);
      }
    },
    value: {
      type: [String, Number],
      "default": void 0
    },
    defaultValue: {
      type: [String, Number]
    },
    onBlur: Function,
    onChange: Function,
    onClear: Function,
    onClick: Function,
    onCompositionend: Function,
    onCompositionstart: Function,
    onEnter: Function,
    onFocus: Function,
    onKeydown: Function,
    onKeypress: Function,
    onKeyup: Function,
    onMouseenter: Function,
    onMouseleave: Function,
    onPaste: Function,
    onValidate: Function,
    onWheel: Function
  };

  function ownKeys$2p(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2o(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2p(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2p(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var ANIMATION_TIME = 100;
  function getValidAttrs$1(obj) {
    var newObj = {};
    Object.keys(obj).forEach(function (key) {
      if (typeof obj[key] !== "undefined") {
        newObj[key] = obj[key];
      }
    });
    return newObj;
  }
  var _Input = mixins(getConfigReceiverMixins("input"), getGlobalIconMixins()).extend({
    name: "TInput",
    inheritAttrs: false,
    props: _objectSpread$2o(_objectSpread$2o({}, props$10), {}, {
      showInput: {
        type: Boolean,
        "default": true
      },
      keepWrapperWidth: {
        type: Boolean,
        "default": false
      }
    }),
    inject: {
      tFormItem: {
        "default": void 0
      }
    },
    data: function data() {
      return {
        formDisabled: void 0,
        isHover: false,
        focused: false,
        renderType: this.type,
        inputValue: this.value,
        composingRef: false,
        composingRefValue: this.value,
        preValue: this.value,
        timer: null,
        observerTimer: null,
        containerObserver: null
      };
    },
    computed: {
      tDisabled: function tDisabled() {
        return this.formDisabled || this.disabled;
      },
      tPlaceholder: function tPlaceholder() {
        var _this$placeholder;
        return (_this$placeholder = this.placeholder) !== null && _this$placeholder !== void 0 ? _this$placeholder : this.t(this.global.placeholder);
      },
      showClear: function showClear() {
        return (this.value && !this.tDisabled && this.clearable && !this.readonly || this.showClearIconOnEmpty) && this.isHover;
      },
      inputAttrs: function inputAttrs() {
        var _this$autocomplete;
        return getValidAttrs$1({
          autofocus: this.autofocus,
          disabled: this.tDisabled,
          readonly: this.readonly,
          autocomplete: (_this$autocomplete = this.autocomplete) !== null && _this$autocomplete !== void 0 ? _this$autocomplete : this.global.autocomplete,
          placeholder: this.tPlaceholder,
          name: this.name || void 0,
          type: this.renderType,
          unselectable: this.readonly ? "on" : "off",
          spellCheck: this.spellCheck
        });
      },
      inputClasses: function inputClasses() {
        return [this.componentName, _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({}, this.commonSizeClassName[this.size], this.size !== "medium"), this.commonStatusClassName.disabled, this.tDisabled), this.commonStatusClassName.focused, this.focused), "".concat(this.classPrefix, "-is-").concat(this.tStatus), this.tStatus && this.tStatus !== "default"), "".concat(this.classPrefix, "-align-").concat(this.align), this.align !== "left"), "".concat(this.classPrefix, "-is-disabled"), this.tDisabled), "".concat(this.classPrefix, "-is-readonly"), this.readonly), "".concat(this.componentName, "--borderless"), this.borderless), "".concat(this.componentName, "--focused"), this.focused)];
      },
      inputWrapClass: function inputWrapClass() {
        var wrapClass = "".concat(this.componentName, "__wrap");
        return ["".concat(wrapClass), _defineProperty$2(_defineProperty$2({}, "".concat(wrapClass, "--focused"), this.focused), "".concat(this.componentName, "--auto-width"), this.autoWidth && !this.keepWrapperWidth)];
      },
      limitNumber: function limitNumber() {
        var maxlength = this.maxlength,
          maxcharacter = this.maxcharacter,
          value = this.value;
        if (typeof value === "number") return String(value);
        if (maxlength && maxcharacter) {
          log.warn("Input", "Pick one of maxlength and maxcharacter please.");
        }
        if (maxlength) {
          var length = value !== null && value !== void 0 && value.length ? getUnicodeLength(value) : 0;
          return "".concat(length, "/").concat(maxlength);
        }
        if (maxcharacter) {
          return "".concat(getCharacterLength(value || ""), "/").concat(maxcharacter);
        }
        return "";
      },
      innerStatus: function innerStatus() {
        if (this.limitNumber) {
          var _this$limitNumber$spl = this.limitNumber.split("/"),
            _this$limitNumber$spl2 = _slicedToArray(_this$limitNumber$spl, 2),
            current = _this$limitNumber$spl2[0],
            total = _this$limitNumber$spl2[1];
          return Number(current) > Number(total) ? "error" : "";
        }
        return "";
      },
      tStatus: function tStatus() {
        return this.status || this.innerStatus;
      },
      isIE: function isIE() {
        return getIEVersion$1() <= 11;
      }
    },
    watch: {
      autofocus: {
        handler: function handler(val) {
          var _this = this;
          if (val === true) {
            this.$nextTick(function () {
              var input = _this.$refs.inputRef;
              input === null || input === void 0 || input.focus();
            });
          }
        },
        immediate: true
      },
      value: {
        handler: function handler(val) {
          this.inputValue = this.format ? this.format(val) : val;
          this.preValue = this.inputValue;
          var newVal = this.getValueByLimitNumber(val);
          if (newVal !== val && this.type !== "number") {
            emitEvent$1(this, "change", newVal, {
              trigger: "initial"
            });
          }
        },
        immediate: true
      },
      type: {
        handler: function handler(val) {
          this.renderType = val;
        },
        immediate: true
      }
    },
    created: function created() {
      var _this2 = this;
      if (this.autoWidth) {
        this.addListeners();
      }
      if (this.maxlength || this.maxcharacter) {
        this.$watch(function () {
          return _this2.innerStatus;
        }, function () {
          return _this2.onValidateChange();
        });
      }
      this.innerStatus && this.onValidateChange();
    },
    mounted: function mounted() {
      this.addResizeObserver();
    },
    beforeDestroy: function beforeDestroy() {
      this.cleanupObserver(this.containerObserver, this.$refs.inputRef);
    },
    methods: {
      getOutputValue: function getOutputValue(val) {
        if (this.type === "number") {
          return val || val === 0 ? Number(val) : void 0;
        }
        return val;
      },
      addListeners: function addListeners() {
        var _this3 = this;
        this.$watch(function () {
          return _this3.value + _this3.placeholder;
        }, function () {
          if (!_this3.autoWidth) return;
          _this3.$nextTick(function () {
            _this3.updateInputWidth();
          });
        }, {
          immediate: true
        });
      },
      addResizeObserver: function addResizeObserver() {
        var _this4 = this;
        if (this.$refs.inputRef) {
          this.$watch(function () {
            return _this4.$refs.inputRef;
          }, function () {
            _this4.cleanupObserver(_this4.containerObserver, _this4.$refs.inputRef);
            _this4.containerObserver = _this4.useResizeObserver(_this4.$refs.inputRef, function () {
              if (_this4.autoWidth) {
                _this4.observerTimer = setTimeout(function () {
                  _this4.updateInputWidth();
                  clearTimeout(_this4.observerTimer);
                }, ANIMATION_TIME);
              }
            });
          }, {
            immediate: true
          });
        }
      },
      renderIcon: function renderIcon(h, icon, iconType) {
        if (typeof icon === "function") {
          return icon(h);
        }
        if (this.$scopedSlots[kebabCase$1(iconType)]) {
          return this.$scopedSlots[kebabCase$1(iconType)](h);
        }
        if (this.$scopedSlots[camelCase$1(iconType)]) {
          return this.$scopedSlots[camelCase$1(iconType)](h);
        }
        return null;
      },
      setInputValue: function setInputValue() {
        var v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        var input = this.$refs.inputRef;
        if (!input) return;
        var sV = String(v);
        if (input.value !== sV) {
          input.value = sV;
        }
      },
      focus: function focus() {
        this.$refs.inputRef.focus();
      },
      blur: function blur() {
        this.$refs.inputRef.blur();
      },
      handleKeydown: function handleKeydown(e) {
        if (this.tDisabled) return;
        var value = e.currentTarget.value;
        var tmpValue = this.getOutputValue(value);
        if (/enter/i.test(e.key) || /enter/i.test(e.code)) {
          emitEvent$1(this, "enter", tmpValue, {
            e: e
          });
        } else {
          emitEvent$1(this, "keydown", tmpValue, {
            e: e
          });
        }
      },
      handleKeyUp: function handleKeyUp(e) {
        if (this.tDisabled) return;
        var value = e.currentTarget.value;
        if (e.key === "Process") {
          return;
        }
        var tmpValue = this.getOutputValue(value);
        emitEvent$1(this, "keyup", tmpValue, {
          e: e
        });
      },
      handleKeypress: function handleKeypress(e) {
        if (this.tDisabled) return;
        var value = e.currentTarget.value;
        var tmpValue = this.getOutputValue(value);
        emitEvent$1(this, "keypress", tmpValue, {
          e: e
        });
      },
      handlePaste: function handlePaste(e) {
        if (this.tDisabled) return;
        var clipData = e.clipboardData || window.clipboardData;
        emitEvent$1(this, "paste", {
          e: e,
          pasteValue: clipData === null || clipData === void 0 ? void 0 : clipData.getData("text/plain")
        });
      },
      onHandleMousewheel: function onHandleMousewheel(e) {
        emitEvent$1(this, "wheel", {
          e: e
        });
      },
      emitPassword: function emitPassword() {
        if (this.tDisabled) return;
        var renderType = this.renderType;
        var toggleType = renderType === "password" ? "text" : "password";
        this.renderType = toggleType;
      },
      emitClear: function emitClear(e) {
        var val = this.type === "number" ? void 0 : "";
        emitEvent$1(this, "change", val, {
          e: e,
          trigger: "clear"
        });
        emitEvent$1(this, "clear", {
          e: e
        });
      },
      emitFocus: function emitFocus(e) {
        this.inputValue = this.value;
        if (this.tDisabled) return;
        this.focused = true;
        emitEvent$1(this, "focus", this.value, {
          e: e
        });
      },
      formatAndEmitBlur: function formatAndEmitBlur(e) {
        var _this$tFormItem;
        if (this.format) {
          this.inputValue = this.type === "number" || typeof this.value === "number" ? this.value : this.format(this.value);
        }
        this.focused = false;
        (_this$tFormItem = this.tFormItem) === null || _this$tFormItem === void 0 || _this$tFormItem.validate("blur");
        emitEvent$1(this, "blur", this.value, {
          e: e
        });
      },
      compositionstartHandler: function compositionstartHandler(e) {
        var _this$onCompositionst;
        this.composingRef = true;
        var value = e.currentTarget.value;
        this.composingRefValue = value;
        this.$emit("compositionstart", value, {
          e: e
        });
        (_this$onCompositionst = this.onCompositionstart) === null || _this$onCompositionst === void 0 || _this$onCompositionst.call(this, value, {
          e: e
        });
      },
      compositionendHandler: function compositionendHandler(e) {
        var _this$onCompositionen;
        var value = e.currentTarget.value;
        if (this.composingRef) {
          this.composingRef = false;
          this.handleInput(e);
        }
        this.composingRefValue = "";
        this.$emit("compositionend", value, {
          e: e
        });
        (_this$onCompositionen = this.onCompositionend) === null || _this$onCompositionen === void 0 || _this$onCompositionen.call(this, value, {
          e: e
        });
      },
      onRootClick: function onRootClick(e) {
        var _this$$refs$inputRef, _this$onClick;
        (_this$$refs$inputRef = this.$refs.inputRef) === null || _this$$refs$inputRef === void 0 || _this$$refs$inputRef.focus();
        this.$emit("click", {
          e: e
        });
        (_this$onClick = this.onClick) === null || _this$onClick === void 0 || _this$onClick.call(this, {
          e: e
        });
      },
      throttleChangeCursorPos: function throttleChangeCursorPos(ref, pos) {
        if (this.type === "number") return;
        ref.selectionEnd = pos;
      },
      handleInput: function handleInput(e) {
        var _this5 = this;
        this.preValue = this.inputValue + e.data;
        var val = e.currentTarget.value;
        var preCursorPos;
        if (this.composingRef) {
          this.composingRefValue = val;
        } else {
          if (this.type === "number") {
            val = this.getOutputValue(val);
          } else {
            val = this.getValueByLimitNumber(val);
          }
          emitEvent$1(this, "change", val, {
            e: e,
            trigger: "input"
          });
          if (!this.isIE) {
            var inputRef = this.$refs.inputRef;
            preCursorPos = inputRef.selectionStart;
            clearTimeout(this.timer);
            this.timer = setTimeout(function () {
              _this5.throttleChangeCursorPos(inputRef, preCursorPos);
            });
          }
          this.$nextTick(function () {
            _this5.setInputValue(_this5.value);
          });
        }
      },
      onInputMouseenter: function onInputMouseenter(e) {
        this.isHover = true;
        emitEvent$1(this, "mouseenter", {
          e: e
        });
      },
      onInputMouseleave: function onInputMouseleave(e) {
        this.isHover = false;
        emitEvent$1(this, "mouseleave", {
          e: e
        });
      },
      updateInputWidth: function updateInputWidth() {
        var pre = this.$refs.inputPreRef;
        if (!pre) return;
        var _pre$getBoundingClien = pre.getBoundingClientRect(),
          width = _pre$getBoundingClien.width;
        if (this.$refs.inputRef) {
          this.$refs.inputRef.style.width = "".concat(width, "px");
        }
      },
      getValueByLimitNumber: function getValueByLimitNumber(inputValue) {
        var allowInputOverMax = this.allowInputOverMax,
          maxlength = this.maxlength,
          maxcharacter = this.maxcharacter;
        if (!(maxlength || maxcharacter) || allowInputOverMax || !inputValue) return inputValue;
        if (maxlength) {
          return limitUnicodeMaxLength(inputValue, Number(maxlength));
        }
        if (maxcharacter) {
          var r = getCharacterLength(inputValue, maxcharacter);
          if (_typeof$2(r) === "object") {
            return r.characters;
          }
        }
      },
      onValidateChange: function onValidateChange() {
        var _this$onValidate;
        var error = this.innerStatus ? "exceed-maximum" : void 0;
        (_this$onValidate = this.onValidate) === null || _this$onValidate === void 0 || _this$onValidate.call(this, {
          error: error
        });
        this.$emit("validate", {
          error: error
        });
      },
      useResizeObserver: function useResizeObserver(el, callback) {
        if (typeof window === "undefined") return;
        var isSupport = typeof window !== "undefined" && window.ResizeObserver;
        if (!isSupport) return;
        var containerObserver = new ResizeObserver(callback);
        containerObserver.observe(el);
        return containerObserver;
      },
      cleanupObserver: function cleanupObserver(observer, container) {
        if (!observer || !container) return;
        observer.unobserve(container);
        observer.disconnect();
      }
    },
    render: function render(h) {
      var inputEvents = {
        focus: this.emitFocus,
        blur: this.formatAndEmitBlur,
        keydown: this.handleKeydown,
        keyup: this.handleKeyUp,
        keypress: this.handleKeypress,
        paste: this.handlePaste,
        compositionstart: this.compositionstartHandler,
        compositionend: this.compositionendHandler,
        change: function change() {}
      };
      var wrapperAttrs = omit(this.$attrs, Object.keys(this.inputAttrs));
      var wrapperEvents = omit(this.$listeners, [].concat(_toConsumableArray(Object.keys(inputEvents)), ["input", "paste"]));
      var prefixIcon = this.renderIcon(h, this.prefixIcon, "prefix-icon");
      var suffixIcon = this.renderIcon(h, this.suffixIcon, "suffix-icon");
      var passwordIcon = this.renderIcon(h, void 0, "password-icon");
      var label = renderTNodeJSX(this, "label");
      var suffix = renderTNodeJSX(this, "suffix");
      var limitNode = this.limitNumber && this.showLimitNumber ? h("div", {
        "class": ["".concat(this.classPrefix, "-input__limit-number"), _defineProperty$2({}, "".concat(this.classPrefix, "-is-disabled"), this.disabled)]
      }, [this.limitNumber]) : null;
      var labelContent = label ? h("div", {
        "class": "".concat(this.componentName, "__prefix")
      }, [label]) : null;
      var suffixContent = suffix || limitNode ? h("div", {
        "class": "".concat(this.componentName, "__suffix")
      }, [suffix, limitNode]) : null;
      var _this$useGlobalIcon = this.useGlobalIcon({
          BrowseIcon: TdBrowseIcon,
          BrowseOffIcon: TdBrowseOffIcon,
          CloseCircleFilledIcon: TdCloseCircleFilledIcon
        }),
        BrowseIcon = _this$useGlobalIcon.BrowseIcon,
        BrowseOffIcon = _this$useGlobalIcon.BrowseOffIcon,
        CloseCircleFilledIcon = _this$useGlobalIcon.CloseCircleFilledIcon;
      if (this.type === "password") {
        if (this.renderType === "password") {
          suffixIcon = h(BrowseOffIcon, {
            "class": _defineProperty$2({}, "".concat(this.componentName, "__suffix-clear"), !this.tDisabled),
            "nativeOn": {
              "click": this.emitPassword
            }
          });
        } else if (this.renderType === "text") {
          suffixIcon = h(BrowseIcon, {
            "class": _defineProperty$2({}, "".concat(this.componentName, "__suffix-clear"), !this.tDisabled),
            "nativeOn": {
              "click": this.emitPassword
            }
          });
        }
      }
      if (this.showClear) {
        if (this.type === "password") {
          passwordIcon = h(CloseCircleFilledIcon, {
            "class": "".concat(this.componentName, "__suffix-clear"),
            "nativeOn": {
              "click": this.emitClear
            }
          });
        } else {
          suffixIcon = h(CloseCircleFilledIcon, {
            "class": "".concat(this.componentName, "__suffix-clear"),
            "nativeOn": {
              "click": this.emitClear
            }
          });
        }
      }
      var classes = [this.inputClasses, this.inputClass, _defineProperty$2(_defineProperty$2({}, "".concat(this.componentName, "--prefix"), prefixIcon || labelContent), "".concat(this.componentName, "--suffix"), suffixIcon || suffixContent)];
      var inputTextValue = this.composingRef ? this.composingRefValue : this.inputValue;
      var inputNode = h("div", {
        "class": classes,
        "attrs": _objectSpread$2o({}, wrapperAttrs),
        "on": _objectSpread$2o(_objectSpread$2o({}, wrapperEvents), {}, {
          "click": this.onRootClick,
          "mouseenter": this.onInputMouseenter,
          "mouseleave": this.onInputMouseleave,
          "wheel": this.onHandleMousewheel
        })
      }, [prefixIcon ? h("span", {
        "class": ["".concat(this.componentName, "__prefix"), "".concat(this.componentName, "__prefix-icon")]
      }, [prefixIcon]) : null, labelContent, h("input", helper([{}, {
        "attrs": this.inputAttrs
      }, {}, {
        "on": inputEvents
      }, {
        "ref": "inputRef",
        "class": ["".concat(this.componentName, "__inner"), _defineProperty$2({}, "".concat(this.componentName, "--soft-hidden"), !this.showInput)],
        "domProps": {
          "value": inputTextValue
        },
        "on": {
          "input": this.handleInput
        },
        "attrs": {
          "title": this.disabled ? inputTextValue : void 0
        }
      }])), this.autoWidth && h("span", {
        "ref": "inputPreRef",
        "class": "".concat(this.classPrefix, "-input__input-pre")
      }, [this.preValue || this.tPlaceholder]), suffixContent, passwordIcon ? h("span", {
        "class": ["".concat(this.componentName, "__suffix"), "".concat(this.componentName, "__suffix-icon"), "".concat(this.componentName, "__clear")]
      }, [passwordIcon]) : null, suffixIcon ? h("span", {
        "class": ["".concat(this.componentName, "__suffix"), "".concat(this.componentName, "__suffix-icon"), _defineProperty$2({}, "".concat(this.componentName, "__clear"), this.showClear)]
      }, [suffixIcon]) : null]);
      var tips = renderTNodeJSX(this, "tips");
      return h("div", {
        "class": this.inputWrapClass
      }, [inputNode, tips && h("div", {
        "class": "".concat(this.componentName, "__tips ").concat(this.componentName, "__tips--").concat(this.tStatus || "default")
      }, [tips])]);
    }
  });

  var classPrefixMixins$n = getClassPrefixMixins("input-group");
  var _InputGroup = mixins(classPrefixMixins$n).extend({
    name: "TInputGroup",
    props: {
      separate: {
        type: Boolean,
        "default": false
      }
    },
    computed: {
      classes: function classes() {
        return [this.componentName, _defineProperty$2({}, "".concat(this.componentName, "--separate"), this.separate)];
      }
    },
    render: function render() {
      var h = arguments[0];
      return h("div", {
        "class": this.classes
      }, [renderTNodeJSX(this, "default")]);
    }
  });

  var Input = withInstall$1(mapProps(["value"], {
    model: {
      prop: "value",
      event: "change"
    }
  })(_Input));
  var InputGroup = withInstall$1(_InputGroup);

  var props$$ = {
    align: {
      type: String,
      validator: function validator(val) {
        if (!val) return true;
        return ["left", "center", "right"].includes(val);
      }
    },
    allowInputOverLimit: {
      type: Boolean,
      "default": true
    },
    autoWidth: Boolean,
    decimalPlaces: {
      type: Number,
      "default": void 0
    },
    disabled: Boolean,
    format: {
      type: Function
    },
    inputProps: {
      type: Object
    },
    label: {
      type: [String, Function]
    },
    largeNumber: Boolean,
    max: {
      type: [String, Number],
      "default": Infinity
    },
    min: {
      type: [String, Number],
      "default": -Infinity
    },
    placeholder: {
      type: String,
      "default": void 0
    },
    readonly: Boolean,
    size: {
      type: String,
      "default": "medium",
      validator: function validator(val) {
        if (!val) return true;
        return ["small", "medium", "large"].includes(val);
      }
    },
    status: {
      type: String,
      "default": "default",
      validator: function validator(val) {
        if (!val) return true;
        return ["default", "success", "warning", "error"].includes(val);
      }
    },
    step: {
      type: [String, Number],
      "default": 1
    },
    suffix: {
      type: [String, Function]
    },
    theme: {
      type: String,
      "default": "row",
      validator: function validator(val) {
        if (!val) return true;
        return ["column", "row", "normal"].includes(val);
      }
    },
    tips: {
      type: [String, Function]
    },
    value: {
      type: [String, Number]
    },
    defaultValue: {
      type: [String, Number]
    },
    onBlur: Function,
    onChange: Function,
    onEnter: Function,
    onFocus: Function,
    onKeydown: Function,
    onKeypress: Function,
    onKeyup: Function,
    onValidate: Function
  };

  function useCommonClassName() {
    var _useConfig = useConfig(),
      classPrefix = _useConfig.classPrefix;
    var sizeClassNames = {
      small: "".concat(classPrefix.value, "-size-s"),
      medium: "".concat(classPrefix.value, "-size-m"),
      large: "".concat(classPrefix.value, "-size-l"),
      "default": "",
      xs: "".concat(classPrefix.value, "-size-xs"),
      xl: "".concat(classPrefix.value, "-size-xl"),
      block: "".concat(classPrefix.value, "-size-full-width")
    };
    var statusClassNames = {
      loading: "".concat(classPrefix.value, "-is-loading"),
      loadMore: "".concat(classPrefix.value, "-is-load-more"),
      disabled: "".concat(classPrefix.value, "-is-disabled"),
      focused: "".concat(classPrefix.value, "-is-focused"),
      success: "".concat(classPrefix.value, "-is-success"),
      error: "".concat(classPrefix.value, "-is-error"),
      warning: "".concat(classPrefix.value, "-is-warning"),
      selected: "".concat(classPrefix.value, "-is-selected"),
      active: "".concat(classPrefix.value, "-is-active"),
      checked: "".concat(classPrefix.value, "-is-checked"),
      current: "".concat(classPrefix.value, "-is-current"),
      hidden: "".concat(classPrefix.value, "-is-hidden"),
      visible: "".concat(classPrefix.value, "-is-visible"),
      expanded: "".concat(classPrefix.value, "-is-expanded"),
      indeterminate: "".concat(classPrefix.value, "-is-indeterminate")
    };
    return {
      classPrefix: classPrefix,
      sizeClassNames: sizeClassNames,
      statusClassNames: statusClassNames,
      classNames: {
        size: sizeClassNames,
        status: statusClassNames
      }
    };
  }

  function useVModel$1(value, defaultValue, onChange) {
    var eventName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "change";
    var propName = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "value";
    var alias = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
    var _getCurrentInstance = VueCompositionAPI.getCurrentInstance(),
      emit = _getCurrentInstance.emit,
      vnode = _getCurrentInstance.vnode;
    var internalValue = VueCompositionAPI.ref();
    internalValue.value = defaultValue;
    var isControlled = Object.prototype.hasOwnProperty.call(vnode.componentOptions.propsData, propName) || Object.prototype.hasOwnProperty.call(vnode.componentOptions.propsData, kebabCase$1(propName));
    if (isControlled) {
      return [value, function (newValue) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        emit === null || emit === void 0 || emit.apply(void 0, ["input", newValue].concat(args));
        onChange === null || onChange === void 0 || onChange.apply(void 0, [newValue].concat(args));
        if (eventName && eventName !== "input") {
          emit === null || emit === void 0 || emit.apply(void 0, [eventName, newValue].concat(args));
        }
      }];
    }
    var _loop = function _loop() {
        var item = alias[i];
        if (Object.prototype.hasOwnProperty.call(vnode.componentOptions.propsData, item.propName)) {
          return {
            v: [item.value, function (newValue) {
              for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
                args[_key3 - 1] = arguments[_key3];
              }
              emit === null || emit === void 0 || emit.apply(void 0, ["update:".concat(item.propName), newValue].concat(args));
              onChange === null || onChange === void 0 || onChange.apply(void 0, [newValue].concat(args));
              if (item.eventName && item.eventName !== "input") {
                emit === null || emit === void 0 || emit.apply(void 0, [item.eventName, newValue].concat(args));
              }
            }]
          };
        }
      },
      _ret;
    for (var i = 0, len = alias.length; i < len; i++) {
      _ret = _loop();
      if (_ret) return _ret.v;
    }
    return [internalValue, function (newValue) {
      internalValue.value = newValue;
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      onChange === null || onChange === void 0 || onChange.apply(void 0, [newValue].concat(args));
      if (eventName && eventName !== "input") {
        emit === null || emit === void 0 || emit.apply(void 0, [eventName, newValue].concat(args));
      }
    }];
  }

  function fillZero(length) {
    return new Array(length).fill(0).join("");
  }
  function isInputNumber(num) {
    if (!num) return true;
    if (isNumber(num)) return !Number.isNaN(num);
    var r = /^[0-9|e|E|-]+\.*[0-9|e|E|-]*$/.test(num);
    if (!r) return false;
    var eCount = 0;
    var negativeCount = 0;
    var dotCount = 0;
    for (var i = 0, len = num.length; i < len; i++) {
      if (num[i] === ".") {
        dotCount += 1;
        if (dotCount > 1) return false;
      }
      if (/(e|E)+/.test(num[i])) {
        eCount += 1;
        if (eCount > 1) return false;
      }
      if (num[i] === "-") {
        negativeCount += 1;
        if (negativeCount > 2) return false;
      }
    }
    return true;
  }
  function removeInvalidZero(num) {
    var decimal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (num.indexOf(".") !== -1) {
      log.error("InputNumber", "num is not a integer number.");
      return num;
    }
    if (!num || num === "0" && decimal) return "";
    if (num === "0") return num;
    return (decimal ? num.replace(/0+$/, "") : num.replace(/^0+/, "")) || "0";
  }
  function largeIntNumberAdd(num1, num2) {
    var decimal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var number1 = removeInvalidZero(num1, decimal);
    var number2 = removeInvalidZero(num2, decimal);
    var isFirstLarger = number1.length > number2.length;
    var maxNumber = isFirstLarger ? number1 : number2;
    var minNumber = isFirstLarger ? number2 : number1;
    var newNumber = [];
    var step = [];
    var diff = decimal ? 0 : maxNumber.length - minNumber.length;
    var len = decimal ? minNumber.length : maxNumber.length;
    for (var i = len - 1; i >= 0; i--) {
      var minIndex = i - diff;
      var count = Number(maxNumber[i]) + (Number(minNumber[minIndex]) || 0) + (step[i] || 0);
      if (count >= 10) {
        step[i - 1] = 1;
      }
      newNumber.unshift(String(count % 10));
    }
    if (step[-1]) {
      newNumber.unshift("1");
    }
    if (decimal) {
      return newNumber.concat(maxNumber.slice(len, maxNumber.length)).join("");
    }
    return newNumber.join("");
  }
  function largePositiveNumberAdd(num1, num2) {
    var _num1$split = num1.split("."),
      _num1$split2 = _slicedToArray(_num1$split, 2),
      _num1$split2$ = _num1$split2[0],
      intNumber1 = _num1$split2$ === void 0 ? "0" : _num1$split2$,
      _num1$split2$2 = _num1$split2[1],
      decimalNumber1 = _num1$split2$2 === void 0 ? "0" : _num1$split2$2;
    var _num2$split = num2.split("."),
      _num2$split2 = _slicedToArray(_num2$split, 2),
      _num2$split2$ = _num2$split2[0],
      intNumber2 = _num2$split2$ === void 0 ? "0" : _num2$split2$,
      _num2$split2$2 = _num2$split2[1],
      decimalNumber2 = _num2$split2$2 === void 0 ? "0" : _num2$split2$2;
    var integerSum = largeIntNumberAdd(intNumber1, intNumber2);
    if (decimalNumber1 === "0" && decimalNumber2 === "0") return integerSum;
    var newDecimalNumber1 = removeInvalidZero(decimalNumber1, true);
    var newDecimalNumber2 = removeInvalidZero(decimalNumber2, true);
    var decimalNumberSum = largeIntNumberAdd(newDecimalNumber1, newDecimalNumber2, true);
    var decimalLength = decimalNumberSum.length;
    if (decimalLength > newDecimalNumber1.length && decimalLength > newDecimalNumber2.length) {
      return [removeInvalidZero(largeIntNumberAdd(integerSum, "1")), removeInvalidZero(decimalNumberSum.slice(1), true)].filter(function (v) {
        return v;
      }).join(".");
    }
    return [removeInvalidZero(integerSum), removeInvalidZero(decimalNumberSum, true)].filter(function (v) {
      return v;
    }).join(".");
  }
  function compareLargeIntegerNumber(num1, num2) {
    var number1 = removeInvalidZero(num1);
    var number2 = removeInvalidZero(num2);
    if (number1.length === number2.length) {
      for (var i = 0, len = number1.length; i < len; i++) {
        if (number1[i] > number2[i]) return 1;
        if (number1[i] < number2[i]) return -1;
      }
      return 0;
    }
    return number1.length > number2.length ? 1 : -1;
  }
  function compareLargeDecimalNumber(num1, num2) {
    var number1 = num1 && num1 !== "0" ? num1.replace(/0+$/, "") : "0";
    var number2 = num2 && num2 !== "0" ? num2.replace(/0+$/, "") : "0";
    var maxLength = Math.max(number1.length, number2.length);
    for (var i = 0, len = maxLength; i < len; i++) {
      if ((number1[i] || 0) > (number2[i] || 0)) return 1;
      if ((number1[i] || 0) < (number2[i] || 0)) return -1;
    }
    return 0;
  }
  function formatENumber(num) {
    var _num$split = num.split("e"),
      _num$split2 = _slicedToArray(_num$split, 2),
      num1 = _num$split2[0],
      num2 = _num$split2[1];
    if (!num2) return num;
    var _num$split3 = num.split("."),
      _num$split4 = _slicedToArray(_num$split3, 2),
      integer = _num$split4[0],
      _num$split4$ = _num$split4[1],
      initDecimal = _num$split4$ === void 0 ? "" : _num$split4$;
    var zeroCount = Number(num2);
    var _initDecimal$split = initDecimal.split("e"),
      _initDecimal$split2 = _slicedToArray(_initDecimal$split, 1),
      decimal = _initDecimal$split2[0];
    if (zeroCount > decimal.length) {
      var multipleZero = fillZero(zeroCount - decimal.length);
      return num1.replace(/(^0+|\.)/g, "") + multipleZero;
    }
    var n1 = integer.replace(/^0+/, "") + decimal.slice(0, zeroCount);
    var d2 = decimal.slice(zeroCount);
    return d2 ? [n1, d2].join(".") : n1;
  }
  function compareLargeNumber(num1, num2) {
    var _formatENumber$split = formatENumber(num1).split("."),
      _formatENumber$split2 = _slicedToArray(_formatENumber$split, 2),
      integer1 = _formatENumber$split2[0],
      decimal1 = _formatENumber$split2[1];
    var _formatENumber$split3 = formatENumber(num2).split("."),
      _formatENumber$split4 = _slicedToArray(_formatENumber$split3, 2),
      integer2 = _formatENumber$split4[0],
      decimal2 = _formatENumber$split4[1];
    var result = compareLargeIntegerNumber(integer1.replace("-", ""), integer2.replace("-", ""));
    var integer1IsNegative = integer1.includes("-");
    var integer2IsNegative = integer2.includes("-");
    if (integer1IsNegative && !integer2IsNegative) return -1;
    if (!integer1IsNegative && integer2IsNegative) return 1;
    if (integer1IsNegative && integer2IsNegative) {
      if (result === 0) return 0;
      return result > 0 ? -1 : 1;
    }
    if (result === 0) {
      return compareLargeDecimalNumber(decimal1, decimal2);
    }
    return result;
  }
  function isInfinity(num) {
    return [-Infinity, Infinity].includes(Number(num));
  }
  function isSafeNumber(num) {
    return Number(num) < Number.MAX_SAFE_INTEGER && Number(num) > Number.MIN_SAFE_INTEGER;
  }
  function compareNumber(num1, num2, largeNumber) {
    var isSafeNumberCompare = isSafeNumber(num1) && isSafeNumber(num2) && !largeNumber;
    var isInfinityCompare = isInfinity(num1) || isInfinity(num2);
    if (isSafeNumberCompare || isInfinityCompare) {
      if (Number(num1) === Number(num2)) return 0;
      return Number(num1) > Number(num2) ? 1 : -1;
    }
    return compareLargeNumber(String(num1), String(num2));
  }
  function largeIntegerNumberSubtract(num1, num2, p) {
    if (num1 === num2) return "0";
    var _ref = p || {},
      decimal = _ref.decimal,
      stayZero = _ref.stayZero;
    var number1 = removeInvalidZero(num1);
    var number2 = removeInvalidZero(num2);
    var isFirstLarger = compareLargeIntegerNumber(number1, number2) > 0;
    var maxNumber = isFirstLarger ? number1 : number2;
    var minNumber = isFirstLarger ? number2 : number1;
    var newNumber = [];
    var step = [];
    var diff = decimal ? 0 : maxNumber.length - minNumber.length;
    var len = decimal ? minNumber.length : maxNumber.length;
    for (var i = len - 1; i >= 0; i--) {
      var minIndex = i - diff;
      var count = Number(maxNumber[i]) - (Number(minNumber[minIndex]) || 0) - (step[i] || 0);
      if (count < 0) {
        step[i - 1] = 1;
        count += 10;
      }
      newNumber.unshift(String(count));
    }
    if (decimal) {
      return newNumber.concat(maxNumber.slice(len, maxNumber.length)).join("");
    }
    var finalNumber = newNumber.join("");
    if (!stayZero) {
      finalNumber = finalNumber.replace(/^0+/, "");
    }
    return removeInvalidZero(isFirstLarger ? finalNumber : "-".concat(finalNumber));
  }
  function largePositiveNumberSubtract(num1, num2) {
    if (num1 === num2) return "0";
    var isFirstLarger = compareNumber(num1, num2, true) > 0;
    var maxNumber = isFirstLarger ? num1 : num2;
    var minNumber = isFirstLarger ? num2 : num1;
    var _maxNumber$split = maxNumber.split("."),
      _maxNumber$split2 = _slicedToArray(_maxNumber$split, 2),
      intNumber1 = _maxNumber$split2[0],
      _maxNumber$split2$ = _maxNumber$split2[1],
      decimalNumber1 = _maxNumber$split2$ === void 0 ? "0" : _maxNumber$split2$;
    var _minNumber$split = minNumber.split("."),
      _minNumber$split2 = _slicedToArray(_minNumber$split, 2),
      intNumber2 = _minNumber$split2[0],
      _minNumber$split2$ = _minNumber$split2[1],
      decimalNumber2 = _minNumber$split2$ === void 0 ? "0" : _minNumber$split2$;
    var integerNumber = largeIntegerNumberSubtract(intNumber1, intNumber2);
    if (decimalNumber1 === "0" && decimalNumber2 === "0") {
      return isFirstLarger ? integerNumber : "-".concat(integerNumber);
    }
    var decimalNumber = "";
    var addOneNumber = decimalNumber1;
    if (decimalNumber1.length < decimalNumber2.length) {
      addOneNumber = "".concat(decimalNumber1).concat(fillZero(decimalNumber2.length - decimalNumber1.length));
    }
    if (compareLargeDecimalNumber(addOneNumber, decimalNumber2) >= 0) {
      decimalNumber = largeIntegerNumberSubtract(addOneNumber, decimalNumber2, {
        decimal: true
      });
    } else {
      if (decimalNumber1.length < decimalNumber2.length || decimalNumber1 === "0") {
        decimalNumber = largeIntegerNumberSubtract("1".concat(addOneNumber), decimalNumber2, {
          stayZero: true
        });
        decimalNumber = fillZero(decimalNumber2.length - decimalNumber.length) + decimalNumber;
      } else {
        decimalNumber = largeIntegerNumberSubtract(decimalNumber1, decimalNumber2, {
          decimal: true
        });
      }
      integerNumber = largeIntegerNumberSubtract(integerNumber, "1");
    }
    var finalNumber = decimalNumber ? [integerNumber, decimalNumber].join(".") : integerNumber;
    return isFirstLarger ? finalNumber : "-".concat(finalNumber);
  }
  function largeNumberSubtract(num1, num2) {
    var isFirstNegative = num1[0] === "-";
    var isSecondNegative = num2[0] === "-";
    if (isFirstNegative && !isSecondNegative) {
      var r = largePositiveNumberAdd(num1.slice(1), num2);
      return "-".concat(r);
    }
    if (isFirstNegative && isSecondNegative) {
      return largePositiveNumberSubtract(num2.slice(1), num1.slice(1));
    }
    if (!isFirstNegative && isSecondNegative) {
      return largePositiveNumberAdd(num1, num2.slice(1));
    }
    return largePositiveNumberSubtract(num1, num2);
  }
  function largeNumberAdd(num1, num2) {
    var isFirstNegative = num1[0] === "-";
    var isSecondNegative = num2[0] === "-";
    if (isFirstNegative && !isSecondNegative) {
      return largePositiveNumberSubtract(num2, num1.slice(1));
    }
    if (isFirstNegative && isSecondNegative) {
      var r = largePositiveNumberAdd(num2.slice(1), num1.slice(1));
      return "-".concat(r);
    }
    if (!isFirstNegative && isSecondNegative) {
      return largePositiveNumberSubtract(num1, num2.slice(1));
    }
    return largePositiveNumberAdd(num1, num2);
  }
  function formatDecimal(num, places) {
    var enableRound = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (enableRound) {
      return num.toFixed(places);
    }
    var _num$toString$split = num.toString().split("."),
      _num$toString$split2 = _slicedToArray(_num$toString$split, 2),
      integer = _num$toString$split2[0],
      decimal = _num$toString$split2[1];
    if (places === 0) {
      return integer;
    }
    if (decimal) {
      var decimalNumber = decimal.slice(0, places);
      if (decimal.length < places) {
        decimalNumber += fillZero(places - decimal.length);
      }
      return [integer, decimalNumber].join(".");
    }
    return [integer, fillZero(places)].join(".");
  }
  function decimalPlacesToFixedNum(num, decimalPlaces) {
    if (isObject(decimalPlaces)) {
      var _decimalPlaces$enable;
      return formatDecimal(num, decimalPlaces.places, (_decimalPlaces$enable = decimalPlaces.enableRound) !== null && _decimalPlaces$enable !== void 0 ? _decimalPlaces$enable : true);
    }
    return formatDecimal(num, decimalPlaces, true);
  }
  function largeNumberToFixed(number) {
    var _decimalPlaces$enable2;
    var decimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var largeNumber = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (Number.isNaN(Number(number))) return "";
    if (!largeNumber) {
      return decimalPlacesToFixedNum(Number(number), decimalPlaces);
    }
    var places = isObject(decimalPlaces) ? decimalPlaces.places : decimalPlaces;
    var enableRound = isObject(decimalPlaces) ? (_decimalPlaces$enable2 = decimalPlaces.enableRound) !== null && _decimalPlaces$enable2 !== void 0 ? _decimalPlaces$enable2 : true : true;
    if (!isString(number)) return String(number);
    var _number$split = number.split("."),
      _number$split2 = _slicedToArray(_number$split, 2),
      num1 = _number$split2[0],
      num2 = _number$split2[1];
    if (!num2) {
      return places > 0 && enableRound ? [number, fillZero(places)].join(".") : number;
    }
    if (places === 0) {
      return enableRound && Number(num2[0]) >= 5 ? largePositiveNumberAdd(num1, "1") : num1;
    }
    var decimalNumber = num2.slice(0, places);
    if (num2.length < places) {
      decimalNumber += fillZero(places - num2.length);
    } else if (enableRound) {
      var _decimalNumber$match;
      var leadZeroNum = (_decimalNumber$match = decimalNumber.match(/^0+/)) === null || _decimalNumber$match === void 0 ? void 0 : _decimalNumber$match[0].length;
      var leadNineNum = decimalNumber.match(/^9+/);
      var needAdded = Number(num2[places]) >= 5;
      decimalNumber = needAdded ? largePositiveNumberAdd(decimalNumber, "1") : decimalNumber;
      if (leadZeroNum && needAdded && leadZeroNum + decimalNumber.length >= places) {
        decimalNumber = "".concat(fillZero(places - decimalNumber.length)).concat(decimalNumber);
      }
      if (leadNineNum && decimalNumber.length > places) {
        num1 = (Number(num1) + 1).toString();
        decimalNumber = fillZero(places);
      }
    }
    return [num1, decimalNumber].join(".");
  }

  function canAddNumber(num, max) {
    var largeNumber = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (!num && num !== 0) return true;
    if (largeNumber && isString(num)) {
      return compareNumber(num, max, largeNumber) < 0;
    }
    return num < max;
  }
  function canReduceNumber(num, min) {
    var largeNumber = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (!num && num !== 0) return true;
    if (largeNumber && isString(num)) {
      return compareNumber(num, min, largeNumber) > 0;
    }
    return num > min;
  }
  function putInRangeNumber(val, params) {
    if (val === "") return void 0;
    var max = params.max,
      min = params.min,
      lastValue = params.lastValue,
      largeNumber = params.largeNumber;
    if (!isInputNumber(val)) return lastValue;
    if (largeNumber && (isString(max) || max === Infinity) && (isString(min) || min === -Infinity)) {
      if (compareNumber(max, val, largeNumber) < 0) return max;
      if (compareNumber(min, val, largeNumber) > 0) return min;
      return val;
    }
    return Math.max(Number(min), Math.min(Number(max), Number(val)));
  }
  function positiveAdd(num1, num2) {
    var _num1$toString$split$, _num2$toString$split$;
    if (!num1 || !num2) return (num1 || 0) + (num2 || 0);
    var r1 = ((_num1$toString$split$ = num1.toString().split(".")[1]) === null || _num1$toString$split$ === void 0 ? void 0 : _num1$toString$split$.length) || 0;
    var r2 = ((_num2$toString$split$ = num2.toString().split(".")[1]) === null || _num2$toString$split$ === void 0 ? void 0 : _num2$toString$split$.length) || 0;
    if (!r1 && !r2) return num1 + num2;
    var newNumber1 = num1;
    var newNumber2 = num2;
    var diff = Math.abs(r1 - r2);
    var digit = Math.pow(10, Math.max(r1, r2));
    if (diff > 0) {
      var cm = Math.pow(10, diff);
      if (r1 > r2) {
        newNumber1 = Number(num1.toString().replace(".", ""));
        newNumber2 = Number(num2.toString().replace(".", "")) * cm;
      } else {
        newNumber1 = Number(num1.toString().replace(".", "")) * cm;
        newNumber2 = Number(num2.toString().replace(".", ""));
      }
    } else {
      newNumber1 = Number(num1.toString().replace(".", ""));
      newNumber2 = Number(num2.toString().replace(".", ""));
    }
    return (newNumber1 + newNumber2) / digit;
  }
  function positiveSubtract(num1, num2) {
    var _num1$toString$split$2, _num2$toString$split$2;
    if (!num1 || !num2) return (num1 || 0) - (num2 || 0);
    var r1 = ((_num1$toString$split$2 = num1.toString().split(".")[1]) === null || _num1$toString$split$2 === void 0 ? void 0 : _num1$toString$split$2.length) || 0;
    var r2 = ((_num2$toString$split$2 = num2.toString().split(".")[1]) === null || _num2$toString$split$2 === void 0 ? void 0 : _num2$toString$split$2.length) || 0;
    var digit = Math.pow(10, Math.max(r1, r2));
    var n = r1 >= r2 ? r1 : r2;
    return Number(((num1 * digit - num2 * digit) / digit).toFixed(n));
  }
  function add(num1, num2) {
    if (num1 < 0 && num2 > 0) return positiveSubtract(num2, Math.abs(num1));
    if (num1 < 0 && num2 < 0) return positiveAdd(Math.abs(num1), Math.abs(num2)) * -1;
    if (num1 > 0 && num2 < 0) return positiveSubtract(num1, Math.abs(num2));
    return positiveAdd(num1, num2);
  }
  function subtract(num1, num2) {
    if (num1 < 0 && num2 > 0) return positiveAdd(Math.abs(num1), num2) * -1;
    if (num1 < 0 && num2 < 0) return positiveSubtract(Math.abs(num2), Math.abs(num1));
    if (num1 > 0 && num2 < 0) return positiveAdd(num1, Math.abs(num2));
    return positiveSubtract(num1, num2);
  }
  function getStepValue(p) {
    var op = p.op,
      step = p.step,
      lastValue = p.lastValue,
      max = p.max,
      min = p.min,
      largeNumber = p.largeNumber;
    if (Number(step) <= 0) {
      log.error("InputNumber", "step must be larger than 0.");
      return lastValue;
    }
    var tStep = isNumber(step) ? String(step) : step;
    var newVal;
    if (op === "add") {
      if (largeNumber && isString(lastValue)) {
        newVal = largeNumberAdd(String(lastValue), String(tStep));
      } else {
        newVal = add(Number(lastValue || 0), Number(step));
      }
    } else if (op === "reduce") {
      if (largeNumber && isString(lastValue)) {
        newVal = largeNumberSubtract(String(lastValue), String(tStep));
      } else {
        newVal = subtract(Number(lastValue || 0), Number(step));
      }
    }
    if (isUndefined(lastValue)) {
      newVal = putInRangeNumber(newVal, {
        max: max,
        min: min,
        lastValue: lastValue,
        largeNumber: largeNumber
      });
    }
    return largeNumber ? newVal : Number(newVal);
  }
  function getMaxOrMinValidateResult(p) {
    var largeNumber = p.largeNumber,
      value = p.value,
      max = p.max,
      min = p.min;
    if (isUndefined(value) || isUndefined(largeNumber)) return void 0;
    if (largeNumber && isNumber(value)) {
      log.warn("InputNumber", "largeNumber value must be a string.");
    }
    var error;
    if (compareNumber(value, max, largeNumber) > 0) {
      error = "exceed-maximum";
    } else if (compareNumber(value, min, largeNumber) < 0) {
      error = "below-minimum";
    } else {
      error = void 0;
    }
    return error;
  }
  var specialCode = ["-", ".", "e", "E", "+"];
  function canInputNumber(number, largeNumber) {
    var _number$match, _number$match2;
    if (["", null, void 0].includes(number)) return true;
    if (number.slice(0, 2) === "00") return false;
    if (number.match(/\s/g)) return false;
    if (((_number$match = number.match(/\./g)) === null || _number$match === void 0 ? void 0 : _number$match.length) > 1) return false;
    if (((_number$match2 = number.match(/e/g)) === null || _number$match2 === void 0 ? void 0 : _number$match2.length) > 1) return false;
    var tmpNumber = number.slice(1);
    if (/(\+|-)/.test(tmpNumber) && !/e+/i.test(tmpNumber)) return false;
    var isNumber2 = largeNumber && isInputNumber(number) || !Number.isNaN(Number(number));
    if (!isNumber2 && !specialCode.includes(number.slice(-1))) return false;
    if (/e/i.test(number) && !/\de/i.test(number)) return false;
    return true;
  }
  function canSetValue(number, lastNumber) {
    return parseFloat(number) !== lastNumber && !Number.isNaN(Number(number));
  }
  function formatUnCompleteNumber(number) {
    var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (["", null, void 0].includes(number) || !/\d+/.test(number)) return void 0;
    var decimalPlaces = extra.decimalPlaces,
      largeNumber = extra.largeNumber,
      isToFixed = extra.isToFixed;
    var newNumber = number.replace(/[.|+|\-|e]$/, "");
    if (largeNumber) {
      newNumber = formatENumber(newNumber);
    }
    if (decimalPlaces !== void 0) {
      newNumber = largeNumberToFixed(newNumber, decimalPlaces, largeNumber);
    }
    if (largeNumber) return newNumber;
    return isToFixed ? newNumber : parseFloat(newNumber);
  }
  function formatThousandths(number) {
    var thousandthsRegExp = /^[-+]?\d{1,3}(,\d{3})*(\.(\d*))?$/;
    if (thousandthsRegExp.test(number)) return number.replace(/,/g, "");
    return number;
  }

  function useFormDisabled() {
    var formDisabled = VueCompositionAPI.computed(function () {
      var currentInstance = VueCompositionAPI.getCurrentInstance();
      if (!currentInstance) return null;
      var parent = currentInstance.parent;
      while (parent) {
        if (parent.proxy.$options.name === "TForm") {
          return parent.props.disabled;
        }
        parent = parent.parent;
      }
      return false;
    });
    return {
      formDisabled: formDisabled
    };
  }

  function useInputNumber(props, context) {
    var _useCommonClassName = useCommonClassName(),
      classPrefix = _useCommonClassName.classPrefix,
      sizeClassNames = _useCommonClassName.sizeClassNames,
      statusClassNames = _useCommonClassName.statusClassNames;
    var _toRefs = VueCompositionAPI.toRefs(props),
      value = _toRefs.value,
      max = _toRefs.max,
      min = _toRefs.min;
    var _useVModel = useVModel$1(value, props.defaultValue, props.onChange, "change"),
      _useVModel2 = _slicedToArray(_useVModel, 2),
      tValue = _useVModel2[0],
      setTValue = _useVModel2[1];
    var inputRef = VueCompositionAPI.ref();
    var userInput = VueCompositionAPI.ref("");
    var _useFormDisabled = useFormDisabled(),
      formDisabled = _useFormDisabled.formDisabled;
    var tDisabled = VueCompositionAPI.computed(function () {
      return props.disabled || formDisabled.value;
    });
    var isError = VueCompositionAPI.ref();
    var disabledReduce = VueCompositionAPI.computed(function () {
      return tDisabled.value || !canReduceNumber(tValue.value, props.min, props.largeNumber);
    });
    var disabledAdd = VueCompositionAPI.computed(function () {
      return tDisabled.value || !canAddNumber(tValue.value, props.max, props.largeNumber);
    });
    var wrapClasses = VueCompositionAPI.computed(function () {
      return ["".concat(classPrefix.value, "-input-number"), sizeClassNames[props.size], _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({}, statusClassNames.disabled, tDisabled.value), "".concat(classPrefix.value, "-is-controls-right"), props.theme === "column"), "".concat(classPrefix.value, "-input-number--").concat(props.theme), props.theme), "".concat(classPrefix.value, "-input-number--auto-width"), props.autoWidth)];
    });
    var reduceClasses = VueCompositionAPI.computed(function () {
      return ["".concat(classPrefix.value, "-input-number__decrease"), _defineProperty$2({}, statusClassNames.disabled, disabledReduce.value)];
    });
    var addClasses = VueCompositionAPI.computed(function () {
      return ["".concat(classPrefix.value, "-input-number__increase"), _defineProperty$2({}, statusClassNames.disabled, disabledAdd.value)];
    });
    var getUserInput = function getUserInput(value2) {
      var _inputRef$value;
      if (!value2 && value2 !== 0) return "";
      var inputStr = value2 || value2 === 0 ? String(value2) : "";
      if (!((_inputRef$value = inputRef.value) !== null && _inputRef$value !== void 0 && (_inputRef$value = _inputRef$value.$el) !== null && _inputRef$value !== void 0 && _inputRef$value.contains(document.activeElement))) {
        var num = formatUnCompleteNumber(inputStr, {
          decimalPlaces: props.decimalPlaces,
          largeNumber: props.largeNumber,
          isToFixed: true
        });
        inputStr = num || num === 0 ? String(num) : "";
        if (props.format) {
          inputStr = String(props.format(value2, {
            fixedNumber: inputStr
          }));
        }
      }
      return inputStr;
    };
    VueCompositionAPI.watch(tValue, function (val) {
      var largeNumber = props.largeNumber,
        decimalPlaces = props.decimalPlaces;
      var inputValue = [void 0, null].includes(val) ? "" : String(val);
      if (!largeNumber && !Number.isNaN(userInput.value)) {
        if (parseFloat(userInput.value) !== val) {
          userInput.value = getUserInput(inputValue);
        }
        var fixedNumber = Number(largeNumberToFixed(inputValue, decimalPlaces, largeNumber));
        if (decimalPlaces !== void 0 && ![void 0, null].includes(val) && Number(fixedNumber) !== Number(tValue.value)) {
          setTValue(fixedNumber, {
            type: "props",
            e: void 0
          });
        }
      }
      if (largeNumber) {
        userInput.value = getUserInput(inputValue);
        if (decimalPlaces !== void 0 && largeNumberToFixed(inputValue, decimalPlaces, largeNumber) !== val) {
          setTValue(userInput.value, {
            type: "props",
            e: void 0
          });
        }
      }
    }, {
      immediate: true
    });
    VueCompositionAPI.watch([tValue, max, min], function () {
      var _props$onValidate;
      if ([void 0, "", null].includes(tValue.value)) return;
      var max2 = props.max,
        min2 = props.min,
        largeNumber = props.largeNumber;
      var error = getMaxOrMinValidateResult({
        value: tValue.value,
        largeNumber: largeNumber,
        max: max2,
        min: min2
      });
      isError.value = error;
      (_props$onValidate = props.onValidate) === null || _props$onValidate === void 0 || _props$onValidate.call(props, {
        error: error
      });
      context.emit("validate", {
        error: error
      });
    }, {
      immediate: true
    });
    var handleStepValue = function handleStepValue(op) {
      var newValue = getStepValue({
        op: op,
        step: props.step,
        max: props.max,
        min: props.min,
        lastValue: tValue.value,
        largeNumber: props.largeNumber
      });
      var largeNumber = props.largeNumber,
        max2 = props.max,
        min2 = props.min;
      var overLimit = getMaxOrMinValidateResult({
        value: newValue,
        largeNumber: largeNumber,
        max: max2,
        min: min2
      });
      return {
        overLimit: overLimit,
        newValue: newValue
      };
    };
    var handleReduce = function handleReduce(e) {
      if (disabledReduce.value || props.readonly) return;
      var r = handleStepValue("reduce");
      if (r.overLimit && !props.allowInputOverLimit) return;
      setTValue(r.newValue, {
        type: "reduce",
        e: e
      });
    };
    var handleAdd = function handleAdd(e) {
      if (disabledAdd.value || props.readonly) return;
      var r = handleStepValue("add");
      if (r.overLimit && !props.allowInputOverLimit) return;
      setTValue(r.newValue, {
        type: "add",
        e: e
      });
    };
    var onInnerInputChange = function onInnerInputChange(inputValue, _ref4) {
      var e = _ref4.e;
      var val = formatThousandths(inputValue);
      if (!canInputNumber(val, props.largeNumber)) return;
      userInput.value = val;
      if (props.largeNumber) {
        setTValue(val, {
          type: "input",
          e: e
        });
        return;
      }
      if (canSetValue(String(val), Number(tValue.value))) {
        var newVal = val === "" ? void 0 : Number(val);
        setTValue(newVal, {
          type: "input",
          e: e
        });
      }
    };
    var emitBlur = function emitBlur(value2, ctx) {
      var _props$onBlur;
      (_props$onBlur = props.onBlur) === null || _props$onBlur === void 0 || _props$onBlur.call(props, value2, ctx);
      context.emit("blur", value2, ctx);
    };
    var handleBlur = function handleBlur(value2, ctx) {
      var largeNumber = props.largeNumber,
        max2 = props.max,
        min2 = props.min,
        decimalPlaces = props.decimalPlaces;
      if (!props.allowInputOverLimit && tValue.value !== void 0) {
        var r = getMaxOrMinValidateResult({
          value: tValue.value,
          largeNumber: largeNumber,
          max: max2,
          min: min2
        });
        if (r === "below-minimum") {
          setTValue(min2, {
            type: "blur",
            e: ctx.e
          });
          emitBlur(min2, ctx);
          return;
        }
        if (r === "exceed-maximum") {
          setTValue(max2, {
            type: "blur",
            e: ctx.e
          });
          emitBlur(max2, ctx);
          return;
        }
      }
      var newValue = formatUnCompleteNumber(String(value2), {
        decimalPlaces: decimalPlaces,
        largeNumber: largeNumber
      });
      userInput.value = getUserInput(newValue);
      if (newValue !== tValue.value) {
        setTValue(newValue, {
          type: "blur",
          e: ctx.e
        });
      }
      emitBlur(newValue, ctx);
    };
    var handleFocus = function handleFocus(value2, ctx) {
      var _props$onFocus;
      userInput.value = tValue.value || tValue.value === 0 ? String(tValue.value) : "";
      (_props$onFocus = props.onFocus) === null || _props$onFocus === void 0 || _props$onFocus.call(props, value2, ctx);
      context.emit("focus", value2, ctx);
    };
    var handleKeydown = function handleKeydown(value2, ctx) {
      var _props$onKeydown;
      var e = ctx.e;
      var keyEvent = {
        ArrowUp: handleAdd,
        ArrowDown: handleReduce
      };
      var code = e.code || e.key;
      if (keyEvent[code] !== void 0) {
        keyEvent[code](e);
      }
      (_props$onKeydown = props.onKeydown) === null || _props$onKeydown === void 0 || _props$onKeydown.call(props, value2, ctx);
      context.emit("keydown", value2, ctx);
    };
    var handleKeyup = function handleKeyup(value2, ctx) {
      var _props$onKeyup;
      (_props$onKeyup = props.onKeyup) === null || _props$onKeyup === void 0 || _props$onKeyup.call(props, value2, ctx);
      context.emit("keyup", value2, ctx);
    };
    var handleKeypress = function handleKeypress(value2, ctx) {
      var _props$onKeypress;
      (_props$onKeypress = props.onKeypress) === null || _props$onKeypress === void 0 || _props$onKeypress.call(props, value2, ctx);
      context.emit("keypress", value2, ctx);
    };
    var handleEnter = function handleEnter(value2, ctx) {
      var _props$onEnter;
      userInput.value = getUserInput(value2);
      var newValue = formatUnCompleteNumber(value2, {
        decimalPlaces: props.decimalPlaces,
        largeNumber: props.largeNumber
      });
      (_props$onEnter = props.onEnter) === null || _props$onEnter === void 0 || _props$onEnter.call(props, newValue, ctx);
      context.emit("enter", newValue, ctx);
    };
    var handleClear = function handleClear(_ref5) {
      var e = _ref5.e;
      setTValue(void 0, {
        type: "clear",
        e: e
      });
      userInput.value = "";
    };
    var focus = function focus() {
      inputRef.value.focus();
    };
    var blur = function blur() {
      inputRef.value.blur();
    };
    var listeners = {
      blur: handleBlur,
      focus: handleFocus,
      keydown: handleKeydown,
      keyup: handleKeyup,
      keypress: handleKeypress,
      enter: handleEnter,
      click: focus,
      clear: handleClear
    };
    return {
      classPrefix: classPrefix,
      wrapClasses: wrapClasses,
      reduceClasses: reduceClasses,
      addClasses: addClasses,
      tDisabled: tDisabled,
      isError: isError,
      listeners: listeners,
      userInput: userInput,
      tValue: tValue,
      inputRef: inputRef,
      formDisabled: formDisabled,
      focus: focus,
      blur: blur,
      handleReduce: handleReduce,
      handleAdd: handleAdd,
      onInnerInputChange: onInnerInputChange
    };
  }

  function ownKeys$2o(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2n(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2o(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2o(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _InputNumber = VueCompositionAPI.defineComponent({
    name: "TInputNumber",
    props: props$$,
    setup: function setup(props2, context) {
      var p = useInputNumber(props2, context);
      var _useGlobalIcon = useGlobalIcon({
          AddIcon: TdAddIcon,
          RemoveIcon: TdRemoveIcon,
          ChevronDownIcon: TdChevronDownIcon,
          ChevronUpIcon: TdChevronUpIcon
        }),
        AddIcon = _useGlobalIcon.AddIcon,
        RemoveIcon = _useGlobalIcon.RemoveIcon,
        ChevronDownIcon = _useGlobalIcon.ChevronDownIcon,
        ChevronUpIcon = _useGlobalIcon.ChevronUpIcon;
      return _objectSpread$2n(_objectSpread$2n({}, p), {}, {
        AddIcon: AddIcon,
        RemoveIcon: RemoveIcon,
        ChevronDownIcon: ChevronDownIcon,
        ChevronUpIcon: ChevronUpIcon
      });
    },
    render: function render() {
      var h = arguments[0];
      var AddIcon = this.AddIcon,
        RemoveIcon = this.RemoveIcon,
        ChevronDownIcon = this.ChevronDownIcon,
        ChevronUpIcon = this.ChevronUpIcon;
      var reduceIcon = this.theme === "column" ? h(ChevronDownIcon, {
        "attrs": {
          "size": this.size
        }
      }) : h(RemoveIcon, {
        "attrs": {
          "size": this.size
        }
      });
      var addIcon = this.theme === "column" ? h(ChevronUpIcon, {
        "attrs": {
          "size": this.size
        }
      }) : h(AddIcon, {
        "attrs": {
          "size": this.size
        }
      });
      var status = this.isError ? "error" : this.status;
      return h("div", {
        "class": this.wrapClasses
      }, [this.theme !== "normal" && h(Button, {
        "class": this.reduceClasses,
        "attrs": {
          "disabled": this.tDisabled,
          "variant": "outline",
          "shape": "square",
          "icon": function icon() {
            return reduceIcon;
          }
        },
        "on": {
          "click": this.handleReduce
        }
      }), h(Input, helper([{
        "ref": "inputRef",
        "attrs": {
          "disabled": this.tDisabled,
          "readonly": this.readonly,
          "autocomplete": "off",
          "placeholder": this.placeholder,
          "unselectable": this.readonly ? "on" : "off",
          "autoWidth": this.autoWidth,
          "align": this.align || (this.theme === "row" ? "center" : void 0),
          "status": status,
          "label": this.label,
          "suffix": this.suffix
        }
      }, {
        "on": this.listeners
      }, {
        "scopedSlots": this.$scopedSlots
      }, {
        "props": this.inputProps
      }, {
        "attrs": {
          "value": this.userInput
        },
        "on": {
          "change": this.onInnerInputChange
        }
      }])), this.theme !== "normal" && h(Button, {
        "class": this.addClasses,
        "attrs": {
          "disabled": this.tDisabled,
          "variant": "outline",
          "shape": "square",
          "icon": function icon() {
            return addIcon;
          }
        },
        "on": {
          "click": this.handleAdd
        }
      }), this.tips && h("div", {
        "class": "".concat(this.classPrefix, "-input__tips ").concat(this.classPrefix, "-input__tips--").concat(status)
      }, [this.tips])]);
    }
  });

  var InputNumber = withInstall$1(_InputNumber, VueCompositionAPI__default["default"]);

  function useDefaultValue(value, defaultValue, onChange, propsName, eventName) {
    var _getCurrentInstance = VueCompositionAPI.getCurrentInstance(),
      emit = _getCurrentInstance.emit,
      vnode = _getCurrentInstance.vnode;
    var internalValue = VueCompositionAPI.ref();
    internalValue.value = defaultValue;
    if (Object.prototype.hasOwnProperty.call(vnode.componentOptions.propsData, propsName)) {
      return [value, function (newValue) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        emit.apply(void 0, ["update:".concat(propsName), newValue].concat(args));
        onChange === null || onChange === void 0 || onChange.apply(void 0, [newValue].concat(args));
        emit.apply(void 0, [eventName, newValue].concat(args));
      }];
    }
    return [internalValue, function (newValue) {
      internalValue.value = newValue;
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      emit.apply(void 0, [eventName, newValue].concat(args));
      onChange === null || onChange === void 0 || onChange.apply(void 0, [newValue].concat(args));
    }];
  }

  var props$_ = {
    autoWidth: Boolean,
    autofocus: Boolean,
    borderless: Boolean,
    clearable: Boolean,
    collapsedItems: {
      type: Function
    },
    creatable: Boolean,
    disabled: Boolean,
    empty: {
      type: [String, Function]
    },
    filter: {
      type: Function
    },
    filterable: Boolean,
    inputProps: {
      type: Object
    },
    inputValue: {
      type: [String, Number]
    },
    defaultInputValue: {
      type: [String, Number]
    },
    keys: {
      type: Object
    },
    label: {
      type: [String, Function]
    },
    loading: Boolean,
    loadingText: {
      type: [String, Function]
    },
    max: {
      type: Number,
      "default": 0
    },
    minCollapsedNum: {
      type: Number,
      "default": 0
    },
    multiple: Boolean,
    options: {
      type: Array
    },
    panelBottomContent: {
      type: [String, Function]
    },
    panelTopContent: {
      type: [String, Function]
    },
    placeholder: {
      type: String,
      "default": void 0
    },
    popupProps: {
      type: Object
    },
    popupVisible: {
      type: Boolean,
      "default": void 0
    },
    defaultPopupVisible: Boolean,
    prefixIcon: {
      type: Function
    },
    readonly: Boolean,
    reserveKeyword: Boolean,
    scroll: {
      type: Object
    },
    selectInputProps: {
      type: Object
    },
    showArrow: {
      type: Boolean,
      "default": true
    },
    size: {
      type: String,
      "default": "medium",
      validator: function validator(val) {
        if (!val) return true;
        return ["small", "medium", "large"].includes(val);
      }
    },
    status: {
      type: String,
      "default": "default",
      validator: function validator(val) {
        if (!val) return true;
        return ["default", "success", "warning", "error"].includes(val);
      }
    },
    suffix: {
      type: [String, Function]
    },
    suffixIcon: {
      type: Function
    },
    tagInputProps: {
      type: Object
    },
    tagProps: {
      type: Object
    },
    tips: {
      type: [String, Function]
    },
    value: {
      type: [String, Number, Boolean, Object, Array],
      "default": void 0
    },
    defaultValue: {
      type: [String, Number, Boolean, Object, Array],
      "default": void 0
    },
    valueDisplay: {
      type: [String, Function]
    },
    valueType: {
      type: String,
      "default": "value",
      validator: function validator(val) {
        if (!val) return true;
        return ["value", "object"].includes(val);
      }
    },
    onBlur: Function,
    onChange: Function,
    onClear: Function,
    onCreate: Function,
    onEnter: Function,
    onFocus: Function,
    onInputChange: Function,
    onPopupVisibleChange: Function,
    onRemove: Function,
    onSearch: Function
  };

  // This file is autogenerated. It's used to publish ESM to npm.
  function _typeof$1(obj) {
    "@babel/helpers - typeof";

    return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof$1(obj);
  }

  // https://github.com/bgrins/TinyColor
  // Brian Grinstead, MIT License

  var trimLeft = /^\s+/;
  var trimRight = /\s+$/;
  function tinycolor(color, opts) {
    color = color ? color : "";
    opts = opts || {};

    // If input is already a tinycolor, return itself
    if (color instanceof tinycolor) {
      return color;
    }
    // If we are called as a function, call using new instead
    if (!(this instanceof tinycolor)) {
      return new tinycolor(color, opts);
    }
    var rgb = inputToRGB(color);
    this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;

    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) this._r = Math.round(this._r);
    if (this._g < 1) this._g = Math.round(this._g);
    if (this._b < 1) this._b = Math.round(this._b);
    this._ok = rgb.ok;
  }
  tinycolor.prototype = {
    isDark: function isDark() {
      return this.getBrightness() < 128;
    },
    isLight: function isLight() {
      return !this.isDark();
    },
    isValid: function isValid() {
      return this._ok;
    },
    getOriginalInput: function getOriginalInput() {
      return this._originalInput;
    },
    getFormat: function getFormat() {
      return this._format;
    },
    getAlpha: function getAlpha() {
      return this._a;
    },
    getBrightness: function getBrightness() {
      //http://www.w3.org/TR/AERT#color-contrast
      var rgb = this.toRgb();
      return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function getLuminance() {
      //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
      var rgb = this.toRgb();
      var RsRGB, GsRGB, BsRGB, R, G, B;
      RsRGB = rgb.r / 255;
      GsRGB = rgb.g / 255;
      BsRGB = rgb.b / 255;
      if (RsRGB <= 0.03928) R = RsRGB / 12.92;else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
      if (GsRGB <= 0.03928) G = GsRGB / 12.92;else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
      if (BsRGB <= 0.03928) B = BsRGB / 12.92;else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
      return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    },
    setAlpha: function setAlpha(value) {
      this._a = boundAlpha(value);
      this._roundA = Math.round(100 * this._a) / 100;
      return this;
    },
    toHsv: function toHsv() {
      var hsv = rgbToHsv(this._r, this._g, this._b);
      return {
        h: hsv.h * 360,
        s: hsv.s,
        v: hsv.v,
        a: this._a
      };
    },
    toHsvString: function toHsvString() {
      var hsv = rgbToHsv(this._r, this._g, this._b);
      var h = Math.round(hsv.h * 360),
        s = Math.round(hsv.s * 100),
        v = Math.round(hsv.v * 100);
      return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
    },
    toHsl: function toHsl() {
      var hsl = rgbToHsl(this._r, this._g, this._b);
      return {
        h: hsl.h * 360,
        s: hsl.s,
        l: hsl.l,
        a: this._a
      };
    },
    toHslString: function toHslString() {
      var hsl = rgbToHsl(this._r, this._g, this._b);
      var h = Math.round(hsl.h * 360),
        s = Math.round(hsl.s * 100),
        l = Math.round(hsl.l * 100);
      return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
    },
    toHex: function toHex(allow3Char) {
      return rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function toHexString(allow3Char) {
      return "#" + this.toHex(allow3Char);
    },
    toHex8: function toHex8(allow4Char) {
      return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function toHex8String(allow4Char) {
      return "#" + this.toHex8(allow4Char);
    },
    toRgb: function toRgb() {
      return {
        r: Math.round(this._r),
        g: Math.round(this._g),
        b: Math.round(this._b),
        a: this._a
      };
    },
    toRgbString: function toRgbString() {
      return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function toPercentageRgb() {
      return {
        r: Math.round(bound01(this._r, 255) * 100) + "%",
        g: Math.round(bound01(this._g, 255) * 100) + "%",
        b: Math.round(bound01(this._b, 255) * 100) + "%",
        a: this._a
      };
    },
    toPercentageRgbString: function toPercentageRgbString() {
      return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function toName() {
      if (this._a === 0) {
        return "transparent";
      }
      if (this._a < 1) {
        return false;
      }
      return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function toFilter(secondColor) {
      var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
      var secondHex8String = hex8String;
      var gradientType = this._gradientType ? "GradientType = 1, " : "";
      if (secondColor) {
        var s = tinycolor(secondColor);
        secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
      }
      return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
    },
    toString: function toString(format) {
      var formatSet = !!format;
      format = format || this._format;
      var formattedString = false;
      var hasAlpha = this._a < 1 && this._a >= 0;
      var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
      if (needsAlphaFormat) {
        // Special case for "transparent", all other non-alpha formats
        // will return rgba when there is transparency.
        if (format === "name" && this._a === 0) {
          return this.toName();
        }
        return this.toRgbString();
      }
      if (format === "rgb") {
        formattedString = this.toRgbString();
      }
      if (format === "prgb") {
        formattedString = this.toPercentageRgbString();
      }
      if (format === "hex" || format === "hex6") {
        formattedString = this.toHexString();
      }
      if (format === "hex3") {
        formattedString = this.toHexString(true);
      }
      if (format === "hex4") {
        formattedString = this.toHex8String(true);
      }
      if (format === "hex8") {
        formattedString = this.toHex8String();
      }
      if (format === "name") {
        formattedString = this.toName();
      }
      if (format === "hsl") {
        formattedString = this.toHslString();
      }
      if (format === "hsv") {
        formattedString = this.toHsvString();
      }
      return formattedString || this.toHexString();
    },
    clone: function clone() {
      return tinycolor(this.toString());
    },
    _applyModification: function _applyModification(fn, args) {
      var color = fn.apply(null, [this].concat([].slice.call(args)));
      this._r = color._r;
      this._g = color._g;
      this._b = color._b;
      this.setAlpha(color._a);
      return this;
    },
    lighten: function lighten() {
      return this._applyModification(_lighten, arguments);
    },
    brighten: function brighten() {
      return this._applyModification(_brighten, arguments);
    },
    darken: function darken() {
      return this._applyModification(_darken, arguments);
    },
    desaturate: function desaturate() {
      return this._applyModification(_desaturate, arguments);
    },
    saturate: function saturate() {
      return this._applyModification(_saturate, arguments);
    },
    greyscale: function greyscale() {
      return this._applyModification(_greyscale, arguments);
    },
    spin: function spin() {
      return this._applyModification(_spin, arguments);
    },
    _applyCombination: function _applyCombination(fn, args) {
      return fn.apply(null, [this].concat([].slice.call(args)));
    },
    analogous: function analogous() {
      return this._applyCombination(_analogous, arguments);
    },
    complement: function complement() {
      return this._applyCombination(_complement, arguments);
    },
    monochromatic: function monochromatic() {
      return this._applyCombination(_monochromatic, arguments);
    },
    splitcomplement: function splitcomplement() {
      return this._applyCombination(_splitcomplement, arguments);
    },
    // Disabled until https://github.com/bgrins/TinyColor/issues/254
    // polyad: function (number) {
    //   return this._applyCombination(polyad, [number]);
    // },
    triad: function triad() {
      return this._applyCombination(polyad, [3]);
    },
    tetrad: function tetrad() {
      return this._applyCombination(polyad, [4]);
    }
  };

  // If input is an object, force 1 into "1.0" to handle ratios properly
  // String input requires "1.0" as input, so 1 will be treated as 1
  tinycolor.fromRatio = function (color, opts) {
    if (_typeof$1(color) == "object") {
      var newColor = {};
      for (var i in color) {
        if (color.hasOwnProperty(i)) {
          if (i === "a") {
            newColor[i] = color[i];
          } else {
            newColor[i] = convertToPercentage(color[i]);
          }
        }
      }
      color = newColor;
    }
    return tinycolor(color, opts);
  };

  // Given a string or object, convert that input to RGB
  // Possible string inputs:
  //
  //     "red"
  //     "#f00" or "f00"
  //     "#ff0000" or "ff0000"
  //     "#ff000000" or "ff000000"
  //     "rgb 255 0 0" or "rgb (255, 0, 0)"
  //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
  //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
  //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
  //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
  //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
  //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
  //
  function inputToRGB(color) {
    var rgb = {
      r: 0,
      g: 0,
      b: 0
    };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color == "string") {
      color = stringInputToObject(color);
    }
    if (_typeof$1(color) == "object") {
      if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
        rgb = rgbToRgb(color.r, color.g, color.b);
        ok = true;
        format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
      } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
        s = convertToPercentage(color.s);
        v = convertToPercentage(color.v);
        rgb = hsvToRgb(color.h, s, v);
        ok = true;
        format = "hsv";
      } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
        s = convertToPercentage(color.s);
        l = convertToPercentage(color.l);
        rgb = hslToRgb(color.h, s, l);
        ok = true;
        format = "hsl";
      }
      if (color.hasOwnProperty("a")) {
        a = color.a;
      }
    }
    a = boundAlpha(a);
    return {
      ok: ok,
      format: color.format || format,
      r: Math.min(255, Math.max(rgb.r, 0)),
      g: Math.min(255, Math.max(rgb.g, 0)),
      b: Math.min(255, Math.max(rgb.b, 0)),
      a: a
    };
  }

  // Conversion Functions
  // --------------------

  // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
  // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

  // `rgbToRgb`
  // Handle bounds / percentage checking to conform to CSS color spec
  // <http://www.w3.org/TR/css3-color/>
  // *Assumes:* r, g, b in [0, 255] or [0, 1]
  // *Returns:* { r, g, b } in [0, 255]
  function rgbToRgb(r, g, b) {
    return {
      r: bound01(r, 255) * 255,
      g: bound01(g, 255) * 255,
      b: bound01(b, 255) * 255
    };
  }

  // `rgbToHsl`
  // Converts an RGB color value to HSL.
  // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
  // *Returns:* { h, s, l } in [0,1]
  function rgbToHsl(r, g, b) {
    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);
    var max = Math.max(r, g, b),
      min = Math.min(r, g, b);
    var h,
      s,
      l = (max + min) / 2;
    if (max == min) {
      h = s = 0; // achromatic
    } else {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }
    return {
      h: h,
      s: s,
      l: l
    };
  }

  // `hslToRgb`
  // Converts an HSL color value to RGB.
  // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
  // *Returns:* { r, g, b } in the set [0, 255]
  function hslToRgb(h, s, l) {
    var r, g, b;
    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);
    function hue2rgb(p, q, t) {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    }
    if (s === 0) {
      r = g = b = l; // achromatic
    } else {
      var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      var p = 2 * l - q;
      r = hue2rgb(p, q, h + 1 / 3);
      g = hue2rgb(p, q, h);
      b = hue2rgb(p, q, h - 1 / 3);
    }
    return {
      r: r * 255,
      g: g * 255,
      b: b * 255
    };
  }

  // `rgbToHsv`
  // Converts an RGB color value to HSV
  // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
  // *Returns:* { h, s, v } in [0,1]
  function rgbToHsv(r, g, b) {
    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);
    var max = Math.max(r, g, b),
      min = Math.min(r, g, b);
    var h,
      s,
      v = max;
    var d = max - min;
    s = max === 0 ? 0 : d / max;
    if (max == min) {
      h = 0; // achromatic
    } else {
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }
    return {
      h: h,
      s: s,
      v: v
    };
  }

  // `hsvToRgb`
  // Converts an HSV color value to RGB.
  // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
  // *Returns:* { r, g, b } in the set [0, 255]
  function hsvToRgb(h, s, v) {
    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);
    var i = Math.floor(h),
      f = h - i,
      p = v * (1 - s),
      q = v * (1 - f * s),
      t = v * (1 - (1 - f) * s),
      mod = i % 6,
      r = [v, q, p, p, t, v][mod],
      g = [t, v, v, q, p, p][mod],
      b = [p, p, t, v, v, q][mod];
    return {
      r: r * 255,
      g: g * 255,
      b: b * 255
    };
  }

  // `rgbToHex`
  // Converts an RGB color to hex
  // Assumes r, g, and b are contained in the set [0, 255]
  // Returns a 3 or 6 character hex
  function rgbToHex(r, g, b, allow3Char) {
    var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];

    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
      return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }
    return hex.join("");
  }

  // `rgbaToHex`
  // Converts an RGBA color plus alpha transparency to hex
  // Assumes r, g, b are contained in the set [0, 255] and
  // a in [0, 1]. Returns a 4 or 8 character rgba hex
  function rgbaToHex(r, g, b, a, allow4Char) {
    var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16)), pad2(convertDecimalToHex(a))];

    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
      return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    }
    return hex.join("");
  }

  // `rgbaToArgbHex`
  // Converts an RGBA color to an ARGB Hex8 string
  // Rarely used, but required for "toFilter()"
  function rgbaToArgbHex(r, g, b, a) {
    var hex = [pad2(convertDecimalToHex(a)), pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];
    return hex.join("");
  }

  // `equals`
  // Can be called with any tinycolor input
  tinycolor.equals = function (color1, color2) {
    if (!color1 || !color2) return false;
    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
  };
  tinycolor.random = function () {
    return tinycolor.fromRatio({
      r: Math.random(),
      g: Math.random(),
      b: Math.random()
    });
  };

  // Modification Functions
  // ----------------------
  // Thanks to less.js for some of the basics here
  // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

  function _desaturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
  }
  function _saturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
  }
  function _greyscale(color) {
    return tinycolor(color).desaturate(100);
  }
  function _lighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
  }
  function _brighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var rgb = tinycolor(color).toRgb();
    rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
    rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
    rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
    return tinycolor(rgb);
  }
  function _darken(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
  }

  // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
  // Values outside of this range will be wrapped into this range.
  function _spin(color, amount) {
    var hsl = tinycolor(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return tinycolor(hsl);
  }

  // Combination Functions
  // ---------------------
  // Thanks to jQuery xColor for some of the ideas behind these
  // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

  function _complement(color) {
    var hsl = tinycolor(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return tinycolor(hsl);
  }
  function polyad(color, number) {
    if (isNaN(number) || number <= 0) {
      throw new Error("Argument to polyad must be a positive number");
    }
    var hsl = tinycolor(color).toHsl();
    var result = [tinycolor(color)];
    var step = 360 / number;
    for (var i = 1; i < number; i++) {
      result.push(tinycolor({
        h: (hsl.h + i * step) % 360,
        s: hsl.s,
        l: hsl.l
      }));
    }
    return result;
  }
  function _splitcomplement(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [tinycolor(color), tinycolor({
      h: (h + 72) % 360,
      s: hsl.s,
      l: hsl.l
    }), tinycolor({
      h: (h + 216) % 360,
      s: hsl.s,
      l: hsl.l
    })];
  }
  function _analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;
    var hsl = tinycolor(color).toHsl();
    var part = 360 / slices;
    var ret = [tinycolor(color)];
    for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;) {
      hsl.h = (hsl.h + part) % 360;
      ret.push(tinycolor(hsl));
    }
    return ret;
  }
  function _monochromatic(color, results) {
    results = results || 6;
    var hsv = tinycolor(color).toHsv();
    var h = hsv.h,
      s = hsv.s,
      v = hsv.v;
    var ret = [];
    var modification = 1 / results;
    while (results--) {
      ret.push(tinycolor({
        h: h,
        s: s,
        v: v
      }));
      v = (v + modification) % 1;
    }
    return ret;
  }

  // Utility Functions
  // ---------------------

  tinycolor.mix = function (color1, color2, amount) {
    amount = amount === 0 ? 0 : amount || 50;
    var rgb1 = tinycolor(color1).toRgb();
    var rgb2 = tinycolor(color2).toRgb();
    var p = amount / 100;
    var rgba = {
      r: (rgb2.r - rgb1.r) * p + rgb1.r,
      g: (rgb2.g - rgb1.g) * p + rgb1.g,
      b: (rgb2.b - rgb1.b) * p + rgb1.b,
      a: (rgb2.a - rgb1.a) * p + rgb1.a
    };
    return tinycolor(rgba);
  };

  // Readability Functions
  // ---------------------
  // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

  // `contrast`
  // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
  tinycolor.readability = function (color1, color2) {
    var c1 = tinycolor(color1);
    var c2 = tinycolor(color2);
    return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
  };

  // `isReadable`
  // Ensure that foreground and background color combinations meet WCAG2 guidelines.
  // The third argument is an optional Object.
  //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
  //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
  // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

  // *Example*
  //    tinycolor.isReadable("#000", "#111") => false
  //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
  tinycolor.isReadable = function (color1, color2, wcag2) {
    var readability = tinycolor.readability(color1, color2);
    var wcag2Parms, out;
    out = false;
    wcag2Parms = validateWCAG2Parms(wcag2);
    switch (wcag2Parms.level + wcag2Parms.size) {
      case "AAsmall":
      case "AAAlarge":
        out = readability >= 4.5;
        break;
      case "AAlarge":
        out = readability >= 3;
        break;
      case "AAAsmall":
        out = readability >= 7;
        break;
    }
    return out;
  };

  // `mostReadable`
  // Given a base color and a list of possible foreground or background
  // colors for that base, returns the most readable color.
  // Optionally returns Black or White if the most readable color is unreadable.
  // *Example*
  //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
  //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
  //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
  //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
  tinycolor.mostReadable = function (baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors;
    level = args.level;
    size = args.size;
    for (var i = 0; i < colorList.length; i++) {
      readability = tinycolor.readability(baseColor, colorList[i]);
      if (readability > bestScore) {
        bestScore = readability;
        bestColor = tinycolor(colorList[i]);
      }
    }
    if (tinycolor.isReadable(baseColor, bestColor, {
      level: level,
      size: size
    }) || !includeFallbackColors) {
      return bestColor;
    } else {
      args.includeFallbackColors = false;
      return tinycolor.mostReadable(baseColor, ["#fff", "#000"], args);
    }
  };

  // Big List of Colors
  // ------------------
  // <https://www.w3.org/TR/css-color-4/#named-colors>
  var names = tinycolor.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
  };

  // Make it easy to access colors via `hexNames[hex]`
  var hexNames = tinycolor.hexNames = flip(names);

  // Utilities
  // ---------

  // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
  function flip(o) {
    var flipped = {};
    for (var i in o) {
      if (o.hasOwnProperty(i)) {
        flipped[o[i]] = i;
      }
    }
    return flipped;
  }

  // Return a valid alpha value [0,1] with all invalid values being set to 1
  function boundAlpha(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) {
      a = 1;
    }
    return a;
  }

  // Take input from [0, n] and return it as [0, 1]
  function bound01(n, max) {
    if (isOnePointZero(n)) n = "100%";
    var processPercent = isPercentage(n);
    n = Math.min(max, Math.max(0, parseFloat(n)));

    // Automatically convert percentage into number
    if (processPercent) {
      n = parseInt(n * max, 10) / 100;
    }

    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) {
      return 1;
    }

    // Convert into [0, 1] range if it isn't already
    return n % max / parseFloat(max);
  }

  // Force a number between 0 and 1
  function clamp01(val) {
    return Math.min(1, Math.max(0, val));
  }

  // Parse a base-16 hex value into a base-10 integer
  function parseIntFromHex(val) {
    return parseInt(val, 16);
  }

  // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
  // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
  function isOnePointZero(n) {
    return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
  }

  // Check to see if string passed in is a percentage
  function isPercentage(n) {
    return typeof n === "string" && n.indexOf("%") != -1;
  }

  // Force a hex value to have 2 characters
  function pad2(c) {
    return c.length == 1 ? "0" + c : "" + c;
  }

  // Replace a decimal with it's percentage value
  function convertToPercentage(n) {
    if (n <= 1) {
      n = n * 100 + "%";
    }
    return n;
  }

  // Converts a decimal to a hex value
  function convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
  }
  // Converts a hex value to a decimal
  function convertHexToDecimal(h) {
    return parseIntFromHex(h) / 255;
  }
  var matchers = function () {
    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";

    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    return {
      CSS_UNIT: new RegExp(CSS_UNIT),
      rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
      rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
      hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
      hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
      hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
      hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
      hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
      hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
      hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
      hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
  }();

  // `isValidCSSUnit`
  // Take in a single string / number and check to see if it looks like a CSS unit
  // (see `matchers` above for definition).
  function isValidCSSUnit(color) {
    return !!matchers.CSS_UNIT.exec(color);
  }

  // `stringInputToObject`
  // Permissive string parsing.  Take in a number of formats, and output an object
  // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
  function stringInputToObject(color) {
    color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
    var named = false;
    if (names[color]) {
      color = names[color];
      named = true;
    } else if (color == "transparent") {
      return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: "name"
      };
    }

    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if (match = matchers.rgb.exec(color)) {
      return {
        r: match[1],
        g: match[2],
        b: match[3]
      };
    }
    if (match = matchers.rgba.exec(color)) {
      return {
        r: match[1],
        g: match[2],
        b: match[3],
        a: match[4]
      };
    }
    if (match = matchers.hsl.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        l: match[3]
      };
    }
    if (match = matchers.hsla.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        l: match[3],
        a: match[4]
      };
    }
    if (match = matchers.hsv.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        v: match[3]
      };
    }
    if (match = matchers.hsva.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        v: match[3],
        a: match[4]
      };
    }
    if (match = matchers.hex8.exec(color)) {
      return {
        r: parseIntFromHex(match[1]),
        g: parseIntFromHex(match[2]),
        b: parseIntFromHex(match[3]),
        a: convertHexToDecimal(match[4]),
        format: named ? "name" : "hex8"
      };
    }
    if (match = matchers.hex6.exec(color)) {
      return {
        r: parseIntFromHex(match[1]),
        g: parseIntFromHex(match[2]),
        b: parseIntFromHex(match[3]),
        format: named ? "name" : "hex"
      };
    }
    if (match = matchers.hex4.exec(color)) {
      return {
        r: parseIntFromHex(match[1] + "" + match[1]),
        g: parseIntFromHex(match[2] + "" + match[2]),
        b: parseIntFromHex(match[3] + "" + match[3]),
        a: convertHexToDecimal(match[4] + "" + match[4]),
        format: named ? "name" : "hex8"
      };
    }
    if (match = matchers.hex3.exec(color)) {
      return {
        r: parseIntFromHex(match[1] + "" + match[1]),
        g: parseIntFromHex(match[2] + "" + match[2]),
        b: parseIntFromHex(match[3] + "" + match[3]),
        format: named ? "name" : "hex"
      };
    }
    return false;
  }
  function validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {
      level: "AA",
      size: "small"
    };
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") {
      level = "AA";
    }
    if (size !== "small" && size !== "large") {
      size = "small";
    }
    return {
      level: level,
      size: size
    };
  }

  var props$Z = {
    closable: Boolean,
    color: {
      type: String,
      "default": ""
    },
    content: {
      type: [String, Function]
    },
    "default": {
      type: [String, Function]
    },
    disabled: Boolean,
    icon: {
      type: Function,
      "default": void 0
    },
    maxWidth: {
      type: [String, Number]
    },
    shape: {
      type: String,
      "default": "square",
      validator: function validator(val) {
        if (!val) return true;
        return ["square", "round", "mark"].includes(val);
      }
    },
    size: {
      type: String,
      "default": "medium",
      validator: function validator(val) {
        if (!val) return true;
        return ["small", "medium", "large"].includes(val);
      }
    },
    theme: {
      type: String,
      "default": "default",
      validator: function validator(val) {
        if (!val) return true;
        return ["default", "primary", "warning", "danger", "success"].includes(val);
      }
    },
    title: {
      type: String,
      "default": ""
    },
    variant: {
      type: String,
      "default": "dark",
      validator: function validator(val) {
        if (!val) return true;
        return ["dark", "light", "outline", "light-outline"].includes(val);
      }
    },
    onClick: Function,
    onClose: Function
  };

  function ownKeys$2n(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2m(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2n(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2n(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _Tag = mixins(getConfigReceiverMixins("tag"), getGlobalIconMixins()).extend({
    name: "TTag",
    props: _objectSpread$2m({}, props$Z),
    computed: {
      tagClass: function tagClass() {
        return ["".concat(this.componentName), "".concat(this.componentName, "--").concat(this.theme), "".concat(this.componentName, "--").concat(this.variant), this.shape !== "square" && "".concat(this.componentName, "--").concat(this.shape), _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({}, this.commonSizeClassName[this.size], this.size !== "medium"), "".concat(this.componentName, "--ellipsis"), this.maxWidth), "".concat(this.componentName, "--close"), this.closable), "".concat(this.classPrefix, "-is-disabled"), this.disabled), "".concat(this.componentName, "--disabled"), this.disabled)];
      },
      textStyle: function textStyle() {
        if (this.maxWidth) {
          return {
            maxWidth: isNaN(Number(this.maxWidth)) ? this.maxWidth : "".concat(this.maxWidth, "px")
          };
        }
        return {};
      },
      tagStyle: function tagStyle() {
        if (this.color) {
          return this.getTagColorStyle();
        }
        return {};
      }
    },
    methods: {
      handleClose: function handleClose(e) {
        if (this.disabled) return;
        emitEvent$1(this, "close", {
          e: e
        });
      },
      handleClick: function handleClick(e) {
        if (this.disabled) return;
        emitEvent$1(this, "click", {
          e: e
        });
      },
      getCloseIcon: function getCloseIcon() {
        var _this = this;
        var h = this.$createElement;
        if (!this.closable) return null;
        var iconClassName = "".concat(this.classPrefix, "-tag__icon-close");
        if (this.global.closeIcon) {
          return this.global.closeIcon(function (component, b) {
            var tProps = _typeof$2(b) === "object" && "attrs" in b ? b.attrs : {};
            return _this.$createElement(component, {
              props: _objectSpread$2m({}, tProps),
              "class": iconClassName,
              nativeOn: {
                click: _this.handleClose
              }
            });
          });
        }
        var _this$useGlobalIcon = this.useGlobalIcon({
            CloseIcon: TdCloseIcon
          }),
          CloseIcon = _this$useGlobalIcon.CloseIcon;
        return h(CloseIcon, {
          "nativeOn": {
            "click": this.handleClose
          },
          "class": iconClassName
        });
      },
      getTagColorStyle: function getTagColorStyle() {
        var _this2 = this;
        var luminance = tinycolor(this.color).getLuminance();
        var style = {
          color: luminance > 0.5 ? "black" : "white"
        };
        if (this.variant === "outline" || this.variant === "light-outline") {
          style.borderColor = this.color;
        }
        if (this.variant !== "outline") {
          var getLightestShade = function getLightestShade() {
            var _tinycolor$toRgb = tinycolor(_this2.color).toRgb(),
              r = _tinycolor$toRgb.r,
              g = _tinycolor$toRgb.g,
              b = _tinycolor$toRgb.b;
            return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", 0.1)");
          };
          style.backgroundColor = this.variant === "dark" ? this.color : getLightestShade();
        }
        if (this.variant !== "dark") {
          style.color = this.color;
        }
        return style;
      },
      renderTitle: function renderTitle(tagContent) {
        if (!this.maxWidth) {
          return void 0;
        }
        var vProps = this.$vnode.componentOptions.propsData || {};
        if (Reflect.has(vProps, "title")) {
          return vProps.title || void 0;
        }
        if (tagContent) {
          return tagContent;
        }
        return void 0;
      }
    },
    render: function render() {
      var h = arguments[0];
      var closeIcon = this.getCloseIcon();
      var tagContent = renderContent(this, "default", "content");
      var title = this.renderTitle(isString(tagContent) ? tagContent : "");
      var icon = renderTNodeJSX(this, "icon");
      return h("div", {
        "class": this.tagClass,
        "on": {
          "click": this.handleClick
        },
        "style": this.tagStyle
      }, [icon, h("span", {
        "class": this.maxWidth ? "".concat(this.componentName, "--text") : void 0,
        "style": this.textStyle,
        "attrs": {
          "title": title
        }
      }, [tagContent]), !this.disabled ? closeIcon : void 0]);
    }
  });

  var props$Y = {
    checked: {
      type: Boolean,
      "default": void 0
    },
    defaultChecked: Boolean,
    checkedProps: {
      type: Object
    },
    content: {
      type: [String, Number, Array, Function]
    },
    "default": {
      type: [String, Function]
    },
    disabled: Boolean,
    size: {
      type: String,
      "default": "medium",
      validator: function validator(val) {
        if (!val) return true;
        return ["small", "medium", "large"].includes(val);
      }
    },
    uncheckedProps: {
      type: Object
    },
    value: {
      type: [String, Number]
    },
    onChange: Function,
    onClick: Function
  };

  var ARROW_DOWN_REG = /^ArrowDown$/i;
  var ARROW_UP_REG = /^ArrowUp$/i;
  var ARROW_LEFT_REG = /^ArrowLeft$/i;
  var ARROW_RIGHT_REG = /^ArrowRight$/i;
  var ESCAPE_REG = /^Escape$/i;
  var SPACE_REG = /^Space$/i;
  var ENTER_REG = /^Enter$/i;
  var SHIFT_REG = /^(Shift|ShiftLeft|ShiftRight)$/i;
  var CLEAR_REG = /^KeyC$/i;
  var ALL_REG = /^(KeyA|KeyL)$/i;
  var CHECKED_CODE_REG = /^(Enter|Space)$/i;

  function useChildComponentSlots() {
    var instance = VueCompositionAPI.getCurrentInstance();
    return function (childComponentName, slots) {
      var _slots, _slots$default;
      if (!slots) {
        var _instance$setupContex;
        slots = (_instance$setupContex = instance.setupContext) === null || _instance$setupContex === void 0 ? void 0 : _instance$setupContex.slots;
      }
      var content = ((_slots = slots) === null || _slots === void 0 || (_slots$default = _slots["default"]) === null || _slots$default === void 0 ? void 0 : _slots$default.call(_slots)) || [];
      var childList = [];
      var _getChildren = function getChildren(content2) {
        if (!isArray$1(content2)) return;
        content2.forEach(function (item) {
          if (item.children && isArray$1(item.children)) {
            _getChildren(item.children);
          } else {
            childList.push(item);
          }
        });
        return childList;
      };
      return _getChildren(content).filter(function (item) {
        var _item$tag;
        return (_item$tag = item.tag) === null || _item$tag === void 0 ? void 0 : _item$tag.endsWith(childComponentName);
      });
    };
  }

  function observe(element, root, callback, marginBottom) {
    if (typeof window === "undefined") return null;
    if (!window || !window.IntersectionObserver) {
      callback();
      return null;
    }
    var io = null;
    try {
      io = new window.IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (entry.isIntersecting) {
          callback();
          io.unobserve(element);
        }
      }, {
        rootMargin: "0px 0px ".concat(marginBottom, "px 0px"),
        root: root
      });
      io.observe(element);
    } catch (e) {
      console.error(e);
      callback();
    }
    return io;
  }

  function useElementLazyRender(labelRef, lazyLoad) {
    var ioObserver = VueCompositionAPI.ref();
    var showElement = VueCompositionAPI.ref(!lazyLoad.value);
    var handleLazyLoad = function handleLazyLoad() {
      if (!lazyLoad.value || !labelRef.value || ioObserver.value) return;
      showElement.value = false;
      var io = observe(labelRef.value, null, function () {
        showElement.value = true;
      }, 10);
      ioObserver.value = io;
    };
    VueCompositionAPI.onMounted(handleLazyLoad);
    lazyLoad.value && VueCompositionAPI.watch([lazyLoad, labelRef], handleLazyLoad);
    VueCompositionAPI.onBeforeUnmount(function () {
      var _ioObserver$value, _ioObserver$value$uno;
      if (!lazyLoad.value) return;
      (_ioObserver$value = ioObserver.value) === null || _ioObserver$value === void 0 || (_ioObserver$value$uno = _ioObserver$value.unobserve) === null || _ioObserver$value$uno === void 0 || _ioObserver$value$uno.call(_ioObserver$value, labelRef.value);
    });
    return {
      showElement: showElement
    };
  }

  function useLazyLoad(containerRef, childRef, params) {
    var tRowHeight = VueCompositionAPI.computed(function () {
      return Math.max(params.rowHeight || 48, 48);
    });
    var isInit = VueCompositionAPI.ref(false);
    var hasLazyLoadHolder = VueCompositionAPI.computed(function () {
      return (params === null || params === void 0 ? void 0 : params.type) === "lazy" && !isInit.value;
    });
    var requestAnimationFrame = (typeof window === "undefined" ? false : window.requestAnimationFrame) || function (cb) {
      return setTimeout(cb, 16.6);
    };
    var init = function init() {
      if (!isInit.value) {
        requestAnimationFrame(function () {
          isInit.value = true;
        });
      }
    };
    VueCompositionAPI.onMounted(function () {
      if ((params === null || params === void 0 ? void 0 : params.type) !== "lazy") return;
      VueCompositionAPI.nextTick(function () {
        var bufferSize = Math.max(10, params.bufferSize || 10);
        var height = tRowHeight.value * bufferSize;
        observe(childRef.value, containerRef === null || containerRef === void 0 ? void 0 : containerRef.value, init, height);
      });
    });
    return {
      hasLazyLoadHolder: hasLazyLoadHolder,
      tRowHeight: tRowHeight
    };
  }

  function useResizeObserver(container, callback) {
    var isSupport = typeof window !== "undefined" && window.ResizeObserver;
    if (!isSupport) return;
    var containerObserver = null;
    var cleanupObserver = function cleanupObserver() {
      if (!containerObserver || !container.value) return;
      containerObserver.unobserve(container.value);
      containerObserver.disconnect();
      containerObserver = null;
    };
    var addObserver = function addObserver(el) {
      containerObserver = new ResizeObserver(callback);
      containerObserver.observe(el);
    };
    container && VueCompositionAPI.watch(container, function (el) {
      cleanupObserver();
      el && addObserver(el);
    }, {
      immediate: true,
      flush: "post"
    });
    VueCompositionAPI.onBeforeUnmount(function () {
      cleanupObserver();
    });
  }

  var useVirtualScroll$1 = function useVirtualScroll(container, params) {
    var _params$value$data, _params$value$scroll;
    var visibleData = VueCompositionAPI.ref([]);
    var translateY = VueCompositionAPI.ref((((_params$value$data = params.value.data) === null || _params$value$data === void 0 ? void 0 : _params$value$data.length) || 0) * (((_params$value$scroll = params.value.scroll) === null || _params$value$scroll === void 0 ? void 0 : _params$value$scroll.rowHeight) || 50));
    var scrollHeight = VueCompositionAPI.ref(0);
    var trScrollTopHeightList = VueCompositionAPI.ref([]);
    var trHeightList = VueCompositionAPI.ref([]);
    var containerHeight = VueCompositionAPI.ref(0);
    var containerWidth = VueCompositionAPI.ref(0);
    var startAndEndIndex = VueCompositionAPI.ref([0, 15]);
    var tScroll = VueCompositionAPI.computed(function () {
      var _scroll$isFixedRowHei;
      var scroll = params.value.scroll;
      if (!scroll) return {};
      return {
        bufferSize: scroll.bufferSize || 10,
        isFixedRowHeight: (_scroll$isFixedRowHei = scroll.isFixedRowHeight) !== null && _scroll$isFixedRowHei !== void 0 ? _scroll$isFixedRowHei : false,
        rowHeight: scroll.rowHeight || 47,
        threshold: scroll.threshold || 100,
        type: scroll.type
      };
    });
    var isVirtualScroll = VueCompositionAPI.computed(function () {
      var data = params.value.data;
      return tScroll.value.type === "virtual" && tScroll.value.threshold < data.length;
    });
    var getTrScrollTopHeightList = function getTrScrollTopHeightList(trHeightList2, containerHeight2) {
      var list = [];
      var data = params.value.data;
      for (var i = 0, len = data.length; i < len; i++) {
        list[i] = (list[i - 1] || containerHeight2) + (trHeightList2[i] || tScroll.value.rowHeight);
      }
      return list;
    };
    var tripleBufferSize = VueCompositionAPI.computed(function () {
      return tScroll.value.bufferSize * 3;
    });
    var updateVisibleData = function updateVisibleData(trScrollTopHeightList2, scrollTop) {
      var currentIndex = -1;
      for (var i = 0, len = trScrollTopHeightList2.length; i < len; i++) {
        if (trScrollTopHeightList2[i] > scrollTop) {
          currentIndex = i;
          break;
        }
      }
      if (currentIndex < 0) return;
      var startIndex = Math.min(currentIndex, trScrollTopHeightList2.length - tripleBufferSize.value);
      var endIndex = startIndex + tripleBufferSize.value;
      if (startAndEndIndex.value.join() !== [startIndex, endIndex].join() && startIndex >= 0) {
        visibleData.value = params.value.data.slice(startIndex, endIndex);
        var lastScrollTop = trScrollTopHeightList2[startIndex - 1];
        var top = lastScrollTop > 0 ? lastScrollTop - containerHeight.value : 0;
        translateY.value = top;
        startAndEndIndex.value = [startIndex, endIndex];
      }
    };
    var handleRowMounted = function handleRowMounted(rowData) {
      var _rowData$ref$value;
      if (!isVirtualScroll.value || !rowData || tScroll.value.isFixedRowHeight || !container.value) return;
      var trHeight = (_rowData$ref$value = rowData.ref.value) === null || _rowData$ref$value === void 0 ? void 0 : _rowData$ref$value.getBoundingClientRect().height;
      var rowIndex = rowData.data.__VIRTUAL_SCROLL_INDEX;
      var newTrHeightList = trHeightList.value;
      if (newTrHeightList[rowIndex] !== trHeight) {
        newTrHeightList[rowIndex] = trHeight;
        var scrollTopHeightList = getTrScrollTopHeightList(newTrHeightList, containerHeight.value);
        trScrollTopHeightList.value = scrollTopHeightList;
        var lastIndex = scrollTopHeightList.length - 1;
        scrollHeight.value = scrollTopHeightList[lastIndex] - containerHeight.value;
        updateVisibleData(scrollTopHeightList, container.value.scrollTop);
      }
    };
    var handleScroll = function handleScroll() {
      if (!isVirtualScroll.value) return;
      updateVisibleData(trScrollTopHeightList.value, container.value.scrollTop);
    };
    var refreshVirtualScroll = function refreshVirtualScroll(_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        contentRect = _ref2[0].contentRect;
      var maxScrollbarWidth = 16;
      if (Math.abs(contentRect.width - containerWidth.value) > maxScrollbarWidth) {
        container.value.scrollTop = 0;
        translateY.value = 0;
      }
      containerWidth.value = contentRect.width;
      containerHeight.value = contentRect.height;
    };
    var addIndexToData = function addIndexToData(data) {
      data.forEach(function (item, index) {
        item["__VIRTUAL_SCROLL_INDEX"] = index;
      });
    };
    var updateScrollTop = function updateScrollTop(_ref3) {
      var index = _ref3.index,
        _ref3$top = _ref3.top,
        top = _ref3$top === void 0 ? 0 : _ref3$top,
        behavior = _ref3.behavior;
      var scrollTop = trScrollTopHeightList.value[index] - containerHeight.value - top;
      container.value.scrollTo({
        top: scrollTop,
        behavior: behavior || "auto"
      });
    };
    var scrollToElement = function scrollToElement(p) {
      updateScrollTop(p);
      if (!tScroll.value.isFixedRowHeight) {
        var _p$time;
        var duration = (_p$time = p.time) !== null && _p$time !== void 0 ? _p$time : 60;
        var timer = setTimeout(function () {
          updateScrollTop(p);
          clearTimeout(timer);
        }, duration);
      }
    };
    useResizeObserver(isVirtualScroll.value ? container : void 0, refreshVirtualScroll);
    VueCompositionAPI.watch(function () {
      return [[].concat(_toConsumableArray(params.value.data), [tScroll.value, isVirtualScroll.value, container.value])];
    }, function () {
      if (!isVirtualScroll.value) return;
      var data = params.value.data;
      addIndexToData(data);
      var startIndex = startAndEndIndex.value[0];
      visibleData.value = data.slice(startIndex, startIndex + tripleBufferSize.value);
      var timer = setTimeout(function () {
        if (container.value) {
          containerHeight.value = container.value.getBoundingClientRect().height;
          var scrollTopHeightList = getTrScrollTopHeightList(trHeightList.value || [], containerHeight.value);
          trScrollTopHeightList.value = scrollTopHeightList;
        }
        clearTimeout(timer);
      }, 0);
    }, {
      immediate: true
    });
    return {
      visibleData: visibleData,
      translateY: translateY,
      scrollHeight: scrollHeight,
      isVirtualScroll: isVirtualScroll,
      handleScroll: handleScroll,
      handleRowMounted: handleRowMounted,
      scrollToElement: scrollToElement
    };
  };

  var IMAGE_REGEXP = /(.png|.jpg|.jpeg|.jpe|.webp|.avif|.svg|.gif|.bmp)/i;
  var IMAGE_ALL_REGEXP = /(.png|.jpg|.jpeg|.jpe|.webp|.avif|.svg|.gif|.bmp|.dwg|.dxf|.svf|.tif|.tiff|.arw)/i;
  var FILE_PDF_REGEXP = /(.pdf)/i;
  var FILE_EXCEL_REGEXP = /(.xlsx|.xls|.csv|.xlc|.xlm|.xlt|.xlw)/i;
  var FILE_WORD_REGEXP = /(.dox|docx|.document|.wps|.wdb|.msword)/i;
  var FILE_PPT_REGEXP = /(.ppt|.pptx|.key)/i;
  var VIDEO_REGEXP = /(.avi|.mp4|.wmv|.mpg|.mpeg|.mov|.rm|.ram|.swf|.flv|.rmvb|.flash|.mid|.3gp)/i;
  var AUDIO_REGEXP = /(.mp2|.mp3|.mp4|.ogg|.3gpp|.ac3|.au)/i;
  var INPUT_FILE_MAP = {
    "audio/*": AUDIO_REGEXP,
    "video/*": VIDEO_REGEXP,
    "image/*": IMAGE_ALL_REGEXP,
    ".ico": /image\/vnd.microsoft.icon/i,
    ".doc": /application\/msword/i,
    ".docx": /application\/vnd.openxmlformats-officedocument.wordprocessingml.document/i,
    ".xls": /application\/vnd.ms-excel/i,
    ".xlsx": /application\/vnd.openxmlformats-officedocument.spreadsheetml.sheet/i,
    ".ppt": /application\/vnd.ms-powerpoint/i,
    ".pptx": /application\/vnd.openxmlformats-officedocument.presentationml.presentation/i,
    ".vsd": /application\/vnd.visio/i,
    ".txt": /text\/plain/i,
    ".abw": /application\/x-abiword/i,
    ".avi": /video\/x-msvideo/i,
    ".azw": /application\/vnd.amazon.ebook/i,
    ".bin": /application\/octet-stream/i,
    ".cda": /application\/x-cdf/i,
    ".mpkg": /application\/vnd.apple.installer+xml/i,
    ".odp": /application\/vnd.oasis.opendocument.presentation/i,
    ".ods": /application\/vnd.oasis.opendocument.spreadsheet/i,
    ".odt": /application\/vnd.oasis.opendocument.text/i,
    ".oga": /audio\/ogg/i,
    ".ogv": /video\/ogg/i,
    ".ogx": /application\/ogg/i
  };
  var SIZE_MAP = {
    B: 1,
    KB: 1024,
    MB: 1048576,
    GB: 1073741824
  };
  function returnFileSize(number) {
    if (number < SIZE_MAP.KB) {
      return "".concat(number, " Bytes");
    }
    if (number >= SIZE_MAP.KB && number < SIZE_MAP.MB) {
      return "".concat((number / SIZE_MAP.KB).toFixed(1), " KB");
    }
    if (number >= SIZE_MAP.MB && number < SIZE_MAP.GB) {
      return "".concat((number / SIZE_MAP.MB).toFixed(1), " MB");
    }
    if (number >= SIZE_MAP.GB) {
      return "".concat((number / SIZE_MAP.GB).toFixed(1), " GB");
    }
    return "";
  }
  function getCurrentDate() {
    var needTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var d = new Date();
    var month = d.getMonth() + 1;
    month = month < 10 ? "0".concat(month) : month;
    var date = "".concat(d.getFullYear(), "-").concat(month, "-").concat(d.getDate());
    var time = "".concat(d.getHours(), ":").concat(d.getMinutes(), ":").concat(d.getSeconds());
    if (needTime) return [date, time].join(" ");
    return date;
  }
  function abridgeName(inputName) {
    var leftCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
    var rightCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 7;
    var name = inputName;
    var leftLength = 0;
    var rightLength = 0;
    if (!name) return "";
    for (var i = 0; i < name.length; i++) {
      var w = name[i];
      var isCn = escape(w).indexOf("%u") === 0;
      if (i < leftCount * 2 && leftLength < leftCount) {
        isCn ? leftLength += 1 : leftLength += 2;
      } else if (i > i - rightCount && rightLength < rightCount) {
        isCn ? rightLength += 1 : rightLength += 2;
      }
    }
    return name.replace(new RegExp("^(.{".concat(leftLength, "})(.+)(.{").concat(rightLength, "})$")), "$1\u2026$3");
  }
  function getFileSizeText(number) {
    if (number < 1024) {
      return "".concat(number, " Bytes");
    }
    if (number >= 1024 && number < 1048576) {
      return "".concat((number / 1024).toFixed(1), " KB");
    }
    if (number >= 1048576) {
      return "".concat((number / 1048576).toFixed(1), " MB");
    }
    return "";
  }
  function isOverSizeLimit(fileSize, sizeLimit, unit) {
    var units = ["B", "KB", "MB", "GB"];
    var KBIndex = 1;
    var index = units.indexOf(unit);
    if (index === -1) {
      log.warn("Upload", "`sizeLimit.unit` can only be one of ".concat(units.join()));
      index = KBIndex;
    }
    var num = SIZE_MAP[unit];
    return fileSize > sizeLimit * num;
  }
  function getFileUrlByFileRaw(fileRaw) {
    return new Promise(function (resolve) {
      if (!fileRaw) {
        resolve("");
        return;
      }
      var reader = new FileReader();
      reader.readAsDataURL(fileRaw);
      reader.onload = function (event) {
        var _event$target;
        resolve((_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.result);
      };
    });
  }
  function validateFileType(accept, fileType, fileName) {
    var tmpFileType = fileType || fileName;
    if (!accept) return true;
    if (!tmpFileType) return false;
    var acceptList = accept.split(",").map(function (v) {
      return v.trim();
    });
    for (var i = 0, len = acceptList.length; i < len; i++) {
      var oneRule = acceptList[i];
      if (INPUT_FILE_MAP[oneRule] && INPUT_FILE_MAP[oneRule].test(tmpFileType)) {
        return true;
      }
      var regExp = new RegExp(oneRule, "i");
      if (regExp.test(tmpFileType)) {
        return true;
      }
    }
    return false;
  }
  function getFileList(files) {
    var accept = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var fileList = [];
    for (var i = 0; i < files.length; i++) {
      if (validateFileType(accept, files[i].type, files[i].name)) {
        fileList.push(files[i]);
      }
    }
    return fileList;
  }

  function useImagePreviewUrl(imgUrl) {
    var previewUrl = VueCompositionAPI.ref("");
    VueCompositionAPI.watch([imgUrl], function (_ref, _ref2) {
      var _ref3 = _slicedToArray(_ref, 1),
        imgUrl2 = _ref3[0];
      var _ref4 = _slicedToArray(_ref2, 1),
        preImgUrl = _ref4[0];
      if (preImgUrl === imgUrl2) return;
      if (typeof imgUrl2 === "string") {
        previewUrl.value = imgUrl2;
        return;
      }
      getFileUrlByFileRaw(imgUrl2).then(function (url) {
        previewUrl.value = url;
      });
    }, {
      immediate: true
    });
    return {
      previewUrl: previewUrl
    };
  }

  function ownKeys$2m(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2l(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2m(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2m(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _CheckTag = VueCompositionAPI.defineComponent({
    name: "TCheckTag",
    props: props$Y,
    model: {
      prop: "checked",
      event: "change"
    },
    setup: function setup(props2, context) {
      var componentName = usePrefixClass("tag");
      var _useCommonClassName = useCommonClassName$1(),
        SIZE = _useCommonClassName.SIZE;
      var _toRefs = VueCompositionAPI.toRefs(props2),
        checked = _toRefs.checked;
      var _useVModel = useVModel$1(checked, props2.defaultChecked, props2.onChange, "change", "checked"),
        _useVModel2 = _slicedToArray(_useVModel, 2),
        innerChecked = _useVModel2[0],
        setInnerChecked = _useVModel2[1];
      var tagClass = VueCompositionAPI.computed(function () {
        return ["".concat(componentName.value), "".concat(componentName.value, "--check"), SIZE.value[props2.size], _defineProperty$2(_defineProperty$2({}, "".concat(componentName.value, "--checked"), innerChecked.value), "".concat(componentName.value, "--disabled"), props2.disabled)];
      });
      var checkTagProps = VueCompositionAPI.computed(function () {
        var checkedProps = _objectSpread$2l({
          theme: "primary"
        }, props2.checkedProps);
        var uncheckedProps = _objectSpread$2l({}, props2.uncheckedProps);
        return innerChecked.value ? checkedProps : uncheckedProps;
      });
      var handleClick = function handleClick(_ref2) {
        var e = _ref2.e;
        if (!props2.disabled) {
          var _props2$onClick;
          (_props2$onClick = props2.onClick) === null || _props2$onClick === void 0 || _props2$onClick.call(props2, {
            e: e
          });
          context.emit("click", {
            e: e
          });
          setInnerChecked(!innerChecked.value, {
            e: e,
            value: props2.value
          });
        }
      };
      var keyboardEventListener = function keyboardEventListener(e) {
        var _e$key;
        var code = e.code || ((_e$key = e.key) === null || _e$key === void 0 ? void 0 : _e$key.trim());
        var isCheckedCode = SPACE_REG.test(code) || ENTER_REG.test(code);
        if (isCheckedCode) {
          e.preventDefault();
          setInnerChecked(!innerChecked.value, {
            e: e,
            value: props2.value
          });
        }
      };
      var onCheckboxFocus = function onCheckboxFocus(e) {
        e.currentTarget.addEventListener("keydown", keyboardEventListener);
      };
      var onCheckboxBlur = function onCheckboxBlur(e) {
        e.currentTarget.removeEventListener("keydown", keyboardEventListener);
      };
      return {
        tagClass: tagClass,
        checkTagProps: checkTagProps,
        onCheckboxFocus: onCheckboxFocus,
        onCheckboxBlur: onCheckboxBlur,
        handleClick: handleClick
      };
    },
    render: function render() {
      var h = arguments[0];
      var tagContent = renderContent(this, "default", "content");
      return h(_Tag, helper([{
        "class": this.tagClass,
        "attrs": {
          "disabled": this.disabled,
          "tabindex": this.disabled ? void 0 : "0"
        },
        "on": {
          "focus": this.onCheckboxFocus,
          "blur": this.onCheckboxBlur
        }
      }, {
        "props": this.checkTagProps
      }, {
        "on": {
          "click": this.handleClick
        }
      }]), [tagContent]);
    }
  });

  var props$X = {
    checkedProps: {
      type: Object
    },
    multiple: Boolean,
    options: {
      type: Array
    },
    uncheckedProps: {
      type: Object
    },
    value: {
      type: Array,
      "default": void 0
    },
    defaultValue: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    onChange: Function
  };

  var _CheckTagGroup = VueCompositionAPI.defineComponent({
    name: "TCheckTagGroup",
    props: props$X,
    setup: function setup(props2, context) {
      var _toRefs = VueCompositionAPI.toRefs(props2),
        value = _toRefs.value;
      var componentName = usePrefixClass("check-tag-group");
      var checkTagGroupClasses = VueCompositionAPI.computed(function () {
        return [componentName.value];
      });
      var _useVModel = useVModel$1(value, props2.defaultValue, props2.onChange),
        _useVModel2 = _slicedToArray(_useVModel, 2),
        innerValue = _useVModel2[0],
        setInnerValue = _useVModel2[1];
      var onCheckTagChange = function onCheckTagChange(checked, ctx) {
        var value2 = ctx.value;
        if (checked) {
          if (props2.multiple) {
            setInnerValue(innerValue.value.concat(value2), {
              e: ctx.e,
              type: "check",
              value: value2
            });
          } else {
            setInnerValue([value2], {
              e: ctx.e,
              type: "check",
              value: value2
            });
          }
        } else {
          var newValue = [];
          if (props2.multiple) {
            newValue = innerValue.value.filter(function (t) {
              return t !== value2;
            });
          }
          setInnerValue(newValue, {
            e: ctx.e,
            type: "uncheck",
            value: value2
          });
        }
      };
      var getTagContent = function getTagContent(option) {
        if (context.slots.option) return context.slots.option(option);
        if (context.slots.label) return context.slots.label(option);
        if (option.label) {
          return isFunction(option.label) ? option.label(VueCompositionAPI.h) : option.label;
        }
        if (option.content && isFunction(option.content)) return option.content(VueCompositionAPI.h);
        if (option["default"] && isFunction(option["default"])) return option["default"](VueCompositionAPI.h);
        return option.value;
      };
      return {
        innerValue: innerValue,
        checkTagGroupClasses: checkTagGroupClasses,
        onCheckTagChange: onCheckTagChange,
        getTagContent: getTagContent
      };
    },
    render: function render() {
      var _this = this;
      var h = arguments[0];
      return h("div", {
        "class": this.checkTagGroupClasses
      }, [(this.options || []).map(function (option) {
        return h(_CheckTag, {
          "key": option.value,
          "attrs": {
            "value": option.value,
            "checkedProps": _this.checkedProps,
            "uncheckedProps": _this.uncheckedProps,
            "checked": _this.innerValue.includes(option.value),
            "disabled": option.disabled,
            "size": option.size,
            "data-value": option.value
          },
          "on": {
            "change": _this.onCheckTagChange
          }
        }, [_this.getTagContent(option)]);
      })]);
    }
  });

  var Tag = withInstall$1(_Tag);
  var CheckTag = withInstall$1(_CheckTag);
  var CheckTagGroup = withInstall$1(_CheckTagGroup);

  var props$W = {
    allowInput: Boolean,
    autoWidth: Boolean,
    autofocus: Boolean,
    borderless: Boolean,
    clearable: Boolean,
    collapsedItems: {
      type: Function
    },
    disabled: Boolean,
    inputProps: {
      type: Object
    },
    inputValue: {
      type: [String, Number],
      "default": void 0
    },
    defaultInputValue: {
      type: [String, Number]
    },
    keys: {
      type: Object
    },
    label: {
      type: [String, Function]
    },
    loading: Boolean,
    minCollapsedNum: {
      type: Number,
      "default": 0
    },
    multiple: Boolean,
    panel: {
      type: [String, Function]
    },
    placeholder: {
      type: String,
      "default": ""
    },
    popupProps: {
      type: Object
    },
    popupVisible: {
      type: Boolean,
      "default": void 0
    },
    defaultPopupVisible: Boolean,
    readonly: Boolean,
    reserveKeyword: Boolean,
    status: {
      type: String,
      "default": "default",
      validator: function validator(val) {
        if (!val) return true;
        return ["default", "success", "warning", "error"].includes(val);
      }
    },
    suffix: {
      type: [String, Function]
    },
    suffixIcon: {
      type: Function
    },
    tag: {
      type: [String, Function]
    },
    tagInputProps: {
      type: Object
    },
    tagProps: {
      type: Object
    },
    tips: {
      type: [String, Function]
    },
    value: {
      type: [String, Number, Boolean, Object, Array, Date],
      "default": void 0
    },
    valueDisplay: {
      type: [String, Function]
    },
    onBlur: Function,
    onClear: Function,
    onEnter: Function,
    onFocus: Function,
    onInputChange: Function,
    onMouseenter: Function,
    onMouseleave: Function,
    onPaste: Function,
    onPopupVisibleChange: Function,
    onTagChange: Function
  };

  var _excluded$5 = ["tips"];
  function ownKeys$2l(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2k(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2l(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2l(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var COMMON_PROPERTIES = ["status", "clearable", "disabled", "label", "placeholder", "readonly", "suffix", "suffixIcon", "autofocus"];
  var DEFAULT_KEYS$2 = {
    label: "label",
    value: "value"
  };
  function getInputValue(value, keys) {
    var iKeys = keys || DEFAULT_KEYS$2;
    return isObject(value) ? get(value, iKeys.label) : value;
  }
  function useSingle$1(props, context) {
    var _props$defaultInputVa;
    var instance = VueCompositionAPI.getCurrentInstance();
    var _toRefs = VueCompositionAPI.toRefs(props),
      value = _toRefs.value,
      keys = _toRefs.keys,
      propsInputValue = _toRefs.inputValue;
    var classPrefix = usePrefixClass();
    var _useDefaultValue = useDefaultValue(propsInputValue, (_props$defaultInputVa = props.defaultInputValue) !== null && _props$defaultInputVa !== void 0 ? _props$defaultInputVa : "", props.onInputChange, "inputValue", "input-change"),
      _useDefaultValue2 = _slicedToArray(_useDefaultValue, 2),
      inputValue = _useDefaultValue2[0],
      setInputValue = _useDefaultValue2[1];
    var isSingleFocus = VueCompositionAPI.ref(props.autofocus);
    var inputRef = VueCompositionAPI.ref();
    var renderTNode = useTNodeJSX();
    var commonInputProps = VueCompositionAPI.computed(function () {
      return pick$1(props, COMMON_PROPERTIES);
    });
    var onInnerClear = function onInnerClear(context2) {
      var _context2$e, _props$onClear;
      context2 === null || context2 === void 0 || (_context2$e = context2.e) === null || _context2$e === void 0 || _context2$e.stopPropagation();
      (_props$onClear = props.onClear) === null || _props$onClear === void 0 || _props$onClear.call(props, context2);
      instance.emit("clear", context2);
      setInputValue("", {
        trigger: "clear"
      });
    };
    var onInnerInputChange = function onInnerInputChange(value2, context2) {
      if (props.allowInput) {
        setInputValue(value2, _objectSpread$2k(_objectSpread$2k({}, context2), {}, {
          trigger: "input"
        }));
      }
    };
    var onEnter = function onEnter(val, context2) {
      var _props$onEnter;
      (_props$onEnter = props.onEnter) === null || _props$onEnter === void 0 || _props$onEnter.call(props, value.value, _objectSpread$2k(_objectSpread$2k({}, context2), {}, {
        inputValue: val
      }));
      instance.emit("enter", value.value, _objectSpread$2k(_objectSpread$2k({}, context2), {}, {
        inputValue: val
      }));
    };
    var onFocus = function onFocus(val, context2) {
      var _props$onFocus;
      isSingleFocus.value = true;
      (_props$onFocus = props.onFocus) === null || _props$onFocus === void 0 || _props$onFocus.call(props, value.value, _objectSpread$2k(_objectSpread$2k({}, context2), {}, {
        inputValue: val
      }));
      instance.emit("focus", value.value, _objectSpread$2k(_objectSpread$2k({}, context2), {}, {
        tagInputValue: val
      }));
    };
    var onPaste = function onPaste(context2) {
      var _props$onPaste;
      (_props$onPaste = props.onPaste) === null || _props$onPaste === void 0 || _props$onPaste.call(props, context2);
      instance.emit("paste", context2);
    };
    var onMouseenter = function onMouseenter(context2) {
      var _props$onMouseenter;
      (_props$onMouseenter = props.onMouseenter) === null || _props$onMouseenter === void 0 || _props$onMouseenter.call(props, context2);
      instance.emit("mouseenter", context2);
    };
    var onMouseleave = function onMouseleave(context2) {
      var _props$onMouseleave;
      (_props$onMouseleave = props.onMouseleave) === null || _props$onMouseleave === void 0 || _props$onMouseleave.call(props, context2);
      instance.emit("mouseenter", context2);
    };
    var renderSelectSingle = function renderSelectSingle(h, popupVisible) {
      var singleValueDisplay = renderTNode("valueDisplay");
      var pureValue = getInputValue(value.value, keys.value);
      var displayedValue = popupVisible && props.allowInput ? inputValue.value : pureValue;
      var prefixContent = [renderTNode("label"), singleValueDisplay];
      var inputProps = _objectSpread$2k(_objectSpread$2k({}, commonInputProps.value), {}, {
        value: singleValueDisplay && props.value ? void 0 : displayedValue,
        label: function label() {
          return prefixContent;
        },
        autoWidth: props.autoWidth,
        autofocus: props.autofocus,
        readonly: !props.allowInput || props.readonly,
        placeholder: singleValueDisplay ? "" : props.placeholder,
        suffixIcon: !props.disabled && props.loading ? function () {
          return h(Loading, {
            "attrs": {
              "loading": true,
              "size": "small"
            }
          });
        } : props.suffixIcon,
        showClearIconOnEmpty: Boolean(!props.disabled && props.clearable && (inputValue.value || displayedValue)),
        inputClass: _defineProperty$2(_defineProperty$2({}, "".concat(classPrefix.value, "-input--focused"), popupVisible), "".concat(classPrefix.value, "-is-focused"), popupVisible)
      }, props.inputProps);
      var _context$slots = context.slots;
        _context$slots.tips;
        var slots = _objectWithoutProperties$2(_context$slots, _excluded$5);
      return h(Input, helper([{
        "ref": "inputRef"
      }, {
        "props": inputProps
      }, {
        "scopedSlots": slots,
        "on": {
          "change": onInnerInputChange,
          "clear": onInnerClear,
          "enter": onEnter,
          "focus": onFocus,
          "paste": onPaste,
          "mouseenter": onMouseenter,
          "mouseleave": onMouseleave
        }
      }]));
    };
    return {
      inputRef: inputRef,
      commonInputProps: commonInputProps,
      singleInputValue: inputValue,
      isSingleFocus: isSingleFocus,
      onInnerClear: onInnerClear,
      renderSelectSingle: renderSelectSingle
    };
  }

  var props$V = {
    autoWidth: Boolean,
    borderless: Boolean,
    clearable: Boolean,
    collapsedItems: {
      type: Function
    },
    disabled: {
      type: Boolean,
      "default": void 0
    },
    dragSort: Boolean,
    excessTagsDisplayType: {
      type: String,
      "default": "break-line",
      validator: function validator(val) {
        if (!val) return true;
        return ["scroll", "break-line"].includes(val);
      }
    },
    inputProps: {
      type: Object
    },
    inputValue: {
      type: [String, Number],
      "default": void 0
    },
    defaultInputValue: {
      type: [String, Number],
      "default": ""
    },
    label: {
      type: [String, Function]
    },
    max: {
      type: Number
    },
    minCollapsedNum: {
      type: Number,
      "default": 0
    },
    placeholder: {
      type: String,
      "default": void 0
    },
    prefixIcon: {
      type: Function
    },
    readonly: Boolean,
    size: {
      type: String,
      "default": "medium",
      validator: function validator(val) {
        if (!val) return true;
        return ["small", "medium", "large"].includes(val);
      }
    },
    status: {
      type: String,
      validator: function validator(val) {
        if (!val) return true;
        return ["default", "success", "warning", "error"].includes(val);
      }
    },
    suffix: {
      type: [String, Function]
    },
    suffixIcon: {
      type: Function
    },
    tag: {
      type: [String, Function]
    },
    tagProps: {
      type: Object
    },
    tips: {
      type: [String, Function]
    },
    value: {
      type: Array,
      "default": void 0
    },
    defaultValue: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    valueDisplay: {
      type: [String, Function]
    },
    onBlur: Function,
    onChange: Function,
    onClear: Function,
    onClick: Function,
    onDragSort: Function,
    onEnter: Function,
    onFocus: Function,
    onInputChange: Function,
    onMouseenter: Function,
    onMouseleave: Function,
    onPaste: Function,
    onRemove: Function
  };

  function useTagScroll(props) {
    var tagInputRef = VueCompositionAPI.ref();
    var _toRefs = VueCompositionAPI.toRefs(props),
      excessTagsDisplayType = _toRefs.excessTagsDisplayType,
      readonly = _toRefs.readonly,
      disabled = _toRefs.disabled;
    var scrollDistance = VueCompositionAPI.ref(0);
    var scrollElement = VueCompositionAPI.ref();
    var mouseEnterTimer = VueCompositionAPI.ref();
    var isScrollable = VueCompositionAPI.ref(false);
    var updateScrollElement = function updateScrollElement(element) {
      var inputElement = element.children[0];
      scrollElement.value = inputElement;
    };
    var updateScrollDistance = function updateScrollDistance() {
      scrollDistance.value = scrollElement.value.scrollWidth - scrollElement.value.clientWidth;
    };
    var scrollTo = function scrollTo(distance) {
      var _scrollElement$value;
      if (!isFunction((_scrollElement$value = scrollElement.value) === null || _scrollElement$value === void 0 ? void 0 : _scrollElement$value.scroll)) return;
      scrollElement.value.scroll({
        left: distance,
        behavior: "smooth"
      });
    };
    var scrollToRight = function scrollToRight() {
      updateScrollDistance();
      scrollTo(scrollDistance.value);
      setTimeout(function () {
        isScrollable.value = true;
      }, 200);
    };
    var scrollToLeft = function scrollToLeft() {
      scrollTo(0);
    };
    var onWheel = function onWheel(_ref) {
      var e = _ref.e;
      if (readonly.value || disabled.value) return;
      if (!scrollElement.value) return;
      if (e.deltaX > 0) {
        var distance = Math.min(scrollElement.value.scrollLeft + 120, scrollDistance.value);
        scrollTo(distance);
      } else {
        var _distance = Math.max(scrollElement.value.scrollLeft - 120, 0);
        scrollTo(_distance);
      }
    };
    var scrollToRightOnEnter = function scrollToRightOnEnter() {
      if (excessTagsDisplayType.value !== "scroll") return;
      mouseEnterTimer.value = setTimeout(function () {
        scrollToRight();
        clearTimeout(mouseEnterTimer.value);
      }, 100);
    };
    var scrollToLeftOnLeave = function scrollToLeftOnLeave() {
      if (excessTagsDisplayType.value !== "scroll") return;
      isScrollable.value = false;
      scrollTo(0);
      clearTimeout(mouseEnterTimer.value);
    };
    var init = function init() {
      var _tagInputRef$value;
      var element = (_tagInputRef$value = tagInputRef.value) === null || _tagInputRef$value === void 0 ? void 0 : _tagInputRef$value.$el;
      if (!element) return;
      updateScrollElement(element);
    };
    var clear = function clear() {
      clearTimeout(mouseEnterTimer.value);
    };
    VueCompositionAPI.onMounted(init);
    VueCompositionAPI.onUnmounted(clear);
    return {
      tagInputRef: tagInputRef,
      scrollElement: scrollElement,
      scrollDistance: scrollDistance,
      scrollTo: scrollTo,
      scrollToRight: scrollToRight,
      scrollToLeft: scrollToLeft,
      updateScrollElement: updateScrollElement,
      updateScrollDistance: updateScrollDistance,
      onWheel: onWheel,
      scrollToRightOnEnter: scrollToRightOnEnter,
      scrollToLeftOnLeave: scrollToLeftOnLeave,
      isScrollable: isScrollable
    };
  }

  function ownKeys$2k(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2j(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2k(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2k(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function useTagList(props, context, getDragProps) {
    var renderTNode = useTNodeJSX();
    var _useConfig = useConfig("classPrefix"),
      classPrefix = _useConfig.classPrefix;
    var _toRefs = VueCompositionAPI.toRefs(props),
      value = _toRefs.value,
      onRemove = _toRefs.onRemove,
      max = _toRefs.max,
      minCollapsedNum = _toRefs.minCollapsedNum,
      size = _toRefs.size,
      disabled = _toRefs.disabled,
      readonly = _toRefs.readonly,
      tagProps = _toRefs.tagProps;
    var _useVModel = useVModel$1(value, props.defaultValue || [], props.onChange, "change"),
      _useVModel2 = _slicedToArray(_useVModel, 2),
      tagValue = _useVModel2[0],
      setTagValue = _useVModel2[1];
    var oldInputValue = VueCompositionAPI.ref();
    var onClose = function onClose(p) {
      var _onRemove$value;
      var arr = _toConsumableArray(tagValue.value);
      var _arr$splice = arr.splice(p.index, 1),
        _arr$splice2 = _slicedToArray(_arr$splice, 1),
        item = _arr$splice2[0];
      setTagValue(arr, _objectSpread$2j({
        trigger: "tag-remove"
      }, p));
      var removeParams = _objectSpread$2j(_objectSpread$2j({}, p), {}, {
        item: item,
        trigger: "tag-remove",
        value: arr
      });
      (_onRemove$value = onRemove.value) === null || _onRemove$value === void 0 || _onRemove$value.call(onRemove, removeParams);
      context.emit("remove", removeParams);
    };
    var clearAll = function clearAll(context2) {
      setTagValue([], {
        trigger: "clear",
        e: context2.e
      });
    };
    var onInnerEnter = function onInnerEnter(value2, params) {
      var _tagValue$value, _props$onEnter;
      var valueStr = String(value2).trim();
      var newValue = tagValue.value;
      var isLimitExceeded = max && ((_tagValue$value = tagValue.value) === null || _tagValue$value === void 0 ? void 0 : _tagValue$value.length) >= max.value;
      if (!isLimitExceeded && valueStr) {
        newValue = tagValue.value instanceof Array ? tagValue.value.concat(String(valueStr)) : [valueStr];
        setTagValue(newValue, {
          trigger: "enter",
          index: newValue.length - 1,
          item: valueStr,
          e: params.e
        });
      }
      var enterEventParams = _objectSpread$2j(_objectSpread$2j({}, params), {}, {
        inputValue: value2
      });
      (_props$onEnter = props.onEnter) === null || _props$onEnter === void 0 || _props$onEnter.call(props, newValue, enterEventParams);
      context.emit("enter", newValue, enterEventParams);
    };
    var onInputBackspaceKeyUp = function onInputBackspaceKeyUp(value2) {
      if (!tagValue.value || !tagValue.value.length) return;
      oldInputValue.value = value2;
    };
    var onInputBackspaceKeyDown = function onInputBackspaceKeyDown(value2, p) {
      var e = p.e;
      if (!tagValue.value || !tagValue.value.length || readonly.value) return;
      var isDelete = /(Backspace|NumpadDelete)/.test(e.code) || /(Backspace|NumpadDelete)/.test(e.key);
      if (!value2 && isDelete) {
        var _onRemove$value2;
        var index = tagValue.value.length - 1;
        var item = tagValue.value[index];
        var trigger = "backspace";
        var newValue = tagValue.value.slice(0, -1);
        var params = {
          e: e,
          index: index,
          item: item,
          trigger: trigger
        };
        setTagValue(newValue, params);
        var removeParams = _objectSpread$2j(_objectSpread$2j({}, params), {}, {
          value: newValue
        });
        (_onRemove$value2 = onRemove.value) === null || _onRemove$value2 === void 0 || _onRemove$value2.call(onRemove, removeParams);
        context.emit("remove", removeParams);
      }
      oldInputValue.value = value2;
    };
    var renderLabel = function renderLabel(_ref, h) {
      var _newList$map;
      var displayNode = _ref.displayNode,
        label = _ref.label;
      var newList = minCollapsedNum.value ? tagValue.value.slice(0, minCollapsedNum.value) : tagValue.value;
      var list = displayNode ? [displayNode] : (newList === null || newList === void 0 || (_newList$map = newList.map) === null || _newList$map === void 0 ? void 0 : _newList$map.call(newList, function (item, index) {
        var tagContent = renderTNode("tag", {
          params: {
            value: item
          }
        });
        var TagNode = h(Tag, helper([{
          "key": index,
          "attrs": {
            "size": size.value,
            "disabled": disabled.value,
            "closable": !readonly.value && !disabled.value
          },
          "on": {
            "close": function close(context2) {
              return onClose({
                e: context2.e,
                index: index
              });
            }
          }
        }, {
          "props": tagProps.value
        }]), [tagContent !== null && tagContent !== void 0 ? tagContent : item]);
        var itemDrag = getDragProps === null || getDragProps === void 0 ? void 0 : getDragProps(index, item);
        return itemDrag && itemDrag.draggable ? h("span", {
          "class": "".concat(classPrefix.value, "-tag-input__drag_wrapper"),
          "attrs": {
            "draggable": true
          },
          "on": {
            "dragstart": itemDrag.onDragstart,
            "dragover": itemDrag.onDragover,
            "dragend": itemDrag.onDragend,
            "drop": itemDrag.onDrop
          }
        }, [TagNode]) : TagNode;
      })) || [];
      if (![null, void 0, ""].includes(label)) {
        list.unshift(h("div", {
          "class": "".concat(classPrefix.value, "-tag-input__prefix"),
          "key": "label"
        }, [label]));
      }
      if (newList.length !== tagValue.value.length) {
        var len = tagValue.value.length - newList.length;
        var more = renderTNode("collapsedItems", {
          params: {
            value: tagValue.value,
            count: tagValue.value.length - minCollapsedNum.value,
            collapsedTags: tagValue.value.slice(minCollapsedNum.value, tagValue.value.length),
            collapsedSelectedItems: tagValue.value.slice(minCollapsedNum.value, tagValue.value.length),
            onClose: onClose
          }
        });
        list.push(more !== null && more !== void 0 ? more : h(Tag, helper([{
          "key": "more",
          "attrs": {
            "size": size.value
          }
        }, {
          "props": tagProps.value
        }]), ["+", len]));
      }
      return list;
    };
    return {
      tagValue: tagValue,
      clearAll: clearAll,
      onClose: onClose,
      onInnerEnter: onInnerEnter,
      onInputBackspaceKeyUp: onInputBackspaceKeyUp,
      onInputBackspaceKeyDown: onInputBackspaceKeyDown,
      renderLabel: renderLabel
    };
  }

  function useHover(props, _ref) {
    var emit = _ref.emit;
    var disabled = props.disabled,
      readonly = props.readonly,
      onMouseenter = props.onMouseenter,
      onMouseleave = props.onMouseleave;
    var isHover = VueCompositionAPI.ref(false);
    var addHover = function addHover(context) {
      if (readonly.value || disabled.value) return;
      isHover.value = true;
      onMouseenter === null || onMouseenter === void 0 || onMouseenter(context);
      emit("mouseenter", context);
    };
    var cancelHover = function cancelHover(context) {
      if (readonly.value || disabled.value) return;
      isHover.value = false;
      onMouseleave === null || onMouseleave === void 0 || onMouseleave(context);
      emit("mouseleave", context);
    };
    return {
      isHover: isHover,
      addHover: addHover,
      cancelHover: cancelHover
    };
  }

  function useDragSorter(props, context) {
    var sortOnDraggable = props.sortOnDraggable,
      onDragSort = props.onDragSort,
      onDragOverCheck = props.onDragOverCheck;
    var draggingIndex = VueCompositionAPI.ref(-1);
    var dragStartData = VueCompositionAPI.ref(null);
    var isDropped = VueCompositionAPI.ref(null);
    var startInfo = VueCompositionAPI.reactive({
      nodeX: 0,
      nodeWidth: 0,
      mouseX: 0
    });
    var onDragOver = function onDragOver(e, index, record) {
      e.preventDefault();
      if (draggingIndex.value === index || draggingIndex.value === -1) return;
      var target = e.target;
      if (onDragOverCheck !== null && onDragOverCheck !== void 0 && onDragOverCheck.targetClassNameRegExp && !(onDragOverCheck !== null && onDragOverCheck !== void 0 && onDragOverCheck.targetClassNameRegExp.test(target.className))) {
        return;
      }
      if (onDragOverCheck !== null && onDragOverCheck !== void 0 && onDragOverCheck.x && target) {
        if (!startInfo.nodeWidth) return;
        var _target$getBoundingCl = target.getBoundingClientRect(),
          x = _target$getBoundingCl.x,
          width = _target$getBoundingCl.width;
        var targetNodeMiddleX = x + width / 2;
        var draggingNodeLeft = e.clientX - (startInfo.mouseX - startInfo.nodeX);
        var draggingNodeRight = draggingNodeLeft + startInfo.nodeWidth;
        var overlap = false;
        if (draggingNodeLeft > x && draggingNodeLeft < x + width) {
          overlap = draggingNodeLeft < targetNodeMiddleX;
        } else {
          overlap = draggingNodeRight > targetNodeMiddleX;
        }
        if (!overlap) return;
      }
      var data = {
        currentIndex: draggingIndex.value,
        current: dragStartData,
        target: record,
        targetIndex: index
      };
      onDragSort === null || onDragSort === void 0 || onDragSort(data);
      context.emit("drag-sort", data);
      draggingIndex.value = index;
    };
    if (!sortOnDraggable) {
      return {};
    }
    function onDragStart(e, index, record) {
      draggingIndex.value = index;
      dragStartData.value = record;
      var target = e.target;
      if (onDragOverCheck && target) {
        var _target$getBoundingCl2 = target.getBoundingClientRect(),
          x = _target$getBoundingCl2.x,
          width = _target$getBoundingCl2.width;
        startInfo.nodeX = x;
        startInfo.nodeWidth = width;
        startInfo.mouseX = e.clientX;
      }
    }
    function _onDrop() {
      isDropped.value = true;
    }
    function onDragEnd() {
      if (!isDropped.value) ;
      isDropped.value = false;
      draggingIndex.value = -1;
      dragStartData.value = null;
    }
    function getDragProps(index, record) {
      if (sortOnDraggable) {
        return {
          draggable: true,
          onDragstart: function onDragstart(e) {
            onDragStart(e, index, record);
          },
          onDragover: function onDragover(e) {
            onDragOver(e, index, record);
          },
          onDrop: function onDrop() {
            _onDrop();
          },
          onDragend: function onDragend() {
            onDragEnd();
          }
        };
      }
    }
    return {
      onDragStart: onDragStart,
      onDragOver: onDragOver,
      onDrop: _onDrop,
      onDragEnd: onDragEnd,
      getDragProps: getDragProps,
      dragging: draggingIndex.value !== -1
    };
  }

  function ownKeys$2j(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2i(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2j(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2j(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _TagInput = VueCompositionAPI.defineComponent({
    name: "TTagInput",
    props: _objectSpread$2i({}, props$V),
    setup: function setup(props2, context) {
      var _toRefs = VueCompositionAPI.toRefs(props2),
        inputValue = _toRefs.inputValue,
        inputProps = _toRefs.inputProps;
      var isComposition = VueCompositionAPI.ref(false);
      var COMPONENT_NAME = usePrefixClass$1("tag-input");
      var classPrefix = usePrefixClass$1();
      var _useDefaultValue = useDefaultValue(inputValue, props2.defaultInputValue, props2.onInputChange, "inputValue", "input-change"),
        _useDefaultValue2 = _slicedToArray(_useDefaultValue, 2),
        tInputValue = _useDefaultValue2[0],
        setTInputValue = _useDefaultValue2[1];
      var _toRefs2 = VueCompositionAPI.toRefs(props2),
        excessTagsDisplayType = _toRefs2.excessTagsDisplayType,
        readonly = _toRefs2.readonly,
        disabled = _toRefs2.disabled,
        clearable = _toRefs2.clearable,
        placeholder = _toRefs2.placeholder;
      var _useHover = useHover({
          readonly: readonly,
          disabled: disabled,
          onMouseenter: props2.onMouseenter,
          onMouseleave: props2.onMouseleave
        }, context),
        isHover = _useHover.isHover,
        addHover = _useHover.addHover,
        cancelHover = _useHover.cancelHover;
      var _useDragSorter = useDragSorter(_objectSpread$2i(_objectSpread$2i({}, props2), {}, {
          sortOnDraggable: props2.dragSort,
          onDragOverCheck: {
            x: true,
            targetClassNameRegExp: new RegExp("^".concat(classPrefix.value, "-tag"))
          }
        }), context),
        getDragProps = _useDragSorter.getDragProps;
      var _useTagScroll = useTagScroll(props2),
        scrollToRight = _useTagScroll.scrollToRight,
        onWheel = _useTagScroll.onWheel,
        scrollToRightOnEnter = _useTagScroll.scrollToRightOnEnter,
        scrollToLeftOnLeave = _useTagScroll.scrollToLeftOnLeave,
        tagInputRef = _useTagScroll.tagInputRef,
        isScrollable = _useTagScroll.isScrollable;
      var _useTagList = useTagList(props2, context, getDragProps),
        tagValue = _useTagList.tagValue,
        onInnerEnter = _useTagList.onInnerEnter,
        onInputBackspaceKeyUp = _useTagList.onInputBackspaceKeyUp,
        onInputBackspaceKeyDown = _useTagList.onInputBackspaceKeyDown,
        clearAll = _useTagList.clearAll,
        renderLabel = _useTagList.renderLabel,
        onClose = _useTagList.onClose;
      var _useGlobalIcon = useGlobalIcon({
          CloseCircleFilledIcon: TdCloseCircleFilledIcon
        }),
        CloseCircleFilledIcon = _useGlobalIcon.CloseCircleFilledIcon;
      var classes = VueCompositionAPI.computed(function () {
        var isEmpty = !(Array.isArray(tagValue.value) && tagValue.value.length);
        return [COMPONENT_NAME.value, _defineProperty$2(_defineProperty$2(_defineProperty$2({}, "".concat(COMPONENT_NAME.value, "--break-line"), excessTagsDisplayType.value === "break-line"), "".concat(classPrefix.value, "-is-empty"), isEmpty), "".concat(classPrefix.value, "-tag-input--with-tag"), !isEmpty)];
      });
      var tagInputPlaceholder = VueCompositionAPI.computed(function () {
        var _tagValue$value;
        return !((_tagValue$value = tagValue.value) !== null && _tagValue$value !== void 0 && _tagValue$value.length) ? placeholder.value : "";
      });
      var showClearIcon = VueCompositionAPI.computed(function () {
        var _tagValue$value2;
        return Boolean(!readonly.value && !disabled.value && clearable.value && isHover.value && (((_tagValue$value2 = tagValue.value) === null || _tagValue$value2 === void 0 ? void 0 : _tagValue$value2.length) || tInputValue.value));
      });
      var onInputCompositionstart = function onInputCompositionstart(value, context2) {
        var _inputProps$value, _inputProps$value$onC;
        isComposition.value = true;
        (_inputProps$value = inputProps.value) === null || _inputProps$value === void 0 || (_inputProps$value$onC = _inputProps$value.onCompositionstart) === null || _inputProps$value$onC === void 0 || _inputProps$value$onC.call(_inputProps$value, value, context2);
      };
      var onInputCompositionend = function onInputCompositionend(value, context2) {
        var _inputProps$value2, _inputProps$value2$on;
        isComposition.value = false;
        (_inputProps$value2 = inputProps.value) === null || _inputProps$value2 === void 0 || (_inputProps$value2$on = _inputProps$value2.onCompositionend) === null || _inputProps$value2$on === void 0 || _inputProps$value2$on.call(_inputProps$value2, value, context2);
      };
      var onInputEnter = function onInputEnter(value, context2) {
        var _context2$e;
        (_context2$e = context2.e) === null || _context2$e === void 0 || _context2$e.preventDefault();
        setTInputValue("", {
          e: context2.e,
          trigger: "enter"
        });
        !isComposition.value && onInnerEnter(value, context2);
        VueCompositionAPI.nextTick(function () {
          scrollToRight();
          isComposition.value = false;
        });
      };
      var onInnerClick = function onInnerClick(params) {
        var _props2$onClick;
        (_props2$onClick = props2.onClick) === null || _props2$onClick === void 0 || _props2$onClick.call(props2, params);
        context.emit("click", params);
      };
      var onClearClick = function onClearClick(ctx) {
        var _props2$onClear;
        clearAll(ctx);
        setTInputValue("", {
          e: ctx.e,
          trigger: "clear"
        });
        (_props2$onClear = props2.onClear) === null || _props2$onClear === void 0 || _props2$onClear.call(props2, ctx);
        context.emit("clear", ctx);
      };
      VueCompositionAPI.watch(function () {
        return isScrollable.value;
      }, function (v) {
        if (props2.excessTagsDisplayType !== "scroll") return;
        var scrollElementClass = "".concat(classPrefix.value, "-input__prefix");
        var scrollElement = tagInputRef.value.$el.querySelector(".".concat(scrollElementClass));
        if (v) scrollElement.classList.add("".concat(scrollElementClass, "--scrollable"));else scrollElement.classList.remove("".concat(scrollElementClass, "--scrollable"));
      });
      return {
        tagValue: tagValue,
        tInputValue: tInputValue,
        isHover: isHover,
        tagInputPlaceholder: tagInputPlaceholder,
        showClearIcon: showClearIcon,
        tagInputRef: tagInputRef,
        classPrefix: classPrefix,
        classes: classes,
        componentName: COMPONENT_NAME,
        setTInputValue: setTInputValue,
        addHover: addHover,
        cancelHover: cancelHover,
        onInputEnter: onInputEnter,
        onInnerEnter: onInnerEnter,
        onInputBackspaceKeyUp: onInputBackspaceKeyUp,
        onInputBackspaceKeyDown: onInputBackspaceKeyDown,
        renderLabel: renderLabel,
        onWheel: onWheel,
        scrollToRightOnEnter: scrollToRightOnEnter,
        scrollToLeftOnLeave: scrollToLeftOnLeave,
        onClearClick: onClearClick,
        onInnerClick: onInnerClick,
        onClose: onClose,
        onInputCompositionstart: onInputCompositionstart,
        onInputCompositionend: onInputCompositionend,
        CloseCircleFilledIcon: CloseCircleFilledIcon
      };
    },
    render: function render(h) {
      var _this = this,
        _this$inputProps,
        _this$inputProps2,
        _this$tagValue;
      var CloseCircleFilledIcon = this.CloseCircleFilledIcon;
      var suffixIconNode = this.showClearIcon ? h(CloseCircleFilledIcon, {
        "class": "".concat(this.componentName, "__suffix-clear"),
        "on": {
          "click": this.onClearClick
        }
      }) : renderTNodeJSX(this, "suffixIcon");
      var suffixClass = "".concat(this.classPrefix, "-tag-input__with-suffix-icon");
      if (suffixIconNode && !this.classes.includes(suffixClass)) {
        this.classes.push(suffixClass);
      }
      var prefixIconNode = renderTNodeJSX(this, "prefixIcon");
      var displayNode = renderTNodeJSX(this, "valueDisplay", {
        params: {
          value: this.tagValue,
          onClose: function onClose(index) {
            return _this.onClose({
              index: index
            });
          }
        }
      });
      var _label = renderTNodeJSX(this, "label", {
        silent: true
      });
      var readonly = this.readonly || ((_this$inputProps = this.inputProps) === null || _this$inputProps === void 0 ? void 0 : _this$inputProps.readonly);
      return h(Input, helper([{
        "ref": "tagInputRef",
        "attrs": {
          "borderless": this.borderless,
          "readonly": readonly,
          "inputClass": (_this$inputProps2 = this.inputProps) === null || _this$inputProps2 === void 0 ? void 0 : _this$inputProps2.inputClass,
          "value": this.tInputValue,
          "showInput": !readonly || !this.tagValue || !((_this$tagValue = this.tagValue) !== null && _this$tagValue !== void 0 && _this$tagValue.length),
          "keepWrapperWidth": !this.autoWidth,
          "autoWidth": true,
          "size": this.size,
          "disabled": this.disabled,
          "label": function label() {
            return _this.renderLabel({
              displayNode: displayNode,
              label: _label
            }, h);
          },
          "tips": this.tips,
          "status": this.status,
          "placeholder": this.tagInputPlaceholder,
          "suffix": this.suffix,
          "suffixIcon": function suffixIcon() {
            return suffixIconNode;
          },
          "prefixIcon": function prefixIcon() {
            return prefixIconNode;
          }
        },
        "class": this.classes
      }, {
        "props": this.inputProps
      }, {
        "scopedSlots": this.$scopedSlots
      }, {
        "on": {
          change: function change(val, context) {
            _this.setTInputValue(val, _objectSpread$2i(_objectSpread$2i({}, context), {}, {
              trigger: "input"
            }));
          },
          enter: this.onInputEnter,
          keyup: this.onInputBackspaceKeyUp,
          keydown: this.onInputBackspaceKeyDown,
          mouseenter: function mouseenter(context) {
            _this.addHover(context);
            _this.scrollToRightOnEnter();
          },
          mouseleave: function mouseleave(context) {
            _this.cancelHover(context);
            _this.scrollToLeftOnLeave();
          },
          focus: function focus(inputValue, context) {
            var _this$onFocus;
            (_this$onFocus = _this.onFocus) === null || _this$onFocus === void 0 || _this$onFocus.call(_this, _this.tagValue, {
              e: context.e,
              inputValue: inputValue
            });
            _this.$emit("focus", _this.tagValue, {
              e: context.e,
              inputValue: inputValue
            });
          },
          blur: function blur(inputValue, context) {
            var _this$onBlur;
            _this.setTInputValue("", {
              e: context.e,
              trigger: "blur"
            });
            (_this$onBlur = _this.onBlur) === null || _this$onBlur === void 0 || _this$onBlur.call(_this, _this.tagValue, {
              e: context.e,
              inputValue: ""
            });
            _this.$emit("blur", _this.tagValue, {
              e: context.e,
              inputValue: ""
            });
          },
          paste: function paste(context) {
            var _this$onPaste;
            (_this$onPaste = _this.onPaste) === null || _this$onPaste === void 0 || _this$onPaste.call(_this, context);
            _this.$emit("paste", context);
          },
          click: this.onInnerClick,
          compositionstart: this.onInputCompositionstart,
          compositionend: this.onInputCompositionend,
          mousewheel: this.onWheel
        }
      }]));
    }
  });

  var TagInput = withInstall$1(_TagInput, VueCompositionAPI__default["default"]);

  var _excluded$4 = ["tips"];
  function ownKeys$2i(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2h(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2i(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2i(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var DEFAULT_KEYS$1 = {
    label: "label",
    value: "value",
    children: "children"
  };
  function useMultiple(props, context) {
    var _toRefs = VueCompositionAPI.toRefs(props),
      inputValue = _toRefs.inputValue;
    var classPrefix = usePrefixClass();
    var tagInputRef = VueCompositionAPI.ref();
    var isMultipleFocus = VueCompositionAPI.ref(props.autofocus);
    var _useDefaultValue = useDefaultValue(inputValue, props.defaultInputValue, props.onInputChange, "inputValue", "input-change"),
      _useDefaultValue2 = _slicedToArray(_useDefaultValue, 2),
      tInputValue = _useDefaultValue2[0],
      setTInputValue = _useDefaultValue2[1];
    var iKeys = VueCompositionAPI.computed(function () {
      return _objectSpread$2h(_objectSpread$2h({}, DEFAULT_KEYS$1), props.keys);
    });
    var tags = VueCompositionAPI.computed(function () {
      if (!(props.value instanceof Array)) {
        return isObject(props.value) ? [get(props.value, iKeys.value.label)] : [props.value];
      }
      return props.value.map(function (item) {
        return isObject(item) ? get(item, iKeys.value.label) : item;
      });
    });
    var tPlaceholder = VueCompositionAPI.computed(function () {
      return !tags.value || !tags.value.length ? props.placeholder : "";
    });
    var onTagInputChange = function onTagInputChange(val, ctx) {
      var _props$onTagChange;
      if (ctx.trigger === "tag-remove") {
        var _ctx$e;
        (_ctx$e = ctx.e) === null || _ctx$e === void 0 || _ctx$e.stopPropagation();
      }
      (_props$onTagChange = props.onTagChange) === null || _props$onTagChange === void 0 || _props$onTagChange.call(props, val, ctx);
      context.emit("tag-change", val, ctx);
    };
    var onInputChange = function onInputChange(val, ctx) {
      if (ctx.trigger === "enter" || ctx.trigger === "blur") return;
      setTInputValue(val, {
        trigger: ctx.trigger,
        e: ctx.e
      });
    };
    var onFocus = function onFocus(val, ctx) {
      var _props$onFocus;
      isMultipleFocus.value = true;
      var params = _objectSpread$2h(_objectSpread$2h({}, ctx), {}, {
        tagInputValue: val
      });
      (_props$onFocus = props.onFocus) === null || _props$onFocus === void 0 || _props$onFocus.call(props, props.value, params);
      context.emit("focus", props.value, params);
    };
    var onEnter = function onEnter(val, ctx) {
      var _props$onEnter;
      var params = _objectSpread$2h(_objectSpread$2h({}, ctx), {}, {
        tagInputValue: val
      });
      (_props$onEnter = props.onEnter) === null || _props$onEnter === void 0 || _props$onEnter.call(props, props.value, params);
      context.emit("enter", props.value, params);
    };
    var renderSelectMultiple = function renderSelectMultiple(p, h) {
      var tagInputProps = _objectSpread$2h(_objectSpread$2h({}, p.commonInputProps), {}, {
        tagProps: props.tagProps,
        label: props.label,
        autoWidth: props.autoWidth,
        readonly: props.readonly,
        placeholder: tPlaceholder.value,
        minCollapsedNum: props.minCollapsedNum,
        collapsedItems: props.collapsedItems,
        tag: props.tag,
        valueDisplay: props.valueDisplay,
        value: tags.value,
        inputValue: tInputValue.value || "",
        inputProps: _objectSpread$2h({
          readonly: !props.allowInput || props.readonly,
          inputClass: _defineProperty$2({}, "".concat(classPrefix.value, "-input--focused"), p.popupVisible)
        }, props.inputProps),
        suffixIcon: !props.disabled && props.loading ? function () {
          return h(Loading, {
            "attrs": {
              "loading": true,
              "size": "small"
            }
          });
        } : props.suffixIcon
      }, props.tagInputProps);
      var _context$slots = context.slots;
        _context$slots.tips;
        var slots = _objectWithoutProperties$2(_context$slots, _excluded$4);
      var newListeners = _objectSpread$2h({}, context.listeners);
      delete newListeners.blur;
      return h(TagInput, helper([{
        "ref": "tagInputRef",
        "scopedSlots": slots
      }, {
        "props": tagInputProps
      }, {}, {
        "on": _objectSpread$2h(_objectSpread$2h({}, newListeners), {}, {
          "input-change": onInputChange,
          change: onTagInputChange,
          clear: p.onInnerClear,
          focus: onFocus,
          enter: onEnter
        })
      }]));
    };
    return {
      tags: tags,
      tPlaceholder: tPlaceholder,
      tagInputRef: tagInputRef,
      multipleInputValue: tInputValue,
      isMultipleFocus: isMultipleFocus,
      renderSelectMultiple: renderSelectMultiple
    };
  }

  function ownKeys$2h(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2g(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2h(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2h(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var MAX_POPUP_WIDTH = 1e3;
  function useOverlayInnerStyle(props, extra) {
    var instance = VueCompositionAPI.getCurrentInstance();
    var _toRefs = VueCompositionAPI.toRefs(props),
      popupProps = _toRefs.popupProps,
      autoWidth = _toRefs.autoWidth;
    var innerPopupVisible = VueCompositionAPI.ref(false);
    var matchWidthFunc = function matchWidthFunc(triggerElement, popupElement) {
      var SCROLLBAR_WIDTH = popupElement.scrollHeight > popupElement.offsetHeight ? 8 : 0;
      popupElement.style.width = "";
      var width = popupElement.offsetWidth + SCROLLBAR_WIDTH >= triggerElement.offsetWidth ? popupElement.offsetWidth : triggerElement.offsetWidth;
      var otherOverlayInnerStyle = {};
      if (popupProps.value && _typeof$2(popupProps.value.overlayInnerStyle) === "object" && !popupProps.value.overlayInnerStyle.width) {
        otherOverlayInnerStyle = popupProps.value.overlayInnerStyle;
      }
      return _objectSpread$2g({
        width: "".concat(Math.min(width, MAX_POPUP_WIDTH), "px")
      }, otherOverlayInnerStyle);
    };
    var onInnerPopupVisibleChange = function onInnerPopupVisibleChange(visible, ctx) {
      if (props.disabled || props.readonly) return;
      var newVisible = ctx.trigger === "trigger-element-click" && props.allowInput ? true : visible;
      if (props.popupVisible !== newVisible) {
        var _props$onPopupVisible;
        innerPopupVisible.value = newVisible;
        (_props$onPopupVisible = props.onPopupVisibleChange) === null || _props$onPopupVisible === void 0 || _props$onPopupVisible.call(props, newVisible, ctx);
        instance.emit("popup-visible-change", newVisible, ctx);
        if (!newVisible) {
          var _extra$afterHidePopup;
          extra === null || extra === void 0 || (_extra$afterHidePopup = extra.afterHidePopup) === null || _extra$afterHidePopup === void 0 || _extra$afterHidePopup.call(extra, ctx);
        }
      }
    };
    var tOverlayInnerStyle = VueCompositionAPI.computed(function () {
      var _popupProps$value;
      var result = {};
      var overlayInnerStyle = ((_popupProps$value = popupProps.value) === null || _popupProps$value === void 0 ? void 0 : _popupProps$value.overlayInnerStyle) || {};
      if (isFunction(overlayInnerStyle) || isObject(overlayInnerStyle) && overlayInnerStyle.width) {
        result = overlayInnerStyle;
      } else if (!autoWidth.value) {
        result = matchWidthFunc;
      }
      return result;
    });
    return {
      tOverlayInnerStyle: tOverlayInnerStyle,
      innerPopupVisible: innerPopupVisible,
      onInnerPopupVisibleChange: onInnerPopupVisibleChange
    };
  }

  function ownKeys$2g(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2f(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2g(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2g(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _SelectInput = VueCompositionAPI.defineComponent({
    name: "TSelectInput",
    props: _objectSpread$2f(_objectSpread$2f({}, props$W), {}, {
      updateScrollTop: {
        type: Function
      }
    }),
    setup: function setup(props2, context) {
      var selectInputRef = VueCompositionAPI.ref();
      var _useConfig = useConfig("classPrefix"),
        classPrefix = _useConfig.classPrefix;
      var _toRefs = VueCompositionAPI.toRefs(props2),
        multiple = _toRefs.multiple,
        value = _toRefs.value,
        popupVisible = _toRefs.popupVisible,
        borderless = _toRefs.borderless;
      var _useSingle = useSingle$1(props2, context),
        isSingleFocus = _useSingle.isSingleFocus,
        commonInputProps = _useSingle.commonInputProps,
        singleInputValue = _useSingle.singleInputValue,
        onInnerClear = _useSingle.onInnerClear,
        renderSelectSingle = _useSingle.renderSelectSingle;
      var _useMultiple = useMultiple(props2, context),
        multipleInputValue = _useMultiple.multipleInputValue,
        isMultipleFocus = _useMultiple.isMultipleFocus,
        renderSelectMultiple = _useMultiple.renderSelectMultiple;
      var _useOverlayInnerStyle = useOverlayInnerStyle(props2, {
          afterHidePopup: onInnerBlur
        }),
        tOverlayInnerStyle = _useOverlayInnerStyle.tOverlayInnerStyle,
        innerPopupVisible = _useOverlayInnerStyle.innerPopupVisible,
        onInnerPopupVisibleChange = _useOverlayInnerStyle.onInnerPopupVisibleChange;
      var isFocus = VueCompositionAPI.computed(function () {
        return props2.multiple ? isMultipleFocus.value : isSingleFocus.value;
      });
      function onInnerBlur(ctx) {
        var _props2$onBlur;
        var inputValue = props2.multiple ? multipleInputValue.value : singleInputValue.value;
        var params = {
          e: ctx.e,
          inputValue: inputValue
        };
        (_props2$onBlur = props2.onBlur) === null || _props2$onBlur === void 0 || _props2$onBlur.call(props2, props2.value, params);
        context.emit("blur", props2.value, params);
        isSingleFocus.value = false;
        isMultipleFocus.value = false;
      }
      var classes = VueCompositionAPI.computed(function () {
        var _popupVisible$value;
        return ["".concat(classPrefix.value, "-select-input"), _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({}, "".concat(classPrefix.value, "-select-input--borderless"), borderless.value), "".concat(classPrefix.value, "-select-input--multiple"), multiple.value), "".concat(classPrefix.value, "-select-input--popup-visible"), (_popupVisible$value = popupVisible.value) !== null && _popupVisible$value !== void 0 ? _popupVisible$value : innerPopupVisible.value), "".concat(classPrefix.value, "-select-input--empty"), value.value instanceof Array ? !value.value.length : !value.value)];
      });
      var addKeyboardEventListener = function addKeyboardEventListener(e) {
        if (/(ArrowDown|ArrowUp)/.test(e.code || e.key)) {
          var _props2$onPopupVisibl;
          var ctx = _objectSpread$2f(_objectSpread$2f({}, context), {}, {
            trigger: "trigger-element-focus"
          });
          (_props2$onPopupVisibl = props2.onPopupVisibleChange) === null || _props2$onPopupVisibl === void 0 || _props2$onPopupVisibl.call(props2, true, ctx);
          context.emit("popup-visible-change", true, ctx);
        }
      };
      VueCompositionAPI.watch([isFocus], function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 1),
          isFocus2 = _ref3[0];
        if (popupVisible.value) return;
        if (isFocus2) {
          selectInputRef.value.addEventListener("keydown", addKeyboardEventListener);
        } else {
          selectInputRef.value.removeEventListener("keydown", addKeyboardEventListener);
        }
      });
      VueCompositionAPI.onMounted(function () {
        if (!popupVisible.value && isFocus) {
          selectInputRef.value.addEventListener("keydown", addKeyboardEventListener);
        }
      });
      VueCompositionAPI.onBeforeUnmount(function () {
        selectInputRef.value.removeEventListener("keydown", addKeyboardEventListener);
      });
      return {
        selectInputRef: selectInputRef,
        innerPopupVisible: innerPopupVisible,
        commonInputProps: commonInputProps,
        tOverlayInnerStyle: tOverlayInnerStyle,
        classes: classes,
        onInnerClear: onInnerClear,
        renderSelectSingle: renderSelectSingle,
        renderSelectMultiple: renderSelectMultiple,
        onInnerPopupVisibleChange: onInnerPopupVisibleChange,
        classPrefix: classPrefix
      };
    },
    render: function render(h) {
      var _this$popupVisible, _this$popupProps, _this$popupVisible2;
      var visibleProps = {
        visible: (_this$popupVisible = this.popupVisible) !== null && _this$popupVisible !== void 0 ? _this$popupVisible : this.innerPopupVisible
      };
      var mainContent = h(Popup, helper([{
        "ref": "selectInputPopupRef",
        "attrs": {
          "trigger": ((_this$popupProps = this.popupProps) === null || _this$popupProps === void 0 ? void 0 : _this$popupProps.trigger) || "click",
          "placement": "bottom-left",
          "visible": (_this$popupVisible2 = this.popupVisible) !== null && _this$popupVisible2 !== void 0 ? _this$popupVisible2 : this.innerPopupVisible,
          "content": this.panel,
          "hideEmptyPopup": true,
          "disabled": this.disabled || this.readonly
        },
        "scopedSlots": _objectSpread$2f(_objectSpread$2f({}, this.$scopedSlots), {}, {
          content: this.$scopedSlots.panel
        }),
        "key": this.multiple ? "multiple" : "single"
      }, {
        "on": {
          "visible-change": this.onInnerPopupVisibleChange
        }
      }, {}, {
        "props": _objectSpread$2f(_objectSpread$2f({}, this.popupProps), {}, {
          overlayInnerStyle: this.tOverlayInnerStyle
        })
      }, {
        "attrs": {
          "updateScrollTop": this.updateScrollTop
        }
      }]), [this.multiple ? this.renderSelectMultiple({
        commonInputProps: this.commonInputProps,
        onInnerClear: this.onInnerClear,
        popupVisible: visibleProps.visible
      }, h) : this.renderSelectSingle(h, visibleProps.visible)]);
      var tipsNode = renderTNodeJSX(this, "tips");
      return h("div", {
        "ref": "selectInputRef",
        "class": this.classes
      }, [mainContent, tipsNode && h("div", {
        "class": "".concat(this.classPrefix, "-input__tips ").concat(this.classPrefix, "-input__tips--").concat(this.status || "normal")
      }, [tipsNode])]);
    }
  });

  var SelectInput = withInstall$1(_SelectInput, VueCompositionAPI__default["default"]);

  var props$U = {
    checkAll: Boolean,
    content: {
      type: [String, Function]
    },
    "default": {
      type: [String, Function]
    },
    disabled: Boolean,
    label: {
      type: String,
      "default": ""
    },
    title: {
      type: String,
      "default": ""
    },
    value: {
      type: [String, Number, Boolean]
    }
  };

  var props$T = {
    checkAll: Boolean,
    checked: {
      type: Boolean,
      "default": void 0
    },
    defaultChecked: Boolean,
    "default": {
      type: [String, Function]
    },
    disabled: {
      type: Boolean,
      "default": void 0
    },
    indeterminate: Boolean,
    label: {
      type: [String, Function]
    },
    lazyLoad: Boolean,
    name: {
      type: String,
      "default": ""
    },
    readonly: Boolean,
    value: {
      type: [String, Number, Boolean]
    },
    onChange: Function
  };

  var CheckboxGroupInjectionKey = Symbol("CheckboxGroupProvide");

  var CheckboxStore = /*#__PURE__*/function () {
    function CheckboxStore() {
      _classCallCheck(this, CheckboxStore);
      _defineProperty$2(this, "observerMap", {});
      _defineProperty$2(this, "parentChecked", void 0);
      _defineProperty$2(this, "parentExist", void 0);
    }
    return _createClass(CheckboxStore, [{
      key: "init",
      value: function init() {
        this.parentExist = true;
      }
    }, {
      key: "updateChecked",
      value: function updateChecked(_ref) {
        var _this$observerMap$CHE, _this$observerMap2;
        var checked = _ref.checked,
          isCheckAll = _ref.isCheckAll,
          oldChecked = _ref.oldChecked,
          indeterminate = _ref.indeterminate;
        this.parentChecked = checked;
        var changedChecked = oldChecked ? getChangedChecked(checked, oldChecked) : checked;
        var checkedParams = {
          parentChecked: checked,
          parentIsCheckAll: isCheckAll,
          parentIsIndeterminate: indeterminate,
          type: "checked"
        };
        for (var i = 0, len = changedChecked.length; i < len; i++) {
          var _this$observerMap$val, _this$observerMap;
          var value = String(changedChecked[i]);
          (_this$observerMap$val = (_this$observerMap = this.observerMap)[value]) === null || _this$observerMap$val === void 0 || _this$observerMap$val.call(_this$observerMap, checkedParams);
        }
        (_this$observerMap$CHE = (_this$observerMap2 = this.observerMap).CHECK_ALL) === null || _this$observerMap$CHE === void 0 || _this$observerMap$CHE.call(_this$observerMap2, checkedParams);
      }
    }, {
      key: "updateCheckbox",
      value: function updateCheckbox(_ref2) {
        var _this = this;
        var disabled = _ref2.disabled,
          maxExceeded = _ref2.maxExceeded,
          checkboxName = _ref2.checkboxName;
        var checkboxList = Object.keys(this.observerMap);
        checkboxList.forEach(function (checkbox) {
          var _this$observerMap$che, _this$observerMap3;
          (_this$observerMap$che = (_this$observerMap3 = _this.observerMap)[checkbox]) === null || _this$observerMap$che === void 0 || _this$observerMap$che.call(_this$observerMap3, {
            type: "checkbox",
            parentDisabled: disabled,
            parentMaxExceeded: maxExceeded,
            checkboxName: checkboxName
          });
        });
      }
    }, {
      key: "subscribe",
      value: function subscribe(value, listener) {
        this.observerMap[String(value)] = listener;
      }
    }, {
      key: "unSubscribe",
      value: function unSubscribe(value) {
        delete this.observerMap[String(value)];
      }
    }]);
  }();
  function getChangedChecked() {
    var checked = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var oldChecked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var checkedMap = /* @__PURE__ */new Map();
    var oldCheckedMap = /* @__PURE__ */new Map();
    var changedValues = [];
    for (var i = 0, len = checked.length; i < len; i++) {
      checkedMap.set(checked[i], true);
    }
    for (var _i = 0, _len = oldChecked.length; _i < _len; _i++) {
      oldCheckedMap.set(oldChecked[_i], true);
    }
    for (var _i2 = 0, _len2 = checked.length; _i2 < _len2; _i2++) {
      if (!oldCheckedMap.get(checked[_i2])) {
        changedValues.push(checked[_i2]);
      }
    }
    for (var _i3 = 0, _len3 = oldChecked.length; _i3 < _len3; _i3++) {
      if (!checkedMap.get(oldChecked[_i3])) {
        changedValues.push(oldChecked[_i3]);
      }
    }
    return changedValues;
  }
  var checkboxStoreInstanceMap = {};
  function createCheckboxStore(key) {
    var date = new Date();
    var storeKey = key || [date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getUTCMilliseconds(), Number((Math.random() * 1e4).toFixed(2))].join("_");
    if (checkboxStoreInstanceMap[storeKey]) {
      return createCheckboxStore();
    }
    checkboxStoreInstanceMap[storeKey] = new CheckboxStore();
    return {
      storeKey: storeKey,
      checkboxStore: checkboxStoreInstanceMap[storeKey]
    };
  }
  function getCheckboxStore(key) {
    return checkboxStoreInstanceMap[key];
  }

  function useKeyboardEvent(handleChange) {
    var keyboardEventListener = function keyboardEventListener(e) {
      var isCheckedCode = CHECKED_CODE_REG.test(e.key) || CHECKED_CODE_REG.test(e.code);
      if (isCheckedCode) {
        e.preventDefault();
        var _e$currentTarget$quer = e.currentTarget.querySelector("input"),
          disabled = _e$currentTarget$quer.disabled;
        !disabled && handleChange(e);
      }
    };
    var onCheckboxFocus = function onCheckboxFocus(e) {
      e.currentTarget.addEventListener("keydown", keyboardEventListener);
    };
    var onCheckboxBlur = function onCheckboxBlur(e) {
      e.currentTarget.removeEventListener("keydown", keyboardEventListener);
    };
    return {
      onCheckboxFocus: onCheckboxFocus,
      onCheckboxBlur: onCheckboxBlur
    };
  }

  function ownKeys$2f(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2e(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2f(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2f(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _Checkbox = VueCompositionAPI.defineComponent({
    name: "TCheckbox",
    props: _objectSpread$2e(_objectSpread$2e({}, props$T), {}, {
      stopLabelTrigger: Boolean,
      storeKey: String,
      index: Number,
      data: Object
    }),
    model: {
      prop: "checked",
      event: "change"
    },
    setup: function setup(props2) {
      var _toRefs = VueCompositionAPI.toRefs(props2),
        storeKey = _toRefs.storeKey;
      var checkboxStore = VueCompositionAPI.computed(function () {
        return getCheckboxStore(storeKey.value);
      });
      var labelRef = VueCompositionAPI.ref();
      var _useCommonClassName = useCommonClassName$1(),
        STATUS = _useCommonClassName.STATUS;
      var checkboxGroupExist = VueCompositionAPI.ref(false);
      var _toRefs2 = VueCompositionAPI.toRefs(props2),
        checked = _toRefs2.checked,
        indeterminate = _toRefs2.indeterminate,
        disabled = _toRefs2.disabled,
        value = _toRefs2.value,
        lazyLoad = _toRefs2.lazyLoad,
        label = _toRefs2.label,
        data = _toRefs2.data;
      var _useVModel = useVModel$1(checked, props2.defaultChecked, props2.onChange, "change", "checked"),
        _useVModel2 = _slicedToArray(_useVModel, 2),
        innerChecked = _useVModel2[0],
        setInnerChecked = _useVModel2[1];
      var checkboxGroupData = VueCompositionAPI.inject(CheckboxGroupInjectionKey, void 0);
      var tIndeterminate = VueCompositionAPI.ref(false);
      var tChecked = VueCompositionAPI.ref(false);
      var handleParentCheckedChange = function handleParentCheckedChange(_ref) {
        var parentIsCheckAll = _ref.parentIsCheckAll,
          parentChecked = _ref.parentChecked,
          parentIsIndeterminate = _ref.parentIsIndeterminate;
        var value2 = props2.value,
          checkAll = props2.checkAll;
        if (checkAll) {
          tChecked.value = parentIsCheckAll;
          tIndeterminate.value = parentIsIndeterminate;
        } else {
          tChecked.value = parentChecked.includes(value2);
        }
        checkboxGroupExist.value = checkboxStore.value.parentExist;
      };
      VueCompositionAPI.watch([innerChecked, checkboxStore], function () {
        var _checkboxStore$value;
        if ((_checkboxStore$value = checkboxStore.value) !== null && _checkboxStore$value !== void 0 && _checkboxStore$value.parentExist) {
          checkboxGroupExist.value = true;
        } else {
          tChecked.value = innerChecked.value;
        }
      }, {
        immediate: true
      });
      VueCompositionAPI.watch([indeterminate, checkboxStore], function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          val = _ref3[0],
          checkboxStore2 = _ref3[1];
        if (!(checkboxStore2 !== null && checkboxStore2 !== void 0 && checkboxStore2.parentExist)) {
          tIndeterminate.value = val;
        }
      }, {
        immediate: true
      });
      var tName = VueCompositionAPI.ref();
      var tDisabled = VueCompositionAPI.ref();
      var _useFormDisabled = useFormDisabled(),
        formDisabled = _useFormDisabled.formDisabled;
      var handleParentDisabled = function handleParentDisabled(_ref4) {
        var parentDisabled = _ref4.parentDisabled,
          parentMaxExceeded = _ref4.parentMaxExceeded;
        var checkAll = props2.checkAll,
          disabled2 = props2.disabled;
        if (!checkAll && !tChecked.value && parentMaxExceeded) {
          tDisabled.value = true;
          return;
        }
        if (disabled2 !== void 0) {
          tDisabled.value = disabled2;
          return;
        }
        if (parentDisabled !== void 0) {
          tDisabled.value = parentDisabled;
          return;
        }
        tDisabled.value = disabled2;
      };
      VueCompositionAPI.watch([checkboxStore], function () {
        var _checkboxStore$value2;
        if (!((_checkboxStore$value2 = checkboxStore.value) !== null && _checkboxStore$value2 !== void 0 && _checkboxStore$value2.parentExist)) {
          tDisabled.value = props2.disabled;
        }
      });
      VueCompositionAPI.watch([disabled], function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 1),
          val = _ref6[0];
        tDisabled.value = val;
      }, {
        immediate: true
      });
      var COMPONENT_NAME = usePrefixClass("checkbox");
      var labelClasses = VueCompositionAPI.ref([]);
      VueCompositionAPI.watch([tChecked, tIndeterminate], function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
          tChecked2 = _ref8[0],
          tIndeterminate2 = _ref8[1];
        labelClasses.value = ["".concat(COMPONENT_NAME.value), _defineProperty$2(_defineProperty$2({}, STATUS.value.checked, tChecked2), STATUS.value.indeterminate, tIndeterminate2)];
      }, {
        immediate: true
      });
      var subscribeParentData = function subscribeParentData(val) {
        checkboxStore.value.subscribe(val, function (data2) {
          if (data2.type === "checked") {
            handleParentCheckedChange(data2);
          } else if (data2.type === "checkbox") {
            setTimeout(function () {
              handleParentDisabled(data2);
            }, 0);
            if (data2.checkboxName) {
              tName.value = data2.checkboxName;
            }
          }
        });
      };
      VueCompositionAPI.watch([data, label, storeKey], function () {
        var _checkboxStore$value3;
        if (!storeKey.value) return;
        if (!tChecked.value && (_checkboxStore$value3 = checkboxStore.value) !== null && _checkboxStore$value3 !== void 0 && (_checkboxStore$value3 = _checkboxStore$value3.parentChecked) !== null && _checkboxStore$value3 !== void 0 && _checkboxStore$value3.includes(props2.value)) {
          tChecked.value = true;
        }
        subscribeParentData(props2.checkAll ? "CHECK_ALL" : value.value);
      }, {
        immediate: true
      });
      VueCompositionAPI.onBeforeUnmount(function () {
        var _checkboxStore$value4;
        (_checkboxStore$value4 = checkboxStore.value) === null || _checkboxStore$value4 === void 0 || _checkboxStore$value4.unSubscribe(props2.checkAll ? "CHECK_ALL" : value.value);
      });
      var handleChange = function handleChange(e) {
        if (props2.readonly) return;
        var checked2 = !tChecked.value;
        setInnerChecked(checked2, {
          e: e
        });
        if (checkboxGroupData !== null && checkboxGroupData !== void 0 && checkboxGroupData.value.onCheckedChange) {
          checkboxGroupData.value.onCheckedChange({
            checked: checked2,
            checkAll: props2.checkAll,
            e: e,
            option: props2
          });
        }
      };
      var handleLabelClick = function handleLabelClick(e) {
        if (props2.stopLabelTrigger) e.preventDefault();
      };
      var _useElementLazyRender = useElementLazyRender(labelRef, lazyLoad),
        showCheckbox = _useElementLazyRender.showElement;
      var _useKeyboardEvent = useKeyboardEvent(handleChange),
        onCheckboxFocus = _useKeyboardEvent.onCheckboxFocus,
        onCheckboxBlur = _useKeyboardEvent.onCheckboxBlur;
      return {
        labelRef: labelRef,
        labelClasses: labelClasses,
        COMPONENT_NAME: COMPONENT_NAME,
        tDisabled: tDisabled,
        tIndeterminate: tIndeterminate,
        tName: tName,
        tChecked: tChecked,
        showCheckbox: showCheckbox,
        formDisabled: formDisabled,
        STATUS: STATUS,
        checkboxGroupExist: checkboxGroupExist,
        handleChange: handleChange,
        handleLabelClick: handleLabelClick,
        onCheckboxFocus: onCheckboxFocus,
        onCheckboxBlur: onCheckboxBlur
      };
    },
    render: function render() {
      var _this$tDisabled;
      var h = arguments[0];
      var disabled = (_this$tDisabled = this.tDisabled) !== null && _this$tDisabled !== void 0 ? _this$tDisabled : this.formDisabled;
      var classes = this.labelClasses.concat(_defineProperty$2({}, this.STATUS.disabled, disabled));
      var slotsPrams = {
        data: this.data,
        index: this.index
      };
      return h("label", {
        "ref": "labelRef",
        "class": classes,
        "attrs": {
          "tabindex": disabled ? void 0 : "0"
        },
        "on": {
          "focus": this.onCheckboxFocus,
          "blur": this.onCheckboxBlur
        }
      }, [!this.showCheckbox ? null : [h("input", helper([{
        "attrs": {
          "type": "checkbox",
          "disabled": disabled,
          "readonly": this.readonly,
          "indeterminate": this.tIndeterminate,
          "name": this.tName || this.name || void 0
        },
        "class": "".concat(this.COMPONENT_NAME, "__former"),
        "domProps": {
          "value": this.value ? this.value : void 0,
          "checked": this.tChecked
        }
      }, {
        "on": {
          change: this.handleChange
        }
      }, {
        "key": "input",
        "attrs": {
          "tabindex": "-1"
        }
      }])), h("span", {
        "class": "".concat(this.COMPONENT_NAME, "__input"),
        "key": "input-span"
      }), h("span", {
        "class": "".concat(this.COMPONENT_NAME, "__label"),
        "key": "label",
        "on": {
          "click": this.handleLabelClick
        }
      }, [renderTNodeJSX(this, "default", {
        params: slotsPrams
      }) || renderTNodeJSX(this, "label", {
        params: slotsPrams,
        slotFirst: this.checkboxGroupExist
      })])]]);
    }
  });

  var props$S = {
    disabled: {
      type: Boolean,
      "default": void 0
    },
    lazyLoad: Boolean,
    max: {
      type: Number,
      "default": void 0
    },
    name: {
      type: String,
      "default": ""
    },
    options: {
      type: Array
    },
    value: {
      type: Array,
      "default": void 0
    },
    defaultValue: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    onChange: Function
  };

  var _CheckboxGroup = VueCompositionAPI.defineComponent({
    name: "TCheckboxGroup",
    props: props$S,
    setup: function setup(props2) {
      var COMPONENT_NAME = usePrefixClass("checkbox-group");
      var _createCheckboxStore = createCheckboxStore(),
        checkboxStore = _createCheckboxStore.checkboxStore,
        storeKey = _createCheckboxStore.storeKey;
      checkboxStore.init();
      var isArray = Array.isArray;
      var _toRefs = VueCompositionAPI.toRefs(props2),
        value = _toRefs.value,
        disabled = _toRefs.disabled,
        name = _toRefs.name,
        options = _toRefs.options;
      var _useVModel = useVModel$1(value, props2.defaultValue, props2.onChange),
        _useVModel2 = _slicedToArray(_useVModel, 2),
        innerValue = _useVModel2[0],
        setInnerValue = _useVModel2[1];
      var optionList = VueCompositionAPI.ref([]);
      var intersectionLen = VueCompositionAPI.computed(function () {
        if (!isArray(innerValue.value)) return 0;
        var values = optionList.value.map(function (item) {
          return item.value;
        });
        var n = intersection$1(innerValue.value, values);
        return n.length;
      });
      var isCheckAll = VueCompositionAPI.computed(function () {
        var optionItems = optionList.value.filter(function (item) {
          return !item.disabled && !item.checkAll;
        }).map(function (t) {
          return t.value;
        });
        var intersectionValues = intersection$1(optionItems, innerValue.value);
        return intersectionValues.length === optionItems.length;
      });
      var indeterminate = VueCompositionAPI.computed(function () {
        return !isCheckAll.value && intersectionLen.value < optionList.value.length && intersectionLen.value !== 0;
      });
      var maxExceeded = VueCompositionAPI.computed(function () {
        return !isUndefined(props2.max) && innerValue.value.length === props2.max;
      });
      VueCompositionAPI.watch([disabled, maxExceeded, name], function (_ref) {
        var _ref2 = _slicedToArray(_ref, 3),
          disabled2 = _ref2[0],
          maxExceeded2 = _ref2[1],
          checkboxName = _ref2[2];
        checkboxStore.updateCheckbox({
          disabled: disabled2,
          maxExceeded: maxExceeded2,
          checkboxName: checkboxName
        });
      });
      VueCompositionAPI.watch([options], function () {
        VueCompositionAPI.nextTick(function () {
          checkboxStore.updateCheckbox({
            disabled: disabled.value,
            maxExceeded: maxExceeded.value,
            checkboxName: name.value
          });
        });
      });
      VueCompositionAPI.onMounted(function () {
        checkboxStore.updateCheckbox({
          disabled: disabled.value,
          maxExceeded: maxExceeded.value,
          checkboxName: name.value
        });
      });
      VueCompositionAPI.watchEffect(function () {
        if (!props2.options) return [];
        optionList.value = props2.options.map(function (item) {
          return isObject(item) ? item : {
            label: String(item),
            value: item
          };
        });
      });
      var getAllCheckboxValue = function getAllCheckboxValue() {
        var val = /* @__PURE__ */new Set();
        for (var i = 0, len = optionList.value.length; i < len; i++) {
          var item = optionList.value[i];
          if (item.checkAll) continue;
          if (item.disabled) continue;
          val.add(item.value);
          if (maxExceeded.value) break;
        }
        return _toConsumableArray(val);
      };
      var onCheckAllChange = function onCheckAllChange(checked, context) {
        var value2 = checked ? getAllCheckboxValue() : [];
        setInnerValue(value2, {
          e: context.e,
          type: checked ? "check" : "uncheck",
          current: void 0,
          option: void 0
        });
      };
      var handleCheckboxChange = function handleCheckboxChange(data) {
        var currentValue = data.option.value;
        if (!isArray(innerValue.value)) {
          console.warn("TDesign CheckboxGroup Warn: `value` must be an array, instead of ".concat(_typeof$2(innerValue.value)));
          return;
        }
        var val = _toConsumableArray(innerValue.value);
        if (data.checked) {
          val.push(currentValue);
        } else {
          var i = val.indexOf(currentValue);
          val.splice(i, 1);
        }
        setInnerValue(val, {
          e: data.e,
          current: data.option.value,
          option: data.option,
          type: data.checked ? "check" : "uncheck"
        });
      };
      var onCheckedChange = function onCheckedChange(p) {
        var checked = p.checked,
          checkAll = p.checkAll,
          e = p.e;
        if (checkAll) {
          onCheckAllChange(checked, {
            e: e
          });
        } else {
          handleCheckboxChange(p);
        }
      };
      var getChildComponentSlots = useChildComponentSlots();
      var getOptionListBySlots = function getOptionListBySlots() {
        var nodes = getChildComponentSlots("Checkbox");
        var arr = [];
        nodes === null || nodes === void 0 || nodes.forEach(function (node) {
          var option = node.componentOptions.propsData;
          if (!option) return;
          if (option["check-all"] === "" || option["check-all"] === true) {
            option.checkAll = true;
          }
          arr.push(option);
        });
        return arr;
      };
      VueCompositionAPI.provide(CheckboxGroupInjectionKey, VueCompositionAPI.computed(function () {
        return {
          handleCheckboxChange: handleCheckboxChange,
          onCheckedChange: onCheckedChange
        };
      }));
      VueCompositionAPI.watch(function () {
        return _toConsumableArray(innerValue.value);
      }, function (val, oldValue) {
        VueCompositionAPI.nextTick(function () {
          checkboxStore.updateChecked({
            checked: val,
            oldChecked: oldValue,
            isCheckAll: isCheckAll.value,
            indeterminate: indeterminate.value
          });
        });
      }, {
        immediate: true
      });
      VueCompositionAPI.watch([isCheckAll, indeterminate, options], function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          isCheckAll2 = _ref4[0],
          indeterminate2 = _ref4[1];
        VueCompositionAPI.nextTick(function () {
          checkboxStore.updateChecked({
            checked: innerValue.value,
            isCheckAll: isCheckAll2,
            indeterminate: indeterminate2
          });
        });
      });
      var _addStoreKeyToCheckbox = function addStoreKeyToCheckbox(nodes) {
        if (!nodes) return;
        for (var i = 0, len = nodes.length; i < len; i++) {
          var _vNode$children;
          var vNode = nodes[i];
          var componentName = getVNodeComponentName(vNode);
          if (vNode.componentOptions && componentName && componentName === getVueComponentName(_Checkbox)) {
            vNode.componentOptions.propsData.storeKey = storeKey;
          }
          if ((_vNode$children = vNode.children) !== null && _vNode$children !== void 0 && _vNode$children.length) {
            _addStoreKeyToCheckbox(vNode.children);
          }
        }
      };
      return {
        storeKey: storeKey,
        optionList: optionList,
        innerValue: innerValue,
        COMPONENT_NAME: COMPONENT_NAME,
        getOptionListBySlots: getOptionListBySlots,
        addStoreKeyToCheckbox: _addStoreKeyToCheckbox
      };
    },
    render: function render() {
      var _this$options,
        _this = this;
      var h = arguments[0];
      var children = null;
      if ((_this$options = this.options) !== null && _this$options !== void 0 && _this$options.length) {
        var _this$optionList;
        children = (_this$optionList = this.optionList) === null || _this$optionList === void 0 ? void 0 : _this$optionList.map(function (option, index) {
          var _option$value, _this$innerValue;
          return h(_Checkbox, helper([{
            "key": (_option$value = option.value) !== null && _option$value !== void 0 ? _option$value : index,
            "attrs": {
              "lazyLoad": _this.lazyLoad
            }
          }, {
            "props": option
          }, {
            "attrs": {
              "index": index,
              "data": option,
              "checked": ((_this$innerValue = _this.innerValue) === null || _this$innerValue === void 0 ? void 0 : _this$innerValue.includes(option.value)) || false,
              "storeKey": _this.storeKey
            },
            "scopedSlots": _this.$scopedSlots
          }]));
        });
      } else {
        var _this$$scopedSlots$de, _this$$scopedSlots;
        var nodes = (_this$$scopedSlots$de = (_this$$scopedSlots = this.$scopedSlots)["default"]) === null || _this$$scopedSlots$de === void 0 ? void 0 : _this$$scopedSlots$de.call(_this$$scopedSlots, null);
        this.optionList = this.getOptionListBySlots();
        this.addStoreKeyToCheckbox(nodes);
        children = nodes;
      }
      return h("div", {
        "class": this.COMPONENT_NAME,
        "attrs": {
          "role": "group",
          "aria-label": "checkbox-group"
        }
      }, [children]);
    }
  });

  var Checkbox = withInstall$1(_Checkbox);
  var CheckboxGroup = withInstall$1(_CheckboxGroup);

  function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
  function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
  function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
  var getSingleContent$1 = function getSingleContent(value, optionsMap) {
    var option = optionsMap.get(value);
    return (option === null || option === void 0 ? void 0 : option.label) || (value === null || value === void 0 ? void 0 : value.toString());
  };
  var getMultipleContent$1 = function getMultipleContent(value, optionsMap) {
    var res = [];
    var _iterator = _createForOfIteratorHelper(value),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var iterator = _step.value;
        var resLabel = getSingleContent$1(iterator, optionsMap);
        if (resLabel) {
          res.push(resLabel);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return res;
  };
  var getNewMultipleValue = function getNewMultipleValue(innerValue, optionValue) {
    var value = cloneDeep(innerValue);
    var valueIndex = value.indexOf(optionValue);
    if (valueIndex < 0) {
      value.push(optionValue);
    } else {
      value.splice(valueIndex, 1);
    }
    return {
      value: value,
      isCheck: valueIndex < 0
    };
  };
  var getAllSelectableOption = function getAllSelectableOption(options) {
    return options.filter(function (option) {
      return !option.disabled && !option.checkAll;
    });
  };
  var _flattenOptions = function flattenOptions(options) {
    return options.reduce(function (acc, current) {
      return acc.concat(current.group ? _flattenOptions(current.children) : [current]);
    }, []);
  };

  function ownKeys$2e(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2d(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2e(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2e(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var keepAnimationMixins$2 = getKeepAnimationMixins();
  var _Option = VueCompositionAPI.defineComponent({
    name: "TOption",
    props: _objectSpread$2d(_objectSpread$2d({}, props$U), {}, {
      isCreatedOption: Boolean,
      multiple: Boolean,
      rowIndex: Number,
      trs: Map,
      scrollType: String,
      isVirtual: Boolean,
      bufferSize: Number,
      index: Number
    }),
    components: {
      TCheckbox: Checkbox
    },
    mixins: [keepAnimationMixins$2],
    directives: {
      Ripple: Ripple
    },
    setup: function setup(props2, context) {
      var selectProvider = VueCompositionAPI.inject("tSelect");
      var optionNode = VueCompositionAPI.ref(null);
      var _useCommonClassName = useCommonClassName(),
        sizeClassNames = _useCommonClassName.sizeClassNames,
        statusClassNames = _useCommonClassName.statusClassNames;
      var _useConfig = useConfig("classPrefix"),
        classPrefix = _useConfig.classPrefix;
      var _toRefs = VueCompositionAPI.toRefs(props2),
        value = _toRefs.value,
        label = _toRefs.label,
        multiple = _toRefs.multiple,
        disabled = _toRefs.disabled,
        panelElement = _toRefs.panelElement,
        scrollType = _toRefs.scrollType,
        bufferSize = _toRefs.bufferSize,
        index = _toRefs.index,
        isCreatedOption = _toRefs.isCreatedOption;
      var _useLazyLoad = useLazyLoad(panelElement, optionNode, VueCompositionAPI.reactive({
          type: scrollType,
          bufferSize: bufferSize
        })),
        _useLazyLoad$hasLazyL = _useLazyLoad.hasLazyLoadHolder,
        hasLazyLoadHolder = _useLazyLoad$hasLazyL === void 0 ? null : _useLazyLoad$hasLazyL,
        _useLazyLoad$tRowHeig = _useLazyLoad.tRowHeight,
        tRowHeight = _useLazyLoad$tRowHeig === void 0 ? null : _useLazyLoad$tRowHeig;
      var isHover = VueCompositionAPI.ref(false);
      var _useFormDisabled = useFormDisabled(),
        formDisabled = _useFormDisabled.formDisabled;
      var isSelected = VueCompositionAPI.computed(function () {
        if (multiple.value) {
          var _selectProvider$selec;
          if (props2.checkAll) {
            return selectProvider.isAllOptionsChecked.value;
          }
          return (_selectProvider$selec = selectProvider.selectValue.value) === null || _selectProvider$selec === void 0 ? void 0 : _selectProvider$selec.includes(props2.value);
        }
        return selectProvider.selectValue.value === props2.value;
      });
      var isIndeterminate = VueCompositionAPI.computed(function () {
        return multiple.value && !selectProvider.isAllOptionsChecked.value && selectProvider.selectValue.value.length > 0;
      });
      var isDisabled = VueCompositionAPI.computed(function () {
        return disabled.value || formDisabled.value || multiple.value && !isSelected.value && !props2.checkAll && selectProvider.isReachMaxLimit.value;
      });
      var mouseEvent = function mouseEvent(v) {
        isHover.value = v;
      };
      var labelText = VueCompositionAPI.computed(function () {
        return label.value || value.value;
      });
      var classes = VueCompositionAPI.computed(function () {
        return ["".concat(classPrefix.value, "-select-option"), sizeClassNames[selectProvider && selectProvider.size.value], _defineProperty$2(_defineProperty$2(_defineProperty$2({}, statusClassNames.disabled, isDisabled.value), statusClassNames.selected, isSelected.value), "".concat(classPrefix.value, "-select-option__hover"), (isHover.value || selectProvider.hoverIndex.value === index.value) && !isDisabled.value && !isSelected.value)];
      });
      var handleClick = function handleClick(e) {
        if (isDisabled.value) return;
        e.preventDefault();
        if (isCreatedOption.value) {
          var _selectProvider$handl;
          (_selectProvider$handl = selectProvider.handleCreate) === null || _selectProvider$handl === void 0 || _selectProvider$handl.call(selectProvider, value.value);
        }
        if (multiple.value) {
          if (props2.checkAll) {
            selectProvider.handleCheckAllClick(e);
          } else {
            var newValue = getNewMultipleValue(selectProvider.selectValue.value, value.value);
            selectProvider.handleValueChange(newValue.value, {
              e: e,
              trigger: newValue.isCheck ? "check" : "uncheck"
            }, value.value);
            if (!selectProvider.reserveKeyword.value) {
              selectProvider.handlerInputChange("");
            }
          }
        } else {
          selectProvider.handleValueChange(value.value, {
            e: e,
            trigger: "check"
          }, value.value);
          selectProvider.handlePopupVisibleChange(false, {
            e: e
          });
        }
      };
      VueCompositionAPI.onMounted(function () {
        var trs = props2.trs,
          rowIndex = props2.rowIndex,
          scrollType2 = props2.scrollType,
          isVirtual = props2.isVirtual;
        if (scrollType2 === "virtual") {
          if (isVirtual) {
            trs.set(rowIndex, optionNode.value);
            context.emit("onRowMounted");
          }
        }
      });
      VueCompositionAPI.onBeforeUnmount(function () {
        if (props2.isVirtual) {
          var trs = props2.trs,
            rowIndex = props2.rowIndex;
          trs["delete"](rowIndex);
        }
      });
      return {
        isHover: isHover,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isIndeterminate: isIndeterminate,
        mouseEvent: mouseEvent,
        classes: classes,
        selectProvider: selectProvider,
        labelText: labelText,
        optionNode: optionNode,
        tRowHeight: tRowHeight,
        hasLazyLoadHolder: hasLazyLoadHolder,
        handleClick: handleClick
      };
    },
    render: function render() {
      var h = arguments[0];
      var classes = this.classes,
        mouseEvent = this.mouseEvent,
        labelText = this.labelText,
        title = this.title;
      var selfDefinedContent = renderContent(this, "default", "content");
      var optionChild = selfDefinedContent || h("span", [labelText]);
      var titleText = title || labelText;
      if (this.hasLazyLoadHolder) {
        return h("li", {
          "ref": "optionNode",
          "class": classes,
          "on": {
            "mouseenter": function mouseenter() {
              return mouseEvent(true);
            },
            "mouseleave": function mouseleave() {
              return mouseEvent(false);
            },
            "click": this.handleClick
          },
          "directives": [{
            name: "ripple",
            value: this.keepAnimation.ripple
          }],
          "attrs": {
            "title": titleText
          }
        }, [h("span", {
          "style": {
            height: "".concat(this.tRowHeight, "px"),
            border: "none"
          }
        })]);
      }
      return h("li", {
        "ref": "optionNode",
        "class": classes,
        "on": {
          "mouseenter": function mouseenter() {
            return mouseEvent(true);
          },
          "mouseleave": function mouseleave() {
            return mouseEvent(false);
          },
          "click": this.handleClick
        },
        "directives": [{
          name: "ripple",
          value: this.keepAnimation.ripple
        }],
        "attrs": {
          "title": titleText
        }
      }, [this.multiple ? h("t-checkbox", {
        "attrs": {
          "checked": this.isSelected,
          "disabled": this.isDisabled,
          "indeterminate": this.checkAll && this.isIndeterminate
        }
      }, [optionChild]) : optionChild]);
    }
  });

  var props$R = {
    divider: {
      type: Boolean,
      "default": true
    },
    label: {
      type: String
    }
  };

  function ownKeys$2d(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2c(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2d(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2d(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _OptionGroup = VueCompositionAPI.defineComponent({
    name: "TOptionGroup",
    props: _objectSpread$2c({}, props$R),
    setup: function setup(props2) {
      var _toRefs = VueCompositionAPI.toRefs(props2),
        divider = _toRefs.divider;
      var tSelect = VueCompositionAPI.inject("tSelect");
      var _useCommonClassName = useCommonClassName(),
        sizeClassNames = _useCommonClassName.sizeClassNames;
      var COMPONENT_NAME = usePrefixClass$1("select");
      var _useConfig = useConfig("classPrefix"),
        classPrefix = _useConfig.classPrefix;
      var classes = VueCompositionAPI.computed(function () {
        return ["".concat(COMPONENT_NAME.value, "-option-group"), _defineProperty$2(_defineProperty$2({}, sizeClassNames[tSelect.size], tSelect && tSelect.size), "".concat(COMPONENT_NAME.value, "-option-group__divider"), divider)];
      });
      return {
        classes: classes,
        classPrefix: classPrefix,
        componentName: COMPONENT_NAME
      };
    },
    render: function render() {
      var _this$label;
      var h = arguments[0];
      var renderTNode = useTNodeJSX();
      var children = renderTNode("default");
      return h("li", {
        "class": this.classes
      }, [((_this$label = this.label) !== null && _this$label !== void 0 ? _this$label : false) && h("div", {
        "class": "".concat(this.componentName, "-option-group__header")
      }, [this.label]), children]);
    }
  });

  function ownKeys$2c(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2b(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2c(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2c(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var useVirtualScroll = function useVirtualScroll(_ref) {
    var data = _ref.data,
      container = _ref.container,
      _ref$fixedHeight = _ref.fixedHeight,
      fixedHeight = _ref$fixedHeight === void 0 ? false : _ref$fixedHeight,
      _ref$lineHeight = _ref.lineHeight,
      lineHeight = _ref$lineHeight === void 0 ? 30 : _ref$lineHeight,
      _ref$bufferSize = _ref.bufferSize,
      bufferSize = _ref$bufferSize === void 0 ? 20 : _ref$bufferSize,
      _ref$threshold = _ref.threshold,
      threshold = _ref$threshold === void 0 ? 100 : _ref$threshold;
    var state = VueCompositionAPI.reactive({
      visibleData: [],
      cachedHeight: [],
      cachedScrollY: []
    });
    var isVirtual = VueCompositionAPI.computed(function () {
      return data.value.length > threshold;
    });
    var updateId = VueCompositionAPI.ref(0);
    var trs = /* @__PURE__ */new Map();
    var visibleCount = 0;
    var beforeScrollTop = 0;
    var index = 0;
    var offset = 0;
    var start = 0;
    var last = 0;
    var reset = function reset() {
      data.value.forEach(function (item, i) {
        item.$index = i;
        if (fixedHeight) {
          state.cachedScrollY[i] = i * lineHeight;
        }
      });
      if (!fixedHeight) {
        state.cachedScrollY[data.value.length - 1] = void 0;
      }
    };
    reset();
    var scrollHeight = VueCompositionAPI.computed(function () {
      var cachedHeight = state.cachedHeight;
      var length = cachedHeight.length;
      if (length) {
        var maxScrollY = cachedHeight.reduce(function (sum, v) {
          return sum + v || lineHeight;
        }, 0);
        if (cachedHeight.length === data.value.length) {
          return maxScrollY;
        }
        var average = maxScrollY / cachedHeight.length;
        return maxScrollY + (data.value.length - cachedHeight.length) * average;
      }
      return isVirtual.value ? data.value.length * lineHeight : 0;
    });
    var translateY = VueCompositionAPI.computed(function () {
      var visibleData = state.visibleData;
      var firstRow = visibleData[0];
      if (firstRow) {
        return visibleData.length === 1 ? 0 : state.cachedScrollY[firstRow.$index];
      }
      return 0;
    });
    var updateVisibleData = function updateVisibleData() {
      last = Math.min(start + visibleCount + bufferSize * 2, data.value.length);
      state.visibleData = data.value.slice(start, last);
    };
    var calculateScrollY = function calculateScrollY() {
      var _anchorDom$getBoundin;
      var anchorDom = trs.get(index);
      if (!anchorDom) {
        return;
      }
      var anchorDomHeight = anchorDom === null || anchorDom === void 0 || (_anchorDom$getBoundin = anchorDom.getBoundingClientRect()) === null || _anchorDom$getBoundin === void 0 ? void 0 : _anchorDom$getBoundin.height;
      state.cachedScrollY[index] = container.value.scrollTop - offset;
      state.cachedHeight[index] = anchorDomHeight;
      for (var i = index + 1; i <= state.visibleData[state.visibleData.length - 1].$index; i++) {
        var tr = trs.get(i);
        var _ref2 = (tr === null || tr === void 0 ? void 0 : tr.getBoundingClientRect()) || {},
          height = _ref2.height;
        state.cachedHeight[i] = height;
        var scrollY = state.cachedScrollY[i - 1] + state.cachedHeight[i - 1];
        state.cachedScrollY.splice(i, 1, scrollY);
      }
      for (var _i = index - 1; _i >= state.visibleData[0].$index; _i--) {
        var _tr = trs.get(_i);
        var _ref3 = (_tr === null || _tr === void 0 ? void 0 : _tr.getBoundingClientRect()) || {},
          _height = _ref3.height;
        state.cachedHeight[_i] = _height;
        var _scrollY = state.cachedScrollY[_i + 1] - state.cachedHeight[_i];
        state.cachedScrollY.splice(_i, 1, _scrollY);
      }
      if (state.cachedScrollY[0] > 0) {
        var distance = state.cachedScrollY[0];
        var length = Math.min(last, data.value.length);
        for (var _i2 = 0; _i2 < length; _i2++) {
          state.cachedScrollY.splice(_i2, 1, state.cachedScrollY[_i2] - distance);
        }
        var scrollTop = state.cachedScrollY[index - 1] ? state.cachedScrollY[index - 1] + offset : offset;
        container.value.scrollTop = scrollTop;
        beforeScrollTop = scrollTop;
      }
      if (state.cachedScrollY[start] < 0) {
        var s = state.cachedHeight.slice(0, Math.max(0, index)).reduce(function (sum, v) {
          return sum + v;
        }, 0) + offset;
        container.value.scrollTop = s;
        beforeScrollTop = s;
        if (s === 0) {
          index = 0;
          offset = 0;
        }
      }
      VueCompositionAPI.nextTick(function () {
        var _container$value = container.value,
          scrollTop = _container$value.scrollTop,
          scrollHeight2 = _container$value.scrollHeight,
          clientHeight = _container$value.clientHeight;
        if (scrollTop + clientHeight === scrollHeight2) {
          for (var _i3 = last - 1; _i3 >= start; _i3--) {
            if (_i3 === last - 1) {
              state.cachedScrollY.splice(_i3, 1, scrollHeight2.value - state.cachedHeight[_i3]);
            } else {
              state.cachedScrollY.splice(_i3, 1, state.cachedScrollY[_i3 + 1] - state.cachedHeight[_i3]);
            }
          }
        }
      });
    };
    var handleScroll = function handleScroll() {
      if (!isVirtual.value) return;
      if (!container.value) return;
      var scrollTop = container.value.scrollTop;
      var distance = scrollTop - beforeScrollTop;
      beforeScrollTop = scrollTop;
      distance += offset;
      var lastIndex = index;
      if (!distance) return;
      if (distance >= 0) {
        while (lastIndex < data.value.length && distance > (state.cachedHeight[lastIndex] || lineHeight)) {
          if (!state.cachedHeight[lastIndex]) {
            state.cachedHeight[lastIndex] = lineHeight;
          }
          distance -= state.cachedHeight[lastIndex];
          lastIndex++;
        }
        if (lastIndex >= data.value.length) {
          index = data.value.length - 1;
          offset = 0;
        } else {
          index = lastIndex;
          offset = distance;
        }
        var _container$value2 = container.value,
          clientHeight = _container$value2.clientHeight,
          scrollHeight2 = _container$value2.scrollHeight;
        if (scrollTop + clientHeight === scrollHeight2) {
          index = data.value.length - visibleCount + 1;
        }
        if (start <= index - bufferSize) {
          start = Math.min(data.value.length - visibleCount, index - bufferSize);
          if (start < 0) {
            start = 0;
          }
        }
      } else {
        while (distance < 0) {
          lastIndex--;
          if (!state.cachedHeight[lastIndex]) {
            state.cachedHeight[lastIndex] = lineHeight;
          }
          distance += state.cachedHeight[lastIndex];
        }
        if (lastIndex < 0) {
          index = 0;
          offset = 0;
        } else {
          index = lastIndex;
          offset = distance;
        }
        calculateScrollY();
        if (start > index - bufferSize) {
          start = Math.max(0, index - bufferSize);
        }
      }
      updateVisibleData();
    };
    !fixedHeight && VueCompositionAPI.watch(updateId, calculateScrollY, {
      flush: "post"
    });
    var handleRowMounted = function handleRowMounted() {
      if (!isVirtual.value) return;
      updateId.value++;
    };
    VueCompositionAPI.watch(data, function () {
      reset();
      state.visibleData = [];
      state.cachedScrollY = [];
      state.cachedHeight = [];
      beforeScrollTop = 0;
      index = 0;
      offset = 0;
      start = 0;
      trs.clear();
      if (data.value.length <= threshold) {
        state.visibleData = data.value;
      } else {
        updateVisibleData();
      }
      container.value && (container.value.scrollTop = 0);
    });
    var mounted = false;
    var refreshContainer = function refreshContainer() {
      if (mounted) {
        visibleCount = Math.ceil(container.value.offsetHeight / lineHeight);
        updateVisibleData();
      }
    };
    VueCompositionAPI.onMounted(function () {
      if (!window || !window.IntersectionObserver) {
        return;
      }
      var ob = new window.IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (entry.isIntersecting || entry.intersectionRatio) {
          mounted = true;
          isVirtual.value && refreshContainer();
          ob.unobserve(container.value);
        }
      });
      container.value && ob.observe(container.value);
    });
    return _objectSpread$2b(_objectSpread$2b({
      trs: trs,
      scrollHeight: scrollHeight
    }, VueCompositionAPI.toRefs(state)), {}, {
      translateY: translateY,
      handleScroll: handleScroll,
      handleRowMounted: handleRowMounted,
      refreshContainer: refreshContainer,
      fixedHeight: fixedHeight,
      calculateScrollY: calculateScrollY
    });
  };

  function ownKeys$2b(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2a(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2b(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2b(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var sizeClassMap = {
    small: "s",
    medium: "m",
    large: "l"
  };
  var SelectPanel = VueCompositionAPI.defineComponent({
    name: "TSelectPanel",
    components: {
      TOption: _Option,
      TOptionGroup: _OptionGroup
    },
    props: ["inputValue", "panelTopContent", "panelBottomContent", "size", "options", "empty", "filter", "loading", "loadingText", "multiple", "scroll", "creatable", "filterable"],
    setup: function setup(props) {
      var _props$scroll5;
      var _toRefs = VueCompositionAPI.toRefs(props),
        options = _toRefs.options,
        inputValue = _toRefs.inputValue;
      var renderTNode = useTNodeJSX();
      var _useConfig = useConfig("select"),
        t = _useConfig.t,
        global = _useConfig.global;
      var selectProvider = VueCompositionAPI.inject("tSelect");
      var COMPONENT_NAME = usePrefixClass$1("select");
      var panelContentRef = VueCompositionAPI.computed(function () {
        return selectProvider.getOverlayElm();
      });
      var _ref = props.scroll || {},
        type = _ref.type,
        _ref$rowHeight = _ref.rowHeight,
        rowHeight = _ref$rowHeight === void 0 ? 28 : _ref$rowHeight,
        _ref$bufferSize = _ref.bufferSize,
        bufferSize = _ref$bufferSize === void 0 ? 20 : _ref$bufferSize,
        _ref$isFixedRowHeight = _ref.isFixedRowHeight,
        isFixedRowHeight = _ref$isFixedRowHeight === void 0 ? false : _ref$isFixedRowHeight,
        _ref$threshold = _ref.threshold,
        threshold = _ref$threshold === void 0 ? 100 : _ref$threshold;
      var displayOptions = VueCompositionAPI.computed(function () {
        if (!inputValue.value || !(props.filterable || isFunction(props.filter)) || selectProvider.isRemoteSearch) return options.value;
        var filterMethods = function filterMethods(option) {
          var _option$label, _option$label$toLower;
          if (isFunction(props.filter)) {
            return props.filter("".concat(props.inputValue), option);
          }
          if ((option === null || option === void 0 ? void 0 : option.checkAll) === true) return true;
          return ((_option$label = option.label) === null || _option$label === void 0 || (_option$label$toLower = _option$label.toLowerCase) === null || _option$label$toLower === void 0 ? void 0 : _option$label$toLower.call(_option$label).indexOf("".concat(props.inputValue).toLowerCase())) > -1;
        };
        var res = [];
        var groupIndex = isCreateOptionShown.value ? 1 : 0;
        props.options.forEach(function (option) {
          if (option.group && option.children) {
            res.push(_objectSpread$2a(_objectSpread$2a({}, option), {}, {
              children: option.children.filter(filterMethods).reduce(function (pre, cur) {
                pre.push(_objectSpread$2a(_objectSpread$2a({}, cur), {}, {
                  index: groupIndex
                }));
                groupIndex += 1;
                return pre;
              }, [])
            }));
          } else if (filterMethods(option)) {
            res.push(_objectSpread$2a(_objectSpread$2a({}, option), {}, {
              index: groupIndex + res.length
            }));
          }
        });
        return res;
      });
      var getDisplayOptions = function getDisplayOptions() {
        var arr = [];
        if (isCreateOptionShown.value) {
          arr.push({
            label: String(inputValue.value),
            value: String(inputValue.value),
            isCreated: true
          });
        }
        arr.push.apply(arr, _toConsumableArray(displayOptions.value));
        return arr;
      };
      var isCreateOptionShown = VueCompositionAPI.computed(function () {
        return !!(props.creatable && props.filterable && props.inputValue && _flattenOptions(options.value).find(function (v) {
          return v.label === props.inputValue;
        }) === void 0);
      });
      var isEmpty = VueCompositionAPI.computed(function () {
        return !(displayOptions.value.length > 0);
      });
      var isVirtual = VueCompositionAPI.computed(function () {
        var _props$scroll, _props$options, _props$scroll2;
        return ((_props$scroll = props.scroll) === null || _props$scroll === void 0 ? void 0 : _props$scroll.type) === "virtual" && ((_props$options = props.options) === null || _props$options === void 0 ? void 0 : _props$options.length) > (((_props$scroll2 = props.scroll) === null || _props$scroll2 === void 0 ? void 0 : _props$scroll2.threshold) || 100);
      });
      var _ref2 = type === "virtual" ? useVirtualScroll({
          container: panelContentRef,
          data: displayOptions,
          fixedHeight: isFixedRowHeight,
          lineHeight: rowHeight,
          bufferSize: bufferSize,
          threshold: threshold
        }) : {},
        _ref2$trs = _ref2.trs,
        trs = _ref2$trs === void 0 ? null : _ref2$trs,
        _ref2$visibleData = _ref2.visibleData,
        visibleData = _ref2$visibleData === void 0 ? null : _ref2$visibleData,
        _ref2$handleScroll = _ref2.handleScroll,
        handleVirtualScroll = _ref2$handleScroll === void 0 ? null : _ref2$handleScroll,
        _ref2$scrollHeight = _ref2.scrollHeight,
        scrollHeight = _ref2$scrollHeight === void 0 ? null : _ref2$scrollHeight,
        _ref2$translateY = _ref2.translateY,
        translateY = _ref2$translateY === void 0 ? null : _ref2$translateY,
        _ref2$handleRowMounte = _ref2.handleRowMounted,
        handleRowMounted = _ref2$handleRowMounte === void 0 ? null : _ref2$handleRowMounte;
      var lastScrollY = -1;
      var onInnerVirtualScroll = function onInnerVirtualScroll(e) {
        if (!isVirtual.value) {
          return;
        }
        var target = e.target || e.srcElement;
        var top = target.scrollTop;
        if (Math.abs(lastScrollY - top) > 5) {
          handleVirtualScroll();
          lastScrollY = top;
        } else {
          lastScrollY = -1;
        }
      };
      VueCompositionAPI.onMounted(function () {
        var _props$scroll3;
        if (((_props$scroll3 = props.scroll) === null || _props$scroll3 === void 0 ? void 0 : _props$scroll3.type) === "virtual") {
          var _selectProvider$getOv;
          (_selectProvider$getOv = selectProvider.getOverlayElm()) === null || _selectProvider$getOv === void 0 || _selectProvider$getOv.addEventListener("scroll", onInnerVirtualScroll);
        }
      });
      VueCompositionAPI.onBeforeUnmount(function () {
        var _props$scroll4;
        if (((_props$scroll4 = props.scroll) === null || _props$scroll4 === void 0 ? void 0 : _props$scroll4.type) === "virtual") {
          var _selectProvider$getOv2;
          (_selectProvider$getOv2 = selectProvider.getOverlayElm()) === null || _selectProvider$getOv2 === void 0 || _selectProvider$getOv2.removeEventListener("scroll", onInnerVirtualScroll);
        }
      });
      return {
        t: t,
        global: global,
        isEmpty: isEmpty,
        renderTNode: renderTNode,
        selectProvider: selectProvider,
        isCreateOptionShown: isCreateOptionShown,
        trs: trs,
        isVirtual: isVirtual,
        onInnerVirtualScroll: onInnerVirtualScroll,
        visibleData: visibleData,
        scrollHeight: scrollHeight,
        translateY: translateY,
        scrollType: (_props$scroll5 = props.scroll) === null || _props$scroll5 === void 0 ? void 0 : _props$scroll5.type,
        handleRowMounted: handleRowMounted,
        bufferSize: bufferSize,
        threshold: threshold,
        displayOptions: displayOptions,
        getDisplayOptions: getDisplayOptions,
        componentName: COMPONENT_NAME
      };
    },
    methods: {
      renderEmptyContent: function renderEmptyContent() {
        var h = this.$createElement;
        if (this.empty && typeof this.empty === "string") {
          return h("div", {
            "class": "".concat(this.componentName, "__empty")
          }, [this.empty]);
        }
        return renderTNodeJSXDefault(this, "empty", h("div", {
          "class": "".concat(this.componentName, "__empty")
        }, [this.t(this.global.empty)]));
      },
      renderLoadingContent: function renderLoadingContent() {
        var h = this.$createElement;
        if (this.loadingText && typeof this.loadingText === "string") {
          return h("div", {
            "class": "".concat(this.componentName, "__loading-tips")
          }, [this.loadingText]);
        }
        return renderTNodeJSXDefault(this, "loadingText", h("div", {
          "class": "".concat(this.componentName, "__loading-tips")
        }, [this.t(this.global.loadingText)]));
      },
      renderCreateOption: function renderCreateOption() {
        var h = this.$createElement;
        var on = this.isVirtual ? {
          onRowMounted: this.handleRowMounted
        } : {};
        return h("ul", {
          "class": ["".concat(this.componentName, "__create-option"), "".concat(this.componentName, "__list")]
        }, [h("t-option", helper([{
          "attrs": {
            "multiple": this.multiple,
            "index": 0,
            "isCreatedOption": true,
            "value": this.inputValue,
            "label": this.inputValue,
            "trs": this.trs,
            "scrollType": this.scrollType,
            "isVirtual": this.isVirtual,
            "bufferSize": this.bufferSize
          },
          "class": "".concat(this.componentName, "__create-option--special")
        }, {
          "on": on
        }]))]);
      },
      renderOptionsContent: function renderOptionsContent(options) {
        var _this = this;
        var h = this.$createElement;
        var on = this.isVirtual ? {
          onRowMounted: this.handleRowMounted
        } : {};
        return h("ul", {
          "class": "".concat(this.componentName, "__list")
        }, [options.map(function (item, index) {
          if (item.children) {
            return h("t-option-group", {
              "attrs": {
                "label": item.group,
                "divider": item.divider
              }
            }, [_this.renderOptionsContent(item.children)]);
          }
          var scrollProps = _this.isVirtual ? {
            rowIndex: item.$index,
            trs: _this.trs,
            scrollType: _this.scrollType,
            isVirtual: _this.isVirtual,
            bufferSize: _this.bufferSize
          } : {
            key: index
          };
          return h("t-option", helper([{
            "class": item["class"],
            "style": item.style,
            "props": _objectSpread$2a({}, _objectSpread$2a(_objectSpread$2a({}, item), scrollProps)),
            "attrs": {
              "multiple": _this.multiple
            },
            "scopedSlots": {
              "default": item.slots
            },
            "key": "".concat(item.$index || "", "_").concat(index)
          }, {
            "on": on
          }]));
        })]);
      },
      renderPanelContent: function renderPanelContent() {
        var innerStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var h = this.$createElement;
        var loading = this.loading;
        return h("div", {
          "class": ["".concat(this.componentName, "__dropdown-inner"), "".concat(this.componentName, "__dropdown-inner--size-").concat(sizeClassMap[this.size])],
          "style": innerStyle
        }, [this.renderTNode("panelTopContent"), this.isCreateOptionShown && this.renderCreateOption(), loading && this.renderLoadingContent(), !loading && this.isEmpty && !this.isCreateOptionShown && this.renderEmptyContent(), !loading && !this.isEmpty && this.renderOptionsContent(this.isVirtual && this.visibleData ? this.visibleData : this.displayOptions), this.renderTNode("panelBottomContent")]);
      }
    },
    render: function render() {
      var h = arguments[0];
      if (this.isVirtual) {
        var cursorTranslate = "translate(0, ".concat(this.scrollHeight, "px)");
        var cursorTranslateStyle = {
          position: "absolute",
          width: "1px",
          height: "1px",
          transition: "transform 0.2s",
          transform: cursorTranslate,
          "-ms-transform": cursorTranslate,
          "-moz-transform": cursorTranslate,
          "-webkit-transform": cursorTranslate
        };
        var translate = "translate(0, ".concat(this.translateY, "px)");
        var virtualStyle = {
          transform: translate,
          "-ms-transform": translate,
          "-moz-transform": translate,
          "-webkit-transform": translate
        };
        return h("div", [h("div", {
          "style": _objectSpread$2a({}, cursorTranslateStyle)
        }), this.renderPanelContent(virtualStyle)]);
      }
      return this.renderPanelContent();
    }
  });

  function ownKeys$2a(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$29(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2a(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2a(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function useSelectOptions(props, instance, keys) {
    var options = VueCompositionAPI.ref([]);
    var optionsCache = VueCompositionAPI.ref([]);
    var innerSlotRecord = null;
    var getOptions = function getOptions() {
      var _props$options;
      var dynamicIndex = 0;
      var innerOptions = ((_props$options = props.options) === null || _props$options === void 0 ? void 0 : _props$options.map(function (option) {
        var getFormatOption = function getFormatOption(option2) {
          var _keys$value = keys.value,
            value = _keys$value.value,
            label = _keys$value.label,
            disabled = _keys$value.disabled;
          var res = _objectSpread$29(_objectSpread$29({}, option2), {}, {
            index: dynamicIndex,
            label: get(option2, label),
            value: get(option2, value),
            disabled: get(option2, disabled)
          });
          dynamicIndex += 1;
          return res;
        };
        if (option.children) {
          return _objectSpread$29(_objectSpread$29({}, option), {}, {
            children: option.children.map(function (child) {
              return getFormatOption(child);
            })
          });
        }
        return getFormatOption(option);
      })) || [];
      if (props.options === void 0) {
        innerSlotRecord = instance.proxy.$slots["default"];
        var currentSlots = instance.proxy.$slots["default"] || [];
        currentSlots.forEach(function (child) {
          if (!child.componentOptions) {
            return;
          }
          var componentName = getVNodeComponentName(child);
          if (componentName && componentName === getVueComponentName(_Option)) {
            innerOptions.push(_objectSpread$29(_objectSpread$29({
              "class": child.data.staticClass,
              style: child.data.staticStyle
            }, child.componentOptions.propsData), {}, {
              slots: function slots() {
                return child.componentOptions.children;
              },
              index: dynamicIndex
            }));
            dynamicIndex += 1;
          } else if (componentName && componentName === getVueComponentName(_OptionGroup)) {
            var _child$componentOptio, _child$componentOptio2, _child$componentOptio3;
            var groupOption = _objectSpread$29(_objectSpread$29({
              group: (_child$componentOptio = child.componentOptions.propsData) === null || _child$componentOptio === void 0 ? void 0 : _child$componentOptio.label
            }, child.componentOptions.propsData), {}, {
              children: []
            });
            (_child$componentOptio2 = child.componentOptions.children) === null || _child$componentOptio2 === void 0 || (_child$componentOptio3 = _child$componentOptio2.forEach) === null || _child$componentOptio3 === void 0 || _child$componentOptio3.call(_child$componentOptio2, function (groupChild) {
              groupOption.children.push(_objectSpread$29(_objectSpread$29({
                "class": groupChild.data.staticClass,
                style: groupChild.data.staticStyle
              }, groupChild.componentOptions.propsData), {}, {
                slots: function slots() {
                  return groupChild.componentOptions.children;
                },
                index: dynamicIndex
              }));
              dynamicIndex += 1;
            });
            innerOptions.push(groupOption);
          }
        });
      }
      options.value = innerOptions;
    };
    var optionsMap = VueCompositionAPI.computed(function () {
      var res = /* @__PURE__ */new Map();
      optionsCache.value.concat(optionsList.value).forEach(function (option) {
        res.set(option.value, option);
      });
      return res;
    });
    var optionsList = VueCompositionAPI.computed(function () {
      var res = [];
      var _getOptionsList = function getOptionsList(options2) {
        options2.forEach(function (option) {
          if (option.children) {
            _getOptionsList(option.children);
          } else {
            res.push(option);
          }
        });
      };
      _getOptionsList(options.value);
      return res;
    });
    getOptions();
    VueCompositionAPI.watch(function () {
      return props.options;
    }, function () {
      getOptions();
    });
    VueCompositionAPI.onBeforeUpdate(function () {
      if (props.options === void 0 && innerSlotRecord !== instance.proxy.$slots["default"]) {
        getOptions();
      }
    });
    return {
      options: options,
      optionsMap: optionsMap,
      optionsList: optionsList,
      optionsCache: optionsCache
    };
  }

  var _excluded$3 = ["overlayClassName"];
  function ownKeys$29(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$28(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$29(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$29(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _Select = VueCompositionAPI.defineComponent({
    name: "TSelect",
    props: _objectSpread$28({}, props$_),
    components: {
      TInput: Input,
      TLoading: Loading,
      Tag: Tag,
      Popup: Popup,
      TOption: _Option,
      FakeArrow: FakeArrow,
      SelectPanel: SelectPanel
    },
    setup: function setup(props2, ctx) {
      var _ctx$listeners;
      var _useConfig = useConfig("select"),
        t = _useConfig.t,
        global = _useConfig.global;
      var renderTNode = useTNodeJSX();
      var instance = VueCompositionAPI.getCurrentInstance();
      var selectInputRef = VueCompositionAPI.ref(null);
      var selectPanelRef = VueCompositionAPI.ref();
      var popupOpenTime = VueCompositionAPI.ref(250);
      var _useFormDisabled = useFormDisabled(),
        formDisabled = _useFormDisabled.formDisabled;
      var COMPONENT_NAME = usePrefixClass$1("select");
      var _useConfig2 = useConfig("classPrefix"),
        classPrefix = _useConfig2.classPrefix;
      var _toRefs = VueCompositionAPI.toRefs(props2),
        valueType = _toRefs.valueType,
        disabled = _toRefs.disabled,
        size = _toRefs.size,
        valueProps = _toRefs.value,
        multiple = _toRefs.multiple,
        placeholder = _toRefs.placeholder,
        loading = _toRefs.loading,
        max = _toRefs.max,
        reserveKeyword = _toRefs.reserveKeyword,
        inputValue = _toRefs.inputValue,
        popupVisible = _toRefs.popupVisible,
        minCollapsedNum = _toRefs.minCollapsedNum,
        creatable = _toRefs.creatable;
      var keys = VueCompositionAPI.computed(function () {
        var _props2$keys, _props2$keys2, _props2$keys3;
        return {
          label: ((_props2$keys = props2.keys) === null || _props2$keys === void 0 ? void 0 : _props2$keys.label) || "label",
          value: ((_props2$keys2 = props2.keys) === null || _props2$keys2 === void 0 ? void 0 : _props2$keys2.value) || "value",
          disabled: ((_props2$keys3 = props2.keys) === null || _props2$keys3 === void 0 ? void 0 : _props2$keys3.disabled) || "disabled"
        };
      });
      var _useSelectOptions = useSelectOptions(props2, instance, keys),
        innerOptions = _useSelectOptions.options,
        optionsMap = _useSelectOptions.optionsMap,
        optionsList = _useSelectOptions.optionsList,
        optionsCache = _useSelectOptions.optionsCache;
      var _useVModel = useVModel$1(valueProps, props2.defaultValue, props2.onChange, "change"),
        _useVModel2 = _slicedToArray(_useVModel, 2),
        value = _useVModel2[0],
        setValue = _useVModel2[1];
      var innerValue = VueCompositionAPI.computed(function () {
        var isObjValue = valueType.value === "object";
        var _value = value.value;
        if (!multiple.value && isArray$1(_value)) {
          log.warn("Select", 'Invalid value for "value" props: got an Array when multiple was set to false');
          _value = isObjValue ? {} : "";
        }
        if (multiple.value && !isArray$1(_value)) {
          log.warn("Select", 'Invalid value for "value" props: expected an Array when multiple was set to true');
          _value = [];
        }
        if (isObjValue) {
          if (multiple.value) {
            return _value.filter(function (option) {
              var isObj2 = isObject(option);
              if (!isObj2) {
                log.warn("Select", "Invalid value for \"value\" props: expected an Object, but got ".concat(_typeof$2(option)));
              }
              return isObj2;
            }).map(function (option) {
              return option[keys.value.value];
            });
          }
          var isObj = isObject(_value);
          if (!isObj) {
            log.warn("Select", "Invalid value for \"value\" props: expected an Object, but got ".concat(_typeof$2(_value)));
            return "";
          }
          return _value[keys.value.value];
        }
        return _value;
      });
      var setInnerValue = function setInnerValue(newVal, context, optionValue) {
        if (newVal === value.value) return;
        var selectedOptions = [];
        var _keys$value = keys.value,
          valueOfKeys = _keys$value.value,
          labelOfKeys = _keys$value.label;
        var oldValueMap = /* @__PURE__ */new Map();
        if (multiple.value) {
          var _mapValue$forEach;
          var mapValue = value.value || [];
          (_mapValue$forEach = mapValue.forEach) === null || _mapValue$forEach === void 0 || _mapValue$forEach.call(mapValue, function (option) {
            oldValueMap.set(option[valueOfKeys], option);
          });
        }
        var getOriginOptions = function getOriginOptions(val) {
          var option = optionsMap.value.get(val);
          if (option) delete option.index;
          return option;
        };
        var getFormatOption = function getFormatOption(val) {
          var option = optionsMap.value.get(val) || oldValueMap.get(val);
          if (option) delete option.index;
          return _defineProperty$2(_defineProperty$2({}, valueOfKeys, get(option, valueOfKeys)), labelOfKeys, get(option, labelOfKeys));
        };
        var addCache = function addCache(val) {
          if (multiple.value) {
            var newCache = [];
            val.forEach(function (item) {
              var option = optionsMap.value.get(item);
              if (option) {
                newCache.push(option);
              }
            });
            optionsCache.value = Array.from(/* @__PURE__ */new Set([].concat(newCache, _toConsumableArray(optionsCache.value))));
          } else {
            var option = optionsMap.value.get(val);
            if (option) {
              optionsCache.value = Array.from(/* @__PURE__ */new Set([option].concat(_toConsumableArray(optionsCache.value))));
            }
          }
        };
        var getSelectedOption = function getSelectedOption(newVal2) {
          var selectedOption = getOriginOptions(newVal2);
          if (!selectedOption && optionValue) {
            selectedOption = {
              label: optionValue,
              value: optionValue
            };
          }
          return selectedOption;
        };
        if (multiple.value) {
          newVal.forEach(function (v) {
            return selectedOptions.push(getSelectedOption(v));
          });
        } else {
          selectedOptions.push(getSelectedOption(newVal));
        }
        if (valueType.value === "object") {
          newVal = multiple.value ? newVal.map(function (val) {
            return getFormatOption(val);
          }) : getFormatOption(newVal);
        }
        var outputContext = _objectSpread$28(_objectSpread$28({}, context), {}, {
          selectedOptions: selectedOptions
        });
        if (optionValue) {
          var outputContextOption = getSelectedOption(optionValue);
          outputContext["option"] = outputContextOption;
        }
        VueCompositionAPI.nextTick(function () {
          addCache(newVal);
        });
        setValue(newVal, outputContext);
      };
      var _useDefaultValue = useDefaultValue(inputValue, props2.defaultInputValue || "", props2.onInputChange, "inputValue", "input-change"),
        _useDefaultValue2 = _slicedToArray(_useDefaultValue, 2),
        tInputValue = _useDefaultValue2[0],
        setTInputValue = _useDefaultValue2[1];
      var _useDefaultValue3 = useDefaultValue(popupVisible, props2.defaultPopupVisible, function (visible, context) {
          var _props2$onPopupVisibl;
          (_props2$onPopupVisibl = props2.onPopupVisibleChange) === null || _props2$onPopupVisibl === void 0 || _props2$onPopupVisibl.call(props2, visible, context);
          instance.emit("visible-change", visible);
        }, "popupVisible", "popup-visible-change"),
        _useDefaultValue4 = _slicedToArray(_useDefaultValue3, 2),
        innerPopupVisible = _useDefaultValue4[0],
        setInnerPopupVisible = _useDefaultValue4[1];
      var isDisabled = VueCompositionAPI.computed(function () {
        return formDisabled.value || disabled.value;
      });
      var isLoading = VueCompositionAPI.computed(function () {
        return loading.value && !isDisabled.value;
      });
      var isFilterable = VueCompositionAPI.computed(function () {
        return Boolean(props2.filterable || global.value.filterable || isFunction(props2.filter));
      });
      var isReachMaxLimit = VueCompositionAPI.computed(function () {
        return multiple.value && max.value !== 0 && max.value <= innerValue.value.length;
      });
      var getFilteredOptions = function getFilteredOptions() {
        return getAllSelectableOption(optionsList.value).filter(function (option) {
          var _option$label;
          if (isFunction(props2.filter)) {
            return props2.filter("".concat(tInputValue.value), option);
          }
          return (_option$label = option.label) === null || _option$label === void 0 || (_option$label = _option$label.toLowerCase()) === null || _option$label === void 0 ? void 0 : _option$label.includes("".concat(tInputValue.value).toLowerCase());
        });
      };
      var isAllOptionsChecked = VueCompositionAPI.computed(function () {
        var filteredOptions = getFilteredOptions();
        return filteredOptions.length === innerValue.value.length;
      });
      var placeholderText = VueCompositionAPI.computed(function () {
        var _ref2, _value$value;
        return (_ref2 = !multiple.value && innerPopupVisible.value && (valueType.value === "object" && (((_value$value = value.value) === null || _value$value === void 0 ? void 0 : _value$value[keys.value.label]) || innerValue.value) || getSingleContent$1(innerValue.value, optionsMap.value)) || placeholder.value) !== null && _ref2 !== void 0 ? _ref2 : t(global.value.placeholder);
      });
      var displayText = VueCompositionAPI.computed(function () {
        if (multiple.value) {
          if (valueType.value === "object") {
            return value.value.map(function (v) {
              return v[keys.value.label];
            });
          }
          return getMultipleContent$1(innerValue.value, optionsMap.value);
        }
        if (valueType.value === "object") {
          var _value$value2;
          return ((_value$value2 = value.value) === null || _value$value2 === void 0 ? void 0 : _value$value2[keys.value.label]) || innerValue.value;
        }
        return getSingleContent$1(innerValue.value, optionsMap.value);
      });
      var valueDisplayParams = VueCompositionAPI.computed(function () {
        var val = multiple.value ? innerValue.value.map(function (value2) {
          var _optionsMap$value$get;
          return {
            value: value2,
            label: (_optionsMap$value$get = optionsMap.value.get(value2)) === null || _optionsMap$value$get === void 0 ? void 0 : _optionsMap$value$get.label
          };
        }) : innerValue.value;
        var params = {
          value: val,
          onClose: multiple.value ? function (index) {
            return removeTag(index);
          } : function () {}
        };
        if (minCollapsedNum.value && multiple.value) {
          var _val$slice;
          return _objectSpread$28(_objectSpread$28({}, params), {}, {
            displayValue: val === null || val === void 0 || (_val$slice = val.slice) === null || _val$slice === void 0 ? void 0 : _val$slice.call(val, 0, minCollapsedNum.value)
          });
        }
        return params;
      });
      var collapsedItemsParams = VueCompositionAPI.computed(function () {
        var tValue = innerValue.value || [];
        var values = Array.isArray(tValue) ? tValue : [tValue];
        return multiple.value ? {
          value: values,
          collapsedSelectedItems: values.map(function (item) {
            var _props2$keys4, _props2$options;
            var tmpValue = _typeof$2(item) === "object" ? item[((_props2$keys4 = props2.keys) === null || _props2$keys4 === void 0 ? void 0 : _props2$keys4.value) || "value"] : item;
            return (_props2$options = props2.options) === null || _props2$options === void 0 ? void 0 : _props2$options.find(function (t2) {
              return t2.value === tmpValue;
            });
          }).slice(minCollapsedNum.value),
          count: values.length - minCollapsedNum.value,
          onClose: function onClose(index) {
            return removeTag(index);
          }
        } : {};
      });
      var removeTag = function removeTag(index, context) {
        var _props2$onRemove;
        var _ref3 = context || {},
          e = _ref3.e;
        e === null || e === void 0 || e.stopPropagation();
        if (isDisabled.value) {
          return;
        }
        var selectValue = cloneDeep(innerValue.value);
        var value2 = selectValue[index];
        selectValue.splice(index, 1);
        setInnerValue(selectValue, {
          e: e,
          trigger: "tag-remove"
        });
        var evtObj = {
          value: value2,
          data: optionsMap.value.get(value2),
          e: e
        };
        instance.emit("remove", evtObj);
        (_props2$onRemove = props2.onRemove) === null || _props2$onRemove === void 0 || _props2$onRemove.call(props2, evtObj);
      };
      var handleCheckAllClick = function handleCheckAllClick(e) {
        var filteredOptions = getFilteredOptions();
        setInnerValue(isAllOptionsChecked.value ? [] : filteredOptions.map(function (option) {
          return option.value;
        }).slice(0, max.value || Infinity), {
          e: e,
          trigger: isAllOptionsChecked.value ? "uncheck" : "check"
        });
        !(reserveKeyword !== null && reserveKeyword !== void 0 && reserveKeyword.value) && setTInputValue("", {
          e: e,
          trigger: "change"
        });
      };
      var handleCreate = function handleCreate(e) {
        var _props2$onCreate;
        if (!tInputValue.value) return;
        var createVal = tInputValue.value;
        multiple.value && setTInputValue("", {
          e: e,
          trigger: "change"
        });
        instance.emit("create", createVal);
        (_props2$onCreate = props2.onCreate) === null || _props2$onCreate === void 0 || _props2$onCreate.call(props2, createVal);
      };
      var handleClear = function handleClear(_ref4) {
        var _props2$onClear;
        var e = _ref4.e;
        e === null || e === void 0 || e.stopPropagation();
        if (multiple.value) {
          setInnerValue([], {
            trigger: "clear",
            e: e
          });
        } else {
          setInnerValue("", {
            trigger: "clear",
            e: e
          });
        }
        instance.emit("clear", {
          e: e
        });
        (_props2$onClear = props2.onClear) === null || _props2$onClear === void 0 || _props2$onClear.call(props2, {
          e: e
        });
      };
      var handleTInputValueChange = function handleTInputValueChange(val, context) {
        if (context.trigger === "blur" || !innerPopupVisible.value) return;
        setTInputValue(val, context);
        debounceSearch({
          e: context.e
        });
      };
      var handleTagChange = function handleTagChange(currentTags, context) {
        var trigger = context.trigger,
          index = context.index;
        if (["tag-remove", "backspace"].includes(trigger)) {
          removeTag(index);
        }
      };
      var handleFocus = function handleFocus(value2, context) {
        var _props2$onFocus;
        instance.emit("focus", {
          value: value2,
          e: context === null || context === void 0 ? void 0 : context.e
        });
        (_props2$onFocus = props2.onFocus) === null || _props2$onFocus === void 0 || _props2$onFocus.call(props2, {
          value: value2,
          e: context === null || context === void 0 ? void 0 : context.e
        });
      };
      var handleBlur = function handleBlur(value2, context) {
        var _props2$onBlur;
        instance.emit("blur", {
          value: value2,
          e: context === null || context === void 0 ? void 0 : context.e
        });
        (_props2$onBlur = props2.onBlur) === null || _props2$onBlur === void 0 || _props2$onBlur.call(props2, {
          value: value2,
          e: context === null || context === void 0 ? void 0 : context.e
        });
      };
      var handleEnter = function handleEnter(value2, context) {
        var _props2$onEnter;
        instance.emit("enter", {
          value: value2,
          e: context === null || context === void 0 ? void 0 : context.e,
          inputValue: tInputValue.value
        });
        (_props2$onEnter = props2.onEnter) === null || _props2$onEnter === void 0 || _props2$onEnter.call(props2, {
          value: value2,
          e: context === null || context === void 0 ? void 0 : context.e,
          inputValue: tInputValue.value.toString()
        });
      };
      var debounceSearch = debounce$1(function (context) {
        var _props2$onSearch;
        instance.emit("search", tInputValue.value);
        (_props2$onSearch = props2.onSearch) === null || _props2$onSearch === void 0 || _props2$onSearch.call(props2, tInputValue.value.toString(), {
          e: context.e
        });
      }, 300);
      var getOverlayElm = function getOverlayElm() {
        var r;
        try {
          var popupRefs = selectInputRef.value.$refs.selectInputPopupRef.$refs;
          r = popupRefs.overlay || popupRefs.component.$refs.overlay;
        } catch (e) {
          log.warn("Select", e);
        }
        return r;
      };
      var updateScrollTop = function updateScrollTop(content) {
        var _props2$scroll;
        if (((_props2$scroll = props2.scroll) === null || _props2$scroll === void 0 ? void 0 : _props2$scroll.type) === "virtual") return;
        var overlayEl = getOverlayElm();
        if (!overlayEl) return;
        var firstSelectedNode = overlayEl === null || overlayEl === void 0 ? void 0 : overlayEl.querySelector(".".concat(classPrefix.value, "-is-selected"));
        VueCompositionAPI.nextTick(function () {
          if (firstSelectedNode && content) {
            var _getComputedStyle = getComputedStyle(firstSelectedNode),
              paddingBottom = _getComputedStyle.paddingBottom;
            var _getComputedStyle2 = getComputedStyle(content),
              marginBottom = _getComputedStyle2.marginBottom;
            var elementBottomHeight = parseInt(paddingBottom, 10) + parseInt(marginBottom, 10);
            var updateValue = firstSelectedNode.offsetTop - content.offsetTop - (content.clientHeight - firstSelectedNode.clientHeight) + elementBottomHeight;
            content.scrollTop = updateValue;
          }
        });
      };
      var hoverIndex = VueCompositionAPI.ref(-1);
      var keydownEvent = function keydownEvent(e) {
        var _selectPanelRef$value, _selectInputRef$value, _displayOptions$;
        var displayOptions = _flattenOptions((_selectPanelRef$value = selectPanelRef.value) === null || _selectPanelRef$value === void 0 ? void 0 : _selectPanelRef$value.getDisplayOptions());
        var displayOptionsLength = displayOptions.length;
        var arrowDownOption = function arrowDownOption() {
          var count = 0;
          while (hoverIndex.value < displayOptionsLength) {
            var _displayOptions$hover;
            if (!((_displayOptions$hover = displayOptions[hoverIndex.value]) !== null && _displayOptions$hover !== void 0 && _displayOptions$hover.disabled)) {
              break;
            }
            if (hoverIndex.value === displayOptionsLength - 1) {
              hoverIndex.value = 0;
            } else {
              hoverIndex.value += 1;
            }
            count += 1;
            if (count >= displayOptionsLength) break;
          }
          setHoverIntoView();
        };
        var arrowUpOption = function arrowUpOption() {
          var count = 0;
          while (hoverIndex.value > -1) {
            var _displayOptions$hover2;
            if (!((_displayOptions$hover2 = displayOptions[hoverIndex.value]) !== null && _displayOptions$hover2 !== void 0 && _displayOptions$hover2.disabled)) {
              break;
            }
            if (hoverIndex.value === 0) {
              hoverIndex.value = displayOptionsLength - 1;
            } else {
              hoverIndex.value -= 1;
            }
            count += 1;
            if (count >= displayOptionsLength) break;
          }
          setHoverIntoView();
        };
        var setHoverIntoView = function setHoverIntoView() {
          VueCompositionAPI.nextTick(function () {
            var _selectPanelRef$value2;
            var hoverDom = (_selectPanelRef$value2 = selectPanelRef.value) === null || _selectPanelRef$value2 === void 0 ? void 0 : _selectPanelRef$value2.$el.querySelector("li.".concat(classPrefix.value, "-select-option.").concat(classPrefix.value, "-select-option__hover"));
            if (hoverDom) {
              var container = selectPanelRef.value.$el.parentNode;
              var containerRect = container.getBoundingClientRect();
              var hoverDomRect = hoverDom.getBoundingClientRect();
              var offsetTop = hoverDomRect.top - containerRect.top + container.scrollTop;
              container.scrollTo({
                top: offsetTop - (container.offsetHeight - hoverDom.offsetHeight * 2),
                behavior: "smooth"
              });
            }
          });
        };
        if (displayOptionsLength === 0) return;
        var preventKeys = ["ArrowDown", "ArrowUp", "Enter", "Escape", "Tab"];
        if (preventKeys.includes(e.code) && (_selectInputRef$value = selectInputRef.value) !== null && _selectInputRef$value !== void 0 && _selectInputRef$value.$el.contains(e.target)) {
          e.preventDefault();
        }
        switch (e.code) {
          case "ArrowDown":
            if (hoverIndex.value === -1) {
              hoverIndex.value = 0;
              return;
            }
            if (hoverIndex.value < displayOptionsLength - 1) {
              hoverIndex.value += 1;
              arrowDownOption();
            } else {
              hoverIndex.value = 0;
              arrowDownOption();
            }
            break;
          case "ArrowUp":
            if (hoverIndex.value === -1) {
              hoverIndex.value = 0;
              return;
            }
            if (hoverIndex.value > 0) {
              hoverIndex.value -= 1;
              arrowUpOption();
            } else {
              hoverIndex.value = displayOptionsLength - 1;
              arrowUpOption();
            }
            break;
          case "Enter":
            if (creatable.value && hoverIndex.value < 1 && displayOptions !== null && displayOptions !== void 0 && (_displayOptions$ = displayOptions[0]) !== null && _displayOptions$ !== void 0 && _displayOptions$.isCreated) {
              handleCreate(e);
            } else if (hoverIndex.value === -1) {
              return;
            }
            if (multiple.value && displayOptions[hoverIndex.value].checkAll) {
              handleCheckAllClick(e);
            } else {
              var _displayOptions$hover3;
              var optionValue = (_displayOptions$hover3 = displayOptions[hoverIndex.value]) === null || _displayOptions$hover3 === void 0 ? void 0 : _displayOptions$hover3.value;
              if (!optionValue) return;
              if (!multiple.value) {
                setInnerValue(optionValue, {
                  e: e,
                  trigger: "check"
                }, optionValue);
                setInnerPopupVisible(false, {
                  e: e
                });
              } else {
                var newValue = getNewMultipleValue(innerValue.value, optionValue);
                setInnerValue(newValue.value, {
                  e: e,
                  trigger: newValue.isCheck ? "check" : "uncheck"
                }, optionValue);
              }
            }
            break;
          case "Escape":
          case "Tab":
            setInnerPopupVisible(false, {
              trigger: "keydown-esc",
              e: e
            });
            setTInputValue("", {
              e: e,
              trigger: "blur"
            });
            break;
        }
      };
      VueCompositionAPI.watch(innerPopupVisible, function (val) {
        val && on$1(document, "keydown", keydownEvent);
        !val && off$1(document, "keydown", keydownEvent);
      }, {
        flush: "sync"
      });
      VueCompositionAPI.watch(innerPopupVisible, function (value2) {
        if (value2) {
          hoverIndex.value = -1;
        } else {
          tInputValue.value && setTInputValue("", {
            trigger: "blur"
          });
        }
      });
      VueCompositionAPI.provide("tSelect", {
        size: size,
        multiple: multiple,
        popupOpenTime: popupOpenTime,
        hoverIndex: hoverIndex,
        selectValue: innerValue,
        reserveKeyword: reserveKeyword,
        isReachMaxLimit: isReachMaxLimit,
        isAllOptionsChecked: isAllOptionsChecked,
        getOverlayElm: getOverlayElm,
        handleCheckAllClick: handleCheckAllClick,
        handleCreate: handleCreate,
        handleValueChange: setInnerValue,
        handlerInputChange: setTInputValue,
        handlePopupVisibleChange: setInnerPopupVisible,
        isRemoteSearch: Boolean(props2.onSearch || ((_ctx$listeners = ctx.listeners) === null || _ctx$listeners === void 0 ? void 0 : _ctx$listeners.search))
      });
      return {
        isFilterable: isFilterable,
        isDisabled: isDisabled,
        isLoading: isLoading,
        innerOptions: innerOptions,
        placeholderText: placeholderText,
        selectInputRef: selectInputRef,
        selectPanelRef: selectPanelRef,
        innerPopupVisible: innerPopupVisible,
        displayText: displayText,
        tInputValue: tInputValue,
        collapsedItemsParams: collapsedItemsParams,
        valueDisplayParams: valueDisplayParams,
        handleFocus: handleFocus,
        handleBlur: handleBlur,
        handleEnter: handleEnter,
        handleClear: handleClear,
        handleTagChange: handleTagChange,
        handleTInputValueChange: handleTInputValueChange,
        setInnerPopupVisible: setInnerPopupVisible,
        removeTag: removeTag,
        renderTNode: renderTNode,
        updateScrollTop: updateScrollTop,
        componentName: COMPONENT_NAME
      };
    },
    methods: {
      renderSuffixIcon: function renderSuffixIcon() {
        var h = this.$createElement;
        var suffixIcon = this.renderTNode("suffixIcon");
        if (suffixIcon) return suffixIcon;
        var isLoading = this.isLoading,
          showArrow = this.showArrow,
          innerPopupVisible = this.innerPopupVisible,
          isDisabled = this.isDisabled;
        if (isLoading) {
          return h("t-loading", {
            "class": ["".concat(this.componentName, "__right-icon"), "".concat(this.componentName, "__active-icon")],
            "attrs": {
              "size": "small"
            }
          });
        }
        return showArrow ? h("fake-arrow", {
          "attrs": {
            "overlayClassName": "".concat(this.componentName, "__right-icon"),
            "isActive": innerPopupVisible && !isDisabled
          }
        }) : null;
      },
      renderLabel: function renderLabel() {
        var h = this.$createElement;
        var label = this.renderTNode("label");
        var prefixIcon = this.renderTNode("prefixIcon");
        if (label && prefixIcon) {
          return h("div", [label, prefixIcon]);
        }
        return label || prefixIcon;
      }
    },
    render: function render() {
      var _this = this;
      var h = arguments[0];
      var renderTNode = this.renderTNode;
      var _ref5 = this.popupProps || {},
        overlayClassName = _ref5.overlayClassName,
        restPopupProps = _objectWithoutProperties$2(_ref5, _excluded$3);
      return h("div", {
        "ref": "select",
        "class": "".concat(this.componentName, "__wrap")
      }, [h(SelectInput, {
        "ref": "selectInputRef",
        "class": this.componentName,
        "scopedSlots": {
          tips: this.$scopedSlots.tips,
          tag: this.$scopedSlots.tag,
          suffix: this.$scopedSlots.suffix
        },
        "props": _objectSpread$28({}, _objectSpread$28(_objectSpread$28({
          autoWidth: this.autoWidth,
          borderless: this.borderless,
          readonly: this.readonly,
          allowInput: this.isFilterable,
          multiple: this.multiple,
          keys: this.keys,
          status: this.status,
          tips: this.tips,
          suffix: this.suffix,
          tag: this.tag,
          value: this.displayText,
          valueDisplay: function valueDisplay() {
            return renderTNode("valueDisplay", {
              params: _this.valueDisplayParams
            });
          },
          clearable: this.clearable,
          disabled: this.isDisabled,
          label: this.renderLabel,
          suffixIcon: this.renderSuffixIcon,
          placeholder: this.placeholderText,
          inputValue: this.tInputValue,
          inputProps: _objectSpread$28({
            size: this.size
          }, this.inputProps),
          tagInputProps: _objectSpread$28({
            size: this.size
          }, this.tagInputProps),
          tagProps: this.tagProps,
          minCollapsedNum: this.minCollapsedNum,
          collapsedItems: function collapsedItems() {
            return renderTNode("collapsedItems", {
              params: _this.collapsedItemsParams
            });
          },
          popupVisible: this.innerPopupVisible,
          popupProps: _objectSpread$28({
            overlayClassName: ["".concat(this.componentName, "__dropdown"), overlayClassName]
          }, restPopupProps),
          updateScrollTop: this.updateScrollTop
        }, this.selectInputProps), {}, {
          panel: function panel() {
            return h("select-panel", {
              "ref": "selectPanelRef",
              "scopedSlots": _this.$scopedSlots,
              "attrs": {
                "size": _this.size,
                "options": _this.innerOptions,
                "inputValue": _this.tInputValue,
                "multiple": _this.multiple,
                "empty": _this.empty,
                "filter": _this.filter,
                "filterable": _this.isFilterable,
                "creatable": _this.creatable,
                "scroll": _this.scroll,
                "loading": _this.isLoading,
                "loadingText": _this.loadingText,
                "panelTopContent": _this.panelTopContent,
                "panelBottomContent": _this.panelBottomContent
              }
            });
          }
        })),
        "on": _objectSpread$28({}, {
          focus: this.handleFocus,
          blur: this.handleBlur,
          enter: this.handleEnter,
          clear: this.handleClear,
          "input-change": this.handleTInputValueChange,
          "popup-visible-change": this.setInnerPopupVisible,
          "tag-change": this.handleTagChange
        })
      })]);
    }
  });

  var Select = withInstall$1(_Select, VueCompositionAPI__default["default"]);
  var Option = withInstall$1(_Option, VueCompositionAPI__default["default"]);
  var OptionGroup = withInstall$1(_OptionGroup, VueCompositionAPI__default["default"]);

  var props$Q = {
    append: {
      type: [String, Function]
    },
    prepend: {
      type: [String, Function]
    }
  };

  var classPrefixMixins$m = getClassPrefixMixins("input-adornment");
  var _InputAdornment = mixins(classPrefixMixins$m).extend({
    name: "TInputAdornment",
    props: props$Q,
    methods: {
      renderAddon: function renderAddon(h, type, addon) {
        var addonNode;
        var isContentNode = isString(addon) || isNumber(addon);
        if (!this.$scopedSlots[type] && isString(addon) && !addon) return null;
        if (this.$scopedSlots[type]) {
          if (this.$scopedSlots[type](null).length === 1 && this.$scopedSlots[type](null)[0].text) {
            addonNode = h("span", {
              "class": "".concat(this.componentName, "__text")
            }, [this.$scopedSlots[type](null)]);
          } else {
            addonNode = this.$scopedSlots[type](null);
          }
        } else if (typeof addon === "function") {
          addonNode = addon(h);
        } else {
          addonNode = isContentNode ? h("span", {
            "class": "".concat(this.componentName, "__text")
          }, [addon]) : addon;
        }
        return addonNode ? h("span", {
          "class": "".concat(this.componentName, "__").concat(type)
        }, [addonNode]) : addonNode;
      }
    },
    render: function render(h) {
      var prepend = this.renderAddon(h, "prepend", this.prepend);
      var append = this.renderAddon(h, "append", this.append);
      var defaultSlot = this.$scopedSlots["default"] ? this.$scopedSlots["default"](null) : [null];
      if (!prepend && !append) {
        return defaultSlot[0];
      }
      return h("div", {
        "class": this.componentName
      }, [prepend, defaultSlot[0], append]);
    }
  });

  var InputAdornment = withInstall$1(_InputAdornment);

  var props$P = {
    current: {
      type: Number,
      "default": 1
    },
    defaultCurrent: {
      type: Number,
      "default": 1
    },
    disabled: Boolean,
    foldedMaxPageBtn: {
      type: Number,
      "default": 5
    },
    maxPageBtn: {
      type: Number,
      "default": 10
    },
    pageEllipsisMode: {
      type: String,
      "default": "mid",
      validator: function validator(val) {
        if (!val) return true;
        return ["mid", "both-ends"].includes(val);
      }
    },
    pageSize: {
      type: Number,
      "default": 10
    },
    defaultPageSize: {
      type: Number,
      "default": 10
    },
    pageSizeOptions: {
      type: Array,
      "default": function _default() {
        return [5, 10, 20, 50];
      }
    },
    selectProps: {
      type: Object
    },
    showFirstAndLastPageBtn: Boolean,
    showJumper: Boolean,
    showPageNumber: {
      type: Boolean,
      "default": true
    },
    showPageSize: {
      type: Boolean,
      "default": true
    },
    showPreviousAndNextBtn: {
      type: Boolean,
      "default": true
    },
    size: {
      type: String,
      "default": "medium",
      validator: function validator(val) {
        if (!val) return true;
        return ["small", "medium"].includes(val);
      }
    },
    theme: {
      type: String,
      "default": "default",
      validator: function validator(val) {
        if (!val) return true;
        return ["default", "simple"].includes(val);
      }
    },
    total: {
      type: Number,
      "default": 0
    },
    totalContent: {
      type: [Boolean, Function],
      "default": true
    },
    onChange: Function,
    onCurrentChange: Function,
    onPageSizeChange: Function
  };

  function ownKeys$28(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$27(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$28(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$28(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var min = 1;
  var PaginationBase = mixins(getConfigReceiverMixins("pagination"), getGlobalIconMixins()).extend({
    name: "TPagination",
    components: {
      TInputNumber: InputNumber,
      TInputAdornment: InputAdornment,
      TSelect: Select,
      TOption: Option
    },
    props: _objectSpread$27(_objectSpread$27({}, props$P), {}, {
      current: {
        type: Number,
        "default": 1,
        validator: function validator(v) {
          return v > 0;
        }
      },
      pageSize: {
        type: Number,
        "default": 10,
        validator: function validator(v) {
          return v > 0;
        }
      }
    }),
    data: function data() {
      return {
        prevMore: false,
        nextMore: false,
        jumpIndex: this.current
      };
    },
    watch: {
      current: function current(val) {
        this.jumpIndex = val;
      }
    },
    computed: {
      paginationClass: function paginationClass() {
        return ["".concat(this.componentName), this.commonSizeClassName[this.size], _defineProperty$2(_defineProperty$2({}, this.commonStatusClassName.disabled, this.disabled), "".concat(this.componentName, "-ie"), getIEVersion$1() < 11)];
      },
      totalClass: function totalClass() {
        return ["".concat(this.componentName, "__total")];
      },
      sizerClass: function sizerClass() {
        return ["".concat(this.componentName, "__select")];
      },
      preBtnClass: function preBtnClass() {
        return ["".concat(this.componentName, "__btn"), "".concat(this.componentName, "__btn-prev"), _defineProperty$2({}, this.commonStatusClassName.disabled, this.disabled || this.current === 1)];
      },
      nextBtnClass: function nextBtnClass() {
        return ["".concat(this.componentName, "__btn"), "".concat(this.componentName, "__btn-next"), _defineProperty$2({}, this.commonStatusClassName.disabled, this.disabled || this.current === this.pageCount)];
      },
      btnWrapClass: function btnWrapClass() {
        return ["".concat(this.componentName, "__pager")];
      },
      btnMoreClass: function btnMoreClass() {
        return ["".concat(this.componentName, "__number"), "".concat(this.componentName, "__number--more"), _defineProperty$2({}, this.commonStatusClassName.disabled, this.disabled)];
      },
      jumperClass: function jumperClass() {
        return ["".concat(this.componentName, "__jump")];
      },
      jumperInputClass: function jumperInputClass() {
        return ["".concat(this.componentName, "__input")];
      },
      pageCount: function pageCount() {
        var c = Math.ceil(this.total / this.pageSize);
        return c > 0 ? c : 1;
      },
      sizeOptions: function sizeOptions() {
        var _this = this;
        var options = this.pageSizeOptions.map(function (option) {
          return _typeof$2(option) === "object" ? option : {
            label: _this.t(_this.global.itemsPerPage, {
              size: option
            }),
            value: Number(option)
          };
        });
        return options.sort(function (a, b) {
          return a.value - b.value;
        });
      },
      curPageLeftCount: function curPageLeftCount() {
        return Math.ceil((this.foldedMaxPageBtn - 1) / 2);
      },
      curPageRightCount: function curPageRightCount() {
        return Math.ceil((this.foldedMaxPageBtn - 1) / 2);
      },
      isPrevMoreShow: function isPrevMoreShow() {
        return 2 + this.curPageLeftCount < this.current;
      },
      isNextMoreShow: function isNextMoreShow() {
        return this.pageCount - 1 - this.curPageRightCount > this.current;
      },
      pages: function pages() {
        var array = [];
        var start;
        var end;
        if (this.isFolded) {
          if (this.isPrevMoreShow && this.isNextMoreShow) {
            start = this.current - this.curPageLeftCount;
            end = this.current + this.curPageRightCount;
          } else {
            var foldedStart = this.isMidEllipsis ? 2 : 1;
            var foldedEnd = this.isMidEllipsis ? this.pageCount - 1 : this.pageCount;
            start = this.isPrevMoreShow ? this.pageCount - this.foldedMaxPageBtn + 1 : foldedStart;
            end = this.isPrevMoreShow ? foldedEnd : this.foldedMaxPageBtn;
          }
        } else {
          start = 1;
          end = this.pageCount;
        }
        for (var i = start; i <= end; i++) {
          array.push(i);
        }
        return array;
      },
      isFolded: function isFolded() {
        return this.pageCount > this.maxPageBtn;
      },
      isMidEllipsis: function isMidEllipsis() {
        return this.pageEllipsisMode === "mid";
      }
    },
    methods: {
      toPage: function toPage(pageIndex, isTriggerChange) {
        if (this.disabled) {
          return;
        }
        var current = pageIndex;
        if (pageIndex < min) {
          current = min;
        } else if (pageIndex > this.pageCount) {
          current = this.pageCount;
        }
        if (this.current !== current) {
          var prev = this.current;
          var pageInfo = {
            current: current,
            previous: prev,
            pageSize: this.pageSize
          };
          emitEvent$1(this, "current-change", current, pageInfo);
          if (isTriggerChange !== false) {
            emitEvent$1(this, "change", pageInfo);
          }
        }
      },
      prevPage: function prevPage() {
        this.toPage(this.current - 1);
      },
      nextPage: function nextPage() {
        this.toPage(this.current + 1);
      },
      prevMorePage: function prevMorePage() {
        this.toPage(this.current - this.foldedMaxPageBtn);
      },
      nextMorePage: function nextMorePage() {
        this.toPage(this.current + this.foldedMaxPageBtn);
      },
      getButtonClass: function getButtonClass(index) {
        return ["".concat(this.componentName, "__number"), _defineProperty$2(_defineProperty$2({}, this.commonStatusClassName.disabled, this.disabled), this.commonStatusClassName.current, this.current === index)];
      },
      onSelectorChange: function onSelectorChange(e) {
        if (this.disabled) {
          return;
        }
        var pageSize = parseInt(e, 10);
        var pageCount = 1;
        if (pageSize > 0 && this.total > 0) {
          pageCount = Math.ceil(this.total / pageSize);
        }
        var isIndexChange = false;
        if (this.current > pageCount) {
          isIndexChange = true;
        }
        var pageInfo = {
          current: isIndexChange ? pageCount : this.current,
          previous: this.current,
          pageSize: pageSize
        };
        this.$emit("update:pageSize", pageSize, pageInfo);
        emitEvent$1(this, "page-size-change", pageSize, pageInfo);
        emitEvent$1(this, "change", pageInfo);
        if (isIndexChange) {
          this.toPage(pageCount, false);
        }
      },
      onJumperChange: function onJumperChange(val) {
        var currentIndex = Number(val);
        if (isNaN(currentIndex)) return;
        this.toPage(currentIndex);
      }
    },
    render: function render() {
      var _this2 = this;
      var h = arguments[0];
      var _this$useGlobalIcon = this.useGlobalIcon({
          PageFirstIcon: TdPageFirstIcon,
          PageLastIcon: TdPageLastIcon,
          ChevronLeftIcon: TdChevronLeftIcon,
          ChevronRightIcon: TdChevronRightIcon,
          ChevronLeftDoubleIcon: TdChevronLeftDoubleIcon,
          ChevronRightDoubleIcon: TdChevronRightDoubleIcon,
          EllipsisIcon: TdEllipsisIcon
        }),
        PageFirstIcon = _this$useGlobalIcon.PageFirstIcon,
        PageLastIcon = _this$useGlobalIcon.PageLastIcon,
        ChevronLeftIcon = _this$useGlobalIcon.ChevronLeftIcon,
        ChevronRightIcon = _this$useGlobalIcon.ChevronRightIcon,
        ChevronLeftDoubleIcon = _this$useGlobalIcon.ChevronLeftDoubleIcon,
        ChevronRightDoubleIcon = _this$useGlobalIcon.ChevronRightDoubleIcon,
        EllipsisIcon = _this$useGlobalIcon.EllipsisIcon;
      var Jumper = h("div", {
        "class": this.jumperClass
      }, [this.t(this.global.jumpTo), h("t-input-adornment", {
        "attrs": {
          "append": "/ ".concat(this.pageCount, " ").concat(this.t(this.global.page))
        }
      }, [h("t-input-number", {
        "class": this.jumperInputClass,
        "on": {
          "blur": this.onJumperChange,
          "enter": this.onJumperChange
        },
        "attrs": {
          "max": this.pageCount,
          "min": min,
          "size": this.size,
          "theme": "normal",
          "placeholder": ""
        },
        "model": {
          value: _this2.jumpIndex,
          callback: function callback($$v) {
            _this2.jumpIndex = $$v;
          }
        }
      })])]);
      return h("div", {
        "class": this.paginationClass
      }, [renderTNodeJSX(this, "totalContent", h("div", {
        "class": this.totalClass
      }, [this.t(this.global.total, {
        total: this.total
      })])), this.showPageSize && this.pageSizeOptions.length ? h("t-select", helper([{
        "attrs": {
          "size": this.size,
          "value": this.pageSize,
          "disabled": this.disabled,
          "autoWidth": true
        },
        "class": this.sizerClass,
        "on": {
          "change": this.onSelectorChange
        }
      }, {
        "props": this.selectProps || {}
      }]), [this.sizeOptions.map(function (item, index) {
        return h("t-option", {
          "attrs": {
            "value": item.value,
            "label": item.label
          },
          "key": index
        });
      })]) : null, this.showFirstAndLastPageBtn ? h("div", {
        "class": this.preBtnClass,
        "on": {
          "click": function click() {
            return _this2.toPage(1);
          }
        },
        "attrs": {
          "disabled": this.disabled || this.current === min
        }
      }, [h(PageFirstIcon)]) : null, this.showPreviousAndNextBtn ? h("div", {
        "class": this.preBtnClass,
        "on": {
          "click": this.prevPage
        },
        "attrs": {
          "disabled": this.disabled || this.current === min
        }
      }, [h(ChevronLeftIcon)]) : null, this.showPageNumber && this.theme === "default" ? h("ul", {
        "class": this.btnWrapClass
      }, [this.isFolded && this.isMidEllipsis ? h("li", {
        "class": this.getButtonClass(1),
        "on": {
          "click": function click() {
            return _this2.toPage(min);
          }
        }
      }, [min]) : null, this.isFolded && this.isPrevMoreShow && this.isMidEllipsis ? h("li", {
        "class": this.btnMoreClass,
        "on": {
          "click": this.prevMorePage,
          "mouseenter": function mouseenter() {
            return _this2.prevMore = true;
          },
          "mouseleave": function mouseleave() {
            return _this2.prevMore = false;
          }
        }
      }, [this.prevMore ? h(ChevronLeftDoubleIcon) : h(EllipsisIcon)]) : null, this.pages.map(function (i) {
        return h("li", {
          "class": _this2.getButtonClass(i),
          "key": i,
          "on": {
            "click": function click() {
              return _this2.toPage(i);
            }
          }
        }, [i]);
      }), this.isFolded && this.isNextMoreShow && this.isMidEllipsis ? h("li", {
        "class": this.btnMoreClass,
        "on": {
          "click": this.nextMorePage,
          "mouseenter": function mouseenter() {
            return _this2.nextMore = true;
          },
          "mouseleave": function mouseleave() {
            return _this2.nextMore = false;
          }
        }
      }, [this.nextMore ? h(ChevronRightDoubleIcon) : h(EllipsisIcon)]) : null, this.isFolded && this.isMidEllipsis ? h("li", {
        "class": this.getButtonClass(this.pageCount),
        "on": {
          "click": function click() {
            return _this2.toPage(_this2.pageCount);
          }
        }
      }, [this.pageCount]) : null]) : null, this.theme === "simple" && Jumper, this.showPreviousAndNextBtn ? h("div", {
        "class": this.nextBtnClass,
        "on": {
          "click": this.nextPage
        },
        "attrs": {
          "disabled": this.disabled || this.current === this.pageCount
        }
      }, [h(ChevronRightIcon)]) : null, this.showFirstAndLastPageBtn ? h("div", {
        "class": this.nextBtnClass,
        "on": {
          "click": function click() {
            return _this2.toPage(_this2.pageCount);
          }
        },
        "attrs": {
          "disabled": this.disabled || this.current === this.pageCount
        }
      }, [h(PageLastIcon)]) : null, this.theme === "default" && this.showJumper && Jumper]);
    }
  });

  var props$O = {
    disabled: {
      type: [Boolean, Object]
    },
    layout: {
      type: String,
      "default": "horizontal",
      validator: function validator(val) {
        if (!val) return true;
        return ["horizontal", "vertical"].includes(val);
      }
    },
    showCurrent: {
      type: Boolean,
      "default": true
    },
    size: {
      type: String,
      "default": "medium",
      validator: function validator(val) {
        if (!val) return true;
        return ["small", "medium", "large"].includes(val);
      }
    },
    tips: {
      type: Object
    },
    variant: {
      type: String,
      "default": "text",
      validator: function validator(val) {
        if (!val) return true;
        return ["text", "outline"].includes(val);
      }
    },
    onChange: Function
  };

  function ownKeys$27(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$26(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$27(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$27(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _PaginationMini = VueCompositionAPI.defineComponent({
    name: "TPaginationMini",
    props: _objectSpread$26({}, props$O),
    setup: function setup(props2, _ref) {
      var emit = _ref.emit;
      var COMPONENT_NAME = usePrefixClass("pagination-mini");
      var _useGlobalIcon = useGlobalIcon({
          ChevronLeftIcon: TdChevronLeftIcon,
          RoundIcon: TdRoundIcon,
          ChevronRightIcon: TdChevronRightIcon,
          ChevronUpIcon: TdChevronUpIcon,
          ChevronDownIcon: TdChevronDownIcon
        }),
        ChevronLeftIcon = _useGlobalIcon.ChevronLeftIcon,
        RoundIcon = _useGlobalIcon.RoundIcon,
        ChevronRightIcon = _useGlobalIcon.ChevronRightIcon,
        ChevronUpIcon = _useGlobalIcon.ChevronUpIcon,
        ChevronDownIcon = _useGlobalIcon.ChevronDownIcon;
      var titleConfig = VueCompositionAPI.computed(function () {
        if (isObject(props2.tips)) return props2.tips;
        if (props2.tips === true) return {
          prev: "\u4E0A\u4E00\u9875",
          current: "\u5F53\u524D",
          next: "\u4E0B\u4E00\u9875"
        };
        return {};
      });
      var disabledConfig = VueCompositionAPI.computed(function () {
        if (isObject(props2.disabled)) return props2.disabled;
        if (props2.disabled === true) return {
          prev: true,
          current: true,
          next: true
        };
        return {
          prev: false,
          current: false,
          next: false
        };
      });
      function handleChange(context) {
        var _props2$onChange;
        emit("change", context);
        (_props2$onChange = props2.onChange) === null || _props2$onChange === void 0 || _props2$onChange.call(props2, context);
      }
      return {
        COMPONENT_NAME: COMPONENT_NAME,
        ChevronLeftIcon: ChevronLeftIcon,
        RoundIcon: RoundIcon,
        ChevronRightIcon: ChevronRightIcon,
        ChevronUpIcon: ChevronUpIcon,
        ChevronDownIcon: ChevronDownIcon,
        titleConfig: titleConfig,
        disabledConfig: disabledConfig,
        handleChange: handleChange
      };
    },
    render: function render() {
      var h = arguments[0];
      var COMPONENT_NAME = this.COMPONENT_NAME,
        ChevronLeftIcon = this.ChevronLeftIcon,
        RoundIcon = this.RoundIcon,
        ChevronRightIcon = this.ChevronRightIcon,
        ChevronUpIcon = this.ChevronUpIcon,
        ChevronDownIcon = this.ChevronDownIcon,
        titleConfig = this.titleConfig,
        disabledConfig = this.disabledConfig,
        handleChange = this.handleChange;
      var jumperClass = [COMPONENT_NAME, _defineProperty$2({}, "".concat(COMPONENT_NAME, "--outline"), this.variant === "outline")];
      return h("div", {
        "class": jumperClass
      }, [h(Button, {
        "attrs": {
          "title": titleConfig.prev,
          "variant": this.variant,
          "size": this.size,
          "shape": "square",
          "icon": this.layout === "horizontal" ? function () {
            return h(ChevronLeftIcon);
          } : function () {
            return h(ChevronUpIcon);
          },
          "disabled": disabledConfig.prev
        },
        "on": {
          "click": function click(e) {
            return handleChange({
              e: e,
              trigger: "prev"
            });
          }
        },
        "class": "".concat(COMPONENT_NAME, "__prev")
      }), this.showCurrent && h(Button, {
        "attrs": {
          "title": titleConfig.current,
          "variant": this.variant,
          "size": this.size,
          "shape": "square",
          "icon": function icon() {
            return h(RoundIcon);
          },
          "disabled": disabledConfig.current
        },
        "on": {
          "click": function click(e) {
            return handleChange({
              e: e,
              trigger: "current"
            });
          }
        },
        "class": "".concat(COMPONENT_NAME, "__current")
      }), h(Button, {
        "attrs": {
          "title": titleConfig.next,
          "variant": this.variant,
          "size": this.size,
          "shape": "square",
          "icon": this.layout === "horizontal" ? function () {
            return h(ChevronRightIcon);
          } : function () {
            return h(ChevronDownIcon);
          },
          "disabled": disabledConfig.next
        },
        "on": {
          "click": function click(e) {
            return handleChange({
              e: e,
              trigger: "next"
            });
          }
        },
        "class": "".concat(COMPONENT_NAME, "__next")
      })]);
    }
  });

  var Pagination = withInstall$1(mapProps(["current", "pageSize"], {
    model: {
      prop: "current",
      event: "current-change"
    }
  })(PaginationBase));
  var PaginationMini = withInstall$1(_PaginationMini);

  var props$N = {
    current: {
      type: [String, Number]
    },
    defaultCurrent: {
      type: [String, Number]
    },
    layout: {
      type: String,
      "default": "horizontal",
      validator: function validator(val) {
        if (!val) return true;
        return ["horizontal", "vertical"].includes(val);
      }
    },
    options: {
      type: Array
    },
    readonly: Boolean,
    separator: {
      type: String,
      "default": "line",
      validator: function validator(val) {
        if (!val) return true;
        return ["line", "dashed", "arrow"].includes(val);
      }
    },
    sequence: {
      type: String,
      "default": "positive",
      validator: function validator(val) {
        if (!val) return true;
        return ["positive", "reverse"].includes(val);
      }
    },
    theme: {
      type: String,
      "default": "default",
      validator: function validator(val) {
        if (!val) return true;
        return ["default", "dot"].includes(val);
      }
    },
    onChange: Function
  };

  var props$M = {
    content: {
      type: [String, Function],
      "default": ""
    },
    "default": {
      type: [String, Function]
    },
    extra: {
      type: [String, Function]
    },
    icon: {
      type: [Boolean, Function],
      "default": true
    },
    status: {
      type: String,
      "default": "default",
      validator: function validator(val) {
        if (!val) return true;
        return ["default", "process", "finish", "error"].includes(val);
      }
    },
    title: {
      type: [String, Function],
      "default": ""
    },
    value: {
      type: [String, Number]
    }
  };

  function ownKeys$26(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$25(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$26(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$26(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _StepItem = mixins(getConfigReceiverMixins("steps"), getGlobalIconMixins()).extend({
    name: "TStepItem",
    props: _objectSpread$25(_objectSpread$25({}, props$M), {}, {
      index: Number
    }),
    inject: {
      steps: {
        "default": void 0
      }
    },
    computed: {
      current: function current() {
        return this.steps && this.steps.current;
      },
      baseClass: function baseClass() {
        return ["".concat(this.componentName, "-item"), _defineProperty$2({}, "".concat(this.componentName, "-item--").concat(this.status), this.status)];
      },
      iconClass: function iconClass() {
        return ["".concat(this.componentName, "-item__icon"), _defineProperty$2({}, "".concat(this.componentName, "-item--").concat(this.status), this.status)];
      },
      canClick: function canClick() {
        var _this$steps;
        return this.status !== "process" && !((_this$steps = this.steps) !== null && _this$steps !== void 0 && _this$steps.readonly);
      }
    },
    methods: {
      renderIcon: function renderIcon() {
        var h = this.$createElement;
        var defaultIcon;
        if (this.steps.theme === "default") {
          var icon = "";
          var _this$useGlobalIcon = this.useGlobalIcon({
              CheckIcon: TdCheckIcon,
              CloseIcon: TdCloseIcon
            }),
            CheckIcon = _this$useGlobalIcon.CheckIcon,
            CloseIcon = _this$useGlobalIcon.CloseIcon;
          switch (this.status) {
            case "finish":
              if (isFunction(this.global.checkIcon)) {
                icon = this.global.checkIcon(this.$createElement);
              } else {
                icon = h(CheckIcon);
              }
              break;
            case "error":
              if (isFunction(this.global.errorIcon)) {
                icon = this.global.errorIcon(this.$createElement);
              } else {
                icon = h(CloseIcon);
              }
              break;
            default:
              icon = String(this.index + 1);
              break;
          }
          defaultIcon = h("span", {
            "class": "".concat(this.componentName, "-item__icon--number")
          }, [icon]);
        }
        return renderTNodeJSX(this, "icon", defaultIcon);
      },
      onStepClick: function onStepClick(e) {
        if (!this.canClick) return;
        var val = this.value === void 0 ? this.index : this.value;
        this.steps.handleChange(val, this.current, e);
      }
    },
    render: function render() {
      var h = arguments[0];
      var content = renderContent(this, "default", "content");
      return h("div", {
        "class": this.baseClass
      }, [h("div", {
        "class": "".concat(this.componentName, "-item__inner ").concat(this.canClick ? "".concat(this.componentName, "-item--clickable") : ""),
        "on": {
          "click": this.onStepClick
        }
      }, [h("div", {
        "class": this.iconClass
      }, [this.renderIcon()]), h("div", {
        "class": "".concat(this.componentName, "-item__content")
      }, [h("div", {
        "class": "".concat(this.componentName, "-item__title")
      }, [renderTNodeJSX(this, "title")]), h("div", {
        "class": "".concat(this.componentName, "-item__description")
      }, [content]), h("div", {
        "class": "".concat(this.componentName, "-item__extra")
      }, [renderTNodeJSX(this, "extra")])])])]);
    }
  });

  function ownKeys$25(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$24(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$25(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$25(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _Steps = mixins(getConfigReceiverMixins("steps")).extend({
    name: "TSteps",
    components: {
      TStepItem: _StepItem
    },
    props: _objectSpread$24({}, props$N),
    data: function data() {
      return {
        indexMap: {}
      };
    },
    provide: function provide() {
      return {
        steps: this
      };
    },
    watch: {
      options: {
        immediate: true,
        handler: function handler() {
          var _this = this;
          if (!this.options) return;
          this.options.forEach(function (item, index) {
            if (item.value !== void 0) {
              _this.indexMap[item.value] = index;
            }
          });
        }
      }
    },
    computed: {
      baseClass: function baseClass() {
        return [this.componentName, "".concat(this.componentName, "--").concat(this.layout), "".concat(this.componentName, "--").concat(this.sequence), "".concat(this.componentName, "--").concat(this.handleTheme(), "-anchor"), "".concat(this.componentName, "--").concat(this.separator, "-separator")];
      }
    },
    render: function render() {
      var _this$$scopedSlots,
        _this2 = this;
      var h = arguments[0];
      var nodes = ((_this$$scopedSlots = this.$scopedSlots) === null || _this$$scopedSlots === void 0 ? void 0 : _this$$scopedSlots["default"]) && this.$scopedSlots["default"](null);
      var options = this.getOptions();
      var content = options.map(function (item, index) {
        var stepIndex = _this2.sequence === "reverse" ? options.length - index - 1 : index;
        var propsData = _objectSpread$24(_objectSpread$24({}, item), {}, {
          index: stepIndex,
          status: _this2.handleStatus(item, index)
        });
        var stepItem = h("t-step-item", helper([{}, {
          "props": _objectSpread$24(_objectSpread$24({}, item), {}, {
            index: stepIndex,
            status: _this2.handleStatus(item, index)
          })
        }, {
          "key": item.value || index
        }]));
        if (nodes && nodes[index]) {
          var vnode = nodes[index];
          if (vnode.componentOptions) {
            vnode.componentOptions.propsData = propsData;
            return vnode;
          }
          return stepItem;
        }
        return stepItem;
      });
      return h("div", {
        "class": this.baseClass
      }, [content]);
    },
    methods: {
      getOptions: function getOptions() {
        var _this$$scopedSlots2;
        var nodes = ((_this$$scopedSlots2 = this.$scopedSlots) === null || _this$$scopedSlots2 === void 0 ? void 0 : _this$$scopedSlots2["default"]) && this.$scopedSlots["default"](null);
        var options;
        if (this.options && this.options.length) {
          options = this.sequence === "reverse" ? this.options.reverse() : this.options;
        } else {
          options = this.getOptionListBySlots(nodes);
        }
        return options;
      },
      getOptionListBySlots: function getOptionListBySlots(nodes) {
        var _this3 = this;
        var arr = [];
        nodes === null || nodes === void 0 || nodes.forEach(function (node) {
          var _node$componentOption;
          var option = node === null || node === void 0 || (_node$componentOption = node.componentOptions) === null || _node$componentOption === void 0 ? void 0 : _node$componentOption.propsData;
          if (!option) return;
          _this3.sequence === "reverse" ? arr.unshift(option) : arr.push(option);
        });
        return arr;
      },
      handleTheme: function handleTheme() {
        var theme = this.theme;
        var options = this.getOptions();
        options.forEach(function (item) {
          if ((item === null || item === void 0 ? void 0 : item.icon) !== void 0) {
            theme = "default";
          }
        });
        return theme;
      },
      handleStatus: function handleStatus(item, index) {
        if (item.status && item.status !== "default") return item.status;
        if (this.current === "FINISH") return "finish";
        if (item.value === void 0) {
          if (this.sequence === "positive" && index < this.current) return "finish";
          if (this.sequence === "reverse" && index > this.current) return "finish";
        }
        if (item.value !== void 0) {
          var matchIndex = this.indexMap[this.current];
          if (matchIndex === void 0) {
            console.warn("TDesign Steps Warn: The current `value` is not exist.");
            return "default";
          }
          if (this.sequence === "positive" && index < matchIndex) return "finish";
          if (this.sequence === "reverse" && index > matchIndex) return "finish";
        }
        var key = item.value === void 0 ? index : item.value;
        if (key === this.current) return "process";
        return "default";
      },
      handleChange: function handleChange(cur, prev, e) {
        emitEvent$1(this, "change", cur, prev, {
          e: e
        });
      }
    }
  });

  var StepItem = withInstall$1(_StepItem);
  var Steps = withInstall$1(mapProps(["current"], {
    model: {
      prop: "current",
      event: "change"
    }
  })(_Steps));

  var props$L = {
    list: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    offset: {
      type: Array
    },
    placement: {
      type: String,
      "default": "right-bottom",
      validator: function validator(val) {
        if (!val) return true;
        return ["right-top", "right-center", "right-bottom", "left-top", "left-center", "left-bottom"].includes(val);
      }
    },
    popupProps: {
      type: Object
    },
    shape: {
      type: String,
      "default": "square",
      validator: function validator(val) {
        if (!val) return true;
        return ["square", "round"].includes(val);
      }
    },
    type: {
      type: String,
      "default": "normal",
      validator: function validator(val) {
        if (!val) return true;
        return ["normal", "compact"].includes(val);
      }
    },
    width: {
      type: [String, Number]
    },
    onClick: Function,
    onHover: Function
  };

  var baseProps$1 = {
    icon: {
      type: Function
    },
    label: {
      type: [String, Function]
    },
    popup: {
      type: [String, Function]
    },
    popupProps: {
      type: Object
    },
    trigger: {
      type: String,
      "default": "hover",
      validator: function validator(val) {
        if (!val) return true;
        return ["hover", "click"].includes(val);
      }
    }
  };

  function ownKeys$24(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$23(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$24(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$24(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _StickyItem = mixins(getConfigReceiverMixins("sticky-item"), getGlobalIconMixins()).extend({
    name: "TStickyItem",
    props: _objectSpread$23(_objectSpread$23({}, baseProps$1), {}, {
      type: props$L.type,
      shape: props$L.shape,
      placement: props$L.placement,
      basePopupProps: Object,
      baseWidth: props$L.width,
      onClick: props$L.onClick,
      onHover: props$L.onHover,
      fatherCompName: String
    }),
    computed: {
      baseClass: function baseClass() {
        return ["".concat(this.componentName), "".concat(this.componentName, "--").concat(this.type), "".concat(this.componentName, "--").concat(this.shape)];
      },
      labelClass: function labelClass() {
        return ["".concat(this.componentName, "__label")];
      },
      popupPlacement: function popupPlacement() {
        return this.placement.indexOf("right") !== -1 ? "left" : "right";
      },
      styles: function styles() {
        var styles = {};
        if (this.baseWidth) {
          var selfWidth = this.type === "normal" ? "56px" : "40px";
          styles.margin = "calc((".concat(this.baseWidth, " - ").concat(selfWidth, ")/2)");
        }
        return styles;
      }
    },
    render: function render() {
      var h = arguments[0];
      var icon = renderTNodeJSX(this, "icon");
      var label = renderTNodeJSX(this, "label");
      var popup = renderTNodeJSX(this, "popup");
      return h(Popup, helper([{
        "attrs": {
          "overlayInnerClassName": "".concat(this.fatherCompName, "-popup-content"),
          "trigger": this.trigger,
          "hideEmptyPopup": true,
          "placement": this.popupPlacement,
          "content": function content() {
            return popup;
          }
        }
      }, {
        "props": this.popupProps || this.basePopupProps
      }]), [h("div", {
        "class": this.baseClass,
        "style": this.styles,
        "on": {
          "click": this.handleClickItem,
          "mouseenter": this.handleHoverItem
        }
      }, [icon, this.type === "normal" ? h("div", {
        "class": this.labelClass
      }, [label]) : null])]);
    },
    methods: {
      handleClickItem: function handleClickItem(e) {
        var _this = this;
        var item = {};
        Object.keys(baseProps$1).forEach(function (i) {
          return item[i] = _this[i];
        });
        this.onClick({
          e: e,
          item: item
        });
      },
      handleHoverItem: function handleHoverItem(e) {
        var _this2 = this;
        var item = {};
        Object.keys(baseProps$1).forEach(function (i) {
          return item[i] = _this2[i];
        });
        this.onHover({
          e: e,
          item: item
        });
      }
    }
  });

  function ownKeys$23(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$22(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$23(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$23(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _StickyTool = mixins(getConfigReceiverMixins("sticky-tool")).extend({
    name: "TStickyTool",
    components: {
      TStickyItem: _StickyItem
    },
    props: _objectSpread$22({}, props$L),
    computed: {
      classes: function classes() {
        return [this.componentName, "".concat(this.componentName, "--").concat(this.shape)];
      },
      styles: function styles() {
        var styles = this.getOffset();
        if (this.width) styles.width = typeof this.width === "number" ? "".concat(this.width, "px") : this.width;
        return styles;
      }
    },
    render: function render() {
      var _this$$scopedSlots,
        _this = this;
      var h = arguments[0];
      var nodes = ((_this$$scopedSlots = this.$scopedSlots) === null || _this$$scopedSlots === void 0 ? void 0 : _this$$scopedSlots["default"]) && this.$scopedSlots["default"](null);
      var list = this.getList();
      var content = list.map(function (item, index) {
        var type = _this.type,
          shape = _this.shape,
          placement = _this.placement,
          popupProps = _this.popupProps,
          handleClick = _this.handleClick,
          handleHover = _this.handleHover;
        var itemProps = _objectSpread$22(_objectSpread$22({}, item), {}, {
          type: type,
          shape: shape,
          placement: placement,
          basePopupProps: popupProps,
          baseWidth: _this.styles.width,
          onClick: handleClick,
          onHover: handleHover,
          fatherCompName: _this.componentName
        });
        var stickyItem = h("t-sticky-item", helper([{}, {
          "props": itemProps
        }, {
          "key": index
        }]));
        if (nodes && nodes[index]) {
          var vnode = nodes[index];
          if (vnode.componentOptions) {
            vnode.componentOptions.propsData = itemProps;
            return vnode;
          }
          return stickyItem;
        }
        return stickyItem;
      });
      return h("div", {
        "class": this.classes,
        "style": this.styles
      }, [content]);
    },
    methods: {
      getList: function getList() {
        var _this$$scopedSlots2, _this$list;
        var nodes = ((_this$$scopedSlots2 = this.$scopedSlots) === null || _this$$scopedSlots2 === void 0 ? void 0 : _this$$scopedSlots2["default"]) && this.$scopedSlots["default"](null);
        var list;
        if ((_this$list = this.list) !== null && _this$list !== void 0 && _this$list.length) {
          list = this.list;
        } else {
          list = this.getListBySlots(nodes);
        }
        return list;
      },
      getListBySlots: function getListBySlots(nodes) {
        var arr = [];
        nodes === null || nodes === void 0 || nodes.forEach(function (node) {
          var _node$componentOption;
          var option = node === null || node === void 0 || (_node$componentOption = node.componentOptions) === null || _node$componentOption === void 0 ? void 0 : _node$componentOption.propsData;
          if (!option) return;
          arr.push(option);
        });
        return arr;
      },
      getOffset: function getOffset() {
        var _this$offset;
        var position = this.offset ? [80, 24] : ["80px", "24px"];
        (_this$offset = this.offset) === null || _this$offset === void 0 || _this$offset.forEach(function (item, index) {
          position[index] = isNaN(Number(item)) ? "calc( ".concat(position[index], "px + ").concat(item, ")") : "".concat(position[index] + item, "px");
        });
        var offsetStyle = {};
        this.placement.split("-").forEach(function (item, index) {
          if (item !== "center") {
            offsetStyle[item] = position[index];
          } else {
            offsetStyle.top = "50%";
            offsetStyle.transform = "translate(0, -50%)";
          }
        });
        return offsetStyle;
      },
      handleClick: function handleClick(context) {
        emitEvent$1(this, "click", context);
      },
      handleHover: function handleHover(context) {
        emitEvent$1(this, "hover", context);
      }
    }
  });

  var StickyItem = withInstall$1(_StickyItem);
  var StickyTool = withInstall$1(_StickyTool);

  var props$K = {
    autofocus: Boolean,
    borderless: Boolean,
    clearable: Boolean,
    "default": {
      type: [String, Function]
    },
    disabled: {
      type: Boolean,
      "default": void 0
    },
    empty: {
      type: [String, Function]
    },
    filter: {
      type: Function
    },
    filterable: {
      type: Boolean,
      "default": true
    },
    highlightKeyword: {
      type: Boolean,
      "default": true
    },
    inputProps: {
      type: Object
    },
    options: {
      type: Array
    },
    panelBottomContent: {
      type: [String, Function]
    },
    panelTopContent: {
      type: [String, Function]
    },
    placeholder: {
      type: String,
      "default": void 0
    },
    popupProps: {
      type: Object
    },
    readonly: Boolean,
    size: {
      type: String,
      "default": "medium",
      validator: function validator(val) {
        if (!val) return true;
        return ["small", "medium", "large"].includes(val);
      }
    },
    status: {
      type: String,
      "default": "default",
      validator: function validator(val) {
        if (!val) return true;
        return ["default", "success", "warning", "error"].includes(val);
      }
    },
    textareaProps: {
      type: Object
    },
    tips: {
      type: [String, Function]
    },
    triggerElement: {
      type: [String, Function]
    },
    value: {
      type: String,
      "default": void 0
    },
    defaultValue: {
      type: String,
      "default": ""
    },
    onBlur: Function,
    onChange: Function,
    onClear: Function,
    onCompositionend: Function,
    onCompositionstart: Function,
    onEnter: Function,
    onFocus: Function,
    onSelect: Function
  };

  var _HighlightOption = VueCompositionAPI.defineComponent({
    name: "HighlightOption",
    props: {
      content: String,
      keyword: String
    },
    setup: function setup(props) {
      var classPrefix = usePrefixClass();
      var words = VueCompositionAPI.computed(function () {
        var _content$match;
        var content = props.content,
          keyword = props.keyword;
        if (!content) return {
          list: []
        };
        if (typeof content !== "string" || !keyword) return {
          list: [content]
        };
        var regExp = new RegExp(escapeRegExp(keyword), "i");
        var splitKeyword = (_content$match = content.match(regExp)) === null || _content$match === void 0 ? void 0 : _content$match[0];
        return {
          list: content.split(splitKeyword),
          keyword: splitKeyword
        };
      });
      return {
        words: words,
        classPrefix: classPrefix
      };
    },
    render: function render() {
      var _this = this;
      var h = arguments[0];
      var _this$words = this.words,
        list = _this$words.list,
        keyword = _this$words.keyword;
      return h("div", {
        "class": "".concat(this.classPrefix, "-select-option__highlight-item")
      }, [list.map(function (item, index) {
        if (!index) return item;
        return [h("b", {
          "class": "".concat(_this.classPrefix, "-is-highlight"),
          "key": item + keyword
        }, [keyword]), item];
      })]);
    }
  });

  function ownKeys$22(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$21(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$22(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$22(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var AutoCompleteOptionList = VueCompositionAPI.defineComponent({
    name: "AutoCompleteOptionList",
    props: {
      sizeClassNames: Object,
      value: String,
      size: String,
      options: Array,
      popupVisible: Boolean,
      highlightKeyword: Boolean,
      filterable: Boolean,
      filter: Function,
      empty: [String, Function]
    },
    setup: function setup(props, _ref) {
      var emit = _ref.emit;
      var active = VueCompositionAPI.ref("");
      var classPrefix = usePrefixClass();
      var _useConfig = useConfig("autoComplete"),
        globalConfig = _useConfig.globalConfig;
      var classes = VueCompositionAPI.computed(function () {
        return "".concat(classPrefix.value, "-select__list");
      });
      var optionClasses = VueCompositionAPI.computed(function () {
        return ["".concat(classPrefix.value, "-select-option"), _defineProperty$2({}, props.sizeClassNames[props.size], props.size)];
      });
      var tOptions = VueCompositionAPI.computed(function () {
        var options = (props.options || []).map(function (item) {
          var option = {};
          if (typeof item === "string") {
            option = {
              text: item,
              label: item
            };
          } else {
            if (item.text && typeof item.text !== "string") {
              log.warn("AutoComplete", "`text` must be a string.");
            }
            if (!item.text) {
              if (typeof item.label === "string") {
                option = _objectSpread$21(_objectSpread$21({}, item), {}, {
                  text: item.label
                });
              } else {
                log.warn("AutoComplete", "one of `label` and `text` must be a existed string.");
              }
            } else {
              option = item;
            }
          }
          return option;
        });
        if (props.filter) {
          options = options.filter(function (option) {
            return props.filter(props.value, option);
          });
        } else if (props.filterable) {
          var regExp = new RegExp(escapeRegExp(props.value), "i");
          options = options.filter(function (item) {
            return regExp.test(item.text);
          });
        }
        return options;
      });
      var onOptionClick = function onOptionClick(e) {
        var liNode = e.target;
        while (liNode && liNode.tagName !== "LI") {
          liNode = liNode.parentNode;
        }
        var keyword = liNode.getAttribute("title");
        active.value = keyword;
        emit("select", keyword, {
          e: e
        });
      };
      var onKeyInnerPress = function onKeyInnerPress(e) {
        if (e.code === "ArrowUp" || e.key === "ArrowUp") {
          var index = tOptions.value.findIndex(function (item) {
            return item.text === active.value;
          });
          var newIndex = index - 1 < 0 ? tOptions.value.length - 1 : index - 1;
          active.value = tOptions.value[newIndex].text;
        } else if (e.code === "ArrowDown" || e.key === "ArrowDown") {
          var _index = tOptions.value.findIndex(function (item) {
            return item.text === active.value;
          });
          var _newIndex = _index + 1 >= tOptions.value.length ? 0 : _index + 1;
          active.value = tOptions.value[_newIndex].text;
        } else if (e.code === "Enter" || e.key === "Enter") {
          emit("select", active.value, {
            e: e
          });
        }
      };
      var addKeyboardListener = function addKeyboardListener() {
        on$1(document, "keydown", onKeyInnerPress);
      };
      var removeKeyboardListener = function removeKeyboardListener() {
        off$1(document, "keydown", onKeyInnerPress);
      };
      VueCompositionAPI.watch(function () {
        return props.popupVisible;
      }, function () {
        if (props.popupVisible) {
          addKeyboardListener();
        } else {
          removeKeyboardListener();
        }
      }, {
        immediate: true
      });
      VueCompositionAPI.watch(function () {
        return props.value;
      }, function () {
        if (!props.value) {
          active.value = "";
        }
      }, {
        immediate: true
      });
      VueCompositionAPI.onBeforeUnmount(function () {
        removeKeyboardListener();
      });
      return {
        globalConfig: globalConfig,
        classes: classes,
        classPrefix: classPrefix,
        optionClasses: optionClasses,
        active: active,
        tOptions: tOptions,
        addKeyboardListener: addKeyboardListener,
        removeKeyboardListener: removeKeyboardListener,
        onOptionClick: onOptionClick
      };
    },
    render: function render() {
      var _this = this;
      var h = arguments[0];
      if (!this.tOptions.length) {
        return h("div", {
          "class": "".concat(this.classPrefix, "-auto-complete__panel--empty")
        }, [this.empty || this.globalConfig.empty]);
      }
      return h("ul", {
        "class": this.classes
      }, [this.tOptions.map(function (item) {
        var cls = _toConsumableArray(_this.optionClasses);
        if (item.text === _this.active) {
          cls.push("".concat(_this.classPrefix, "-select-option--hover"));
        }
        var labelNode = item.label;
        if (isFunction(item.label)) {
          labelNode = item.label(h);
        } else if (_this.$scopedSlots.option) {
          var _this$$scopedSlots$op, _this$$scopedSlots;
          labelNode = (_this$$scopedSlots$op = (_this$$scopedSlots = _this.$scopedSlots).option) === null || _this$$scopedSlots$op === void 0 ? void 0 : _this$$scopedSlots$op.call(_this$$scopedSlots, {
            option: item
          });
        }
        var content = labelNode || item.text;
        return h("li", {
          "key": item.text,
          "class": cls,
          "attrs": {
            "title": item.text
          },
          "on": {
            "click": _this.onOptionClick
          }
        }, [typeof content === "string" && _this.highlightKeyword ? h(_HighlightOption, {
          "attrs": {
            "content": content,
            "keyword": _this.value
          }
        }) : content]);
      })]);
    }
  });

  function ownKeys$21(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$20(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$21(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$21(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _AutoComplete = VueCompositionAPI.defineComponent({
    name: "TAutoComplete",
    props: props$K,
    setup: function setup(props2, _ref) {
      var emit = _ref.emit;
      var _toRefs = VueCompositionAPI.toRefs(props2),
        value = _toRefs.value;
      var _useVModel = useVModel$1(value, props2.defaultValue, props2.onChange),
        _useVModel2 = _slicedToArray(_useVModel, 2),
        tValue = _useVModel2[0],
        setTValue = _useVModel2[1];
      var _useCommonClassName = useCommonClassName(),
        classPrefix = _useCommonClassName.classPrefix,
        sizeClassNames = _useCommonClassName.sizeClassNames;
      var _useConfig = useConfig("input"),
        global = _useConfig.global;
      var popupVisible = VueCompositionAPI.ref();
      var optionListRef = VueCompositionAPI.ref();
      var getOverlayStyle = function getOverlayStyle(trigger, popupElement) {
        var _props2$popupProps;
        var triggerWidth = trigger.getBoundingClientRect().width || trigger.offsetWidth || trigger.clientWidth;
        var popupWidth = popupElement.getBoundingClientRect().width || popupElement.offsetWidth || popupElement.clientWidth;
        return _objectSpread$20({
          width: triggerWidth >= popupWidth ? "".concat(triggerWidth, "px") : "auto"
        }, (_props2$popupProps = props2.popupProps) === null || _props2$popupProps === void 0 ? void 0 : _props2$popupProps.overlayInnerStyle);
      };
      var classes = VueCompositionAPI.computed(function () {
        return ["".concat(classPrefix.value, "-auto-complete")];
      });
      var popupClasses = VueCompositionAPI.computed(function () {
        var _props2$popupProps2;
        var classes2 = ["".concat(classPrefix.value, "-select__dropdown")];
        if ((_props2$popupProps2 = props2.popupProps) !== null && _props2$popupProps2 !== void 0 && _props2$popupProps2.overlayClassName) {
          classes2 = classes2.concat(props2.popupProps.overlayClassName);
        }
        return classes2;
      });
      var popupInnerClasses = VueCompositionAPI.computed(function () {
        var _props2$popupProps3;
        var classes2 = ["".concat(classPrefix.value, "-select__dropdown-inner")];
        if ((_props2$popupProps3 = props2.popupProps) !== null && _props2$popupProps3 !== void 0 && _props2$popupProps3.overlayInnerClassName) {
          classes2 = classes2.concat(props2.popupProps.overlayInnerClassName);
        }
        return classes2;
      });
      var onInputChange = function onInputChange(value2, context) {
        setTValue(value2, context);
      };
      var innerInputProps = VueCompositionAPI.computed(function () {
        var tProps = _objectSpread$20({
          value: tValue.value,
          size: props2.size
        }, props2.inputProps);
        return tProps;
      });
      var onInnerFocus = function onInnerFocus(value2, context) {
        var _props2$onFocus;
        popupVisible.value = true;
        emit("focus", _objectSpread$20(_objectSpread$20({}, context), {}, {
          value: value2
        }));
        (_props2$onFocus = props2.onFocus) === null || _props2$onFocus === void 0 || _props2$onFocus.call(props2, _objectSpread$20(_objectSpread$20({}, context), {}, {
          value: value2
        }));
        VueCompositionAPI.nextTick(function () {
          var _optionListRef$value;
          (_optionListRef$value = optionListRef.value) === null || _optionListRef$value === void 0 || _optionListRef$value.addKeyboardListener();
        });
      };
      var onInnerBlur = function onInnerBlur(value2, context) {
        var _props2$onBlur;
        emit("blur", _objectSpread$20(_objectSpread$20({}, context), {}, {
          value: value2
        }));
        (_props2$onBlur = props2.onBlur) === null || _props2$onBlur === void 0 || _props2$onBlur.call(props2, _objectSpread$20(_objectSpread$20({}, context), {}, {
          value: value2
        }));
      };
      var onInnerCompositionend = function onInnerCompositionend(value2, context) {
        var _props2$onComposition;
        emit("compositionend", _objectSpread$20(_objectSpread$20({}, context), {}, {
          value: value2
        }));
        (_props2$onComposition = props2.onCompositionend) === null || _props2$onComposition === void 0 || _props2$onComposition.call(props2, _objectSpread$20(_objectSpread$20({}, context), {}, {
          value: value2
        }));
      };
      var onInnerCompositionstart = function onInnerCompositionstart(value2, context) {
        var _props2$onComposition2;
        emit("compositionstart", _objectSpread$20(_objectSpread$20({}, context), {}, {
          value: value2
        }));
        (_props2$onComposition2 = props2.onCompositionstart) === null || _props2$onComposition2 === void 0 || _props2$onComposition2.call(props2, _objectSpread$20(_objectSpread$20({}, context), {}, {
          value: value2
        }));
      };
      var onInnerEnter = function onInnerEnter(value2, context) {
        var _props2$onEnter;
        emit("enter", _objectSpread$20(_objectSpread$20({}, context), {}, {
          value: value2
        }));
        (_props2$onEnter = props2.onEnter) === null || _props2$onEnter === void 0 || _props2$onEnter.call(props2, _objectSpread$20(_objectSpread$20({}, context), {}, {
          value: value2
        }));
      };
      var onInnerClear = function onInnerClear(context) {
        var _props2$onClear;
        emit("clear", context);
        (_props2$onClear = props2.onClear) === null || _props2$onClear === void 0 || _props2$onClear.call(props2, context);
      };
      var inputListeners = VueCompositionAPI.computed(function () {
        return {
          change: onInputChange,
          focus: onInnerFocus,
          blur: onInnerBlur,
          compositionend: onInnerCompositionend,
          compositionstart: onInnerCompositionstart,
          enter: onInnerEnter,
          clear: onInnerClear
        };
      });
      var onInnerSelect = function onInnerSelect(value2, context) {
        var _props2$onSelect;
        if (props2.readonly || props2.disabled) return;
        popupVisible.value = false;
        setTValue(value2, context);
        emit("select", value2, context);
        (_props2$onSelect = props2.onSelect) === null || _props2$onSelect === void 0 || _props2$onSelect.call(props2, value2, context);
      };
      var onPopupVisibleChange = function onPopupVisibleChange(visible, _ref2) {
        var trigger = _ref2.trigger;
        if (trigger !== "trigger-element-click") {
          popupVisible.value = visible;
        }
      };
      return {
        global: global,
        classes: classes,
        classPrefix: classPrefix,
        popupClasses: popupClasses,
        popupInnerClasses: popupInnerClasses,
        sizeClassNames: sizeClassNames,
        innerInputProps: innerInputProps,
        inputListeners: inputListeners,
        tValue: tValue,
        popupVisible: popupVisible,
        optionListRef: optionListRef,
        onPopupVisibleChange: onPopupVisibleChange,
        getOverlayStyle: getOverlayStyle,
        onInnerSelect: onInnerSelect
      };
    },
    render: function render() {
      var _this$placeholder;
      var h = arguments[0];
      var triggerNode = renderContent(this, "default", "triggerElement") || h(Input, helper([{
        "attrs": {
          "placeholder": (_this$placeholder = this.placeholder) !== null && _this$placeholder !== void 0 ? _this$placeholder : this.global.placeholder
        }
      }, {
        "on": this.inputListeners
      }, {
        "attrs": {
          "tips": this.tips,
          "status": this.status,
          "readonly": this.readonly,
          "disabled": this.disabled,
          "autofocus": this.autofocus,
          "clearable": this.clearable
        }
      }, {
        "props": this.innerInputProps
      }, {
        "scopedSlots": this.$scopedSlots,
        "attrs": {
          "borderless": this.borderless
        }
      }]));
      var listContent = Array.isArray(this.options) && h(AutoCompleteOptionList, {
        "ref": "optionListRef",
        "attrs": {
          "value": this.tValue,
          "options": this.options,
          "size": this.size,
          "sizeClassNames": this.sizeClassNames,
          "popupVisible": this.popupVisible,
          "highlightKeyword": this.highlightKeyword,
          "filterable": this.filterable,
          "filter": this.filter,
          "empty": renderTNodeJSX(this, "empty")
        },
        "on": {
          "select": this.onInnerSelect
        },
        "scopedSlots": {
          option: this.$scopedSlots.option
        }
      });
      var topContent = renderTNodeJSX(this, "panelTopContent");
      var bottomContent = renderTNodeJSX(this, "panelBottomContent");
      var panelContent = topContent || listContent || bottomContent ? h("div", {
        "class": "".concat(this.classPrefix, "-auto-complete__panel")
      }, [topContent, listContent, bottomContent]) : null;
      var popupProps = _objectSpread$20(_objectSpread$20({}, this.popupProps), {}, {
        overlayInnerStyle: this.getOverlayStyle,
        overlayInnerClassName: this.popupInnerClasses,
        overlayClassName: this.popupClasses
      });
      return h("div", {
        "class": this.classes
      }, [panelContent && h(Popup, helper([{
        "attrs": {
          "visible": this.popupVisible
        }
      }, {
        "on": {
          "visible-change": this.onPopupVisibleChange
        }
      }, {
        "attrs": {
          "trigger": "focus",
          "placement": "bottom-left",
          "hideEmptyPopup": true,
          "content": panelContent ? function () {
            return panelContent;
          } : null
        }
      }, {
        "props": popupProps
      }]), [triggerNode]), !panelContent && triggerNode]);
    }
  });

  var AutoComplete = withInstall$1(_AutoComplete, VueCompositionAPI__default["default"]);
  var HighlightOption = withInstall$1(_HighlightOption, VueCompositionAPI__default["default"]);

  function getSingleContent(cascaderContext) {
    var value = cascaderContext.value,
      multiple = cascaderContext.multiple,
      treeStore = cascaderContext.treeStore,
      showAllLevels = cascaderContext.showAllLevels;
    if (multiple || typeof value !== "number" && !value) return "";
    if (Array.isArray(value)) return "";
    var node = treeStore && treeStore.getNodes(value);
    if (!(node && node.length)) {
      return value;
    }
    var path = node && node[0].getPath();
    if (path && path.length) {
      return showAllLevels ? path.map(function (node2) {
        return node2.label;
      }).join(" / ") : path.at(-1).label;
    }
    return value;
  }
  function getMultipleContent(cascaderContext) {
    var value = cascaderContext.value,
      multiple = cascaderContext.multiple,
      treeStore = cascaderContext.treeStore,
      showAllLevels = cascaderContext.showAllLevels;
    if (!multiple) return [];
    if (multiple && !Array.isArray(value)) return [];
    var node = treeStore && treeStore.getNodes(value);
    if (!node) return [];
    return value.map(function (item) {
      var node2 = treeStore.getNodes(item);
      return showAllLevels ? getFullPathLabel(node2[0]) : node2[0].label;
    }).filter(function (item) {
      return !!item;
    });
  }
  function getPanels(treeNodes) {
    var panels = [];
    treeNodes.forEach(function (node) {
      if (panels[node.level]) {
        panels[node.level].push(node);
      } else {
        panels[node.level] = [node];
      }
    });
    return panels;
  }
  function getFullPathLabel(node) {
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "/";
    return node === null || node === void 0 ? void 0 : node.getPath().map(function (node2) {
      return node2.label;
    }).join(separator);
  }
  var getTreeValue = function getTreeValue(value) {
    var treeValue = [];
    if (Array.isArray(value)) {
      if (value.length > 0 && _typeof$2(value[0]) === "object") {
        treeValue = value.map(function (val) {
          return val.value;
        });
      } else if (value.length) {
        treeValue = value;
      }
    } else if (value) {
      if (_typeof$2(value) === "object") {
        treeValue = [value.value];
      } else {
        treeValue = [value];
      }
    }
    return treeValue;
  };
  var getCascaderValue = function getCascaderValue(value, valueType, multiple) {
    if (valueType === "single") {
      return value;
    }
    var val = value;
    if (multiple) {
      return val.map(function (item) {
        return item.at(-1);
      });
    }
    return val.at(-1);
  };
  function isEmptyValues(value) {
    if (typeof value === "number" && !isNaN(value)) return false;
    return isEmpty(value);
  }
  function isValueInvalid(value, cascaderContext) {
    var multiple = cascaderContext.multiple,
      showAllLevels = cascaderContext.showAllLevels,
      valueType = cascaderContext.valueType;
    return multiple && !Array.isArray(value) || !multiple && Array.isArray(value) && valueType === "single" && !showAllLevels;
  }

  function getFakeArrowIconClass(prefix, STATUS, cascaderContext) {
    var disabled = cascaderContext.disabled;
    return ["".concat(prefix, "-cascader__icon"), _defineProperty$2({}, STATUS.disabled, disabled)];
  }
  function getNodeStatusClass(node, STATUS, cascaderContext) {
    var checkStrictly = cascaderContext.checkStrictly,
      multiple = cascaderContext.multiple,
      value = cascaderContext.value,
      max = cascaderContext.max;
    var expandedActive = !checkStrictly && node.expanded && (multiple ? !node.isLeaf() : true) || checkStrictly && node.expanded;
    var isLeaf = node.isLeaf();
    var isDisabled = node.disabled || multiple && value.length >= max && max !== 0;
    var isSelected = node.checked || multiple && !checkStrictly && node.expanded && !isLeaf;
    return [_defineProperty$2(_defineProperty$2(_defineProperty$2({}, STATUS.selected, !isDisabled && isSelected), STATUS.expanded, !isDisabled && expandedActive), STATUS.disabled, isDisabled)];
  }
  function getCascaderItemClass(prefix, node, SIZE, STATUS, cascaderContext) {
    var size = cascaderContext.size;
    return ["".concat(prefix, "-cascader__item")].concat(_toConsumableArray(getNodeStatusClass(node, STATUS, cascaderContext)), [SIZE[size], _defineProperty$2(_defineProperty$2({}, "".concat(prefix, "-cascader__item--with-icon"), !!node.children), "".concat(prefix, "-cascader__item--leaf"), node.isLeaf())]);
  }
  function getCascaderItemIconClass(prefix, node, STATUS, cascaderContext) {
    return ["".concat(prefix, "-cascader__item-icon"), "".concat(prefix, "-icon")].concat(_toConsumableArray(getNodeStatusClass(node, STATUS, cascaderContext)));
  }

  function ownKeys$20(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1$(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$20(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$20(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var keepAnimationMixins$1 = getKeepAnimationMixins();
  var props$J = {
    node: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    optionChild: {
      type: [Object, Array]
    },
    cascaderContext: {
      type: Object
    },
    onChange: Function,
    onClick: Function,
    onMouseenter: Function
  };
  var Item = VueCompositionAPI.defineComponent({
    mixins: [keepAnimationMixins$1],
    directives: {
      Ripple: Ripple
    },
    props: _objectSpread$1$({}, props$J),
    setup: function setup(props2) {
      var COMPONENT_NAME = usePrefixClass("cascader__item");
      var classPrefix = usePrefixClass();
      var _useCommonClassName = useCommonClassName$1(),
        STATUS = _useCommonClassName.STATUS,
        SIZE = _useCommonClassName.SIZE;
      var _useGlobalIcon = useGlobalIcon({
          ChevronRightIcon: TdChevronRightIcon
        }),
        ChevronRightIcon = _useGlobalIcon.ChevronRightIcon;
      var itemClass = VueCompositionAPI.computed(function () {
        return getCascaderItemClass(classPrefix.value, props2.node, SIZE.value, STATUS.value, props2.cascaderContext);
      });
      var iconClass = VueCompositionAPI.computed(function () {
        return getCascaderItemIconClass(classPrefix.value, props2.node, STATUS.value, props2.cascaderContext);
      });
      return {
        COMPONENT_NAME: COMPONENT_NAME,
        ChevronRightIcon: ChevronRightIcon,
        iconClass: iconClass,
        itemClass: itemClass
      };
    },
    render: function render() {
      var _this = this;
      var h = arguments[0];
      var iconClass = this.iconClass,
        cascaderContext = this.cascaderContext,
        itemClass = this.itemClass,
        node = this.node,
        optionChild = this.optionChild,
        COMPONENT_NAME = this.COMPONENT_NAME,
        onChange = this.onChange,
        ChevronRightIcon = this.ChevronRightIcon;
      function RenderLabelInner(node2, cascaderContext2) {
        var inputVal = cascaderContext2.inputVal;
        var labelText = inputVal ? getFullPathLabel(node2) : node2.label;
        if (inputVal) {
          var texts = labelText.split(inputVal);
          var doms = [];
          for (var index = 0; index < texts.length; index++) {
            doms.push(h("span", {
              "key": index
            }, [texts[index]]));
            if (index === texts.length - 1) break;
            doms.push(h("span", {
              "key": "".concat(index, "filter"),
              "class": "".concat(COMPONENT_NAME, "-label--filter")
            }, [inputVal]));
          }
          return doms;
        }
        return labelText;
      }
      function RenderLabelContent(node2, cascaderContext2) {
        var label = RenderLabelInner(node2, cascaderContext2);
        var labelCont = h("span", {
          "attrs": {
            "title": cascaderContext2.inputVal ? getFullPathLabel(node2) : node2.label,
            "role": "label"
          },
          "class": ["".concat(COMPONENT_NAME, "-label"), "".concat(COMPONENT_NAME, "-label--ellipsis")]
        }, [label]);
        return labelCont;
      }
      function RenderCheckBox(node2, cascaderContext2) {
        var checkProps = cascaderContext2.checkProps,
          value = cascaderContext2.value,
          max = cascaderContext2.max,
          inputVal = cascaderContext2.inputVal;
        var label = RenderLabelInner(node2, cascaderContext2);
        return h(Checkbox, helper([{
          "attrs": {
            "checked": node2.checked,
            "indeterminate": node2.indeterminate,
            "disabled": node2.isDisabled() || value.length >= max && max !== 0,
            "name": String(node2.value),
            "title": inputVal ? getFullPathLabel(node2) : node2.label,
            "stopLabelTrigger": !!node2.children
          },
          "on": {
            "change": function change(vale, _ref) {
              var e = _ref.e;
              e.stopPropagation();
              onChange();
            }
          }
        }, checkProps]), [label]);
      }
      return h("li", {
        "class": itemClass,
        "on": {
          "click": function click(e) {
            e.stopPropagation();
            _this.onClick();
          },
          "mouseenter": function mouseenter(e) {
            e.stopPropagation();
            _this.onMouseenter();
          }
        }
      }, [optionChild || (cascaderContext.multiple ? RenderCheckBox(node, cascaderContext) : RenderLabelContent(node, cascaderContext)), node.children && (node.loading ? h(Loading, {
        "class": iconClass,
        "attrs": {
          "size": "small"
        }
      }) : h(ChevronRightIcon, {
        "class": iconClass
      }))]);
    }
  });

  var props$I = {
    autofocus: Boolean,
    borderless: Boolean,
    checkProps: {
      type: Object
    },
    checkStrictly: Boolean,
    clearable: Boolean,
    collapsedItems: {
      type: Function
    },
    disabled: Boolean,
    empty: {
      type: [String, Function]
    },
    filter: {
      type: Function
    },
    filterable: Boolean,
    inputProps: {
      type: Object
    },
    keys: {
      type: Object
    },
    label: {
      type: [String, Function]
    },
    lazy: {
      type: Boolean,
      "default": true
    },
    load: {
      type: Function
    },
    loading: Boolean,
    loadingText: {
      type: [String, Function]
    },
    max: {
      type: Number,
      "default": 0
    },
    minCollapsedNum: {
      type: Number,
      "default": 0
    },
    multiple: Boolean,
    option: {
      type: Function
    },
    options: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    placeholder: {
      type: String,
      "default": void 0
    },
    popupProps: {
      type: Object
    },
    popupVisible: Boolean,
    readonly: Boolean,
    reserveKeyword: Boolean,
    selectInputProps: {
      type: Object
    },
    showAllLevels: {
      type: Boolean,
      "default": true
    },
    size: {
      type: String,
      "default": "medium",
      validator: function validator(val) {
        if (!val) return true;
        return ["large", "medium", "small"].includes(val);
      }
    },
    status: {
      type: String,
      "default": "default",
      validator: function validator(val) {
        if (!val) return true;
        return ["default", "success", "warning", "error"].includes(val);
      }
    },
    suffix: {
      type: [String, Function]
    },
    suffixIcon: {
      type: Function
    },
    tagInputProps: {
      type: Object
    },
    tagProps: {
      type: Object
    },
    tips: {
      type: [String, Function]
    },
    trigger: {
      type: String,
      "default": "click",
      validator: function validator(val) {
        if (!val) return true;
        return ["click", "hover"].includes(val);
      }
    },
    value: {
      type: [String, Number, Array],
      "default": function _default() {
        return [];
      }
    },
    defaultValue: {
      type: [String, Number, Array],
      "default": function _default() {
        return [];
      }
    },
    valueDisplay: {
      type: [String, Function]
    },
    valueMode: {
      type: String,
      "default": "onlyLeaf",
      validator: function validator(val) {
        if (!val) return true;
        return ["onlyLeaf", "parentFirst", "all"].includes(val);
      }
    },
    valueType: {
      type: String,
      "default": "single",
      validator: function validator(val) {
        if (!val) return true;
        return ["single", "full"].includes(val);
      }
    },
    onBlur: Function,
    onChange: Function,
    onFocus: Function,
    onPopupVisibleChange: Function,
    onRemove: Function
  };

  function expendClickEffect(propsTrigger, trigger, node, cascaderContext) {
    var checkStrictly = cascaderContext.checkStrictly,
      multiple = cascaderContext.multiple,
      treeStore = cascaderContext.treeStore,
      setVisible = cascaderContext.setVisible,
      setValue = cascaderContext.setValue,
      setTreeNodes = cascaderContext.setTreeNodes,
      setExpend = cascaderContext.setExpend,
      value = cascaderContext.value,
      max = cascaderContext.max,
      valueType = cascaderContext.valueType,
      filterable = cascaderContext.filterable,
      inputVal = cascaderContext.inputVal;
    var isDisabled = node.disabled || multiple && value.length >= max && max !== 0;
    var isFiltering = filterable && inputVal && multiple;
    if (isDisabled || isFiltering) return;
    if (propsTrigger === trigger) {
      var expanded = node.setExpanded(true);
      treeStore.refreshNodes();
      treeStore.replaceExpanded(expanded);
      var nodes = treeStore.getNodes().filter(function (node2) {
        return node2.visible;
      });
      setTreeNodes(nodes);
      if (multiple) {
        setExpend(expanded);
      }
    }
    if (!multiple && (node.isLeaf() || checkStrictly) && trigger === "click") {
      treeStore.resetChecked();
      var checked = node.setChecked(!node.checked);
      var _checked = _slicedToArray(checked, 1),
        value2 = _checked[0];
      setValue(valueType === "single" ? value2 : node.getPath().map(function (item) {
        return item.value;
      }), "check", node.getModel());
      if (!checkStrictly || propsTrigger === "hover") {
        setVisible(false, {});
      }
    }
  }
  function valueChangeEffect(node, cascaderContext) {
    var disabled = cascaderContext.disabled,
      max = cascaderContext.max,
      inputVal = cascaderContext.inputVal,
      multiple = cascaderContext.multiple,
      setVisible = cascaderContext.setVisible,
      setValue = cascaderContext.setValue,
      treeNodes = cascaderContext.treeNodes,
      treeStore = cascaderContext.treeStore,
      valueType = cascaderContext.valueType;
    if (!node || disabled || node.disabled) {
      return;
    }
    var checked = node.setChecked(!node.isChecked());
    if (isNumber(max) && max < 0) {
      console.warn("TDesign Warn:", "max should > 0");
    }
    if (checked.length > max && isNumber(max) && max > 0) {
      return;
    }
    if (checked.length === 0) {
      var expanded = treeStore.getExpanded();
      setTimeout(function () {
        treeStore.replaceExpanded(expanded);
        treeStore.refreshNodes();
      }, 0);
    }
    if (!multiple) {
      setVisible(false, {});
    }
    var isSelectAll = treeNodes.every(function (item) {
      return checked.indexOf(item.value) > -1;
    });
    if (inputVal && isSelectAll) {
      setVisible(false, {});
    }
    var resValue = valueType === "single" ? checked : checked.map(function (val) {
      return treeStore.getNode(val).getPath().map(function (item) {
        return item.value;
      });
    });
    setValue(resValue, node.checked ? "uncheck" : "check", node.getModel());
  }
  function closeIconClickEffect(cascaderContext) {
    var setVisible = cascaderContext.setVisible,
      multiple = cascaderContext.multiple,
      setExpend = cascaderContext.setExpend,
      setValue = cascaderContext.setValue;
    setVisible(false, {});
    if (multiple) {
      setExpend([]);
    }
    setValue(multiple ? [] : "", "clear");
  }
  function handleRemoveTagEffect(cascaderContext, index, onRemove) {
    var disabled = cascaderContext.disabled,
      setValue = cascaderContext.setValue,
      value = cascaderContext.value,
      valueType = cascaderContext.valueType,
      treeStore = cascaderContext.treeStore;
    if (disabled) return;
    if (index !== void 0) {
      var newValue = cloneDeep(value);
      var res = newValue.splice(index, 1);
      var node = treeStore.getNodes(res[0])[0];
      var checked = node.setChecked(!node.isChecked());
      var resValue = valueType === "single" ? checked : checked.map(function (val) {
        return treeStore.getNode(val).getPath().map(function (item) {
          return item.value;
        });
      });
      setValue(resValue, "uncheck", node.getModel());
      if (isFunction(onRemove)) {
        onRemove({
          value: checked,
          node: node
        });
      }
    } else if (isFunction(onRemove)) {
      onRemove({
        value: value,
        node: void 0
      });
    }
  }
  var treeNodesEffect = function treeNodesEffect(inputVal, treeStore, setTreeNodes, filter) {
    if (!treeStore) return;
    var nodes = [];
    if (inputVal) {
      var filterMethods = function filterMethods(node) {
        if (!node.isLeaf()) return;
        if (isFunction(filter)) {
          return filter("".concat(inputVal), node);
        }
        var fullPathLabel = getFullPathLabel(node, "");
        return fullPathLabel.indexOf("".concat(inputVal)) > -1;
      };
      nodes = treeStore.nodes.filter(filterMethods);
    } else {
      nodes = treeStore.getNodes().filter(function (node) {
        return node.visible;
      });
    }
    setTreeNodes(nodes);
  };
  var treeStoreExpendEffect = function treeStoreExpendEffect(treeStore, value, expend) {
    var treeValue = getTreeValue(value);
    if (!treeStore) return;
    if (Array.isArray(treeValue) && expend.length === 0) {
      var expandedMap = /* @__PURE__ */new Map();
      var _treeValue = _slicedToArray(treeValue, 1),
        val = _treeValue[0];
      if (val) {
        expandedMap.set(val, true);
        var node = treeStore.getNode(val);
        if (!node) {
          treeStore.refreshNodes();
          return;
        }
        node.getParents().forEach(function (tn) {
          expandedMap.set(tn.value, true);
        });
        var expandedArr = Array.from(expandedMap.keys());
        treeStore.replaceExpanded(expandedArr);
      } else {
        treeStore.resetExpanded();
      }
    }
    if (treeStore.getExpanded() && expend.length) {
      treeStore.replaceExpanded(expend);
    }
    treeStore.refreshNodes();
  };

  function ownKeys$1$(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1_(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1$(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1$(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var Panel = VueCompositionAPI.defineComponent({
    name: "TCascaderSubPanel",
    props: {
      option: props$I.option,
      empty: props$I.empty,
      trigger: props$I.trigger,
      onChange: props$I.onChange,
      loading: props$I.loading,
      loadingText: props$I.loadingText,
      cascaderContext: {
        type: Object
      }
    },
    setup: function setup(props, _ref) {
      var _treeStore$config;
      var emit = _ref.emit;
      var renderTNodeJSXDefault = useTNodeDefault();
      var COMPONENT_NAME = usePrefixClass("cascader");
      var _useConfig = useConfig("cascader"),
        global = _useConfig.global;
      var _props$cascaderContex = props.cascaderContext,
        valueType = _props$cascaderContex.valueType,
        cascaderValue = _props$cascaderContex.cascaderValue,
        treeStore = _props$cascaderContex.treeStore,
        multiple = _props$cascaderContex.multiple;
      var panels = VueCompositionAPI.computed(function () {
        return getPanels(props.cascaderContext.treeNodes);
      });
      var handleExpand = function handleExpand(node, trigger) {
        var propsTrigger = props.trigger,
          cascaderContext = props.cascaderContext;
        expendClickEffect(propsTrigger, trigger, node, cascaderContext);
      };
      if (treeStore !== null && treeStore !== void 0 && (_treeStore$config = treeStore.config) !== null && _treeStore$config !== void 0 && _treeStore$config.load && valueType === "full" && cascaderValue.length > 0) {
        var firstValue = multiple ? cascaderValue[0][0] : cascaderValue[0];
        var firstExpandNode = treeStore.nodes.find(function (node) {
          return node.value === firstValue;
        });
        handleExpand(firstExpandNode, "click");
      }
      return {
        global: global,
        panels: panels,
        handleExpand: handleExpand,
        renderTNodeJSXDefault: renderTNodeJSXDefault,
        COMPONENT_NAME: COMPONENT_NAME,
        emit: emit
      };
    },
    render: function render() {
      var _this = this;
      var h = arguments[0];
      var global = this.global,
        COMPONENT_NAME = this.COMPONENT_NAME,
        handleExpand = this.handleExpand,
        renderTNodeJSXDefault = this.renderTNodeJSXDefault,
        cascaderContext = this.cascaderContext,
        panels = this.panels,
        emit = this.emit;
      var renderItem = function renderItem(node, index) {
        var optionChild = node.data.content ? getDefaultNode(node.data.content(_this.$createElement)) : renderTNodeJSXDefault("option", {
          params: {
            item: node.data,
            index: index
          }
        });
        return h(Item, {
          "key": node.value,
          "attrs": {
            "node": node,
            "cascaderContext": cascaderContext
          },
          "props": _objectSpread$1_({}, {
            node: node,
            optionChild: optionChild,
            cascaderContext: cascaderContext,
            onClick: function onClick() {
              emit("click", node.value, node);
              handleExpand(node, "click");
            },
            onMouseenter: function onMouseenter() {
              handleExpand(node, "hover");
            },
            onChange: function onChange() {
              valueChangeEffect(node, cascaderContext);
            }
          })
        });
      };
      var renderList = function renderList(treeNodes) {
        var isFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var segment = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
        return h("ul", {
          "class": ["".concat(COMPONENT_NAME, "__menu"), "narrow-scrollbar", _defineProperty$2(_defineProperty$2({}, "".concat(COMPONENT_NAME, "__menu--segment"), segment), "".concat(COMPONENT_NAME, "__menu--filter"), isFilter)],
          "key": "".concat(COMPONENT_NAME, "__menu").concat(index)
        }, [treeNodes.map(function (node) {
          return renderItem(node, index);
        })]);
      };
      var renderEmpty = function renderEmpty() {
        if (_this.empty && typeof _this.empty === "string") {
          return h("div", {
            "class": "".concat(COMPONENT_NAME, "__panel--empty")
          }, [_this.empty]);
        }
        return renderTNodeJSXDefault("empty", h("div", {
          "class": "".concat(COMPONENT_NAME, "__panel--empty")
        }, [global.empty]));
      };
      var renderPanels = function renderPanels() {
        var inputVal = cascaderContext.inputVal,
          treeNodes = cascaderContext.treeNodes;
        return inputVal ? renderList(treeNodes, true) : panels.map(function (treeNodes2, index) {
          return renderList(treeNodes2, false, index !== panels.length - 1, index);
        });
      };
      var content;
      if (this.loading) {
        content = renderTNodeJSXDefault("loadingText", h("div", {
          "class": "".concat(COMPONENT_NAME, "__panel--empty")
        }, [global.loadingText]));
      } else {
        content = panels.length ? renderPanels() : renderEmpty();
      }
      return h("div", {
        "class": ["".concat(COMPONENT_NAME, "__panel"), _defineProperty$2({}, "".concat(COMPONENT_NAME, "--normal"), panels.length && !this.loading)]
      }, [content]);
    }
  });

  function mitt (n) {
    return {
      all: n = n || new Map(),
      on: function on(t, e) {
        var i = n.get(t);
        i ? i.push(e) : n.set(t, [e]);
      },
      off: function off(t, e) {
        var i = n.get(t);
        i && (e ? i.splice(i.indexOf(e) >>> 0, 1) : n.set(t, []));
      },
      emit: function emit(t, e) {
        var i = n.get(t);
        i && i.slice().map(function (n) {
          n(e);
        }), (i = n.get("*")) && i.slice().map(function (n) {
          n(t, e);
        });
      }
    };
  }

  var nodeKey = "__tdesign_tree-node__";
  var TreeNodeModel = /*#__PURE__*/function () {
    function TreeNodeModel(node) {
      _classCallCheck(this, TreeNodeModel);
      _defineProperty$2(this, nodeKey, void 0);
      this[nodeKey] = node;
    }
    return _createClass(TreeNodeModel, [{
      key: "value",
      get: function get() {
        var node = this[nodeKey];
        return node.value;
      }
    }, {
      key: "label",
      get: function get() {
        var node = this[nodeKey];
        return node.label;
      }
    }, {
      key: "data",
      get: function get() {
        var node = this[nodeKey];
        return node.data;
      }
    }, {
      key: "actived",
      get: function get() {
        var node = this[nodeKey];
        return node.actived;
      }
    }, {
      key: "expanded",
      get: function get() {
        var node = this[nodeKey];
        return node.expanded;
      }
    }, {
      key: "checked",
      get: function get() {
        var node = this[nodeKey];
        return node.checked;
      }
    }, {
      key: "indeterminate",
      get: function get() {
        var node = this[nodeKey];
        return node.indeterminate;
      }
    }, {
      key: "loading",
      get: function get() {
        var node = this[nodeKey];
        return node.loading;
      }
    }, {
      key: "disabled",
      get: function get() {
        var node = this[nodeKey];
        return node.isDisabled();
      }
    }, {
      key: "getLevel",
      value: function getLevel() {
        var node = this[nodeKey];
        return node.getLevel();
      }
    }, {
      key: "getIndex",
      value: function getIndex() {
        var node = this[nodeKey];
        return node.getIndex();
      }
    }, {
      key: "isFirst",
      value: function isFirst() {
        var node = this[nodeKey];
        return node.isFirst();
      }
    }, {
      key: "isLast",
      value: function isLast() {
        var node = this[nodeKey];
        return node.isLast();
      }
    }, {
      key: "isLeaf",
      value: function isLeaf() {
        var node = this[nodeKey];
        return node.isLeaf();
      }
    }, {
      key: "insertBefore",
      value: function insertBefore(newData) {
        var node = this[nodeKey];
        return node.insertBefore(newData);
      }
    }, {
      key: "insertAfter",
      value: function insertAfter(newData) {
        var node = this[nodeKey];
        return node.insertAfter(newData);
      }
    }, {
      key: "appendData",
      value: function appendData(data) {
        var node = this[nodeKey];
        return node.append(data);
      }
    }, {
      key: "getPath",
      value: function getPath() {
        var node = this[nodeKey];
        var nodes = node.getPath();
        return nodes.map(function (item) {
          return item.getModel();
        });
      }
    }, {
      key: "getParent",
      value: function getParent() {
        var _node$parent;
        var node = this[nodeKey];
        return (_node$parent = node.parent) === null || _node$parent === void 0 ? void 0 : _node$parent.getModel();
      }
    }, {
      key: "getParents",
      value: function getParents() {
        var node = this[nodeKey];
        var nodes = node.getParents();
        return nodes.map(function (item) {
          return item.getModel();
        });
      }
    }, {
      key: "getRoot",
      value: function getRoot() {
        var node = this[nodeKey];
        var root = node.getRoot();
        return root === null || root === void 0 ? void 0 : root.getModel();
      }
    }, {
      key: "getSiblings",
      value: function getSiblings() {
        var node = this[nodeKey];
        var nodes = node.getSiblings();
        return nodes.map(function (item) {
          return item.getModel();
        });
      }
    }, {
      key: "getChildren",
      value: function getChildren(deep) {
        var node = this[nodeKey];
        var childrenModel = false;
        var children = node.children;
        if (Array.isArray(children)) {
          if (children.length > 0) {
            if (deep) {
              var nodes = node.walk();
              nodes.shift();
              childrenModel = nodes.map(function (item) {
                return item.getModel();
              });
            } else {
              childrenModel = children.map(function (item) {
                return item.getModel();
              });
            }
          } else {
            childrenModel = false;
          }
        } else if (isBoolean(children)) {
          childrenModel = children;
        }
        return childrenModel;
      }
    }, {
      key: "remove",
      value: function remove(value) {
        var node = this[nodeKey];
        if (!value) {
          node.remove();
          return;
        }
        var tree = node.tree;
        var targetNode = tree.getNode(value);
        if (!targetNode) {
          log.warnOnce("Tree", "`".concat(value, "` is not exist"));
          return;
        }
        var parents = targetNode.getParents();
        var parentValues = parents.map(function (pnode) {
          return pnode.value;
        });
        if (parentValues.indexOf(node.value) < 0) {
          log.warnOnce("Tree", "`".concat(value, "` is not a childNode of current node"));
          return;
        }
        targetNode.remove();
      }
    }, {
      key: "setData",
      value: function setData(data) {
        var node = this[nodeKey];
        var syncAttrs = ["value", "label", "disabled"];
        var cleanData = omit$2(data, ["children"].concat(syncAttrs));
        var keys = node.tree.config.keys;
        syncAttrs.forEach(function (attr) {
          var dataAttrValue = get(data, (keys === null || keys === void 0 ? void 0 : keys[attr]) || attr);
          if (!isUndefined(dataAttrValue)) cleanData[attr] = dataAttrValue;
        });
        Object.assign(node.data, cleanData);
        Object.assign(node, cleanData);
        node.update();
      }
    }]);
  }();
  function createNodeModel(node) {
    var model = new TreeNodeModel(node);
    return model;
  }

  function ownKeys$1_(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1Z(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1_(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1_(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var settableStatus = {
    expandMutex: null,
    activable: null,
    checkable: null,
    draggable: null,
    loading: false
  };
  var settableProps = Object.keys(settableStatus);
  var syncableProps = [].concat(settableProps, ["actived", "expanded", "checked"]);
  var privateKey = "__tdesign_id__";
  var TreeNode = /*#__PURE__*/function () {
    function TreeNode(tree, data, parent) {
      var _this = this;
      _classCallCheck(this, TreeNode);
      _defineProperty$2(this, "tree", void 0);
      _defineProperty$2(this, privateKey, void 0);
      _defineProperty$2(this, "value", void 0);
      _defineProperty$2(this, "label", void 0);
      _defineProperty$2(this, "data", void 0);
      _defineProperty$2(this, "parent", void 0);
      _defineProperty$2(this, "children", void 0);
      _defineProperty$2(this, "model", void 0);
      _defineProperty$2(this, "vmIsLeaf", void 0);
      _defineProperty$2(this, "vmIsFirst", void 0);
      _defineProperty$2(this, "vmIsLast", void 0);
      _defineProperty$2(this, "vmIsRest", void 0);
      _defineProperty$2(this, "vmIsLocked", void 0);
      _defineProperty$2(this, "expanded", void 0);
      _defineProperty$2(this, "expandMutex", void 0);
      _defineProperty$2(this, "actived", void 0);
      _defineProperty$2(this, "activable", void 0);
      _defineProperty$2(this, "checkable", void 0);
      _defineProperty$2(this, "vmCheckable", void 0);
      _defineProperty$2(this, "checked", void 0);
      _defineProperty$2(this, "indeterminate", void 0);
      _defineProperty$2(this, "disabled", void 0);
      _defineProperty$2(this, "draggable", void 0);
      _defineProperty$2(this, "visible", void 0);
      _defineProperty$2(this, "level", void 0);
      _defineProperty$2(this, "loading", void 0);
      this.data = data;
      this.tree = tree;
      var config = tree.config || {};
      var prefix = config.prefix || "t";
      var keys = config.keys || {};
      var propChildren = keys.children || "children";
      var propLabel = keys.label || "label";
      var propValue = keys.value || "value";
      var propDisabled = keys.disabled || "disabled";
      this.model = null;
      this.children = null;
      this.level = 0;
      this.vmCheckable = false;
      this.vmIsLeaf = false;
      this.vmIsFirst = false;
      this.vmIsLast = false;
      this.vmIsRest = false;
      this.vmIsLocked = false;
      this.visible = false;
      this.actived = false;
      this.checked = false;
      this.indeterminate = false;
      this.loading = false;
      this.expanded = config.expandAll;
      this.activable = null;
      this.checkable = null;
      this.expandMutex = null;
      this.draggable = null;
      this[privateKey] = uniqueId(prefix);
      this.value = isNil(get(data, propValue)) ? this[privateKey] : get(data, propValue);
      var nodeMap = tree.nodeMap,
        privateMap = tree.privateMap;
      if (nodeMap.get(this.value)) {
        log.warn("Tree", "Dulplicate value: ".concat(this.value));
      }
      nodeMap.set(this.value, this);
      privateMap.set(this[privateKey], this);
      this.label = get(data, propLabel) || "";
      this.disabled = get(data, propDisabled) || false;
      var children = data[propChildren];
      if (children === true) {
        this.children = children;
      }
      if (parent && parent instanceof TreeNode) {
        this.parent = parent;
      } else {
        this.parent = null;
      }
      syncableProps.forEach(function (prop) {
        if (typeof data[prop] !== "undefined") {
          _this[prop] = data[prop];
        }
      });
      this.initActived();
      this.initExpanded();
      if (Array.isArray(children)) {
        this.append(children);
      } else if (children === true && !config.lazy) {
        this.loadChildren();
      }
      this.initChecked();
      this.updateChecked();
      this.update();
      tree.reflow(this);
    }
    return _createClass(TreeNode, [{
      key: "initChecked",
      value: function initChecked() {
        var tree = this.tree,
          value = this.value,
          parent = this.parent;
        var checkedMap = tree.checkedMap;
        var checkStrictly = tree.config.checkStrictly;
        if (this.checked) {
          checkedMap.set(value, true);
        }
        if (!checkStrictly && parent !== null && parent !== void 0 && parent.checked) {
          checkedMap.set(value, true);
        }
      }
    }, {
      key: "initExpanded",
      value: function initExpanded() {
        var tree = this.tree;
        var expanded = this.expanded;
        var config = tree.config;
        if (isNumber(config.expandLevel) && this.getLevel() < config.expandLevel) {
          tree.expandedMap.set(this.value, true);
          expanded = true;
        }
        if (this.children === true && config.lazy) {
          expanded = false;
        }
        if (expanded) {
          tree.expandedMap.set(this.value, true);
        } else {
          tree.expandedMap["delete"](this.value);
        }
        this.expanded = expanded;
      }
    }, {
      key: "initActived",
      value: function initActived() {
        var tree = this.tree,
          actived = this.actived;
        if (actived && this.isActivable()) {
          tree.activedMap.set(this.value, true);
        }
      }
    }, {
      key: "append",
      value: function append(data) {
        var _this2 = this;
        var list = [];
        if (!Array.isArray(data)) {
          list.push(data);
        } else {
          list.push.apply(list, _toConsumableArray(data));
        }
        if (list.length <= 0) {
          return;
        }
        if (!Array.isArray(this.children)) {
          this.children = [];
        }
        var children = this.children,
          tree = this.tree;
        list.forEach(function (item) {
          var node = null;
          if (item instanceof TreeNode) {
            node = item;
            node.appendTo(_this2.tree, _this2);
          } else {
            node = new TreeNode(_this2.tree, item, _this2);
            children.push(node);
          }
        });
        tree.reflow(this);
        this.updateRelated();
      }
    }, {
      key: "appendTo",
      value: function appendTo(tree, parent, index) {
        var _this3 = this;
        var parentNode = parent;
        var targetIndex = -1;
        if (isNumber(index)) {
          targetIndex = index;
        }
        var targetParents = (parentNode === null || parentNode === void 0 ? void 0 : parentNode.getParents()) || [];
        var includeCurrent = targetParents.some(function (pnode) {
          return pnode === _this3;
        });
        if (includeCurrent) {
          throw new Error("\u65E0\u6CD5\u5C06\u7236\u8282\u70B9\u63D2\u5165\u5230\u5B50\u8282\u70B9");
        }
        if (parentNode === this) {
          throw new Error("\u65E0\u6CD5\u5C06\u8282\u70B9\u63D2\u5165\u5230\u672C\u8282\u70B9");
        }
        if (Array.isArray(parentNode === null || parentNode === void 0 ? void 0 : parentNode.children)) {
          var targetPosNode = parentNode === null || parentNode === void 0 ? void 0 : parentNode.children[targetIndex];
          if (targetPosNode && targetPosNode === this) {
            return;
          }
        }
        var siblings = null;
        if (parentNode instanceof TreeNode) {
          if (!Array.isArray(parentNode === null || parentNode === void 0 ? void 0 : parentNode.children)) {
            parentNode.children = [];
          }
          siblings = parent.children;
        } else {
          siblings = tree.children;
        }
        if (!Array.isArray(siblings)) {
          throw new Error("\u65E0\u6CD5\u63D2\u5165\u5230\u76EE\u6807\u4F4D\u7F6E\uFF0C\u53EF\u63D2\u5165\u7684\u8282\u70B9\u5217\u8868\u4E0D\u5B58\u5728");
        }
        var prevLength = siblings.length;
        var prevIndex = this.getIndex();
        this.remove();
        if (isNumber(index)) {
          var targetIndex2 = index;
          if (parentNode === this.parent) {
            var curLength = siblings.length;
            if (curLength < prevLength && prevIndex <= targetIndex2) {
              targetIndex2 -= 1;
            }
          }
          siblings.splice(targetIndex2, 0, this);
        } else {
          siblings.push(this);
        }
        this.parent = parentNode;
        var nodes = this.walk();
        nodes.forEach(function (item) {
          var node = item;
          node.tree = tree;
          tree.nodeMap.set(node.value, node);
          tree.privateMap.set(node[privateKey], node);
          if (node.expanded) {
            tree.expandedMap.set(node.value, true);
          }
        });
        var updateNodes = (parentNode === null || parentNode === void 0 ? void 0 : parentNode.walk()) || tree.children.map(function (item) {
          return item.walk();
        }).flat();
        updateNodes.forEach(function (node) {
          node.update();
          node.updateChecked();
        });
        tree.reflow();
      }
    }, {
      key: "insert",
      value: function insert(item, index) {
        var tree = this.tree,
          parent = this.parent;
        var siblings = this.getSiblings();
        var node = null;
        if (item instanceof TreeNode) {
          node = item;
          node.appendTo(tree, parent, index);
        } else if (item) {
          node = new TreeNode(tree, item, parent);
          if (isNumber(index)) {
            siblings.splice(index, 0, node);
          }
          siblings.forEach(function (sibling) {
            sibling.update();
          });
        }
        tree.reflow();
      }
    }, {
      key: "insertBefore",
      value: function insertBefore(newData) {
        var index = this.getIndex();
        this.insert(newData, index);
      }
    }, {
      key: "insertAfter",
      value: function insertAfter(newData) {
        var index = this.getIndex();
        this.insert(newData, index + 1);
      }
    }, {
      key: "remove",
      value: function remove() {
        var tree = this.tree;
        var nodes = this.walk();
        var siblings = this.getSiblings();
        var index = this.getIndex();
        if (Array.isArray(siblings)) {
          siblings.splice(index, 1);
        }
        nodes.forEach(function (node) {
          node.clean();
        });
        siblings.forEach(function (node) {
          node.update();
        });
        this.updateParents();
        tree.reflow();
      }
    }, {
      key: "clean",
      value: function clean() {
        var tree = this.tree,
          value = this.value;
        tree.activedMap["delete"](value);
        tree.checkedMap["delete"](value);
        tree.expandedMap["delete"](value);
        tree.nodeMap["delete"](value);
        tree.filterMap["delete"](value);
        tree.privateMap["delete"](this[privateKey]);
      }
    }, {
      key: "loadChildren",
      value: function () {
        var _loadChildren = _asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee() {
          var config, list;
          return regenerator.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                config = get(this, "tree.config") || {};
                if (!(this.children === true && !this.loading)) {
                  _context.next = 13;
                  break;
                }
                if (!isFunction(config.load)) {
                  _context.next = 13;
                  break;
                }
                this.loading = true;
                this.update();
                list = [];
                _context.next = 8;
                return config.load(this);
              case 8:
                list = _context.sent;
                this.tree.emit("load", {
                  node: this,
                  data: list
                });
                this.loading = false;
                if (Array.isArray(list) && list.length > 0) {
                  this.append(list);
                } else {
                  this.children = false;
                }
                this.update();
              case 13:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
        function loadChildren() {
          return _loadChildren.apply(this, arguments);
        }
        return loadChildren;
      }()
    }, {
      key: "set",
      value: function set(item) {
        var _this4 = this;
        var tree = this.tree;
        var keys = Object.keys(item);
        keys.forEach(function (key) {
          if (hasOwnProperty.call(settableStatus, key) || key === "label") {
            _this4[key] = item[key];
          }
          if (key === "disabled") {
            _this4.setDisabled(item[key]);
          }
        });
        tree.updated(this);
      }
    }, {
      key: "getParent",
      value: function getParent() {
        return this.parent;
      }
    }, {
      key: "getParents",
      value: function getParents() {
        var parents = [];
        var node = this.parent;
        while (node) {
          parents.push(node);
          node = node.parent;
        }
        return parents;
      }
    }, {
      key: "getSiblings",
      value: function getSiblings() {
        var parent = this.parent,
          tree = this.tree;
        var list = [];
        if (parent) {
          if (Array.isArray(parent.children)) {
            list = parent.children;
          }
        } else if (tree) {
          list = tree.children;
        }
        return list;
      }
    }, {
      key: "getChildren",
      value: function getChildren(deep) {
        var childrenModel = false;
        var children = this.children;
        if (Array.isArray(children)) {
          if (children.length > 0) {
            if (deep) {
              var nodes = this.walk();
              nodes.shift();
              childrenModel = nodes.map(function (item) {
                return item.getModel();
              });
            } else {
              childrenModel = children.map(function (item) {
                return item.getModel();
              });
            }
          } else {
            childrenModel = false;
          }
        } else if (isBoolean(children)) {
          childrenModel = children;
        }
        return childrenModel;
      }
    }, {
      key: "getRoot",
      value: function getRoot() {
        var parents = this.getParents();
        return parents[parents.length - 1] || null;
      }
    }, {
      key: "getIndex",
      value: function getIndex() {
        var list = this.getSiblings();
        return list.indexOf(this);
      }
    }, {
      key: "getPath",
      value: function getPath() {
        var nodes = this.getParents();
        nodes.unshift(this);
        return nodes.reverse();
      }
    }, {
      key: "getLevel",
      value: function getLevel() {
        var parents = this.getParents();
        return parents.length;
      }
    }, {
      key: "isRest",
      value: function isRest() {
        var _this$tree = this.tree,
          config = _this$tree.config,
          filterMap = _this$tree.filterMap,
          hasFilter = _this$tree.hasFilter;
        var rest = false;
        if (hasFilter) {
          var nodeModel = this.getModel();
          rest = config.filter(nodeModel);
        }
        if (rest) {
          filterMap.set(this.value, true);
        } else if (filterMap.get(this.value)) {
          filterMap["delete"](this.value);
        }
        return rest;
      }
    }, {
      key: "isVisible",
      value: function isVisible() {
        var _this$tree2 = this.tree,
          nodeMap = _this$tree2.nodeMap,
          hasFilter = _this$tree2.hasFilter,
          config = _this$tree2.config;
        var allowFoldNodeOnFilter = config.allowFoldNodeOnFilter;
        var visible = true;
        if (!nodeMap.get(this.value)) {
          return false;
        }
        if (hasFilter && !allowFoldNodeOnFilter) {
          visible = this.vmIsLocked || this.vmIsRest;
          return visible;
        }
        var expandVisible = true;
        var parents = this.getParents();
        if (parents.length > 0) {
          expandVisible = parents.every(function (node) {
            return node.expanded;
          });
        }
        if (hasFilter) {
          visible = expandVisible && (this.vmIsRest || this.vmIsLocked);
        } else {
          visible = expandVisible;
        }
        return visible;
      }
    }, {
      key: "isDisabledState",
      value: function isDisabledState() {
        var tree = this.tree,
          parent = this.parent;
        var config = tree.config;
        var disabled = config.disabled,
          disableCheck = config.disableCheck,
          checkStrictly = config.checkStrictly;
        var state = disabled || false;
        if (this.disabled) {
          state = true;
        }
        if (!checkStrictly && parent !== null && parent !== void 0 && parent.isDisabledState()) {
          state = true;
        }
        if (typeof disableCheck === "boolean") {
          if (disableCheck) {
            state = true;
          }
        } else if (typeof disableCheck === "function") {
          if (disableCheck(this.getModel())) {
            state = true;
          }
        }
        return state;
      }
    }, {
      key: "isDisabled",
      value: function isDisabled() {
        var tree = this.tree;
        var hasFilter = tree.hasFilter,
          config = tree.config;
        var allowFoldNodeOnFilter = config.allowFoldNodeOnFilter;
        if (hasFilter && !allowFoldNodeOnFilter && this.vmIsLocked && !this.vmIsRest) {
          return true;
        }
        return this.isDisabledState();
      }
    }, {
      key: "isDraggable",
      value: function isDraggable() {
        var state = !!get(this, "tree.config.draggable");
        if (typeof this.draggable === "boolean") {
          state = this.draggable;
        }
        return state;
      }
    }, {
      key: "isExpandMutex",
      value: function isExpandMutex() {
        var state = !!get(this, "tree.config.expandMutex");
        if (typeof this.expandMutex === "boolean") {
          state = this.expandMutex;
        }
        return state;
      }
    }, {
      key: "isActivable",
      value: function isActivable() {
        var state = !!get(this, "tree.config.activable");
        if (typeof this.activable === "boolean") {
          state = this.activable;
        }
        return state;
      }
    }, {
      key: "isCheckable",
      value: function isCheckable() {
        var state = !!get(this, "tree.config.checkable");
        if (typeof this.checkable === "boolean") {
          state = this.checkable;
        }
        return state;
      }
    }, {
      key: "isActived",
      value: function isActived(map) {
        var tree = this.tree,
          value = this.value;
        var activedMap = map || tree.activedMap;
        return !!(tree.nodeMap.get(value) && activedMap.get(value));
      }
    }, {
      key: "isExpanded",
      value: function isExpanded(map) {
        var tree = this.tree,
          value = this.value,
          vmIsLocked = this.vmIsLocked;
        var hasFilter = tree.hasFilter,
          config = tree.config;
        var allowFoldNodeOnFilter = config.allowFoldNodeOnFilter;
        if (hasFilter && !allowFoldNodeOnFilter && vmIsLocked) return true;
        var expandedMap = map || tree.expandedMap;
        return !!(tree.nodeMap.get(value) && expandedMap.get(value));
      }
    }, {
      key: "isChecked",
      value: function isChecked(map) {
        var children = this.children,
          tree = this.tree,
          value = this.value;
        var _tree$config = tree.config,
          checkStrictly = _tree$config.checkStrictly,
          valueMode = _tree$config.valueMode;
        if (!tree.nodeMap.get(value)) return false;
        if (!this.isCheckable()) return false;
        var checkedMap = map || tree.checkedMap;
        if (checkStrictly) {
          return !!checkedMap.get(value);
        }
        var checked = false;
        if (checkedMap.get(value) && (valueMode !== "onlyLeaf" || this.isLeaf())) {
          return true;
        }
        if (Array.isArray(children) && children.length > 0) {
          checked = children.every(function (node) {
            var childIsChecked = node.isChecked(checkedMap);
            return childIsChecked;
          });
        } else {
          var parents = this.getParents();
          checked = parents.some(function (node) {
            return checkedMap.get(node.value);
          });
        }
        return checked;
      }
    }, {
      key: "isIndeterminate",
      value: function isIndeterminate() {
        var children = this.children,
          tree = this.tree,
          value = this.value;
        var checkStrictly = tree.config.checkStrictly;
        if (!tree.nodeMap.get(value)) return false;
        if (!this.isCheckable()) return false;
        if (checkStrictly) return false;
        if (!Array.isArray(children)) return false;
        var childChecked = null;
        var indeterminate = children.some(function (node) {
          if (node.isIndeterminate()) {
            return true;
          }
          if (isNull(childChecked)) {
            childChecked = node.isChecked();
          }
          if (childChecked !== node.isChecked()) {
            return true;
          }
          return false;
        });
        return indeterminate;
      }
    }, {
      key: "isFirst",
      value: function isFirst() {
        var siblings = this.getSiblings();
        return siblings[0] === this;
      }
    }, {
      key: "isLast",
      value: function isLast() {
        var siblings = this.getSiblings();
        return siblings[siblings.length - 1] === this;
      }
    }, {
      key: "isLeaf",
      value: function isLeaf() {
        var isLeaf = false;
        if (Array.isArray(this.children)) {
          isLeaf = this.children.length <= 0;
        } else {
          isLeaf = !this.children;
        }
        return isLeaf;
      }
    }, {
      key: "lock",
      value: function lock(lockState) {
        this.vmIsLocked = lockState;
        this.expanded = this.isExpanded();
        this.visible = this.isVisible();
      }
    }, {
      key: "afterExpanded",
      value: function afterExpanded() {
        this.update();
        if (this.expanded && this.children === true) {
          this.loadChildren();
        }
        this.updateChildren();
      }
    }, {
      key: "toggleExpanded",
      value: function toggleExpanded(opts) {
        return this.setExpanded(!this.isExpanded(), opts);
      }
    }, {
      key: "setExpanded",
      value: function setExpanded(expanded, opts) {
        var tree = this.tree;
        var config = tree.config;
        var options = _objectSpread$1Z({
          directly: false
        }, opts);
        var map = tree.expandedMap;
        if (!options.directly) {
          map = new Map(tree.expandedMap);
        }
        if (expanded) {
          var shouldExpandNodes = [];
          shouldExpandNodes.push(this);
          if (config.expandParent) {
            this.getParents().forEach(function (node) {
              shouldExpandNodes.push(node);
            });
          }
          shouldExpandNodes.forEach(function (node) {
            var isExpandMutex = false;
            if (node.parent) {
              isExpandMutex = node.parent.isExpandMutex();
            } else {
              var _tree$config2;
              isExpandMutex = tree === null || tree === void 0 || (_tree$config2 = tree.config) === null || _tree$config2 === void 0 ? void 0 : _tree$config2.expandMutex;
            }
            if (isExpandMutex) {
              var siblings = node.getSiblings();
              siblings.forEach(function (snode) {
                map["delete"](snode.value);
                snode.update();
                snode.updateChildren();
              });
            }
            map.set(node.value, true);
            node.update();
            node.updateChildren();
          });
        } else {
          map["delete"](this.value);
        }
        if (options.directly) {
          this.afterExpanded();
        }
        return tree.getExpanded(map);
      }
    }, {
      key: "toggleActived",
      value: function toggleActived(opts) {
        return this.setActived(!this.isActived(), opts);
      }
    }, {
      key: "setActived",
      value: function setActived(actived, opts) {
        var tree = this.tree;
        var options = _objectSpread$1Z({
          isAction: true,
          directly: false
        }, opts);
        var config = tree.config || {};
        var map = tree.activedMap;
        if (!options.directly) {
          map = new Map(tree.activedMap);
        }
        if (options.isAction && this.isDisabledState()) {
          return tree.getActived(map);
        }
        if (this.isActivable()) {
          if (actived) {
            var prevKeys = Array.from(map.keys());
            if (!config.activeMultiple) {
              map.clear();
            }
            prevKeys.forEach(function (value) {
              var node = tree.getNode(value);
              node === null || node === void 0 || node.update();
            });
            map.set(this.value, true);
          } else {
            map["delete"](this.value);
          }
        }
        this.update();
        return tree.getActived(map);
      }
    }, {
      key: "hasEnableUnCheckedChild",
      value: function hasEnableUnCheckedChild() {
        var children = this.children;
        if (!Array.isArray(children) || children.length <= 0) {
          return false;
        }
        var state = false;
        children.some(function (child) {
          if (child.isDisabledState()) return false;
          if (child.isChecked()) return false;
          if (child.isIndeterminate()) {
            if (child.hasEnableUnCheckedChild()) {
              state = true;
              return true;
            }
            return false;
          }
          state = true;
          return true;
        });
        return state;
      }
    }, {
      key: "toggleChecked",
      value: function toggleChecked(opts) {
        if (this.isIndeterminate()) {
          var expectState = this.hasEnableUnCheckedChild();
          return this.setChecked(expectState, opts);
        }
        return this.setChecked(!this.isChecked(), opts);
      }
    }, {
      key: "setChecked",
      value: function setChecked(checked, opts) {
        var tree = this.tree;
        var config = tree.config || {};
        var options = _objectSpread$1Z({
          isAction: true,
          directly: false
        }, opts);
        var map = tree.checkedMap;
        if (!options.directly) {
          map = new Map(tree.checkedMap);
        }
        if (!this.isCheckable()) {
          return tree.getChecked(map);
        }
        if (options.isAction && this.isDisabledState()) {
          return tree.getChecked(map);
        }
        if (checked === this.isChecked()) {
          var shouldSet = this.isIndeterminate() && !this.hasEnableUnCheckedChild();
          if (!shouldSet) {
            return tree.getChecked(map);
          }
        }
        if (checked) {
          map.set(this.value, true);
        } else {
          map["delete"](this.value);
        }
        if (config.checkStrictly) {
          if (options.directly) {
            this.updateChecked();
          }
        } else {
          this.spreadChildrenChecked(checked, map, options);
          this.spreadParentChecked(checked, map, options);
          if (options.directly) {
            var relatedNodes = tree.getRelatedNodes([this.value], {
              reverse: true
            });
            relatedNodes.forEach(function (node) {
              node.updateChecked();
            });
          }
        }
        return tree.getChecked(map);
      }
    }, {
      key: "spreadParentChecked",
      value: function spreadParentChecked(checked, map, opts) {
        var options = _objectSpread$1Z({
          isAction: true,
          directly: false
        }, opts);
        if (!this.isCheckable()) return;
        var children = this.children;
        if (Array.isArray(children) && children.length > 0) {
          map["delete"](this.value);
        }
        var parent = this.parent;
        if (!parent) return;
        parent.spreadParentChecked(checked, map, options);
      }
    }, {
      key: "spreadChildrenChecked",
      value: function spreadChildrenChecked(checked, map, opts) {
        var options = _objectSpread$1Z({
          isAction: true,
          directly: false
        }, opts);
        if (!this.isCheckable()) return;
        if (options.isAction && this.isDisabledState()) return;
        var children = this.children;
        if (!Array.isArray(children)) return;
        if (children.length <= 0) return;
        map["delete"](this.value);
        children.forEach(function (node) {
          if (options.isAction && node.isDisabledState()) return;
          if (checked) {
            map.set(node.value, true);
          } else {
            map["delete"](node.value);
          }
          node.spreadChildrenChecked(checked, map, options);
        });
      }
    }, {
      key: "setDisabled",
      value: function setDisabled(disabled) {
        this.disabled = disabled;
        this.update();
        this.updateChildren();
      }
    }, {
      key: "update",
      value: function update() {
        this.level = this.getLevel();
        this.vmIsFirst = this.isFirst();
        this.vmIsLast = this.isLast();
        this.vmIsLeaf = this.isLeaf();
        this.vmCheckable = this.isCheckable();
        this.vmIsRest = this.isRest();
        this.actived = this.isActived();
        this.expanded = this.isExpanded();
        this.visible = this.isVisible();
        this.tree.updated(this);
      }
    }, {
      key: "updateChecked",
      value: function updateChecked() {
        var tree = this.tree,
          value = this.value;
        var checkedMap = tree.checkedMap;
        this.checked = this.isChecked();
        this.indeterminate = this.isIndeterminate();
        if (this.checked) {
          checkedMap.set(value, true);
        }
        tree.updated(this);
      }
    }, {
      key: "updateChildren",
      value: function updateChildren() {
        var _this5 = this;
        this.spreadChildren(function (node) {
          if (node === _this5) return;
          node.update();
          node.updateChecked();
        });
      }
    }, {
      key: "updateParents",
      value: function updateParents() {
        var _this6 = this;
        this.spreadParents(function (node) {
          if (node === _this6) return;
          node.update();
          node.updateChecked();
        });
      }
    }, {
      key: "updateRelated",
      value: function updateRelated() {
        var tree = this.tree;
        var relatedNodes = tree.getRelatedNodes([this.value]);
        relatedNodes.forEach(function (node) {
          node.update();
          node.updateChecked();
        });
      }
    }, {
      key: "walk",
      value: function walk() {
        var list = [];
        this.spreadChildren(function (node) {
          list.push(node);
        });
        return list;
      }
    }, {
      key: "spreadChildren",
      value: function spreadChildren(fn) {
        fn(this);
        var children = this.children;
        if (Array.isArray(children) && children.length > 0) {
          children.forEach(function (node) {
            node === null || node === void 0 || node.spreadChildren(fn);
          });
        }
      }
    }, {
      key: "spreadParents",
      value: function spreadParents(fn) {
        fn(this);
        var parent = this.parent;
        if (!parent) return;
        parent === null || parent === void 0 || parent.spreadParents(fn);
      }
    }, {
      key: "getModel",
      value: function getModel() {
        var model = this.model;
        if (!model) {
          model = createNodeModel(this);
          this.model = model;
        }
        return model;
      }
    }]);
  }();

  function ownKeys$1Z(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1Y(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1Z(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1Z(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function nextTick(fn) {
    var pm = Promise.resolve();
    pm.then(fn);
    return pm;
  }
  var TreeStore = /*#__PURE__*/function () {
    function TreeStore(options) {
      _classCallCheck(this, TreeStore);
      _defineProperty$2(this, "children", void 0);
      _defineProperty$2(this, "nodes", void 0);
      _defineProperty$2(this, "nodeMap", void 0);
      _defineProperty$2(this, "privateMap", void 0);
      _defineProperty$2(this, "config", void 0);
      _defineProperty$2(this, "activedMap", void 0);
      _defineProperty$2(this, "updatedMap", void 0);
      _defineProperty$2(this, "checkedMap", void 0);
      _defineProperty$2(this, "expandedMap", void 0);
      _defineProperty$2(this, "filterMap", void 0);
      _defineProperty$2(this, "hasFilter", void 0);
      _defineProperty$2(this, "emitter", void 0);
      _defineProperty$2(this, "updateTick", void 0);
      _defineProperty$2(this, "shouldReflow", void 0);
      _defineProperty$2(this, "prevFilter", void 0);
      var config = _objectSpread$1Y({
        prefix: "t",
        keys: {},
        expandAll: false,
        expandLevel: 0,
        expandMutex: false,
        expandParent: false,
        activable: false,
        activeMultiple: false,
        checkable: false,
        checkStrictly: false,
        disabled: false,
        disableCheck: false,
        draggable: false,
        load: null,
        lazy: false,
        valueMode: "onlyLeaf",
        filter: null,
        allowFoldNodeOnFilter: false,
        onLoad: null,
        onReflow: null,
        onUpdate: null
      }, options);
      this.config = config;
      this.nodes = [];
      this.children = [];
      this.nodeMap = /* @__PURE__ */new Map();
      this.privateMap = /* @__PURE__ */new Map();
      this.activedMap = /* @__PURE__ */new Map();
      this.expandedMap = /* @__PURE__ */new Map();
      this.checkedMap = /* @__PURE__ */new Map();
      this.updatedMap = /* @__PURE__ */new Map();
      this.filterMap = /* @__PURE__ */new Map();
      this.prevFilter = null;
      this.updateTick = null;
      this.shouldReflow = false;
      this.hasFilter = isFunction(config.filter);
      this.emitter = mitt();
    }
    return _createClass(TreeStore, [{
      key: "setConfig",
      value: function setConfig(options) {
        var config = this.config;
        var hasChanged = false;
        Object.keys(options).forEach(function (key) {
          var val = options[key];
          if (val !== config[key]) {
            hasChanged = true;
            config[key] = val;
          }
        });
        this.hasFilter = isFunction(config.filter);
        if (hasChanged) {
          this.refreshState();
        }
      }
    }, {
      key: "getChildren",
      value: function getChildren() {
        return this.children;
      }
    }, {
      key: "getNode",
      value: function getNode(item) {
        var node = null;
        if (isString(item) || isNumber(item)) {
          node = this.nodeMap.get(item);
        } else if (item instanceof TreeNode) {
          node = this.nodeMap.get(item.value);
        }
        if (!node) node = null;
        return node;
      }
    }, {
      key: "getIndex",
      value: function getIndex(node) {
        return this.nodes.indexOf(node);
      }
    }, {
      key: "getParent",
      value: function getParent(value) {
        var parent = null;
        var node = this.getNode(value);
        if (node) {
          parent = node.getParent();
        }
        return parent;
      }
    }, {
      key: "getParents",
      value: function getParents(value) {
        var node = this.getNode(value);
        var parents = [];
        if (node) {
          parents = node.getParents();
        }
        return parents;
      }
    }, {
      key: "getNodeIndex",
      value: function getNodeIndex(value) {
        var node = this.getNode(value);
        var index = -1;
        if (node) {
          index = node.getIndex();
        }
        return index;
      }
    }, {
      key: "getNodes",
      value: function getNodes(item, options) {
        var nodes = [];
        var val = "";
        if (isString(item) || isNumber(item)) {
          val = item;
        } else if (item instanceof TreeNode) {
          val = item.value;
        }
        if (!val && val !== 0) {
          nodes = this.nodes.slice(0);
        } else {
          var node = this.getNode(val);
          if (node) {
            nodes = node.walk();
          }
        }
        if (options) {
          var conf = _objectSpread$1Y({
            filter: null,
            level: Infinity
          }, options);
          if (isNumber(conf.level) && conf.level !== Infinity) {
            nodes = nodes.filter(function (node) {
              return node.level <= conf.level;
            });
          }
          if (isFunction(conf.filter)) {
            nodes = nodes.filter(function (node) {
              var nodeModel = node.getModel();
              return conf.filter(nodeModel);
            });
          }
          if (isPlainObject(conf.props)) {
            nodes = nodes.filter(function (node) {
              var result = Object.keys(conf.props).every(function (key) {
                var propEqual = node[key] === conf.props[key];
                return propEqual;
              });
              return result;
            });
          }
        }
        return nodes;
      }
    }, {
      key: "append",
      value: function append(list) {
        var _this = this;
        list.forEach(function (item) {
          var node = new TreeNode(_this, item);
          _this.children.push(node);
        });
        this.reflow();
      }
    }, {
      key: "reload",
      value: function reload(list) {
        this.removeAll();
        this.append(list);
      }
    }, {
      key: "parseNodeData",
      value: function parseNodeData(para, item) {
        var value = "";
        var node = null;
        var data = null;
        if (isString(para) || isNumber(para)) {
          value = para;
          node = this.getNode(value);
          data = item;
        } else if (para instanceof TreeNode) {
          if (item) {
            node = para;
            data = item;
          } else {
            data = para;
          }
        } else {
          data = para;
        }
        var spec = {
          node: node,
          data: data
        };
        return spec;
      }
    }, {
      key: "appendNodes",
      value: function appendNodes(para, item) {
        var spec = this.parseNodeData(para, item);
        if (spec.data) {
          if (!spec.node) {
            if (spec.data instanceof TreeNode) {
              spec.data.appendTo(this);
            } else if (Array.isArray(spec.data)) {
              this.append(spec.data);
            } else {
              this.append([spec.data]);
            }
          } else {
            if (spec.data instanceof TreeNode) {
              spec.data.appendTo(this, spec.node);
            } else if (isArray$1(spec.data)) {
              spec.node.append(spec.data);
            } else {
              spec.node.append([spec.data]);
            }
            spec.node.updateRelated();
          }
        }
      }
    }, {
      key: "insertBefore",
      value: function insertBefore(value, item) {
        var node = this.getNode(value);
        if (node) {
          node.insertBefore(item);
        }
      }
    }, {
      key: "insertAfter",
      value: function insertAfter(value, item) {
        var node = this.getNode(value);
        if (node) {
          node.insertAfter(item);
        }
      }
    }, {
      key: "refreshNodes",
      value: function refreshNodes() {
        var children = this.children,
          nodes = this.nodes;
        nodes.length = 0;
        children.forEach(function (node) {
          var list = node.walk();
          Array.prototype.push.apply(nodes, list);
        });
      }
    }, {
      key: "reflow",
      value: function reflow(node) {
        this.shouldReflow = true;
        this.updated(node);
      }
    }, {
      key: "updated",
      value: function updated(node) {
        var _this2 = this;
        var updatedMap = this.updatedMap;
        if (node) {
          updatedMap.set(node[privateKey], "changed");
        } else {
          this.getNodes().forEach(function (itemNode) {
            updatedMap.set(itemNode[privateKey], "changed");
          });
        }
        if (this.updateTick) return;
        this.updateTick = nextTick(function () {
          _this2.updateTick = null;
          if (_this2.shouldReflow) {
            _this2.refreshNodes();
            _this2.emit("reflow");
          }
          _this2.lockFilterPathNodes();
          var stateId = "t".concat(new Date().getTime());
          var updatedList = Array.from(updatedMap.keys());
          var updatedNodes = updatedList.map(function (nodePrivateKey) {
            updatedMap.set(nodePrivateKey, stateId);
            return _this2.privateMap.get(nodePrivateKey);
          });
          _this2.emit("update", {
            nodes: updatedNodes,
            map: updatedMap
          });
          _this2.shouldReflow = false;
          updatedMap.clear();
        });
      }
    }, {
      key: "getActived",
      value: function getActived(map) {
        var activedMap = map || this.activedMap;
        return Array.from(activedMap.keys());
      }
    }, {
      key: "getActivedNodes",
      value: function getActivedNodes(item) {
        var nodes = this.getNodes(item);
        nodes = nodes.filter(function (node) {
          return node.isActived();
        });
        return nodes;
      }
    }, {
      key: "replaceActived",
      value: function replaceActived(list) {
        this.resetActived();
        this.setActived(list);
      }
    }, {
      key: "setActived",
      value: function setActived(actived) {
        var _this3 = this;
        var activeMultiple = this.config.activeMultiple;
        var list = actived.slice(0);
        if (!activeMultiple) {
          list.length = 1;
        }
        list.forEach(function (val) {
          _this3.activedMap.set(val, true);
          var node = _this3.getNode(val);
          if (node) {
            node.update();
          }
        });
      }
    }, {
      key: "resetActived",
      value: function resetActived() {
        var actived = this.getActived();
        this.activedMap.clear();
        var relatedNodes = this.getRelatedNodes(actived);
        relatedNodes.forEach(function (node) {
          node.update();
        });
      }
    }, {
      key: "getExpanded",
      value: function getExpanded(map) {
        var expandedMap = map || this.expandedMap;
        return Array.from(expandedMap.keys());
      }
    }, {
      key: "replaceExpanded",
      value: function replaceExpanded(list) {
        var expanded = this.getExpanded();
        var added = difference$1(list, expanded);
        var removed = difference$1(expanded, list);
        this.setExpandedDirectly(removed, false);
        this.updateExpanded(removed);
        this.setExpanded(added);
      }
    }, {
      key: "setExpanded",
      value: function setExpanded(list) {
        this.setExpandedDirectly(list);
        this.updateExpanded(list);
      }
    }, {
      key: "setExpandedDirectly",
      value: function setExpandedDirectly(list) {
        var _this4 = this;
        var expanded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        list.forEach(function (val) {
          if (expanded) {
            _this4.expandedMap.set(val, true);
          } else {
            _this4.expandedMap["delete"](val);
          }
          var node = _this4.getNode(val);
          if (node) {
            node.afterExpanded();
          }
        });
      }
    }, {
      key: "resetExpanded",
      value: function resetExpanded() {
        var expanded = this.getExpanded();
        this.expandedMap.clear();
        this.updateExpanded(expanded);
      }
    }, {
      key: "updateExpanded",
      value: function updateExpanded(list) {
        var relatedNodes = this.getRelatedNodes(list, {
          withParents: false
        });
        relatedNodes.forEach(function (node) {
          node.update();
        });
      }
    }, {
      key: "getChecked",
      value: function getChecked(map) {
        var nodeMap = this.nodeMap,
          config = this.config;
        var valueMode = config.valueMode,
          checkStrictly = config.checkStrictly;
        var list = [];
        var checkedMap = map || this.checkedMap;
        nodeMap.forEach(function (node) {
          if (!node.isChecked(checkedMap)) return;
          if (valueMode === "parentFirst" && !checkStrictly) {
            if (!node.parent || !node.parent.isChecked(checkedMap)) {
              list.push(node.value);
            }
          } else if (valueMode === "onlyLeaf" && !checkStrictly) {
            if (node.isLeaf()) {
              list.push(node.value);
            }
          } else {
            list.push(node.value);
          }
        });
        return list;
      }
    }, {
      key: "getCheckedNodes",
      value: function getCheckedNodes(item) {
        var nodes = this.getNodes(item);
        nodes = nodes.filter(function (node) {
          return node.isChecked();
        });
        return nodes;
      }
    }, {
      key: "replaceChecked",
      value: function replaceChecked(list) {
        this.resetChecked();
        this.setChecked(list);
      }
    }, {
      key: "setChecked",
      value: function setChecked(list) {
        var _this5 = this;
        var _this$config = this.config,
          checkStrictly = _this$config.checkStrictly,
          checkable = _this$config.checkable;
        if (!checkable) return;
        list.forEach(function (val) {
          var node = _this5.getNode(val);
          if (!node) return;
          if (checkStrictly) {
            _this5.checkedMap.set(val, true);
            node.updateChecked();
          } else {
            var childrenNodes = node.walk();
            childrenNodes.forEach(function (childNode) {
              _this5.checkedMap.set(childNode.value, true);
            });
          }
        });
        if (!checkStrictly) {
          var checkedValues = this.getChecked();
          var relatedNodes = this.getRelatedNodes(checkedValues);
          relatedNodes.forEach(function (node) {
            node.updateChecked();
          });
        }
      }
    }, {
      key: "resetChecked",
      value: function resetChecked() {
        var checked = this.getChecked();
        var relatedNodes = this.getRelatedNodes(checked);
        this.checkedMap.clear();
        relatedNodes.forEach(function (node) {
          node.updateChecked();
        });
      }
    }, {
      key: "refreshState",
      value: function refreshState() {
        var nodeMap = this.nodeMap;
        nodeMap.forEach(function (node) {
          node.update();
        });
      }
    }, {
      key: "updateAll",
      value: function updateAll() {
        var nodeMap = this.nodeMap;
        nodeMap.forEach(function (node) {
          node.update();
          node.updateChecked();
        });
      }
    }, {
      key: "remove",
      value: function remove(value) {
        var node = this.getNode(value);
        if (node) {
          node.remove();
        }
      }
    }, {
      key: "removeAll",
      value: function removeAll() {
        this.expandedMap.clear();
        this.checkedMap.clear();
        this.activedMap.clear();
        this.filterMap.clear();
        this.nodeMap.clear();
        this.privateMap.clear();
        this.updatedMap.clear();
        this.nodes = [];
        this.children = [];
        this.reflow();
      }
    }, {
      key: "getRelatedNodes",
      value: function getRelatedNodes(list, options) {
        var _this6 = this;
        var conf = _objectSpread$1Y({
          reverse: false,
          withParents: true
        }, options);
        var map = /* @__PURE__ */new Map();
        list.forEach(function (value) {
          if (map.get(value)) return;
          var node = _this6.getNode(value);
          if (node) {
            var parents = node.getParents().reverse();
            var children = node.walk();
            var related = [];
            if (conf.withParents) {
              related = parents.concat(children);
            } else {
              related = children;
            }
            related.forEach(function (relatedNode) {
              map.set(relatedNode.value, relatedNode);
            });
          }
        });
        var relatedNodes = Array.from(map.values());
        if (conf.reverse) {
          relatedNodes = relatedNodes.reverse();
        }
        return relatedNodes;
      }
    }, {
      key: "emit",
      value: function emit(name, state) {
        var config = this.config,
          emitter = this.emitter;
        var methodName = camelCase$1("on-".concat(name));
        var method = config[methodName];
        if (isFunction(method)) {
          method(state);
        }
        emitter.emit(name, state);
      }
    }, {
      key: "lockFilterPathNodes",
      value: function lockFilterPathNodes() {
        var config = this.config;
        var allNodes = this.getNodes();
        if (this.prevFilter) {
          allNodes.forEach(function (node) {
            if (node.vmIsLocked) {
              node.lock(false);
            }
          });
        }
        var currentFilter = config.filter;
        if (!currentFilter || !isFunction(currentFilter)) return;
        this.prevFilter = config.filter;
        allNodes.reverse().forEach(function (node) {
          var parent = node.getParent();
          if (!parent) return;
          if (node.vmIsRest || node.vmIsLocked) {
            if (!parent.vmIsLocked) {
              parent.lock(true);
            }
          }
        });
      }
    }]);
  }();

  function ownKeys$1Y(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1X(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1Y(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1Y(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var useContext = function useContext(props, setInnerValue, innerPopupVisible, setPopupVisible) {
    var statusContext = VueCompositionAPI.reactive({
      treeStore: null,
      inputVal: null,
      scopeVal: void 0,
      treeNodes: [],
      expend: []
    });
    return {
      statusContext: statusContext,
      cascaderContext: VueCompositionAPI.computed(function () {
        var size = props.size,
          checkStrictly = props.checkStrictly,
          lazy = props.lazy,
          multiple = props.multiple,
          filterable = props.filterable,
          clearable = props.clearable,
          checkProps = props.checkProps,
          max = props.max,
          disabled = props.disabled,
          showAllLevels = props.showAllLevels,
          minCollapsedNum = props.minCollapsedNum,
          valueType = props.valueType,
          value = props.value;
        return _objectSpread$1X(_objectSpread$1X({
          value: statusContext.scopeVal,
          size: size,
          checkStrictly: checkStrictly,
          lazy: lazy,
          multiple: multiple,
          filterable: filterable,
          clearable: clearable,
          checkProps: checkProps,
          max: max,
          disabled: disabled,
          showAllLevels: showAllLevels,
          minCollapsedNum: minCollapsedNum,
          valueType: valueType,
          visible: innerPopupVisible.value,
          cascaderValue: value
        }, statusContext), {}, {
          setTreeNodes: function setTreeNodes(nodes) {
            statusContext.treeNodes = nodes;
          },
          setValue: function setValue(val, source, node) {
            if (isEqual(val, value)) return;
            setInnerValue(val, {
              source: source,
              node: node
            });
          },
          setVisible: setPopupVisible,
          setInputVal: function setInputVal(val) {
            statusContext.inputVal = val;
          },
          setExpend: function setExpend(val) {
            statusContext.expend = val;
          }
        });
      })
    };
  };
  var useCascaderContext = function useCascaderContext(props) {
    var disabled = props.disabled;
    var _toRefs = VueCompositionAPI.toRefs(props),
      value = _toRefs.value,
      popupVisible = _toRefs.popupVisible;
    var _useVModel = useVModel$1(value, props.defaultValue, props.onChange, "change"),
      _useVModel2 = _slicedToArray(_useVModel, 2),
      innerValue = _useVModel2[0],
      setInnerValue = _useVModel2[1];
    var _useDefaultValue = useDefaultValue(popupVisible, false, props.onPopupVisibleChange, "popupVisible", "popup-visible-change"),
      _useDefaultValue2 = _slicedToArray(_useDefaultValue, 2),
      innerPopupVisible = _useDefaultValue2[0],
      setPopupVisible = _useDefaultValue2[1];
    var _useContext = useContext(props, setInnerValue, innerPopupVisible, setPopupVisible),
      cascaderContext = _useContext.cascaderContext,
      statusContext = _useContext.statusContext;
    var isFilterable = VueCompositionAPI.computed(function () {
      return Boolean(props.filterable || isFunction(props.filter));
    });
    var updatedTreeNodes = function updatedTreeNodes() {
      var _cascaderContext$valu = cascaderContext.value,
        inputVal = _cascaderContext$valu.inputVal,
        treeStore = _cascaderContext$valu.treeStore,
        setTreeNodes = _cascaderContext$valu.setTreeNodes;
      treeNodesEffect(inputVal, treeStore, setTreeNodes, props.filter);
    };
    var updateExpend = function updateExpend() {
      var _cascaderContext$valu2 = cascaderContext.value,
        value2 = _cascaderContext$valu2.value,
        treeStore = _cascaderContext$valu2.treeStore;
      var expend = statusContext.expend;
      treeStoreExpendEffect(treeStore, value2, expend);
      treeStore.replaceChecked(getTreeValue(value2));
    };
    var loadChildrenByValue = function loadChildrenByValue() {
      var value2 = props.value,
        multiple = props.multiple;
      var treeStore = statusContext.treeStore;
      if (value2 instanceof Array) {
        if (!multiple && value2.length > treeStore.expandedMap.size) {
          var expanded = value2.slice(0, treeStore.expandedMap.size + 1);
          treeStore.setExpanded(expanded);
        }
        if (multiple) {
          if (value2.length > 0) {
            var firstValue = value2[0];
            if (firstValue.length > treeStore.expandedMap.size) {
              treeStore.setExpanded(firstValue.slice(0, treeStore.expandedMap.size + 1));
            }
          }
          var lastValues = value2.map(function (item) {
            return item[item.length - 1];
          });
          treeStore.setChecked(lastValues);
        }
      }
    };
    VueCompositionAPI.watch(function () {
      return props.options;
    }, function () {
      var options = props.options,
        _props$keys = props.keys,
        keys = _props$keys === void 0 ? {} : _props$keys,
        checkStrictly = props.checkStrictly,
        lazy = props.lazy,
        load = props.load,
        valueMode = props.valueMode;
      var treeStore = statusContext.treeStore;
      if (!options.length && !treeStore) return;
      if (!treeStore) {
        var store = new TreeStore({
          keys: _objectSpread$1X(_objectSpread$1X({}, keys), {}, {
            children: typeof keys.children === "string" ? keys.children : "children"
          }),
          checkable: true,
          expandMutex: true,
          expandParent: true,
          checkStrictly: checkStrictly,
          lazy: lazy,
          load: load,
          valueMode: valueMode,
          onLoad: function onLoad() {
            VueCompositionAPI.nextTick(function () {
              store.refreshNodes();
              updatedTreeNodes();
              loadChildrenByValue();
            });
          }
        });
        store.append(options);
        statusContext.treeStore = store;
      } else {
        treeStore.reload(options);
        treeStore.refreshNodes();
      }
      updateExpend();
      updatedTreeNodes();
    }, {
      immediate: true,
      deep: true
    });
    VueCompositionAPI.watch(function () {
      var checkStrictly = props.checkStrictly,
        lazy = props.lazy,
        load = props.load,
        valueMode = props.valueMode;
      return JSON.stringify({
        valueMode: valueMode,
        checkStrictly: checkStrictly,
        lazy: lazy,
        load: load
      });
    }, function () {
      var treeStore = statusContext.treeStore;
      if (!treeStore) return;
      var checkStrictly = props.checkStrictly,
        lazy = props.lazy,
        load = props.load,
        valueMode = props.valueMode;
      var treeProps = {
        checkStrictly: checkStrictly,
        disabled: disabled,
        load: load,
        lazy: lazy,
        valueMode: valueMode
      };
      treeStore.setConfig(treeProps);
    }, {
      immediate: true
    });
    VueCompositionAPI.watch(innerValue, function () {
      var _cascaderContext$valu3 = cascaderContext.value,
        setValue = _cascaderContext$valu3.setValue,
        multiple = _cascaderContext$valu3.multiple,
        valueType = _cascaderContext$valu3.valueType;
      if (isValueInvalid(innerValue.value, cascaderContext.value)) {
        setValue(multiple ? [] : "", "invalid-value");
      }
      if (!isEmptyValues(innerValue)) {
        statusContext.scopeVal = getCascaderValue(innerValue.value, valueType, multiple);
      } else {
        statusContext.scopeVal = multiple ? [] : "";
      }
      if (!statusContext.treeStore) return;
      updateExpend();
      updatedTreeNodes();
    }, {
      immediate: true
    });
    VueCompositionAPI.watch(function () {
      return innerPopupVisible.value && isFilterable.value;
    }, function (visible) {
      var setInputVal = cascaderContext.value.setInputVal;
      if (visible) {
        setInputVal("");
      }
    });
    VueCompositionAPI.watch(function () {
      return statusContext.inputVal;
    }, function () {
      updatedTreeNodes();
    });
    var getCascaderItems = function getCascaderItems(arrValue) {
      var options = [];
      arrValue.forEach(function (value2) {
        var _statusContext$treeSt;
        var nodes = (_statusContext$treeSt = statusContext.treeStore) === null || _statusContext$treeSt === void 0 ? void 0 : _statusContext$treeSt.getNodes(value2);
        nodes && nodes[0] && options.push(nodes[0].data);
      });
      return options;
    };
    return {
      innerValue: innerValue,
      cascaderContext: cascaderContext,
      isFilterable: isFilterable,
      getCascaderItems: getCascaderItems
    };
  };

  function ownKeys$1X(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1W(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1X(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1X(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _Cascader = VueCompositionAPI.defineComponent({
    name: "TCascader",
    props: _objectSpread$1W({}, props$I),
    setup: function setup(props2, _ref) {
      var emit = _ref.emit;
      var COMPONENT_NAME = usePrefixClass("cascader");
      var classPrefix = usePrefixClass();
      var _useCommonClassName = useCommonClassName$1(),
        STATUS = _useCommonClassName.STATUS;
      var overlayClassName = usePrefixClass("cascader__popup");
      var _useConfig = useConfig("cascader"),
        global = _useConfig.global;
      var _useCascaderContext = useCascaderContext(props2),
        innerValue = _useCascaderContext.innerValue,
        cascaderContext = _useCascaderContext.cascaderContext,
        isFilterable = _useCascaderContext.isFilterable,
        getCascaderItems = _useCascaderContext.getCascaderItems;
      var displayValue = VueCompositionAPI.computed(function () {
        return props2.multiple ? getMultipleContent(cascaderContext.value) : getSingleContent(cascaderContext.value);
      });
      var panels = VueCompositionAPI.computed(function () {
        return getPanels(cascaderContext.value.treeNodes);
      });
      var inputPlaceholder = VueCompositionAPI.computed(function () {
        var _props2$placeholder;
        if (cascaderContext.value.visible && !props2.multiple) {
          var placeholder = getSingleContent(cascaderContext.value);
          if (typeof placeholder === "number") placeholder = String(placeholder);
          return placeholder;
        }
        return (_props2$placeholder = props2.placeholder) !== null && _props2$placeholder !== void 0 ? _props2$placeholder : global.value.placeholder;
      });
      var _useFormDisabled = useFormDisabled(),
        formDisabled = _useFormDisabled.formDisabled;
      var isDisabled = VueCompositionAPI.computed(function () {
        return formDisabled.value || cascaderContext.value.disabled;
      });
      var valueDisplayParams = VueCompositionAPI.computed(function () {
        var arrayValue = innerValue.value instanceof Array ? innerValue.value : [innerValue.value];
        var displayValue2 = props2.multiple && props2.minCollapsedNum ? arrayValue.slice(0, props2.minCollapsedNum) : innerValue.value;
        var options = getCascaderItems(arrayValue);
        return {
          value: innerValue.value,
          selectedOptions: options,
          onClose: function onClose(index) {
            handleRemoveTagEffect(cascaderContext.value, index, props2.onRemove);
          },
          displayValue: displayValue2
        };
      });
      var updateScrollTop = function updateScrollTop(content) {
        var cascaderMenuList = content.querySelectorAll(".".concat(COMPONENT_NAME.value, "__menu"));
        cascaderMenuList.forEach(function (menu) {
          var firstSelectedNode = (menu === null || menu === void 0 ? void 0 : menu.querySelector(".".concat(classPrefix.value, "-is-selected"))) || (menu === null || menu === void 0 ? void 0 : menu.querySelector(".".concat(classPrefix.value, "-is-expanded")));
          if (!firstSelectedNode || !menu) return;
          var _getComputedStyle = getComputedStyle(firstSelectedNode),
            paddingBottom = _getComputedStyle.paddingBottom;
          var _getComputedStyle2 = getComputedStyle(menu),
            marginBottom = _getComputedStyle2.marginBottom;
          var elementBottomHeight = parseInt(paddingBottom, 10) + parseInt(marginBottom, 10);
          var updateValue = firstSelectedNode.offsetTop - menu.offsetTop - (menu.clientHeight - firstSelectedNode.clientHeight) + elementBottomHeight;
          menu.scrollTop = updateValue;
        });
      };
      return {
        COMPONENT_NAME: COMPONENT_NAME,
        overlayClassName: overlayClassName,
        panels: panels,
        innerValue: innerValue,
        displayValue: displayValue,
        inputPlaceholder: inputPlaceholder,
        isFilterable: isFilterable,
        isDisabled: isDisabled,
        STATUS: STATUS,
        classPrefix: classPrefix,
        cascaderContext: cascaderContext,
        emit: emit,
        valueDisplayParams: valueDisplayParams,
        updateScrollTop: updateScrollTop
      };
    },
    render: function render() {
      var _this = this,
        _this$popupProps;
      var h = arguments[0];
      var valueDisplayParams = this.valueDisplayParams,
        COMPONENT_NAME = this.COMPONENT_NAME,
        overlayClassName = this.overlayClassName,
        panels = this.panels,
        displayValue = this.displayValue,
        inputPlaceholder = this.inputPlaceholder,
        isFilterable = this.isFilterable,
        isDisabled = this.isDisabled,
        STATUS = this.STATUS,
        classPrefix = this.classPrefix,
        cascaderContext = this.cascaderContext,
        emit = this.emit;
      var renderValueDisplay = function renderValueDisplay() {
        return renderTNodeJSX(_this, "valueDisplay", {
          params: valueDisplayParams
        });
      };
      var renderSuffixIcon = function renderSuffixIcon() {
        var suffixIcon = renderTNodeJSX(_this, "suffixIcon");
        if (suffixIcon) return suffixIcon;
        var visible2 = cascaderContext.visible;
        return h(FakeArrow, {
          "attrs": {
            "overlayClassName": getFakeArrowIconClass(classPrefix, STATUS, cascaderContext),
            "isActive": visible2,
            "disabled": isDisabled
          }
        });
      };
      var setVisible = cascaderContext.setVisible,
        visible = cascaderContext.visible,
        inputVal = cascaderContext.inputVal,
        setInputVal = cascaderContext.setInputVal;
      var slots = this.$scopedSlots;
      return h(SelectInput, {
        "class": COMPONENT_NAME,
        "props": _objectSpread$1W({}, _objectSpread$1W({
          value: displayValue,
          inputValue: visible ? inputVal : "",
          popupVisible: visible,
          keys: this.keys,
          allowInput: isFilterable,
          minCollapsedNum: this.minCollapsedNum,
          collapsedItems: this.collapsedItems,
          label: this.label,
          valueDisplay: renderValueDisplay,
          suffix: this.suffix,
          tag: this.tag,
          readonly: this.readonly,
          disabled: isDisabled,
          clearable: this.clearable,
          placeholder: inputPlaceholder,
          multiple: this.multiple,
          loading: this.loading,
          status: this.status,
          tips: this.tips,
          updateScrollTop: this.updateScrollTop,
          suffixIcon: function suffixIcon() {
            return renderSuffixIcon();
          },
          popupProps: _objectSpread$1W(_objectSpread$1W({}, this.popupProps), {}, {
            overlayInnerStyle: panels.length && !this.loading ? {
              width: "auto"
            } : "",
            overlayClassName: [overlayClassName, (_this$popupProps = this.popupProps) === null || _this$popupProps === void 0 ? void 0 : _this$popupProps.overlayClassName]
          }),
          inputProps: _objectSpread$1W({
            size: this.size
          }, this.inputProps),
          tagInputProps: _objectSpread$1W({
            size: this.size
          }, this.tagInputProps),
          tagProps: _objectSpread$1W({}, this.tagProps),
          onInputChange: function onInputChange(value, ctx) {
            var _this$selectInputProp, _this$selectInputProp2;
            if (!_this.isFilterable) return;
            setInputVal("".concat(value));
            _this === null || _this === void 0 || (_this$selectInputProp = _this.selectInputProps) === null || _this$selectInputProp === void 0 || (_this$selectInputProp2 = _this$selectInputProp.onInputChange) === null || _this$selectInputProp2 === void 0 || _this$selectInputProp2.call(_this$selectInputProp, value, ctx);
          },
          onTagChange: function onTagChange(val, ctx) {
            var _this$selectInputProp3, _this$selectInputProp4;
            if (ctx.trigger === "enter") return;
            handleRemoveTagEffect(cascaderContext, ctx.index, _this.onRemove);
            (_this$selectInputProp3 = _this.selectInputProps) === null || _this$selectInputProp3 === void 0 || (_this$selectInputProp4 = _this$selectInputProp3.onTagChange) === null || _this$selectInputProp4 === void 0 || _this$selectInputProp4.call(_this$selectInputProp3, val, ctx);
          },
          onPopupVisibleChange: function onPopupVisibleChange(val, context) {
            var _this$selectInputProp5, _this$selectInputProp6;
            if (_this.disabled) return;
            setVisible(val, context);
            (_this$selectInputProp5 = _this.selectInputProps) === null || _this$selectInputProp5 === void 0 || (_this$selectInputProp6 = _this$selectInputProp5.onPopupVisibleChange) === null || _this$selectInputProp6 === void 0 || _this$selectInputProp6.call(_this$selectInputProp5, val, context);
          },
          onBlur: function onBlur(val, context) {
            var _this$onBlur, _this$selectInputProp7, _this$selectInputProp8;
            var ctx = {
              value: cascaderContext.value,
              inputValue: context.inputValue || "",
              e: context.e
            };
            (_this$onBlur = _this.onBlur) === null || _this$onBlur === void 0 || _this$onBlur.call(_this, ctx);
            emit("blur", ctx);
            (_this$selectInputProp7 = _this.selectInputProps) === null || _this$selectInputProp7 === void 0 || (_this$selectInputProp8 = _this$selectInputProp7.onBlur) === null || _this$selectInputProp8 === void 0 || _this$selectInputProp8.call(_this$selectInputProp7, val, context);
          },
          onFocus: function onFocus(val, context) {
            var _this$onFocus, _this$selectInputProp9, _this$selectInputProp10;
            var ctx = {
              value: cascaderContext.value,
              e: context.e
            };
            (_this$onFocus = _this.onFocus) === null || _this$onFocus === void 0 || _this$onFocus.call(_this, ctx);
            emit("focus", ctx);
            (_this$selectInputProp9 = _this.selectInputProps) === null || _this$selectInputProp9 === void 0 || (_this$selectInputProp10 = _this$selectInputProp9.onFocus) === null || _this$selectInputProp10 === void 0 || _this$selectInputProp10.call(_this$selectInputProp9, val, context);
          },
          onClear: function onClear(context) {
            var _this$selectInputProp11, _this$selectInputProp12;
            closeIconClickEffect(cascaderContext);
            (_this$selectInputProp11 = _this.selectInputProps) === null || _this$selectInputProp11 === void 0 || (_this$selectInputProp12 = _this$selectInputProp11.onClear) === null || _this$selectInputProp12 === void 0 || _this$selectInputProp12.call(_this$selectInputProp11, context);
          }
        }, omit$2(this.selectInputProps, ["onTagChange", "onInputChange", "onPopupVisibleChange", "onBlur", "onFocus", "onClear"]))),
        "scopedSlots": {
          panel: function panel() {
            return h(Panel, {
              "attrs": {
                "option": _this.option,
                "empty": _this.empty,
                "trigger": _this.trigger,
                "loading": _this.loading,
                "loadingText": _this.loadingText,
                "cascaderContext": cascaderContext
              },
              "scopedSlots": {
                option: slots.option,
                empty: slots.empty,
                loadingText: slots.loadingText
              }
            });
          },
          tips: slots.tips,
          tag: slots.tag,
          suffix: slots.suffix,
          label: slots.label,
          collapsedItems: slots.collapsedItems
        }
      });
    }
  });

  function ownKeys$1W(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1V(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1W(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1W(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _CascaderPanel = VueCompositionAPI.defineComponent({
    name: "TCascaderPanel",
    props: _objectSpread$1V({}, props$I),
    setup: function setup(props2, _ref) {
      var slots = _ref.slots,
        emit = _ref.emit;
      var _useCascaderContext = useCascaderContext(props2),
        cascaderContext = _useCascaderContext.cascaderContext;
      var onClick = function onClick(value, node) {
        emit("click", value, node);
      };
      return {
        cascaderContext: cascaderContext,
        slots: slots,
        onClick: onClick
      };
    },
    render: function render() {
      var h = arguments[0];
      return h(Panel, {
        "attrs": {
          "empty": this.empty,
          "trigger": this.trigger,
          "cascaderContext": this.cascaderContext
        },
        "scopedSlots": {
          empty: this.slots.empty,
          option: this.slots.option,
          loadingText: this.slots.loadingText
        },
        "on": {
          "click": this.onClick
        }
      });
    }
  });

  var Cascader = withInstall$1(_Cascader, VueCompositionAPI__default["default"]);
  var CascaderPanel = withInstall$1(_CascaderPanel, VueCompositionAPI__default["default"]);

  var props$H = {
    borderless: Boolean,
    clearable: Boolean,
    closeBtn: {
      type: [String, Boolean, Function],
      "default": true
    },
    colorModes: {
      type: Array,
      "default": function _default() {
        return ["monochrome", "linear-gradient"];
      }
    },
    disabled: {
      type: Boolean,
      "default": void 0
    },
    enableAlpha: Boolean,
    enableMultipleGradient: {
      type: Boolean,
      "default": true
    },
    format: {
      type: String,
      "default": "RGB",
      validator: function validator(val) {
        if (!val) return true;
        return ["RGB", "RGBA", "HSL", "HSLA", "HSB", "HSV", "HSVA", "HEX", "CMYK", "CSS"].includes(val);
      }
    },
    inputProps: {
      type: Object
    },
    multiple: Boolean,
    popupProps: {
      type: Object
    },
    recentColors: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    defaultRecentColors: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    selectInputProps: {
      type: Object
    },
    showPrimaryColorPreview: {
      type: Boolean,
      "default": true
    },
    size: {
      type: String,
      "default": "medium",
      validator: function validator(val) {
        if (!val) return true;
        return ["small", "medium", "large"].includes(val);
      }
    },
    swatchColors: {
      type: Array
    },
    value: {
      type: String,
      "default": ""
    },
    defaultValue: {
      type: String,
      "default": ""
    },
    onChange: Function,
    onPaletteBarChange: Function,
    onRecentColorsChange: Function
  };

  var TD_COLOR_USED_COLORS_MAX_SIZE = 100;
  var COLOR_MODES = {
    monochrome: "singleColor",
    "linear-gradient": "gradientColor"
  };
  var DEFAULT_COLOR = "#001F97";
  var DEFAULT_LINEAR_GRADIENT = "linear-gradient(90deg, rgba(241,29,0,1) 0%, rgba(73,106,220,1) 100%);";
  var DEFAULT_SYSTEM_SWATCH_COLORS = ["#ECF2FE", "#D4E3FC", "#BBD3FB", "#96BBF8", "#699EF5", "#4787F0", "#266FE8", "#0052D9", "#0034B5", "#001F97", "#FDECEE", "#F9D7D9", "#F8B9BE", "#F78D94", "#F36D78", "#E34D59", "#C9353F", "#B11F26", "#951114", "#680506", "#FEF3E6", "#F9E0C7", "#F7C797", "#F2995F", "#ED7B2F", "#D35A21", "#BA431B", "#9E3610", "#842B0B", "#5A1907", "#E8F8F2", "#BCEBDC", "#85DBBE", "#48C79C", "#00A870", "#078D5C", "#067945", "#056334", "#044F2A", "#033017"];
  var FORMATS = ["HEX", "RGB", "HSL", "HSV", "CMYK", "CSS"];
  var SATURATION_PANEL_DEFAULT_WIDTH = 230;
  var SATURATION_PANEL_DEFAULT_HEIGHT = 168;
  var SLIDER_DEFAULT_WIDTH = 186;
  var GRADIENT_SLIDER_DEFAULT_WIDTH = 176;

  var props$G = {
    allowUncheck: Boolean,
    checked: {
      type: Boolean,
      "default": void 0
    },
    defaultChecked: Boolean,
    "default": {
      type: [String, Function]
    },
    disabled: {
      type: Boolean,
      "default": void 0
    },
    label: {
      type: [String, Function]
    },
    name: {
      type: String,
      "default": ""
    },
    readonly: {
      type: Boolean,
      "default": void 0
    },
    value: {
      type: [String, Number, Boolean],
      "default": void 0
    },
    onChange: Function,
    onClick: Function
  };

  function ownKeys$1V(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1U(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1V(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1V(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$l = getClassPrefixMixins("radio");
  var _Radio = mixins(Vue__default["default"], classPrefixMixins$l).extend({
    name: "TRadio",
    inheritAttrs: false,
    props: _objectSpread$1U({}, props$G),
    inject: {
      radioGroup: {
        "default": void 0
      },
      radioButton: {
        "default": void 0
      }
    },
    data: function data() {
      return {
        formDisabled: void 0
      };
    },
    render: function render() {
      var _this$radioGroup, _this$value;
      var h = arguments[0];
      var radioGroup = this.radioGroup,
        radioButton = this.radioButton;
      var tChecked = this.getChecked();
      var tDisabled = this.getDisabled();
      var prefixCls = radioButton ? "".concat(this.componentName, "-button") : this.componentName;
      var inputClass = ["".concat(prefixCls), _defineProperty$2(_defineProperty$2({}, this.commonStatusClassName.checked, tChecked), this.commonStatusClassName.disabled, tDisabled)];
      var allowUncheck = this.allowUncheck || ((_this$radioGroup = this.radioGroup) === null || _this$radioGroup === void 0 ? void 0 : _this$radioGroup.allowUncheck);
      return h("label", {
        "class": inputClass,
        "on": {
          "click": this.handleRadioClick
        },
        "attrs": {
          "tabindex": tDisabled ? void 0 : "0"
        }
      }, [h("input", helper([{
        "attrs": {
          "type": "radio",
          "name": this.name || (radioGroup === null || radioGroup === void 0 ? void 0 : radioGroup.name) || void 0,
          "disabled": tDisabled,
          "tabindex": "-1",
          "data-value": typeof this.value === "string" ? "'".concat(this.value, "'") : this.value,
          "data-allow-uncheck": allowUncheck || void 0
        },
        "class": "".concat(prefixCls, "__former"),
        "domProps": {
          "value": (_this$value = this.value) !== null && _this$value !== void 0 ? _this$value : void 0,
          "checked": tChecked
        },
        "on": {
          "click": this.onInputClick
        }
      }, {
        "on": _objectSpread$1U({}, omit(this.$listeners, ["change", "click"]))
      }])), h("span", {
        "class": "".concat(prefixCls, "__input")
      }), h("span", {
        "class": "".concat(prefixCls, "__label")
      }, [renderContent(this, "default", "label")])]);
    },
    methods: {
      getChecked: function getChecked() {
        var _this$radioGroup2;
        return this.checked || this.value !== void 0 && ((_this$radioGroup2 = this.radioGroup) === null || _this$radioGroup2 === void 0 ? void 0 : _this$radioGroup2.value) === this.value;
      },
      getDisabled: function getDisabled() {
        var _ref2, _this$radioGroup3;
        return Boolean((_ref2 = this.formDisabled || this.disabled) !== null && _ref2 !== void 0 ? _ref2 : (_this$radioGroup3 = this.radioGroup) === null || _this$radioGroup3 === void 0 ? void 0 : _this$radioGroup3.disabled);
      },
      getReadonly: function getReadonly() {
        var _this$readonly, _this$radioGroup4;
        return Boolean((_this$readonly = this.readonly) !== null && _this$readonly !== void 0 ? _this$readonly : (_this$radioGroup4 = this.radioGroup) === null || _this$radioGroup4 === void 0 ? void 0 : _this$radioGroup4.readonly);
      },
      onInputClick: function onInputClick(e) {
        e.stopPropagation();
      },
      handleRadioClick: function handleRadioClick(e) {
        var tDisabled = this.getDisabled();
        var tReadonly = this.getReadonly();
        if (tDisabled || tReadonly) return;
        this.$emit("click", {
          e: e
        });
        this.checkRadio(e);
      },
      checkRadio: function checkRadio(e) {
        var _this$radioGroup5;
        var tChecked = this.getChecked();
        var allowUncheck = this.allowUncheck || ((_this$radioGroup5 = this.radioGroup) === null || _this$radioGroup5 === void 0 ? void 0 : _this$radioGroup5.allowUncheck);
        if (tChecked && !allowUncheck) return;
        if (this.radioGroup) {
          var value = tChecked && allowUncheck ? void 0 : this.value;
          this.radioGroup.handleRadioChange(value, {
            e: e,
            name: this.radioGroup.name
          });
        } else {
          var _value = allowUncheck ? !tChecked : true;
          emitEvent$1(this, "change", _value, {
            e: e
          });
        }
      }
    }
  });

  var props$F = {
    allowUncheck: Boolean,
    disabled: {
      type: Boolean,
      "default": void 0
    },
    name: {
      type: String,
      "default": ""
    },
    options: {
      type: Array
    },
    readonly: {
      type: Boolean,
      "default": void 0
    },
    size: {
      type: String,
      "default": "medium",
      validator: function validator(val) {
        if (!val) return true;
        return ["small", "medium", "large"].includes(val);
      }
    },
    theme: {
      type: String,
      "default": "radio",
      validator: function validator(val) {
        if (!val) return true;
        return ["radio", "button"].includes(val);
      }
    },
    value: {
      type: [String, Number, Boolean],
      "default": void 0
    },
    defaultValue: {
      type: [String, Number, Boolean]
    },
    variant: {
      type: String,
      "default": "outline",
      validator: function validator(val) {
        if (!val) return true;
        return ["outline", "primary-filled", "default-filled"].includes(val);
      }
    },
    onChange: Function
  };

  function ownKeys$1U(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1T(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1U(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1U(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _RadioButton = Vue__default["default"].extend({
    name: "TRadioButton",
    inheritAttrs: false,
    props: _objectSpread$1T({}, props$G),
    components: {
      Radio: _Radio
    },
    provide: function provide() {
      return {
        radioButton: this
      };
    },
    inject: {
      radioGroup: {
        "default": void 0
      }
    },
    render: function render() {
      var h = arguments[0];
      var $props = this.$props,
        $listeners = this.$listeners,
        radioGroup = this.radioGroup;
      var radioProps = {
        props: _objectSpread$1T({}, $props),
        on: $listeners
      };
      if (radioGroup) {
        radioProps.props.checked = $props.value === radioGroup.value;
        radioProps.props.disabled = $props.disabled === void 0 ? radioGroup.disabled : $props.disabled;
        radioProps.props.readonly = $props.readonly === void 0 ? radioGroup.readonly : $props.readonly;
        radioProps.props.name = radioGroup.name;
      }
      return h(_Radio, helper([{}, radioProps]), [renderContent(this, "default", "label")]);
    }
  });

  function ownKeys$1T(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1S(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1T(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1T(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$k = getClassPrefixMixins("radio-group");
  var _RadioGroup = mixins(classPrefixMixins$k).extend({
    name: "TRadioGroup",
    props: _objectSpread$1S({}, props$F),
    components: {
      Radio: _Radio
    },
    provide: function provide() {
      return {
        radioGroup: this
      };
    },
    data: function data() {
      return {
        barStyle: {
          width: "0px",
          left: "0px"
        },
        observer: null
      };
    },
    computed: {
      checkedClassName: function checkedClassName() {
        return ".".concat(this.classPrefix, "-radio-button.").concat(this.commonStatusClassName.checked);
      }
    },
    render: function render(h) {
      var _this = this;
      var $scopedSlots = this.$scopedSlots;
      var children = $scopedSlots["default"] && $scopedSlots["default"](null);
      if (this.options && this.options.length) {
        children = this.options.map(function (option, index) {
          var opt = option;
          if (isNumber(option) || isString(option)) {
            opt = {
              value: option,
              label: option.toString()
            };
          }
          var RadioComponent = _this.theme === "button" ? _RadioButton : _Radio;
          return h(RadioComponent, helper([{}, {
            "props": option
          }, {
            "key": "radio-group-options-".concat(opt.value, "-").concat(index),
            "attrs": {
              "name": _this.name,
              "checked": _this.value === opt.value,
              "disabled": "disabled" in opt ? opt.disabled : _this.disabled,
              "value": opt.value
            }
          }]), [typeof opt.label === "function" ? opt.label(h) : opt.label]);
        });
      }
      var groupClass = ["".concat(this.componentName), this.commonSizeClassName[this.size], _defineProperty$2(_defineProperty$2(_defineProperty$2({}, "".concat(this.componentName, "__outline"), this.variant === "outline"), "".concat(this.componentName, "--filled"), this.variant.includes("filled")), "".concat(this.componentName, "--primary-filled"), this.variant === "primary-filled")];
      if (this.variant.includes("filled")) {
        children && children.push(h("div", {
          "style": this.barStyle,
          "class": "".concat(this.componentName, "__bg-block")
        }));
      }
      return h("div", {
        "class": groupClass
      }, [children]);
    },
    watch: {
      value: function value() {
        var _this2 = this;
        this.$nextTick(function () {
          return _this2.calcBarStyle();
        });
      }
    },
    mounted: function mounted() {
      this.calcBarStyle();
      var observer = new MutationObserver(this.calcBarStyle);
      observer.observe(this.$el, {
        childList: true,
        attributes: true,
        subtree: true,
        characterData: true
      });
      this.observer = observer;
      this.addKeyboardListeners();
    },
    beforeDestroy: function beforeDestroy() {
      this.observer.disconnect();
      this.removeKeyboardListeners();
    },
    methods: {
      addKeyboardListeners: function addKeyboardListeners() {
        on$1(this.$el, "keydown", this.checkRadioInGroup);
      },
      removeKeyboardListeners: function removeKeyboardListeners() {
        off$1(this.$el, "keydown", this.checkRadioInGroup);
      },
      checkRadioInGroup: function checkRadioInGroup(e) {
        var isCheckedCode = CHECKED_CODE_REG.test(e.key) || CHECKED_CODE_REG.test(e.code);
        if (isCheckedCode) {
          e.preventDefault();
          var inputNode = e.target.querySelector("input");
          var data = inputNode.dataset;
          if (inputNode.checked && data.allowUncheck) {
            this.handleRadioChange(void 0, {
              e: e
            });
          } else {
            var value = !isNaN(Number(data.value)) ? Number(data.value) : data.value;
            value = typeof value === "string" && {
              "true": true,
              "false": false
            }[value] || value;
            value = typeof value === "string" && value[0] === "'" ? value.replace(/'/g, "") : value;
            this.handleRadioChange(value, {
              e: e
            });
          }
        }
      },
      handleRadioChange: function handleRadioChange(value, context) {
        emitEvent$1(this, "change", value, context);
      },
      calcDefaultBarStyle: function calcDefaultBarStyle() {
        var defaultNode = this.$el.cloneNode(true);
        var div = document.createElement("div");
        div.setAttribute("style", "position: absolute; visibility: hidden;");
        div.appendChild(defaultNode);
        document.body.appendChild(div);
        var defaultCheckedRadio = div.querySelector(this.checkedClassName);
        var offsetWidth = defaultCheckedRadio.offsetWidth,
          offsetLeft = defaultCheckedRadio.offsetLeft;
        document.body.removeChild(div);
        return {
          offsetWidth: offsetWidth,
          offsetLeft: offsetLeft
        };
      },
      calcBarStyle: function calcBarStyle() {
        if (this.variant === "outline") return;
        var checkedRadio = this.$el.querySelector(this.checkedClassName);
        if (!checkedRadio) return;
        var offsetWidth = checkedRadio.offsetWidth,
          offsetLeft = checkedRadio.offsetLeft;
        if (!offsetWidth) {
          var _this$calcDefaultBarS = this.calcDefaultBarStyle(),
            width2 = _this$calcDefaultBarS.offsetWidth,
            left2 = _this$calcDefaultBarS.offsetLeft;
          offsetWidth = width2;
          offsetLeft = left2;
        }
        var width = "".concat(offsetWidth, "px");
        var left = "".concat(offsetLeft, "px");
        if (this.barStyle.width === width && this.barStyle.left === left) return;
        this.barStyle = {
          width: width,
          left: left
        };
      }
    }
  });

  var Radio = withInstall$1(mapProps(["checked"], {
    model: {
      prop: "checked",
      event: "change"
    }
  })(_Radio));
  var RadioGroup = withInstall$1(mapProps(["value"], {
    model: {
      prop: "value",
      event: "change"
    }
  })(_RadioGroup));
  var RadioButton = withInstall$1(_RadioButton);

  var BASE_COMPONENT_NAME = "color-picker";
  var useBaseClassName = function useBaseClassName(className) {
    var baseClassName = usePrefixClass(BASE_COMPONENT_NAME);
    return VueCompositionAPI.computed(function () {
      return className ? "".concat(baseClassName.value, "-").concat(className) : baseClassName.value;
    });
  };

  function ownKeys$1S(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1R(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1S(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1S(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var PanelHeader = VueCompositionAPI.defineComponent({
    name: "PanelHeader",
    components: {
      TRadioGroup: RadioGroup,
      TRadioButton: RadioButton
    },
    props: _objectSpread$1R(_objectSpread$1R({}, props$H), {}, {
      mode: {
        type: String,
        "default": "color"
      },
      togglePopup: {
        type: Function
      },
      handleModeChange: {
        type: Function,
        "default": function _default() {
          return function () {};
        }
      }
    }),
    setup: function setup(props2) {
      var _useConfig = useConfig("colorPicker"),
        globalConfig = _useConfig.globalConfig;
      var baseClassName = useBaseClassName();
      var modeValue = VueCompositionAPI.ref(props2.mode);
      VueCompositionAPI.watch(function () {
        return props2.mode;
      }, function (v) {
        modeValue.value = v;
      });
      return {
        globalConfig: globalConfig,
        baseClassName: baseClassName,
        modeValue: modeValue
      };
    },
    render: function render() {
      var _this$colorModes,
        _this = this;
      var h = arguments[0];
      if (((_this$colorModes = this.colorModes) === null || _this$colorModes === void 0 ? void 0 : _this$colorModes.length) === 1) {
        return null;
      }
      var baseClassName = this.baseClassName;
      return h("div", {
        "class": "".concat(baseClassName, "__head")
      }, [h("div", {
        "class": "".concat(baseClassName, "__mode")
      }, [h("t-radio-group", {
        "attrs": {
          "variant": "default-filled",
          "size": "small",
          "disabled": this.disabled
        },
        "on": {
          "change": this.handleModeChange
        },
        "model": {
          value: _this.modeValue,
          callback: function callback($$v) {
            _this.modeValue = $$v;
          }
        }
      }, [this.colorModes.map(function (key) {
        return h("t-radio-button", {
          "key": key,
          "attrs": {
            "value": key
          }
        }, [Reflect.get(_this.globalConfig, COLOR_MODES[key])]);
      })])])]);
    }
  });

  var rgb2cmyk = function rgb2cmyk(red, green, blue) {
    var computedC = 0;
    var computedM = 0;
    var computedY = 0;
    var computedK = 0;
    var r = parseInt("".concat(red).replace(/\s/g, ""), 10);
    var g = parseInt("".concat(green).replace(/\s/g, ""), 10);
    var b = parseInt("".concat(blue).replace(/\s/g, ""), 10);
    if (r === 0 && g === 0 && b === 0) {
      computedK = 1;
      return [0, 0, 0, 1];
    }
    computedC = 1 - r / 255;
    computedM = 1 - g / 255;
    computedY = 1 - b / 255;
    var minCMY = Math.min(computedC, Math.min(computedM, computedY));
    computedC = (computedC - minCMY) / (1 - minCMY);
    computedM = (computedM - minCMY) / (1 - minCMY);
    computedY = (computedY - minCMY) / (1 - minCMY);
    computedK = minCMY;
    return [computedC, computedM, computedY, computedK];
  };
  var cmyk2rgb = function cmyk2rgb(cyan, magenta, yellow, black) {
    var c = cyan / 100;
    var m = magenta / 100;
    var y = yellow / 100;
    var k = black / 100;
    c = c * (1 - k) + k;
    m = m * (1 - k) + k;
    y = y * (1 - k) + k;
    var r = 1 - c;
    var g = 1 - m;
    var b = 1 - y;
    r = Math.round(255 * r);
    g = Math.round(255 * g);
    b = Math.round(255 * b);
    return {
      r: r,
      g: g,
      b: b
    };
  };
  var REG_CMYK_STRING = /cmyk\((\d+%?),(\d+%?),(\d+%?),(\d+%?)\)/;
  var toNumber = function toNumber(str) {
    return Math.max(0, Math.min(255, parseInt(str, 10)));
  };
  var cmykInputToColor = function cmykInputToColor(input) {
    if (/cmyk/i.test(input)) {
      var str = input.replace(/\s/g, "");
      var match = str.match(REG_CMYK_STRING);
      var c = toNumber(match[1]);
      var m = toNumber(match[2]);
      var y = toNumber(match[3]);
      var k = toNumber(match[4]);
      var _cmyk2rgb = cmyk2rgb(c, m, y, k),
        r = _cmyk2rgb.r,
        g = _cmyk2rgb.g,
        b = _cmyk2rgb.b;
      return "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
    }
    return input;
  };

  var combineRegExp = function combineRegExp(regexpList, flags) {
    var source = "";
    for (var i = 0; i < regexpList.length; i++) {
      if (isString(regexpList[i])) {
        source += regexpList[i];
      } else {
        source += regexpList[i].source;
      }
    }
    return new RegExp(source, flags);
  };
  var generateRegExp = function generateRegExp() {
    var searchFlags = "gi";
    var rAngle = /(?:[+-]?\d*\.?\d+)(?:deg|grad|rad|turn)/;
    var rSideCornerCapture = /to\s+((?:(?:left|right|top|bottom)(?:\s+(?:top|bottom|left|right))?))/;
    var rComma = /\s*,\s*/;
    var rColorHex = /#(?:[a-f0-9]{6}|[a-f0-9]{3})/;
    var rDigits3 = /\(\s*(?:\d{1,3}\s*,\s*){2}\d{1,3}\s*\)/;
    var rDigits4 = /\(\s*(?:\d{1,3}\s*,\s*){2}\d{1,3}\s*,\s*\d*\.?\d+\)/;
    var rValue = /(?:[+-]?\d*\.?\d+)(?:%|[a-z]+)?/;
    var rKeyword = /[_a-z-][_a-z0-9-]*/;
    var rColor = combineRegExp(["(?:", rColorHex, "|", "(?:rgb|hsl)", rDigits3, "|", "(?:rgba|hsla)", rDigits4, "|", rKeyword, ")"], "");
    var rColorStop = combineRegExp([rColor, "(?:\\s+", rValue, "(?:\\s+", rValue, ")?)?"], "");
    var rColorStopList = combineRegExp(["(?:", rColorStop, rComma, ")*", rColorStop], "");
    var rLineCapture = combineRegExp(["(?:(", rAngle, ")|", rSideCornerCapture, ")"], "");
    var rGradientSearch = combineRegExp(["(?:(", rLineCapture, ")", rComma, ")?(", rColorStopList, ")"], searchFlags);
    var rColorStopSearch = combineRegExp(["\\s*(", rColor, ")", "(?:\\s+", "(", rValue, "))?", "(?:", rComma, "\\s*)?"], searchFlags);
    return {
      gradientSearch: rGradientSearch,
      colorStopSearch: rColorStopSearch
    };
  };
  var parseGradient = function parseGradient(regExpLib, input) {
    var result;
    var matchColorStop;
    var stopResult;
    regExpLib.gradientSearch.lastIndex = 0;
    var matchGradient = regExpLib.gradientSearch.exec(input);
    if (!isNull(matchGradient)) {
      result = {
        original: matchGradient[0],
        colorStopList: []
      };
      if (matchGradient[1]) {
        result.line = matchGradient[1];
      }
      if (matchGradient[2]) {
        result.angle = matchGradient[2];
      }
      if (matchGradient[3]) {
        result.sideCorner = matchGradient[3];
      }
      regExpLib.colorStopSearch.lastIndex = 0;
      matchColorStop = regExpLib.colorStopSearch.exec(matchGradient[4]);
      while (!isNull(matchColorStop)) {
        stopResult = {
          color: matchColorStop[1]
        };
        if (matchColorStop[2]) {
          stopResult.position = matchColorStop[2];
        }
        result.colorStopList.push(stopResult);
        matchColorStop = regExpLib.colorStopSearch.exec(matchGradient[4]);
      }
    }
    return result;
  };
  var REGEXP_LIB = generateRegExp();
  var REG_GRADIENT = /.*gradient\s*\(((?:\([^)]*\)|[^)(]*)*)\)/gim;
  var isGradientColor = function isGradientColor(input) {
    REG_GRADIENT.lastIndex = 0;
    return REG_GRADIENT.exec(input);
  };
  var sideCornerDegreeMap = {
    top: 0,
    right: 90,
    bottom: 180,
    left: 270,
    "top left": 225,
    "left top": 225,
    "top right": 135,
    "right top": 135,
    "bottom left": 315,
    "left bottom": 315,
    "bottom right": 45,
    "right bottom": 45
  };
  var parseGradientString = function parseGradientString(input) {
    var match = isGradientColor(input);
    if (!match) {
      return false;
    }
    var gradientColors = {
      points: [],
      degree: 0
    };
    var result = parseGradient(REGEXP_LIB, match[1]);
    if (result.original.trim() !== match[1].trim()) {
      return false;
    }
    var points = result.colorStopList.map(function (_ref) {
      var color = _ref.color,
        position = _ref.position;
      var point = /* @__PURE__ */Object.create(null);
      point.color = tinycolor(color).toRgbString();
      point.left = parseFloat(position);
      return point;
    });
    gradientColors.points = points;
    var degree = parseInt(result.angle, 10);
    if (Number.isNaN(degree)) {
      degree = sideCornerDegreeMap[result.sideCorner] || 90;
    }
    gradientColors.degree = degree;
    return gradientColors;
  };

  var _Color;
  function ownKeys$1R(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1Q(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1R(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1R(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var mathRound = Math.round;
  var hsv2rgba = function hsv2rgba(states) {
    return tinycolor(states).toRgb();
  };
  var hsv2hsva = function hsv2hsva(states) {
    return tinycolor(states).toHsv();
  };
  var hsv2hsla = function hsv2hsla(states) {
    return tinycolor(states).toHsl();
  };
  var gradientColors2string = function gradientColors2string(object) {
    var points = object.points,
      degree = object.degree;
    var colorsStop = points.sort(function (pA, pB) {
      return pA.left - pB.left;
    }).map(function (p) {
      return "".concat(p.color, " ").concat(Math.round(p.left * 100) / 100, "%");
    });
    return "linear-gradient(".concat(degree, "deg,").concat(colorsStop.join(","), ")");
  };
  var genId = function genId() {
    return (1 + Math.random() * 4294967295).toString(16);
  };
  var genGradientPoint = function genGradientPoint(left, color) {
    return {
      id: genId(),
      left: left,
      color: color
    };
  };
  var Color = /*#__PURE__*/function () {
    function Color(input) {
      _classCallCheck(this, Color);
      _defineProperty$2(this, "states", {
        s: 100,
        v: 100,
        h: 100,
        a: 1
      });
      _defineProperty$2(this, "originColor", void 0);
      _defineProperty$2(this, "isGradient", void 0);
      _defineProperty$2(this, "gradientStates", {
        colors: [],
        degree: 0,
        selectedId: null,
        css: ""
      });
      this.update(input);
    }
    return _createClass(Color, [{
      key: "update",
      value: function update(input) {
        if (input === this.originColor) {
          return;
        }
        var gradientColors = parseGradientString(input);
        if (this.isGradient && !gradientColors) {
          var colorHsv = tinycolor(input).toHsv();
          this.states = colorHsv;
          this.updateCurrentGradientColor();
          return;
        }
        this.originColor = input;
        this.isGradient = false;
        var colorInput = input;
        if (gradientColors) {
          var _points$, _this$gradientSelecte;
          this.isGradient = true;
          var object = gradientColors;
          var points = object.points.map(function (c) {
            return genGradientPoint(c.left, c.color);
          });
          this.gradientStates = {
            colors: points,
            degree: object.degree,
            selectedId: ((_points$ = points[0]) === null || _points$ === void 0 ? void 0 : _points$.id) || null
          };
          this.gradientStates.css = this.linearGradient;
          colorInput = (_this$gradientSelecte = this.gradientSelectedPoint) === null || _this$gradientSelecte === void 0 ? void 0 : _this$gradientSelecte.color;
        }
        this.updateStates(colorInput);
      }
    }, {
      key: "saturation",
      get: function get() {
        return this.states.s;
      },
      set: function set(value) {
        this.states.s = Math.max(0, Math.min(100, value));
        this.updateCurrentGradientColor();
      }
    }, {
      key: "value",
      get: function get() {
        return this.states.v;
      },
      set: function set(value) {
        this.states.v = Math.max(0, Math.min(100, value));
        this.updateCurrentGradientColor();
      }
    }, {
      key: "hue",
      get: function get() {
        return this.states.h;
      },
      set: function set(value) {
        this.states.h = Math.max(0, Math.min(360, value));
        this.updateCurrentGradientColor();
      }
    }, {
      key: "alpha",
      get: function get() {
        return this.states.a;
      },
      set: function set(value) {
        this.states.a = Math.max(0, Math.min(1, Math.round(value * 100) / 100));
        this.updateCurrentGradientColor();
      }
    }, {
      key: "rgb",
      get: function get() {
        var _hsv2rgba = hsv2rgba(this.states),
          r = _hsv2rgba.r,
          g = _hsv2rgba.g,
          b = _hsv2rgba.b;
        return "rgb(".concat(mathRound(r), ", ").concat(mathRound(g), ", ").concat(mathRound(b), ")");
      }
    }, {
      key: "rgba",
      get: function get() {
        var _hsv2rgba2 = hsv2rgba(this.states),
          r = _hsv2rgba2.r,
          g = _hsv2rgba2.g,
          b = _hsv2rgba2.b,
          a = _hsv2rgba2.a;
        return "rgba(".concat(mathRound(r), ", ").concat(mathRound(g), ", ").concat(mathRound(b), ", ").concat(a, ")");
      }
    }, {
      key: "hsv",
      get: function get() {
        var _this$getHsva = this.getHsva(),
          h = _this$getHsva.h,
          s = _this$getHsva.s,
          v = _this$getHsva.v;
        return "hsv(".concat(h, ", ").concat(s, "%, ").concat(v, "%)");
      }
    }, {
      key: "hsva",
      get: function get() {
        var _this$getHsva2 = this.getHsva(),
          h = _this$getHsva2.h,
          s = _this$getHsva2.s,
          v = _this$getHsva2.v,
          a = _this$getHsva2.a;
        return "hsva(".concat(h, ", ").concat(s, "%, ").concat(v, "%, ").concat(a, ")");
      }
    }, {
      key: "hsl",
      get: function get() {
        var _this$getHsla = this.getHsla(),
          h = _this$getHsla.h,
          s = _this$getHsla.s,
          l = _this$getHsla.l;
        return "hsl(".concat(h, ", ").concat(s, "%, ").concat(l, "%)");
      }
    }, {
      key: "hsla",
      get: function get() {
        var _this$getHsla2 = this.getHsla(),
          h = _this$getHsla2.h,
          s = _this$getHsla2.s,
          l = _this$getHsla2.l,
          a = _this$getHsla2.a;
        return "hsla(".concat(h, ", ").concat(s, "%, ").concat(l, "%, ").concat(a, ")");
      }
    }, {
      key: "hex",
      get: function get() {
        return tinycolor(this.states).toHexString();
      }
    }, {
      key: "hex8",
      get: function get() {
        return tinycolor(this.states).toHex8String();
      }
    }, {
      key: "cmyk",
      get: function get() {
        var _this$getCmyk = this.getCmyk(),
          c = _this$getCmyk.c,
          m = _this$getCmyk.m,
          y = _this$getCmyk.y,
          k = _this$getCmyk.k;
        return "cmyk(".concat(c, ", ").concat(m, ", ").concat(y, ", ").concat(k, ")");
      }
    }, {
      key: "css",
      get: function get() {
        if (this.isGradient) {
          return this.linearGradient;
        }
        return this.rgba;
      }
    }, {
      key: "linearGradient",
      get: function get() {
        var gradientColors = this.gradientColors,
          gradientDegree = this.gradientDegree;
        return gradientColors2string({
          points: gradientColors,
          degree: gradientDegree
        });
      }
    }, {
      key: "gradientColors",
      get: function get() {
        return this.gradientStates.colors;
      },
      set: function set(colors) {
        this.gradientStates.colors = colors;
        this.gradientStates.css = this.linearGradient;
      }
    }, {
      key: "gradientSelectedId",
      get: function get() {
        return this.gradientStates.selectedId;
      },
      set: function set(id) {
        var _this$gradientSelecte2;
        if (id === this.gradientSelectedId) {
          return;
        }
        this.gradientStates.selectedId = id;
        this.updateStates((_this$gradientSelecte2 = this.gradientSelectedPoint) === null || _this$gradientSelecte2 === void 0 ? void 0 : _this$gradientSelecte2.color);
      }
    }, {
      key: "gradientDegree",
      get: function get() {
        return this.gradientStates.degree;
      },
      set: function set(degree) {
        this.gradientStates.degree = Math.max(0, Math.min(360, degree));
        this.gradientStates.css = this.linearGradient;
      }
    }, {
      key: "gradientSelectedPoint",
      get: function get() {
        var gradientColors = this.gradientColors,
          gradientSelectedId = this.gradientSelectedId;
        return gradientColors.find(function (color) {
          return color.id === gradientSelectedId;
        });
      }
    }, {
      key: "getFormatsColorMap",
      value: function getFormatsColorMap() {
        return {
          HEX: this.hex,
          CMYK: this.cmyk,
          RGB: this.rgb,
          RGBA: this.rgba,
          HSL: this.hsl,
          HSLA: this.hsla,
          HSV: this.hsv,
          HSVA: this.hsva,
          CSS: this.css,
          HEX8: this.hex8
        };
      }
    }, {
      key: "updateCurrentGradientColor",
      value: function updateCurrentGradientColor() {
        var isGradient = this.isGradient,
          gradientColors = this.gradientColors,
          gradientSelectedId = this.gradientSelectedId;
        var length = gradientColors.length;
        var current = this.gradientSelectedPoint;
        if (!isGradient || length === 0 || !current) {
          return false;
        }
        var index = gradientColors.findIndex(function (color) {
          return color.id === gradientSelectedId;
        });
        var newColor = _objectSpread$1Q(_objectSpread$1Q({}, current), {}, {
          color: this.rgba
        });
        gradientColors.splice(index, 1, newColor);
        this.gradientColors = gradientColors.slice();
        return this;
      }
    }, {
      key: "updateStates",
      value: function updateStates(input) {
        var color = tinycolor(cmykInputToColor(input));
        var hsva = color.toHsv();
        this.states = hsva;
      }
    }, {
      key: "getRgba",
      value: function getRgba() {
        var _hsv2rgba3 = hsv2rgba(this.states),
          r = _hsv2rgba3.r,
          g = _hsv2rgba3.g,
          b = _hsv2rgba3.b,
          a = _hsv2rgba3.a;
        return {
          r: mathRound(r),
          g: mathRound(g),
          b: mathRound(b),
          a: a
        };
      }
    }, {
      key: "getCmyk",
      value: function getCmyk() {
        var _this$getRgba = this.getRgba(),
          r = _this$getRgba.r,
          g = _this$getRgba.g,
          b = _this$getRgba.b;
        var _rgb2cmyk = rgb2cmyk(r, g, b),
          _rgb2cmyk2 = _slicedToArray(_rgb2cmyk, 4),
          c = _rgb2cmyk2[0],
          m = _rgb2cmyk2[1],
          y = _rgb2cmyk2[2],
          k = _rgb2cmyk2[3];
        return {
          c: mathRound(c * 100),
          m: mathRound(m * 100),
          y: mathRound(y * 100),
          k: mathRound(k * 100)
        };
      }
    }, {
      key: "getHsva",
      value: function getHsva() {
        var _hsv2hsva = hsv2hsva(this.states),
          h = _hsv2hsva.h,
          s = _hsv2hsva.s,
          v = _hsv2hsva.v,
          a = _hsv2hsva.a;
        h = mathRound(h);
        s = mathRound(s * 100);
        v = mathRound(v * 100);
        a *= 1;
        return {
          h: h,
          s: s,
          v: v,
          a: a
        };
      }
    }, {
      key: "getHsla",
      value: function getHsla() {
        var _hsv2hsla = hsv2hsla(this.states),
          h = _hsv2hsla.h,
          s = _hsv2hsla.s,
          l = _hsv2hsla.l,
          a = _hsv2hsla.a;
        h = mathRound(h);
        s = mathRound(s * 100);
        l = mathRound(l * 100);
        a *= 1;
        return {
          h: h,
          s: s,
          l: l,
          a: a
        };
      }
    }, {
      key: "equals",
      value: function equals(color) {
        return tinycolor.equals(this.rgba, color);
      }
    }], [{
      key: "isValid",
      value: function isValid(color) {
        if (parseGradientString(color)) {
          return true;
        }
        return tinycolor(color).isValid();
      }
    }, {
      key: "hsva2color",
      value: function hsva2color(h, s, v, a) {
        return tinycolor({
          h: h,
          s: s,
          v: v,
          a: a
        }).toHsvString();
      }
    }, {
      key: "hsla2color",
      value: function hsla2color(h, s, l, a) {
        return tinycolor({
          h: h,
          s: s,
          l: l,
          a: a
        }).toHslString();
      }
    }, {
      key: "rgba2color",
      value: function rgba2color(r, g, b, a) {
        return tinycolor({
          r: r,
          g: g,
          b: b,
          a: a
        }).toHsvString();
      }
    }, {
      key: "hex2color",
      value: function hex2color(hex, a) {
        var color = tinycolor(hex);
        color.setAlpha(a);
        return color.toHexString();
      }
    }, {
      key: "object2color",
      value: function object2color(object, format) {
        if (format === "CMYK") {
          var c = object.c,
            m = object.m,
            y = object.y,
            k = object.k;
          return "cmyk(".concat(c, ", ").concat(m, ", ").concat(y, ", ").concat(k, ")");
        }
        var color = tinycolor(object, {
          format: format
        });
        return color.toRgbString();
      }
    }]);
  }();
  _Color = Color;
  _defineProperty$2(Color, "isGradientColor", function (input) {
    return !!isGradientColor(input);
  });
  _defineProperty$2(Color, "compare", function (color1, color2) {
    var isGradientColor1 = _Color.isGradientColor(color1);
    var isGradientColor2 = _Color.isGradientColor(color2);
    if (isGradientColor1 && isGradientColor2) {
      var gradientColor1 = gradientColors2string(parseGradientString(color1));
      var gradientColor2 = gradientColors2string(parseGradientString(color2));
      return gradientColor1 === gradientColor2;
    }
    if (!isGradientColor1 && !isGradientColor2) {
      return tinycolor.equals(color1, color2);
    }
    return false;
  });
  var COLOR_OBJECT_OUTPUT_KEYS = ["alpha", "css", "hex", "hex8", "hsl", "hsla", "hsv", "hsva", "rgb", "rgba", "saturation", "value", "isGradient"];
  var getColorObject = function getColorObject(color) {
    if (!color) {
      return null;
    }
    var colorObject = /* @__PURE__ */Object.create(null);
    COLOR_OBJECT_OUTPUT_KEYS.forEach(function (key) {
      colorObject[key] = color[key];
    });
    if (color.isGradient) {
      colorObject.linearGradient = color.linearGradient;
    }
    return colorObject;
  };

  function ownKeys$1Q(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1P(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1Q(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1Q(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  var defaultsOptions = {
    start: function start(coordinate, event) {},
    drag: function drag(coordinate, event) {},
    end: function end(coordinate, event) {}
  };
  var _Draggable_brand = /*#__PURE__*/new WeakSet();
  var Draggable = /*#__PURE__*/function () {
    function Draggable(el, options) {
      _classCallCheck(this, Draggable);
      _classPrivateMethodInitSpec(this, _Draggable_brand);
      _defineProperty$2(this, "dragging", false);
      _defineProperty$2(this, "$el", void 0);
      _defineProperty$2(this, "props", void 0);
      _defineProperty$2(this, "handles", void 0);
      this.$el = el;
      this.props = _objectSpread$1P(_objectSpread$1P({}, defaultsOptions), options);
      this.handles = {
        start: _assertClassBrand(_Draggable_brand, this, _dragStart).bind(this),
        drag: _assertClassBrand(_Draggable_brand, this, _drag).bind(this),
        end: _assertClassBrand(_Draggable_brand, this, _dragEnd).bind(this)
      };
      this.$el.addEventListener("mousedown", this.handles.start, false);
    }
    return _createClass(Draggable, [{
      key: "destroy",
      value: function destroy() {
        this.$el.removeEventListener("mousedown", this.handles.start, false);
        window.removeEventListener("mousemove", this.handles.drag, false);
        window.removeEventListener("mouseup", this.handles.end, false);
        window.removeEventListener("contextmenu", this.handles.end, false);
      }
    }]);
  }();
  function _dragStart(event) {
    if (this.dragging) {
      return;
    }
    window.addEventListener("mousemove", this.handles.drag, false);
    window.addEventListener("mouseup", this.handles.end, false);
    window.addEventListener("contextmenu", this.handles.end, false);
    this.dragging = true;
    this.props.start(_assertClassBrand(_Draggable_brand, this, _getCoordinate).call(this, event), event);
  }
  function _drag(event) {
    if (!this.dragging) {
      return;
    }
    this.props.drag(_assertClassBrand(_Draggable_brand, this, _getCoordinate).call(this, event), event);
  }
  function _dragEnd(event) {
    var _this = this;
    setTimeout(function () {
      _this.dragging = false;
      _this.props.end(_assertClassBrand(_Draggable_brand, _this, _getCoordinate).call(_this, event), event);
    }, 0);
    window.removeEventListener("mousemove", this.handles.drag, false);
    window.removeEventListener("mouseup", this.handles.end, false);
    window.removeEventListener("contextmenu", this.handles.end, false);
  }
  function _getCoordinate(event) {
    var rect = this.$el.getBoundingClientRect();
    var mouseEvent = event;
    var left = mouseEvent.clientX - rect.left;
    var top = mouseEvent.clientY - rect.top;
    return {
      y: Math.min(Math.max(0, top), rect.height),
      x: Math.min(Math.max(0, left), rect.width)
    };
  }

  var baseProps = {
    disabled: Boolean,
    color: {
      type: Object
    },
    handleChange: {
      type: Function,
      "default": function _default() {
        return function () {};
      }
    }
  };

  function ownKeys$1P(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1O(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1P(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1P(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var DELETE_KEYS = ["delete", "backspace"];
  var LinearGradient = VueCompositionAPI.defineComponent({
    name: "LinearGradient",
    components: {
      TInputNumber: InputNumber
    },
    inheritAttrs: false,
    props: _objectSpread$1O(_objectSpread$1O({}, baseProps), {}, {
      enableMultipleGradient: {
        type: Boolean,
        "default": true
      }
    }),
    setup: function setup(props) {
      var baseClassName = useBaseClassName();
      var _useCommonClassName = useCommonClassName(),
        statusClassNames = _useCommonClassName.statusClassNames;
      var refSlider = VueCompositionAPI.ref(null);
      var sliderRect = VueCompositionAPI.reactive({
        left: 0,
        width: GRADIENT_SLIDER_DEFAULT_WIDTH
      });
      var isDragging = VueCompositionAPI.ref(false);
      var isMoved = VueCompositionAPI.ref(false);
      var colorInstance = VueCompositionAPI.computed(function () {
        return cloneDeep(props.color);
      });
      var degree = VueCompositionAPI.ref(colorInstance.value.gradientDegree);
      var selectedId = VueCompositionAPI.ref(colorInstance.value.gradientSelectedId);
      var colors = VueCompositionAPI.ref(cloneDeep(colorInstance.value.gradientColors));
      VueCompositionAPI.watch(function () {
        return props.color.gradientDegree;
      }, function (value) {
        return degree.value = value;
      });
      VueCompositionAPI.watch(function () {
        return props.color.gradientSelectedId;
      }, function (value) {
        return selectedId.value = value;
      });
      VueCompositionAPI.watch(function () {
        return props.color.gradientColors;
      }, function (value) {
        colors.value = cloneDeep(value);
      }, {
        deep: true
      });
      var handleChange = function handleChange(key, payload, addUsedColor) {
        if (props.disabled) {
          return;
        }
        props.handleChange({
          key: key,
          payload: payload,
          addUsedColor: addUsedColor
        });
      };
      var handleDegreeChange = function handleDegreeChange(value) {
        if (props.disabled || value === colorInstance.value.gradientDegree) {
          return;
        }
        degree.value = value;
        handleChange("degree", value, true);
      };
      var handleSelectedIdChange = function handleSelectedIdChange(value) {
        if (props.disabled) {
          return;
        }
        selectedId.value = value;
        handleChange("selectedId", value);
      };
      var handleColorsChange = function handleColorsChange(value, isEnded) {
        if (props.disabled) {
          return;
        }
        colors.value = value;
        handleChange("colors", value, isEnded);
      };
      var updateActiveThumbLeft = function updateActiveThumbLeft(left) {
        var index = colors.value.findIndex(function (c) {
          return c.id === selectedId.value;
        });
        if (index === -1) {
          return;
        }
        var point = colors.value[index];
        left = Math.max(0, Math.min(sliderRect.width, left));
        var percentLeft = left / sliderRect.width * 100;
        colors.value.splice(index, 1, {
          color: point.color,
          left: percentLeft,
          id: point.id
        });
        handleColorsChange(colors.value);
      };
      var handleStart = function handleStart(id) {
        var rect = refSlider.value.getBoundingClientRect();
        sliderRect.left = rect.left;
        sliderRect.width = rect.width || GRADIENT_SLIDER_DEFAULT_WIDTH;
        if (isDragging.value || props.disabled) {
          return;
        }
        isMoved.value = false;
        isDragging.value = true;
        handleSelectedIdChange(id);
        refSlider.value.focus();
        window.addEventListener("mousemove", handleMove, false);
        window.addEventListener("mouseup", _handleEnd, false);
        window.addEventListener("contextmenu", _handleEnd, false);
      };
      var handleMove = function handleMove(e) {
        if (!isDragging.value || props.disabled) {
          return;
        }
        var left = e.clientX - sliderRect.left;
        isMoved.value = true;
        updateActiveThumbLeft(left);
      };
      var _handleEnd = function handleEnd() {
        if (!isDragging.value) {
          return;
        }
        setTimeout(function () {
          isDragging.value = false;
        }, 0);
        if (isMoved.value) {
          handleColorsChange(colors.value, true);
          isMoved.value = false;
        }
        window.removeEventListener("mousemove", handleMove, false);
        window.removeEventListener("mouseup", _handleEnd, false);
        window.removeEventListener("contextmenu", _handleEnd, false);
      };
      var handleKeyup = function handleKeyup(e) {
        if (props.disabled) {
          return;
        }
        var points = colors.value;
        var pos = points.findIndex(function (c) {
          return c.id === selectedId.value;
        });
        var length = points.length;
        if (DELETE_KEYS.includes(e.key.toLocaleLowerCase()) && length > 2 && pos >= 0 && pos <= length - 1) {
          points.splice(pos, 1);
          if (!points[pos]) {
            pos = points[pos + 1] ? pos + 1 : points[pos - 1] ? pos - 1 : 0;
          }
          var current = points[pos];
          handleColorsChange(points, true);
          handleSelectedIdChange(current === null || current === void 0 ? void 0 : current.id);
        }
      };
      var handleThumbBarClick = function handleThumbBarClick(e) {
        if (props.disabled || !props.enableMultipleGradient) {
          return;
        }
        var left = e.clientX - sliderRect.left;
        left = Math.max(0, Math.min(sliderRect.width, left));
        var percentLeft = left / sliderRect.width * 100;
        var newPoint = genGradientPoint(percentLeft, colorInstance.value.rgba);
        colors.value.push(newPoint);
        handleColorsChange(colors.value, true);
        handleSelectedIdChange(newPoint.id);
      };
      VueCompositionAPI.onMounted(function () {
        var rect = refSlider.value.getBoundingClientRect();
        sliderRect.left = rect.left;
        sliderRect.width = rect.width || GRADIENT_SLIDER_DEFAULT_WIDTH;
      });
      VueCompositionAPI.onBeforeUnmount(function () {
        window.removeEventListener("mousemove", handleMove, false);
        window.removeEventListener("mouseup", _handleEnd, false);
        window.removeEventListener("contextmenu", _handleEnd, false);
      });
      return {
        baseClassName: baseClassName,
        statusClassNames: statusClassNames,
        refSlider: refSlider,
        degree: degree,
        selectedId: selectedId,
        colors: colors,
        colorInstance: colorInstance,
        handleDegreeChange: handleDegreeChange,
        handleStart: handleStart,
        handleMove: handleMove,
        handleEnd: _handleEnd,
        handleKeyup: handleKeyup,
        handleThumbBarClick: handleThumbBarClick
      };
    },
    render: function render() {
      var _this = this;
      var h = arguments[0];
      var _this$colorInstance = this.colorInstance,
        linearGradient = _this$colorInstance.linearGradient,
        gradientColors = _this$colorInstance.gradientColors;
      var colors = this.colors,
        selectedId = this.selectedId,
        degree = this.degree,
        disabled = this.disabled,
        baseClassName = this.baseClassName,
        statusClassNames = this.statusClassNames;
      var thumbBackground = gradientColors2string({
        points: gradientColors,
        degree: 90
      });
      return h("div", {
        "class": "".concat(baseClassName, "__gradient")
      }, [h("div", {
        "class": "".concat(baseClassName, "__gradient-slider")
      }, [h("div", {
        "class": ["".concat(baseClassName, "__slider"), "".concat(baseClassName, "--bg-alpha")],
        "on": {
          "keyup": this.handleKeyup
        },
        "attrs": {
          "tabindex": 0
        },
        "ref": "refSlider"
      }, [h("ul", {
        "class": "gradient-thumbs",
        "on": {
          "click": this.handleThumbBarClick
        },
        "style": {
          background: thumbBackground
        }
      }, [colors.map(function (t) {
        var left = "".concat(Math.round(t.left * 100) / 100, "%");
        return h("li", {
          "class": ["".concat(baseClassName, "__thumb"), "gradient-thumbs__item", selectedId === t.id ? statusClassNames.active : ""],
          "key": t.id,
          "attrs": {
            "title": "".concat(t.color, " ").concat(left)
          },
          "style": {
            color: t.color,
            left: left
          },
          "on": {
            "click": function click(e) {
              return e.stopPropagation();
            },
            "mousedown": function mousedown() {
              return _this.handleStart(t.id);
            }
          }
        }, [h("span", {
          "class": ["gradient-thumbs__item-inner", "".concat(baseClassName, "--bg-alpha")]
        })]);
      })])])]), h("div", {
        "class": "".concat(baseClassName, "__gradient-degree"),
        "attrs": {
          "title": "".concat(degree, "deg")
        }
      }, [h("t-input-number", {
        "attrs": {
          "theme": "normal",
          "size": "small",
          "min": 0,
          "max": 360,
          "step": 1,
          "format": function format(value) {
            return "".concat(value, "\xB0");
          },
          "disabled": disabled
        },
        "on": {
          "blur": this.handleDegreeChange,
          "enter": this.handleDegreeChange
        },
        "model": {
          value: _this.degree,
          callback: function callback($$v) {
            _this.degree = $$v;
          }
        }
      })]), h("div", {
        "class": ["".concat(baseClassName, "__gradient-preview"), "".concat(baseClassName, "--bg-alpha")]
      }, [h("span", {
        "class": "preview-inner",
        "style": {
          background: linearGradient
        }
      })])]);
    }
  });

  function ownKeys$1O(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1N(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1O(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1O(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var SaturationPanel = VueCompositionAPI.defineComponent({
    name: "SaturationPanel",
    components: {
      TSelect: Select,
      TOption: Option
    },
    props: _objectSpread$1N({}, baseProps),
    setup: function setup(props) {
      var baseClassName = useBaseClassName();
      var refPanel = VueCompositionAPI.ref(null);
      var refThumb = VueCompositionAPI.ref(null);
      var dragInstance = VueCompositionAPI.ref(null);
      var panelRect = VueCompositionAPI.reactive({
        width: SATURATION_PANEL_DEFAULT_WIDTH,
        height: SATURATION_PANEL_DEFAULT_HEIGHT
      });
      var styles = VueCompositionAPI.computed(function () {
        var _props$color = props.color,
          saturation = _props$color.saturation,
          value = _props$color.value;
        var width = panelRect.width,
          height = panelRect.height;
        var top = Math.round((1 - value) * height);
        var left = Math.round(saturation * width);
        return {
          color: props.color.rgb,
          left: "".concat(left, "px"),
          top: "".concat(top, "px")
        };
      });
      var getSaturationAndValueByCoordinate = function getSaturationAndValueByCoordinate(coordinate) {
        var width = panelRect.width,
          height = panelRect.height;
        var x = coordinate.x,
          y = coordinate.y;
        var saturation = Math.round(x / width * 100);
        var value = Math.round((1 - y / height) * 100);
        return {
          saturation: saturation,
          value: value
        };
      };
      var handleDrag = function handleDrag(coordinate, isEnded) {
        if (props.disabled) {
          return;
        }
        var _getSaturationAndValu = getSaturationAndValueByCoordinate(coordinate),
          saturation = _getSaturationAndValu.saturation,
          value = _getSaturationAndValu.value;
        props.handleChange({
          saturation: saturation / 100,
          value: value / 100,
          addUsedColor: isEnded
        });
      };
      var handleDragEnd = function handleDragEnd(coordinate) {
        if (props.disabled) {
          return;
        }
        VueCompositionAPI.nextTick(function () {
          handleDrag(coordinate, true);
        });
      };
      var panelBackground = VueCompositionAPI.computed(function () {
        return "hsl(".concat(props.color.hue, ", 100%, 50%)");
      });
      VueCompositionAPI.onMounted(function () {
        panelRect.width = refPanel.value.offsetWidth || SATURATION_PANEL_DEFAULT_WIDTH;
        panelRect.height = refPanel.value.offsetHeight || SATURATION_PANEL_DEFAULT_HEIGHT;
        dragInstance.value = new Draggable(refPanel.value, {
          start: function start() {
            panelRect.width = refPanel.value.offsetWidth;
            panelRect.height = refPanel.value.offsetHeight;
          },
          drag: function drag(coordinate) {
            handleDrag(coordinate);
          },
          end: handleDragEnd
        });
      });
      VueCompositionAPI.onBeforeUnmount(function () {
        dragInstance.value.destroy();
      });
      return {
        baseClassName: baseClassName,
        refThumb: refThumb,
        refPanel: refPanel,
        styles: styles,
        panelBackground: panelBackground
      };
    },
    render: function render() {
      var h = arguments[0];
      var baseClassName = this.baseClassName,
        styles = this.styles,
        panelBackground = this.panelBackground;
      return h("div", {
        "class": ["".concat(baseClassName, "__saturation")],
        "ref": "refPanel",
        "style": {
          background: panelBackground
        }
      }, [h("span", {
        "class": ["".concat(baseClassName, "__thumb")],
        "attrs": {
          "role": "slider",
          "tabindex": 0
        },
        "ref": "refThumb",
        "style": styles
      })]);
    }
  });

  function ownKeys$1N(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1M(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1N(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1N(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var ColorSlider = VueCompositionAPI.defineComponent({
    name: "ColorSlider",
    components: {
      TSelect: Select,
      TOption: Option
    },
    props: _objectSpread$1M(_objectSpread$1M({}, baseProps), {}, {
      className: {
        type: String,
        "default": ""
      },
      value: {
        type: Number,
        "default": 0
      },
      maxValue: {
        type: Number,
        "default": 360
      },
      railStyle: {
        type: Object
      },
      type: {
        type: String,
        "default": "hue"
      }
    }),
    setup: function setup(props, _ref) {
      var emit = _ref.emit;
      var baseClassName = useBaseClassName();
      var refPanel = VueCompositionAPI.ref(null);
      var refThumb = VueCompositionAPI.ref(null);
      var dragInstance = VueCompositionAPI.ref(null);
      var panelRect = VueCompositionAPI.reactive({
        width: SLIDER_DEFAULT_WIDTH
      });
      var styles = VueCompositionAPI.computed(function () {
        var width = panelRect.width;
        if (!width) {
          return;
        }
        var left = Math.round(props.value / props.maxValue * 100);
        return {
          left: "".concat(left, "%"),
          color: props.color.rgb
        };
      });
      var handleDrag = function handleDrag(coordinate, isEnded) {
        if (props.disabled) {
          return;
        }
        var width = panelRect.width;
        var x = coordinate.x;
        var value = Math.round(x / width * props.maxValue * 100) / 100;
        props.handleChange(value, isEnded);
        emit("change", value, isEnded);
      };
      var handleDragEnd = function handleDragEnd(coordinate) {
        if (props.disabled) {
          return;
        }
        handleDrag(coordinate, true);
      };
      VueCompositionAPI.onMounted(function () {
        panelRect.width = refPanel.value.offsetWidth || SLIDER_DEFAULT_WIDTH;
        dragInstance.value = new Draggable(refPanel.value, {
          start: function start() {
            panelRect.width = refPanel.value.offsetWidth;
          },
          drag: function drag(coordinate) {
            handleDrag(coordinate);
          },
          end: handleDragEnd
        });
      });
      VueCompositionAPI.onBeforeUnmount(function () {
        dragInstance.value.destroy();
      });
      return {
        baseClassName: baseClassName,
        refThumb: refThumb,
        refPanel: refPanel,
        styles: styles
      };
    },
    render: function render() {
      var h = arguments[0];
      var baseClassName = this.baseClassName,
        className = this.className,
        railStyle = this.railStyle,
        styles = this.styles,
        type = this.type,
        color = this.color;
      var paddingStyle = {
        background: "linear-gradient(90deg, rgba(0,0,0,.0) 0%, rgba(0,0,0,.0) 93%, ".concat(color.rgb, " 93%, ").concat(color.rgb, " 100%)")
      };
      return h("div", {
        "class": ["".concat(baseClassName, "__slider-wrapper"), "".concat(baseClassName, "__slider-wrapper--").concat(type, "-type")]
      }, [type === "alpha" && h("div", {
        "class": "".concat(baseClassName, "__slider-padding"),
        "style": paddingStyle
      }), h("div", {
        "class": ["".concat(baseClassName, "__slider"), className],
        "ref": "refPanel"
      }, [h("div", {
        "class": "".concat(baseClassName, "__rail"),
        "style": railStyle
      }), h("span", {
        "class": ["".concat(baseClassName, "__thumb")],
        "attrs": {
          "role": "slider",
          "tabindex": 0
        },
        "ref": "refThumb",
        "style": styles
      })])]);
    }
  });

  function ownKeys$1M(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1L(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1M(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1M(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var HueSlider = VueCompositionAPI.defineComponent({
    name: "HueSlider",
    components: {
      ColorSlider: ColorSlider
    },
    inheritAttrs: false,
    props: _objectSpread$1L({}, baseProps),
    setup: function setup() {
      var baseClassName = useBaseClassName();
      return {
        baseClassName: baseClassName
      };
    },
    render: function render() {
      var h = arguments[0];
      return h("color-slider", {
        "class": "".concat(this.baseClassName, "__hue"),
        "attrs": {
          "color": this.color,
          "value": this.color.hue,
          "handleChange": this.handleChange,
          "disabled": this.disabled,
          "type": "hue"
        }
      });
    }
  });

  var AlphaSlider = VueCompositionAPI.defineComponent({
    name: "AlphaSlider",
    components: {
      ColorSlider: ColorSlider
    },
    inheritAttrs: false,
    props: {
      color: {
        type: Object
      },
      disabled: {
        type: Boolean,
        "default": false
      },
      handleChange: {
        type: Function,
        "default": function _default() {
          return function () {};
        }
      }
    },
    setup: function setup(props) {
      var baseClassName = useBaseClassName();
      var handleValueChange = function handleValueChange(v, isDragEnd) {
        props.handleChange(v / 100, isDragEnd);
      };
      var railStyle = VueCompositionAPI.computed(function () {
        return {
          background: "linear-gradient(to right, rgba(0, 0, 0, 0), ".concat(props.color.rgb, ")")
        };
      });
      return {
        baseClassName: baseClassName,
        railStyle: railStyle,
        handleValueChange: handleValueChange
      };
    },
    render: function render() {
      var h = arguments[0];
      var baseClassName = this.baseClassName;
      return h("color-slider", {
        "class": ["".concat(baseClassName, "__alpha"), "".concat(baseClassName, "--bg-alpha")],
        "attrs": {
          "color": this.color,
          "value": this.color.alpha * 100,
          "handleChange": this.handleValueChange,
          "rail-style": this.railStyle,
          "max-value": 100,
          "disabled": this.disabled,
          "type": "alpha"
        }
      });
    }
  });

  var FORMAT_INPUT_CONFIG = {
    RGB: [{
      key: "r",
      min: 0,
      max: 255,
      type: "inputNumber"
    }, {
      key: "g",
      min: 0,
      max: 255,
      type: "inputNumber"
    }, {
      key: "b",
      min: 0,
      max: 255,
      type: "inputNumber"
    }],
    HSV: [{
      key: "h",
      min: 0,
      max: 360,
      type: "inputNumber"
    }, {
      key: "s",
      min: 0,
      max: 100,
      type: "inputNumber"
    }, {
      key: "v",
      min: 0,
      max: 100,
      type: "inputNumber"
    }],
    HSL: [{
      key: "h",
      min: 0,
      max: 360,
      type: "inputNumber"
    }, {
      key: "s",
      min: 0,
      max: 100,
      type: "inputNumber"
    }, {
      key: "l",
      min: 0,
      max: 100,
      type: "inputNumber"
    }],
    CMYK: [{
      key: "c",
      min: 0,
      max: 255,
      type: "inputNumber"
    }, {
      key: "m",
      min: 0,
      max: 255,
      type: "inputNumber"
    }, {
      key: "y",
      min: 0,
      max: 255,
      type: "inputNumber"
    }, {
      key: "k",
      min: 0,
      max: 255,
      type: "inputNumber"
    }],
    CSS: [{
      key: "css",
      type: "input",
      flex: 3
    }],
    HEX: [{
      key: "hex",
      type: "input",
      flex: 3
    }]
  };

  function ownKeys$1L(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1K(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1L(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1L(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var FormatInputs = VueCompositionAPI.defineComponent({
    name: "FormatInputs",
    components: {
      TSelect: Select,
      TOption: Option,
      TInput: Input,
      TInputNumber: InputNumber
    },
    inheritAttrs: false,
    props: _objectSpread$1K(_objectSpread$1K({}, props$H), {}, {
      color: {
        type: Object
      },
      handleFormatInputChange: {
        type: Function,
        "default": function _default() {
          return function () {};
        }
      }
    }),
    setup: function setup(props2) {
      var inputConfigs = VueCompositionAPI.computed(function () {
        var configs = _toConsumableArray(FORMAT_INPUT_CONFIG[props2.format]);
        if (props2.enableAlpha) {
          configs.push({
            type: "inputNumber",
            key: "a",
            min: 0,
            max: 100,
            format: function format(value) {
              return "".concat(value, "%");
            },
            flex: 1.15
          });
        }
        return configs;
      });
      var modelValues = VueCompositionAPI.reactive({
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        c: 0,
        m: 0,
        y: 0,
        k: 0,
        h: 0,
        l: 0,
        s: 0,
        v: 0,
        hex: "",
        css: ""
      });
      var lastModelValue = VueCompositionAPI.reactive({});
      var getFormatColorMap = function getFormatColorMap(type) {
        var color = props2.color;
        if (type === "encode") {
          return {
            HSV: color.getHsva(),
            HSL: color.getHsla(),
            RGB: color.getRgba(),
            CMYK: color.getCmyk(),
            CSS: {
              css: color.css
            },
            HEX: {
              hex: color.hex
            }
          };
        }
        return {
          HSV: Color.object2color(modelValues, "HSV"),
          HSL: Color.object2color(modelValues, "HSL"),
          RGB: Color.object2color(modelValues, "RGB"),
          CMYK: Color.object2color(modelValues, "CMYK"),
          CSS: modelValues.css,
          HEX: modelValues.hex
        };
      };
      var updateModelValue = function updateModelValue() {
        var format = props2.format,
          color = props2.color;
        var values = getFormatColorMap("encode")[format];
        values.a = Math.round(color.alpha * 100);
        Object.keys(values).forEach(function (key) {
          modelValues[key] = values[key];
          lastModelValue[key] = values[key];
        });
      };
      updateModelValue();
      var throttleUpdate = throttle$1(updateModelValue, 100);
      VueCompositionAPI.watch(function () {
        var _props2$color = props2.color,
          saturation = _props2$color.saturation,
          hue = _props2$color.hue,
          value = _props2$color.value,
          alpha = _props2$color.alpha;
        return [saturation, hue, value, alpha, props2.format];
      }, throttleUpdate);
      var handleChange = function handleChange(key, v) {
        if (v === lastModelValue[key]) {
          return;
        }
        var value = getFormatColorMap("decode")[props2.format];
        props2.handleFormatInputChange(value, modelValues.a / 100, key, v);
      };
      return {
        modelValues: modelValues,
        inputConfigs: inputConfigs,
        handleChange: handleChange
      };
    },
    render: function render() {
      var _this = this;
      var h = arguments[0];
      var inputProps = _objectSpread$1K({}, this.inputProps || {});
      return h("div", {
        "class": "input-group"
      }, [this.inputConfigs.map(function (config) {
        return h("div", {
          "class": "input-group__item",
          "key": config.key,
          "style": {
            flex: config.flex || 1
          }
        }, [config.type === "input" ? h("t-input", helper([{}, inputProps, {
          "attrs": {
            "align": "center",
            "size": "small",
            "disabled": _this.disabled,
            "maxlength": _this.format === "HEX" ? 9 : void 0,
            "title": _this.modelValues[config.key]
          },
          "on": {
            "blur": function blur(v) {
              return _this.handleChange(config.key, v);
            },
            "enter": function enter(v) {
              return _this.handleChange(config.key, v);
            }
          },
          "model": {
            value: _this.modelValues[config.key],
            callback: function callback($$v) {
              _this.$set(_this.modelValues, config.key, $$v);
            }
          }
        }])) : h("t-input-number", helper([{}, inputProps, {
          "attrs": {
            "align": "center",
            "theme": "normal",
            "size": "small",
            "disabled": _this.disabled,
            "title": _this.modelValues[config.key],
            "min": config.min,
            "max": config.max,
            "step": 1,
            "format": config.format
          },
          "on": {
            "blur": function blur(v) {
              return _this.handleChange(config.key, v);
            },
            "enter": function enter(v) {
              return _this.handleChange(config.key, v);
            }
          },
          "model": {
            value: _this.modelValues[config.key],
            callback: function callback($$v) {
              _this.$set(_this.modelValues, config.key, $$v);
            }
          }
        }]))]);
      })]);
    }
  });

  function ownKeys$1K(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1J(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1K(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1K(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var FormatPanel = VueCompositionAPI.defineComponent({
    name: "FormatPanel",
    components: {
      TSelect: Select,
      TInput: Input,
      TOption: Option,
      FormatInputs: FormatInputs
    },
    inheritAttrs: false,
    props: _objectSpread$1J(_objectSpread$1J({}, props$H), {}, {
      color: {
        type: Object
      },
      handleFormatModeChange: {
        type: Function,
        "default": function _default() {
          return function () {};
        }
      },
      handleFormatInputChange: {
        type: Function,
        "default": function _default() {
          return function () {};
        }
      }
    }),
    setup: function setup(props2) {
      var baseClassName = useBaseClassName();
      var formatModel = VueCompositionAPI.ref(props2.format);
      VueCompositionAPI.watch(function () {
        return [props2.format];
      }, function () {
        return formatModel.value = props2.format;
      });
      var handleModeChange = function handleModeChange(v) {
        formatModel.value = v;
        props2.handleFormatModeChange(v);
      };
      return {
        formatModel: formatModel,
        baseClassName: baseClassName,
        handleModeChange: handleModeChange
      };
    },
    render: function render(h) {
      var _this = this;
      var baseClassName = this.baseClassName,
        handleModeChange = this.handleModeChange;
      var newProps = _objectSpread$1J(_objectSpread$1J({}, this.$props), {}, {
        format: this.formatModel
      });
      var selectInputProps = _objectSpread$1J({}, this.selectInputProps || {});
      return h("div", {
        "class": "".concat(baseClassName, "__format")
      }, [h("div", {
        "class": "".concat(baseClassName, "__format--item")
      }, [h("t-select", {
        "attrs": {
          "size": "small",
          "selectInputProps": _objectSpread$1J({}, selectInputProps),
          "popupProps": _objectSpread$1J({
            overlayClassName: "".concat(baseClassName, "__select-options")
          }, selectInputProps.popupProps),
          "disabled": this.disabled
        },
        "class": "".concat(baseClassName, "__format-mode-select"),
        "on": {
          "change": handleModeChange
        },
        "model": {
          value: _this.formatModel,
          callback: function callback($$v) {
            _this.formatModel = $$v;
          }
        }
      }, [FORMATS.map(function (item) {
        return h("t-option", {
          "key": item,
          "attrs": {
            "value": item,
            "label": upperCase$1(item)
          },
          "style": {
            fontSize: "12px"
          }
        });
      })])]), h("div", {
        "class": "".concat(baseClassName, "__format--item")
      }, [h("format-inputs", {
        props: newProps
      })])]);
    }
  });

  function ownKeys$1J(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1I(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1J(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1J(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var SwatchesPanel = VueCompositionAPI.defineComponent({
    name: "SwatchesPanel",
    components: {
      TSelect: Select,
      TOption: Option,
      TButton: Button
    },
    props: _objectSpread$1I(_objectSpread$1I({}, baseProps), {}, {
      colors: {
        type: Array,
        "default": function _default() {
          return [];
        }
      },
      title: {
        type: String,
        "default": "\u7CFB\u7EDF\u8272\u5F69"
      },
      editable: {
        type: Boolean,
        "default": false
      },
      handleSetColor: {
        type: Function,
        "default": function _default() {
          return function () {};
        }
      },
      handleAddColor: {
        type: Function,
        "default": function _default() {
          return function () {};
        }
      }
    }),
    setup: function setup(props) {
      var baseClassName = useBaseClassName();
      var _useConfig = useConfig("colorPicker"),
        t = _useConfig.t,
        global = _useConfig.global;
      var _useConfig2 = useConfig("popconfirm"),
        confirmGlobal = _useConfig2.global;
      var classPrefix = usePrefixClass();
      var _useGlobalIcon = useGlobalIcon({
          DeleteIcon: TdDeleteIcon,
          AddIcon: TdAddIcon
        }),
        DeleteIcon = _useGlobalIcon.DeleteIcon,
        AddIcon = _useGlobalIcon.AddIcon;
      var _useCommonClassName = useCommonClassName(),
        statusClassNames = _useCommonClassName.statusClassNames;
      var visiblePopConfirm = VueCompositionAPI.ref(false);
      var colorInstance = VueCompositionAPI.computed(function () {
        return cloneDeep(props.color);
      });
      var setVisiblePopConfirm = function setVisiblePopConfirm(visible) {
        visiblePopConfirm.value = visible;
      };
      var handleClick = function handleClick(color) {
        props.handleSetColor(color);
      };
      var isEqualCurrentColor = function isEqualCurrentColor(color) {
        return Color.compare(color, colorInstance.value.css);
      };
      var selectedColorIndex = VueCompositionAPI.computed(function () {
        return props.colors.findIndex(function (color) {
          return isEqualCurrentColor(color);
        });
      });
      var handleRemoveColor = function handleRemoveColor() {
        var _props$handleChange;
        var colors = props.colors;
        var selectedIndex = selectedColorIndex.value;
        if (selectedIndex === -1) return;
        colors.splice(selectedIndex, 1);
        (_props$handleChange = props.handleChange) === null || _props$handleChange === void 0 || _props$handleChange.call(props, colors);
        setVisiblePopConfirm(false);
      };
      return {
        t: t,
        global: global,
        confirmGlobal: confirmGlobal,
        classPrefix: classPrefix,
        DeleteIcon: DeleteIcon,
        AddIcon: AddIcon,
        baseClassName: baseClassName,
        statusClassNames: statusClassNames,
        selectedColorIndex: selectedColorIndex,
        visiblePopConfirm: visiblePopConfirm,
        setVisiblePopConfirm: setVisiblePopConfirm,
        handleClick: handleClick,
        isEqualCurrentColor: isEqualCurrentColor,
        handleRemoveColor: handleRemoveColor
      };
    },
    render: function render() {
      var _this = this;
      var h = arguments[0];
      var baseClassName = this.baseClassName,
        statusClassNames = this.statusClassNames,
        title = this.title,
        editable = this.editable,
        DeleteIcon = this.DeleteIcon,
        AddIcon = this.AddIcon;
      var swatchesClass = "".concat(baseClassName, "__swatches");
      var renderActions = function renderActions() {
        if (!editable) {
          return null;
        }
        return h("div", {
          "class": "".concat(swatchesClass, "--actions")
        }, [h("span", {
          "attrs": {
            "role": "button"
          },
          "class": "".concat(baseClassName, "__icon"),
          "on": {
            "click": function click() {
              return _this.handleAddColor();
            }
          }
        }, [h(AddIcon)]), _this.colors.length > 0 ? h("span", {
          "attrs": {
            "role": "button"
          },
          "class": "".concat(baseClassName, "__icon"),
          "on": {
            "click": function click() {
              return _this.handleRemoveColor();
            }
          }
        }, [h(DeleteIcon)]) : null]);
      };
      return h("div", {
        "class": swatchesClass
      }, [h("h3", {
        "class": "".concat(swatchesClass, "--title")
      }, [h("span", [title]), renderActions()]), h("ul", {
        "class": ["".concat(swatchesClass, "--items"), "narrow-scrollbar"]
      }, [this.colors.map(function (color) {
        return h("li", {
          "class": ["".concat(swatchesClass, "--item"), _this.isEqualCurrentColor(color) && editable ? statusClassNames.active : ""],
          "key": color,
          "on": {
            "click": function click() {
              if (_this.disabled) {
                return;
              }
              _this.handleClick(color);
            }
          }
        }, [h("div", {
          "class": ["".concat(swatchesClass, "--color"), "".concat(baseClassName, "--bg-alpha")]
        }, [h("span", {
          "class": "".concat(swatchesClass, "--inner"),
          "style": {
            background: color
          }
        })])]);
      })])]);
    }
  });

  function ownKeys$1I(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1H(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1I(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1I(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var ColorPanel = VueCompositionAPI.defineComponent({
    name: "ColorPanel",
    components: {
      PanelHeader: PanelHeader,
      LinearGradient: LinearGradient,
      SaturationPanel: SaturationPanel,
      HueSlider: HueSlider,
      AlphaSlider: AlphaSlider,
      FormatPanel: FormatPanel,
      SwatchesPanel: SwatchesPanel
    },
    props: _objectSpread$1H(_objectSpread$1H({}, props$H), {}, {
      togglePopup: {
        type: Function
      }
    }),
    setup: function setup(props2) {
      var _props2$colorModes;
      var baseClassName = useBaseClassName();
      var _useCommonClassName = useCommonClassName(),
        statusClassNames = _useCommonClassName.statusClassNames;
      var _useConfig = useConfig("colorPicker"),
        t = _useConfig.t,
        global = _useConfig.global;
      var _toRefs = VueCompositionAPI.toRefs(props2),
        inputValue = _toRefs.value,
        recentColors = _toRefs.recentColors;
      var _useVModel = useVModel$1(inputValue, props2.defaultValue, props2.onChange, "change"),
        _useVModel2 = _slicedToArray(_useVModel, 2),
        innerValue = _useVModel2[0],
        setInnerValue = _useVModel2[1];
      var defaultEmptyColor = VueCompositionAPI.computed(function () {
        return isGradient.value ? DEFAULT_LINEAR_GRADIENT : DEFAULT_COLOR;
      });
      var mode = VueCompositionAPI.ref(((_props2$colorModes = props2.colorModes) === null || _props2$colorModes === void 0 ? void 0 : _props2$colorModes.length) === 1 ? props2.colorModes[0] : "monochrome");
      var isGradient = VueCompositionAPI.computed(function () {
        return mode.value === "linear-gradient";
      });
      var color = VueCompositionAPI.ref(new Color(innerValue.value || defaultEmptyColor.value));
      var updateColor = function updateColor() {
        return color.value.update(innerValue.value || defaultEmptyColor.value);
      };
      var formatModel = VueCompositionAPI.ref(color.value.isGradient ? "CSS" : "RGB");
      var _useDefaultValue = useDefaultValue(recentColors, props2.defaultRecentColors, props2.onRecentColorsChange, "recentColors", "recentColorsChange"),
        _useDefaultValue2 = _slicedToArray(_useDefaultValue, 2),
        recentlyUsedColors = _useDefaultValue2[0],
        setRecentlyUsedColors = _useDefaultValue2[1];
      var formatValue = function formatValue() {
        if (mode.value === "linear-gradient") {
          return color.value.linearGradient;
        }
        return color.value.getFormatsColorMap()[props2.format] || color.value.css;
      };
      var addRecentlyUsedColor = function addRecentlyUsedColor() {
        if (recentlyUsedColors.value === null || recentlyUsedColors.value === false) {
          return;
        }
        var colors = recentlyUsedColors.value || [];
        var currentColor = color.value.isGradient ? color.value.linearGradient : color.value.rgba;
        var index = colors.indexOf(currentColor);
        if (index > -1) {
          colors.splice(index, 1);
        }
        colors.unshift(currentColor);
        if (colors.length > TD_COLOR_USED_COLORS_MAX_SIZE) {
          colors.length = TD_COLOR_USED_COLORS_MAX_SIZE;
        }
        handleRecentlyUsedColorsChange(colors);
      };
      var handleRecentlyUsedColorsChange = function handleRecentlyUsedColorsChange(colors) {
        recentlyUsedColors.value = colors;
        setRecentlyUsedColors(colors);
      };
      var emitColorChange = function emitColorChange(trigger) {
        setInnerValue(formatValue(), {
          color: getColorObject(color.value),
          trigger: trigger || "palette-saturation-brightness"
        });
      };
      VueCompositionAPI.watch(function () {
        return [props2.defaultValue, props2.enableAlpha];
      }, updateColor);
      VueCompositionAPI.watch(function () {
        return innerValue.value;
      }, function (newColor) {
        if (newColor !== formatValue()) {
          updateColor();
          mode.value = color.value.isGradient ? "linear-gradient" : "monochrome";
        }
      });
      var handleModeChange = function handleModeChange(value) {
        mode.value = value;
        if (value === "linear-gradient") {
          color.value.update(color.value.gradientColors.length > 0 ? color.value.linearGradient : DEFAULT_LINEAR_GRADIENT);
        } else {
          color.value.update(color.value.rgba);
        }
        emitColorChange();
      };
      var handleFormatModeChange = function handleFormatModeChange(format) {
        return formatModel.value = format;
      };
      var handleSatAndValueChange = function handleSatAndValueChange(_ref) {
        var saturation = _ref.saturation,
          value = _ref.value;
        var _color$value = color.value,
          sat = _color$value.saturation,
          val = _color$value.value;
        var changeTrigger = "palette-saturation-brightness";
        if (value !== val && saturation !== sat) {
          color.value.saturation = saturation;
          color.value.value = value;
          changeTrigger = "palette-saturation-brightness";
        } else if (saturation !== sat) {
          color.value.saturation = saturation;
          changeTrigger = "palette-saturation";
        } else if (value !== val) {
          color.value.value = value;
          changeTrigger = "palette-brightness";
        } else {
          return;
        }
        emitColorChange(changeTrigger);
      };
      var handleHueChange = function handleHueChange(hue) {
        var _props2$onPaletteBarC;
        color.value.hue = hue;
        emitColorChange("palette-hue-bar");
        (_props2$onPaletteBarC = props2.onPaletteBarChange) === null || _props2$onPaletteBarC === void 0 || _props2$onPaletteBarC.call(props2, {
          color: getColorObject(color.value)
        });
      };
      var handleAlphaChange = function handleAlphaChange(alpha) {
        color.value.alpha = alpha;
        emitColorChange("palette-alpha-bar");
      };
      var handleInputChange = function handleInputChange(input, alpha) {
        color.value.update(input);
        color.value.alpha = alpha;
        emitColorChange("input");
      };
      var handleGradientChange = function handleGradientChange(_ref2) {
        var key = _ref2.key,
          payload = _ref2.payload;
        var trigger = "palette-saturation-brightness";
        switch (key) {
          case "degree":
            color.value.gradientDegree = payload;
            trigger = "input";
            break;
          case "selectedId":
            color.value.gradientSelectedId = payload;
            break;
          case "colors":
            color.value.gradientColors = payload;
            break;
        }
        emitColorChange(trigger);
      };
      var handleSetColor = function handleSetColor(type, value) {
        var isGradientValue = Color.isGradientColor(value);
        if (isGradientValue) {
          if (props2.colorModes.includes("linear-gradient")) {
            mode.value = "linear-gradient";
            color.value.update(value);
            color.value.updateCurrentGradientColor();
          } else {
            console.warn("\u8BE5\u6A21\u5F0F\u4E0D\u652F\u6301\u6E10\u53D8\u8272");
          }
        } else if (mode.value === "linear-gradient") {
          color.value.updateStates(value);
          color.value.updateCurrentGradientColor();
        } else {
          color.value.update(value);
        }
        emitColorChange();
      };
      var previewColorStyle = VueCompositionAPI.computed(function () {
        return mode.value === "linear-gradient" ? color.value.linearGradient : color.value.rgba;
      });
      return {
        baseClassName: baseClassName,
        statusClassNames: statusClassNames,
        t: t,
        global: global,
        color: color,
        mode: mode,
        isGradient: isGradient,
        formatModel: formatModel,
        recentlyUsedColors: recentlyUsedColors,
        previewColorStyle: previewColorStyle,
        addRecentlyUsedColor: addRecentlyUsedColor,
        handleModeChange: handleModeChange,
        handleSatAndValueChange: handleSatAndValueChange,
        handleHueChange: handleHueChange,
        handleAlphaChange: handleAlphaChange,
        handleGradientChange: handleGradientChange,
        handleSetColor: handleSetColor,
        handleFormatModeChange: handleFormatModeChange,
        handleInputChange: handleInputChange,
        handleRecentlyUsedColorsChange: handleRecentlyUsedColorsChange
      };
    },
    render: function render() {
      var _systemColors,
        _this = this;
      var h = arguments[0];
      var baseClassName = this.baseClassName,
        statusClassNames = this.statusClassNames,
        t = this.t,
        global = this.global,
        swatchColors = this.swatchColors,
        previewColorStyle = this.previewColorStyle,
        isGradient = this.isGradient;
      var showUsedColors = this.recentlyUsedColors !== null && this.recentlyUsedColors !== false;
      var systemColors = swatchColors;
      if (systemColors === void 0) {
        systemColors = _toConsumableArray(DEFAULT_SYSTEM_SWATCH_COLORS);
      }
      var showSystemColors = ((_systemColors = systemColors) === null || _systemColors === void 0 ? void 0 : _systemColors.length) > 0;
      var renderSwatches = function renderSwatches() {
        if (!showSystemColors && !showUsedColors) {
          return null;
        }
        return h("div", {
          "class": "".concat(baseClassName, "__swatches-wrap")
        }, [showUsedColors ? h("swatches-panel", {
          "attrs": {
            "color": _this.color,
            "disabled": _this.disabled,
            "title": t(global.recentColorTitle),
            "editable": true,
            "colors": _this.recentlyUsedColors,
            "handleAddColor": _this.addRecentlyUsedColor,
            "handleSetColor": function handleSetColor(color) {
              _this.handleSetColor("used", color);
            },
            "handleChange": _this.handleRecentlyUsedColorsChange
          }
        }) : null, showSystemColors ? h("swatches-panel", {
          "attrs": {
            "color": _this.color,
            "disabled": _this.disabled,
            "title": t(global.swatchColorTitle),
            "colors": systemColors,
            "handleSetColor": function handleSetColor(color) {
              return _this.handleSetColor("system", color);
            }
          }
        }) : null]);
      };
      return h("div", {
        "class": ["".concat(baseClassName, "__panel"), this.disabled ? statusClassNames.disabled : false]
      }, [h("panel-header", {
        "props": _objectSpread$1H({}, _objectSpread$1H({}, this.$props)),
        "attrs": {
          "mode": this.mode,
          "handleModeChange": this.handleModeChange
        }
      }), h("div", {
        "class": ["".concat(baseClassName, "__body")]
      }, [isGradient ? h("linear-gradient", {
        "attrs": {
          "color": this.color,
          "disabled": this.disabled,
          "handleChange": this.handleGradientChange,
          "enableMultipleGradient": this.enableMultipleGradient
        }
      }) : null, h("saturation-panel", {
        "attrs": {
          "color": this.color,
          "disabled": this.disabled,
          "handleChange": this.handleSatAndValueChange
        }
      }), h("div", {
        "class": ["".concat(baseClassName, "__sliders-wrapper")]
      }, [h("div", {
        "class": ["".concat(baseClassName, "__sliders")]
      }, [h("hue-slider", {
        "attrs": {
          "color": this.color,
          "disabled": this.disabled,
          "handleChange": this.handleHueChange
        }
      }), this.enableAlpha ? h("alpha-slider", {
        "attrs": {
          "color": this.color,
          "disabled": this.disabled,
          "handleChange": this.handleAlphaChange
        }
      }) : null]), this.showPrimaryColorPreview ? h("div", {
        "class": ["".concat(baseClassName, "__sliders-preview"), "".concat(baseClassName, "--bg-alpha")]
      }, [h("span", {
        "class": "".concat(baseClassName, "__sliders-preview-inner"),
        "style": {
          background: previewColorStyle
        }
      })]) : null]), h("format-panel", {
        "props": _objectSpread$1H({}, _objectSpread$1H(_objectSpread$1H({}, this.$props), {}, {
          format: this.formatModel
        })),
        "attrs": {
          "color": this.color,
          "handleFormatModeChange": this.handleFormatModeChange,
          "handleFormatInputChange": this.handleInputChange
        }
      }), renderSwatches()])]);
    }
  });

  function ownKeys$1H(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1G(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1H(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1H(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _ColorPickerPanel = VueCompositionAPI.defineComponent({
    name: "TColorPickerPanel",
    components: {
      ColorPanel: ColorPanel
    },
    inheritAttrs: false,
    props: _objectSpread$1G({}, props$H),
    setup: function setup(props2) {
      var prefix = usePrefixClass$1();
      var _toRefs = VueCompositionAPI.toRefs(props2),
        value = _toRefs.value;
      var _useVModel = useVModel$1(value, props2.defaultValue, props2.onChange, "change"),
        _useVModel2 = _slicedToArray(_useVModel, 2),
        innerValue = _useVModel2[0],
        setInnerValue = _useVModel2[1];
      var handleChange = function handleChange(value2, context) {
        setInnerValue(value2, context);
      };
      return {
        prefix: prefix,
        innerValue: innerValue,
        setInnerValue: setInnerValue,
        handleChange: handleChange
      };
    },
    render: function render() {
      var h = arguments[0];
      var prefix = this.prefix,
        innerValue = this.innerValue,
        handleChange = this.handleChange;
      return h("color-panel", helper([{
        "props": _objectSpread$1G({}, _objectSpread$1G(_objectSpread$1G({}, this.$props), {}, {
          closeBtn: false,
          popupProps: null,
          value: innerValue
        }))
      }, {
        "on": {
          change: handleChange
        }
      }, {
        "class": "".concat(prefix, "-is-inline")
      }]));
    }
  });

  function ownKeys$1G(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1F(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1G(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1G(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var DefaultTrigger = VueCompositionAPI.defineComponent({
    name: "DefaultTrigger",
    components: {
      TInput: Input,
      TInputNumber: InputNumber
    },
    inheritAttrs: false,
    props: {
      borderless: {
        type: Boolean,
        "default": false
      },
      color: {
        type: String,
        "default": ""
      },
      disabled: {
        type: Boolean,
        "default": false
      },
      inputProps: {
        type: Object,
        "default": function _default() {
          return {
            autoWidth: true
          };
        }
      },
      handleTriggerChange: {
        type: Function,
        "default": function _default() {
          return function () {};
        }
      },
      clearable: {
        type: Boolean,
        "default": false
      },
      size: {
        type: String,
        "default": "medium"
      }
    },
    setup: function setup(props) {
      var baseClassName = useBaseClassName();
      var value = VueCompositionAPI.ref(props.color);
      var _useCommonClassName = useCommonClassName(),
        sizeClassNames = _useCommonClassName.sizeClassNames;
      VueCompositionAPI.watch(function () {
        return [props.color];
      }, function () {
        return value.value = props.color;
      });
      var handleChange = function handleChange(input) {
        if (input === props.color) {
          return;
        }
        if (!Color.isValid(input) && input) {
          value.value = props.color;
        } else {
          value.value = input;
        }
        props.handleTriggerChange(value.value);
      };
      return {
        baseClassName: baseClassName,
        value: value,
        handleChange: handleChange,
        sizeClassNames: sizeClassNames
      };
    },
    render: function render() {
      var _this = this;
      var h = arguments[0];
      var baseClassName = this.baseClassName;
      var inputSlots = {
        label: function label() {
          return h("div", {
            "class": ["".concat(baseClassName, "__trigger--default__color"), "".concat(baseClassName, "--bg-alpha")]
          }, [h("span", {
            "class": ["color-inner", _defineProperty$2({}, _this.sizeClassNames[_this.size], _this.size !== "medium")],
            "style": {
              background: _this.value
            }
          })]);
        }
      };
      return h("div", {
        "class": "".concat(baseClassName, "__trigger--default")
      }, [h("t-input", {
        "scopedSlots": inputSlots,
        "attrs": {
          "borderless": this.borderless,
          "clearable": this.clearable,
          "disabled": this.disabled,
          "size": this.size
        },
        "on": {
          "blur": this.handleChange
        },
        "props": _objectSpread$1F({}, _objectSpread$1F({}, this.inputProps)),
        "model": {
          value: _this.value,
          callback: function callback($$v) {
            _this.value = $$v;
          }
        }
      })]);
    }
  });

  function ownKeys$1F(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1E(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1F(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1F(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _ColorPicker = VueCompositionAPI.defineComponent({
    name: "TColorPicker",
    components: {
      TPopup: Popup,
      ColorPanel: ColorPanel,
      DefaultTrigger: DefaultTrigger
    },
    props: _objectSpread$1E({}, props$H),
    setup: function setup(props2) {
      var baseClassName = useBaseClassName();
      var visible = VueCompositionAPI.ref(false);
      var setVisible = function setVisible(value2) {
        return visible.value = value2;
      };
      var _toRefs = VueCompositionAPI.toRefs(props2),
        value = _toRefs.value;
      var _useVModel = useVModel$1(value, props2.defaultValue, props2.onChange, "change"),
        _useVModel2 = _slicedToArray(_useVModel, 2),
        innerValue = _useVModel2[0],
        setInnerValue = _useVModel2[1];
      var handleChange = function handleChange(value2, context) {
        setInnerValue(value2, context);
      };
      var handlePaletteChange = function handlePaletteChange(context) {
        props2.onPaletteBarChange(context);
      };
      return {
        baseClassName: baseClassName,
        innerValue: innerValue,
        visible: visible,
        setVisible: setVisible,
        setInnerValue: setInnerValue,
        handleChange: handleChange,
        handlePaletteChange: handlePaletteChange
      };
    },
    render: function render() {
      var _this = this;
      var h = arguments[0];
      var popupProps = this.popupProps,
        disabled = this.disabled,
        innerValue = this.innerValue,
        baseClassName = this.baseClassName,
        setVisible = this.setVisible,
        handleChange = this.handleChange,
        handlePaletteChange = this.handlePaletteChange;
      var renderPopupContent = function renderPopupContent() {
        if (disabled) {
          return null;
        }
        return h("color-panel", helper([{
          "props": _objectSpread$1E({}, _objectSpread$1E(_objectSpread$1E({}, _this.$props), {}, {
            value: innerValue
          })),
          "attrs": {
            "togglePopup": setVisible
          }
        }, {
          "on": {
            change: handleChange,
            handlePaletteChange: handlePaletteChange
          }
        }, {
          "ref": "refColorPanel"
        }]));
      };
      var popProps = _objectSpread$1E({
        placement: "bottom-left",
        trigger: "click",
        attach: "body",
        overlayClassName: [baseClassName],
        visible: this.visible,
        overlayInnerStyle: {
          padding: 0
        },
        onVisibleChange: function onVisibleChange(visible, context) {
          if (context.trigger === "document") {
            _this.setVisible(false);
          }
        }
      }, popupProps || {});
      return h("t-popup", {
        "props": _objectSpread$1E({}, _objectSpread$1E({}, popProps)),
        "attrs": {
          "content": renderPopupContent
        }
      }, [h("div", {
        "class": "".concat(baseClassName, "__trigger"),
        "on": {
          "click": function click() {
            return setVisible(!_this.visible);
          }
        }
      }, [renderTNodeJSXDefault(this, "default", h("default-trigger", {
        "attrs": {
          "borderless": this.borderless,
          "color": this.innerValue,
          "disabled": disabled,
          "clearable": this.clearable,
          "input-props": this.inputProps,
          "handleTriggerChange": this.setInnerValue,
          "size": this.size
        }
      }))])]);
    }
  });

  var ColorPickerPanel = withInstall$1(_ColorPickerPanel, VueCompositionAPI__default["default"]);
  var ColorPicker = withInstall$1(_ColorPicker, VueCompositionAPI__default["default"]);

  var isoWeeksInYear = createCommonjsModule(function (module, exports) {
    !function (e, n) {
      module.exports = n() ;
    }(commonjsGlobal, function () {

      return function (e, n) {
        n.prototype.isoWeeksInYear = function () {
          var e = this.isLeapYear(),
            n = this.endOf("y").day();
          return 4 === n || e && 5 === n ? 53 : 52;
        };
      };
    });
  });

  var isLeapYear = createCommonjsModule(function (module, exports) {
    !function (e, t) {
      module.exports = t() ;
    }(commonjsGlobal, function () {

      return function (e, t) {
        t.prototype.isLeapYear = function () {
          return this.$y % 4 == 0 && this.$y % 100 != 0 || this.$y % 400 == 0;
        };
      };
    });
  });

  dayjs_min.extend(isoWeeksInYear);
  dayjs_min.extend(isLeapYear);
  var TIME_FORMAT$1 = "HH:mm:ss";
  function extractTimeFormat() {
    var dateFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return dateFormat.replace(/\W?Y{2,4}|\W?D{1,2}|\W?Do|\W?d{1,4}|\W?M{1,4}|\W?y{2,4}/g, "").trim();
  }
  function parseToDayjs(value, format, timeOfDay, dayjsLocale) {
    if (value === "" || value === null) return dayjs_min();
    var dateText = value;
    if (/[w|W]/g.test(format)) {
      if (!isString(dateText)) {
        dateText = dayjs_min(dateText).locale(dayjsLocale || "zh-cn").format(format);
      }
      var yearStr = dateText.split(/[-/.\s]/)[0];
      var weekStr = dateText.split(/[-/.\s]/)[1];
      var weekFormatStr = format.split(/[-/.\s]/)[1];
      var firstWeek = dayjs_min(yearStr, "YYYY").locale(dayjsLocale || "zh-cn").startOf("year");
      if (firstWeek.day() > 4 || firstWeek.day() === 0) firstWeek = firstWeek.add(1, "week");
      var weekCounts = dayjs_min(yearStr, "YYYY").locale(dayjsLocale || "zh-cn").isoWeeksInYear();
      for (var i = 0; i <= weekCounts; i += 1) {
        var nextWeek = firstWeek.add(i, "week");
        if (timeOfDay === "start") nextWeek = nextWeek.subtract(5, "day");
        if (nextWeek.format(weekFormatStr) === weekStr) {
          return nextWeek;
        }
      }
    }
    if (/Q/g.test(format)) {
      if (!isString(dateText)) {
        dateText = dayjs_min(dateText).locale(dayjsLocale || "zh-cn").format(format);
      }
      var _yearStr = dateText.split(/[-/.\s]/)[0];
      var quarterStr = dateText.split(/[-/.\s]/)[1];
      var quarterFormatStr = format.split(/[-/.\s]/)[1];
      var firstQuarter = dayjs_min(_yearStr, "YYYY").startOf("year");
      for (var _i = 0; _i < 4; _i += 1) {
        var nextQuarter = firstQuarter.add(_i, "quarter");
        if (nextQuarter.format(quarterFormatStr) === quarterStr) {
          return nextQuarter;
        }
      }
    }
    var result = dayjs_min(dateText, format).isValid() ? dayjs_min(dateText, format) : dayjs_min(dateText);
    if (!result.isValid()) {
      log.error("DatePicker", "Check whether the format\u3001value format is valid.\n value: '".concat(value, "', format: '").concat(format, "'"));
      return dayjs_min();
    }
    return result;
  }
  function formatRange(_ref) {
    var newDate = _ref.newDate,
      format = _ref.format,
      dayjsLocale = _ref.dayjsLocale,
      targetFormat = _ref.targetFormat,
      autoSwap = _ref.autoSwap;
    if (!newDate || !Array.isArray(newDate)) return [];
    var dayjsDateList = newDate.map(function (d) {
      return d && parseToDayjs(d, format).locale(dayjsLocale);
    });
    if (autoSwap && dayjsDateList[0] && dayjsDateList[1] && dayjsDateList[0].toDate().getTime() > dayjsDateList[1].toDate().getTime()) {
      dayjsDateList = [dayjsDateList[1], dayjsDateList[0]];
    }
    if (dayjsDateList.some(function (r) {
      return r && !r.isValid();
    })) {
      log.error("DatePicker", "Check whether the value\u3001format\u3001valueType format is valid.\nformat: '".concat(format, "' value: '").concat(newDate, "' valueType: '").concat(targetFormat, "'"));
      return [];
    }
    if (targetFormat === "time-stamp") return dayjsDateList.map(function (da) {
      return da && da.toDate().getTime();
    });
    if (targetFormat === "Date") return dayjsDateList.map(function (da) {
      return da && da.toDate();
    });
    return dayjsDateList.map(function (da) {
      return da && da.format(targetFormat || format);
    });
  }
  function formatSingle(_ref2) {
    var newDate = _ref2.newDate,
      format = _ref2.format,
      targetFormat = _ref2.targetFormat,
      dayjsLocale = _ref2.dayjsLocale;
    if (!newDate) return "";
    var dayJsDate = parseToDayjs(newDate, format).locale(dayjsLocale);
    if (!dayJsDate.isValid()) {
      log.error("DatePicker", "Check whether the format\u3001value format is valid.\nformat: '".concat(format, "' value: '").concat(newDate, "'"));
      return "";
    }
    if (targetFormat === "time-stamp") return dayJsDate.toDate().getTime();
    if (targetFormat === "Date") return dayJsDate.toDate();
    return dayJsDate.format(targetFormat || format);
  }
  function isValidDate(value, format) {
    if (Array.isArray(value)) {
      return value.every(function (v) {
        if (v === "") return true;
        return dayjs_min(v, format).isValid() || dayjs_min(v).isValid();
      });
    }
    if (value === "") return true;
    return dayjs_min(value, format).isValid() || dayjs_min(value).isValid();
  }
  function formatDate(newDate, _ref3) {
    var format = _ref3.format,
      targetFormat = _ref3.targetFormat,
      _ref3$dayjsLocale = _ref3.dayjsLocale,
      dayjsLocale = _ref3$dayjsLocale === void 0 ? "zh-cn" : _ref3$dayjsLocale,
      autoSwap = _ref3.autoSwap;
    var result;
    if (Array.isArray(newDate)) {
      result = formatRange({
        newDate: newDate,
        format: format,
        dayjsLocale: dayjsLocale,
        targetFormat: targetFormat,
        autoSwap: autoSwap
      });
    } else {
      result = formatSingle({
        newDate: newDate,
        format: format,
        dayjsLocale: dayjsLocale,
        targetFormat: targetFormat
      });
    }
    return result;
  }
  function calcFormatTime(time, timeFormat) {
    if (time && timeFormat) {
      var timeArr = time.split(":");
      var timeFormatArr = timeFormat.split(":");
      return timeArr.slice(0, timeFormatArr.length).join(":");
    }
    return time;
  }
  function formatTime(value, format, timeFormat, defaultTime) {
    var _result;
    var result = Array.isArray(value) ? value : [value];
    defaultTime = Array.isArray(defaultTime) ? defaultTime : [defaultTime, defaultTime];
    result = result.map(function (v, i) {
      if (v) return dayjs_min(v, typeof v === "string" ? format : void 0).format(timeFormat);
      return calcFormatTime(defaultTime[i], timeFormat);
    });
    result = result.length ? result : defaultTime.map(function (t) {
      return calcFormatTime(t, timeFormat);
    });
    return Array.isArray(value) ? result : (_result = result) === null || _result === void 0 ? void 0 : _result[0];
  }
  function getDefaultFormat(_ref4) {
    var _ref4$mode = _ref4.mode,
      mode = _ref4$mode === void 0 ? "date" : _ref4$mode,
      format = _ref4.format,
      valueType = _ref4.valueType,
      enableTimePicker = _ref4.enableTimePicker;
    if (mode === "year") {
      return {
        format: format || "YYYY",
        valueType: valueType || format || "YYYY",
        timeFormat: TIME_FORMAT$1
      };
    }
    if (mode === "month") {
      return {
        format: format || "YYYY-MM",
        valueType: valueType || format || "YYYY-MM",
        timeFormat: TIME_FORMAT$1
      };
    }
    if (mode === "quarter") {
      return {
        format: format || "YYYY-[Q]Q",
        valueType: valueType || format || "YYYY-[Q]Q",
        timeFormat: TIME_FORMAT$1
      };
    }
    if (mode === "week") {
      return {
        format: format || "gggg-wo",
        valueType: valueType || format || "gggg-wo",
        timeFormat: TIME_FORMAT$1
      };
    }
    if (mode === "date") {
      return {
        format: format || "YYYY-MM-DD".concat(enableTimePicker ? " HH:mm:ss" : ""),
        valueType: valueType || format || "YYYY-MM-DD".concat(enableTimePicker ? " HH:mm:ss" : ""),
        timeFormat: extractTimeFormat(format || "YYYY-MM-DD".concat(enableTimePicker ? " HH:mm:ss" : "")) || TIME_FORMAT$1
      };
    }
    log.error("DatePicker", "Invalid mode: ".concat(mode));
    return {};
  }
  function initYearMonthTime(_ref5) {
    var value = _ref5.value,
      _ref5$mode = _ref5.mode,
      mode = _ref5$mode === void 0 ? "date" : _ref5$mode,
      format = _ref5.format,
      _ref5$timeFormat = _ref5.timeFormat,
      timeFormat = _ref5$timeFormat === void 0 ? "HH:mm:ss" : _ref5$timeFormat,
      enableTimePicker = _ref5.enableTimePicker;
    var defaultYearMonthTime = {
      year: [dayjs_min().year(), dayjs_min().year()],
      month: [dayjs_min().month(), dayjs_min().month()],
      time: [dayjs_min().format(timeFormat), dayjs_min().format(timeFormat)]
    };
    if (mode === "year") {
      defaultYearMonthTime.year[1] += 10;
    } else if (mode === "month" || mode === "quarter") {
      defaultYearMonthTime.year[1] += 1;
    } else if ((mode === "date" || mode === "week") && !enableTimePicker) {
      if (defaultYearMonthTime.month[0] === 11) {
        defaultYearMonthTime.year[1] += 1;
        defaultYearMonthTime.month[1] = 0;
      } else {
        defaultYearMonthTime.month[1] += 1;
      }
    }
    if (!value || !Array.isArray(value) || !value.length) {
      return defaultYearMonthTime;
    }
    return {
      year: value.map(function (v) {
        return parseToDayjs(v, format).year();
      }),
      month: value.map(function (v) {
        return parseToDayjs(v, format).month();
      }),
      time: value.map(function (v) {
        return parseToDayjs(v, format).format(timeFormat);
      })
    };
  }

  function useSingleValue(props) {
    var _toRefs = VueCompositionAPI.toRefs(props),
      valueFromProps = _toRefs.value;
    var _useVModel = useVModel$1(valueFromProps, props.defaultValue, props.onChange, "change"),
      _useVModel2 = _slicedToArray(_useVModel, 2),
      value = _useVModel2[0],
      onChange = _useVModel2[1];
    var formatRef = VueCompositionAPI.computed(function () {
      return getDefaultFormat({
        mode: props.mode,
        format: props.format,
        enableTimePicker: props.multiple ? false : props.enableTimePicker
      });
    });
    if (props.enableTimePicker) {
      if (!extractTimeFormat(formatRef.value.format)) console.error("format: ".concat(formatRef.value.format, " \u4E0D\u89C4\u8303\uFF0C\u5305\u542B\u65F6\u95F4\u9009\u62E9\u5FC5\u987B\u8981\u6709\u65F6\u95F4\u683C\u5F0F\u5316 HH:mm:ss"));
    }
    var time = VueCompositionAPI.ref(formatTime(props.multiple ? value.value[0] : value.value, formatRef.value.format, formatRef.value.timeFormat, props.defaultTime));
    var month = VueCompositionAPI.ref(parseToDayjs(props.multiple ? value.value[0] : value.value, formatRef.value.format).month());
    var year = VueCompositionAPI.ref(parseToDayjs(props.multiple ? value.value[0] : value.value, formatRef.value.format).year());
    var cacheValue = VueCompositionAPI.ref(formatDate(props.multiple ? value.value[0] : value.value, {
      format: formatRef.value.format
    }));
    VueCompositionAPI.watchEffect(function () {
      if (!value.value) {
        cacheValue.value = "";
        return;
      }
      if (!isValidDate(value.value, formatRef.value.format)) return;
      cacheValue.value = formatDate(value.value, {
        format: formatRef.value.format
      });
      time.value = formatTime(value.value, formatRef.value.format, formatRef.value.timeFormat, props.defaultTime);
    });
    return {
      year: year,
      month: month,
      value: value,
      time: time,
      cacheValue: cacheValue,
      onChange: onChange
    };
  }

  function ownKeys$1E(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1D(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1E(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1E(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function useSingle(props, _ref) {
    var emit = _ref.emit;
    var COMPONENT_NAME = usePrefixClass("date-picker");
    var inputRef = VueCompositionAPI.ref();
    var _useSingleValue = useSingleValue(props),
      value = _useSingleValue.value,
      onChange = _useSingleValue.onChange,
      time = _useSingleValue.time,
      month = _useSingleValue.month,
      year = _useSingleValue.year,
      cacheValue = _useSingleValue.cacheValue;
    var formatRef = VueCompositionAPI.computed(function () {
      return getDefaultFormat({
        mode: props.mode,
        format: props.format,
        valueType: props.valueType,
        enableTimePicker: props.multiple ? false : props.enableTimePicker
      });
    });
    var popupVisible = VueCompositionAPI.ref(false);
    var isHoverCell = VueCompositionAPI.ref(false);
    var inputValue = VueCompositionAPI.ref(formatDate(value.value, {
      format: formatRef.value.format
    }));
    var inputProps = VueCompositionAPI.computed(function () {
      var inputProps2 = _objectSpread$1D(_objectSpread$1D({}, props.inputProps), {}, {
        ref: inputRef,
        borderless: props.borderless,
        size: props.size,
        prefixIcon: props.prefixIcon,
        "class": [_defineProperty$2({}, "".concat(COMPONENT_NAME.value, "__input--placeholder"), isHoverCell.value)],
        onClear: function onClear(context) {
          var _context$e;
          context === null || context === void 0 || (_context$e = context.e) === null || _context$e === void 0 || _context$e.stopPropagation();
          popupVisible.value = false;
          onChange === null || onChange === void 0 || onChange("", {
            dayjsValue: dayjs_min(),
            trigger: "clear"
          });
          emit("clear", "", {
            dayjsValue: dayjs_min(),
            trigger: "clear"
          });
        },
        onBlur: function onBlur(val, context) {
          var _props$onBlur;
          (_props$onBlur = props.onBlur) === null || _props$onBlur === void 0 || _props$onBlur.call(props, {
            value: val,
            e: context.e
          });
          emit("blur", {
            value: val,
            e: context.e
          });
        },
        onFocus: function onFocus(_, _ref3) {
          var _props$onFocus;
          var e = _ref3.e;
          (_props$onFocus = props.onFocus) === null || _props$onFocus === void 0 || _props$onFocus.call(props, {
            value: value.value,
            e: e
          });
          emit("focus", {
            value: value.value,
            e: e
          });
        },
        onChange: function onChange(val) {
          inputValue.value = val;
          if (!isValidDate(val, formatRef.value.format)) return;
          cacheValue.value = val;
          var newMonth = parseToDayjs(val, formatRef.value.format).month();
          var newYear = parseToDayjs(val, formatRef.value.format).year();
          var newTime = formatTime(val, formatRef.value.format, formatRef.value.timeFormat, props.defaultTime);
          !Number.isNaN(newYear) && (year.value = newYear);
          !Number.isNaN(newMonth) && (month.value = newMonth);
          !Number.isNaN(newTime) && (time.value = newTime);
        },
        onEnter: function onEnter(val) {
          if (!val) {
            onChange === null || onChange === void 0 || onChange("", {
              dayjsValue: dayjs_min(),
              trigger: "enter"
            });
            popupVisible.value = false;
            return;
          }
          if (!isValidDate(val, formatRef.value.format) && !isValidDate(value.value, formatRef.value.format)) return;
          popupVisible.value = false;
          if (isValidDate(val, formatRef.value.format)) {
            onChange === null || onChange === void 0 || onChange(formatDate(val, {
              format: formatRef.value.format,
              targetFormat: formatRef.value.valueType
            }), {
              dayjsValue: parseToDayjs(val, formatRef.value.format),
              trigger: "enter"
            });
          } else if (isValidDate(value.value, formatRef.value.format)) {
            inputValue.value = formatDate(value.value, {
              format: formatRef.value.format
            });
          } else {
            inputValue.value = "";
          }
        }
      });
      return props.multiple ? _objectSpread$1D({}, omit$2(inputProps2, ["ref", "class"])) : inputProps2;
    });
    var popupProps = VueCompositionAPI.computed(function () {
      var _props$popupProps$ove, _props$popupProps, _props$popupProps2;
      return _objectSpread$1D(_objectSpread$1D({
        expandAnimation: true
      }, props.popupProps), {}, {
        trigger: "click",
        overlayInnerStyle: (_props$popupProps$ove = (_props$popupProps = props.popupProps) === null || _props$popupProps === void 0 ? void 0 : _props$popupProps.overlayInnerStyle) !== null && _props$popupProps$ove !== void 0 ? _props$popupProps$ove : {
          width: "auto"
        },
        overlayClassName: [(_props$popupProps2 = props.popupProps) === null || _props$popupProps2 === void 0 ? void 0 : _props$popupProps2.overlayClassName, "".concat(COMPONENT_NAME.value, "__panel-container")],
        onVisibleChange: function onVisibleChange(visible, context) {
          var _props$popupProps3, _props$popupProps3$on;
          (_props$popupProps3 = props.popupProps) === null || _props$popupProps3 === void 0 || (_props$popupProps3$on = _props$popupProps3.onVisibleChange) === null || _props$popupProps3$on === void 0 || _props$popupProps3$on.call(_props$popupProps3, visible, context);
          if (context.trigger === "trigger-element-click") {
            popupVisible.value = true;
            return;
          }
          popupVisible.value = visible;
        }
      });
    });
    VueCompositionAPI.watch(value, function (value2) {
      if (!value2) {
        inputValue.value = "";
        return;
      }
      if (!isValidDate(value2, formatRef.value.format)) return;
      inputValue.value = formatDate(value2, {
        format: formatRef.value.format
      });
    }, {
      immediate: true
    });
    return {
      year: year,
      month: month,
      value: value,
      time: time,
      inputValue: inputValue,
      popupVisible: popupVisible,
      inputProps: inputProps,
      popupProps: popupProps,
      inputRef: inputRef,
      cacheValue: cacheValue,
      isHoverCell: isHoverCell,
      onChange: onChange
    };
  }

  function _objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
  }

  function _extends$1() {
    return _extends$1 = Object.assign ? Object.assign.bind() : function (n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
      return n;
    }, _extends$1.apply(null, arguments);
  }

  var isBetween = createCommonjsModule(function (module, exports) {
    !function (e, i) {
      module.exports = i() ;
    }(commonjsGlobal, function () {

      return function (e, i, t) {
        i.prototype.isBetween = function (e, i, s, f) {
          var n = t(e),
            o = t(i),
            r = "(" === (f = f || "()")[0],
            u = ")" === f[1];
          return (r ? this.isAfter(n, s) : !this.isBefore(n, s)) && (u ? this.isBefore(o, s) : !this.isAfter(o, s)) || (r ? this.isBefore(n, s) : !this.isAfter(n, s)) && (u ? this.isAfter(o, s) : !this.isBefore(o, s));
        };
      };
    });
  });

  var weekOfYear = createCommonjsModule(function (module, exports) {
    !function (e, t) {
      module.exports = t() ;
    }(commonjsGlobal, function () {

      var e = "week",
        t = "year";
      return function (i, n, r) {
        var f = n.prototype;
        f.week = function (i) {
          if (void 0 === i && (i = null), null !== i) return this.add(7 * (i - this.week()), "day");
          var n = this.$locale().yearStart || 1;
          if (11 === this.month() && this.date() > 25) {
            var f = r(this).startOf(t).add(1, t).date(n),
              s = r(this).endOf(e);
            if (f.isBefore(s)) return 1;
          }
          var a = r(this).startOf(t).date(n).startOf(e).subtract(1, "millisecond"),
            o = this.diff(a, e, !0);
          return o < 0 ? r(this).startOf("week").week() : Math.ceil(o);
        }, f.weeks = function (e) {
          return void 0 === e && (e = null), this.week(e);
        };
      };
    });
  });

  var weekYear = createCommonjsModule(function (module, exports) {
    !function (e, t) {
      module.exports = t() ;
    }(commonjsGlobal, function () {

      return function (e, t) {
        t.prototype.weekYear = function () {
          var e = this.month(),
            t = this.week(),
            n = this.year();
          return 1 === t && 11 === e ? n + 1 : 0 === e && t >= 52 ? n - 1 : n;
        };
      };
    });
  });

  var localeData = createCommonjsModule(function (module, exports) {
    !function (n, e) {
      module.exports = e() ;
    }(commonjsGlobal, function () {

      return function (n, e, t) {
        var r = e.prototype,
          o = function o(n) {
            return n && (n.indexOf ? n : n.s);
          },
          u = function u(n, e, t, r, _u) {
            var i = n.name ? n : n.$locale(),
              a = o(i[e]),
              s = o(i[t]),
              f = a || s.map(function (n) {
                return n.slice(0, r);
              });
            if (!_u) return f;
            var d = i.weekStart;
            return f.map(function (n, e) {
              return f[(e + (d || 0)) % 7];
            });
          },
          i = function i() {
            return t.Ls[t.locale()];
          },
          a = function a(n, e) {
            return n.formats[e] || function (n) {
              return n.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function (n, e, t) {
                return e || t.slice(1);
              });
            }(n.formats[e.toUpperCase()]);
          },
          s = function s() {
            var n = this;
            return {
              months: function months(e) {
                return e ? e.format("MMMM") : u(n, "months");
              },
              monthsShort: function monthsShort(e) {
                return e ? e.format("MMM") : u(n, "monthsShort", "months", 3);
              },
              firstDayOfWeek: function firstDayOfWeek() {
                return n.$locale().weekStart || 0;
              },
              weekdays: function weekdays(e) {
                return e ? e.format("dddd") : u(n, "weekdays");
              },
              weekdaysMin: function weekdaysMin(e) {
                return e ? e.format("dd") : u(n, "weekdaysMin", "weekdays", 2);
              },
              weekdaysShort: function weekdaysShort(e) {
                return e ? e.format("ddd") : u(n, "weekdaysShort", "weekdays", 3);
              },
              longDateFormat: function longDateFormat(e) {
                return a(n.$locale(), e);
              },
              meridiem: this.$locale().meridiem,
              ordinal: this.$locale().ordinal
            };
          };
        r.localeData = function () {
          return s.bind(this)();
        }, t.localeData = function () {
          var n = i();
          return {
            firstDayOfWeek: function firstDayOfWeek() {
              return n.weekStart || 0;
            },
            weekdays: function weekdays() {
              return t.weekdays();
            },
            weekdaysShort: function weekdaysShort() {
              return t.weekdaysShort();
            },
            weekdaysMin: function weekdaysMin() {
              return t.weekdaysMin();
            },
            months: function months() {
              return t.months();
            },
            monthsShort: function monthsShort() {
              return t.monthsShort();
            },
            longDateFormat: function longDateFormat(e) {
              return a(n, e);
            },
            meridiem: n.meridiem,
            ordinal: n.ordinal
          };
        }, t.months = function () {
          return u(i(), "months");
        }, t.monthsShort = function () {
          return u(i(), "monthsShort", "months", 3);
        }, t.weekdays = function (n) {
          return u(i(), "weekdays", null, null, n);
        }, t.weekdaysShort = function (n) {
          return u(i(), "weekdaysShort", "weekdays", 3, n);
        }, t.weekdaysMin = function (n) {
          return u(i(), "weekdaysMin", "weekdays", 2, n);
        };
      };
    });
  });

  var quarterOfYear = createCommonjsModule(function (module, exports) {
    !function (t, n) {
      module.exports = n() ;
    }(commonjsGlobal, function () {

      var t = "month",
        n = "quarter";
      return function (e, i) {
        var r = i.prototype;
        r.quarter = function (t) {
          return this.$utils().u(t) ? Math.ceil((this.month() + 1) / 3) : this.month(this.month() % 3 + 3 * (t - 1));
        };
        var s = r.add;
        r.add = function (e, i) {
          return e = Number(e), this.$utils().p(i) === n ? this.add(3 * e, t) : s.bind(this)(e, i);
        };
        var u = r.startOf;
        r.startOf = function (e, i) {
          var r = this.$utils(),
            s = !!r.u(i) || i;
          if (r.p(e) === n) {
            var o = this.quarter() - 1;
            return s ? this.month(3 * o).startOf(t).startOf("day") : this.month(3 * o + 2).endOf(t).endOf("day");
          }
          return u.bind(this)(e, i);
        };
      };
    });
  });

  var advancedFormat = createCommonjsModule(function (module, exports) {
    !function (e, t) {
      module.exports = t() ;
    }(commonjsGlobal, function () {

      return function (e, t) {
        var r = t.prototype,
          n = r.format;
        r.format = function (e) {
          var t = this,
            r = this.$locale();
          if (!this.isValid()) return n.bind(this)(e);
          var s = this.$utils(),
            a = (e || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function (e) {
              switch (e) {
                case "Q":
                  return Math.ceil((t.$M + 1) / 3);
                case "Do":
                  return r.ordinal(t.$D);
                case "gggg":
                  return t.weekYear();
                case "GGGG":
                  return t.isoWeekYear();
                case "wo":
                  return r.ordinal(t.week(), "W");
                case "w":
                case "ww":
                  return s.s(t.week(), "w" === e ? 1 : 2, "0");
                case "W":
                case "WW":
                  return s.s(t.isoWeek(), "W" === e ? 1 : 2, "0");
                case "k":
                case "kk":
                  return s.s(String(0 === t.$H ? 24 : t.$H), "k" === e ? 1 : 2, "0");
                case "X":
                  return Math.floor(t.$d.getTime() / 1e3);
                case "x":
                  return t.$d.getTime();
                case "z":
                  return "[" + t.offsetName() + "]";
                case "zzz":
                  return "[" + t.offsetName("long") + "]";
                default:
                  return e;
              }
            });
          return n.bind(this)(a);
        };
      };
    });
  });

  var customParseFormat = createCommonjsModule(function (module, exports) {
    !function (e, t) {
      module.exports = t() ;
    }(commonjsGlobal, function () {

      var e = {
          LTS: "h:mm:ss A",
          LT: "h:mm A",
          L: "MM/DD/YYYY",
          LL: "MMMM D, YYYY",
          LLL: "MMMM D, YYYY h:mm A",
          LLLL: "dddd, MMMM D, YYYY h:mm A"
        },
        t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g,
        n = /\d\d/,
        r = /\d\d?/,
        i = /\d*[^-_:/,()\s\d]+/,
        o = {},
        s = function s(e) {
          return (e = +e) + (e > 68 ? 1900 : 2e3);
        };
      var a = function a(e) {
          return function (t) {
            this[e] = +t;
          };
        },
        f = [/[+-]\d\d:?(\d\d)?|Z/, function (e) {
          (this.zone || (this.zone = {})).offset = function (e) {
            if (!e) return 0;
            if ("Z" === e) return 0;
            var t = e.match(/([+-]|\d\d)/g),
              n = 60 * t[1] + (+t[2] || 0);
            return 0 === n ? 0 : "+" === t[0] ? -n : n;
          }(e);
        }],
        h = function h(e) {
          var t = o[e];
          return t && (t.indexOf ? t : t.s.concat(t.f));
        },
        u = function u(e, t) {
          var n,
            r = o.meridiem;
          if (r) {
            for (var i = 1; i <= 24; i += 1) if (e.indexOf(r(i, 0, t)) > -1) {
              n = i > 12;
              break;
            }
          } else n = e === (t ? "pm" : "PM");
          return n;
        },
        d = {
          A: [i, function (e) {
            this.afternoon = u(e, !1);
          }],
          a: [i, function (e) {
            this.afternoon = u(e, !0);
          }],
          S: [/\d/, function (e) {
            this.milliseconds = 100 * +e;
          }],
          SS: [n, function (e) {
            this.milliseconds = 10 * +e;
          }],
          SSS: [/\d{3}/, function (e) {
            this.milliseconds = +e;
          }],
          s: [r, a("seconds")],
          ss: [r, a("seconds")],
          m: [r, a("minutes")],
          mm: [r, a("minutes")],
          H: [r, a("hours")],
          h: [r, a("hours")],
          HH: [r, a("hours")],
          hh: [r, a("hours")],
          D: [r, a("day")],
          DD: [n, a("day")],
          Do: [i, function (e) {
            var t = o.ordinal,
              n = e.match(/\d+/);
            if (this.day = n[0], t) for (var r = 1; r <= 31; r += 1) t(r).replace(/\[|\]/g, "") === e && (this.day = r);
          }],
          M: [r, a("month")],
          MM: [n, a("month")],
          MMM: [i, function (e) {
            var t = h("months"),
              n = (h("monthsShort") || t.map(function (e) {
                return e.slice(0, 3);
              })).indexOf(e) + 1;
            if (n < 1) throw new Error();
            this.month = n % 12 || n;
          }],
          MMMM: [i, function (e) {
            var t = h("months").indexOf(e) + 1;
            if (t < 1) throw new Error();
            this.month = t % 12 || t;
          }],
          Y: [/[+-]?\d+/, a("year")],
          YY: [n, function (e) {
            this.year = s(e);
          }],
          YYYY: [/\d{4}/, a("year")],
          Z: f,
          ZZ: f
        };
      function c(n) {
        var r, i;
        r = n, i = o && o.formats;
        for (var s = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function (t, n, r) {
            var o = r && r.toUpperCase();
            return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function (e, t, n) {
              return t || n.slice(1);
            });
          })).match(t), a = s.length, f = 0; f < a; f += 1) {
          var h = s[f],
            u = d[h],
            c = u && u[0],
            l = u && u[1];
          s[f] = l ? {
            regex: c,
            parser: l
          } : h.replace(/^\[|\]$/g, "");
        }
        return function (e) {
          for (var t = {}, n = 0, r = 0; n < a; n += 1) {
            var i = s[n];
            if ("string" == typeof i) r += i.length;else {
              var o = i.regex,
                f = i.parser,
                h = e.slice(r),
                u = o.exec(h)[0];
              f.call(t, u), e = e.replace(u, "");
            }
          }
          return function (e) {
            var t = e.afternoon;
            if (void 0 !== t) {
              var n = e.hours;
              t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
            }
          }(t), t;
        };
      }
      return function (e, t, n) {
        n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (s = e.parseTwoDigitYear);
        var r = t.prototype,
          i = r.parse;
        r.parse = function (e) {
          var t = e.date,
            r = e.utc,
            s = e.args;
          this.$u = r;
          var a = s[1];
          if ("string" == typeof a) {
            var f = !0 === s[2],
              h = !0 === s[3],
              u = f || h,
              d = s[2];
            h && (d = s[2]), o = this.$locale(), !f && d && (o = n.Ls[d]), this.$d = function (e, t, n) {
              try {
                if (["x", "X"].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                var r = c(t)(e),
                  i = r.year,
                  o = r.month,
                  s = r.day,
                  a = r.hours,
                  f = r.minutes,
                  h = r.seconds,
                  u = r.milliseconds,
                  d = r.zone,
                  l = new Date(),
                  m = s || (i || o ? 1 : l.getDate()),
                  M = i || l.getFullYear(),
                  Y = 0;
                i && !o || (Y = o > 0 ? o - 1 : l.getMonth());
                var p = a || 0,
                  v = f || 0,
                  D = h || 0,
                  g = u || 0;
                return d ? new Date(Date.UTC(M, Y, m, p, v, D, g + 60 * d.offset * 1e3)) : n ? new Date(Date.UTC(M, Y, m, p, v, D, g)) : new Date(M, Y, m, p, v, D, g);
              } catch (e) {
                return new Date("");
              }
            }(t, a, r), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), o = {};
          } else if (a instanceof Array) for (var l = a.length, m = 1; m <= l; m += 1) {
            s[1] = a[m - 1];
            var M = n.apply(this, s);
            if (M.isValid()) {
              this.$d = M.$d, this.$L = M.$L, this.init();
              break;
            }
            m === l && (this.$d = new Date(""));
          } else i.call(this, e);
        };
      };
    });
  });

  function ownKeys$1D(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1C(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1D(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1D(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  dayjs_min.extend(weekOfYear);
  dayjs_min.extend(weekYear);
  dayjs_min.extend(localeData);
  dayjs_min.extend(quarterOfYear);
  dayjs_min.extend(advancedFormat);
  dayjs_min.extend(customParseFormat);
  dayjs_min.extend(isBetween);
  function firstUpperCase(str) {
    if (!str) return str;
    return str[0].toUpperCase().concat(str.substring(1, str.length));
  }
  function getFirstDayOfMonth(_ref) {
    var year = _ref.year,
      month = _ref.month;
    return new Date(year, month, 1);
  }
  function getDaysInMonth(_ref2) {
    var year = _ref2.year,
      month = _ref2.month;
    return new Date(year, month + 1, 0).getDate();
  }
  function getLastDayOfMonth(_ref3) {
    var year = _ref3.year,
      month = _ref3.month;
    return new Date(year, month, getDaysInMonth({
      year: year,
      month: month
    }));
  }
  function isSameYear(date1, date2) {
    return date1.getFullYear() === date2.getFullYear();
  }
  function isSameQuarter(date1, date2) {
    return isSameYear(date1, date2) && dayjs_min(date1).quarter() === dayjs_min(date2).quarter();
  }
  function isSameMonth(date1, date2) {
    return isSameYear(date1, date2) && date1.getMonth() === date2.getMonth();
  }
  function isSameWeek(date1, date2) {
    var dayjsLocale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "zh-cn";
    return isSameMonth(date1, date2) && dayjs_min(date1).locale(dayjsLocale).week() === dayjs_min(date2).locale(dayjsLocale).week();
  }
  function isSameDate(date1, date2) {
    return isSameMonth(date1, date2) && date1.getDate() === date2.getDate();
  }
  function compareAsc(date1, date2) {
    var d1 = date1.getTime();
    var d2 = date2.getTime();
    if (d1 < d2) return -1;
    if (d1 > d2) return 1;
    return 0;
  }
  function isSame(date1, date2) {
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "date";
    var dayjsLocale = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "zh-cn";
    var func = {
      isSameYear: isSameYear,
      isSameQuarter: isSameQuarter,
      isSameMonth: isSameMonth,
      isSameWeek: isSameWeek,
      isSameDate: isSameDate
    };
    return func["isSame".concat(firstUpperCase(type))](date1, date2, dayjsLocale);
  }
  function outOfRanges(d, min, max) {
    return min && compareAsc(d, min) === -1 || max && compareAsc(d, max) === 1;
  }
  function getToday() {
    var now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
  }
  function subtractMonth(date, num) {
    return dayjs_min(date).subtract(num, "month").toDate();
  }
  function addMonth(date, num) {
    return dayjs_min(date).add(num, "month").toDate();
  }
  function getWeeks(_ref4, _ref5) {
    var year = _ref4.year,
      month = _ref4.month;
    var firstDayOfWeek = _ref5.firstDayOfWeek,
      _ref5$showWeekOfYear = _ref5.showWeekOfYear,
      showWeekOfYear = _ref5$showWeekOfYear === void 0 ? false : _ref5$showWeekOfYear,
      _ref5$disableDate = _ref5.disableDate,
      disableDate = _ref5$disableDate === void 0 ? function () {
        return false;
      } : _ref5$disableDate,
      minDate = _ref5.minDate,
      maxDate = _ref5.maxDate,
      _ref5$dayjsLocale = _ref5.dayjsLocale,
      dayjsLocale = _ref5$dayjsLocale === void 0 ? "zh-cn" : _ref5$dayjsLocale,
      _ref5$cancelRangeSele = _ref5.cancelRangeSelectLimit,
      cancelRangeSelectLimit = _ref5$cancelRangeSele === void 0 ? false : _ref5$cancelRangeSele;
    var prependDay = getFirstDayOfMonth({
      year: year,
      month: month
    });
    var appendDay = getLastDayOfMonth({
      year: year,
      month: month
    });
    var maxDays = getDaysInMonth({
      year: year,
      month: month
    });
    var daysArr = [];
    var i = 1;
    var today = getToday();
    for (i; i <= maxDays; i++) {
      var currentDay = new Date(year, month, i);
      daysArr.push({
        text: i,
        active: false,
        value: currentDay,
        disabled: isFunction(disableDate) && disableDate(currentDay) || !cancelRangeSelectLimit && outOfRanges(currentDay, minDate, maxDate),
        now: isSame(today, currentDay),
        firstDayOfMonth: i === 1,
        lastDayOfMonth: i === maxDays,
        type: "current-month",
        dayjsObj: dayjs_min(currentDay).locale(dayjsLocale)
      });
    }
    if (prependDay.getDay() !== firstDayOfWeek) {
      prependDay.setDate(0);
      while (true) {
        daysArr.unshift({
          text: prependDay.getDate().toString(),
          active: false,
          value: new Date(prependDay),
          disabled: isFunction(disableDate) && disableDate(prependDay) || !cancelRangeSelectLimit && outOfRanges(prependDay, minDate, maxDate),
          additional: true,
          type: "prev-month",
          dayjsObj: dayjs_min(prependDay).locale(dayjsLocale)
        });
        prependDay.setDate(prependDay.getDate() - 1);
        if (prependDay.getDay() === Math.abs(firstDayOfWeek + 6) % 7) break;
      }
    }
    var LEN = 42;
    while (daysArr.length < LEN) {
      appendDay.setDate(appendDay.getDate() + 1);
      daysArr.push({
        text: appendDay.getDate(),
        active: false,
        value: new Date(appendDay),
        disabled: isFunction(disableDate) && disableDate(appendDay) || !cancelRangeSelectLimit && outOfRanges(appendDay, minDate, maxDate),
        additional: true,
        type: "next-month",
        dayjsObj: dayjs_min(appendDay).locale(dayjsLocale)
      });
    }
    var dataList = chunk(daysArr, 7);
    if (showWeekOfYear) {
      dataList.forEach(function (d) {
        d.unshift(_objectSpread$1C(_objectSpread$1C({}, d[0]), {}, {
          active: false,
          value: d[0].value,
          text: dayjs_min(d[0].value).locale(dayjsLocale).week(),
          dayjsObj: dayjs_min(d[0].value).locale(dayjsLocale)
        }));
      });
    }
    return dataList;
  }
  function getQuarters(year, _ref6) {
    var _ref6$disableDate = _ref6.disableDate,
      disableDate = _ref6$disableDate === void 0 ? function () {
        return false;
      } : _ref6$disableDate,
      minDate = _ref6.minDate,
      maxDate = _ref6.maxDate,
      quarterLocal = _ref6.quarterLocal,
      _ref6$dayjsLocale = _ref6.dayjsLocale,
      dayjsLocale = _ref6$dayjsLocale === void 0 ? "zh-cn" : _ref6$dayjsLocale,
      _ref6$cancelRangeSele = _ref6.cancelRangeSelectLimit,
      cancelRangeSelectLimit = _ref6$cancelRangeSele === void 0 ? false : _ref6$cancelRangeSele;
    var quarterArr = [];
    var today = getToday();
    for (var i = 1; i <= 4; i++) {
      var date = dayjs_min(new Date(year, 0)).quarter(i).toDate();
      quarterArr.push({
        value: date,
        now: isSame(date, today, "quarter"),
        disabled: isFunction(disableDate) && disableDate(date) || !cancelRangeSelectLimit && outOfRanges(date, minDate, maxDate),
        active: false,
        text: quarterLocal[i - 1],
        dayjsObj: dayjs_min(date).locale(dayjsLocale)
      });
    }
    return chunk(quarterArr, 4);
  }
  function getYears(year, _ref7) {
    var _ref7$disableDate = _ref7.disableDate,
      disableDate = _ref7$disableDate === void 0 ? function () {
        return false;
      } : _ref7$disableDate,
      minDate = _ref7.minDate,
      maxDate = _ref7.maxDate,
      _ref7$dayjsLocale = _ref7.dayjsLocale,
      dayjsLocale = _ref7$dayjsLocale === void 0 ? "zh-cn" : _ref7$dayjsLocale,
      _ref7$cancelRangeSele = _ref7.cancelRangeSelectLimit,
      cancelRangeSelectLimit = _ref7$cancelRangeSele === void 0 ? false : _ref7$cancelRangeSele;
    var startYear = parseInt((year / 10).toString(), 10) * 10;
    var endYear = startYear + 9;
    var yearArr = [];
    var today = getToday();
    for (var i = startYear; i <= endYear; i++) {
      var date = new Date(i, 1);
      yearArr.push({
        value: date,
        now: isSame(date, today, "year"),
        disabled: isFunction(disableDate) && disableDate(date) || !cancelRangeSelectLimit && outOfRanges(date, minDate, maxDate),
        active: false,
        text: "".concat(date.getFullYear()),
        dayjsObj: dayjs_min(date).locale(dayjsLocale)
      });
    }
    return chunk(yearArr, 3);
  }
  function getMonths(year, params) {
    var _params$disableDate = params.disableDate,
      disableDate = _params$disableDate === void 0 ? function () {
        return false;
      } : _params$disableDate,
      minDate = params.minDate,
      maxDate = params.maxDate,
      monthLocal = params.monthLocal,
      _params$dayjsLocale = params.dayjsLocale,
      dayjsLocale = _params$dayjsLocale === void 0 ? "zh-cn" : _params$dayjsLocale,
      _params$cancelRangeSe = params.cancelRangeSelectLimit,
      cancelRangeSelectLimit = _params$cancelRangeSe === void 0 ? false : _params$cancelRangeSe;
    var MonthArr = [];
    var today = getToday();
    for (var i = 0; i <= 11; i++) {
      var date = new Date(year, i);
      MonthArr.push({
        value: date,
        now: isSame(date, today, "month"),
        disabled: isFunction(disableDate) && disableDate(date) || !cancelRangeSelectLimit && outOfRanges(date, minDate, maxDate),
        active: false,
        text: monthLocal[date.getMonth()],
        dayjsObj: dayjs_min(date).locale(dayjsLocale)
      });
    }
    return chunk(MonthArr, 3);
  }
  function flagActive(data, _ref8) {
    var args = _extends$1({}, (_objectDestructuringEmpty(_ref8), _ref8));
    var start = args.start,
      end = args.end,
      hoverStart = args.hoverStart,
      hoverEnd = args.hoverEnd,
      _args$type = args.type,
      type = _args$type === void 0 ? "date" : _args$type,
      _args$isRange = args.isRange,
      isRange = _args$isRange === void 0 ? false : _args$isRange,
      value = args.value,
      _args$multiple = args.multiple,
      multiple = _args$multiple === void 0 ? false : _args$multiple;
    if (type === "week") return data;
    if (!isRange) {
      return data.map(function (row) {
        return row.map(function (item) {
          var _item = item;
          if (multiple) {
            var _value$some;
            _item.active = value === null || value === void 0 || (_value$some = value.some) === null || _value$some === void 0 ? void 0 : _value$some.call(value, function (val) {
              return isSame(dayjs_min(val).toDate(), _item.value, type) && !_item.additional;
            });
          } else {
            _item.active = start && isSame(item.value, start, type) && !_item.additional;
          }
          return _item;
        });
      });
    }
    return data.map(function (row) {
      return row.map(function (item) {
        var _item = item;
        var date = item.value;
        var isStart = start && isSame(start, date, type);
        var isHoverStart = hoverStart && isSame(hoverStart, date, type);
        var isEnd = end && isSame(end, date, type);
        var isHoverEnd = hoverEnd && isSame(hoverEnd, date, type);
        _item.active = (isStart || isEnd) && !_item.additional;
        if (start && end) {
          _item.highlight = dayjs_min(date).isBetween(start, end, type, "[]") && !_item.additional;
          _item.startOfRange = isStart;
          _item.endOfRange = isEnd;
        }
        if (hoverStart && hoverEnd) {
          _item.hoverHighlight = dayjs_min(date).isBetween(hoverStart, hoverEnd, type, "[]") && !_item.additional;
          _item.hoverStartOfRange = isHoverStart;
          _item.hoverEndOfRange = isHoverEnd;
        }
        return _item;
      });
    });
  }
  function extractTimeObj() {
    var timeFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var matchedMeridiem = timeFormat.match(/[ap]m/i) || [""];
    var timeReg = /\d{1,2}(:\d{1,2})?(:\d{1,2})?(:\d{1,3})?/;
    var matchedTimeStr = timeFormat.match(timeReg) || ["0:0:0:0"];
    var _matchedTimeStr$0$spl = matchedTimeStr[0].split(":"),
      _matchedTimeStr$0$spl2 = _slicedToArray(_matchedTimeStr$0$spl, 4),
      _matchedTimeStr$0$spl3 = _matchedTimeStr$0$spl2[0],
      hours = _matchedTimeStr$0$spl3 === void 0 ? 0 : _matchedTimeStr$0$spl3,
      _matchedTimeStr$0$spl4 = _matchedTimeStr$0$spl2[1],
      minutes = _matchedTimeStr$0$spl4 === void 0 ? 0 : _matchedTimeStr$0$spl4,
      _matchedTimeStr$0$spl5 = _matchedTimeStr$0$spl2[2],
      seconds = _matchedTimeStr$0$spl5 === void 0 ? 0 : _matchedTimeStr$0$spl5,
      _matchedTimeStr$0$spl6 = _matchedTimeStr$0$spl2[3],
      milliseconds = _matchedTimeStr$0$spl6 === void 0 ? 0 : _matchedTimeStr$0$spl6;
    return {
      hours: +hours,
      minutes: +minutes,
      seconds: +seconds,
      milliseconds: +milliseconds,
      meridiem: matchedMeridiem[0]
    };
  }
  function covertToDate(value, valueType) {
    return valueType === "time-stamp" ? new Date(value) : dayjs_min(value, valueType).toDate();
  }

  var datePickerProps = {
    allowInput: Boolean,
    borderless: Boolean,
    clearable: Boolean,
    defaultTime: {
      type: String,
      "default": "00:00:00"
    },
    disableDate: {
      type: [Object, Array, Function]
    },
    disableTime: {
      type: Function
    },
    disabled: Boolean,
    readonly: {
      type: Boolean,
      "default": void 0
    },
    enableTimePicker: Boolean,
    firstDayOfWeek: {
      type: Number,
      validator: function validator(val) {
        if (!val) return true;
        return [1, 2, 3, 4, 5, 6, 7].includes(val);
      }
    },
    format: {
      type: String,
      "default": void 0
    },
    inputProps: {
      type: Object
    },
    label: {
      type: [String, Function]
    },
    mode: {
      type: String,
      "default": "date",
      validator: function validator(val) {
        if (!val) return true;
        return ["year", "quarter", "month", "week", "date"].includes(val);
      }
    },
    multiple: Boolean,
    placeholder: {
      type: [String, Array],
      "default": void 0
    },
    popupProps: {
      type: Object
    },
    prefixIcon: {
      type: Function
    },
    presets: {
      type: Object
    },
    presetsPlacement: {
      type: String,
      "default": "bottom",
      validator: function validator(val) {
        if (!val) return true;
        return ["left", "top", "right", "bottom"].includes(val);
      }
    },
    size: {
      type: String,
      "default": "medium",
      validator: function validator(val) {
        if (!val) return true;
        return ["small", "medium", "large"].includes(val);
      }
    },
    status: {
      type: String,
      "default": "default",
      validator: function validator(val) {
        if (!val) return true;
        return ["default", "success", "warning", "error"].includes(val);
      }
    },
    suffixIcon: {
      type: Function
    },
    timePickerProps: {
      type: Object
    },
    tips: {
      type: [String, Function]
    },
    value: {
      type: [String, Number, Array, Date],
      "default": ""
    },
    defaultValue: {
      type: [String, Number, Array, Date],
      "default": ""
    },
    valueType: {
      type: String,
      "default": ""
    },
    onBlur: Function,
    onChange: Function,
    onConfirm: Function,
    onFocus: Function,
    onPick: Function,
    onPresetClick: Function
  };

  function ownKeys$1C(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1B(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1C(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1C(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var TDateHeader = VueCompositionAPI.defineComponent({
    name: "TDatePickerHeader",
    props: {
      mode: {
        type: String,
        "default": "date"
      },
      year: Number,
      month: Number,
      onMonthChange: Function,
      onYearChange: Function,
      onJumperClick: Function
    },
    setup: function setup(props) {
      var _useConfig = useConfig("classPrefix"),
        classPrefix = _useConfig.classPrefix;
      var COMPONENT_NAME = usePrefixClass("date-picker__header");
      var _useConfig2 = useConfig("datePicker"),
        global = _useConfig2.global;
      var yearOptions = VueCompositionAPI.ref(initOptions(props.year));
      var showMonthPicker = props.mode === "date" || props.mode === "week";
      var nearestYear = VueCompositionAPI.computed(function () {
        var _yearOptions$value$fi;
        return ((_yearOptions$value$fi = yearOptions.value.find(function (option) {
          return option.value - props.year <= 9 && option.value - props.year >= 0;
        })) === null || _yearOptions$value$fi === void 0 ? void 0 : _yearOptions$value$fi.value) || props.year;
      });
      var monthOptions = VueCompositionAPI.computed(function () {
        return global.value.months.map(function (item, index) {
          return {
            label: item,
            value: index
          };
        });
      });
      function initOptions(year) {
        var options = [];
        if (props.mode === "year") {
          var extraYear = year % 10;
          var minYear = year - extraYear - 100;
          var maxYear = year - extraYear + 100;
          for (var i = minYear; i <= maxYear; i += 10) {
            options.push({
              label: "".concat(i, " - ").concat(i + 9),
              value: i + 9
            });
          }
        } else {
          options.push({
            label: "".concat(year),
            value: year
          });
          for (var _i = 1; _i <= 10; _i++) {
            options.push({
              label: "".concat(year + _i),
              value: year + _i
            });
            options.unshift({
              label: "".concat(year - _i),
              value: year - _i
            });
          }
        }
        return options;
      }
      function loadMoreYear(year, type) {
        var options = [];
        if (props.mode === "year") {
          var extraYear = year % 10;
          if (type === "add") {
            for (var i = year - extraYear + 10; i <= year - extraYear + 50; i += 10) {
              options.push({
                label: "".concat(i, " - ").concat(i + 9),
                value: i
              });
            }
          } else {
            for (var _i2 = year - extraYear - 1; _i2 > year - extraYear - 50; _i2 -= 10) {
              options.unshift({
                label: "".concat(_i2 - 9, " - ").concat(_i2),
                value: _i2
              });
            }
          }
        } else if (type === "add") {
          for (var _i3 = year + 1; _i3 <= year + 10; _i3++) {
            options.push({
              label: "".concat(_i3),
              value: _i3
            });
          }
        } else {
          for (var _i4 = year - 1; _i4 > year - 10; _i4--) {
            options.unshift({
              label: "".concat(_i4),
              value: _i4
            });
          }
        }
        return options;
      }
      var labelMap = {
        year: {
          prev: global.value.preDecade,
          current: global.value.now,
          next: global.value.nextDecade
        },
        month: {
          prev: global.value.preYear,
          current: global.value.now,
          next: global.value.nextYear
        },
        date: {
          prev: global.value.preMonth,
          current: global.value.now,
          next: global.value.nextMonth
        }
      };
      function handlePanelTopClick(e) {
        var _e$stopPropagation;
        e === null || e === void 0 || (_e$stopPropagation = e.stopPropagation) === null || _e$stopPropagation === void 0 || _e$stopPropagation.call(e);
        var firstYear = yearOptions.value[0].value;
        var options = loadMoreYear(firstYear, "reduce");
        yearOptions.value = [].concat(_toConsumableArray(options), _toConsumableArray(yearOptions.value));
      }
      function handlePanelBottomClick(e) {
        var _e$stopPropagation2;
        e === null || e === void 0 || (_e$stopPropagation2 = e.stopPropagation) === null || _e$stopPropagation2 === void 0 || _e$stopPropagation2.call(e);
        var lastYear = yearOptions.value.slice(-1)[0].value;
        var options = loadMoreYear(lastYear, "add");
        yearOptions.value = [].concat(_toConsumableArray(yearOptions.value), _toConsumableArray(options));
      }
      function handleScroll(_ref) {
        var e = _ref.e;
        if (e.target.scrollTop === 0) {
          handlePanelTopClick(e);
        } else if (e.target.scrollTop === e.target.scrollHeight - e.target.clientHeight) {
          handlePanelBottomClick(e);
        }
      }
      return {
        COMPONENT_NAME: COMPONENT_NAME,
        labelMap: labelMap,
        nearestYear: nearestYear,
        classPrefix: classPrefix,
        monthOptions: monthOptions,
        yearOptions: yearOptions,
        showMonthPicker: showMonthPicker,
        handleScroll: handleScroll,
        handlePanelTopClick: handlePanelTopClick,
        handlePanelBottomClick: handlePanelBottomClick
      };
    },
    render: function render() {
      var _this = this;
      var h = arguments[0];
      var COMPONENT_NAME = this.COMPONENT_NAME,
        labelMap = this.labelMap,
        nearestYear = this.nearestYear,
        classPrefix = this.classPrefix,
        monthOptions = this.monthOptions,
        yearOptions = this.yearOptions,
        showMonthPicker = this.showMonthPicker,
        handlePanelTopClick = this.handlePanelTopClick,
        handlePanelBottomClick = this.handlePanelBottomClick;
      return h("div", {
        "class": COMPONENT_NAME
      }, [h("div", {
        "class": "".concat(COMPONENT_NAME, "-controller")
      }, [showMonthPicker && h(Select, {
        "class": "".concat(COMPONENT_NAME, "-controller-month"),
        "props": _objectSpread$1B({}, {
          value: this.month,
          options: monthOptions,
          onChange: function onChange(val) {
            var _this$onMonthChange;
            return (_this$onMonthChange = _this.onMonthChange) === null || _this$onMonthChange === void 0 ? void 0 : _this$onMonthChange.call(_this, val);
          },
          popupProps: {
            attach: function attach(triggerElement) {
              return triggerElement.parentNode;
            },
            overlayClassName: "".concat(COMPONENT_NAME, "-controller-month-popup")
          }
        })
      }), h(Select, {
        "class": "".concat(COMPONENT_NAME, "-controller-year"),
        "props": _objectSpread$1B({}, {
          value: this.mode === "year" ? nearestYear : this.year,
          options: yearOptions,
          onChange: function onChange(val) {
            var _this$onYearChange;
            return (_this$onYearChange = _this.onYearChange) === null || _this$onYearChange === void 0 ? void 0 : _this$onYearChange.call(_this, val);
          },
          popupProps: {
            onScroll: this.handleScroll,
            attach: function attach(triggerElement) {
              return triggerElement.parentNode;
            },
            overlayClassName: "".concat(COMPONENT_NAME, "-controller-year-popup")
          },
          panelTopContent: function panelTopContent() {
            return h("div", {
              "class": "".concat(classPrefix, "-select-option"),
              "on": {
                "click": handlePanelTopClick
              }
            }, ["..."]);
          },
          panelBottomContent: function panelBottomContent() {
            return h("div", {
              "class": "".concat(classPrefix, "-select-option"),
              "on": {
                "click": handlePanelBottomClick
              }
            }, ["..."]);
          }
        })
      })]), h(PaginationMini, {
        "props": _objectSpread$1B({}, {
          tips: labelMap[this.mode],
          onChange: this.onJumperClick,
          size: "small"
        })
      })]);
    }
  });

  var TDatePickerCell = VueCompositionAPI.defineComponent({
    name: "TDatePickerCell",
    props: {
      time: String,
      text: [String, Number],
      value: Date,
      active: Boolean,
      highlight: Boolean,
      disabled: Boolean,
      startOfRange: Boolean,
      endOfRange: Boolean,
      hoverHighlight: Boolean,
      hoverStartOfRange: Boolean,
      hoverEndOfRange: Boolean,
      additional: Boolean,
      now: Boolean,
      firstDayOfMonth: Boolean,
      lastDayOfMonth: Boolean,
      onClick: Function,
      onMouseEnter: Function
    },
    setup: function setup(props) {
      var COMPONENT_NAME = usePrefixClass("date-picker__cell");
      var cellClass = VueCompositionAPI.computed(function () {
        var _ref;
        return [COMPONENT_NAME.value, (_ref = {}, _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_ref, "".concat(COMPONENT_NAME.value, "--now"), props.now), "".concat(COMPONENT_NAME.value, "--active"), props.active), "".concat(COMPONENT_NAME.value, "--disabled"), props.disabled), "".concat(COMPONENT_NAME.value, "--highlight"), props.highlight), "".concat(COMPONENT_NAME.value, "--hover-highlight"), props.hoverHighlight), "".concat(COMPONENT_NAME.value, "--active-start"), props.startOfRange), "".concat(COMPONENT_NAME.value, "--active-end"), props.endOfRange), "".concat(COMPONENT_NAME.value, "--hover-start"), props.hoverStartOfRange), "".concat(COMPONENT_NAME.value, "--hover-end"), props.hoverEndOfRange), "".concat(COMPONENT_NAME.value, "--additional"), props.additional), _defineProperty$2(_defineProperty$2(_ref, "".concat(COMPONENT_NAME.value, "--first-day-of-month"), props.firstDayOfMonth), "".concat(COMPONENT_NAME.value, "--last-day-of-month"), props.lastDayOfMonth))];
      });
      function handleClick(e) {
        var _props$onClick;
        if (props.disabled) return;
        if (props.time) {
          var _extractTimeObj = extractTimeObj(props.time),
            hours = _extractTimeObj.hours,
            minutes = _extractTimeObj.minutes,
            seconds = _extractTimeObj.seconds,
            milliseconds = _extractTimeObj.milliseconds,
            meridiem = _extractTimeObj.meridiem;
          var nextHours = hours;
          if (/am/i.test(meridiem) && nextHours === 12) nextHours -= 12;
          if (/pm/i.test(meridiem) && nextHours < 12) nextHours += 12;
          props.value.setHours(nextHours);
          props.value.setMinutes(minutes);
          props.value.setSeconds(seconds);
          props.value.setMilliseconds(milliseconds);
        }
        (_props$onClick = props.onClick) === null || _props$onClick === void 0 || _props$onClick.call(props, props.value, {
          e: e
        });
      }
      function handleMouseEnter() {
        var _props$onMouseEnter;
        if (props.disabled) return;
        if (props.time) {
          var _extractTimeObj2 = extractTimeObj(props.time),
            hours = _extractTimeObj2.hours,
            minutes = _extractTimeObj2.minutes,
            seconds = _extractTimeObj2.seconds,
            milliseconds = _extractTimeObj2.milliseconds,
            meridiem = _extractTimeObj2.meridiem;
          var nextHours = hours;
          if (/am/i.test(meridiem) && nextHours === 12) nextHours -= 12;
          if (/pm/i.test(meridiem) && nextHours < 12) nextHours += 12;
          props.value.setHours(nextHours);
          props.value.setMinutes(minutes);
          props.value.setSeconds(seconds);
          props.value.setMilliseconds(milliseconds);
        }
        (_props$onMouseEnter = props.onMouseEnter) === null || _props$onMouseEnter === void 0 || _props$onMouseEnter.call(props, props.value);
      }
      return {
        cellClass: cellClass,
        COMPONENT_NAME: COMPONENT_NAME,
        handleClick: handleClick,
        handleMouseEnter: handleMouseEnter
      };
    },
    render: function render() {
      var h = arguments[0];
      var cellClass = this.cellClass,
        COMPONENT_NAME = this.COMPONENT_NAME,
        handleClick = this.handleClick,
        handleMouseEnter = this.handleMouseEnter;
      return h("td", {
        "class": cellClass,
        "on": {
          "click": handleClick,
          "mouseenter": handleMouseEnter
        }
      }, [h("div", {
        "class": "".concat(COMPONENT_NAME, "-inner")
      }, [this.text])]);
    }
  });

  function ownKeys$1B(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1A(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1B(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1B(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var TDateTable = VueCompositionAPI.defineComponent({
    name: "TDatePickerTable",
    props: {
      mode: {
        type: String,
        "default": "date"
      },
      firstDayOfWeek: Number,
      data: Array,
      time: String,
      value: [String, Number, Array, Date],
      format: String,
      onCellClick: Function,
      onCellMouseEnter: Function,
      onCellMouseLeave: Function
    },
    setup: function setup(props) {
      var COMPONENT_NAME = usePrefixClass("date-picker__table");
      var _useConfig = useConfig("datePicker"),
        global = _useConfig.global;
      var _global$value = global.value,
        weekdays = _global$value.weekdays,
        weekAbbreviation = _global$value.weekAbbreviation,
        dayjsLocale = _global$value.dayjsLocale;
      var weekArr = VueCompositionAPI.computed(function () {
        var _weekArr = [];
        var wi = props.firstDayOfWeek - 1;
        var len = weekdays.length;
        while (_weekArr.length < len) {
          _weekArr.push(weekdays[wi]);
          wi = (wi + len + 1) % len;
        }
        if (props.mode === "week") _weekArr.unshift(weekAbbreviation);
        return _weekArr;
      });
      var showThead = VueCompositionAPI.computed(function () {
        return props.mode === "date" || props.mode === "week";
      });
      var weekRowClass = function weekRowClass(value, format, targetValue) {
        if (props.mode !== "week" || !value) return {};
        if (Array.isArray(value)) {
          var _startObj$locale, _startObj$locale$week, _endObj$locale, _endObj$locale$week;
          if (!value.length) return {};
          var _value$map = value.map(function (v) {
              return v && parseToDayjs(v, format);
            }),
            _value$map2 = _slicedToArray(_value$map, 2),
            startObj = _value$map2[0],
            endObj = _value$map2[1];
          var startYear = startObj && startObj.year();
          var startWeek = startObj === null || startObj === void 0 || (_startObj$locale = startObj.locale) === null || _startObj$locale === void 0 || (_startObj$locale = _startObj$locale.call(startObj, dayjsLocale)) === null || _startObj$locale === void 0 || (_startObj$locale$week = _startObj$locale.week) === null || _startObj$locale$week === void 0 ? void 0 : _startObj$locale$week.call(_startObj$locale);
          var endYear = endObj && endObj.year();
          var endWeek = endObj === null || endObj === void 0 || (_endObj$locale = endObj.locale) === null || _endObj$locale === void 0 || (_endObj$locale = _endObj$locale.call(endObj, dayjsLocale)) === null || _endObj$locale === void 0 || (_endObj$locale$week = _endObj$locale.week) === null || _endObj$locale$week === void 0 ? void 0 : _endObj$locale$week.call(_endObj$locale);
          var targetObj = parseToDayjs(targetValue, format);
          var targetYear = targetObj.year();
          var targetWeek = targetObj.week();
          var isActive = targetYear === startYear && targetWeek === startWeek || targetYear === endYear && targetWeek === endWeek;
          var isRange = targetYear >= startYear && targetYear <= endYear && targetWeek > startWeek && targetWeek < endWeek;
          return _defineProperty$2(_defineProperty$2({}, "".concat(COMPONENT_NAME.value, "-").concat(props.mode, "-row--active"), isActive), "".concat(COMPONENT_NAME.value, "-").concat(props.mode, "-row--range"), isRange);
        }
        return _defineProperty$2({}, "".concat(COMPONENT_NAME.value, "-").concat(props.mode, "-row--active"), parseToDayjs(value, format).locale(dayjsLocale).week() === parseToDayjs(targetValue, format).locale(dayjsLocale).week());
      };
      return {
        COMPONENT_NAME: COMPONENT_NAME,
        weekArr: weekArr,
        showThead: showThead,
        weekRowClass: weekRowClass
      };
    },
    render: function render() {
      var _this = this;
      var h = arguments[0];
      var COMPONENT_NAME = this.COMPONENT_NAME,
        weekArr = this.weekArr,
        showThead = this.showThead,
        weekRowClass = this.weekRowClass;
      return h("div", {
        "class": COMPONENT_NAME,
        "on": {
          "mouseleave": function mouseleave(e) {
            var _this$onCellMouseLeav;
            return (_this$onCellMouseLeav = _this.onCellMouseLeave) === null || _this$onCellMouseLeav === void 0 ? void 0 : _this$onCellMouseLeav.call(_this, {
              e: e
            });
          }
        }
      }, [h("table", [showThead && h("thead", [h("tr", [weekArr.map(function (value, i) {
        return h("th", {
          "key": i
        }, [value]);
      })])]), h("tbody", [this.data.map(function (row, i) {
        return h("tr", {
          "key": i,
          "class": _objectSpread$1A(_defineProperty$2({}, "".concat(COMPONENT_NAME, "-").concat(_this.mode, "-row"), true), weekRowClass(_this.value, _this.format, row[0].value))
        }, [row.map(function (col, j) {
          return h(TDatePickerCell, {
            "key": j,
            "props": _objectSpread$1A({}, _objectSpread$1A({
              time: _this.time,
              onClick: _this.onCellClick,
              onMouseEnter: _this.onCellMouseEnter
            }, col))
          });
        })]);
      })])])]);
    }
  });

  var AM = "am";
  var PM = "pm";
  var MERIDIEM_LIST = [AM, PM];
  var TIME_PICKER_EMPTY = [void 0, void 0];
  var DEFAULT_STEPS = [1, 1, 1];
  var DEFAULT_FORMAT = "HH:mm:ss";
  var EPickerCols$1 = /* @__PURE__ */function (EPickerCols2) {
    EPickerCols2["hour"] = "hour";
    EPickerCols2["minute"] = "minute";
    EPickerCols2["second"] = "second";
    EPickerCols2["milliSecond"] = "millisecond";
    EPickerCols2["meridiem"] = "meridiem";
    return EPickerCols2;
  }(EPickerCols$1 || {});
  var TIME_FORMAT = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g;
  var TWELVE_HOUR_FORMAT = /[h]{1}/;

  var props$E = {
    allowInput: Boolean,
    borderless: Boolean,
    clearable: Boolean,
    disableTime: {
      type: Function
    },
    disabled: {
      type: Boolean,
      "default": void 0
    },
    readonly: {
      type: Boolean,
      "default": void 0
    },
    format: {
      type: String,
      "default": "HH:mm:ss"
    },
    hideDisabledTime: {
      type: Boolean,
      "default": true
    },
    inputProps: {
      type: Object
    },
    placeholder: {
      type: String,
      "default": void 0
    },
    popupProps: {
      type: Object
    },
    presets: {
      type: Object
    },
    size: {
      type: String,
      "default": "medium",
      validator: function validator(val) {
        if (!val) return true;
        return ["small", "medium", "large"].includes(val);
      }
    },
    status: {
      type: String,
      "default": "default",
      validator: function validator(val) {
        if (!val) return true;
        return ["default", "success", "warning", "error"].includes(val);
      }
    },
    steps: {
      type: Array,
      "default": function _default() {
        return [1, 1, 1];
      }
    },
    tips: {
      type: [String, Function]
    },
    value: {
      type: String,
      "default": void 0
    },
    defaultValue: {
      type: String,
      "default": ""
    },
    onBlur: Function,
    onChange: Function,
    onClose: Function,
    onFocus: Function,
    onInput: Function,
    onOpen: Function,
    onPick: Function
  };

  function ownKeys$1A(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1z(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1A(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1A(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var panelProps = function panelProps() {
    return {
      disabled: {
        type: Boolean,
        "default": false
      },
      isFocus: {
        type: Boolean,
        "default": false
      },
      value: {
        type: [String, Object],
        "default": ""
      },
      format: {
        type: String,
        "default": "HH:mm:ss"
      },
      position: String,
      steps: {
        type: Array,
        "default": function _default() {
          return [1, 1, 1];
        }
      },
      isShowPanel: {
        type: Boolean,
        "default": true
      },
      activeIndex: {
        type: Number
      },
      presets: {
        type: Object
      },
      hideDisabledTime: _objectSpread$1z({}, props$E.hideDisabledTime),
      isFooterDisplay: {
        type: Boolean,
        "default": false
      }
    };
  };
  var panelColProps = function panelColProps() {
    return {
      format: {
        type: String,
        "default": "HH:mm:ss"
      },
      value: {
        type: [String, Object],
        "default": ""
      },
      steps: {
        type: Array,
        "default": function _default() {
          return [1, 1, 1];
        }
      },
      hideDisabledTime: _objectSpread$1z({}, props$E.hideDisabledTime)
    };
  };

  dayjs_min.extend(advancedFormat);
  dayjs_min.extend(customParseFormat);
  function validateInputValue(value, format) {
    return dayjs_min(value, format).format(format) === value;
  }
  function formatInputValue(value, format) {
    return dayjs_min(value, format).format(format);
  }
  function closestLookup(availableArr, calcVal, step) {
    if (step <= 1) return calcVal;
    return availableArr.sort(function (a, b) {
      return Math.abs(calcVal + 1 - a) - Math.abs(calcVal + 1 - b);
    })[0];
  }
  function getPickerCols(format) {
    var renderCol = [];
    var meridiem = EPickerCols$1.meridiem,
      hour = EPickerCols$1.hour,
      minute = EPickerCols$1.minute,
      second = EPickerCols$1.second,
      milliSecond = EPickerCols$1.milliSecond;
    var match = format.match(TIME_FORMAT);
    match.forEach(function (m) {
      switch (m) {
        case "H":
        case "HH":
        case "h":
        case "hh":
          renderCol.push(hour);
          break;
        case "a":
        case "A":
          renderCol.push(meridiem);
          break;
        case "m":
        case "mm":
          renderCol.push(minute);
          break;
        case "s":
        case "ss":
          renderCol.push(second);
          break;
        case "SSS":
          renderCol.push(milliSecond);
          break;
      }
    });
    return renderCol;
  }

  function ownKeys$1z(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1y(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1z(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1z(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  dayjs_min.extend(customParseFormat);
  var timeArr = [EPickerCols$1.hour, EPickerCols$1.minute, EPickerCols$1.second, EPickerCols$1.milliSecond];
  var panelOffset = {
    top: 15,
    bottom: 21
  };
  var SinglePanel = VueCompositionAPI.defineComponent({
    name: "TTimePickerPanelCol",
    props: _objectSpread$1y(_objectSpread$1y({}, panelColProps()), {}, {
      position: String,
      triggerScroll: Boolean,
      onChange: Function,
      resetTriggerScroll: Function,
      disableTime: Function,
      isShowPanel: Boolean
    }),
    setup: function setup(props, ctx) {
      var _toRefs = VueCompositionAPI.toRefs(props),
        steps = _toRefs.steps,
        value = _toRefs.value,
        format = _toRefs.format,
        position = _toRefs.position,
        triggerScroll = _toRefs.triggerScroll;
      var _useConfig = useConfig("timePicker"),
        global = _useConfig.global;
      var _useConfig2 = useConfig(),
        classPrefix = _useConfig2.classPrefix;
      var cols = VueCompositionAPI.ref([]);
      var bodyRef = VueCompositionAPI.ref();
      var maskRef = VueCompositionAPI.ref(null);
      var dayjsValue = VueCompositionAPI.computed(function () {
        var isStepsSet = !!steps.value.filter(function (v) {
          return v > 1;
        }).length;
        if (value.value) return dayjs_min(value.value, format.value);
        if (isStepsSet) return dayjs_min().hour(0).minute(0).second(0);
        return dayjs_min();
      });
      var panelClassName = VueCompositionAPI.computed(function () {
        return "".concat(classPrefix.value, "-time-picker__panel");
      });
      VueCompositionAPI.watch(function () {
        return dayjsValue.value;
      }, function () {
        if (dayjsValue.value && value.value) updateTimeScrollPos(true);
      });
      VueCompositionAPI.watch(function () {
        return triggerScroll.value;
      }, function () {
        if (triggerScroll.value) {
          updateTimeScrollPos(true);
        }
      });
      VueCompositionAPI.onMounted(function () {
        cols.value = getPickerCols(format.value);
      });
      var getItemHeight = function getItemHeight() {
        var _maskRef$value;
        var maskDom = (_maskRef$value = maskRef.value) === null || _maskRef$value === void 0 ? void 0 : _maskRef$value.querySelector("div");
        if (!maskDom) {
          return {
            offsetHeight: 0,
            margin: 0
          };
        }
        return {
          offsetHeight: maskDom.offsetHeight,
          margin: parseInt(getComputedStyle(maskDom).marginTop, 10)
        };
      };
      var timeItemCanUsed = function timeItemCanUsed(col, el) {
        var colIdx = timeArr.indexOf(col);
        if (colIdx !== -1) {
          var _props$disableTime;
          var params = [dayjsValue.value.hour(), dayjsValue.value.minute(), dayjsValue.value.second()];
          var n = Number(el);
          if (col === EPickerCols$1.hour && TWELVE_HOUR_FORMAT.test(props.format) && dayjsValue.value.hour() >= 12) {
            n += 12;
          }
          params[colIdx] = n;
          return !((_props$disableTime = props.disableTime) !== null && _props$disableTime !== void 0 && (_props$disableTime = _props$disableTime.call.apply(_props$disableTime, [props].concat(params, [{
            partial: position.value || "start"
          }]))) !== null && _props$disableTime !== void 0 && (_props$disableTime = _props$disableTime[col]) !== null && _props$disableTime !== void 0 && _props$disableTime.includes(n));
        }
        return true;
      };
      var getColList = function getColList(col) {
        var count = 0;
        if (timeArr.includes(col)) {
          var colIdx = timeArr.indexOf(col);
          var colStep = steps.value[colIdx] || 1;
          if (col === EPickerCols$1.hour) count = TWELVE_HOUR_FORMAT.test(format.value) ? 11 : 23;else if (col === EPickerCols$1.milliSecond) count = 999;else count = 59;
          var colList = range$1(0, count + 1, Number(colStep)).map(function (v) {
            return padStart(String(v), 2, "0");
          }) || [];
          return props.hideDisabledTime && !!props.disableTime ? colList.filter(function (t) {
            var _props$disableTime2;
            var params = [dayjsValue.value.hour(), dayjsValue.value.minute(), dayjsValue.value.second(), dayjsValue.value.millisecond()];
            var n = Number(t);
            if (col === EPickerCols$1.hour && TWELVE_HOUR_FORMAT.test(props.format) && dayjsValue.value.hour() >= 12) {
              n += 12;
            }
            params[colIdx] = n;
            return !((_props$disableTime2 = props.disableTime) !== null && _props$disableTime2 !== void 0 && (_props$disableTime2 = _props$disableTime2.call.apply(_props$disableTime2, [props].concat(params, [{
              partial: position.value || "start"
            }]))) !== null && _props$disableTime2 !== void 0 && (_props$disableTime2 = _props$disableTime2[col]) !== null && _props$disableTime2 !== void 0 && _props$disableTime2.includes(n));
          }) : colList;
        }
        return MERIDIEM_LIST;
      };
      var getScrollDistance = function getScrollDistance(col, time) {
        if (col === EPickerCols$1.hour && /[h]{1}/.test(format.value)) {
          time %= 12;
        }
        var itemIdx = getColList(col).indexOf(padStart(String(time), 2, "0"));
        var _getItemHeight = getItemHeight(),
          offsetHeight = _getItemHeight.offsetHeight,
          margin = _getItemHeight.margin;
        var timeItemTotalHeight = offsetHeight + margin;
        var distance = Math.abs(Math.max(0, itemIdx) * timeItemTotalHeight);
        return distance;
      };
      var handleScroll = function handleScroll(col, e) {
        var _ctx$refs, _props$onChange;
        var val;
        var formattedVal;
        if (!props.isShowPanel) return;
        var scrollTop = ((_ctx$refs = ctx.refs["".concat(col, "Col")]) === null || _ctx$refs === void 0 ? void 0 : _ctx$refs.scrollTop) + panelOffset.top;
        var _getItemHeight2 = getItemHeight(),
          offsetHeight = _getItemHeight2.offsetHeight,
          margin = _getItemHeight2.margin;
        var timeItemTotalHeight = offsetHeight + margin;
        var colStep = Math.abs(Math.round(scrollTop / timeItemTotalHeight + 0.5));
        var meridiem = MERIDIEM_LIST[Math.min(colStep - 1, 1)].toLowerCase();
        if (Number.isNaN(colStep)) colStep = 1;
        if (timeArr.includes(col)) {
          var max = 59;
          if (col === EPickerCols$1.hour) max = /[h]{1}/.test(format.value) ? 11 : 23;else if (col === EPickerCols$1.milliSecond) max = 999;
          var colIdx = timeArr.indexOf(col);
          var availableArr = range$1(0, max + 1, Number(steps.value[colIdx]) || 1);
          val = closestLookup(availableArr, Number(getColList(col)[Math.min(colStep - 1, max + 1, availableArr.length - 1)]), Number(steps.value[colIdx]) || 1);
          if (Number.isNaN(val)) val = availableArr[availableArr.length - 1];
          if (col === EPickerCols$1.hour && cols.value.includes(EPickerCols$1.meridiem) && dayjsValue.value.hour() >= 12) {
            val = Number(val) + 12;
          }
        } else val = meridiem;
        var distance = getScrollDistance(col, val);
        if (!dayjs_min(dayjsValue.value).isValid() || value.value && !dayjs_min(value.value, format.value, true).isValid()) return;
        if (timeArr.includes(col)) {
          if (timeItemCanUsed(col, val)) {
            var _dayjsValue$value$col, _dayjsValue$value;
            formattedVal = (_dayjsValue$value$col = (_dayjsValue$value = dayjsValue.value)[col]) === null || _dayjsValue$value$col === void 0 ? void 0 : _dayjsValue$value$col.call(_dayjsValue$value, val).format(format.value);
          } else {
            formattedVal = dayjsValue.value.format(format.value);
          }
        } else {
          var currentHour = dayjsValue.value.hour();
          if (meridiem === AM && currentHour >= 12) {
            formattedVal = dayjsValue.value.hour(currentHour - 12).format(format.value);
          } else if (meridiem === PM && currentHour < 12) {
            formattedVal = dayjsValue.value.hour(currentHour + 12).format(format.value);
          } else {
            formattedVal = dayjsValue.value.format(format.value);
          }
        }
        if (formattedVal !== value.value) (_props$onChange = props.onChange) === null || _props$onChange === void 0 || _props$onChange.call(props, formattedVal, e);
        if (distance !== scrollTop) {
          var _scrollCtrl$scrollTo;
          var scrollCtrl = ctx.refs["".concat(col, "Col")];
          if (!scrollCtrl || scrollCtrl.scrollTop === distance) return;
          (_scrollCtrl$scrollTo = scrollCtrl.scrollTo) === null || _scrollCtrl$scrollTo === void 0 || _scrollCtrl$scrollTo.call(scrollCtrl, {
            top: distance,
            behavior: "smooth"
          });
        }
      };
      var scrollToTime = function scrollToTime(col, time, idx) {
        var _scrollCtrl$scrollTo2;
        var behavior = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "auto";
        var distance = getScrollDistance(col, time);
        var scrollCtrl = ctx.refs["".concat(col, "Col")];
        if (!scrollCtrl || scrollCtrl.scrollTop === distance || !timeItemCanUsed(col, time)) return;
        (_scrollCtrl$scrollTo2 = scrollCtrl.scrollTo) === null || _scrollCtrl$scrollTo2 === void 0 || _scrollCtrl$scrollTo2.call(scrollCtrl, {
          top: distance,
          behavior: behavior
        });
      };
      var handleTimeItemClick = function handleTimeItemClick(col, el, idx, e) {
        if (!timeItemCanUsed(col, el)) return;
        if (timeArr.includes(col)) {
          if (col === EPickerCols$1.hour && dayjsValue.value.hour() >= 12 && cols.value.includes(EPickerCols$1.meridiem)) {
            el = Number(el) + 12;
          }
          scrollToTime(col, el, idx, "smooth");
        } else {
          var currentHour = dayjsValue.value.hour();
          if (el === AM && currentHour >= 12) {
            var _props$onChange2;
            (_props$onChange2 = props.onChange) === null || _props$onChange2 === void 0 || _props$onChange2.call(props, dayjsValue.value.hour(currentHour - 12).format(format.value), e);
          } else if (el === PM && currentHour < 12) {
            var _props$onChange3;
            (_props$onChange3 = props.onChange) === null || _props$onChange3 === void 0 || _props$onChange3.call(props, dayjsValue.value.hour(currentHour + 12).format(format.value), e);
          }
        }
      };
      var updateTimeScrollPos = function updateTimeScrollPos() {
        var isAutoScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var behavior = value.value && !isAutoScroll ? "smooth" : "auto";
        var isStepsSet = !!steps.value.filter(function (v) {
          return v > 1;
        }).length;
        VueCompositionAPI.nextTick(function () {
          cols.value.forEach(function (col, idx) {
            if (!isStepsSet || isStepsSet && value.value) {
              var _dayjsValue$value$col2, _dayjsValue$value2;
              scrollToTime(col, timeArr.includes(col) ? (_dayjsValue$value$col2 = (_dayjsValue$value2 = dayjsValue.value)[col]) === null || _dayjsValue$value$col2 === void 0 ? void 0 : _dayjsValue$value$col2.call(_dayjsValue$value2) : dayjsValue.value.locale("en").format("a"), idx, behavior);
            } else {
              var _getColList;
              scrollToTime(col, (_getColList = getColList(col)) === null || _getColList === void 0 ? void 0 : _getColList[0], idx, behavior);
            }
          });
        });
        props.resetTriggerScroll();
      };
      var isCurrent = function isCurrent(col, colItem) {
        var _dayjsValue$value$col3, _dayjsValue$value3;
        var colVal;
        if (col === EPickerCols$1.meridiem) {
          var currentMeridiem = dayjsValue.value.locale("en").format("a");
          return currentMeridiem === colItem;
        }
        colVal = (_dayjsValue$value$col3 = (_dayjsValue$value3 = dayjsValue.value)[col]) === null || _dayjsValue$value$col3 === void 0 ? void 0 : _dayjsValue$value$col3.call(_dayjsValue$value3);
        if (col === EPickerCols$1.hour && /[h]{1}/.test(format.value)) {
          colVal %= 12;
        }
        return colVal === Number(colItem);
      };
      return {
        getColList: getColList,
        isCurrent: isCurrent,
        bodyRef: bodyRef,
        maskRef: maskRef,
        global: global,
        classPrefix: classPrefix,
        panelClassName: panelClassName,
        cols: cols,
        timeItemCanUsed: timeItemCanUsed,
        handleScroll: handleScroll,
        handleTimeItemClick: handleTimeItemClick
      };
    },
    render: function render() {
      var _this$cols$map,
        _this$cols,
        _this$cols$map2,
        _this$cols2,
        _this = this;
      var h = arguments[0];
      return h("div", {
        "class": "".concat(this.panelClassName, "-body"),
        "ref": "bodyRef"
      }, [h("div", {
        "class": "".concat(this.panelClassName, "-body-active-mask"),
        "ref": "maskRef"
      }, [(_this$cols$map = (_this$cols = this.cols).map) === null || _this$cols$map === void 0 ? void 0 : _this$cols$map.call(_this$cols, function (col, idx) {
        return h("div", {
          "key": "".concat(col, "_").concat(idx)
        });
      })]), (_this$cols$map2 = (_this$cols2 = this.cols).map) === null || _this$cols$map2 === void 0 ? void 0 : _this$cols$map2.call(_this$cols2, function (col, idx) {
        return h("ul", {
          "key": "".concat(col, "_").concat(idx),
          "ref": "".concat(col, "Col"),
          "class": "".concat(_this.panelClassName, "-body-scroll"),
          "on": {
            "scroll": debounce$1(function (e) {
              return _this.handleScroll(col, e);
            }, 50)
          }
        }, [_this.getColList(col).map(function (el) {
          return h("li", {
            "key": el,
            "class": ["".concat(_this.panelClassName, "-body-scroll-item"), _defineProperty$2(_defineProperty$2({}, "".concat(_this.classPrefix, "-is-disabled"), !_this.timeItemCanUsed(col, el)), "".concat(_this.classPrefix, "-is-current"), _this.isCurrent(col, el))],
            "on": {
              "click": function click(e) {
                return _this.handleTimeItemClick(col, el, idx, e);
              }
            }
          }, [timeArr.includes(col) ? TWELVE_HOUR_FORMAT.test(_this.format) && col === EPickerCols$1.hour && el === "00" ? "12" : el : _this.global[el === AM ? "anteMeridiem" : "postMeridiem"]]);
        })]);
      })]);
    }
  });

  function ownKeys$1y(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1x(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1y(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1y(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  dayjs_min.extend(customParseFormat);
  var _TimePickerPanel = VueCompositionAPI.defineComponent({
    name: "TTimePickerPanel",
    props: _objectSpread$1x(_objectSpread$1x({}, panelProps()), {}, {
      handleConfirmClick: Function,
      onChange: Function,
      onPick: Function,
      disableTime: Function
    }),
    setup: function setup(props, ctx) {
      var panelClassName = usePrefixClass("time-picker__panel");
      var triggerScroll = VueCompositionAPI.ref(false);
      var _useConfig = useConfig("timePicker"),
        global = _useConfig.global;
      var showNowTimeBtn = VueCompositionAPI.computed(function () {
        return !!props.steps.filter(function (v) {
          return v > 1;
        }).length;
      });
      var defaultValue = VueCompositionAPI.computed(function () {
        var isStepsSet = showNowTimeBtn.value;
        var formattedValue = dayjs_min(props.value, props.format);
        if (props.value && formattedValue.isValid()) {
          return formattedValue;
        }
        if (isStepsSet) {
          return dayjs_min().hour(0).minute(0).second(0);
        }
        return dayjs_min().hour(0).minute(0).second(0).format(props.format);
      });
      var panelColUpdate = function panelColUpdate() {
        VueCompositionAPI.nextTick(function () {
          triggerScroll.value = true;
        });
      };
      var resetTriggerScroll = function resetTriggerScroll() {
        triggerScroll.value = false;
      };
      var handleChange = function handleChange(v, e) {
        var _props$onPick, _props$onChange;
        (_props$onPick = props.onPick) === null || _props$onPick === void 0 || _props$onPick.call(props, v, e);
        ctx.emit("pick", v, e);
        (_props$onChange = props.onChange) === null || _props$onChange === void 0 || _props$onChange.call(props, v);
        ctx.emit("change", v);
      };
      var handlePresetClick = function handlePresetClick(presetValue) {
        var presetVal = typeof presetValue === "function" ? presetValue() : presetValue;
        if (typeof props.activeIndex === "number") {
          if (Array.isArray(presetVal)) {
            props.onChange(presetVal[props.activeIndex]);
          } else {
            log.error("TimePicker", "preset: ".concat(props.presets, " \u9884\u8BBE\u503C\u5FC5\u987B\u662F\u6570\u7EC4!"));
          }
        } else {
          props.onChange(presetVal);
        }
      };
      VueCompositionAPI.onMounted(function () {
        panelColUpdate();
      });
      VueCompositionAPI.watch(function () {
        return props.isShowPanel;
      }, function () {
        panelColUpdate();
      });
      return {
        showNowTimeBtn: showNowTimeBtn,
        panelClassName: panelClassName,
        triggerScroll: triggerScroll,
        resetTriggerScroll: resetTriggerScroll,
        defaultValue: defaultValue,
        global: global,
        handleChange: handleChange,
        handlePresetClick: handlePresetClick
      };
    },
    render: function render() {
      var _this = this;
      var h = arguments[0];
      return h("div", {
        "class": this.panelClassName
      }, [h("div", {
        "class": "".concat(this.panelClassName, "-section-body")
      }, [h(SinglePanel, {
        "props": _objectSpread$1x({}, {
          value: dayjs_min(this.value, this.format).isValid() ? this.value : this.defaultValue,
          onChange: this.handleChange,
          onPick: this.onPick,
          format: this.format || DEFAULT_FORMAT,
          steps: this.steps || DEFAULT_STEPS,
          triggerScroll: this.triggerScroll,
          disableTime: this.disableTime,
          position: this.position,
          resetTriggerScroll: this.resetTriggerScroll,
          isShowPanel: this.isShowPanel,
          hideDisabledTime: this.hideDisabledTime
        })
      })]), this.isFooterDisplay ? h("div", {
        "class": "".concat(this.panelClassName, "-section-footer")
      }, [h(TButton, {
        "attrs": {
          "theme": "primary",
          "variant": "base",
          "disabled": !this.value,
          "size": "small"
        },
        "on": {
          "click": function click() {
            return _this.handleConfirmClick(_this.defaultValue);
          }
        }
      }, [this.global.confirm]), h("div", [!this.showNowTimeBtn ? h(TButton, {
        "attrs": {
          "theme": "primary",
          "variant": "text",
          "size": "small"
        },
        "on": {
          "click": function click() {
            return _this.onChange(dayjs_min().format(_this.format));
          }
        }
      }, [this.global.now]) : null, this.presets && Object.keys(this.presets).map(function (key) {
        return h(TButton, {
          "key": key,
          "attrs": {
            "theme": "primary",
            "size": "small",
            "variant": "text"
          },
          "on": {
            "click": function click() {
              var _this$handlePresetCli;
              return (_this$handlePresetCli = _this.handlePresetClick) === null || _this$handlePresetCli === void 0 ? void 0 : _this$handlePresetCli.call(_this, _this.presets[key]);
            }
          }
        }, [key]);
      })])]) : null]);
    }
  });

  function ownKeys$1x(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1w(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1x(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1x(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var TPanelContent = VueCompositionAPI.defineComponent({
    name: "TPanelContent",
    props: {
      mode: String,
      format: String,
      enableTimePicker: Boolean,
      timePickerProps: {
        type: Object,
        "default": function _default() {
          return {};
        }
      },
      value: [String, Number, Array, Date],
      year: Number,
      month: Number,
      tableData: Array,
      time: String,
      popupVisible: Boolean,
      firstDayOfWeek: Number,
      partial: String,
      onYearChange: Function,
      onMonthChange: Function,
      onJumperClick: Function,
      onCellMouseEnter: Function,
      onCellClick: Function,
      onCellMouseLeave: Function,
      onTimePickerChange: Function
    },
    setup: function setup(props) {
      var COMPONENT_NAME = usePrefixClass("date-picker__panel");
      var _getDefaultFormat = getDefaultFormat({
          mode: props.mode,
          format: props.format,
          enableTimePicker: props.enableTimePicker
        }),
        timeFormat = _getDefaultFormat.timeFormat;
      return {
        COMPONENT_NAME: COMPONENT_NAME,
        timeFormat: timeFormat
      };
    },
    render: function render() {
      var _this = this;
      var h = arguments[0];
      var COMPONENT_NAME = this.COMPONENT_NAME,
        timeFormat = this.timeFormat;
      return h("div", {
        "class": "".concat(COMPONENT_NAME, "-content")
      }, [h("div", {
        "class": "".concat(COMPONENT_NAME, "-").concat(this.mode)
      }, [h(TDateHeader, {
        "props": _objectSpread$1w({}, {
          mode: this.mode,
          year: this.year,
          month: this.month,
          onMonthChange: function onMonthChange(val) {
            var _this$onMonthChange;
            return (_this$onMonthChange = _this.onMonthChange) === null || _this$onMonthChange === void 0 ? void 0 : _this$onMonthChange.call(_this, val, {
              partial: _this.partial
            });
          },
          onYearChange: function onYearChange(val) {
            var _this$onYearChange;
            return (_this$onYearChange = _this.onYearChange) === null || _this$onYearChange === void 0 ? void 0 : _this$onYearChange.call(_this, val, {
              partial: _this.partial
            });
          },
          onJumperClick: function onJumperClick(_ref) {
            var _this$onJumperClick;
            var trigger = _ref.trigger;
            return (_this$onJumperClick = _this.onJumperClick) === null || _this$onJumperClick === void 0 ? void 0 : _this$onJumperClick.call(_this, {
              trigger: trigger,
              partial: _this.partial
            });
          }
        })
      }), h(TDateTable, {
        "props": _objectSpread$1w({}, {
          mode: this.mode,
          data: this.tableData,
          time: this.time,
          value: this.value,
          format: this.format,
          firstDayOfWeek: this.firstDayOfWeek,
          onCellClick: function onCellClick(date, _ref2) {
            var _this$onCellClick;
            var e = _ref2.e;
            return (_this$onCellClick = _this.onCellClick) === null || _this$onCellClick === void 0 ? void 0 : _this$onCellClick.call(_this, date, {
              e: e,
              partial: _this.partial
            });
          },
          onCellMouseEnter: function onCellMouseEnter(date) {
            var _this$onCellMouseEnte;
            return (_this$onCellMouseEnte = _this.onCellMouseEnter) === null || _this$onCellMouseEnte === void 0 ? void 0 : _this$onCellMouseEnte.call(_this, date, {
              partial: _this.partial
            });
          },
          onCellMouseLeave: this.onCellMouseLeave
        })
      })]), this.enableTimePicker && h("div", {
        "class": "".concat(COMPONENT_NAME, "-time")
      }, [h("div", {
        "class": "".concat(COMPONENT_NAME, "-time-viewer")
      }, [this.time]), h(_TimePickerPanel, helper([{}, {
        key: this.partial,
        props: _objectSpread$1w({
          position: this.partial,
          format: timeFormat,
          value: this.time,
          onChange: this.onTimePickerChange,
          isShowPanel: this.popupVisible
        }, this.timePickerProps)
      }]))])]);
    }
  });

  function ownKeys$1w(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1v(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1w(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1w(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var TDateFooter = VueCompositionAPI.defineComponent({
    name: "TDatePickerTable",
    props: {
      enableTimePicker: Boolean,
      presetsPlacement: String,
      presets: Object,
      selectedValue: [Date, String, Number],
      onPresetClick: Function,
      onConfirmClick: Function
    },
    setup: function setup(props) {
      var COMPONENT_NAME = usePrefixClass("date-picker__footer");
      var presetsClass = usePrefixClass("date-picker__presets");
      var _useConfig = useConfig("datePicker"),
        t = _useConfig.t,
        global = _useConfig.global;
      var footerClass = VueCompositionAPI.computed(function () {
        return [COMPONENT_NAME.value, "".concat(COMPONENT_NAME.value, "--").concat(props.presetsPlacement)];
      });
      return {
        footerClass: footerClass,
        presetsClass: presetsClass,
        global: global,
        t: t
      };
    },
    render: function render() {
      var _this = this;
      var h = arguments[0];
      var footerClass = this.footerClass,
        presetsClass = this.presetsClass,
        global = this.global,
        t = this.t;
      return h("div", {
        "class": footerClass
      }, [h("div", {
        "class": presetsClass
      }, [this.presets && Object.keys(this.presets).map(function (key) {
        return h(Button, {
          "key": key,
          "attrs": {
            "size": "small",
            "variant": "text"
          },
          "on": {
            "click": function click(e) {
              var _this$onPresetClick;
              return (_this$onPresetClick = _this.onPresetClick) === null || _this$onPresetClick === void 0 ? void 0 : _this$onPresetClick.call(_this, _this.presets[key], {
                e: e,
                preset: _defineProperty$2({}, key, _this.presets[key])
              });
            }
          }
        }, [key]);
      })]), this.enableTimePicker && h(Button, {
        "props": _objectSpread$1v({}, {
          size: "small",
          theme: "primary",
          disabled: !this.selectedValue,
          onClick: function onClick(e) {
            var _this$onConfirmClick;
            return (_this$onConfirmClick = _this.onConfirmClick) === null || _this$onConfirmClick === void 0 ? void 0 : _this$onConfirmClick.call(_this, {
              e: e
            });
          }
        })
      }, [t(global.confirm)])]);
    }
  });

  function ownKeys$1v(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1u(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1v(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1v(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var TExtraContent = VueCompositionAPI.defineComponent({
    name: "TExtraContent",
    props: {
      presets: Object,
      enableTimePicker: Boolean,
      presetsPlacement: String,
      onPresetClick: Function,
      onConfirmClick: Function,
      selectedValue: [String, Number, Array]
    },
    setup: function setup(props) {
      var showPanelFooter = VueCompositionAPI.computed(function () {
        return props.enableTimePicker || props.presets;
      });
      return {
        showPanelFooter: showPanelFooter
      };
    },
    render: function render() {
      var h = arguments[0];
      var showPanelFooter = this.showPanelFooter;
      return showPanelFooter ? h(TDateFooter, {
        "props": _objectSpread$1u({}, {
          presets: this.presets,
          onPresetClick: this.onPresetClick,
          enableTimePicker: this.enableTimePicker,
          onConfirmClick: this.onConfirmClick,
          presetsPlacement: this.presetsPlacement,
          selectedValue: this.selectedValue
        })
      }) : null;
    }
  });

  function useTableData(props) {
    var _props$firstDayOfWeek;
    var _useConfig = useConfig("datePicker"),
      global = _useConfig.global;
    var options = {
      minDate: props.minDate,
      maxDate: props.maxDate,
      disableDate: props.disableDate,
      firstDayOfWeek: (_props$firstDayOfWeek = props.firstDayOfWeek) !== null && _props$firstDayOfWeek !== void 0 ? _props$firstDayOfWeek : global.value.firstDayOfWeek,
      monthLocal: global.value.months,
      quarterLocal: global.value.quarters,
      showWeekOfYear: props.mode === "week",
      dayjsLocale: global.value.dayjsLocale,
      cancelRangeSelectLimit: props.cancelRangeSelectLimit
    };
    var data = [];
    if (props.mode === "date") {
      data = getWeeks({
        year: props.year,
        month: props.month
      }, options);
    } else if (props.mode === "week") {
      data = getWeeks({
        year: props.year,
        month: props.month
      }, options);
    } else if (props.mode === "quarter") {
      data = getQuarters(props.year, options);
    } else if (props.mode === "month") {
      data = getMonths(props.year, options);
    } else if (props.mode === "year") {
      data = getYears(props.year, options);
    }
    return flagActive(data, {
      start: props.start,
      end: props.end,
      hoverStart: props.hoverStart,
      hoverEnd: props.hoverEnd,
      type: props.mode,
      isRange: props.isRange,
      value: props.value,
      multiple: props.multiple
    });
  }

  function useDisableDate(props) {
    return {
      disableDate: function disableDate(value) {
        return !isEnabled({
          disableDate: props.disableDate,
          format: props.format,
          mode: props.mode,
          value: value
        });
      },
      minDate: isObject(props.disableDate) && "before" in props.disableDate ? new Date(props.disableDate.before) : props.start,
      maxDate: isObject(props.disableDate) && "after" in props.disableDate ? new Date(props.disableDate.after) : props.end
    };
  }
  function isEnabled(props) {
    if (!props.disableDate) return true;
    var isEnabled2 = true;
    if (typeof props.disableDate === "function") {
      return !props.disableDate(props.value);
    }
    if (Array.isArray(props.disableDate)) {
      var isIncludes = false;
      var formattedDisabledDate = props.disableDate.map(function (item) {
        return dayjs_min(item, props.format);
      });
      formattedDisabledDate.forEach(function (item) {
        if (item.isSame(dayjs_min(props.value))) {
          isIncludes = true;
        }
      });
      return !isIncludes;
    }
    if (props.disableDate.from && props.disableDate.to) {
      var compareMin = dayjs_min(new Date(props.disableDate.from));
      var compareMax = dayjs_min(new Date(props.disableDate.to));
      return !dayjs_min(props.value).isBetween(compareMin, compareMax, props.mode, "[]");
    }
    var min = props.disableDate.before ? new Date(props.disableDate.before) : null;
    var max = props.disableDate.after ? new Date(props.disableDate.after) : null;
    if (max && min) {
      var _compareMin = dayjs_min(new Date(min));
      var _compareMax = dayjs_min(new Date(max));
      isEnabled2 = dayjs_min(props.value).isBetween(_compareMin, _compareMax, props.mode, "[]");
    } else if (min) {
      var _compareMin2 = dayjs_min(new Date(min));
      isEnabled2 = !dayjs_min(props.value).isBefore(_compareMin2, props.mode);
    } else if (max) {
      var _compareMax2 = dayjs_min(new Date(max));
      isEnabled2 = !dayjs_min(props.value).isAfter(_compareMax2, props.mode);
    }
    return isEnabled2;
  }

  function dateCorrection(partialIndex, preYear, preMonth, onlyYearSelect) {
    var nextYear = preYear;
    var nextMonth = preMonth;
    if (partialIndex === 0) {
      if (nextYear[1] <= nextYear[0]) {
        if (onlyYearSelect) nextYear[1] = nextYear[0] + 1;else {
          nextYear[1] = nextYear[0];
          if (nextMonth[1] <= nextMonth[0]) {
            nextMonth[1] = nextMonth[0] + 1;
            if (nextMonth[1] === 12) {
              nextMonth[1] = 0;
              nextYear = [nextYear[0], nextYear[1] + 1];
            }
          }
        }
      }
    }
    if (partialIndex === 1) {
      if (nextYear[0] >= nextYear[1]) {
        if (onlyYearSelect) nextYear[0] = nextYear[1] - 1;else {
          nextYear[0] = nextYear[1];
          if (nextMonth[0] >= nextMonth[1]) {
            nextMonth[0] = nextMonth[1] - 1;
            if (nextMonth[0] === -1) {
              nextMonth[0] = 11;
              nextYear = [nextYear[0] - 1, nextYear[1]];
            }
          }
        }
      }
    }
    return {
      nextYear: nextYear,
      nextMonth: nextMonth
    };
  }
  function parseToDateTime(value, format, times) {
    if (isNil(value)) {
      return null;
    }
    var dayjs = parseToDayjs(value, format);
    if (times) {
      var _times = _slicedToArray(times, 4),
        _times$ = _times[0],
        hour = _times$ === void 0 ? 0 : _times$,
        _times$2 = _times[1],
        minute = _times$2 === void 0 ? 0 : _times$2,
        _times$3 = _times[2],
        second = _times$3 === void 0 ? 0 : _times$3,
        _times$4 = _times[3],
        millisecond = _times$4 === void 0 ? 0 : _times$4;
      dayjs = dayjs.hour(hour).minute(minute).second(second).millisecond(millisecond);
    }
    return dayjs.toDate();
  }

  function ownKeys$1u(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1t(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1u(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1u(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var TSinglePanel = VueCompositionAPI.defineComponent({
    name: "TSinglePanel",
    props: {
      disableDate: [Object, Array, Function],
      disableTime: Function,
      mode: {
        type: String,
        "default": "date"
      },
      format: String,
      presetsPlacement: {
        type: String,
        "default": "bottom"
      },
      value: [String, Number, Array, Date],
      timePickerProps: Object,
      presets: Object,
      enableTimePicker: Boolean,
      firstDayOfWeek: Number,
      year: Number,
      month: Number,
      time: String,
      popupVisible: Boolean,
      multiple: Boolean,
      onPanelClick: Function,
      onCellClick: Function,
      onCellMouseEnter: Function,
      onCellMouseLeave: Function,
      onJumperClick: Function,
      onConfirmClick: Function,
      onPresetClick: Function,
      onYearChange: Function,
      onMonthChange: Function,
      onTimePickerChange: Function
    },
    setup: function setup(props) {
      var COMPONENT_NAME = usePrefixClass("date-picker__panel");
      var _useConfig = useConfig("datePicker"),
        global = _useConfig.global;
      var _getDefaultFormat = getDefaultFormat({
          mode: props.mode,
          format: props.format,
          enableTimePicker: props.enableTimePicker
        }),
        format = _getDefaultFormat.format;
      var disableDateOptions = VueCompositionAPI.computed(function () {
        return useDisableDate({
          format: format,
          mode: props.mode,
          disableDate: props.disableDate
        });
      });
      var disableTime = function disableTime(h, m, s, ms) {
        if (!isFunction(props.disableTime) || !props.value) {
          return {};
        }
        var value = props.multiple ? Date.now() : props.value;
        return props.disableTime(parseToDateTime(value, format, [h, m, s, ms]));
      };
      var tableData = VueCompositionAPI.computed(function () {
        return useTableData(_objectSpread$1t({
          value: props.value,
          year: props.year,
          month: props.month,
          mode: props.mode,
          start: props.value ? parseToDayjs(props.multiple ? props.value[0] : props.value, format).toDate() : void 0,
          firstDayOfWeek: props.firstDayOfWeek || global.value.firstDayOfWeek,
          multiple: props.multiple
        }, disableDateOptions.value));
      });
      var panelContentProps = VueCompositionAPI.computed(function () {
        return {
          format: format,
          value: props.value,
          mode: props.mode,
          year: props.year,
          month: props.month,
          firstDayOfWeek: props.firstDayOfWeek || global.value.firstDayOfWeek,
          tableData: tableData.value,
          popupVisible: props.popupVisible,
          multiple: props.multiple,
          enableTimePicker: props.enableTimePicker,
          timePickerProps: _objectSpread$1t({
            disableTime: disableTime
          }, props.timePickerProps),
          time: props.time,
          onMonthChange: props.onMonthChange,
          onYearChange: props.onYearChange,
          onJumperClick: props.onJumperClick,
          onCellClick: props.onCellClick,
          onCellMouseEnter: props.onCellMouseEnter,
          onCellMouseLeave: props.onCellMouseLeave,
          onTimePickerChange: props.onTimePickerChange
        };
      });
      var extraProps = VueCompositionAPI.computed(function () {
        return {
          presets: props.presets,
          enableTimePicker: props.enableTimePicker,
          presetsPlacement: props.presetsPlacement,
          onPresetClick: props.onPresetClick,
          onConfirmClick: props.onConfirmClick,
          selectedValue: props.value
        };
      });
      return {
        COMPONENT_NAME: COMPONENT_NAME,
        panelContentProps: panelContentProps,
        extraProps: extraProps
      };
    },
    render: function render() {
      var _this = this;
      var h = arguments[0];
      var COMPONENT_NAME = this.COMPONENT_NAME,
        panelContentProps = this.panelContentProps,
        extraProps = this.extraProps;
      return h("div", {
        "class": [COMPONENT_NAME, _defineProperty$2({}, "".concat(COMPONENT_NAME, "--direction-row"), ["left", "right"].includes(this.presetsPlacement))],
        "on": {
          "click": function click(e) {
            var _this$onPanelClick;
            return (_this$onPanelClick = _this.onPanelClick) === null || _this$onPanelClick === void 0 ? void 0 : _this$onPanelClick.call(_this, {
              e: e
            });
          }
        }
      }, [["top", "left"].includes(this.presetsPlacement) ? h(TExtraContent, {
        "props": _objectSpread$1t({}, extraProps)
      }) : null, h(TPanelContent, {
        "props": _objectSpread$1t({}, panelContentProps)
      }), ["bottom", "right"].includes(this.presetsPlacement) ? h(TExtraContent, {
        "props": _objectSpread$1t({}, extraProps)
      }) : null]);
    }
  });

  function ownKeys$1t(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1s(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1t(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1t(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _DatePicker = VueCompositionAPI.defineComponent({
    name: "TDatePicker",
    props: datePickerProps,
    setup: function setup(props2, _ref) {
      var emit = _ref.emit;
      var COMPONENT_NAME = usePrefixClass("date-picker");
      var _useGlobalIcon = useGlobalIcon({
          CalendarIcon: TdCalendarIcon
        }),
        CalendarIcon = _useGlobalIcon.CalendarIcon;
      var _useConfig = useConfig("datePicker"),
        global = _useConfig.global;
      var _useSingle = useSingle(props2, {
          emit: emit
        }),
        inputValue = _useSingle.inputValue,
        popupVisible = _useSingle.popupVisible,
        datePickerInputProps = _useSingle.inputProps,
        datePickerPopupProps = _useSingle.popupProps,
        isHoverCell = _useSingle.isHoverCell,
        cacheValue = _useSingle.cacheValue,
        value = _useSingle.value,
        year = _useSingle.year,
        month = _useSingle.month,
        time = _useSingle.time,
        inputRef = _useSingle.inputRef,
        onChange = _useSingle.onChange;
      var formatRef = VueCompositionAPI.computed(function () {
        return getDefaultFormat({
          mode: props2.mode,
          format: props2.format,
          valueType: props2.valueType,
          enableTimePicker: props2.multiple ? false : props2.enableTimePicker
        });
      });
      var _useFormDisabled = useFormDisabled(),
        formDisabled = _useFormDisabled.formDisabled;
      var isDisabled = VueCompositionAPI.computed(function () {
        return formDisabled.value || props2.disabled;
      });
      VueCompositionAPI.watch(popupVisible, function (visible) {
        var _formatRef$value;
        if (props2.multiple) return;
        var dateValue = value.value && !isDate$2(value.value) && !["week", "quarter"].includes(props2.mode) ? covertToDate(value.value, (_formatRef$value = formatRef.value) === null || _formatRef$value === void 0 ? void 0 : _formatRef$value.valueType) : value.value;
        cacheValue.value = formatDate(dateValue, {
          format: formatRef.value.format
        });
        inputValue.value = formatDate(dateValue, {
          format: formatRef.value.format
        });
        if (visible) {
          year.value = parseToDayjs(value.value, formatRef.value.format).year();
          month.value = parseToDayjs(value.value, formatRef.value.format).month();
          time.value = formatTime(value.value, formatRef.value.format, formatRef.value.timeFormat, props2.defaultTime);
        } else {
          isHoverCell.value = false;
        }
      });
      function onCellMouseEnter(date) {
        if (props2.multiple) return;
        isHoverCell.value = true;
        inputValue.value = formatDate(date, {
          format: formatRef.value.format
        });
      }
      function onCellMouseLeave() {
        if (props2.multiple) return;
        isHoverCell.value = false;
        inputValue.value = formatDate(cacheValue.value, {
          format: formatRef.value.format
        });
      }
      function onCellClick(date) {
        var _props2$onPick;
        isHoverCell.value = false;
        if (props2.mode === "date") {
          year.value = date.getFullYear();
          month.value = date.getMonth();
        }
        if (props2.enableTimePicker) {
          cacheValue.value = formatDate(date, {
            format: formatRef.value.format
          });
        } else {
          if (props2.multiple) {
            var newDate = processDate(date);
            onChange === null || onChange === void 0 || onChange(newDate, {
              dayjsValue: parseToDayjs(date, formatRef.value.format),
              trigger: "pick"
            });
            return;
          }
          onChange === null || onChange === void 0 || onChange(formatDate(date, {
            format: formatRef.value.format,
            targetFormat: formatRef.value.valueType
          }), {
            dayjsValue: parseToDayjs(date, formatRef.value.format),
            trigger: "pick"
          });
          popupVisible.value = false;
        }
        (_props2$onPick = props2.onPick) === null || _props2$onPick === void 0 || _props2$onPick.call(props2, date);
        emit("pick", date);
      }
      function onJumperClick(_ref2) {
        var trigger = _ref2.trigger;
        var monthCountMap = {
          date: 1,
          week: 1,
          month: 12,
          quarter: 12,
          year: 120
        };
        var monthCount = monthCountMap[props2.mode] || 0;
        var current = new Date(year.value, month.value);
        var next = null;
        if (trigger === "prev") {
          next = subtractMonth(current, monthCount);
        } else if (trigger === "current") {
          next = new Date();
        } else if (trigger === "next") {
          next = addMonth(current, monthCount);
        }
        var nextYear = next.getFullYear();
        var nextMonth = next.getMonth();
        year.value = nextYear;
        month.value = nextMonth;
      }
      function onTimePickerChange(val) {
        var _props2$onPick2;
        time.value = val;
        var _extractTimeObj = extractTimeObj(val),
          hours = _extractTimeObj.hours,
          minutes = _extractTimeObj.minutes,
          seconds = _extractTimeObj.seconds,
          milliseconds = _extractTimeObj.milliseconds,
          meridiem = _extractTimeObj.meridiem;
        var nextHours = hours;
        if (/am/i.test(meridiem) && nextHours === 12) nextHours -= 12;
        if (/pm/i.test(meridiem) && nextHours < 12) nextHours += 12;
        var currentDate = !dayjs_min(inputValue.value, formatRef.value.format).isValid() ? dayjs_min() : dayjs_min(inputValue.value, formatRef.value.format);
        var nextDate = currentDate.hour(nextHours).minute(minutes).second(seconds).millisecond(milliseconds).toDate();
        inputValue.value = formatDate(nextDate, {
          format: formatRef.value.format
        });
        cacheValue.value = formatDate(nextDate, {
          format: formatRef.value.format
        });
        (_props2$onPick2 = props2.onPick) === null || _props2$onPick2 === void 0 || _props2$onPick2.call(props2, nextDate);
      }
      function onConfirmClick(_ref3) {
        var e = _ref3.e;
        var nextValue = formatDate(inputValue.value, {
          format: formatRef.value.format
        });
        if (nextValue) {
          var _props2$onConfirm;
          props2 === null || props2 === void 0 || (_props2$onConfirm = props2.onConfirm) === null || _props2$onConfirm === void 0 || _props2$onConfirm.call(props2, {
            date: dayjs_min(nextValue).toDate(),
            e: e
          });
          emit("confirm", {
            date: dayjs_min(nextValue).toDate(),
            e: e
          });
          onChange === null || onChange === void 0 || onChange(formatDate(inputValue.value, {
            format: formatRef.value.format,
            targetFormat: formatRef.value.valueType
          }), {
            dayjsValue: parseToDayjs(inputValue.value, formatRef.value.format),
            trigger: "confirm"
          });
        } else {
          inputValue.value = formatDate(value.value, {
            format: formatRef.value.format
          });
        }
        popupVisible.value = false;
      }
      function onPresetClick(presetValue, context) {
        var _props2$onPresetClick;
        var presetVal = typeof presetValue === "function" ? presetValue() : presetValue;
        onChange === null || onChange === void 0 || onChange(formatDate(presetVal, {
          format: formatRef.value.format,
          targetFormat: formatRef.value.valueType
        }), {
          dayjsValue: parseToDayjs(presetVal, formatRef.value.format),
          trigger: "preset"
        });
        (_props2$onPresetClick = props2.onPresetClick) === null || _props2$onPresetClick === void 0 || _props2$onPresetClick.call(props2, context);
        emit("preset-click", context);
        popupVisible.value = false;
      }
      function onYearChange(nextYear) {
        year.value = nextYear;
      }
      function onMonthChange(nextMonth) {
        month.value = nextMonth;
      }
      function processDate(date) {
        var val = value.value;
        var isSameDate = val.some(function (val2) {
          return isSame(dayjs_min(val2).toDate(), date);
        });
        var currentDate;
        if (!isSameDate) {
          currentDate = val.concat(formatDate(date, {
            format: formatRef.value.format,
            targetFormat: formatRef.value.valueType
          }));
        } else {
          currentDate = val.filter(function (val2) {
            return formatDate(val2, {
              format: formatRef.value.format,
              targetFormat: formatRef.value.valueType
            }) !== formatDate(date, {
              format: formatRef.value.format,
              targetFormat: formatRef.value.valueType
            });
          });
        }
        return currentDate.sort(function (a, b) {
          return dayjs_min(a).valueOf() - dayjs_min(b).valueOf();
        });
      }
      var onTagRemoveClick = function onTagRemoveClick(ctx) {
        var removeDate = dayjs_min(ctx.item).toDate();
        var newDate = processDate(removeDate);
        onChange === null || onChange === void 0 || onChange(newDate, {
          dayjsValue: parseToDayjs(removeDate, formatRef.value.format),
          trigger: "tag-remove"
        });
      };
      var onTagClearClick = function onTagClearClick(_ref4) {
        var e = _ref4.e;
        e.stopPropagation();
        popupVisible.value = false;
        onChange === null || onChange === void 0 || onChange([], {
          dayjsValue: dayjs_min(),
          trigger: "clear"
        });
      };
      var panelProps = VueCompositionAPI.computed(function () {
        return {
          value: cacheValue.value,
          year: year.value,
          month: month.value,
          format: formatRef.value.format,
          mode: props2.mode,
          presets: props2.presets,
          time: props2.multiple ? "" : time.value,
          disableDate: props2.disableDate,
          disableTime: props2.disableTime,
          firstDayOfWeek: props2.firstDayOfWeek,
          timePickerProps: props2.timePickerProps,
          enableTimePicker: props2.multiple ? false : props2.enableTimePicker,
          presetsPlacement: props2.presetsPlacement,
          popupVisible: popupVisible.value,
          multiple: props2.multiple,
          onCellClick: onCellClick,
          onCellMouseEnter: onCellMouseEnter,
          onCellMouseLeave: onCellMouseLeave,
          onJumperClick: onJumperClick,
          onConfirmClick: onConfirmClick,
          onPresetClick: onPresetClick,
          onYearChange: onYearChange,
          onMonthChange: onMonthChange,
          onTimePickerChange: onTimePickerChange,
          onPanelClick: function onPanelClick() {
            var _inputRef$value, _inputRef$value$focus;
            return (_inputRef$value = inputRef.value) === null || _inputRef$value === void 0 || (_inputRef$value$focus = _inputRef$value.focus) === null || _inputRef$value$focus === void 0 ? void 0 : _inputRef$value$focus.call(_inputRef$value);
          }
        };
      });
      return {
        COMPONENT_NAME: COMPONENT_NAME,
        inputValue: inputValue,
        datePickerPopupProps: datePickerPopupProps,
        datePickerInputProps: datePickerInputProps,
        popupVisible: popupVisible,
        panelProps: panelProps,
        isDisabled: isDisabled,
        onTagRemoveClick: onTagRemoveClick,
        onTagClearClick: onTagClearClick,
        CalendarIcon: CalendarIcon,
        global: global
      };
    },
    render: function render() {
      var _this = this,
        _this$placeholder;
      var h = arguments[0];
      var COMPONENT_NAME = this.COMPONENT_NAME,
        inputValue = this.inputValue,
        datePickerPopupProps = this.datePickerPopupProps,
        datePickerInputProps = this.datePickerInputProps,
        popupVisible = this.popupVisible,
        panelProps = this.panelProps,
        isDisabled = this.isDisabled,
        onTagRemoveClick = this.onTagRemoveClick,
        onTagClearClick = this.onTagClearClick,
        CalendarIcon = this.CalendarIcon;
      var renderSuffixIcon = function renderSuffixIcon() {
        if (_this.suffixIcon) return _this.suffixIcon;
        if (_this.$scopedSlots.suffixIcon) return _this.$scopedSlots.suffixIcon;
        if (_this.$scopedSlots["suffix-icon"]) return _this.$scopedSlots["suffix-icon"];
        return function () {
          return h(CalendarIcon);
        };
      };
      return h("div", {
        "class": COMPONENT_NAME
      }, [h(SelectInput, {
        "attrs": {
          "disabled": isDisabled,
          "readonly": this.readonly,
          "value": inputValue,
          "inputValue": this.multiple ? "" : inputValue,
          "label": this.label,
          "status": this.status,
          "tips": this.tips,
          "popupProps": datePickerPopupProps,
          "inputProps": _objectSpread$1s({}, datePickerInputProps),
          "popupVisible": popupVisible,
          "clearable": this.clearable,
          "allowInput": this.allowInput && !this.readonly,
          "panel": function panel() {
            return h(TSinglePanel, {
              "props": _objectSpread$1s({}, panelProps)
            });
          },
          "multiple": this.multiple,
          "placeholder": (_this$placeholder = this.placeholder) !== null && _this$placeholder !== void 0 ? _this$placeholder : this.global.placeholder[this.mode],
          "suffixIcon": renderSuffixIcon(),
          "tagInputProps": {
            onRemove: onTagRemoveClick
          }
        },
        "on": {
          "clear": onTagClearClick
        }
      })]);
    }
  });

  var datePickerPanelProps = {
    defaultTime: {
      type: String,
      "default": "00:00:00"
    },
    onCellClick: Function,
    onChange: Function,
    onConfirm: Function,
    onMonthChange: Function,
    onPanelClick: Function,
    onPresetClick: Function,
    onTimeChange: Function,
    onYearChange: Function
  };

  function ownKeys$1s(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1r(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1s(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1s(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _DatePickerPanel = VueCompositionAPI.defineComponent({
    name: "TDatePickerPanel",
    props: _objectSpread$1r({
      value: datePickerProps.value,
      defaultValue: datePickerProps.defaultValue,
      disabled: datePickerProps.disabled,
      disableDate: datePickerProps.disableDate,
      enableTimePicker: datePickerProps.enableTimePicker,
      firstDayOfWeek: datePickerProps.firstDayOfWeek,
      format: datePickerProps.format,
      mode: datePickerProps.mode,
      presets: datePickerProps.presets,
      presetsPlacement: datePickerProps.presetsPlacement,
      timePickerProps: datePickerProps.timePickerProps
    }, datePickerPanelProps),
    setup: function setup(props, _ref) {
      var emit = _ref.emit,
        attrs = _ref.attrs;
      var _useSingleValue = useSingleValue(props),
        cacheValue = _useSingleValue.cacheValue,
        value = _useSingleValue.value,
        year = _useSingleValue.year,
        month = _useSingleValue.month,
        time = _useSingleValue.time,
        onChange = _useSingleValue.onChange;
      var formatRef = VueCompositionAPI.computed(function () {
        return getDefaultFormat({
          mode: props.mode,
          format: props.format,
          enableTimePicker: props.enableTimePicker
        });
      });
      function onCellClick(date, _ref2) {
        var _props$onCellClick;
        var e = _ref2.e;
        (_props$onCellClick = props.onCellClick) === null || _props$onCellClick === void 0 || _props$onCellClick.call(props, {
          date: date,
          e: e
        });
        emit("cell-click", {
          date: date,
          e: e
        });
        if (props.mode === "date") {
          year.value = date.getFullYear();
          month.value = date.getMonth();
        }
        if (props.enableTimePicker) {
          cacheValue.value = formatDate(date, {
            format: formatRef.value.format
          });
        } else {
          onChange === null || onChange === void 0 || onChange(formatDate(date, {
            format: formatRef.value.format
          }), {
            dayjsValue: parseToDayjs(date, formatRef.value.format),
            trigger: "pick"
          });
        }
      }
      function onJumperClick(_ref3) {
        var trigger = _ref3.trigger;
        var triggerMap = {
          prev: "arrow-previous",
          next: "arrow-next"
        };
        var monthCountMap = {
          date: 1,
          week: 1,
          month: 12,
          quarter: 12,
          year: 120
        };
        var monthCount = monthCountMap[props.mode] || 0;
        var current = new Date(year.value, month.value);
        var next = null;
        if (trigger === "prev") {
          next = subtractMonth(current, monthCount);
        } else if (trigger === "current") {
          next = new Date();
        } else if (trigger === "next") {
          next = addMonth(current, monthCount);
        }
        var nextYear = next.getFullYear();
        var nextMonth = next.getMonth();
        if (year.value !== nextYear) {
          var _props$onYearChange;
          (_props$onYearChange = props.onYearChange) === null || _props$onYearChange === void 0 || _props$onYearChange.call(props, {
            year: nextYear,
            date: parseToDayjs(value.value, formatRef.value.format).toDate(),
            trigger: trigger === "current" ? "today" : "year-".concat(triggerMap[trigger])
          });
          emit("year-change", {
            year: nextYear,
            date: parseToDayjs(value.value, formatRef.value.format).toDate(),
            trigger: trigger === "current" ? "today" : "year-".concat(triggerMap[trigger])
          });
        }
        if (month.value !== nextMonth) {
          var _props$onMonthChange;
          (_props$onMonthChange = props.onMonthChange) === null || _props$onMonthChange === void 0 || _props$onMonthChange.call(props, {
            month: nextMonth,
            date: parseToDayjs(value.value, formatRef.value.format).toDate(),
            trigger: trigger === "current" ? "today" : "month-".concat(triggerMap[trigger])
          });
          emit("month-change", {
            month: nextMonth,
            date: parseToDayjs(value.value, formatRef.value.format).toDate(),
            trigger: trigger === "current" ? "today" : "month-".concat(triggerMap[trigger])
          });
        }
        year.value = nextYear;
        month.value = nextMonth;
      }
      function onTimePickerChange(val) {
        var _props$onTimeChange;
        time.value = val;
        var _extractTimeObj = extractTimeObj(val),
          hours = _extractTimeObj.hours,
          minutes = _extractTimeObj.minutes,
          seconds = _extractTimeObj.seconds,
          milliseconds = _extractTimeObj.milliseconds,
          meridiem = _extractTimeObj.meridiem;
        var nextHours = hours;
        if (/am/i.test(meridiem) && nextHours === 12) nextHours -= 12;
        if (/pm/i.test(meridiem) && nextHours < 12) nextHours += 12;
        var currentDate = !dayjs_min(cacheValue.value, formatRef.value.format).isValid() ? dayjs_min() : dayjs_min(cacheValue.value, formatRef.value.format);
        var nextDate = currentDate.hour(nextHours).minute(minutes).second(seconds).millisecond(milliseconds).toDate();
        cacheValue.value = formatDate(nextDate, {
          format: formatRef.value.format
        });
        (_props$onTimeChange = props.onTimeChange) === null || _props$onTimeChange === void 0 || _props$onTimeChange.call(props, {
          time: val,
          date: parseToDayjs(value.value, formatRef.value.format).toDate(),
          trigger: "time-hour"
        });
        emit("time-change", {
          time: val,
          date: parseToDayjs(value.value, formatRef.value.format).toDate(),
          trigger: "time-hour"
        });
      }
      function onConfirmClick(_ref4) {
        var _props$onConfirm;
        var e = _ref4.e;
        onChange === null || onChange === void 0 || onChange(formatDate(cacheValue.value, {
          format: formatRef.value.format
        }), {
          dayjsValue: parseToDayjs(cacheValue.value, formatRef.value.format),
          trigger: "confirm"
        });
        (_props$onConfirm = props.onConfirm) === null || _props$onConfirm === void 0 || _props$onConfirm.call(props, {
          date: dayjs_min(cacheValue.value).toDate(),
          e: e
        });
        emit("confirm", {
          date: dayjs_min(cacheValue.value).toDate(),
          e: e
        });
      }
      function onPresetClick(presetValue, context) {
        var _props$onPresetClick;
        var presetVal = typeof presetValue === "function" ? presetValue() : presetValue;
        onChange === null || onChange === void 0 || onChange(formatDate(presetVal, {
          format: formatRef.value.format
        }), {
          dayjsValue: parseToDayjs(presetVal, formatRef.value.format),
          trigger: "preset"
        });
        (_props$onPresetClick = props.onPresetClick) === null || _props$onPresetClick === void 0 || _props$onPresetClick.call(props, context);
        emit("preset-click", context);
      }
      function onYearChange(nextYear) {
        var _props$onYearChange2;
        year.value = nextYear;
        (_props$onYearChange2 = props.onYearChange) === null || _props$onYearChange2 === void 0 || _props$onYearChange2.call(props, {
          year: year.value,
          date: parseToDayjs(value.value, formatRef.value.format).toDate(),
          trigger: "year-select"
        });
        emit("year-change", {
          year: year.value,
          date: parseToDayjs(value.value, formatRef.value.format).toDate(),
          trigger: "year-select"
        });
      }
      function onMonthChange(nextMonth) {
        var _props$onMonthChange2;
        month.value = nextMonth;
        (_props$onMonthChange2 = props.onMonthChange) === null || _props$onMonthChange2 === void 0 || _props$onMonthChange2.call(props, {
          month: month.value,
          date: parseToDayjs(value.value, formatRef.value.format).toDate(),
          trigger: "month-select"
        });
        emit("month-change", {
          month: month.value,
          date: parseToDayjs(value.value, formatRef.value.format).toDate(),
          trigger: "month-select"
        });
      }
      function onPanelClick(context) {
        var _props$onPanelClick;
        (_props$onPanelClick = props.onPanelClick) === null || _props$onPanelClick === void 0 || _props$onPanelClick.call(props, context);
        emit("panel-click", context);
      }
      var panelProps = VueCompositionAPI.computed(function () {
        var _attrs$popupVisible;
        return {
          value: cacheValue.value,
          year: year.value,
          month: month.value,
          mode: props.mode,
          format: formatRef.value.format,
          presets: props.presets,
          time: time.value,
          disableDate: props.disableDate,
          firstDayOfWeek: props.firstDayOfWeek,
          timePickerProps: props.timePickerProps,
          enableTimePicker: props.enableTimePicker,
          presetsPlacement: props.presetsPlacement,
          popupVisible: (_attrs$popupVisible = attrs === null || attrs === void 0 ? void 0 : attrs.popupVisible) !== null && _attrs$popupVisible !== void 0 ? _attrs$popupVisible : true,
          onPanelClick: onPanelClick,
          onCellClick: onCellClick,
          onJumperClick: onJumperClick,
          onConfirmClick: onConfirmClick,
          onPresetClick: onPresetClick,
          onYearChange: onYearChange,
          onMonthChange: onMonthChange,
          onTimePickerChange: onTimePickerChange
        };
      });
      return {
        panelProps: panelProps
      };
    },
    render: function render() {
      var h = arguments[0];
      var panelProps = this.panelProps;
      return h(TSinglePanel, {
        "props": _objectSpread$1r({}, panelProps)
      });
    }
  });

  var dateRangePickerProps = {
    allowInput: Boolean,
    borderless: Boolean,
    clearable: Boolean,
    defaultTime: {
      type: Array,
      "default": function _default() {
        return ["00:00:00", "23:59:59"];
      }
    },
    disableDate: {
      type: [Object, Array, Function]
    },
    disableTime: {
      type: Function
    },
    disabled: Boolean,
    readonly: {
      type: Boolean,
      "default": void 0
    },
    enableTimePicker: Boolean,
    firstDayOfWeek: {
      type: Number,
      validator: function validator(val) {
        if (!val) return true;
        return [1, 2, 3, 4, 5, 6, 7].includes(val);
      }
    },
    format: {
      type: String,
      "default": ""
    },
    label: {
      type: [String, Function]
    },
    mode: {
      type: String,
      "default": "date",
      validator: function validator(val) {
        if (!val) return true;
        return ["year", "quarter", "month", "week", "date"].includes(val);
      }
    },
    panelPreselection: {
      type: Boolean,
      "default": true
    },
    placeholder: {
      type: [String, Array]
    },
    popupProps: {
      type: Object
    },
    prefixIcon: {
      type: Function
    },
    presets: {
      type: Object
    },
    presetsPlacement: {
      type: String,
      "default": "bottom",
      validator: function validator(val) {
        if (!val) return true;
        return ["left", "top", "right", "bottom"].includes(val);
      }
    },
    rangeInputProps: {
      type: Object
    },
    separator: {
      type: String,
      "default": ""
    },
    size: {
      type: String,
      "default": "medium",
      validator: function validator(val) {
        if (!val) return true;
        return ["small", "medium", "large"].includes(val);
      }
    },
    status: {
      type: String,
      "default": "default",
      validator: function validator(val) {
        if (!val) return true;
        return ["default", "success", "warning", "error"].includes(val);
      }
    },
    suffixIcon: {
      type: Function
    },
    timePickerProps: {
      type: Object
    },
    tips: {
      type: [String, Function]
    },
    value: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    defaultValue: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    valueType: {
      type: String,
      validator: function validator(val) {
        if (!val) return true;
        return ["time-stamp", "Date", "YYYY", "YYYY-MM", "YYYY-MM-DD", "YYYY-MM-DD HH", "YYYY-MM-DD HH:mm", "YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD HH:mm:ss:SSS"].includes(val);
      }
    },
    cancelRangeSelectLimit: {
      type: Boolean,
      "default": false
    },
    onBlur: Function,
    onChange: Function,
    onConfirm: Function,
    onFocus: Function,
    onInput: Function,
    onPick: Function,
    onPresetClick: Function
  };

  var props$D = {
    activeIndex: {
      type: Number
    },
    borderless: Boolean,
    clearable: Boolean,
    disabled: {
      type: Boolean,
      "default": void 0
    },
    format: {
      type: [Array, Function]
    },
    inputProps: {
      type: [Object, Array]
    },
    label: {
      type: [String, Function]
    },
    placeholder: {
      type: [String, Array]
    },
    prefixIcon: {
      type: Function
    },
    readonly: Boolean,
    separator: {
      type: [String, Function],
      "default": "-"
    },
    showClearIconOnEmpty: Boolean,
    size: {
      type: String,
      "default": "medium",
      validator: function validator(val) {
        if (!val) return true;
        return ["small", "medium", "large"].includes(val);
      }
    },
    status: {
      type: String,
      "default": "default",
      validator: function validator(val) {
        if (!val) return true;
        return ["default", "success", "warning", "error"].includes(val);
      }
    },
    suffix: {
      type: [String, Function]
    },
    suffixIcon: {
      type: Function
    },
    tips: {
      type: [String, Function]
    },
    value: {
      type: Array,
      "default": void 0
    },
    defaultValue: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    onBlur: Function,
    onChange: Function,
    onClear: Function,
    onClick: Function,
    onEnter: Function,
    onFocus: Function,
    onMouseenter: Function,
    onMouseleave: Function
  };

  function ownKeys$1r(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1q(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1r(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1r(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function calcArrayValue(value) {
    if (Array.isArray(value)) {
      return value;
    }
    return [value, value];
  }
  var _RangeInput = VueCompositionAPI.defineComponent({
    name: "TRangeInput",
    props: props$D,
    setup: function setup(props2) {
      var instance = VueCompositionAPI.getCurrentInstance();
      var _toRefs = VueCompositionAPI.toRefs(props2),
        value = _toRefs.value;
      var _useCommonClassName = useCommonClassName$1(),
        STATUS = _useCommonClassName.STATUS,
        SIZE = _useCommonClassName.SIZE;
      var classPrefix = usePrefixClass();
      var _useGlobalIcon = useGlobalIcon({
          CloseCircleFilledIcon: TdCloseCircleFilledIcon
        }),
        CloseCircleFilledIcon = _useGlobalIcon.CloseCircleFilledIcon;
      var COMPONENT_NAME = usePrefixClass("range-input");
      var renderTNodeJSX = useTNodeJSX();
      var focused = VueCompositionAPI.ref(false);
      var isHover = VueCompositionAPI.ref(false);
      var calcFormat = VueCompositionAPI.computed(function () {
        return calcArrayValue(props2.format);
      });
      var calcInputProps = VueCompositionAPI.computed(function () {
        return calcArrayValue(props2.inputProps);
      });
      var calcPlaceholder = VueCompositionAPI.computed(function () {
        return calcArrayValue(props2.placeholder);
      });
      var _useVModel = useVModel$1(value, props2.defaultValue, props2.onChange, "change"),
        _useVModel2 = _slicedToArray(_useVModel, 2),
        innerValue = _useVModel2[0],
        setInnerValue = _useVModel2[1];
      var isShowClearIcon = VueCompositionAPI.computed(function () {
        var _props2$value;
        return (props2.clearable && ((_props2$value = props2.value) === null || _props2$value === void 0 ? void 0 : _props2$value.length) && !props2.disabled || props2.showClearIconOnEmpty) && isHover.value;
      });
      var inputRefs = {
        firstInputRef: VueCompositionAPI.ref(),
        secondInputRef: VueCompositionAPI.ref()
      };
      function handleClear(context) {
        var _props2$onClear;
        (_props2$onClear = props2.onClear) === null || _props2$onClear === void 0 || _props2$onClear.call(props2, context);
      }
      function handleEnter(rangeValue, context) {
        var _props2$onEnter;
        (_props2$onEnter = props2.onEnter) === null || _props2$onEnter === void 0 || _props2$onEnter.call(props2, rangeValue, context);
        instance.emit("enter", rangeValue, context);
      }
      function handleFocus(rangeValue, context) {
        var _props2$onFocus;
        focused.value = true;
        (_props2$onFocus = props2.onFocus) === null || _props2$onFocus === void 0 || _props2$onFocus.call(props2, rangeValue, context);
        instance.emit("focus", rangeValue, context);
      }
      function handleBlur(rangeValue, context) {
        var _props2$onBlur;
        focused.value = false;
        (_props2$onBlur = props2.onBlur) === null || _props2$onBlur === void 0 || _props2$onBlur.call(props2, rangeValue, context);
        instance.emit("blur", rangeValue, context);
      }
      function handleMouseEnter(e) {
        var _props2$onMouseenter;
        isHover.value = true;
        props2 === null || props2 === void 0 || (_props2$onMouseenter = props2.onMouseenter) === null || _props2$onMouseenter === void 0 || _props2$onMouseenter.call(props2, {
          e: e
        });
        instance.emit("monseenter", {
          e: e
        });
      }
      function handleMouseLeave(e) {
        var _props2$onMouseleave;
        isHover.value = false;
        props2 === null || props2 === void 0 || (_props2$onMouseleave = props2.onMouseleave) === null || _props2$onMouseleave === void 0 || _props2$onMouseleave.call(props2, {
          e: e
        });
        instance.emit("monseleave", {
          e: e
        });
      }
      var exposeObj = {
        firstInputElement: inputRefs.firstInputRef.value,
        secondInputElement: inputRefs.secondInputRef.value,
        focus: function focus(options) {
          var _inputRefs$value;
          var _ref = options || {},
            _ref$position = _ref.position,
            position = _ref$position === void 0 ? "first" : _ref$position;
          (_inputRefs$value = inputRefs["".concat(position, "InputRef")].value) === null || _inputRefs$value === void 0 || _inputRefs$value.focus();
        },
        blur: function blur(options) {
          var _inputRefs$value2;
          var _ref2 = options || {},
            _ref2$position = _ref2.position,
            position = _ref2$position === void 0 ? "first" : _ref2$position;
          (_inputRefs$value2 = inputRefs["".concat(position, "InputRef")].value) === null || _inputRefs$value2 === void 0 || _inputRefs$value2.blur();
        },
        select: function select(options) {
          var _inputRefs$value3;
          var _ref3 = options || {},
            _ref3$position = _ref3.position,
            position = _ref3$position === void 0 ? "first" : _ref3$position;
          (_inputRefs$value3 = inputRefs["".concat(position, "InputRef")].value) === null || _inputRefs$value3 === void 0 || _inputRefs$value3.select();
        }
      };
      return _objectSpread$1q(_objectSpread$1q({}, exposeObj), {}, {
        COMPONENT_NAME: COMPONENT_NAME,
        SIZE: SIZE,
        STATUS: STATUS,
        focused: focused,
        classPrefix: classPrefix,
        inputRefs: inputRefs,
        calcInputProps: calcInputProps,
        calcFormat: calcFormat,
        calcPlaceholder: calcPlaceholder,
        innerValue: innerValue,
        isShowClearIcon: isShowClearIcon,
        handleMouseEnter: handleMouseEnter,
        handleMouseLeave: handleMouseLeave,
        handleEnter: handleEnter,
        handleFocus: handleFocus,
        handleBlur: handleBlur,
        setInnerValue: setInnerValue,
        renderTNodeJSX: renderTNodeJSX,
        handleClear: handleClear,
        CloseCircleFilledIcon: CloseCircleFilledIcon
      });
    },
    render: function render() {
      var _this = this;
      var h = arguments[0];
      var COMPONENT_NAME = this.COMPONENT_NAME,
        SIZE = this.SIZE,
        STATUS = this.STATUS,
        focused = this.focused,
        handleMouseEnter = this.handleMouseEnter,
        handleMouseLeave = this.handleMouseLeave,
        handleEnter = this.handleEnter,
        handleFocus = this.handleFocus,
        handleBlur = this.handleBlur,
        setInnerValue = this.setInnerValue,
        renderTNodeJSX = this.renderTNodeJSX,
        handleClear = this.handleClear,
        classPrefix = this.classPrefix,
        inputRefs = this.inputRefs,
        calcInputProps = this.calcInputProps,
        calcFormat = this.calcFormat,
        calcPlaceholder = this.calcPlaceholder,
        innerValue = this.innerValue,
        isShowClearIcon = this.isShowClearIcon,
        CloseCircleFilledIcon = this.CloseCircleFilledIcon;
      var labelContent = renderTNodeJSX("label");
      var prefixIconContent = renderTNodeJSX("prefixIcon");
      var suffixContent = renderTNodeJSX("suffix");
      var suffixIconContent = renderTNodeJSX("suffixIcon");
      var tips = renderTNodeJSX("tips");
      return h("div", {
        "class": [COMPONENT_NAME, _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({}, SIZE[this.size], this.size !== "medium"), STATUS.disabled, this.disabled), STATUS.focused, focused), STATUS.success, this.status === "success"), STATUS.warning, this.status === "warning"), STATUS.error, this.status === "error"), "".concat(COMPONENT_NAME, "--prefix"), prefixIconContent || labelContent), "".concat(COMPONENT_NAME, "--suffix"), suffixIconContent || suffixContent), "".concat(COMPONENT_NAME, "--borderless"), this.borderless)],
        "on": {
          "mouseenter": handleMouseEnter,
          "mouseleave": handleMouseLeave
        }
      }, [h("div", {
        "class": "".concat(COMPONENT_NAME, "__inner")
      }, [prefixIconContent, labelContent ? h("div", {
        "class": "".concat(classPrefix, "-input__prefix")
      }, [labelContent]) : null, h(Input, {
        "ref": inputRefs.firstInputRef,
        "class": "".concat(COMPONENT_NAME, "__inner-left"),
        "attrs": {
          "inputClass": _defineProperty$2({}, "".concat(classPrefix, "-is-focused"), this.activeIndex === 0),
          "placeholder": calcPlaceholder[0],
          "disabled": this.disabled,
          "readonly": this.readonly,
          "format": calcFormat[0],
          "value": innerValue === null || innerValue === void 0 ? void 0 : innerValue[0]
        },
        "on": {
          "click": function click(_ref6) {
            var _this$onClick;
            var e = _ref6.e;
            return (_this$onClick = _this.onClick) === null || _this$onClick === void 0 ? void 0 : _this$onClick.call(_this, {
              e: e,
              position: "first"
            });
          },
          "clear": function clear() {
            return setInnerValue([], {
              position: "first",
              trigger: "input"
            });
          },
          "enter": function enter(val, _ref7) {
            var e = _ref7.e;
            return handleEnter([val, innerValue === null || innerValue === void 0 ? void 0 : innerValue[1]], {
              e: e,
              position: "first"
            });
          },
          "focus": function focus(val, _ref8) {
            var e = _ref8.e;
            return handleFocus([val, innerValue === null || innerValue === void 0 ? void 0 : innerValue[1]], {
              e: e,
              position: "first"
            });
          },
          "blur": function blur(val, _ref9) {
            var e = _ref9.e;
            return handleBlur([val, innerValue === null || innerValue === void 0 ? void 0 : innerValue[1]], {
              e: e,
              position: "first"
            });
          },
          "change": function change(val, _ref10) {
            var e = _ref10.e;
            return setInnerValue([val, innerValue === null || innerValue === void 0 ? void 0 : innerValue[1]], {
              e: e,
              position: "first",
              trigger: "input"
            });
          }
        },
        "props": _objectSpread$1q({}, calcInputProps[0])
      }), h("div", {
        "class": "".concat(COMPONENT_NAME, "__inner-separator")
      }, [this.separator]), h(Input, {
        "ref": inputRefs.secondInputRef,
        "class": "".concat(COMPONENT_NAME, "__inner-right"),
        "attrs": {
          "inputClass": _defineProperty$2({}, "".concat(classPrefix, "-is-focused"), this.activeIndex === 1),
          "placeholder": calcPlaceholder[1],
          "disabled": this.disabled,
          "readonly": this.readonly,
          "format": calcFormat[1],
          "value": innerValue === null || innerValue === void 0 ? void 0 : innerValue[1]
        },
        "on": {
          "click": function click(_ref12) {
            var _this$onClick2;
            var e = _ref12.e;
            return (_this$onClick2 = _this.onClick) === null || _this$onClick2 === void 0 ? void 0 : _this$onClick2.call(_this, {
              e: e,
              position: "second"
            });
          },
          "clear": function clear() {
            return setInnerValue([], {
              position: "second",
              trigger: "input"
            });
          },
          "enter": function enter(val, _ref13) {
            var e = _ref13.e;
            return handleEnter([innerValue === null || innerValue === void 0 ? void 0 : innerValue[0], val], {
              e: e,
              position: "second"
            });
          },
          "focus": function focus(val, _ref14) {
            var e = _ref14.e;
            return handleFocus([innerValue === null || innerValue === void 0 ? void 0 : innerValue[0], val], {
              e: e,
              position: "second"
            });
          },
          "blur": function blur(val, _ref15) {
            var e = _ref15.e;
            return handleBlur([innerValue === null || innerValue === void 0 ? void 0 : innerValue[0], val], {
              e: e,
              position: "second"
            });
          },
          "change": function change(val, _ref16) {
            var e = _ref16.e;
            return setInnerValue([innerValue === null || innerValue === void 0 ? void 0 : innerValue[0], val], {
              e: e,
              position: "second",
              trigger: "input"
            });
          }
        },
        "props": _objectSpread$1q({}, calcInputProps[1])
      }), suffixContent ? h("div", {
        "class": "".concat(COMPONENT_NAME, "__suffix")
      }, [suffixContent]) : null, suffixIconContent && h("span", {
        "class": "".concat(COMPONENT_NAME, "__suffix ").concat(COMPONENT_NAME, "__suffix-icon")
      }, [isShowClearIcon ? h(CloseCircleFilledIcon, {
        "class": "".concat(COMPONENT_NAME, "__suffix-clear"),
        "on": {
          "click": handleClear
        }
      }) : suffixIconContent])]), tips && h("div", {
        "class": "".concat(COMPONENT_NAME, "__tips")
      }, [tips])]);
    }
  });

  var props$C = {
    autoWidth: Boolean,
    disabled: Boolean,
    inputValue: {
      type: Array,
      "default": void 0
    },
    defaultInputValue: {
      type: Array
    },
    label: {
      type: [String, Function]
    },
    panel: {
      type: [String, Function]
    },
    popupProps: {
      type: Object
    },
    popupVisible: Boolean,
    rangeInputProps: {
      type: Object
    },
    readonly: Boolean,
    status: {
      type: String,
      "default": "default",
      validator: function validator(val) {
        if (!val) return true;
        return ["default", "success", "warning", "error"].includes(val);
      }
    },
    tips: {
      type: [String, Function]
    },
    onInputChange: Function,
    onPopupVisibleChange: Function
  };

  function ownKeys$1q(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1p(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1q(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1q(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _RangeInputPopup = VueCompositionAPI.defineComponent({
    name: "TRangeInputPopup",
    props: props$C,
    setup: function setup(props2) {
      var COMPONENT_NAME = usePrefixClass("range-input-popup");
      var _useOverlayInnerStyle = useOverlayInnerStyle(props2),
        tOverlayInnerStyle = _useOverlayInnerStyle.tOverlayInnerStyle,
        innerPopupVisible = _useOverlayInnerStyle.innerPopupVisible,
        onInnerPopupVisibleChange = _useOverlayInnerStyle.onInnerPopupVisibleChange;
      var popupClasses = VueCompositionAPI.computed(function () {
        return [COMPONENT_NAME.value, _defineProperty$2({}, "".concat(COMPONENT_NAME.value, "--visible"), props2.popupVisible || innerPopupVisible.value)];
      });
      return {
        COMPONENT_NAME: COMPONENT_NAME,
        tOverlayInnerStyle: tOverlayInnerStyle,
        innerPopupVisible: innerPopupVisible,
        onInnerPopupVisibleChange: onInnerPopupVisibleChange,
        popupClasses: popupClasses
      };
    },
    render: function render() {
      var h = arguments[0];
      var tOverlayInnerStyle = this.tOverlayInnerStyle,
        innerPopupVisible = this.innerPopupVisible,
        onInnerPopupVisibleChange = this.onInnerPopupVisibleChange,
        popupClasses = this.popupClasses;
      return h("div", {
        "class": popupClasses
      }, [h(Popup, {
        "attrs": {
          "hideEmptyPopup": true,
          "content": this.panel,
          "trigger": "click",
          "placement": "bottom-left",
          "visible": this.popupVisible || innerPopupVisible
        },
        "props": _objectSpread$1p({}, _objectSpread$1p({
          disabled: this.disabled || this.readonly,
          overlayInnerStyle: tOverlayInnerStyle,
          onVisibleChange: onInnerPopupVisibleChange
        }, this.popupProps))
      }, [h(_RangeInput, {
        "props": _objectSpread$1p({}, _objectSpread$1p({
          value: this.inputValue,
          onChange: this.onInputChange,
          disabled: this.disabled,
          label: this.label,
          status: this.status,
          tips: this.tips
        }, this.rangeInputProps))
      })])]);
    }
  });

  var RangeInput = withInstall$1(_RangeInput);
  var RangeInputPopup = withInstall$1(_RangeInputPopup);

  function ownKeys$1p(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1o(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1p(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1p(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var TRangePanel = VueCompositionAPI.defineComponent({
    name: "TRangePanel",
    props: {
      hoverValue: Array,
      activeIndex: Number,
      isFirstValueSelected: Boolean,
      disableDate: [Object, Array, Function],
      disableTime: Function,
      mode: {
        type: String,
        "default": "date"
      },
      format: String,
      presetsPlacement: {
        type: String,
        "default": "bottom"
      },
      value: Array,
      timePickerProps: Object,
      presets: Object,
      enableTimePicker: Boolean,
      firstDayOfWeek: Number,
      panelPreselection: Boolean,
      hidePreselection: {
        type: Boolean,
        defaultValue: true
      },
      popupVisible: Boolean,
      year: Array,
      month: Array,
      time: Array,
      cancelRangeSelectLimit: Boolean,
      onClick: Function,
      onCellClick: Function,
      onCellMouseEnter: Function,
      onCellMouseLeave: Function,
      onJumperClick: Function,
      onConfirmClick: Function,
      onPresetClick: Function,
      onYearChange: Function,
      onMonthChange: Function,
      onTimePickerChange: Function
    },
    setup: function setup(props) {
      var COMPONENT_NAME = usePrefixClass("date-range-picker__panel");
      var _useConfig = useConfig("datePicker"),
        global = _useConfig.global;
      var _getDefaultFormat = getDefaultFormat({
          mode: props.mode,
          format: props.format,
          enableTimePicker: props.enableTimePicker
        }),
        format = _getDefaultFormat.format;
      var hidePreselection = !props.panelPreselection && props.value.length === 2;
      var disableDateOptions = VueCompositionAPI.computed(function () {
        return useDisableDate({
          format: format,
          mode: props.mode,
          disableDate: props.disableDate,
          start: props.isFirstValueSelected && props.activeIndex === 1 ? new Date(parseToDayjs(props.value[0], format, "start").toDate().setHours(0, 0, 0)) : void 0,
          end: props.isFirstValueSelected && props.activeIndex === 0 ? new Date(parseToDayjs(props.value[1], format).toDate().setHours(23, 59, 59)) : void 0
        });
      });
      var disableTime = function disableTime(h, m, s, context) {
        if (!isFunction(props.disableTime)) {
          return {};
        }
        var _ref = props.value || [],
          _ref2 = _slicedToArray(_ref, 2),
          startTime = _ref2[0],
          endTime = _ref2[1];
        if (context.partial) {
          return props.disableTime([parseToDateTime(startTime, format, [h, m, s]), parseToDateTime(endTime, format)], context);
        }
        return props.disableTime([parseToDateTime(startTime, format), parseToDateTime(endTime, format, [h, m, s])], context);
      };
      var startTableData = VueCompositionAPI.computed(function () {
        return useTableData(_objectSpread$1o(_objectSpread$1o({
          isRange: true,
          start: props.value[0] ? parseToDayjs(props.value[0], format).toDate() : void 0,
          end: props.value[1] ? parseToDayjs(props.value[1], format).toDate() : void 0,
          hoverStart: !hidePreselection && props.hoverValue[0] ? parseToDayjs(props.hoverValue[0], format).toDate() : void 0,
          hoverEnd: !hidePreselection && props.hoverValue[1] ? parseToDayjs(props.hoverValue[1], format).toDate() : void 0,
          year: props.year[0],
          month: props.month[0],
          mode: props.mode,
          firstDayOfWeek: props.firstDayOfWeek || global.value.firstDayOfWeek
        }, disableDateOptions.value), {}, {
          cancelRangeSelectLimit: props.cancelRangeSelectLimit
        }));
      });
      var endTableData = VueCompositionAPI.computed(function () {
        return useTableData(_objectSpread$1o(_objectSpread$1o({
          isRange: true,
          start: props.value[0] ? parseToDayjs(props.value[0], format).toDate() : void 0,
          end: props.value[1] ? parseToDayjs(props.value[1], format).toDate() : void 0,
          hoverStart: !hidePreselection && props.hoverValue[0] ? parseToDayjs(props.hoverValue[0], format).toDate() : void 0,
          hoverEnd: !hidePreselection && props.hoverValue[1] ? parseToDayjs(props.hoverValue[1], format).toDate() : void 0,
          year: props.year[1],
          month: props.month[1],
          mode: props.mode,
          firstDayOfWeek: props.firstDayOfWeek || global.value.firstDayOfWeek
        }, disableDateOptions.value), {}, {
          cancelRangeSelectLimit: props.cancelRangeSelectLimit
        }));
      });
      var panelContentProps = VueCompositionAPI.computed(function () {
        return {
          format: format,
          mode: props.mode,
          firstDayOfWeek: props.firstDayOfWeek || global.value.firstDayOfWeek,
          popupVisible: props.popupVisible,
          enableTimePicker: props.enableTimePicker,
          timePickerProps: _objectSpread$1o({
            disableTime: disableTime
          }, props.timePickerProps),
          onMonthChange: props.onMonthChange,
          onYearChange: props.onYearChange,
          onJumperClick: props.onJumperClick,
          onCellClick: props.onCellClick,
          onCellMouseEnter: props.onCellMouseEnter,
          onCellMouseLeave: props.onCellMouseLeave,
          onTimePickerChange: props.onTimePickerChange
        };
      });
      return {
        COMPONENT_NAME: COMPONENT_NAME,
        startTableData: startTableData,
        endTableData: endTableData,
        panelContentProps: panelContentProps
      };
    },
    render: function render() {
      var _this = this;
      var h = arguments[0];
      var COMPONENT_NAME = this.COMPONENT_NAME,
        startTableData = this.startTableData,
        endTableData = this.endTableData,
        panelContentProps = this.panelContentProps;
      return h("div", {
        "class": [COMPONENT_NAME, _defineProperty$2({}, "".concat(COMPONENT_NAME, "--direction-row"), ["left", "right"].includes(this.presetsPlacement))],
        "on": {
          "click": function click(e) {
            var _this$onClick;
            return (_this$onClick = _this.onClick) === null || _this$onClick === void 0 ? void 0 : _this$onClick.call(_this, {
              e: e
            });
          }
        }
      }, [["top", "left"].includes(this.presetsPlacement) ? h(TExtraContent, {
        "props": _objectSpread$1o({}, {
          presets: this.presets,
          selectedValue: this.value[this.activeIndex],
          enableTimePicker: this.enableTimePicker,
          onPresetClick: this.onPresetClick,
          onConfirmClick: this.onConfirmClick,
          presetsPlacement: this.presetsPlacement
        })
      }) : null, h("div", {
        "class": "".concat(COMPONENT_NAME, "-content-wrapper")
      }, [!this.enableTimePicker ? [h(TPanelContent, {
        "key": "startPanel",
        "props": _objectSpread$1o({}, _objectSpread$1o({
          partial: "start",
          year: this.year[0],
          month: this.month[0],
          time: this.time[0],
          value: this.value,
          tableData: startTableData
        }, panelContentProps))
      }), h(TPanelContent, {
        "key": "endPanel",
        "props": _objectSpread$1o({}, _objectSpread$1o({
          partial: "end",
          year: this.year[1],
          month: this.month[1],
          time: this.time[1],
          value: this.value,
          tableData: endTableData
        }, panelContentProps))
      })] : h(TPanelContent, {
        "key": "start",
        "props": _objectSpread$1o({}, _objectSpread$1o({
          partial: this.activeIndex ? "end" : "start",
          year: this.activeIndex ? this.year[1] : this.year[0],
          month: this.activeIndex ? this.month[1] : this.month[0],
          time: this.activeIndex ? this.time[1] : this.time[0],
          value: this.value,
          tableData: this.activeIndex ? endTableData : startTableData
        }, panelContentProps))
      })]), ["bottom", "right"].includes(this.presetsPlacement) ? h(TExtraContent, {
        "props": _objectSpread$1o({}, {
          presets: this.presets,
          selectedValue: this.value[this.activeIndex],
          enableTimePicker: this.enableTimePicker,
          onPresetClick: this.onPresetClick,
          onConfirmClick: this.onConfirmClick,
          presetsPlacement: this.presetsPlacement
        })
      }) : null]);
    }
  });

  function useRangeValue(props) {
    var _toRefs = VueCompositionAPI.toRefs(props),
      valueFromProps = _toRefs.value;
    var _useVModel = useVModel$1(valueFromProps, props.defaultValue, props.onChange, "change"),
      _useVModel2 = _slicedToArray(_useVModel, 2),
      value = _useVModel2[0],
      onChange = _useVModel2[1];
    var formatRef = VueCompositionAPI.computed(function () {
      return getDefaultFormat({
        mode: props.mode,
        format: props.format,
        enableTimePicker: props.enableTimePicker
      });
    });
    if (props.enableTimePicker) {
      if (!extractTimeFormat(formatRef.value.format)) console.error("format: ".concat(formatRef.value.format, " \u4E0D\u89C4\u8303\uFF0C\u5305\u542B\u65F6\u95F4\u9009\u62E9\u5FC5\u987B\u8981\u6709\u65F6\u95F4\u683C\u5F0F\u5316 HH:mm:ss"));
    }
    if (!Array.isArray(value.value)) {
      console.error("typeof value: ".concat(value.value, " must be Array!"));
    } else if (!isValidDate(value.value, formatRef.value.format)) {
      console.error("value: ".concat(value.value, " is invalid dateTime! Check whether the value is consistent with format: ").concat(formatRef.value.format));
    }
    var isFirstValueSelected = VueCompositionAPI.ref(false);
    var time = VueCompositionAPI.ref(initYearMonthTime({
      value: value.value,
      mode: props.mode,
      format: formatRef.value.format,
      timeFormat: formatRef.value.timeFormat
    }).time);
    var month = VueCompositionAPI.ref(initYearMonthTime({
      value: value.value,
      mode: props.mode,
      format: formatRef.value.format,
      enableTimePicker: props.enableTimePicker
    }).month);
    var year = VueCompositionAPI.ref(initYearMonthTime({
      value: value.value,
      mode: props.mode,
      format: formatRef.value.format
    }).year);
    var cacheValue = VueCompositionAPI.ref(formatDate(value.value, {
      format: formatRef.value.format
    }));
    VueCompositionAPI.watchEffect(function () {
      if (!value.value) {
        cacheValue.value = [];
        return;
      }
      if (!isValidDate(value.value, formatRef.value.format)) return;
      cacheValue.value = formatDate(value.value, {
        format: formatRef.value.format
      });
      time.value = formatTime(value.value, formatRef.value.format, formatRef.value.timeFormat, props.defaultTime);
    });
    return {
      year: year,
      month: month,
      value: value,
      time: time,
      isFirstValueSelected: isFirstValueSelected,
      cacheValue: cacheValue,
      onChange: onChange
    };
  }

  function ownKeys$1o(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1n(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1o(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1o(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var PARTIAL_MAP = {
    first: "start",
    second: "end"
  };
  function useRange(props, _ref) {
    var emit = _ref.emit;
    var COMPONENT_NAME = usePrefixClass("date-range-picker");
    var _useConfig = useConfig("datePicker"),
      global = _useConfig.global;
    var isMountedRef = VueCompositionAPI.ref(false);
    var inputRef = VueCompositionAPI.ref();
    var _useRangeValue = useRangeValue(props),
      value = _useRangeValue.value,
      onChange = _useRangeValue.onChange,
      time = _useRangeValue.time,
      month = _useRangeValue.month,
      year = _useRangeValue.year,
      cacheValue = _useRangeValue.cacheValue,
      isFirstValueSelected = _useRangeValue.isFirstValueSelected;
    var formatRef = VueCompositionAPI.computed(function () {
      return getDefaultFormat({
        mode: props.mode,
        format: props.format,
        valueType: props.valueType,
        enableTimePicker: props.enableTimePicker
      });
    });
    var popupVisible = VueCompositionAPI.ref(false);
    var isHoverCell = VueCompositionAPI.ref(false);
    var activeIndex = VueCompositionAPI.ref(0);
    var inputValue = VueCompositionAPI.ref(formatDate(value.value, {
      format: formatRef.value.format
    }));
    var rangeInputProps = VueCompositionAPI.computed(function () {
      return _objectSpread$1n(_objectSpread$1n({}, props.rangeInputProps), {}, {
        ref: inputRef,
        borderless: props.borderless,
        size: props.size,
        clearable: props.clearable,
        prefixIcon: props.prefixIcon,
        readonly: !props.allowInput || props.readonly,
        separator: props.separator || global.value.rangeSeparator,
        placeholder: props.placeholder || global.value.placeholder[props.mode],
        activeIndex: popupVisible.value ? activeIndex.value : void 0,
        "class": _defineProperty$2({}, "".concat(COMPONENT_NAME.value, "__input--placeholder"), isHoverCell.value),
        onClick: function onClick(_ref2) {
          var position = _ref2.position;
          activeIndex.value = position === "first" ? 0 : 1;
        },
        onClear: function onClear(_ref3) {
          var e = _ref3.e;
          e.stopPropagation();
          popupVisible.value = false;
          onChange === null || onChange === void 0 || onChange([], {
            dayjsValue: [],
            trigger: "clear"
          });
          emit("clear", [], {
            dayjsValue: [],
            trigger: "clear"
          });
        },
        onBlur: function onBlur(newVal, _ref4) {
          var _props$onBlur;
          var e = _ref4.e,
            position = _ref4.position;
          (_props$onBlur = props.onBlur) === null || _props$onBlur === void 0 || _props$onBlur.call(props, {
            value: newVal,
            partial: PARTIAL_MAP[position],
            e: e
          });
          emit("blur", {
            value: newVal,
            partial: PARTIAL_MAP[position],
            e: e
          });
        },
        onFocus: function onFocus(newVal, _ref5) {
          var _props$onFocus;
          var e = _ref5.e,
            position = _ref5.position;
          (_props$onFocus = props.onFocus) === null || _props$onFocus === void 0 || _props$onFocus.call(props, {
            value: newVal,
            partial: PARTIAL_MAP[position],
            e: e
          });
          emit("focus", {
            value: newVal,
            partial: PARTIAL_MAP[position],
            e: e
          });
          activeIndex.value = position === "first" ? 0 : 1;
        },
        onChange: function onChange(newVal) {
          inputValue.value = newVal;
          if (!isValidDate(newVal, formatRef.value.format)) return;
          cacheValue.value = newVal;
          var newYear = [];
          var newMonth = [];
          var newTime = [];
          newVal.forEach(function (v) {
            newYear.push(parseToDayjs(v, formatRef.value.format).year());
            newMonth.push(parseToDayjs(v, formatRef.value.format).month());
            newTime.push(parseToDayjs(v, formatRef.value.format).format(formatRef.value.timeFormat));
          });
          year.value = newYear;
          month.value = newMonth;
          time.value = newTime;
        },
        onEnter: function onEnter(newVal) {
          if (!isValidDate(newVal, formatRef.value.format) && !isValidDate(value.value, formatRef.value.format)) return;
          popupVisible.value = false;
          if (isValidDate(newVal, formatRef.value.format)) {
            onChange === null || onChange === void 0 || onChange(formatDate(newVal, {
              format: formatRef.value.format,
              targetFormat: formatRef.value.valueType,
              autoSwap: true
            }), {
              dayjsValue: newVal.map(function (v) {
                return parseToDayjs(v, formatRef.value.format);
              }),
              trigger: "enter"
            });
          } else if (isValidDate(value.value, formatRef.value.format)) {
            inputValue.value = formatDate(value.value, {
              format: formatRef.value.format
            });
          } else {
            inputValue.value = [];
          }
        }
      });
    });
    var popupProps = VueCompositionAPI.computed(function () {
      var _props$popupProps$ove, _props$popupProps, _props$popupProps2;
      return _objectSpread$1n(_objectSpread$1n({
        expandAnimation: true
      }, props.popupProps), {}, {
        overlayInnerStyle: (_props$popupProps$ove = (_props$popupProps = props.popupProps) === null || _props$popupProps === void 0 ? void 0 : _props$popupProps.overlayInnerStyle) !== null && _props$popupProps$ove !== void 0 ? _props$popupProps$ove : {
          width: "auto"
        },
        overlayClassName: [(_props$popupProps2 = props.popupProps) === null || _props$popupProps2 === void 0 ? void 0 : _props$popupProps2.overlayClassName, "".concat(COMPONENT_NAME.value, "__panel-container")],
        onVisibleChange: function onVisibleChange(visible, context) {
          var _props$popupProps3, _props$popupProps3$on;
          (_props$popupProps3 = props.popupProps) === null || _props$popupProps3 === void 0 || (_props$popupProps3$on = _props$popupProps3.onVisibleChange) === null || _props$popupProps3$on === void 0 || _props$popupProps3$on.call(_props$popupProps3, visible, context);
          if (context.trigger === "trigger-element-click") {
            var _inputRef$value, _inputRef$value$focus;
            var indexMap = {
              0: "first",
              1: "second"
            };
            (_inputRef$value = inputRef.value) === null || _inputRef$value === void 0 || (_inputRef$value$focus = _inputRef$value.focus) === null || _inputRef$value$focus === void 0 || _inputRef$value$focus.call(_inputRef$value, {
              position: indexMap[activeIndex.value]
            });
            popupVisible.value = true;
            return;
          }
          popupVisible.value = visible;
        }
      });
    });
    VueCompositionAPI.watch(value, function (value2) {
      if (!value2) {
        inputValue.value = [];
        return;
      }
      if (!isValidDate(value2, formatRef.value.format)) return;
      inputValue.value = formatDate(value2, {
        format: formatRef.value.format
      });
    }, {
      immediate: true
    });
    VueCompositionAPI.watch(activeIndex, function (index) {
      var _inputRef$value2, _inputRef$value2$focu;
      if (!isMountedRef.value) {
        isMountedRef.value = true;
        return;
      }
      if (!popupVisible.value) return;
      var indexMap = {
        0: "first",
        1: "second"
      };
      (_inputRef$value2 = inputRef.value) === null || _inputRef$value2 === void 0 || (_inputRef$value2$focu = _inputRef$value2.focus) === null || _inputRef$value2$focu === void 0 || _inputRef$value2$focu.call(_inputRef$value2, {
        position: indexMap[index]
      });
    });
    return {
      year: year,
      month: month,
      value: value,
      time: time,
      inputValue: inputValue,
      popupVisible: popupVisible,
      rangeInputProps: rangeInputProps,
      popupProps: popupProps,
      isHoverCell: isHoverCell,
      activeIndex: activeIndex,
      isFirstValueSelected: isFirstValueSelected,
      cacheValue: cacheValue,
      onChange: onChange
    };
  }

  function ownKeys$1n(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1m(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1n(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1n(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _DateRangePicker = VueCompositionAPI.defineComponent({
    name: "TDateRangePicker",
    props: dateRangePickerProps,
    setup: function setup(props2, _ref) {
      var emit = _ref.emit;
      var COMPONENT_NAME = usePrefixClass("date-range-picker");
      var _useGlobalIcon = useGlobalIcon({
          CalendarIcon: TdCalendarIcon
        }),
        CalendarIcon = _useGlobalIcon.CalendarIcon;
      var _useFormDisabled = useFormDisabled(),
        formDisabled = _useFormDisabled.formDisabled;
      var _useRange = useRange(props2, {
          emit: emit
        }),
        inputValue = _useRange.inputValue,
        popupVisible = _useRange.popupVisible,
        dateRangePickerRangeInputProps = _useRange.rangeInputProps,
        dateRangePickerPopupProps = _useRange.popupProps,
        value = _useRange.value,
        year = _useRange.year,
        month = _useRange.month,
        time = _useRange.time,
        cacheValue = _useRange.cacheValue,
        activeIndex = _useRange.activeIndex,
        isHoverCell = _useRange.isHoverCell,
        isFirstValueSelected = _useRange.isFirstValueSelected,
        onChange = _useRange.onChange;
      var formatRef = VueCompositionAPI.computed(function () {
        return getDefaultFormat({
          mode: props2.mode,
          enableTimePicker: props2.enableTimePicker,
          format: props2.format,
          valueType: props2.valueType
        });
      });
      var isDisabled = VueCompositionAPI.computed(function () {
        return formDisabled.value || props2.disabled;
      });
      var isSelected = VueCompositionAPI.ref(false);
      VueCompositionAPI.watch(popupVisible, function (visible) {
        if (visible) {
          isSelected.value = false;
          cacheValue.value = formatDate(value.value || [], {
            format: formatRef.value.format
          });
          time.value = formatTime(value.value || [dayjs_min().format(formatRef.value.timeFormat), dayjs_min().format(formatRef.value.timeFormat)], formatRef.value.format, formatRef.value.timeFormat, props2.defaultTime);
          if (!value.value.length) {
            var _initYearMonthTime = initYearMonthTime({
                value: value.value,
                mode: props2.mode,
                format: formatRef.value.format,
                enableTimePicker: props2.enableTimePicker
              }),
              defaultYear = _initYearMonthTime.year,
              defaultMonth = _initYearMonthTime.month;
            year.value = defaultYear;
            month.value = defaultMonth;
          } else if (value.value.length === 2 && !props2.enableTimePicker) {
            var nextMonth = value.value.map(function (v) {
              return parseToDayjs(v, formatRef.value.format).month();
            });
            year.value = value.value.map(function (v) {
              return parseToDayjs(v, formatRef.value.format).year();
            });
            if (year.value[0] === year.value[1] && nextMonth[0] === nextMonth[1]) {
              nextMonth[0] === 11 ? nextMonth[0] -= 1 : nextMonth[1] += 1;
            }
            month.value = nextMonth;
            if ((props2.mode === "month" || props2.mode === "quarter") && year.value[0] === year.value[1]) {
              year.value = [year.value[0], year.value[0] + 1];
            }
          } else {
            year.value = value.value.map(function (v) {
              return parseToDayjs(v, formatRef.value.format).year();
            });
            if (year.value.length === 1) year.value = [year.value[0], year.value[0]];
            month.value = value.value.map(function (v) {
              return parseToDayjs(v, formatRef.value.format).month();
            });
            if (month.value.length === 1) month.value = [month.value[0], Math.min(month.value[0] + 1, 11)];
          }
        } else {
          activeIndex.value = 0;
          isHoverCell.value = false;
          isFirstValueSelected.value = false;
          inputValue.value = formatDate(value.value, {
            format: formatRef.value.format
          });
        }
      });
      function onCellMouseEnter(nextDate) {
        var date = nextDate;
        if (activeIndex.value && !props2.enableTimePicker) date.setHours(23, 59, 59);
        isHoverCell.value = true;
        var nextValue = _toConsumableArray(inputValue.value);
        nextValue[activeIndex.value] = formatDate(date, {
          format: formatRef.value.format
        });
        inputValue.value = nextValue;
      }
      function onCellMouseLeave() {
        isHoverCell.value = false;
        inputValue.value = cacheValue.value;
      }
      function onCellClick(nextDate, _ref2) {
        var _props2$onPick;
        var e = _ref2.e;
        var date = nextDate;
        if (activeIndex.value && !props2.enableTimePicker) date.setHours(23, 59, 59);
        (_props2$onPick = props2.onPick) === null || _props2$onPick === void 0 || _props2$onPick.call(props2, date, {
          e: e,
          partial: activeIndex.value ? "end" : "start"
        });
        emit("pick", date, {
          e: e,
          partial: activeIndex.value ? "end" : "start"
        });
        isHoverCell.value = false;
        isSelected.value = true;
        var nextValue = _toConsumableArray(inputValue.value);
        nextValue[activeIndex.value] = formatDate(date, {
          format: formatRef.value.format
        });
        cacheValue.value = nextValue;
        inputValue.value = nextValue;
        if (props2.enableTimePicker) return;
        var notValidIndex = nextValue.findIndex(function (v) {
          return !v || !isValidDate(v, formatRef.value.format);
        });
        if (notValidIndex === -1 && nextValue.length === 2) {
          if (!isFirstValueSelected.value && parseToDayjs(nextValue[0], formatRef.value.format).isAfter(parseToDayjs(nextValue[1], formatRef.value.format))) {
            nextValue[activeIndex.value ? 0 : 1] = "";
            cacheValue.value = nextValue;
            inputValue.value = nextValue;
          } else {
            onChange === null || onChange === void 0 || onChange(formatDate(nextValue, {
              format: formatRef.value.format,
              targetFormat: formatRef.value.valueType,
              autoSwap: true
            }), {
              dayjsValue: nextValue.map(function (v) {
                return parseToDayjs(v, formatRef.value.format);
              }),
              trigger: "pick"
            });
          }
        }
        if (!isFirstValueSelected.value) {
          var nextIndex = notValidIndex;
          if (nextIndex === -1) nextIndex = activeIndex.value ? 0 : 1;
          activeIndex.value = nextIndex;
          isFirstValueSelected.value = true;
        } else {
          popupVisible.value = false;
        }
      }
      function onJumperClick(_ref3) {
        var trigger = _ref3.trigger,
          partial = _ref3.partial;
        var partialIndex = partial === "start" ? 0 : 1;
        var monthCountMap = {
          date: 1,
          week: 1,
          month: 12,
          quarter: 12,
          year: 120
        };
        var monthCount = monthCountMap[props2.mode] || 0;
        var current = new Date(year.value[partialIndex], month.value[partialIndex]);
        var next = null;
        if (trigger === "prev") {
          next = subtractMonth(current, monthCount);
        } else if (trigger === "current") {
          next = new Date();
        } else if (trigger === "next") {
          next = addMonth(current, monthCount);
        }
        var nextYear = _toConsumableArray(year.value);
        nextYear[partialIndex] = next.getFullYear();
        var nextMonth = _toConsumableArray(month.value);
        nextMonth[partialIndex] = next.getMonth();
        var onlyYearSelect = ["year", "quarter", "month"].includes(props2.mode);
        var correctedDate = dateCorrection(partialIndex, nextYear, nextMonth, onlyYearSelect);
        nextYear = correctedDate.nextYear;
        nextMonth = correctedDate.nextMonth;
        year.value = nextYear;
        month.value = nextMonth;
      }
      function onTimePickerChange(val) {
        var _extractTimeObj = extractTimeObj(val),
          hours = _extractTimeObj.hours,
          minutes = _extractTimeObj.minutes,
          seconds = _extractTimeObj.seconds,
          milliseconds = _extractTimeObj.milliseconds,
          meridiem = _extractTimeObj.meridiem;
        var nextInputValue = _toConsumableArray(inputValue.value);
        var changedInputValue = inputValue.value[activeIndex.value];
        var currentDate = !dayjs_min(changedInputValue, formatRef.value.format).isValid() ? dayjs_min().year(year.value[activeIndex.value]).month(month.value[activeIndex.value]) : dayjs_min(changedInputValue, formatRef.value.format);
        var nextHours = hours;
        if (/am/i.test(meridiem) && nextHours === 12) nextHours -= 12;
        if (/pm/i.test(meridiem) && nextHours < 12) nextHours += 12;
        var nextDate = currentDate.hour(nextHours).minute(minutes).second(seconds).millisecond(milliseconds).toDate();
        nextInputValue[activeIndex.value] = nextDate;
        var nextTime = _toConsumableArray(time.value);
        nextTime[activeIndex.value] = val;
        time.value = nextTime;
        isSelected.value = true;
        inputValue.value = formatDate(nextInputValue, {
          format: formatRef.value.format
        });
        cacheValue.value = formatDate(nextInputValue, {
          format: formatRef.value.format
        });
      }
      function onConfirmClick(_ref4) {
        var e = _ref4.e;
        var nextValue = _toConsumableArray(inputValue.value);
        var notValidIndex = nextValue.findIndex(function (v) {
          return !v || !isValidDate(v, formatRef.value.format);
        });
        if (notValidIndex === -1 && nextValue.length === 2) {
          if (!isFirstValueSelected.value && parseToDayjs(nextValue[0], formatRef.value.format).isAfter(parseToDayjs(nextValue[1], formatRef.value.format))) {
            nextValue[activeIndex.value ? 0 : 1] = "";
            cacheValue.value = nextValue;
            inputValue.value = nextValue;
          } else {
            var _props2$onConfirm;
            props2 === null || props2 === void 0 || (_props2$onConfirm = props2.onConfirm) === null || _props2$onConfirm === void 0 || _props2$onConfirm.call(props2, {
              date: nextValue.map(function (v) {
                return dayjs_min(v).toDate();
              }),
              e: e,
              partial: activeIndex.value ? "end" : "start"
            });
            onChange === null || onChange === void 0 || onChange(formatDate(nextValue, {
              format: formatRef.value.format,
              targetFormat: formatRef.value.valueType,
              autoSwap: true
            }), {
              dayjsValue: nextValue.map(function (v) {
                return parseToDayjs(v, formatRef.value.format);
              }),
              trigger: "confirm"
            });
          }
        }
        if (nextValue.length === 1 || !isFirstValueSelected.value) {
          var nextIndex = notValidIndex;
          if (nextIndex === -1) nextIndex = activeIndex.value ? 0 : 1;
          activeIndex.value = nextIndex;
          isFirstValueSelected.value = true;
        } else if (nextValue.length === 2) {
          popupVisible.value = false;
        }
      }
      function onPresetClick(preset, context) {
        var presetValue = preset;
        if (typeof preset === "function") {
          presetValue = preset();
        }
        if (!Array.isArray(presetValue)) {
          console.error("preset: ".concat(preset, " \u9884\u8BBE\u503C\u5FC5\u987B\u662F\u6570\u7EC4!"));
        } else {
          var _props2$onPresetClick;
          onChange === null || onChange === void 0 || onChange(formatDate(presetValue, {
            format: formatRef.value.format,
            targetFormat: formatRef.value.valueType,
            autoSwap: true
          }), {
            dayjsValue: presetValue.map(function (p) {
              return parseToDayjs(p, formatRef.value.format);
            }),
            trigger: "preset"
          });
          popupVisible.value = false;
          (_props2$onPresetClick = props2.onPresetClick) === null || _props2$onPresetClick === void 0 || _props2$onPresetClick.call(props2, context);
          emit("preset-click", context);
        }
      }
      function onYearChange(nextVal, _ref5) {
        var partial = _ref5.partial;
        var partialIndex = partial === "start" ? 0 : 1;
        if (props2.enableTimePicker) partialIndex = activeIndex.value;
        var nextYear = _toConsumableArray(year.value);
        var nextMonth = _toConsumableArray(month.value);
        nextYear[partialIndex] = nextVal;
        var onlyYearSelect = ["year", "quarter", "month"].includes(props2.mode);
        var correctedDate = dateCorrection(partialIndex, nextYear, nextMonth, onlyYearSelect);
        nextYear = correctedDate.nextYear;
        nextMonth = correctedDate.nextMonth;
        year.value = nextYear;
        if (!onlyYearSelect) month.value = nextMonth;
      }
      function onMonthChange(nextVal, _ref6) {
        var partial = _ref6.partial;
        var partialIndex = partial === "start" ? 0 : 1;
        if (props2.enableTimePicker) partialIndex = activeIndex.value;
        var nextMonth = _toConsumableArray(month.value);
        nextMonth[partialIndex] = nextVal;
        if (year.value[0] === year.value[1]) {
          if (partialIndex === 0) {
            if (nextMonth[1] <= nextMonth[0]) {
              nextMonth[1] = nextMonth[0] + 1;
              if (nextMonth[1] === 12) {
                var _year$value, _year$value2;
                nextMonth[1] = 0;
                year.value = [(_year$value = year.value) === null || _year$value === void 0 ? void 0 : _year$value[0], ((_year$value2 = year.value) === null || _year$value2 === void 0 ? void 0 : _year$value2[1]) + 1];
              }
            }
          }
          if (partialIndex === 1) {
            nextMonth[0] = Math.min(nextMonth[0], nextMonth[1]);
            if (nextMonth[0] >= nextMonth[1]) {
              nextMonth[0] -= 1;
              if (nextMonth[0] === -1) {
                var _year$value3, _year$value4;
                nextMonth[0] = 11;
                year.value = [((_year$value3 = year.value) === null || _year$value3 === void 0 ? void 0 : _year$value3[0]) - 1, (_year$value4 = year.value) === null || _year$value4 === void 0 ? void 0 : _year$value4[1]];
              }
            }
          }
        }
        month.value = nextMonth;
      }
      var panelProps = VueCompositionAPI.computed(function () {
        return {
          hoverValue: isHoverCell.value ? inputValue.value : [],
          value: isSelected.value ? cacheValue.value : value.value,
          isFirstValueSelected: isFirstValueSelected.value,
          activeIndex: activeIndex.value,
          year: year.value,
          month: month.value,
          format: formatRef.value.format,
          mode: props2.mode,
          presets: props2.presets,
          time: time.value,
          disableDate: props2.disableDate,
          disableTime: props2.disableTime,
          firstDayOfWeek: props2.firstDayOfWeek,
          timePickerProps: props2.timePickerProps,
          enableTimePicker: props2.enableTimePicker,
          presetsPlacement: props2.presetsPlacement,
          panelPreselection: props2.panelPreselection,
          popupVisible: popupVisible.value,
          cancelRangeSelectLimit: props2.cancelRangeSelectLimit,
          onCellClick: onCellClick,
          onCellMouseEnter: onCellMouseEnter,
          onCellMouseLeave: onCellMouseLeave,
          onJumperClick: onJumperClick,
          onConfirmClick: onConfirmClick,
          onPresetClick: onPresetClick,
          onYearChange: onYearChange,
          onMonthChange: onMonthChange,
          onTimePickerChange: onTimePickerChange
        };
      });
      return {
        COMPONENT_NAME: COMPONENT_NAME,
        inputValue: inputValue,
        dateRangePickerPopupProps: dateRangePickerPopupProps,
        dateRangePickerRangeInputProps: dateRangePickerRangeInputProps,
        popupVisible: popupVisible,
        panelProps: panelProps,
        CalendarIcon: CalendarIcon,
        isDisabled: isDisabled
      };
    },
    render: function render() {
      var _this = this;
      var h = arguments[0];
      var COMPONENT_NAME = this.COMPONENT_NAME,
        inputValue = this.inputValue,
        dateRangePickerPopupProps = this.dateRangePickerPopupProps,
        dateRangePickerRangeInputProps = this.dateRangePickerRangeInputProps,
        popupVisible = this.popupVisible,
        panelProps = this.panelProps,
        CalendarIcon = this.CalendarIcon;
      var renderSuffixIcon = function renderSuffixIcon() {
        if (_this.suffixIcon) return _this.suffixIcon;
        if (_this.$scopedSlots.suffixIcon) return _this.$scopedSlots.suffixIcon;
        if (_this.$scopedSlots["suffix-icon"]) return _this.$scopedSlots["suffix-icon"];
        return function () {
          return h(CalendarIcon);
        };
      };
      return h("div", {
        "class": COMPONENT_NAME
      }, [h(RangeInputPopup, {
        "attrs": {
          "disabled": this.isDisabled,
          "label": this.label,
          "status": this.status,
          "tips": this.tips || this.$scopedSlots.tips,
          "inputValue": inputValue,
          "popupProps": dateRangePickerPopupProps,
          "rangeInputProps": _objectSpread$1m({
            suffixIcon: renderSuffixIcon()
          }, dateRangePickerRangeInputProps),
          "popupVisible": popupVisible,
          "panel": function panel() {
            return h(TRangePanel, {
              "props": _objectSpread$1m({}, panelProps)
            });
          }
        }
      })]);
    }
  });

  var dateRangePickerPanelProps = {
    defaultTime: {
      type: Array,
      "default": function _default() {
        return ["00:00:00", "23:59:59"];
      }
    },
    onCellClick: Function,
    onChange: Function,
    onConfirm: Function,
    onMonthChange: Function,
    onPanelClick: Function,
    onPresetClick: Function,
    onTimeChange: Function,
    onYearChange: Function
  };

  function ownKeys$1m(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1l(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1m(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1m(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _DateRangePickerPanel = VueCompositionAPI.defineComponent({
    name: "TDateRangePickerPanel",
    props: _objectSpread$1l({
      value: dateRangePickerProps.value,
      defaultValue: dateRangePickerProps.defaultValue,
      disabled: dateRangePickerProps.disabled,
      disableDate: dateRangePickerProps.disableDate,
      disableTime: dateRangePickerProps.disableTime,
      enableTimePicker: dateRangePickerProps.enableTimePicker,
      firstDayOfWeek: dateRangePickerProps.firstDayOfWeek,
      format: dateRangePickerProps.format,
      mode: dateRangePickerProps.mode,
      presets: dateRangePickerProps.presets,
      presetsPlacement: dateRangePickerProps.presetsPlacement,
      timePickerProps: dateRangePickerProps.timePickerProps,
      panelPreselection: dateRangePickerProps.panelPreselection
    }, dateRangePickerPanelProps),
    setup: function setup(props, _ref) {
      var emit = _ref.emit,
        attrs = _ref.attrs;
      var _useRangeValue = useRangeValue(props),
        value = _useRangeValue.value,
        year = _useRangeValue.year,
        month = _useRangeValue.month,
        time = _useRangeValue.time,
        cacheValue = _useRangeValue.cacheValue,
        isFirstValueSelected = _useRangeValue.isFirstValueSelected,
        onChange = _useRangeValue.onChange;
      var formatRef = VueCompositionAPI.computed(function () {
        return getDefaultFormat({
          mode: props.mode,
          enableTimePicker: props.enableTimePicker,
          format: props.format
        });
      });
      var isSelected = VueCompositionAPI.ref(false);
      var isHoverCell = VueCompositionAPI.ref(false);
      var hoverValue = VueCompositionAPI.ref([]);
      var activeIndex = VueCompositionAPI.computed(function () {
        return isFirstValueSelected.value ? 1 : 0;
      });
      VueCompositionAPI.watch(function () {
        return value.value;
      }, function (value2) {
        if (value2.length === 2 && !props.enableTimePicker) {
          var nextMonth = value2.map(function (v) {
            return parseToDayjs(v || new Date(), formatRef.value.format).month();
          });
          if (year.value[0] === year.value[1] && nextMonth[0] === nextMonth[1]) {
            nextMonth[0] === 11 ? nextMonth[0] -= 1 : nextMonth[1] += 1;
          }
          month.value = nextMonth;
        }
      }, {
        immediate: true
      });
      function onCellMouseEnter(date) {
        isHoverCell.value = true;
        var nextValue = _toConsumableArray(hoverValue.value);
        nextValue[activeIndex.value] = formatDate(date, {
          format: formatRef.value.format
        });
        hoverValue.value = nextValue;
      }
      function onCellMouseLeave() {
        isHoverCell.value = false;
        hoverValue.value = cacheValue.value;
      }
      function onCellClick(date, _ref2) {
        var _props$onCellClick;
        var e = _ref2.e;
        isHoverCell.value = false;
        isSelected.value = true;
        var nextValue = _toConsumableArray(cacheValue.value);
        nextValue[activeIndex.value] = formatDate(date, {
          format: formatRef.value.format
        });
        cacheValue.value = nextValue;
        (_props$onCellClick = props.onCellClick) === null || _props$onCellClick === void 0 || _props$onCellClick.call(props, {
          e: e,
          partial: activeIndex.value ? "end" : "start",
          date: nextValue.map(function (v) {
            return parseToDayjs(v, formatRef.value.format).toDate();
          })
        });
        emit("cell-click", {
          e: e,
          partial: activeIndex.value ? "end" : "start",
          date: nextValue.map(function (v) {
            return parseToDayjs(v, formatRef.value.format).toDate();
          })
        });
        if (props.enableTimePicker) return;
        if (nextValue.length === 2 && isFirstValueSelected.value) {
          onChange === null || onChange === void 0 || onChange(formatDate(nextValue, {
            format: formatRef.value.format,
            autoSwap: true
          }), {
            dayjsValue: nextValue.map(function (v) {
              return parseToDayjs(v, formatRef.value.format);
            }),
            trigger: "pick"
          });
          isFirstValueSelected.value = false;
        } else {
          isFirstValueSelected.value = true;
        }
      }
      function onJumperClick(_ref3) {
        var trigger = _ref3.trigger,
          partial = _ref3.partial;
        var partialIndex = partial === "start" ? 0 : 1;
        var triggerMap = {
          prev: "arrow-previous",
          next: "arrow-next"
        };
        var monthCountMap = {
          date: 1,
          week: 1,
          month: 12,
          quarter: 12,
          year: 120
        };
        var monthCount = monthCountMap[props.mode] || 0;
        var current = new Date(year.value[partialIndex], month.value[partialIndex]);
        var next = null;
        if (trigger === "prev") {
          next = subtractMonth(current, monthCount);
        } else if (trigger === "current") {
          next = new Date();
        } else if (trigger === "next") {
          next = addMonth(current, monthCount);
        }
        var nextYear = _toConsumableArray(year.value);
        nextYear[partialIndex] = next.getFullYear();
        var nextMonth = _toConsumableArray(month.value);
        nextMonth[partialIndex] = next.getMonth();
        var onlyYearSelect = ["year", "quarter", "month"].includes(props.mode);
        var correctedDate = dateCorrection(partialIndex, nextYear, nextMonth, onlyYearSelect);
        nextYear = correctedDate.nextYear;
        nextMonth = correctedDate.nextMonth;
        if (year.value.some(function (y) {
          return !nextYear.includes(y);
        })) {
          var _props$onYearChange;
          (_props$onYearChange = props.onYearChange) === null || _props$onYearChange === void 0 || _props$onYearChange.call(props, {
            partial: partial,
            year: nextYear[partialIndex],
            date: value.value.map(function (v) {
              return dayjs_min(v).toDate();
            }),
            trigger: trigger === "current" ? "today" : "year-".concat(triggerMap[trigger])
          });
          emit("year-change", {
            partial: partial,
            year: nextYear[partialIndex],
            date: value.value.map(function (v) {
              return dayjs_min(v).toDate();
            }),
            trigger: trigger === "current" ? "today" : "year-".concat(triggerMap[trigger])
          });
        }
        if (month.value.some(function (m) {
          return !nextMonth.includes(m);
        })) {
          var _props$onMonthChange;
          (_props$onMonthChange = props.onMonthChange) === null || _props$onMonthChange === void 0 || _props$onMonthChange.call(props, {
            partial: partial,
            month: nextMonth[partialIndex],
            date: value.value.map(function (v) {
              return dayjs_min(v).toDate();
            }),
            trigger: trigger === "current" ? "today" : "month-".concat(triggerMap[trigger])
          });
          emit("month-change", {
            partial: partial,
            month: nextMonth[partialIndex],
            date: value.value.map(function (v) {
              return dayjs_min(v).toDate();
            }),
            trigger: trigger === "current" ? "today" : "month-".concat(triggerMap[trigger])
          });
        }
        year.value = nextYear;
        month.value = nextMonth;
      }
      function onTimePickerChange(val) {
        var _props$onTimeChange;
        var _extractTimeObj = extractTimeObj(val),
          hours = _extractTimeObj.hours,
          minutes = _extractTimeObj.minutes,
          seconds = _extractTimeObj.seconds,
          milliseconds = _extractTimeObj.milliseconds,
          meridiem = _extractTimeObj.meridiem;
        var nextInputValue = _toConsumableArray(cacheValue.value);
        var changedInputValue = cacheValue.value[activeIndex.value];
        var currentDate = !dayjs_min(changedInputValue, formatRef.value.format).isValid() ? dayjs_min().year(year.value[activeIndex.value]).month(month.value[activeIndex.value]) : dayjs_min(changedInputValue, formatRef.value.format);
        var nextHours = hours;
        if (/am/i.test(meridiem) && nextHours === 12) nextHours -= 12;
        if (/pm/i.test(meridiem) && nextHours < 12) nextHours += 12;
        var nextDate = currentDate.hour(nextHours).minute(minutes).second(seconds).millisecond(milliseconds).toDate();
        nextInputValue[activeIndex.value] = nextDate;
        var nextTime = _toConsumableArray(time.value);
        nextTime[activeIndex.value] = val;
        time.value = nextTime;
        isSelected.value = true;
        cacheValue.value = formatDate(nextInputValue, {
          format: formatRef.value.format
        });
        (_props$onTimeChange = props.onTimeChange) === null || _props$onTimeChange === void 0 || _props$onTimeChange.call(props, {
          time: val,
          date: value.value.map(function (v) {
            return dayjs_min(v).toDate();
          }),
          partial: activeIndex.value ? "end" : "start",
          trigger: "time-hour"
        });
        emit("time-change", {
          time: val,
          date: value.value.map(function (v) {
            return dayjs_min(v).toDate();
          }),
          partial: activeIndex.value ? "end" : "start",
          trigger: "time-hour"
        });
      }
      function onConfirmClick(_ref4) {
        var _props$onConfirm;
        var e = _ref4.e;
        var nextValue = _toConsumableArray(cacheValue.value);
        if (nextValue.length === 2 && isFirstValueSelected.value) {
          onChange === null || onChange === void 0 || onChange(formatDate(nextValue, {
            format: formatRef.value.format,
            autoSwap: true
          }), {
            dayjsValue: nextValue.map(function (v) {
              return parseToDayjs(v, formatRef.value.format);
            }),
            trigger: "confirm"
          });
          year.value = nextValue.map(function (v) {
            return dayjs_min(v, formatRef.value.format).year();
          });
          month.value = nextValue.map(function (v) {
            return dayjs_min(v, formatRef.value.format).month();
          });
          isFirstValueSelected.value = false;
        } else {
          isFirstValueSelected.value = true;
        }
        (_props$onConfirm = props.onConfirm) === null || _props$onConfirm === void 0 || _props$onConfirm.call(props, {
          date: value.value.map(function (v) {
            return dayjs_min(v).toDate();
          }),
          e: e
        });
        emit("confirm", {
          date: value.value.map(function (v) {
            return dayjs_min(v).toDate();
          }),
          e: e
        });
      }
      function onPresetClick(preset, context) {
        var presetValue = preset;
        if (typeof preset === "function") {
          presetValue = preset();
        }
        if (!Array.isArray(presetValue)) {
          console.error("preset: ".concat(preset, " \u9884\u8BBE\u503C\u5FC5\u987B\u662F\u6570\u7EC4!"));
        } else {
          var _props$onPresetClick;
          onChange === null || onChange === void 0 || onChange(formatDate(presetValue, {
            format: formatRef.value.format,
            autoSwap: true
          }), {
            dayjsValue: presetValue.map(function (p) {
              return parseToDayjs(p, formatRef.value.format);
            }),
            trigger: "preset"
          });
          (_props$onPresetClick = props.onPresetClick) === null || _props$onPresetClick === void 0 || _props$onPresetClick.call(props, context);
          emit("preset-click", context);
        }
      }
      function onYearChange(nextVal, _ref5) {
        var _props$onYearChange2;
        var partial = _ref5.partial;
        var partialIndex = partial === "start" ? 0 : 1;
        if (props.enableTimePicker) partialIndex = activeIndex.value;
        var nextYear = _toConsumableArray(year.value);
        nextYear[partialIndex] = nextVal;
        var nextMonth = _toConsumableArray(month.value);
        var onlyYearSelect = ["year", "quarter", "month"].includes(props.mode);
        var correctedDate = dateCorrection(partialIndex, nextYear, nextMonth, onlyYearSelect);
        nextYear = correctedDate.nextYear;
        nextMonth = correctedDate.nextMonth;
        year.value = nextYear;
        if (!onlyYearSelect) month.value = nextMonth;
        (_props$onYearChange2 = props.onYearChange) === null || _props$onYearChange2 === void 0 || _props$onYearChange2.call(props, {
          partial: partial,
          year: nextYear[partialIndex],
          date: value.value.map(function (v) {
            return dayjs_min(v).toDate();
          }),
          trigger: "year-select"
        });
        emit("year-change", {
          partial: partial,
          year: nextYear[partialIndex],
          date: value.value.map(function (v) {
            return dayjs_min(v).toDate();
          }),
          trigger: "year-select"
        });
      }
      function onMonthChange(nextVal, _ref6) {
        var _props$onMonthChange2;
        var partial = _ref6.partial;
        var partialIndex = partial === "start" ? 0 : 1;
        if (props.enableTimePicker) partialIndex = activeIndex.value;
        var nextMonth = _toConsumableArray(month.value);
        nextMonth[partialIndex] = nextVal;
        if (year[0] === year[1]) {
          if (partialIndex === 0) {
            if (nextMonth[1] <= nextMonth[0]) {
              nextMonth[1] = nextMonth[0] + 1;
              if (nextMonth[1] === 12) {
                var _year$value, _year$value2;
                nextMonth[1] = 0;
                year.value = [(_year$value = year.value) === null || _year$value === void 0 ? void 0 : _year$value[0], ((_year$value2 = year.value) === null || _year$value2 === void 0 ? void 0 : _year$value2[1]) + 1];
              }
            }
          }
          if (partialIndex === 1) {
            nextMonth[0] = Math.min(nextMonth[0], nextMonth[1]);
            if (nextMonth[0] >= nextMonth[1]) {
              nextMonth[0] -= 1;
              if (nextMonth[0] === -1) {
                var _year$value3, _year$value4;
                nextMonth[0] = 11;
                year.value = [((_year$value3 = year.value) === null || _year$value3 === void 0 ? void 0 : _year$value3[0]) - 1, (_year$value4 = year.value) === null || _year$value4 === void 0 ? void 0 : _year$value4[1]];
              }
            }
          }
        }
        month.value = nextMonth;
        (_props$onMonthChange2 = props.onMonthChange) === null || _props$onMonthChange2 === void 0 || _props$onMonthChange2.call(props, {
          partial: partial,
          month: nextMonth[partialIndex],
          date: value.value.map(function (v) {
            return dayjs_min(v).toDate();
          }),
          trigger: "month-select"
        });
        emit("month-change", {
          partial: partial,
          month: nextMonth[partialIndex],
          date: value.value.map(function (v) {
            return dayjs_min(v).toDate();
          }),
          trigger: "month-select"
        });
      }
      function onPanelClick(context) {
        var _props$onPanelClick;
        (_props$onPanelClick = props.onPanelClick) === null || _props$onPanelClick === void 0 || _props$onPanelClick.call(props, context);
        emit("panel-click", context);
      }
      var panelProps = VueCompositionAPI.computed(function () {
        var _attrs$popupVisible;
        return {
          hoverValue: isHoverCell.value ? hoverValue.value : [],
          value: isSelected.value ? formatDate(cacheValue.value, {
            format: formatRef.value.format
          }) : value.value,
          activeIndex: activeIndex.value,
          year: year.value,
          month: month.value,
          mode: props.mode,
          format: formatRef.value.format,
          presets: props.presets,
          time: time.value,
          disableDate: props.disableDate,
          disableTime: props.disableTime,
          firstDayOfWeek: props.firstDayOfWeek,
          timePickerProps: props.timePickerProps,
          enableTimePicker: props.enableTimePicker,
          presetsPlacement: props.presetsPlacement,
          panelPreselection: props.panelPreselection,
          popupVisible: (_attrs$popupVisible = attrs === null || attrs === void 0 ? void 0 : attrs.popupVisible) !== null && _attrs$popupVisible !== void 0 ? _attrs$popupVisible : true,
          onPanelClick: onPanelClick,
          onCellClick: onCellClick,
          onCellMouseEnter: onCellMouseEnter,
          onCellMouseLeave: onCellMouseLeave,
          onJumperClick: onJumperClick,
          onConfirmClick: onConfirmClick,
          onPresetClick: onPresetClick,
          onYearChange: onYearChange,
          onMonthChange: onMonthChange,
          onTimePickerChange: onTimePickerChange
        };
      });
      return {
        panelProps: panelProps
      };
    },
    render: function render() {
      var h = arguments[0];
      var panelProps = this.panelProps;
      return h(TRangePanel, {
        "props": _objectSpread$1l({}, panelProps)
      });
    }
  });

  var DatePicker = withInstall$1(_DatePicker, VueCompositionAPI__default["default"]);
  var DatePickerPanel = withInstall$1(_DatePickerPanel, VueCompositionAPI__default["default"]);
  var DateRangePicker = withInstall$1(_DateRangePicker, VueCompositionAPI__default["default"]);
  var DateRangePickerPanel = withInstall$1(_DateRangePickerPanel, VueCompositionAPI__default["default"]);

  var props$B = {
    colon: Boolean,
    data: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      "default": void 0
    },
    errorMessage: {
      type: Object
    },
    formControlledComponents: {
      type: Array
    },
    id: {
      type: String,
      "default": void 0
    },
    labelAlign: {
      type: String,
      "default": "right",
      validator: function validator(val) {
        if (!val) return true;
        return ["left", "right", "top"].includes(val);
      }
    },
    labelWidth: {
      type: [String, Number],
      "default": "100px"
    },
    layout: {
      type: String,
      "default": "vertical",
      validator: function validator(val) {
        if (!val) return true;
        return ["vertical", "inline"].includes(val);
      }
    },
    preventSubmitDefault: {
      type: Boolean,
      "default": true
    },
    requiredMark: {
      type: Boolean,
      "default": void 0
    },
    resetType: {
      type: String,
      "default": "empty",
      validator: function validator(val) {
        if (!val) return true;
        return ["empty", "initial"].includes(val);
      }
    },
    rules: {
      type: Object
    },
    scrollToFirstError: {
      type: String,
      validator: function validator(val) {
        if (!val) return true;
        return ["", "smooth", "auto"].includes(val);
      }
    },
    showErrorMessage: {
      type: Boolean,
      "default": true
    },
    statusIcon: {
      type: [Boolean, Function],
      "default": void 0
    },
    submitWithWarningMessage: Boolean,
    onReset: Function,
    onSubmit: Function,
    onValidate: Function
  };

  var FORM_CONTROL_COMPONENTS = ["TInput", "TTextarea", "TCascader", "TSelect", "TOption", "TSwitch", "TCheckbox", "TCheckboxGroup", "TRadio", "TRadioGroup", "TTreeSelect", "TDatePicker", "TTimePicker", "TUpload", "TTransfer", "TSlider"];

  var merge_1 = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports["default"] = merge;
    function merge() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var defaults = arguments.length > 1 ? arguments[1] : undefined;
      for (var key in defaults) {
        if (typeof obj[key] === 'undefined') {
          obj[key] = defaults[key];
        }
      }
      return obj;
    }
    module.exports = exports["default"];
    module.exports["default"] = exports["default"];
  });

  var isDate_1 = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports["default"] = isDate;
    var _merge = _interopRequireDefault(merge_1);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        "default": obj
      };
    }
    function _slicedToArray(arr, i) {
      return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    function _nonIterableRest() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _iterableToArrayLimit(r, l) {
      var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
      if (null != t) {
        var e,
          n,
          i,
          u,
          a = [],
          f = !0,
          o = !1;
        try {
          if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t) return;
            f = !1;
          } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
          o = !0, n = r;
        } finally {
          try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
          } finally {
            if (o) throw n;
          }
        }
        return a;
      }
    }
    function _arrayWithHoles(arr) {
      if (Array.isArray(arr)) return arr;
    }
    function _createForOfIteratorHelper(o, allowArrayLike) {
      var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
      if (!it) {
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
          if (it) o = it;
          var i = 0;
          var F = function F() {};
          return {
            s: F,
            n: function n() {
              if (i >= o.length) return {
                done: true
              };
              return {
                done: false,
                value: o[i++]
              };
            },
            e: function e(_e) {
              throw _e;
            },
            f: F
          };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }
      var normalCompletion = true,
        didErr = false,
        err;
      return {
        s: function s() {
          it = it.call(o);
        },
        n: function n() {
          var step = it.next();
          normalCompletion = step.done;
          return step;
        },
        e: function e(_e2) {
          didErr = true;
          err = _e2;
        },
        f: function f() {
          try {
            if (!normalCompletion && it["return"] != null) it["return"]();
          } finally {
            if (didErr) throw err;
          }
        }
      };
    }
    function _unsupportedIterableToArray(o, minLen) {
      if (!o) return;
      if (typeof o === "string") return _arrayLikeToArray(o, minLen);
      var n = Object.prototype.toString.call(o).slice(8, -1);
      if (n === "Object" && o.constructor) n = o.constructor.name;
      if (n === "Map" || n === "Set") return Array.from(o);
      if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
      if (len == null || len > arr.length) len = arr.length;
      for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
      return arr2;
    }
    var default_date_options = {
      format: 'YYYY/MM/DD',
      delimiters: ['/', '-'],
      strictMode: false
    };
    function isValidFormat(format) {
      return /(^(y{4}|y{2})[.\/-](m{1,2})[.\/-](d{1,2})$)|(^(m{1,2})[.\/-](d{1,2})[.\/-]((y{4}|y{2})$))|(^(d{1,2})[.\/-](m{1,2})[.\/-]((y{4}|y{2})$))/gi.test(format);
    }
    function zip(date, format) {
      var zippedArr = [],
        len = Math.min(date.length, format.length);
      for (var i = 0; i < len; i++) {
        zippedArr.push([date[i], format[i]]);
      }
      return zippedArr;
    }
    function isDate(input, options) {
      if (typeof options === 'string') {
        // Allow backward compatibility for old format isDate(input [, format])
        options = (0, _merge["default"])({
          format: options
        }, default_date_options);
      } else {
        options = (0, _merge["default"])(options, default_date_options);
      }
      if (typeof input === 'string' && isValidFormat(options.format)) {
        var formatDelimiter = options.delimiters.find(function (delimiter) {
          return options.format.indexOf(delimiter) !== -1;
        });
        var dateDelimiter = options.strictMode ? formatDelimiter : options.delimiters.find(function (delimiter) {
          return input.indexOf(delimiter) !== -1;
        });
        var dateAndFormat = zip(input.split(dateDelimiter), options.format.toLowerCase().split(formatDelimiter));
        var dateObj = {};
        var _iterator = _createForOfIteratorHelper(dateAndFormat),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _slicedToArray(_step.value, 2),
              dateWord = _step$value[0],
              formatWord = _step$value[1];
            if (dateWord.length !== formatWord.length) {
              return false;
            }
            dateObj[formatWord.charAt(0)] = dateWord;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        var fullYear = dateObj.y;

        // Check if the year starts with a hyphen
        if (fullYear.startsWith('-')) {
          return false; // Hyphen before year is not allowed
        }
        if (dateObj.y.length === 2) {
          var parsedYear = parseInt(dateObj.y, 10);
          if (isNaN(parsedYear)) {
            return false;
          }
          var currentYearLastTwoDigits = new Date().getFullYear() % 100;
          if (parsedYear < currentYearLastTwoDigits) {
            fullYear = "20".concat(dateObj.y);
          } else {
            fullYear = "19".concat(dateObj.y);
          }
        }
        var month = dateObj.m;
        if (dateObj.m.length === 1) {
          month = "0".concat(dateObj.m);
        }
        var day = dateObj.d;
        if (dateObj.d.length === 1) {
          day = "0".concat(dateObj.d);
        }
        return new Date("".concat(fullYear, "-").concat(month, "-").concat(day, "T00:00:00.000Z")).getUTCDate() === +dateObj.d;
      }
      if (!options.strictMode) {
        return Object.prototype.toString.call(input) === '[object Date]' && isFinite(input);
      }
      return false;
    }
    module.exports = exports["default"];
    module.exports["default"] = exports["default"];
  });
  var isDate = /*@__PURE__*/getDefaultExportFromCjs(isDate_1);

  var assertString_1 = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports["default"] = assertString;
    function _typeof(o) {
      "@babel/helpers - typeof";

      return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
        return typeof o;
      } : function (o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
      }, _typeof(o);
    }
    function assertString(input) {
      var isString = typeof input === 'string' || input instanceof String;
      if (!isString) {
        var invalidType = _typeof(input);
        if (input === null) invalidType = 'null';else if (invalidType === 'object') invalidType = input.constructor.name;
        throw new TypeError("Expected a string but received a ".concat(invalidType));
      }
    }
    module.exports = exports["default"];
    module.exports["default"] = exports["default"];
  });

  var isByteLength_1 = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports["default"] = isByteLength;
    var _assertString = _interopRequireDefault(assertString_1);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        "default": obj
      };
    }
    function _typeof(o) {
      "@babel/helpers - typeof";

      return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
        return typeof o;
      } : function (o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
      }, _typeof(o);
    }
    /* eslint-disable prefer-rest-params */
    function isByteLength(str, options) {
      (0, _assertString["default"])(str);
      var min;
      var max;
      if (_typeof(options) === 'object') {
        min = options.min || 0;
        max = options.max;
      } else {
        // backwards compatibility: isByteLength(str, min [, max])
        min = arguments[1];
        max = arguments[2];
      }
      var len = encodeURI(str).split(/%..|./).length - 1;
      return len >= min && (typeof max === 'undefined' || len <= max);
    }
    module.exports = exports["default"];
    module.exports["default"] = exports["default"];
  });

  var isFQDN_1 = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports["default"] = isFQDN;
    var _assertString = _interopRequireDefault(assertString_1);
    var _merge = _interopRequireDefault(merge_1);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        "default": obj
      };
    }
    var default_fqdn_options = {
      require_tld: true,
      allow_underscores: false,
      allow_trailing_dot: false,
      allow_numeric_tld: false,
      allow_wildcard: false,
      ignore_max_length: false
    };
    function isFQDN(str, options) {
      (0, _assertString["default"])(str);
      options = (0, _merge["default"])(options, default_fqdn_options);

      /* Remove the optional trailing dot before checking validity */
      if (options.allow_trailing_dot && str[str.length - 1] === '.') {
        str = str.substring(0, str.length - 1);
      }

      /* Remove the optional wildcard before checking validity */
      if (options.allow_wildcard === true && str.indexOf('*.') === 0) {
        str = str.substring(2);
      }
      var parts = str.split('.');
      var tld = parts[parts.length - 1];
      if (options.require_tld) {
        // disallow fqdns without tld
        if (parts.length < 2) {
          return false;
        }
        if (!options.allow_numeric_tld && !/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
          return false;
        }

        // disallow spaces
        if (/\s/.test(tld)) {
          return false;
        }
      }

      // reject numeric TLDs
      if (!options.allow_numeric_tld && /^\d+$/.test(tld)) {
        return false;
      }
      return parts.every(function (part) {
        if (part.length > 63 && !options.ignore_max_length) {
          return false;
        }
        if (!/^[a-z_\u00a1-\uffff0-9-]+$/i.test(part)) {
          return false;
        }

        // disallow full-width chars
        if (/[\uff01-\uff5e]/.test(part)) {
          return false;
        }

        // disallow parts starting or ending with hyphen
        if (/^-|-$/.test(part)) {
          return false;
        }
        if (!options.allow_underscores && /_/.test(part)) {
          return false;
        }
        return true;
      });
    }
    module.exports = exports["default"];
    module.exports["default"] = exports["default"];
  });

  var isIP_1 = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports["default"] = isIP;
    var _assertString = _interopRequireDefault(assertString_1);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        "default": obj
      };
    }
    /**
    11.3.  Examples
    
       The following addresses
    
                 fe80::1234 (on the 1st link of the node)
                 ff02::5678 (on the 5th link of the node)
                 ff08::9abc (on the 10th organization of the node)
    
       would be represented as follows:
    
                 fe80::1234%1
                 ff02::5678%5
                 ff08::9abc%10
    
       (Here we assume a natural translation from a zone index to the
       <zone_id> part, where the Nth zone of any scope is translated into
       "N".)
    
       If we use interface names as <zone_id>, those addresses could also be
       represented as follows:
    
                fe80::1234%ne0
                ff02::5678%pvc1.3
                ff08::9abc%interface10
    
       where the interface "ne0" belongs to the 1st link, "pvc1.3" belongs
       to the 5th link, and "interface10" belongs to the 10th organization.
     * * */
    var IPv4SegmentFormat = '(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])';
    var IPv4AddressFormat = "(".concat(IPv4SegmentFormat, "[.]){3}").concat(IPv4SegmentFormat);
    var IPv4AddressRegExp = new RegExp("^".concat(IPv4AddressFormat, "$"));
    var IPv6SegmentFormat = '(?:[0-9a-fA-F]{1,4})';
    var IPv6AddressRegExp = new RegExp('^(' + "(?:".concat(IPv6SegmentFormat, ":){7}(?:").concat(IPv6SegmentFormat, "|:)|") + "(?:".concat(IPv6SegmentFormat, ":){6}(?:").concat(IPv4AddressFormat, "|:").concat(IPv6SegmentFormat, "|:)|") + "(?:".concat(IPv6SegmentFormat, ":){5}(?::").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,2}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){4}(?:(:").concat(IPv6SegmentFormat, "){0,1}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,3}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){3}(?:(:").concat(IPv6SegmentFormat, "){0,2}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,4}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){2}(?:(:").concat(IPv6SegmentFormat, "){0,3}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,5}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){1}(?:(:").concat(IPv6SegmentFormat, "){0,4}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,6}|:)|") + "(?::((?::".concat(IPv6SegmentFormat, "){0,5}:").concat(IPv4AddressFormat, "|(?::").concat(IPv6SegmentFormat, "){1,7}|:))") + ')(%[0-9a-zA-Z-.:]{1,})?$');
    function isIP(str) {
      var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      (0, _assertString["default"])(str);
      version = String(version);
      if (!version) {
        return isIP(str, 4) || isIP(str, 6);
      }
      if (version === '4') {
        return IPv4AddressRegExp.test(str);
      }
      if (version === '6') {
        return IPv6AddressRegExp.test(str);
      }
      return false;
    }
    module.exports = exports["default"];
    module.exports["default"] = exports["default"];
  });

  var isEmail_1 = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports["default"] = isEmail;
    var _assertString = _interopRequireDefault(assertString_1);
    var _isByteLength = _interopRequireDefault(isByteLength_1);
    var _isFQDN = _interopRequireDefault(isFQDN_1);
    var _isIP = _interopRequireDefault(isIP_1);
    var _merge = _interopRequireDefault(merge_1);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        "default": obj
      };
    }
    var default_email_options = {
      allow_display_name: false,
      allow_underscores: false,
      require_display_name: false,
      allow_utf8_local_part: true,
      require_tld: true,
      blacklisted_chars: '',
      ignore_max_length: false,
      host_blacklist: [],
      host_whitelist: []
    };

    /* eslint-disable max-len */
    /* eslint-disable no-control-regex */
    var splitNameAddress = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i;
    var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
    var gmailUserPart = /^[a-z\d]+$/;
    var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
    var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A1-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
    var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
    var defaultMaxEmailLength = 254;
    /* eslint-enable max-len */
    /* eslint-enable no-control-regex */

    /**
     * Validate display name according to the RFC2822: https://tools.ietf.org/html/rfc2822#appendix-A.1.2
     * @param {String} display_name
     */
    function validateDisplayName(display_name) {
      var display_name_without_quotes = display_name.replace(/^"(.+)"$/, '$1');
      // display name with only spaces is not valid
      if (!display_name_without_quotes.trim()) {
        return false;
      }

      // check whether display name contains illegal character
      var contains_illegal = /[\.";<>]/.test(display_name_without_quotes);
      if (contains_illegal) {
        // if contains illegal characters,
        // must to be enclosed in double-quotes, otherwise it's not a valid display name
        if (display_name_without_quotes === display_name) {
          return false;
        }

        // the quotes in display name must start with character symbol \
        var all_start_with_back_slash = display_name_without_quotes.split('"').length === display_name_without_quotes.split('\\"').length;
        if (!all_start_with_back_slash) {
          return false;
        }
      }
      return true;
    }
    function isEmail(str, options) {
      (0, _assertString["default"])(str);
      options = (0, _merge["default"])(options, default_email_options);
      if (options.require_display_name || options.allow_display_name) {
        var display_email = str.match(splitNameAddress);
        if (display_email) {
          var display_name = display_email[1];

          // Remove display name and angle brackets to get email address
          // Can be done in the regex but will introduce a ReDOS (See  #1597 for more info)
          str = str.replace(display_name, '').replace(/(^<|>$)/g, '');

          // sometimes need to trim the last space to get the display name
          // because there may be a space between display name and email address
          // eg. myname <address@gmail.com>
          // the display name is `myname` instead of `myname `, so need to trim the last space
          if (display_name.endsWith(' ')) {
            display_name = display_name.slice(0, -1);
          }
          if (!validateDisplayName(display_name)) {
            return false;
          }
        } else if (options.require_display_name) {
          return false;
        }
      }
      if (!options.ignore_max_length && str.length > defaultMaxEmailLength) {
        return false;
      }
      var parts = str.split('@');
      var domain = parts.pop();
      var lower_domain = domain.toLowerCase();
      if (options.host_blacklist.includes(lower_domain)) {
        return false;
      }
      if (options.host_whitelist.length > 0 && !options.host_whitelist.includes(lower_domain)) {
        return false;
      }
      var user = parts.join('@');
      if (options.domain_specific_validation && (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com')) {
        /*
          Previously we removed dots for gmail addresses before validating.
          This was removed because it allows `multiple..dots@gmail.com`
          to be reported as valid, but it is not.
          Gmail only normalizes single dots, removing them from here is pointless,
          should be done in normalizeEmail
        */
        user = user.toLowerCase();

        // Removing sub-address from username before gmail validation
        var username = user.split('+')[0];

        // Dots are not included in gmail length restriction
        if (!(0, _isByteLength["default"])(username.replace(/\./g, ''), {
          min: 6,
          max: 30
        })) {
          return false;
        }
        var _user_parts = username.split('.');
        for (var i = 0; i < _user_parts.length; i++) {
          if (!gmailUserPart.test(_user_parts[i])) {
            return false;
          }
        }
      }
      if (options.ignore_max_length === false && (!(0, _isByteLength["default"])(user, {
        max: 64
      }) || !(0, _isByteLength["default"])(domain, {
        max: 254
      }))) {
        return false;
      }
      if (!(0, _isFQDN["default"])(domain, {
        require_tld: options.require_tld,
        ignore_max_length: options.ignore_max_length,
        allow_underscores: options.allow_underscores
      })) {
        if (!options.allow_ip_domain) {
          return false;
        }
        if (!(0, _isIP["default"])(domain)) {
          if (!domain.startsWith('[') || !domain.endsWith(']')) {
            return false;
          }
          var noBracketdomain = domain.slice(1, -1);
          if (noBracketdomain.length === 0 || !(0, _isIP["default"])(noBracketdomain)) {
            return false;
          }
        }
      }
      if (user[0] === '"') {
        user = user.slice(1, user.length - 1);
        return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
      }
      var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;
      var user_parts = user.split('.');
      for (var _i = 0; _i < user_parts.length; _i++) {
        if (!pattern.test(user_parts[_i])) {
          return false;
        }
      }
      if (options.blacklisted_chars) {
        if (user.search(new RegExp("[".concat(options.blacklisted_chars, "]+"), 'g')) !== -1) return false;
      }
      return true;
    }
    module.exports = exports["default"];
    module.exports["default"] = exports["default"];
  });
  var isEmail = /*@__PURE__*/getDefaultExportFromCjs(isEmail_1);

  var isURL_1 = createCommonjsModule(function (module, exports) {

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports["default"] = isURL;
    var _assertString = _interopRequireDefault(assertString_1);
    var _isFQDN = _interopRequireDefault(isFQDN_1);
    var _isIP = _interopRequireDefault(isIP_1);
    var _merge = _interopRequireDefault(merge_1);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        "default": obj
      };
    }
    function _slicedToArray(arr, i) {
      return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    function _nonIterableRest() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _unsupportedIterableToArray(o, minLen) {
      if (!o) return;
      if (typeof o === "string") return _arrayLikeToArray(o, minLen);
      var n = Object.prototype.toString.call(o).slice(8, -1);
      if (n === "Object" && o.constructor) n = o.constructor.name;
      if (n === "Map" || n === "Set") return Array.from(o);
      if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
      if (len == null || len > arr.length) len = arr.length;
      for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
      return arr2;
    }
    function _iterableToArrayLimit(r, l) {
      var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
      if (null != t) {
        var e,
          n,
          i,
          u,
          a = [],
          f = !0,
          o = !1;
        try {
          if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t) return;
            f = !1;
          } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
          o = !0, n = r;
        } finally {
          try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
          } finally {
            if (o) throw n;
          }
        }
        return a;
      }
    }
    function _arrayWithHoles(arr) {
      if (Array.isArray(arr)) return arr;
    }
    /*
    options for isURL method
    
    require_protocol - if set as true isURL will return false if protocol is not present in the URL
    require_valid_protocol - isURL will check if the URL's protocol is present in the protocols option
    protocols - valid protocols can be modified with this option
    require_host - if set as false isURL will not check if host is present in the URL
    require_port - if set as true isURL will check if port is present in the URL
    allow_protocol_relative_urls - if set as true protocol relative URLs will be allowed
    validate_length - if set as false isURL will skip string length validation (IE maximum is 2083)
    
    */

    var default_url_options = {
      protocols: ['http', 'https', 'ftp'],
      require_tld: true,
      require_protocol: false,
      require_host: true,
      require_port: false,
      require_valid_protocol: true,
      allow_underscores: false,
      allow_trailing_dot: false,
      allow_protocol_relative_urls: false,
      allow_fragments: true,
      allow_query_components: true,
      validate_length: true
    };
    var wrapped_ipv6 = /^\[([^\]]+)\](?::([0-9]+))?$/;
    function isRegExp(obj) {
      return Object.prototype.toString.call(obj) === '[object RegExp]';
    }
    function checkHost(host, matches) {
      for (var i = 0; i < matches.length; i++) {
        var match = matches[i];
        if (host === match || isRegExp(match) && match.test(host)) {
          return true;
        }
      }
      return false;
    }
    function isURL(url, options) {
      (0, _assertString["default"])(url);
      if (!url || /[\s<>]/.test(url)) {
        return false;
      }
      if (url.indexOf('mailto:') === 0) {
        return false;
      }
      options = (0, _merge["default"])(options, default_url_options);
      if (options.validate_length && url.length >= 2083) {
        return false;
      }
      if (!options.allow_fragments && url.includes('#')) {
        return false;
      }
      if (!options.allow_query_components && (url.includes('?') || url.includes('&'))) {
        return false;
      }
      var protocol, auth, host, hostname, port, port_str, split, ipv6;
      split = url.split('#');
      url = split.shift();
      split = url.split('?');
      url = split.shift();
      split = url.split('://');
      if (split.length > 1) {
        protocol = split.shift().toLowerCase();
        if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) {
          return false;
        }
      } else if (options.require_protocol) {
        return false;
      } else if (url.slice(0, 2) === '//') {
        if (!options.allow_protocol_relative_urls) {
          return false;
        }
        split[0] = url.slice(2);
      }
      url = split.join('://');
      if (url === '') {
        return false;
      }
      split = url.split('/');
      url = split.shift();
      if (url === '' && !options.require_host) {
        return true;
      }
      split = url.split('@');
      if (split.length > 1) {
        if (options.disallow_auth) {
          return false;
        }
        if (split[0] === '') {
          return false;
        }
        auth = split.shift();
        if (auth.indexOf(':') >= 0 && auth.split(':').length > 2) {
          return false;
        }
        var _auth$split = auth.split(':'),
          _auth$split2 = _slicedToArray(_auth$split, 2),
          user = _auth$split2[0],
          password = _auth$split2[1];
        if (user === '' && password === '') {
          return false;
        }
      }
      hostname = split.join('@');
      port_str = null;
      ipv6 = null;
      var ipv6_match = hostname.match(wrapped_ipv6);
      if (ipv6_match) {
        host = '';
        ipv6 = ipv6_match[1];
        port_str = ipv6_match[2] || null;
      } else {
        split = hostname.split(':');
        host = split.shift();
        if (split.length) {
          port_str = split.join(':');
        }
      }
      if (port_str !== null && port_str.length > 0) {
        port = parseInt(port_str, 10);
        if (!/^[0-9]+$/.test(port_str) || port <= 0 || port > 65535) {
          return false;
        }
      } else if (options.require_port) {
        return false;
      }
      if (options.host_whitelist) {
        return checkHost(host, options.host_whitelist);
      }
      if (host === '' && !options.require_host) {
        return true;
      }
      if (!(0, _isIP["default"])(host) && !(0, _isFQDN["default"])(host, options) && (!ipv6 || !(0, _isIP["default"])(ipv6, 6))) {
        return false;
      }
      host = host || ipv6;
      if (options.host_blacklist && checkHost(host, options.host_blacklist)) {
        return false;
      }
      return true;
    }
    module.exports = exports["default"];
    module.exports["default"] = exports["default"];
  });
  var isURL = /*@__PURE__*/getDefaultExportFromCjs(isURL_1);

  function ownKeys$1l(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1k(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1l(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1l(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function isValueEmpty(val) {
    var type = Object.prototype.toString.call(val);
    var typeMap = {
      Date: "[object Date]"
    };
    if (type === typeMap.Date) {
      return false;
    }
    return _typeof$2(val) === "object" ? isEmpty(val) : ["", void 0, null].includes(val);
  }
  var compareValue = function compareValue(val, num, isMax) {
    var compare = function compare(a, b) {
      return isMax ? a <= b : a >= b;
    };
    if (isNumber(val)) return compare(val, num);
    if (Array.isArray(val)) return compare(val.length, num);
    return compare(getCharacterLength(val), num);
  };
  var VALIDATE_MAP = {
    date: isDate,
    url: isURL,
    email: isEmail,
    required: function required(val) {
      return !isValueEmpty(val);
    },
    whitespace: function whitespace(val) {
      return !(/^\s+$/.test(val) || val === "");
    },
    "boolean": function boolean(val) {
      return typeof val === "boolean";
    },
    max: function max(val, num) {
      return compareValue(val, num, true);
    },
    min: function min(val, num) {
      return compareValue(val, num, false);
    },
    len: function len(val, num) {
      return getCharacterLength(val) === num;
    },
    number: function number(val) {
      return isNumber(val);
    },
    "enum": function _enum(val, strs) {
      return strs.includes(val);
    },
    idcard: function idcard(val) {
      return /^(\d{18,18}|\d{15,15}|\d{17,17}x)$/i.test(val);
    },
    telnumber: function telnumber(val) {
      return /^1[3-9]\d{9}$/.test(val);
    },
    pattern: function pattern(val, regexp) {
      return regexp.test(val);
    },
    validator: function validator(val, validate2) {
      return validate2(val);
    }
  };
  function validateOneRule(_x, _x2) {
    return _validateOneRule.apply(this, arguments);
  }
  function _validateOneRule() {
    _validateOneRule = _asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee(value, rule) {
      var validateResult, keys, vOptions, vValidateFun, i, key, validateRule;
      return regenerator.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            validateResult = {
              result: true
            };
            keys = Object.keys(rule);
            i = 0;
          case 3:
            if (!(i < keys.length)) {
              _context.next = 15;
              break;
            }
            key = keys[i];
            if (!(!rule.required && isValueEmpty(value) && !rule.validator)) {
              _context.next = 7;
              break;
            }
            return _context.abrupt("return", validateResult);
          case 7:
            validateRule = VALIDATE_MAP[key];
            if (!(validateRule && (rule[key] || rule[key] === 0))) {
              _context.next = 12;
              break;
            }
            vOptions = rule[key] === true ? void 0 : rule[key];
            vValidateFun = validateRule;
            return _context.abrupt("break", 15);
          case 12:
            i++;
            _context.next = 3;
            break;
          case 15:
            if (!vValidateFun) {
              _context.next = 23;
              break;
            }
            _context.next = 18;
            return vValidateFun(value, vOptions);
          case 18:
            validateResult = _context.sent;
            if (!(typeof validateResult === "boolean")) {
              _context.next = 21;
              break;
            }
            return _context.abrupt("return", _objectSpread$1k(_objectSpread$1k({}, rule), {}, {
              result: validateResult
            }));
          case 21:
            if (!(_typeof$2(validateResult) === "object")) {
              _context.next = 23;
              break;
            }
            return _context.abrupt("return", validateResult);
          case 23:
            return _context.abrupt("return", validateResult);
          case 24:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _validateOneRule.apply(this, arguments);
  }
  function validate(_x3, _x4) {
    return _validate.apply(this, arguments);
  }
  function _validate() {
    _validate = _asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee2(value, rules) {
      var all, r;
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            all = rules.map(function (rule) {
              return validateOneRule(value, rule);
            });
            _context2.next = 3;
            return Promise.all(all);
          case 3:
            r = _context2.sent;
            return _context2.abrupt("return", r);
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _validate.apply(this, arguments);
  }

  var props$A = {
    "for": {
      type: String,
      "default": ""
    },
    help: {
      type: [String, Function]
    },
    label: {
      type: [String, Function],
      "default": ""
    },
    labelAlign: {
      type: String,
      validator: function validator(val) {
        if (!val) return true;
        return ["left", "right", "top"].includes(val);
      }
    },
    labelWidth: {
      type: [String, Number]
    },
    name: {
      type: String,
      "default": ""
    },
    requiredMark: {
      type: Boolean,
      "default": void 0
    },
    rules: {
      type: Array
    },
    showErrorMessage: {
      type: Boolean,
      "default": void 0
    },
    status: {
      type: String,
      "default": ""
    },
    statusIcon: {
      type: [Boolean, Function],
      "default": void 0
    },
    successBorder: Boolean,
    tips: {
      type: [String, Function]
    }
  };

  function ownKeys$1k(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1j(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1k(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1k(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function getFormItemClassName(componentName, name) {
    if (!name) return "";
    return "".concat(componentName, "-item__").concat(name).replace(/(\[|\]\.|'|")/g, "_");
  }
  var _FormItem = mixins(getConfigReceiverMixins("form"), getGlobalIconMixins()).extend({
    name: "TFormItem",
    props: _objectSpread$1j({}, props$A),
    inject: {
      form: {
        "default": void 0
      }
    },
    provide: function provide() {
      return {
        tFormItem: this
      };
    },
    data: function data() {
      return {
        errorList: [],
        successList: [],
        verifyStatus: "not" /* TO_BE_VALIDATED */,
        resetValidating: false,
        needResetField: false,
        initialValue: void 0,
        freeShowErrorMessage: void 0
      };
    },
    computed: {
      needErrorMessage: function needErrorMessage() {
        if (this.freeShowErrorMessage !== void 0) return this.freeShowErrorMessage;
        if (typeof this.showErrorMessage === "boolean") return this.showErrorMessage;
        var parent = this.form;
        return parent === null || parent === void 0 ? void 0 : parent.showErrorMessage;
      },
      classes: function classes() {
        return ["".concat(this.componentName, "__item"), getFormItemClassName(this.componentName, this.name), _defineProperty$2(_defineProperty$2({}, "".concat(this.componentName, "__item-with-help"), this.help), "".concat(this.componentName, "__item-with-extra"), this.extraNode)];
      },
      extraNode: function extraNode() {
        var h = this.$createElement;
        var list = this.errorList;
        if (this.needErrorMessage && list && list[0] && list[0].message) {
          return h("div", {
            "class": "".concat(this.classPrefix, "-input__extra")
          }, [list[0].message]);
        }
        if (this.successList.length) {
          return h("div", {
            "class": "".concat(this.classPrefix, "-input__extra")
          }, [this.successList[0].message]);
        }
        return null;
      },
      labelClasses: function labelClasses() {
        var parent = this.form;
        var labelAlign = isNil(this.labelAlign) ? parent === null || parent === void 0 ? void 0 : parent.labelAlign : this.labelAlign;
        var labelWidth = isNil(this.labelWidth) ? parent === null || parent === void 0 ? void 0 : parent.labelWidth : this.labelWidth;
        return ["".concat(this.componentName, "__label"), _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({}, "".concat(this.componentName, "__label--required"), this.needRequiredMark), "".concat(this.componentName, "__label--top"), this.getLabelContent() && (labelAlign === "top" || !labelWidth)), "".concat(this.componentName, "__label--left"), labelAlign === "left" && labelWidth), "".concat(this.componentName, "__label--right"), labelAlign === "right" && labelWidth)];
      },
      errorClasses: function errorClasses() {
        if (!this.needErrorMessage) return "";
        if (this.verifyStatus === "success" /* SUCCESS */) {
          return this.successBorder ? [this.commonStatusClassName.success, "".concat(this.componentName, "--success-border")].join(" ") : this.commonStatusClassName.success;
        }
        if (this.status) return this.statusClass;
        var list = this.errorList;
        if (!list.length) return;
        var type = list[0].type || "error";
        return type === "error" ? this.commonStatusClassName.error : this.commonStatusClassName.warning;
      },
      disabled: function disabled() {
        return this.form.disabled;
      },
      contentClasses: function contentClasses() {
        var getErrorClass = this.errorClasses;
        return ["".concat(this.componentName, "__controls"), getErrorClass];
      },
      contentStyle: function contentStyle() {
        var parent = this.form;
        var labelAlign = isNil(this.labelAlign) ? parent === null || parent === void 0 ? void 0 : parent.labelAlign : this.labelAlign;
        var labelWidth = isNil(this.labelWidth) ? parent === null || parent === void 0 ? void 0 : parent.labelWidth : this.labelWidth;
        var contentStyle = {};
        if (this.getLabelContent() && labelWidth && labelAlign !== "top") {
          if (typeof labelWidth === "number") {
            contentStyle = {
              marginLeft: "".concat(labelWidth, "px")
            };
          } else {
            contentStyle = {
              marginLeft: labelWidth
            };
          }
        }
        return contentStyle;
      },
      value: function value() {
        var parent = this.form;
        return parent && parent.data && get(parent.data, this.name);
      },
      hasColon: function hasColon() {
        var parent = this.form;
        return !!(parent && parent.colon && this.getLabelContent());
      },
      needRequiredMark: function needRequiredMark() {
        var _ref3, _this$$props$required;
        var requiredMark = (_ref3 = (_this$$props$required = this.$props.requiredMark) !== null && _this$$props$required !== void 0 ? _this$$props$required : this.form.requiredMark) !== null && _ref3 !== void 0 ? _ref3 : this.global.requiredMark;
        var isRequired = this.innerRules.filter(function (rule) {
          return rule.required;
        }).length > 0;
        return requiredMark || (requiredMark !== null && requiredMark !== void 0 ? requiredMark : isRequired);
      },
      innerRules: function innerRules() {
        var _this$rules;
        var parent = this.form;
        if ((_this$rules = this.rules) !== null && _this$rules !== void 0 && _this$rules.length) return this.rules || [];
        if (!this.name) return [];
        var index = String(this.name || "").lastIndexOf(".") || -1;
        var pRuleName = String(this.name || "").slice(index + 1);
        return get(parent === null || parent === void 0 ? void 0 : parent.rules, this.name) || get(parent === null || parent === void 0 ? void 0 : parent.rules, pRuleName) || [];
      },
      errorMessages: function errorMessages() {
        var _this$form$errorMessa;
        return (_this$form$errorMessa = this.form.errorMessage) !== null && _this$form$errorMessa !== void 0 ? _this$form$errorMessa : this.global.errorMessage;
      },
      statusClass: function statusClass() {
        return "".concat(this.classPrefix, "-is-").concat(this.$props.status || "default", " ").concat(this.$props.status === "success" ? "".concat(this.componentName, "--success-border") : "");
      }
    },
    created: function created() {
      var _this = this;
      this.addWatch();
      this.$watch(function () {
        if (_typeof$2(_this.value) === "object") return JSON.stringify(_this.value);
        return _this.value;
      }, function () {
        _this.validate("change");
      });
      this.$watch(function () {
        return [_this.name, JSON.stringify(_this.rules)].join(",");
      }, function () {
        _this.validate("change");
      });
    },
    mounted: function mounted() {
      this.initialValue = cloneDeep(this.value);
      this.form.$emit("form-item-created", this);
    },
    beforeDestroy: function beforeDestroy() {
      this.form.$emit("form-item-destroyed", this);
    },
    methods: {
      addWatch: function addWatch() {
        var _this2 = this;
        if (this.disabled === void 0) return;
        this.$watch("disabled", function (val) {
          _this2.$nextTick(function () {
            _this2.setChildrenDisabled(val, _this2.$children);
          });
        }, {
          immediate: true
        });
      },
      setChildrenDisabled: function setChildrenDisabled(disabled, children) {
        var _this3 = this;
        children.forEach(function (item) {
          var _this3$form$controlle, _item$$children;
          if ((_this3$form$controlle = _this3.form.controlledComponents) !== null && _this3$form$controlle !== void 0 && _this3$form$controlle.includes(item.$options.name)) {
            item.$data.formDisabled = disabled;
          }
          if ((_item$$children = item.$children) !== null && _item$$children !== void 0 && _item$$children.length) {
            _this3.setChildrenDisabled(disabled, item.$children);
          }
        });
      },
      setValidateMessage: function setValidateMessage(validateMessage) {
        if (!validateMessage || !Array.isArray(validateMessage)) return;
        if (validateMessage.length === 0) {
          this.errorList = [];
          this.verifyStatus = "success" /* SUCCESS */;
          return;
        }
        this.errorList = validateMessage;
        this.verifyStatus = "fail" /* FAIL */;
      },
      validate: function validate(trigger) {
        var _arguments = arguments,
          _this4 = this;
        return _asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee() {
          var showErrorMessage, source, _yield$_this4$analysi, errorList, resultList, successList, rules, allowSetValue;
          return regenerator.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                showErrorMessage = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : true;
                source = _arguments.length > 2 && _arguments[2] !== undefined ? _arguments[2] : "submit-event";
                _this4.freeShowErrorMessage = source === "submit-function" ? showErrorMessage : void 0;
                _this4.resetValidating = true;
                _context.next = 6;
                return _this4.analysisValidateResult(trigger);
              case 6:
                _yield$_this4$analysi = _context.sent;
                errorList = _yield$_this4$analysi.errorList;
                resultList = _yield$_this4$analysi.resultList;
                successList = _yield$_this4$analysi.successList;
                rules = _yield$_this4$analysi.rules;
                allowSetValue = _yield$_this4$analysi.allowSetValue;
                if (allowSetValue) {
                  _this4.errorList = errorList;
                  _this4.successList = successList;
                }
                if (rules.length) {
                  _this4.verifyStatus = errorList.length ? "fail" /* FAIL */ : "success" /* SUCCESS */;
                } else {
                  _this4.verifyStatus = "not" /* TO_BE_VALIDATED */;
                }
                if (_this4.needResetField) {
                  _this4.resetHandler();
                }
                _this4.resetValidating = false;
                return _context.abrupt("return", _defineProperty$2({}, _this4.name, errorList.length === 0 ? true : resultList));
              case 17:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }))();
      },
      validateOnly: function validateOnly(trigger) {
        var _this5 = this;
        return _asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee2() {
          var _yield$_this5$analysi, errorList, resultList;
          return regenerator.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this5.analysisValidateResult(trigger);
              case 2:
                _yield$_this5$analysi = _context2.sent;
                errorList = _yield$_this5$analysi.errorList;
                resultList = _yield$_this5$analysi.resultList;
                return _context2.abrupt("return", _defineProperty$2({}, _this5.name, errorList.length === 0 ? true : resultList));
              case 6:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }))();
      },
      analysisValidateResult: function analysisValidateResult(trigger) {
        var _this6 = this;
        return _asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee3() {
          var result;
          return regenerator.wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                result = {
                  successList: [],
                  errorList: [],
                  rules: [],
                  resultList: [],
                  allowSetValue: false
                };
                result.rules = trigger === "all" ? _this6.innerRules : _this6.innerRules.filter(function (item) {
                  var _item$trigger = item.trigger,
                    validateTrigger = _item$trigger === void 0 ? "change" : _item$trigger;
                  if (Array.isArray(validateTrigger)) {
                    return validateTrigger.includes(trigger);
                  }
                  return trigger === validateTrigger;
                });
                if (!(_this6.innerRules.length && !result.rules.length)) {
                  _context3.next = 4;
                  break;
                }
                return _context3.abrupt("return", result);
              case 4:
                result.allowSetValue = true;
                _context3.next = 7;
                return validate(_this6.value, result.rules);
              case 7:
                result.resultList = _context3.sent;
                result.errorList = result.resultList.filter(function (item) {
                  return item.result !== true;
                }).map(function (item) {
                  Object.keys(item).forEach(function (key) {
                    if (typeof item.message === "undefined" && _this6.errorMessages[key]) {
                      var compiled = template(_this6.errorMessages[key]);
                      var name = typeof _this6.label === "string" ? _this6.label : _this6.name;
                      item.message = compiled({
                        name: name,
                        validate: item[key]
                      });
                    }
                  });
                  return item;
                });
                result.successList = result.resultList.filter(function (item) {
                  return item.result === true && item.message && item.type === "success";
                });
                return _context3.abrupt("return", result);
              case 11:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }))();
      },
      getLabelContent: function getLabelContent() {
        if (typeof this.label === "function") {
          return this.label(this.$createElement);
        }
        if (typeof this.$scopedSlots.label === "function") {
          return this.$scopedSlots.label(null);
        }
        return this.label;
      },
      getLabel: function getLabel() {
        var h = this.$createElement;
        var parent = this.form;
        var labelWidth = isNil(this.labelWidth) ? parent === null || parent === void 0 ? void 0 : parent.labelWidth : this.labelWidth;
        var labelAlign = isNil(this.labelAlign) ? parent === null || parent === void 0 ? void 0 : parent.labelAlign : this.labelAlign;
        if (Number(labelWidth) === 0) return;
        var labelContent = this.getLabelContent();
        if (!labelContent) return null;
        var labelStyle = {};
        if (labelWidth && labelAlign !== "top") {
          if (typeof labelWidth === "number") {
            labelStyle = {
              width: "".concat(labelWidth, "px")
            };
          } else {
            labelStyle = {
              width: labelWidth
            };
          }
        }
        return h("div", {
          "class": this.labelClasses,
          "style": labelStyle
        }, [h("label", {
          "attrs": {
            "for": this["for"]
          }
        }, [labelContent]), this.hasColon && this.global.colonText]);
      },
      getDefaultIcon: function getDefaultIcon() {
        var _this7 = this;
        var h = this.$createElement;
        var resultIcon = function resultIcon(Icon) {
          return h("span", {
            "class": "".concat(_this7.componentName, "__status")
          }, [h(Icon)]);
        };
        var list = this.errorList;
        var _this$useGlobalIcon = this.useGlobalIcon({
            CheckCircleFilledIcon: TdCheckCircleFilledIcon,
            CloseCircleFilledIcon: TdCloseCircleFilledIcon,
            ErrorCircleFilledIcon: TdErrorCircleFilledIcon
          }),
          CheckCircleFilledIcon = _this$useGlobalIcon.CheckCircleFilledIcon,
          CloseCircleFilledIcon = _this$useGlobalIcon.CloseCircleFilledIcon,
          ErrorCircleFilledIcon = _this$useGlobalIcon.ErrorCircleFilledIcon;
        if (this.verifyStatus === "success" /* SUCCESS */) {
          return resultIcon(CheckCircleFilledIcon);
        }
        if (list && list[0]) {
          var type = list[0].type || "error";
          var icon = {
            error: CloseCircleFilledIcon,
            warning: ErrorCircleFilledIcon
          }[type] || CheckCircleFilledIcon;
          return resultIcon(icon);
        }
        return null;
      },
      getIcon: function getIcon(statusIcon, slotStatusIcon, props2) {
        var _this8 = this;
        var h = this.$createElement;
        var resultIcon = function resultIcon(otherContent) {
          return h("span", {
            "class": "".concat(_this8.componentName, "__status")
          }, [otherContent]);
        };
        if (statusIcon === true) {
          return this.getDefaultIcon();
        }
        if (typeof statusIcon === "function") {
          return resultIcon(statusIcon(this.$createElement, props2));
        }
        if (typeof slotStatusIcon === "function") {
          return resultIcon(slotStatusIcon(null));
        }
        return null;
      },
      getSuffixIcon: function getSuffixIcon() {
        var parent = this.form;
        var statusIcon = this.statusIcon;
        var slotStatusIcon = this.$scopedSlots.statusIcon;
        var parentStatusIcon = parent.statusIcon;
        var parentSlotStatusIcon = parent.$scopedSlots.statusIcon;
        if (statusIcon === false) return;
        var resultIcon = this.getIcon(statusIcon, slotStatusIcon);
        if (resultIcon) return resultIcon;
        if (resultIcon === false) return;
        resultIcon = this.getIcon(parentStatusIcon, parentSlotStatusIcon, this.$props);
        if (resultIcon) return resultIcon;
      },
      getEmptyValue: function getEmptyValue() {
        var parent = this.form;
        var type = Object.prototype.toString.call(get(parent.data, this.name));
        var emptyValue;
        if (type === "[object String]") {
          emptyValue = "";
        }
        if (type === "[object Array]") {
          emptyValue = [];
        }
        if (type === "[object Object]") {
          emptyValue = {};
        }
        return emptyValue;
      },
      resetField: function resetField() {
        var _this9 = this;
        var resetType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "initial";
        var parent = this.form;
        if (!this.name && this.label) {
          log.warn("Form", "name is required for validating.");
          return;
        }
        var tResetType = resetType || parent.resetType;
        if (tResetType === "empty") {
          set(parent.data, this.name, this.getEmptyValue());
        }
        if (tResetType === "initial") {
          set(parent.data, this.name, this.initialValue);
        }
        Vue__default["default"].nextTick(function () {
          if (_this9.resetValidating) {
            _this9.needResetField = true;
          } else {
            _this9.resetHandler();
          }
        });
      },
      resetHandler: function resetHandler() {
        this.needResetField = false;
        this.errorList = [];
        this.successList = [];
        this.verifyStatus = "not" /* TO_BE_VALIDATED */;
      }
    },
    render: function render() {
      var h = arguments[0];
      var helpNode = renderTNodeJSX(this, "help");
      var tipsNode = renderTNodeJSX(this, "tips");
      return h("div", {
        "class": this.classes
      }, [this.getLabel(), h("div", {
        "class": this.contentClasses,
        "style": this.contentStyle
      }, [h("div", {
        "class": "".concat(this.componentName, "__controls-content")
      }, [this.$slots["default"], this.getSuffixIcon()]), helpNode && h("div", {
        "class": "".concat(this.classPrefix, "-input__help")
      }, [helpNode]), tipsNode && h("div", {
        "class": ["".concat(this.componentName, "-tips"), "".concat(this.classPrefix, "-tips"), this.statusClass]
      }, [tipsNode]), this.extraNode])]);
    }
  });

  function ownKeys$1j(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1i(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1j(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1j(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$j = getClassPrefixMixins("form");
  var _Form = mixins(classPrefixMixins$j).extend({
    name: "TForm",
    props: _objectSpread$1i({}, props$B),
    provide: function provide() {
      return {
        form: this
      };
    },
    data: function data() {
      return {
        children: []
      };
    },
    computed: {
      formClass: function formClass() {
        return [this.componentName, _defineProperty$2({}, "".concat(this.componentName, "-inline"), this.layout === "inline")];
      },
      formDataKeys: function formDataKeys() {
        return keys(this.data);
      },
      controlledComponents: function controlledComponents() {
        var _this$formControlledC;
        var fields = FORM_CONTROL_COMPONENTS;
        if ((_this$formControlledC = this.formControlledComponents) !== null && _this$formControlledC !== void 0 && _this$formControlledC.length) {
          fields = fields.concat(this.formControlledComponents);
        }
        return fields;
      }
    },
    created: function created() {
      var _this = this;
      this.$on("form-item-created", function (formItem) {
        _this.children.push(formItem);
      });
      this.$on("form-item-destroyed", function (formItem) {
        var index = _this.children.findIndex(function (item) {
          return item === formItem;
        });
        _this.children.splice(index, 1);
      });
    },
    methods: {
      getFirstError: function getFirstError(r) {
        if (r === true) return;
        var _Object$keys = Object.keys(r),
          _Object$keys2 = _slicedToArray(_Object$keys, 1),
          firstKey = _Object$keys2[0];
        if (this.scrollToFirstError) {
          this.scrollTo(".".concat(getFormItemClassName(this.componentName, firstKey)));
        }
        return r[firstKey][0].message;
      },
      scrollTo: function scrollTo(selector) {
        var dom = this.$el.querySelector(selector);
        var behavior = this.scrollToFirstError;
        dom && dom.scrollIntoView({
          behavior: behavior
        });
      },
      isFunction: function isFunction(val) {
        return typeof val === "function";
      },
      needValidate: function needValidate(name, fields) {
        if (!fields || !Array.isArray(fields)) return true;
        return fields.indexOf(name) !== -1;
      },
      formatValidateResult: function formatValidateResult(arr) {
        if (!arr || !arr.length) return true;
        var r = arr.reduce(function (r2, err) {
          return Object.assign(r2 || {}, err);
        });
        Object.keys(r).forEach(function (key) {
          if (r[key] === true) {
            delete r[key];
          } else {
            r[key] = r[key].filter(function (fr) {
              return fr.result === false;
            });
          }
        });
        return isEmpty(r) ? true : r;
      },
      validate: function validate() {
        var _arguments = arguments,
          _this2 = this;
        return _asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee() {
          var param, source, _ref2, fields, _ref2$trigger, trigger, list, arr, result;
          return regenerator.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                param = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {
                  showErrorMessage: true
                };
                source = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : "submit-function";
                _ref2 = param || {}, fields = _ref2.fields, _ref2$trigger = _ref2.trigger, trigger = _ref2$trigger === void 0 ? "all" : _ref2$trigger;
                list = _this2.children.filter(function (child) {
                  return _this2.isFunction(child.validate) && _this2.needValidate(String(child.name), fields);
                }).map(function (child) {
                  return child.validate(trigger, param.showErrorMessage, source);
                });
                _context.next = 6;
                return Promise.all(list);
              case 6:
                arr = _context.sent;
                result = _this2.formatValidateResult(arr);
                emitEvent$1(_this2, "validate", {
                  validateResult: result,
                  firstError: _this2.getFirstError(result)
                });
                return _context.abrupt("return", result);
              case 10:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }))();
      },
      validateOnly: function validateOnly(param) {
        var _this3 = this;
        return _asyncToGenerator(/*#__PURE__*/regenerator.mark(function _callee2() {
          var _ref3, fields, _ref3$trigger, trigger, list, arr, result;
          return regenerator.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _ref3 = param || {}, fields = _ref3.fields, _ref3$trigger = _ref3.trigger, trigger = _ref3$trigger === void 0 ? "all" : _ref3$trigger;
                list = _this3.children.filter(function (child) {
                  return _this3.isFunction(child.validate) && _this3.needValidate(String(child.name), fields);
                }).map(function (child) {
                  return child.validateOnly(trigger);
                });
                _context2.next = 4;
                return Promise.all(list);
              case 4:
                arr = _context2.sent;
                result = _this3.formatValidateResult(arr);
                return _context2.abrupt("return", result);
              case 7:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }))();
      },
      setValidateMessage: function setValidateMessage(validateMessage) {
        var _this4 = this;
        var keys2 = Object.keys(validateMessage || {});
        if (!keys2.length) return;
        var list = this.children.filter(function (child) {
          return _this4.isFunction(child.setValidateMessage) && keys2.includes(String(child.name));
        }).map(function (child) {
          return child.setValidateMessage(validateMessage[child.name]);
        });
        Promise.all(list);
      },
      submitHandler: function submitHandler(e) {
        var _this5 = this;
        if (this.preventSubmitDefault) {
          e === null || e === void 0 || e.preventDefault();
          e === null || e === void 0 || e.stopPropagation();
        }
        this.validate({
          showErrorMessage: true
        }, "submit-event").then(function (r) {
          emitEvent$1(_this5, "submit", {
            validateResult: r,
            firstError: _this5.getFirstError(r),
            e: e
          });
        });
      },
      resetHandler: function resetHandler(e) {
        var _this6 = this;
        if (this.preventSubmitDefault) {
          e === null || e === void 0 || e.preventDefault();
          e === null || e === void 0 || e.stopPropagation();
        }
        this.children.filter(function (child) {
          return _this6.isFunction(child.resetField) && _this6.needValidate(String(child.name), _this6.formDataKeys);
        }).forEach(function (child) {
          return child.resetField(_this6.resetType || "initial");
        });
        emitEvent$1(this, "reset", {
          e: e
        });
      },
      clearValidate: function clearValidate(fields) {
        var _this7 = this;
        this.children.forEach(function (child) {
          if (_this7.isFunction(child.resetHandler) && _this7.needValidate(String(child.name), fields)) {
            child.resetHandler();
          }
        });
      },
      reset: function reset() {
        var _this8 = this;
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.children.filter(function (child) {
          return _this8.isFunction(child.resetField) && _this8.needValidate(String(child.name), _this8.formDataKeys);
        }).forEach(function (child) {
          var resetType = params.type || _this8.resetType || "initial";
          if (!params.fields || params.fields && params.fields.includes(child.name)) {
            child.resetField(resetType);
          }
        });
        emitEvent$1(this, "reset", {
          e: void 0
        });
      },
      submit: function submit(params) {
        var _this9 = this;
        this.validate({
          showErrorMessage: params === null || params === void 0 ? void 0 : params.showErrorMessage
        }, "submit-function").then(function (r) {
          emitEvent$1(_this9, "submit", {
            validateResult: r,
            firstError: _this9.getFirstError(r)
          });
        });
      }
    },
    render: function render() {
      var h = arguments[0];
      var on = {
        submit: this.submitHandler,
        reset: this.resetHandler
      };
      return h("form", {
        "ref": "form",
        "class": this.formClass,
        "on": _objectSpread$1i({}, on)
      }, [this.$slots["default"]]);
    }
  });

  var Form = withInstall$1(_Form);
  var FormItem = withInstall$1(_FormItem);

  var props$z = {
    disabled: Boolean,
    inputNumberProps: {
      type: [Boolean, Object],
      "default": false
    },
    label: {
      type: [String, Boolean, Function],
      "default": true
    },
    layout: {
      type: String,
      "default": "horizontal",
      validator: function validator(val) {
        if (!val) return true;
        return ["vertical", "horizontal"].includes(val);
      }
    },
    marks: {
      type: [Object, Array]
    },
    max: {
      type: Number,
      "default": 100
    },
    min: {
      type: Number,
      "default": 0
    },
    range: Boolean,
    step: {
      type: Number,
      "default": 1
    },
    tooltipProps: {
      type: Object
    },
    value: {
      type: [Number, Array]
    },
    defaultValue: {
      type: [Number, Array]
    },
    onChange: Function,
    onChangeEnd: Function
  };

  var classPrefixMixins$i = getClassPrefixMixins("slider");
  var TSliderMark = mixins(classPrefixMixins$i).extend({
    name: "TSliderMark",
    props: {
      mark: {
        type: [Object, Array, String]
      },
      point: {
        type: Number
      }
    },
    methods: {
      changeValue: function changeValue(event) {
        event.stopPropagation();
        this.$emit("change-value", this.point);
      }
    },
    render: function render() {
      var h = arguments[0];
      var label = this.mark;
      return h("div", {
        "class": "".concat(this.componentName, "__mark-text"),
        "on": {
          "click": this.changeValue
        }
      }, [label]);
    }
  });

  var formatLabel = function formatLabel(label, val) {
    if (Boolean(label) === false) {
      return String(val);
    }
    if (isString(label)) {
      var text = String(val);
      try {
        var rule = /\${value}%/g;
        var enableToReplace = rule.test(label);
        if (enableToReplace) {
          text = label.replace(/\${value}/g, String(val));
        } else {
          text = label;
          throw new Error();
        }
      } catch (e) {
        console.warn("fail to parse label prop, please pass string such as '${value}%'");
      }
      return text;
    }
    return label;
  };

  var classPrefixMixins$h = getClassPrefixMixins("slider__button");
  var TSliderButton = mixins(classPrefixMixins$h, Vue__default["default"]).extend({
    name: "TSliderButton",
    props: {
      value: {
        type: [Number, String],
        "default": 0
      },
      vertical: {
        type: Boolean,
        "default": false
      },
      popupClass: {
        type: String,
        "default": ""
      },
      tooltipProps: {
        type: [Boolean, Object],
        "default": true
      },
      label: {
        type: [String, Function, Boolean],
        "default": true
      },
      range: {
        type: Boolean,
        "default": false
      },
      position: {
        type: String
      }
    },
    inject: {
      slider: {
        "default": void 0
      }
    },
    computed: {
      placement: function placement() {
        if (this.tooltipProps instanceof Object) {
          var placement = this.tooltipProps.placement;
          if (placement) return placement;
        }
        return this.vertical ? "right" : "top";
      },
      rangeDiff: function rangeDiff() {
        return this.max - this.min;
      },
      disabled: function disabled() {
        return this.slider.disabled;
      },
      max: function max() {
        return this.slider.max;
      },
      min: function min() {
        return this.slider.min;
      },
      step: function step() {
        return this.slider.step;
      },
      precision: function precision() {
        return this.slider.precision;
      },
      currentPos: function currentPos() {
        return "".concat((this.value - this.min) / this.rangeDiff * 100, "%");
      },
      wrapperStyle: function wrapperStyle() {
        return this.vertical ? {
          bottom: this.currentPos
        } : {
          left: this.currentPos
        };
      }
    },
    data: function data() {
      return {
        visible: false,
        hovering: false,
        dragging: false,
        isClick: false,
        clientX: 0,
        clientY: 0,
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        startPos: 0,
        newPos: null,
        prevValue: this.value,
        showTooltip: true,
        trigger: "hover",
        showArrow: true,
        overlayInnerStyle: void 0,
        overlayClassName: void 0,
        attach: "body",
        destroyOnClose: null
      };
    },
    watch: {
      disabled: function disabled() {
        this.handleIE();
      }
    },
    mounted: function mounted() {
      this.showTooltip = !this.tooltipProps === false;
      this.setTooltipProps();
      this.handleIE();
    },
    methods: {
      getTooltipContent: function getTooltipContent() {
        if (this.label === true) return String(this.value);
        if (typeof this.label === "string") return formatLabel(this.label, this.value);
        return renderTNodeJSX(this, "label", {
          params: this.range ? {
            value: this.value,
            position: this.position
          } : {
            value: this.value
          }
        });
      },
      setTooltipProps: function setTooltipProps() {
        if (this.tooltipProps instanceof Object) {
          var _this$tooltipProps = this.tooltipProps,
            trigger = _this$tooltipProps.trigger,
            destroyOnClose = _this$tooltipProps.destroyOnClose,
            showArrow = _this$tooltipProps.showArrow,
            overlayInnerStyle = _this$tooltipProps.overlayInnerStyle,
            overlayClassName = _this$tooltipProps.overlayClassName,
            attach = _this$tooltipProps.attach;
          if (!this.empty(trigger)) {
            this.trigger = trigger;
          }
          this.destroyOnClose = destroyOnClose;
          if (!this.empty(showArrow)) {
            this.showArrow = showArrow;
          }
          this.overlayInnerStyle = overlayInnerStyle;
          this.overlayClassName = overlayClassName;
          if (!this.empty(attach)) {
            this.attach = attach;
          }
        }
      },
      getTooltipProps: function getTooltipProps() {
        if (this.tooltipProps instanceof Object) {
          return this.tooltipProps;
        }
        return {};
      },
      handleIE: function handleIE() {
        var _this = this;
        if (getIEVersion$1() <= 11) {
          this.$nextTick(function () {
            _this.$el.removeAttribute("disabled");
          });
        }
      },
      showTooltipComponent: function showTooltipComponent() {
        this.visible = true;
      },
      hideTooltipComponent: function hideTooltipComponent() {
        this.visible = false;
      },
      handleMouseEnter: function handleMouseEnter() {
        this.hovering = true;
        this.showTooltipComponent();
        this.$refs.button.focus();
      },
      handleMouseLeave: function handleMouseLeave() {
        this.hovering = false;
        if (!this.dragging) {
          this.hideTooltipComponent();
        }
      },
      onButtonDown: function onButtonDown(event) {
        if (this.disabled) {
          return;
        }
        event.preventDefault();
        this.onDragStart(event);
        window.addEventListener("mousemove", this.onDragging);
        window.addEventListener("mouseup", this.onDragEnd);
        window.addEventListener("touchmove", this.onDragging);
        window.addEventListener("touchend", this.onDragEnd);
        window.addEventListener("contextmenu", this.onDragEnd);
      },
      onNativeKeyDown: function onNativeKeyDown(e) {
        var code = e.code;
        e.preventDefault();
        if (code === "ArrowDown" || code === "ArrowLeft") {
          this.onKeyDown("sub");
        }
        if (code === "ArrowUp" || code === "ArrowRight") {
          this.onKeyDown("add");
        }
      },
      onLeftKeyDown: function onLeftKeyDown() {
        this.onKeyDown("sub");
      },
      onRightKeyDown: function onRightKeyDown() {
        this.onKeyDown("add");
      },
      onKeyDown: function onKeyDown(state) {
        if (this.disabled) {
          return;
        }
        var stepLength = this.step / this.rangeDiff * 100;
        if (state === "sub") {
          stepLength = -stepLength;
        }
        this.newPos = parseFloat(this.currentPos) + stepLength;
        this.setPosition(this.newPos);
      },
      onDragStart: function onDragStart(event) {
        this.dragging = true;
        this.isClick = true;
        var type = event.type;
        var clientY = event.clientY,
          clientX = event.clientX;
        if (type === "touchstart") {
          var touch = event.touches;
          var _ref = [touch[0].clientY, touch[0].clientX];
          clientY = _ref[0];
          clientX = _ref[1];
        }
        if (this.vertical) {
          this.startY = clientY;
        } else {
          this.startX = clientX;
        }
        this.startPos = parseFloat(this.currentPos);
        this.newPos = this.startPos;
      },
      onDragging: function onDragging(e) {
        var event = e;
        if (!this.dragging) {
          return;
        }
        this.isClick = false;
        this.showTooltipComponent();
        this.slider.resetSize();
        var diff = 0;
        var parentSliderSize = this.slider.sliderSize;
        if (this.vertical) {
          this.currentY = event.clientY;
          diff = this.startY - this.currentY;
        } else {
          this.currentX = event.clientX;
          diff = this.currentX - this.startX;
        }
        if (event.type === "touchmove") {
          var touch = event.touches;
          var _ref2 = [touch[0].clientY, touch[0].clientX],
            clientY = _ref2[0],
            clientX = _ref2[1];
          this.clientY = clientY;
          this.clientX = clientX;
        }
        diff = diff / parentSliderSize * 100;
        this.newPos = this.startPos + diff;
        this.setPosition(this.newPos);
      },
      onDragEnd: function onDragEnd() {
        var _this2 = this;
        if (this.dragging) {
          setTimeout(function () {
            _this2.dragging = false;
            _this2.hideTooltipComponent();
          }, 0);
          window.removeEventListener("mousemove", this.onDragging);
          window.removeEventListener("touchmove", this.onDragging);
          window.removeEventListener("mouseup", this.onDragEnd);
          window.removeEventListener("touchend", this.onDragEnd);
          window.removeEventListener("contextmenu", this.onDragEnd);
          this.$emit("mouseup");
        }
      },
      setPosition: function setPosition(pos) {
        var _this3 = this;
        var newPos = pos;
        if (newPos === null || isNaN(newPos)) {
          return;
        }
        if (newPos > 100) {
          newPos = 100;
        } else if (newPos < 0) {
          newPos = 0;
        }
        var perStepLen = 100 * this.step / this.rangeDiff;
        var steps = Math.round(newPos / perStepLen);
        var value = steps * perStepLen * this.rangeDiff * 0.01;
        value += this.min;
        value = Number(parseFloat("".concat(value)).toFixed(this.precision));
        this.$emit("input", value);
        this.$nextTick(function () {
          _this3.showTooltipComponent();
          _this3.$refs.tooltip && _this3.$refs.tooltip.updatedTooltip();
        });
        if (!this.dragging && this.value !== this.prevValue) {
          this.prevValue = this.value;
        }
      },
      empty: function empty(str) {
        return str === void 0 || str === null;
      }
    },
    render: function render() {
      var h = arguments[0];
      return h("div", {
        "ref": "button",
        "class": "".concat(this.componentName, "-wrapper"),
        "style": this.wrapperStyle,
        "attrs": {
          "tabindex": "0",
          "show-tooltip": this.showTooltip
        },
        "on": {
          "mouseenter": this.handleMouseEnter,
          "mouseleave": this.handleMouseLeave,
          "mousedown": this.onButtonDown,
          "touchstart": this.onButtonDown,
          "focus": this.handleMouseEnter,
          "blur": this.handleMouseLeave,
          "keydown": this.onNativeKeyDown
        }
      }, [h(Tooltip, helper([{
        "ref": "tooltip",
        "attrs": {
          "hideEmptyPopup": true
        }
      }, {
        "props": this.getTooltipProps()
      }, {
        "attrs": {
          "visible": this.label && this.visible,
          "content": this.getTooltipContent
        }
      }]), [h("div", {
        "class": [this.componentName, _defineProperty$2({}, "".concat(this.componentName, "--dragging"), this.dragging)]
      })])]);
    }
  });

  function ownKeys$1i(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1h(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1i(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1i(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$g = getClassPrefixMixins("slider");
  var _Slider = mixins(classPrefixMixins$g).extend({
    name: "TSlider",
    model: {
      prop: "value",
      event: "change"
    },
    props: _objectSpread$1h({}, props$z),
    components: {
      TSliderMark: TSliderMark,
      TInputNumber: InputNumber
    },
    provide: function provide() {
      return {
        slider: this
      };
    },
    data: function data() {
      return {
        firstValue: 0,
        secondValue: 0,
        prevValue: 0,
        dragging: false,
        sliderSize: 1,
        inputDecimalPlaces: 0,
        inputFormat: null,
        inputPlaceholder: "",
        inputTheme: "column",
        showSteps: false,
        formDisabled: void 0
      };
    },
    computed: {
      tDisabled: function tDisabled() {
        return this.formDisabled || this.disabled;
      },
      containerClass: function containerClass() {
        return ["".concat(this.componentName, "__container"), {
          "is-vertical": this.vertical
        }];
      },
      sliderClass: function sliderClass() {
        return ["".concat(this.componentName), _defineProperty$2(_defineProperty$2(_defineProperty$2({
          "is-vertical": this.vertical
        }, "".concat(this.componentName, "--with-input"), this.inputNumberProps), "".concat(this.componentName, "--vertical"), this.vertical), "".concat(this.classPrefix, "-is-disabled"), this.tDisabled)];
      },
      sliderRailClass: function sliderRailClass() {
        return ["".concat(this.componentName, "__rail"), _defineProperty$2({
          "show-input": this.inputNumberProps
        }, "".concat(this.classPrefix, "-is-disabled"), this.tDisabled)];
      },
      sliderNumberClass: function sliderNumberClass() {
        return ["".concat(this.componentName, "__input"), {
          "is-vertical": this.vertical
        }];
      },
      vertical: function vertical() {
        return this.layout === "vertical";
      },
      rangeDiff: function rangeDiff() {
        return this.max - this.min;
      },
      steps: function steps() {
        var _this = this;
        var min = this.min,
          max = this.max,
          rangeDiff = this.rangeDiff,
          step = this.step;
        if (!this.showSteps || min > max) return [];
        if (this.step === 0) {
          console.warn("[Element Warn][Slider]step should not be 0.");
          return [];
        }
        var stepCount = rangeDiff / step;
        var stepWidth = 100 * step / rangeDiff;
        var result = [];
        for (var i = 1; i < stepCount; i++) {
          result.push(i * stepWidth);
        }
        if (this.range) {
          return result.filter(function (step2) {
            return step2 < 100 * (_this.minValue - min) / rangeDiff || step2 > 100 * (_this.maxValue - min) / rangeDiff;
          });
        }
        return result.filter(function (step2) {
          return step2 > 100 * (_this.firstValue - min) / rangeDiff;
        });
      },
      markList: function markList() {
        var _this2 = this;
        if (!this.marks) {
          return [];
        }
        var legalMarks = [];
        Object.keys(this.marks).map(parseFloat).sort(function (a, b) {
          return a - b;
        }).filter(function (point) {
          return point <= _this2.max && point >= _this2.min;
        }).forEach(function (point) {
          var item = {
            point: point,
            position: (point - _this2.min) * 100 / _this2.rangeDiff,
            mark: _this2.marks[point]
          };
          legalMarks.push(item);
        });
        return legalMarks;
      },
      minValue: function minValue() {
        return Math.min(this.firstValue, this.secondValue);
      },
      maxValue: function maxValue() {
        return Math.max(this.firstValue, this.secondValue);
      },
      barSize: function barSize() {
        var diff = this.range ? this.maxValue - this.minValue : this.prevValue - this.min;
        return "".concat(100 * diff / this.rangeDiff, "%");
      },
      barStart: function barStart() {
        return this.range ? "".concat(100 * (this.minValue - this.min) / this.rangeDiff, "%") : "0%";
      },
      precision: function precision() {
        var precisions = [this.min, this.max, this.step].map(function (item) {
          var decimalArr = "".concat(item).split(".");
          return decimalArr[1] ? decimalArr[1].length : 0;
        });
        return Math.max.apply(null, precisions);
      },
      runwayStyle: function runwayStyle() {
        return this.vertical ? {
          height: "100%"
        } : {};
      },
      barStyle: function barStyle() {
        return this.vertical ? {
          height: this.barSize,
          bottom: this.barStart
        } : {
          width: this.barSize,
          left: this.barStart
        };
      },
      calcInputNumberProps: function calcInputNumberProps() {
        var defaultInputNumberProps = {
          placeholder: "",
          theme: "column"
        };
        if (_typeof$2(this.inputNumberProps) === "object") {
          return _objectSpread$1h(_objectSpread$1h({}, defaultInputNumberProps), this.inputNumberProps);
        }
        return defaultInputNumberProps;
      }
    },
    watch: {
      value: function value(newVal) {
        if (this.dragging === true) return;
        if (Array.isArray(newVal) && this.range) {
          var _newVal = _slicedToArray(newVal, 2);
          this.firstValue = _newVal[0];
          this.secondValue = _newVal[1];
        } else {
          this.prevValue = newVal;
        }
      },
      dragging: function dragging(newVal) {
        if (newVal === false) {
          this.init();
        }
      }
    },
    mounted: function mounted() {
      this.init();
    },
    beforeDestroy: function beforeDestroy() {
      window.removeEventListener("resize", this.resetSize);
    },
    methods: {
      init: function init() {
        var valuetext;
        var min = this.min,
          max = this.max,
          value = this.value;
        if (this.range) {
          if (Array.isArray(value)) {
            var _value$, _value$2;
            this.firstValue = Math.max(min || 0, (_value$ = value[0]) !== null && _value$ !== void 0 ? _value$ : 0);
            this.secondValue = Math.min(max || 100, (_value$2 = value[1]) !== null && _value$2 !== void 0 ? _value$2 : 0);
          } else {
            this.firstValue = min || 0;
            this.secondValue = max || 100;
          }
          valuetext = "".concat(this.firstValue, "-").concat(this.secondValue);
        } else {
          if (typeof this.value !== "number") {
            this.prevValue = min;
          } else {
            this.prevValue = Math.min(max, Math.max(min, value));
          }
          valuetext = String(this.prevValue);
        }
        this.$el.setAttribute("aria-valuetext", valuetext);
        this.resetSize();
        window.addEventListener("resize", this.resetSize);
      },
      valueChanged: function valueChanged() {
        var _this3 = this;
        if (this.range) {
          return ![this.minValue, this.maxValue].every(function (item, index) {
            return item === _this3.prevValue[index];
          });
        }
        return this.value !== this.prevValue;
      },
      setValues: function setValues(value) {
        var _ref3 = [this.min, this.max],
          min = _ref3[0],
          max = _ref3[1];
        if (min > max) {
          console.warn("[Slider] max should be greater than min.");
          return;
        }
        if (this.range && Array.isArray(value)) {
          var _ref4 = [Math.min.apply(Math, _toConsumableArray(value)), Math.max.apply(Math, _toConsumableArray(value))],
            firstValue = _ref4[0],
            secondValue = _ref4[1];
          if (firstValue > max) firstValue = this.firstValue;
          if (firstValue < min) firstValue = min;
          if (secondValue < min) secondValue = this.secondValue;
          if (secondValue > max) secondValue = max;
          return [firstValue, secondValue];
        }
        var prevValue = value;
        if (prevValue < min) prevValue = min;
        if (prevValue > max) prevValue = max;
        return prevValue;
      },
      setPosition: function setPosition(percent) {
        var targetValue = percent * this.rangeDiff / 100;
        targetValue = this.min + targetValue;
        if (!this.range) {
          this.$refs.button1.setPosition(percent);
          return;
        }
        var button;
        if (Math.abs(this.minValue - targetValue) < Math.abs(this.maxValue - targetValue)) {
          button = this.firstValue < this.secondValue ? "button1" : "button2";
        } else {
          button = this.firstValue > this.secondValue ? "button1" : "button2";
        }
        this.$refs[button].setPosition(percent);
      },
      onSliderClick: function onSliderClick(event) {
        if (this.tDisabled || this.dragging) {
          return;
        }
        this.resetSize();
        var value = 0;
        if (this.vertical) {
          var sliderOffsetBottom = this.$refs.slider.getBoundingClientRect().bottom;
          value = (sliderOffsetBottom - event.clientY) / this.sliderSize * 100;
          this.setPosition(value);
        } else {
          var sliderOffsetLeft = this.$refs.slider.getBoundingClientRect().left;
          value = (event.clientX - sliderOffsetLeft) / this.sliderSize * 100;
          this.setPosition(value);
        }
      },
      resetSize: function resetSize() {
        if (this.$refs.slider) {
          this.sliderSize = this.$refs.slider["client".concat(this.vertical ? "Height" : "Width")];
        }
      },
      emitChange: function emitChange(value) {
        var changeValue = value;
        if (changeValue === void 0) {
          if (this.range) {
            changeValue = [this.firstValue, this.secondValue];
          } else {
            changeValue = this.prevValue;
          }
        }
        var fixValue = this.setValues(changeValue);
        emitEvent$1(this, "change", fixValue);
      },
      emitChangeEnd: function emitChangeEnd() {
        emitEvent$1(this, "change-end", this.value);
      },
      getStopStyle: function getStopStyle(position) {
        return this.vertical ? {
          top: "calc(".concat(100 - position, "% - 1px)")
        } : {
          left: "".concat(position, "%")
        };
      },
      changeValue: function changeValue(point) {
        if (this.tDisabled || this.dragging) {
          return;
        }
        this.resetSize();
        var value = Number(point / this.rangeDiff * 100);
        this.setPosition(value);
        this.emitChange(point);
      },
      renderMask: function renderMask() {
        var _this4 = this;
        var h = this.$createElement;
        if (this.markList.length) {
          return h("div", [h("div", {
            "class": "".concat(this.componentName, "__stops")
          }, [this.markList.map(function (item, index) {
            if (item.position === 0 || item.position === 100) return null;
            return h("div", {
              "class": ["".concat(_this4.componentName, "__stop"), "".concat(_this4.componentName, "__mark-stop")],
              "style": _this4.getStopStyle(item.position),
              "key": index
            });
          })]), h("div", {
            "class": "".concat(this.componentName, "__mark")
          }, [this.markList.map(function (item, key) {
            return h("t-slider-mark", {
              "attrs": {
                "mark": item.mark,
                "point": item.point
              },
              "key": key,
              "style": _this4.getStopStyle(item.position),
              "on": {
                "change-value": _this4.changeValue
              }
            });
          })])]);
        }
      },
      renderInputButton: function renderInputButton() {
        var _this5 = this;
        var h = this.$createElement;
        var max = this.max,
          min = this.min,
          sliderNumberClass = this.sliderNumberClass,
          range = this.range;
        return h("div", {
          "class": ["".concat(this.componentName, "__input-container"), {
            "is-vertical": this.vertical
          }]
        }, [h("t-input-number", helper([{
          "class": sliderNumberClass,
          "attrs": {
            "value": range ? this.firstValue : this.prevValue,
            "step": this.step,
            "disabled": this.tDisabled,
            "min": min,
            "max": max
          },
          "ref": "input",
          "on": {
            "change": function change(v) {
              _this5.range ? _this5.emitChange([v, _this5.secondValue]) : _this5.emitChange(v);
            }
          }
        }, {
          "props": this.calcInputNumberProps
        }])), range && h("div", {
          "class": "".concat(this.componentName, "__center-line")
        }), range && h("t-input-number", helper([{
          "class": this.sliderNumberClass,
          "attrs": {
            "value": this.secondValue,
            "step": this.step,
            "disabled": this.tDisabled,
            "min": min,
            "max": max
          },
          "ref": "input",
          "on": {
            "input": function input(v) {
              _this5.emitChange([_this5.firstValue, v]);
            }
          }
        }, {
          "props": this.calcInputNumberProps
        }]))]);
      }
    },
    render: function render() {
      var _this6 = this;
      var h = arguments[0];
      var min = this.min,
        max = this.max,
        layout = this.layout,
        disabled = this.disabled,
        vertical = this.vertical,
        range = this.range;
      var buttonGroup = this.inputNumberProps && this.renderInputButton();
      var masks = this.renderMask();
      return h("div", {
        "class": this.containerClass
      }, [h("div", {
        "class": this.sliderClass,
        "attrs": {
          "role": "slider",
          "aria-valuemin": min,
          "aria-valuemax": max,
          "aria-orientation": layout,
          "aria-disabled": disabled,
          "tooltip-props": this.tooltipProps
        }
      }, [h("div", {
        "class": this.sliderRailClass,
        "style": this.runwayStyle,
        "on": {
          "click": this.onSliderClick
        },
        "ref": "slider"
      }, [h("div", {
        "class": "".concat(this.componentName, "__track"),
        "style": this.barStyle
      }), h(TSliderButton, {
        "attrs": {
          "vertical": vertical,
          "value": range ? this.firstValue : this.prevValue,
          "disabled": this.tDisabled,
          "label": this.label,
          "range": this.range,
          "position": "start",
          "tooltip-props": this.tooltipProps
        },
        "ref": "button1",
        "on": {
          "input": function input(v) {
            range ? _this6.emitChange([v, _this6.secondValue]) : _this6.emitChange(v);
          },
          "mouseup": this.emitChangeEnd
        }
      }), this.range && h(TSliderButton, {
        "attrs": {
          "vertical": vertical,
          "value": this.secondValue,
          "disabled": this.tDisabled,
          "range": this.range,
          "position": "end",
          "label": this.label,
          "tooltip-props": this.tooltipProps
        },
        "ref": "button2",
        "on": {
          "input": function input(v) {
            _this6.emitChange([_this6.firstValue, v]);
          },
          "mouseup": this.emitChangeEnd
        }
      }), this.showSteps && h("div", {
        "class": "".concat(this.componentName, "__stops")
      }, [this.steps.map(function (item, key) {
        if (item.position === 0 || item.position === 100) return null;
        return h("div", {
          "class": "".concat(_this6.componentName, "__stop"),
          "key": key,
          "style": _this6.getStopStyle(item)
        });
      })]), masks])]), buttonGroup]);
    }
  });

  var Slider = withInstall$1(mapProps(["value"], {
    model: {
      prop: "value",
      event: "change"
    }
  })(_Slider));

  var props$y = {
    beforeChange: {
      type: Function
    },
    customValue: {
      type: Array
    },
    disabled: Boolean,
    label: {
      type: [Array, Function],
      "default": function _default() {
        return [];
      }
    },
    loading: Boolean,
    size: {
      type: String,
      "default": "medium",
      validator: function validator(val) {
        return ["small", "medium", "large"].includes(val);
      }
    },
    value: {
      type: [String, Number, Boolean],
      "default": false
    },
    defaultValue: {
      type: [String, Number, Boolean],
      "default": false
    },
    onChange: Function
  };

  function ownKeys$1h(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1g(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1h(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1h(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$f = getClassPrefixMixins("switch");
  var _Switch = mixins(classPrefixMixins$f).extend({
    name: "TSwitch",
    props: _objectSpread$1g({}, props$y),
    model: {
      prop: "value",
      event: "change"
    },
    data: function data() {
      return {
        formDisabled: void 0
      };
    },
    computed: {
      classes: function classes() {
        return ["".concat(this.componentName), this.commonSizeClassName[this.size], _defineProperty$2(_defineProperty$2(_defineProperty$2({}, this.commonStatusClassName.disabled, this.tDisabled), this.commonStatusClassName.loading, this.loading), this.commonStatusClassName.checked, this.value === this.activeValue)];
      },
      nodeClasses: function nodeClasses() {
        return ["".concat(this.componentName, "__handle"), _defineProperty$2(_defineProperty$2({}, this.commonStatusClassName.disabled, this.tDisabled), this.commonStatusClassName.loading, this.loading)];
      },
      contentClasses: function contentClasses() {
        return ["".concat(this.componentName, "__content"), this.commonSizeClassName[this.size], _defineProperty$2({}, this.commonStatusClassName.disabled, this.tDisabled)];
      },
      tDisabled: function tDisabled() {
        return this.formDisabled || this.disabled;
      },
      activeValue: function activeValue() {
        if (this.customValue && this.customValue.length > 0) {
          return this.customValue[0];
        }
        return true;
      },
      inactiveValue: function inactiveValue() {
        if (this.customValue && this.customValue.length > 1) {
          return this.customValue[1];
        }
        return false;
      },
      content: function content() {
        if (typeof this.label === "function") {
          return this.label(this.$createElement, {
            value: this.value
          });
        }
        if (typeof this.label === "string") {
          return this.label;
        }
        if (Array.isArray(this.label)) {
          var label = this.value === this.activeValue ? this.label[0] : this.label[1];
          if (!label) return;
          if (typeof label === "string") {
            return label;
          }
          if (typeof label === "function") {
            return label(this.$createElement);
          }
        }
        if (this.$scopedSlots.label) {
          return this.$scopedSlots.label({
            value: this.value
          });
        }
        return null;
      }
    },
    watch: {
      value: {
        handler: function handler(val) {
          if (this.customValue && this.customValue.length && !this.customValue.includes(val)) {
            throw "value is not in ".concat(JSON.stringify(this.customValue));
          }
        },
        immediate: true
      }
    },
    methods: {
      handleToggle: function handleToggle() {
        var checked = this.value === this.activeValue ? this.inactiveValue : this.activeValue;
        typeof this.onChange === "function" && this.onChange(checked);
        this.$emit("change", checked);
      },
      toggle: function toggle() {
        var _this = this;
        if (this.tDisabled || this.loading) {
          return;
        }
        if (!this.beforeChange) {
          this.handleToggle();
          return;
        }
        Promise.resolve(this.beforeChange()).then(function (v) {
          if (v) {
            _this.handleToggle();
          }
        })["catch"](function (e) {
          throw new Error("Switch: some error occurred: ".concat(e));
        });
      }
    },
    render: function render() {
      var h = arguments[0];
      var loading = this.loading,
        disabled = this.disabled,
        content = this.content,
        nodeClasses = this.nodeClasses,
        classes = this.classes,
        toggle = this.toggle,
        contentClasses = this.contentClasses;
      var switchContent;
      var loadingContent;
      if (loading) {
        loadingContent = h(Loading, {
          "attrs": {
            "size": "small"
          }
        });
      } else if (content) {
        switchContent = content;
      }
      return h("div", {
        "class": classes,
        "attrs": {
          "disabled": disabled
        },
        "on": {
          "click": toggle
        }
      }, [h("span", {
        "class": nodeClasses
      }, [loadingContent]), h("div", {
        "class": contentClasses
      }, [switchContent])]);
    }
  });

  var Switch = withInstall$1(mapProps(["value"], {
    model: {
      prop: "value",
      event: "change"
    }
  })(_Switch));

  var hiddenTextarea;
  var HIDDEN_TEXTAREA_STYLE = "\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow-y:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n";
  var SIZING_PROPS = ["letter-spacing", "line-height", "padding-top", "padding-bottom", "font-family", "font-weight", "font-size", "font-variant", "text-rendering", "text-transform", "width", "text-indent", "padding-left", "padding-right", "border-width", "box-sizing"];
  function calculateNodeStyling(targetElement) {
    var style = window.getComputedStyle(targetElement);
    var boxSizing = style.getPropertyValue("box-sizing") || style.getPropertyValue("-moz-box-sizing") || style.getPropertyValue("-webkit-box-sizing");
    var paddingSize = parseFloat(style.getPropertyValue("padding-bottom")) + parseFloat(style.getPropertyValue("padding-top"));
    var borderSize = parseFloat(style.getPropertyValue("border-bottom-width")) + parseFloat(style.getPropertyValue("border-top-width"));
    var sizingStyle = SIZING_PROPS.map(function (name) {
      return "".concat(name, ":").concat(style.getPropertyValue(name));
    }).join(";");
    return {
      sizingStyle: sizingStyle,
      paddingSize: paddingSize,
      borderSize: borderSize,
      boxSizing: boxSizing
    };
  }
  function calcTextareaHeight(targetElement) {
    var minRows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var maxRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    if (!hiddenTextarea) {
      hiddenTextarea = document.createElement("textarea");
      document.body.appendChild(hiddenTextarea);
    }
    var _calculateNodeStyling = calculateNodeStyling(targetElement),
      paddingSize = _calculateNodeStyling.paddingSize,
      borderSize = _calculateNodeStyling.borderSize,
      boxSizing = _calculateNodeStyling.boxSizing,
      sizingStyle = _calculateNodeStyling.sizingStyle;
    hiddenTextarea.setAttribute("style", "".concat(sizingStyle, ";").concat(HIDDEN_TEXTAREA_STYLE));
    hiddenTextarea.value = targetElement.value || targetElement.placeholder || "";
    var height = hiddenTextarea.scrollHeight;
    var result = {};
    if (boxSizing === "border-box") {
      height += borderSize;
    } else if (boxSizing === "content-box") {
      height -= paddingSize;
    }
    hiddenTextarea.value = "";
    var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
    if (minRows !== null) {
      var minHeight = singleRowHeight * minRows;
      if (boxSizing === "border-box") {
        minHeight = minHeight + paddingSize + borderSize;
      }
      height = Math.max(minHeight, height);
      result.minHeight = "".concat(minHeight, "px");
    }
    if (maxRows !== null) {
      var maxHeight = singleRowHeight * maxRows;
      if (boxSizing === "border-box") {
        maxHeight = maxHeight + paddingSize + borderSize;
      }
      height = Math.min(maxHeight, height);
    }
    result.height = "".concat(height, "px");
    hiddenTextarea.parentNode && hiddenTextarea.parentNode.removeChild(hiddenTextarea);
    hiddenTextarea = null;
    return result;
  }

  var props$x = {
    autofocus: Boolean,
    autosize: {
      type: [Boolean, Object],
      "default": false
    },
    disabled: Boolean,
    maxcharacter: {
      type: Number
    },
    maxlength: {
      type: [Number, String]
    },
    name: {
      type: String,
      "default": ""
    },
    placeholder: {
      type: String,
      "default": void 0
    },
    readonly: Boolean,
    status: {
      type: String,
      validator: function validator(val) {
        return ["default", "success", "warning", "error"].includes(val);
      }
    },
    tips: {
      type: [String, Function]
    },
    value: {
      type: [String, Number]
    },
    defaultValue: {
      type: [String, Number]
    },
    onBlur: Function,
    onChange: Function,
    onFocus: Function,
    onKeydown: Function,
    onKeypress: Function,
    onKeyup: Function
  };

  function ownKeys$1g(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1f(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1g(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1g(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$e = getClassPrefixMixins("textarea");
  function getValidAttrs(obj) {
    var newObj = {};
    Object.keys(obj).forEach(function (key) {
      if (typeof obj[key] !== "undefined") {
        newObj[key] = obj[key];
      }
    });
    return newObj;
  }
  var _Textarea = mixins(Vue__default["default"], classPrefixMixins$e).extend({
    name: "TTextarea",
    props: _objectSpread$1f({}, props$x),
    inject: {
      tFormItem: {
        "default": void 0
      }
    },
    data: function data() {
      return {
        formDisabled: void 0,
        focused: false,
        mouseHover: false,
        textareaStyle: {},
        isComposing: false
      };
    },
    computed: {
      tDisabled: function tDisabled() {
        return this.formDisabled || this.disabled;
      },
      textareaClasses: function textareaClasses() {
        return [this.componentName, _defineProperty$2(_defineProperty$2({}, "".concat(this.classPrefix, "-is-disabled"), this.tDisabled), "".concat(this.classPrefix, "-is-readonly"), this.readonly)];
      },
      limitClasses: function limitClasses() {
        return ["".concat(this.componentName, "__limit"), _defineProperty$2({}, "".concat(this.classPrefix, "-is-disabled"), this.tDisabled)];
      },
      inputAttrs: function inputAttrs() {
        return getValidAttrs({
          autofocus: this.autofocus,
          disabled: this.tDisabled,
          readonly: this.readonly,
          placeholder: this.placeholder,
          name: this.name || void 0,
          unselectable: this.readonly ? "on" : "off"
        });
      },
      characterNumber: function characterNumber() {
        var characterInfo = getCharacterLength(String(this.value || ""));
        if (_typeof$2(characterInfo) === "object") {
          return characterInfo.length;
        }
        return characterInfo;
      }
    },
    mounted: function mounted() {
      var textareaElem = this.$refs.refTextareaElem;
      if (textareaElem) {
        textareaElem.addEventListener("transitionend", this.adjustTextareaHeightAfterReady);
      } else {
        this.adjustTextareaHeightAfterReady();
      }
    },
    beforeDestroy: function beforeDestroy() {
      var textareaElem = this.$refs.refTextareaElem;
      if (textareaElem) {
        textareaElem.removeEventListener("transitionend", this.adjustTextareaHeightAfterReady);
      }
    },
    watch: {
      autofocus: {
        handler: function handler(val) {
          var _this = this;
          if (val === true) {
            this.$nextTick(function () {
              var textArea = _this.$refs.refTextareaElem;
              textArea === null || textArea === void 0 || textArea.focus();
            });
          }
        },
        immediate: true
      },
      value: {
        handler: function handler() {
          var _this2 = this;
          this.$nextTick(function () {
            return _this2.adjustTextareaHeight();
          });
        },
        immediate: true
      },
      textareaStyle: {
        handler: function handler(val) {
          var style = this.$attrs.style;
          setStyle(this.$refs.refTextareaElem, merge$1(style, val));
        },
        immediate: true
      }
    },
    methods: {
      adjustTextareaHeight: function adjustTextareaHeight() {
        var _this3 = this;
        this.$nextTick(function () {
          if (!_this3.$refs.refTextareaElem) return;
          if (_this3.autosize === true) {
            _this3.textareaStyle = calcTextareaHeight(_this3.$refs.refTextareaElem);
          } else if (_this3.autosize && _typeof$2(_this3.autosize) === "object") {
            var _this3$autosize, _this3$autosize2;
            _this3.textareaStyle = calcTextareaHeight(_this3.$refs.refTextareaElem, (_this3$autosize = _this3.autosize) === null || _this3$autosize === void 0 ? void 0 : _this3$autosize.minRows, (_this3$autosize2 = _this3.autosize) === null || _this3$autosize2 === void 0 ? void 0 : _this3$autosize2.maxRows);
          } else if (_this3.$attrs.rows) {
            _this3.textareaStyle = {
              height: "auto",
              minHeight: "auto"
            };
          }
        });
      },
      adjustTextareaHeightAfterReady: function adjustTextareaHeightAfterReady() {
        var _this4 = this;
        this.$nextTick(function () {
          return _this4.adjustTextareaHeight();
        });
      },
      emitEvent: function emitEvent(name, value, context) {
        this.$emit(name, value, context);
        var handleName = getPropsApiByEvent(name);
        isFunction(this[handleName]) && this[handleName](value, context);
      },
      focus: function focus() {
        var textArea = this.$refs.refTextareaElem;
        textArea === null || textArea === void 0 || textArea.focus();
      },
      blur: function blur() {
        var textArea = this.$refs.refTextareaElem;
        textArea === null || textArea === void 0 || textArea.blur();
      },
      handleInput: function handleInput(e) {
        this.inputValueChangeHandle(e);
      },
      onCompositionstart: function onCompositionstart() {
        this.isComposing = true;
      },
      onCompositionend: function onCompositionend(e) {
        this.isComposing = false;
        this.inputValueChangeHandle(e);
      },
      inputValueChangeHandle: function inputValueChangeHandle(e) {
        var _this5 = this;
        var target = e.target;
        var val = target.value;
        if (!this.isComposing) {
          if (this.maxlength) {
            val = limitUnicodeMaxLength(val, Number(this.maxlength));
          }
          if (this.maxcharacter && this.maxcharacter >= 0) {
            var stringInfo = getCharacterLength(val, this.maxcharacter);
            val = _typeof$2(stringInfo) === "object" && stringInfo.characters;
          }
        }
        this.$emit("input", val);
        if (!this.isComposing) {
          this.emitEvent("change", val, {
            e: e
          });
        }
        this.$nextTick(function () {
          return _this5.setInputValue(val);
        });
        this.adjustTextareaHeight();
      },
      setInputValue: function setInputValue() {
        var v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        var textareaElem = this.$refs.refTextareaElem;
        var sV = String(v);
        if (!textareaElem) {
          return;
        }
        if (textareaElem.value !== sV) {
          textareaElem.value = sV;
        }
      },
      emitKeyDown: function emitKeyDown(e) {
        if (this.tDisabled) return;
        this.emitEvent("keydown", this.value, {
          e: e
        });
      },
      emitKeyUp: function emitKeyUp(e) {
        if (this.tDisabled) return;
        this.emitEvent("keyup", this.value, {
          e: e
        });
      },
      emitKeypress: function emitKeypress(e) {
        if (this.tDisabled) return;
        this.emitEvent("keypress", this.value, {
          e: e
        });
      },
      emitFocus: function emitFocus(e) {
        if (this.tDisabled) return;
        this.focused = true;
        this.emitEvent("focus", this.value, {
          e: e
        });
      },
      emitBlur: function emitBlur(e) {
        var _this$tFormItem;
        this.focused = false;
        (_this$tFormItem = this.tFormItem) === null || _this$tFormItem === void 0 || _this$tFormItem.validate("blur");
        this.emitEvent("blur", this.value, {
          e: e
        });
      }
    },
    render: function render() {
      var h = arguments[0];
      var inputEvents = getValidAttrs({
        focus: this.emitFocus,
        blur: this.emitBlur,
        keydown: this.emitKeyDown,
        keyup: this.emitKeyUp,
        keypress: this.emitKeypress
      });
      var classes = ["".concat(this.componentName, "__inner"), _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({}, "".concat(this.classPrefix, "-is-").concat(this.status), this.status), this.commonStatusClassName.disabled, this.tDisabled), this.commonStatusClassName.focused, this.focused), "".concat(this.classPrefix, "-resize-none"), _typeof$2(this.autosize) === "object")];
      var tips = renderTNodeJSX(this, "tips");
      var textTips = tips && h("div", {
        "class": ["".concat(this.componentName, "__tips"), "".concat(this.componentName, "__tips--").concat(this.status || "normal")]
      }, [tips]);
      var limitText = this.maxcharacter && h("span", {
        "class": this.limitClasses
      }, ["".concat(this.characterNumber, "/").concat(this.maxcharacter)]) || !this.maxcharacter && this.maxlength && h("span", {
        "class": this.limitClasses
      }, ["".concat(this.value ? getUnicodeLength(String(this.value)) : 0, "/").concat(this.maxlength)]);
      return h("div", {
        "class": this.textareaClasses
      }, [h("textarea", {
        "on": _objectSpread$1f({
          "input": this.handleInput,
          "compositionstart": this.onCompositionstart,
          "compositionend": this.onCompositionend
        }, inputEvents),
        "attrs": _objectSpread$1f({}, _objectSpread$1f(_objectSpread$1f({}, this.$attrs), this.inputAttrs)),
        "domProps": {
          "value": this.value
        },
        "class": classes,
        "ref": "refTextareaElem"
      }), textTips || limitText ? h("div", {
        "class": ["".concat(this.componentName, "__info_wrapper"), _defineProperty$2({}, "".concat(this.componentName, "__info_wrapper_align"), !textTips)]
      }, [textTips, limitText]) : null]);
    }
  });

  var Textarea = withInstall$1(mapProps(["value"])(_Textarea));

  function ownKeys$1f(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1e(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1f(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1f(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var TRANSFER_NAME = "TTransfer";
  var SOURCE = "source";
  var TARGET = "target";
  function findTopNode(vm) {
    if (vm.$options.name === TRANSFER_NAME) {
      return vm;
    }
    if (vm.$parent) {
      return findTopNode(vm.$parent);
    }
    return vm;
  }
  function getTransferListOption(prop) {
    if (Array.isArray(prop)) {
      return {
        source: prop[0],
        target: prop[1]
      };
    }
    return {
      source: prop,
      target: prop
    };
  }
  function getDataValues(data, filterValues) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$isTreeMode = _ref.isTreeMode,
      isTreeMode = _ref$isTreeMode === void 0 ? false : _ref$isTreeMode,
      _ref$include = _ref.include,
      include = _ref$include === void 0 ? true : _ref$include,
      _ref$remainValue = _ref.remainValue,
      remainValue = _ref$remainValue === void 0 ? [] : _ref$remainValue;
    if (isTreeMode) {
      var result = [];
      if (data) {
        for (var i = 0; i < data.length; i++) {
          var _item$children;
          var item = data[i];
          var isInclude = filterValues.includes(item.value) && !item.disabled;
          if (!include && isInclude) {
            continue;
          }
          if (item !== null && item !== void 0 && item.children && ((_item$children = item.children) === null || _item$children === void 0 ? void 0 : _item$children.length) > 0) {
            var childResult = getDataValues(item.children, filterValues, {
              isTreeMode: isTreeMode,
              include: include
            });
            result = result.concat(childResult);
          } else if (include && isInclude || !include && !isInclude) {
            result.push(item.value);
          }
        }
      }
      return result;
    }
    return data.filter(function (item) {
      var isInclude = filterValues.includes(item.value);
      return (include && isInclude || !include && !isInclude) && (!item.disabled || remainValue.includes(item.value));
    }).map(function (item) {
      return item.value;
    });
  }
  function getTransferData(data, keys) {
    var isTreeMode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var list = data.map(function (transferDataItem, index) {
      var _transferDataItem$dis;
      var labelKey = (keys === null || keys === void 0 ? void 0 : keys.label) || "label";
      var valueKey = (keys === null || keys === void 0 ? void 0 : keys.value) || "value";
      var disabledKey = (keys === null || keys === void 0 ? void 0 : keys.disabled) || "disabled";
      if (transferDataItem[labelKey] === void 0) {
        throw "".concat(labelKey, " is not in DataOption ").concat(JSON.stringify(transferDataItem));
      }
      if (transferDataItem[valueKey] === void 0) {
        throw "".concat(valueKey, " is not in DataOption ").concat(JSON.stringify(transferDataItem));
      }
      var result = {
        label: transferDataItem[labelKey],
        value: transferDataItem[valueKey],
        key: "key__value_".concat(transferDataItem[valueKey], "_index_").concat(index),
        disabled: (_transferDataItem$dis = transferDataItem[disabledKey]) !== null && _transferDataItem$dis !== void 0 ? _transferDataItem$dis : false,
        data: transferDataItem
      };
      if (isTreeMode && transferDataItem.children) {
        result.children = getTransferData(transferDataItem.children, keys, true);
      }
      return result;
    });
    return list;
  }
  function isAllNodeValid(data, filterValues, needMatch) {
    if (filterValues.includes(data.value)) {
      return needMatch;
    }
    return false;
  }
  function isTreeNodeValid(data, filterValues, needMatch) {
    if (filterValues.includes(data.value)) {
      return needMatch;
    }
    if (data !== null && data !== void 0 && data.children) {
      return data === null || data === void 0 ? void 0 : data.children.some(function (item) {
        return isTreeNodeValid(item, filterValues, needMatch);
      });
    }
    return !needMatch;
  }
  function cloneTreeWithFilter(sourceTree, targetTree, filterValues, needMatch) {
    sourceTree.forEach(function (item) {
      var newNode;
      if (isAllNodeValid(item, filterValues, needMatch)) {
        newNode = cloneDeep(item);
        targetTree.push(newNode);
      } else if (isTreeNodeValid(item, filterValues, needMatch)) {
        newNode = _objectSpread$1e({}, item);
        delete newNode.children;
        targetTree.push(newNode);
        if (item.children) {
          newNode.children = [];
          cloneTreeWithFilter(item.children, newNode.children, filterValues, needMatch);
          if (newNode.children.length === 0) {
            delete newNode.children;
          }
        }
      }
    });
  }
  function filterTransferData(data, filterValues) {
    var needMatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var isTreeMode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!isTreeMode) {
      if (needMatch) {
        var dataMap = new Map(data.map(function (item) {
          return [item.value, item];
        }));
        return filterValues.map(function (value) {
          return dataMap.get(value);
        }).filter(Boolean);
      }
      return data.filter(function (item) {
        var isMatch = filterValues.includes(item.value);
        return !isMatch;
      });
    }
    var result = [];
    cloneTreeWithFilter(data, result, filterValues, needMatch);
    return result;
  }
  function getLeafCount(nodes) {
    var total = 0;
    nodes.forEach(function (child) {
      if (child.children && child.children.length > 0) {
        total += getLeafCount(child.children);
      } else {
        total += 1;
      }
    });
    return total;
  }
  function filterTreeData(tree, filterStr) {
    var res = filter(cloneDeep(tree), function (node) {
      var _node$children;
      if (node.label.toLowerCase().indexOf(filterStr.toLowerCase()) > -1) {
        return true;
      }
      if ((node === null || node === void 0 || (_node$children = node.children) === null || _node$children === void 0 ? void 0 : _node$children.length) > 0) {
        node.children = filterTreeData(node.children, filterStr);
        return node.children.length > 0;
      }
      return false;
    });
    return res;
  }

  function ownKeys$1e(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1d(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1e(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1e(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var Search = mixins(getGlobalIconMixins()).extend({
    name: "TTransferSearch",
    model: {
      prop: "searchValue",
      event: "change"
    },
    props: {
      searchValue: {
        type: String,
        "default": ""
      },
      search: {
        type: [Boolean, Object]
      },
      placeholder: String,
      classPrefix: String
    },
    render: function render() {
      var _this = this;
      var h = arguments[0];
      var _this$useGlobalIcon = this.useGlobalIcon({
          SearchIcon: SearchIcon
        }),
        SearchIcon$1 = _this$useGlobalIcon.SearchIcon;
      var searchValue = this.searchValue,
        search = this.search,
        placeholder = this.placeholder,
        classPrefix = this.classPrefix;
      var inputProps = _typeof$2(search) === "object" ? search : {
        clearable: true
      };
      var handleSearch = function handleSearch(value, trigger, changeCtx) {
        _this.$emit("search", {
          value: value,
          trigger: trigger,
          e: changeCtx.e
        });
      };
      var handleChange = function handleChange(value, changeCtx) {
        _this.$emit("change", value);
        handleSearch(value, "input", changeCtx);
      };
      var handleEnter = function handleEnter(value, changeCtx) {
        handleSearch(value, "enter", changeCtx);
      };
      return h("div", {
        "class": "".concat(classPrefix, "-transfer__search-wrapper")
      }, [h(Input, helper([{}, {
        "props": _objectSpread$1d({}, inputProps)
      }, {
        "attrs": {
          "value": searchValue,
          "placeholder": placeholder
        },
        "on": {
          "change": handleChange,
          "enter": handleEnter
        }
      }]), [h(SearchIcon$1, {
        "slot": "suffix-icon"
      })])]);
    }
  });

  var props$w = {
    checkboxProps: {
      type: Object
    },
    checked: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    defaultChecked: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    data: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    direction: {
      type: String,
      "default": "both",
      validator: function validator(val) {
        if (!val) return true;
        return ["left", "right", "both"].includes(val);
      }
    },
    disabled: {
      type: [Boolean, Array]
    },
    empty: {
      type: [String, Array, Function],
      "default": ""
    },
    footer: {
      type: [Array, Function]
    },
    keys: {
      type: Object
    },
    operation: {
      type: [Array, Function]
    },
    pagination: {
      type: [Object, Array]
    },
    search: {
      type: [Boolean, Object, Array],
      "default": false
    },
    showCheckAll: {
      type: [Boolean, Array],
      "default": true
    },
    targetDraggable: Boolean,
    targetSort: {
      type: String,
      "default": "original",
      validator: function validator(val) {
        if (!val) return true;
        return ["original", "push", "unshift"].includes(val);
      }
    },
    title: {
      type: [Array, Function],
      "default": function _default() {
        return [];
      }
    },
    transferItem: {
      type: Function
    },
    tree: {
      type: Function
    },
    value: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    defaultValue: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    onChange: Function,
    onCheckedChange: Function,
    onPageChange: Function,
    onScroll: Function,
    onSearch: Function
  };

  function ownKeys$1d(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1c(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1d(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1d(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$d = getClassPrefixMixins("transfer");
  var keepAnimationMixins = getKeepAnimationMixins();
  var TransferList = mixins(keepAnimationMixins, classPrefixMixins$d).extend({
    name: "TTransferList",
    components: {
      Search: Search,
      TCheckbox: Checkbox,
      TCheckboxGroup: CheckboxGroup
    },
    directives: {
      ripple: Ripple
    },
    props: {
      checkboxProps: {
        type: Object,
        "default": function _default() {
          return {};
        }
      },
      dataSource: {
        type: Array,
        "default": function _default() {
          return [];
        }
      },
      listType: {
        type: String,
        "default": "target"
      },
      title: {
        type: [String, Function]
      },
      checkedValue: {
        type: Array,
        "default": function _default() {
          return [];
        }
      },
      disabled: {
        type: Boolean,
        "default": false
      },
      search: {
        type: [Boolean, Object],
        "default": false
      },
      transferItem: Function,
      empty: {
        type: [Function, String]
      },
      pagination: [Boolean, Object],
      footer: [Function, String],
      checkAll: Boolean,
      t: Function,
      global: Object,
      tree: props$w.tree,
      isTreeMode: {
        type: Boolean,
        "default": false
      },
      draggable: Boolean,
      currentValue: {
        type: Array
      }
    },
    data: function data() {
      return {
        filterValue: "",
        defaultCurrent: null,
        defaultPageSize: null,
        draggingIndex: null,
        dragoverIndex: null,
        dragoverPos: ""
      };
    },
    computed: {
      currentPage: function currentPage() {
        var _ref, _ref2, _this$pagination$curr, _this$pagination, _this$pagination2;
        return (_ref = (_ref2 = (_this$pagination$curr = (_this$pagination = this.pagination) === null || _this$pagination === void 0 ? void 0 : _this$pagination.current) !== null && _this$pagination$curr !== void 0 ? _this$pagination$curr : this.defaultCurrent) !== null && _ref2 !== void 0 ? _ref2 : (_this$pagination2 = this.pagination) === null || _this$pagination2 === void 0 ? void 0 : _this$pagination2.defaultCurrent) !== null && _ref !== void 0 ? _ref : 1;
      },
      pageSize: function pageSize() {
        var _ref3, _ref4, _this$pagination$page, _this$pagination3, _this$pagination4;
        return (_ref3 = (_ref4 = (_this$pagination$page = (_this$pagination3 = this.pagination) === null || _this$pagination3 === void 0 ? void 0 : _this$pagination3.pageSize) !== null && _this$pagination$page !== void 0 ? _this$pagination$page : this.defaultPageSize) !== null && _ref4 !== void 0 ? _ref4 : (_this$pagination4 = this.pagination) === null || _this$pagination4 === void 0 ? void 0 : _this$pagination4.defaultPageSize) !== null && _ref3 !== void 0 ? _ref3 : 10;
      },
      pageTotal: function pageTotal() {
        return this.filteredData && this.filteredData.length || 0;
      },
      filteredData: function filteredData() {
        var _this = this;
        if (!this.isTreeMode) {
          return this.dataSource.filter(function (item) {
            var label = item && item.label.toString();
            return label.toLowerCase().indexOf(_this.filterValue.toLowerCase()) > -1;
          });
        }
        return filterTreeData(this.dataSource, this.filterValue);
      },
      curPageData: function curPageData() {
        var pageData = this.filteredData;
        if (!this.pagination) return pageData;
        if (this.pageSize === 0) return pageData;
        var startIndex = (this.currentPage - 1) * this.pageSize;
        var endIndex = this.currentPage * this.pageSize;
        pageData = pageData.slice(startIndex, endIndex);
        return pageData;
      },
      paginationProps: function paginationProps() {
        var defaultPaginationProps = {
          totalContent: false,
          pageSizeOptions: []
        };
        return _typeof$2(this.pagination) === "object" ? _objectSpread$1c(_objectSpread$1c(_objectSpread$1c({}, defaultPaginationProps), this.pagination), {}, {
          size: "small",
          theme: "simple",
          current: this.currentPage,
          total: this.pageTotal,
          pageSize: this.pageSize
        }) : {};
      },
      hasFooter: function hasFooter() {
        return !!this.$slots["default"];
      },
      indeterminate: function indeterminate() {
        return !this.isAllChecked && this.checkedValue.length > 0;
      },
      isAllChecked: function isAllChecked() {
        var _this2 = this;
        var allValue = getDataValues(this.dataSource, [], {
          isTreeMode: this.isTreeMode,
          include: false
        });
        return this.checkedValue.length > 0 && (this.isTreeMode ? allValue.every(function (item) {
          return _this2.checkedValue.includes(item);
        }) : (this.search ? this.filteredData : this.dataSource).every(function (item) {
          return item.disabled || _this2.checkedValue.includes(item.value);
        }));
      },
      totalCount: function totalCount() {
        return getLeafCount(this.dataSource);
      }
    },
    watch: {
      totalCount: function totalCount(val) {
        if (val <= (this.currentPage - 1) * this.pageSize && val !== 0) {
          var lastPage = Math.ceil(val / this.pageSize);
          this.defaultCurrent = lastPage;
        }
      }
    },
    methods: {
      handlePaginationChange: function handlePaginationChange(pageInfo) {
        this.$emit("pageChange", pageInfo);
        this.defaultCurrent = pageInfo.current;
        this.defaultPageSize = pageInfo.pageSize;
      },
      handleCheckedChange: function handleCheckedChange(val) {
        this.$emit("checkedChange", val);
      },
      handleCheckedAllChange: function handleCheckedAllChange(checked) {
        if (checked) {
          var allValue = getDataValues(this.search ? this.filteredData : this.dataSource, [], {
            isTreeMode: this.isTreeMode,
            include: false
          });
          this.handleCheckedChange(allValue);
        } else {
          this.handleCheckedChange([]);
        }
      },
      scroll: function scroll(e) {
        this.$emit("scroll", e);
      },
      handleSearch: function handleSearch(e) {
        var event = {
          query: e.value,
          type: this.listType,
          e: e.e,
          trigger: e.trigger
        };
        this.$emit("search", event);
      },
      onDragStart: function onDragStart(e) {
        var index = Number(e.target.dataset.index);
        this.draggingIndex = index;
      },
      onDragOver: function onDragOver(e) {
        e.preventDefault();
        if (e.currentTarget) {
          var currentElement = e.currentTarget;
          var index = Number(currentElement.dataset.index);
          var elemHeight = currentElement.offsetHeight;
          var dragY = e.clientY - currentElement.getBoundingClientRect().top;
          var insertAreaPercent = 0.3;
          var insertAreaHeight = elemHeight * insertAreaPercent;
          this.dragoverIndex = index;
          if (this.dragoverIndex === this.draggingIndex) {
            this.dragoverPos = "";
            return;
          }
          if (dragY < insertAreaHeight) {
            this.dragoverPos = "top";
          } else if (dragY > elemHeight - insertAreaHeight) {
            this.dragoverPos = "bottom";
          } else {
            this.dragoverPos = "center";
          }
        }
      },
      onDragLeave: function onDragLeave() {
        this.dragoverPos = "";
        this.dragoverIndex = null;
      },
      onDragEnd: function onDragEnd() {
        this.draggingIndex = null;
        this.dragoverIndex = null;
        this.dragoverPos = "";
      },
      onDrop: function onDrop(e) {
        e.preventDefault();
        var draggingIndex = this.draggingIndex,
          dragoverIndex = this.dragoverIndex,
          dragoverPos = this.dragoverPos;
        this.draggingIndex = null;
        this.dragoverIndex = null;
        this.dragoverPos = "";
        if (draggingIndex === dragoverIndex) {
          return;
        }
        var newData = _toConsumableArray(this.currentValue);
        var sourceItem = this.curPageData[draggingIndex].value;
        var targetItem = this.curPageData[dragoverIndex].value;
        var sourceIndex = newData.indexOf(sourceItem);
        var targetIndex = newData.indexOf(targetItem);
        newData.splice(sourceIndex, 1);
        if (dragoverPos === "bottom") {
          targetIndex += 1;
        }
        newData.splice(targetIndex, 0, sourceItem);
        this.$emit("dataChange", newData);
      },
      renderTitle: function renderTitle() {
        var h = this.$createElement;
        var defaultNode = this.title && typeof this.title === "string" ? h("template", [this.title]) : null;
        var titleNode = renderTNodeJSXDefault(this, "title", {
          defaultNode: defaultNode,
          params: {
            type: this.listType
          }
        });
        return h("span", [titleNode]);
      },
      renderContent: function renderContent() {
        var _this3 = this;
        var h = this.$createElement;
        var rootNode = findTopNode(this);
        var isDraggable = this.draggable && this.listType === TARGET;
        var defaultNode;
        if (!isDraggable) {
          defaultNode = h(CheckboxGroup, {
            "attrs": {
              "value": this.checkedValue
            },
            "on": {
              "change": this.handleCheckedChange
            }
          }, [this.curPageData.map(function (item, index) {
            return h(Checkbox, {
              "attrs": {
                "disabled": _this3.disabled || item.disabled,
                "value": item.value
              },
              "class": ["".concat(_this3.componentName, "__list-item")],
              "key": item.key,
              "directives": [{
                name: "ripple",
                value: _this3.keepAnimation.ripple && !_this3.draggable
              }],
              "props": _objectSpread$1c({}, _this3.checkboxProps)
            }, [renderTNodeJSXDefault(_this3, "transferItem", {
              defaultNode: h("span", [item.label]),
              params: {
                data: item.data,
                index: index,
                type: _this3.listType
              }
            })]);
          })]);
        } else {
          defaultNode = h(CheckboxGroup, {
            "attrs": {
              "value": this.checkedValue
            },
            "on": {
              "change": this.handleCheckedChange
            },
            "key": JSON.stringify(this.currentValue)
          }, [this.curPageData.map(function (item, index) {
            return h("div", {
              "attrs": {
                "draggable": isDraggable,
                "data-index": index
              },
              "on": {
                "dragend": _this3.onDragEnd,
                "dragstart": _this3.onDragStart,
                "dragover": _this3.onDragOver,
                "dragleave": _this3.onDragLeave,
                "drop": _this3.onDrop
              }
            }, [h(Checkbox, {
              "attrs": {
                "disabled": _this3.disabled || item.disabled,
                "value": item.value
              },
              "class": ["".concat(_this3.componentName, "__list-item")],
              "key": item.key,
              "directives": [{
                name: "ripple",
                value: _this3.keepAnimation.ripple && !_this3.draggable
              }],
              "props": _objectSpread$1c({}, _this3.checkboxProps)
            }, [renderTNodeJSXDefault(_this3, "transferItem", {
              defaultNode: h("span", [item.label]),
              params: {
                data: item.data,
                index: index,
                type: _this3.listType
              }
            })])]);
          })]);
        }
        return h("div", {
          "class": "".concat(this.componentName, "__list-content narrow-scrollbar"),
          "on": {
            "scroll": this.scroll
          }
        }, [renderTNodeJSXDefault(rootNode, "tree", {
          defaultNode: defaultNode,
          params: {
            data: this.curPageData,
            value: this.checkedValue,
            onChange: this.handleCheckedChange
          }
        })]);
      },
      renderEmpty: function renderEmpty() {
        var h = this.$createElement;
        var empty = this.empty || this.t(this.global.empty);
        var defaultNode = typeof empty === "string" ? h("span", [empty]) : null;
        return h("div", {
          "class": "".concat(this.componentName, "__empty")
        }, [renderTNodeJSXDefault(this, "empty", {
          defaultNode: defaultNode,
          params: {
            type: this.listType
          }
        })]);
      },
      renderFooter: function renderFooter() {
        var h = this.$createElement;
        var defaultNode = typeof this.footer === "string" ? h("div", {
          "class": "".concat(this.componentName, "__footer")
        }, [this.footer]) : null;
        return renderTNodeJSXDefault(this, "footer", {
          defaultNode: defaultNode,
          params: {
            type: this.listType
          }
        });
      }
    },
    render: function render() {
      var _this4 = this;
      var h = arguments[0];
      return h("div", {
        "class": "".concat(this.componentName, "__list ").concat(this.componentName, "__list-").concat(this.listType)
      }, [h("div", {
        "class": "".concat(this.componentName, "__list-header")
      }, [h("div", [this.checkAll && h(Checkbox, {
        "attrs": {
          "disabled": this.disabled || !this.dataSource.length,
          "checked": this.isAllChecked,
          "indeterminate": this.indeterminate
        },
        "on": {
          "change": this.handleCheckedAllChange
        }
      }), h("span", [this.t(this.global.title, {
        checked: this.checkedValue.length,
        total: this.totalCount
      })])]), this.renderTitle()]), h("div", {
        "class": ["".concat(this.componentName, "__list-body"), this.search ? "".concat(this.componentName, "__list--with-search") : ""]
      }, [this.search && h("search", {
        "attrs": {
          "searchValue": this.filterValue,
          "placeholder": this.t(this.global.placeholder),
          "disabled": this.disabled,
          "search": this.search,
          "classPrefix": this.classPrefix
        },
        "on": {
          "change": function change(e) {
            return _this4.filterValue = e;
          },
          "search": this.handleSearch
        }
      }), this.curPageData.length > 0 ? this.renderContent() : this.renderEmpty()]), this.pagination && this.pageSize > 0 && this.pageTotal > 0 && h("div", {
        "class": "".concat(this.componentName, "__list-pagination")
      }, [h(Pagination, helper([{}, {
        "props": this.paginationProps
      }, {
        "on": {
          "change": this.handlePaginationChange
        }
      }]))]), this.renderFooter()]);
    }
  });

  var classPrefixMixins$c = getClassPrefixMixins("transfer");
  var TransferOperations = mixins(classPrefixMixins$c, getGlobalIconMixins()).extend({
    name: "TTransferOperations",
    props: {
      leftDisabled: {
        type: Boolean,
        required: true
      },
      rightDisabled: {
        type: Boolean,
        required: true
      },
      operation: {
        type: [String, Array, Function, Boolean]
      }
    },
    methods: {
      moveToRight: function moveToRight() {
        this.$emit("moveToRight");
      },
      moveToLeft: function moveToLeft() {
        this.$emit("moveToLeft");
      },
      getIconRight: function getIconRight() {
        var h = this.$createElement;
        var _this$useGlobalIcon = this.useGlobalIcon({
            ChevronRightIcon: TdChevronRightIcon
          }),
          ChevronRightIcon = _this$useGlobalIcon.ChevronRightIcon;
        return h(ChevronRightIcon);
      },
      getIconLeft: function getIconLeft() {
        var h = this.$createElement;
        var _this$useGlobalIcon2 = this.useGlobalIcon({
            ChevronLeftIcon: TdChevronLeftIcon
          }),
          ChevronLeftIcon = _this$useGlobalIcon2.ChevronLeftIcon;
        return h(ChevronLeftIcon);
      },
      getIcon: function getIcon(direction) {
        if (typeof this.operation === "function") {
          return null;
        }
        if (direction === "right" && this.operation && typeof this.operation[0] === "function") {
          return null;
        }
        if (direction === "left" && this.operation && typeof this.operation[1] === "function") {
          return null;
        }
        if (this.$scopedSlots.operation) {
          return null;
        }
        return direction === "left" ? this.getIconLeft : this.getIconRight;
      },
      _renderButton: function _renderButton(h, direction) {
        if (typeof this.$scopedSlots.operation === "function") {
          return this.$scopedSlots.operation({
            direction: direction
          });
        }
        if (typeof this.operation === "function") {
          var renderContent2 = this.operation;
          return renderContent2(h, {
            direction: direction
          });
        }
        var renderContent;
        if (Array.isArray(this.operation)) {
          var _this$operation = _slicedToArray(this.operation, 2),
            left = _this$operation[0],
            right = _this$operation[1];
          renderContent = direction === "right" ? right : left;
        } else {
          renderContent = "";
        }
        return renderContent;
      }
    },
    render: function render(h) {
      var _this$operation2, _this$operation3;
      var _this$$props = this.$props,
        leftDisabled = _this$$props.leftDisabled,
        rightDisabled = _this$$props.rightDisabled;
      return h("div", {
        "class": "".concat(this.componentName, "__operations")
      }, [h(Button, {
        "attrs": {
          "variant": "outline",
          "size": "small",
          "shape": typeof ((_this$operation2 = this.operation) === null || _this$operation2 === void 0 ? void 0 : _this$operation2[1]) === "string" ? "rectangle" : "square",
          "disabled": rightDisabled,
          "icon": this.getIcon("right")
        },
        "key": rightDisabled ? "right-outline" : "right-base",
        "on": {
          "click": this.moveToRight
        }
      }, [this._renderButton(h, "right")]), h(Button, {
        "attrs": {
          "variant": "outline",
          "size": "small",
          "shape": typeof ((_this$operation3 = this.operation) === null || _this$operation3 === void 0 ? void 0 : _this$operation3[0]) === "string" ? "rectangle" : "square",
          "disabled": leftDisabled,
          "icon": this.getIcon("left")
        },
        "key": leftDisabled ? "left-outline" : "left-base",
        "on": {
          "click": this.moveToLeft
        }
      }, [this._renderButton(h, "left")])]);
    }
  });

  function ownKeys$1c(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1b(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1c(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1c(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _Transfer = mixins(getConfigReceiverMixins("transfer")).extend({
    name: TRANSFER_NAME,
    components: {
      TransferList: TransferList,
      TransferOperations: TransferOperations
    },
    model: {
      prop: "value",
      event: "change"
    },
    props: _objectSpread$1b({}, props$w),
    data: function data() {
      return {
        SOURCE: SOURCE,
        TARGET: TARGET,
        formDisabled: void 0
      };
    },
    computed: {
      tDisabled: function tDisabled() {
        return this.formDisabled || this.disabled;
      },
      isTreeMode: function isTreeMode() {
        var treeSlot = this.$scopedSlots.tree;
        return typeof treeSlot === "function" || typeof this.tree === "function";
      },
      leftButtonDisabled: function leftButtonDisabled() {
        return this.direction === "right";
      },
      rightButtonDisabled: function rightButtonDisabled() {
        return this.direction === "left";
      },
      transferData: function transferData() {
        return getTransferData(this.data, this.keys, this.isTreeMode);
      },
      sourceList: function sourceList() {
        return filterTransferData(this.transferData, this.value, false, this.isTreeMode);
      },
      targetList: function targetList() {
        return filterTransferData(this.transferData, this.value, true, this.isTreeMode);
      },
      checkedValue: function checkedValue() {
        return _defineProperty$2(_defineProperty$2({}, SOURCE, getDataValues(this.sourceList, this.checked, {
          isTreeMode: this.isTreeMode
        })), TARGET, getDataValues(this.targetList, this.checked, {
          isTreeMode: this.isTreeMode
        }));
      },
      hasFooter: function hasFooter() {
        return !!this.$scopedSlots.footer || !!this.footer;
      },
      showPagination: function showPagination() {
        return !!this.pagination && !this.$scopedSlots.content;
      },
      showSearch: function showSearch() {
        return !!this.search;
      },
      footerOption: function footerOption() {
        var footer = this.footer || "";
        return getTransferListOption(footer);
      },
      emptyOption: function emptyOption() {
        return getTransferListOption(this.empty);
      },
      searchOption: function searchOption() {
        return getTransferListOption(this.search);
      },
      checkAllOption: function checkAllOption() {
        return getTransferListOption(this.showCheckAll);
      },
      disabledOption: function disabledOption() {
        return getTransferListOption(this.tDisabled);
      },
      titleOption: function titleOption() {
        return getTransferListOption(this.title);
      },
      paginationOption: function paginationOption() {
        return getTransferListOption(this.pagination);
      }
    },
    methods: {
      transferTo: function transferTo(toDirection) {
        var oldTargetValue = JSON.parse(JSON.stringify(this.value));
        var newTargetValue;
        var checkedValue = toDirection === TARGET ? this.checkedValue[SOURCE] : this.checkedValue[TARGET];
        if (toDirection === SOURCE) {
          newTargetValue = oldTargetValue.filter(function (v) {
            return !checkedValue.includes(v);
          });
        } else if (this.targetSort === "original") {
          var remainValue = this.transferData.reduce(function (acc, data) {
            if (oldTargetValue.includes(data.value) && data.disabled) {
              return acc.concat(data.value);
            }
            return acc;
          }, []);
          newTargetValue = getDataValues(this.transferData, oldTargetValue.concat(checkedValue), {
            isTreeMode: this.isTreeMode,
            remainValue: remainValue
          });
        } else if (this.targetSort === "unshift") {
          newTargetValue = checkedValue.concat(oldTargetValue);
        } else {
          newTargetValue = oldTargetValue.concat(checkedValue);
        }
        this.handleCheckedChange([], toDirection === SOURCE ? TARGET : SOURCE);
        var params = {
          type: toDirection,
          movedValue: checkedValue
        };
        emitEvent$1(this, "change", newTargetValue, params);
      },
      transferToRight: function transferToRight() {
        this.transferTo(TARGET);
      },
      transferToLeft: function transferToLeft() {
        this.transferTo(SOURCE);
      },
      handleCheckedChange: function handleCheckedChange(val, listType) {
        var sourceChecked = listType === SOURCE ? val : this.checkedValue[SOURCE];
        var targetChecked = listType === TARGET ? val : this.checkedValue[TARGET];
        var checked = [].concat(_toConsumableArray(sourceChecked), _toConsumableArray(targetChecked));
        var event = {
          checked: checked,
          sourceChecked: sourceChecked,
          targetChecked: targetChecked,
          type: listType
        };
        this.$emit("update:checked", checked);
        emitEvent$1(this, "checked-change", event);
      },
      filterMethod: function filterMethod(transferList, targetValueList, needMatch) {
        return transferList.filter(function (item) {
          var isMatch = targetValueList.indexOf(item.value) > -1;
          return needMatch ? isMatch : !isMatch;
        });
      },
      handleScroll: function handleScroll(e, listType) {
        var target = e.target;
        var bottomDistance = target.scrollHeight - target.scrollTop - target.clientHeight;
        var event = {
          e: e,
          bottomDistance: bottomDistance,
          type: listType
        };
        emitEvent$1(this, "scroll", event);
      },
      handleSearch: function handleSearch(e) {
        emitEvent$1(this, "search", e);
      },
      handlePageChange: function handlePageChange(pageInfo, listType) {
        emitEvent$1(this, "page-change", pageInfo, {
          type: listType
        });
      },
      handleDataChange: function handleDataChange(data) {
        this.$emit("change", data, null);
      },
      renderTransferList: function renderTransferList(listType) {
        var _this = this;
        var h = this.$createElement;
        var scopedSlots = pick$1(this.$scopedSlots, ["title", "empty", "footer", "operation", "transferItem", "default"]);
        return h("transfer-list", {
          "attrs": {
            "checkboxProps": this.checkboxProps,
            "transferItem": this.transferItem,
            "list-type": listType,
            "title": this.titleOption[listType],
            "data-source": listType === SOURCE ? this.sourceList : this.targetList,
            "checked-value": this.checkedValue[listType],
            "disabled": this.disabledOption[listType],
            "search": this.searchOption[listType],
            "pagination": this.paginationOption[listType],
            "check-all": this.checkAllOption[listType],
            "footer": this.footerOption[listType],
            "empty": this.emptyOption[listType],
            "t": this.t,
            "global": this.global,
            "isTreeMode": this.isTreeMode,
            "currentValue": this.value,
            "draggable": this.targetDraggable && listType === TARGET
          },
          "on": {
            "checkedChange": function checkedChange(val) {
              return _this.handleCheckedChange(val, listType);
            },
            "scroll": function scroll($event) {
              return _this.handleScroll($event, listType);
            },
            "search": this.handleSearch,
            "pageChange": function pageChange(pageInfo) {
              return _this.handlePageChange(pageInfo, listType);
            },
            "dataChange": this.handleDataChange
          },
          "scopedSlots": scopedSlots
        });
      }
    },
    render: function render() {
      var h = arguments[0];
      return h("div", {
        "class": [this.componentName, this.showSearch ? "".concat(this.componentName, "__search") : "", this.hasFooter ? "".concat(this.componentName, "__footer") : "", this.showPagination ? "".concat(this.componentName, "__pagination") : "", this.isTreeMode ? "".concat(this.componentName, "--with-tree") : ""]
      }, [this.renderTransferList(SOURCE), h("transfer-operations", {
        "attrs": {
          "left-disabled": this.disabledOption[TARGET] || this.leftButtonDisabled || this.checkedValue[TARGET].length === 0,
          "right-disabled": this.disabledOption[SOURCE] || this.rightButtonDisabled || this.checkedValue[SOURCE].length === 0,
          "operation": this.operation
        },
        "on": {
          "moveToRight": this.transferToRight,
          "moveToLeft": this.transferToLeft
        },
        "scopedSlots": {
          operation: this.$scopedSlots.operation
        }
      }), this.renderTransferList(TARGET)]);
    }
  });

  var Transfer = withInstall$1(mapProps([{
    name: "value"
  }, {
    name: "checked",
    event: "update:checked"
  }], {
    model: {
      prop: "value",
      event: "change"
    }
  })(_Transfer));

  function ownKeys$1b(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1a(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1b(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1b(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  dayjs_min.extend(customParseFormat);
  var _TimePicker = VueCompositionAPI.defineComponent({
    name: "TTimePicker",
    props: _objectSpread$1a({}, props$E),
    setup: function setup(props2, ctx) {
      var _useConfig = useConfig("classPrefix"),
        classPrefix = _useConfig.classPrefix;
      var componentName = usePrefixClass("time-picker");
      var _useGlobalIcon = useGlobalIcon({
          TimeIcon: TdTimeIcon
        }),
        TimeIcon = _useGlobalIcon.TimeIcon;
      var _useFormDisabled = useFormDisabled(),
        formDisabled = _useFormDisabled.formDisabled;
      var currentValue = VueCompositionAPI.ref("");
      var isShowPanel = VueCompositionAPI.ref(false);
      var _useConfig2 = useConfig("timePicker"),
        global = _useConfig2.global;
      var isDisabled = VueCompositionAPI.computed(function () {
        return formDisabled.value || props2.disabled;
      });
      var _toRefs = VueCompositionAPI.toRefs(props2),
        value = _toRefs.value;
      var _useVModel = useVModel$1(value, props2.defaultValue, props2.onChange, "change"),
        _useVModel2 = _slicedToArray(_useVModel, 2),
        innerValue = _useVModel2[0],
        setInnerValue = _useVModel2[1];
      var inputClasses = VueCompositionAPI.computed(function () {
        return ["".concat(componentName.value, "__group"), _defineProperty$2({}, "".concat(classPrefix.value, "-is-focused"), isShowPanel.value)];
      });
      var handleShowPopup = function handleShowPopup(visible, context) {
        isShowPanel.value = visible;
        if (visible) {
          var _props2$onOpen;
          (_props2$onOpen = props2.onOpen) === null || _props2$onOpen === void 0 || _props2$onOpen.call(props2, context);
          ctx.emit("open", context);
        } else {
          var _props2$onClose;
          (_props2$onClose = props2.onClose) === null || _props2$onClose === void 0 || _props2$onClose.call(props2, context);
          ctx.emit("close", context);
        }
      };
      var handleClear = function handleClear(context) {
        var e = context.e;
        e.stopPropagation();
        currentValue.value = null;
        setInnerValue(null);
      };
      var handleInputChange = function handleInputChange(value2) {
        currentValue.value = value2;
      };
      var handleInputBlur = function handleInputBlur(value2, _ref2) {
        var _props2$onBlur;
        var e = _ref2.e;
        if (props2.allowInput) {
          var isValidTime = validateInputValue(currentValue.value, props2.format);
          if (isValidTime) {
            setInnerValue(formatInputValue(currentValue.value, props2.format));
          }
        }
        (_props2$onBlur = props2.onBlur) === null || _props2$onBlur === void 0 || _props2$onBlur.call(props2, {
          value: value2,
          e: e
        });
        ctx.emit("blur", {
          value: value2,
          e: e
        });
      };
      var handleClickConfirm = function handleClickConfirm() {
        var isValidTime = validateInputValue(currentValue.value, props2.format);
        if (isValidTime) setInnerValue(currentValue.value);
        isShowPanel.value = false;
      };
      var handlePanelChange = function handlePanelChange(v) {
        currentValue.value = v;
      };
      var handleOnFocus = function handleOnFocus(context) {
        var _props2$onFocus;
        (_props2$onFocus = props2.onFocus) === null || _props2$onFocus === void 0 || _props2$onFocus.call(props2, context);
        ctx.emit("focus", context);
      };
      var handleOnPick = function handleOnPick(v, e) {
        var _props2$onPick;
        (_props2$onPick = props2.onPick) === null || _props2$onPick === void 0 || _props2$onPick.call(props2, v, {
          e: e
        });
        ctx.emit("pick", v, {
          e: e
        });
      };
      VueCompositionAPI.watch(function () {
        return isShowPanel.value;
      }, function () {
        var _innerValue$value;
        currentValue.value = isShowPanel.value ? (_innerValue$value = innerValue.value) !== null && _innerValue$value !== void 0 ? _innerValue$value : "" : "";
      });
      return {
        handleClickConfirm: handleClickConfirm,
        handlePanelChange: handlePanelChange,
        handleInputBlur: handleInputBlur,
        handleInputChange: handleInputChange,
        handleClear: handleClear,
        handleShowPopup: handleShowPopup,
        handleOnFocus: handleOnFocus,
        handleOnPick: handleOnPick,
        inputClasses: inputClasses,
        componentName: componentName,
        innerValue: innerValue,
        isShowPanel: isShowPanel,
        global: global,
        currentValue: currentValue,
        TimeIcon: TimeIcon,
        isDisabled: isDisabled
      };
    },
    render: function render() {
      var _this$innerValue,
        _this$innerValue2,
        _this = this;
      var h = arguments[0];
      var TimeIcon = this.TimeIcon;
      return h("div", {
        "class": this.componentName
      }, [h(SelectInput, {
        "props": _objectSpread$1a({}, {
          onFocus: this.handleOnFocus,
          onClear: this.handleClear,
          onBlur: this.handleInputBlur,
          onInputChange: this.handleInputChange,
          borderless: this.borderless,
          disabled: this.isDisabled,
          readonly: this.readonly,
          clearable: this.clearable,
          allowInput: this.allowInput,
          "class": this.inputClasses,
          suffixIcon: function suffixIcon() {
            return h(TimeIcon);
          },
          popupVisible: this.isShowPanel,
          placeholder: !this.innerValue ? this.placeholder || this.global.placeholder : void 0,
          value: this.isShowPanel ? this.currentValue : (_this$innerValue = this.innerValue) !== null && _this$innerValue !== void 0 ? _this$innerValue : void 0,
          inputValue: this.isShowPanel ? this.currentValue : (_this$innerValue2 = this.innerValue) !== null && _this$innerValue2 !== void 0 ? _this$innerValue2 : void 0,
          inputProps: _objectSpread$1a(_objectSpread$1a({}, this.inputProps), {}, {
            size: this.size
          }),
          status: this.status,
          tips: this.tips,
          panel: function panel() {
            return h(_TimePickerPanel, {
              "props": _objectSpread$1a({}, {
                steps: _this.steps,
                format: _this.format,
                value: _this.currentValue,
                isFooterDisplay: true,
                isShowPanel: _this.isShowPanel,
                disableTime: _this.disableTime,
                onChange: _this.handlePanelChange,
                onPick: _this.handleOnPick,
                hideDisabledTime: _this.hideDisabledTime,
                handleConfirmClick: _this.handleClickConfirm,
                presets: _this.presets
              })
            });
          },
          popupProps: _objectSpread$1a({
            overlayInnerStyle: {
              width: "auto",
              padding: 0
            },
            onVisibleChange: this.handleShowPopup
          }, this.popupProps)
        })
      })]);
    }
  });

  var props$v = {
    allowInput: Boolean,
    autoSwap: {
      type: Boolean,
      "default": true
    },
    borderless: Boolean,
    clearable: Boolean,
    disableTime: {
      type: Function
    },
    disabled: {
      type: [Boolean, Array],
      "default": void 0
    },
    readonly: {
      type: Boolean,
      "default": void 0
    },
    format: {
      type: String,
      "default": "HH:mm:ss"
    },
    hideDisabledTime: {
      type: Boolean,
      "default": true
    },
    placeholder: {
      type: [String, Array],
      "default": void 0
    },
    popupProps: {
      type: Object
    },
    presets: {
      type: Object
    },
    rangeInputProps: {
      type: Object
    },
    size: {
      type: String,
      "default": "medium",
      validator: function validator(val) {
        if (!val) return true;
        return ["small", "medium", "large"].includes(val);
      }
    },
    status: {
      type: String,
      "default": "default",
      validator: function validator(val) {
        if (!val) return true;
        return ["default", "success", "warning", "error"].includes(val);
      }
    },
    steps: {
      type: Array,
      "default": function _default() {
        return [1, 1, 1];
      }
    },
    tips: {
      type: [String, Function]
    },
    value: {
      type: Array,
      "default": void 0
    },
    defaultValue: {
      type: Array
    },
    onBlur: Function,
    onChange: Function,
    onFocus: Function,
    onInput: Function,
    onPick: Function
  };

  function ownKeys$1a(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$19(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1a(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1a(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  dayjs_min.extend(customParseFormat);
  var _TimeRangePicker = VueCompositionAPI.defineComponent({
    name: "TTimeRangePicker",
    props: _objectSpread$19(_objectSpread$19({}, props$v), {}, {
      rangeInputProps: Object,
      popupProps: Object
    }),
    setup: function setup(props2, ctx) {
      var componentName = usePrefixClass("time-range-picker");
      var _useConfig = useConfig("timePicker"),
        global = _useConfig.global;
      var _useConfig2 = useConfig("classPrefix"),
        classPrefix = _useConfig2.classPrefix;
      var _useGlobalIcon = useGlobalIcon({
          TimeIcon: TdTimeIcon
        }),
        TimeIcon = _useGlobalIcon.TimeIcon;
      var _useFormDisabled = useFormDisabled(),
        formDisabled = _useFormDisabled.formDisabled;
      var currentPanelIdx = VueCompositionAPI.ref(void 0);
      var currentValue = VueCompositionAPI.ref(TIME_PICKER_EMPTY);
      var isShowPanel = VueCompositionAPI.ref(false);
      var inputClasses = VueCompositionAPI.computed(function () {
        return ["".concat(componentName.value, "__group"), _defineProperty$2({}, "".concat(classPrefix.value, "-is-focused"), isShowPanel.value)];
      });
      var isDisabled = VueCompositionAPI.computed(function () {
        return formDisabled.value || props2.disabled;
      });
      var _toRefs = VueCompositionAPI.toRefs(props2),
        value = _toRefs.value,
        format = _toRefs.format;
      var _useVModel = useVModel$1(value, props2.defaultValue, props2.onChange, "change"),
        _useVModel2 = _slicedToArray(_useVModel, 2),
        innerValue = _useVModel2[0],
        setInnerValue = _useVModel2[1];
      var handleShowPopup = function handleShowPopup(visible, context) {
        if (context.trigger === "trigger-element-click") {
          isShowPanel.value = true;
          return;
        }
        isShowPanel.value = visible;
      };
      var handleClear = function handleClear(context) {
        var e = context.e;
        e.stopPropagation();
        currentValue.value = TIME_PICKER_EMPTY;
        setInnerValue(null);
      };
      var handleClick = function handleClick(_ref2) {
        var position = _ref2.position;
        currentPanelIdx.value = position === "first" ? 0 : 1;
      };
      var handleTimeChange = function handleTimeChange(newValue) {
        if (currentPanelIdx.value === 0) {
          var _currentValue$value$;
          currentValue.value = [newValue, (_currentValue$value$ = currentValue.value[1]) !== null && _currentValue$value$ !== void 0 ? _currentValue$value$ : newValue];
        } else {
          var _currentValue$value$2;
          currentValue.value = [(_currentValue$value$2 = currentValue.value[0]) !== null && _currentValue$value$2 !== void 0 ? _currentValue$value$2 : newValue, newValue];
        }
      };
      var handleInputBlur = function handleInputBlur(value2, _ref3) {
        var _props2$onBlur;
        var e = _ref3.e;
        if (props2.allowInput) {
          var isValidTime = validateInputValue(currentValue.value[currentPanelIdx.value], format.value);
          if (isValidTime) {
            var _currentValue$value$3, _currentValue$value$4;
            var formattedVal = formatInputValue(currentValue.value[currentPanelIdx.value], format.value);
            currentPanelIdx.value === 0 ? currentValue.value = [formattedVal, (_currentValue$value$3 = currentValue.value[1]) !== null && _currentValue$value$3 !== void 0 ? _currentValue$value$3 : formattedVal] : currentValue.value = [(_currentValue$value$4 = currentValue.value[0]) !== null && _currentValue$value$4 !== void 0 ? _currentValue$value$4 : formattedVal, formattedVal];
          }
        }
        (_props2$onBlur = props2.onBlur) === null || _props2$onBlur === void 0 || _props2$onBlur.call(props2, {
          value: value2,
          e: e
        });
      };
      var handleInputChange = function handleInputChange(inputVal, _ref4) {
        var _props2$onInput;
        var e = _ref4.e,
          position = _ref4.position;
        currentValue.value = inputVal;
        (_props2$onInput = props2.onInput) === null || _props2$onInput === void 0 || _props2$onInput.call(props2, {
          value: innerValue.value,
          e: e,
          position: position === "first" ? "start" : "end"
        });
        ctx.emit("input", {
          value: innerValue.value,
          e: e,
          position: position === "first" ? "start" : "end"
        });
      };
      var handleClickConfirm = function handleClickConfirm() {
        var isValidTime = !currentValue.value.find(function (v) {
          return !validateInputValue(v, format.value);
        });
        if (isValidTime) setInnerValue(currentValue.value);
        if (props2.autoSwap) autoSwapTime();
        isShowPanel.value = false;
      };
      var handleFocus = function handleFocus(value2, _ref5) {
        var _props2$onFocus;
        var e = _ref5.e,
          position = _ref5.position;
        (_props2$onFocus = props2.onFocus) === null || _props2$onFocus === void 0 || _props2$onFocus.call(props2, {
          value: value2,
          e: e,
          position: position === "first" ? "start" : "end"
        });
        ctx.emit("focus", {
          value: value2,
          e: e,
          position: position === "first" ? "start" : "end"
        });
      };
      var autoSwapTime = function autoSwapTime() {
        var _currentValue$value = _slicedToArray(currentValue.value, 2),
          startTime = _currentValue$value[0],
          endTime = _currentValue$value[1];
        var startDayjs = dayjs_min(startTime, props2.format);
        var endDayjs = dayjs_min(endTime, props2.format);
        if (startDayjs.isAfter(endDayjs, "second")) {
          setInnerValue([currentValue.value[1], currentValue.value[0]]);
        } else {
          setInnerValue([currentValue.value[0], currentValue.value[1]]);
        }
      };
      var handleOnPick = function handleOnPick(pickValue, e) {
        var _props2$onPick;
        var pickedRangeValue = [];
        var context = {
          e: e
        };
        if (currentPanelIdx.value === 0) {
          var _currentValue$value$5;
          pickedRangeValue = [pickValue, (_currentValue$value$5 = currentValue.value[1]) !== null && _currentValue$value$5 !== void 0 ? _currentValue$value$5 : pickValue];
          context = {
            position: "start",
            e: e
          };
        } else {
          var _currentValue$value$6;
          pickedRangeValue = [(_currentValue$value$6 = currentValue.value[0]) !== null && _currentValue$value$6 !== void 0 ? _currentValue$value$6 : pickValue, pickValue];
          context = {
            position: "end",
            e: e
          };
        }
        (_props2$onPick = props2.onPick) === null || _props2$onPick === void 0 || _props2$onPick.call(props2, pickedRangeValue, context);
        ctx.emit("pick", pickedRangeValue, context);
      };
      VueCompositionAPI.watch(function () {
        return isShowPanel.value;
      }, function () {
        var _innerValue$value;
        currentValue.value = isShowPanel.value ? (_innerValue$value = innerValue.value) !== null && _innerValue$value !== void 0 ? _innerValue$value : TIME_PICKER_EMPTY : TIME_PICKER_EMPTY;
        if (!isShowPanel.value) currentPanelIdx.value = void 0;
      });
      return {
        global: global,
        componentName: componentName,
        currentValue: currentValue,
        currentPanelIdx: currentPanelIdx,
        inputClasses: inputClasses,
        innerValue: innerValue,
        isShowPanel: isShowPanel,
        handleInputChange: handleInputChange,
        handleShowPopup: handleShowPopup,
        handleClear: handleClear,
        handleFocus: handleFocus,
        handleOnPick: handleOnPick,
        handleClickConfirm: handleClickConfirm,
        handleClick: handleClick,
        handleInputBlur: handleInputBlur,
        handleTimeChange: handleTimeChange,
        TimeIcon: TimeIcon,
        isDisabled: isDisabled
      };
    },
    render: function render() {
      var _this$innerValue,
        _this = this;
      var h = arguments[0];
      var TimeIcon = this.TimeIcon;
      return h("div", {
        "class": this.componentName
      }, [h(RangeInputPopup, {
        "props": _objectSpread$19({}, {
          onInputChange: this.handleInputChange,
          disabled: this.isDisabled,
          readonly: this.readonly,
          popupVisible: this.isShowPanel,
          inputValue: this.isShowPanel ? this.currentValue : (_this$innerValue = this.innerValue) !== null && _this$innerValue !== void 0 ? _this$innerValue : TIME_PICKER_EMPTY,
          popupProps: _objectSpread$19({
            overlayInnerStyle: {
              width: "auto",
              padding: 0
            },
            onVisibleChange: this.handleShowPopup
          }, this.popupProps),
          status: this.status,
          tips: this.tips,
          rangeInputProps: _objectSpread$19({
            size: this.size,
            borderless: this.borderless,
            clearable: this.clearable,
            "class": this.inputClasses,
            placeholder: this.placeholder || [this.global.placeholder, this.global.placeholder],
            suffixIcon: function suffixIcon() {
              return h(TimeIcon);
            },
            onClear: this.handleClear,
            onClick: this.handleClick,
            onFocus: this.handleFocus,
            onBlur: this.handleInputBlur,
            readonly: this.readonly || !this.allowInput,
            activeIndex: this.currentPanelIdx
          }, this.rangeInputProps),
          panel: function panel() {
            return h(_TimePickerPanel, {
              "props": _objectSpread$19({}, {
                steps: _this.steps,
                format: _this.format,
                isShowPanel: _this.isShowPanel,
                disableTime: _this.disableTime,
                hideDisabledTime: _this.hideDisabledTime,
                isFooterDisplay: true,
                value: _this.currentValue[_this.currentPanelIdx || 0],
                onChange: _this.handleTimeChange,
                onPick: _this.handleOnPick,
                handleConfirmClick: _this.handleClickConfirm,
                position: _this.currentPanelIdx === 0 ? "start" : "end",
                activeIndex: _this.currentPanelIdx,
                presets: _this.presets
              })
            });
          }
        })
      })]);
    }
  });

  var KeyboardDirection = /* @__PURE__ */function (KeyboardDirection2) {
    KeyboardDirection2[KeyboardDirection2["left"] = 37] = "left";
    KeyboardDirection2[KeyboardDirection2["up"] = 38] = "up";
    KeyboardDirection2[KeyboardDirection2["right"] = 39] = "right";
    KeyboardDirection2[KeyboardDirection2["down"] = 40] = "down";
    return KeyboardDirection2;
  }(KeyboardDirection || {});
  var EPickerCols = /* @__PURE__ */function (EPickerCols2) {
    EPickerCols2["hour"] = "hour";
    EPickerCols2["minute"] = "minute";
    EPickerCols2["second"] = "second";
    EPickerCols2["meridiem"] = "meridiem";
    return EPickerCols2;
  }(EPickerCols || {});

  var TimePicker = withInstall$1(_TimePicker, VueCompositionAPI__default["default"]);
  var TimeRangePicker = withInstall$1(_TimeRangePicker, VueCompositionAPI__default["default"]);
  var TimePickerPanel = withInstall$1(_TimePickerPanel, VueCompositionAPI__default["default"]);

  var TransitionGroup = Vue__default["default"].component("TransitionGroup");
  var onDrag = {
    "default": void 0
  };
  var TreeItemDefinition = {
    name: "TTreeItem",
    inject: {
      onDrag: onDrag
    }
  };
  function withInstall(construct) {
    return withInstall$1(construct, VueCompositionAPI__default["default"]);
  }
  function getCreateElement(h) {
    return h;
  }
  function getScopedSlots(instance) {
    return instance.$scopedSlots;
  }
  function useVModel(props, refsProps) {
    var propName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "value";
    var defaultPropName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "defaultValue";
    var eventPropName = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "onChange";
    var eventName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "change";
    if (propName === "value") {
      return useVModel$1(refsProps[propName], props[defaultPropName], props[eventPropName], eventName, propName);
    }
    return useDefaultValue(refsProps[propName], props[defaultPropName], props[eventPropName], propName, eventName);
  }

  var props$u = {
    activable: Boolean,
    activeMultiple: Boolean,
    actived: {
      type: Array,
      "default": void 0
    },
    defaultActived: {
      type: Array
    },
    allowDrop: {
      type: Function
    },
    allowFoldNodeOnFilter: Boolean,
    checkProps: {
      type: Object
    },
    checkStrictly: Boolean,
    checkable: Boolean,
    data: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    disableCheck: {
      type: [Boolean, Function],
      "default": false
    },
    disabled: Boolean,
    draggable: Boolean,
    empty: {
      type: [String, Function],
      "default": ""
    },
    expandAll: Boolean,
    expandLevel: {
      type: Number,
      "default": 0
    },
    expandMutex: Boolean,
    expandOnClickNode: Boolean,
    expandParent: Boolean,
    expanded: {
      type: Array,
      "default": void 0
    },
    defaultExpanded: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    filter: {
      type: Function
    },
    height: {
      type: [String, Number]
    },
    hover: Boolean,
    icon: {
      type: [Boolean, Function],
      "default": true
    },
    keys: {
      type: Object
    },
    label: {
      type: [String, Boolean, Function],
      "default": true
    },
    lazy: {
      type: Boolean,
      "default": true
    },
    line: {
      type: [Boolean, Function],
      "default": false
    },
    load: {
      type: Function
    },
    maxHeight: {
      type: [String, Number]
    },
    operations: {
      type: Function
    },
    scroll: {
      type: Object
    },
    transition: {
      type: Boolean,
      "default": true
    },
    value: {
      type: Array,
      "default": void 0
    },
    defaultValue: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    valueMode: {
      type: String,
      "default": "onlyLeaf",
      validator: function validator(val) {
        if (!val) return true;
        return ["onlyLeaf", "parentFirst", "all"].includes(val);
      }
    },
    onActive: Function,
    onChange: Function,
    onClick: Function,
    onDragEnd: Function,
    onDragLeave: Function,
    onDragOver: Function,
    onDragStart: Function,
    onDrop: Function,
    onExpand: Function,
    onLoad: Function,
    onScroll: Function
  };

  function useTreeStore(state) {
    var props = state.props,
      context = state.context,
      refProps = state.refProps;
    var valueMode = props.valueMode,
      filter = props.filter,
      keys = props.keys;
    var store = new TreeStore({
      valueMode: valueMode,
      filter: filter
    });
    var tValue = state.vmValue[0];
    var tActived = state.vmActived[0];
    var tExpanded = state.vmExpanded[0];
    var updateStoreConfig = function updateStoreConfig() {
      var storeProps = pick$1(props, ["expandAll", "expandLevel", "expandMutex", "expandParent", "activable", "activeMultiple", "disabled", "disableCheck", "checkable", "draggable", "checkStrictly", "load", "lazy", "valueMode", "filter", "allowFoldNodeOnFilter"]);
      store.setConfig(storeProps);
    };
    var updateExpanded = function updateExpanded() {
      var expandParent = props.expandParent;
      if (!Array.isArray(tExpanded.value)) return;
      var expandedMap = /* @__PURE__ */new Map();
      tExpanded.value.forEach(function (val) {
        expandedMap.set(val, true);
        if (expandParent) {
          var node = store.getNode(val);
          if (node) {
            node.getModel().getParents().forEach(function (tn) {
              expandedMap.set(tn.value, true);
            });
          }
        }
      });
      var expandedArr = Array.from(expandedMap.keys());
      store.setExpanded(expandedArr);
    };
    var filterChanged = false;
    var prevExpanded = null;
    var expandFilterPath = function expandFilterPath() {
      if (!props.allowFoldNodeOnFilter) return;
      if (!filterChanged) return;
      filterChanged = false;
      if (props.filter) {
        if (!prevExpanded) {
          prevExpanded = store.getExpanded();
        }
        var pathValues = [];
        var allNodes = store.getNodes();
        allNodes.forEach(function (node) {
          if (node.vmIsLocked) {
            pathValues.push(node.value);
          }
        });
        store.setExpanded(pathValues);
      } else if (prevExpanded) {
        store.replaceExpanded(prevExpanded);
        prevExpanded = null;
      }
    };
    var checkFilterExpand = function checkFilterExpand(newFilter, previousFilter) {
      if (!props.allowFoldNodeOnFilter) return;
      filterChanged = newFilter !== previousFilter;
    };
    var handleLoad = function handleLoad(info) {
      var node = info.node;
      var evtCtx = {
        node: node.getModel()
      };
      if (Array.isArray(tValue.value) && tValue.value.length > 0) {
        store.replaceChecked(tValue.value);
      }
      if (Array.isArray(tExpanded.value) && tExpanded.value.length > 0) {
        store.replaceExpanded(tExpanded.value);
      }
      if (Array.isArray(tActived.value) && tActived.value.length > 0) {
        store.replaceActived(tActived.value);
      }
      if (props !== null && props !== void 0 && props.onLoad) {
        props === null || props === void 0 || props.onLoad(evtCtx);
      }
      context.emit("load", evtCtx);
    };
    var rebuild = function rebuild(list) {
      store.reload(list || []);
      store.refreshNodes();
      if (Array.isArray(tValue.value)) {
        store.setChecked(tValue.value);
      }
      updateExpanded();
      if (Array.isArray(tActived.value)) {
        store.setActived(tActived.value);
      }
      store.refreshState();
    };
    function initStore() {
      store.setConfig({
        keys: keys
      });
      updateStoreConfig();
      store.append(props.data || []);
      store.refreshNodes();
      if (Array.isArray(tValue.value)) {
        store.setChecked(tValue.value);
      }
      updateExpanded();
      if (Array.isArray(tActived.value)) {
        store.setActived(tActived.value);
      }
      store.emitter.on("load", handleLoad);
      store.emitter.on("update", expandFilterPath);
    }
    initStore();
    state.setStore(store);
    VueCompositionAPI.watch(function () {
      return _toConsumableArray(tValue.value || []);
    }, function (nVal) {
      store.replaceChecked(nVal);
    });
    VueCompositionAPI.watch(function () {
      return _toConsumableArray(tExpanded.value || []);
    }, function (nVal) {
      store.replaceExpanded(nVal);
    });
    VueCompositionAPI.watch(function () {
      return _toConsumableArray(tActived.value || []);
    }, function (nVal) {
      store.replaceActived(nVal);
    });
    VueCompositionAPI.watch(refProps.filter, function (nVal, previousVal) {
      checkFilterExpand(nVal, previousVal);
    });
    VueCompositionAPI.watch(refProps.keys, function (keys2) {
      store.setConfig({
        keys: keys2
      });
    });
    return {
      store: store,
      rebuild: rebuild,
      checkFilterExpand: checkFilterExpand,
      updateStoreConfig: updateStoreConfig,
      updateExpanded: updateExpanded,
      expandFilterPath: expandFilterPath
    };
  }

  function formatCSSUnit$1(unit) {
    if (!unit) return unit;
    return isNaN(Number(unit)) ? unit : "".concat(unit, "px");
  }
  function useTreeStyles(state) {
    var props = state.props;
    var componentName = usePrefixClass("tree").value;
    var classPrefix = usePrefixClass().value;
    var virtualConfig = state.virtualConfig,
      isScrolling = state.isScrolling,
      refProps = state.refProps;
    var height = refProps.height,
      maxHeight = refProps.maxHeight;
    var treeClasses = VueCompositionAPI.computed(function () {
      var list = [componentName];
      var disabled = props.disabled,
        hover = props.hover,
        transition = props.transition,
        checkable = props.checkable,
        draggable = props.draggable,
        expandOnClickNode = props.expandOnClickNode,
        scroll = props.scroll;
      if (disabled) {
        list.push("".concat(classPrefix, "-is-disabled"));
      }
      if (hover) {
        list.push("".concat(componentName, "--hoverable"));
      }
      if (checkable) {
        list.push("".concat(componentName, "--checkable"));
      }
      if (draggable) {
        list.push("".concat(componentName, "--draggable"));
      }
      if (transition) {
        list.push("".concat(componentName, "--transition"));
      }
      if (expandOnClickNode) {
        list.push("".concat(componentName, "--block-node"));
      }
      var isVirtual = virtualConfig === null || virtualConfig === void 0 ? void 0 : virtualConfig.isVirtualScroll.value;
      if (isVirtual) {
        list.push("".concat(componentName, "__vscroll"));
        if (isScrolling.value) {
          list.push("".concat(componentName, "--scrolling"));
        }
      } else if (scroll && scroll.type === "lazy") {
        list.push("".concat(componentName, "__lazyload"));
      }
      return list;
    });
    var treeContentStyles = VueCompositionAPI.computed(function () {
      return {
        height: formatCSSUnit$1(height.value),
        maxHeight: formatCSSUnit$1(maxHeight.value),
        overflowY: formatCSSUnit$1(height.value) || formatCSSUnit$1(maxHeight.value) ? "auto" : void 0
      };
    });
    var scrollStyles = VueCompositionAPI.computed(function () {
      var isVirtual = virtualConfig === null || virtualConfig === void 0 ? void 0 : virtualConfig.isVirtualScroll.value;
      var translateY = isVirtual ? virtualConfig === null || virtualConfig === void 0 ? void 0 : virtualConfig.translateY.value : 0;
      var transform = "translateY(".concat(translateY, "px)");
      var posStyle = {
        transform: transform,
        "-ms-transform": transform,
        "-moz-transform": transform,
        "-webkit-transform": transform
      };
      return posStyle;
    });
    var cursorStyles = VueCompositionAPI.computed(function () {
      var isVirtual = virtualConfig === null || virtualConfig === void 0 ? void 0 : virtualConfig.isVirtualScroll.value;
      var translateY = isVirtual ? virtualConfig === null || virtualConfig === void 0 ? void 0 : virtualConfig.translateY.value : 0;
      var translate = "translate(0, ".concat(translateY, "px)");
      return {
        transform: translate,
        "-ms-transform": translate,
        "-moz-transform": translate,
        "-webkit-transform": translate
      };
    });
    return {
      treeClasses: treeClasses,
      treeContentStyles: treeContentStyles,
      scrollStyles: scrollStyles,
      cursorStyles: cursorStyles
    };
  }

  function useTreeState(props, context) {
    var treeContentRef = VueCompositionAPI.ref();
    var nodes = VueCompositionAPI.ref([]);
    var allNodes = VueCompositionAPI.ref([]);
    var isScrolling = VueCompositionAPI.ref(false);
    var refProps = VueCompositionAPI.toRefs(props);
    var vmValue = useVModel(props, refProps, "value", "defaultValue", "onChange", "change");
    var vmActived = useVModel(props, refProps, "actived", "defaultActived", "onActive", "active");
    var vmExpanded = useVModel(props, refProps, "expanded", "defaultExpanded", "onExpand", "expand");
    function setStore(store) {
      state.store = store;
      state.scope.store = store;
      allNodes.value = store.getNodes();
    }
    var state = {
      props: props,
      context: context,
      store: null,
      treeContentRef: treeContentRef,
      nodes: nodes,
      allNodes: allNodes,
      isScrolling: isScrolling,
      mouseEvent: null,
      virtualConfig: null,
      scope: {
        store: null,
        treeContentRef: treeContentRef,
        treeProps: props,
        scopedSlots: {},
        virtualConfig: null
      },
      setStore: setStore,
      refProps: refProps,
      vmValue: vmValue,
      vmActived: vmActived,
      vmExpanded: vmExpanded
    };
    return {
      state: state
    };
  }

  function ownKeys$19(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$18(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$19(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$19(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function emitEvent(props, context, evtName) {
    var apiName = camelCase$1("on-".concat(evtName));
    evtName.replace(/^on/, "").toLowerCase();
    for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      args[_key - 3] = arguments[_key];
    }
    if (typeof props[apiName] === "function") {
      props[apiName].apply(props, args);
    }
    {
      context.emit.apply(context, [evtName].concat(args));
    }
  }
  function getParentsToRoot(element, root) {
    var list = [];
    var el = element;
    while (el && el.parentNode) {
      list.push(el);
      if (el === root) {
        break;
      }
      el = el.parentNode;
    }
    return list;
  }
  function getParentMarks(name, element, root) {
    var list = getParentsToRoot(element, root);
    return list.map(function (el) {
      var mark = {
        name: name,
        value: (el === null || el === void 0 ? void 0 : el.getAttribute(name)) || "",
        el: el
      };
      return mark;
    }).filter(function (mark) {
      return mark.value;
    });
  }
  function getMark(name, element, root) {
    var list = getParentMarks(name, element, root);
    var info = list.pop() || null;
    return info;
  }
  function pathMatchClass(name, element, root) {
    var list = getParentsToRoot(element, root);
    var rs = list.some(function (el) {
      return el.classList.contains(name);
    });
    return rs;
  }
  function getTNode(prop, options) {
    var tnode = null;
    var item = null;
    var conf = _objectSpread$18({}, options);
    if (typeof prop === "function") {
      var _conf$node;
      item = prop(conf.createElement, (_conf$node = conf.node) === null || _conf$node === void 0 ? void 0 : _conf$node.getModel());
    } else if (typeof prop === "string") {
      item = prop;
    }
    if (typeof item === "string") {
      tnode = item;
    } else if (item) {
      tnode = item;
    }
    return tnode;
  }
  function isTreeNodeValue(item) {
    return typeof item === "string" || typeof item === "number";
  }
  function getNode(store, item) {
    var node = null;
    var val = null;
    if (typeof item === "string" || typeof item === "number") {
      val = item;
    } else if (item && isTreeNodeValue(item.value)) {
      val = item.value;
    }
    node = store.getNode(val);
    return node;
  }

  function useTreeAction(state) {
    var treeState = state;
    var store = treeState.store;
    var componentName = usePrefixClass("tree").value;
    var _state$vmValue = _slicedToArray(state.vmValue, 2),
      tValue = _state$vmValue[0],
      setTValue = _state$vmValue[1];
    var _state$vmActived = _slicedToArray(state.vmActived, 2),
      tActived = _state$vmActived[0],
      setTActived = _state$vmActived[1];
    var _state$vmExpanded = _slicedToArray(state.vmExpanded, 2),
      tExpanded = _state$vmExpanded[0],
      setTExpanded = _state$vmExpanded[1];
    var setExpanded = function setExpanded(item, isExpanded) {
      var node = getNode(store, item);
      var mouseEvent = treeState.mouseEvent;
      var evtCtx = {
        node: node.getModel(),
        e: mouseEvent,
        trigger: "setItem"
      };
      if (mouseEvent) {
        evtCtx.trigger = "node-click";
        var target = mouseEvent.target;
        var currentTarget = mouseEvent.currentTarget;
        if (pathMatchClass("".concat(componentName, "__icon"), target, currentTarget)) {
          evtCtx.trigger = "icon-click";
        }
      }
      var expanded = node.setExpanded(isExpanded, {
        directly: true
      });
      setTExpanded(expanded, evtCtx);
      if (evtCtx.trigger !== "setItem") {
        store.replaceExpanded(tExpanded.value || []);
      }
      return expanded;
    };
    var toggleExpanded = function toggleExpanded(item) {
      var node = getNode(store, item);
      if (!node.children) return;
      return setExpanded(node, !node.isExpanded());
    };
    var setActived = function setActived(item, isActived) {
      var node = getNode(store, item);
      var mouseEvent = treeState.mouseEvent;
      var evtCtx = {
        node: node.getModel(),
        e: mouseEvent,
        trigger: "setItem"
      };
      if (mouseEvent) {
        evtCtx.trigger = "node-click";
      }
      var actived = node.setActived(isActived, {
        isAction: evtCtx.trigger === "node-click",
        directly: true
      });
      setTActived(actived, evtCtx);
      if (evtCtx.trigger !== "setItem") {
        store.replaceActived(tActived.value || []);
      }
      return actived;
    };
    var toggleActived = function toggleActived(item) {
      var node = getNode(store, item);
      return setActived(node, !node.isActived());
    };
    var setChecked = function setChecked(item, isChecked, ctx) {
      var node = getNode(store, item);
      var mouseEvent = ctx === null || ctx === void 0 ? void 0 : ctx.e;
      var evtCtx = {
        node: node.getModel(),
        e: mouseEvent,
        trigger: "setItem"
      };
      if (mouseEvent) {
        evtCtx.trigger = "node-click";
      }
      var checked = node.setChecked(isChecked, {
        isAction: evtCtx.trigger === "node-click",
        directly: true
      });
      setTValue(checked, evtCtx);
      if (evtCtx.trigger !== "setItem") {
        store.replaceChecked(tValue.value || []);
      }
      return checked;
    };
    var toggleChecked = function toggleChecked(item, ctx) {
      var node = getNode(store, item);
      if (node.isIndeterminate()) {
        var expectState = node.hasEnableUnCheckedChild();
        return setChecked(node, expectState, ctx);
      }
      return setChecked(node, !node.isChecked(), ctx);
    };
    return {
      setExpanded: setExpanded,
      toggleExpanded: toggleExpanded,
      setActived: setActived,
      toggleActived: toggleActived,
      setChecked: setChecked,
      toggleChecked: toggleChecked
    };
  }

  function ownKeys$18(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$17(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$18(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$18(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function useTreeScroll(state) {
    var treeState = state;
    var props = treeState.props,
      context = treeState.context,
      allNodes = treeState.allNodes,
      nodes = treeState.nodes,
      scope = treeState.scope,
      treeContentRef = treeState.treeContentRef,
      isScrolling = treeState.isScrolling;
    var scrollProps = VueCompositionAPI.computed(function () {
      return _objectSpread$17({
        rowHeight: 34
      }, props.scroll);
    });
    scope.scrollProps = scrollProps;
    var virtualScrollParams = VueCompositionAPI.computed(function () {
      var list = allNodes.value.filter(function (node) {
        return node.visible;
      });
      return {
        data: list,
        scroll: scrollProps.value
      };
    });
    var virtualConfig = useVirtualScroll$1(treeContentRef, virtualScrollParams);
    scope.virtualConfig = virtualConfig;
    treeState.virtualConfig = virtualConfig;
    VueCompositionAPI.onMounted(function () {
      var isVirtual = virtualConfig === null || virtualConfig === void 0 ? void 0 : virtualConfig.isVirtualScroll.value;
      if (isVirtual) {
        virtualConfig.handleScroll();
      }
    });
    var emitScrollEvent = function emitScrollEvent(e) {
      var _props$onScroll;
      (_props$onScroll = props.onScroll) === null || _props$onScroll === void 0 || _props$onScroll.call(props, {
        e: e
      });
      context.emit("scroll", {
        e: e
      });
    };
    var scrollStopTimer = null;
    var setScrolling = function setScrolling() {
      isScrolling.value = true;
      if (scrollStopTimer) {
        clearTimeout(scrollStopTimer);
        scrollStopTimer = null;
      }
      scrollStopTimer = setTimeout(function () {
        scrollStopTimer = null;
        isScrolling.value = false;
      }, 100);
    };
    var lastScrollY = 0;
    var onInnerVirtualScroll = function onInnerVirtualScroll(e) {
      setScrolling();
      var isVirtual = virtualConfig === null || virtualConfig === void 0 ? void 0 : virtualConfig.isVirtualScroll.value;
      var target = e.target || e.srcElement;
      var top = target.scrollTop;
      if (lastScrollY !== top) {
        if (isVirtual) {
          virtualConfig.handleScroll();
          nodes.value = virtualConfig.visibleData.value;
        }
      } else {
        lastScrollY = 0;
      }
      lastScrollY = top;
      emitScrollEvent(e);
    };
    var handleScrollTo = function handleScrollTo(params) {
      var index = params.index;
      if (!index && index !== 0) {
        var _allNodes$value;
        if (!params.key) {
          log.error("Tree", "scrollToElement: one of `index` or `key` must exist.");
          return;
        }
        index = (_allNodes$value = allNodes.value) === null || _allNodes$value === void 0 ? void 0 : _allNodes$value.findIndex(function (item) {
          return [get(item.data, "key"), get(item.data, "value")].includes(params.key);
        });
        if (index < 0) {
          log.error("Tree", "".concat(params.key, " does not exist in data, check `key` or `data` please."));
          return;
        }
      }
      virtualConfig.scrollToElement(_objectSpread$17(_objectSpread$17({}, params), {}, {
        index: index - 1
      }));
    };
    return {
      treeContentRef: treeContentRef,
      onInnerVirtualScroll: onInnerVirtualScroll,
      virtualConfig: virtualConfig,
      scrollToElement: handleScrollTo
    };
  }

  function useItemState(props, context) {
    var refProps = VueCompositionAPI.toRefs(props);
    var treeItemRef = VueCompositionAPI.ref(null);
    var treeScope = props.treeScope;
    var store = treeScope.store;
    var node = store.privateMap.get(props.itemKey);
    var state = {
      stateId: props.stateId,
      props: props,
      context: context,
      treeScope: treeScope,
      refProps: refProps,
      node: node,
      treeItemRef: treeItemRef
    };
    return {
      state: state
    };
  }

  function useItemEvents(state) {
    var context = state.context;
    var classPrefix = usePrefixClass().value;
    var handleChange = function handleChange(_, ctx) {
      var node = state.node;
      var event = new Event("change");
      var evtContext = {
        event: event,
        node: node
      };
      context.emit("change", evtContext, ctx);
    };
    var clicked = false;
    var handleClick = function handleClick(evt) {
      var _srcTarget$className, _srcTarget$className$;
      var node = state.node,
        treeScope = state.treeScope;
      var _treeScope$treeProps = treeScope.treeProps,
        treeProps = _treeScope$treeProps === void 0 ? {} : _treeScope$treeProps;
      var expandOnClickNode = treeProps.expandOnClickNode;
      var srcTarget = evt.target;
      var isBranchTrigger = node.children && expandOnClickNode && (srcTarget.className === "".concat(classPrefix, "-checkbox__input") || srcTarget.tagName.toLowerCase() === "input");
      if (clicked || isBranchTrigger) return;
      clicked = true;
      setTimeout(function () {
        clicked = false;
      });
      if (expandOnClickNode && node.children && ((_srcTarget$className = srcTarget.className) === null || _srcTarget$className === void 0 || (_srcTarget$className$ = _srcTarget$className.indexOf) === null || _srcTarget$className$ === void 0 ? void 0 : _srcTarget$className$.call(_srcTarget$className, "".concat(classPrefix, "-tree__label"))) !== -1) {
        evt.preventDefault();
      }
      var evtContext = {
        mouseEvent: evt,
        event: evt,
        node: node,
        path: node.getPath()
      };
      context.emit("click", evtContext);
    };
    return {
      handleChange: handleChange,
      handleClick: handleClick
    };
  }

  function useRenderIcon(state) {
    var classPrefix = usePrefixClass().value;
    var componentName = usePrefixClass("tree").value;
    var getFolderIcon = function getFolderIcon(h) {
      var _useGlobalIcon = useGlobalIcon({
          CaretRightSmallIcon: TdCaretRightSmallIcon
        }),
        CaretRightSmallIcon = _useGlobalIcon.CaretRightSmallIcon;
      return h(CaretRightSmallIcon);
    };
    var handleMousedown = function handleMousedown(evt) {
      evt.preventDefault();
    };
    var renderIcon = function renderIcon(h) {
      var node = state.node,
        treeScope = state.treeScope;
      var scopedSlots = treeScope.scopedSlots;
      var treeProps = (treeScope === null || treeScope === void 0 ? void 0 : treeScope.treeProps) || {};
      var icon = treeProps.icon;
      var isDefaultIcon = false;
      var iconNode = null;
      if (icon === true) {
        if (scopedSlots !== null && scopedSlots !== void 0 && scopedSlots.icon) {
          iconNode = scopedSlots.icon({
            node: node === null || node === void 0 ? void 0 : node.getModel()
          });
        } else if (!node.vmIsLeaf) {
          isDefaultIcon = true;
          iconNode = getFolderIcon(h);
          if (node.loading && node.expanded) {
            iconNode = h(Loading);
          }
        } else {
          iconNode = "";
        }
      } else if (icon) {
        iconNode = getTNode(icon, {
          createElement: h,
          node: node
        });
      }
      var wrapIconNode = h("span", {
        "class": ["".concat(componentName, "__icon"), "".concat(classPrefix, "-folder-icon"), isDefaultIcon ? "".concat(componentName, "__icon--default") : ""],
        "attrs": {
          "trigger": "expand",
          "ignore": "active"
        },
        "on": {
          "mousedown": handleMousedown
        }
      }, [iconNode]);
      return wrapIconNode;
    };
    return {
      renderIcon: renderIcon
    };
  }

  function ownKeys$17(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$16(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$17(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$17(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function useRenderLabel(state) {
    var classPrefix = usePrefixClass().value;
    var componentName = usePrefixClass("tree").value;
    var _useItemEvents = useItemEvents(state),
      handleChange = _useItemEvents.handleChange;
    var renderLabel = function renderLabel(h) {
      var node = state.node,
        treeScope = state.treeScope;
      var scopedSlots = treeScope.scopedSlots,
        _treeScope$treeProps = treeScope.treeProps,
        treeProps = _treeScope$treeProps === void 0 ? {} : _treeScope$treeProps;
      var label = treeProps.label,
        expandOnClickNode = treeProps.expandOnClickNode;
      var checkProps = (treeProps === null || treeProps === void 0 ? void 0 : treeProps.checkProps) || {};
      var labelNode = null;
      if (label === true) {
        if (scopedSlots !== null && scopedSlots !== void 0 && scopedSlots.label) {
          labelNode = scopedSlots.label({
            node: node === null || node === void 0 ? void 0 : node.getModel()
          });
        } else {
          labelNode = node.label || "";
        }
      } else {
        labelNode = getTNode(label, {
          createElement: h,
          node: node
        });
      }
      var labelClasses = ["".concat(componentName, "__label"), _defineProperty$2({}, "".concat(classPrefix, "-is-active"), node.isActivable() ? node.actived : false)];
      var shouldStopLabelTrigger = VueCompositionAPI.computed(function () {
        var _node$children;
        var isNormalBranchNode = Array.isArray(node.children) && ((_node$children = node.children) === null || _node$children === void 0 ? void 0 : _node$children.length) > 0;
        var isLazyLoadChildBranchNode = isBoolean(node.children) && node.children;
        var isBranchNode = isNormalBranchNode || isLazyLoadChildBranchNode;
        return expandOnClickNode && isBranchNode;
      });
      if (node.vmCheckable) {
        var checkboxDisabled = false;
        if (node.vmIsLocked && !node.vmIsRest) {
          checkboxDisabled = true;
        }
        if (node.isDisabled()) {
          checkboxDisabled = true;
        }
        var itemCheckProps = _objectSpread$16(_objectSpread$16({}, checkProps), {}, {
          disabled: checkboxDisabled
        });
        labelNode = h(Checkbox, helper([{
          "class": labelClasses,
          "attrs": {
            "checked": node.checked,
            "indeterminate": node.indeterminate,
            "disabled": checkboxDisabled,
            "name": String(node.value),
            "stopLabelTrigger": shouldStopLabelTrigger.value,
            "ignore": treeProps.expandOnClickNode ? "active" : "expand,active"
          },
          "on": {
            "change": handleChange
          }
        }, {
          "props": itemCheckProps
        }]), [labelNode]);
      } else {
        var inner = h("span", {
          "style": "position: relative"
        }, [labelNode]);
        labelNode = node.isActivable() ? h("span", {
          "key": "1",
          "ref": "label",
          "class": labelClasses,
          "attrs": {
            "title": node.label
          }
        }, [inner]) : h("span", {
          "key": "2",
          "class": labelClasses,
          "attrs": {
            "title": node.label
          }
        }, [inner]);
      }
      return labelNode;
    };
    return {
      renderLabel: renderLabel
    };
  }

  function useRenderLine(state) {
    var componentName = usePrefixClass("tree").value;
    var renderLine = function renderLine(h) {
      var node = state.node,
        treeScope = state.treeScope;
      var scopedSlots = treeScope.scopedSlots;
      var treeProps = (treeScope === null || treeScope === void 0 ? void 0 : treeScope.treeProps) || {};
      var line = treeProps.line;
      var iconVisible = !!treeProps.icon;
      var lineNode = null;
      if (line === true) {
        if (scopedSlots !== null && scopedSlots !== void 0 && scopedSlots.line) {
          lineNode = scopedSlots.line({
            node: node === null || node === void 0 ? void 0 : node.getModel()
          });
        } else if (node.parent && node.tree) {
          var vmIsLeaf = node.vmIsLeaf,
            vmIsFirst = node.vmIsFirst,
            level = node.level;
          var lineClasses = [];
          lineClasses.push("".concat(componentName, "__line"));
          if (vmIsLeaf || !iconVisible) {
            lineClasses.push("".concat(componentName, "__line--leaf"));
          }
          if (vmIsFirst && iconVisible) {
            lineClasses.push("".concat(componentName, "__line--first"));
          }
          var shadowStyles = [];
          var parents = node.getParents();
          parents.pop();
          parents.forEach(function (pnode, index) {
            if (!pnode.vmIsLast) {
              shadowStyles.push("calc(-".concat(index + 1, " * var(--space)) 0 var(--color)"));
            }
          });
          var styles = {
            "--level": level ? String(level) : void 0,
            "box-shadow": shadowStyles.join(",")
          };
          lineNode = h("span", {
            "class": lineClasses,
            "style": styles
          });
        }
      } else {
        lineNode = getTNode(line, {
          createElement: h,
          node: node
        });
      }
      return lineNode;
    };
    return {
      renderLine: renderLine
    };
  }

  function useRenderOperations(state) {
    var componentName = usePrefixClass("tree").value;
    var renderOperations = function renderOperations(h) {
      var node = state.node,
        treeScope = state.treeScope;
      var scopedSlots = treeScope.scopedSlots;
      var treeProps = (treeScope === null || treeScope === void 0 ? void 0 : treeScope.treeProps) || {};
      var operations = treeProps.operations;
      var opNode = null;
      if (scopedSlots !== null && scopedSlots !== void 0 && scopedSlots.operations) {
        opNode = scopedSlots.operations({
          node: node === null || node === void 0 ? void 0 : node.getModel()
        });
      } else {
        opNode = getTNode(operations, {
          createElement: h,
          node: node
        });
      }
      if (opNode) {
        opNode = h("span", {
          "class": "".concat(componentName, "__operations"),
          "attrs": {
            "ignore": "active,expand"
          }
        }, [opNode]);
      }
      return opNode;
    };
    return {
      renderOperations: renderOperations
    };
  }

  var DragPosition = /* @__PURE__ */function (DragPosition2) {
    DragPosition2[DragPosition2["Before"] = -1] = "Before";
    DragPosition2[DragPosition2["Inside"] = 0] = "Inside";
    DragPosition2[DragPosition2["After"] = 1] = "After";
    return DragPosition2;
  }(DragPosition || {});
  function useDraggable(state) {
    var treeItemRef = state.treeItemRef;
    var dragStates = VueCompositionAPI.reactive({
      isDragOver: false,
      isDragging: false,
      dropPosition: 0 /* Inside */
    });
    var updateDropPosition = function updateDropPosition(dragEvent) {
      var _rootNode$getBounding;
      var rootNode = treeItemRef.value;
      if (!rootNode) return;
      var rect = rootNode === null || rootNode === void 0 || (_rootNode$getBounding = rootNode.getBoundingClientRect) === null || _rootNode$getBounding === void 0 ? void 0 : _rootNode$getBounding.call(rootNode);
      var offsetY = window.scrollY + rect.top;
      var pageY = dragEvent.pageY;
      var gapHeight = rect.height / 4;
      var diff = pageY - offsetY;
      if (diff < gapHeight) {
        dragStates.dropPosition = -1 /* Before */;
      } else if (diff < rect.height - gapHeight) {
        dragStates.dropPosition = 0 /* Inside */;
      } else {
        dragStates.dropPosition = 1 /* After */;
      }
    };
    var setDragStatus = function setDragStatus(status, dragEvent) {
      var _drag$handleDragStart, _drag$handleDragEnd, _drag$handleDragOver, _drag$handleDragLeave, _drag$handleDrop;
      var node = state.node,
        treeScope = state.treeScope;
      var drag = treeScope.drag;
      if (!drag) return;
      switch (status) {
        case "dragStart":
          dragStates.isDragging = true;
          dragStates.dropPosition = 0 /* Inside */;
          (_drag$handleDragStart = drag.handleDragStart) === null || _drag$handleDragStart === void 0 || _drag$handleDragStart.call(drag, {
            node: node,
            dragEvent: dragEvent
          });
          break;
        case "dragEnd":
          dragStates.isDragging = false;
          dragStates.isDragOver = false;
          dragStates.dropPosition = 0 /* Inside */;
          throttleUpdateDropPosition.cancel();
          (_drag$handleDragEnd = drag.handleDragEnd) === null || _drag$handleDragEnd === void 0 || _drag$handleDragEnd.call(drag, {
            node: node,
            dragEvent: dragEvent
          });
          break;
        case "dragOver":
          dragStates.isDragOver = true;
          throttleUpdateDropPosition(dragEvent);
          (_drag$handleDragOver = drag.handleDragOver) === null || _drag$handleDragOver === void 0 || _drag$handleDragOver.call(drag, {
            node: node,
            dragEvent: dragEvent
          });
          break;
        case "dragLeave":
          dragStates.isDragOver = false;
          dragStates.dropPosition = 0 /* Inside */;
          throttleUpdateDropPosition.cancel();
          (_drag$handleDragLeave = drag.handleDragLeave) === null || _drag$handleDragLeave === void 0 || _drag$handleDragLeave.call(drag, {
            node: node,
            dragEvent: dragEvent
          });
          break;
        case "drop":
          (_drag$handleDrop = drag.handleDrop) === null || _drag$handleDrop === void 0 || _drag$handleDrop.call(drag, {
            node: node,
            dropPosition: dragStates.dropPosition,
            dragEvent: dragEvent
          });
          dragStates.isDragOver = false;
          throttleUpdateDropPosition.cancel();
          break;
      }
    };
    var handleDragStart = function handleDragStart(evt) {
      var node = state.node;
      if (!node.isDraggable()) return;
      evt.stopPropagation();
      setDragStatus("dragStart", evt);
      try {
        var _evt$dataTransfer;
        (_evt$dataTransfer = evt.dataTransfer) === null || _evt$dataTransfer === void 0 || _evt$dataTransfer.setData("text/plain", "");
      } catch (e) {}
    };
    var handleDragEnd = function handleDragEnd(evt) {
      var node = state.node;
      if (!node.isDraggable()) return;
      evt.stopPropagation();
      setDragStatus("dragEnd", evt);
    };
    var handleDragOver = function handleDragOver(evt) {
      var node = state.node;
      if (!node.isDraggable()) return;
      evt.stopPropagation();
      evt.preventDefault();
      setDragStatus("dragOver", evt);
    };
    var handleDragLeave = function handleDragLeave(evt) {
      var node = state.node;
      if (!node.isDraggable()) return;
      evt.stopPropagation();
      setDragStatus("dragLeave", evt);
    };
    var handleDrop = function handleDrop(evt) {
      var node = state.node;
      if (!node.isDraggable()) return;
      evt.stopPropagation();
      evt.preventDefault();
      setDragStatus("drop", evt);
    };
    var throttleUpdateDropPosition = throttle$1(function (dragEvent) {
      updateDropPosition(dragEvent);
    });
    return {
      dragStates: dragStates,
      handleDragStart: handleDragStart,
      handleDragEnd: handleDragEnd,
      handleDragOver: handleDragOver,
      handleDragLeave: handleDragLeave,
      handleDrop: handleDrop
    };
  }

  function ownKeys$16(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$15(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$16(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$16(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function useTreeItem(state) {
    var treeScope = state.treeScope,
      treeItemRef = state.treeItemRef;
    var virtualConfig = treeScope.virtualConfig,
      treeContentRef = treeScope.treeContentRef,
      scrollProps = treeScope.scrollProps;
    var classPrefix = usePrefixClass().value;
    var componentName = usePrefixClass("tree").value;
    var _useItemEvents = useItemEvents(state),
      handleClick = _useItemEvents.handleClick;
    var _useRenderIcon = useRenderIcon(state),
      renderIcon = _useRenderIcon.renderIcon;
    var _useRenderLabel = useRenderLabel(state),
      renderLabel = _useRenderLabel.renderLabel;
    var _useRenderLine = useRenderLine(state),
      renderLine = _useRenderLine.renderLine;
    var _useRenderOperations = useRenderOperations(state),
      renderOperations = _useRenderOperations.renderOperations;
    var _useDraggable = useDraggable(state),
      dragStates = _useDraggable.dragStates,
      handleDragStart = _useDraggable.handleDragStart,
      handleDragEnd = _useDraggable.handleDragEnd,
      handleDragOver = _useDraggable.handleDragOver,
      handleDragLeave = _useDraggable.handleDragLeave,
      handleDrop = _useDraggable.handleDrop;
    var _useLazyLoad = useLazyLoad(treeContentRef, treeItemRef, VueCompositionAPI.reactive(_objectSpread$15({}, scrollProps === null || scrollProps === void 0 ? void 0 : scrollProps.value))),
      hasLazyLoadHolder = _useLazyLoad.hasLazyLoadHolder,
      tRowHeight = _useLazyLoad.tRowHeight;
    VueCompositionAPI.onMounted(function () {
      var node = state.node;
      var isVirtual = virtualConfig === null || virtualConfig === void 0 ? void 0 : virtualConfig.isVirtualScroll.value;
      if (isVirtual) {
        virtualConfig.handleRowMounted({
          ref: treeItemRef,
          data: node
        });
      }
    });
    var getItemStyles = function getItemStyles() {
      var node = state.node;
      var level = node.level;
      var levelStyle = "--level: ".concat(level, ";");
      var strStyle = "".concat(levelStyle);
      return strStyle;
    };
    var getItemClassList = function getItemClassList() {
      var node = state.node;
      var isDragOver = dragStates.isDragOver,
        isDragging = dragStates.isDragging,
        dropPosition = dragStates.dropPosition;
      var list = [];
      list.push("".concat(componentName, "__item"));
      list.push(_defineProperty$2(_defineProperty$2(_defineProperty$2({}, "".concat(componentName, "__item--open"), node.expanded), "".concat(classPrefix, "-is-active"), node.isActivable() ? node.actived : false), "".concat(classPrefix, "-is-disabled"), node.isDisabled()));
      list.push(_defineProperty$2({}, "".concat(componentName, "__item--draggable"), node.isDraggable()));
      if (node.visible) {
        list.push("".concat(componentName, "__item--visible"));
      } else {
        list.push("".concat(componentName, "__item--hidden"));
      }
      if (node.vmIsLocked) {
        list.push("".concat(componentName, "__item--locked"));
      }
      if (node.vmIsRest) {
        list.push("".concat(componentName, "__item--matched"));
      }
      list.push(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({}, "".concat(componentName, "__item--dragging"), isDragging), "".concat(componentName, "__item--tip-top"), isDragOver && dropPosition < 0), "".concat(componentName, "__item--tip-bottom"), isDragOver && dropPosition > 0), "".concat(componentName, "__item--tip-highlight"), !isDragging && isDragOver && dropPosition === 0));
      return list;
    };
    var renderItem = function renderItem(h) {
      var itemNodes = [];
      var iconNode = renderIcon(h);
      var lineNode = renderLine(h);
      if (lineNode) {
        itemNodes.push(lineNode);
      }
      if (iconNode) {
        itemNodes.push(iconNode);
      }
      var labelNode = renderLabel(h);
      if (labelNode) {
        itemNodes.push(labelNode);
      }
      var opNode = renderOperations(h);
      if (opNode) {
        itemNodes.push(opNode);
      }
      return itemNodes;
    };
    var renderItemNode = function renderItemNode(h) {
      var node = state.node,
        props = state.props;
      if (!node) return null;
      var level = node.level,
        value = node.value;
      var styles = getItemStyles();
      var classList = getItemClassList();
      var treeState = state;
      treeState.stateId = props.stateId;
      var itemNode = h("div", {
        "ref": "treeItemRef",
        "class": classList,
        "attrs": {
          "data-value": value,
          "data-level": level,
          "draggable": node.isDraggable()
        },
        "style": styles,
        "on": {
          "click": function click(evt) {
            return handleClick(evt);
          },
          "dragstart": function dragstart(evt) {
            return handleDragStart(evt);
          },
          "dragend": function dragend(evt) {
            return handleDragEnd(evt);
          },
          "dragover": function dragover(evt) {
            return handleDragOver(evt);
          },
          "dragleave": function dragleave(evt) {
            return handleDragLeave(evt);
          },
          "drop": function drop(evt) {
            return handleDrop(evt);
          }
        }
      }, [hasLazyLoadHolder.value ? [h("div")] : renderItem(h)]);
      return itemNode;
    };
    return {
      hasLazyLoadHolder: hasLazyLoadHolder,
      tRowHeight: tRowHeight,
      renderItemNode: renderItemNode
    };
  }

  function ownKeys$15(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$14(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$15(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$15(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var treeItemProps = {
    stateId: {
      type: String
    },
    itemKey: {
      type: String
    },
    rowIndex: {
      type: Number
    },
    treeScope: {
      type: Object
    }
  };
  var TreeItem = VueCompositionAPI.defineComponent(_objectSpread$14(_objectSpread$14({
    props: treeItemProps
  }, TreeItemDefinition), {}, {
    setup: function setup(props, context) {
      var _useItemState = useItemState(props, context),
        state = _useItemState.state;
      var treeItemRef = state.treeItemRef;
      VueCompositionAPI.ref();
      var _useTreeItem = useTreeItem(state),
        renderItemNode = _useTreeItem.renderItemNode;
      return {
        treeItemRef: treeItemRef,
        renderItemNode: renderItemNode
      };
    },
    render: function render(h) {
      var createElement = getCreateElement(h);
      if (typeof this.renderItemNode === "function") {
        return this.renderItemNode(createElement);
      }
      return null;
    }
  }));

  function useTreeEvents(state) {
    var treeState = state;
    var props = treeState.props,
      context = treeState.context;
    var _useTreeAction = useTreeAction(state),
      toggleExpanded = _useTreeAction.toggleExpanded,
      toggleActived = _useTreeAction.toggleActived,
      toggleChecked = _useTreeAction.toggleChecked;
    var handleClick = function handleClick(evtState) {
      var mouseEvent = evtState.mouseEvent,
        event = evtState.event,
        node = evtState.node;
      if (!node || !mouseEvent) return;
      treeState.mouseEvent = mouseEvent;
      var shouldExpand = props.expandOnClickNode;
      var shouldActive = !props.disabled && !node.disabled && node.isActivable();
      ["trigger", "ignore"].forEach(function (markName) {
        var mark = getMark(markName, event.target, event.currentTarget);
        var markValue = (mark === null || mark === void 0 ? void 0 : mark.value) || "";
        if (markValue.indexOf("expand") >= 0) {
          if (markName === "trigger") {
            shouldExpand = true;
          } else if (markName === "ignore") {
            shouldExpand = false;
          }
        }
        if (markValue.indexOf("active") >= 0) {
          if (markName === "ignore") {
            shouldActive = false;
          }
        }
      });
      if (shouldExpand) {
        toggleExpanded(node);
      }
      if (shouldActive) {
        toggleActived(node);
      }
      var evtCtx = {
        node: node.getModel(),
        e: mouseEvent
      };
      emitEvent(props, context, "click", evtCtx);
      treeState.mouseEvent = null;
    };
    var handleChange = function handleChange(evtState, ctx) {
      var disabled = props.disabled;
      var node = evtState.node;
      if (!node || disabled || node.disabled || !node.isCheckable()) {
        return;
      }
      toggleChecked(node, ctx);
    };
    return {
      handleChange: handleChange,
      handleClick: handleClick
    };
  }

  function useTreeNodes(state) {
    var store = state.store,
      scope = state.scope,
      allNodes = state.allNodes,
      nodes = state.nodes,
      virtualConfig = state.virtualConfig;
    var _useTreeEvents = useTreeEvents(state),
      handleClick = _useTreeEvents.handleClick,
      handleChange = _useTreeEvents.handleChange;
    var nodesEmpty = VueCompositionAPI.ref(false);
    var cacheMap = /* @__PURE__ */new Map();
    var refresh = function refresh() {
      allNodes.value = store.getNodes();
    };
    var refreshVisibleNodes = function refreshVisibleNodes() {
      var isVirtual = virtualConfig === null || virtualConfig === void 0 ? void 0 : virtualConfig.isVirtualScroll.value;
      if (isVirtual) return;
      var list = [];
      var hasVisibleNode = false;
      allNodes.value.forEach(function (node) {
        if (node.visible) {
          hasVisibleNode = true;
          cacheMap.set(node.value, node.value);
        }
        if (!isUndefined(cacheMap.get(node.value))) {
          list.push(node);
        }
      });
      cacheMap.forEach(function (value) {
        if (!store.getNode(value)) {
          cacheMap["delete"](value);
        }
      });
      nodes.value = list;
      nodesEmpty.value = !hasVisibleNode;
    };
    var refreshVirtualNodes = function refreshVirtualNodes() {
      var isVirtual = virtualConfig === null || virtualConfig === void 0 ? void 0 : virtualConfig.isVirtualScroll.value;
      if (!isVirtual) return;
      var list = virtualConfig.visibleData.value;
      nodes.value = list;
      nodesEmpty.value = list.length <= 0;
    };
    var renderItem = function renderItem(h, node, index, stateId) {
      var rowIndex = node.__VIRTUAL_SCROLL_INDEX || index;
      var nodeUniqueId = node[privateKey];
      var treeItem = h(TreeItem, {
        "key": nodeUniqueId,
        "attrs": {
          "rowIndex": rowIndex,
          "stateId": stateId,
          "itemKey": nodeUniqueId,
          "treeScope": scope
        },
        "on": {
          "click": handleClick,
          "change": handleChange
        }
      });
      return treeItem;
    };
    var renderTreeNodes = function renderTreeNodes(h) {
      var stateId = "render-".concat(new Date().getTime());
      var treeNodeViews = nodes.value.map(function (node, index) {
        return renderItem(h, node, index, stateId);
      });
      return treeNodeViews;
    };
    VueCompositionAPI.watch(allNodes, refreshVisibleNodes);
    VueCompositionAPI.watch(virtualConfig.visibleData, refreshVirtualNodes);
    refresh();
    refreshVisibleNodes();
    refreshVirtualNodes();
    store.emitter.on("update", refresh);
    return {
      nodesEmpty: nodesEmpty,
      renderTreeNodes: renderTreeNodes
    };
  }

  function useDragHandle(state) {
    var props = state.props,
      context = state.context,
      scope = state.scope,
      store = state.store;
    var dragNode = null;
    var handleDragStart = function handleDragStart(state2) {
      var dragEvent = state2.dragEvent,
        node = state2.node;
      dragNode = node;
      var ctx = {
        node: node.getModel(),
        e: dragEvent
      };
      emitEvent(props, context, "drag-start", ctx);
    };
    var handleDragEnd = function handleDragEnd(state2) {
      var dragEvent = state2.dragEvent,
        node = state2.node;
      dragNode = node;
      var ctx = {
        node: node.getModel(),
        e: dragEvent
      };
      emitEvent(props, context, "drag-end", ctx);
    };
    var handleDragOver = function handleDragOver(state2) {
      var dragEvent = state2.dragEvent,
        node = state2.node;
      var ctx = {
        node: node.getModel(),
        e: dragEvent
      };
      emitEvent(props, context, "drag-over", ctx);
    };
    var handleDragLeave = function handleDragLeave(state2) {
      var dragEvent = state2.dragEvent,
        node = state2.node;
      var ctx = {
        node: node.getModel(),
        e: dragEvent
      };
      emitEvent(props, context, "drag-leave", ctx);
    };
    var handleDrop = function handleDrop(state2) {
      var _props$allowDrop;
      var dragEvent = state2.dragEvent,
        node = state2.node,
        dropPosition = state2.dropPosition;
      if (node.value === dragNode.value || node.getParents().some(function (_node) {
        return _node.value === dragNode.value;
      })) return;
      var ctx = {
        dropNode: node.getModel(),
        dragNode: dragNode.getModel(),
        dropPosition: dropPosition,
        e: dragEvent
      };
      if (((_props$allowDrop = props.allowDrop) === null || _props$allowDrop === void 0 ? void 0 : _props$allowDrop.call(props, ctx)) === false) return;
      var nodes = store.getNodes();
      nodes.some(function (_node) {
        if (_node.value === node.value) {
          if (dropPosition === DragPosition.Inside) {
            dragNode.appendTo(store, _node);
          } else if (dropPosition === DragPosition.Before) {
            node.insertBefore(dragNode);
          } else {
            node.insertAfter(dragNode);
          }
          return true;
        }
        return false;
      });
      emitEvent(props, context, "drop", ctx);
    };
    var drag = {
      handleDragStart: handleDragStart,
      handleDragEnd: handleDragEnd,
      handleDragOver: handleDragOver,
      handleDragLeave: handleDragLeave,
      handleDrop: handleDrop
    };
    scope.drag = drag;
    return {
      drag: drag
    };
  }

  function ownKeys$14(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$13(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$14(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$14(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _TdTree = VueCompositionAPI.defineComponent({
    name: "TTree",
    model: {
      prop: "value",
      event: "change"
    },
    props: _objectSpread$13({}, props$u),
    setup: function setup(props2, context) {
      var _useConfig = useConfig("tree"),
        t = _useConfig.t,
        global = _useConfig.global;
      var classPrefix = usePrefixClass();
      var componentName = usePrefixClass("tree");
      var _useTreeState = useTreeState(props2, context),
        state = _useTreeState.state;
      var treeContentRef = state.treeContentRef,
        isScrolling = state.isScrolling;
      var _useTreeStore = useTreeStore(state),
        store = _useTreeStore.store,
        updateStoreConfig = _useTreeStore.updateStoreConfig,
        rebuild = _useTreeStore.rebuild;
      useDragHandle(state);
      var _useTreeAction = useTreeAction(state),
        setActived = _useTreeAction.setActived,
        setExpanded = _useTreeAction.setExpanded,
        setChecked = _useTreeAction.setChecked;
      var _useTreeScroll = useTreeScroll(state),
        onInnerVirtualScroll = _useTreeScroll.onInnerVirtualScroll,
        virtualConfig = _useTreeScroll.virtualConfig,
        scrollToElement = _useTreeScroll.scrollToElement;
      var _useTreeNodes = useTreeNodes(state),
        renderTreeNodes = _useTreeNodes.renderTreeNodes,
        nodesEmpty = _useTreeNodes.nodesEmpty;
      var _useTreeStyles = useTreeStyles(state),
        treeClasses = _useTreeStyles.treeClasses,
        treeContentStyles = _useTreeStyles.treeContentStyles,
        scrollStyles = _useTreeStyles.scrollStyles,
        cursorStyles = _useTreeStyles.cursorStyles;
      return {
        t: t,
        global: global,
        classPrefix: classPrefix,
        componentName: componentName,
        state: state,
        store: store,
        treeClasses: treeClasses,
        treeContentRef: treeContentRef,
        rebuild: rebuild,
        updateStoreConfig: updateStoreConfig,
        setActived: setActived,
        setExpanded: setExpanded,
        setChecked: setChecked,
        renderTreeNodes: renderTreeNodes,
        nodesEmpty: nodesEmpty,
        isScrolling: isScrolling,
        onInnerVirtualScroll: onInnerVirtualScroll,
        treeContentStyles: treeContentStyles,
        scrollStyles: scrollStyles,
        cursorStyles: cursorStyles,
        virtualConfig: virtualConfig,
        scrollTo: scrollToElement,
        scrollToElement: scrollToElement
      };
    },
    watch: {
      data: function data(list) {
        this.rebuild(list);
      }
    },
    methods: {
      refresh: function refresh() {
        this.store.refreshState();
      },
      setItem: function setItem(value, options) {
        var _this = this;
        var node = this.store.getNode(value);
        var spec = options;
        var keys = Object.keys(spec);
        if (node && spec) {
          ["expanded", "actived", "checked"].forEach(function (name) {
            if (keys.includes(name)) {
              var val = spec[name];
              delete spec[name];
              var methodName = "set".concat(upperFirst$1(name));
              var setupMethod = _this[methodName];
              if (isFunction(setupMethod)) {
                setupMethod.call(_this, node, val);
              }
            }
          });
          node.set(spec);
        }
      },
      getItem: function getItem(value) {
        var node = this.store.getNode(value);
        return node === null || node === void 0 ? void 0 : node.getModel();
      },
      getItems: function getItems(value) {
        var nodes = this.store.getNodes(value);
        return nodes.map(function (node) {
          return node.getModel();
        });
      },
      appendTo: function appendTo(para, item) {
        var store = this.store;
        var list = [];
        if (Array.isArray(item)) {
          list = item;
        } else {
          list = [item];
        }
        list.forEach(function (item2) {
          var val = (item2 === null || item2 === void 0 ? void 0 : item2.value) || "";
          var node = getNode(store, val);
          if (node) {
            store.appendNodes(para, node);
          } else {
            store.appendNodes(para, item2);
          }
        });
      },
      insertBefore: function insertBefore(value, item) {
        var store = this.store;
        var val = (item === null || item === void 0 ? void 0 : item.value) || "";
        var node = getNode(store, val);
        if (node) {
          store.insertBefore(value, node);
        } else {
          store.insertBefore(value, item);
        }
      },
      insertAfter: function insertAfter(value, item) {
        var store = this.store;
        var val = (item === null || item === void 0 ? void 0 : item.value) || "";
        var node = getNode(store, val);
        if (node) {
          store.insertAfter(value, node);
        } else {
          store.insertAfter(value, item);
        }
      },
      remove: function remove(value) {
        return this.store.remove(value);
      },
      getIndex: function getIndex(value) {
        return this.store.getNodeIndex(value);
      },
      getParent: function getParent(value) {
        var node = this.store.getParent(value);
        return node === null || node === void 0 ? void 0 : node.getModel();
      },
      getParents: function getParents(value) {
        var nodes = this.store.getParents(value);
        return nodes.map(function (node) {
          return node.getModel();
        });
      },
      getPath: function getPath(value) {
        var node = this.store.getNode(value);
        var pathNodes = [];
        if (node) {
          pathNodes = node.getPath().map(function (node2) {
            return node2.getModel();
          });
        }
        return pathNodes;
      },
      getTreeData: function getTreeData(value) {
        var list = [];
        if (value) {
          var node = this.store.getNode(value);
          if (!node) return [];
          list = this.store.getNodes(value);
        } else {
          list = this.store.getNodes();
        }
        var nodeMap = {};
        var treeNodes = [];
        list.forEach(function (item) {
          var value2 = item.value;
          var itemData = _objectSpread$13(_objectSpread$13({}, item.data), {}, {
            value: value2
          });
          delete itemData.children;
          nodeMap[value2] = itemData;
          var parent = item.getParent();
          if (!parent) {
            treeNodes.push(itemData);
          } else {
            var parentData = nodeMap[parent.value];
            if (!parentData) {
              treeNodes.push(itemData);
            } else {
              if (!Array.isArray(parentData.children)) {
                parentData.children = [];
              }
              parentData.children.push(itemData);
            }
          }
        });
        return treeNodes;
      }
    },
    render: function render(h) {
      var _allNodes$value$filte, _allNodes$value, _refProps$scroll$valu, _refProps$scroll$valu2;
      var state = this.state,
        treeClasses = this.treeClasses,
        updateStoreConfig = this.updateStoreConfig,
        renderTreeNodes = this.renderTreeNodes,
        nodesEmpty = this.nodesEmpty,
        isScrolling = this.isScrolling,
        virtualConfig = this.virtualConfig,
        treeContentStyles = this.treeContentStyles,
        scrollStyles = this.scrollStyles,
        cursorStyles = this.cursorStyles;
      var createElement = getCreateElement(h);
      var scope = state.scope,
        allNodes = state.allNodes,
        refProps = state.refProps;
      scope.scopedSlots = getScopedSlots(this);
      updateStoreConfig();
      var treeNodeViews = renderTreeNodes(createElement);
      var cname = this.componentName;
      var isVirtual = virtualConfig.isVirtualScroll.value;
      var emptyNode = null;
      if (nodesEmpty) {
        var useLocale = !this.empty && !this.$slots.empty;
        var emptyContent = useLocale ? this.t(this.global.empty) : renderTNodeJSX(this, "empty");
        emptyNode = h("div", {
          "class": "".concat(cname, "__empty")
        }, [emptyContent]);
      } else if (treeNodeViews.length <= 0) {
        emptyNode = h("div");
      }
      var $props = this.$props;
      var transition = $props.transition;
      var treeNodeList = null;
      if (!transition || isVirtual && isScrolling) {
        treeNodeList = h("div", {
          "class": "".concat(cname, "__list"),
          "style": scrollStyles
        }, [treeNodeViews]);
      } else {
        treeNodeList = h(TransitionGroup, {
          "attrs": {
            "tag": "div",
            "enter-active-class": "".concat(cname, "__item--enter-active"),
            "leave-active-class": "".concat(cname, "__item--leave-active")
          },
          "class": "".concat(cname, "__list"),
          "style": scrollStyles
        }, [treeNodeViews]);
      }
      var topValue = ((_allNodes$value$filte = (_allNodes$value = allNodes.value) === null || _allNodes$value === void 0 ? void 0 : _allNodes$value.filter(function (node) {
        return node.visible;
      }).length) !== null && _allNodes$value$filte !== void 0 ? _allNodes$value$filte : 0) * ((_refProps$scroll$valu = (_refProps$scroll$valu2 = refProps.scroll.value) === null || _refProps$scroll$valu2 === void 0 ? void 0 : _refProps$scroll$valu2.rowHeight) !== null && _refProps$scroll$valu !== void 0 ? _refProps$scroll$valu : 34);
      var placeholderStyles = {
        width: "1px",
        height: "1px",
        opacity: 0,
        pointerEvents: "none",
        position: "absolute",
        left: 0,
        top: "".concat(topValue, "px")
      };
      var placeholderEl = h("div", {
        "style": placeholderStyles
      });
      var treeNode = h("div", {
        "class": treeClasses,
        "ref": "treeContentRef",
        "on": {
          "scroll": this.onInnerVirtualScroll
        },
        "style": treeContentStyles
      }, [isVirtual && h("div", {
        "class": "".concat(cname, "__vscroll-cursor"),
        "style": cursorStyles
      }), emptyNode || treeNodeList, isVirtual && placeholderEl]);
      return treeNode;
    }
  });

  var Tree = withInstall(_TdTree);

  var props$t = {
    autoWidth: Boolean,
    autofocus: Boolean,
    borderless: Boolean,
    clearable: Boolean,
    collapsedItems: {
      type: Function
    },
    data: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    disabled: Boolean,
    empty: {
      type: [String, Function]
    },
    filter: {
      type: Function
    },
    filterable: Boolean,
    inputProps: {
      type: Object
    },
    inputValue: {
      type: [String, Number]
    },
    defaultInputValue: {
      type: [String, Number]
    },
    keys: {
      type: Object
    },
    label: {
      type: [String, Function]
    },
    loading: Boolean,
    loadingText: {
      type: [String, Function]
    },
    max: {
      type: Number,
      "default": 0
    },
    minCollapsedNum: {
      type: Number,
      "default": 0
    },
    multiple: Boolean,
    panelBottomContent: {
      type: [String, Function]
    },
    panelTopContent: {
      type: [String, Function]
    },
    placeholder: {
      type: String,
      "default": void 0
    },
    popupProps: {
      type: Object
    },
    popupVisible: {
      type: Boolean,
      "default": void 0
    },
    defaultPopupVisible: {
      type: Boolean,
      "default": void 0
    },
    prefixIcon: {
      type: Function
    },
    readonly: Boolean,
    reserveKeyword: Boolean,
    selectInputProps: {
      type: Object
    },
    size: {
      type: String,
      "default": "medium",
      validator: function validator(val) {
        if (!val) return true;
        return ["small", "medium", "large"].includes(val);
      }
    },
    status: {
      type: String,
      "default": "default",
      validator: function validator(val) {
        if (!val) return true;
        return ["default", "success", "warning", "error"].includes(val);
      }
    },
    suffix: {
      type: [String, Function]
    },
    suffixIcon: {
      type: Function
    },
    tagProps: {
      type: Object
    },
    tips: {
      type: [String, Function]
    },
    treeProps: {
      type: Object
    },
    value: {
      type: [String, Number, Object, Array]
    },
    defaultValue: {
      type: [String, Number, Object, Array]
    },
    valueDisplay: {
      type: Function
    },
    valueType: {
      type: String,
      "default": "value",
      validator: function validator(val) {
        if (!val) return true;
        return ["value", "object"].includes(val);
      }
    },
    onBlur: Function,
    onChange: Function,
    onClear: Function,
    onEnter: Function,
    onFocus: Function,
    onInputChange: Function,
    onPopupVisibleChange: Function,
    onRemove: Function,
    onSearch: Function
  };

  function getNodeDataByValue(values, data, keys) {
    var _getTreeNodeData = function getTreeNodeData(values2, data2, keys2) {
      var results2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : /* @__PURE__ */new Map();
      var _loop = function _loop() {
          var _item$children;
          var item = data2[i];
          var index = values2.findIndex(function (val) {
            return get(item, keys2.value) === val;
          });
          if (index !== -1) {
            results2.set(values2[index], item);
          }
          if (Array.isArray(item.children) && (_item$children = item.children) !== null && _item$children !== void 0 && _item$children.length) {
            _getTreeNodeData(values2, item.children, keys2, results2);
          }
          if (results2.size >= values2.length) {
            return {
              v: results2
            };
          }
        },
        _ret;
      for (var i = 0, len = data2.length; i < len; i++) {
        _ret = _loop();
        if (_ret) return _ret.v;
      }
      return results2;
    };
    var results = _getTreeNodeData(values, data, keys);
    if (values.length && results.size < values.length) {
      values.forEach(function (value) {
        if (!results.get(value)) {
          var obj = {};
          set(obj, keys.label, value);
          set(obj, keys.value, value);
          results.set(value, obj);
        }
      });
    }
    return values.map(function (value) {
      return results.get(value);
    });
  }
  function normalizeArray(value) {
    if (isNil(value)) {
      return [];
    }
    return Array.isArray(value) ? value : [value];
  }

  function ownKeys$13(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$12(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$13(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$13(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var DEFAULT_KEYS = {
    label: "label",
    value: "value",
    children: "children"
  };
  function useTreeSelect$1(props, context) {
    var classPrefix = usePrefixClass();
    var _useConfig = useConfig("treeSelect"),
      global = _useConfig.global;
    var _useFormDisabled = useFormDisabled(),
      formDisabled = _useFormDisabled.formDisabled;
    var treeRef = VueCompositionAPI.ref(null);
    var treeKey = VueCompositionAPI.ref(0);
    var _toRefs = VueCompositionAPI.toRefs(props),
      value = _toRefs.value,
      popupVisible = _toRefs.popupVisible,
      inputValue = _toRefs.inputValue;
    var _useVModel = useVModel$1(value, props.defaultValue, props.onChange, "change"),
      _useVModel2 = _slicedToArray(_useVModel, 2),
      treeSelectValue = _useVModel2[0],
      setTreeSelectValue = _useVModel2[1];
    var _useDefaultValue = useDefaultValue(popupVisible, props.defaultPopupVisible, props.onPopupVisibleChange, "popupVisible", "popup-visible-change"),
      _useDefaultValue2 = _slicedToArray(_useDefaultValue, 2),
      innerVisible = _useDefaultValue2[0],
      setInnerVisible = _useDefaultValue2[1];
    var _useDefaultValue3 = useDefaultValue(inputValue, props.defaultInputValue || "", props.onInputChange, "inputValue", "input-change"),
      _useDefaultValue4 = _slicedToArray(_useDefaultValue3, 2),
      innerInputValue = _useDefaultValue4[0],
      setInnerInputValue = _useDefaultValue4[1];
    var tDisabled = VueCompositionAPI.computed(function () {
      return formDisabled.value || props.disabled;
    });
    var isObjectValue = VueCompositionAPI.computed(function () {
      return props.valueType === "object";
    });
    var tKeys = VueCompositionAPI.computed(function () {
      var _props$treeProps;
      return _objectSpread$12(_objectSpread$12(_objectSpread$12({}, DEFAULT_KEYS), (_props$treeProps = props.treeProps) === null || _props$treeProps === void 0 ? void 0 : _props$treeProps.keys), props.keys);
    });
    var inputPlaceholder = VueCompositionAPI.computed(function () {
      var label = nodeInfo.value ? get(nodeInfo.value, tKeys.value.label) : void 0;
      if (typeof label === "number") label = String(label);
      return innerVisible.value && label || props.placeholder || global.value.placeholder;
    });
    var popupClass = VueCompositionAPI.computed(function () {
      return ["".concat(classPrefix.value, "-select__dropdown"), "narrow-scrollbar"];
    });
    var dropdownInnerSize = VueCompositionAPI.computed(function () {
      return {
        small: "s",
        medium: "m",
        large: "l"
      }[props.size];
    });
    var treeRerender = function treeRerender() {
      treeKey.value += 1;
    };
    VueCompositionAPI.watch(function () {
      return _toConsumableArray(props.data);
    }, function () {
      treeRerender();
    }, {
      immediate: true,
      flush: "post"
    });
    var nodeInfo = VueCompositionAPI.computed(function () {
      return props.multiple ? getMultipleNodeInfo() : getSingleNodeInfo();
    });
    var singleActivated = VueCompositionAPI.computed(function () {
      if (props.multiple || !nodeInfo.value) return [];
      if (nodeInfo.value instanceof Array) return [nodeInfo.value[0] ? get(nodeInfo.value[0], tKeys.value.value) : void 0];
      return [get(nodeInfo.value, tKeys.value.value)];
    });
    var multipleChecked = VueCompositionAPI.computed(function () {
      if (!props.multiple || !nodeInfo.value) return [];
      if (nodeInfo.value instanceof Array) {
        return nodeInfo.value.map(function (item) {
          return get(item, tKeys.value.value);
        });
      }
      return [get(nodeInfo.value, tKeys.value.value)];
    });
    function getMultipleNodeInfo() {
      var value2 = treeSelectValue.value;
      var list = normalizeArray(value2);
      if (treeRef.value) {
        return list.map(function (item) {
          var _treeRef$value$getIte;
          var finalValue = _typeof$2(item) === "object" ? item.value : item;
          var obj = {};
          set(obj, tKeys.value.label, finalValue);
          set(obj, tKeys.value.value, finalValue);
          return ((_treeRef$value$getIte = treeRef.value.getItem(finalValue)) === null || _treeRef$value$getIte === void 0 ? void 0 : _treeRef$value$getIte.data) || obj;
        });
      }
      var onlyValues = list.map(function (item) {
        return _typeof$2(item) === "object" ? get(item, tKeys.value.value) : item;
      });
      return getNodeDataByValue(onlyValues, props.data, tKeys.value);
    }
    function getSingleNodeInfo() {
      var value2 = treeSelectValue.value;
      if (value2 === "" || value2 === void 0 || value2 === null) {
        return void 0;
      }
      var oneValue = Array.isArray(value2) ? value2[0] : value2;
      var finalValue = _typeof$2(oneValue) === "object" ? oneValue.value : oneValue;
      if (treeRef.value) {
        var _treeRef$value$getIte2;
        var obj = {};
        set(obj, tKeys.value.label, finalValue);
        set(obj, tKeys.value.value, finalValue);
        return ((_treeRef$value$getIte2 = treeRef.value.getItem(finalValue)) === null || _treeRef$value$getIte2 === void 0 ? void 0 : _treeRef$value$getIte2.data) || obj;
      }
      return getNodeDataByValue([finalValue], props.data, tKeys.value)[0];
    }
    var clear = function clear(_ref) {
      var _props$onClear;
      var e = _ref.e;
      var defaultValue = props.multiple ? [] : void 0;
      setTreeSelectValue(defaultValue, {
        e: e,
        node: null,
        data: null,
        trigger: "clear"
      });
      (_props$onClear = props.onClear) === null || _props$onClear === void 0 || _props$onClear.call(props, {
        e: e
      });
      context.emit("clear", {
        e: e
      });
      setInnerVisible(false, {
        e: e,
        trigger: "clear"
      });
    };
    var treeNodeChange = function treeNodeChange(value2, ctx) {
      if (!props.multiple) return;
      var current = value2;
      if (isObjectValue.value) {
        current = value2.map(function (nodeValue) {
          return treeRef.value.getItem(nodeValue);
        });
      }
      var tmpValue = Array.isArray(treeSelectValue.value) ? treeSelectValue.value : [treeSelectValue.value];
      setTreeSelectValue(current, _objectSpread$12(_objectSpread$12({}, ctx), {}, {
        data: ctx.node.data,
        trigger: value2.length > tmpValue.length ? "check" : "uncheck"
      }));
      innerInputValue.value && setInnerInputValue("", {
        trigger: "change",
        e: ctx.e
      });
    };
    var treeNodeActive = function treeNodeActive(value2, ctx) {
      var _props$treeProps2, _ctx$node, _ctx$node2;
      if (props.multiple) return;
      if (treeSelectValue.value === get(ctx.node.data, tKeys.value.value)) {
        return;
      }
      var onlyLeafNode = Boolean(!props.multiple && ((_props$treeProps2 = props.treeProps) === null || _props$treeProps2 === void 0 ? void 0 : _props$treeProps2.valueMode) === "onlyLeaf" && Array.isArray((_ctx$node = ctx.node) === null || _ctx$node === void 0 || (_ctx$node = _ctx$node.data) === null || _ctx$node === void 0 ? void 0 : _ctx$node.children) && ((_ctx$node2 = ctx.node) === null || _ctx$node2 === void 0 || (_ctx$node2 = _ctx$node2.data) === null || _ctx$node2 === void 0 || (_ctx$node2 = _ctx$node2.children) === null || _ctx$node2 === void 0 ? void 0 : _ctx$node2.length));
      var current = value2;
      var nodeValue = Array.isArray(value2) ? value2[0] : value2;
      current = isObjectValue.value ? treeRef.value.getItem(nodeValue) : nodeValue;
      if (!onlyLeafNode) {
        setTreeSelectValue(current, _objectSpread$12(_objectSpread$12({}, ctx), {}, {
          data: ctx.node.data,
          trigger: "check"
        }));
        setInnerVisible(false, {
          e: ctx.e,
          trigger: "trigger-element-click"
        });
      }
      innerInputValue.value && setInnerInputValue("", {
        trigger: "change",
        e: ctx.e
      });
    };
    var defaultFilterFunction = function defaultFilterFunction(node) {
      var label = get(node.data, tKeys.value.label);
      var searchLabel = isFunction(label) ? node.data.text : label || node.data.text;
      return (searchLabel === null || searchLabel === void 0 ? void 0 : searchLabel.indexOf(innerInputValue.value)) >= 0;
    };
    var filterByText = VueCompositionAPI.computed(function () {
      if (props.onSearch || context.listeners.search) return;
      if ((props.filter || props.filterable) && innerInputValue.value && !context.listeners.search) {
        return props.filter ? function (node) {
          return props.filter(innerInputValue.value, node);
        } : function (node) {
          return defaultFilterFunction(node);
        };
      }
      return void 0;
    });
    var inputChange = function inputChange() {
      var value2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var ctx = arguments.length > 1 ? arguments[1] : undefined;
      if (value2 === innerInputValue.value) return;
      setInnerInputValue(value2, ctx);
      if (context.listeners.search || props.onSearch) {
        var _props$onSearch;
        (_props$onSearch = props.onSearch) === null || _props$onSearch === void 0 || _props$onSearch.call(props, value2, {
          e: ctx.e
        });
        context.emit("search", value2);
      }
    };
    var onInnerPopupVisibleChange = function onInnerPopupVisibleChange(state, ctx) {
      setInnerVisible(state, ctx);
      if (state) {
        treeRerender();
      }
      if (!state && innerInputValue.value) {
        setInnerInputValue("", {
          trigger: "blur",
          e: ctx.e
        });
      }
    };
    var tagChange = function tagChange(_, ctx) {
      var _treeRef$value;
      var trigger = ctx.trigger,
        index = ctx.index;
      var fitTrigger = trigger === "tag-remove" || trigger === "backspace";
      if (!fitTrigger) return;
      var current = treeSelectValue.value[index];
      var currentDeleteValue = _typeof$2(current) === "object" ? get(current, tKeys.value.value) : current;
      var currentNode = (_treeRef$value = treeRef.value) === null || _treeRef$value === void 0 ? void 0 : _treeRef$value.getItem(currentDeleteValue);
      var data = currentNode ? currentNode.data : getNodeDataByValue([currentDeleteValue], props.data, tKeys.value)[0];
      if (fitTrigger) {
        var _props$onRemove;
        var removeParams = {
          value: currentDeleteValue,
          data: data,
          node: currentNode,
          trigger: fitTrigger ? trigger : void 0,
          index: index,
          e: ctx.e
        };
        (_props$onRemove = props.onRemove) === null || _props$onRemove === void 0 || _props$onRemove.call(props, removeParams);
        context.emit("remove", removeParams);
      }
      if (Array.isArray(treeSelectValue.value)) {
        var newValue = _toConsumableArray(treeSelectValue.value);
        newValue.splice(index, 1);
        setTreeSelectValue(newValue, {
          node: currentNode,
          data: data,
          index: index,
          e: ctx.e,
          trigger: fitTrigger ? trigger : void 0
        });
      }
      innerInputValue.value && setInnerInputValue("", {
        trigger: "change",
        e: ctx.e
      });
    };
    var onInnerFocus = function onInnerFocus(_, ctx) {
      var _props$onFocus;
      (_props$onFocus = props.onFocus) === null || _props$onFocus === void 0 || _props$onFocus.call(props, {
        value: treeSelectValue.value,
        e: ctx.e
      });
      context.emit("focus", {
        value: treeSelectValue.value,
        e: ctx.e
      });
    };
    var onInnerBlur = function onInnerBlur(_, ctx) {
      var _props$onBlur;
      (_props$onBlur = props.onBlur) === null || _props$onBlur === void 0 || _props$onBlur.call(props, _objectSpread$12({
        value: treeSelectValue.value
      }, ctx));
      context.emit("blur", _objectSpread$12({
        value: treeSelectValue.value
      }, ctx));
    };
    var onInnerEnter = function onInnerEnter(_, ctx) {
      var _props$onEnter, _props$onSearch2;
      var enterParams = {
        value: treeSelectValue.value,
        inputValue: ctx.inputValue,
        e: ctx.e
      };
      (_props$onEnter = props.onEnter) === null || _props$onEnter === void 0 || _props$onEnter.call(props, enterParams);
      context.emit("enter", enterParams);
      (_props$onSearch2 = props.onSearch) === null || _props$onSearch2 === void 0 || _props$onSearch2.call(props, ctx.inputValue, {
        e: ctx.e
      });
      context.emit("search", ctx.inputValue, {
        e: ctx.e
      });
    };
    return {
      classPrefix: classPrefix,
      global: global,
      tDisabled: tDisabled,
      treeRef: treeRef,
      tKeys: tKeys,
      treeKey: treeKey,
      popupClass: popupClass,
      isObjectValue: isObjectValue,
      dropdownInnerSize: dropdownInnerSize,
      inputPlaceholder: inputPlaceholder,
      innerVisible: innerVisible,
      nodeInfo: nodeInfo,
      treeSelectValue: treeSelectValue,
      innerInputValue: innerInputValue,
      multipleChecked: multipleChecked,
      singleActivated: singleActivated,
      clear: clear,
      filterByText: filterByText,
      setInnerVisible: setInnerVisible,
      setTreeSelectValue: setTreeSelectValue,
      setInnerInputValue: setInnerInputValue,
      treeNodeChange: treeNodeChange,
      treeNodeActive: treeNodeActive,
      inputChange: inputChange,
      tagChange: tagChange,
      onInnerPopupVisibleChange: onInnerPopupVisibleChange,
      onInnerFocus: onInnerFocus,
      onInnerBlur: onInnerBlur,
      onInnerEnter: onInnerEnter
    };
  }

  function ownKeys$12(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$11(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$12(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$12(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _TreeSelect = VueCompositionAPI.defineComponent({
    name: "TTreeSelect",
    props: _objectSpread$11({}, props$t),
    setup: function setup(props2, context) {
      var renderTNodeJSX = useTNodeJSX();
      var renderDefaultTNode = useTNodeDefault();
      var treeSelectInfo = useTreeSelect$1(props2, context);
      var dropdownInnerSize = treeSelectInfo.dropdownInnerSize,
        treeSelectValue = treeSelectInfo.treeSelectValue;
      var multiLimitDisabled = VueCompositionAPI.computed(function () {
        return props2.multiple && !!props2.max && isArray$1(treeSelectValue.value) && props2.max <= treeSelectValue.value.length;
      });
      return _objectSpread$11(_objectSpread$11({}, treeSelectInfo), {}, {
        dropdownInnerSize: dropdownInnerSize,
        multiLimitDisabled: multiLimitDisabled,
        renderTNodeJSX: renderTNodeJSX,
        renderDefaultTNode: renderDefaultTNode
      });
    },
    methods: {
      renderSuffixIcon: function renderSuffixIcon() {
        var h = this.$createElement;
        return h(FakeArrow, {
          "attrs": {
            "isActive": this.innerVisible,
            "disabled": this.disabled,
            "overlayClassName": _defineProperty$2(_defineProperty$2({}, "".concat(this.classPrefix, "-fake-arrow--highlight"), this.innerVisible), "".concat(this.classPrefix, "-fake-arrow--disable"), this.disabled)
          }
        });
      },
      renderLabel: function renderLabel() {
        var h = this.$createElement;
        var label = this.renderTNodeJSX("label");
        var prefixIcon = this.renderTNodeJSX("prefixIcon");
        if (label && prefixIcon) {
          return h("div", [label, prefixIcon]);
        }
        return label || prefixIcon;
      },
      getTreePanel: function getTreePanel() {
        var _this$treeProps,
          _this = this;
        var h = this.$createElement;
        return h("div", {
          "class": ["".concat(this.classPrefix, "-select__dropdown-inner"), "".concat(this.classPrefix, "-select__dropdown-inner--size-").concat(this.dropdownInnerSize)]
        }, [this.renderTNodeJSX("panelTopContent"), this.loading && !this.tDisabled ? h("p", {
          "class": ["".concat(this.classPrefix, "-select__loading-tips"), "".concat(this.classPrefix, "-select__right-icon-polyfill")]
        }, [this.renderDefaultTNode("loadingText", {
          defaultNode: h("div", {
            "class": "".concat(this.classPrefix, "-select__empty")
          }, [this.global.loadingText])
        })]) : null, !this.loading ? h(Tree, helper([{
          "ref": "treeRef",
          "key": !((_this$treeProps = this.treeProps) !== null && _this$treeProps !== void 0 && _this$treeProps.load) && this.treeKey
        }, {
          "props": _objectSpread$11({
            keys: this.tKeys,
            value: _toConsumableArray(this.multipleChecked),
            actived: this.singleActivated,
            hover: true,
            data: this.data,
            activable: !this.multiple,
            checkable: this.multiple,
            disabled: this.tDisabled || this.multiLimitDisabled,
            size: this.size,
            filter: this.filterByText,
            icon: !this.filterByText,
            activeMultiple: this.multiple,
            onExpand: this.treeNodeExpand,
            onLoad: this.treeNodeLoad,
            onChange: this.treeNodeChange,
            onActive: this.treeNodeActive,
            expandOnClickNode: false,
            empty: function empty() {
              return _this.renderDefaultTNode("empty", {
                defaultNode: h("div", {
                  "class": "".concat(_this.classPrefix, "-select__empty")
                }, [_this.global.empty])
              });
            }
          }, this.treeProps)
        }])) : null, this.renderTNodeJSX("panelBottomContent")]);
      }
    },
    render: function render() {
      var _this2 = this;
      var h = arguments[0];
      var slots = this.$scopedSlots;
      return h(SelectInput, {
        "scopedSlots": {
          tips: slots.tips,
          suffix: slots.suffix,
          collapsedItems: slots.collapsedItems
        },
        "class": "".concat(this.classPrefix, "-tree-select"),
        "props": _objectSpread$11({}, _objectSpread$11({
          keys: this.tKeys,
          value: this.nodeInfo,
          inputValue: this.innerInputValue,
          popupVisible: this.innerVisible,
          disabled: this.tDisabled,
          multiple: this.multiple,
          loading: this.loading,
          clearable: this.clearable,
          autofocus: this.autofocus,
          autoWidth: this.autoWidth,
          borderless: this.borderless,
          readonly: this.readonly,
          placeholder: this.inputPlaceholder,
          status: this.status,
          tips: this.tips,
          suffix: this.suffix,
          allowInput: Boolean(this.filterable || isFunction(this.filter) || this.$listeners.search || this.onSearch),
          minCollapsedNum: this.minCollapsedNum,
          collapsedItems: this.collapsedItems,
          popupProps: _objectSpread$11({
            overlayClassName: this.popupClass
          }, this.popupProps),
          inputProps: _objectSpread$11({
            size: this.size
          }, this.inputProps),
          tagInputProps: {
            size: this.size
          },
          tagProps: _objectSpread$11({
            maxWidth: 300
          }, this.tagProps),
          label: this.renderLabel,
          suffixIcon: this.renderSuffixIcon,
          onClear: this.clear,
          onBlur: this.onInnerBlur,
          onFocus: this.onInnerFocus,
          onInputChange: this.inputChange,
          onTagChange: this.tagChange,
          onEnter: this.onInnerEnter,
          onPopupVisibleChange: this.onInnerPopupVisibleChange,
          valueDisplay: function valueDisplay() {
            return _this2.renderTNodeJSX("valueDisplay", {
              params: _this2.multiple ? {
                value: _this2.nodeInfo,
                onClose: function onClose(index) {
                  var value = _this2.nodeInfo.map(function (node) {
                    return get(node, _this2.tKeys.value);
                  });
                  _this2.tagChange(value, {
                    trigger: "tag-remove",
                    index: index,
                    item: value[index]
                  });
                }
              } : {
                value: _this2.nodeInfo || _defineProperty$2(_defineProperty$2({}, _this2.tKeys.label, ""), _this2.tKeys.value, void 0)
              }
            });
          },
          panel: this.getTreePanel
        }, this.selectInputProps))
      });
    }
  });

  var TreeSelect = withInstall$1(_TreeSelect, VueCompositionAPI__default["default"]);

  var props$s = {
    alt: {
      type: String,
      "default": ""
    },
    content: {
      type: [String, Function]
    },
    "default": {
      type: [String, Function]
    },
    hideOnLoadFailed: Boolean,
    icon: {
      type: Function
    },
    image: {
      type: String,
      "default": ""
    },
    imageProps: {
      type: Object
    },
    shape: {
      type: String,
      "default": "circle",
      validator: function validator(val) {
        if (!val) return true;
        return ["circle", "round"].includes(val);
      }
    },
    size: {
      type: String,
      "default": ""
    },
    onError: Function
  };

  var props$r = {
    alt: {
      type: String,
      "default": ""
    },
    error: {
      type: [String, Function]
    },
    fallback: {
      type: String,
      "default": ""
    },
    fit: {
      type: String,
      "default": "fill",
      validator: function validator(val) {
        if (!val) return true;
        return ["contain", "cover", "fill", "none", "scale-down"].includes(val);
      }
    },
    gallery: Boolean,
    lazy: Boolean,
    loading: {
      type: [String, Function]
    },
    overlayContent: {
      type: [String, Function]
    },
    overlayTrigger: {
      type: String,
      "default": "always",
      validator: function validator(val) {
        if (!val) return true;
        return ["always", "hover"].includes(val);
      }
    },
    placeholder: {
      type: [String, Function]
    },
    position: {
      type: String,
      "default": "center"
    },
    referrerpolicy: {
      type: String,
      validator: function validator(val) {
        if (!val) return true;
        return ["no-referrer", "no-referrer-when-downgrade", "origin", "origin-when-cross-origin", "same-origin", "strict-origin", "strict-origin-when-cross-origin", "unsafe-url"].includes(val);
      }
    },
    shape: {
      type: String,
      "default": "square",
      validator: function validator(val) {
        if (!val) return true;
        return ["circle", "round", "square"].includes(val);
      }
    },
    src: {
      type: [String, Object]
    },
    srcset: {
      type: Object
    },
    onError: Function,
    onLoad: Function
  };

  var _Image = VueCompositionAPI.defineComponent({
    name: "TImage",
    components: {
      Space: Space
    },
    props: props$r,
    setup: function setup(props2, _ref) {
      var emit = _ref.emit;
      var onLoad = props2.onLoad,
        onError = props2.onError;
      var _toRefs = VueCompositionAPI.toRefs(props2),
        src = _toRefs.src,
        lazy = _toRefs.lazy,
        fallback = _toRefs.fallback,
        overlayTrigger = _toRefs.overlayTrigger;
      var rest = omit$2(props2, ["className", "src", "style", "alt", "fit", "position", "shape", "placeholder", "loading", "error", "overlayTrigger", "overlayContent", "lazy", "gallery", "onLoad", "onError"]);
      var _useConfig = useConfig("image"),
        classPrefix = _useConfig.classPrefix,
        globalConfig = _useConfig.globalConfig;
      var imageRef = VueCompositionAPI.ref(null);
      var imageStrSrc = VueCompositionAPI.ref(src.value);
      VueCompositionAPI.watch([src, globalConfig], function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          src2 = _ref3[0],
          globalConfig2 = _ref3[1];
        var _ref4 = globalConfig2 || {},
          replaceImageSrc = _ref4.replaceImageSrc;
        var tmpUrl = isFunction(replaceImageSrc) ? replaceImageSrc(props2) : src2;
        if (tmpUrl === imageStrSrc.value && imageStrSrc.value) return;
        imageStrSrc.value = tmpUrl;
      }, {
        immediate: true
      });
      var _useImagePreviewUrl = useImagePreviewUrl(imageStrSrc),
        previewUrl = _useImagePreviewUrl.previewUrl;
      VueCompositionAPI.watch([previewUrl], function () {
        hasError.value = false;
        isLoaded.value = false;
      });
      var shouldLoad = VueCompositionAPI.ref(!lazy.value);
      var handleLoadImage = function handleLoadImage() {
        shouldLoad.value = true;
      };
      var isLoaded = VueCompositionAPI.ref(false);
      var handleLoad = function handleLoad(e) {
        isLoaded.value = true;
        emit("load", {
          e: e
        });
        onLoad === null || onLoad === void 0 || onLoad({
          e: e
        });
      };
      var hasError = VueCompositionAPI.ref(false);
      var handleError = function handleError(e) {
        hasError.value = true;
        if (fallback.value) {
          imageStrSrc.value = fallback.value;
          hasError.value = false;
        }
        emit("error", {
          e: e
        });
        onError === null || onError === void 0 || onError({
          e: e
        });
      };
      var hasMouseEvent = overlayTrigger.value === "hover";
      var shouldShowOverlay = VueCompositionAPI.ref(!hasMouseEvent);
      var handleToggleOverlay = function handleToggleOverlay() {
        if (hasMouseEvent) {
          shouldShowOverlay.value = !shouldShowOverlay.value;
        }
      };
      var imageClasses = VueCompositionAPI.computed(function () {
        return ["".concat(classPrefix.value, "-image"), "".concat(classPrefix.value, "-image--fit-").concat(props2.fit), "".concat(classPrefix.value, "-image--position-").concat(props2.position)];
      });
      return {
        imageRef: imageRef,
        imageClasses: imageClasses,
        handleLoadImage: handleLoadImage,
        classPrefix: classPrefix,
        globalConfig: globalConfig,
        hasMouseEvent: hasMouseEvent,
        handleToggleOverlay: handleToggleOverlay,
        shouldShowOverlay: shouldShowOverlay,
        imageStrSrc: imageStrSrc,
        previewUrl: previewUrl,
        hasError: hasError,
        shouldLoad: shouldLoad,
        handleError: handleError,
        handleLoad: handleLoad,
        isLoaded: isLoaded,
        rest: rest
      };
    },
    mounted: function mounted() {
      if (!this.lazy || !this.imageRef) return;
      var io = observe(this.imageRef, null, this.handleLoadImage, 0);
      this.io = io;
    },
    destroyed: function destroyed() {
      this.imageRef && this.io && this.io.unobserve(this.imageRef);
    },
    methods: {
      renderPlaceholder: function renderPlaceholder() {
        var h = this.$createElement;
        var placeholder = renderTNodeJSX(this, "placeholder");
        if (!placeholder) return;
        return h("div", {
          "class": "".concat(this.classPrefix, "-image__placeholder")
        }, [placeholder]);
      },
      renderGalleryShadow: function renderGalleryShadow() {
        var h = this.$createElement;
        if (!this.gallery) return null;
        return h("div", {
          "class": "".concat(this.classPrefix, "-image__gallery-shadow")
        });
      },
      renderOverlay: function renderOverlay() {
        var h = this.$createElement;
        var overlay = renderTNodeJSX(this, "overlayContent");
        if (!overlay) return null;
        return h("div", {
          "class": ["".concat(this.classPrefix, "-image__overlay-content"), !this.shouldShowOverlay && "".concat(this.classPrefix, "-image__overlay-content--hidden")]
        }, [overlay]);
      },
      renderImageSrcset: function renderImageSrcset() {
        var h = this.$createElement;
        return h("picture", [Object.entries(this.srcset).map(function (_ref5) {
          var _ref6 = _slicedToArray(_ref5, 2),
            type = _ref6[0],
            url = _ref6[1];
          return h("source", {
            "attrs": {
              "type": type,
              "srcset": url
            }
          });
        }), this.renderImage()]);
      },
      renderImage: function renderImage() {
        var h = this.$createElement;
        var url = typeof this.imageStrSrc === "string" ? this.imageStrSrc : this.previewUrl;
        return h("img", {
          "attrs": {
            "src": url,
            "alt": this.alt,
            "referrerpolicy": this.referrerpolicy
          },
          "on": {
            "error": this.handleError,
            "load": this.handleLoad
          },
          "class": this.imageClasses
        });
      }
    },
    render: function render() {
      var h = arguments[0];
      return h("div", helper([{
        "ref": "imageRef",
        "class": ["".concat(this.classPrefix, "-image__wrapper"), "".concat(this.classPrefix, "-image__wrapper--shape-").concat(this.shape), this.gallery && "".concat(this.classPrefix, "-image__wrapper--gallery"), this.hasMouseEvent && "".concat(this.classPrefix, "-image__wrapper--need-hover"), this.className],
        "on": {
          "mouseenter": this.handleToggleOverlay,
          "mouseleave": this.handleToggleOverlay
        }
      }, this.rest, {}, {
        "on": this.$listeners
      }]), [this.renderPlaceholder(), this.renderGalleryShadow(), (this.hasError || !this.shouldLoad) && h("div", {
        "class": "".concat(this.classPrefix, "-image")
      }), !(this.hasError || !this.shouldLoad) && (this.srcset && Object.keys(this.srcset).length ? this.renderImageSrcset() : this.renderImage()), !(this.hasError || !this.shouldLoad) && !this.isLoaded && h("div", {
        "class": "".concat(this.classPrefix, "-image__loading")
      }, [renderTNodeJSX(this, "loading") || h(Space, {
        "attrs": {
          "direction": "vertical",
          "size": 8,
          "align": "center"
        }
      }, [h(ImageIcon, {
        "attrs": {
          "size": "24px"
        }
      }), typeof this.loading === "string" ? this.loading : this.globalConfig.loadingText])]), this.hasError && h("div", {
        "class": "".concat(this.classPrefix, "-image__error")
      }, [renderTNodeJSX(this, "error") || h(Space, {
        "attrs": {
          "direction": "vertical",
          "size": 8,
          "align": "center"
        }
      }, [h(ImageErrorIcon, {
        "attrs": {
          "size": "24px"
        }
      }), typeof this.error === "string" ? this.error : this.globalConfig.errorText])]), this.renderOverlay()]);
    }
  });

  var Image$1 = withInstall$1(mapProps(["value"])(_Image));

  function ownKeys$11(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$10(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$11(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$11(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$b = getClassPrefixMixins("avatar");
  var _Avatar = mixins(Vue__default["default"], classPrefixMixins$b).extend({
    name: "TAvatar",
    props: _objectSpread$10({}, props$s),
    data: function data() {
      return {
        isImgExist: true,
        gap: 4,
        scale: ""
      };
    },
    inject: {
      avatarGroup: {
        "default": void 0
      }
    },
    computed: {
      sizeValue: function sizeValue() {
        var _this$avatarGroup;
        return this.size || ((_this$avatarGroup = this.avatarGroup) === null || _this$avatarGroup === void 0 ? void 0 : _this$avatarGroup.size);
      },
      customAvatarSize: function customAvatarSize() {
        return this.isCustomSize() ? {
          width: this.sizeValue,
          height: this.sizeValue,
          "font-size": "".concat(Number.parseInt(this.sizeValue, 10) / 2, "px")
        } : {};
      },
      customImageSize: function customImageSize() {
        return this.isCustomSize() ? {
          height: this.sizeValue,
          width: this.sizeValue
        } : {};
      },
      customCharacterSize: function customCharacterSize() {
        return {
          transform: this.scale
        };
      }
    },
    mounted: function mounted() {
      var _this = this;
      this.$nextTick(function () {
        _this.setScaleParams();
      });
    },
    methods: {
      handleImgLoadError: function handleImgLoadError(context) {
        var onError = this.onError,
          hideOnLoadFailed = this.hideOnLoadFailed;
        this.isImgExist = !hideOnLoadFailed;
        this.$emit("error", context);
        onError && onError(context);
      },
      setScaleParams: function setScaleParams() {
        var avatar = this.$refs.avatar;
        var avatarChild = this.$refs.avatarChild;
        var avatarWidth = avatar === null || avatar === void 0 ? void 0 : avatar.offsetWidth;
        var avatarChildWidth = avatarChild === null || avatarChild === void 0 ? void 0 : avatarChild.offsetWidth;
        if (this.gap * 2 < avatarWidth) {
          this.scale = avatarChildWidth > avatarWidth - this.gap * 2 ? "scale(".concat((avatarWidth - this.gap * 2) / avatarChildWidth, ")") : "scale(1)";
        }
      },
      isCustomSize: function isCustomSize() {
        return this.sizeValue && !this.commonSizeClassName[this.sizeValue];
      }
    },
    updated: function updated() {
      var _this2 = this;
      this.$nextTick(function () {
        _this2.setScaleParams();
      });
    },
    render: function render() {
      var h = arguments[0];
      var content = renderContent(this, "default", "content");
      var icon = renderTNodeJSX(this, "icon");
      var isIconOnly = icon && !content;
      var _this$$props = this.$props,
        shape = _this$$props.shape,
        image = _this$$props.image,
        alt = _this$$props.alt;
      var avatarClass = [this.componentName, this.commonSizeClassName[this.sizeValue], _defineProperty$2(_defineProperty$2(_defineProperty$2({}, "".concat(this.componentName, "--circle"), shape === "circle"), "".concat(this.componentName, "--round"), shape === "round"), "".concat(this.componentName, "__icon"), !!isIconOnly)];
      content = h("span", {
        "ref": "avatarChild",
        "style": _objectSpread$10({}, this.customCharacterSize)
      }, [content]);
      if (icon) {
        content = [icon, !isIconOnly ? content : ""];
      }
      if (image && this.isImgExist) {
        var _this$imageProps, _this$imageProps2;
        content = h(Image$1, helper([{
          "style": _objectSpread$10({}, this.customImageSize),
          "attrs": {
            "src": image,
            "alt": alt
          }
        }, {
          "props": this.imageProps
        }, {
          "attrs": {
            "error": !this.$scopedSlots.error && !((_this$imageProps = this.imageProps) !== null && _this$imageProps !== void 0 && _this$imageProps.error) ? " " : void 0,
            "loading": !this.$scopedSlots.loading && !((_this$imageProps2 = this.imageProps) !== null && _this$imageProps2 !== void 0 && _this$imageProps2.loading) ? " " : void 0
          },
          "scopedSlots": this.$scopedSlots
        }, {
          "on": {
            error: this.handleImgLoadError
          }
        }]));
      }
      return h("div", {
        "ref": "avatar",
        "class": avatarClass,
        "style": this.customAvatarSize
      }, [content]);
    }
  });

  var props$q = {
    cascading: {
      type: String,
      "default": "right-up",
      validator: function validator(val) {
        if (!val) return true;
        return ["left-up", "right-up"].includes(val);
      }
    },
    collapseAvatar: {
      type: [String, Function]
    },
    max: {
      type: Number
    },
    popupProps: {
      type: Object
    },
    size: {
      type: String,
      "default": "medium"
    }
  };

  function ownKeys$10(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$$(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$10(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$10(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$a = getClassPrefixMixins("avatar");
  var _AvatarGroup = mixins(classPrefixMixins$a).extend({
    name: "TAvatarGroup",
    components: {
      Avatar: _Avatar
    },
    props: _objectSpread$$({}, props$q),
    provide: function provide() {
      return {
        avatarGroup: this
      };
    },
    methods: {
      renderEllipsisAvatar: function renderEllipsisAvatar(children) {
        var h = this.$createElement;
        if ((children === null || children === void 0 ? void 0 : children.length) > this.max) {
          var content = this.setEllipsisContent(children);
          var outAvatar = children.slice(0, this.max);
          outAvatar.push(h(_Avatar, {
            "class": "".concat(this.componentName, "__collapse"),
            "attrs": {
              "size": this.size,
              "icon": this.isIcon() ? this.collapseAvatar : null
            }
          }, [content]));
          return [outAvatar];
        }
        return [children];
      },
      setEllipsisContent: function setEllipsisContent(children) {
        var content = "";
        if (this.collapseAvatar) {
          if (!this.isIcon()) {
            content = renderContent(this, "collapseAvatar", "content");
          }
        } else {
          content = "+".concat(children.length - this.max);
        }
        return content;
      },
      isIcon: function isIcon() {
        var content = renderTNodeJSX(this, "collapseAvatar");
        return (content === null || content === void 0 ? void 0 : content.context) instanceof Vue__default["default"];
      }
    },
    render: function render() {
      var h = arguments[0];
      var $scopedSlots = this.$scopedSlots;
      var children = $scopedSlots["default"] && $scopedSlots["default"](null);
      var _this$$props = this.$props,
        cascading = _this$$props.cascading,
        max = _this$$props.max;
      var groupClass = ["".concat(this.componentName, "-group"), _defineProperty$2(_defineProperty$2({}, "".concat(this.componentName, "--offset-right"), cascading === "right-up"), "".concat(this.componentName, "--offset-left"), cascading === "left-up")];
      var content = [children];
      if (max && max >= 0) {
        content = [this.renderEllipsisAvatar(children)];
      }
      return h("div", {
        "class": groupClass
      }, [content]);
    }
  });

  var Avatar = withInstall$1(_Avatar);
  var AvatarGroup = withInstall$1(_AvatarGroup);

  var props$p = {
    color: {
      type: String,
      "default": ""
    },
    content: {
      type: [String, Function]
    },
    count: {
      type: [String, Number, Function],
      "default": 0
    },
    "default": {
      type: [String, Function]
    },
    dot: Boolean,
    maxCount: {
      type: Number,
      "default": 99
    },
    offset: {
      type: Array
    },
    shape: {
      type: String,
      "default": "circle",
      validator: function validator(val) {
        return ["circle", "round"].includes(val);
      }
    },
    showZero: Boolean,
    size: {
      type: String,
      "default": "medium",
      validator: function validator(val) {
        return ["small", "medium"].includes(val);
      }
    }
  };

  function ownKeys$$(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$_(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$$(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$$(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$9 = getClassPrefixMixins("badge");
  var _Badge = mixins(classPrefixMixins$9).extend({
    name: "TBadge",
    props: _objectSpread$_({}, props$p),
    methods: {
      getContent: function getContent() {
        if (typeof this.$scopedSlots.count === "function") {
          return this.$scopedSlots.count(null);
        }
        if (typeof this.count === "function") {
          return renderTNodeJSX(this, "count");
        }
        if (isNaN(Number(this.count))) {
          return this.count;
        }
        var count = Number(this.count);
        return count > this.maxCount ? "".concat(this.maxCount, "+") : count;
      },
      isSmall: function isSmall() {
        return this.size === "small";
      },
      isZero: function isZero() {
        var content = this.getContent();
        return content === 0 || content === "0";
      },
      isHidden: function isHidden() {
        return !this.showZero && this.isZero();
      },
      getOffset: function getOffset() {
        if (!this.offset) return {};
        var _this$offset = _slicedToArray(this.offset, 2),
          xOffset = _this$offset[0],
          yOffset = _this$offset[1];
        xOffset = isNaN(Number(xOffset)) ? xOffset : "".concat(xOffset, "px");
        yOffset = isNaN(Number(yOffset)) ? yOffset : "".concat(yOffset, "px");
        return {
          xOffset: xOffset,
          yOffset: yOffset
        };
      }
    },
    render: function render() {
      var h = arguments[0];
      var _this$$props = this.$props,
        dot = _this$$props.dot,
        shape = _this$$props.shape,
        color = _this$$props.color;
      var content = this.getContent();
      var isHidden = this.isHidden();
      var children = renderContent(this, "default", "content");
      var _this$getOffset = this.getOffset(),
        xOffset = _this$getOffset.xOffset,
        yOffset = _this$getOffset.yOffset;
      var badgeClassNames = [_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({}, "".concat(this.componentName, "--dot"), !!dot), "".concat(this.componentName, "--circle"), !dot && shape === "circle"), "".concat(this.componentName, "--round"), shape === "round"), "".concat(this.componentName, "--ribbon"), shape === "ribbon"), "".concat(this.classPrefix, "-size-s"), this.isSmall())];
      var inlineStyle = {
        background: "".concat(color),
        right: xOffset,
        top: yOffset
      };
      return h("div", {
        "class": this.componentName
      }, [children || null, isHidden ? null : h("sup", {
        "class": badgeClassNames,
        "style": inlineStyle
      }, [dot ? null : content])]);
    }
  });

  var Badge = withInstall$1(_Badge);

  var calendar = createCommonjsModule(function (module, exports) {
    !function (e, t) {
      module.exports = t() ;
    }(commonjsGlobal, function () {

      return function (e, t, a) {
        var n = "h:mm A",
          d = {
            lastDay: "[Yesterday at] " + n,
            sameDay: "[Today at] " + n,
            nextDay: "[Tomorrow at] " + n,
            nextWeek: "dddd [at] " + n,
            lastWeek: "[Last] dddd [at] " + n,
            sameElse: "MM/DD/YYYY"
          };
        t.prototype.calendar = function (e, t) {
          var n = t || this.$locale().calendar || d,
            o = a(e || void 0).startOf("d"),
            s = this.diff(o, "d", !0),
            i = "sameElse",
            f = s < -6 ? i : s < -1 ? "lastWeek" : s < 0 ? "lastDay" : s < 1 ? "sameDay" : s < 2 ? "nextDay" : s < 7 ? "nextWeek" : i,
            l = n[f] || d[f];
          return "function" == typeof l ? l.call(this, a()) : this.format(l);
        };
      };
    });
  });

  var props$o = {
    cell: {
      type: [String, Function]
    },
    cellAppend: {
      type: [String, Function]
    },
    controllerConfig: {
      type: [Boolean, Object],
      "default": void 0
    },
    fillWithZero: {
      type: Boolean,
      "default": void 0
    },
    firstDayOfWeek: {
      type: Number,
      validator: function validator(val) {
        if (!val) return true;
        return [1, 2, 3, 4, 5, 6, 7].includes(val);
      }
    },
    format: {
      type: String,
      "default": "YYYY-MM-DD"
    },
    head: {
      type: [String, Function]
    },
    isShowWeekendDefault: {
      type: Boolean,
      "default": true
    },
    mode: {
      type: String,
      "default": "month",
      validator: function validator(val) {
        if (!val) return true;
        return ["month", "year"].includes(val);
      }
    },
    month: {
      type: [String, Number]
    },
    multiple: Boolean,
    preventCellContextmenu: Boolean,
    range: {
      type: Array
    },
    theme: {
      type: String,
      "default": "full",
      validator: function validator(val) {
        if (!val) return true;
        return ["full", "card"].includes(val);
      }
    },
    value: {
      type: [String, Array, Date]
    },
    week: {
      type: [Array, Function]
    },
    year: {
      type: [String, Number]
    },
    onCellClick: Function,
    onCellDoubleClick: Function,
    onCellRightClick: Function,
    onControllerChange: Function,
    onMonthChange: Function
  };

  var MIN_YEAR = 1970;
  var FIRST_MONTH_OF_YEAR = 1;
  var LAST_MONTH_OF_YEAR = 12;
  var DEFAULT_YEAR_CELL_NUMINROW = 4;
  var DAY_CN_MAP = {
    1: "\u4E00",
    2: "\u4E8C",
    3: "\u4E09",
    4: "\u56DB",
    5: "\u4E94",
    6: "\u516D",
    7: "\u65E5"
  };

  var getDay = function getDay(dt) {
    var day = dayjs_min(dt).day();
    if (day === 0) {
      day = 7;
    }
    return day;
  };
  var getDayCn = function getDayCn(num) {
    var re = "";
    var numStr = num.toString();
    if (numStr in DAY_CN_MAP) {
      re = DAY_CN_MAP[numStr];
    }
    return re;
  };
  var getCellColIndex = function getCellColIndex(firstDayOfWeek, dt) {
    var re = 0;
    var day = getDay(dt);
    if (day >= firstDayOfWeek) {
      re = day - firstDayOfWeek;
    } else {
      re = 7 - firstDayOfWeek + day;
    }
    return re;
  };
  var addDate = function addDate(dt, days) {
    var d = new Date(dt);
    d.setDate(d.getDate() + days);
    return d;
  };
  var createYearCellsData = function createYearCellsData(props, state) {
    var year = state.curSelectedYear,
      curDate = state.curDate,
      curDateList = state.curDateList;
    var format = props.format,
      multiple = props.multiple;
    var monthsArr = [];
    var _loop = function _loop(num) {
      var date = new Date(year, num - 1);
      var isCurrent = multiple ? !!curDateList.find(function (item) {
        return item.year() === year && parseInt(item.format("M"), 10) === num;
      }) : curDate.year() === year && parseInt(curDate.format("M"), 10) === num;
      monthsArr.push({
        mode: "year",
        isCurrent: isCurrent,
        date: date,
        formattedDate: dayjs_min(date).format(format),
        filterDate: null,
        formattedFilterDate: null,
        isShowWeekend: true
      });
    };
    for (var num = FIRST_MONTH_OF_YEAR; num <= LAST_MONTH_OF_YEAR; num++) {
      _loop(num);
    }
    return monthsArr;
  };
  var createMonthCellsData = function createMonthCellsData(props, state) {
    var year = state.curSelectedYear,
      month = state.curSelectedMonth,
      firstDayOfWeek = state.realFirstDayOfWeek,
      curDate = state.curDate,
      curDateList = state.curDateList;
    var format = props.format,
      multiple = props.multiple;
    var daysArr = [];
    var begin = dayjs_min("".concat(year, "-").concat(month)).startOf("month").toDate();
    var end = dayjs_min(dayjs_min("".concat(year, "-").concat(month)).endOf("month").format("YYYY-MM-DD")).toDate();
    var days = end.getDate();
    var beginDateColIndex = getCellColIndex(firstDayOfWeek, begin);
    var arr = [];
    var num = 1;
    var createCellData = function createCellData(belongTo, isCurrent, date, weekOrder) {
      var day = getDay(date);
      return {
        mode: "month",
        belongTo: belongTo,
        isCurrent: isCurrent,
        day: day,
        weekOrder: weekOrder,
        date: date,
        formattedDate: dayjs_min(date).format(format),
        filterDate: null,
        formattedFilterDate: null,
        isShowWeekend: true
      };
    };
    var judgeIsCurrent = function judgeIsCurrent(date) {
      var isCurrent = multiple ? !!curDateList.find(function (item) {
        return item.isSame(dayjs_min(date));
      }) : curDate.isSame(dayjs_min(date));
      return isCurrent;
    };
    for (var i = 0; i < beginDateColIndex; i++) {
      var date = addDate(begin, i - beginDateColIndex);
      arr.push(createCellData(-1, false, date, num));
      if (arr.length === 7) {
        daysArr.push(arr);
        arr = [];
        num += 1;
      }
    }
    for (var _i = 0; _i < days; _i++) {
      var _date = addDate(begin, _i);
      var isCurrent = judgeIsCurrent(_date);
      arr.push(createCellData(0, isCurrent, _date, num));
      if (arr.length === 7) {
        daysArr.push(arr);
        arr = [];
        num += 1;
      }
    }
    if (arr.length) {
      var nextMonthCellNum = 7 - arr.length;
      for (var _i2 = 0; _i2 < nextMonthCellNum; _i2++) {
        var _date2 = addDate(end, _i2 + 1);
        arr.push(createCellData(1, false, _date2, num));
      }
      daysArr.push(arr);
    }
    return daysArr;
  };

  var classPrefixMixins$8 = getClassPrefixMixins("calendar");
  var clickTypeEmitEventMap = {
    click: "click",
    dblclick: "dblclick",
    contextmenu: "rightclick"
  };
  var CalendarCellItem = mixins(classPrefixMixins$8).extend({
    name: "TCalendarCell",
    props: {
      item: {
        type: Object,
        "default": function _default() {
          return null;
        }
      },
      theme: {
        type: String,
        "default": function _default() {
          return null;
        }
      },
      fillWithZero: {
        type: Boolean,
        "default": void 0
      },
      t: Function,
      global: Object,
      cell: Function
    },
    computed: {
      allowSlot: function allowSlot() {
        return this.theme === "full";
      },
      disabled: function disabled() {
        return this.item.mode === "month" && this.item.belongTo !== 0;
      },
      valueDisplay: function valueDisplay() {
        if (this.item.mode === "month") {
          var _ref, _this$fillWithZero;
          var dateNum = this.item.date.getDate();
          var fillZero = dateNum < 10 && ((_ref = (_this$fillWithZero = this.fillWithZero) !== null && _this$fillWithZero !== void 0 ? _this$fillWithZero : this.global.fillWithZero) !== null && _ref !== void 0 ? _ref : true);
          return fillZero ? "0".concat(dateNum) : dateNum;
        }
        var map = this.t(this.global.cellMonth).split(",");
        return map[this.item.date.getMonth().toString()];
      },
      cellCls: function cellCls() {
        var _this$item = this.item,
          mode = _this$item.mode,
          date = _this$item.date,
          formattedDate = _this$item.formattedDate,
          isCurrent = _this$item.isCurrent;
        var now = new Date();
        var isNow = mode === "year" ? now.getMonth() === date.getMonth() && now.getFullYear() === date.getFullYear() : formattedDate === dayjs_min().format("YYYY-MM-DD");
        return ["".concat(this.componentName, "__table-body-cell"), _defineProperty$2(_defineProperty$2(_defineProperty$2({}, "".concat(this.classPrefix, "-is-disabled"), this.disabled), "".concat(this.classPrefix, "-is-checked"), isCurrent), "".concat(this.componentName, "__table-body-cell--now"), isNow)];
      }
    },
    methods: {
      clickCell: function clickCell(e) {
        if (this.disabled) return;
        this.$emit(clickTypeEmitEventMap[e.type], e);
      }
    },
    render: function render() {
      var _this = this;
      var h = arguments[0];
      var item = this.item,
        cellCls = this.cellCls,
        clickCell = this.clickCell,
        valueDisplay = this.valueDisplay,
        allowSlot = this.allowSlot;
      var defaultNode = function defaultNode() {
        var cellContentOuterDomStyle = {
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end"
        };
        return h("div", {
          "style": cellContentOuterDomStyle
        }, [h("div", {
          "class": "".concat(_this.componentName, "__table-body-cell-display")
        }, [valueDisplay]), h("div", {
          "class": "".concat(_this.componentName, "__table-body-cell-content")
        }, [allowSlot && renderTNodeJSX(_this, "cellAppend", {
          params: item
        })])]);
      };
      return item && h("div", {
        "class": cellCls,
        "on": {
          "click": clickCell,
          "dblclick": clickCell,
          "contextmenu": clickCell
        }
      }, [typeof this.cell === "function" ? this.cell(this.$createElement, item) : renderTNodeJSXDefault(this, "cell", {
        defaultNode: defaultNode(),
        params: item
      })]);
    }
  });

  var RenderComponent = Vue__default["default"].extend({
    name: "render-component",
    functional: true,
    props: {
      render: Function
    },
    render: function render(h, ctx) {
      return ctx.props.render(h, ctx.data.attrs);
    }
  });

  function ownKeys$_(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$Z(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$_(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$_(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  dayjs_min.extend(calendar);
  var createDefaultCurDate = function createDefaultCurDate() {
    return dayjs_min(dayjs_min().format("YYYY-MM-DD"));
  };
  var getDefaultControllerConfigData = function getDefaultControllerConfigData() {
    var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return {
      visible: visible,
      disabled: false,
      mode: {
        visible: true,
        radioGroupProps: {}
      },
      year: {
        visible: true,
        selectProps: {}
      },
      month: {
        visible: true,
        selectProps: {}
      },
      weekend: {
        visible: true,
        showWeekendButtonProps: {},
        hideWeekendButtonProps: {}
      },
      current: {
        visible: true,
        currentDayButtonProps: {},
        currentMonthButtonProps: {}
      }
    };
  };
  var _Calendar = mixins(getConfigReceiverMixins("calendar")).extend({
    name: "TCalendar",
    components: {
      TCheckTag: CheckTag,
      TSelect: Select,
      TOption: Option,
      TRadioGroup: RadioGroup,
      TRadioButton: RadioButton,
      TButton: Button,
      CalendarCellItem: CalendarCellItem,
      RenderComponent: RenderComponent
    },
    props: _objectSpread$Z({}, props$o),
    data: function data() {
      return {
        realFirstDayOfWeek: 1,
        curDate: null,
        curDateList: [],
        curSelectedYear: null,
        curSelectedMonth: null,
        curSelectedMode: null,
        isShowWeekend: true,
        controlSize: "medium"
      };
    },
    computed: {
      state: function state() {
        return this.$data;
      },
      props: function props() {
        return this.$props;
      },
      TEXT_MAP: function TEXT_MAP() {
        var t = this.t,
          global = this.global;
        var r = {
          showWeekend: t(global.showWeekend),
          hideWeekend: t(global.hideWeekend),
          today: t(global.today),
          thisMonth: t(global.thisMonth)
        };
        return r;
      },
      weekDipalyText: function weekDipalyText() {
        return this.week || this.t(this.global.week).split(",");
      },
      calendarCls: function calendarCls() {
        return ["".concat(this.componentName), "".concat(this.componentName, "--").concat(this.theme)];
      },
      calendarPanelCls: function calendarPanelCls() {
        return ["".concat(this.componentName, "__panel"), "".concat(this.componentName, "__panel--").concat(this.curSelectedMode)];
      },
      isWeekRender: function isWeekRender() {
        return typeof this.week === "function";
      },
      rangeFromTo: function rangeFromTo() {
        if (!this.range || this.range.length < 2) {
          return null;
        }
        var _this$range = _slicedToArray(this.range, 2),
          v1 = _this$range[0],
          v2 = _this$range[1];
        if (dayjs_min(v1).isBefore(dayjs_min(v2))) {
          return {
            from: v1,
            to: v2
          };
        }
        return {
          from: v2,
          to: v1
        };
      },
      controllerOptions: function controllerOptions() {
        var dayJsFilterDate = dayjs_min("".concat(this.curSelectedYear, "-").concat(this.curSelectedMonth));
        var re = {
          isShowWeekend: this.isShowWeekend,
          filterDate: dayJsFilterDate.toDate(),
          formattedFilterDate: dayJsFilterDate.format(this.format),
          mode: this.curSelectedMode
        };
        return re;
      },
      cellColHeaders: function cellColHeaders() {
        var re = [];
        var min = 1;
        var max = 7;
        for (var i = this.realFirstDayOfWeek; i <= max; i++) {
          re.push({
            num: i,
            display: this.getWeekDisplay(i)
          });
        }
        if (this.realFirstDayOfWeek > min) {
          for (var _i = min; _i < this.realFirstDayOfWeek; _i++) {
            re.push({
              num: _i,
              display: this.getWeekDisplay(_i)
            });
          }
        }
        return re;
      },
      yearSelectOptionList: function yearSelectOptionList() {
        var re = [];
        var begin = this.curSelectedYear - 10;
        var end = this.curSelectedYear + 10;
        if (this.rangeFromTo && this.rangeFromTo.from && this.rangeFromTo.to) {
          begin = dayjs_min(this.rangeFromTo.from).year();
          end = dayjs_min(this.rangeFromTo.to).year();
        }
        if (begin < MIN_YEAR) {
          begin = MIN_YEAR;
        }
        if (end < MIN_YEAR) {
          end = MIN_YEAR;
        }
        for (var i = begin; i <= end; i++) {
          var disabled = this.checkMonthAndYearSelectorDisabled(i, this.curSelectedMonth);
          re.push({
            value: i,
            label: this.t(this.global.yearSelection, {
              year: i
            }),
            disabled: disabled
          });
        }
        return re;
      },
      monthSelectOptionList: function monthSelectOptionList() {
        var re = [];
        for (var i = FIRST_MONTH_OF_YEAR; i <= LAST_MONTH_OF_YEAR; i++) {
          var disabled = this.checkMonthAndYearSelectorDisabled(this.curSelectedYear, i);
          re.push({
            value: i,
            label: this.t(this.global.monthSelection, {
              month: i
            }),
            disabled: disabled
          });
        }
        return re;
      },
      modeSelectOptionList: function modeSelectOptionList() {
        return [{
          value: "month",
          label: this.t(this.global.monthRadio)
        }, {
          value: "year",
          label: this.t(this.global.yearRadio)
        }];
      },
      monthCellsData: function monthCellsData() {
        var daysArr = createMonthCellsData(this.props, this.state);
        return daysArr;
      },
      yearCellsData: function yearCellsData() {
        var re = [];
        var monthsArr = createYearCellsData(this.props, this.state);
        var rowCount = Math.ceil(monthsArr.length / DEFAULT_YEAR_CELL_NUMINROW);
        var index = 0;
        for (var i = 1; i <= rowCount; i++) {
          var row = [];
          for (var j = 1; j <= DEFAULT_YEAR_CELL_NUMINROW; j++) {
            row.push(monthsArr[index]);
            index += 1;
          }
          re.push(row);
        }
        return re;
      },
      controllerConfigData: function controllerConfigData() {
        var _ref, _this$controllerConfi;
        var controllerConfig = (_ref = (_this$controllerConfi = this.controllerConfig) !== null && _this$controllerConfi !== void 0 ? _this$controllerConfi : this.global.controllerConfig) !== null && _ref !== void 0 ? _ref : true;
        if (typeof controllerConfig === "boolean") {
          return getDefaultControllerConfigData(controllerConfig);
        }
        return _objectSpread$Z(_objectSpread$Z({}, getDefaultControllerConfigData()), controllerConfig);
      },
      isControllerVisible: function isControllerVisible() {
        return this.controllerConfigData && this.controllerConfigData.visible;
      },
      weekendBtnText: function weekendBtnText() {
        return this.isShowWeekend ? this.TEXT_MAP.hideWeekend : this.TEXT_MAP.showWeekend;
      },
      weekendBtnVBind: function weekendBtnVBind() {
        var c = this.controllerConfigData.weekend;
        return this.isShowWeekend ? c.hideWeekendButtonProps : c.showWeekendButtonProps;
      },
      currentBtnText: function currentBtnText() {
        return this.curSelectedMode === "month" ? this.TEXT_MAP.today : this.TEXT_MAP.thisMonth;
      },
      currentBtnVBind: function currentBtnVBind() {
        var c = this.controllerConfigData.current;
        return this.curSelectedMode === "month" ? c.currentDayButtonProps : c.currentMonthButtonProps;
      },
      isModeVisible: function isModeVisible() {
        return this.checkControllerVisible("mode");
      },
      isYearVisible: function isYearVisible() {
        return this.checkControllerVisible("year");
      },
      isMonthVisible: function isMonthVisible() {
        return this.checkControllerVisible("month");
      },
      isWeekendToggleVisible: function isWeekendToggleVisible() {
        return this.checkControllerVisible("weekend");
      },
      isCurrentBtnVisible: function isCurrentBtnVisible() {
        return this.checkControllerVisible("current");
      },
      isModeDisabled: function isModeDisabled() {
        return this.checkControllerDisabled("mode", "radioGroupProps");
      },
      isYearDisabled: function isYearDisabled() {
        return this.checkControllerDisabled("year", "selectProps");
      },
      isMonthDisabled: function isMonthDisabled() {
        return this.checkControllerDisabled("month", "selectProps");
      },
      isWeekendToggleDisabled: function isWeekendToggleDisabled() {
        var p = this.isShowWeekend ? "hideWeekendButtonProps" : "showWeekendButtonProps";
        return this.checkControllerDisabled("weekend", p);
      },
      isCurrentBtnDisabled: function isCurrentBtnDisabled() {
        var p = this.curSelectedMode === "month" ? "currentDayButtonProps" : "currentMonthButtonProps";
        return this.checkControllerDisabled("current", p);
      },
      filterYearStr: function filterYearStr() {
        return "".concat(this.controllerOptions.filterDate.getFullYear());
      },
      filterMonthStr: function filterMonthStr() {
        return "".concat(this.controllerOptions.filterDate.getMonth() + 1);
      },
      filterYearMonth: function filterYearMonth() {
        return {
          year: this.filterYearStr,
          month: this.filterMonthStr
        };
      }
    },
    watch: {
      firstDayOfWeek: {
        handler: function handler() {
          var _ref2, _this$firstDayOfWeek;
          this.realFirstDayOfWeek = (_ref2 = (_this$firstDayOfWeek = this.firstDayOfWeek) !== null && _this$firstDayOfWeek !== void 0 ? _this$firstDayOfWeek : this.global.firstDayOfWeek) !== null && _ref2 !== void 0 ? _ref2 : 1;
        },
        immediate: true
      },
      value: {
        handler: function handler(v) {
          if (this.multiple) {
            this.setCurrentDateList(v);
          } else {
            this.setCurrentDate(v);
          }
        },
        immediate: true
      },
      year: {
        handler: function handler(v) {
          this.setCurSelectedYear(v);
        },
        immediate: true
      },
      month: {
        handler: function handler(v) {
          this.setCurSelectedMonth(v);
        },
        immediate: true
      },
      mode: {
        handler: function handler(v) {
          this.curSelectedMode = v;
        },
        immediate: true
      },
      isShowWeekendDefault: {
        handler: function handler(v) {
          this.isShowWeekend = v;
        },
        immediate: true
      },
      filterYearMonth: {
        handler: function handler(v) {
          emitEvent$1(this, "month-change", v);
          this.controllerChange();
        }
      },
      curSelectedMode: function curSelectedMode() {
        this.handleIE();
      },
      isShowWeekend: function isShowWeekend() {
        this.handleIE();
      },
      isControllerVisible: function isControllerVisible() {
        this.handleIE();
      },
      theme: {
        handler: function handler(v) {
          if (v === "card") this.controlSize = "small";
          if (v === "full") this.controlSize = "medium";
        },
        immediate: true
      }
    },
    mounted: function mounted() {
      this.handleIE();
    },
    methods: {
      handleIE: function handleIE() {
        var _this = this;
        if (getIEVersion$1() <= 9) {
          this.$nextTick(function () {
            var element = _this.$el.children[_this.isControllerVisible ? 1 : 0];
            if (_this.curSelectedMode === "month") {
              element.setAttribute("is-show-weekend", "".concat(_this.isShowWeekend));
            } else {
              element.removeAttribute("is-show-weekend");
            }
          });
        }
      },
      getCalendarWeekSlotData: function getCalendarWeekSlotData(item) {
        return {
          day: item.num
        };
      },
      getWeekDisplay: function getWeekDisplay(weekNum) {
        var weekText = this.weekDipalyText;
        return _typeof$2(weekText) === "object" && weekText[weekNum - 1] ? weekText[weekNum - 1] : getDayCn(weekNum);
      },
      checkMonthCellItemShowed: function checkMonthCellItemShowed(cellData) {
        return this.isShowWeekend || cellData.day < 6;
      },
      createCalendarCell: function createCalendarCell(cellData) {
        return _objectSpread$Z(_objectSpread$Z({}, cellData), this.controllerOptions);
      },
      clickCell: function clickCell(e, cellData) {
        var d = dayjs_min(cellData.date);
        if (this.multiple) {
          if (this.curDateList.find(function (item) {
            return item.isSame(d);
          })) {
            this.curDateList = remove(this.curDateList, function (item) {
              return !item.isSame(d);
            });
          } else {
            this.curDateList.push(d);
          }
        } else {
          this.curDate = d;
        }
        var options = this.getCellClickEventOptions(e, cellData);
        emitEvent$1(this, "cell-click", options);
      },
      doubleClickCell: function doubleClickCell(e, cellData) {
        var options = this.getCellClickEventOptions(e, cellData);
        emitEvent$1(this, "cell-double-click", options);
      },
      rightClickCell: function rightClickCell(e, cellData) {
        if (this.preventCellContextmenu) {
          e.preventDefault();
        }
        var options = this.getCellClickEventOptions(e, cellData);
        emitEvent$1(this, "cell-right-click", options);
      },
      getCellClickEventOptions: function getCellClickEventOptions(e, cellData) {
        return {
          cell: this.createCalendarCell(cellData),
          e: e
        };
      },
      controllerChange: function controllerChange() {
        var options = this.controllerOptions;
        emitEvent$1(this, "controller-change", options);
      },
      onWeekendToggleClick: function onWeekendToggleClick() {
        this.isShowWeekend = !this.isShowWeekend;
        this.controllerChange();
      },
      checkMonthCellColHeaderVisibled: function checkMonthCellColHeaderVisibled(item) {
        var re = true;
        if (!this.isShowWeekend) {
          re = item.num !== 6 && item.num !== 7;
        }
        return re;
      },
      checkControllerDisabled: function checkControllerDisabled(name, propsName) {
        var re = false;
        var conf = this.controllerConfigData;
        if (conf && (conf.disabled || conf[name] && conf[name][propsName] && conf[name][propsName].disabled)) {
          re = true;
        }
        return re;
      },
      checkControllerVisible: function checkControllerVisible(name) {
        var re = true;
        var conf = this.controllerConfigData;
        if (!conf || !conf.visible || conf[name] === false || conf[name] && !conf[name].visible) {
          re = false;
        }
        return re;
      },
      toToday: function toToday() {
        var currentSelectDate = createDefaultCurDate();
        this.curSelectedYear = currentSelectDate.year();
        this.curSelectedMonth = parseInt(currentSelectDate.format("M"), 10);
      },
      setCurSelectedYear: function setCurSelectedYear(year) {
        var curSelectedYear = year ? parseInt("".concat(year), 10) : createDefaultCurDate().year();
        if (!isNaN(curSelectedYear) && curSelectedYear > 0) {
          this.curSelectedYear = curSelectedYear;
        }
      },
      setCurSelectedMonth: function setCurSelectedMonth(month) {
        var curSelectedMonth = month ? parseInt("".concat(month), 10) : parseInt(createDefaultCurDate().format("M"), 10);
        if (!isNaN(curSelectedMonth) && curSelectedMonth > 0 && curSelectedMonth <= 12) {
          this.curSelectedMonth = curSelectedMonth;
        }
      },
      setCurrentDate: function setCurrentDate(value) {
        if (Array.isArray(value)) {
          this.curDate = value && value.length ? dayjs_min(value[0]) : createDefaultCurDate();
        } else {
          this.curDate = value ? dayjs_min(value) : createDefaultCurDate();
        }
      },
      setCurrentDateList: function setCurrentDateList(value) {
        if (Array.isArray(value)) {
          this.curDateList = value && value.length ? value.map(function (item) {
            return dayjs_min(item);
          }) : [createDefaultCurDate()];
        } else {
          this.curDateList = value ? [dayjs_min(value)] : [createDefaultCurDate()];
        }
      },
      checkMonthAndYearSelectorDisabled: function checkMonthAndYearSelectorDisabled(year, month) {
        var disabled = false;
        if (this.rangeFromTo && this.rangeFromTo.from && this.rangeFromTo.to) {
          var beginYear = dayjs_min(this.rangeFromTo.from).year();
          var endYear = dayjs_min(this.rangeFromTo.to).year();
          if (year === beginYear) {
            var beginMon = parseInt(dayjs_min(this.rangeFromTo.from).format("M"), 10);
            disabled = month < beginMon;
          } else if (year === endYear) {
            var endMon = parseInt(dayjs_min(this.rangeFromTo.to).format("M"), 10);
            disabled = month > endMon;
          }
        }
        return disabled;
      },
      renderControl: function renderControl() {
        var _this2 = this;
        var h = this.$createElement;
        var controllerOptions = this.controllerOptions;
        return h("div", {
          "class": "".concat(this.componentName, "__control")
        }, [h("div", {
          "class": "".concat(this.componentName, "__title")
        }, [renderTNodeJSX(this, "head", {
          params: controllerOptions
        })]), h("div", {
          "class": "".concat(this.componentName, "__control-section")
        }, [this.isYearVisible && h("div", {
          "class": "".concat(this.componentName, "__control-section-cell")
        }, [h("t-select", helper([{
          "attrs": {
            "size": this.controlSize,
            "disabled": this.isYearDisabled,
            "autoWidth": true
          }
        }, {
          "props": _objectSpread$Z({}, this.controllerConfigData.year.selectProps)
        }, {
          "model": {
            value: _this2.curSelectedYear,
            callback: function callback($$v) {
              _this2.curSelectedYear = $$v;
            }
          }
        }]), [this.yearSelectOptionList.map(function (item) {
          return h("t-option", {
            "key": item.value,
            "attrs": {
              "value": item.value,
              "label": item.label,
              "disabled": item.disabled
            }
          }, [item.label]);
        })])]), this.curSelectedMode === "month" && this.isMonthVisible && h("div", {
          "class": "".concat(this.componentName, "__control-section-cell")
        }, [h("t-select", helper([{
          "attrs": {
            "size": this.controlSize,
            "disabled": this.isMonthDisabled,
            "autoWidth": true
          }
        }, {
          "props": _objectSpread$Z({}, this.controllerConfigData.month.selectProps)
        }, {
          "model": {
            value: _this2.curSelectedMonth,
            callback: function callback($$v) {
              _this2.curSelectedMonth = $$v;
            }
          }
        }]), [this.monthSelectOptionList.map(function (item) {
          return h("t-option", {
            "key": item.value,
            "attrs": {
              "value": item.value,
              "label": item.label,
              "disabled": item.disabled
            }
          }, [item.label]);
        })])]), this.isModeVisible && h("div", {
          "class": "".concat(this.componentName, "__control-section-cell"),
          "style": "height: auto"
        }, [h("t-radio-group", helper([{
          "attrs": {
            "variant": "default-filled",
            "size": this.controlSize,
            "disabled": this.isModeDisabled
          }
        }, {
          "props": _objectSpread$Z({}, this.controllerConfigData.mode.radioGroupProps)
        }, {
          "on": {
            "change": this.controllerChange
          },
          "model": {
            value: _this2.curSelectedMode,
            callback: function callback($$v) {
              _this2.curSelectedMode = $$v;
            }
          }
        }]), [this.modeSelectOptionList.map(function (item) {
          return h("t-radio-button", {
            "key": item.value,
            "attrs": {
              "value": item.value
            }
          }, [item.label]);
        })])]), this.theme === "full" && this.curSelectedMode === "month" && this.isWeekendToggleVisible && h("div", {
          "class": "".concat(this.componentName, "__control-section-cell")
        }, [h("t-check-tag", helper([{
          "class": "".concat(this.componentName, "__control-tag"),
          "attrs": {
            "defaultChecked": !this.isShowWeekend,
            "disabled": this.isWeekendToggleDisabled,
            "size": "large"
          },
          "on": {
            "click": this.onWeekendToggleClick
          }
        }, {
          "props": _objectSpread$Z({}, this.weekendBtnVBind)
        }]), [this.weekendBtnText])]), this.theme === "full" && this.isCurrentBtnVisible && h("div", {
          "class": "".concat(this.componentName, "__control-section-cell")
        }, [h("t-button", helper([{
          "attrs": {
            "size": this.controlSize,
            "disabled": this.isCurrentBtnDisabled
          },
          "on": {
            "click": function click() {
              _this2.toToday();
            }
          }
        }, {
          "props": _objectSpread$Z({}, this.currentBtnVBind)
        }]), [this.currentBtnText])])])]);
      }
    },
    render: function render() {
      var _this3 = this;
      var h = arguments[0];
      var calendarCls = this.calendarCls,
        calendarPanelCls = this.calendarPanelCls,
        isControllerVisible = this.isControllerVisible,
        cellColHeaders = this.cellColHeaders,
        checkMonthCellColHeaderVisibled = this.checkMonthCellColHeaderVisibled;
      var monthBody = function monthBody() {
        return h("table", {
          "class": "".concat(_this3.componentName, "__table")
        }, [h("thead", {
          "class": "".concat(_this3.componentName, "__table-head")
        }, [h("tr", {
          "class": "".concat(_this3.componentName, "__table-head-row")
        }, [cellColHeaders.map(function (item, index) {
          return checkMonthCellColHeaderVisibled(item) && h("th", {
            "class": "".concat(_this3.componentName, "__table-head-cell")
          }, [Array.isArray(_this3.week) ? _this3.week[index] : renderTNodeJSXDefault(_this3, "week", {
            defaultNode: h("span", [item.display]),
            params: _this3.getCalendarWeekSlotData(item)
          })]);
        })])]), h("tbody", {
          "class": "".concat(_this3.componentName, "__table-body")
        }, [_this3.monthCellsData.map(function (week, weekIndex) {
          return h("tr", {
            "class": "".concat(_this3.componentName, "__table-body-row")
          }, [week.map(function (item, itemIndex) {
            return _this3.checkMonthCellItemShowed(item) && h("calendar-cell-item", {
              "key": "d-".concat(weekIndex, "-").concat(itemIndex),
              "attrs": {
                "item": item,
                "theme": _this3.theme,
                "t": _this3.t,
                "global": _this3.global,
                "cell": _this3.cell,
                "fillWithZero": _this3.fillWithZero
              },
              "on": {
                "click": function click(e) {
                  return _this3.clickCell(e, item);
                },
                "dblclick": function dblclick(e) {
                  return _this3.doubleClickCell(e, item);
                },
                "rightclick": function rightclick(e) {
                  return _this3.rightClickCell(e, item);
                }
              },
              "scopedSlots": _objectSpread$Z({}, _this3.$scopedSlots)
            });
          })]);
        })])]);
      };
      var yearBody = function yearBody() {
        return h("table", {
          "class": "".concat(_this3.componentName, "__table")
        }, [h("tbody", {
          "class": "".concat(_this3.componentName, "__table-body")
        }, [_this3.yearCellsData.map(function (cell, cellIndex) {
          return h("tr", {
            "class": "".concat(_this3.componentName, "__table-body-row")
          }, [cell.map(function (item, itemIndex) {
            return h("calendar-cell-item", {
              "key": "m-".concat(cellIndex, "-").concat(itemIndex),
              "attrs": {
                "item": item,
                "theme": _this3.theme,
                "t": _this3.t,
                "global": _this3.global,
                "cell": _this3.cell,
                "fillWithZero": _this3.fillWithZero
              },
              "on": {
                "click": function click(e) {
                  return _this3.clickCell(e, item);
                },
                "dblclick": function dblclick(e) {
                  return _this3.doubleClickCell(e, item);
                },
                "rightclick": function rightclick(e) {
                  return _this3.rightClickCell(e, item);
                }
              },
              "scopedSlots": _objectSpread$Z({}, _this3.$scopedSlots)
            });
          })]);
        })])]);
      };
      return h("div", {
        "class": calendarCls
      }, [isControllerVisible && this.renderControl(), h("div", {
        "class": calendarPanelCls
      }, [this.curSelectedMode === "month" ? monthBody() : yearBody()])]);
    }
  });

  var Calendar = withInstall$1(_Calendar);

  var props$n = {
    actions: {
      type: [String, Function]
    },
    avatar: {
      type: [String, Function]
    },
    bordered: {
      type: Boolean,
      "default": true
    },
    content: {
      type: [String, Function]
    },
    cover: {
      type: [String, Function]
    },
    "default": {
      type: [String, Function]
    },
    description: {
      type: [String, Function]
    },
    footer: {
      type: [String, Function]
    },
    header: {
      type: [String, Function]
    },
    headerBordered: Boolean,
    hoverShadow: Boolean,
    loading: {
      type: [Boolean, Function],
      "default": false
    },
    loadingProps: {
      type: Object
    },
    shadow: Boolean,
    size: {
      type: String,
      "default": "medium",
      validator: function validator(val) {
        if (!val) return true;
        return ["medium", "small"].includes(val);
      }
    },
    status: {
      type: String,
      "default": ""
    },
    subtitle: {
      type: [String, Function]
    },
    theme: {
      type: String,
      "default": "normal",
      validator: function validator(val) {
        if (!val) return true;
        return ["normal", "poster1", "poster2"].includes(val);
      }
    },
    title: {
      type: [String, Function]
    }
  };

  function ownKeys$Z(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$Y(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$Z(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$Z(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _Card = VueCompositionAPI.defineComponent({
    name: "TCard",
    props: _objectSpread$Y({}, props$n),
    components: {
      TLoading: Loading
    },
    setup: function setup(props2, _ref) {
      var slots = _ref.slots;
      var _useCommonClassName = useCommonClassName(),
        sizeClassNames = _useCommonClassName.sizeClassNames;
      var COMPONENT_NAME = usePrefixClass$1("card");
      var baseCls = VueCompositionAPI.computed(function () {
        var defaultClass = [COMPONENT_NAME.value];
        if (props2.size === "small") defaultClass.push("".concat(sizeClassNames[props2.size]));
        if (props2.bordered) defaultClass.push("".concat(COMPONENT_NAME.value, "--bordered"));
        if (props2.shadow) defaultClass.push("".concat(COMPONENT_NAME.value, "--shadow"));
        if (props2.hoverShadow) defaultClass.push("".concat(COMPONENT_NAME.value, "--shadow-hover"));
        return defaultClass;
      });
      var headerCls = VueCompositionAPI.computed(function () {
        var defaultClass = ["".concat(COMPONENT_NAME.value, "__header")];
        return props2.headerBordered ? defaultClass.concat("".concat(COMPONENT_NAME.value, "__title--bordered")) : ["".concat(COMPONENT_NAME.value, "__header")];
      });
      var headerWrapperCls = usePrefixClass$1("card__header-wrapper");
      var headerAvatarCls = usePrefixClass$1("card__avatar");
      var headerTitleCls = usePrefixClass$1("card__title");
      var headerSubTitleCls = usePrefixClass$1("card__subtitle");
      var headerDescriptionCls = usePrefixClass$1("card__description");
      var actionsCls = usePrefixClass$1("card__actions");
      var bodyCls = usePrefixClass$1("card__body");
      var coverCls = usePrefixClass$1("card__cover");
      var footerCls = usePrefixClass$1("card__footer");
      var footerWrapperCls = usePrefixClass$1("card__footer-wrapper");
      var isPoster2 = VueCompositionAPI.computed(function () {
        return props2.theme === "poster2";
      });
      var showTitle = VueCompositionAPI.computed(function () {
        return props2.title || slots.title;
      });
      var showHeader = VueCompositionAPI.computed(function () {
        return props2.header || slots.header;
      });
      var showSubtitle = VueCompositionAPI.computed(function () {
        return props2.subtitle || slots.subtitle;
      });
      var showAvatar = VueCompositionAPI.computed(function () {
        return props2.avatar || slots.avatar;
      });
      var showDescription = VueCompositionAPI.computed(function () {
        return props2.description || slots.description;
      });
      var showStatus = VueCompositionAPI.computed(function () {
        return props2.status || slots.status;
      });
      var showActions = VueCompositionAPI.computed(function () {
        return props2.actions || slots.actions;
      });
      var showFooter = VueCompositionAPI.computed(function () {
        return props2.footer || slots.footer;
      });
      var showCover = VueCompositionAPI.computed(function () {
        return props2.cover || slots.cover;
      });
      var showLoading = VueCompositionAPI.computed(function () {
        return props2.loading || slots.loading;
      });
      var showContent = VueCompositionAPI.computed(function () {
        return props2.content || slots.content || props2["default"] || slots["default"];
      });
      var isHeaderRender = VueCompositionAPI.computed(function () {
        return showHeader.value || showTitle.value || showSubtitle.value || showDescription.value || showAvatar.value || showStatus.value && isPoster2.value || showActions.value && !isPoster2.value;
      });
      var isFooterRender = VueCompositionAPI.computed(function () {
        return showFooter.value || showActions.value && isPoster2.value;
      });
      return {
        isHeaderRender: isHeaderRender,
        isFooterRender: isFooterRender,
        isPoster2: isPoster2,
        showLoading: showLoading,
        showHeader: showHeader,
        showTitle: showTitle,
        showSubtitle: showSubtitle,
        showDescription: showDescription,
        showAvatar: showAvatar,
        showActions: showActions,
        showStatus: showStatus,
        showContent: showContent,
        showCover: showCover,
        showFooter: showFooter,
        baseCls: baseCls,
        bodyCls: bodyCls,
        footerCls: footerCls,
        footerWrapperCls: footerWrapperCls,
        coverCls: coverCls,
        actionsCls: actionsCls,
        headerCls: headerCls,
        headerWrapperCls: headerWrapperCls,
        headerAvatarCls: headerAvatarCls,
        headerTitleCls: headerTitleCls,
        headerSubTitleCls: headerSubTitleCls,
        headerDescriptionCls: headerDescriptionCls,
        COMPONENT_NAME: COMPONENT_NAME
      };
    },
    methods: {
      renderLoading: function renderLoading() {},
      renderCover: function renderCover() {
        var h = this.$createElement;
        var textCover = typeof this.cover === "string";
        return h("div", {
          "class": this.coverCls
        }, [textCover ? h("img", {
          "attrs": {
            "src": this.cover
          }
        }) : renderTNodeJSX(this, "cover")]);
      },
      renderHeader: function renderHeader() {
        var h = this.$createElement;
        if (this.showHeader) return h("div", {
          "class": this.headerCls
        }, [renderTNodeJSX(this, "header")]);
        return h("div", {
          "class": this.headerCls
        }, [h("div", {
          "class": this.headerWrapperCls
        }, [this.showAvatar && h("div", {
          "class": this.headerAvatarCls
        }, [renderTNodeJSX(this, "avatar")]), h("div", [this.showTitle && h("div", {
          "class": this.headerTitleCls
        }, [renderTNodeJSX(this, "title")]), this.showSubtitle && h("div", {
          "class": this.headerSubTitleCls
        }, [renderTNodeJSX(this, "subtitle")]), this.showDescription && h("p", {
          "class": this.headerDescriptionCls
        }, [renderTNodeJSX(this, "description")])])]), this.showActions && !this.isPoster2 && h("div", {
          "class": this.actionsCls
        }, [renderTNodeJSX(this, "actions")]), this.showStatus && h("div", {
          "class": this.actionsCls
        }, [renderTNodeJSX(this, "status")])]);
      }
    },
    render: function render() {
      var h = arguments[0];
      var content = h("div", {
        "class": this.baseCls
      }, [this.isHeaderRender ? this.renderHeader() : null, this.showCover ? this.renderCover() : null, this.showContent && h("div", {
        "class": this.bodyCls
      }, [renderContent(this, "default", "content")]), this.isFooterRender && h("div", {
        "class": this.footerCls
      }, [h("div", {
        "class": this.footerWrapperCls
      }, [renderTNodeJSX(this, "footer")]), this.showActions && this.isPoster2 && h("div", {
        "class": this.actionsCls
      }, [renderTNodeJSX(this, "actions")])])]);
      if (this.loading) {
        return renderTNodeJSX(this, "loading", {
          defaultNode: h("t-loading", helper([{}, {
            "props": this.loadingProps
          }]), [content])
        });
      }
      return content;
    }
  });

  var Card = withInstall$1(_Card);

  var props$m = {
    actions: {
      type: Array
    },
    author: {
      type: [String, Function]
    },
    avatar: {
      type: [String, Object, Function]
    },
    content: {
      type: [String, Function]
    },
    datetime: {
      type: [String, Function]
    },
    quote: {
      type: [String, Function]
    },
    reply: {
      type: [String, Function]
    }
  };

  var classPrefixMixins$7 = getClassPrefixMixins("comment");
  var _Comment = mixins(classPrefixMixins$7).extend({
    name: "TComment",
    props: props$m,
    methods: {
      renderReply: function renderReply() {
        var h = this.$createElement;
        var reply = renderTNodeJSX(this, "reply");
        return reply ? h("div", {
          "class": "".concat(this.componentName, "__reply")
        }, [reply]) : null;
      },
      renderActions: function renderActions() {
        var h = this.$createElement;
        var actions = renderTNodeJSX(this, "actions");
        return actions && actions.length ? h("div", {
          "class": "".concat(this.componentName, "__actions")
        }, [actions.map(function (action, index) {
          return h(Button, {
            "key": "action-".concat(index),
            "attrs": {
              "size": "small",
              "variant": "text"
            }
          }, [action]);
        })]) : null;
      },
      renderQuote: function renderQuote() {
        var h = this.$createElement;
        var quote = renderTNodeJSX(this, "quote");
        return quote ? h("div", {
          "class": "".concat(this.componentName, "__quote")
        }, [quote]) : null;
      },
      renderAuthorDatetime: function renderAuthorDatetime() {
        var h = this.$createElement;
        var author = renderTNodeJSX(this, "author");
        var datetime = renderTNodeJSX(this, "datetime");
        return (author || datetime) && h("div", {
          "class": "".concat(this.componentName, "__author")
        }, [author && h("span", {
          "class": "".concat(this.componentName, "__name")
        }, [author]), datetime && h("span", {
          "class": "".concat(this.componentName, "__time")
        }, [datetime])]);
      },
      renderContent: function renderContent() {
        var h = this.$createElement;
        return h("div", {
          "class": "".concat(this.componentName, "__content")
        }, [this.renderAuthorDatetime(), h("div", {
          "class": "".concat(this.componentName, "__detail")
        }, [renderTNodeJSX(this, "content")]), this.renderQuote(), this.renderActions()]);
      },
      renderAvatar: function renderAvatar() {
        var h = this.$createElement;
        var avatar = renderTNodeJSX(this, "avatar");
        return avatar ? h("div", {
          "class": "".concat(this.componentName, "__avatar")
        }, [typeof avatar === "string" ? h("img", {
          "attrs": {
            "src": avatar,
            "alt": ""
          },
          "class": "".concat(this.componentName, "__avatar-image")
        }) : avatar]) : null;
      }
    },
    render: function render() {
      var h = arguments[0];
      return h("div", {
        "class": this.componentName
      }, [h("div", {
        "class": "".concat(this.componentName, "__inner")
      }, [this.renderAvatar(), this.renderContent()]), this.renderReply()]);
    }
  });

  var Comment = withInstall$1(_Comment);

  var props$l = {
    bordered: Boolean,
    colon: Boolean,
    column: {
      type: Number,
      "default": 2
    },
    contentStyle: {
      type: Object
    },
    itemLayout: {
      type: String,
      "default": "horizontal",
      validator: function validator(val) {
        if (!val) return true;
        return ["horizontal", "vertical"].includes(val);
      }
    },
    items: {
      type: Array
    },
    labelStyle: {
      type: Object
    },
    layout: {
      type: String,
      "default": "horizontal",
      validator: function validator(val) {
        if (!val) return true;
        return ["horizontal", "vertical"].includes(val);
      }
    },
    size: {
      type: String,
      "default": "medium",
      validator: function validator(val) {
        if (!val) return true;
        return ["small", "medium", "large"].includes(val);
      }
    },
    title: {
      type: [String, Function]
    }
  };

  var descriptionsKey = Symbol("TDescriptions");

  var ItemsType = /* @__PURE__ */function (ItemsType2) {
    ItemsType2["props"] = "props";
    ItemsType2["slots"] = "slots";
    return ItemsType2;
  }(ItemsType || {});

  function renderCustomNode(node) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (isString(node)) {
      return node;
    }
    if (isFunction(node)) {
      return node(VueCompositionAPI.h, params);
    }
    if (isFunction(node.render)) {
      return VueCompositionAPI.h(node);
    }
    return node;
  }
  function renderVNodeTNode(node, name1, name2) {
    var _node$componentOption, _node$data$scopedSlot, _node$data$scopedSlot2, _node$data$scopedSlot3, _node$data$scopedSlot4;
    var prop = (_node$componentOption = node.componentOptions.propsData) === null || _node$componentOption === void 0 ? void 0 : _node$componentOption[name1];
    if (prop) return prop;
    var slot = ((_node$data$scopedSlot = node.data.scopedSlots) === null || _node$data$scopedSlot === void 0 || (_node$data$scopedSlot2 = _node$data$scopedSlot[name1]) === null || _node$data$scopedSlot2 === void 0 ? void 0 : _node$data$scopedSlot2.call(_node$data$scopedSlot)) || ((_node$data$scopedSlot3 = node.data.scopedSlots) === null || _node$data$scopedSlot3 === void 0 || (_node$data$scopedSlot4 = _node$data$scopedSlot3[name2]) === null || _node$data$scopedSlot4 === void 0 ? void 0 : _node$data$scopedSlot4.call(_node$data$scopedSlot3));
    if (slot) return slot;
    return node.componentOptions.children;
  }
  function itemTypeIsProps(itemsType, item) {
    return itemsType === ItemsType.props;
  }

  var DescriptionsBody = VueCompositionAPI.defineComponent({
    name: "TDescriptionsBody",
    props: {
      rows: Array,
      itemType: String
    },
    setup: function setup() {
      var descriptionsProps = VueCompositionAPI.inject(descriptionsKey);
      var COMPONENT_NAME = usePrefixClass("descriptions");
      var _useCommonClassName = useCommonClassName$1(),
        SIZE = _useCommonClassName.SIZE;
      var _useConfig = useConfig("descriptions"),
        global = _useConfig.global;
      return {
        descriptionsProps: descriptionsProps,
        COMPONENT_NAME: COMPONENT_NAME,
        SIZE: SIZE,
        global: global
      };
    },
    render: function render() {
      var _this = this;
      var h = arguments[0];
      var props = this.$props;
      var label = function label(node) {
        var layout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "horizontal";
        var labelClass = ["".concat(_this.COMPONENT_NAME, "__label")];
        var label2 = null;
        var span = null;
        if (itemTypeIsProps(props.itemType)) {
          label2 = node.label;
          span = node.span;
        } else {
          label2 = renderVNodeTNode(node, "label");
          var propsData = node.componentOptions.propsData || {};
          span = propsData.span;
        }
        var labelSpan = layout === "horizontal" ? 1 : span;
        return h("td", helper([{
          "attrs": {
            "colspan": labelSpan
          },
          "class": labelClass
        }, {
          style: _this.descriptionsProps.labelStyle
        }]), [label2, _this.descriptionsProps.colon && _this.global.colonText]);
      };
      var content = function content(node) {
        var layout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "horizontal";
        var contentClass = ["".concat(_this.COMPONENT_NAME, "__content")];
        var content2 = null;
        var span = null;
        if (itemTypeIsProps(props.itemType)) {
          content2 = node.content;
          span = node.span;
        } else {
          content2 = renderVNodeTNode(node, "content", "default");
          var propsData = node.componentOptions.propsData || {};
          span = propsData.span;
        }
        var contentSpan = span > 1 && layout === "horizontal" ? span * 2 - 1 : span;
        return h("td", helper([{
          "attrs": {
            "colspan": contentSpan
          },
          "class": contentClass
        }, {
          style: _this.descriptionsProps.contentStyle
        }]), [content2]);
      };
      var hh = function hh(row) {
        return h("tr", [row.map(function (node) {
          return [label(node), content(node)];
        })]);
      };
      var hv = function hv(row) {
        return [h("tr", [row.map(function (node) {
          return label(node, "vertical");
        })]), h("tr", [row.map(function (node) {
          return content(node, "vertical");
        })])];
      };
      var vh = function vh(row) {
        return row.map(function (node) {
          return h("tr", [label(node), content(node)]);
        });
      };
      var vv = function vv(row) {
        return row.map(function (node) {
          return [h("tr", [label(node)]), h("tr", [content(node)])];
        });
      };
      var renderRow = function renderRow(row) {
        if (_this.descriptionsProps.layout === "horizontal") {
          if (_this.descriptionsProps.itemLayout === "horizontal") {
            return hh(row);
          }
          return hv(row);
        }
        if (_this.descriptionsProps.itemLayout === "horizontal") {
          return vh(row);
        }
        return vv(row);
      };
      var tableClass = ["".concat(this.COMPONENT_NAME, "__body"), this.SIZE[this.descriptionsProps.size], _defineProperty$2({}, "".concat(this.COMPONENT_NAME, "__body--border"), this.descriptionsProps.bordered)];
      return h("table", {
        "class": tableClass
      }, [h("tbody", [props.rows.map(function (row) {
        return renderRow(row);
      })])]);
    }
  });

  function ownKeys$Y(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$X(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$Y(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$Y(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _Descriptions = VueCompositionAPI.defineComponent({
    name: "TDescriptions",
    props: props$l,
    setup: function setup(props2) {
      var COMPONENT_NAME = usePrefixClass("descriptions");
      var getChildByName = useChildComponentSlots();
      var itemsType = VueCompositionAPI.ref(ItemsType.props);
      var renderTNodeJSX = useTNodeJSX();
      var renderTitle = renderTNodeJSX("title");
      var getRows = function getRows() {
        var column = props2.column,
          layout = props2.layout;
        var items = [];
        if (isArray$1(props2.items)) {
          items = props2.items.map(function (item) {
            return {
              label: renderCustomNode(item.label),
              content: renderCustomNode(item.content),
              span: item.span || 1
            };
          });
          itemsType.value = ItemsType.props;
        } else {
          var slots = getChildByName("TDescriptionsItem");
          if (slots.length !== 0) {
            items = slots;
            itemsType.value = ItemsType.slots;
          }
        }
        if (layout === "vertical") {
          return [items];
        }
        var temp = [];
        var reset = column;
        var res = [];
        items.forEach(function (item, index) {
          var span = 1;
          if (itemTypeIsProps(itemsType.value)) {
            span = isNil(item.span) ? span : item.span;
          } else {
            var propsData = item.componentOptions.propsData || {};
            span = isNil(propsData === null || propsData === void 0 ? void 0 : propsData.span) ? span : propsData.span;
            propsData.span = span;
            Object.assign(item.componentOptions, _objectSpread$X(_objectSpread$X({}, item.componentOptions), {}, {
              propsData: propsData
            }));
          }
          if (reset >= span) {
            temp.push(item);
            reset -= span;
          } else {
            res.push(temp);
            temp = [item];
            reset = column - span;
          }
          if (index === items.length - 1) {
            if (itemTypeIsProps(itemsType.value)) {
              Object.assign(item, {
                span: item.span + reset
              });
            } else {
              var _propsData = item.componentOptions.propsData || {};
              _propsData.span += reset;
              Object.assign(item.componentOptions, _objectSpread$X(_objectSpread$X({}, item.componentOptions), {}, {
                propsData: _propsData
              }));
            }
            res.push(temp);
          }
        });
        return res;
      };
      VueCompositionAPI.provide(descriptionsKey, props2);
      return {
        renderTitle: renderTitle,
        getRows: getRows,
        itemsType: itemsType,
        COMPONENT_NAME: COMPONENT_NAME
      };
    },
    render: function render() {
      var _this = this;
      var h = arguments[0];
      var renderHeader = function renderHeader() {
        return _this.renderTitle ? h("div", {
          "class": "".concat(_this.COMPONENT_NAME, "__header")
        }, [_this.renderTitle]) : "";
      };
      return h("div", {
        "class": this.COMPONENT_NAME
      }, [renderHeader(), h(DescriptionsBody, {
        "attrs": {
          "item-type": this.itemsType,
          "rows": this.getRows()
        }
      })]);
    }
  });

  var props$k = {
    content: {
      type: [String, Function]
    },
    "default": {
      type: [String, Function]
    },
    label: {
      type: [String, Function]
    },
    span: {
      type: Number,
      "default": 1
    }
  };

  var _DescriptionsItem = VueCompositionAPI.defineComponent({
    name: "TDescriptionsItem",
    props: props$k
  });

  var Descriptions = withInstall$1(_Descriptions);
  var DescriptionsItem = withInstall$1(_DescriptionsItem);

  var props$j = {
    action: {
      type: Function
    },
    description: {
      type: [String, Function]
    },
    image: {
      type: [String, Function]
    },
    imageStyle: {
      type: Object
    },
    size: {
      type: String,
      "default": "medium",
      validator: function validator(val) {
        if (!val) return true;
        return ["small", "medium", "large"].includes(val);
      }
    },
    title: {
      type: [String, Function]
    },
    type: {
      type: String,
      "default": "empty",
      validator: function validator(val) {
        if (!val) return true;
        return ["empty", "success", "fail", "network-error", "maintenance"].includes(val);
      }
    }
  };

  var MaintenanceSvg = VueCompositionAPI.defineComponent({
    name: "MaintenanceSvg",
    render: function render() {
      var h = arguments[0];
      return h("svg", {
        "attrs": {
          "width": "1em",
          "height": "1em",
          "viewBox": "0 0 48 48",
          "fill": "none",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [h("g", {
        "attrs": {
          "id": "\xE8\xB7\xAF\xE5\x86\xB5\xE4\xBA\x8B\xE4\xBB\xB6-traffic-events"
        }
      }, [h("g", {
        "attrs": {
          "id": "Subtract"
        }
      }, [h("path", {
        "attrs": {
          "d": "M29.5237 17L24 3.82812L18.4763 17H29.5237Z",
          "fill": "var(--td-text-color-placeholder)"
        }
      }), h("path", {
        "attrs": {
          "d": "M31.2011 21H16.7989L13.6699 28.4615H34.3301L31.2011 21Z",
          "fill": "var(--td-text-color-placeholder)"
        }
      }), h("path", {
        "attrs": {
          "d": "M36.0076 32.4615H11.9924L9.66997 37.9997H6V41.9997H42V37.9997H38.33L36.0076 32.4615Z",
          "fill": "var(--td-text-color-placeholder)"
        }
      })])])]);
    }
  });

  var NetworkErrorSvg = VueCompositionAPI.defineComponent({
    name: "NetworkErrorSvg",
    render: function render() {
      var h = arguments[0];
      return h("svg", {
        "attrs": {
          "width": "1em",
          "height": "1em",
          "viewBox": "0 0 48 48",
          "fill": "none",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [h("g", {
        "attrs": {
          "id": "\xE6\x97\xA0\xE7\xBD\x91\xE7\xBB\x9C-no-network"
        }
      }, [h("g", {
        "attrs": {
          "id": "Union"
        }
      }, [h("path", {
        "attrs": {
          "d": "M26 17V2H22V17H26Z",
          "fill": "var(--td-text-color-placeholder)"
        }
      }), h("path", {
        "attrs": {
          "d": "M26.0078 20H22V24.0078H26.0078V20Z",
          "fill": "var(--td-text-color-placeholder)"
        }
      }), h("path", {
        "attrs": {
          "d": "M2.75751 13.45C7.29713 9.80916 12.553 7.50276 18 6.53088V28H30V6.53052C35.4475 7.50216 40.7038 9.80854 45.2438 13.4497L46.8021 14.6995L24.0006 43.2016L1.19922 14.6998L2.75751 13.45Z",
          "fill": "var(--td-text-color-placeholder)"
        }
      })])])]);
    }
  });

  var EmptySvg = VueCompositionAPI.defineComponent({
    name: "EmptySvg",
    render: function render() {
      var h = arguments[0];
      return h("svg", {
        "attrs": {
          "width": "1em",
          "height": "1em",
          "viewBox": "0 0 48 48",
          "fill": "none",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [h("g", {
        "attrs": {
          "id": "\xE6\x97\xA0\xE7\xBB\x93\xE6\x9E\x9C-no-result"
        }
      }, [h("g", {
        "attrs": {
          "id": "Union"
        }
      }, [h("path", {
        "attrs": {
          "d": "M22 0H26V8H22V0Z",
          "fill": "var(--td-text-color-placeholder)"
        }
      }), h("path", {
        "attrs": {
          "d": "M10.002 1.17157L7.17353 4L13.002 9.82843L15.8304 7L10.002 1.17157Z",
          "fill": "var(--td-text-color-placeholder)"
        }
      }), h("path", {
        "attrs": {
          "fillRule": "evenodd",
          "clipRule": "evenodd",
          "d": "M2 27.4689L10.8394 12H37.1606L46 27.4689V44H2V27.4689ZM13.1606 16L7.44636 26H17.8025L18.1889 27.5015C18.8551 30.0898 21.207 32 24 32C26.793 32 29.1449 30.0898 29.8111 27.5015L30.1975 26H40.5536L34.8394 16H13.1606Z",
          "fill": "var(--td-text-color-placeholder)"
        }
      }), h("path", {
        "attrs": {
          "d": "M37.998 1.17157L32.1696 7L34.998 9.82843L40.8265 4L37.998 1.17157Z",
          "fill": "var(--td-text-color-placeholder)"
        }
      })])])]);
    }
  });

  var FailSvg = VueCompositionAPI.defineComponent({
    name: "FailSvg",
    render: function render() {
      var h = arguments[0];
      return h("svg", {
        "attrs": {
          "width": "1em",
          "height": "1em",
          "viewBox": "0 0 48 48",
          "fill": "none",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [h("path", {
        "attrs": {
          "fillRule": "evenodd",
          "clipRule": "evenodd",
          "d": "M24 6C14.0589 6 6 14.0589 6 24C6 33.9411 14.0589 42 24 42C33.9411 42 42 33.9411 42 24C42 14.0589 33.9411 6 24 6ZM2 24C2 11.8497 11.8497 2 24 2C36.1503 2 46 11.8497 46 24C46 36.1503 36.1503 46 24 46C11.8497 46 2 36.1503 2 24ZM26 13V28H22V13H26ZM22 31H26.0078V35.0078H22V31Z",
          "fill": "#D54941"
        }
      })]);
    }
  });

  var SuccessSvg = VueCompositionAPI.defineComponent({
    name: "SuccessSvg",
    render: function render() {
      var h = arguments[0];
      return h("svg", {
        "attrs": {
          "width": "1em",
          "height": "1em",
          "viewBox": "0 0 48 48",
          "fill": "none",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [h("path", {
        "attrs": {
          "fillRule": "evenodd",
          "clipRule": "evenodd",
          "d": "M24 42C33.9411 42 42 33.9411 42 24C42 14.0589 33.9411 6 24 6C14.0589 6 6 14.0589 6 24C6 33.9411 14.0589 42 24 42ZM46 24C46 36.1503 36.1503 46 24 46C11.8497 46 2 36.1503 2 24C2 11.8497 11.8497 2 24 2C36.1503 2 46 11.8497 46 24ZM21 32.8284L12.1716 24L15 21.1716L21 27.1716L33 15.1716L35.8284 18L21 32.8284Z",
          "fill": "#2BA471"
        }
      })]);
    }
  });

  var _Empty = VueCompositionAPI.defineComponent({
    name: "TEmpty",
    components: {
      TImage: Image$1
    },
    props: props$j,
    setup: function setup(props2, _ref) {
      var slots = _ref.slots;
      var _toRefs = VueCompositionAPI.toRefs(props2),
        size = _toRefs.size,
        propsImage = _toRefs.image,
        propsDescription = _toRefs.description,
        propsTitle = _toRefs.title,
        type = _toRefs.type;
      var _useConfig = useConfig("empty"),
        globalConfig = _useConfig.globalConfig;
      var componentName = usePrefixClass$1("empty");
      var showAction = VueCompositionAPI.computed(function () {
        return props2.action || slots.action;
      });
      var _useCommonClassName = useCommonClassName$1(),
        SIZE = _useCommonClassName.SIZE;
      var defaultMaps = {
        maintenance: {
          image: globalConfig.value.image.maintenance || MaintenanceSvg,
          title: globalConfig.value.titleText.maintenance
        },
        success: {
          image: globalConfig.value.image.success || SuccessSvg,
          title: globalConfig.value.titleText.success
        },
        fail: {
          image: globalConfig.value.image.fail || FailSvg,
          title: globalConfig.value.titleText.fail
        },
        "network-error": {
          image: globalConfig.value.image.networkError || NetworkErrorSvg,
          title: globalConfig.value.titleText.networkError
        },
        empty: {
          image: globalConfig.value.image.empty || EmptySvg,
          title: globalConfig.value.titleText.empty
        }
      };
      var emptyClasses = VueCompositionAPI.computed(function () {
        return [componentName.value, SIZE.value[size.value]];
      });
      var titleClasses = ["".concat(componentName.value, "__title")];
      var imageClasses = ["".concat(componentName.value, "__image")];
      var descriptionClasses = ["".concat(componentName.value, "__description")];
      var actionClass = ["".concat(componentName.value, "__action")];
      var typeImageProps = VueCompositionAPI.computed(function () {
        var _defaultMaps$type$val;
        return (_defaultMaps$type$val = defaultMaps[type.value]) !== null && _defaultMaps$type$val !== void 0 ? _defaultMaps$type$val : null;
      });
      var showImage = VueCompositionAPI.computed(function () {
        var _typeImageProps$value;
        return propsImage.value || slots.image || ((_typeImageProps$value = typeImageProps.value) === null || _typeImageProps$value === void 0 ? void 0 : _typeImageProps$value.image);
      });
      var showTitle = VueCompositionAPI.computed(function () {
        var _typeImageProps$value2;
        return propsTitle.value || slots.title || ((_typeImageProps$value2 = typeImageProps.value) === null || _typeImageProps$value2 === void 0 ? void 0 : _typeImageProps$value2.title);
      });
      var showDescription = VueCompositionAPI.computed(function () {
        return propsDescription.value || slots.description;
      });
      return {
        emptyClasses: emptyClasses,
        imageClasses: imageClasses,
        titleClasses: titleClasses,
        descriptionClasses: descriptionClasses,
        actionClass: actionClass,
        showImage: showImage,
        showTitle: showTitle,
        showDescription: showDescription,
        showAction: showAction
      };
    },
    methods: {
      renderTitle: function renderTitle() {
        var h = this.$createElement;
        if (!this.showTitle) {
          return null;
        }
        return h("div", {
          "class": this.titleClasses
        }, [this.showTitle]);
      },
      renderDescription: function renderDescription() {
        var h = this.$createElement;
        if (!this.showDescription) {
          return null;
        }
        return h("div", {
          "class": this.descriptionClasses
        }, [this.showDescription]);
      },
      getImageIns: function getImageIns() {
        var h = this.$createElement;
        var data = this.showImage;
        var result = null;
        if (isString(data)) {
          result = h(Image$1, {
            "attrs": {
              "src": data
            }
          });
        } else if (data && Reflect.has(data, "render")) {
          result = h(data);
        } else if (isPlainObject(data)) {
          result = h(Image$1, helper([{}, data]));
        }
        return data ? result : null;
      }
    },
    render: function render() {
      var h = arguments[0];
      return h("div", {
        "class": this.emptyClasses
      }, [this.showImage ? h("div", {
        "class": this.imageClasses,
        "style": this.imageStyle
      }, [this.$slots.image ? renderTNodeJSX(this, "image") : this.getImageIns()]) : null, this.renderTitle(), this.renderDescription(), this.showAction ? h("div", {
        "class": this.actionClass
      }, [renderTNodeJSX(this, "action")]) : null]);
    }
  });

  var Empty = withInstall$1(_Empty);

  var props$i = {
    closeBtn: {
      type: [Boolean, Function],
      "default": true
    },
    closeOnEscKeydown: {
      type: Boolean,
      "default": true
    },
    closeOnOverlay: Boolean,
    draggable: {
      type: Boolean,
      "default": void 0
    },
    imageScale: {
      type: Object
    },
    images: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    index: {
      type: Number,
      "default": void 0
    },
    defaultIndex: {
      type: Number,
      "default": 0
    },
    mode: {
      type: String,
      "default": "modal",
      validator: function validator(val) {
        if (!val) return true;
        return ["modal", "modeless"].includes(val);
      }
    },
    navigationArrow: {
      type: [Boolean, Function],
      "default": true
    },
    showOverlay: {
      type: Boolean,
      "default": void 0
    },
    title: {
      type: [String, Function]
    },
    trigger: {
      type: [String, Function]
    },
    viewerScale: {
      type: Object
    },
    visible: {
      type: Boolean,
      "default": void 0
    },
    defaultVisible: Boolean,
    zIndex: {
      type: Number
    },
    onClose: Function,
    onIndexChange: Function
  };

  var Container = Vue__default["default"].extend({
    props: {
      mode: props$i.mode,
      renderModal: Function,
      renderViewer: Function
    },
    data: function data() {
      return {
        content: null,
        timer: null
      };
    },
    methods: {
      mountContent: function mountContent() {
        clearTimeout(this.timer);
        if (this.content) return;
        var _this = this;
        var elm = document.createElement("div");
        elm.style.cssText = "position: absolute; top: 0px; left: 0px; width: 100%";
        this.content = new this.$root.constructor({
          render: function render() {
            return _this.mode === "modeless" ? _this.renderModal() : _this.renderViewer();
          },
          destroyed: function destroyed() {
            if (_this.content.$el) {
              removeDom(_this.content.$el);
            }
            _this.content = null;
          }
        });
        getAttach(document.body).appendChild(elm);
        this.content.$mount(elm);
      },
      unmountContent: function unmountContent() {
        var _this2 = this;
        clearTimeout(this.timer);
        this.timer = setTimeout(function () {
          var _this2$content, _this2$content$$destr;
          (_this2$content = _this2.content) === null || _this2$content === void 0 || (_this2$content$$destr = _this2$content.$destroy) === null || _this2$content$$destr === void 0 || _this2$content$$destr.call(_this2$content);
        }, 200);
      }
    },
    render: function render() {
      var _children$;
      var h = arguments[0];
      var children = this.$slots["default"] || [];
      if (children.length > 1 || !((_children$ = children[0]) !== null && _children$ !== void 0 && _children$.tag)) {
        return h("span", [children]);
      }
      return children[0];
    }
  });

  var propHandler = {
    type: Function,
    "default": function _default() {
      return function () {};
    }
  };
  var TImageViewerIcon = VueCompositionAPI.defineComponent({
    name: "TImageModalIcon",
    props: {
      disabled: Boolean,
      clickHandler: propHandler,
      label: String,
      icon: Function
    },
    setup: function setup(props) {
      var classPrefix = usePrefixClass();
      var renderTNodeJSX = useTNodeJSX();
      var wrapClass = VueCompositionAPI.computed(function () {
        return ["".concat(classPrefix.value, "-image-viewer__modal-icon"), _defineProperty$2({}, "".concat(classPrefix.value, "-is-disabled"), props.disabled)];
      });
      return {
        wrapClass: wrapClass,
        classPrefix: classPrefix,
        renderTNodeJSX: renderTNodeJSX
      };
    },
    render: function render() {
      var h = arguments[0];
      return h("div", {
        "class": this.wrapClass,
        "on": {
          "click": this.clickHandler
        }
      }, [this.renderTNodeJSX("icon"), this.label && h("span", {
        "class": "".concat(this.classPrefix, "-image-viewer__modal-icon-label")
      }, [this.label])]);
    }
  });

  function ownKeys$X(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$W(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$X(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$X(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var downloadFile = function downloadFile(imgSrc) {
    var _imgSrc$split;
    var image = new Image();
    var name = (imgSrc === null || imgSrc === void 0 || (_imgSrc$split = imgSrc.split) === null || _imgSrc$split === void 0 ? void 0 : _imgSrc$split.call(imgSrc, "/").pop()) || Math.random().toString(32).slice(2);
    image.setAttribute("crossOrigin", "anonymous");
    image.onload = function () {
      var canvas = document.createElement("canvas");
      canvas.width = image.width;
      canvas.height = image.height;
      var context = canvas.getContext("2d");
      context.drawImage(image, 0, 0, image.width, image.height);
      canvas.toBlob(function (blob) {
        var url = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.download = name;
        a.href = url;
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      });
    };
    image.src = imgSrc;
  };
  var isImageInfo = function isImageInfo(image) {
    return !!image && typeof image !== "string" && !(image instanceof File);
  };
  var formatImages = function formatImages(images) {
    if (!Array.isArray(images)) return [];
    return images.map(function (item) {
      if (isImageInfo(item)) {
        return _objectSpread$W({
          download: true,
          thumbnail: item.mainImage
        }, item);
      }
      return {
        mainImage: item,
        thumbnail: item,
        download: true
      };
    });
  };
  var getOverlay = function getOverlay(props) {
    if (props.showOverlay !== void 0) {
      return props.showOverlay;
    }
    return props.mode === "modal";
  };

  var currentImage = {
    type: Object,
    "default": function _default() {
      return {};
    }
  };
  var TImageViewerUtils = VueCompositionAPI.defineComponent({
    name: "TImageViewerUtils",
    props: {
      scale: Number,
      rotateHandler: Function,
      zoomInHandler: Function,
      zoomOutHandler: Function,
      mirrorHandler: Function,
      resetHandler: Function,
      currentImage: currentImage
    },
    setup: function setup(props) {
      var _useConfig = useConfig("imageViewer"),
        classPrefix = _useConfig.classPrefix,
        globalConfig = _useConfig.global;
      var imageUrl = VueCompositionAPI.computed(function () {
        return props.currentImage.mainImage;
      });
      var _useImagePreviewUrl = useImagePreviewUrl(imageUrl),
        previewUrl = _useImagePreviewUrl.previewUrl;
      return {
        classPrefix: classPrefix,
        globalConfig: globalConfig,
        previewUrl: previewUrl
      };
    },
    render: function render() {
      var _this = this;
      var h = arguments[0];
      return h("div", {
        "class": "".concat(this.classPrefix, "-image-viewer__utils")
      }, [h("div", {
        "class": "".concat(this.classPrefix, "-image-viewer__utils-content")
      }, [h(Tooltip, {
        "attrs": {
          "overlayClassName": "".concat(this.classPrefix, "-image-viewer__utils--tip"),
          "content": this.globalConfig.mirrorTipText,
          "destroyOnClose": true,
          "placement": "top",
          "showArrow": true,
          "theme": "default"
        }
      }, [h(TImageViewerIcon, {
        "attrs": {
          "clickHandler": this.mirrorHandler,
          "icon": function icon() {
            return h(MirrorIcon, {
              "attrs": {
                "size": "medium"
              }
            });
          }
        }
      })]), h(Tooltip, {
        "attrs": {
          "overlayClassName": "".concat(this.classPrefix, "-image-viewer__utils--tip"),
          "content": this.globalConfig.rotateTipText,
          "destroyOnClose": true,
          "placement": "top",
          "showArrow": true,
          "theme": "default"
        }
      }, [h(TImageViewerIcon, {
        "attrs": {
          "clickHandler": this.rotateHandler,
          "icon": function icon() {
            return h(RotationIcon, {
              "attrs": {
                "size": "medium"
              }
            });
          }
        }
      })]), h(TImageViewerIcon, {
        "attrs": {
          "icon": function icon() {
            return h(ZoomOutIcon, {
              "attrs": {
                "size": "medium"
              }
            });
          },
          "clickHandler": this.zoomOutHandler
        }
      }), h(TImageViewerIcon, {
        "class": "".concat(this.classPrefix, "-image-viewer__utils-scale"),
        "attrs": {
          "size": "medium",
          "label": "".concat(this.scale * 100, "%")
        }
      }), h(TImageViewerIcon, {
        "attrs": {
          "icon": function icon() {
            return h(ZoomInIcon, {
              "attrs": {
                "size": "medium"
              }
            });
          },
          "clickHandler": this.zoomInHandler
        }
      }), h(Tooltip, {
        "attrs": {
          "overlayClassName": "".concat(this.classPrefix, "-image-viewer__utils--tip"),
          "content": this.globalConfig.originalSizeTipText,
          "destroyOnClose": true,
          "placement": "top",
          "showArrow": true,
          "theme": "default"
        }
      }, [h("div", {
        "class": "".concat(this.classPrefix, "-image-viewer__modal-icon")
      }, [h(TImageViewerIcon, {
        "attrs": {
          "icon": function icon() {
            return h(ImageIcon, {
              "attrs": {
                "size": "medium"
              }
            });
          },
          "clickHandler": this.resetHandler
        }
      })])]), this.currentImage.download && h(TImageViewerIcon, {
        "attrs": {
          "icon": function icon() {
            return h(DownloadIcon, {
              "attrs": {
                "size": "medium"
              }
            });
          },
          "clickHandler": function clickHandler() {
            downloadFile(_this.previewUrl);
          }
        }
      })])]);
    }
  });

  var EVENT_CODE = /* @__PURE__ */function (EVENT_CODE2) {
    EVENT_CODE2["left"] = "ArrowLeft";
    EVENT_CODE2["up"] = "ArrowUp";
    EVENT_CODE2["right"] = "ArrowRight";
    EVENT_CODE2["down"] = "ArrowDown";
    EVENT_CODE2["esc"] = "Escape";
    return EVENT_CODE2;
  }(EVENT_CODE || {});
  var DEFAULT_IMAGE_SCALE = {
    max: 2,
    min: 0.5,
    step: 0.5,
    defaultScale: 1
  };

  function ownKeys$W(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$V(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$W(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$W(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function useDrag$1(initTransform) {
    var transform = VueCompositionAPI.ref(initTransform);
    var mouseDownHandler = function mouseDownHandler(e) {
      var startX = e.pageX,
        startY = e.pageY;
      var _transform$value = transform.value,
        translateX = _transform$value.translateX,
        translateY = _transform$value.translateY;
      var mouseMoveHandler = function mouseMoveHandler(e2) {
        var pageX = e2.pageX,
          pageY = e2.pageY;
        transform.value = {
          translateX: translateX + pageX - startX,
          translateY: translateY + pageY - startY
        };
      };
      var _mouseUpHandler = function mouseUpHandler() {
        document.removeEventListener("mousemove", mouseMoveHandler);
        document.removeEventListener("mouseup", _mouseUpHandler);
      };
      document.addEventListener("mousemove", mouseMoveHandler);
      document.addEventListener("mouseup", _mouseUpHandler);
    };
    var resetTransform = function resetTransform() {
      transform.value = _objectSpread$V({}, initTransform);
    };
    return {
      transform: transform,
      mouseDownHandler: mouseDownHandler,
      resetTransform: resetTransform
    };
  }
  function useMirror() {
    var mirror = VueCompositionAPI.ref(1);
    var onMirror = function onMirror() {
      mirror.value *= -1;
    };
    var resetMirror = function resetMirror() {
      mirror.value = 1;
    };
    return {
      mirror: mirror,
      onMirror: onMirror,
      resetMirror: resetMirror
    };
  }
  function useScale(imageScale) {
    var _imageScale$value = imageScale.value,
      _imageScale$value$max = _imageScale$value.max,
      max = _imageScale$value$max === void 0 ? DEFAULT_IMAGE_SCALE.max : _imageScale$value$max,
      _imageScale$value$min = _imageScale$value.min,
      min = _imageScale$value$min === void 0 ? DEFAULT_IMAGE_SCALE.min : _imageScale$value$min,
      _imageScale$value$def = _imageScale$value.defaultScale,
      defaultScale = _imageScale$value$def === void 0 ? DEFAULT_IMAGE_SCALE.defaultScale : _imageScale$value$def;
    var scaleVal = Math.min(Math.max(defaultScale, min), max);
    var scale = VueCompositionAPI.ref(scaleVal);
    var setScale = function setScale(newScale) {
      var _imageScale$value2 = imageScale.value,
        _imageScale$value2$ma = _imageScale$value2.max,
        max2 = _imageScale$value2$ma === void 0 ? DEFAULT_IMAGE_SCALE.max : _imageScale$value2$ma,
        _imageScale$value2$mi = _imageScale$value2.min,
        min2 = _imageScale$value2$mi === void 0 ? DEFAULT_IMAGE_SCALE.min : _imageScale$value2$mi;
      var value = newScale;
      if (newScale < min2) {
        value = min2;
      }
      if (newScale > max2) {
        value = max2;
      }
      scale.value = value;
    };
    var onZoomIn = function onZoomIn() {
      var _imageScale$value$ste = imageScale.value.step,
        step = _imageScale$value$ste === void 0 ? DEFAULT_IMAGE_SCALE.step : _imageScale$value$ste;
      setScale(scale.value + step);
    };
    var onZoomOut = function onZoomOut() {
      var _imageScale$value$ste2 = imageScale.value.step,
        step = _imageScale$value$ste2 === void 0 ? DEFAULT_IMAGE_SCALE.step : _imageScale$value$ste2;
      setScale(scale.value - step);
    };
    var resetScale = function resetScale() {
      scale.value = scaleVal;
    };
    return {
      scale: scale,
      onZoomIn: onZoomIn,
      onZoomOut: onZoomOut,
      resetScale: resetScale
    };
  }
  function useRotate() {
    var rotate = VueCompositionAPI.ref(0);
    var ROTATE_DEG = 90;
    var onRotate = function onRotate() {
      rotate.value += ROTATE_DEG;
    };
    var resetRotate = function resetRotate() {
      rotate.value = 0;
    };
    return {
      rotate: rotate,
      onRotate: onRotate,
      resetRotate: resetRotate
    };
  }

  function ownKeys$V(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$U(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$V(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$V(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var TImageItem = VueCompositionAPI.defineComponent({
    name: "TImageItem",
    props: {
      rotate: Number,
      scale: Number,
      mirror: Number,
      src: [String, Object],
      placementSrc: [String, Object]
    },
    setup: function setup(props) {
      var _toRefs = VueCompositionAPI.toRefs(props),
        src = _toRefs.src,
        placementSrc = _toRefs.placementSrc;
      var _useConfig = useConfig("imageViewer"),
        classPrefix = _useConfig.classPrefix,
        globalConfig = _useConfig.global;
      var error = VueCompositionAPI.ref(false);
      var loaded = VueCompositionAPI.ref(false);
      var _useDrag = useDrag$1({
          translateX: 0,
          translateY: 0
        }),
        transform = _useDrag.transform,
        mouseDownHandler = _useDrag.mouseDownHandler;
      var _useImagePreviewUrl = useImagePreviewUrl(src),
        mainImagePreviewUrl = _useImagePreviewUrl.previewUrl;
      var _useImagePreviewUrl2 = useImagePreviewUrl(placementSrc),
        placementImagePreviewUrl = _useImagePreviewUrl2.previewUrl;
      var imgStyle = VueCompositionAPI.computed(function () {
        return _objectSpread$U(_objectSpread$U({}, setTransform("rotate(".concat(props.rotate, "deg) scale(").concat(props.scale, ")"))), {}, {
          display: !props.placementSrc || loaded.value ? "block" : "none"
        });
      });
      var placementImgStyle = VueCompositionAPI.computed(function () {
        return _objectSpread$U(_objectSpread$U({}, setTransform("rotate(".concat(props.rotate, "deg) scale(").concat(props.scale, ")"))), {}, {
          display: !loaded.value ? "block" : "none"
        });
      });
      var boxStyle = VueCompositionAPI.computed(function () {
        var _transform$value = transform.value,
          translateX = _transform$value.translateX,
          translateY = _transform$value.translateY;
        return setTransform("translate(".concat(translateX, "px, ").concat(translateY, "px) scale(").concat(props.mirror, ", 1)"));
      });
      var resetStatus = function resetStatus() {
        error.value = false;
        loaded.value = false;
      };
      VueCompositionAPI.watch([mainImagePreviewUrl, placementImagePreviewUrl], function () {
        resetStatus();
      });
      return {
        globalConfig: globalConfig,
        classPrefix: classPrefix,
        boxStyle: boxStyle,
        loaded: loaded,
        error: error,
        mouseDownHandler: mouseDownHandler,
        placementImgStyle: placementImgStyle,
        imgStyle: imgStyle,
        mainImagePreviewUrl: mainImagePreviewUrl,
        placementImagePreviewUrl: placementImagePreviewUrl
      };
    },
    render: function render() {
      var _this = this;
      var h = arguments[0];
      return h("div", {
        "class": "".concat(this.classPrefix, "-image-viewer__modal-pic")
      }, [h("div", {
        "class": "".concat(this.classPrefix, "-image-viewer__modal-box"),
        "style": this.boxStyle
      }, [this.error && h("div", {
        "class": "".concat(this.classPrefix, "-image-viewer__img-error")
      }, [h("div", {
        "class": "".concat(this.classPrefix, "-image-viewer__img-error-content")
      }, [h(ImageErrorIcon, {
        "attrs": {
          "size": "4em"
        }
      }), h("div", {
        "class": "".concat(this.classPrefix, "-image-viewer__img-error-text")
      }, [this.globalConfig.errorText])])]), !this.error && !!this.placementSrc && this.placementImagePreviewUrl && h("img", {
        "class": "".concat(this.classPrefix, "-image-viewer__modal-image"),
        "on": {
          "mousedown": function mousedown(event) {
            event.stopPropagation();
            _this.mouseDownHandler(event);
          }
        },
        "attrs": {
          "src": this.placementImagePreviewUrl,
          "alt": "image",
          "draggable": "false"
        },
        "style": this.placementImgStyle
      }), !this.error && this.mainImagePreviewUrl && h("img", {
        "class": "".concat(this.classPrefix, "-image-viewer__modal-image"),
        "on": {
          "mousedown": function mousedown(event) {
            event.stopPropagation();
            _this.mouseDownHandler(event);
          },
          "load": function load() {
            return _this.loaded = true;
          },
          "error": function error() {
            return _this.error = true;
          }
        },
        "attrs": {
          "src": this.mainImagePreviewUrl,
          "alt": "image",
          "draggable": "false"
        },
        "style": this.imgStyle
      })])]);
    }
  });

  function ownKeys$U(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$T(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$U(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$U(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var ActionMixin = Vue__default["default"].extend({
    methods: {
      getConfirmBtn: function getConfirmBtn(options) {
        var h = this.$createElement;
        var confirmBtn = options.confirmBtn,
          className = options.className,
          confirmLoading = options.confirmLoading;
        if (confirmBtn === null) return null;
        if (confirmBtn && this.$scopedSlots.confirmBtn) {
          console.warn("Both $props.confirmBtn and $scopedSlots.confirmBtn exist, $props.confirmBtn is preferred.");
        }
        var defaultButtonProps = this.getDefaultConfirmBtnProps(options);
        if (!confirmBtn && !this.$scopedSlots.confirmBtn) {
          return h(Button, helper([{
            "class": className
          }, {
            "props": _objectSpread$T({
              loading: confirmLoading
            }, defaultButtonProps)
          }]));
        }
        if (confirmBtn && ["string", "object"].includes(_typeof$2(confirmBtn))) {
          return this.getButtonByProps(confirmBtn, {
            defaultButtonProps: defaultButtonProps,
            className: className,
            confirmLoading: confirmLoading
          });
        }
        return renderTNodeJSX(this, "confirmBtn");
      },
      getCancelBtn: function getCancelBtn(options) {
        var h = this.$createElement;
        var cancelBtn = options.cancelBtn,
          className = options.className;
        if (cancelBtn === null) return null;
        if (cancelBtn && this.$scopedSlots.cancelBtn) {
          console.warn("Both $props.cancelBtn and $scopedSlots.cancelBtn exist, $props.cancelBtn is preferred.");
        }
        var defaultButtonProps = this.getDefaultCancelBtnProps(options);
        if (!cancelBtn && !this.$scopedSlots.cancelBtn) {
          return h(Button, helper([{
            "class": className
          }, {
            "props": _objectSpread$T({}, defaultButtonProps)
          }]));
        }
        if (cancelBtn && ["string", "object"].includes(_typeof$2(cancelBtn))) {
          return this.getButtonByProps(cancelBtn, {
            defaultButtonProps: defaultButtonProps
          });
        }
        return renderTNodeJSX(this, "cancelBtn");
      },
      getButtonByProps: function getButtonByProps(button, params) {
        var h = this.$createElement;
        var defaultButtonProps = params.defaultButtonProps,
          className = params.className,
          confirmLoading = params.confirmLoading;
        var newOptions = defaultButtonProps;
        if (isString(button)) {
          newOptions.content = button;
        } else if (isObject(button)) {
          newOptions = _objectSpread$T(_objectSpread$T({}, newOptions), button);
        }
        if (confirmLoading !== void 0) {
          newOptions.loading = confirmLoading;
        }
        return h(Button, helper([{
          "class": className
        }, {
          "props": newOptions
        }]));
      },
      confirmBtnAction: function confirmBtnAction(e) {},
      cancelBtnAction: function cancelBtnAction(e) {},
      getDefaultConfirmBtnProps: function getDefaultConfirmBtnProps(options) {
        var _this = this;
        var globalConfirm = options.globalConfirm,
          theme = options.theme,
          globalConfirmBtnTheme = options.globalConfirmBtnTheme;
        var defaultTheme = (globalConfirmBtnTheme === null || globalConfirmBtnTheme === void 0 ? void 0 : globalConfirmBtnTheme[theme]) || "primary";
        var props = {
          theme: defaultTheme,
          content: "\u786E\u5B9A",
          size: options.size,
          onClick: function onClick(e) {
            _this.confirmBtnAction(e);
          }
        };
        if (isString(globalConfirm)) {
          props.content = globalConfirm;
        } else if (isObject(globalConfirm)) {
          props = _objectSpread$T(_objectSpread$T({}, props), globalConfirm);
        }
        return props;
      },
      getDefaultCancelBtnProps: function getDefaultCancelBtnProps(options) {
        var _this2 = this;
        var globalCancel = options.globalCancel;
        var props = {
          theme: "default",
          content: "\u53D6\u6D88",
          size: options.size,
          onClick: function onClick(e) {
            _this2.cancelBtnAction(e);
          }
        };
        if (isString(globalCancel)) {
          props.content = globalCancel;
        } else if (isObject(globalCancel)) {
          props = _objectSpread$T(_objectSpread$T({}, props), globalCancel);
        }
        return props;
      }
    }
  });

  var props$h = {
    attach: {
      type: [String, Function]
    },
    body: {
      type: [String, Function]
    },
    cancelBtn: {
      type: [String, Object, Function]
    },
    closeBtn: {
      type: [String, Boolean, Function],
      "default": true
    },
    closeOnEscKeydown: {
      type: Boolean,
      "default": void 0
    },
    closeOnOverlayClick: {
      type: Boolean,
      "default": void 0
    },
    confirmBtn: {
      type: [String, Object, Function]
    },
    confirmLoading: {
      type: Boolean,
      "default": void 0
    },
    confirmOnEnter: Boolean,
    "default": {
      type: [String, Function]
    },
    destroyOnClose: Boolean,
    dialogClassName: {
      type: String,
      "default": ""
    },
    dialogStyle: {
      type: Object
    },
    draggable: Boolean,
    footer: {
      type: [Boolean, Function],
      "default": true
    },
    header: {
      type: [String, Boolean, Function],
      "default": true
    },
    mode: {
      type: String,
      "default": "modal",
      validator: function validator(val) {
        if (!val) return true;
        return ["modal", "modeless", "normal", "full-screen"].includes(val);
      }
    },
    placement: {
      type: String,
      "default": "top",
      validator: function validator(val) {
        if (!val) return true;
        return ["top", "center"].includes(val);
      }
    },
    preventScrollThrough: {
      type: Boolean,
      "default": true
    },
    showInAttachedElement: Boolean,
    showOverlay: {
      type: Boolean,
      "default": true
    },
    theme: {
      type: String,
      "default": "default",
      validator: function validator(val) {
        if (!val) return true;
        return ["default", "info", "warning", "danger", "success"].includes(val);
      }
    },
    top: {
      type: [String, Number]
    },
    visible: Boolean,
    width: {
      type: [String, Number]
    },
    zIndex: {
      type: Number
    },
    onBeforeClose: Function,
    onBeforeOpen: Function,
    onCancel: Function,
    onClose: Function,
    onCloseBtnClick: Function,
    onClosed: Function,
    onConfirm: Function,
    onEscKeydown: Function,
    onOpened: Function,
    onOverlayClick: Function
  };

  var data = [];
  var push = function push(value) {
    data.push(value);
  };
  var pop = function pop(value) {
    if (data.length && data.includes(value)) {
      data.pop();
    }
  };
  var stack = {
    push: push,
    pop: pop,
    get top() {
      return data[data.length - 1];
    }
  };

  function getScrollbarWidthWithCSS() {
    var defaultScrollbarWidth = 6;
    if (typeof navigator === "undefined" || !navigator) return defaultScrollbarWidth;
    if (/(Chrome|Safari)/i.test(navigator.userAgent)) return defaultScrollbarWidth;
    var scrollDiv = document.createElement("div");
    scrollDiv.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;";
    document.body.appendChild(scrollDiv);
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    if (/Firefox/.test(navigator.userAgent)) {
      scrollbarWidth -= 4;
    }
    if (getIEVersion$1() <= 11) {
      scrollbarWidth = 12;
    }
    return scrollbarWidth;
  }
  function getScrollbarWidth() {
    var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
    if (container === document.body) {
      return window.innerWidth - document.documentElement.clientWidth;
    }
    return container.offsetWidth - container.clientWidth;
  }

  function ownKeys$T(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$S(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$T(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$T(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function getCSSValue(v) {
    return isNaN(Number(v)) ? v : "".concat(Number(v), "px");
  }
  var mousePosition;
  var getClickPosition = function getClickPosition(e) {
    mousePosition = {
      x: e.clientX,
      y: e.clientY
    };
    setTimeout(function () {
      mousePosition = null;
    }, 100);
  };
  if (typeof window !== "undefined" && window.document && window.document.documentElement) {
    document.documentElement.addEventListener("click", getClickPosition, true);
  }
  var key$1 = 1;
  var _Dialog = mixins(ActionMixin, getConfigReceiverMixins("dialog"), getGlobalIconMixins(), getAttachConfigMixins("dialog")).extend({
    name: "TDialog",
    components: {
      TButton: Button
    },
    data: function data() {
      return {
        uid: 0,
        scrollWidth: 0,
        disX: 0,
        disY: 0,
        windowInnerWidth: 0,
        windowInnerHeight: 0,
        dialogW: 0,
        dialogH: 0,
        dLeft: 0,
        dTop: 0,
        styleEl: null,
        timer: null,
        animationEnd: false
      };
    },
    props: _objectSpread$S(_objectSpread$S({}, props$h), {}, {
      instanceGlobal: Object
    }),
    computed: {
      isModal: function isModal() {
        return this.mode === "modal";
      },
      isModeLess: function isModeLess() {
        return this.mode === "modeless";
      },
      isNormal: function isNormal() {
        return this.mode === "normal";
      },
      isFullScreen: function isFullScreen() {
        return this.mode === "full-screen";
      },
      maskClass: function maskClass() {
        return ["".concat(this.componentName, "__mask"), !this.showOverlay && "".concat(this.classPrefix, "-is-hidden")];
      },
      dialogClass: function dialogClass() {
        var dialogClass = ["".concat(this.componentName), "".concat(this.componentName, "__modal-").concat(this.theme), this.isModeLess && this.draggable && "".concat(this.componentName, "--draggable")];
        if (this.isFullScreen) {
          dialogClass.push("".concat(this.componentName, "__fullscreen"));
        } else {
          dialogClass.push("".concat(this.componentName, "--default"));
        }
        return dialogClass;
      },
      positionClass: function positionClass() {
        if (this.isNormal) return [];
        if (this.isFullScreen) return ["".concat(this.componentName, "__position_fullscreen")];
        var dialogClass = ["".concat(this.componentName, "__position"), !!this.top && "".concat(this.componentName, "--top"), "".concat(this.placement && !this.top ? "".concat(this.componentName, "--").concat(this.placement) : "")];
        return dialogClass;
      },
      wrapClass: function wrapClass() {
        return [!this.isNormal && "".concat(this.componentName, "__wrap")];
      },
      ctxClass: function ctxClass() {
        return ["".concat(this.componentName, "__ctx"), _defineProperty$2(_defineProperty$2(_defineProperty$2({}, "".concat(this.classPrefix, "-dialog__ctx--fixed"), this.mode === "modal" || this.isFullScreen), "".concat(this.classPrefix, "-dialog__ctx--absolute"), this.isModal && this.showInAttachedElement), "".concat(this.componentName, "__ctx--modeless"), this.isModeLess)];
      },
      positionStyle: function positionStyle() {
        if (this.isFullScreen) return {};
        var topStyle = {};
        if (this.top !== void 0) {
          if (isNumber(this.top) && this.top < 0) {
            topStyle.paddingTop = "".concat(this.top, "px");
          } else {
            topStyle.paddingTop = this.top;
          }
        }
        return topStyle;
      },
      computedDialogStyle: function computedDialogStyle() {
        return !this.isFullScreen ? _objectSpread$S({
          width: getCSSValue(this.width)
        }, this.dialogStyle) : _objectSpread$S({}, this.dialogStyle);
      },
      computedAttach: function computedAttach() {
        return this.showInAttachedElement || this.isNormal ? void 0 : this.attach || this.globalAttach();
      }
    },
    watch: {
      visible: {
        handler: function handler(value) {
          var _this = this;
          if (typeof window === "undefined") return;
          if (value) {
            this.animationEnd = false;
            if (this.isModal && !this.showInAttachedElement || this.isFullScreen) {
              if (this.preventScrollThrough) {
                this.$nextTick(function () {
                  document.head.appendChild(_this.styleEl);
                });
              }
              this.$nextTick(function () {
                var target = _this.$refs.dialog;
                if (mousePosition && target) {
                  target.style.transformOrigin = "".concat(mousePosition.x - target.offsetLeft, "px ").concat(mousePosition.y - target.offsetTop, "px");
                }
              });
            }
            document.activeElement.blur();
          } else {
            this.clearStyleFunc();
          }
          this.$nextTick(function () {
            _this.storeUid(value);
          });
          this.addKeyboardEvent(value);
          if (this.isModeLess && this.draggable) {
            this.$nextTick(function () {
              _this.initDragEvent(value);
            });
          }
          if (value && !this.destroyOnClose && requestAnimationFrame) {
            requestAnimationFrame(function () {
              updateElement(_this);
            });
          }
        },
        immediate: true
      }
    },
    mounted: function mounted() {
      var hasScrollBar = document.documentElement.scrollHeight > document.documentElement.clientHeight;
      var scrollWidth = hasScrollBar ? getScrollbarWidth() : 0;
      if (this.draggable) {
        window.addEventListener("resize", throttle$1(this.resizeAdjustPosition, 1e3));
      }
      this.uid = this._uid;
      this.styleEl = document.createElement("style");
      this.styleEl.dataset.id = "td_dialog_".concat(+new Date(), "_").concat(key$1 += 1);
      this.styleEl.innerHTML = "\n      html body {\n        overflow-y: hidden;\n        width: calc(100% - ".concat(scrollWidth, "px);\n      }\n    ");
      if (this.visible && this.isModal && this.preventScrollThrough && !this.showInAttachedElement) {
        document.head.appendChild(this.styleEl);
      }
    },
    beforeDestroy: function beforeDestroy() {
      this.addKeyboardEvent(false);
      this.destroySelf();
      this.destroySelfStyle();
    },
    directives: {
      TransferDom: TransferDom
    },
    methods: {
      clearStyleFunc: function clearStyleFunc() {
        var _this2 = this;
        clearTimeout(this.timer);
        this.timer = setTimeout(function () {
          _this2.destroySelfStyle();
        }, 150);
      },
      destroySelfStyle: function destroySelfStyle() {
        var _this$styleEl$parentN, _this$styleEl$parentN2;
        (_this$styleEl$parentN = this.styleEl.parentNode) === null || _this$styleEl$parentN === void 0 || (_this$styleEl$parentN2 = _this$styleEl$parentN.removeChild) === null || _this$styleEl$parentN2 === void 0 || _this$styleEl$parentN2.call(_this$styleEl$parentN, this.styleEl);
      },
      destroySelf: function destroySelf() {
        var _this$$el$parentNode, _this$$el$parentNode$;
        (_this$$el$parentNode = this.$el.parentNode) === null || _this$$el$parentNode === void 0 || (_this$$el$parentNode$ = _this$$el$parentNode.removeChild) === null || _this$$el$parentNode$ === void 0 || _this$$el$parentNode$.call(_this$$el$parentNode, this.$el);
      },
      storeUid: function storeUid(flag) {
        if (flag) {
          stack.push(this.uid);
        } else {
          stack.pop(this.uid);
        }
      },
      addKeyboardEvent: function addKeyboardEvent(status) {
        if (status) {
          document.addEventListener("keydown", this.keyboardEvent);
          this.confirmOnEnter && document.addEventListener("keydown", this.keyboardEnterEvent);
        } else {
          document.removeEventListener("keydown", this.keyboardEvent);
          this.confirmOnEnter && document.removeEventListener("keydown", this.keyboardEnterEvent);
        }
      },
      keyboardEvent: function keyboardEvent(e) {
        if (e.code === "Escape" && stack.top === this.uid) {
          var _this$closeOnEscKeydo;
          emitEvent$1(this, "esc-keydown", {
            e: e
          });
          if ((_this$closeOnEscKeydo = this.closeOnEscKeydown) !== null && _this$closeOnEscKeydo !== void 0 ? _this$closeOnEscKeydo : this.global.closeOnEscKeydown) {
            this.emitCloseEvent({
              e: e,
              trigger: "esc"
            });
          }
        }
      },
      keyboardEnterEvent: function keyboardEnterEvent(e) {
        var code = e.code;
        if ((code === "Enter" || code === "NumpadEnter") && stack.top === this.uid) {
          emitEvent$1(this, "confirm", {
            e: e
          });
        }
      },
      overlayAction: function overlayAction(e) {
        var _this$closeOnOverlayC;
        if (e.target !== this.$refs.dialogPosition) {
          return;
        }
        emitEvent$1(this, "overlay-click", {
          e: e
        });
        if (this.showOverlay && ((_this$closeOnOverlayC = this.closeOnOverlayClick) !== null && _this$closeOnOverlayC !== void 0 ? _this$closeOnOverlayC : this.global.closeOnOverlayClick)) {
          this.emitCloseEvent({
            e: e,
            trigger: "overlay"
          });
        }
      },
      closeBtnAction: function closeBtnAction(e) {
        emitEvent$1(this, "close-btn-click", {
          e: e
        });
        this.emitCloseEvent({
          trigger: "close-btn",
          e: e
        });
      },
      cancelBtnAction: function cancelBtnAction(e) {
        emitEvent$1(this, "cancel", {
          e: e
        });
        this.emitCloseEvent({
          trigger: "cancel",
          e: e
        });
      },
      confirmBtnAction: function confirmBtnAction(e) {
        emitEvent$1(this, "confirm", {
          e: e
        });
      },
      beforeEnter: function beforeEnter() {
        emitEvent$1(this, "before-open");
      },
      afterEnter: function afterEnter() {
        emitEvent$1(this, "opened");
      },
      beforeLeave: function beforeLeave() {
        emitEvent$1(this, "before-close");
      },
      afterLeave: function afterLeave() {
        if (this.isModeLess && this.draggable) {
          var target = this.$refs.dialog;
          if (!target) return;
          target.style.position = "relative";
          target.style.left = "unset";
          target.style.top = "unset";
        }
        emitEvent$1(this, "closed");
        this.animationEnd = true;
      },
      emitCloseEvent: function emitCloseEvent(context) {
        emitEvent$1(this, "close", context);
        this.$emit("update:visible", false);
      },
      hasEventOn: function hasEventOn(name) {
        var _this$_events;
        var eventFuncs = (_this$_events = this["_events"]) === null || _this$_events === void 0 ? void 0 : _this$_events[name];
        return !!(eventFuncs !== null && eventFuncs !== void 0 && eventFuncs.length);
      },
      getIcon: function getIcon() {
        var h = this.$createElement;
        var _this$useGlobalIcon = this.useGlobalIcon({
            InfoCircleFilledIcon: TdInfoCircleFilledIcon,
            CheckCircleFilledIcon: TdCheckCircleFilledIcon,
            ErrorCircleFilledIcon: TdErrorCircleFilledIcon
          }),
          InfoCircleFilledIcon = _this$useGlobalIcon.InfoCircleFilledIcon,
          CheckCircleFilledIcon = _this$useGlobalIcon.CheckCircleFilledIcon,
          ErrorCircleFilledIcon = _this$useGlobalIcon.ErrorCircleFilledIcon;
        var icon = {
          info: h(InfoCircleFilledIcon, {
            "class": "".concat(this.classPrefix, "-is-info")
          }),
          warning: h(ErrorCircleFilledIcon, {
            "class": "".concat(this.classPrefix, "-is-warning")
          }),
          danger: h(ErrorCircleFilledIcon, {
            "class": "".concat(this.classPrefix, "-is-error")
          }),
          success: h(CheckCircleFilledIcon, {
            "class": "".concat(this.classPrefix, "-is-success")
          })
        };
        return icon[this.theme];
      },
      mousedownHandler: function mousedownHandler(targetEvent) {
        var target = this.$refs.dialog;
        this.disX = targetEvent.clientX - target.offsetLeft;
        this.disY = targetEvent.clientY - target.offsetTop;
        this.dialogW = target.offsetWidth;
        this.dialogH = target.offsetHeight;
        this.windowInnerWidth = window.innerWidth || document.documentElement.clientWidth;
        this.windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
        if (this.dialogW > this.windowInnerWidth || this.dialogH > this.windowInnerHeight) return;
        document.addEventListener("mousemove", this.mouseMoverHandler);
        document.addEventListener("mouseup", this.mouseUpHandler);
        document.addEventListener("dragend", this.mouseUpHandler);
      },
      mouseMoverHandler: function mouseMoverHandler(documentEvent) {
        var target = this.$refs.dialog;
        var left = documentEvent.clientX - this.disX;
        var top = documentEvent.clientY - this.disY;
        if (left < 0) left = 0;
        if (top < 0) top = 0;
        if (this.windowInnerWidth - target.offsetWidth - left < 0) left = this.windowInnerWidth - target.offsetWidth;
        if (this.windowInnerHeight - target.offsetHeight - top < 0) top = this.windowInnerHeight - target.offsetHeight;
        target.style.position = "absolute";
        target.style.left = "".concat(left, "px");
        target.style.top = "".concat(top, "px");
      },
      mouseUpHandler: function mouseUpHandler() {
        document.removeEventListener("mousemove", this.mouseMoverHandler);
        document.removeEventListener("mouseup", this.mouseUpHandler);
        document.removeEventListener("dragend", this.mouseUpHandler);
      },
      initDragEvent: function initDragEvent(status) {
        var target = this.$refs.dialog;
        if (status) {
          target.addEventListener("mousedown", this.mousedownHandler);
        } else {
          target.removeEventListener("mousedown", this.mousedownHandler);
        }
      },
      resizeAdjustPosition: function resizeAdjustPosition() {
        if (this.visible) {
          var target = this.$refs.dialog;
          target.style.left = "".concat(this.dLeft * (window.innerWidth / this.windowInnerWidth), "px");
          target.style.top = "".concat(this.dTop * (window.innerHeight / this.windowInnerHeight), "px");
        }
      },
      onStopDown: function onStopDown(e) {
        if (this.isModeLess && this.draggable) e.stopPropagation();
      },
      renderDialog: function renderDialog() {
        var _this$instanceGlobal, _this$instanceGlobal2, _this$instanceGlobal3;
        var h = this.$createElement;
        var _this$useGlobalIcon2 = this.useGlobalIcon({
            CloseIcon: TdCloseIcon
          }),
          CloseIcon = _this$useGlobalIcon2.CloseIcon;
        var defaultHeader = h("h5", {
          "class": "title"
        });
        var defaultCloseBtn = h(CloseIcon);
        var body = renderContent(this, "default", "body");
        var defaultFooter = h("div", [this.getCancelBtn({
          cancelBtn: this.cancelBtn,
          globalCancel: ((_this$instanceGlobal = this.instanceGlobal) === null || _this$instanceGlobal === void 0 ? void 0 : _this$instanceGlobal.cancel) || this.global.cancel,
          className: "".concat(this.componentName, "__cancel")
        }), this.getConfirmBtn({
          theme: this.theme,
          confirmBtn: this.confirmBtn,
          confirmLoading: this.confirmLoading,
          globalConfirm: ((_this$instanceGlobal2 = this.instanceGlobal) === null || _this$instanceGlobal2 === void 0 ? void 0 : _this$instanceGlobal2.confirm) || this.global.confirm,
          globalConfirmBtnTheme: ((_this$instanceGlobal3 = this.instanceGlobal) === null || _this$instanceGlobal3 === void 0 ? void 0 : _this$instanceGlobal3.confirmBtnTheme) || this.global.confirmBtnTheme,
          className: "".concat(this.componentName, "__confirm")
        })]);
        var headerClassName = this.isFullScreen ? ["".concat(this.componentName, "__header"), "".concat(this.componentName, "__header--fullscreen")] : "".concat(this.componentName, "__header");
        var closeClassName = this.isFullScreen ? ["".concat(this.componentName, "__close"), "".concat(this.componentName, "__close--fullscreen")] : "".concat(this.componentName, "__close");
        var bodyClassName = this.theme === "default" ? ["".concat(this.componentName, "__body")] : ["".concat(this.componentName, "__body"), "".concat(this.componentName, "__body__icon")];
        var footerContent = renderTNodeJSX(this, "footer", defaultFooter);
        if (this.isFullScreen && footerContent) {
          bodyClassName.push("".concat(this.componentName, "__body--fullscreen"));
        } else if (this.isFullScreen) {
          bodyClassName.push("".concat(this.componentName, "__body--fullscreen--without-footer"));
        }
        var footerClassName = this.isFullScreen ? ["".concat(this.componentName, "__footer"), "".concat(this.componentName, "__footer--fullscreen")] : "".concat(this.componentName, "__footer");
        var footer = this.footer ? h("div", {
          "class": footerClassName,
          "on": {
            "mousedown": this.onStopDown
          }
        }, [footerContent]) : null;
        return h("div", {
          "class": this.wrapClass
        }, [h("div", {
          "class": this.positionClass,
          "style": this.positionStyle,
          "on": {
            "click": this.overlayAction
          },
          "ref": "dialogPosition"
        }, [h("div", {
          "key": "dialog",
          "ref": "dialog",
          "class": this.dialogClass,
          "style": this.computedDialogStyle
        }, [h("div", {
          "class": headerClassName,
          "on": {
            "mousedown": this.onStopDown
          }
        }, [h("div", {
          "class": "".concat(this.componentName, "__header-content")
        }, [this.getIcon(), renderTNodeJSX(this, "header", defaultHeader)]), this.closeBtn ? h("span", {
          "class": closeClassName,
          "on": {
            "click": this.closeBtnAction
          }
        }, [renderTNodeJSX(this, "closeBtn", defaultCloseBtn)]) : null]), h("div", {
          "class": bodyClassName,
          "on": {
            "mousedown": this.onStopDown
          }
        }, [body]), footer])])]);
      }
    },
    render: function render() {
      var h = arguments[0];
      var maskView = (this.isModal || this.isFullScreen) && h("div", {
        "key": "mask",
        "class": this.maskClass
      });
      var dialogView = this.renderDialog();
      var view = [maskView, dialogView];
      var ctxStyle = {
        zIndex: this.zIndex
      };
      if (this.destroyOnClose && !this.visible && this.animationEnd) return null;
      return h("transition", {
        "attrs": {
          "duration": 300,
          "name": "".concat(this.componentName, "-zoom__vue")
        },
        "on": {
          "beforeEnter": this.beforeEnter,
          "afterEnter": this.afterEnter,
          "beforeLeave": this.beforeLeave,
          "afterLeave": this.afterLeave
        }
      }, [h("div", {
        "directives": [{
          name: "show",
          value: this.visible
        }, {
          name: "transfer-dom",
          value: this.computedAttach
        }],
        "class": this.ctxClass,
        "style": ctxStyle
      }, [view])]);
    }
  });

  var globalConfigSymbol = "__TDESIGN__INSTANCE__GLOBAL__CONFIG__";
  var ConfigProvider$1 = Vue__default["default"].extend({
    name: "TConfigProvider",
    props: {
      globalConfig: Object
    },
    data: function data() {
      return {
        defaultData: cloneDeep(defaultGlobalConfig)
      };
    },
    provide: function provide() {
      return {
        globalConfig: this.mergedGlobalConfig
      };
    },
    computed: {
      mergedGlobalConfig: function mergedGlobalConfig() {
        var mergedGlobalConfig = mergeWith(this.defaultData, this.globalConfig);
        Vue__default["default"].prototype[globalConfigSymbol] = mergedGlobalConfig;
        return mergedGlobalConfig;
      }
    },
    render: function render() {
      var _this$$slots$default;
      var h = arguments[0];
      if (((_this$$slots$default = this.$slots["default"]) === null || _this$$slots$default === void 0 ? void 0 : _this$$slots$default.length) === 1) {
        return this.$slots["default"][0];
      }
      return h("div", [this.$slots["default"]]);
    }
  });

  function ownKeys$S(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$R(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$S(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$S(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var createDialog = function createDialog(props) {
    var options = _objectSpread$R({}, props);
    var globalOptions = Vue__default["default"].prototype[globalConfigSymbol];
    var dialog = new _Dialog({
      propsData: _objectSpread$R(_objectSpread$R({}, options), {}, {
        onClose: options.onClose || function () {
          dialog.visible = false;
        },
        instanceGlobal: globalOptions === null || globalOptions === void 0 ? void 0 : globalOptions.dialog
      })
    }).$mount();
    dialog.visible = true;
    if (options.className) {
      options.className.split(" ").forEach(function (name) {
        dialog.$el.classList.add(name.trim());
      });
    }
    if (options.style) {
      dialog.$el.style.cssText += options.style;
    }
    var container = getAttach(options.attach);
    if (container) {
      container.appendChild(dialog.$el);
    } else {
      console.error("attach is not exist");
    }
    var dialogNode = {
      show: function show() {
        dialog.visible = true;
      },
      hide: function hide() {
        dialog.visible = false;
      },
      update: function update(options2) {
        Object.assign(dialog, options2);
      },
      destroy: function destroy() {
        dialog.visible = false;
        container.contains(dialog.$el) && container.removeChild(dialog.$el);
      },
      setConfirmLoading: function setConfirmLoading(val) {
        dialog.confirmLoading = val;
      }
    };
    return dialogNode;
  };
  var confirm = function confirm(props) {
    return createDialog(props);
  };
  var alert = function alert(props) {
    var options = _objectSpread$R({}, props);
    options.cancelBtn = null;
    return createDialog(options);
  };
  var extraApi$1 = {
    confirm: confirm,
    alert: alert
  };
  var _DialogPlugin = {
    install: function install() {
      Vue__default["default"].prototype.$dialog = createDialog;
      Object.keys(extraApi$1).forEach(function (funcName) {
        Vue__default["default"].prototype.$dialog[funcName] = extraApi$1[funcName];
      });
    }
  };
  Object.keys(extraApi$1).forEach(function (funcName) {
    _DialogPlugin[funcName] = extraApi$1[funcName];
  });
  var DialogPlugin = _DialogPlugin;

  var Dialog = withInstall$1(_Dialog);

  function ownKeys$R(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$Q(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$R(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$R(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var defaultProps = {
    zIndex: Number,
    visible: Boolean,
    index: Number,
    images: props$i.images,
    scale: Number,
    rotate: Number,
    mirror: Number,
    currentImage: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    rotateHandler: Function,
    zoomInHandler: Function,
    zoomOutHandler: Function,
    mirrorHandler: Function,
    resetHandler: Function,
    closeHandler: props$i.onClose,
    draggable: {
      type: Boolean,
      "default": true
    },
    viewerScale: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    showOverlay: Boolean,
    closeBtn: props$i.closeBtn
  };
  var TImageViewerModal = VueCompositionAPI.defineComponent({
    name: "TImageViewerModal",
    props: _objectSpread$Q({}, defaultProps),
    setup: function setup(props2) {
      var classPrefix = usePrefixClass();
      var renderJSX = useTNodeJSX();
      var style = VueCompositionAPI.computed(function () {
        return {
          minWidth: props2.viewerScale.minWidth,
          minHeight: props2.viewerScale.minHeight
        };
      });
      return {
        classPrefix: classPrefix,
        renderJSX: renderJSX,
        style: style
      };
    },
    render: function render() {
      var _this = this;
      var h = arguments[0];
      return h(Dialog, {
        "attrs": {
          "destroyOnClose": true,
          "visible": this.visible,
          "placement": "center",
          "mode": "modeless",
          "width": 1e3,
          "cancelBtn": null,
          "confirmBtn": null,
          "draggable": this.draggable,
          "zIndex": this.zIndex,
          "showOverlay": this.showOverlay,
          "header": this.title,
          "footer": function footer() {
            return h("div", {
              "class": "".concat(_this.classPrefix, "-image-viewer-mini__footer")
            }, [h(TImageViewerUtils, {
              "attrs": {
                "zoomInHandler": _this.zoomInHandler,
                "zoomOutHandler": _this.zoomOutHandler,
                "scale": _this.scale,
                "currentImage": _this.currentImage,
                "rotateHandler": _this.rotateHandler,
                "mirrorHandler": _this.mirrorHandler,
                "resetHandler": _this.resetHandler
              }
            })]);
          }
        },
        "on": {
          "close": this.closeHandler
        },
        "class": "".concat(this.classPrefix, "-image-viewer__dialog")
      }, [h("div", {
        "class": "".concat(this.classPrefix, "-image-viewer-mini__content"),
        "style": this.style
      }, [h(TImageItem, {
        "attrs": {
          "rotate": this.rotate,
          "scale": this.scale,
          "mirror": this.mirror,
          "src": this.currentImage.mainImage,
          "placementSrc": this.currentImage.thumbnail
        }
      })])]);
    }
  });

  function ownKeys$Q(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$P(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$Q(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$Q(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _ImageViewer = VueCompositionAPI.defineComponent({
    name: "TImageViewer",
    props: _objectSpread$P({}, props$i),
    model: {
      prop: "visible",
      event: "change"
    },
    setup: function setup(props2, _ref) {
      var _props2$defaultIndex;
      var emit = _ref.emit;
      var classPrefix = usePrefixClass();
      var COMPONENT_NAME = usePrefixClass("image-viewer");
      var isExpand = VueCompositionAPI.ref(true);
      var showOverlayValue = VueCompositionAPI.computed(function () {
        return getOverlay(props2);
      });
      var _toRefs = VueCompositionAPI.toRefs(props2),
        index = _toRefs.index,
        visible = _toRefs.visible;
      var _useDefaultValue = useDefaultValue(index, (_props2$defaultIndex = props2.defaultIndex) !== null && _props2$defaultIndex !== void 0 ? _props2$defaultIndex : 0, props2.onIndexChange, "index", "index-change"),
        _useDefaultValue2 = _slicedToArray(_useDefaultValue, 2),
        indexValue = _useDefaultValue2[0],
        setIndexValue = _useDefaultValue2[1];
      var _useVModel = useVModel$1(visible, props2.defaultVisible, function () {}, "change", "visible"),
        _useVModel2 = _slicedToArray(_useVModel, 2),
        visibleValue = _useVModel2[0],
        setVisibleValue = _useVModel2[1];
      var rootClass = VueCompositionAPI.computed(function () {
        return ["".concat(COMPONENT_NAME.value)];
      });
      var wrapClass = VueCompositionAPI.computed(function () {
        return [COMPONENT_NAME.value, "".concat(COMPONENT_NAME.value, "-preview-image"), _defineProperty$2({}, "".concat(classPrefix.value, "-is-hide"), !visibleValue.value)];
      });
      var headerClass = VueCompositionAPI.computed(function () {
        return ["".concat(classPrefix.value, "-image-viewer__modal-header"), _defineProperty$2({}, "".concat(classPrefix.value, "-is-show"), isExpand.value)];
      });
      var zIndexValue = VueCompositionAPI.computed(function () {
        var _props2$zIndex;
        return (_props2$zIndex = props2.zIndex) !== null && _props2$zIndex !== void 0 ? _props2$zIndex : 2600;
      });
      var toggleExpand = function toggleExpand() {
        isExpand.value = !isExpand.value;
      };
      var imageScaleRef = VueCompositionAPI.computed(function () {
        var _props2$imageScale;
        return (_props2$imageScale = props2.imageScale) !== null && _props2$imageScale !== void 0 ? _props2$imageScale : DEFAULT_IMAGE_SCALE;
      });
      var _useMirror = useMirror(),
        mirror = _useMirror.mirror,
        onMirror = _useMirror.onMirror,
        resetMirror = _useMirror.resetMirror;
      var _useScale = useScale(imageScaleRef),
        scale = _useScale.scale,
        onZoomIn = _useScale.onZoomIn,
        onZoomOut = _useScale.onZoomOut,
        resetScale = _useScale.resetScale;
      var _useRotate = useRotate(),
        rotate = _useRotate.rotate,
        onRotate = _useRotate.onRotate,
        resetRotate = _useRotate.resetRotate;
      var onRest = function onRest() {
        resetMirror();
        resetScale();
        resetRotate();
      };
      var imagesList = VueCompositionAPI.computed(function () {
        return formatImages(props2.images);
      });
      var currentImage = VueCompositionAPI.computed(function () {
        var _imagesList$value$ind;
        return (_imagesList$value$ind = imagesList.value[indexValue.value]) !== null && _imagesList$value$ind !== void 0 ? _imagesList$value$ind : {
          mainImage: ""
        };
      });
      var prevImage = function prevImage() {
        var newIndex = indexValue.value - 1;
        onRest();
        setIndexValue(newIndex < 0 ? 0 : newIndex, {
          trigger: "prev"
        });
      };
      var nextImage = function nextImage() {
        var newIndex = indexValue.value + 1;
        onRest();
        setIndexValue(newIndex >= imagesList.value.length ? indexValue.value : newIndex, {
          trigger: "next"
        });
      };
      var onImgClick = function onImgClick(i) {
        setIndexValue(i, {
          trigger: "current"
        });
      };
      var openHandler = function openHandler() {
        setVisibleValue(true);
      };
      var onCloseHandle = function onCloseHandle(ctx) {
        var _props2$onClose;
        setVisibleValue(false);
        unmountContent();
        (_props2$onClose = props2.onClose) === null || _props2$onClose === void 0 || _props2$onClose.call(props2, ctx);
        emit("close", ctx);
      };
      var closeBtnAction = function closeBtnAction(e) {
        onCloseHandle({
          e: e,
          trigger: "close-btn"
        });
      };
      var clickOverlayHandler = function clickOverlayHandler(e) {
        if (props2.closeOnOverlay) {
          onCloseHandle({
            e: e,
            trigger: "overlay"
          });
        }
      };
      var keydownHandler = function keydownHandler(e) {
        e.stopPropagation();
        switch (e.code) {
          case EVENT_CODE.left:
            prevImage();
            break;
          case EVENT_CODE.right:
            nextImage();
            break;
          case EVENT_CODE.up:
            onZoomIn();
            break;
          case EVENT_CODE.down:
            onZoomOut();
            break;
          case EVENT_CODE.esc:
            if (props2.closeOnEscKeydown) {
              onCloseHandle({
                e: e,
                trigger: "esc"
              });
            }
            break;
        }
      };
      var containerRef = VueCompositionAPI.ref();
      var mountContent = function mountContent() {
        if (containerRef) {
          containerRef.value.mountContent();
        }
      };
      var unmountContent = function unmountContent() {
        if (containerRef) {
          containerRef.value.unmountContent();
        }
      };
      var divRef = VueCompositionAPI.ref();
      var getFocus = function getFocus() {
        if (divRef.value) {
          divRef.value.focus();
        }
      };
      VueCompositionAPI.watch(function () {
        return visibleValue.value;
      }, function (val) {
        if (val) {
          onRest();
          mountContent();
          getFocus();
        }
      });
      var onWheel = function onWheel(e) {
        e.preventDefault();
        var deltaY = e.deltaY;
        deltaY > 0 ? onZoomOut() : onZoomIn();
      };
      var transStyle = VueCompositionAPI.computed(function () {
        return setTransform("translateX(calc(-".concat(indexValue.value, " * (40px / 9 * 16 + 4px)))"));
      });
      var isMultipleImg = VueCompositionAPI.computed(function () {
        return imagesList.value.length > 1;
      });
      return {
        COMPONENT_NAME: COMPONENT_NAME,
        rootClass: rootClass,
        classPrefix: classPrefix,
        prevImage: prevImage,
        nextImage: nextImage,
        zIndexValue: zIndexValue,
        visibleValue: visibleValue,
        indexValue: indexValue,
        imagesList: imagesList,
        showOverlayValue: showOverlayValue,
        wrapClass: wrapClass,
        rotate: rotate,
        mirror: mirror,
        currentImage: currentImage,
        onRotate: onRotate,
        onZoomIn: onZoomIn,
        onZoomOut: onZoomOut,
        onMirror: onMirror,
        onRest: onRest,
        openHandler: openHandler,
        onCloseHandle: onCloseHandle,
        onWheel: onWheel,
        clickOverlayHandler: clickOverlayHandler,
        headerClass: headerClass,
        toggleExpand: toggleExpand,
        transStyle: transStyle,
        onImgClick: onImgClick,
        closeBtnAction: closeBtnAction,
        scale: scale,
        isMultipleImg: isMultipleImg,
        containerRef: containerRef,
        keydownHandler: keydownHandler,
        divRef: divRef
      };
    },
    methods: {
      renderHeader: function renderHeader() {
        var _this = this;
        var h = this.$createElement;
        return h("div", {
          "class": this.headerClass
        }, [h(TImageViewerIcon, {
          "attrs": {
            "icon": function icon() {
              return h(TdChevronDownIcon);
            },
            "clickHandler": this.toggleExpand
          },
          "class": "".concat(this.COMPONENT_NAME, "__header-pre-bt")
        }), h("div", {
          "class": "".concat(this.COMPONENT_NAME, "__header-prev")
        }, [h("div", {
          "class": "".concat(this.COMPONENT_NAME, "__header-trans"),
          "style": this.transStyle
        }, [this.imagesList.map(function (image, index) {
          return h("div", {
            "key": index,
            "class": ["".concat(_this.COMPONENT_NAME, "__header-box"), _defineProperty$2({}, "".concat(_this.classPrefix, "-is-active"), index === _this.indexValue)]
          }, [h(Image$1, {
            "attrs": {
              "alt": "",
              "error": "",
              "src": image.thumbnail || image.mainImage
            },
            "class": "".concat(_this.COMPONENT_NAME, "__header-img"),
            "on": {
              "click": function click() {
                return _this.onImgClick(index);
              }
            }
          })]);
        })])])]);
      },
      renderNavigationArrow: function renderNavigationArrow(type) {
        var h = this.$createElement;
        var rotateDeg = type === "prev" ? 0 : 180;
        var _icon = renderTNodeJSX(this, "navigationArrow", h(TdChevronLeftIcon, {
          "style": setTransform("rotate(".concat(rotateDeg, "deg)")),
          "attrs": {
            "size": "24px"
          }
        }));
        return h(TImageViewerIcon, {
          "class": "".concat(this.COMPONENT_NAME, "__modal-").concat(type, "-bt"),
          "attrs": {
            "clickHandler": type === "prev" ? this.prevImage : this.nextImage,
            "icon": function icon() {
              return _icon;
            }
          }
        });
      },
      renderModal: function renderModal() {
        var h = this.$createElement;
        return h(TImageViewerModal, {
          "attrs": {
            "zIndex": this.zIndexValue,
            "visible": this.visibleValue,
            "index": this.indexValue,
            "images": this.imagesList,
            "scale": this.scale,
            "rotate": this.rotate,
            "mirror": this.mirror,
            "currentImage": this.currentImage,
            "rotateHandler": this.onRotate,
            "zoomInHandler": this.onZoomIn,
            "zoomOutHandler": this.onZoomOut,
            "mirrorHandler": this.onMirror,
            "resetHandler": this.onRest,
            "closeHandler": this.onCloseHandle,
            "draggable": this.draggable,
            "showOverlay": this.showOverlayValue,
            "closeBtn": this.closeBtn
          }
        });
      },
      renderCloseBtn: function renderCloseBtn() {
        var h = this.$createElement;
        if (this.closeBtn === false) {
          return;
        }
        return h("div", {
          "class": ["".concat(this.COMPONENT_NAME, "__modal-icon"), "".concat(this.COMPONENT_NAME, "__modal-close-bt")],
          "on": {
            "click": this.closeBtnAction
          }
        }, [renderTNodeJSX(this, "closeBtn", h(TdCloseIcon, {
          "attrs": {
            "size": "24px"
          }
        }))]);
      },
      renderViewer: function renderViewer() {
        var h = this.$createElement;
        return h("div", {
          "attrs": {
            "tabindex": -1
          },
          "on": {
            "keydown": this.keydownHandler,
            "wheel": this.onWheel
          },
          "ref": "divRef",
          "class": this.wrapClass,
          "style": {
            zIndex: this.zIndexValue
          }
        }, [!!this.showOverlayValue && h("div", {
          "class": "".concat(this.COMPONENT_NAME, "__modal-mask"),
          "on": {
            "click": this.clickOverlayHandler
          }
        }), this.isMultipleImg && this.renderHeader(), this.isMultipleImg && this.renderNavigationArrow("prev"), this.isMultipleImg && this.renderNavigationArrow("next"), this.isMultipleImg && h("div", {
          "class": "".concat(this.COMPONENT_NAME, "__modal-index")
        }, [renderTNodeJSX(this, "title"), "".concat(this.indexValue + 1, "/").concat(this.imagesList.length)]), this.renderCloseBtn(), h(TImageViewerUtils, {
          "attrs": {
            "zoomInHandler": this.onZoomIn,
            "zoomOutHandler": this.onZoomOut,
            "mirrorHandler": this.onMirror,
            "resetHandler": this.onRest,
            "rotateHandler": this.onRotate,
            "scale": this.scale,
            "currentImage": this.currentImage
          }
        }), h(TImageItem, {
          "attrs": {
            "scale": this.scale,
            "rotate": this.rotate,
            "mirror": this.mirror,
            "src": this.currentImage.mainImage,
            "placementSrc": this.currentImage.thumbnail
          }
        })]);
      }
    },
    render: function render() {
      var h = arguments[0];
      return h(Container, {
        "ref": "containerRef",
        "attrs": {
          "mode": this.mode,
          "renderModal": this.renderModal,
          "renderViewer": this.renderViewer
        }
      }, [renderTNodeJSX(this, "trigger", {
        params: {
          open: this.openHandler
        }
      })]);
    }
  });

  var ImageViewer = withInstall$1(_ImageViewer);

  var props$g = {
    action: {
      type: [String, Function]
    },
    content: {
      type: [String, Function]
    },
    "default": {
      type: [String, Function]
    },
    onClick: Function
  };

  var _ListItem = VueCompositionAPI.defineComponent({
    name: "TListItem",
    props: props$g,
    setup: function setup(props2, _ref) {
      var emit = _ref.emit;
      var componentName = usePrefixClass("list-item");
      var handleClick = function handleClick(e) {
        var _props2$onClick;
        emit("click", {
          e: e
        });
        (_props2$onClick = props2.onClick) === null || _props2$onClick === void 0 || _props2$onClick.call(props2, {
          e: e
        });
      };
      return {
        componentName: componentName,
        handleClick: handleClick
      };
    },
    render: function render() {
      var h = arguments[0];
      var componentName = this.componentName,
        handleClick = this.handleClick;
      var content = renderContent(this, "default", "content");
      var propsActionContent = renderTNodeJSX(this, "action");
      return h("li", {
        "class": componentName,
        "on": {
          "click": handleClick
        }
      }, [h("div", {
        "class": "".concat(componentName, "-main")
      }, [h("div", {
        "class": "".concat(componentName, "__content")
      }, [content]), propsActionContent && h("li", {
        "class": "".concat(componentName, "__action")
      }, [propsActionContent])])]);
    }
  });

  var props$f = {
    asyncLoading: {
      type: [String, Function]
    },
    footer: {
      type: [String, Function]
    },
    header: {
      type: [String, Function]
    },
    layout: {
      type: String,
      "default": "horizontal",
      validator: function validator(val) {
        if (!val) return true;
        return ["horizontal", "vertical"].includes(val);
      }
    },
    scroll: {
      type: Object
    },
    size: {
      type: String,
      "default": "medium",
      validator: function validator(val) {
        if (!val) return true;
        return ["small", "medium", "large"].includes(val);
      }
    },
    split: Boolean,
    stripe: Boolean,
    onLoadMore: Function,
    onScroll: Function
  };

  var LOAD_MORE = "load-more";
  var LOADING = "loading";

  var useListVirtualScroll = function useListVirtualScroll(scroll, listRef, listItems) {
    var virtualScrollParams = VueCompositionAPI.computed(function () {
      return {
        data: listItems.value,
        scroll: scroll
      };
    });
    var virtualConfig = useVirtualScroll$1(listRef, virtualScrollParams);
    var isVirtualScroll = VueCompositionAPI.computed(function () {
      return virtualConfig.isVirtualScroll.value;
    });
    var lastScrollY = -1;
    var onInnerVirtualScroll = function onInnerVirtualScroll(e) {
      var target = e.target || e.srcElement;
      var top = target.scrollTop;
      if (lastScrollY !== top) {
        virtualConfig.isVirtualScroll.value && virtualConfig.handleScroll();
      } else {
        lastScrollY = -1;
      }
      lastScrollY = top;
    };
    var cursorStyle = VueCompositionAPI.computed(function () {
      return {
        position: "absolute",
        width: "1px",
        height: "1px",
        transition: "transform 0.2s",
        transform: "translate(0, ".concat(virtualConfig.scrollHeight.value, "px)"),
        "-ms-transform": "translate(0, ".concat(virtualConfig.scrollHeight.value, "px)"),
        "-moz-transform": "translate(0, ".concat(virtualConfig.scrollHeight.value, "px)"),
        "-webkit-transform": "translate(0, ".concat(virtualConfig.scrollHeight.value, "px)")
      };
    });
    var listStyle = VueCompositionAPI.computed(function () {
      return {
        transform: "translate(0, ".concat(virtualConfig.translateY.value, "px)"),
        "-ms-transform": "translate(0, ".concat(virtualConfig.translateY.value, "px)"),
        "-moz-transform": "translate(0, ".concat(virtualConfig.translateY.value, "px)"),
        "-webkit-transform": "translate(0, ".concat(virtualConfig.translateY.value, "px)")
      };
    });
    return {
      virtualConfig: virtualConfig,
      cursorStyle: cursorStyle,
      listStyle: listStyle,
      isVirtualScroll: isVirtualScroll,
      onInnerVirtualScroll: onInnerVirtualScroll
    };
  };

  function ownKeys$P(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$O(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$P(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$P(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var useListItems = function useListItems() {
    var instance = VueCompositionAPI.getCurrentInstance();
    var currentSlots = instance.proxy.$slots["default"] || [];
    var listItems = VueCompositionAPI.computed(function () {
      var computedListItems = [];
      currentSlots.forEach(function (child) {
        var componentName = getVNodeComponentName(child);
        if (componentName && componentName === getVueComponentName(_ListItem)) {
          computedListItems.push(_objectSpread$O(_objectSpread$O({
            "class": child.data.staticClass,
            style: child.data.staticStyle
          }, child.componentOptions.propsData), {}, {
            slots: function slots() {
              return child.componentOptions.children;
            }
          }));
        }
      });
      return computedListItems;
    });
    return {
      listItems: listItems
    };
  };

  var _List = VueCompositionAPI.defineComponent({
    name: "TList",
    props: props$f,
    setup: function setup(props2, _ref) {
      var emit = _ref.emit;
      var listRef = VueCompositionAPI.ref();
      var _useConfig = useConfig("list"),
        globalConfig = _useConfig.globalConfig;
      var componentName = usePrefixClass("list");
      var _useCommonClassName = useCommonClassName$1(),
        SIZE = _useCommonClassName.SIZE;
      var _useListItems = useListItems(),
        listItems = _useListItems.listItems;
      var listClass = VueCompositionAPI.computed(function () {
        return ["".concat(componentName.value), SIZE.value[props2.size], _defineProperty$2(_defineProperty$2(_defineProperty$2({}, "".concat(componentName.value, "--split"), props2.split), "".concat(componentName.value, "--stripe"), props2.stripe), "".concat(componentName.value, "--vertical-action"), props2.layout === "vertical")];
      });
      var loadingClass = VueCompositionAPI.computed(function () {
        return isString(props2.asyncLoading) && ["loading", "load-more"].includes(props2.asyncLoading) ? "".concat(componentName.value, "__load ").concat(componentName.value, "__load--").concat(props2.asyncLoading) : "".concat(componentName.value, "__load");
      });
      var _useListVirtualScroll = useListVirtualScroll(props2.scroll, listRef, listItems),
        virtualConfig = _useListVirtualScroll.virtualConfig,
        cursorStyle = _useListVirtualScroll.cursorStyle,
        listStyle = _useListVirtualScroll.listStyle,
        isVirtualScroll = _useListVirtualScroll.isVirtualScroll,
        onInnerVirtualScroll = _useListVirtualScroll.onInnerVirtualScroll;
      var handleScroll = function handleScroll(e) {
        var _props2$onScroll;
        var listElement = e.target;
        var scrollTop = listElement.scrollTop,
          scrollHeight = listElement.scrollHeight,
          clientHeight = listElement.clientHeight;
        if (isVirtualScroll.value) onInnerVirtualScroll(e);
        var scrollParams = {
          e: e,
          scrollTop: scrollTop,
          scrollBottom: scrollHeight - clientHeight - scrollTop
        };
        emit("scroll", scrollParams);
        (_props2$onScroll = props2.onScroll) === null || _props2$onScroll === void 0 || _props2$onScroll.call(props2, scrollParams);
      };
      var handleLoadMore = function handleLoadMore(e) {
        var _props2$onLoadMore;
        if (isString(props2.asyncLoading) && props2.asyncLoading !== LOAD_MORE) return;
        emit("load-more", {
          e: e
        });
        (_props2$onLoadMore = props2.onLoadMore) === null || _props2$onLoadMore === void 0 || _props2$onLoadMore.call(props2, {
          e: e
        });
      };
      return {
        componentName: componentName,
        listClass: listClass,
        loadingClass: loadingClass,
        handleScroll: handleScroll,
        handleLoadMore: handleLoadMore,
        listRef: listRef,
        globalConfig: globalConfig,
        virtualConfig: virtualConfig,
        cursorStyle: cursorStyle,
        listStyle: listStyle,
        isVirtualScroll: isVirtualScroll
      };
    },
    render: function render() {
      var _this = this;
      var h = arguments[0];
      var isVirtualScroll = this.isVirtualScroll,
        cursorStyle = this.cursorStyle,
        listStyle = this.listStyle,
        componentName = this.componentName,
        globalConfig = this.globalConfig,
        virtualConfig = this.virtualConfig;
      var propsHeaderContent = renderTNodeJSX(this, "header");
      var propsFooterContent = renderTNodeJSX(this, "footer");
      var renderLoading = function renderLoading() {
        if (_this.asyncLoading && isString(_this.asyncLoading)) {
          if (_this.asyncLoading === LOADING) {
            return h("div", [h(Loading), h("span", [globalConfig.loadingText])]);
          }
          if (_this.asyncLoading === LOAD_MORE) {
            return h("span", [globalConfig.loadingMoreText]);
          }
        }
        return renderTNodeJSX(_this, "asyncLoading");
      };
      return h("div", {
        "class": this.listClass,
        "on": {
          "scroll": this.handleScroll
        },
        "ref": "listRef",
        "style": isVirtualScroll ? "position:relative" : void 0
      }, [propsHeaderContent ? h("div", {
        "class": "".concat(componentName, "__header")
      }, [propsHeaderContent]) : null, isVirtualScroll ? h("div", [h("div", {
        "style": cursorStyle
      }), h("ul", {
        "class": "".concat(componentName, "__inner"),
        "style": listStyle
      }, [virtualConfig.visibleData.value.map(function (item) {
        return h(_ListItem, helper([{}, omit$2(item, "slots"), {
          "scopedSlots": {
            "default": item.slots
          }
        }]));
      })])]) : h("ul", {
        "class": "".concat(componentName, "__inner")
      }, [renderTNodeJSX(this, "default")]), propsFooterContent ? h("div", {
        "class": "".concat(componentName, "__footer")
      }, [propsFooterContent]) : null, h("div", {
        "class": this.loadingClass,
        "on": {
          "click": this.handleLoadMore
        }
      }, [renderLoading()])]);
    }
  });

  var props$e = {
    avatar: {
      type: [String, Function]
    },
    description: {
      type: [String, Function]
    },
    image: {
      type: [String, Function]
    },
    title: {
      type: [String, Function]
    }
  };

  var classPrefixMixins$6 = getClassPrefixMixins("list-item__meta");
  var _ListItemMeta = mixins(classPrefixMixins$6).extend({
    name: "TListItemMeta",
    props: props$e,
    methods: {
      renderAvatar: function renderAvatar() {
        var h = this.$createElement;
        if (this.avatar || this.$scopedSlots.avatar) {
          console.warn("`avatar` is going to be deprecated, please use `image` instead");
        }
        var thumbnail = renderContent(this, "avatar", "image");
        if (!thumbnail) return;
        if (typeof thumbnail === "string") {
          return h("div", {
            "class": "".concat(this.componentName, "-avatar")
          }, [h("img", {
            "attrs": {
              "src": thumbnail
            }
          })]);
        }
        return h("div", {
          "class": "".concat(this.componentName, "-avatar")
        }, [thumbnail]);
      }
    },
    render: function render() {
      var h = arguments[0];
      var propsTitleContent = renderTNodeJSX(this, "title");
      var propsDescriptionContent = renderTNodeJSX(this, "description");
      var listItemMetaContent = [this.renderAvatar(), h("div", {
        "class": "".concat(this.componentName, "-content")
      }, [propsTitleContent && h("h3", {
        "class": "".concat(this.componentName, "-title")
      }, [propsTitleContent]), propsDescriptionContent && h("p", {
        "class": "".concat(this.componentName, "-description")
      }, [propsDescriptionContent])])];
      return h("div", {
        "class": this.componentName
      }, [listItemMetaContent]);
    }
  });

  var List = withInstall$1(_List);
  var ListItem = withInstall$1(_ListItem);
  var ListItemMeta = withInstall$1(_ListItemMeta);

  var PRO_THEME = {
    LINE: "line",
    PLUMP: "plump",
    CIRCLE: "circle"
  };
  var CIRCLE_SIZE = {
    SMALL: "small",
    MEDIUM: "medium",
    LARGE: "large"
  };
  var CIRCLE_SIZE_PX = {
    SMALL: 72,
    MEDIUM: 112,
    LARGE: 160
  };
  var CIRCLE_FONT_SIZE_RATIO = {
    SMALL: 14 / CIRCLE_SIZE_PX.SMALL,
    MEDIUM: 20 / CIRCLE_SIZE_PX.MEDIUM,
    LARGE: 36 / CIRCLE_SIZE_PX.LARGE
  };
  var STATUS_ICON = ["success", "error", "warning"];

  var props$d = {
    color: {
      type: [String, Object, Array],
      "default": ""
    },
    label: {
      type: [String, Boolean, Function],
      "default": true
    },
    percentage: {
      type: Number,
      "default": 0
    },
    size: {
      type: [String, Number],
      "default": "medium"
    },
    status: {
      type: String,
      validator: function validator(val) {
        return ["success", "error", "warning", "active"].includes(val);
      }
    },
    strokeWidth: {
      type: [String, Number]
    },
    theme: {
      type: String,
      "default": "line",
      validator: function validator(val) {
        return ["line", "plump", "circle"].includes(val);
      }
    },
    trackColor: {
      type: String,
      "default": ""
    }
  };

  function ownKeys$O(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$N(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$O(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$O(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$5 = getClassPrefixMixins("progress");
  var _Progress = mixins(classPrefixMixins$5, getGlobalIconMixins()).extend({
    name: "TProgress",
    props: _objectSpread$N({}, props$d),
    computed: {
      statusStyle: function statusStyle() {
        if (!this.status && this.percentage >= 100) {
          return "success";
        }
        return this.status;
      },
      themeClass: function themeClass() {
        var Line = PRO_THEME.LINE;
        if (this.theme === Line) {
          return "thin";
        }
        return this.theme;
      },
      trackBgStyle: function trackBgStyle() {
        var strokeWidth = this.strokeWidth;
        var height = typeof strokeWidth === "string" ? strokeWidth : "".concat(strokeWidth, "px");
        var Plump = PRO_THEME.PLUMP;
        if (this.theme === Plump) {
          height = "";
        }
        return {
          height: height,
          backgroundColor: this.trackColor,
          borderRadius: height
        };
      },
      circleStrokeStyle: function circleStrokeStyle() {
        return {
          stroke: this.trackColor
        };
      },
      barStyle: function barStyle() {
        return {
          width: "".concat(this.percentage, "%"),
          background: this.color && getBackgroundColor(this.color)
        };
      },
      circlePathStyle: function circlePathStyle() {
        var strokeColor = _typeof$2(this.color) === "object" ? "" : this.color;
        return {
          stroke: strokeColor
        };
      },
      isShowIcon: function isShowIcon() {
        return STATUS_ICON.includes(this.status) && typeof this.label === "boolean";
      },
      diameter: function diameter() {
        var diameter = CIRCLE_SIZE_PX.MEDIUM;
        if (!this.size) {
          return diameter;
        }
        var SMALL = CIRCLE_SIZE.SMALL,
          LARGE = CIRCLE_SIZE.LARGE,
          MEDIUM = CIRCLE_SIZE.MEDIUM;
        switch (this.size) {
          case SMALL:
            diameter = CIRCLE_SIZE_PX.SMALL;
            break;
          case MEDIUM:
            diameter = CIRCLE_SIZE_PX.MEDIUM;
            break;
          case LARGE:
            diameter = CIRCLE_SIZE_PX.LARGE;
            break;
          default:
            diameter = Number(this.size);
            break;
        }
        return diameter;
      },
      rPoints: function rPoints() {
        return this.diameter / 2;
      },
      radius: function radius() {
        return this.rPoints - this.circleStrokeWidth / 2;
      },
      circleStyle: function circleStyle() {
        if (this.theme !== PRO_THEME.CIRCLE) {
          return {};
        }
        var fontSize = this.diameter * CIRCLE_FONT_SIZE_RATIO.MEDIUM;
        if (this.diameter <= CIRCLE_SIZE_PX.SMALL) {
          fontSize = this.diameter * CIRCLE_FONT_SIZE_RATIO.SMALL;
        } else if (this.diameter >= CIRCLE_SIZE_PX.LARGE) {
          fontSize = this.diameter * CIRCLE_FONT_SIZE_RATIO.LARGE;
        }
        return {
          width: "".concat(this.diameter, "px"),
          height: "".concat(this.diameter, "px"),
          fontSize: "".concat(fontSize, "px")
        };
      },
      circleStrokeWidth: function circleStrokeWidth() {
        var defaultWidth = this.size === CIRCLE_SIZE.SMALL ? 4 : 6;
        return this.strokeWidth ? Number(this.strokeWidth) : defaultWidth;
      },
      strokeDashArr: function strokeDashArr() {
        var radius = (this.diameter - this.circleStrokeWidth) / 2;
        var perimeter = Math.PI * 2 * radius;
        var percent = this.percentage / 100;
        return "".concat(perimeter * percent, "  ").concat(perimeter * (1 - percent));
      },
      plumpStyles: function plumpStyles() {
        return {};
      }
    },
    methods: {
      getIconMap: function getIconMap() {
        var _this$useGlobalIcon = this.useGlobalIcon({
            CloseCircleFilledIcon: TdCloseCircleFilledIcon,
            CheckCircleFilledIcon: TdCheckCircleFilledIcon,
            ErrorCircleFilledIcon: TdErrorCircleFilledIcon,
            CloseIcon: TdCloseIcon,
            CheckIcon: TdCheckIcon,
            ErrorIcon: TdErrorIcon
          }),
          CloseCircleFilledIcon = _this$useGlobalIcon.CloseCircleFilledIcon,
          CheckCircleFilledIcon = _this$useGlobalIcon.CheckCircleFilledIcon,
          ErrorCircleFilledIcon = _this$useGlobalIcon.ErrorCircleFilledIcon,
          CloseIcon = _this$useGlobalIcon.CloseIcon,
          CheckIcon = _this$useGlobalIcon.CheckIcon,
          ErrorIcon = _this$useGlobalIcon.ErrorIcon;
        var CIRCLE_ICONS = {
          success: CheckIcon,
          warning: ErrorIcon,
          error: CloseIcon
        };
        var NORMAL_ICONS = {
          success: CheckCircleFilledIcon,
          warning: ErrorCircleFilledIcon,
          error: CloseCircleFilledIcon
        };
        return this.theme === PRO_THEME.CIRCLE ? CIRCLE_ICONS : NORMAL_ICONS;
      },
      getLabelContent: function getLabelContent() {
        var h = this.$createElement;
        var labelContent = "".concat(this.percentage, "%");
        var status = this.status || "";
        if (STATUS_ICON.includes(status) && this.theme !== PRO_THEME.PLUMP) {
          var components = this.getIconMap();
          var component = components[status];
          if (component) {
            labelContent = h(component, {
              "class": ["".concat(this.componentName, "__icon")]
            });
          }
        }
        return labelContent;
      }
    },
    render: function render() {
      var h = arguments[0];
      var labelContent = h("div", {
        "class": "".concat(this.componentName, "__info")
      }, [renderTNodeJSX(this, "label", this.getLabelContent())]);
      var PLUMP_SEPARATE = 10;
      var separateClasses = this.percentage > PLUMP_SEPARATE ? "".concat(this.componentName, "--over-ten") : "".concat(this.componentName, "--under-ten");
      return h("div", {
        "class": this.componentName
      }, [this.theme === PRO_THEME.LINE && h("div", {
        "class": "".concat(this.componentName, "--thin ").concat(this.componentName, "--status--").concat(this.statusStyle)
      }, [h("div", {
        "class": "".concat(this.componentName, "__bar"),
        "style": this.trackBgStyle
      }, [h("div", {
        "class": "".concat(this.componentName, "__inner"),
        "style": this.barStyle
      })]), labelContent]), this.theme === PRO_THEME.PLUMP && h("div", {
        "class": ["".concat(this.componentName, "__bar ").concat(this.componentName, "--plump ").concat(separateClasses), _defineProperty$2({}, "".concat(this.componentName, "--status--").concat(this.statusStyle), this.statusStyle)],
        "style": this.trackBgStyle
      }, [h("div", {
        "class": "".concat(this.componentName, "__inner"),
        "style": this.barStyle
      }, [this.percentage > PLUMP_SEPARATE && labelContent]), this.percentage <= PLUMP_SEPARATE && labelContent]), this.theme === PRO_THEME.CIRCLE && h("div", {
        "class": "".concat(this.componentName, "--circle ").concat(this.componentName, "--status--").concat(this.statusStyle),
        "style": this.circleStyle
      }, [labelContent, h("svg", {
        "attrs": {
          "width": this.diameter,
          "height": this.diameter,
          "viewBox": "0 0 ".concat(this.diameter, " ").concat(this.diameter)
        }
      }, [h("circle", {
        "attrs": {
          "cx": this.rPoints,
          "cy": this.rPoints,
          "r": this.radius,
          "stroke-width": this.circleStrokeWidth,
          "stroke": this.trackColor,
          "fill": "none"
        },
        "class": "".concat(this.componentName, "__circle-outer"),
        "style": this.circleStrokeStyle
      }), this.percentage > 0 && h("circle", {
        "attrs": {
          "cx": this.rPoints,
          "cy": this.rPoints,
          "r": this.radius,
          "stroke-width": this.circleStrokeWidth,
          "fill": "none",
          "stroke-linecap": "round",
          "transform": "matrix(0,-1,1,0,0,".concat(this.diameter, ")"),
          "stroke-dasharray": this.strokeDashArr
        },
        "class": "".concat(this.componentName, "__circle-inner"),
        "style": this.circlePathStyle
      })])])]);
    }
  });

  var Progress = withInstall$1(_Progress);

  var props$c = {
    animation: {
      type: String,
      validator: function validator(val) {
        return ["gradient", "flashed"].includes(val);
      }
    },
    loading: {
      type: Boolean,
      "default": true
    },
    rowCol: {
      type: Array
    },
    theme: {
      type: String,
      validator: function validator(val) {
        return ["text", "avatar", "paragraph", "avatar-text", "tab", "article"].includes(val);
      }
    },
    delay: {
      type: Number,
      "default": 0
    }
  };

  function ownKeys$N(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$M(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$N(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$N(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$4 = getClassPrefixMixins("skeleton");
  var ThemeMap = {
    text: [1],
    avatar: [{
      type: "circle",
      size: "56px"
    }],
    paragraph: [1, 1, {
      width: "70%"
    }],
    "avatar-text": [[{
      type: "circle"
    }, {
      type: "text",
      height: "32px"
    }]],
    tab: [{
      height: "30px"
    }, {
      height: "200px"
    }],
    article: [{
      type: "rect",
      height: "30px",
      width: "100%"
    }, {
      type: "rect",
      height: "200px",
      width: "100%"
    }, [{
      type: "text",
      height: "30px"
    }, {
      type: "text",
      height: "30px"
    }, {
      type: "text",
      height: "30px"
    }], [{
      type: "text",
      height: "30px"
    }, {
      type: "text",
      height: "30px"
    }], [{
      type: "text",
      height: "30px"
    }, {
      type: "text",
      height: "30px"
    }], [{
      type: "text",
      height: "30px"
    }, {
      type: "text",
      height: "30px"
    }]]
  };
  var _Skeleton = mixins(classPrefixMixins$4).extend({
    name: "TSkeleton",
    props: _objectSpread$M({}, props$c),
    data: function data() {
      return {
        delayShowLoading: this.delay <= 0 ? this.loading : false,
        delayTimer: 0
      };
    },
    watch: {
      loading: {
        handler: function handler(val) {
          if (this.delay <= 0) {
            this.delayShowLoading = this.loading;
            return;
          }
          this.handleDelay(val);
        },
        immediate: true
      }
    },
    methods: {
      handleDelay: function handleDelay(loading) {
        var _this = this;
        if (loading) {
          clearTimeout(this.delayTimer);
          this.delayTimer = window.setTimeout(function () {
            _this.delayShowLoading = _this.loading;
          }, this.delay);
        } else {
          this.delayShowLoading = loading;
        }
      },
      renderCols: function renderCols(_cols) {
        var _this2 = this;
        var h = this.$createElement;
        var getColItemClass = function getColItemClass(obj) {
          return ["".concat(_this2.componentName, "__col"), "".concat(_this2.componentName, "--type-").concat(obj.type || "text"), _defineProperty$2({}, "".concat(_this2.componentName, "--animation-").concat(_this2.animation), _this2.animation)];
        };
        var getColItemStyle = function getColItemStyle(obj) {
          var styleName = ["width", "height", "marginRight", "marginLeft", "margin", "size", "background", "backgroundColor"];
          var style = {};
          styleName.forEach(function (name) {
            if (name in obj) {
              var px = isNumber(obj[name]) ? "".concat(obj[name], "px") : obj[name];
              if (name === "size") {
                var _ref2 = [px, px];
                style.width = _ref2[0];
                style.height = _ref2[1];
              } else {
                style[name] = px;
              }
            }
          });
          return style;
        };
        var cols = [];
        if (Array.isArray(_cols)) {
          cols = _cols;
        } else if (isNumber(_cols)) {
          cols = new Array(_cols).fill({
            type: "text"
          });
        } else {
          cols = [_cols];
        }
        return cols.map(function (obj) {
          return h("div", {
            "class": getColItemClass(obj),
            "style": getColItemStyle(obj)
          }, [typeof obj.content === "function" ? obj.content(_this2.$createElement) : obj.content]);
        });
      },
      renderRowCol: function renderRowCol(_rowCol) {
        var _this3 = this;
        var h = this.$createElement;
        var rowCol = _rowCol || this.rowCol;
        var getBlockClass = function getBlockClass() {
          return ["".concat(_this3.componentName, "__row")];
        };
        return rowCol.map(function (item) {
          return h("div", {
            "class": getBlockClass()
          }, [_this3.renderCols(item)]);
        });
      }
    },
    render: function render() {
      var h = arguments[0];
      var content = renderContent(this, "default", "content");
      if (this.$scopedSlots["default"] && !this.delayShowLoading) {
        return h("div", [content]);
      }
      if (!this.delayShowLoading) {
        return;
      }
      var children = [];
      if (this.theme) {
        children.push(this.renderRowCol(ThemeMap[this.theme]));
      }
      if (this.rowCol) {
        children.push(this.renderRowCol(this.rowCol));
      }
      if (!this.theme && !this.rowCol) {
        children.push(this.renderRowCol([1, 1, 1, {
          width: "70%"
        }]));
      }
      return h("div", {
        "class": this.componentName
      }, [children]);
    }
  });

  var Skeleton = withInstall$1(_Skeleton);

  var props$b = {
    animation: {
      type: Object
    },
    animationStart: Boolean,
    color: {
      type: String,
      validator: function validator(val) {
        if (!val) return true;
        return ["black", "blue", "red", "orange", "green"].includes(val);
      }
    },
    decimalPlaces: {
      type: Number
    },
    extra: {
      type: [String, Function]
    },
    format: {
      type: Function
    },
    loading: Boolean,
    prefix: {
      type: [String, Function]
    },
    separator: {
      type: String,
      "default": ","
    },
    suffix: {
      type: [String, Function]
    },
    title: {
      type: [String, Function]
    },
    trend: {
      type: String,
      validator: function validator(val) {
        if (!val) return true;
        return ["increase", "decrease"].includes(val);
      }
    },
    trendPlacement: {
      type: String,
      "default": "left",
      validator: function validator(val) {
        if (!val) return true;
        return ["left", "right"].includes(val);
      }
    },
    unit: {
      type: [String, Function]
    },
    value: {
      type: Number
    }
  };

  var quartOut = function quartOut(t) {
    return 1 - Math.abs(Math.pow(t - 1, 4));
  };
  var Tween = /*#__PURE__*/function () {
    function Tween(_ref) {
      var _this = this;
      var from = _ref.from,
        to = _ref.to,
        _ref$duration = _ref.duration,
        duration = _ref$duration === void 0 ? 200 : _ref$duration,
        onStart = _ref.onStart,
        _ref$onUpdate = _ref.onUpdate,
        onUpdate = _ref$onUpdate === void 0 ? function () {} : _ref$onUpdate,
        onFinish = _ref.onFinish;
      _classCallCheck(this, Tween);
      _defineProperty$2(this, "from", void 0);
      _defineProperty$2(this, "to", void 0);
      _defineProperty$2(this, "duration", void 0);
      _defineProperty$2(this, "onStart", void 0);
      _defineProperty$2(this, "onUpdate", void 0);
      _defineProperty$2(this, "onFinish", void 0);
      _defineProperty$2(this, "startTime", void 0);
      _defineProperty$2(this, "started", void 0);
      _defineProperty$2(this, "finished", void 0);
      _defineProperty$2(this, "timer", void 0);
      _defineProperty$2(this, "keys", void 0);
      _defineProperty$2(this, "time", 0);
      _defineProperty$2(this, "elapsed", 0);
      this.from = from;
      this.to = to;
      this.duration = duration;
      this.onStart = onStart;
      this.onUpdate = onUpdate;
      this.onFinish = onFinish;
      this.startTime = Date.now();
      this.started = false;
      this.finished = false;
      this.timer = null;
      this.keys = {};
      Object.entries(from).forEach(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          key = _ref3[0],
          value = _ref3[1];
        if (_this.to[key] === void 0) {
          _this.to[key] = value;
        }
      });
      Object.entries(to).forEach(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
          key = _ref5[0],
          value = _ref5[1];
        if (_this.from[key] === void 0) {
          _this.from[key] = value;
        }
      });
    }
    return _createClass(Tween, [{
      key: "update",
      value: function update() {
        var _this2 = this;
        this.time = Date.now();
        if (this.time < this.startTime || this.finished) return;
        if (this.elapsed >= this.duration) {
          var _this$onFinish;
          this.finished = true;
          (_this$onFinish = this.onFinish) === null || _this$onFinish === void 0 || _this$onFinish.call(this, this.keys);
          return;
        }
        var elapsed = Math.min(this.time - this.startTime, this.duration);
        this.elapsed = elapsed;
        var progress = quartOut(elapsed / this.duration);
        Object.keys(this.to).forEach(function (key) {
          var delta = _this2.to[key] - _this2.from[key];
          _this2.keys[key] = _this2.from[key] + delta * progress;
        });
        if (!this.started) {
          var _this$onStart;
          (_this$onStart = this.onStart) === null || _this$onStart === void 0 || _this$onStart.call(this, this.keys);
          this.started = true;
        }
        this.onUpdate(this.keys);
      }
    }, {
      key: "polyfillStart",
      value: function polyfillStart() {
        var _this3 = this;
        var elapsed = Date.now() - this.startTime;
        var interval = quartOut(elapsed / this.duration);
        this.timer = setInterval(function () {
          _this3.update();
          if (_this3.finished) {
            clearInterval(_this3.timer);
          }
        }, interval);
      }
    }, {
      key: "normalStart",
      value: function normalStart() {
        var _this4 = this;
        var _tick = function tick() {
          _this4.update();
          _this4.timer = requestAnimationFrame(_tick);
          if (_this4.finished) {
            cancelAnimationFrame(_this4.timer);
            _this4.timer = null;
          }
        };
        _tick();
      }
    }, {
      key: "start",
      value: function start() {
        this.startTime = Date.now();
        if (getIEVersion$1() < 10) this.polyfillStart();else this.normalStart();
      }
    }, {
      key: "stop",
      value: function stop() {
        if (getIEVersion$1() < 10) clearInterval(this.timer);else cancelAnimationFrame(this.timer);
        this.timer = null;
      }
    }]);
  }();

  var COLOR_MAP = {
    black: "var(--td-text-color-primary)",
    blue: "var(--td-brand-color)",
    red: "var(--td-error-color)",
    orange: "var(--td-warning-color)",
    green: "var(--td-success-color)"
  };
  function getFormatValue(value, decimalPlaces, separator) {
    var options = {
      minimumFractionDigits: decimalPlaces !== null && decimalPlaces !== void 0 ? decimalPlaces : 0,
      maximumFractionDigits: decimalPlaces !== null && decimalPlaces !== void 0 ? decimalPlaces : 20,
      useGrouping: !!separator
    };
    return value.toLocaleString(void 0, options).replace(/,|，/g, separator);
  }

  var _Statistic = VueCompositionAPI.defineComponent({
    name: "Statistic",
    props: props$b,
    setup: function setup(props2) {
      var _props2$animation$val, _props2$animation;
      var classPrefix = usePrefixClass("statistic");
      var _toRefs = VueCompositionAPI.toRefs(props2),
        value = _toRefs.value,
        decimalPlaces = _toRefs.decimalPlaces,
        separator = _toRefs.separator,
        color = _toRefs.color;
      var innerValue = VueCompositionAPI.ref((_props2$animation$val = (_props2$animation = props2.animation) === null || _props2$animation === void 0 ? void 0 : _props2$animation.valueFrom) !== null && _props2$animation$val !== void 0 ? _props2$animation$val : props2.value);
      var tween = VueCompositionAPI.ref(null);
      var numberValue = VueCompositionAPI.computed(function () {
        return isNumber(props2.value) ? props2.value : 0;
      });
      var valueStyle = VueCompositionAPI.computed(function () {
        return {
          color: COLOR_MAP[color.value] || color.value
        };
      });
      var innerDecimalPlaces = VueCompositionAPI.computed(function () {
        var _ref, _decimalPlaces$value, _numberValue$value$to;
        return (_ref = (_decimalPlaces$value = decimalPlaces.value) !== null && _decimalPlaces$value !== void 0 ? _decimalPlaces$value : (_numberValue$value$to = numberValue.value.toString().split(".")[1]) === null || _numberValue$value$to === void 0 ? void 0 : _numberValue$value$to.length) !== null && _ref !== void 0 ? _ref : 0;
      });
      var start = function start() {
        var _props2$animation$val2, _props2$animation2;
        var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (_props2$animation$val2 = (_props2$animation2 = props2.animation) === null || _props2$animation2 === void 0 ? void 0 : _props2$animation2.valueFrom) !== null && _props2$animation$val2 !== void 0 ? _props2$animation$val2 : 0;
        var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : numberValue.value;
        if (from !== to) {
          var _tween$value;
          tween.value = new Tween({
            from: {
              value: from
            },
            to: {
              value: to
            },
            duration: props2.animation.duration,
            onUpdate: function onUpdate(keys) {
              innerValue.value = Number(keys.value.toFixed(innerDecimalPlaces.value));
            },
            onFinish: function onFinish() {
              innerValue.value = to;
            }
          });
          (_tween$value = tween.value) === null || _tween$value === void 0 || _tween$value.start();
        }
      };
      var formatValue = VueCompositionAPI.computed(function () {
        if (isFunction(props2.format)) {
          return props2.format(innerValue.value);
        }
        return getFormatValue(innerValue.value, decimalPlaces.value, separator.value);
      });
      VueCompositionAPI.onMounted(function () {
        return props2.animation && props2.animationStart && start();
      });
      VueCompositionAPI.watch(function () {
        return props2.animationStart;
      }, function (value2) {
        if (props2.animation && value2 && !tween.value) {
          start();
        }
      });
      VueCompositionAPI.watch(value, function (value2) {
        if (tween.value) {
          var _tween$value2;
          (_tween$value2 = tween.value) === null || _tween$value2 === void 0 || _tween$value2.stop();
          tween.value = null;
        }
        innerValue.value = value2;
        if (props2.animationStart && props2.animation) {
          start();
        }
      });
      return {
        start: start,
        classPrefix: classPrefix,
        formatValue: formatValue,
        valueStyle: valueStyle
      };
    },
    render: function render() {
      var h = arguments[0];
      var classPrefix = this.classPrefix,
        formatValue = this.formatValue,
        valueStyle = this.valueStyle,
        loading = this.loading,
        trendPlacement = this.trendPlacement,
        trend = this.trend;
      var _useGlobalIcon = useGlobalIcon({
          ArrowTriangleUpFilledIcon: TDArrowTriangleUpFilledIcon
        }),
        ArrowTriangleUpFilledIcon = _useGlobalIcon.ArrowTriangleUpFilledIcon;
      var _useGlobalIcon2 = useGlobalIcon({
          ArrowTriangleDownFilledIcon: TDArrowTriangleDownFilledIcon
        }),
        ArrowTriangleDownFilledIcon = _useGlobalIcon2.ArrowTriangleDownFilledIcon;
      var trendIcons = {
        increase: h(ArrowTriangleUpFilledIcon),
        decrease: h(ArrowTriangleDownFilledIcon)
      };
      var trendIcon = trend ? trendIcons[trend] : null;
      var prefix = renderTNodeJSX(this, "prefix") || (trendIcon && trendPlacement !== "right" ? trendIcon : null);
      var suffix = renderTNodeJSX(this, "suffix") || (trendIcon && trendPlacement === "right" ? trendIcon : null);
      var title = renderTNodeJSX(this, "title");
      var unit = renderTNodeJSX(this, "unit");
      var extra = renderTNodeJSX(this, "extra");
      return h("div", {
        "class": classPrefix
      }, [title && h("div", {
        "class": "".concat(classPrefix, "-title")
      }, [title]), h(Skeleton, {
        "attrs": {
          "animation": "gradient",
          "theme": "text",
          "loading": !!loading
        }
      }, [h("div", {
        "class": "".concat(classPrefix, "-content"),
        "style": valueStyle
      }, [prefix && h("span", {
        "class": "".concat(classPrefix, "-content-prefix")
      }, [prefix]), h("span", {
        "class": "".concat(classPrefix, "-content-value")
      }, [formatValue]), unit && h("span", {
        "class": "".concat(classPrefix, "-content-unit")
      }, [unit]), suffix && h("span", {
        "class": "".concat(classPrefix, "-content-suffix")
      }, [suffix])])]), extra && h("div", {
        "class": "".concat(classPrefix, "-extra")
      }, [extra])]);
    }
  });

  var Statistic = withInstall$1(_Statistic);

  var props$a = {
    animation: {
      type: String,
      "default": "slide",
      validator: function validator(val) {
        if (!val) return true;
        return ["slide", "fade"].includes(val);
      }
    },
    autoplay: {
      type: Boolean,
      "default": true
    },
    current: {
      type: Number,
      "default": 0
    },
    defaultCurrent: {
      type: Number,
      "default": 0
    },
    direction: {
      type: String,
      "default": "horizontal",
      validator: function validator(val) {
        if (!val) return true;
        return ["horizontal", "vertical"].includes(val);
      }
    },
    duration: {
      type: Number,
      "default": 300
    },
    height: {
      type: Number
    },
    interval: {
      type: Number,
      "default": 5e3
    },
    loop: {
      type: Boolean,
      "default": true
    },
    navigation: {
      type: [Object, Function]
    },
    stopOnHover: {
      type: Boolean,
      "default": true
    },
    theme: {
      type: String,
      "default": "light",
      validator: function validator(val) {
        if (!val) return true;
        return ["light", "dark"].includes(val);
      }
    },
    trigger: {
      type: String,
      "default": "hover",
      validator: function validator(val) {
        if (!val) return true;
        return ["hover", "click"].includes(val);
      }
    },
    type: {
      type: String,
      "default": "default",
      validator: function validator(val) {
        if (!val) return true;
        return ["default", "card"].includes(val);
      }
    },
    onChange: Function
  };

  function ownKeys$M(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$L(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$M(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$M(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$3 = getClassPrefixMixins("swiper");
  var swiperItemProps = {
    index: {
      type: Number
    },
    currentIndex: {
      type: Number
    },
    isSwitching: {
      type: Boolean,
      "default": false
    },
    getWrapAttribute: {
      type: Function
    },
    swiperItemLength: {
      type: Number,
      "default": 0
    }
  };
  var CARD_SCALE = 210 / 332;
  var itemWidth = 0.415;
  var _SwiperItem = mixins(classPrefixMixins$3).extend({
    name: "TSwiperItem",
    props: _objectSpread$L(_objectSpread$L({}, props$a), swiperItemProps),
    computed: {
      active: function active() {
        return this.index === this.currentIndex;
      },
      disposeIndex: function disposeIndex() {
        if (this.type !== "card") return 0;
        if (this.currentIndex === 0 && this.index === this.swiperItemLength - 1) {
          return -1;
        }
        if (this.currentIndex === this.swiperItemLength - 1 && this.index === 0) {
          return this.swiperItemLength;
        }
        if (this.index < this.currentIndex - 1 && this.currentIndex - this.index >= this.swiperItemLength / 2) {
          return this.swiperItemLength + 1;
        }
        if (this.index > this.currentIndex + 1 && this.index - this.currentIndex >= this.swiperItemLength / 2) {
          return -2;
        }
        return this.index;
      },
      translateX: function translateX() {
        if (this.type !== "card") return 0;
        var wrapWidth = this.getWrapAttribute("offsetWidth");
        var translateIndex = !this.active && this.swiperItemLength > 2 ? this.disposeIndex : this.index;
        var inStage = Math.abs(translateIndex - this.currentIndex) <= 1;
        if (inStage) {
          return wrapWidth * ((translateIndex - this.currentIndex) * (1 - itemWidth * CARD_SCALE) - itemWidth + 1) / 2;
        }
        if (translateIndex < this.currentIndex) {
          return -itemWidth * (1 + CARD_SCALE) * wrapWidth / 2;
        }
        return (2 + itemWidth * (CARD_SCALE - 1)) * wrapWidth / 2;
      },
      zIndex: function zIndex() {
        if (this.type !== "card") return 0;
        var translateIndex = !this.active && this.swiperItemLength > 2 ? this.disposeIndex : this.index;
        var isActivity = translateIndex === this.currentIndex;
        var inStage = Math.round(Math.abs(translateIndex - this.currentIndex)) <= 1;
        if (isActivity) {
          return 2;
        }
        if (inStage) {
          return 1;
        }
        return 0;
      },
      itemStyle: function itemStyle() {
        if (this.animation === "fade") {
          return {
            opacity: this.active ? 1 : 0,
            transition: this.isSwitching ? "opacity ".concat(this.duration / 1e3, "s") : "",
            zIndex: this.active ? 1 : 0
          };
        }
        if (this.type === "card") {
          var translateIndex = !this.active && this.swiperItemLength > 2 ? this.disposeIndex : this.index;
          var isActivity = translateIndex === this.currentIndex;
          return {
            transform: "translateX(".concat(this.translateX, "px) scale(").concat(isActivity ? 1 : CARD_SCALE, ")"),
            transition: "transform ".concat(this.duration / 1e3, "s ease"),
            zIndex: this.zIndex
          };
        }
        return {};
      }
    },
    render: function render() {
      var _this$$scopedSlots$de, _this$$scopedSlots;
      var h = arguments[0];
      return h("div", {
        "class": ["".concat(this.classPrefix, "-swiper__container__item"), _defineProperty$2(_defineProperty$2(_defineProperty$2({}, "".concat(this.classPrefix, "-swiper__card"), this.type === "card"), "".concat(this.classPrefix, "-is-active"), this.type === "card" && this.active), "".concat(this.classPrefix, "-swiper__fade"), this.animation === "fade")],
        "style": this.itemStyle
      }, [((_this$$scopedSlots$de = (_this$$scopedSlots = this.$scopedSlots)["default"]) === null || _this$$scopedSlots$de === void 0 ? void 0 : _this$$scopedSlots$de.call(_this$$scopedSlots, {})) || []]);
    }
  });

  function ownKeys$L(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$K(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$L(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$L(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$2 = getClassPrefixMixins("swiper");
  var defaultNavigation = {
    placement: "inside",
    showSlideBtn: "always",
    size: "medium",
    type: "bars"
  };
  var _Swiper = mixins(Vue__default["default"], classPrefixMixins$2, getGlobalIconMixins()).extend(_objectSpread$K(_objectSpread$K({
    name: "TSwiper",
    components: {
      TSwiperItem: _SwiperItem
    }
  }, {
    swiperTimer: 0,
    swiperSwitchingTimer: 0
  }), {}, {
    props: _objectSpread$K({}, props$a),
    data: function data() {
      return {
        currentIndex: 0,
        isHovering: false,
        isSwitching: false,
        swiperItemList: [],
        showArrow: false
      };
    },
    computed: {
      swiperItemLength: function swiperItemLength() {
        return this.swiperItemList.length;
      },
      navigationConfig: function navigationConfig() {
        return _objectSpread$K(_objectSpread$K({}, defaultNavigation), isVNode(this.navigation) ? {} : this.navigation);
      },
      isEnd: function isEnd() {
        if (this.type === "card") {
          return !this.loop && this.currentIndex + 1 >= this.swiperItemLength;
        }
        return !this.loop && this.currentIndex + 2 >= this.swiperItemLength;
      },
      propsToUpdateSetTimer: function propsToUpdateSetTimer() {
        return [this.autoplay, this.currentIndex, this.duration, this.interval];
      },
      swiperWrapClass: function swiperWrapClass() {
        return _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({}, "".concat(this.componentName, "__wrap"), true), "".concat(this.componentName, "--inside"), this.navigationConfig.placement === "inside"), "".concat(this.componentName, "--outside"), this.navigationConfig.placement === "outside"), "".concat(this.componentName, "--vertical"), this.direction === "vertical"), "".concat(this.componentName, "--large"), this.navigationConfig.size === "large"), "".concat(this.componentName, "--small"), this.navigationConfig.size === "small");
      },
      containerStyle: function containerStyle() {
        var offsetHeight = this.height ? "".concat(this.height, "px") : "".concat(this.getWrapAttribute("offsetHeight"), "px");
        if (this.type === "card" || this.animation === "fade") {
          return {
            height: offsetHeight
          };
        }
        if (this.animation === "slide") {
          if (this.direction === "vertical") {
            return {
              height: offsetHeight,
              transform: "translate3d(0, -".concat(this.currentIndex * 100, "%, 0px)"),
              transition: this.isSwitching ? "transform ".concat(this.duration / 1e3, "s ease") : ""
            };
          }
          return {
            msTransform: "translate3d(-".concat(this.currentIndex * 100, "%, 0px, 0px)"),
            WebkitTransform: "translate3d(-".concat(this.currentIndex * 100, "%, 0px, 0px)"),
            transform: "translate3d(-".concat(this.currentIndex * 100, "%, 0px, 0px)"),
            transition: this.isSwitching ? "transform ".concat(this.duration / 1e3, "s ease") : ""
          };
        }
        return {};
      },
      swiperItems: function swiperItems() {
        var _this = this;
        var h = this.$createElement;
        return this.swiperItemList.map(function (swiperItem, index) {
          return h(_SwiperItem, helper([{
            "attrs": {
              "index": index,
              "currentIndex": _this.currentIndex,
              "isSwitching": _this.isSwitching,
              "getWrapAttribute": _this.getWrapAttribute,
              "swiperItemLength": _this.swiperItemLength
            }
          }, {
            "props": _objectSpread$K(_objectSpread$K({}, _this.$props), swiperItem.propsData)
          }]), [swiperItem.children]);
        });
      }
    },
    watch: {
      propsToUpdateSetTimer: function propsToUpdateSetTimer() {
        this.setTimer();
      },
      isSwitching: function isSwitching() {
        var _this2 = this;
        if (this.isSwitching) {
          if (this.swiperSwitchingTimer) clearTimeout(this.swiperSwitchingTimer);
          this.swiperSwitchingTimer = setTimeout(function () {
            _this2.isSwitching = false;
            _this2.swiperSwitchingTimer = 0;
            if (_this2.isEnd) {
              _this2.clearTimer();
            }
          }, this.duration + 50);
        }
      },
      current: function current() {
        this.swiperTo(this.current, {
          source: "autoplay"
        });
      }
    },
    mounted: function mounted() {
      this.updateSwiperItems();
      this.setTimer();
      this.showArrow = this.navigationConfig.showSlideBtn === "always";
    },
    updated: function updated() {
      var _this3 = this;
      this.$nextTick(function () {
        _this3.updateSwiperItems();
      });
    },
    methods: {
      updateSwiperItems: function updateSwiperItems() {
        var _this$$scopedSlots$de,
          _this$$scopedSlots,
          _this4 = this;
        var originalChildren = ((_this$$scopedSlots$de = (_this$$scopedSlots = this.$scopedSlots)["default"]) === null || _this$$scopedSlots$de === void 0 ? void 0 : _this$$scopedSlots$de.call(_this$$scopedSlots, {})) || [];
        var swiperItemList = originalChildren.map(function (swiper) {
          return swiper.componentOptions;
        }).filter(function (swiper) {
          return kebabCase$1(swiper === null || swiper === void 0 ? void 0 : swiper.tag).endsWith("".concat(_this4.componentName, "-item"));
        });
        var isUnchange = swiperItemList.length === this.swiperItemList.length && this.swiperItemList.every(function (swiperItem, index) {
          return swiperItem === swiperItemList[index];
        });
        if (isUnchange) return;
        this.swiperItemList = swiperItemList;
      },
      setTimer: function setTimer() {
        var _this5 = this;
        if (this.autoplay && this.interval > 0) {
          this.clearTimer();
          this.swiperTimer = setTimeout(function () {
            _this5.swiperTo(_this5.currentIndex + 1, {
              source: "autoplay"
            });
          }, this.currentIndex === 0 ? this.interval - (this.duration + 50) : this.interval);
        }
      },
      clearTimer: function clearTimer() {
        if (this.swiperTimer) {
          clearTimeout(this.swiperTimer);
          this.swiperTimer = 0;
        }
      },
      onMouseEnter: function onMouseEnter() {
        this.isHovering = true;
        if (this.stopOnHover) {
          this.clearTimer();
        }
        if (this.navigationConfig.showSlideBtn === "hover") {
          this.showArrow = true;
        }
      },
      onMouseLeave: function onMouseLeave() {
        this.isHovering = false;
        if (!this.isEnd) {
          this.setTimer();
        }
        if (this.navigationConfig.showSlideBtn === "hover") {
          this.showArrow = false;
        }
      },
      onMouseEnterNavigationItem: function onMouseEnterNavigationItem(i) {
        if (this.trigger === "hover") {
          this.swiperTo(i, {
            source: "hover"
          });
        }
      },
      onClickNavigationItem: function onClickNavigationItem(i) {
        if (this.trigger === "click") {
          this.swiperTo(i, {
            source: "click"
          });
        }
      },
      swiperTo: function swiperTo(index, context) {
        var targetIndex = index % this.swiperItemLength;
        emitEvent$1(this, "change", targetIndex, context);
        this.isSwitching = true;
        this.currentIndex = targetIndex;
      },
      goNext: function goNext(context) {
        if (this.isSwitching) return;
        if (this.type === "card") {
          return this.swiperTo(this.currentIndex + 1 >= this.swiperItemLength ? 0 : this.currentIndex + 1, context);
        }
        return this.swiperTo(this.currentIndex + 1, context);
      },
      goPrevious: function goPrevious(context) {
        if (this.isSwitching) return;
        if (this.currentIndex - 1 < 0) {
          return this.swiperTo(this.swiperItemLength - 1, context);
        }
        return this.swiperTo(this.currentIndex - 1, context);
      },
      getWrapAttribute: function getWrapAttribute(attr) {
        var _this$$refs$swiperWra;
        return (_this$$refs$swiperWra = this.$refs.swiperWrap) === null || _this$$refs$swiperWra === void 0 || (_this$$refs$swiperWra = _this$$refs$swiperWra.parentNode) === null || _this$$refs$swiperWra === void 0 ? void 0 : _this$$refs$swiperWra[attr];
      },
      renderPagination: function renderPagination() {
        var _this6 = this;
        var h = this.$createElement;
        var fractionIndex = this.currentIndex + 1 > this.swiperItemLength ? 1 : this.currentIndex + 1;
        var _this$useGlobalIcon = this.useGlobalIcon({
            ChevronLeftIcon: TdChevronLeftIcon,
            ChevronRightIcon: TdChevronRightIcon
          }),
          ChevronLeftIcon = _this$useGlobalIcon.ChevronLeftIcon,
          ChevronRightIcon = _this$useGlobalIcon.ChevronRightIcon;
        return h("div", {
          "class": "".concat(this.componentName, "__arrow")
        }, [h("div", {
          "class": "".concat(this.componentName, "__arrow-left"),
          "on": {
            "click": function click() {
              return _this6.goPrevious({
                source: "click"
              });
            }
          }
        }, [h(ChevronLeftIcon)]), h("div", {
          "class": "".concat(this.componentName, "__navigation-text-fraction")
        }, [fractionIndex, "/", this.swiperItemLength]), h("div", {
          "class": "".concat(this.componentName, "__arrow-right"),
          "on": {
            "click": function click() {
              return _this6.goNext({
                source: "click"
              });
            }
          }
        }, [h(ChevronRightIcon)])]);
      },
      renderArrow: function renderArrow() {
        var _this7 = this;
        var h = this.$createElement;
        if (!this.showArrow) return null;
        var _this$useGlobalIcon2 = this.useGlobalIcon({
            ChevronLeftIcon: TdChevronLeftIcon,
            ChevronRightIcon: TdChevronRightIcon
          }),
          ChevronLeftIcon = _this$useGlobalIcon2.ChevronLeftIcon,
          ChevronRightIcon = _this$useGlobalIcon2.ChevronRightIcon;
        return h("div", {
          "class": ["".concat(this.componentName, "__arrow"), "".concat(this.componentName, "__arrow--default")]
        }, [h("div", {
          "class": "".concat(this.componentName, "__arrow-left"),
          "on": {
            "click": function click() {
              return _this7.goPrevious({
                source: "click"
              });
            }
          }
        }, [h(ChevronLeftIcon)]), h("div", {
          "class": "".concat(this.componentName, "__arrow-right"),
          "on": {
            "click": function click() {
              return _this7.goNext({
                source: "click"
              });
            }
          }
        }, [h(ChevronRightIcon)])]);
      },
      renderNavigation: function renderNavigation() {
        var _this8 = this;
        var h = this.$createElement;
        var navigationSlot = renderTNodeJSX(this, "navigation");
        if (isVNode(this.navigation)) return this.navigation;
        if (navigationSlot && isVNode(navigationSlot === null || navigationSlot === void 0 ? void 0 : navigationSlot[0])) return navigationSlot;
        if (this.navigationConfig.type === "fraction") {
          return h("div", {
            "class": ["".concat(this.componentName, "__navigation"), "".concat(this.componentName, "__navigation--fraction")]
          }, [this.renderPagination()]);
        }
        return h("ul", {
          "class": ["".concat(this.componentName, "__navigation"), _defineProperty$2({}, "".concat(this.componentName, "__navigation-bars"), this.navigationConfig.type === "bars")]
        }, [this.swiperItemList.map(function (_, i) {
          return h("li", {
            "key": i,
            "class": ["".concat(_this8.componentName, "__navigation-item"), _defineProperty$2({}, "".concat(_this8.classPrefix, "-is-active"), i === _this8.currentIndex)],
            "on": {
              "mouseenter": function mouseenter() {
                return _this8.onMouseEnterNavigationItem(i);
              },
              "click": function click() {
                return _this8.onClickNavigationItem(i);
              }
            }
          }, [h("span")]);
        })]);
      },
      renderSwiperItems: function renderSwiperItems() {
        return this.swiperItems;
      }
    },
    render: function render() {
      var h = arguments[0];
      return h("div", {
        "class": this.componentName,
        "on": {
          "mouseenter": this.onMouseEnter,
          "mouseleave": this.onMouseLeave
        },
        "ref": "swiperWrap"
      }, [h("div", {
        "class": this.swiperWrapClass
      }, [h("div", {
        "class": ["".concat(this.componentName, "__content"), _defineProperty$2(_defineProperty$2({}, "".concat(this.componentName, "-fade"), this.animation === "fade"), "".concat(this.componentName, "-card"), this.type === "card")]
      }, [h("div", {
        "class": "".concat(this.componentName, "__container"),
        "style": this.containerStyle
      }, [this.renderSwiperItems()])]), this.renderNavigation(), this.renderArrow()])]);
    }
  }));

  var Swiper = withInstall$1(_Swiper);
  var SwiperItem = withInstall$1(_SwiperItem);

  var baseTableProps = {
    activeRowKeys: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    defaultActiveRowKeys: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    activeRowType: {
      type: String,
      "default": ""
    },
    allowResizeColumnWidth: {
      type: Boolean,
      "default": void 0
    },
    attach: {
      type: [String, Function]
    },
    bordered: Boolean,
    bottomContent: {
      type: [String, Function]
    },
    cellEmptyContent: {
      type: [String, Function]
    },
    columns: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    data: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    disableDataPage: Boolean,
    disableSpaceInactiveRow: {
      type: Boolean,
      "default": void 0
    },
    empty: {
      type: [String, Function],
      "default": ""
    },
    firstFullRow: {
      type: [String, Function]
    },
    fixedRows: {
      type: Array
    },
    footData: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    footerAffixProps: {
      type: Object
    },
    footerAffixedBottom: {
      type: [Boolean, Object],
      "default": false
    },
    footerSummary: {
      type: [String, Function]
    },
    headerAffixProps: {
      type: Object
    },
    headerAffixedTop: {
      type: [Boolean, Object],
      "default": false
    },
    height: {
      type: [String, Number]
    },
    horizontalScrollAffixedBottom: {
      type: [Boolean, Object]
    },
    hover: Boolean,
    keyboardRowHover: {
      type: Boolean,
      "default": true
    },
    lastFullRow: {
      type: [String, Function]
    },
    lazyLoad: Boolean,
    loading: {
      type: [Boolean, Function],
      "default": void 0
    },
    loadingProps: {
      type: Object
    },
    locale: {
      type: Object
    },
    maxHeight: {
      type: [String, Number]
    },
    pagination: {
      type: Object
    },
    paginationAffixedBottom: {
      type: [Boolean, Object]
    },
    resizable: Boolean,
    rowAttributes: {
      type: [Object, Array, Function]
    },
    rowClassName: {
      type: [String, Object, Array, Function]
    },
    rowKey: {
      type: String,
      "default": "id",
      required: true
    },
    rowspanAndColspan: {
      type: Function
    },
    rowspanAndColspanInFooter: {
      type: Function
    },
    scroll: {
      type: Object
    },
    showHeader: {
      type: Boolean,
      "default": true
    },
    size: {
      type: String,
      validator: function validator(val) {
        if (!val) return true;
        return ["small", "medium", "large"].includes(val);
      }
    },
    stripe: Boolean,
    tableContentWidth: {
      type: String,
      "default": ""
    },
    tableLayout: {
      type: String,
      "default": "fixed",
      validator: function validator(val) {
        if (!val) return true;
        return ["auto", "fixed"].includes(val);
      }
    },
    topContent: {
      type: [String, Function]
    },
    verticalAlign: {
      type: String,
      "default": "middle",
      validator: function validator(val) {
        if (!val) return true;
        return ["top", "middle", "bottom"].includes(val);
      }
    },
    onActiveChange: Function,
    onActiveRowAction: Function,
    onCellClick: Function,
    onColumnResizeChange: Function,
    onPageChange: Function,
    onRowClick: Function,
    onRowDblclick: Function,
    onRowMousedown: Function,
    onRowMouseenter: Function,
    onRowMouseleave: Function,
    onRowMouseover: Function,
    onRowMouseup: Function,
    onScroll: Function,
    onScrollX: Function,
    onScrollY: Function
  };

  function getNodeDepth(columns, depthMap) {
    var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var maxDepth = depth;
    for (var i = 0, len = columns.length; i < len; i++) {
      var _col$children;
      var col = columns[i];
      depthMap.set(col, depth);
      if (col !== null && col !== void 0 && (_col$children = col.children) !== null && _col$children !== void 0 && _col$children.length) {
        var deep = getNodeDepth(col.children, depthMap, depth + 1);
        if (deep > maxDepth) {
          maxDepth = deep;
        }
      }
    }
    return maxDepth;
  }
  function getChildrenNodeWidth(node) {
    var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var countNew = count;
    var childrenList = (node === null || node === void 0 ? void 0 : node.children) || [];
    for (var i = 0, len = childrenList.length; i < len; i++) {
      var item = childrenList[i];
      if (item.children) {
        countNew = getChildrenNodeWidth(item, countNew);
      } else {
        countNew += 1;
      }
    }
    return countNew;
  }
  function getThRowspanAndColspan(columns) {
    var depthMap = /* @__PURE__ */new Map();
    var columnsDepth = getNodeDepth(columns, depthMap);
    var rowspanAndColspanMap = /* @__PURE__ */new Map();
    var _loop = function loop(nodes, leafColumns2) {
      for (var i = 0, len = nodes.length; i < len; i++) {
        var _col$children2;
        var col = nodes[i];
        var rowspan = col.children ? 1 : columnsDepth - depthMap.get(col) + 1;
        var colspan = col.children ? getChildrenNodeWidth(col) : 1;
        var span = {};
        rowspan > 1 && (span.rowspan = rowspan);
        colspan > 1 && (span.colspan = colspan);
        rowspanAndColspanMap.set(col, span);
        if (col !== null && col !== void 0 && (_col$children2 = col.children) !== null && _col$children2 !== void 0 && _col$children2.length) {
          _loop(col.children, leafColumns2);
        } else {
          leafColumns2.push(col);
        }
      }
    };
    var leafColumns = [];
    _loop(columns, leafColumns);
    return {
      rowspanAndColspanMap: rowspanAndColspanMap,
      leafColumns: leafColumns
    };
  }
  function getThList(columns) {
    var _loop2 = function loop(nodes, thRows) {
      var _children;
      var thRowData = [];
      var children = [];
      for (var i = 0, len = nodes.length; i < len; i++) {
        var _node$children;
        var node = nodes[i];
        var thList = [node];
        thRowData = thRowData.concat(thList);
        if (node !== null && node !== void 0 && (_node$children = node.children) !== null && _node$children !== void 0 && _node$children.length) {
          children = children.concat(node.children);
        }
      }
      if ((_children = children) !== null && _children !== void 0 && _children.length) {
        _loop2(children, thRows);
      }
      thRows.push(thRowData);
      return thRowData;
    };
    var list = [];
    _loop2(columns, list);
    list = list.reverse();
    return list;
  }

  function useClassName() {
    var _navigator;
    var _useConfig = useConfig(),
      classPrefix = _useConfig.classPrefix;
    var classNames = {
      classPrefix: classPrefix.value,
      tableBaseClass: {
        table: ["".concat(classPrefix.value, "-table"), _defineProperty$2({}, "".concat(classPrefix.value, "-table--chrome"), typeof navigator !== "undefined" && /Chrome/.test((_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.userAgent))],
        columnResizableTable: "".concat(classPrefix.value, "-table--column-resizable"),
        overflowVisible: "".concat(classPrefix.value, "-table--overflow-visible"),
        body: "".concat(classPrefix.value, "-table__body"),
        content: "".concat(classPrefix.value, "-table__content"),
        topContent: "".concat(classPrefix.value, "-table__top-content"),
        bottomContent: "".concat(classPrefix.value, "-table__bottom-content"),
        paginationWrap: "".concat(classPrefix.value, "-table__pagination-wrap"),
        tdLastRow: "".concat(classPrefix.value, "-table__td-last-row"),
        tdFirstCol: "".concat(classPrefix.value, "-table__td-first-col"),
        thCellInner: "".concat(classPrefix.value, "-table__th-cell-inner"),
        tableRowEdit: "".concat(classPrefix.value, "-table--row-edit"),
        cellEditable: "".concat(classPrefix.value, "-table__cell--editable"),
        cellEditWrap: "".concat(classPrefix.value, "-table__cell-wrap"),
        bordered: "".concat(classPrefix.value, "-table--bordered"),
        striped: "".concat(classPrefix.value, "-table--striped"),
        hover: "".concat(classPrefix.value, "-table--hoverable"),
        loading: "".concat(classPrefix.value, "-table--loading"),
        rowspanAndColspan: "".concat(classPrefix.value, "-table--rowspan-colspan"),
        empty: "".concat(classPrefix.value, "-table__empty"),
        emptyRow: "".concat(classPrefix.value, "-table__empty-row"),
        headerFixed: "".concat(classPrefix.value, "-table--header-fixed"),
        columnFixed: "".concat(classPrefix.value, "-table--column-fixed"),
        widthOverflow: "".concat(classPrefix.value, "-table--width-overflow"),
        multipleHeader: "".concat(classPrefix.value, "-table--multiple-header"),
        footerAffixed: "".concat(classPrefix.value, "-table--footer-affixed"),
        horizontalBarAffixed: "".concat(classPrefix.value, "-table--horizontal-bar-affixed"),
        affixedHeader: "".concat(classPrefix.value, "-table--affixed-header"),
        affixedHeaderElm: "".concat(classPrefix.value, "-table__affixed-header-elm"),
        affixedFooterElm: "".concat(classPrefix.value, "-table__affixed-footer-elm"),
        affixedFooterWrap: "".concat(classPrefix.value, "-table__affixed-footer-wrap"),
        scrollbarDivider: "".concat(classPrefix.value, "-table__scroll-bar-divider"),
        fullHeight: "".concat(classPrefix.value, "-table--full-height"),
        resizeLine: "".concat(classPrefix.value, "-table__resize-line"),
        obviousScrollbar: "".concat(classPrefix.value, "-table__scrollbar--obvious"),
        affixedHeaderWrap: "".concat(classPrefix.value, "-table__affixed-header-elm-wrap")
      },
      tdAlignClasses: {
        left: "".concat(classPrefix.value, "-align-left"),
        right: "".concat(classPrefix.value, "-align-right"),
        center: "".concat(classPrefix.value, "-align-center")
      },
      tableHeaderClasses: {
        header: "".concat(classPrefix.value, "-table__header"),
        thBordered: "".concat(classPrefix.value, "-table__header-th--bordered"),
        fixed: "".concat(classPrefix.value, "-table__header--fixed"),
        multipleHeader: "".concat(classPrefix.value, "-table__header--multiple")
      },
      tableFooterClasses: {
        footer: "".concat(classPrefix.value, "-table__footer"),
        footerSummary: "".concat(classPrefix.value, "-table__footer-summary"),
        fixed: "".concat(classPrefix.value, "-table__footer--fixed")
      },
      tableAlignClasses: {
        top: "".concat(classPrefix.value, "-vertical-align-top"),
        middle: "".concat(classPrefix.value, "-vertical-align-middle"),
        bottom: "".concat(classPrefix.value, "-vertical-align-bottom")
      },
      tableRowFixedClasses: {
        top: "".concat(classPrefix.value, "-table__row--fixed-top"),
        bottom: "".concat(classPrefix.value, "-table__row--fixed-bottom"),
        firstBottom: "".concat(classPrefix.value, "-table__row--fixed-bottom-first"),
        withoutBorderBottom: "".concat(classPrefix.value, "-table__row--without-border-bottom")
      },
      tableColFixedClasses: {
        left: "".concat(classPrefix.value, "-table__cell--fixed-left"),
        right: "".concat(classPrefix.value, "-table__cell--fixed-right"),
        lastLeft: "".concat(classPrefix.value, "-table__cell--fixed-left-last"),
        firstRight: "".concat(classPrefix.value, "-table__cell--fixed-right-first"),
        leftShadow: "".concat(classPrefix.value, "-table__content--scrollable-to-left"),
        rightShadow: "".concat(classPrefix.value, "-table__content--scrollable-to-right")
      },
      tableLayoutClasses: {
        auto: "".concat(classPrefix.value, "-table--layout-auto"),
        fixed: "".concat(classPrefix.value, "-table--layout-fixed")
      },
      tdEllipsisClass: "".concat(classPrefix.value, "-table-td--ellipsis"),
      tableFullRowClasses: {
        base: "".concat(classPrefix.value, "-table__row--full"),
        innerFullRow: "".concat(classPrefix.value, "-table__row-full-inner"),
        innerFullElement: "".concat(classPrefix.value, "-table__row-full-element"),
        firstFullRow: "".concat(classPrefix.value, "-table__first-full-row"),
        lastFullRow: "".concat(classPrefix.value, "-table__last-full-row")
      },
      tableExpandClasses: {
        iconBox: "".concat(classPrefix.value, "-table__expand-box"),
        iconCell: "".concat(classPrefix.value, "-table__expandable-icon-cell"),
        rowExpanded: "".concat(classPrefix.value, "-table__row--expanded"),
        rowFolded: "".concat(classPrefix.value, "-table__row--folded"),
        row: "".concat(classPrefix.value, "-table__expanded-row"),
        rowInner: "".concat(classPrefix.value, "-table__expanded-row-inner"),
        expanded: "".concat(classPrefix.value, "-table__row--expanded"),
        collapsed: "".concat(classPrefix.value, "-table__row--collapsed")
      },
      tableSortClasses: {
        sortable: "".concat(classPrefix.value, "-table__cell--sortable"),
        sortColumn: "".concat(classPrefix.value, "-table__sort-column"),
        title: "".concat(classPrefix.value, "-table__cell--title"),
        trigger: "".concat(classPrefix.value, "-table__cell--sort-trigger"),
        doubleIcon: "".concat(classPrefix.value, "-table__double-icons"),
        sortIcon: "".concat(classPrefix.value, "-table__sort-icon"),
        iconDirection: {
          asc: "".concat(classPrefix.value, "-table-sort-asc"),
          desc: "".concat(classPrefix.value, "-table-sort-desc")
        },
        iconActive: "".concat(classPrefix.value, "-table__sort-icon--active"),
        iconDefault: "".concat(classPrefix.value, "-icon-sort--default")
      },
      tableSelectedClasses: {
        selected: "".concat(classPrefix.value, "-table__row--selected"),
        disabled: "".concat(classPrefix.value, "-table__row--disabled"),
        checkCell: "".concat(classPrefix.value, "-table__cell-check")
      },
      tableFilterClasses: {
        filterable: "".concat(classPrefix.value, "-table__cell--filterable"),
        popup: "".concat(classPrefix.value, "-table__filter-pop"),
        icon: "".concat(classPrefix.value, "-table__filter-icon"),
        popupContent: "".concat(classPrefix.value, "-table__filter-pop-content"),
        result: "".concat(classPrefix.value, "-table__filter-result"),
        inner: "".concat(classPrefix.value, "-table__row-filter-inner"),
        bottomButtons: "".concat(classPrefix.value, "-table__filter--bottom-buttons"),
        contentInner: "".concat(classPrefix.value, "-table__filter-pop-content-inner"),
        iconWrap: "".concat(classPrefix.value, "-table__filter-icon-wrap"),
        inputFilter: "".concat(classPrefix.value, "-table__filter-popup-input")
      },
      asyncLoadingClass: "".concat(classPrefix.value, "-table__async-loading"),
      isFocusClass: "".concat(classPrefix.value, "-is-focus"),
      isLoadingClass: "".concat(classPrefix.value, "-is-loading"),
      isLoadMoreClass: "".concat(classPrefix.value, "-is-load-more"),
      tableTreeClasses: {
        col: "".concat(classPrefix.value, "-table__tree-col"),
        inlineCol: "".concat(classPrefix.value, "-table__tree-col--inline"),
        icon: "".concat(classPrefix.value, "-table__tree-op-icon"),
        leafNode: "".concat(classPrefix.value, "-table__tree-leaf-node")
      },
      tableDraggableClasses: {
        rowDraggable: "".concat(classPrefix.value, "-table--row-draggable"),
        rowHandlerDraggable: "".concat(classPrefix.value, "-table--row-handler-draggable"),
        colDraggable: "".concat(classPrefix.value, "-table--col-draggable"),
        handle: "".concat(classPrefix.value, "-table__handle-draggable"),
        ghost: "".concat(classPrefix.value, "-table__ele--draggable-ghost"),
        chosen: "".concat(classPrefix.value, "-table__ele--draggable-chosen"),
        dragging: "".concat(classPrefix.value, "-table__ele--draggable-dragging"),
        dragSortTh: "".concat(classPrefix.value, "-table__th--drag-sort")
      },
      virtualScrollClasses: {
        cursor: "".concat(classPrefix.value, "-table__virtual-scroll-cursor"),
        header: "".concat(classPrefix.value, "-table__virtual-scroll-header")
      },
      positiveRotate90: "".concat(classPrefix.value, "-positive-rotate-90"),
      negativeRotate180: "".concat(classPrefix.value, "-negative-rotate-180")
    };
    return classNames;
  }

  function ownKeys$K(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$J(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$K(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$K(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var TEllipsis = VueCompositionAPI.defineComponent({
    name: "TEllipsis",
    props: {
      content: {
        type: [String, Function]
      },
      "default": {
        type: [String, Function]
      },
      tooltipContent: {
        type: [String, Number, Function]
      },
      placement: String,
      attach: [String, Function],
      tooltipProps: Object,
      zIndex: Number,
      overlayClassName: String,
      classPrefix: {
        type: String
      }
    },
    setup: function setup(props) {
      var root = VueCompositionAPI.ref();
      var isOverflow = VueCompositionAPI.ref(false);
      var ellipsisClasses = VueCompositionAPI.computed(function () {
        return ["".concat(props.classPrefix, "-table__ellipsis"), "".concat(props.classPrefix, "-text-ellipsis")];
      });
      var innerEllipsisClassName = VueCompositionAPI.computed(function () {
        return ["".concat(props.classPrefix, "-table__ellipsis-content"), props.overlayClassName];
      });
      var onTriggerMouseenter = function onTriggerMouseenter() {
        if (!root.value) return;
        isOverflow.value = isNodeOverflow(root.value);
      };
      var onTriggerMouseleave = function onTriggerMouseleave() {
        isOverflow.value = isNodeOverflow(root.value);
      };
      var onMouseAround = debounce$1(function (e) {
        e.type === "mouseleave" ? onTriggerMouseleave() : onTriggerMouseenter();
      }, 80);
      return {
        root: root,
        isOverflow: isOverflow,
        ellipsisClasses: ellipsisClasses,
        innerEllipsisClassName: innerEllipsisClassName,
        onMouseAround: onMouseAround
      };
    },
    render: function render() {
      var _this = this;
      var h = arguments[0];
      var cellNode = renderContent(this, "default", "content");
      var ellipsisContent = h("div", {
        "ref": "root",
        "class": this.ellipsisClasses,
        "on": {
          "mouseenter": this.onMouseAround,
          "mouseleave": this.onMouseAround
        }
      }, [cellNode]);
      var content = null;
      var tooltipProps = this.tooltipProps;
      if (this.isOverflow) {
        var rProps = _objectSpread$J({
          content: this.tooltipContent || function () {
            return cellNode;
          },
          destroyOnClose: true,
          zIndex: this.zIndex,
          attach: this.attach || function () {
            return _this.root;
          },
          placement: this.placement,
          overlayClassName: tooltipProps !== null && tooltipProps !== void 0 && tooltipProps.overlayClassName ? this.innerEllipsisClassName.concat(tooltipProps.overlayClassName) : this.innerEllipsisClassName
        }, tooltipProps);
        content = h(Tooltip, helper([{}, {
          "props": rProps
        }]), [ellipsisContent]);
      } else {
        content = ellipsisContent;
      }
      return content;
    }
  });

  function ownKeys$J(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$I(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$J(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$J(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function renderTitle(h, slots, col, index) {
    var params = {
      col: col,
      colIndex: index
    };
    if (isFunction(col.title)) {
      return col.title(h, params);
    }
    if (isString(col.title) && slots[col.title]) {
      if (col.colKey === col.title) {
        log.error("Table", ["both colKey '".concat(col.colKey, "' and title have the same slot name"), "please set a different slot name for col and title."].join(", "));
      }
      return slots[col.title](params);
    }
    if (isFunction(col.render)) {
      return col.render(h, _objectSpread$I(_objectSpread$I({}, params), {}, {
        type: "title",
        row: {},
        rowIndex: -1
      })) || col.title;
    }
    return col.title;
  }
  function useTableHeader(props) {
    var _useClassName = useClassName(),
      tableSortClasses = _useClassName.tableSortClasses,
      tableFilterClasses = _useClassName.tableFilterClasses;
    var spansAndLeafNodes = VueCompositionAPI.computed(function () {
      return getThRowspanAndColspan(props.columns);
    });
    var thList = VueCompositionAPI.computed(function () {
      return getThList(props.columns);
    });
    var isMultipleHeader = VueCompositionAPI.computed(function () {
      return thList.value.length > 1;
    });
    var renderTitleWidthIcon = function renderTitleWidthIcon(h, _ref, col, colIndex, ellipsisTitle, attach, extra) {
      var _ref2 = _slicedToArray(_ref, 3),
        title = _ref2[0],
        sortIcon = _ref2[1],
        filterIcon = _ref2[2];
      var classes = _defineProperty$2(_defineProperty$2({}, tableSortClasses.sortable, sortIcon), tableFilterClasses.filterable, filterIcon);
      var content = isFunction(ellipsisTitle) ? ellipsisTitle(h, {
        col: col,
        colIndex: colIndex
      }) : void 0;
      var isEllipsis = ellipsisTitle !== void 0 ? Boolean(ellipsisTitle) : Boolean(col.ellipsis);
      return h("div", {
        "class": classes
      }, [h("div", {
        "class": tableSortClasses.title
      }, [isEllipsis ? h(TEllipsis, {
        "attrs": {
          "placement": "bottom",
          "attach": props.attach || (attach ? function () {
            return attach;
          } : void 0),
          "tooltipContent": content && function () {
            return content;
          },
          "tooltipProps": _typeof$2(ellipsisTitle) === "object" ? ellipsisTitle : void 0,
          "classPrefix": extra === null || extra === void 0 ? void 0 : extra.classPrefix,
          "overlayClassName": extra === null || extra === void 0 ? void 0 : extra.ellipsisOverlayClassName
        }
      }, [title]) : h("div", [title]), Boolean(sortIcon || filterIcon) && h("div", {
        "class": tableFilterClasses.iconWrap
      }, [sortIcon, filterIcon])])]);
    };
    return {
      thList: thList,
      isMultipleHeader: isMultipleHeader,
      spansAndLeafNodes: spansAndLeafNodes,
      renderTitleWidthIcon: renderTitleWidthIcon
    };
  }

  function ownKeys$I(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$H(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$I(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$I(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var DEFAULT_MIN_WIDTH = 80;
  var DEFAULT_MAX_WIDTH = 600;
  var distance = 8;
  function useColumnResize(params) {
    var isWidthOverflow = params.isWidthOverflow,
      tableContentRef = params.tableContentRef,
      showColumnShadow = params.showColumnShadow,
      getThWidthList = params.getThWidthList,
      updateThWidthList = params.updateThWidthList,
      setTableElmWidth = params.setTableElmWidth,
      updateTableAfterColumnResize = params.updateTableAfterColumnResize,
      onColumnResizeChange = params.onColumnResizeChange;
    var resizeLineRef = VueCompositionAPI.ref();
    var effectColMap = VueCompositionAPI.ref({});
    var leafColumns = VueCompositionAPI.ref([]);
    var originalSelectStart;
    var originalDragStart;
    VueCompositionAPI.onMounted(function () {
      var hasDocument = typeof document !== "undefined";
      originalSelectStart = hasDocument ? document.onselectstart : null;
      originalDragStart = hasDocument ? document.ondragstart : null;
    });
    var getSiblingResizableCol = function getSiblingResizableCol(nodes, index, type) {
      var i = index;
      while (nodes[i] && nodes[i].resizable === false) {
        if (type === "next") {
          i += 1;
        } else {
          i -= 1;
        }
      }
      return nodes[i];
    };
    var _setEffectColMap = function setEffectColMap(nodes, parent) {
      if (!nodes) return;
      leafColumns.value = nodes;
      nodes.forEach(function (n, index) {
        var prevNode = getSiblingResizableCol(nodes, index - 1, "prev");
        var nextNode = getSiblingResizableCol(nodes, index + 1, "next");
        var parentPrevCol = parent ? effectColMap.value[parent.colKey].prev : nextNode;
        var parentNextCol = parent ? effectColMap.value[parent.colKey].next : prevNode;
        var prev = index === 0 ? parentPrevCol : prevNode;
        var next = index === nodes.length - 1 ? parentNextCol : nextNode;
        effectColMap.value[n.colKey] = {
          prev: prev,
          next: next,
          current: {
            prevSibling: getSiblingResizableCol(nodes, index - 1, "prev"),
            nextSibling: getSiblingResizableCol(nodes, index + 1, "next")
          }
        };
        _setEffectColMap(n.children, n);
      });
    };
    var resizeLineParams = {
      isDragging: false,
      draggingCol: null,
      draggingStart: 0,
      effectCol: "next"
    };
    var resizeLineStyle = VueCompositionAPI.reactive({
      display: "none",
      height: "10px",
      left: "10px",
      bottom: "0"
    });
    var isColRightFixActive = function isColRightFixActive(col) {
      return col.fixed === "right" && showColumnShadow.right;
    };
    var onColumnMouseover = function onColumnMouseover(e, col) {
      if (!resizeLineRef.value || resizeLineParams.isDragging || !e.target) return;
      var target = e.target.closest("th");
      var colKey = target.getAttribute("data-colkey");
      if (!leafColumns.value.find(function (t) {
        return t.colKey === colKey;
      })) return;
      var targetBoundRect = target.getBoundingClientRect();
      var thRightCursor = targetBoundRect.right - e.pageX <= distance;
      var thLeftCursor = e.pageX - targetBoundRect.left <= distance;
      var isFixedToRight = isColRightFixActive(col);
      if (thRightCursor || isFixedToRight) {
        var _col$resizable;
        var colResizable = (_col$resizable = col.resizable) !== null && _col$resizable !== void 0 ? _col$resizable : true;
        if (colResizable) {
          target.style.cursor = thRightCursor || isFixedToRight && thLeftCursor ? "col-resize" : "";
          var isCurrent = thRightCursor && !isFixedToRight || isFixedToRight && thLeftCursor;
          resizeLineParams.draggingCol = isCurrent ? target : target.nextElementSibling;
          resizeLineParams.effectCol = "next";
          return;
        }
      } else if (thLeftCursor) {
        var prevEl = target.previousElementSibling;
        if (prevEl) {
          var _effectColMap$value$c, _effectPrevCol$resiza;
          var effectPrevCol = (_effectColMap$value$c = effectColMap.value[col.colKey]) === null || _effectColMap$value$c === void 0 ? void 0 : _effectColMap$value$c.prev;
          var _colResizable = (_effectPrevCol$resiza = effectPrevCol === null || effectPrevCol === void 0 ? void 0 : effectPrevCol.resizable) !== null && _effectPrevCol$resiza !== void 0 ? _effectPrevCol$resiza : true;
          if (_colResizable) {
            target.style.cursor = "col-resize";
            resizeLineParams.draggingCol = prevEl;
            resizeLineParams.effectCol = "prev";
            return;
          }
        }
      }
      target.style.cursor = "";
      resizeLineParams.draggingCol = null;
      resizeLineParams.effectCol = null;
    };
    var getMinMaxColWidth = function getMinMaxColWidth(targetCol) {
      var _targetCol$resize, _targetCol$resize2;
      var propMinWidth = isNumber(targetCol.minWidth) ? targetCol.minWidth : parseInt(targetCol.minWidth || "0", 10);
      return {
        minColWidth: Math.max(((_targetCol$resize = targetCol.resize) === null || _targetCol$resize === void 0 ? void 0 : _targetCol$resize.minWidth) || DEFAULT_MIN_WIDTH, propMinWidth),
        maxColWidth: ((_targetCol$resize2 = targetCol.resize) === null || _targetCol$resize2 === void 0 ? void 0 : _targetCol$resize2.maxWidth) || DEFAULT_MAX_WIDTH
      };
    };
    var getNormalResizeInfo = function getNormalResizeInfo(col, effectPrevCol, targetBoundRect, tableBoundRect) {
      var resizeLinePos = targetBoundRect.right - tableBoundRect.left;
      var colLeft = targetBoundRect.left - tableBoundRect.left;
      var targetCol = resizeLineParams.effectCol === "next" ? col : effectPrevCol;
      var _getMinMaxColWidth = getMinMaxColWidth(targetCol),
        minColWidth = _getMinMaxColWidth.minColWidth,
        maxColWidth = _getMinMaxColWidth.maxColWidth;
      return {
        resizeLinePos: resizeLinePos,
        minResizeLineLeft: colLeft + minColWidth,
        maxResizeLineLeft: colLeft + maxColWidth
      };
    };
    var getFixedToRightResizeInfo = function getFixedToRightResizeInfo(target, col, effectPrevCol, targetBoundRect, tableBoundRect) {
      var resizeLinePos = targetBoundRect.left - tableBoundRect.left;
      var targetCol = target.dataset.colkey === col.colKey ? col : effectPrevCol;
      var colLeft = targetBoundRect.left - tableBoundRect.left;
      var _getMinMaxColWidth2 = getMinMaxColWidth(targetCol),
        minColWidth = _getMinMaxColWidth2.minColWidth,
        maxColWidth = _getMinMaxColWidth2.maxColWidth;
      return {
        resizeLinePos: resizeLinePos,
        minResizeLineLeft: colLeft + (targetBoundRect.width - maxColWidth),
        maxResizeLineLeft: colLeft + (targetBoundRect.width - minColWidth)
      };
    };
    var getFixedToLeftResizeInfo = function getFixedToLeftResizeInfo(target, col, targetBoundRect, tableBoundRect) {
      var targetIsSameAsCol = target.dataset.colkey === col.colKey;
      var colLeft = targetBoundRect.left - tableBoundRect.left;
      var resizeLinePos = colLeft + targetBoundRect.width;
      var _getMinMaxColWidth3 = getMinMaxColWidth(col),
        minColWidth = _getMinMaxColWidth3.minColWidth,
        maxColWidth = _getMinMaxColWidth3.maxColWidth;
      return {
        resizeLinePos: resizeLinePos,
        minResizeLineLeft: colLeft + (targetIsSameAsCol ? minColWidth : targetBoundRect.width),
        maxResizeLineLeft: colLeft + (targetIsSameAsCol ? maxColWidth : targetBoundRect.width)
      };
    };
    var getTotalTableWidth = function getTotalTableWidth(thWidthList) {
      var tableWidth = 0;
      leafColumns.value.forEach(function (col) {
        tableWidth += thWidthList[col.colKey];
      });
      return tableWidth;
    };
    var getSiblingColCanResizable = function getSiblingColCanResizable(newThWidthList, effectNextCol, distance2, index) {
      var isWidthAbnormal = true;
      if (effectNextCol) {
        var _getMinMaxColWidth4 = getMinMaxColWidth(effectNextCol),
          minColWidth = _getMinMaxColWidth4.minColWidth,
          maxColWidth = _getMinMaxColWidth4.maxColWidth;
        var targetNextColWidth = newThWidthList[effectNextCol.colKey] + distance2;
        isWidthAbnormal = targetNextColWidth < minColWidth || targetNextColWidth > maxColWidth;
      }
      return !(isWidthAbnormal || isWidthOverflow.value || index === leafColumns.value.length - 1);
    };
    var getOtherResizeInfo = function getOtherResizeInfo(target, col, effectPrevCol, targetBoundRect, tableBoundRect) {
      return effectPrevCol ? getNormalResizeInfo(col, effectPrevCol, targetBoundRect, tableBoundRect) : getFixedToLeftResizeInfo(target, col, targetBoundRect, tableBoundRect);
    };
    var onColumnMousedown = function onColumnMousedown(e, col, index) {
      var _tableContentRef$valu, _effectColMap$value$c2, _effectColMap$value$c3;
      if (!resizeLineParams.draggingCol) return;
      var target = resizeLineParams.draggingCol;
      var targetBoundRect = target.getBoundingClientRect();
      var tableBoundRect = (_tableContentRef$valu = tableContentRef.value) === null || _tableContentRef$valu === void 0 ? void 0 : _tableContentRef$valu.getBoundingClientRect();
      var effectNextCol = (_effectColMap$value$c2 = effectColMap.value[col.colKey]) === null || _effectColMap$value$c2 === void 0 ? void 0 : _effectColMap$value$c2.next;
      var effectPrevCol = (_effectColMap$value$c3 = effectColMap.value[col.colKey]) === null || _effectColMap$value$c3 === void 0 ? void 0 : _effectColMap$value$c3.prev;
      var _ref = isColRightFixActive(col) ? getFixedToRightResizeInfo(target, col, effectNextCol, targetBoundRect, tableBoundRect) : getOtherResizeInfo(target, col, effectPrevCol, targetBoundRect, tableBoundRect),
        resizeLinePos = _ref.resizeLinePos,
        minResizeLineLeft = _ref.minResizeLineLeft,
        maxResizeLineLeft = _ref.maxResizeLineLeft;
      resizeLineParams.isDragging = true;
      resizeLineParams.draggingStart = e.x;
      if (resizeLineRef !== null && resizeLineRef !== void 0 && resizeLineRef.value) {
        resizeLineStyle.display = "block";
        resizeLineStyle.height = "".concat(tableBoundRect.bottom - targetBoundRect.top, "px");
        resizeLineStyle.left = "".concat(resizeLinePos, "px");
        var parent = tableContentRef.value.parentElement.getBoundingClientRect();
        resizeLineStyle.bottom = "".concat(parent.bottom - tableBoundRect.bottom, "px");
      }
      var _onDragEnd = function onDragEnd() {
        var _effectColMap$value$c4;
        if (!resizeLineParams.isDragging) return;
        var moveDistance = resizeLinePos - parseFloat(resizeLineStyle.left) || 0;
        var thWidthList = getThWidthList("calculate");
        var currentCol = (_effectColMap$value$c4 = effectColMap.value[col.colKey]) === null || _effectColMap$value$c4 === void 0 ? void 0 : _effectColMap$value$c4.current;
        var currentSibling = resizeLineParams.effectCol === "next" ? currentCol.nextSibling : currentCol.prevSibling;
        var newThWidthList = _objectSpread$H({}, thWidthList);
        var tmpCurrentCol = col.resizable !== false ? col : currentSibling;
        var rightCol = resizeLineParams.effectCol === "next" ? currentCol.nextSibling : col;
        var canResizeSiblingColWidth = getSiblingColCanResizable(newThWidthList, rightCol, moveDistance, index);
        if (resizeLineParams.effectCol === "next") {
          if (isColRightFixActive(col)) {
            if (target.dataset.colkey !== col.colKey) {
              newThWidthList[effectNextCol.colKey] += moveDistance;
            } else {
              newThWidthList[tmpCurrentCol.colKey] += moveDistance;
            }
          } else {
            newThWidthList[tmpCurrentCol.colKey] -= moveDistance;
            if (canResizeSiblingColWidth) {
              newThWidthList[effectNextCol.colKey] += moveDistance;
            }
          }
        } else if (resizeLineParams.effectCol === "prev") {
          if (canResizeSiblingColWidth) {
            newThWidthList[tmpCurrentCol.colKey] += moveDistance;
          }
          effectPrevCol && (newThWidthList[effectPrevCol.colKey] -= moveDistance);
        }
        updateThWidthList(newThWidthList);
        var tableWidth = getTotalTableWidth(newThWidthList);
        setTableElmWidth(Math.round(tableWidth));
        updateTableAfterColumnResize();
        resizeLineParams.isDragging = false;
        resizeLineParams.draggingCol = null;
        resizeLineParams.effectCol = null;
        target.style.cursor = "";
        resizeLineStyle.display = "none";
        resizeLineStyle.left = "0";
        off$1(document, "mouseup", _onDragEnd);
        off$1(document, "mousemove", onDragOver);
        document.onselectstart = originalSelectStart;
        document.ondragstart = originalDragStart;
        onColumnResizeChange === null || onColumnResizeChange === void 0 || onColumnResizeChange({
          columnsWidth: newThWidthList
        });
      };
      var onDragOver = function onDragOver(e2) {
        if (resizeLineParams.isDragging) {
          var left = resizeLinePos + e2.x - resizeLineParams.draggingStart;
          resizeLineStyle.left = "".concat(Math.min(Math.max(left, minResizeLineLeft), maxResizeLineLeft), "px");
        }
      };
      on$1(document, "mouseup", _onDragEnd);
      on$1(document, "mousemove", onDragOver);
      document.onselectstart = function () {
        return false;
      };
      document.ondragstart = function () {
        return false;
      };
    };
    return {
      resizeLineRef: resizeLineRef,
      resizeLineStyle: resizeLineStyle,
      onColumnMouseover: onColumnMouseover,
      onColumnMousedown: onColumnMousedown,
      setEffectColMap: _setEffectColMap
    };
  }

  function ownKeys$H(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$G(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$H(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$H(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function getColumnFixedStyles(col, index, rowAndColFixedPosition, tableColFixedClasses) {
    var fixedPos = rowAndColFixedPosition === null || rowAndColFixedPosition === void 0 ? void 0 : rowAndColFixedPosition.get(col.colKey || index);
    if (!fixedPos) return {};
    var thClasses = _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({}, tableColFixedClasses.left, col.fixed === "left"), tableColFixedClasses.right, col.fixed === "right"), tableColFixedClasses.lastLeft, col.fixed === "left" && fixedPos.lastLeftFixedCol), tableColFixedClasses.firstRight, col.fixed === "right" && fixedPos.firstRightFixedCol);
    var thStyles = {
      left: col.fixed === "left" ? "".concat(fixedPos.left, "px") : void 0,
      right: col.fixed === "right" ? "".concat(fixedPos.right, "px") : void 0
    };
    return {
      style: thStyles,
      classes: thClasses
    };
  }
  function getRowFixedStyles(rowId, rowIndex, rowLength, fixedRows, rowAndColFixedPosition, tableRowFixedClasses) {
    if (!fixedRows || !fixedRows.length) return {
      style: void 0,
      classes: void 0
    };
    var fixedTop = rowIndex < fixedRows[0];
    var fixedBottom = rowIndex > rowLength - 1 - fixedRows[1];
    var firstFixedBottomRow = rowLength - fixedRows[1];
    var fixedPos = (rowAndColFixedPosition === null || rowAndColFixedPosition === void 0 ? void 0 : rowAndColFixedPosition.get(rowId)) || {};
    var rowClasses = _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({}, tableRowFixedClasses.top, fixedTop), tableRowFixedClasses.bottom, fixedBottom), tableRowFixedClasses.firstBottom, rowIndex === firstFixedBottomRow), tableRowFixedClasses.withoutBorderBottom, rowIndex === firstFixedBottomRow - 1);
    var rowStyles = {
      top: fixedTop ? "".concat(fixedPos.top, "px") : void 0,
      bottom: fixedBottom ? "".concat(fixedPos.bottom, "px") : void 0
    };
    return {
      style: rowStyles,
      classes: rowClasses
    };
  }
  function useFixed(props, context, finalColumns, affixRef) {
    var _toRefs = VueCompositionAPI.toRefs(props),
      columns = _toRefs.columns,
      tableLayout = _toRefs.tableLayout,
      tableContentWidth = _toRefs.tableContentWidth,
      fixedRows = _toRefs.fixedRows,
      firstFullRow = _toRefs.firstFullRow,
      lastFullRow = _toRefs.lastFullRow,
      maxHeight = _toRefs.maxHeight,
      headerAffixedTop = _toRefs.headerAffixedTop,
      footerAffixedBottom = _toRefs.footerAffixedBottom,
      bordered = _toRefs.bordered,
      resizable = _toRefs.resizable,
      allowResizeColumnWidth = _toRefs.allowResizeColumnWidth;
    var data = VueCompositionAPI.ref([]);
    var tableRef = VueCompositionAPI.ref();
    var tableContentRef = VueCompositionAPI.ref();
    var isFixedHeader = VueCompositionAPI.ref(false);
    var isWidthOverflow = VueCompositionAPI.ref(false);
    var tableElmRef = VueCompositionAPI.ref();
    var scrollbarWidth = VueCompositionAPI.ref(6);
    var rowAndColFixedPosition = VueCompositionAPI.ref(/* @__PURE__ */new Map());
    var showColumnShadow = VueCompositionAPI.reactive({
      left: false,
      right: false
    });
    var virtualScrollHeaderPos = VueCompositionAPI.ref({
      left: 0,
      top: 0
    });
    var tableWidth = VueCompositionAPI.ref(0);
    var tableElmWidth = VueCompositionAPI.ref(0);
    var thWidthList = VueCompositionAPI.ref({});
    var isFixedColumn = VueCompositionAPI.ref(false);
    var isFixedRightColumn = VueCompositionAPI.ref(false);
    var isFixedLeftColumn = VueCompositionAPI.ref(false);
    var columnResizable = VueCompositionAPI.computed(function () {
      var _ref, _allowResizeColumnWid;
      return (_ref = (_allowResizeColumnWid = allowResizeColumnWidth.value) !== null && _allowResizeColumnWid !== void 0 ? _allowResizeColumnWid : resizable.value) !== null && _ref !== void 0 ? _ref : false;
    });
    var notNeedThWidthList = VueCompositionAPI.computed(function () {
      var _props$scroll;
      return !(props.headerAffixedTop || props.footerAffixedBottom || props.horizontalScrollAffixedBottom || ((_props$scroll = props.scroll) === null || _props$scroll === void 0 ? void 0 : _props$scroll.type) === "virtual");
    });
    function setUseFixedTableElmRef(val) {
      tableElmRef.value = val;
    }
    function getColumnMap(columns2) {
      var map = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : /* @__PURE__ */new Map();
      var levelNodes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var level = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var parent = arguments.length > 4 ? arguments[4] : undefined;
      for (var i = 0, len = columns2.length; i < len; i++) {
        var _col$children;
        var col = columns2[i];
        if (["left", "right"].includes(col.fixed)) {
          isFixedColumn.value = true;
        }
        if (col.fixed === "right") {
          isFixedRightColumn.value = true;
        }
        if (col.fixed === "left") {
          isFixedLeftColumn.value = true;
        }
        var key = col.colKey || i;
        var columnInfo = {
          col: col,
          parent: parent,
          index: i
        };
        map.set(key, columnInfo);
        if ((_col$children = col.children) !== null && _col$children !== void 0 && _col$children.length) {
          getColumnMap(col.children, map, levelNodes, level + 1, columnInfo);
        }
        if (levelNodes[level]) {
          levelNodes[level].push(columnInfo);
        } else {
          levelNodes[level] = [columnInfo];
        }
      }
      return {
        newColumnsMap: map,
        levelNodes: levelNodes
      };
    }
    var _setFixedLeftPos = function setFixedLeftPos(columns2, initialColumnMap) {
      var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      for (var i = 0, len = columns2.length; i < len; i++) {
        var _col$children2;
        var col = columns2[i];
        if (col.fixed === "right") return;
        var colInfo = initialColumnMap.get(col.colKey || i);
        var lastColIndex = i - 1;
        while (lastColIndex >= 0 && columns2[lastColIndex].fixed !== "left") {
          lastColIndex -= 1;
        }
        var lastCol = columns2[lastColIndex];
        var defaultWidth = i === 0 ? (parent === null || parent === void 0 ? void 0 : parent.left) || 0 : 0;
        var lastColInfo = initialColumnMap.get((lastCol === null || lastCol === void 0 ? void 0 : lastCol.colKey) || i - 1);
        if (colInfo) {
          colInfo.left = ((lastColInfo === null || lastColInfo === void 0 ? void 0 : lastColInfo.left) || defaultWidth) + ((lastColInfo === null || lastColInfo === void 0 ? void 0 : lastColInfo.width) || 0);
        }
        if ((_col$children2 = col.children) !== null && _col$children2 !== void 0 && _col$children2.length) {
          _setFixedLeftPos(col.children, initialColumnMap, colInfo);
        }
      }
    };
    var _setFixedRightPos = function setFixedRightPos(columns2, initialColumnMap) {
      var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      for (var i = columns2.length - 1; i >= 0; i--) {
        var _col$children3;
        var col = columns2[i];
        if (col.fixed === "left") return;
        var colInfo = initialColumnMap.get(col.colKey || i);
        var lastColIndex = i + 1;
        while (lastColIndex < columns2.length && columns2[lastColIndex].fixed !== "right") {
          lastColIndex += 1;
        }
        var lastCol = columns2[lastColIndex];
        var defaultWidth = i === columns2.length - 1 ? (parent === null || parent === void 0 ? void 0 : parent.right) || 0 : 0;
        var lastColInfo = initialColumnMap.get((lastCol === null || lastCol === void 0 ? void 0 : lastCol.colKey) || i + 1);
        if (colInfo) {
          colInfo.right = ((lastColInfo === null || lastColInfo === void 0 ? void 0 : lastColInfo.right) || defaultWidth) + ((lastColInfo === null || lastColInfo === void 0 ? void 0 : lastColInfo.width) || 0);
        }
        if ((_col$children3 = col.children) !== null && _col$children3 !== void 0 && _col$children3.length) {
          _setFixedRightPos(col.children, initialColumnMap, colInfo);
        }
      }
    };
    var setFixedColPosition = function setFixedColPosition(trList, initialColumnMap) {
      if (!trList) return;
      for (var i = 0, len = trList.length; i < len; i++) {
        var thList = trList[i].children;
        for (var j = 0, thLen = thList.length; j < thLen; j++) {
          var _obj$col;
          var th = thList[j];
          var colKey = th.dataset.colkey;
          if (!colKey) {
            log.warn("Table", "".concat(th.innerText, " missing colKey. colKey is required for fixed column feature."));
          }
          var obj = initialColumnMap.get(colKey || j);
          if (obj !== null && obj !== void 0 && (_obj$col = obj.col) !== null && _obj$col !== void 0 && _obj$col.fixed) {
            initialColumnMap.set(colKey, _objectSpread$G(_objectSpread$G({}, obj), {}, {
              width: th.getBoundingClientRect().width
            }));
          }
        }
      }
      _setFixedLeftPos(columns.value, initialColumnMap);
      _setFixedRightPos(columns.value, initialColumnMap);
    };
    var setFixedRowPosition = function setFixedRowPosition(trList, initialColumnMap, thead, tfoot) {
      var _ref2 = fixedRows.value || [],
        _ref3 = _slicedToArray(_ref2, 2),
        fixedTopRows = _ref3[0],
        fixedBottomRows = _ref3[1];
      var data2 = props.data,
        _props$rowKey = props.rowKey,
        rowKey = _props$rowKey === void 0 ? "id" : _props$rowKey;
      for (var i = 0; i < fixedTopRows; i++) {
        var tr = trList[i];
        var rowId = get(data2[i], rowKey);
        var thisRowInfo = initialColumnMap.get(rowId) || {};
        var lastRowId = get(data2[i - 1], rowKey);
        var lastRowInfo = initialColumnMap.get(lastRowId) || {};
        var defaultBottom = 0;
        if (i === 0) {
          defaultBottom = (thead === null || thead === void 0 ? void 0 : thead.getBoundingClientRect().height) || 0;
        }
        thisRowInfo.top = (lastRowInfo.top || defaultBottom) + (lastRowInfo.height || 0);
        initialColumnMap.set(rowId, _objectSpread$G(_objectSpread$G({}, thisRowInfo), {}, {
          height: tr === null || tr === void 0 ? void 0 : tr.getBoundingClientRect().height
        }));
      }
      for (var _i = data2.length - 1; _i >= data2.length - fixedBottomRows; _i--) {
        var _tr = trList[_i];
        var _rowId = get(data2[_i], rowKey);
        var _thisRowInfo = initialColumnMap.get(_rowId) || {};
        var _lastRowId = get(data2[_i + 1], rowKey);
        var _lastRowInfo = initialColumnMap.get(_lastRowId) || {};
        var _defaultBottom = 0;
        if (_i === data2.length - 1) {
          _defaultBottom = (tfoot === null || tfoot === void 0 ? void 0 : tfoot.getBoundingClientRect().height) || 0;
        }
        _thisRowInfo.bottom = (_lastRowInfo.bottom || _defaultBottom) + (_lastRowInfo.height || 0);
        initialColumnMap.set(_rowId, _objectSpread$G(_objectSpread$G({}, _thisRowInfo), {}, {
          height: _tr === null || _tr === void 0 ? void 0 : _tr.getBoundingClientRect().height
        }));
      }
    };
    var updateRowAndColFixedPosition = function updateRowAndColFixedPosition(tableContentElm, initialColumnMap) {
      rowAndColFixedPosition.value.clear();
      if (!tableContentElm) return;
      var thead = tableContentElm.querySelector("thead");
      thead && setFixedColPosition(thead.children, initialColumnMap);
      var tbody = tableContentElm.querySelector("tbody");
      var tfoot = tableContentElm.querySelector("tfoot");
      tbody && setFixedRowPosition(tbody.children, initialColumnMap, thead, tfoot);
      rowAndColFixedPosition.value = initialColumnMap;
    };
    var shadowLastScrollLeft;
    var updateColumnFixedShadow = function updateColumnFixedShadow(target, extra) {
      if (!isFixedColumn.value || !target) return;
      var scrollLeft = target.scrollLeft;
      if (shadowLastScrollLeft === scrollLeft && (!extra || !extra.skipScrollLimit)) return;
      shadowLastScrollLeft = scrollLeft;
      var isShowRight = target.clientWidth + scrollLeft < target.scrollWidth;
      var isShowLeft = scrollLeft > 0;
      if (showColumnShadow.left === isShowLeft && showColumnShadow.right === isShowRight) return;
      showColumnShadow.left = isShowLeft && isFixedLeftColumn.value;
      showColumnShadow.right = isShowRight && isFixedRightColumn.value;
    };
    var setIsLastOrFirstFixedCol = function setIsLastOrFirstFixedCol(levelNodes) {
      for (var t = 0; t < levelNodes.length; t++) {
        var nodes = levelNodes[t];
        for (var i = 0, len = nodes.length; i < len; i++) {
          var colMapInfo = nodes[i];
          var nextColMapInfo = nodes[i + 1];
          var parent = colMapInfo.parent;
          var isParentLastLeftFixedCol = !parent || (parent === null || parent === void 0 ? void 0 : parent.lastLeftFixedCol);
          if (isParentLastLeftFixedCol && colMapInfo.col.fixed === "left" && (nextColMapInfo === null || nextColMapInfo === void 0 ? void 0 : nextColMapInfo.col.fixed) !== "left") {
            colMapInfo.lastLeftFixedCol = true;
          }
          var lastColMapInfo = nodes[i - 1];
          var isParentFirstRightFixedCol = !parent || (parent === null || parent === void 0 ? void 0 : parent.firstRightFixedCol);
          if (isParentFirstRightFixedCol && colMapInfo.col.fixed === "right" && (lastColMapInfo === null || lastColMapInfo === void 0 ? void 0 : lastColMapInfo.col.fixed) !== "right") {
            colMapInfo.firstRightFixedCol = true;
          }
        }
      }
    };
    var updateFixedStatus = function updateFixedStatus() {
      var _getColumnMap = getColumnMap(columns.value),
        newColumnsMap = _getColumnMap.newColumnsMap,
        levelNodes = _getColumnMap.levelNodes;
      setIsLastOrFirstFixedCol(levelNodes);
      var timer = setTimeout(function () {
        var _fixedRows$value;
        if (isFixedColumn.value || (_fixedRows$value = fixedRows.value) !== null && _fixedRows$value !== void 0 && _fixedRows$value.length) {
          updateRowAndColFixedPosition(tableContentRef.value, newColumnsMap);
        }
        clearTimeout(timer);
      }, 0);
      return function () {
        clearTimeout(timer);
      };
    };
    var updateFixedHeader = function updateFixedHeader() {
      var timer = setTimeout(function () {
        if (!tableContentRef.value) return;
        isFixedHeader.value = tableContentRef.value.scrollHeight - tableContentRef.value.clientHeight >= scrollbarWidth.value;
        isWidthOverflow.value = tableContentRef.value.scrollWidth - tableContentRef.value.clientWidth >= scrollbarWidth.value;
        var pos = tableContentRef.value.getBoundingClientRect();
        virtualScrollHeaderPos.value = {
          top: pos.top,
          left: pos.left
        };
        clearTimeout(timer);
      }, 0);
    };
    var setTableElmWidth = function setTableElmWidth(width) {
      if (tableElmWidth.value === width) return;
      tableElmWidth.value = width;
    };
    var updateTableWidth = function updateTableWidth() {
      var _tableContentRef$valu, _tableElmRef$value;
      var rect = (_tableContentRef$valu = tableContentRef.value) === null || _tableContentRef$valu === void 0 ? void 0 : _tableContentRef$valu.getBoundingClientRect();
      if (!rect) return;
      var reduceWidth = isFixedHeader.value ? scrollbarWidth.value : 0;
      tableWidth.value = rect.width - reduceWidth - (props.bordered ? 1 : 0);
      var elmRect = tableElmRef === null || tableElmRef === void 0 || (_tableElmRef$value = tableElmRef.value) === null || _tableElmRef$value === void 0 ? void 0 : _tableElmRef$value.getBoundingClientRect();
      setTableElmWidth(elmRect === null || elmRect === void 0 ? void 0 : elmRect.width);
    };
    var updateAffixPosition = function updateAffixPosition() {
      var _affixRef$paginationA, _affixRef$paginationA2, _affixRef$horizontalS, _affixRef$horizontalS2, _affixRef$headerTopAf, _affixRef$headerTopAf2, _affixRef$footerBotto, _affixRef$footerBotto2;
      (_affixRef$paginationA = affixRef.paginationAffixRef.value) === null || _affixRef$paginationA === void 0 || (_affixRef$paginationA2 = _affixRef$paginationA.handleScroll) === null || _affixRef$paginationA2 === void 0 || _affixRef$paginationA2.call(_affixRef$paginationA);
      (_affixRef$horizontalS = affixRef.horizontalScrollAffixRef.value) === null || _affixRef$horizontalS === void 0 || (_affixRef$horizontalS2 = _affixRef$horizontalS.handleScroll) === null || _affixRef$horizontalS2 === void 0 || _affixRef$horizontalS2.call(_affixRef$horizontalS);
      (_affixRef$headerTopAf = affixRef.headerTopAffixRef.value) === null || _affixRef$headerTopAf === void 0 || (_affixRef$headerTopAf2 = _affixRef$headerTopAf.handleScroll) === null || _affixRef$headerTopAf2 === void 0 || _affixRef$headerTopAf2.call(_affixRef$headerTopAf);
      (_affixRef$footerBotto = affixRef.footerBottomAffixRef.value) === null || _affixRef$footerBotto === void 0 || (_affixRef$footerBotto2 = _affixRef$footerBotto.handleScroll) === null || _affixRef$footerBotto2 === void 0 || _affixRef$footerBotto2.call(_affixRef$footerBotto);
    };
    var calculateThWidthList = function calculateThWidthList(trList) {
      var widthMap = {};
      if (!trList) return widthMap;
      for (var i = 0, len = trList.length; i < len; i++) {
        var thList = trList[i].children;
        for (var j = 0, thLen = thList.length; j < thLen; j++) {
          var th = thList[j];
          var colKey = th.dataset.colkey;
          widthMap[colKey] = th.getBoundingClientRect().width;
        }
      }
      return widthMap;
    };
    var updateThWidthList = function updateThWidthList(trList) {
      if (trList instanceof HTMLCollection) {
        if (columnResizable.value) return;
        thWidthList.value = calculateThWidthList(trList);
      } else {
        thWidthList.value = thWidthList.value || {};
        Object.entries(trList).forEach(function (_ref4) {
          var _ref5 = _slicedToArray(_ref4, 2),
            colKey = _ref5[0],
            width = _ref5[1];
          thWidthList.value[colKey] = width;
        });
      }
      return thWidthList.value;
    };
    var updateThWidthListHandler = function updateThWidthListHandler() {
      var timer = setTimeout(function () {
        var _tableContentRef$valu2;
        updateTableWidth();
        if (notNeedThWidthList.value) return;
        var thead = (_tableContentRef$valu2 = tableContentRef.value) === null || _tableContentRef$valu2 === void 0 ? void 0 : _tableContentRef$valu2.querySelector("thead");
        if (!thead) return;
        updateThWidthList(thead.children);
        clearTimeout(timer);
      }, 0);
    };
    var resetThWidthList = function resetThWidthList() {
      thWidthList.value = {};
    };
    var emitScrollEvent = function emitScrollEvent(e) {
      var _props$onScrollX, _props$onScrollY, _props$onScroll;
      (_props$onScrollX = props.onScrollX) === null || _props$onScrollX === void 0 || _props$onScrollX.call(props, {
        e: e
      });
      context.emit("scroll-x", {
        e: e
      });
      (_props$onScrollY = props.onScrollY) === null || _props$onScrollY === void 0 || _props$onScrollY.call(props, {
        e: e
      });
      context.emit("scroll-y", {
        e: e
      });
      (_props$onScroll = props.onScroll) === null || _props$onScroll === void 0 || _props$onScroll.call(props, {
        e: e
      });
      context.emit("scroll", {
        e: e
      });
    };
    var getThWidthList = function getThWidthList(type) {
      if (type === "calculate") {
        var _tableContentRef$valu3;
        var trList = (_tableContentRef$valu3 = tableContentRef.value) === null || _tableContentRef$valu3 === void 0 || (_tableContentRef$valu3 = _tableContentRef$valu3.querySelector("thead")) === null || _tableContentRef$valu3 === void 0 ? void 0 : _tableContentRef$valu3.children;
        return calculateThWidthList(trList);
      }
      return thWidthList.value || {};
    };
    VueCompositionAPI.watch([data, columns, bordered, tableLayout, tableContentWidth, isFixedHeader, isWidthOverflow, isFixedColumn, fixedRows, firstFullRow, lastFullRow], updateFixedStatus, {
      immediate: true
    });
    VueCompositionAPI.watch([isFixedColumn, columns], function () {
      var timer = setTimeout(function () {
        if (isFixedColumn.value) {
          updateColumnFixedShadow(tableContentRef.value);
        }
        clearTimeout(timer);
      }, 0);
    }, {
      immediate: true
    });
    VueCompositionAPI.watch([maxHeight, data, columns, bordered], updateFixedHeader, {
      immediate: true
    });
    VueCompositionAPI.watch(finalColumns, function () {
      resetThWidthList();
    });
    VueCompositionAPI.watch([data, bordered, tableLayout, fixedRows, isFixedHeader, headerAffixedTop, footerAffixedBottom, tableContentWidth], function () {
      var timer = setTimeout(function () {
        updateThWidthListHandler();
        updateAffixPosition();
        clearTimeout(timer);
      }, 60);
    }, {
      immediate: true
    });
    VueCompositionAPI.watch([finalColumns], function (_ref6, _ref7) {
      var _ref8 = _slicedToArray(_ref6, 1),
        finalColumns2 = _ref8[0];
      var _ref9 = _slicedToArray(_ref7, 1),
        preFinalColumns = _ref9[0];
      if (!props.showHeader) return;
      var finalColKeys = finalColumns2.map(function (t) {
        return t.colKey;
      });
      var preColKeys = preFinalColumns.map(function (t) {
        return t.colKey;
      });
      if (finalColKeys.length < preColKeys.length) {
        var reduceKeys = xorWith$1(preColKeys, finalColKeys);
        var thWidthList2 = getThWidthList("calculate");
        var reduceWidth = 0;
        reduceKeys.forEach(function (key) {
          reduceWidth += thWidthList2[key];
        });
        var rootThWidthList = pick$1(thWidthList2, preColKeys);
        var oldTotalWidth = Object.values(rootThWidthList).reduce(function () {
          var r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
          var n = arguments.length > 1 ? arguments[1] : undefined;
          return r + n;
        });
        var contentWidth = tableContentRef.value.clientWidth;
        var widthToReserve = oldTotalWidth - reduceWidth;
        setTableElmWidth(Math.max(contentWidth, widthToReserve));
      }
    });
    var refreshTable = function refreshTable() {
      updateThWidthListHandler();
      updateFixedHeader();
      updateAffixPosition();
      if (isFixedColumn.value || isFixedHeader.value) {
        updateFixedStatus();
        updateColumnFixedShadow(tableContentRef.value, {
          skipScrollLimit: true
        });
      }
    };
    var onResize = debounce$1(function () {
      refreshTable();
    }, 30);
    var resizeObserver = null;
    function addTableResizeObserver(tableElement) {
      if (typeof window === "undefined") return;
      if (getIEVersion$1() < 11 || typeof window.ResizeObserver === "undefined") return;
      off$1(window, "resize", onResize);
      resizeObserver = new window.ResizeObserver(function () {
        var timer = setTimeout(function () {
          refreshTable();
          clearTimeout(timer);
        }, 200);
      });
      resizeObserver.observe(tableElement);
      tableRef.value = tableElement;
    }
    VueCompositionAPI.onMounted(function () {
      var scrollWidth = getScrollbarWidthWithCSS();
      scrollbarWidth.value = scrollWidth;
      updateThWidthListHandler();
      var isWatchResize = isFixedColumn.value || isFixedHeader.value || !notNeedThWidthList.value || !data.value.length;
      var hasWindow = typeof window !== "undefined";
      var hasResizeObserver = hasWindow && typeof window.ResizeObserver !== "undefined";
      if (isWatchResize && getIEVersion$1() < 11 || !hasResizeObserver) {
        on$1(window, "resize", onResize);
      }
    });
    VueCompositionAPI.onBeforeUnmount(function () {
      var _resizeObserver, _resizeObserver2;
      if (typeof window !== "undefined") {
        off$1(window, "resize", onResize);
      }
      (_resizeObserver = resizeObserver) === null || _resizeObserver === void 0 || _resizeObserver.unobserve(tableRef.value);
      (_resizeObserver2 = resizeObserver) === null || _resizeObserver2 === void 0 || _resizeObserver2.disconnect();
    });
    var setData = function setData(dataSource) {
      data.value = dataSource;
    };
    var updateTableAfterColumnResize = function updateTableAfterColumnResize() {
      updateFixedStatus();
      updateFixedHeader();
    };
    return {
      tableWidth: tableWidth,
      tableElmWidth: tableElmWidth,
      thWidthList: thWidthList,
      isFixedHeader: isFixedHeader,
      isWidthOverflow: isWidthOverflow,
      tableContentRef: tableContentRef,
      isFixedColumn: isFixedColumn,
      showColumnShadow: showColumnShadow,
      rowAndColFixedPosition: rowAndColFixedPosition,
      virtualScrollHeaderPos: virtualScrollHeaderPos,
      scrollbarWidth: scrollbarWidth,
      setData: setData,
      refreshTable: refreshTable,
      setTableElmWidth: setTableElmWidth,
      emitScrollEvent: emitScrollEvent,
      updateThWidthListHandler: updateThWidthListHandler,
      updateColumnFixedShadow: updateColumnFixedShadow,
      setUseFixedTableElmRef: setUseFixedTableElmRef,
      getThWidthList: getThWidthList,
      updateThWidthList: updateThWidthList,
      addTableResizeObserver: addTableResizeObserver,
      updateTableAfterColumnResize: updateTableAfterColumnResize
    };
  }

  function ownKeys$G(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$F(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$G(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$G(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var DEFAULT_PAGE_SIZE = 10;
  function usePaginationValue(pagination, onPageChange) {
    var _pagination$value, _pagination$value2, _pagination$value3;
    if ((_pagination$value = pagination.value) !== null && _pagination$value !== void 0 && _pagination$value.current && (_pagination$value2 = pagination.value) !== null && _pagination$value2 !== void 0 && _pagination$value2.defaultPageSize || (_pagination$value3 = pagination.value) !== null && _pagination$value3 !== void 0 && _pagination$value3.defaultCurrent && pagination !== null && pagination !== void 0 && pagination.value.pageSize) {
      log.error("Table", "cannot set both current and defaultPageSize, or defaultCurrent and pagesize. current/pageSize and defaultCurrent/defaultPageSize are allowed.");
    }
    var innerPagination = VueCompositionAPI.ref();
    var setInnerPagination = VueCompositionAPI.ref(onPageChange);
    VueCompositionAPI.watch(function () {
      return _objectSpread$F({}, pagination.value);
    }, function (pagination2) {
      if (!pagination2) return [innerPagination, setInnerPagination];
      var isControlled = Boolean(pagination2 === null || pagination2 === void 0 ? void 0 : pagination2.current);
      if (isControlled) {
        innerPagination.value = pagination2;
        return;
      }
      if (!innerPagination.value && pagination2.defaultCurrent) {
        innerPagination.value = _objectSpread$F(_objectSpread$F({}, pagination2), {}, {
          current: pagination2.defaultCurrent,
          pageSize: pagination2.defaultPageSize || DEFAULT_PAGE_SIZE
        });
      } else if (innerPagination.value && !pagination2.defaultCurrent) {
        innerPagination.value = void 0;
      }
      setInnerPagination.value = function (newPagination, newData) {
        innerPagination.value = _objectSpread$F(_objectSpread$F({}, innerPagination.value), newPagination);
        onPageChange === null || onPageChange === void 0 || onPageChange(newPagination, newData);
      };
    }, {
      immediate: true
    });
    return [innerPagination, setInnerPagination];
  }
  function usePagination(props, context) {
    var _toRefs = VueCompositionAPI.toRefs(props),
      pagination = _toRefs.pagination,
      disableDataPage = _toRefs.disableDataPage,
      data = _toRefs.data;
    var _useConfig = useConfig(),
      classPrefix = _useConfig.classPrefix;
    var dataSource = VueCompositionAPI.ref([]);
    var onPageChange = function onPageChange(pageInfo, newData) {
      var _props$onPageChange;
      context.emit("page-change", pageInfo, newData);
      (_props$onPageChange = props.onPageChange) === null || _props$onPageChange === void 0 || _props$onPageChange.call(props, pageInfo, newData);
    };
    var _usePaginationValue = usePaginationValue(pagination, onPageChange),
      _usePaginationValue2 = _slicedToArray(_usePaginationValue, 2),
      innerPagination = _usePaginationValue2[0],
      setInnerPagination = _usePaginationValue2[1];
    var isPaginateData = VueCompositionAPI.computed(function () {
      var _innerPagination$valu;
      var pageSize = (innerPagination === null || innerPagination === void 0 || (_innerPagination$valu = innerPagination.value) === null || _innerPagination$valu === void 0 ? void 0 : _innerPagination$valu.pageSize) || DEFAULT_PAGE_SIZE;
      return Boolean(!disableDataPage.value && props.data.length > pageSize);
    });
    var getDataSourceAndPaginate = function getDataSourceAndPaginate() {
      var current = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_PAGE_SIZE;
      var data2 = props.data;
      var paginationData = [];
      if (isPaginateData.value) {
        var start = (current - 1) * pageSize;
        var end = current * pageSize;
        paginationData = data2.slice(start, end);
      } else {
        paginationData = data2;
      }
      return paginationData;
    };
    VueCompositionAPI.watch(function () {
      return [_objectSpread$F({}, innerPagination.value), _toConsumableArray(data.value)];
    }, function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        innerPagination2 = _ref2[0],
        data2 = _ref2[1];
      if (!(innerPagination2 !== null && innerPagination2 !== void 0 && innerPagination2.current)) {
        dataSource.value = data2;
        return;
      }
      var current = innerPagination2.current,
        pageSize = innerPagination2.pageSize;
      dataSource.value = getDataSourceAndPaginate(current, pageSize);
    }, {
      immediate: true
    });
    var renderPagination = function renderPagination(h) {
      if (!innerPagination.value) return null;
      return h("div", {
        "class": "".concat(classPrefix.value, "-table__pagination")
      }, [h(Pagination, helper([{}, {
        "props": _objectSpread$F(_objectSpread$F({}, props.pagination), innerPagination.value)
      }, {}, {
        "on": {
          change: function change(pageInfo) {
            var _setInnerPagination$v;
            var dataSource2 = getDataSourceAndPaginate(pageInfo.current, pageInfo.pageSize);
            setInnerPagination === null || setInnerPagination === void 0 || (_setInnerPagination$v = setInnerPagination.value) === null || _setInnerPagination$v === void 0 || _setInnerPagination$v.call(setInnerPagination, _objectSpread$F(_objectSpread$F({}, innerPagination.value), pageInfo), dataSource2);
          }
        }
      }, {
        "scopedSlots": {
          totalContent: context.slots.totalContent
        }
      }]))]);
    };
    return {
      isPaginateData: isPaginateData,
      dataSource: dataSource,
      innerPagination: innerPagination,
      renderPagination: renderPagination
    };
  }

  function useAffix(props) {
    var tableContentRef = VueCompositionAPI.ref();
    var affixHeaderRef = VueCompositionAPI.ref();
    var affixFooterRef = VueCompositionAPI.ref();
    var horizontalScrollbarRef = VueCompositionAPI.ref();
    var paginationRef = VueCompositionAPI.ref();
    var showAffixHeader = VueCompositionAPI.ref(true);
    var showAffixFooter = VueCompositionAPI.ref(true);
    var showAffixPagination = VueCompositionAPI.ref(true);
    var isMousedown = false;
    var isMouseInScrollableArea = false;
    var isVirtualScroll = VueCompositionAPI.computed(function () {
      return props.scroll && props.scroll.type === "virtual" && (props.scroll.threshold || 100) < props.data.length;
    });
    var isAffixed = VueCompositionAPI.computed(function () {
      return !!(props.headerAffixedTop || props.footerAffixedBottom || props.horizontalScrollAffixedBottom);
    });
    var lastScrollLeft = 0;
    var onHorizontalScroll = function onHorizontalScroll(scrollElement) {
      if (!isAffixed.value && !isVirtualScroll.value) return;
      var target = scrollElement;
      if (!target && tableContentRef.value) {
        lastScrollLeft = 0;
        target = tableContentRef.value;
      }
      if (!target) return;
      var left = target.scrollLeft;
      if (lastScrollLeft === left) return;
      lastScrollLeft = left;
      var toUpdateScrollElement = [tableContentRef.value, affixHeaderRef.value, affixFooterRef.value, horizontalScrollbarRef.value];
      for (var i = 0, len = toUpdateScrollElement.length; i < len; i++) {
        if (toUpdateScrollElement[i] && scrollElement !== toUpdateScrollElement[i]) {
          toUpdateScrollElement[i].scrollLeft = left;
        }
      }
    };
    var isAffixedBottomElementShow = function isAffixedBottomElementShow(elementRect, tableRect, headerHeight) {
      return tableRect.top + headerHeight < elementRect.top && elementRect.top > elementRect.height;
    };
    var isAffixedBottomScrollShow = function isAffixedBottomScrollShow(elementRect, tableRect, headerHeight) {
      return !!tableContentRef.value && tableContentRef.value.scrollWidth > tableContentRef.value.clientWidth && isAffixedBottomElementShow(elementRect, tableRect, headerHeight);
    };
    var getOffsetTop = function getOffsetTop(props2) {
      if (typeof props2 === "boolean") return 0;
      return props2.offsetTop || 0;
    };
    var updateAffixHeaderOrFooter = function updateAffixHeaderOrFooter() {
      var _tableContentRef$valu, _tableContentRef$valu2, _affixFooterRef$value;
      if (!isAffixed.value && !isVirtualScroll.value) return;
      var pos = (_tableContentRef$valu = tableContentRef.value) === null || _tableContentRef$valu === void 0 ? void 0 : _tableContentRef$valu.getBoundingClientRect();
      if (!pos) return;
      var headerRect = (_tableContentRef$valu2 = tableContentRef.value) === null || _tableContentRef$valu2 === void 0 || (_tableContentRef$valu2 = _tableContentRef$valu2.querySelector("thead")) === null || _tableContentRef$valu2 === void 0 ? void 0 : _tableContentRef$valu2.getBoundingClientRect();
      var headerHeight = (headerRect === null || headerRect === void 0 ? void 0 : headerRect.height) || 0;
      var footerRect = (_affixFooterRef$value = affixFooterRef.value) === null || _affixFooterRef$value === void 0 ? void 0 : _affixFooterRef$value.getBoundingClientRect();
      if ((props.headerAffixedTop || isVirtualScroll.value) && affixHeaderRef.value) {
        var offsetTop = getOffsetTop(props.headerAffixProps || props.headerAffixedTop);
        var footerHeight = (footerRect === null || footerRect === void 0 ? void 0 : footerRect.height) || 0;
        var r = Math.abs(pos.top) < pos.height - headerHeight - offsetTop - footerHeight;
        if (isVirtualScroll.value) {
          r = pos.top > -1 * headerRect.height;
        }
        showAffixHeader.value = r;
      }
      if (props.footerAffixedBottom && affixFooterRef !== null && affixFooterRef !== void 0 && affixFooterRef.value) {
        showAffixFooter.value = isAffixedBottomElementShow(footerRect, pos, headerHeight);
      } else if (props.horizontalScrollAffixedBottom && horizontalScrollbarRef !== null && horizontalScrollbarRef !== void 0 && horizontalScrollbarRef.value) {
        var horizontalScrollbarRect = horizontalScrollbarRef.value.getBoundingClientRect();
        showAffixFooter.value = isAffixedBottomScrollShow(horizontalScrollbarRect, pos, headerHeight);
      }
      if (props.paginationAffixedBottom && paginationRef.value) {
        var pageRect = paginationRef.value.getBoundingClientRect();
        showAffixPagination.value = isAffixedBottomElementShow(pageRect, pos, headerHeight);
      }
    };
    var onDocumentScroll = function onDocumentScroll() {
      updateAffixHeaderOrFooter();
    };
    var onFootScroll = function onFootScroll() {
      onHorizontalScroll(affixFooterRef.value);
    };
    var onHeaderScroll = function onHeaderScroll() {
      onHorizontalScroll(affixHeaderRef.value);
    };
    var horizontalScrollbarScroll = function horizontalScrollbarScroll() {
      onHorizontalScroll(horizontalScrollbarRef.value);
    };
    var onTableContentScroll = function onTableContentScroll() {
      onHorizontalScroll(tableContentRef.value);
    };
    var onFootMouseEnter = function onFootMouseEnter() {
      on$1(affixFooterRef.value, "scroll", onFootScroll);
    };
    var onFootMouseLeave = function onFootMouseLeave() {
      off$1(affixFooterRef.value, "scroll", onFootScroll);
    };
    var onHeaderMouseEnter = function onHeaderMouseEnter() {
      on$1(affixHeaderRef.value, "scroll", onHeaderScroll);
      onMouseEnterScrollableArea();
    };
    var onHeaderMouseLeave = function onHeaderMouseLeave() {
      if (!isMousedown) off$1(affixHeaderRef.value, "scroll", onHeaderScroll);
      onMouseLeaveScrollableArea();
    };
    var onScrollbarMouseEnter = function onScrollbarMouseEnter() {
      on$1(horizontalScrollbarRef.value, "scroll", horizontalScrollbarScroll);
    };
    var onScrollbarMouseLeave = function onScrollbarMouseLeave() {
      off$1(horizontalScrollbarRef.value, "scroll", horizontalScrollbarScroll);
    };
    var onTableContentMouseEnter = function onTableContentMouseEnter() {
      on$1(tableContentRef.value, "scroll", onTableContentScroll);
      onMouseEnterScrollableArea();
    };
    var onTableContentMouseLeave = function onTableContentMouseLeave() {
      if (!isMousedown) off$1(tableContentRef.value, "scroll", onTableContentScroll);
      onMouseLeaveScrollableArea();
    };
    var onMousedown = function onMousedown() {
      isMousedown = true;
    };
    var onMouseup = function onMouseup() {
      isMousedown = false;
      if (!isMouseInScrollableArea) {
        off$1(affixHeaderRef.value, "scroll", onHeaderScroll);
        off$1(tableContentRef.value, "scroll", onTableContentScroll);
      }
    };
    var onMouseEnterScrollableArea = function onMouseEnterScrollableArea() {
      isMouseInScrollableArea = true;
    };
    var onMouseLeaveScrollableArea = function onMouseLeaveScrollableArea() {
      isMouseInScrollableArea = false;
    };
    var addHorizontalScrollListeners = function addHorizontalScrollListeners() {
      on$1(window, "mousedown", onMousedown);
      on$1(window, "mouseup", onMouseup);
      removeHorizontalScrollListeners();
      if (affixHeaderRef.value) {
        on$1(affixHeaderRef.value, "mouseenter", onHeaderMouseEnter);
        on$1(affixHeaderRef.value, "mouseleave", onHeaderMouseLeave);
      }
      if (props.footerAffixedBottom && affixFooterRef.value) {
        on$1(affixFooterRef.value, "mouseenter", onFootMouseEnter);
        on$1(affixFooterRef.value, "mouseleave", onFootMouseLeave);
      }
      if (props.horizontalScrollAffixedBottom && horizontalScrollbarRef.value) {
        on$1(horizontalScrollbarRef.value, "mouseenter", onScrollbarMouseEnter);
        on$1(horizontalScrollbarRef.value, "mouseleave", onScrollbarMouseLeave);
      }
      if ((isAffixed.value || isVirtualScroll.value) && tableContentRef.value) {
        on$1(tableContentRef.value, "mouseenter", onTableContentMouseEnter);
        on$1(tableContentRef.value, "mouseleave", onTableContentMouseLeave);
      }
    };
    var activatingTouchScrollListenerCleanups = [];
    var setupElementTouchScrollListener = function setupElementTouchScrollListener(element) {
      var debounceOffScrollListener = debounce$1(function (listener) {
        off$1(element, "scroll", listener);
      }, 200);
      function onElementTouchScroll() {
        onHorizontalScroll(element);
        debounceOffScrollListener(onElementTouchScroll);
      }
      function onElementTouchStart(e) {
        if (e.composedPath().includes(element)) {
          activatingTouchScrollListenerCleanups.forEach(function (cleanup) {
            return cleanup();
          });
          activatingTouchScrollListenerCleanups.length = 0;
          on$1(element, "scroll", onElementTouchScroll);
          debounceOffScrollListener(onElementTouchScroll);
          activatingTouchScrollListenerCleanups.push(function () {
            off$1(element, "scroll", onElementTouchScroll);
          });
        }
      }
      on$1(element, "touchstart", onElementTouchStart);
      function removeElementTouchScrollListener() {
        off$1(element, "touchstart", onElementTouchStart);
      }
      return {
        removeElementTouchScrollListener: removeElementTouchScrollListener
      };
    };
    var elementTouchScrollCleanups = [];
    var cleanupElementTouchScroll = function cleanupElementTouchScroll() {
      elementTouchScrollCleanups.forEach(function (cleanup) {
        return cleanup();
      });
      elementTouchScrollCleanups.length = 0;
    };
    var removeHorizontalScrollListeners = function removeHorizontalScrollListeners() {
      off$1(window, "mousedown", onMousedown);
      off$1(window, "mouseup", onMouseup);
      cleanupElementTouchScroll();
      if (affixHeaderRef.value) {
        off$1(affixHeaderRef.value, "mouseenter", onHeaderMouseEnter);
        off$1(affixHeaderRef.value, "mouseleave", onHeaderMouseLeave);
        var _setupElementTouchScr = setupElementTouchScrollListener(affixHeaderRef.value),
          removeElementTouchScrollListener = _setupElementTouchScr.removeElementTouchScrollListener;
        elementTouchScrollCleanups.push(removeElementTouchScrollListener);
      }
      if (affixFooterRef.value) {
        off$1(affixFooterRef.value, "mouseenter", onFootMouseEnter);
        off$1(affixFooterRef.value, "mouseleave", onFootMouseLeave);
        var _setupElementTouchScr2 = setupElementTouchScrollListener(affixFooterRef.value),
          _removeElementTouchScrollListener = _setupElementTouchScr2.removeElementTouchScrollListener;
        elementTouchScrollCleanups.push(_removeElementTouchScrollListener);
      }
      if (tableContentRef.value) {
        off$1(tableContentRef.value, "mouseenter", onTableContentMouseEnter);
        off$1(tableContentRef.value, "mouseleave", onTableContentMouseLeave);
        var _setupElementTouchScr3 = setupElementTouchScrollListener(horizontalScrollbarRef.value),
          _removeElementTouchScrollListener2 = _setupElementTouchScr3.removeElementTouchScrollListener;
        elementTouchScrollCleanups.push(_removeElementTouchScrollListener2);
      }
      if (horizontalScrollbarRef.value) {
        off$1(horizontalScrollbarRef.value, "mouseenter", onScrollbarMouseEnter);
        off$1(horizontalScrollbarRef.value, "mouseleave", onScrollbarMouseLeave);
        var _setupElementTouchScr4 = setupElementTouchScrollListener(tableContentRef.value),
          _removeElementTouchScrollListener3 = _setupElementTouchScr4.removeElementTouchScrollListener;
        elementTouchScrollCleanups.push(_removeElementTouchScrollListener3);
      }
    };
    var addVerticalScrollListener = function addVerticalScrollListener() {
      if (!isAffixed.value && !props.paginationAffixedBottom) return;
      var timer = setTimeout(function () {
        if (isAffixed.value || props.paginationAffixedBottom) {
          on$1(document, "scroll", onDocumentScroll);
        } else {
          off$1(document, "scroll", onDocumentScroll);
        }
        clearTimeout(timer);
      });
    };
    VueCompositionAPI.watch([affixHeaderRef, affixFooterRef, horizontalScrollbarRef, tableContentRef], function () {
      addHorizontalScrollListeners();
      onHorizontalScroll();
      updateAffixHeaderOrFooter();
    });
    VueCompositionAPI.watch(isAffixed, addVerticalScrollListener);
    VueCompositionAPI.watch(function () {
      return [props.data, props.columns, props.headerAffixedTop, props.footerAffixedBottom, props.horizontalScrollAffixedBottom];
    }, function () {
      onHorizontalScroll();
    });
    VueCompositionAPI.onBeforeUnmount(function () {
      off$1(document, "scroll", onDocumentScroll);
      removeHorizontalScrollListeners();
      affixHeaderRef.value = null;
      affixFooterRef.value = null;
      horizontalScrollbarRef.value = null;
      tableContentRef.value = null;
    });
    var setTableContentRef = function setTableContentRef(tableContent) {
      tableContentRef.value = tableContent;
      addVerticalScrollListener();
    };
    return {
      showAffixHeader: showAffixHeader,
      showAffixFooter: showAffixFooter,
      showAffixPagination: showAffixPagination,
      affixHeaderRef: affixHeaderRef,
      affixFooterRef: affixFooterRef,
      horizontalScrollbarRef: horizontalScrollbarRef,
      paginationRef: paginationRef,
      onHorizontalScroll: onHorizontalScroll,
      setTableContentRef: setTableContentRef,
      updateAffixHeaderOrFooter: updateAffixHeaderOrFooter
    };
  }

  function formatRowAttributes(attributes, params) {
    if (!attributes) return void 0;
    var attrList = attributes instanceof Array ? attributes : [attributes];
    var result = {};
    for (var i = 0; i < attrList.length; i++) {
      var attrItem = attrList[i];
      if (!attrItem) continue;
      var attrProperty = isFunction(attrItem) ? attrItem(params) : attrItem;
      result = attrProperty instanceof Array ? formatRowAttributes(attrProperty, params) : Object.assign(result, attrProperty);
    }
    return result;
  }
  function formatRowClassNames(rowClassNames, params, rowKey) {
    var rowClassList = rowClassNames instanceof Array ? rowClassNames : [rowClassNames];
    var row = params.row,
      rowIndex = params.rowIndex;
    var customClasses = [];
    for (var i = 0, len = rowClassList.length; i < len; i++) {
      var rName = rowClassList[i];
      var tClass = isFunction(rName) ? rName(params) : rName;
      if (isObject(tClass) && !(tClass instanceof Array)) {
        tClass[rowIndex] && (tClass = tClass[rowIndex]);
        var rowId = get(row, rowKey || "id");
        tClass[rowId] && (tClass = tClass[rowId]);
      } else if (tClass instanceof Array) {
        tClass = formatRowClassNames(tClass, params, rowKey);
      }
      customClasses = customClasses.concat(tClass);
    }
    return customClasses;
  }
  function formatClassNames(classNames, params) {
    var classes = classNames instanceof Array ? classNames : [classNames];
    var arr = [];
    for (var i = 0, len = classes.length; i < len; i++) {
      var cls = classes[i];
      if (isFunction(cls)) {
        arr.push(cls(params));
      } else {
        arr.push(cls);
      }
    }
    return arr;
  }
  function getCurrentRowByKey(columns, key) {
    if (!columns || !key) return;
    var col = columns === null || columns === void 0 ? void 0 : columns.find(function (t) {
      return t.colKey === key;
    });
    if (col) return col;
    for (var i = 0, len = columns.length; i < len; i++) {
      var _columns$i;
      if ((_columns$i = columns[i]) !== null && _columns$i !== void 0 && (_columns$i = _columns$i.children) !== null && _columns$i !== void 0 && _columns$i.length) {
        var _columns$i2;
        return getCurrentRowByKey((_columns$i2 = columns[i]) === null || _columns$i2 === void 0 ? void 0 : _columns$i2.children, key);
      }
    }
  }
  function getAffixProps(mainAffixProps, subAffixProps) {
    if (_typeof$2(mainAffixProps) === "object") return mainAffixProps;
    if (_typeof$2(subAffixProps) === "object") return subAffixProps;
    return {};
  }

  function getCellKey(row, rowKey, colKey, colIndex) {
    var rowValue = get(row, rowKey);
    if (rowValue === void 0) {
      log.error("Table", "rowKey is wrong, can not get unique identifier of row.");
    }
    return [rowValue, colKey || colIndex].join("_");
  }
  function useRowspanAndColspan(data, columns, rowKey, rowspanAndColspan) {
    var skipSpansMap = VueCompositionAPI.ref(/* @__PURE__ */new Map());
    var onTrRowspanOrColspan = function onTrRowspanOrColspan(params, skipSpansValue) {
      var rowIndex = params.rowIndex,
        colIndex = params.colIndex;
      if (!skipSpansValue.rowspan && !skipSpansValue.colspan) return;
      var maxRowIndex = rowIndex + (skipSpansValue.rowspan || 1);
      var maxColIndex = colIndex + (skipSpansValue.colspan || 1);
      for (var i = rowIndex; i < maxRowIndex; i++) {
        for (var j = colIndex; j < maxColIndex; j++) {
          if (i !== rowIndex || j !== colIndex) {
            if (!data.value[i] || !columns.value[j]) return;
            var cellKey = getCellKey(data.value[i], rowKey.value, columns.value[j].colKey, j);
            var state = skipSpansMap.value.get(cellKey) || {};
            state.skipped = true;
            skipSpansMap.value.set(cellKey, state);
          }
        }
      }
    };
    var updateSkipSpansMap = function updateSkipSpansMap(data2, columns2, rowspanAndColspan2) {
      var _skipSpansMap$value;
      (_skipSpansMap$value = skipSpansMap.value) === null || _skipSpansMap$value === void 0 || _skipSpansMap$value.clear();
      if (!data2 || !rowspanAndColspan2) return;
      for (var i = 0, len = data2.length; i < len; i++) {
        var row = data2[i];
        for (var j = 0, colLen = columns2.length; j < colLen; j++) {
          var col = columns2[j];
          var params = {
            row: row,
            col: col,
            rowIndex: i,
            colIndex: j
          };
          var cellKey = getCellKey(row, rowKey.value, col.colKey, j);
          var state = skipSpansMap.value.get(cellKey) || {};
          var o = rowspanAndColspan2(params) || {};
          if (o.rowspan || o.colspan || state.rowspan || state.colspan) {
            o.rowspan && (state.rowspan = o.rowspan);
            o.colspan && (state.colspan = o.colspan);
            skipSpansMap.value.set(cellKey, state);
          }
          onTrRowspanOrColspan === null || onTrRowspanOrColspan === void 0 || onTrRowspanOrColspan(params, state);
        }
      }
    };
    VueCompositionAPI.watch(function () {
      return [data.value, columns.value, rowspanAndColspan];
    }, function () {
      updateSkipSpansMap(data.value, columns.value, rowspanAndColspan === null || rowspanAndColspan === void 0 ? void 0 : rowspanAndColspan.value);
    }, {
      immediate: true
    });
    return {
      skipSpansMap: skipSpansMap
    };
  }

  function ownKeys$F(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$E(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$F(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$F(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var TABLE_PROPS = ["rowKey", "rowClassName", "columns", "fixedRows", "footData", "rowAttributes", "rowspanAndColspan", "scroll", "cellEmptyContent", "pagination", "attach", "onCellClick", "onRowClick", "onRowDblclick", "onRowMouseover", "onRowMousedown", "onRowMouseenter", "onRowMouseleave", "onRowMouseup"];
  var ROW_LISTENERS = ["click", "dblclick", "mouseover", "mousedown", "mouseenter", "mouseleave", "mouseup"];
  function renderCell(params, slots, extra) {
    var col = params.col,
      row = params.row,
      rowIndex = params.rowIndex;
    if (col.colKey === "serial-number") {
      var _ref = (extra === null || extra === void 0 ? void 0 : extra.pagination) || {},
        current = _ref.current,
        pageSize = _ref.pageSize,
        defaultCurrent = _ref.defaultCurrent,
        defaultPageSize = _ref.defaultPageSize;
      var tCurrent = current || defaultCurrent;
      var tPageSize = pageSize || defaultPageSize;
      if (tPageSize && tCurrent) {
        return tPageSize * (tCurrent - 1) + rowIndex + 1;
      }
      return rowIndex + 1;
    }
    if (isFunction(col.cell)) {
      return col.cell(VueCompositionAPI.h, params);
    }
    if (slots[col.colKey]) {
      return slots[col.colKey](params);
    }
    if (isString(col.cell) && slots[col.cell]) {
      return slots[col.cell](params);
    }
    if (isFunction(col.render)) {
      return col.render(VueCompositionAPI.h, _objectSpread$E(_objectSpread$E({}, params), {}, {
        type: "cell"
      }));
    }
    var r = get(row, col.colKey);
    if (![void 0, "", null].includes(r)) return r;
    if (extra !== null && extra !== void 0 && extra.cellEmptyContent) {
      return isFunction(extra.cellEmptyContent) ? extra.cellEmptyContent(VueCompositionAPI.h, params) : extra.cellEmptyContent;
    }
    var hParams = VueCompositionAPI.h;
    Object.assign(hParams, params || {});
    if (slots.cellEmptyContent) {
      return slots.cellEmptyContent(hParams);
    }
    if (slots["cell-empty-content"]) {
      return slots["cell-empty-content"](hParams);
    }
    return r;
  }
  var TrElement = VueCompositionAPI.defineComponent({
    name: "TR",
    props: _objectSpread$E(_objectSpread$E({
      row: Object,
      rowIndex: Number,
      ellipsisOverlayClassName: String,
      classPrefix: String,
      dataLength: Number,
      rowAndColFixedPosition: Map,
      skipSpansMap: Map,
      virtualConfig: Object,
      active: Boolean,
      isHover: Boolean
    }, pick$1(baseTableProps, TABLE_PROPS)), {}, {
      tableElm: {},
      tableContentElm: {}
    }),
    setup: function setup(props, context) {
      var _toRefs = VueCompositionAPI.toRefs(props),
        tableContentElm = _toRefs.tableContentElm,
        active = _toRefs.active,
        isHover = _toRefs.isHover;
      var trRef = VueCompositionAPI.ref(null);
      var _useClassName = useClassName(),
        tdEllipsisClass = _useClassName.tdEllipsisClass,
        tableBaseClass = _useClassName.tableBaseClass,
        tableColFixedClasses = _useClassName.tableColFixedClasses,
        tableRowFixedClasses = _useClassName.tableRowFixedClasses,
        tdAlignClasses = _useClassName.tdAlignClasses,
        tableDraggableClasses = _useClassName.tableDraggableClasses;
      var trStyles = VueCompositionAPI.computed(function () {
        return getRowFixedStyles(get(props.row, props.rowKey || "id"), props.rowIndex, props.dataLength, props.fixedRows, props.rowAndColFixedPosition, tableRowFixedClasses);
      });
      var trAttributes = VueCompositionAPI.computed(function () {
        return formatRowAttributes(props.rowAttributes, {
          row: props.row,
          rowIndex: props.rowIndex,
          type: "body"
        });
      });
      var classes = VueCompositionAPI.computed(function () {
        var _trStyles$value;
        var customClasses = formatRowClassNames(props.rowClassName, {
          row: props.row,
          rowKey: props.rowKey,
          rowIndex: props.rowIndex,
          type: "body"
        }, props.rowKey || "id");
        return [(_trStyles$value = trStyles.value) === null || _trStyles$value === void 0 ? void 0 : _trStyles$value.classes, customClasses, _defineProperty$2(_defineProperty$2({}, "".concat(props.classPrefix, "-table__row--active"), active.value), "".concat(props.classPrefix, "-table__row--hover"), isHover.value)].filter(function (v) {
          return v;
        });
      });
      var _useLazyLoad = useLazyLoad(tableContentElm, trRef, VueCompositionAPI.reactive(_objectSpread$E({}, props.scroll))),
        hasLazyLoadHolder = _useLazyLoad.hasLazyLoadHolder,
        tRowHeight = _useLazyLoad.tRowHeight;
      var getTrListeners = function getTrListeners(row, rowIndex) {
        var trListeners = {};
        ROW_LISTENERS.forEach(function (eventName) {
          trListeners[eventName] = function (e) {
            var _props;
            var p = {
              e: e,
              row: row,
              index: rowIndex
            };
            (_props = props["onRow".concat(upperFirst$1(eventName))]) === null || _props === void 0 || _props.call(props, p);
            context.emit("row-".concat(eventName), p);
          };
        });
        return trListeners;
      };
      VueCompositionAPI.watch([trRef], function () {
        var _props$virtualConfig;
        if ((_props$virtualConfig = props.virtualConfig) !== null && _props$virtualConfig !== void 0 && _props$virtualConfig.isVirtualScroll.value) {
          context.emit("row-mounted", {
            ref: trRef,
            data: props.row
          });
        }
      });
      return {
        trRef: trRef,
        tableColFixedClasses: tableColFixedClasses,
        tableDraggableClasses: tableDraggableClasses,
        tdEllipsisClass: tdEllipsisClass,
        tableBaseClass: tableBaseClass,
        tdAlignClasses: tdAlignClasses,
        trStyles: trStyles,
        classes: classes,
        trAttributes: trAttributes,
        tRowHeight: tRowHeight,
        hasLazyLoadHolder: hasLazyLoadHolder,
        getTrListeners: getTrListeners
      };
    },
    methods: {
      renderEllipsisCell: function renderEllipsisCell(h2, cellParams, params) {
        var _this = this;
        var h = this.$createElement;
        var cellNode = params.cellNode;
        var col = cellParams.col;
        var content;
        if (isFunction(col.ellipsis)) {
          content = col.ellipsis(h2, cellParams);
        } else if (_typeof$2(col.ellipsis) === "object" && isFunction(col.ellipsis.content)) {
          content = col.ellipsis.content(h2, cellParams);
        } else if (this.$scopedSlots["ellipsis-".concat(col.colKey)]) {
          content = this.$scopedSlots["ellipsis-".concat(col.colKey)](cellParams);
        } else if (this.$scopedSlots.ellipsis) {
          content = this.$scopedSlots.ellipsis(cellParams);
        }
        var tooltipProps = {};
        if (_typeof$2(col.ellipsis) === "object") {
          tooltipProps = "props" in col.ellipsis ? col.ellipsis.props : col.ellipsis || void 0;
        }
        return h(TEllipsis, {
          "attrs": {
            "placement": "top",
            "attach": this.attach || (this.tableElm ? function () {
              return _this.tableElm;
            } : void 0),
            "tooltipContent": content && function () {
              return content;
            },
            "tooltipProps": tooltipProps,
            "overlayClassName": this.ellipsisOverlayClassName,
            "classPrefix": this.classPrefix
          }
        }, [cellNode]);
      },
      renderTd: function renderTd(h2, params, extra) {
        var _this2 = this;
        var h = this.$createElement;
        var col = params.col,
          colIndex = params.colIndex,
          rowIndex = params.rowIndex;
        var cellSpans = extra.cellSpans,
          dataLength = extra.dataLength,
          rowAndColFixedPosition = extra.rowAndColFixedPosition;
        var cellNode = renderCell(params, this.$scopedSlots, {
          cellEmptyContent: extra.cellEmptyContent,
          pagination: this.pagination
        });
        var tdStyles = getColumnFixedStyles(col, colIndex, rowAndColFixedPosition, this.tableColFixedClasses);
        var customClasses = formatClassNames(col.className, _objectSpread$E(_objectSpread$E({}, params), {}, {
          type: "td"
        }));
        var classes = [tdStyles.classes, customClasses, _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({}, this.tdEllipsisClass, col.ellipsis), this.tableBaseClass.tdLastRow, rowIndex + cellSpans.rowspan === dataLength), this.tableBaseClass.tdFirstCol, colIndex === 0 && this.rowspanAndColspan), this.tdAlignClasses[col.align], col.align && col.align !== "left"), this.tableDraggableClasses.handle, col.colKey === "drag")];
        var onClick = function onClick(e) {
          var _this2$onCellClick;
          var p = _objectSpread$E(_objectSpread$E({}, params), {}, {
            e: e
          });
          if (col.stopPropagation) {
            e.stopPropagation();
          }
          (_this2$onCellClick = _this2.onCellClick) === null || _this2$onCellClick === void 0 || _this2$onCellClick.call(_this2, p);
          _this2.$emit("cell-click", p);
        };
        var normalAttrs = isFunction(col.attrs) ? col.attrs(_objectSpread$E(_objectSpread$E({}, params), {}, {
          type: "td"
        })) : col.attrs;
        var attrs = _objectSpread$E(_objectSpread$E({}, normalAttrs), cellSpans);
        return h("td", helper([{
          "class": classes
        }, {
          "attrs": attrs
        }, {
          "style": _objectSpread$E(_objectSpread$E({}, tdStyles.style), attrs.style),
          "on": {
            "click": onClick
          }
        }]), [col.ellipsis ? this.renderEllipsisCell(h2, params, {
          cellNode: cellNode
        }) : cellNode]);
      }
    },
    render: function render(h2) {
      var _this$columns,
        _this3 = this,
        _this$trStyles;
      var h = arguments[0];
      var row = this.row,
        rowIndex = this.rowIndex,
        dataLength = this.dataLength,
        rowAndColFixedPosition = this.rowAndColFixedPosition;
      var columnVNodeList = (_this$columns = this.columns) === null || _this$columns === void 0 ? void 0 : _this$columns.map(function (col, colIndex) {
        var cellSpans = {};
        var params = {
          row: row,
          col: col,
          rowIndex: rowIndex,
          colIndex: colIndex
        };
        var spanState = null;
        if (_this3.skipSpansMap.size) {
          var _spanState, _spanState2;
          var cellKey = getCellKey(row, _this3.rowKey, col.colKey, colIndex);
          spanState = _this3.skipSpansMap.get(cellKey) || {};
          ((_spanState = spanState) === null || _spanState === void 0 ? void 0 : _spanState.rowspan) > 1 && (cellSpans.rowspan = spanState.rowspan);
          ((_spanState2 = spanState) === null || _spanState2 === void 0 ? void 0 : _spanState2.colspan) > 1 && (cellSpans.colspan = spanState.colspan);
          if (spanState.skipped) return null;
        }
        return _this3.renderTd(h2, params, {
          dataLength: dataLength,
          rowAndColFixedPosition: rowAndColFixedPosition,
          columnLength: _this3.columns.length,
          cellSpans: cellSpans,
          cellEmptyContent: _this3.cellEmptyContent
        });
      });
      var attrs = this.trAttributes || {};
      return h("tr", helper([{
        "ref": "trRef"
      }, {
        "attrs": attrs
      }, {
        "style": (_this$trStyles = this.trStyles) === null || _this$trStyles === void 0 ? void 0 : _this$trStyles.style,
        "class": this.classes
      }, {
        "on": this.getTrListeners(row, rowIndex)
      }]), [this.hasLazyLoadHolder ? [h("td", {
        "style": {
          height: "".concat(this.tRowHeight, "px"),
          border: "none"
        }
      })] : columnVNodeList]);
    }
  });

  function ownKeys$E(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$D(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$E(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$E(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var ROW_AND_TD_LISTENERS = ROW_LISTENERS.concat("cell-click");
  var extendTableProps = ["bordered", "rowKey", "rowClassName", "rowAttributes", "loading", "empty", "fixedRows", "firstFullRow", "lastFullRow", "rowspanAndColspan", "scroll", "cellEmptyContent", "pagination", "attach", "onCellClick", "onPageChange", "onRowClick", "onRowDblclick", "onRowMouseover", "onRowMousedown", "onRowMouseenter", "onRowMouseleave", "onRowMouseup", "onScroll", "onScrollX", "onScrollY"];
  var TBody = VueCompositionAPI.defineComponent({
    name: "TBody",
    props: _objectSpread$D({
      classPrefix: String,
      ellipsisOverlayClassName: String,
      data: Array,
      columns: Array,
      rowAndColFixedPosition: Map,
      showColumnShadow: Object,
      tableElm: {},
      tableWidth: Number,
      isWidthOverflow: Boolean,
      virtualConfig: Object,
      tableContentElm: {},
      handleRowMounted: Function,
      renderExpandedRow: Function,
      firstFullRow: [String, Function],
      lastFullRow: [String, Function],
      activeRow: Array,
      hoverRow: [String, Number]
    }, pick$1(baseTableProps, extendTableProps)),
    setup: function setup(props, _ref) {
      var emit = _ref.emit;
      var renderTNode = useTNodeJSX();
      var _toRefs = VueCompositionAPI.toRefs(props),
        data = _toRefs.data,
        columns = _toRefs.columns,
        rowKey = _toRefs.rowKey,
        rowspanAndColspan = _toRefs.rowspanAndColspan;
      var _useConfig = useConfig("table", props.locale),
        t = _useConfig.t,
        global = _useConfig.global;
      var _useClassName = useClassName(),
        tableFullRowClasses = _useClassName.tableFullRowClasses,
        tableBaseClass = _useClassName.tableBaseClass;
      var _useRowspanAndColspan = useRowspanAndColspan(data, columns, rowKey, rowspanAndColspan),
        skipSpansMap = _useRowspanAndColspan.skipSpansMap;
      var tbodyClasses = VueCompositionAPI.computed(function () {
        return [tableBaseClass.body];
      });
      var isFixedLeftColumn = VueCompositionAPI.computed(function () {
        return props.isWidthOverflow && !!props.columns.find(function (col) {
          return col.fixed === "left";
        });
      });
      var getTrListeners = function getTrListeners() {
        var trListeners = {};
        ROW_AND_TD_LISTENERS.forEach(function (eventName) {
          var name = ["cell-click"].includes(eventName) ? eventName : "row-".concat(eventName);
          trListeners[name] = function (context) {
            emit(name, context);
          };
        });
        return trListeners;
      };
      return {
        t: t,
        global: global,
        tableFullRowClasses: tableFullRowClasses,
        tbodyClasses: tbodyClasses,
        tableBaseClass: tableBaseClass,
        isFixedLeftColumn: isFixedLeftColumn,
        skipSpansMap: skipSpansMap,
        renderTNode: renderTNode,
        getTrListeners: getTrListeners
      };
    },
    render: function render(h) {
      var _this = this,
        _this$data,
        _this$data2,
        _this$data3,
        _this$virtualConfig,
        _this$virtualConfig2;
      var renderEmpty = function renderEmpty(h2, columns) {
        var showEmptyText = Boolean(_this.tableWidth && _this.tableWidth > 100) || "development" === "test";
        var tableWidth = _this.bordered ? _this.tableWidth - 2 : _this.tableWidth;
        return h("tr", {
          "class": [_this.tableBaseClass.emptyRow, _defineProperty$2({}, _this.tableFullRowClasses.base, _this.isWidthOverflow)]
        }, [h("td", {
          "attrs": {
            "colspan": columns.length
          }
        }, [h("div", {
          "class": [_this.tableBaseClass.empty, _defineProperty$2({}, _this.tableFullRowClasses.innerFullRow, _this.isWidthOverflow)],
          "style": _this.isWidthOverflow ? {
            width: "".concat(tableWidth, "px")
          } : {}
        }, [showEmptyText ? _this.renderTNode("empty") || _this.t(_this.global.empty) : ""])])]);
      };
      var getFullRow = function getFullRow(h2, columnLength2, type) {
        var tType = camelCase$1(type);
        var fullRowNode = _this.renderTNode(tType);
        if (["", null, void 0, false].includes(fullRowNode)) return null;
        var classes = [_this.tableFullRowClasses.base, _this.tableFullRowClasses[tType]];
        var tableWidth = _this.bordered ? _this.tableWidth - 2 : _this.tableWidth;
        return h("tr", {
          "class": classes
        }, [h("td", {
          "attrs": {
            "colspan": columnLength2
          }
        }, [h("div", {
          "class": _defineProperty$2({}, _this.tableFullRowClasses.innerFullRow, _this.isFixedToLeft),
          "style": _this.isFixedToLeft ? {
            width: "".concat(tableWidth, "px")
          } : {}
        }, [h("div", {
          "class": _this.tableFullRowClasses.innerFullElement
        }, [fullRowNode])])])]);
      };
      var columnLength = this.columns.length;
      var dataLength = (_this$data = this.data) === null || _this$data === void 0 ? void 0 : _this$data.length;
      var trNodeList = [];
      var properties = ["classPrefix", "ellipsisOverlayClassName", "rowAndColFixedPosition", "scroll", "tableElm", "tableContentElm", "pagination", "attach"];
      (_this$data2 = this.data) === null || _this$data2 === void 0 || _this$data2.forEach(function (row, rowIndex) {
        var _this$activeRow;
        var rowKey = _this.rowKey || "id";
        var rowValue = get(row, rowKey);
        var trProps = _objectSpread$D(_objectSpread$D({}, pick$1(_this.$props, TABLE_PROPS)), {}, {
          rowKey: rowKey,
          row: row,
          columns: _this.columns,
          rowIndex: (row === null || row === void 0 ? void 0 : row.__VIRTUAL_SCROLL_INDEX) || rowIndex,
          dataLength: dataLength,
          skipSpansMap: _this.skipSpansMap,
          virtualConfig: _this.virtualConfig,
          active: (_this$activeRow = _this.activeRow) === null || _this$activeRow === void 0 ? void 0 : _this$activeRow.includes(rowValue),
          isHover: _this.hoverRow === rowValue
        }, pick$1(_this.$props, properties));
        if (_this.onCellClick) {
          trProps.onCellClick = _this.onCellClick;
        }
        var on = _this.getTrListeners();
        if (_this.handleRowMounted) {
          on["row-mounted"] = _this.handleRowMounted;
        }
        var trNode = h(TrElement, helper([{
          "scopedSlots": _this.$scopedSlots,
          "key": get(row, _this.rowKey || "id")
        }, {
          "on": on
        }, {}, {
          "props": trProps
        }]));
        trNodeList.push(trNode);
        if (_this.renderExpandedRow) {
          var p = {
            row: row,
            index: rowIndex,
            columns: _this.columns,
            tableWidth: _this.tableWidth,
            isWidthOverflow: _this.isWidthOverflow
          };
          var expandedContent = _this.renderExpandedRow(h, p);
          expandedContent && trNodeList.push(expandedContent);
        }
      });
      var list = [getFullRow(h, columnLength, "first-full-row"), trNodeList, getFullRow(h, columnLength, "last-full-row")];
      var isEmpty = !((_this$data3 = this.data) !== null && _this$data3 !== void 0 && _this$data3.length) && !this.loading && !this.firstFullRow && !this.lastFullRow;
      var translate = "translateY(".concat((_this$virtualConfig = this.virtualConfig) === null || _this$virtualConfig === void 0 ? void 0 : _this$virtualConfig.translateY.value, "px)");
      var posStyle = (_this$virtualConfig2 = this.virtualConfig) !== null && _this$virtualConfig2 !== void 0 && _this$virtualConfig2.isVirtualScroll.value ? {
        transform: translate,
        "-ms-transform": translate,
        "-moz-transform": translate,
        "-webkit-transform": translate
      } : void 0;
      return h("tbody", {
        "class": this.tbodyClasses,
        "style": _objectSpread$D({}, posStyle)
      }, [isEmpty ? renderEmpty(h, this.columns) : list]);
    }
  });

  function formatCSSUnit(unit) {
    if (!unit) return unit;
    return isNaN(Number(unit)) ? unit : "".concat(unit, "px");
  }
  function useStyle(props) {
    var _toRefs = VueCompositionAPI.toRefs(props),
      bordered = _toRefs.bordered,
      stripe = _toRefs.stripe,
      hover = _toRefs.hover,
      verticalAlign = _toRefs.verticalAlign,
      height = _toRefs.height,
      maxHeight = _toRefs.maxHeight,
      tableContentWidth = _toRefs.tableContentWidth;
    var _useClassName = useClassName(),
      tableBaseClass = _useClassName.tableBaseClass,
      tableAlignClasses = _useClassName.tableAlignClasses;
    var _useCommonClassName = useCommonClassName(),
      sizeClassNames = _useCommonClassName.sizeClassNames;
    var _useConfig = useConfig("table", props.locale),
      global = _useConfig.global;
    var tableSize = VueCompositionAPI.computed(function () {
      var _props$size;
      return (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : global.value.size;
    });
    var tableClasses = VueCompositionAPI.computed(function () {
      return [tableBaseClass.table, _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({}, sizeClassNames[tableSize.value], tableSize.value !== "medium"), tableBaseClass.bordered, bordered.value), tableBaseClass.striped, stripe.value), tableBaseClass.hover, hover.value), tableBaseClass.loading, props.loading), tableBaseClass.affixedHeader, props.headerAffixedTop), tableBaseClass.rowspanAndColspan, props.rowspanAndColspan), tableBaseClass.horizontalBarAffixed, props.horizontalScrollAffixedBottom), tableBaseClass.footerAffixed, props.footerAffixedBottom), tableAlignClasses[verticalAlign.value], verticalAlign.value !== "middle")];
    });
    var tableContentStyles = VueCompositionAPI.computed(function () {
      return {
        height: formatCSSUnit(height.value),
        maxHeight: formatCSSUnit(maxHeight.value)
      };
    });
    var tableElementStyles = VueCompositionAPI.computed(function () {
      return {
        width: formatCSSUnit(tableContentWidth.value)
      };
    });
    return {
      sizeClassNames: sizeClassNames,
      tableClasses: tableClasses,
      tableElementStyles: tableElementStyles,
      tableContentStyles: tableContentStyles
    };
  }

  function useRowHighlight(props, tableRef) {
    var _toRefs = VueCompositionAPI.toRefs(props),
      data = _toRefs.data,
      activeRowType = _toRefs.activeRowType,
      activeRowKeys = _toRefs.activeRowKeys,
      defaultActiveRowKeys = _toRefs.defaultActiveRowKeys,
      disableSpaceInactiveRow = _toRefs.disableSpaceInactiveRow;
    var currentOperationRowIndex = VueCompositionAPI.ref(-1);
    var isShiftPressed = VueCompositionAPI.ref(false);
    var shiftSelectionState = VueCompositionAPI.ref(false);
    var areaSelectionStartIndex = VueCompositionAPI.ref(-1);
    var _useDefaultValue = useDefaultValue(activeRowKeys, defaultActiveRowKeys.value, props.onActiveChange, "active-row-keys", "active-change"),
      _useDefaultValue2 = _slicedToArray(_useDefaultValue, 2),
      tActiveRow = _useDefaultValue2[0],
      setTActiveRow = _useDefaultValue2[1];
    var handleInactive = function handleInactive(ctx) {
      var row = ctx.row;
      var rowValue = get(row, props.rowKey);
      if (activeRowType.value === "single") {
        setTActiveRow([], {
          type: "inactive",
          activeRowList: [],
          currentRowData: row
        });
      } else if (activeRowType.value === "multiple") {
        var newActiveRowKeys = tActiveRow.value.filter(function (t) {
          return t !== rowValue;
        });
        setTActiveRow(newActiveRowKeys, {
          type: "inactive",
          activeRowList: [],
          currentRowData: row
        });
      }
    };
    var handleActive = function handleActive(ctx) {
      var row = ctx.row;
      var rowValue = get(row, props.rowKey);
      if (activeRowType.value === "single") {
        setTActiveRow([rowValue], {
          activeRowList: [{
            row: row,
            rowIndex: ctx.index
          }],
          currentRowData: row,
          type: "active"
        });
      } else {
        var newActiveRowKeys = tActiveRow.value.concat(rowValue);
        var activeRowList = [];
        for (var i = 0, len = data.value.length; i < len; i++) {
          var row2 = data.value[i];
          if (newActiveRowKeys.includes(get(row2, props.rowKey))) {
            activeRowList.push({
              row: row2,
              rowIndex: i
            });
          }
        }
        setTActiveRow(newActiveRowKeys, {
          activeRowList: activeRowList,
          currentRowData: row,
          type: "active"
        });
      }
    };
    var handleShiftActive = function handleShiftActive(ctx) {
      document.getSelection().removeAllRanges();
      var row = ctx.row;
      var currentIndex = currentOperationRowIndex.value;
      var startIndex = Math.min(areaSelectionStartIndex.value, currentIndex);
      var endIndex = Math.max(areaSelectionStartIndex.value, currentIndex);
      var newActiveRowData = [];
      for (var i = startIndex; i <= endIndex; i++) {
        newActiveRowData.push({
          row: data.value[i],
          rowIndex: i
        });
      }
      var newActiveRowKeys = newActiveRowData.map(function (item) {
        return get(item.row, props.rowKey);
      });
      setTActiveRow(newActiveRowKeys, {
        activeRowList: newActiveRowData,
        type: "active",
        currentRowData: row
      });
    };
    var getActiveRowList = function getActiveRowList() {
      var list = [];
      for (var i = 0, len = data.value.length; i < len; i++) {
        var row = data.value[i];
        var rowValue = get(row, props.rowKey);
        if (tActiveRow.value.includes(rowValue)) {
          list.push({
            row: row,
            rowIndex: i
          });
        }
      }
      return list;
    };
    var onHighlightRow = function onHighlightRow(ctx, extra) {
      if (!activeRowType.value) return;
      var row = ctx.row,
        index = ctx.index;
      var rowValue = get(row, props.rowKey);
      if (isShiftPressed.value) {
        currentOperationRowIndex.value = index;
        handleShiftActive(ctx);
        shiftSelectionState.value = true;
      } else if (tActiveRow.value.includes(rowValue) && (extra === null || extra === void 0 ? void 0 : extra.action) !== "active") {
        handleInactive(ctx);
        currentOperationRowIndex.value = index;
      } else {
        handleActive(ctx);
        currentOperationRowIndex.value = index;
      }
    };
    var clearActive = function clearActive() {
      var _props$onActiveRowAct;
      setTActiveRow([], {
        activeRowList: [],
        currentRowData: void 0,
        type: "inactive"
      });
      (_props$onActiveRowAct = props.onActiveRowAction) === null || _props$onActiveRowAct === void 0 || _props$onActiveRowAct.call(props, {
        action: "clear",
        activeRowList: []
      });
      currentOperationRowIndex.value = -1;
    };
    var setAllActive = function setAllActive() {
      var _props$onActiveRowAct2;
      var activeKeys = data.value.map(function (item) {
        return get(item, props.rowKey);
      });
      var activeRowList = data.value.map(function (row, rowIndex) {
        return {
          row: row,
          rowIndex: rowIndex
        };
      });
      setTActiveRow(activeKeys, {
        activeRowList: activeRowList,
        currentRowData: void 0,
        type: "active"
      });
      (_props$onActiveRowAct2 = props.onActiveRowAction) === null || _props$onActiveRowAct2 === void 0 || _props$onActiveRowAct2.call(props, {
        action: "select-all",
        activeRowList: activeRowList
      });
      currentOperationRowIndex.value = -1;
    };
    var clearShiftAreaSelection = function clearShiftAreaSelection() {
      shiftSelectionState.value = false;
    };
    var keyboardDownListener = function keyboardDownListener(e) {
      var _e$key;
      var code = e.code || ((_e$key = e.key) === null || _e$key === void 0 ? void 0 : _e$key.trim());
      if (ARROW_DOWN_REG.test(code)) {
        e.preventDefault();
        var index = Math.min(data.value.length - 1, currentOperationRowIndex.value + 1);
        if (activeRowType.value === "single") {
          onHighlightRow({
            row: data.value[index],
            index: index,
            e: e
          }, {
            action: "active"
          });
        } else {
          currentOperationRowIndex.value = index;
        }
      } else if (ARROW_UP_REG.test(code)) {
        e.preventDefault();
        var _index = Math.max(0, currentOperationRowIndex.value - 1);
        if (activeRowType.value === "single") {
          onHighlightRow({
            row: data.value[_index],
            index: _index,
            e: e
          }, {
            action: "active"
          });
        } else {
          currentOperationRowIndex.value = _index;
        }
      } else if (SPACE_REG.test(code)) {
        e.preventDefault();
        var _index2 = currentOperationRowIndex.value;
        if (shiftSelectionState.value) {
          var _props$onActiveRowAct3;
          (_props$onActiveRowAct3 = props.onActiveRowAction) === null || _props$onActiveRowAct3 === void 0 || _props$onActiveRowAct3.call(props, {
            action: "shift-area-selection",
            activeRowList: getActiveRowList()
          });
        } else if (!disableSpaceInactiveRow.value) {
          onHighlightRow({
            row: data.value[_index2],
            index: _index2,
            e: e
          });
        } else {
          var _props$onActiveRowAct4;
          (_props$onActiveRowAct4 = props.onActiveRowAction) === null || _props$onActiveRowAct4 === void 0 || _props$onActiveRowAct4.call(props, {
            action: "space-one-selection",
            activeRowList: getActiveRowList()
          });
        }
      } else if (SHIFT_REG.test(code)) {
        isShiftPressed.value = true;
        areaSelectionStartIndex.value = currentOperationRowIndex.value;
      } else if (ESCAPE_REG.test(code) || CLEAR_REG.test(code)) {
        clearActive();
        clearShiftAreaSelection();
      } else if (ALL_REG.test(code)) {
        setAllActive();
      }
      if (!SPACE_REG.test(code)) {
        clearShiftAreaSelection();
      }
    };
    var keyboardUpListener = function keyboardUpListener(e) {
      var _e$key2;
      var code = ((_e$key2 = e.key) === null || _e$key2 === void 0 ? void 0 : _e$key2.trim()) || e.code;
      if (SHIFT_REG.test(code)) {
        isShiftPressed.value = false;
      }
    };
    var addHighlightKeyboardListener = function addHighlightKeyboardListener() {
      on$1(tableRef.value, "keydown", keyboardDownListener);
      on$1(tableRef.value, "keyup", keyboardUpListener);
    };
    var removeHighlightKeyboardListener = function removeHighlightKeyboardListener() {
      off$1(tableRef.value, "keydown", keyboardDownListener);
      off$1(tableRef.value, "keyup", keyboardUpListener);
    };
    return {
      tActiveRow: tActiveRow,
      onHighlightRow: onHighlightRow,
      addHighlightKeyboardListener: addHighlightKeyboardListener,
      removeHighlightKeyboardListener: removeHighlightKeyboardListener
    };
  }

  function useHoverKeyboardEvent(props, tableRef) {
    var _toRefs = VueCompositionAPI.toRefs(props),
      hover = _toRefs.hover,
      data = _toRefs.data,
      activeRowType = _toRefs.activeRowType,
      keyboardRowHover = _toRefs.keyboardRowHover;
    var hoverRow = VueCompositionAPI.ref();
    var currentHoverRowIndex = VueCompositionAPI.ref(-1);
    var tableRefTabIndex = VueCompositionAPI.ref(0);
    var needKeyboardRowHover = VueCompositionAPI.computed(function () {
      if (activeRowType.value === "single") return false;
      if (activeRowType.value === "multiple") return true;
      return hover.value || keyboardRowHover.value;
    });
    var onHoverRow = function onHoverRow(ctx, extra) {
      var rowValue = get(ctx.row, props.rowKey);
      if (hoverRow.value === rowValue && (extra === null || extra === void 0 ? void 0 : extra.action) !== "hover") {
        hoverRow.value = void 0;
      } else {
        hoverRow.value = rowValue;
      }
      currentHoverRowIndex.value = ctx.index;
    };
    var clearHoverRow = function clearHoverRow() {
      hoverRow.value = void 0;
      currentHoverRowIndex.value = -1;
    };
    var keyboardDownListener = function keyboardDownListener(e) {
      var _e$key;
      if (!needKeyboardRowHover.value) return;
      var code = ((_e$key = e.key) === null || _e$key === void 0 ? void 0 : _e$key.trim()) || e.code;
      if (ARROW_DOWN_REG.test(code)) {
        e.preventDefault();
        var index = Math.min(data.value.length - 1, currentHoverRowIndex.value + 1);
        onHoverRow({
          row: data.value[index],
          index: index,
          e: e
        }, {
          action: "hover"
        });
      } else if (ARROW_UP_REG.test(code)) {
        e.preventDefault();
        var _index = Math.max(0, currentHoverRowIndex.value - 1);
        onHoverRow({
          row: data.value[_index],
          index: _index,
          e: e
        }, {
          action: "hover"
        });
      } else if (SPACE_REG.test(code) && props.activeRowType !== "multiple") {
        var _index2 = currentHoverRowIndex.value;
        onHoverRow({
          row: data.value[_index2],
          index: _index2,
          e: e
        });
      }
      if (ARROW_LEFT_REG.test(code) || ARROW_RIGHT_REG.test(code)) {
        tableRefTabIndex.value = void 0;
      } else {
        tableRefTabIndex.value = 0;
      }
    };
    var addRowHoverKeyboardListener = function addRowHoverKeyboardListener() {
      on$1(tableRef.value, "keydown", keyboardDownListener);
    };
    var removeRowHoverKeyboardListener = function removeRowHoverKeyboardListener() {
      off$1(tableRef.value, "keydown", keyboardDownListener);
    };
    return {
      hoverRow: hoverRow,
      needKeyboardRowHover: needKeyboardRowHover,
      clearHoverRow: clearHoverRow,
      addRowHoverKeyboardListener: addRowHoverKeyboardListener,
      removeRowHoverKeyboardListener: removeRowHoverKeyboardListener,
      tableRefTabIndex: tableRefTabIndex
    };
  }

  function ownKeys$D(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$C(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$D(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$D(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var THead = VueCompositionAPI.defineComponent({
    name: "THead",
    props: {
      ellipsisOverlayClassName: String,
      isFixedHeader: Boolean,
      thDraggable: Boolean,
      maxHeight: [String, Number],
      height: [String, Number],
      rowAndColFixedPosition: Map,
      thWidthList: Object,
      bordered: Boolean,
      isMultipleHeader: Boolean,
      resizable: Boolean,
      spansAndLeafNodes: Object,
      thList: Array,
      columnResizeParams: Object,
      attach: [String, Function],
      showColumnShadow: Object
    },
    setup: function setup(props, _ref) {
      var slots = _ref.slots;
      var theadRef = VueCompositionAPI.ref();
      var classnames = useClassName();
      var tableHeaderClasses = classnames.tableHeaderClasses,
        tableBaseClass = classnames.tableBaseClass;
      var theadClasses = VueCompositionAPI.computed(function () {
        return [tableHeaderClasses.header, _defineProperty$2(_defineProperty$2(_defineProperty$2({}, tableHeaderClasses.fixed, Boolean(props.maxHeight || props.height)), tableBaseClass.bordered, props.bordered && props.isMultipleHeader), tableHeaderClasses.multipleHeader, props.isMultipleHeader)];
      });
      var colspanSkipMap = VueCompositionAPI.computed(function () {
        var map = {};
        var _processColumns = function processColumns(columns) {
          for (var i = 0, len = columns.length; i < len; i++) {
            var item = columns[i];
            if (item.colspan > 1) {
              for (var j = i + 1; j < i + item.colspan; j++) {
                if (columns[j]) {
                  map[columns[j].colKey] = true;
                }
              }
            }
            if (item.children) {
              _processColumns(item.children);
            }
          }
        };
        var list = props.thList[0];
        _processColumns(list);
        return map;
      });
      var getTableNode = function getTableNode(thead) {
        var parent = thead;
        while (parent) {
          var _parent;
          parent = parent.parentNode;
          if ((_parent = parent) !== null && _parent !== void 0 && (_parent = _parent.classList) !== null && _parent !== void 0 && _parent.contains("".concat(props.classPrefix, "-table"))) {
            break;
          }
        }
        return parent;
      };
      return _objectSpread$C(_objectSpread$C({}, classnames), {}, {
        colspanSkipMap: colspanSkipMap,
        theadRef: theadRef,
        theadClasses: theadClasses,
        slots: slots,
        getTableNode: getTableNode
      });
    },
    render: function render(h) {
      var _this = this;
      var renderThNodeList = function renderThNodeList(h2, rowAndColFixedPosition, thWidthList) {
        var thBorderMap = /* @__PURE__ */new Map();
        var thRowspanAndColspan = _this.spansAndLeafNodes.rowspanAndColspanMap;
        return _this.thList.map(function (row, rowIndex) {
          var thRow = row.map(function (col, index) {
            var _col$children;
            if (_this.colspanSkipMap[col.colKey]) return null;
            var rowspanAndColspan = thRowspanAndColspan.get(col);
            if (index === 0 && rowspanAndColspan.rowspan > 1) {
              for (var j = rowIndex + 1; j < rowIndex + rowspanAndColspan.rowspan; j++) {
                thBorderMap.set(_this.thList[j][0], true);
              }
            }
            var thStyles = getColumnFixedStyles(col, index, rowAndColFixedPosition, _this.tableColFixedClasses);
            var colParams = {
              col: col,
              colIndex: index,
              row: {},
              rowIndex: -1
            };
            var customClasses = formatClassNames(col.className, _objectSpread$C(_objectSpread$C({}, colParams), {}, {
              type: "th"
            }));
            var thCustomClasses = formatClassNames(col.thClassName, _objectSpread$C(_objectSpread$C({}, colParams), {}, {
              type: "th"
            }));
            var isLeftFixedActive = _this.showColumnShadow.left && col.fixed === "left";
            var isRightFixedActive = _this.showColumnShadow.right && col.fixed === "right";
            var canDragSort = _this.thDraggable && !(isLeftFixedActive || isRightFixedActive);
            var thClasses = [thStyles.classes, customClasses, thCustomClasses, _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({}, _this.tableHeaderClasses.thBordered, thBorderMap.get(col)), "".concat(_this.classPrefix, "-table__th-").concat(col.colKey), col.colKey), _this.tdAlignClasses[col.align], col.align && col.align !== "left"), _this.tableDraggableClasses.dragSortTh, canDragSort)];
            var withoutChildren = !((_col$children = col.children) !== null && _col$children !== void 0 && _col$children.length);
            var width = withoutChildren && thWidthList !== null && thWidthList !== void 0 && thWidthList[col.colKey] ? "".concat(thWidthList === null || thWidthList === void 0 ? void 0 : thWidthList[col.colKey], "px") : void 0;
            var styles = _objectSpread$C(_objectSpread$C({}, thStyles.style || {}), {}, {
              width: width
            });
            var innerTh = renderTitle(h2, _this.slots, col, index);
            var resizeColumnListener = _this.resizable || !canDragSort ? {
              mousedown: function mousedown(e) {
                e.stopPropagation();
                if (_this.resizable) {
                  var _this$columnResizePar, _this$columnResizePar2;
                  (_this$columnResizePar = _this.columnResizeParams) === null || _this$columnResizePar === void 0 || (_this$columnResizePar2 = _this$columnResizePar.onColumnMousedown) === null || _this$columnResizePar2 === void 0 || _this$columnResizePar2.call(_this$columnResizePar, e, col, index);
                }
                if (!canDragSort) {
                  var timer = setTimeout(function () {
                    var _thList$index;
                    var thList = _this.theadRef.querySelectorAll("th");
                    (_thList$index = thList[index]) === null || _thList$index === void 0 || _thList$index.removeAttribute("draggable");
                    clearTimeout(timer);
                  }, 10);
                }
              },
              mousemove: function mousemove(e) {
                var _this$columnResizePar3, _this$columnResizePar4;
                _this.resizable && ((_this$columnResizePar3 = _this.columnResizeParams) === null || _this$columnResizePar3 === void 0 || (_this$columnResizePar4 = _this$columnResizePar3.onColumnMouseover) === null || _this$columnResizePar4 === void 0 ? void 0 : _this$columnResizePar4.call(_this$columnResizePar3, e, col));
              }
            } : {};
            var content = isFunction(col.ellipsisTitle) ? col.ellipsisTitle(h2, {
              col: col,
              colIndex: index
            }) : void 0;
            var isEllipsis = col.ellipsisTitle !== void 0 ? Boolean(col.ellipsisTitle) : Boolean(col.ellipsis);
            var attrs = (isFunction(col.attrs) ? col.attrs(_objectSpread$C(_objectSpread$C({}, colParams), {}, {
              type: "th"
            })) : col.attrs) || {};
            if (col.colspan > 1) {
              attrs.colspan = col.colspan;
            }
            return h("th", helper([{
              "key": col.colKey,
              "attrs": {
                "data-colkey": col.colKey
              },
              "class": thClasses,
              "style": styles
            }, {
              "attrs": _objectSpread$C(_objectSpread$C({}, attrs), rowspanAndColspan)
            }, {}, {
              "on": resizeColumnListener
            }]), [h("div", {
              "class": _this.tableBaseClass.thCellInner
            }, [isEllipsis ? h(TEllipsis, {
              "attrs": {
                "placement": "bottom",
                "attach": _this.attach || (_this.theadRef ? function () {
                  return _this.getTableNode(_this.theadRef);
                } : void 0),
                "tooltipContent": content && function () {
                  return content;
                },
                "tooltipProps": _typeof$2(col.ellipsisTitle) === "object" ? col.ellipsisTitle : void 0,
                "overlayClassName": _this.ellipsisOverlayClassName,
                "classPrefix": _this.classPrefix
              }
            }, [innerTh]) : innerTh])]);
          });
          return h("tr", {
            "key": rowIndex
          }, [thRow]);
        });
      };
      return h("thead", {
        "ref": "theadRef",
        "class": this.theadClasses
      }, [renderThNodeList(h, this.rowAndColFixedPosition, this.thWidthList)]);
    }
  });

  function ownKeys$C(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$B(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$C(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$C(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var TFoot = VueCompositionAPI.defineComponent({
    name: "TFoot",
    props: {
      rowKey: String,
      isFixedHeader: Boolean,
      rowAndColFixedPosition: Map,
      footData: Array,
      columns: Array,
      rowAttributes: [Array, Object, Function],
      rowClassName: [Array, String, Object, Function],
      thWidthList: [Object],
      footerSummary: [String, Function],
      rowspanAndColspanInFooter: Function
    },
    setup: function setup(props, context) {
      var renderTNode = useTNodeJSX();
      var classnames = useClassName();
      var _toRefs = VueCompositionAPI.toRefs(props),
        footData = _toRefs.footData,
        columns = _toRefs.columns,
        rowKey = _toRefs.rowKey,
        rowspanAndColspanInFooter = _toRefs.rowspanAndColspanInFooter;
      var _useRowspanAndColspan = useRowspanAndColspan(footData, columns, rowKey, rowspanAndColspanInFooter),
        skipSpansMap = _useRowspanAndColspan.skipSpansMap;
      var renderTFootCell = function renderTFootCell(p) {
        var col = p.col,
          row = p.row;
        if (isFunction(col.foot)) {
          return col.foot(VueCompositionAPI.h, p);
        }
        if (isString(col.foot) && context.slots[col.foot]) {
          return context.slots[col.foot](p);
        }
        return col.foot || get(row, col.colKey);
      };
      return _objectSpread$B(_objectSpread$B({
        skipSpansMap: skipSpansMap
      }, classnames), {}, {
        renderTFootCell: renderTFootCell,
        renderTNode: renderTNode
      });
    },
    render: function render() {
      var _this$footData,
        _this = this;
      var h = arguments[0];
      if (!this.columns) return null;
      var theadClasses = [this.tableFooterClasses.footer, _defineProperty$2({}, this.tableFooterClasses.fixed, this.isFixedHeader)];
      var footerDomList = (_this$footData = this.footData) === null || _this$footData === void 0 ? void 0 : _this$footData.map(function (row, rowIndex) {
        var trAttributes = formatRowAttributes(_this.rowAttributes, {
          row: row,
          rowIndex: rowIndex,
          type: "foot"
        });
        var customClasses = formatRowClassNames(_this.rowClassName, {
          row: row,
          rowIndex: rowIndex,
          type: "foot"
        }, _this.rowKey || "id");
        return h("tr", helper([{
          "key": rowIndex
        }, {
          "attrs": trAttributes
        }, {
          "class": customClasses
        }]), [_this.columns.map(function (col, colIndex) {
          var _this$thWidthList;
          var cellSpans = {};
          var spanState = null;
          if (_this.skipSpansMap.size) {
            var _spanState, _spanState2;
            var cellKey = getCellKey(row, _this.rowKey, col.colKey, colIndex);
            spanState = _this.skipSpansMap.get(cellKey) || {};
            ((_spanState = spanState) === null || _spanState === void 0 ? void 0 : _spanState.rowspan) > 1 && (cellSpans.rowspan = spanState.rowspan);
            ((_spanState2 = spanState) === null || _spanState2 === void 0 ? void 0 : _spanState2.colspan) > 1 && (cellSpans.colspan = spanState.colspan);
            if (spanState.skipped) return null;
          }
          var tdStyles = getColumnFixedStyles(col, colIndex, _this.rowAndColFixedPosition, _this.tableColFixedClasses);
          var style = _objectSpread$B({}, tdStyles.style);
          if ((_this$thWidthList = _this.thWidthList) !== null && _this$thWidthList !== void 0 && _this$thWidthList[col.colKey]) {
            style.width = "".concat(_this.thWidthList[col.colKey], "px");
          }
          return h("td", helper([{}, {
            "attrs": _objectSpread$B({
              key: col.colKey
            }, cellSpans)
          }, {
            "class": tdStyles.classes,
            "style": style
          }]), [_this.renderTFootCell({
            row: row,
            rowIndex: rowIndex,
            col: col,
            colIndex: colIndex
          })]);
        })]);
      });
      var footerSummary = this.renderTNode("footerSummary");
      if (!footerSummary && (!this.footData || !this.footData.length)) return null;
      return h("tfoot", {
        "ref": "tFooterRef",
        "class": theadClasses
      }, [footerSummary && h("tr", {
        "class": this.tableFullRowClasses.base
      }, [h("td", {
        "attrs": {
          "colspan": this.columns.length
        }
      }, [h("div", {
        "class": this.tableFullRowClasses.innerFullElement
      }, [footerSummary])])]), footerDomList]);
    }
  });

  function ownKeys$B(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$A(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$B(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$B(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var BASE_TABLE_EVENTS = ["page-change", "cell-click", "scroll", "scrollX", "scrollY", "column-resize-change"];
  var BASE_TABLE_ALL_EVENTS = ROW_LISTENERS.map(function (t) {
    return "row-".concat(t);
  }).concat(BASE_TABLE_EVENTS);
  var _BaseTable = VueCompositionAPI.defineComponent({
    name: "TBaseTable",
    props: _objectSpread$A(_objectSpread$A({}, baseTableProps), {}, {
      renderExpandedRow: Function,
      onLeafColumnsChange: Function,
      thDraggable: Boolean
    }),
    setup: function setup(props2, context) {
      var _toRefs = VueCompositionAPI.toRefs(props2),
        lazyLoad = _toRefs.lazyLoad;
      var tableRef = VueCompositionAPI.ref();
      var tableElmRef = VueCompositionAPI.ref();
      var tableBodyRef = VueCompositionAPI.ref();
      var bottomContentRef = VueCompositionAPI.ref();
      var tableFootHeight = VueCompositionAPI.ref(0);
      var _useClassName = useClassName(),
        classPrefix = _useClassName.classPrefix,
        virtualScrollClasses = _useClassName.virtualScrollClasses,
        tableLayoutClasses = _useClassName.tableLayoutClasses,
        tableBaseClass = _useClassName.tableBaseClass,
        tableColFixedClasses = _useClassName.tableColFixedClasses;
      var _useStyle = useStyle(props2),
        tableClasses = _useStyle.tableClasses,
        sizeClassNames = _useStyle.sizeClassNames,
        tableContentStyles = _useStyle.tableContentStyles,
        tableElementStyles = _useStyle.tableElementStyles;
      var _useConfig = useConfig("table", props2.locale),
        global = _useConfig.global;
      var _useTableHeader = useTableHeader(props2),
        isMultipleHeader = _useTableHeader.isMultipleHeader,
        spansAndLeafNodes = _useTableHeader.spansAndLeafNodes,
        thList = _useTableHeader.thList;
      var finalColumns = VueCompositionAPI.computed(function () {
        var _spansAndLeafNodes$va;
        return ((_spansAndLeafNodes$va = spansAndLeafNodes.value) === null || _spansAndLeafNodes$va === void 0 ? void 0 : _spansAndLeafNodes$va.leafColumns) || props2.columns;
      });
      var isIE = VueCompositionAPI.computed(function () {
        return getIEVersion$1() <= 11;
      });
      var tableSize = VueCompositionAPI.computed(function () {
        var _props2$size;
        return (_props2$size = props2.size) !== null && _props2$size !== void 0 ? _props2$size : global.value.size;
      });
      var paginationAffixRef = VueCompositionAPI.ref();
      var horizontalScrollAffixRef = VueCompositionAPI.ref();
      var headerTopAffixRef = VueCompositionAPI.ref();
      var footerBottomAffixRef = VueCompositionAPI.ref();
      var _useFixed = useFixed(props2, context, finalColumns, {
          paginationAffixRef: paginationAffixRef,
          horizontalScrollAffixRef: horizontalScrollAffixRef,
          headerTopAffixRef: headerTopAffixRef,
          footerBottomAffixRef: footerBottomAffixRef
        }),
        scrollbarWidth = _useFixed.scrollbarWidth,
        tableWidth = _useFixed.tableWidth,
        tableElmWidth = _useFixed.tableElmWidth,
        tableContentRef = _useFixed.tableContentRef,
        isFixedHeader = _useFixed.isFixedHeader,
        isWidthOverflow = _useFixed.isWidthOverflow,
        isFixedColumn = _useFixed.isFixedColumn,
        thWidthList = _useFixed.thWidthList,
        showColumnShadow = _useFixed.showColumnShadow,
        rowAndColFixedPosition = _useFixed.rowAndColFixedPosition,
        setData = _useFixed.setData,
        refreshTable = _useFixed.refreshTable,
        setTableElmWidth = _useFixed.setTableElmWidth,
        emitScrollEvent = _useFixed.emitScrollEvent,
        setUseFixedTableElmRef = _useFixed.setUseFixedTableElmRef,
        updateColumnFixedShadow = _useFixed.updateColumnFixedShadow,
        getThWidthList = _useFixed.getThWidthList,
        updateThWidthList = _useFixed.updateThWidthList,
        addTableResizeObserver = _useFixed.addTableResizeObserver,
        updateTableAfterColumnResize = _useFixed.updateTableAfterColumnResize;
      var _useAffix = useAffix(props2),
        affixHeaderRef = _useAffix.affixHeaderRef,
        affixFooterRef = _useAffix.affixFooterRef,
        horizontalScrollbarRef = _useAffix.horizontalScrollbarRef,
        paginationRef = _useAffix.paginationRef,
        showAffixHeader = _useAffix.showAffixHeader,
        showAffixFooter = _useAffix.showAffixFooter,
        showAffixPagination = _useAffix.showAffixPagination,
        onHorizontalScroll = _useAffix.onHorizontalScroll,
        updateAffixHeaderOrFooter = _useAffix.updateAffixHeaderOrFooter,
        setTableContentRef = _useAffix.setTableContentRef;
      var _useElementLazyRender = useElementLazyRender(tableRef, lazyLoad),
        showElement = _useElementLazyRender.showElement;
      var _usePagination = usePagination(props2, context),
        dataSource = _usePagination.dataSource,
        innerPagination = _usePagination.innerPagination,
        isPaginateData = _usePagination.isPaginateData,
        renderPagination = _usePagination.renderPagination;
      var onInnerResizeChange = function onInnerResizeChange(p) {
        var _props2$onColumnResiz;
        (_props2$onColumnResiz = props2.onColumnResizeChange) === null || _props2$onColumnResiz === void 0 || _props2$onColumnResiz.call(props2, p);
        context.emit("column-resize-change", p);
      };
      var columnResizeParams = useColumnResize({
        isWidthOverflow: isWidthOverflow,
        tableContentRef: tableContentRef,
        showColumnShadow: showColumnShadow,
        getThWidthList: getThWidthList,
        updateThWidthList: updateThWidthList,
        setTableElmWidth: setTableElmWidth,
        updateTableAfterColumnResize: updateTableAfterColumnResize,
        onColumnResizeChange: onInnerResizeChange
      });
      var resizeLineRef = columnResizeParams.resizeLineRef,
        resizeLineStyle = columnResizeParams.resizeLineStyle,
        setEffectColMap = columnResizeParams.setEffectColMap;
      var dynamicBaseTableClasses = VueCompositionAPI.computed(function () {
        return [tableClasses.value, _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({}, tableBaseClass.headerFixed, isFixedHeader.value), tableBaseClass.columnFixed, isFixedColumn.value), tableBaseClass.widthOverflow, isWidthOverflow.value), tableBaseClass.multipleHeader, isMultipleHeader.value), tableColFixedClasses.leftShadow, showColumnShadow.left), tableColFixedClasses.rightShadow, showColumnShadow.right), tableBaseClass.columnResizableTable, props2.resizable), "".concat(classPrefix, "-table__row--active-").concat(props2.activeRowType), props2.activeRowType)];
      });
      var tableElmClasses = VueCompositionAPI.computed(function () {
        return [[tableLayoutClasses[props2.tableLayout]]];
      });
      var showRightDivider = VueCompositionAPI.computed(function () {
        return props2.bordered && isFixedHeader.value && (isMultipleHeader.value && isWidthOverflow.value || !isMultipleHeader.value);
      });
      var dividerBottom = VueCompositionAPI.computed(function () {
        var _bottomContentRef$val, _paginationRef$value;
        if (!props2.bordered) return 0;
        var bottomRect = (_bottomContentRef$val = bottomContentRef.value) === null || _bottomContentRef$val === void 0 ? void 0 : _bottomContentRef$val.getBoundingClientRect();
        var paginationRect = (_paginationRef$value = paginationRef.value) === null || _paginationRef$value === void 0 ? void 0 : _paginationRef$value.getBoundingClientRect();
        return ((bottomRect === null || bottomRect === void 0 ? void 0 : bottomRect.height) || 0) + ((paginationRect === null || paginationRect === void 0 ? void 0 : paginationRect.height) || 0);
      });
      var columnResizable = VueCompositionAPI.computed(function () {
        var _props2$allowResizeCo;
        return (_props2$allowResizeCo = props2.allowResizeColumnWidth) !== null && _props2$allowResizeCo !== void 0 ? _props2$allowResizeCo : props2.resizable;
      });
      var _useRowHighlight = useRowHighlight(props2, tableRef),
        tActiveRow = _useRowHighlight.tActiveRow,
        onHighlightRow = _useRowHighlight.onHighlightRow,
        addHighlightKeyboardListener = _useRowHighlight.addHighlightKeyboardListener,
        removeHighlightKeyboardListener = _useRowHighlight.removeHighlightKeyboardListener;
      var _useHoverKeyboardEven = useHoverKeyboardEvent(props2, tableRef),
        hoverRow = _useHoverKeyboardEven.hoverRow,
        needKeyboardRowHover = _useHoverKeyboardEven.needKeyboardRowHover,
        clearHoverRow = _useHoverKeyboardEven.clearHoverRow,
        addRowHoverKeyboardListener = _useHoverKeyboardEven.addRowHoverKeyboardListener,
        removeRowHoverKeyboardListener = _useHoverKeyboardEven.removeRowHoverKeyboardListener,
        tableRefTabIndex = _useHoverKeyboardEven.tableRefTabIndex;
      VueCompositionAPI.watch(tableElmRef, function () {
        setUseFixedTableElmRef(tableElmRef.value);
      });
      VueCompositionAPI.watch(function () {
        return [props2.data, dataSource, isPaginateData];
      }, function () {
        setData(isPaginateData.value ? dataSource.value : props2.data);
      });
      VueCompositionAPI.watch(spansAndLeafNodes, function () {
        var _props2$onLeafColumns;
        (_props2$onLeafColumns = props2.onLeafColumnsChange) === null || _props2$onLeafColumns === void 0 || _props2$onLeafColumns.call(props2, spansAndLeafNodes.value.leafColumns);
        context.emit("LeafColumnsChange", spansAndLeafNodes.value.leafColumns);
        setEffectColMap(spansAndLeafNodes.value.leafColumns, null);
      }, {
        immediate: true
      });
      var onFixedChange = function onFixedChange() {
        VueCompositionAPI.nextTick(function () {
          onHorizontalScroll();
          updateAffixHeaderOrFooter();
        });
      };
      var getListener = function getListener() {
        var listener = {};
        BASE_TABLE_ALL_EVENTS.forEach(function (key) {
          listener[key] = function () {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            context.emit.apply(context, [key].concat(args));
          };
        });
        return listener;
      };
      var virtualScrollParams = VueCompositionAPI.computed(function () {
        return {
          data: props2.data,
          scroll: props2.scroll
        };
      });
      var virtualConfig = useVirtualScroll$1(tableContentRef, virtualScrollParams);
      var lastScrollY = 0;
      var onInnerVirtualScroll = function onInnerVirtualScroll(e) {
        var target = e.target || e.srcElement;
        var top = target.scrollTop;
        if (lastScrollY !== top) {
          virtualConfig.isVirtualScroll.value && virtualConfig.handleScroll();
        } else {
          lastScrollY = 0;
          updateColumnFixedShadow(target);
        }
        lastScrollY = top;
        emitScrollEvent(e);
      };
      var getTFootHeight = function getTFootHeight() {
        var _tableElmRef$value$qu;
        if (!tableElmRef.value) return;
        tableFootHeight.value = (_tableElmRef$value$qu = tableElmRef.value.querySelector("tfoot")) === null || _tableElmRef$value$qu === void 0 ? void 0 : _tableElmRef$value$qu.getBoundingClientRect().height;
      };
      var scrollColumnIntoView = function scrollColumnIntoView(colKey) {
        if (!tableContentRef.value) return;
        var thDom = tableContentRef.value.querySelector("th[data-colkey=\"".concat(colKey, "\"]"));
        var fixedThDom = tableContentRef.value.querySelectorAll("th.t-table__cell--fixed-left");
        var totalWidth = 0;
        for (var i = 0, len = fixedThDom.length; i < len; i++) {
          totalWidth += fixedThDom[i].getBoundingClientRect().width;
        }
        var domRect = thDom.getBoundingClientRect();
        var contentRect = tableContentRef.value.getBoundingClientRect();
        var distance = domRect.left - contentRect.left - totalWidth;
        tableContentRef.value.scrollTo({
          left: distance,
          behavior: "smooth"
        });
      };
      VueCompositionAPI.watch(tableContentRef, function () {
        setTableContentRef(tableContentRef.value);
      });
      VueCompositionAPI.watch(tableElmRef, getTFootHeight);
      VueCompositionAPI.watch(tableRef, function (tableRef2) {
        addTableResizeObserver(tableRef2);
      });
      VueCompositionAPI.onMounted(function () {
        getTFootHeight();
        setTableContentRef(tableContentRef.value);
        addTableResizeObserver(tableRef.value);
      });
      var onTableFocus = function onTableFocus() {
        props2.activeRowType && addHighlightKeyboardListener();
        needKeyboardRowHover.value && addRowHoverKeyboardListener();
      };
      var onTableBlur = function onTableBlur() {
        props2.activeRowType && removeHighlightKeyboardListener();
        needKeyboardRowHover.value && removeRowHoverKeyboardListener();
      };
      var onInnerRowClick = function onInnerRowClick(ctx) {
        var _props2$onRowClick;
        (_props2$onRowClick = props2.onRowClick) === null || _props2$onRowClick === void 0 || _props2$onRowClick.call(props2, ctx);
        props2.activeRowType && onHighlightRow(ctx);
        needKeyboardRowHover.value && clearHoverRow();
      };
      var tableData = VueCompositionAPI.computed(function () {
        return isPaginateData.value ? dataSource.value : props2.data;
      });
      var scrollToElement = function scrollToElement(params) {
        var index = params.index;
        if (!index && index !== 0) {
          var _tableData$value;
          if (!params.key) {
            log.error("Table", "scrollToElement: one of `index` or `key` must exist.");
            return;
          }
          index = (_tableData$value = tableData.value) === null || _tableData$value === void 0 ? void 0 : _tableData$value.findIndex(function (item) {
            return get(item, props2.rowKey) === params.key;
          });
          if (index < 0) {
            log.error("Table", "".concat(params.key, " does not exist in data, check `rowKey` or `data` please."));
          }
        }
        virtualConfig.scrollToElement(_objectSpread$A(_objectSpread$A({}, params), {}, {
          index: index
        }));
      };
      VueCompositionAPI.watch([showElement], function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 1),
          showElement2 = _ref3[0];
        context.emit("show-element-change", showElement2);
      }, {
        immediate: true
      });
      return {
        virtualConfig: virtualConfig,
        scrollToElement: scrollToElement,
        columnResizable: columnResizable,
        thList: thList,
        classPrefix: classPrefix,
        innerPagination: innerPagination,
        global: global,
        tableSize: tableSize,
        tableFootHeight: tableFootHeight,
        tableWidth: tableWidth,
        tableElmWidth: tableElmWidth,
        tableRef: tableRef,
        tableElmRef: tableElmRef,
        sizeClassNames: sizeClassNames,
        tableBaseClass: tableBaseClass,
        spansAndLeafNodes: spansAndLeafNodes,
        dynamicBaseTableClasses: dynamicBaseTableClasses,
        tableContentStyles: tableContentStyles,
        tableElementStyles: tableElementStyles,
        virtualScrollClasses: virtualScrollClasses,
        tableLayoutClasses: tableLayoutClasses,
        tableElmClasses: tableElmClasses,
        dividerBottom: dividerBottom,
        tableContentRef: tableContentRef,
        isFixedHeader: isFixedHeader,
        isWidthOverflow: isWidthOverflow,
        isFixedColumn: isFixedColumn,
        rowAndColFixedPosition: rowAndColFixedPosition,
        showColumnShadow: showColumnShadow,
        thWidthList: thWidthList,
        isPaginateData: isPaginateData,
        dataSource: dataSource,
        affixHeaderRef: affixHeaderRef,
        affixFooterRef: affixFooterRef,
        paginationRef: paginationRef,
        bottomContentRef: bottomContentRef,
        showAffixHeader: showAffixHeader,
        showAffixFooter: showAffixFooter,
        scrollbarWidth: scrollbarWidth,
        isMultipleHeader: isMultipleHeader,
        showRightDivider: showRightDivider,
        resizeLineRef: resizeLineRef,
        resizeLineStyle: resizeLineStyle,
        columnResizeParams: columnResizeParams,
        horizontalScrollbarRef: horizontalScrollbarRef,
        tableBodyRef: tableBodyRef,
        showAffixPagination: showAffixPagination,
        tActiveRow: tActiveRow,
        hoverRow: hoverRow,
        showElement: showElement,
        getListener: getListener,
        renderPagination: renderPagination,
        onFixedChange: onFixedChange,
        onHorizontalScroll: onHorizontalScroll,
        updateAffixHeaderOrFooter: updateAffixHeaderOrFooter,
        refreshTable: refreshTable,
        onInnerVirtualScroll: onInnerVirtualScroll,
        scrollColumnIntoView: scrollColumnIntoView,
        onTableFocus: onTableFocus,
        onTableBlur: onTableBlur,
        onInnerRowClick: onInnerRowClick,
        paginationAffixRef: paginationAffixRef,
        horizontalScrollAffixRef: horizontalScrollAffixRef,
        headerTopAffixRef: headerTopAffixRef,
        footerBottomAffixRef: footerBottomAffixRef,
        isIE: isIE,
        tableRefTabIndex: tableRefTabIndex
      };
    },
    methods: {
      renderColGroup: function renderColGroup(columns) {
        var _this = this;
        var isAffixHeader = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var h = this.$createElement;
        return h("colgroup", [columns.map(function (col) {
          var style = {
            width: formatCSSUnit((isAffixHeader || _this.columnResizable ? _this.thWidthList[col.colKey] : void 0) || col.width)
          };
          if (col.minWidth) {
            style.minWidth = formatCSSUnit(col.minWidth);
          }
          if (!style.width && !col.minWidth && _this.tableLayout === "fixed") {
            style.minWidth = "80px";
          }
          return h("col", {
            "key": col.colKey,
            "style": style
          });
        })]);
      },
      getHeadProps: function getHeadProps() {
        var isAffixHeader = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var headProps = {
          isFixedHeader: this.isFixedHeader,
          showColumnShadow: this.showColumnShadow,
          thDraggable: this.thDraggable,
          rowAndColFixedPosition: this.rowAndColFixedPosition,
          isMultipleHeader: this.isMultipleHeader,
          bordered: this.bordered,
          maxHeight: this.maxHeight,
          height: this.height,
          spansAndLeafNodes: this.spansAndLeafNodes,
          thList: this.thList,
          thWidthList: isAffixHeader || this.columnResizable ? this.thWidthList : {},
          resizable: this.resizable,
          columnResizeParams: this.columnResizeParams,
          classPrefix: this.classPrefix,
          ellipsisOverlayClassName: this.tableSize !== "medium" ? this.sizeClassNames[this.tableSize] : "",
          attach: this.attach
        };
        return headProps;
      },
      renderFixedHeader: function renderFixedHeader(columns) {
        var _this$affixHeaderRef;
        var h = this.$createElement;
        if (!this.showHeader) return null;
        var isVirtual = this.virtualConfig.isVirtualScroll.value;
        var barWidth = this.isWidthOverflow ? this.scrollbarWidth : 0;
        var IEHeaderWrap = this.isIE ? 4 : 0;
        var affixHeaderHeight = (((_this$affixHeaderRef = this.affixHeaderRef) === null || _this$affixHeaderRef === void 0 ? void 0 : _this$affixHeaderRef.getBoundingClientRect().height) || 0) - IEHeaderWrap;
        var affixHeaderWrapHeight = affixHeaderHeight - barWidth;
        var headerOpacity = this.headerAffixedTop ? Number(this.showAffixHeader) : 1;
        var affixHeaderWrapHeightStyle = {
          width: "".concat(this.tableWidth, "px"),
          height: "".concat(affixHeaderWrapHeight, "px"),
          opacity: headerOpacity
        };
        var colgroup = this.renderColGroup(columns, true);
        var affixedLeftBorder = this.bordered && !this.isIE ? 1 : 0;
        var affixedHeader = Boolean((this.headerAffixedTop || isVirtual) && this.tableWidth) && h("div", {
          "ref": "affixHeaderRef",
          "style": {
            width: "".concat(this.tableWidth - affixedLeftBorder, "px"),
            opacity: headerOpacity
          },
          "class": ["scrollbar", _defineProperty$2({}, this.tableBaseClass.affixedHeaderElm, this.headerAffixedTop || isVirtual)]
        }, [h("table", {
          "class": this.tableElmClasses,
          "style": _objectSpread$A(_objectSpread$A({}, this.tableElementStyles), {}, {
            width: "".concat(this.tableElmWidth, "px")
          })
        }, [colgroup, h(THead, helper([{
          "scopedSlots": this.$scopedSlots
        }, {
          "props": this.getHeadProps(true)
        }]))])]);
        var affixHeaderWithWrap = h("div", {
          "class": this.tableBaseClass.affixedHeaderWrap,
          "style": affixHeaderWrapHeightStyle
        }, [affixedHeader]);
        return affixHeaderWithWrap;
      },
      renderAffixedFooter: function renderAffixedFooter(columns) {
        var _this$footData;
        var h = this.$createElement;
        var barWidth = this.isWidthOverflow ? this.scrollbarWidth : 0;
        var affixedLeftBorder = this.bordered && !this.isIE ? 1 : 0;
        var marginScrollbarWidth = barWidth;
        if (this.bordered) {
          marginScrollbarWidth += 1;
        }
        var isVirtual = this.virtualConfig.isVirtualScroll.value;
        var affixedFooter = Boolean(this.footerAffixedBottom && ((_this$footData = this.footData) === null || _this$footData === void 0 ? void 0 : _this$footData.length) && this.tableWidth) && h(Affix, helper([{
          "class": this.tableBaseClass.affixedFooterWrap,
          "on": {
            "fixedChange": this.onFixedChange
          },
          "attrs": {
            "offsetBottom": marginScrollbarWidth || 0
          }
        }, {
          "props": getAffixProps(this.footerAffixedBottom, this.footerAffixProps)
        }, {
          "style": {
            marginTop: "".concat(-1 * (this.tableFootHeight + marginScrollbarWidth), "px")
          },
          "ref": "footerBottomAffixRef"
        }]), [h("div", {
          "ref": "affixFooterRef",
          "style": {
            width: "".concat(this.tableWidth - affixedLeftBorder, "px"),
            opacity: Number(this.showAffixFooter)
          },
          "class": ["scrollbar", _defineProperty$2({}, this.tableBaseClass.affixedFooterElm, this.footerAffixedBottom || isVirtual)]
        }, [h("table", {
          "class": this.tableElmClasses,
          "style": _objectSpread$A(_objectSpread$A({}, this.tableElementStyles), {}, {
            width: "".concat(this.tableElmWidth, "px")
          })
        }, [this.renderColGroup(columns, true), h(TFoot, {
          "attrs": {
            "rowKey": this.rowKey,
            "isFixedHeader": this.isFixedHeader,
            "rowAndColFixedPosition": this.rowAndColFixedPosition,
            "footData": this.footData,
            "columns": columns,
            "rowAttributes": this.rowAttributes,
            "rowClassName": this.rowClassName,
            "thWidthList": this.thWidthList,
            "footerSummary": this.footerSummary,
            "rowspanAndColspanInFooter": this.rowspanAndColspanInFooter
          },
          "scopedSlots": this.$scopedSlots
        })])])]);
        return affixedFooter;
      },
      renderAffixedHeader: function renderAffixedHeader(columns) {
        var h = this.$createElement;
        if (!baseTableProps.showHeader) return null;
        return !!(this.virtualConfig.isVirtualScroll.value || this.headerAffixedTop) && (this.headerAffixedTop ? h(Affix, helper([{
          "attrs": {
            "offsetTop": 0
          }
        }, {
          "props": getAffixProps(this.headerAffixedTop, this.headerAffixProps)
        }, {
          "on": {
            "fixedChange": this.onFixedChange
          },
          "ref": "headerTopAffixRef"
        }]), [this.renderFixedHeader(columns)]) : this.isFixedHeader && this.renderFixedHeader(columns));
      }
    },
    render: function render(h) {
      var _this$spansAndLeafNod,
        _this2 = this,
        _this$tableContentRef;
      if (!this.showElement) {
        return h("div", {
          "ref": "tableRef"
        });
      }
      var rowAndColFixedPosition = this.rowAndColFixedPosition;
      var data = this.isPaginateData ? this.dataSource : this.data;
      var columns = ((_this$spansAndLeafNod = this.spansAndLeafNodes) === null || _this$spansAndLeafNod === void 0 ? void 0 : _this$spansAndLeafNod.leafColumns) || this.columns;
      if (this.allowResizeColumnWidth) {
        log.warn("Table", "allowResizeColumnWidth is going to be deprecated, please use resizable instead.");
      }
      if (this.columnResizable && this.tableLayout === "auto") {
        log.warn("Table", "table-layout can not be `auto`, cause you are using column resizable, set `table-layout: fixed` please.");
      }
      var translate = "translate(0, ".concat(this.virtualConfig.scrollHeight.value, "px)");
      var virtualStyle = {
        transform: translate,
        "-ms-transform": translate,
        "-moz-transform": translate,
        "-webkit-transform": translate
      };
      var tableBodyProps = _objectSpread$A(_objectSpread$A({
        rowAndColFixedPosition: rowAndColFixedPosition,
        showColumnShadow: this.showColumnShadow,
        thDraggable: this.thDraggable,
        data: this.virtualConfig.isVirtualScroll.value ? this.virtualConfig.visibleData.value : data,
        virtualConfig: this.virtualConfig,
        columns: columns,
        tableElm: this.tableRef,
        tableContentElm: this.tableContentRef,
        tableWidth: this.tableWidth,
        isWidthOverflow: this.isWidthOverflow,
        scroll: this.scroll,
        cellEmptyContent: this.cellEmptyContent,
        classPrefix: this.classPrefix,
        handleRowMounted: this.virtualConfig.handleRowMounted,
        renderExpandedRow: this.renderExpandedRow
      }, pick$1(this.$props, extendTableProps)), {}, {
        pagination: this.innerPagination,
        attach: this.attach,
        hoverRow: this.hoverRow,
        activeRow: this.tActiveRow,
        onRowClick: this.onInnerRowClick
      });
      var tBodyListener = this.getListener();
      var tableContent = h("div", helper([{
        "ref": "tableContentRef",
        "key": "table-content",
        "class": this.tableBaseClass.content,
        "style": this.tableContentStyles
      }, {
        "on": {
          scroll: this.onInnerVirtualScroll
        }
      }]), [this.virtualConfig.isVirtualScroll.value && h("div", {
        "class": this.virtualScrollClasses.cursor,
        "style": virtualStyle
      }), h("table", {
        "ref": "tableElmRef",
        "class": this.tableElmClasses,
        "style": _objectSpread$A(_objectSpread$A({}, this.tableElementStyles), {}, {
          width: this.resizable && this.isWidthOverflow && this.tableElmWidth ? "".concat(this.tableElmWidth, "px") : this.tableElementStyles.width
        })
      }, [this.renderColGroup(columns, false), this.showHeader && h(THead, helper([{
        "scopedSlots": this.$scopedSlots
      }, {
        "props": this.getHeadProps(false)
      }])), h(TBody, helper([{
        "ref": "tableBodyRef",
        "scopedSlots": this.$scopedSlots
      }, {
        "props": tableBodyProps
      }, {}, {
        "on": tBodyListener
      }])), h(TFoot, {
        "attrs": {
          "rowKey": this.rowKey,
          "isFixedHeader": this.isFixedHeader,
          "rowAndColFixedPosition": rowAndColFixedPosition,
          "footData": this.footData,
          "columns": columns,
          "rowAttributes": this.rowAttributes,
          "rowClassName": this.rowClassName,
          "footerSummary": this.footerSummary,
          "rowspanAndColspanInFooter": this.rowspanAndColspanInFooter
        },
        "scopedSlots": this.$scopedSlots
      })])]);
      var getCustomLoadingText = isFunction(this.loading) ? this.loading : this.$scopedSlots.loading;
      var loadingContent = this.loading !== void 0 && h(Loading, helper([{
        "key": "loading",
        "attrs": {
          "loading": !!this.loading,
          "text": getCustomLoadingText,
          "attach": this.tableRef ? function () {
            return _this2.tableRef;
          } : void 0,
          "showOverlay": true
        }
      }, {
        "props": _objectSpread$A({
          size: "small"
        }, this.loadingProps)
      }]));
      var topContent = renderTNodeJSX(this, "topContent");
      var bottomContent = renderTNodeJSX(this, "bottomContent");
      var paginationContent = this.innerPagination ? h("div", {
        "ref": "paginationRef",
        "class": this.tableBaseClass.paginationWrap,
        "style": {
          opacity: Number(this.showAffixPagination)
        }
      }, [this.renderPagination(h)]) : null;
      var bottom = !!bottomContent && h("div", {
        "ref": "bottomContentRef",
        "class": this.tableBaseClass.bottomContent
      }, [bottomContent]);
      return h("div", {
        "ref": "tableRef",
        "attrs": {
          "tabindex": this.tableRefTabIndex
        },
        "class": this.dynamicBaseTableClasses,
        "on": {
          "focus": this.onTableFocus,
          "blur": this.onTableBlur
        }
      }, [!!topContent && h("div", {
        "class": this.tableBaseClass.topContent
      }, [topContent]), this.renderAffixedHeader(columns), tableContent, this.renderAffixedFooter(columns), loadingContent, bottom, this.showRightDivider && h("div", {
        "key": "right-divider",
        "class": this.tableBaseClass.scrollbarDivider,
        "style": {
          right: "".concat(this.scrollbarWidth, "px"),
          bottom: this.dividerBottom ? "".concat(this.dividerBottom, "px") : void 0,
          height: "".concat((_this$tableContentRef = this.tableContentRef) === null || _this$tableContentRef === void 0 ? void 0 : _this$tableContentRef.getBoundingClientRect().height, "px")
        }
      }), this.horizontalScrollAffixedBottom && h(Affix, helper([{
        "attrs": {
          "offsetBottom": 0
        }
      }, {
        "props": getAffixProps(this.horizontalScrollAffixedBottom)
      }, {
        "style": this.showAffixFooter ? {
          marginTop: "-".concat(this.scrollbarWidth * 2, "px")
        } : {
          "float": "right",
          visibility: "hidden"
        },
        "ref": "horizontalScrollAffixRef"
      }]), [h("div", {
        "ref": "horizontalScrollbarRef",
        "class": ["scrollbar", this.tableBaseClass.obviousScrollbar],
        "style": {
          width: "".concat(this.tableWidth, "px"),
          overflow: "auto",
          opacity: Number(this.showAffixFooter)
        }
      }, [h("div", {
        "style": {
          width: "".concat(this.tableElmWidth, "px"),
          height: "5px"
        }
      })])]), this.paginationAffixedBottom ? h(Affix, helper([{
        "attrs": {
          "offsetBottom": 0
        }
      }, {
        "props": getAffixProps(this.paginationAffixedBottom)
      }, {
        "ref": "paginationAffixRef"
      }]), [paginationContent]) : paginationContent, h("div", {
        "ref": "resizeLineRef",
        "class": this.tableBaseClass.resizeLine,
        "style": this.resizeLineStyle
      })]);
    }
  });

  var primaryTableProps = {
    asyncLoading: {
      type: [String, Function]
    },
    columnController: {
      type: Object
    },
    columnControllerVisible: {
      type: Boolean,
      "default": void 0
    },
    defaultColumnControllerVisible: {
      type: Boolean,
      "default": void 0
    },
    columns: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    displayColumns: {
      type: Array
    },
    defaultDisplayColumns: {
      type: Array
    },
    dragSort: {
      type: String,
      validator: function validator(val) {
        if (!val) return true;
        return ["row", "row-handler", "col", "row-handler-col", "drag-col"].includes(val);
      }
    },
    dragSortOptions: {
      type: Object
    },
    editableCellState: {
      type: Function
    },
    editableRowKeys: {
      type: Array
    },
    expandIcon: {
      type: [Boolean, Function],
      "default": true
    },
    expandOnRowClick: Boolean,
    expandedRow: {
      type: [String, Function]
    },
    expandedRowKeys: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    defaultExpandedRowKeys: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    filterIcon: {
      type: Function
    },
    filterRow: {
      type: [String, Function]
    },
    filterValue: {
      type: Object
    },
    defaultFilterValue: {
      type: Object
    },
    hideSortTips: Boolean,
    indeterminateSelectedRowKeys: {
      type: Array
    },
    multipleSort: Boolean,
    reserveSelectedRowOnPaginate: {
      type: Boolean,
      "default": true
    },
    rowSelectionAllowUncheck: Boolean,
    rowSelectionType: {
      type: String,
      validator: function validator(val) {
        if (!val) return true;
        return ["single", "multiple"].includes(val);
      }
    },
    selectOnRowClick: Boolean,
    selectedRowKeys: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    defaultSelectedRowKeys: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    showSortColumnBgColor: Boolean,
    sort: {
      type: [Object, Array]
    },
    defaultSort: {
      type: [Object, Array]
    },
    sortIcon: {
      type: Function
    },
    sortOnRowDraggable: Boolean,
    onAsyncLoadingClick: Function,
    onCellClick: Function,
    onChange: Function,
    onColumnChange: Function,
    onColumnControllerVisibleChange: Function,
    onDataChange: Function,
    onDisplayColumnsChange: Function,
    onDragSort: Function,
    onExpandChange: Function,
    onFilterChange: Function,
    onRowEdit: Function,
    onRowValidate: Function,
    onSelectChange: Function,
    onSortChange: Function,
    onValidate: Function
  };

  function ownKeys$A(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$z(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$A(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$A(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var ColumnCheckboxGroup = VueCompositionAPI.defineComponent({
    name: "ColumnCheckboxGroup",
    props: {
      checkboxProps: Object,
      options: {
        type: Array,
        "default": function _default() {
          return [];
        }
      },
      label: String,
      uniqueKey: String,
      value: Array,
      onChange: Function
    },
    setup: function setup(props, context) {
      var _toRefs = VueCompositionAPI.toRefs(props),
        value = _toRefs.value,
        options = _toRefs.options;
      var classPrefix = usePrefixClass();
      var allCheckedColumnKeys = VueCompositionAPI.computed(function () {
        var allCheckedKeys = [];
        options.value.forEach(function (option) {
          if (_typeof$2(option) === "object") {
            if (option.disabled) return;
            if (option.value) {
              allCheckedKeys.push(option.value);
            } else if (typeof option.label === "string") {
              allCheckedKeys.push(option.label);
            }
          } else {
            allCheckedKeys.push(option);
          }
        });
        return allCheckedKeys;
      });
      var intersectionKeys = VueCompositionAPI.computed(function () {
        return intersection$1(allCheckedColumnKeys.value, value.value);
      });
      var isCheckedAll = VueCompositionAPI.computed(function () {
        var len = intersectionKeys.value.length;
        return Boolean(len && allCheckedColumnKeys.value.length === len);
      });
      var isIndeterminate = VueCompositionAPI.computed(function () {
        var len = intersectionKeys.value.length;
        return Boolean(len < allCheckedColumnKeys.value.length && len);
      });
      var onCheckAllColumnsChange = function onCheckAllColumnsChange(checkAll, ctx) {
        var changeParams = {
          e: ctx.e,
          type: "check",
          current: void 0,
          option: void 0
        };
        if (checkAll) {
          var _props$onChange;
          var newKeys = _toConsumableArray(new Set(value.value.concat(allCheckedColumnKeys.value)));
          (_props$onChange = props.onChange) === null || _props$onChange === void 0 || _props$onChange.call(props, newKeys, changeParams);
          context.emit("change", newKeys, changeParams);
        } else {
          var _props$onChange2;
          var _newKeys = value.value.filter(function (val) {
            return !allCheckedColumnKeys.value.includes(val);
          });
          (_props$onChange2 = props.onChange) === null || _props$onChange2 === void 0 || _props$onChange2.call(props, _newKeys, _objectSpread$z(_objectSpread$z({}, changeParams), {}, {
            type: "uncheck"
          }));
          context.emit("change", _newKeys, _objectSpread$z(_objectSpread$z({}, changeParams), {}, {
            type: "uncheck"
          }));
        }
      };
      var handleCheckChange = function handleCheckChange(val, ctx) {
        var _props$onChange3;
        (_props$onChange3 = props.onChange) === null || _props$onChange3 === void 0 || _props$onChange3.call(props, val, ctx);
        context.emit("change", val, ctx);
      };
      var classes = VueCompositionAPI.computed(function () {
        return ["".concat(classPrefix.value, "-table__column-controller-item"), _defineProperty$2({}, "".concat(classPrefix.value, "-table__").concat(props.uniqueKey), props.uniqueKey)];
      });
      return {
        classes: classes,
        classPrefix: classPrefix,
        isIndeterminate: isIndeterminate,
        isCheckedAll: isCheckedAll,
        allCheckedColumnKeys: allCheckedColumnKeys,
        onCheckAllColumnsChange: onCheckAllColumnsChange,
        handleCheckChange: handleCheckChange
      };
    },
    render: function render() {
      var h = arguments[0];
      return h("div", {
        "class": this.classes
      }, [h("div", {
        "class": "".concat(this.classPrefix, "-table__column-controller-block")
      }, [h(Checkbox, helper([{
        "attrs": {
          "indeterminate": this.isIndeterminate,
          "checked": this.isCheckedAll
        }
      }, {
        "on": {
          change: this.onCheckAllColumnsChange
        }
      }, {
        "attrs": {
          "disabled": !this.allCheckedColumnKeys.length
        }
      }]), [this.label])]), h("div", {
        "class": "".concat(this.classPrefix, "-table__column-controller-block")
      }, [h(CheckboxGroup, helper([{
        "attrs": {
          "options": this.options
        }
      }, this.checkboxProps, {
        "attrs": {
          "value": this.value
        }
      }, {
        "on": {
          change: this.handleCheckChange
        }
      }]))])]);
    }
  });

  function ownKeys$z(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$y(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$z(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$z(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function getColumnKeys(columns) {
    var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : /* @__PURE__ */new Set();
    for (var i = 0, len = columns.length; i < len; i++) {
      var _col$children;
      var col = columns[i];
      if ((_col$children = col.children) !== null && _col$children !== void 0 && _col$children.length) {
        getColumnKeys(col.children, keys);
      } else {
        col.colKey && keys.add(col.colKey);
      }
    }
    return keys;
  }
  function useColumnController(props, context) {
    var _useConfig = useConfig("table", props.locale),
      classPrefix = _useConfig.classPrefix,
      globalConfig = _useConfig.globalConfig;
    var _useGlobalIcon = useGlobalIcon({
        SettingIcon: TdSettingIcon
      }),
      SettingIcon = _useGlobalIcon.SettingIcon;
    var _toRefs = VueCompositionAPI.toRefs(props),
      columns = _toRefs.columns,
      columnController = _toRefs.columnController,
      displayColumns = _toRefs.displayColumns,
      columnControllerVisible = _toRefs.columnControllerVisible;
    var renderTNodeJSX = useTNodeJSX();
    var dialogInstance = VueCompositionAPI.ref(null);
    var enabledColKeys = VueCompositionAPI.computed(function () {
      var _columnController$val;
      var arr = (((_columnController$val = columnController.value) === null || _columnController$val === void 0 ? void 0 : _columnController$val.fields) || _toConsumableArray(getColumnKeys(columns.value))).filter(function (v) {
        return v;
      });
      return new Set(arr);
    });
    var keys = _toConsumableArray(getColumnKeys(columns.value));
    var _useDefaultValue = useDefaultValue(displayColumns, props.defaultDisplayColumns || keys, props.onDisplayColumnsChange, "displayColumns", "display-columns-change"),
      _useDefaultValue2 = _slicedToArray(_useDefaultValue, 2),
      tDisplayColumns = _useDefaultValue2[0],
      setTDisplayColumns = _useDefaultValue2[1];
    var columnCheckboxKeys = VueCompositionAPI.ref(displayColumns.value || props.defaultDisplayColumns || keys);
    var checkboxOptions = VueCompositionAPI.computed(function () {
      return getCheckboxOptions(columns.value);
    });
    var checkboxGroupList = VueCompositionAPI.computed(function () {
      var _columnController$val2;
      if ((_columnController$val2 = columnController.value) !== null && _columnController$val2 !== void 0 && (_columnController$val2 = _columnController$val2.groupColumns) !== null && _columnController$val2 !== void 0 && _columnController$val2.length) {
        return getCheckboxGroupOptions(columns.value);
      }
      var oneItem = {
        label: globalConfig.value.selectAllText,
        options: getCheckboxOptions(columns.value)
      };
      return [oneItem];
    });
    VueCompositionAPI.watch([displayColumns], function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        val = _ref2[0];
      columnCheckboxKeys.value = val || props.defaultDisplayColumns || keys;
    });
    function getOneColumnItem(column, i) {
      return {
        label: function label() {
          return renderTitle(VueCompositionAPI.h, context.slots, column, i);
        },
        value: column.colKey,
        disabled: !enabledColKeys.value.has(column.colKey)
      };
    }
    function getCheckboxGroupOptions(columns2) {
      var _columnController$val3;
      var groupColumns = (_columnController$val3 = columnController.value) === null || _columnController$val3 === void 0 ? void 0 : _columnController$val3.groupColumns;
      if (!(groupColumns !== null && groupColumns !== void 0 && groupColumns.length)) return [];
      var groupList = [];
      var _loop = function loop(columns3) {
        for (var i = 0, len = columns3.length; i < len; i++) {
          var _column$children;
          var column = columns3[i];
          var oneItem = getOneColumnItem(column, i);
          for (var j = 0, len1 = groupColumns.length; j < len1; j++) {
            var _groupList$j;
            var groupInfo = groupColumns[j];
            if (!groupInfo.columns.includes(column.colKey)) continue;
            if ((_groupList$j = groupList[j]) !== null && _groupList$j !== void 0 && (_groupList$j = _groupList$j.options) !== null && _groupList$j !== void 0 && _groupList$j.length) {
              groupList[j].options.push(oneItem);
            } else {
              groupList[j] = _objectSpread$y(_objectSpread$y({}, groupColumns[j]), {}, {
                options: [oneItem]
              });
            }
          }
          if ((_column$children = column.children) !== null && _column$children !== void 0 && _column$children.length) {
            _loop(column.children);
          }
        }
      };
      _loop(columns2);
      return groupList;
    }
    function getCheckboxOptions(columns2) {
      var _columnController$val4;
      var arr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      if ((_columnController$val4 = columnController.value) !== null && _columnController$val4 !== void 0 && (_columnController$val4 = _columnController$val4.groupColumns) !== null && _columnController$val4 !== void 0 && _columnController$val4.length) return [];
      for (var i = 0, len = columns2.length; i < len; i++) {
        var _item$children;
        var item = columns2[i];
        if ((_item$children = item.children) !== null && _item$children !== void 0 && _item$children.length) {
          getCheckboxOptions(item.children, arr);
        } else if (item.colKey) {
          arr.push(getOneColumnItem(item, i));
        }
      }
      return arr;
    }
    var handleCheckChange = function handleCheckChange(val, ctx) {
      var _props$onColumnChange;
      columnCheckboxKeys.value = val;
      var params = {
        columns: val,
        type: ctx.type,
        currentColumn: getCurrentRowByKey(columns.value, String(ctx.current)),
        e: ctx.e
      };
      (_props$onColumnChange = props.onColumnChange) === null || _props$onColumnChange === void 0 || _props$onColumnChange.call(props, params);
      context.emit("column-change", params);
    };
    var handleToggleColumnController = function handleToggleColumnController() {
      var _columnController$val8;
      if (dialogInstance.value) {
        dialogInstance.value.show();
        return;
      }
      dialogInstance.value = DialogPlugin.confirm(_objectSpread$y({
        header: globalConfig.value.columnConfigTitleText,
        body: function body(h2) {
          var _columnController$val5;
          var widthMode = ((_columnController$val5 = columnController.value) === null || _columnController$val5 === void 0 ? void 0 : _columnController$val5.displayType) === "fixed-width" ? "fixed" : "auto";
          var _ref3 = columnController.value || {},
            columnControllerTopContent = _ref3.columnControllerTopContent,
            columnControllerBottomContent = _ref3.columnControllerBottomContent;
          var prefix = classPrefix.value;
          var classes = ["".concat(prefix, "-table__column-controller"), "".concat(prefix, "-table__column-controller--").concat(widthMode)];
          var defaultNode = VueCompositionAPI.h("div", {
            "class": classes
          }, [VueCompositionAPI.h("div", {
            "class": "".concat(prefix, "-table__column-controller-body")
          }, [isFunction(columnControllerTopContent) ? columnControllerTopContent(h2) : renderTNodeJSX("columnControllerTopContent"), globalConfig.value.columnConfigDescriptionText && VueCompositionAPI.h("p", {
            "class": "".concat(prefix, "-table__column-controller-desc")
          }, [globalConfig.value.columnConfigDescriptionText]), checkboxGroupList.value.map(function (group, index) {
            var _columnController$val6, _columnController$val7;
            var uniqueKey = (_columnController$val6 = columnController.value) !== null && _columnController$val6 !== void 0 && (_columnController$val6 = _columnController$val6.groupColumns) !== null && _columnController$val6 !== void 0 && _columnController$val6.length ? String(group.value || index) : void 0;
            return VueCompositionAPI.h(ColumnCheckboxGroup, helper([{
              "key": group.value || index,
              "attrs": {
                "uniqueKey": uniqueKey,
                "value": columnCheckboxKeys.value,
                "label": group.label,
                "options": group.options
              }
            }, {
              "on": {
                change: handleCheckChange
              }
            }, {
              "attrs": {
                "checkboxProps": (_columnController$val7 = columnController.value) === null || _columnController$val7 === void 0 ? void 0 : _columnController$val7.checkboxProps
              }
            }]));
          }), isFunction(columnControllerBottomContent) ? columnControllerBottomContent(h2) : renderTNodeJSX("columnControllerBottomContent")])]);
          return defaultNode;
        },
        confirmBtn: globalConfig.value.confirmText,
        cancelBtn: globalConfig.value.cancelText,
        width: 612,
        onConfirm: function onConfirm() {
          setTDisplayColumns(_toConsumableArray(columnCheckboxKeys.value));
          if (columnControllerVisible.value === void 0) {
            dialogInstance.value.hide();
          } else {
            var _props$onColumnContro;
            (_props$onColumnContro = props.onColumnControllerVisibleChange) === null || _props$onColumnContro === void 0 || _props$onColumnContro.call(props, false, {
              trigger: "confirm"
            });
            context.emit("update:columnControllerVisible", false);
          }
        },
        onClose: function onClose() {
          if (columnControllerVisible.value === void 0) {
            dialogInstance.value.hide();
          } else {
            var _props$onColumnContro2;
            (_props$onColumnContro2 = props.onColumnControllerVisibleChange) === null || _props$onColumnContro2 === void 0 || _props$onColumnContro2.call(props, false, {
              trigger: "cancel"
            });
            context.emit("update:columnControllerVisible", false);
          }
        }
      }, ((_columnController$val8 = columnController.value) === null || _columnController$val8 === void 0 ? void 0 : _columnController$val8.dialogProps) || {}));
    };
    VueCompositionAPI.watch([columnControllerVisible], function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 1),
        visible = _ref5[0];
      if (visible === void 0) return;
      if (dialogInstance.value) {
        visible ? dialogInstance.value.show() : dialogInstance.value.hide();
      } else {
        visible && handleToggleColumnController();
      }
    }, {
      immediate: true
    });
    var renderColumnController = function renderColumnController(h2) {
      var _props$columnControll;
      var isColumnController = !!(columnController.value && Object.keys(columnController.value).length);
      var placement = isColumnController ? columnController.value.placement || "top-right" : "";
      if (isColumnController && columnController.value.hideTriggerButton) return null;
      var classes = ["".concat(classPrefix.value, "-table__column-controller-trigger"), _defineProperty$2({}, "".concat(classPrefix.value, "-align-").concat(placement), !!placement)];
      return VueCompositionAPI.h("div", {
        "class": classes
      }, [VueCompositionAPI.h(Button, helper([{
        "attrs": {
          "theme": "default",
          "variant": "outline",
          "content": globalConfig.value.columnConfigButtonText
        },
        "on": {
          "click": handleToggleColumnController
        },
        "scopedSlots": {
          icon: function icon() {
            return VueCompositionAPI.h(SettingIcon);
          }
        }
      }, {
        "props": (_props$columnControll = props.columnController) === null || _props$columnControll === void 0 ? void 0 : _props$columnControll.buttonProps
      }]))]);
    };
    return {
      tDisplayColumns: tDisplayColumns,
      columnCheckboxKeys: columnCheckboxKeys,
      checkboxOptions: checkboxOptions,
      renderColumnController: renderColumnController
    };
  }

  function useRowExpand(props, context) {
    var _toRefs = VueCompositionAPI.toRefs(props),
      expandedRowKeys = _toRefs.expandedRowKeys;
    var renderTNode = useTNodeJSX();
    var _useConfig = useConfig("table", props.locale),
      t = _useConfig.t,
      global = _useConfig.global;
    var _useGlobalIcon = useGlobalIcon({
        ChevronRightCircleIcon: TdChevronRightCircleIcon
      }),
      ChevronRightCircleIcon = _useGlobalIcon.ChevronRightCircleIcon;
    var _useClassName = useClassName(),
      tableExpandClasses = _useClassName.tableExpandClasses,
      positiveRotate90 = _useClassName.positiveRotate90,
      tableFullRowClasses = _useClassName.tableFullRowClasses;
    var _useDefaultValue = useDefaultValue(expandedRowKeys, props.defaultExpandedRowKeys || [], props.onExpandChange, "expandedRowKeys", "expand-change"),
      _useDefaultValue2 = _slicedToArray(_useDefaultValue, 2),
      tExpandedRowKeys = _useDefaultValue2[0],
      setTExpandedRowKeys = _useDefaultValue2[1];
    var showExpandedRow = VueCompositionAPI.computed(function () {
      return Boolean(props.expandedRow || context.slots.expandedRow || context.slots["expanded-row"]);
    });
    var showExpandIconColumn = VueCompositionAPI.computed(function () {
      return props.expandIcon !== false && showExpandedRow.value;
    });
    var isFirstColumnFixed = VueCompositionAPI.computed(function () {
      var _props$columns;
      return ((_props$columns = props.columns) === null || _props$columns === void 0 || (_props$columns = _props$columns[0]) === null || _props$columns === void 0 ? void 0 : _props$columns.fixed) === "left";
    });
    var getExpandedRowClass = function getExpandedRowClass(params) {
      var _tExpandedRowKeys$val;
      if (!showExpandedRow.value) return null;
      var row = params.row,
        rowKey = params.rowKey;
      var currentRowKey = get(row, rowKey || "id");
      return tableExpandClasses[(_tExpandedRowKeys$val = tExpandedRowKeys.value) !== null && _tExpandedRowKeys$val !== void 0 && _tExpandedRowKeys$val.includes(currentRowKey) ? "rowExpanded" : "rowFolded"];
    };
    var onToggleExpand = function onToggleExpand(e, row) {
      props.expandOnRowClick && e.stopPropagation();
      var currentId = get(row, props.rowKey || "id");
      var index = tExpandedRowKeys.value.indexOf(currentId);
      var newKeys = _toConsumableArray(tExpandedRowKeys.value);
      index !== -1 ? newKeys.splice(index, 1) : newKeys.push(currentId);
      setTExpandedRowKeys(newKeys, {
        expandedRowData: props.data.filter(function (t2) {
          return newKeys.includes(get(t2, props.rowKey || "id"));
        }),
        currentRowData: row
      });
    };
    var renderExpandIcon = function renderExpandIcon(h, p) {
      var row = p.row,
        rowIndex = p.rowIndex;
      var currentId = get(row, props.rowKey || "id");
      var expanded = tExpandedRowKeys.value.includes(currentId);
      var icon = renderTNode("expandIcon", {
        defaultNode: t(global.value.expandIcon) || h(ChevronRightCircleIcon),
        params: {
          row: row,
          index: rowIndex
        }
      });
      if (!icon) return null;
      var classes = [tableExpandClasses.iconBox, tableExpandClasses[expanded ? "expanded" : "collapsed"], _defineProperty$2({}, positiveRotate90, expanded)];
      return h("span", {
        "class": classes,
        "on": {
          "click": function click(e) {
            return onToggleExpand(e, row);
          }
        }
      }, [icon]);
    };
    var getExpandColumn = function getExpandColumn(h) {
      var expandCol = {
        colKey: "__EXPAND_ROW_ICON_COLUMN__",
        width: 64,
        className: tableExpandClasses.iconCell,
        fixed: isFirstColumnFixed.value ? "left" : void 0,
        cell: renderExpandIcon,
        stopPropagation: true
      };
      return expandCol;
    };
    var renderExpandedRow = function renderExpandedRow(h, p) {
      var rowId = get(p.row, props.rowKey || "id");
      if (!tExpandedRowKeys.value || !tExpandedRowKeys.value.includes(rowId)) return null;
      var isFixedLeft = p.isWidthOverflow && props.columns.find(function (item) {
        return item.fixed === "left";
      });
      return h("tr", {
        "key": "expand_".concat(rowId),
        "class": [tableExpandClasses.row, _defineProperty$2({}, tableFullRowClasses.base, isFixedLeft)]
      }, [h("td", {
        "attrs": {
          "colspan": p.columns.length
        }
      }, [h("div", {
        "class": [tableExpandClasses.rowInner, _defineProperty$2({}, tableFullRowClasses.innerFullRow, isFixedLeft)],
        "style": isFixedLeft ? {
          width: "".concat(p.tableWidth, "px")
        } : {}
      }, [h("div", {
        "class": tableFullRowClasses.innerFullElement
      }, [renderTNode("expandedRow", {
        params: p
      })])])])]);
    };
    var onInnerExpandRowClick = function onInnerExpandRowClick(p) {
      onToggleExpand(p.e, p.row);
    };
    return {
      showExpandedRow: showExpandedRow,
      showExpandIconColumn: showExpandIconColumn,
      getExpandColumn: getExpandColumn,
      renderExpandedRow: renderExpandedRow,
      onInnerExpandRowClick: onInnerExpandRowClick,
      getExpandedRowClass: getExpandedRowClass
    };
  }

  function isRowSelectedDisabled(selectColumn, row, rowIndex) {
    if (!selectColumn) return false;
    var disabled = isFunction(selectColumn.disabled) ? selectColumn.disabled({
      row: row,
      rowIndex: rowIndex
    }) : selectColumn.disabled;
    if (selectColumn.checkProps) {
      if (isFunction(selectColumn.checkProps)) {
        disabled = disabled || selectColumn.checkProps({
          row: row,
          rowIndex: rowIndex
        }).disabled;
      } else if (selectColumn.checkProps === "object") {
        disabled = disabled || selectColumn.checkProps.disabled;
      }
    }
    return !!disabled;
  }
  function getEditableKeysMap(keys, list, rowKey) {
    var map = {};
    for (var i = 0, len = list.length; i < len; i++) {
      var rowValue = get(list[i], rowKey);
      if (keys.includes(rowValue)) {
        map[rowValue] = true;
      }
    }
    return map;
  }
  function getColumnDataByKey(columns, colKey) {
    for (var i = 0, len = columns.length; i < len; i++) {
      var _columns$i$children;
      if (columns[i].colKey === colKey) return columns[i];
      if ((_columns$i$children = columns[i].children) !== null && _columns$i$children !== void 0 && _columns$i$children.length) {
        var t = getColumnDataByKey(columns[i].children, colKey);
        if (t) return t;
      }
    }
    return null;
  }
  function getColumnIndexByKey(columns, colKey) {
    for (var i = 0, len = columns.length; i < len; i++) {
      var _columns$i$children2;
      if (columns[i].colKey === colKey) {
        return i;
      }
      if ((_columns$i$children2 = columns[i].children) !== null && _columns$i$children2 !== void 0 && _columns$i$children2.length) {
        var t = getColumnDataByKey(columns[i].children, colKey);
        if (t) return i;
      }
    }
    return -1;
  }
  function getColumnsResetValue(columns) {
    var resetValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    for (var i = 0, len = columns.length; i < len; i++) {
      var _col$children;
      var col = columns[i];
      if (col.filter && "resetValue" in col.filter) {
        resetValue[col.colKey] = col.filter.resetValue;
      }
      if ((_col$children = col.children) !== null && _col$children !== void 0 && _col$children.length) {
        getColumnsResetValue(col.children, resetValue);
      }
    }
    return resetValue;
  }

  function ownKeys$y(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$x(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$y(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$y(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function useRowSelect(props, tableSelectedClasses) {
    var _toRefs = VueCompositionAPI.toRefs(props),
      selectedRowKeys = _toRefs.selectedRowKeys,
      columns = _toRefs.columns,
      data = _toRefs.data,
      rowKey = _toRefs.rowKey,
      reserveSelectedRowOnPaginate = _toRefs.reserveSelectedRowOnPaginate;
    var currentPaginateData = VueCompositionAPI.ref(data.value);
    var selectedRowClassNames = VueCompositionAPI.ref();
    var _useDefaultValue = useDefaultValue(selectedRowKeys, props.defaultSelectedRowKeys || [], props.onSelectChange, "selectedRowKeys", "select-change"),
      _useDefaultValue2 = _slicedToArray(_useDefaultValue, 2),
      tSelectedRowKeys = _useDefaultValue2[0],
      setTSelectedRowKeys = _useDefaultValue2[1];
    var selectedRowDataMap = VueCompositionAPI.ref(/* @__PURE__ */new Map());
    var selectColumn = VueCompositionAPI.computed(function () {
      return props.columns.find(function (_ref) {
        var type = _ref.type;
        return ["multiple", "single"].includes(type);
      });
    });
    var canSelectedRows = VueCompositionAPI.computed(function () {
      var currentData = reserveSelectedRowOnPaginate.value ? data.value : currentPaginateData.value;
      return currentData.filter(function (row, rowIndex) {
        return !isDisabled(row, rowIndex);
      });
    });
    var intersectionKeys = VueCompositionAPI.computed(function () {
      return intersection$1(tSelectedRowKeys.value, canSelectedRows.value.map(function (t) {
        return get(t, props.rowKey || "id");
      }));
    });
    var allowUncheck = VueCompositionAPI.computed(function () {
      var singleSelectCol = columns.value.find(function (col) {
        return col.type === "single";
      });
      if (!singleSelectCol || !singleSelectCol.checkProps || !("allowUncheck" in singleSelectCol.checkProps)) return false;
      return singleSelectCol.checkProps.allowUncheck;
    });
    VueCompositionAPI.watch([data, columns, tSelectedRowKeys, selectColumn, rowKey], function () {
      var _selectColumn$value;
      var disabledRowFunc = function disabledRowFunc(p) {
        return selectColumn.value.disabled(p) ? tableSelectedClasses.disabled : "";
      };
      var disabledRowClass = (_selectColumn$value = selectColumn.value) !== null && _selectColumn$value !== void 0 && _selectColumn$value.disabled ? disabledRowFunc : void 0;
      var selected = new Set(tSelectedRowKeys.value);
      var selectedRowClassFunc = function selectedRowClassFunc(_ref2) {
        var row = _ref2.row;
        var rowId = get(row, props.rowKey || "id");
        return selected.has(rowId) ? tableSelectedClasses.selected : "";
      };
      var selectedRowClass = selected.size ? selectedRowClassFunc : void 0;
      selectedRowClassNames.value = [disabledRowClass, selectedRowClass].filter(function (v) {
        return v;
      });
    }, {
      immediate: true
    });
    function isDisabled(row, rowIndex) {
      return isRowSelectedDisabled(selectColumn.value, row, rowIndex);
    }
    function getSelectedHeader(h2) {
      return function () {
        return VueCompositionAPI.h(Checkbox, {
          "attrs": {
            "checked": intersectionKeys.value.length !== 0 && canSelectedRows.value.length !== 0 && intersectionKeys.value.length === canSelectedRows.value.length,
            "indeterminate": intersectionKeys.value.length > 0 && intersectionKeys.value.length < canSelectedRows.value.length,
            "disabled": !canSelectedRows.value.length
          },
          "on": _objectSpread$x({}, {
            change: handleSelectAll
          })
        });
      };
    }
    function getRowSelectDisabledData(p) {
      var col = p.col,
        row = p.row,
        rowIndex = p.rowIndex;
      var disabled = typeof col.disabled === "function" ? col.disabled({
        row: row,
        rowIndex: rowIndex
      }) : col.disabled;
      var checkProps = isFunction(col.checkProps) ? col.checkProps({
        row: row,
        rowIndex: rowIndex
      }) : col.checkProps;
      return {
        disabled: disabled || (checkProps === null || checkProps === void 0 ? void 0 : checkProps.disabled),
        checkProps: checkProps
      };
    }
    function renderSelectCell(h2, p) {
      var column = p.col,
        _p$row = p.row,
        row = _p$row === void 0 ? {} : _p$row;
      var checked = tSelectedRowKeys.value.includes(get(row, props.rowKey || "id"));
      var _getRowSelectDisabled = getRowSelectDisabledData(p),
        disabled = _getRowSelectDisabled.disabled,
        checkProps = _getRowSelectDisabled.checkProps;
      var selectBoxProps = {
        props: _objectSpread$x({
          checked: checked,
          disabled: disabled
        }, checkProps),
        on: {
          click: function click(_ref3) {
            var e = _ref3.e;
            e === null || e === void 0 || e.stopPropagation();
          },
          change: function change() {
            return handleSelectChange(row);
          }
        }
      };
      if (column.type === "single") return VueCompositionAPI.h(Radio, helper([{}, selectBoxProps]));
      if (column.type === "multiple") {
        var _props$indeterminateS;
        var isIndeterminate = (_props$indeterminateS = props.indeterminateSelectedRowKeys) !== null && _props$indeterminateS !== void 0 && _props$indeterminateS.length ? props.indeterminateSelectedRowKeys.includes(get(row, props.rowKey)) : false;
        return VueCompositionAPI.h(Checkbox, helper([{
          "attrs": {
            "indeterminate": isIndeterminate
          }
        }, selectBoxProps]));
      }
      return null;
    }
    function handleSelectChange() {
      var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var selectedRowKeys2 = _toConsumableArray(tSelectedRowKeys.value);
      var reRowKey = props.rowKey || "id";
      var id = get(row, reRowKey);
      var selectedRowIndex = selectedRowKeys2.indexOf(id);
      var isExisted = selectedRowIndex !== -1;
      if (selectColumn.value.type === "multiple") {
        isExisted ? selectedRowKeys2.splice(selectedRowIndex, 1) : selectedRowKeys2.push(id);
      } else if (selectColumn.value.type === "single") {
        selectedRowKeys2 = isExisted && allowUncheck.value ? [] : [id];
      } else {
        log.warn("Table", "`column.type` must be one of `multiple` and `single`");
        return;
      }
      setTSelectedRowKeys(selectedRowKeys2, {
        selectedRowData: selectedRowKeys2.map(function (t) {
          return selectedRowDataMap.value.get(t);
        }).filter(function (rowData) {
          return !!rowData;
        }),
        currentRowKey: id,
        currentRowData: row,
        type: isExisted ? "uncheck" : "check"
      });
    }
    function handleSelectAll(checked) {
      var _selectedRowKeys$valu;
      var reRowKey = props.rowKey || "id";
      var canSelectedRowKeys = canSelectedRows.value.map(function (record) {
        return get(record, reRowKey);
      });
      var disabledSelectedRowKeys = ((_selectedRowKeys$valu = selectedRowKeys.value) === null || _selectedRowKeys$valu === void 0 ? void 0 : _selectedRowKeys$valu.filter(function (id) {
        return !canSelectedRowKeys.includes(id);
      })) || [];
      var allIds = checked ? [].concat(_toConsumableArray(disabledSelectedRowKeys), _toConsumableArray(canSelectedRowKeys)) : _toConsumableArray(disabledSelectedRowKeys);
      setTSelectedRowKeys(allIds, {
        selectedRowData: checked ? allIds.map(function (t) {
          return selectedRowDataMap.value.get(t);
        }) : [],
        type: checked ? "check" : "uncheck",
        currentRowKey: "CHECK_ALL_BOX"
      });
    }
    function formatToRowSelectColumn(col) {
      var isSelection = ["multiple", "single"].includes(col.type);
      if (!isSelection) return col;
      return _objectSpread$x(_objectSpread$x({}, col), {}, {
        width: col.width || 64,
        className: [tableSelectedClasses.checkCell, col.className],
        cell: function cell(h2, p) {
          return renderSelectCell(h2, p);
        },
        title: col.type === "multiple" ? getSelectedHeader() : col.title
      });
    }
    var onInnerSelectRowClick = function onInnerSelectRowClick(_ref4) {
      var row = _ref4.row,
        index = _ref4.index;
      var selectedColIndex = props.columns.findIndex(function (item) {
        return item.colKey === "row-select";
      });
      if (selectedColIndex === -1) return;
      var _getRowSelectDisabled2 = getRowSelectDisabledData({
          row: row,
          rowIndex: index,
          col: props.columns[selectedColIndex],
          colIndex: selectedColIndex
        }),
        disabled = _getRowSelectDisabled2.disabled;
      if (disabled) return;
      handleSelectChange(row);
    };
    VueCompositionAPI.watch([data, rowKey], function () {
      for (var i = 0, len = data.value.length; i < len; i++) {
        selectedRowDataMap.value.set(get(data.value[i], rowKey.value || "id"), data.value[i]);
      }
    }, {
      immediate: true
    });
    var showRowSelect = VueCompositionAPI.computed(function () {
      return !!selectColumn.value;
    });
    var clearAllSelectedRowKeys = function clearAllSelectedRowKeys() {
      setTSelectedRowKeys([], {
        selectedRowData: [],
        currentRowKey: void 0,
        currentRowData: void 0,
        type: "uncheck"
      });
    };
    var handleRowSelectWithAreaSelection = function handleRowSelectWithAreaSelection(_ref5) {
      var _selectColumn$value2;
      var activeRowList = _ref5.activeRowList,
        action = _ref5.action;
      if (!showRowSelect.value) return;
      if (action === "clear") {
        clearAllSelectedRowKeys();
        return;
      }
      if (((_selectColumn$value2 = selectColumn.value) === null || _selectColumn$value2 === void 0 ? void 0 : _selectColumn$value2.type) === "single") {
        if (action === "space-one-selection") {
          handleSelectChange(activeRowList[0].row);
        }
        return;
      }
      var validAreaSelection = activeRowList.filter(function (_ref6) {
        var row = _ref6.row,
          rowIndex = _ref6.rowIndex;
        return !getRowSelectDisabledData({
          row: row,
          rowIndex: rowIndex,
          col: selectColumn.value,
          colIndex: void 0
        }).disabled;
      });
      if (!validAreaSelection.length) return;
      var areaSelectionKeys = validAreaSelection.map(function (_ref7) {
        var row = _ref7.row;
        return get(row, props.rowKey);
      });
      var intersectionKeys2 = intersection$1(tSelectedRowKeys.value, areaSelectionKeys);
      var toCheck = intersectionKeys2.length !== areaSelectionKeys.length;
      var clearedKeys = tSelectedRowKeys.value.filter(function (key) {
        return !areaSelectionKeys.includes(key);
      });
      var newSelectedRowKeys = toCheck ? _toConsumableArray(new Set(tSelectedRowKeys.value.concat(areaSelectionKeys))) : clearedKeys;
      var currentRowData = action === "space-one-selection" ? activeRowList[0].row : void 0;
      setTSelectedRowKeys(newSelectedRowKeys, {
        selectedRowData: activeRowList,
        currentRowKey: get(currentRowData, props.rowKey),
        currentRowData: currentRowData,
        type: toCheck ? "check" : "uncheck"
      });
    };
    return {
      selectColumn: selectColumn,
      showRowSelect: showRowSelect,
      selectedRowClassNames: selectedRowClassNames,
      currentPaginateData: currentPaginateData,
      setTSelectedRowKeys: setTSelectedRowKeys,
      formatToRowSelectColumn: formatToRowSelectColumn,
      onInnerSelectRowClick: onInnerSelectRowClick,
      handleRowSelectWithAreaSelection: handleRowSelectWithAreaSelection
    };
  }

  var SorterButton = VueCompositionAPI.defineComponent({
    props: {
      sortType: {
        type: String,
        "default": "all"
      },
      sortOrder: {
        type: String,
        "default": function _default() {
          return "";
        }
      },
      sortIcon: Function,
      tooltipProps: Object,
      locale: Object,
      hideSortTips: Boolean
    },
    setup: function setup(props, context) {
      var _useClassName = useClassName(),
        tableSortClasses = _useClassName.tableSortClasses,
        negativeRotate180 = _useClassName.negativeRotate180;
      var renderTNode = useTNodeDefault();
      var _useConfig = useConfig("table", props.locale),
        t = _useConfig.t,
        global = _useConfig.global;
      var _useGlobalIcon = useGlobalIcon({
          ChevronDownIcon: TdChevronDownIcon
        }),
        ChevronDownIcon = _useGlobalIcon.ChevronDownIcon;
      var allowSortTypes = VueCompositionAPI.computed(function () {
        return props.sortType === "all" ? ["asc", "desc"] : [props.sortType];
      });
      var onSortIconClick = function onSortIconClick(e, direction) {
        context.emit("sort-icon-click", e, {
          descending: direction === "desc"
        });
      };
      return {
        t: t,
        global: global,
        ChevronDownIcon: ChevronDownIcon,
        tableSortClasses: tableSortClasses,
        negativeRotate180: negativeRotate180,
        allowSortTypes: allowSortTypes,
        onSortIconClick: onSortIconClick,
        renderTNode: renderTNode
      };
    },
    methods: {
      getSortIcon: function getSortIcon(direction, activeClass) {
        var _this = this;
        var h = this.$createElement;
        var ChevronDownIcon = this.ChevronDownIcon;
        var defaultIcon = this.t(this.global.sortIcon) || h(ChevronDownIcon);
        var icon = this.renderTNode("sortIcon", defaultIcon);
        var sortClassName = [activeClass, this.tableSortClasses.sortIcon, this.tableSortClasses.iconDirection[direction], _defineProperty$2({}, this.negativeRotate180, direction === "asc")];
        return h("span", {
          "class": sortClassName,
          "on": {
            "click": function click(e) {
              return _this.onSortIconClick(e, direction);
            }
          }
        }, [icon]);
      }
    },
    render: function render() {
      var _this2 = this;
      var h = arguments[0];
      var tableSortClasses = this.tableSortClasses;
      var classes = [tableSortClasses.trigger, _defineProperty$2({}, tableSortClasses.doubleIcon, this.allowSortTypes.length > 1)];
      var tooltips = {
        asc: this.global.sortAscendingOperationText,
        desc: this.global.sortDescendingOperationText
      };
      var sortButton = this.allowSortTypes.map(function (direction) {
        var _this2$hideSortTips;
        var activeClass = direction === _this2.sortOrder ? tableSortClasses.iconActive : tableSortClasses.iconDefault;
        var cancelTips = _this2.global.sortCancelOperationText;
        var tips = direction === _this2.sortOrder ? cancelTips : tooltips[direction];
        if ((_this2$hideSortTips = _this2.hideSortTips) !== null && _this2$hideSortTips !== void 0 ? _this2$hideSortTips : _this2.global.hideSortTips) return _this2.getSortIcon(direction, activeClass);
        return h(Tooltip, helper([{
          "attrs": {
            "content": tips,
            "placement": "right",
            "showArrow": false
          },
          "class": _this2.tableSortClasses.iconDirection[direction]
        }, _this2.tooltipProps]), [_this2.getSortIcon(direction, activeClass)]);
      });
      return h("div", {
        "class": classes
      }, [sortButton]);
    }
  });

  function ownKeys$x(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$w(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$x(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$x(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function useSorter(props, _ref) {
    var emit = _ref.emit,
      slots = _ref.slots;
    var _toRefs = VueCompositionAPI.toRefs(props),
      sort = _toRefs.sort,
      data = _toRefs.data;
    var originalData = VueCompositionAPI.ref();
    var _useDefaultValue = useDefaultValue(sort, props.defaultSort, props.onSortChange, "sort", "sort-change"),
      _useDefaultValue2 = _slicedToArray(_useDefaultValue, 2),
      tSortInfo = _useDefaultValue2[0],
      setTSortInfo = _useDefaultValue2[1];
    var _useDefaultValue3 = useDefaultValue(data, [], props.onDataChange, "data", "data-change"),
      _useDefaultValue4 = _slicedToArray(_useDefaultValue3, 2),
      tData = _useDefaultValue4[0],
      setTData = _useDefaultValue4[1];
    var sorterFuncMap = VueCompositionAPI.computed(function () {
      return getSorterFuncMap(props.columns);
    });
    var innerSort = VueCompositionAPI.ref();
    var sortArray = VueCompositionAPI.computed(function () {
      var sort2 = tSortInfo.value;
      if (!sort2) return [];
      return Array.isArray(sort2) ? sort2 : [sort2];
    });
    var sortMap = VueCompositionAPI.computed(function () {
      var sortMap2 = {};
      sortArray.value.forEach(function (info, index) {
        var sortBy = info.sortBy;
        sortMap2[sortBy] = _objectSpread$w({
          index: index
        }, info);
      });
      return sortMap2;
    });
    function getSorterFuncMap(columns) {
      var map = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      for (var i = 0, len = columns.length; i < len; i++) {
        var _col$children;
        var col = columns[i];
        if (isFunction(col.sorter)) {
          map[col.colKey] = col.sorter;
        }
        if ((_col$children = col.children) !== null && _col$children !== void 0 && _col$children.length) {
          getSorterFuncMap(col.children, map);
        }
      }
      return map;
    }
    function handleDataSort(sortInfo) {
      var sort2 = sortInfo;
      if (!Object.keys(sorterFuncMap.value).length) return;
      if (!originalData.value) {
        originalData.value = tData.value;
      }
      var isEmptyArraySort = !sort2 || sort2 instanceof Array && !sort2.length;
      var isEmptyObjectSort = !(sort2 instanceof Array) && !(sort2 !== null && sort2 !== void 0 && sort2.sortBy);
      if (isEmptyArraySort || isEmptyObjectSort) {
        setTData(originalData.value, {
          trigger: "sort"
        });
        return originalData.value;
      }
      var formattedSort = sort2 instanceof Array ? sort2 : [sort2];
      var newData = tData.value.slice().sort(function (a, b) {
        var sortResult = 0;
        for (var i = 0, len = formattedSort.length; i < len; i++) {
          var item = formattedSort[i];
          var sortFunc = sorterFuncMap.value[item.sortBy];
          if (sortResult === 0 && sortFunc) {
            sortResult = item.descending ? sortFunc(b, a) : sortFunc(a, b);
          } else {
            break;
          }
        }
        return sortResult;
      });
      if (JSON.stringify(newData) === JSON.stringify(tData.value)) return;
      setTData(newData, {
        trigger: "sort"
      });
      return newData;
    }
    function handleSortHeaderClick(col, p) {
      var _props$onChange;
      var sortInfo;
      if (props.multipleSort) {
        sortInfo = getMultipleNextSort(col, p);
      } else {
        var sort2 = tSortInfo.value instanceof Array ? tSortInfo.value[0] : tSortInfo.value;
        sortInfo = getSingleNextSort(col, sort2, p);
      }
      var newData = handleDataSort(sortInfo);
      var currentData = newData || tData.value;
      var currentDataSource = currentData;
      setTSortInfo(sortInfo, {
        currentDataSource: currentDataSource,
        col: col
      });
      (_props$onChange = props.onChange) === null || _props$onChange === void 0 || _props$onChange.call(props, {
        sorter: sortInfo
      }, {
        currentData: currentData,
        trigger: "sorter"
      });
      emit("change", {
        sorter: sortInfo
      }, {
        currentData: currentData,
        col: col,
        trigger: "sorter"
      });
      innerSort.value = sortInfo;
    }
    function getSortOrder(descending) {
      if (descending === void 0) return;
      return descending ? "desc" : "asc";
    }
    function getSingleNextSort(col, sortInfo, p) {
      if (sortInfo && sortInfo.sortBy === col.colKey && sortInfo.descending === p.descending) {
        return void 0;
      }
      return {
        sortBy: col.colKey,
        descending: p.descending
      };
    }
    function getMultipleNextSort(col, p) {
      var sort2 = tSortInfo.value;
      if (!(sort2 instanceof Array)) return;
      var colKey = col.colKey;
      var result = _toConsumableArray(sort2);
      for (var i = 0, len = sort2.length; i < len; i++) {
        if (sort2[i].sortBy === colKey) {
          var next = getSingleNextSort(col, sort2[i], p);
          next ? result[i] = next : result.splice(i, 1);
          return result;
        }
      }
      result.push({
        sortBy: colKey,
        descending: p.descending
      });
      return result;
    }
    function renderSortIcon(h, _ref2) {
      var _sortMap$value$col$co;
      var col = _ref2.col;
      if (!col.sorter) return null;
      var sorterButtonsProps = {
        sortType: col.sortType,
        sortOrder: getSortOrder((_sortMap$value$col$co = sortMap.value[col.colKey]) === null || _sortMap$value$col$co === void 0 ? void 0 : _sortMap$value$col$co.descending),
        sortIcon: props.sortIcon,
        local: props.locale,
        hideSortTips: props.hideSortTips
      };
      return h(SorterButton, helper([{
        "scopedSlots": {
          sortIcon: slots.sortIcon
        }
      }, {
        "props": sorterButtonsProps
      }, {}, {
        "on": {
          "sort-icon-click": function sortIconClick(_, p) {
            return handleSortHeaderClick(col, p);
          }
        }
      }]));
    }
    var isSortInfoSame = function isSortInfoSame(a, b) {
      var tmpSortInfo = Array.isArray(a) ? a : [a];
      var tmpInnerSortInfo = Array.isArray(b) ? b : [b];
      if (tmpSortInfo.length && !b) return false;
      var _loop = function _loop() {
          var item = tmpSortInfo[i];
          var result = tmpInnerSortInfo.find(function (t) {
            return t.sortBy === item.sortBy;
          });
          if (!result) return {
            v: false
          };
          return {
            v: item.descending === result.descending
          };
        },
        _ret;
      for (var i = 0, len = tmpSortInfo.length; i < len; i++) {
        _ret = _loop();
        if (_ret) return _ret.v;
      }
    };
    VueCompositionAPI.watch(tSortInfo, function () {
      if (!tSortInfo.value) return;
      if (!isSortInfoSame(tSortInfo.value, innerSort.value)) {
        handleDataSort(tSortInfo.value);
      }
    }, {
      immediate: true
    });
    VueCompositionAPI.watch(function () {
      return props.data;
    }, function () {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var previousVal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      if (val.map(function (t) {
        return get(t, props.rowKey);
      }).join() !== previousVal.map(function (t) {
        return get(t, props.rowKey);
      }).join()) {
        originalData.value = props.data;
      }
    });
    return {
      renderSortIcon: renderSortIcon
    };
  }

  function ownKeys$w(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$v(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$w(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$w(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var TableFilterController = VueCompositionAPI.defineComponent({
    name: "TableFilterController",
    props: {
      column: Object,
      colIndex: Number,
      tFilterValue: Object,
      innerFilterValue: Object,
      tableFilterClasses: Object,
      isFocusClass: String,
      primaryTableElement: {},
      popupProps: Object,
      attach: [String, Function],
      filterIcon: [Function]
    },
    setup: function setup(props, _ref) {
      var emit = _ref.emit;
      var triggerElementRef = VueCompositionAPI.ref(null);
      var renderTNode = useTNodeDefault();
      var _useConfig = useConfig("table", props.locale),
        t = _useConfig.t,
        global = _useConfig.global;
      var _useGlobalIcon = useGlobalIcon({
          FilterIcon: TdFilterIcon
        }),
        FilterIcon = _useGlobalIcon.FilterIcon;
      var filterPopupVisible = VueCompositionAPI.ref(false);
      var listFilterValue = VueCompositionAPI.ref("");
      var onFilterPopupVisibleChange = function onFilterPopupVisibleChange(visible) {
        filterPopupVisible.value = visible;
        emit("visible-change", visible);
      };
      var getFilterDisplayList = function getFilterDisplayList(column) {
        var _column$filter = column.filter,
          filter = _column$filter === void 0 ? {} : _column$filter;
        var listFilterConfig = filter.listFilterConfig;
        if (!listFilterValue.value || !filter.listFilterConfig) {
          return filter.list;
        }
        var regExp = new RegExp(escapeRegExp(listFilterValue.value));
        if (listFilterConfig === true) {
          return filter.list.filter(function (item) {
            return regExp.test(item.label);
          });
        }
        if (isObject(listFilterConfig)) {
          return isFunction(listFilterConfig.filterMethod) ? filter.list.filter(function (item) {
            return listFilterConfig.filterMethod(item, listFilterValue.value);
          }) : filter.list.filter(function (item) {
            return regExp.test(item.label);
          });
        }
      };
      return {
        t: t,
        global: global,
        FilterIcon: FilterIcon,
        filterPopupVisible: filterPopupVisible,
        triggerElementRef: triggerElementRef,
        listFilterValue: listFilterValue,
        renderTNode: renderTNode,
        getFilterDisplayList: getFilterDisplayList,
        onFilterPopupVisibleChange: onFilterPopupVisibleChange
      };
    },
    render: function render(h) {
      var _this = this,
        _this$tFilterValue;
      var getFilterContent = function getFilterContent(h2, column2) {
        var _column2$filter;
        var types = ["single", "multiple", "input"];
        if (column2.type && !types.includes(column2.filter.type)) {
          log.error("Table", "filter.type must be the following: ".concat(JSON.stringify(types)));
          return;
        }
        if (!column2.filter.type && !column2.filter.component) {
          log.error("Table", "both filter.type and filter.component can not be empty.");
          return;
        }
        var component = {
          single: RadioGroup,
          multiple: CheckboxGroup,
          input: Input
        }[column2.filter.type] || column2.filter.component;
        if (!component && !column2.filter.component) return;
        var filterComponentProps = _objectSpread$v({
          options: ["single", "multiple"].includes(column2.filter.type) ? _this.getFilterDisplayList(column2) : void 0
        }, ((_column2$filter = column2.filter) === null || _column2$filter === void 0 ? void 0 : _column2$filter.props) || {});
        if (column2.colKey && _this.innerFilterValue && column2.colKey in _this.innerFilterValue) {
          filterComponentProps.value = _this.innerFilterValue[column2.colKey];
        }
        var on = {
          change: function change(val) {
            var _column2$filter2;
            _this.$emit("inner-filter-change", val, column2);
            if ((_column2$filter2 = column2.filter) !== null && _column2$filter2 !== void 0 && (_column2$filter2 = _column2$filter2.confirmEvents) !== null && _column2$filter2 !== void 0 && _column2$filter2.includes("onChange")) {
              _this.filterPopupVisible = false;
            }
          }
        };
        if (column2.filter.confirmEvents) {
          column2.filter.confirmEvents.forEach(function (event) {
            if (event === "onChange") return;
            var pureEvent = lowerFirst$1(event.replace("on", ""));
            on[pureEvent] = function () {
              _this.$emit("confirm", column2);
              _this.filterPopupVisible = false;
            };
          });
        }
        var wrapperListeners = {};
        if (column2.filter.showConfirmAndReset) {
          wrapperListeners.click = function (e) {
            return e.stopPropagation();
          };
        }
        var renderComponent = function renderComponent() {
          if (!component) return null;
          var isVueComponent = component.install && component.component;
          if (typeof component === "function" && !isVueComponent) {
            return component(function (v, b) {
              var attributes = _typeof$2(b) === "object" && "attrs" in b ? b.attrs : {};
              return h2(v, {
                props: _objectSpread$v({}, filterComponentProps),
                attrs: attributes,
                on: on
              });
            });
          }
          var filter = _this.column.filter || {};
          return h(component, helper([{}, {
            "attrs": filter.attrs
          }, {
            "class": filter.classNames,
            "style": filter.style
          }, {
            "props": _objectSpread$v({}, filterComponentProps)
          }, {}, {
            "on": _objectSpread$v({}, on)
          }]));
        };
        var inputObj = isObject(column2.filter.listFilterConfig) ? column2.filter.listFilterConfig : {};
        return h("div", helper([{
          "class": _this.tableFilterClasses.contentInner
        }, {
          "on": wrapperListeners
        }]), [column2.filter.listFilterConfig && h(Input, helper([{
          "attrs": {
            "borderless": true
          },
          "class": [_this.tableFilterClasses.inputFilter, inputObj.className].filter(Boolean),
          "scopedSlots": _objectSpread$v({
            prefixIcon: function prefixIcon() {
              return h(SearchIcon);
            }
          }, inputObj.slots)
        }, {
          "props": inputObj.props
        }, {
          "style": inputObj.style,
          "model": {
            value: _this.listFilterValue,
            callback: function callback($$v) {
              _this.listFilterValue = $$v;
            }
          }
        }])), renderComponent()]);
      };
      var getBottomButtons = function getBottomButtons(h2, column2) {
        if (!column2.filter.showConfirmAndReset) return;
        return h("div", {
          "class": _this.tableFilterClasses.bottomButtons
        }, [h(Button, {
          "attrs": {
            "theme": "default",
            "size": "small"
          },
          "on": {
            "click": function click() {
              _this.$emit("reset", column2);
              _this.filterPopupVisible = false;
            }
          }
        }, [_this.global.resetText]), h(Button, {
          "attrs": {
            "theme": "primary",
            "size": "small"
          },
          "on": {
            "click": function click() {
              _this.$emit("confirm", column2);
              _this.filterPopupVisible = false;
            }
          }
        }, [_this.global.confirmText])]);
      };
      var column = this.column,
        FilterIcon = this.FilterIcon,
        popupProps = this.popupProps;
      if (!column.filter || column.filter && !Object.keys(column.filter).length) return null;
      var defaultFilterIcon = this.t(this.global.filterIcon) || h(FilterIcon);
      var filterValue = (_this$tFilterValue = this.tFilterValue) === null || _this$tFilterValue === void 0 ? void 0 : _this$tFilterValue[column.colKey];
      var isObjectTrue = _typeof$2(filterValue) === "object" && !isEmpty(filterValue);
      var isValueExist = ![null, void 0, ""].includes(filterValue) && _typeof$2(filterValue) !== "object";
      return h(Popup, helper([{
        "attrs": {
          "attach": this.attach || (this.primaryTableElement ? function () {
            return _this.primaryTableElement;
          } : void 0),
          "visible": this.filterPopupVisible,
          "destroyOnClose": true,
          "trigger": "click",
          "placement": "bottom",
          "showArrow": true,
          "overlayClassName": this.tableFilterClasses.popup
        }
      }, {
        "on": {
          "visible-change": function visibleChange(val) {
            return _this.onFilterPopupVisibleChange(val);
          }
        }
      }, {
        "class": [this.tableFilterClasses.icon, _defineProperty$2({}, this.isFocusClass, isObjectTrue || isValueExist)],
        "attrs": {
          "content": function content() {
            return h("div", {
              "class": _this.tableFilterClasses.popupContent
            }, [getFilterContent(h, column), getBottomButtons(h, column)]);
          }
        }
      }, {
        "props": popupProps
      }]), [h("div", {
        "ref": "triggerElementRef"
      }, [this.renderTNode("filterIcon", {
        defaultNode: defaultFilterIcon,
        params: {
          col: column,
          colIndex: this.colIndex
        }
      })])]);
    }
  });

  function ownKeys$v(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$u(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$v(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$v(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function isFilterValueExist(value) {
    var isArrayTrue = value instanceof Array && value.length;
    var isObject = _typeof$2(value) === "object" && !(value instanceof Array);
    var isObjectTrue = isObject && Object.keys(value).length;
    return isArrayTrue || isObjectTrue || !["null", "", "undefined"].includes(String(value));
  }
  function filterEmptyData(data) {
    var newFilterValue = {};
    Object.keys(data).forEach(function (key) {
      var item = data[key];
      if (isFilterValueExist(item)) {
        newFilterValue[key] = item;
      }
    });
    return newFilterValue;
  }
  function useFilter(props, context) {
    var primaryTableRef = VueCompositionAPI.ref(null);
    var _useConfig = useConfig("table", props.locale),
      t = _useConfig.t,
      global = _useConfig.global;
    var renderTNode = useTNodeDefault();
    var _toRefs = VueCompositionAPI.toRefs(props),
      filterValue = _toRefs.filterValue,
      columns = _toRefs.columns;
    var _useClassName = useClassName(),
      tableFilterClasses = _useClassName.tableFilterClasses,
      isFocusClass = _useClassName.isFocusClass;
    var isTableOverflowHidden = VueCompositionAPI.ref();
    var _useDefaultValue = useDefaultValue(filterValue, props.defaultFilterValue, props.onFilterChange, "filterValue", "filter-change"),
      _useDefaultValue2 = _slicedToArray(_useDefaultValue, 2),
      tFilterValue = _useDefaultValue2[0],
      setTFilterValue = _useDefaultValue2[1];
    var innerFilterValue = VueCompositionAPI.ref(tFilterValue.value);
    var hasEmptyCondition = VueCompositionAPI.computed(function () {
      var filterEmpty = filterEmptyData(tFilterValue.value || {});
      return !tFilterValue.value || !Object.keys(filterEmpty).length;
    });
    VueCompositionAPI.watch([tFilterValue], function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        val = _ref2[0];
      innerFilterValue.value = val;
    });
    function renderFirstFilterRow(h) {
      var _props$pagination, _props$data;
      if (hasEmptyCondition.value) return null;
      var defaultNode = h("div", {
        "class": tableFilterClasses.result
      }, [t(global.value.searchResultText, {
        result: getFilterResultContent(h),
        count: ((_props$pagination = props.pagination) === null || _props$pagination === void 0 ? void 0 : _props$pagination.total) || ((_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.length)
      }), h(Button, {
        "attrs": {
          "theme": "primary",
          "variant": "text"
        },
        "on": {
          "click": onResetAll
        }
      }, [global.value.clearFilterResultButtonText])]);
      var filterContent = renderTNode("filterRow");
      if (props.filterRow && !filterContent || props.filterRow === null) return null;
      return h("div", {
        "class": tableFilterClasses.inner
      }, [filterContent || defaultNode]);
    }
    function getFilterResultContent(h) {
      var arr = [];
      props.columns.filter(function (col) {
        return col.filter;
      }).forEach(function (col, index) {
        var value = tFilterValue.value[col.colKey];
        if (col.filter.list && !["null", "", "undefined"].includes(String(value))) {
          var formattedValue = value instanceof Array ? value : [value];
          var label = [];
          col.filter.list.forEach(function (option) {
            if (formattedValue.includes(option.value)) {
              label.push(option.label);
            }
          });
          value = label.join();
        }
        if (isFilterValueExist(value)) {
          var _col$filter, _col$filter2;
          var _label = isFunction((_col$filter = col.filter) === null || _col$filter === void 0 ? void 0 : _col$filter.label) ? col.filter.label(h) : (_col$filter2 = col.filter) === null || _col$filter2 === void 0 ? void 0 : _col$filter2.label;
          var title = renderTitle(h, context.slots, col, index);
          arr.push("".concat(_label || title, "\uFF1A").concat(value));
        }
      });
      return arr.join("\uFF1B");
    }
    function onInnerFilterChange(val, column) {
      var filterValue2 = _objectSpread$u(_objectSpread$u({}, innerFilterValue.value), {}, _defineProperty$2({}, column.colKey, val));
      innerFilterValue.value = filterValue2;
      if (!column.filter.showConfirmAndReset) {
        emitFilterChange(filterValue2, "filter-change", column);
      }
    }
    function emitFilterChange(filterValue2, trigger, column) {
      var _props$onChange;
      setTFilterValue(filterValue2, {
        col: column,
        trigger: trigger
      });
      (_props$onChange = props.onChange) === null || _props$onChange === void 0 || _props$onChange.call(props, {
        filter: filterValue2
      }, {
        trigger: "filter"
      });
      context.emit("change", {
        filter: filterValue2
      }, {
        trigger: "filter"
      });
    }
    function onReset(column) {
      var _ref3, _column$filter$resetV;
      var filterValue2 = _objectSpread$u(_objectSpread$u({}, tFilterValue.value), {}, _defineProperty$2({}, column.colKey, (_ref3 = (_column$filter$resetV = column.filter.resetValue) !== null && _column$filter$resetV !== void 0 ? _column$filter$resetV : {
        single: "",
        multiple: [],
        input: ""
      }[column.filter.type]) !== null && _ref3 !== void 0 ? _ref3 : ""));
      emitFilterChange(filterValue2, "reset", column);
    }
    function onResetAll() {
      var resetValue = getColumnsResetValue(columns.value);
      emitFilterChange(resetValue, "clear", void 0);
    }
    function onConfirm(column) {
      emitFilterChange(innerFilterValue.value, "confirm", column);
    }
    function renderFilterIcon(h, _ref4) {
      var _primaryTableRef$valu;
      var col = _ref4.col,
        colIndex = _ref4.colIndex;
      return h(TableFilterController, helper([{
        "scopedSlots": {
          filterIcon: context.slots.filterIcon
        },
        "attrs": {
          "local": props.locale,
          "column": col,
          "colIndex": colIndex,
          "filterIcon": props.filterIcon,
          "tFilterValue": tFilterValue.value,
          "innerFilterValue": innerFilterValue.value,
          "tableFilterClasses": tableFilterClasses,
          "isFocusClass": isFocusClass,
          "popupProps": col.filter.popupProps,
          "primaryTableElement": (_primaryTableRef$valu = primaryTableRef.value) === null || _primaryTableRef$valu === void 0 ? void 0 : _primaryTableRef$valu.$el
        }
      }, {
        "on": {
          reset: onReset,
          confirm: onConfirm,
          "inner-filter-change": onInnerFilterChange,
          "visible-change": onPopupVisibleChange
        }
      }, {
        "attrs": {
          "attach": props.attach
        }
      }]));
    }
    function setFilterPrimaryTableRef(primaryTableElement) {
      primaryTableRef.value = primaryTableElement;
    }
    function onPopupVisibleChange(visible) {
      if (visible && !isTableOverflowHidden.value) {
        isTableOverflowHidden.value = !visible;
      }
    }
    return {
      hasEmptyCondition: hasEmptyCondition,
      isTableOverflowHidden: isTableOverflowHidden,
      renderFilterIcon: renderFilterIcon,
      renderFirstFilterRow: renderFirstFilterRow,
      setFilterPrimaryTableRef: setFilterPrimaryTableRef
    };
  }

  /**!
   * Sortable 1.15.6
   * @author	RubaXa   <trash@rubaxa.org>
   * @author	owenm    <owen23355@gmail.com>
   * @license MIT
   */
  function ownKeys$u(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys$u(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys$u(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }
    return _typeof(obj);
  }
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  var version = "1.15.6";
  function userAgent(pattern) {
    if (typeof window !== 'undefined' && window.navigator) {
      return !! /*@__PURE__*/navigator.userAgent.match(pattern);
    }
  }
  var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
  var Edge = userAgent(/Edge/i);
  var FireFox = userAgent(/firefox/i);
  var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
  var IOS = userAgent(/iP(ad|od|hone)/i);
  var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);
  var captureMode = {
    capture: false,
    passive: false
  };
  function on(el, event, fn) {
    el.addEventListener(event, fn, !IE11OrLess && captureMode);
  }
  function off(el, event, fn) {
    el.removeEventListener(event, fn, !IE11OrLess && captureMode);
  }
  function matches(/**HTMLElement*/el, /**String*/selector) {
    if (!selector) return;
    selector[0] === '>' && (selector = selector.substring(1));
    if (el) {
      try {
        if (el.matches) {
          return el.matches(selector);
        } else if (el.msMatchesSelector) {
          return el.msMatchesSelector(selector);
        } else if (el.webkitMatchesSelector) {
          return el.webkitMatchesSelector(selector);
        }
      } catch (_) {
        return false;
      }
    }
    return false;
  }
  function getParentOrHost(el) {
    return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
  }
  function closest(/**HTMLElement*/el, /**String*/selector, /**HTMLElement*/ctx, includeCTX) {
    if (el) {
      ctx = ctx || document;
      do {
        if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) {
          return el;
        }
        if (el === ctx) break;
        /* jshint boss:true */
      } while (el = getParentOrHost(el));
    }
    return null;
  }
  var R_SPACE = /\s+/g;
  function toggleClass(el, name, state) {
    if (el && name) {
      if (el.classList) {
        el.classList[state ? 'add' : 'remove'](name);
      } else {
        var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
        el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
      }
    }
  }
  function css(el, prop, val) {
    var style = el && el.style;
    if (style) {
      if (val === void 0) {
        if (document.defaultView && document.defaultView.getComputedStyle) {
          val = document.defaultView.getComputedStyle(el, '');
        } else if (el.currentStyle) {
          val = el.currentStyle;
        }
        return prop === void 0 ? val : val[prop];
      } else {
        if (!(prop in style) && prop.indexOf('webkit') === -1) {
          prop = '-webkit-' + prop;
        }
        style[prop] = val + (typeof val === 'string' ? '' : 'px');
      }
    }
  }
  function matrix(el, selfOnly) {
    var appliedTransforms = '';
    if (typeof el === 'string') {
      appliedTransforms = el;
    } else {
      do {
        var transform = css(el, 'transform');
        if (transform && transform !== 'none') {
          appliedTransforms = transform + ' ' + appliedTransforms;
        }
        /* jshint boss:true */
      } while (!selfOnly && (el = el.parentNode));
    }
    var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
    /*jshint -W056 */
    return matrixFn && new matrixFn(appliedTransforms);
  }
  function find(ctx, tagName, iterator) {
    if (ctx) {
      var list = ctx.getElementsByTagName(tagName),
        i = 0,
        n = list.length;
      if (iterator) {
        for (; i < n; i++) {
          iterator(list[i], i);
        }
      }
      return list;
    }
    return [];
  }
  function getWindowScrollingElement() {
    var scrollingElement = document.scrollingElement;
    if (scrollingElement) {
      return scrollingElement;
    } else {
      return document.documentElement;
    }
  }

  /**
   * Returns the "bounding client rect" of given element
   * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
   * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
   * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
   * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
   * @param  {[HTMLElement]} container              The parent the element will be placed in
   * @return {Object}                               The boundingClientRect of el, with specified adjustments
   */
  function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
    if (!el.getBoundingClientRect && el !== window) return;
    var elRect, top, left, bottom, right, height, width;
    if (el !== window && el.parentNode && el !== getWindowScrollingElement()) {
      elRect = el.getBoundingClientRect();
      top = elRect.top;
      left = elRect.left;
      bottom = elRect.bottom;
      right = elRect.right;
      height = elRect.height;
      width = elRect.width;
    } else {
      top = 0;
      left = 0;
      bottom = window.innerHeight;
      right = window.innerWidth;
      height = window.innerHeight;
      width = window.innerWidth;
    }
    if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
      // Adjust for translate()
      container = container || el.parentNode;

      // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
      // Not needed on <= IE11
      if (!IE11OrLess) {
        do {
          if (container && container.getBoundingClientRect && (css(container, 'transform') !== 'none' || relativeToNonStaticParent && css(container, 'position') !== 'static')) {
            var containerRect = container.getBoundingClientRect();

            // Set relative to edges of padding box of container
            top -= containerRect.top + parseInt(css(container, 'border-top-width'));
            left -= containerRect.left + parseInt(css(container, 'border-left-width'));
            bottom = top + elRect.height;
            right = left + elRect.width;
            break;
          }
          /* jshint boss:true */
        } while (container = container.parentNode);
      }
    }
    if (undoScale && el !== window) {
      // Adjust for scale()
      var elMatrix = matrix(container || el),
        scaleX = elMatrix && elMatrix.a,
        scaleY = elMatrix && elMatrix.d;
      if (elMatrix) {
        top /= scaleY;
        left /= scaleX;
        width /= scaleX;
        height /= scaleY;
        bottom = top + height;
        right = left + width;
      }
    }
    return {
      top: top,
      left: left,
      bottom: bottom,
      right: right,
      width: width,
      height: height
    };
  }

  /**
   * Checks if a side of an element is scrolled past a side of its parents
   * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
   * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
   * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
   * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
   */
  function isScrolledPast(el, elSide, parentSide) {
    var parent = getParentAutoScrollElement(el, true),
      elSideVal = getRect(el)[elSide];

    /* jshint boss:true */
    while (parent) {
      var parentSideVal = getRect(parent)[parentSide],
        visible = void 0;
      if (parentSide === 'top' || parentSide === 'left') {
        visible = elSideVal >= parentSideVal;
      } else {
        visible = elSideVal <= parentSideVal;
      }
      if (!visible) return parent;
      if (parent === getWindowScrollingElement()) break;
      parent = getParentAutoScrollElement(parent, false);
    }
    return false;
  }

  /**
   * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
   * and non-draggable elements
   * @param  {HTMLElement} el       The parent element
   * @param  {Number} childNum      The index of the child
   * @param  {Object} options       Parent Sortable's options
   * @return {HTMLElement}          The child at index childNum, or null if not found
   */
  function getChild(el, childNum, options, includeDragEl) {
    var currentChild = 0,
      i = 0,
      children = el.children;
    while (i < children.length) {
      if (children[i].style.display !== 'none' && children[i] !== Sortable.ghost && (includeDragEl || children[i] !== Sortable.dragged) && closest(children[i], options.draggable, el, false)) {
        if (currentChild === childNum) {
          return children[i];
        }
        currentChild++;
      }
      i++;
    }
    return null;
  }

  /**
   * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
   * @param  {HTMLElement} el       Parent element
   * @param  {selector} selector    Any other elements that should be ignored
   * @return {HTMLElement}          The last child, ignoring ghostEl
   */
  function lastChild(el, selector) {
    var last = el.lastElementChild;
    while (last && (last === Sortable.ghost || css(last, 'display') === 'none' || selector && !matches(last, selector))) {
      last = last.previousElementSibling;
    }
    return last || null;
  }

  /**
   * Returns the index of an element within its parent for a selected set of
   * elements
   * @param  {HTMLElement} el
   * @param  {selector} selector
   * @return {number}
   */
  function index(el, selector) {
    var index = 0;
    if (!el || !el.parentNode) {
      return -1;
    }

    /* jshint boss:true */
    while (el = el.previousElementSibling) {
      if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== Sortable.clone && (!selector || matches(el, selector))) {
        index++;
      }
    }
    return index;
  }

  /**
   * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
   * The value is returned in real pixels.
   * @param  {HTMLElement} el
   * @return {Array}             Offsets in the format of [left, top]
   */
  function getRelativeScrollOffset(el) {
    var offsetLeft = 0,
      offsetTop = 0,
      winScroller = getWindowScrollingElement();
    if (el) {
      do {
        var elMatrix = matrix(el),
          scaleX = elMatrix.a,
          scaleY = elMatrix.d;
        offsetLeft += el.scrollLeft * scaleX;
        offsetTop += el.scrollTop * scaleY;
      } while (el !== winScroller && (el = el.parentNode));
    }
    return [offsetLeft, offsetTop];
  }

  /**
   * Returns the index of the object within the given array
   * @param  {Array} arr   Array that may or may not hold the object
   * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
   * @return {Number}      The index of the object in the array, or -1
   */
  function indexOfObject(arr, obj) {
    for (var i in arr) {
      if (!arr.hasOwnProperty(i)) continue;
      for (var key in obj) {
        if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
      }
    }
    return -1;
  }
  function getParentAutoScrollElement(el, includeSelf) {
    // skip to window
    if (!el || !el.getBoundingClientRect) return getWindowScrollingElement();
    var elem = el;
    var gotSelf = false;
    do {
      // we don't need to get elem css if it isn't even overflowing in the first place (performance)
      if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
        var elemCSS = css(elem);
        if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
          if (!elem.getBoundingClientRect || elem === document.body) return getWindowScrollingElement();
          if (gotSelf || includeSelf) return elem;
          gotSelf = true;
        }
      }
      /* jshint boss:true */
    } while (elem = elem.parentNode);
    return getWindowScrollingElement();
  }
  function extend(dst, src) {
    if (dst && src) {
      for (var key in src) {
        if (src.hasOwnProperty(key)) {
          dst[key] = src[key];
        }
      }
    }
    return dst;
  }
  function isRectEqual(rect1, rect2) {
    return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
  }
  var _throttleTimeout;
  function throttle(callback, ms) {
    return function () {
      if (!_throttleTimeout) {
        var args = arguments,
          _this = this;
        if (args.length === 1) {
          callback.call(_this, args[0]);
        } else {
          callback.apply(_this, args);
        }
        _throttleTimeout = setTimeout(function () {
          _throttleTimeout = void 0;
        }, ms);
      }
    };
  }
  function cancelThrottle() {
    clearTimeout(_throttleTimeout);
    _throttleTimeout = void 0;
  }
  function scrollBy(el, x, y) {
    el.scrollLeft += x;
    el.scrollTop += y;
  }
  function clone(el) {
    var Polymer = window.Polymer;
    var $ = window.jQuery || window.Zepto;
    if (Polymer && Polymer.dom) {
      return Polymer.dom(el).cloneNode(true);
    } else if ($) {
      return $(el).clone(true)[0];
    } else {
      return el.cloneNode(true);
    }
  }
  function getChildContainingRectFromElement(container, options, ghostEl) {
    var rect = {};
    Array.from(container.children).forEach(function (child) {
      var _rect$left, _rect$top, _rect$right, _rect$bottom;
      if (!closest(child, options.draggable, container, false) || child.animated || child === ghostEl) return;
      var childRect = getRect(child);
      rect.left = Math.min((_rect$left = rect.left) !== null && _rect$left !== void 0 ? _rect$left : Infinity, childRect.left);
      rect.top = Math.min((_rect$top = rect.top) !== null && _rect$top !== void 0 ? _rect$top : Infinity, childRect.top);
      rect.right = Math.max((_rect$right = rect.right) !== null && _rect$right !== void 0 ? _rect$right : -Infinity, childRect.right);
      rect.bottom = Math.max((_rect$bottom = rect.bottom) !== null && _rect$bottom !== void 0 ? _rect$bottom : -Infinity, childRect.bottom);
    });
    rect.width = rect.right - rect.left;
    rect.height = rect.bottom - rect.top;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
  }
  var expando = 'Sortable' + new Date().getTime();
  function AnimationStateManager() {
    var animationStates = [],
      animationCallbackId;
    return {
      captureAnimationState: function captureAnimationState() {
        animationStates = [];
        if (!this.options.animation) return;
        var children = [].slice.call(this.el.children);
        children.forEach(function (child) {
          if (css(child, 'display') === 'none' || child === Sortable.ghost) return;
          animationStates.push({
            target: child,
            rect: getRect(child)
          });
          var fromRect = _objectSpread2({}, animationStates[animationStates.length - 1].rect);

          // If animating: compensate for current animation
          if (child.thisAnimationDuration) {
            var childMatrix = matrix(child, true);
            if (childMatrix) {
              fromRect.top -= childMatrix.f;
              fromRect.left -= childMatrix.e;
            }
          }
          child.fromRect = fromRect;
        });
      },
      addAnimationState: function addAnimationState(state) {
        animationStates.push(state);
      },
      removeAnimationState: function removeAnimationState(target) {
        animationStates.splice(indexOfObject(animationStates, {
          target: target
        }), 1);
      },
      animateAll: function animateAll(callback) {
        var _this = this;
        if (!this.options.animation) {
          clearTimeout(animationCallbackId);
          if (typeof callback === 'function') callback();
          return;
        }
        var animating = false,
          animationTime = 0;
        animationStates.forEach(function (state) {
          var time = 0,
            target = state.target,
            fromRect = target.fromRect,
            toRect = getRect(target),
            prevFromRect = target.prevFromRect,
            prevToRect = target.prevToRect,
            animatingRect = state.rect,
            targetMatrix = matrix(target, true);
          if (targetMatrix) {
            // Compensate for current animation
            toRect.top -= targetMatrix.f;
            toRect.left -= targetMatrix.e;
          }
          target.toRect = toRect;
          if (target.thisAnimationDuration) {
            // Could also check if animatingRect is between fromRect and toRect
            if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) &&
            // Make sure animatingRect is on line between toRect & fromRect
            (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
              // If returning to same place as started from animation and on same axis
              time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
            }
          }

          // if fromRect != toRect: animate
          if (!isRectEqual(toRect, fromRect)) {
            target.prevFromRect = fromRect;
            target.prevToRect = toRect;
            if (!time) {
              time = _this.options.animation;
            }
            _this.animate(target, animatingRect, toRect, time);
          }
          if (time) {
            animating = true;
            animationTime = Math.max(animationTime, time);
            clearTimeout(target.animationResetTimer);
            target.animationResetTimer = setTimeout(function () {
              target.animationTime = 0;
              target.prevFromRect = null;
              target.fromRect = null;
              target.prevToRect = null;
              target.thisAnimationDuration = null;
            }, time);
            target.thisAnimationDuration = time;
          }
        });
        clearTimeout(animationCallbackId);
        if (!animating) {
          if (typeof callback === 'function') callback();
        } else {
          animationCallbackId = setTimeout(function () {
            if (typeof callback === 'function') callback();
          }, animationTime);
        }
        animationStates = [];
      },
      animate: function animate(target, currentRect, toRect, duration) {
        if (duration) {
          css(target, 'transition', '');
          css(target, 'transform', '');
          var elMatrix = matrix(this.el),
            scaleX = elMatrix && elMatrix.a,
            scaleY = elMatrix && elMatrix.d,
            translateX = (currentRect.left - toRect.left) / (scaleX || 1),
            translateY = (currentRect.top - toRect.top) / (scaleY || 1);
          target.animatingX = !!translateX;
          target.animatingY = !!translateY;
          css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
          this.forRepaintDummy = repaint(target); // repaint

          css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
          css(target, 'transform', 'translate3d(0,0,0)');
          typeof target.animated === 'number' && clearTimeout(target.animated);
          target.animated = setTimeout(function () {
            css(target, 'transition', '');
            css(target, 'transform', '');
            target.animated = false;
            target.animatingX = false;
            target.animatingY = false;
          }, duration);
        }
      }
    };
  }
  function repaint(target) {
    return target.offsetWidth;
  }
  function calculateRealTime(animatingRect, fromRect, toRect, options) {
    return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
  }
  var plugins = [];
  var defaults = {
    initializeByDefault: true
  };
  var PluginManager = {
    mount: function mount(plugin) {
      // Set default static properties
      for (var option in defaults) {
        if (defaults.hasOwnProperty(option) && !(option in plugin)) {
          plugin[option] = defaults[option];
        }
      }
      plugins.forEach(function (p) {
        if (p.pluginName === plugin.pluginName) {
          throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
        }
      });
      plugins.push(plugin);
    },
    pluginEvent: function pluginEvent(eventName, sortable, evt) {
      var _this = this;
      this.eventCanceled = false;
      evt.cancel = function () {
        _this.eventCanceled = true;
      };
      var eventNameGlobal = eventName + 'Global';
      plugins.forEach(function (plugin) {
        if (!sortable[plugin.pluginName]) return;
        // Fire global events if it exists in this sortable
        if (sortable[plugin.pluginName][eventNameGlobal]) {
          sortable[plugin.pluginName][eventNameGlobal](_objectSpread2({
            sortable: sortable
          }, evt));
        }

        // Only fire plugin event if plugin is enabled in this sortable,
        // and plugin has event defined
        if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
          sortable[plugin.pluginName][eventName](_objectSpread2({
            sortable: sortable
          }, evt));
        }
      });
    },
    initializePlugins: function initializePlugins(sortable, el, defaults, options) {
      plugins.forEach(function (plugin) {
        var pluginName = plugin.pluginName;
        if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
        var initialized = new plugin(sortable, el, sortable.options);
        initialized.sortable = sortable;
        initialized.options = sortable.options;
        sortable[pluginName] = initialized;

        // Add default options from plugin
        _extends(defaults, initialized.defaults);
      });
      for (var option in sortable.options) {
        if (!sortable.options.hasOwnProperty(option)) continue;
        var modified = this.modifyOption(sortable, option, sortable.options[option]);
        if (typeof modified !== 'undefined') {
          sortable.options[option] = modified;
        }
      }
    },
    getEventProperties: function getEventProperties(name, sortable) {
      var eventProperties = {};
      plugins.forEach(function (plugin) {
        if (typeof plugin.eventProperties !== 'function') return;
        _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
      });
      return eventProperties;
    },
    modifyOption: function modifyOption(sortable, name, value) {
      var modifiedValue;
      plugins.forEach(function (plugin) {
        // Plugin must exist on the Sortable
        if (!sortable[plugin.pluginName]) return;

        // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin
        if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') {
          modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
        }
      });
      return modifiedValue;
    }
  };
  function dispatchEvent(_ref) {
    var sortable = _ref.sortable,
      rootEl = _ref.rootEl,
      name = _ref.name,
      targetEl = _ref.targetEl,
      cloneEl = _ref.cloneEl,
      toEl = _ref.toEl,
      fromEl = _ref.fromEl,
      oldIndex = _ref.oldIndex,
      newIndex = _ref.newIndex,
      oldDraggableIndex = _ref.oldDraggableIndex,
      newDraggableIndex = _ref.newDraggableIndex,
      originalEvent = _ref.originalEvent,
      putSortable = _ref.putSortable,
      extraEventProperties = _ref.extraEventProperties;
    sortable = sortable || rootEl && rootEl[expando];
    if (!sortable) return;
    var evt,
      options = sortable.options,
      onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1);
    // Support for new CustomEvent feature
    if (window.CustomEvent && !IE11OrLess && !Edge) {
      evt = new CustomEvent(name, {
        bubbles: true,
        cancelable: true
      });
    } else {
      evt = document.createEvent('Event');
      evt.initEvent(name, true, true);
    }
    evt.to = toEl || rootEl;
    evt.from = fromEl || rootEl;
    evt.item = targetEl || rootEl;
    evt.clone = cloneEl;
    evt.oldIndex = oldIndex;
    evt.newIndex = newIndex;
    evt.oldDraggableIndex = oldDraggableIndex;
    evt.newDraggableIndex = newDraggableIndex;
    evt.originalEvent = originalEvent;
    evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;
    var allEventProperties = _objectSpread2(_objectSpread2({}, extraEventProperties), PluginManager.getEventProperties(name, sortable));
    for (var option in allEventProperties) {
      evt[option] = allEventProperties[option];
    }
    if (rootEl) {
      rootEl.dispatchEvent(evt);
    }
    if (options[onName]) {
      options[onName].call(sortable, evt);
    }
  }
  var _excluded$2 = ["evt"];
  var pluginEvent = function pluginEvent(eventName, sortable) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      originalEvent = _ref.evt,
      data = _objectWithoutProperties(_ref, _excluded$2);
    PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread2({
      dragEl: dragEl,
      parentEl: parentEl,
      ghostEl: ghostEl,
      rootEl: rootEl,
      nextEl: nextEl,
      lastDownEl: lastDownEl,
      cloneEl: cloneEl,
      cloneHidden: cloneHidden,
      dragStarted: moved,
      putSortable: putSortable,
      activeSortable: Sortable.active,
      originalEvent: originalEvent,
      oldIndex: oldIndex,
      oldDraggableIndex: oldDraggableIndex,
      newIndex: newIndex,
      newDraggableIndex: newDraggableIndex,
      hideGhostForTarget: _hideGhostForTarget,
      unhideGhostForTarget: _unhideGhostForTarget,
      cloneNowHidden: function cloneNowHidden() {
        cloneHidden = true;
      },
      cloneNowShown: function cloneNowShown() {
        cloneHidden = false;
      },
      dispatchSortableEvent: function dispatchSortableEvent(name) {
        _dispatchEvent({
          sortable: sortable,
          name: name,
          originalEvent: originalEvent
        });
      }
    }, data));
  };
  function _dispatchEvent(info) {
    dispatchEvent(_objectSpread2({
      putSortable: putSortable,
      cloneEl: cloneEl,
      targetEl: dragEl,
      rootEl: rootEl,
      oldIndex: oldIndex,
      oldDraggableIndex: oldDraggableIndex,
      newIndex: newIndex,
      newDraggableIndex: newDraggableIndex
    }, info));
  }
  var dragEl,
    parentEl,
    ghostEl,
    rootEl,
    nextEl,
    lastDownEl,
    cloneEl,
    cloneHidden,
    oldIndex,
    newIndex,
    oldDraggableIndex,
    newDraggableIndex,
    activeGroup,
    putSortable,
    awaitingDragStarted = false,
    ignoreNextClick = false,
    sortables = [],
    tapEvt,
    touchEvt,
    lastDx,
    lastDy,
    tapDistanceLeft,
    tapDistanceTop,
    moved,
    lastTarget,
    lastDirection,
    pastFirstInvertThresh = false,
    isCircumstantialInvert = false,
    targetMoveDistance,
    // For positioning ghost absolutely
    ghostRelativeParent,
    ghostRelativeParentInitialScroll = [],
    // (left, top)

    _silent = false,
    savedInputChecked = [];

  /** @const */
  var documentExists = typeof document !== 'undefined',
    PositionGhostAbsolutely = IOS,
    CSSFloatProperty = Edge || IE11OrLess ? 'cssFloat' : 'float',
    // This will not pass for IE9, because IE9 DnD only works on anchors
    supportDraggable = documentExists && !ChromeForAndroid && !IOS && 'draggable' in document.createElement('div'),
    supportCssPointerEvents = function () {
      if (!documentExists) return;
      // false when <= IE11
      if (IE11OrLess) {
        return false;
      }
      var el = document.createElement('x');
      el.style.cssText = 'pointer-events:auto';
      return el.style.pointerEvents === 'auto';
    }(),
    _detectDirection = function _detectDirection(el, options) {
      var elCSS = css(el),
        elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth),
        child1 = getChild(el, 0, options),
        child2 = getChild(el, 1, options),
        firstChildCSS = child1 && css(child1),
        secondChildCSS = child2 && css(child2),
        firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width,
        secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;
      if (elCSS.display === 'flex') {
        return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
      }
      if (elCSS.display === 'grid') {
        return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
      }
      if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
        var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
        return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
      }
      return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === 'none' || child2 && elCSS[CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
    },
    _dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
      var dragElS1Opp = vertical ? dragRect.left : dragRect.top,
        dragElS2Opp = vertical ? dragRect.right : dragRect.bottom,
        dragElOppLength = vertical ? dragRect.width : dragRect.height,
        targetS1Opp = vertical ? targetRect.left : targetRect.top,
        targetS2Opp = vertical ? targetRect.right : targetRect.bottom,
        targetOppLength = vertical ? targetRect.width : targetRect.height;
      return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
    },
    /**
     * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
     * @param  {Number} x      X position
     * @param  {Number} y      Y position
     * @return {HTMLElement}   Element of the first found nearest Sortable
     */
    _detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
      var ret;
      sortables.some(function (sortable) {
        var threshold = sortable[expando].options.emptyInsertThreshold;
        if (!threshold || lastChild(sortable)) return;
        var rect = getRect(sortable),
          insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold,
          insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
        if (insideHorizontally && insideVertically) {
          return ret = sortable;
        }
      });
      return ret;
    },
    _prepareGroup = function _prepareGroup(options) {
      function toFn(value, pull) {
        return function (to, from, dragEl, evt) {
          var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
          if (value == null && (pull || sameGroup)) {
            // Default pull value
            // Default pull and put value if same group
            return true;
          } else if (value == null || value === false) {
            return false;
          } else if (pull && value === 'clone') {
            return value;
          } else if (typeof value === 'function') {
            return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
          } else {
            var otherGroup = (pull ? to : from).options.group.name;
            return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
          }
        };
      }
      var group = {};
      var originalGroup = options.group;
      if (!originalGroup || _typeof(originalGroup) != 'object') {
        originalGroup = {
          name: originalGroup
        };
      }
      group.name = originalGroup.name;
      group.checkPull = toFn(originalGroup.pull, true);
      group.checkPut = toFn(originalGroup.put);
      group.revertClone = originalGroup.revertClone;
      options.group = group;
    },
    _hideGhostForTarget = function _hideGhostForTarget() {
      if (!supportCssPointerEvents && ghostEl) {
        css(ghostEl, 'display', 'none');
      }
    },
    _unhideGhostForTarget = function _unhideGhostForTarget() {
      if (!supportCssPointerEvents && ghostEl) {
        css(ghostEl, 'display', '');
      }
    };

  // #1184 fix - Prevent click event on fallback if dragged but item not changed position
  if (documentExists && !ChromeForAndroid) {
    document.addEventListener('click', function (evt) {
      if (ignoreNextClick) {
        evt.preventDefault();
        evt.stopPropagation && evt.stopPropagation();
        evt.stopImmediatePropagation && evt.stopImmediatePropagation();
        ignoreNextClick = false;
        return false;
      }
    }, true);
  }
  var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
    if (dragEl) {
      evt = evt.touches ? evt.touches[0] : evt;
      var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);
      if (nearest) {
        // Create imitation event
        var event = {};
        for (var i in evt) {
          if (evt.hasOwnProperty(i)) {
            event[i] = evt[i];
          }
        }
        event.target = event.rootEl = nearest;
        event.preventDefault = void 0;
        event.stopPropagation = void 0;
        nearest[expando]._onDragOver(event);
      }
    }
  };
  var _checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
    if (dragEl) {
      dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
    }
  };

  /**
   * @class  Sortable
   * @param  {HTMLElement}  el
   * @param  {Object}       [options]
   */
  function Sortable(el, options) {
    if (!(el && el.nodeType && el.nodeType === 1)) {
      throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
    }
    this.el = el; // root element
    this.options = options = _extends({}, options);

    // Export instance
    el[expando] = this;
    var defaults = {
      group: null,
      sort: true,
      disabled: false,
      store: null,
      handle: null,
      draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
      swapThreshold: 1,
      // percentage; 0 <= x <= 1
      invertSwap: false,
      // invert always
      invertedSwapThreshold: null,
      // will be set to same as swapThreshold if default
      removeCloneOnHide: true,
      direction: function direction() {
        return _detectDirection(el, this.options);
      },
      ghostClass: 'sortable-ghost',
      chosenClass: 'sortable-chosen',
      dragClass: 'sortable-drag',
      ignore: 'a, img',
      filter: null,
      preventOnFilter: true,
      animation: 0,
      easing: null,
      setData: function setData(dataTransfer, dragEl) {
        dataTransfer.setData('Text', dragEl.textContent);
      },
      dropBubble: false,
      dragoverBubble: false,
      dataIdAttr: 'data-id',
      delay: 0,
      delayOnTouchOnly: false,
      touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
      forceFallback: false,
      fallbackClass: 'sortable-fallback',
      fallbackOnBody: false,
      fallbackTolerance: 0,
      fallbackOffset: {
        x: 0,
        y: 0
      },
      // Disabled on Safari: #1571; Enabled on Safari IOS: #2244
      supportPointer: Sortable.supportPointer !== false && 'PointerEvent' in window && (!Safari || IOS),
      emptyInsertThreshold: 5
    };
    PluginManager.initializePlugins(this, el, defaults);

    // Set default options
    for (var name in defaults) {
      !(name in options) && (options[name] = defaults[name]);
    }
    _prepareGroup(options);

    // Bind all private methods
    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    }

    // Setup drag mode
    this.nativeDraggable = options.forceFallback ? false : supportDraggable;
    if (this.nativeDraggable) {
      // Touch start threshold cannot be greater than the native dragstart threshold
      this.options.touchStartThreshold = 1;
    }

    // Bind events
    if (options.supportPointer) {
      on(el, 'pointerdown', this._onTapStart);
    } else {
      on(el, 'mousedown', this._onTapStart);
      on(el, 'touchstart', this._onTapStart);
    }
    if (this.nativeDraggable) {
      on(el, 'dragover', this);
      on(el, 'dragenter', this);
    }
    sortables.push(this.el);

    // Restore sorting
    options.store && options.store.get && this.sort(options.store.get(this) || []);

    // Add animation state manager
    _extends(this, AnimationStateManager());
  }
  Sortable.prototype = /** @lends Sortable.prototype */{
    constructor: Sortable,
    _isOutsideThisEl: function _isOutsideThisEl(target) {
      if (!this.el.contains(target) && target !== this.el) {
        lastTarget = null;
      }
    },
    _getDirection: function _getDirection(evt, target) {
      return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
    },
    _onTapStart: function _onTapStart(/** Event|TouchEvent */evt) {
      if (!evt.cancelable) return;
      var _this = this,
        el = this.el,
        options = this.options,
        preventOnFilter = options.preventOnFilter,
        type = evt.type,
        touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt,
        target = (touch || evt).target,
        originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target,
        filter = options.filter;
      _saveInputCheckedState(el);

      // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
      if (dragEl) {
        return;
      }
      if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
        return; // only left button and enabled
      }

      // cancel dnd if original target is content editable
      if (originalTarget.isContentEditable) {
        return;
      }

      // Safari ignores further event handling after mousedown
      if (!this.nativeDraggable && Safari && target && target.tagName.toUpperCase() === 'SELECT') {
        return;
      }
      target = closest(target, options.draggable, el, false);
      if (target && target.animated) {
        return;
      }
      if (lastDownEl === target) {
        // Ignoring duplicate `down`
        return;
      }

      // Get the index of the dragged element within its parent
      oldIndex = index(target);
      oldDraggableIndex = index(target, options.draggable);

      // Check filter
      if (typeof filter === 'function') {
        if (filter.call(this, evt, target, this)) {
          _dispatchEvent({
            sortable: _this,
            rootEl: originalTarget,
            name: 'filter',
            targetEl: target,
            toEl: el,
            fromEl: el
          });
          pluginEvent('filter', _this, {
            evt: evt
          });
          preventOnFilter && evt.preventDefault();
          return; // cancel dnd
        }
      } else if (filter) {
        filter = filter.split(',').some(function (criteria) {
          criteria = closest(originalTarget, criteria.trim(), el, false);
          if (criteria) {
            _dispatchEvent({
              sortable: _this,
              rootEl: criteria,
              name: 'filter',
              targetEl: target,
              fromEl: el,
              toEl: el
            });
            pluginEvent('filter', _this, {
              evt: evt
            });
            return true;
          }
        });
        if (filter) {
          preventOnFilter && evt.preventDefault();
          return; // cancel dnd
        }
      }
      if (options.handle && !closest(originalTarget, options.handle, el, false)) {
        return;
      }

      // Prepare `dragstart`
      this._prepareDragStart(evt, touch, target);
    },
    _prepareDragStart: function _prepareDragStart(/** Event */evt, /** Touch */touch, /** HTMLElement */target) {
      var _this = this,
        el = _this.el,
        options = _this.options,
        ownerDocument = el.ownerDocument,
        dragStartFn;
      if (target && !dragEl && target.parentNode === el) {
        var dragRect = getRect(target);
        rootEl = el;
        dragEl = target;
        parentEl = dragEl.parentNode;
        nextEl = dragEl.nextSibling;
        lastDownEl = target;
        activeGroup = options.group;
        Sortable.dragged = dragEl;
        tapEvt = {
          target: dragEl,
          clientX: (touch || evt).clientX,
          clientY: (touch || evt).clientY
        };
        tapDistanceLeft = tapEvt.clientX - dragRect.left;
        tapDistanceTop = tapEvt.clientY - dragRect.top;
        this._lastX = (touch || evt).clientX;
        this._lastY = (touch || evt).clientY;
        dragEl.style['will-change'] = 'all';
        dragStartFn = function dragStartFn() {
          pluginEvent('delayEnded', _this, {
            evt: evt
          });
          if (Sortable.eventCanceled) {
            _this._onDrop();
            return;
          }
          // Delayed drag has been triggered
          // we can re-enable the events: touchmove/mousemove
          _this._disableDelayedDragEvents();
          if (!FireFox && _this.nativeDraggable) {
            dragEl.draggable = true;
          }

          // Bind the events: dragstart/dragend
          _this._triggerDragStart(evt, touch);

          // Drag start event
          _dispatchEvent({
            sortable: _this,
            name: 'choose',
            originalEvent: evt
          });

          // Chosen item
          toggleClass(dragEl, options.chosenClass, true);
        };

        // Disable "draggable"
        options.ignore.split(',').forEach(function (criteria) {
          find(dragEl, criteria.trim(), _disableDraggable);
        });
        on(ownerDocument, 'dragover', nearestEmptyInsertDetectEvent);
        on(ownerDocument, 'mousemove', nearestEmptyInsertDetectEvent);
        on(ownerDocument, 'touchmove', nearestEmptyInsertDetectEvent);
        if (options.supportPointer) {
          on(ownerDocument, 'pointerup', _this._onDrop);
          // Native D&D triggers pointercancel
          !this.nativeDraggable && on(ownerDocument, 'pointercancel', _this._onDrop);
        } else {
          on(ownerDocument, 'mouseup', _this._onDrop);
          on(ownerDocument, 'touchend', _this._onDrop);
          on(ownerDocument, 'touchcancel', _this._onDrop);
        }

        // Make dragEl draggable (must be before delay for FireFox)
        if (FireFox && this.nativeDraggable) {
          this.options.touchStartThreshold = 4;
          dragEl.draggable = true;
        }
        pluginEvent('delayStart', this, {
          evt: evt
        });

        // Delay is impossible for native DnD in Edge or IE
        if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
          if (Sortable.eventCanceled) {
            this._onDrop();
            return;
          }
          // If the user moves the pointer or let go the click or touch
          // before the delay has been reached:
          // disable the delayed drag
          if (options.supportPointer) {
            on(ownerDocument, 'pointerup', _this._disableDelayedDrag);
            on(ownerDocument, 'pointercancel', _this._disableDelayedDrag);
          } else {
            on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
            on(ownerDocument, 'touchend', _this._disableDelayedDrag);
            on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
          }
          on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
          on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
          options.supportPointer && on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
          _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
        } else {
          dragStartFn();
        }
      }
    },
    _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(/** TouchEvent|PointerEvent **/e) {
      var touch = e.touches ? e.touches[0] : e;
      if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
        this._disableDelayedDrag();
      }
    },
    _disableDelayedDrag: function _disableDelayedDrag() {
      dragEl && _disableDraggable(dragEl);
      clearTimeout(this._dragStartTimer);
      this._disableDelayedDragEvents();
    },
    _disableDelayedDragEvents: function _disableDelayedDragEvents() {
      var ownerDocument = this.el.ownerDocument;
      off(ownerDocument, 'mouseup', this._disableDelayedDrag);
      off(ownerDocument, 'touchend', this._disableDelayedDrag);
      off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
      off(ownerDocument, 'pointerup', this._disableDelayedDrag);
      off(ownerDocument, 'pointercancel', this._disableDelayedDrag);
      off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
      off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
      off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
    },
    _triggerDragStart: function _triggerDragStart(/** Event */evt, /** Touch */touch) {
      touch = touch || evt.pointerType == 'touch' && evt;
      if (!this.nativeDraggable || touch) {
        if (this.options.supportPointer) {
          on(document, 'pointermove', this._onTouchMove);
        } else if (touch) {
          on(document, 'touchmove', this._onTouchMove);
        } else {
          on(document, 'mousemove', this._onTouchMove);
        }
      } else {
        on(dragEl, 'dragend', this);
        on(rootEl, 'dragstart', this._onDragStart);
      }
      try {
        if (document.selection) {
          _nextTick(function () {
            document.selection.empty();
          });
        } else {
          window.getSelection().removeAllRanges();
        }
      } catch (err) {}
    },
    _dragStarted: function _dragStarted(fallback, evt) {
      awaitingDragStarted = false;
      if (rootEl && dragEl) {
        pluginEvent('dragStarted', this, {
          evt: evt
        });
        if (this.nativeDraggable) {
          on(document, 'dragover', _checkOutsideTargetEl);
        }
        var options = this.options;

        // Apply effect
        !fallback && toggleClass(dragEl, options.dragClass, false);
        toggleClass(dragEl, options.ghostClass, true);
        Sortable.active = this;
        fallback && this._appendGhost();

        // Drag start event
        _dispatchEvent({
          sortable: this,
          name: 'start',
          originalEvent: evt
        });
      } else {
        this._nulling();
      }
    },
    _emulateDragOver: function _emulateDragOver() {
      if (touchEvt) {
        this._lastX = touchEvt.clientX;
        this._lastY = touchEvt.clientY;
        _hideGhostForTarget();
        var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
        var parent = target;
        while (target && target.shadowRoot) {
          target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
          if (target === parent) break;
          parent = target;
        }
        dragEl.parentNode[expando]._isOutsideThisEl(target);
        if (parent) {
          do {
            if (parent[expando]) {
              var inserted = void 0;
              inserted = parent[expando]._onDragOver({
                clientX: touchEvt.clientX,
                clientY: touchEvt.clientY,
                target: target,
                rootEl: parent
              });
              if (inserted && !this.options.dragoverBubble) {
                break;
              }
            }
            target = parent; // store last element
          }
          /* jshint boss:true */ while (parent = getParentOrHost(parent));
        }
        _unhideGhostForTarget();
      }
    },
    _onTouchMove: function _onTouchMove(/**TouchEvent*/evt) {
      if (tapEvt) {
        var options = this.options,
          fallbackTolerance = options.fallbackTolerance,
          fallbackOffset = options.fallbackOffset,
          touch = evt.touches ? evt.touches[0] : evt,
          ghostMatrix = ghostEl && matrix(ghostEl, true),
          scaleX = ghostEl && ghostMatrix && ghostMatrix.a,
          scaleY = ghostEl && ghostMatrix && ghostMatrix.d,
          relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent),
          dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1),
          dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1);

        // only set the status to dragging, when we are actually dragging
        if (!Sortable.active && !awaitingDragStarted) {
          if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
            return;
          }
          this._onDragStart(evt, true);
        }
        if (ghostEl) {
          if (ghostMatrix) {
            ghostMatrix.e += dx - (lastDx || 0);
            ghostMatrix.f += dy - (lastDy || 0);
          } else {
            ghostMatrix = {
              a: 1,
              b: 0,
              c: 0,
              d: 1,
              e: dx,
              f: dy
            };
          }
          var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
          css(ghostEl, 'webkitTransform', cssMatrix);
          css(ghostEl, 'mozTransform', cssMatrix);
          css(ghostEl, 'msTransform', cssMatrix);
          css(ghostEl, 'transform', cssMatrix);
          lastDx = dx;
          lastDy = dy;
          touchEvt = touch;
        }
        evt.cancelable && evt.preventDefault();
      }
    },
    _appendGhost: function _appendGhost() {
      // Bug if using scale(): https://stackoverflow.com/questions/2637058
      // Not being adjusted for
      if (!ghostEl) {
        var container = this.options.fallbackOnBody ? document.body : rootEl,
          rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container),
          options = this.options;

        // Position absolutely
        if (PositionGhostAbsolutely) {
          // Get relatively positioned parent
          ghostRelativeParent = container;
          while (css(ghostRelativeParent, 'position') === 'static' && css(ghostRelativeParent, 'transform') === 'none' && ghostRelativeParent !== document) {
            ghostRelativeParent = ghostRelativeParent.parentNode;
          }
          if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
            if (ghostRelativeParent === document) ghostRelativeParent = getWindowScrollingElement();
            rect.top += ghostRelativeParent.scrollTop;
            rect.left += ghostRelativeParent.scrollLeft;
          } else {
            ghostRelativeParent = getWindowScrollingElement();
          }
          ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
        }
        ghostEl = dragEl.cloneNode(true);
        toggleClass(ghostEl, options.ghostClass, false);
        toggleClass(ghostEl, options.fallbackClass, true);
        toggleClass(ghostEl, options.dragClass, true);
        css(ghostEl, 'transition', '');
        css(ghostEl, 'transform', '');
        css(ghostEl, 'box-sizing', 'border-box');
        css(ghostEl, 'margin', 0);
        css(ghostEl, 'top', rect.top);
        css(ghostEl, 'left', rect.left);
        css(ghostEl, 'width', rect.width);
        css(ghostEl, 'height', rect.height);
        css(ghostEl, 'opacity', '0.8');
        css(ghostEl, 'position', PositionGhostAbsolutely ? 'absolute' : 'fixed');
        css(ghostEl, 'zIndex', '100000');
        css(ghostEl, 'pointerEvents', 'none');
        Sortable.ghost = ghostEl;
        container.appendChild(ghostEl);

        // Set transform-origin
        css(ghostEl, 'transform-origin', tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + '% ' + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + '%');
      }
    },
    _onDragStart: function _onDragStart(/**Event*/evt, /**boolean*/fallback) {
      var _this = this;
      var dataTransfer = evt.dataTransfer;
      var options = _this.options;
      pluginEvent('dragStart', this, {
        evt: evt
      });
      if (Sortable.eventCanceled) {
        this._onDrop();
        return;
      }
      pluginEvent('setupClone', this);
      if (!Sortable.eventCanceled) {
        cloneEl = clone(dragEl);
        cloneEl.removeAttribute("id");
        cloneEl.draggable = false;
        cloneEl.style['will-change'] = '';
        this._hideClone();
        toggleClass(cloneEl, this.options.chosenClass, false);
        Sortable.clone = cloneEl;
      }

      // #1143: IFrame support workaround
      _this.cloneId = _nextTick(function () {
        pluginEvent('clone', _this);
        if (Sortable.eventCanceled) return;
        if (!_this.options.removeCloneOnHide) {
          rootEl.insertBefore(cloneEl, dragEl);
        }
        _this._hideClone();
        _dispatchEvent({
          sortable: _this,
          name: 'clone'
        });
      });
      !fallback && toggleClass(dragEl, options.dragClass, true);

      // Set proper drop events
      if (fallback) {
        ignoreNextClick = true;
        _this._loopId = setInterval(_this._emulateDragOver, 50);
      } else {
        // Undo what was set in _prepareDragStart before drag started
        off(document, 'mouseup', _this._onDrop);
        off(document, 'touchend', _this._onDrop);
        off(document, 'touchcancel', _this._onDrop);
        if (dataTransfer) {
          dataTransfer.effectAllowed = 'move';
          options.setData && options.setData.call(_this, dataTransfer, dragEl);
        }
        on(document, 'drop', _this);

        // #1276 fix:
        css(dragEl, 'transform', 'translateZ(0)');
      }
      awaitingDragStarted = true;
      _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
      on(document, 'selectstart', _this);
      moved = true;
      window.getSelection().removeAllRanges();
      if (Safari) {
        css(document.body, 'user-select', 'none');
      }
    },
    // Returns true - if no further action is needed (either inserted or another condition)
    _onDragOver: function _onDragOver(/**Event*/evt) {
      var el = this.el,
        target = evt.target,
        dragRect,
        targetRect,
        revert,
        options = this.options,
        group = options.group,
        activeSortable = Sortable.active,
        isOwner = activeGroup === group,
        canSort = options.sort,
        fromSortable = putSortable || activeSortable,
        vertical,
        _this = this,
        completedFired = false;
      if (_silent) return;
      function dragOverEvent(name, extra) {
        pluginEvent(name, _this, _objectSpread2({
          evt: evt,
          isOwner: isOwner,
          axis: vertical ? 'vertical' : 'horizontal',
          revert: revert,
          dragRect: dragRect,
          targetRect: targetRect,
          canSort: canSort,
          fromSortable: fromSortable,
          target: target,
          completed: completed,
          onMove: function onMove(target, after) {
            return _onMove(rootEl, el, dragEl, dragRect, target, getRect(target), evt, after);
          },
          changed: changed
        }, extra));
      }

      // Capture animation state
      function capture() {
        dragOverEvent('dragOverAnimationCapture');
        _this.captureAnimationState();
        if (_this !== fromSortable) {
          fromSortable.captureAnimationState();
        }
      }

      // Return invocation when dragEl is inserted (or completed)
      function completed(insertion) {
        dragOverEvent('dragOverCompleted', {
          insertion: insertion
        });
        if (insertion) {
          // Clones must be hidden before folding animation to capture dragRectAbsolute properly
          if (isOwner) {
            activeSortable._hideClone();
          } else {
            activeSortable._showClone(_this);
          }
          if (_this !== fromSortable) {
            // Set ghost class to new sortable's ghost class
            toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
            toggleClass(dragEl, options.ghostClass, true);
          }
          if (putSortable !== _this && _this !== Sortable.active) {
            putSortable = _this;
          } else if (_this === Sortable.active && putSortable) {
            putSortable = null;
          }

          // Animation
          if (fromSortable === _this) {
            _this._ignoreWhileAnimating = target;
          }
          _this.animateAll(function () {
            dragOverEvent('dragOverAnimationComplete');
            _this._ignoreWhileAnimating = null;
          });
          if (_this !== fromSortable) {
            fromSortable.animateAll();
            fromSortable._ignoreWhileAnimating = null;
          }
        }

        // Null lastTarget if it is not inside a previously swapped element
        if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
          lastTarget = null;
        }

        // no bubbling and not fallback
        if (!options.dragoverBubble && !evt.rootEl && target !== document) {
          dragEl.parentNode[expando]._isOutsideThisEl(evt.target);

          // Do not detect for empty insert if already inserted
          !insertion && nearestEmptyInsertDetectEvent(evt);
        }
        !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
        return completedFired = true;
      }

      // Call when dragEl has been inserted
      function changed() {
        newIndex = index(dragEl);
        newDraggableIndex = index(dragEl, options.draggable);
        _dispatchEvent({
          sortable: _this,
          name: 'change',
          toEl: el,
          newIndex: newIndex,
          newDraggableIndex: newDraggableIndex,
          originalEvent: evt
        });
      }
      if (evt.preventDefault !== void 0) {
        evt.cancelable && evt.preventDefault();
      }
      target = closest(target, options.draggable, el, true);
      dragOverEvent('dragOver');
      if (Sortable.eventCanceled) return completedFired;
      if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
        return completed(false);
      }
      ignoreNextClick = false;
      if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = parentEl !== rootEl) // Reverting item into the original list
      : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
        vertical = this._getDirection(evt, target) === 'vertical';
        dragRect = getRect(dragEl);
        dragOverEvent('dragOverValid');
        if (Sortable.eventCanceled) return completedFired;
        if (revert) {
          parentEl = rootEl; // actualization
          capture();
          this._hideClone();
          dragOverEvent('revert');
          if (!Sortable.eventCanceled) {
            if (nextEl) {
              rootEl.insertBefore(dragEl, nextEl);
            } else {
              rootEl.appendChild(dragEl);
            }
          }
          return completed(true);
        }
        var elLastChild = lastChild(el, options.draggable);
        if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
          // Insert to end of list

          // If already at end of list: Do not insert
          if (elLastChild === dragEl) {
            return completed(false);
          }

          // if there is a last element, it is the target
          if (elLastChild && el === evt.target) {
            target = elLastChild;
          }
          if (target) {
            targetRect = getRect(target);
          }
          if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
            capture();
            if (elLastChild && elLastChild.nextSibling) {
              // the last draggable element is not the last node
              el.insertBefore(dragEl, elLastChild.nextSibling);
            } else {
              el.appendChild(dragEl);
            }
            parentEl = el; // actualization

            changed();
            return completed(true);
          }
        } else if (elLastChild && _ghostIsFirst(evt, vertical, this)) {
          // Insert to start of list
          var firstChild = getChild(el, 0, options, true);
          if (firstChild === dragEl) {
            return completed(false);
          }
          target = firstChild;
          targetRect = getRect(target);
          if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, false) !== false) {
            capture();
            el.insertBefore(dragEl, firstChild);
            parentEl = el; // actualization

            changed();
            return completed(true);
          }
        } else if (target.parentNode === el) {
          targetRect = getRect(target);
          var direction = 0,
            targetBeforeFirstSwap,
            differentLevel = dragEl.parentNode !== el,
            differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical),
            side1 = vertical ? 'top' : 'left',
            scrolledPastTop = isScrolledPast(target, 'top', 'top') || isScrolledPast(dragEl, 'top', 'top'),
            scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
          if (lastTarget !== target) {
            targetBeforeFirstSwap = targetRect[side1];
            pastFirstInvertThresh = false;
            isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
          }
          direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
          var sibling;
          if (direction !== 0) {
            // Check if target is beside dragEl in respective direction (ignoring hidden elements)
            var dragIndex = index(dragEl);
            do {
              dragIndex -= direction;
              sibling = parentEl.children[dragIndex];
            } while (sibling && (css(sibling, 'display') === 'none' || sibling === ghostEl));
          }
          // If dragEl is already beside target: Do not insert
          if (direction === 0 || sibling === target) {
            return completed(false);
          }
          lastTarget = target;
          lastDirection = direction;
          var nextSibling = target.nextElementSibling,
            after = false;
          after = direction === 1;
          var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);
          if (moveVector !== false) {
            if (moveVector === 1 || moveVector === -1) {
              after = moveVector === 1;
            }
            _silent = true;
            setTimeout(_unsilent, 30);
            capture();
            if (after && !nextSibling) {
              el.appendChild(dragEl);
            } else {
              target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
            }

            // Undo chrome's scroll adjustment (has no effect on other browsers)
            if (scrolledPastTop) {
              scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
            }
            parentEl = dragEl.parentNode; // actualization

            // must be done before animation
            if (targetBeforeFirstSwap !== undefined && !isCircumstantialInvert) {
              targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
            }
            changed();
            return completed(true);
          }
        }
        if (el.contains(dragEl)) {
          return completed(false);
        }
      }
      return false;
    },
    _ignoreWhileAnimating: null,
    _offMoveEvents: function _offMoveEvents() {
      off(document, 'mousemove', this._onTouchMove);
      off(document, 'touchmove', this._onTouchMove);
      off(document, 'pointermove', this._onTouchMove);
      off(document, 'dragover', nearestEmptyInsertDetectEvent);
      off(document, 'mousemove', nearestEmptyInsertDetectEvent);
      off(document, 'touchmove', nearestEmptyInsertDetectEvent);
    },
    _offUpEvents: function _offUpEvents() {
      var ownerDocument = this.el.ownerDocument;
      off(ownerDocument, 'mouseup', this._onDrop);
      off(ownerDocument, 'touchend', this._onDrop);
      off(ownerDocument, 'pointerup', this._onDrop);
      off(ownerDocument, 'pointercancel', this._onDrop);
      off(ownerDocument, 'touchcancel', this._onDrop);
      off(document, 'selectstart', this);
    },
    _onDrop: function _onDrop(/**Event*/evt) {
      var el = this.el,
        options = this.options;

      // Get the index of the dragged element within its parent
      newIndex = index(dragEl);
      newDraggableIndex = index(dragEl, options.draggable);
      pluginEvent('drop', this, {
        evt: evt
      });
      parentEl = dragEl && dragEl.parentNode;

      // Get again after plugin event
      newIndex = index(dragEl);
      newDraggableIndex = index(dragEl, options.draggable);
      if (Sortable.eventCanceled) {
        this._nulling();
        return;
      }
      awaitingDragStarted = false;
      isCircumstantialInvert = false;
      pastFirstInvertThresh = false;
      clearInterval(this._loopId);
      clearTimeout(this._dragStartTimer);
      _cancelNextTick(this.cloneId);
      _cancelNextTick(this._dragStartId);

      // Unbind events
      if (this.nativeDraggable) {
        off(document, 'drop', this);
        off(el, 'dragstart', this._onDragStart);
      }
      this._offMoveEvents();
      this._offUpEvents();
      if (Safari) {
        css(document.body, 'user-select', '');
      }
      css(dragEl, 'transform', '');
      if (evt) {
        if (moved) {
          evt.cancelable && evt.preventDefault();
          !options.dropBubble && evt.stopPropagation();
        }
        ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);
        if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
          // Remove clone(s)
          cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
        }
        if (dragEl) {
          if (this.nativeDraggable) {
            off(dragEl, 'dragend', this);
          }
          _disableDraggable(dragEl);
          dragEl.style['will-change'] = '';

          // Remove classes
          // ghostClass is added in dragStarted
          if (moved && !awaitingDragStarted) {
            toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
          }
          toggleClass(dragEl, this.options.chosenClass, false);

          // Drag stop event
          _dispatchEvent({
            sortable: this,
            name: 'unchoose',
            toEl: parentEl,
            newIndex: null,
            newDraggableIndex: null,
            originalEvent: evt
          });
          if (rootEl !== parentEl) {
            if (newIndex >= 0) {
              // Add event
              _dispatchEvent({
                rootEl: parentEl,
                name: 'add',
                toEl: parentEl,
                fromEl: rootEl,
                originalEvent: evt
              });

              // Remove event
              _dispatchEvent({
                sortable: this,
                name: 'remove',
                toEl: parentEl,
                originalEvent: evt
              });

              // drag from one list and drop into another
              _dispatchEvent({
                rootEl: parentEl,
                name: 'sort',
                toEl: parentEl,
                fromEl: rootEl,
                originalEvent: evt
              });
              _dispatchEvent({
                sortable: this,
                name: 'sort',
                toEl: parentEl,
                originalEvent: evt
              });
            }
            putSortable && putSortable.save();
          } else {
            if (newIndex !== oldIndex) {
              if (newIndex >= 0) {
                // drag & drop within the same list
                _dispatchEvent({
                  sortable: this,
                  name: 'update',
                  toEl: parentEl,
                  originalEvent: evt
                });
                _dispatchEvent({
                  sortable: this,
                  name: 'sort',
                  toEl: parentEl,
                  originalEvent: evt
                });
              }
            }
          }
          if (Sortable.active) {
            /* jshint eqnull:true */
            if (newIndex == null || newIndex === -1) {
              newIndex = oldIndex;
              newDraggableIndex = oldDraggableIndex;
            }
            _dispatchEvent({
              sortable: this,
              name: 'end',
              toEl: parentEl,
              originalEvent: evt
            });

            // Save sorting
            this.save();
          }
        }
      }
      this._nulling();
    },
    _nulling: function _nulling() {
      pluginEvent('nulling', this);
      rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
      savedInputChecked.forEach(function (el) {
        el.checked = true;
      });
      savedInputChecked.length = lastDx = lastDy = 0;
    },
    handleEvent: function handleEvent(/**Event*/evt) {
      switch (evt.type) {
        case 'drop':
        case 'dragend':
          this._onDrop(evt);
          break;
        case 'dragenter':
        case 'dragover':
          if (dragEl) {
            this._onDragOver(evt);
            _globalDragOver(evt);
          }
          break;
        case 'selectstart':
          evt.preventDefault();
          break;
      }
    },
    /**
     * Serializes the item into an array of string.
     * @returns {String[]}
     */
    toArray: function toArray() {
      var order = [],
        el,
        children = this.el.children,
        i = 0,
        n = children.length,
        options = this.options;
      for (; i < n; i++) {
        el = children[i];
        if (closest(el, options.draggable, this.el, false)) {
          order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
        }
      }
      return order;
    },
    /**
     * Sorts the elements according to the array.
     * @param  {String[]}  order  order of the items
     */
    sort: function sort(order, useAnimation) {
      var items = {},
        rootEl = this.el;
      this.toArray().forEach(function (id, i) {
        var el = rootEl.children[i];
        if (closest(el, this.options.draggable, rootEl, false)) {
          items[id] = el;
        }
      }, this);
      useAnimation && this.captureAnimationState();
      order.forEach(function (id) {
        if (items[id]) {
          rootEl.removeChild(items[id]);
          rootEl.appendChild(items[id]);
        }
      });
      useAnimation && this.animateAll();
    },
    /**
     * Save the current sorting
     */
    save: function save() {
      var store = this.options.store;
      store && store.set && store.set(this);
    },
    /**
     * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
     * @param   {HTMLElement}  el
     * @param   {String}       [selector]  default: `options.draggable`
     * @returns {HTMLElement|null}
     */
    closest: function closest$1(el, selector) {
      return closest(el, selector || this.options.draggable, this.el, false);
    },
    /**
     * Set/get option
     * @param   {string} name
     * @param   {*}      [value]
     * @returns {*}
     */
    option: function option(name, value) {
      var options = this.options;
      if (value === void 0) {
        return options[name];
      } else {
        var modifiedValue = PluginManager.modifyOption(this, name, value);
        if (typeof modifiedValue !== 'undefined') {
          options[name] = modifiedValue;
        } else {
          options[name] = value;
        }
        if (name === 'group') {
          _prepareGroup(options);
        }
      }
    },
    /**
     * Destroy
     */
    destroy: function destroy() {
      pluginEvent('destroy', this);
      var el = this.el;
      el[expando] = null;
      off(el, 'mousedown', this._onTapStart);
      off(el, 'touchstart', this._onTapStart);
      off(el, 'pointerdown', this._onTapStart);
      if (this.nativeDraggable) {
        off(el, 'dragover', this);
        off(el, 'dragenter', this);
      }
      // Remove draggable attributes
      Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
        el.removeAttribute('draggable');
      });
      this._onDrop();
      this._disableDelayedDragEvents();
      sortables.splice(sortables.indexOf(this.el), 1);
      this.el = el = null;
    },
    _hideClone: function _hideClone() {
      if (!cloneHidden) {
        pluginEvent('hideClone', this);
        if (Sortable.eventCanceled) return;
        css(cloneEl, 'display', 'none');
        if (this.options.removeCloneOnHide && cloneEl.parentNode) {
          cloneEl.parentNode.removeChild(cloneEl);
        }
        cloneHidden = true;
      }
    },
    _showClone: function _showClone(putSortable) {
      if (putSortable.lastPutMode !== 'clone') {
        this._hideClone();
        return;
      }
      if (cloneHidden) {
        pluginEvent('showClone', this);
        if (Sortable.eventCanceled) return;

        // show clone at dragEl or original position
        if (dragEl.parentNode == rootEl && !this.options.group.revertClone) {
          rootEl.insertBefore(cloneEl, dragEl);
        } else if (nextEl) {
          rootEl.insertBefore(cloneEl, nextEl);
        } else {
          rootEl.appendChild(cloneEl);
        }
        if (this.options.group.revertClone) {
          this.animate(dragEl, cloneEl);
        }
        css(cloneEl, 'display', '');
        cloneHidden = false;
      }
    }
  };
  function _globalDragOver(/**Event*/evt) {
    if (evt.dataTransfer) {
      evt.dataTransfer.dropEffect = 'move';
    }
    evt.cancelable && evt.preventDefault();
  }
  function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
    var evt,
      sortable = fromEl[expando],
      onMoveFn = sortable.options.onMove,
      retVal;
    // Support for new CustomEvent feature
    if (window.CustomEvent && !IE11OrLess && !Edge) {
      evt = new CustomEvent('move', {
        bubbles: true,
        cancelable: true
      });
    } else {
      evt = document.createEvent('Event');
      evt.initEvent('move', true, true);
    }
    evt.to = toEl;
    evt.from = fromEl;
    evt.dragged = dragEl;
    evt.draggedRect = dragRect;
    evt.related = targetEl || toEl;
    evt.relatedRect = targetRect || getRect(toEl);
    evt.willInsertAfter = willInsertAfter;
    evt.originalEvent = originalEvent;
    fromEl.dispatchEvent(evt);
    if (onMoveFn) {
      retVal = onMoveFn.call(sortable, evt, originalEvent);
    }
    return retVal;
  }
  function _disableDraggable(el) {
    el.draggable = false;
  }
  function _unsilent() {
    _silent = false;
  }
  function _ghostIsFirst(evt, vertical, sortable) {
    var firstElRect = getRect(getChild(sortable.el, 0, sortable.options, true));
    var childContainingRect = getChildContainingRectFromElement(sortable.el, sortable.options, ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX < childContainingRect.left - spacer || evt.clientY < firstElRect.top && evt.clientX < firstElRect.right : evt.clientY < childContainingRect.top - spacer || evt.clientY < firstElRect.bottom && evt.clientX < firstElRect.left;
  }
  function _ghostIsLast(evt, vertical, sortable) {
    var lastElRect = getRect(lastChild(sortable.el, sortable.options.draggable));
    var childContainingRect = getChildContainingRectFromElement(sortable.el, sortable.options, ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX > childContainingRect.right + spacer || evt.clientY > lastElRect.bottom && evt.clientX > lastElRect.left : evt.clientY > childContainingRect.bottom + spacer || evt.clientX > lastElRect.right && evt.clientY > lastElRect.top;
  }
  function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
    var mouseOnAxis = vertical ? evt.clientY : evt.clientX,
      targetLength = vertical ? targetRect.height : targetRect.width,
      targetS1 = vertical ? targetRect.top : targetRect.left,
      targetS2 = vertical ? targetRect.bottom : targetRect.right,
      invert = false;
    if (!invertSwap) {
      // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
      if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
        // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
        // check if past first invert threshold on side opposite of lastDirection
        if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
          // past first invert threshold, do not restrict inverted threshold to dragEl shadow
          pastFirstInvertThresh = true;
        }
        if (!pastFirstInvertThresh) {
          // dragEl shadow (target move distance shadow)
          if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance // over dragEl shadow
          : mouseOnAxis > targetS2 - targetMoveDistance) {
            return -lastDirection;
          }
        } else {
          invert = true;
        }
      } else {
        // Regular
        if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
          return _getInsertDirection(target);
        }
      }
    }
    invert = invert || invertSwap;
    if (invert) {
      // Invert of regular
      if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
        return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
      }
    }
    return 0;
  }

  /**
   * Gets the direction dragEl must be swapped relative to target in order to make it
   * seem that dragEl has been "inserted" into that element's position
   * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
   * @return {Number}                   Direction dragEl must be swapped
   */
  function _getInsertDirection(target) {
    if (index(dragEl) < index(target)) {
      return 1;
    } else {
      return -1;
    }
  }

  /**
   * Generate id
   * @param   {HTMLElement} el
   * @returns {String}
   * @private
   */
  function _generateId(el) {
    var str = el.tagName + el.className + el.src + el.href + el.textContent,
      i = str.length,
      sum = 0;
    while (i--) {
      sum += str.charCodeAt(i);
    }
    return sum.toString(36);
  }
  function _saveInputCheckedState(root) {
    savedInputChecked.length = 0;
    var inputs = root.getElementsByTagName('input');
    var idx = inputs.length;
    while (idx--) {
      var el = inputs[idx];
      el.checked && savedInputChecked.push(el);
    }
  }
  function _nextTick(fn) {
    return setTimeout(fn, 0);
  }
  function _cancelNextTick(id) {
    return clearTimeout(id);
  }

  // Fixed #973:
  if (documentExists) {
    on(document, 'touchmove', function (evt) {
      if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
        evt.preventDefault();
      }
    });
  }

  // Export utils
  Sortable.utils = {
    on: on,
    off: off,
    css: css,
    find: find,
    is: function is(el, selector) {
      return !!closest(el, selector, el, false);
    },
    extend: extend,
    throttle: throttle,
    closest: closest,
    toggleClass: toggleClass,
    clone: clone,
    index: index,
    nextTick: _nextTick,
    cancelNextTick: _cancelNextTick,
    detectDirection: _detectDirection,
    getChild: getChild,
    expando: expando
  };

  /**
   * Get the Sortable instance of an element
   * @param  {HTMLElement} element The element
   * @return {Sortable|undefined}         The instance of Sortable
   */
  Sortable.get = function (element) {
    return element[expando];
  };

  /**
   * Mount a plugin to Sortable
   * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
   */
  Sortable.mount = function () {
    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins[_key] = arguments[_key];
    }
    if (plugins[0].constructor === Array) plugins = plugins[0];
    plugins.forEach(function (plugin) {
      if (!plugin.prototype || !plugin.prototype.constructor) {
        throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
      }
      if (plugin.utils) Sortable.utils = _objectSpread2(_objectSpread2({}, Sortable.utils), plugin.utils);
      PluginManager.mount(plugin);
    });
  };

  /**
   * Create sortable instance
   * @param {HTMLElement}  el
   * @param {Object}      [options]
   */
  Sortable.create = function (el, options) {
    return new Sortable(el, options);
  };

  // Export
  Sortable.version = version;
  var autoScrolls = [],
    scrollEl,
    scrollRootEl,
    scrolling = false,
    lastAutoScrollX,
    lastAutoScrollY,
    touchEvt$1,
    pointerElemChangedInterval;
  function AutoScrollPlugin() {
    function AutoScroll() {
      this.defaults = {
        scroll: true,
        forceAutoScrollFallback: false,
        scrollSensitivity: 30,
        scrollSpeed: 10,
        bubbleScroll: true
      };

      // Bind all private methods
      for (var fn in this) {
        if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
          this[fn] = this[fn].bind(this);
        }
      }
    }
    AutoScroll.prototype = {
      dragStarted: function dragStarted(_ref) {
        var originalEvent = _ref.originalEvent;
        if (this.sortable.nativeDraggable) {
          on(document, 'dragover', this._handleAutoScroll);
        } else {
          if (this.options.supportPointer) {
            on(document, 'pointermove', this._handleFallbackAutoScroll);
          } else if (originalEvent.touches) {
            on(document, 'touchmove', this._handleFallbackAutoScroll);
          } else {
            on(document, 'mousemove', this._handleFallbackAutoScroll);
          }
        }
      },
      dragOverCompleted: function dragOverCompleted(_ref2) {
        var originalEvent = _ref2.originalEvent;
        // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
        if (!this.options.dragOverBubble && !originalEvent.rootEl) {
          this._handleAutoScroll(originalEvent);
        }
      },
      drop: function drop() {
        if (this.sortable.nativeDraggable) {
          off(document, 'dragover', this._handleAutoScroll);
        } else {
          off(document, 'pointermove', this._handleFallbackAutoScroll);
          off(document, 'touchmove', this._handleFallbackAutoScroll);
          off(document, 'mousemove', this._handleFallbackAutoScroll);
        }
        clearPointerElemChangedInterval();
        clearAutoScrolls();
        cancelThrottle();
      },
      nulling: function nulling() {
        touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
        autoScrolls.length = 0;
      },
      _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
        this._handleAutoScroll(evt, true);
      },
      _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
        var _this = this;
        var x = (evt.touches ? evt.touches[0] : evt).clientX,
          y = (evt.touches ? evt.touches[0] : evt).clientY,
          elem = document.elementFromPoint(x, y);
        touchEvt$1 = evt;

        // IE does not seem to have native autoscroll,
        // Edge's autoscroll seems too conditional,
        // MACOS Safari does not have autoscroll,
        // Firefox and Chrome are good
        if (fallback || this.options.forceAutoScrollFallback || Edge || IE11OrLess || Safari) {
          autoScroll(evt, this.options, elem, fallback);

          // Listener for pointer element change
          var ogElemScroller = getParentAutoScrollElement(elem, true);
          if (scrolling && (!pointerElemChangedInterval || x !== lastAutoScrollX || y !== lastAutoScrollY)) {
            pointerElemChangedInterval && clearPointerElemChangedInterval();
            // Detect for pointer elem change, emulating native DnD behaviour
            pointerElemChangedInterval = setInterval(function () {
              var newElem = getParentAutoScrollElement(document.elementFromPoint(x, y), true);
              if (newElem !== ogElemScroller) {
                ogElemScroller = newElem;
                clearAutoScrolls();
              }
              autoScroll(evt, _this.options, newElem, fallback);
            }, 10);
            lastAutoScrollX = x;
            lastAutoScrollY = y;
          }
        } else {
          // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
          if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
            clearAutoScrolls();
            return;
          }
          autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
        }
      }
    };
    return _extends(AutoScroll, {
      pluginName: 'scroll',
      initializeByDefault: true
    });
  }
  function clearAutoScrolls() {
    autoScrolls.forEach(function (autoScroll) {
      clearInterval(autoScroll.pid);
    });
    autoScrolls = [];
  }
  function clearPointerElemChangedInterval() {
    clearInterval(pointerElemChangedInterval);
  }
  var autoScroll = throttle(function (evt, options, rootEl, isFallback) {
    // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
    if (!options.scroll) return;
    var x = (evt.touches ? evt.touches[0] : evt).clientX,
      y = (evt.touches ? evt.touches[0] : evt).clientY,
      sens = options.scrollSensitivity,
      speed = options.scrollSpeed,
      winScroller = getWindowScrollingElement();
    var scrollThisInstance = false,
      scrollCustomFn;

    // New scroll root, set scrollEl
    if (scrollRootEl !== rootEl) {
      scrollRootEl = rootEl;
      clearAutoScrolls();
      scrollEl = options.scroll;
      scrollCustomFn = options.scrollFn;
      if (scrollEl === true) {
        scrollEl = getParentAutoScrollElement(rootEl, true);
      }
    }
    var layersOut = 0;
    var currentParent = scrollEl;
    do {
      var el = currentParent,
        rect = getRect(el),
        top = rect.top,
        bottom = rect.bottom,
        left = rect.left,
        right = rect.right,
        width = rect.width,
        height = rect.height,
        canScrollX = void 0,
        canScrollY = void 0,
        scrollWidth = el.scrollWidth,
        scrollHeight = el.scrollHeight,
        elCSS = css(el),
        scrollPosX = el.scrollLeft,
        scrollPosY = el.scrollTop;
      if (el === winScroller) {
        canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll' || elCSS.overflowX === 'visible');
        canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll' || elCSS.overflowY === 'visible');
      } else {
        canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll');
        canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll');
      }
      var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
      var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);
      if (!autoScrolls[layersOut]) {
        for (var i = 0; i <= layersOut; i++) {
          if (!autoScrolls[i]) {
            autoScrolls[i] = {};
          }
        }
      }
      if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
        autoScrolls[layersOut].el = el;
        autoScrolls[layersOut].vx = vx;
        autoScrolls[layersOut].vy = vy;
        clearInterval(autoScrolls[layersOut].pid);
        if (vx != 0 || vy != 0) {
          scrollThisInstance = true;
          /* jshint loopfunc:true */
          autoScrolls[layersOut].pid = setInterval(function () {
            // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
            if (isFallback && this.layer === 0) {
              Sortable.active._onTouchMove(touchEvt$1); // To move ghost if it is positioned absolutely
            }
            var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
            var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;
            if (typeof scrollCustomFn === 'function') {
              if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== 'continue') {
                return;
              }
            }
            scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
          }.bind({
            layer: layersOut
          }), 24);
        }
      }
      layersOut++;
    } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));
    scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
  }, 30);
  var drop = function drop(_ref) {
    var originalEvent = _ref.originalEvent,
      putSortable = _ref.putSortable,
      dragEl = _ref.dragEl,
      activeSortable = _ref.activeSortable,
      dispatchSortableEvent = _ref.dispatchSortableEvent,
      hideGhostForTarget = _ref.hideGhostForTarget,
      unhideGhostForTarget = _ref.unhideGhostForTarget;
    if (!originalEvent) return;
    var toSortable = putSortable || activeSortable;
    hideGhostForTarget();
    var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
    var target = document.elementFromPoint(touch.clientX, touch.clientY);
    unhideGhostForTarget();
    if (toSortable && !toSortable.el.contains(target)) {
      dispatchSortableEvent('spill');
      this.onSpill({
        dragEl: dragEl,
        putSortable: putSortable
      });
    }
  };
  function Revert() {}
  Revert.prototype = {
    startIndex: null,
    dragStart: function dragStart(_ref2) {
      var oldDraggableIndex = _ref2.oldDraggableIndex;
      this.startIndex = oldDraggableIndex;
    },
    onSpill: function onSpill(_ref3) {
      var dragEl = _ref3.dragEl,
        putSortable = _ref3.putSortable;
      this.sortable.captureAnimationState();
      if (putSortable) {
        putSortable.captureAnimationState();
      }
      var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);
      if (nextSibling) {
        this.sortable.el.insertBefore(dragEl, nextSibling);
      } else {
        this.sortable.el.appendChild(dragEl);
      }
      this.sortable.animateAll();
      if (putSortable) {
        putSortable.animateAll();
      }
    },
    drop: drop
  };
  _extends(Revert, {
    pluginName: 'revertOnSpill'
  });
  function Remove() {}
  Remove.prototype = {
    onSpill: function onSpill(_ref4) {
      var dragEl = _ref4.dragEl,
        putSortable = _ref4.putSortable;
      var parentSortable = putSortable || this.sortable;
      parentSortable.captureAnimationState();
      dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
      parentSortable.animateAll();
    },
    drop: drop
  };
  _extends(Remove, {
    pluginName: 'removeOnSpill'
  });
  Sortable.mount(new AutoScrollPlugin());
  Sortable.mount(Remove, Revert);

  function swapDragArrayElement(data, currentIndex, targetIndex) {
    var newData = _toConsumableArray(data);
    if (targetIndex - currentIndex > 0) {
      newData.splice(targetIndex + 1, 0, newData[currentIndex]);
      newData.splice(currentIndex, 1);
    } else {
      newData.splice(targetIndex, 0, newData[currentIndex]);
      newData.splice(currentIndex + 1, 1);
    }
    return newData;
  }

  function ownKeys$t(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$t(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$t(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$t(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function useDragSort(props, context, extraParams) {
    var _toRefs = VueCompositionAPI.toRefs(props),
      sortOnRowDraggable = _toRefs.sortOnRowDraggable,
      dragSort = _toRefs.dragSort,
      data = _toRefs.data;
    var _useClassName = useClassName(),
      tableDraggableClasses = _useClassName.tableDraggableClasses,
      tableBaseClass = _useClassName.tableBaseClass,
      tableFullRowClasses = _useClassName.tableFullRowClasses;
    var columns = VueCompositionAPI.ref(props.columns || []);
    var primaryTableRef = VueCompositionAPI.ref(null);
    var dragCol = VueCompositionAPI.computed(function () {
      var _columns$value;
      return (_columns$value = columns.value) === null || _columns$value === void 0 ? void 0 : _columns$value.find(function (item) {
        return item.colKey === "drag";
      });
    });
    var isRowDraggable = VueCompositionAPI.computed(function () {
      return sortOnRowDraggable.value || dragSort.value === "row";
    });
    var isRowHandlerDraggable = VueCompositionAPI.computed(function () {
      return ["drag-col", "row-handler", "row-handler-col"].includes(dragSort.value) && !!dragCol.value;
    });
    var isColDraggable = VueCompositionAPI.computed(function () {
      return ["col", "row-handler-col"].includes(dragSort.value);
    });
    var lastRowList = VueCompositionAPI.ref([]);
    var lastColList = VueCompositionAPI.ref([]);
    if (dragSort.value === "drag-col") {
      log.error("Table", "dragSort='drag-col' is going to be deprecated, please use dragSort='col' instead.");
    }
    if (props.sortOnRowDraggable) {
      log.error("Table", "`sortOnRowDraggable` is going to be deprecated, please use dragSort='row' instead.");
    }
    VueCompositionAPI.watch(data, function (data2) {
      lastRowList.value = data2 === null || data2 === void 0 ? void 0 : data2.map(function (item) {
        return get(item, props.rowKey);
      });
    }, {
      immediate: true
    });
    VueCompositionAPI.watch(columns, function (columns2) {
      lastColList.value = columns2 ? columns2.map(function (t) {
        return t.colKey;
      }) : [];
    }, {
      immediate: true
    });
    function getDataPageIndex(index, pagination) {
      var _pagination$current, _pagination$pageSize;
      var current = (_pagination$current = pagination.current) !== null && _pagination$current !== void 0 ? _pagination$current : pagination.defaultCurrent;
      var pageSize = (_pagination$pageSize = pagination.pageSize) !== null && _pagination$pageSize !== void 0 ? _pagination$pageSize : pagination.defaultPageSize;
      if (!props.disableDataPage && pagination && data.value.length > pageSize) {
        return pageSize * (current - 1) + index;
      }
      return index;
    }
    var registerRowDragEvent = function registerRowDragEvent(element) {
      if (!isRowHandlerDraggable.value && !isRowDraggable.value) return;
      var dragContainer = element === null || element === void 0 ? void 0 : element.querySelector("tbody");
      if (!dragContainer) {
        return null;
      }
      var dragInstanceTmp = null;
      var baseOptions = _objectSpread$t({
        animation: 150,
        ghostClass: tableDraggableClasses.ghost,
        chosenClass: tableDraggableClasses.chosen,
        dragClass: tableDraggableClasses.dragging,
        filter: ".".concat(tableFullRowClasses.base),
        onMove: function onMove(evt) {
          return !hasClass(evt.related, tableFullRowClasses.base);
        },
        onEnd: function onEnd(evt) {
          var _dragInstanceTmp, _props$onDragSort;
          if (evt.newIndex === evt.oldIndex) return;
          (_dragInstanceTmp = dragInstanceTmp) === null || _dragInstanceTmp === void 0 || _dragInstanceTmp.sort(lastRowList.value);
          var currentIndex = evt.oldIndex,
            targetIndex = evt.newIndex;
          if (isFunction(props.firstFullRow) && props.firstFullRow(VueCompositionAPI.h) || context.slots.firstFullRow) {
            currentIndex -= 1;
            targetIndex -= 1;
          }
          if (extraParams.value.pagination) {
            currentIndex = getDataPageIndex(currentIndex, extraParams.value.pagination);
            targetIndex = getDataPageIndex(targetIndex, extraParams.value.pagination);
          }
          var params = {
            data: data.value,
            currentIndex: currentIndex,
            current: data.value[currentIndex],
            targetIndex: targetIndex,
            target: data.value[targetIndex],
            newData: swapDragArrayElement(_toConsumableArray(props.data), currentIndex, targetIndex),
            e: evt,
            sort: "row"
          };
          params.currentData = params.newData;
          (_props$onDragSort = props.onDragSort) === null || _props$onDragSort === void 0 || _props$onDragSort.call(props, params);
          context.emit("drag-sort", params);
        }
      }, props.dragSortOptions);
      if (!dragContainer) return;
      if (isRowDraggable.value) {
        dragInstanceTmp = new Sortable(dragContainer, _objectSpread$t({}, baseOptions));
      } else {
        dragInstanceTmp = new Sortable(dragContainer, _objectSpread$t(_objectSpread$t({}, baseOptions), {}, {
          handle: ".".concat(tableDraggableClasses.handle)
        }));
      }
      lastRowList.value = dragInstanceTmp.toArray();
    };
    var registerOneLevelColDragEvent = function registerOneLevelColDragEvent(container, recover) {
      var dragInstanceTmp = null;
      var options = _objectSpread$t({
        animation: 150,
        dataIdAttr: "data-colkey",
        direction: "vertical",
        ghostClass: tableDraggableClasses.ghost,
        chosenClass: tableDraggableClasses.chosen,
        dragClass: tableDraggableClasses.dragging,
        handle: ".".concat(tableBaseClass.thCellInner),
        onEnd: function onEnd(evt) {
          var _props$onDragSort2;
          if (evt.newIndex === evt.oldIndex) return;
          if (recover) {
            var _dragInstanceTmp2;
            (_dragInstanceTmp2 = dragInstanceTmp) === null || _dragInstanceTmp2 === void 0 || _dragInstanceTmp2.sort(_toConsumableArray(lastColList.value));
          }
          var oldIndex = evt.oldIndex,
            newIndex = evt.newIndex,
            targetElement = evt.target;
          var currentIndex = recover ? oldIndex : newIndex;
          var targetIndex = recover ? newIndex : oldIndex;
          var oldElement = targetElement.children[currentIndex];
          var newElement = targetElement.children[targetIndex];
          var current = getColumnDataByKey(columns.value, oldElement.dataset.colkey);
          var target = getColumnDataByKey(columns.value, newElement.dataset.colkey);
          if (!current || !current.colKey) {
            log.error("Table", "colKey is missing in ".concat(JSON.stringify(current)));
          }
          if (!target || !target.colKey) {
            log.error("Table", "colKey is missing in ".concat(JSON.stringify(target)));
          }
          currentIndex = getColumnIndexByKey(props.columns, current.colKey);
          targetIndex = getColumnIndexByKey(props.columns, target.colKey);
          var params = {
            data: columns.value,
            currentIndex: currentIndex,
            current: current,
            targetIndex: targetIndex,
            target: target,
            newData: swapDragArrayElement(_toConsumableArray(props.columns), currentIndex, targetIndex),
            e: evt,
            sort: "col"
          };
          params.currentData = params.newData;
          (_props$onDragSort2 = props.onDragSort) === null || _props$onDragSort2 === void 0 || _props$onDragSort2.call(props, params);
          context.emit("drag-sort", params);
        }
      }, props.dragSortOptions);
      if (!container) return;
      dragInstanceTmp = new Sortable(container, options);
      return dragInstanceTmp;
    };
    var registerColDragEvent = function registerColDragEvent(tableElement) {
      if (!isColDraggable.value || !tableElement) return;
      var trList = tableElement.querySelectorAll("thead > tr");
      if (trList.length <= 1) {
        var _trList = _slicedToArray(trList, 1),
          container = _trList[0];
        var dragInstanceTmp = registerOneLevelColDragEvent(container, true);
        lastColList.value = dragInstanceTmp === null || dragInstanceTmp === void 0 ? void 0 : dragInstanceTmp.toArray();
      } else {
        trList.forEach(function (container) {
          registerOneLevelColDragEvent(container, false);
        });
      }
    };
    function setDragSortPrimaryTableRef(primaryTableElement) {
      primaryTableRef.value = primaryTableElement;
    }
    function setDragSortColumns(val) {
      columns.value = val;
    }
    VueCompositionAPI.watch([primaryTableRef, columns, dragSort, extraParams], function (_ref) {
      var _ref2 = _slicedToArray(_ref, 4),
        val = _ref2[0];
        _ref2[1];
        _ref2[2];
        var extraParams2 = _ref2[3];
      var primaryTableCmp = val;
      if (!val || !primaryTableCmp.$el || !extraParams2.showElement) return;
      var timer = setTimeout(function () {
        registerRowDragEvent(primaryTableCmp.$el);
        registerColDragEvent(primaryTableCmp.$el);
        var timer1 = setTimeout(function () {
          if (primaryTableCmp.$refs.affixHeaderRef) {
            registerColDragEvent(primaryTableCmp.$refs.affixHeaderRef);
            clearTimeout(timer1);
          }
        });
        clearTimeout(timer);
      }, 60);
    });
    return {
      isRowDraggable: isRowDraggable,
      isRowHandlerDraggable: isRowHandlerDraggable,
      isColDraggable: isColDraggable,
      setDragSortPrimaryTableRef: setDragSortPrimaryTableRef,
      setDragSortColumns: setDragSortColumns
    };
  }

  function useAsyncLoading(props, context) {
    var renderTNode = useTNodeJSX();
    var _useConfig = useConfig("table", props.locale),
      global = _useConfig.global;
    var _useClassName = useClassName(),
      isLoadingClass = _useClassName.isLoadingClass,
      isLoadMoreClass = _useClassName.isLoadMoreClass,
      asyncLoadingClass = _useClassName.asyncLoadingClass;
    var classes = VueCompositionAPI.computed(function () {
      return [asyncLoadingClass, _defineProperty$2(_defineProperty$2({}, isLoadingClass, props.asyncLoading === "loading"), isLoadMoreClass, props.asyncLoading === "load-more")];
    });
    function onLoadClick() {
      var _props$onAsyncLoading;
      if (typeof props.asyncLoading !== "string") return;
      (_props$onAsyncLoading = props.onAsyncLoadingClick) === null || _props$onAsyncLoading === void 0 || _props$onAsyncLoading.call(props, {
        status: props.asyncLoading
      });
      context.emit("async-loading-click", {
        status: props.asyncLoading
      });
    }
    function renderAsyncLoading(h) {
      var asyncLoadingNode = renderTNode("asyncLoading");
      if (isString(asyncLoadingNode)) {
        var asyncLoading = props.asyncLoading;
        var loadingText = {
          "load-more": global.value.loadingMoreText,
          loading: global.value.loadingText
        }[String(asyncLoading)];
        return h("div", {
          "class": classes.value,
          "on": {
            "click": onLoadClick
          }
        }, [h(Loading, {
          "attrs": {
            "indicator": asyncLoading === "loading",
            "loading": !!asyncLoading,
            "size": "small",
            "text": loadingText
          }
        })]);
      }
      if (![null, false, void 0].includes(asyncLoadingNode)) {
        return h("div", {
          "class": classes.value,
          "on": {
            "click": onLoadClick
          }
        }, [asyncLoadingNode]);
      }
      return null;
    }
    return {
      renderAsyncLoading: renderAsyncLoading
    };
  }

  function _toArray(r) {
    return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray$1(r) || _nonIterableRest();
  }

  function ownKeys$s(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$s(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$s(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$s(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var EditableCell = VueCompositionAPI.defineComponent({
    name: "TableEditableCell",
    props: {
      rowKey: String,
      row: Object,
      rowIndex: Number,
      col: Object,
      colIndex: Number,
      oldCell: [Function, String],
      tableBaseClass: Object,
      cellEmptyContent: [Function, String],
      editable: {
        type: Boolean,
        "default": void 0
      },
      readonly: {
        type: Boolean
      },
      errors: {
        type: Array,
        "default": void 0
      },
      onChange: Function,
      onValidate: Function,
      onRuleChange: Function,
      onEditableChange: Function
    },
    emits: ["update-edited-cell"],
    setup: function setup(props, context) {
      var _col$value$edit2;
      var _toRefs = VueCompositionAPI.toRefs(props),
        row = _toRefs.row,
        col = _toRefs.col;
      var tableEditableCellRef = VueCompositionAPI.ref(null);
      var isKeepEditMode = VueCompositionAPI.computed(function () {
        var _col$value$edit;
        return (_col$value$edit = col.value.edit) === null || _col$value$edit === void 0 ? void 0 : _col$value$edit.keepEditMode;
      });
      var isEdit = VueCompositionAPI.ref(isKeepEditMode.value || ((_col$value$edit2 = col.value.edit) === null || _col$value$edit2 === void 0 ? void 0 : _col$value$edit2.defaultEditable) || false);
      var editValue = VueCompositionAPI.ref();
      var errorList = VueCompositionAPI.ref();
      var classPrefix = usePrefixClass$1();
      var _useGlobalIcon = useGlobalIcon({
          Edit1Icon: TdEdit1Icon
        }),
        Edit1Icon = _useGlobalIcon.Edit1Icon;
      var updateEditedCellValue = function updateEditedCellValue(obj) {
        if (_typeof$2(obj) === "object" && ("rowValue" in obj || obj.isUpdateCurrentRow)) {
          var newObj = _objectSpread$s({}, obj);
          var rowValue = newObj.isUpdateCurrentRow ? get(row.value, props.rowKey) : newObj.rowValue;
          delete newObj.rowValue;
          delete newObj.isUpdateCurrentRow;
          context.emit("update-edited-cell", rowValue, row.value, newObj);
        } else {
          editValue.value = obj;
        }
      };
      VueCompositionAPI.watch([isKeepEditMode], function (val) {
        if (val) {
          isEdit.value = true;
        }
      });
      var editOnListeners = VueCompositionAPI.computed(function () {
        var _col$value$edit3, _col$value$edit3$on;
        var listeners2 = ((_col$value$edit3 = col.value.edit) === null || _col$value$edit3 === void 0 || (_col$value$edit3$on = _col$value$edit3.on) === null || _col$value$edit3$on === void 0 ? void 0 : _col$value$edit3$on.call(_col$value$edit3, _objectSpread$s(_objectSpread$s({}, cellParams.value), {}, {
          editedRow: currentRow.value,
          updateEditedCellValue: updateEditedCellValue
        }))) || {};
        Object.keys(listeners2).forEach(function (eventName) {
          if (eventName.slice(0, 2) === "on") {
            listeners2[eventName.slice(2).toLocaleLowerCase()] = listeners2[eventName];
            delete listeners2[eventName];
          }
        });
        return listeners2;
      });
      var currentRow = VueCompositionAPI.computed(function () {
        var colKey = col.value.colKey;
        var _ref = colKey.split(".") || [],
          _ref2 = _toArray(_ref),
          firstKey = _ref2[0],
          restKeys = _ref2.slice(1);
        var newRow = _objectSpread$s({}, row.value);
        if (restKeys.length) {
          newRow[firstKey] = cloneDeep(row.value[firstKey]);
          set(newRow[firstKey], restKeys.join("."), editValue.value);
        } else {
          set(newRow, colKey, editValue.value);
        }
        return newRow;
      });
      var cellParams = VueCompositionAPI.computed(function () {
        return {
          rowIndex: props.rowIndex,
          colIndex: props.colIndex,
          col: props.col,
          row: props.row
        };
      });
      var cellNode = VueCompositionAPI.computed(function () {
        var node = renderCell({
          row: currentRow.value,
          col: _objectSpread$s(_objectSpread$s({}, col.value), {}, {
            cell: props.oldCell
          }),
          rowIndex: props.rowIndex,
          colIndex: props.colIndex
        }, context.slots, {
          cellEmptyContent: props.cellEmptyContent
        });
        return node;
      });
      var componentProps = VueCompositionAPI.computed(function () {
        var _edit$abortEditOnEven;
        var edit = col.value.edit;
        if (!edit) return {};
        var editProps = isFunction(edit.props) ? edit.props(_objectSpread$s(_objectSpread$s({}, cellParams.value), {}, {
          editedRow: currentRow.value,
          updateEditedCellValue: updateEditedCellValue
        })) : _objectSpread$s({}, edit.props);
        delete editProps.onChange;
        delete editProps.value;
        (_edit$abortEditOnEven = edit.abortEditOnEvent) === null || _edit$abortEditOnEven === void 0 || _edit$abortEditOnEven.forEach(function (item) {
          delete editProps[item];
        });
        return editProps;
      });
      var isAbortEditOnChange = VueCompositionAPI.computed(function () {
        var _edit$abortEditOnEven2;
        var edit = col.value.edit;
        if (!edit) return false;
        return Boolean((_edit$abortEditOnEven2 = edit.abortEditOnEvent) === null || _edit$abortEditOnEven2 === void 0 ? void 0 : _edit$abortEditOnEven2.includes("onChange"));
      });
      var validateEdit = function validateEdit(trigger) {
        return new Promise(function (resolve) {
          var params = {
            result: [_objectSpread$s(_objectSpread$s({}, cellParams.value), {}, {
              errorList: [],
              value: editValue.value
            })],
            trigger: trigger
          };
          var rules = isFunction(col.value.edit.rules) ? col.value.edit.rules(cellParams.value) : col.value.edit.rules;
          if (!col.value.edit || !rules || !rules.length) {
            var _props$onValidate;
            (_props$onValidate = props.onValidate) === null || _props$onValidate === void 0 || _props$onValidate.call(props, params);
            resolve(true);
            return;
          }
          validate(editValue.value, rules).then(function (result) {
            var _props$onValidate2;
            var list = result === null || result === void 0 ? void 0 : result.filter(function (t) {
              return !t.result;
            });
            params.result[0].errorList = list;
            (_props$onValidate2 = props.onValidate) === null || _props$onValidate2 === void 0 || _props$onValidate2.call(props, params);
            if (!list || !list.length) {
              errorList.value = [];
              resolve(true);
            } else {
              errorList.value = list;
              resolve(list);
            }
          });
        });
      };
      var isSame = function isSame(a, b) {
        if (_typeof$2(a) === "object" && _typeof$2(b) === "object") {
          return JSON.stringify(a) === JSON.stringify(b);
        }
        return a === b;
      };
      var updateAndSaveAbort = function updateAndSaveAbort(outsideAbortEvent, eventName) {
        for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          args[_key - 2] = arguments[_key];
        }
        validateEdit("self").then(function (result) {
          var _editOnListeners$valu, _editOnListeners$valu2;
          if (result !== true) return;
          var oldValue = get(row.value, col.value.colKey);
          if (!isSame(editValue.value, oldValue)) {
            editValue.value = oldValue;
            outsideAbortEvent === null || outsideAbortEvent === void 0 || outsideAbortEvent.apply(void 0, args);
          }
          (_editOnListeners$valu = (_editOnListeners$valu2 = editOnListeners.value)[eventName]) === null || _editOnListeners$valu === void 0 || _editOnListeners$valu.call(_editOnListeners$valu2, args[2]);
          var timer = setTimeout(function () {
            var _props$onEditableChan;
            if (!isKeepEditMode.value) {
              isEdit.value = false;
            }
            errorList.value = [];
            (_props$onEditableChan = props.onEditableChange) === null || _props$onEditableChan === void 0 || _props$onEditableChan.call(props, _objectSpread$s(_objectSpread$s({}, cellParams.value), {}, {
              value: editValue.value,
              editedRow: _objectSpread$s(_objectSpread$s({}, props.row), {}, _defineProperty$2({}, props.col.colKey, editValue.value)),
              validateEdit: validateEdit,
              isEdit: false
            }));
            clearTimeout(timer);
          }, 0);
        });
      };
      var listeners = VueCompositionAPI.computed(function () {
        var _edit$abortEditOnEven3;
        var edit = col.value.edit;
        var isCellEditable = props.editable === void 0;
        if (!isEdit.value || !isCellEditable) return;
        if (!(edit !== null && edit !== void 0 && (_edit$abortEditOnEven3 = edit.abortEditOnEvent) !== null && _edit$abortEditOnEven3 !== void 0 && _edit$abortEditOnEven3.length)) return {};
        var tListeners = {};
        var outsideAbortEvent = edit === null || edit === void 0 ? void 0 : edit.onEdited;
        edit.abortEditOnEvent.forEach(function (itemEvent) {
          if (itemEvent === "onChange") return;
          var eventName = itemEvent.slice(2, 3).toLocaleLowerCase() + itemEvent.slice(3);
          tListeners[eventName] = function () {
            for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }
            updateAndSaveAbort.apply(void 0, [outsideAbortEvent, eventName, _objectSpread$s(_objectSpread$s({}, cellParams.value), {}, {
              trigger: itemEvent,
              newRowData: currentRow.value
            })].concat(args));
          };
        });
        return tListeners;
      });
      var onEditChange = function onEditChange(val) {
        var _props$onChange, _props$onRuleChange, _col$value$edit5;
        editValue.value = val;
        var params = _objectSpread$s(_objectSpread$s({}, cellParams.value), {}, {
          value: val,
          editedRow: _objectSpread$s(_objectSpread$s({}, props.row), {}, _defineProperty$2({}, props.col.colKey, val))
        });
        (_props$onChange = props.onChange) === null || _props$onChange === void 0 || _props$onChange.call(props, params);
        (_props$onRuleChange = props.onRuleChange) === null || _props$onRuleChange === void 0 || _props$onRuleChange.call(props, params);
        var isCellEditable = props.editable === void 0;
        if (isCellEditable && isAbortEditOnChange.value) {
          var _col$value$edit4;
          var outsideAbortEvent = (_col$value$edit4 = col.value.edit) === null || _col$value$edit4 === void 0 ? void 0 : _col$value$edit4.onEdited;
          for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
            args[_key3 - 1] = arguments[_key3];
          }
          updateAndSaveAbort.apply(void 0, [outsideAbortEvent, "change", _objectSpread$s(_objectSpread$s({}, cellParams.value), {}, {
            trigger: "onChange",
            newRowData: currentRow.value
          })].concat(args));
        }
        if (((_col$value$edit5 = col.value.edit) === null || _col$value$edit5 === void 0 ? void 0 : _col$value$edit5.validateTrigger) === "change") {
          validateEdit("self");
        }
      };
      var documentClickHandler = function documentClickHandler(e) {
        var _e$composedPath;
        if (!col.value.edit || !col.value.edit.component) return;
        if (!isEdit.value) return;
        var path = ((_e$composedPath = e.composedPath) === null || _e$composedPath === void 0 ? void 0 : _e$composedPath.call(e)) || e.path || [];
        var node = path.find(function (node2) {
          var _node2$classList;
          return (_node2$classList = node2.classList) === null || _node2$classList === void 0 ? void 0 : _node2$classList.contains("".concat(classPrefix.value, "-popup__content"));
        });
        if (node) return;
        var outsideAbortEvent = col.value.edit.onEdited;
        updateAndSaveAbort(outsideAbortEvent, "", _objectSpread$s(_objectSpread$s({}, cellParams.value), {}, {
          trigger: "document",
          newRowData: currentRow.value
        }));
      };
      var cellValue = VueCompositionAPI.computed(function () {
        return get(row.value, col.value.colKey);
      });
      var enterEdit = function enterEdit() {
        var _props$onEditableChan2;
        (_props$onEditableChan2 = props.onEditableChange) === null || _props$onEditableChan2 === void 0 || _props$onEditableChan2.call(props, _objectSpread$s(_objectSpread$s({}, cellParams.value), {}, {
          value: editValue.value,
          editedRow: props.row,
          isEdit: true,
          validateEdit: validateEdit
        }));
      };
      var onCellClick = function onCellClick(e) {
        isEdit.value = true;
        enterEdit();
        e.stopPropagation();
      };
      VueCompositionAPI.onMounted(function () {
        var _props$col$edit;
        if ((_props$col$edit = props.col.edit) !== null && _props$col$edit !== void 0 && _props$col$edit.defaultEditable) {
          enterEdit();
        }
      });
      VueCompositionAPI.watch(cellValue, function (cellValue2) {
        editValue.value = cellValue2;
      }, {
        immediate: true
      });
      VueCompositionAPI.watch(isEdit, function (isEdit2) {
        var isCellEditable = props.editable === void 0;
        if (!col.value.edit || !col.value.edit.component || !isCellEditable) return;
        if (isEdit2) {
          on$1(document, "click", documentClickHandler);
        } else {
          off$1(document, "click", documentClickHandler);
        }
      }, {
        immediate: true
      });
      VueCompositionAPI.watch(function () {
        return [props.editable, props.row, props.col, props.rowIndex, props.colIndex];
      }, function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 1),
          editable = _ref4[0];
        if (editable === false) {
          editValue.value = cellValue.value;
        } else {
          var _props$onRuleChange2;
          (_props$onRuleChange2 = props.onRuleChange) === null || _props$onRuleChange2 === void 0 || _props$onRuleChange2.call(props, _objectSpread$s(_objectSpread$s({}, cellParams.value), {}, {
            value: cellValue.value,
            editedRow: row.value
          }));
        }
      }, {
        immediate: true
      });
      VueCompositionAPI.watch(function () {
        return props.errors;
      }, function (errors) {
        errorList.value = errors;
      });
      return {
        editValue: editValue,
        isEdit: isEdit,
        cellNode: cellNode,
        isAbortEditOnChange: isAbortEditOnChange,
        listeners: listeners,
        componentProps: componentProps,
        tableEditableCellRef: tableEditableCellRef,
        errorList: errorList,
        currentRow: currentRow,
        editOnListeners: editOnListeners,
        onEditChange: onEditChange,
        Edit1Icon: Edit1Icon,
        validateEdit: validateEdit,
        onCellClick: onCellClick,
        cellParams: cellParams
      };
    },
    render: function render() {
      var _this$col$edit2, _this$errorList, _this$col$edit3, _this$tableBaseClass2, _this$errorList2;
      var h = arguments[0];
      if (this.readonly) {
        return h("div", [this.cellNode]);
      }
      if (this.editable === void 0 && !this.isEdit || this.editable === false) {
        var _this$tableBaseClass, _this$col$edit;
        var Edit1Icon = this.Edit1Icon;
        return h("div", {
          "class": (_this$tableBaseClass = this.tableBaseClass) === null || _this$tableBaseClass === void 0 ? void 0 : _this$tableBaseClass.cellEditable,
          "on": {
            "click": this.onCellClick
          }
        }, [this.cellNode, ((_this$col$edit = this.col.edit) === null || _this$col$edit === void 0 ? void 0 : _this$col$edit.showEditIcon) !== false && h(Edit1Icon)]);
      }
      var Component = (_this$col$edit2 = this.col.edit) === null || _this$col$edit2 === void 0 ? void 0 : _this$col$edit2.component;
      if (!Component) {
        log.error("Table", "edit.component is required.");
        return null;
      }
      var errorMessage = (_this$errorList = this.errorList) === null || _this$errorList === void 0 || (_this$errorList = _this$errorList[0]) === null || _this$errorList === void 0 ? void 0 : _this$errorList.message;
      var tmpEditOnListeners = _objectSpread$s({}, this.editOnListeners);
      if ((_this$col$edit3 = this.col.edit) !== null && _this$col$edit3 !== void 0 && (_this$col$edit3 = _this$col$edit3.abortEditOnEvent) !== null && _this$col$edit3 !== void 0 && _this$col$edit3.length) {
        this.col.edit.abortEditOnEvent.forEach(function (onEventName) {
          var vue2EventName = onEventName.slice(2).toLocaleLowerCase();
          if (tmpEditOnListeners[vue2EventName]) {
            delete tmpEditOnListeners[vue2EventName];
          }
        });
      }
      return h("div", {
        "class": (_this$tableBaseClass2 = this.tableBaseClass) === null || _this$tableBaseClass2 === void 0 ? void 0 : _this$tableBaseClass2.cellEditWrap,
        "ref": "tableEditableCellRef",
        "on": {
          "click": function click(e) {
            e.stopPropagation();
          }
        }
      }, [h(Component, helper([{
        "attrs": {
          "status": errorMessage ? ((_this$errorList2 = this.errorList) === null || _this$errorList2 === void 0 || (_this$errorList2 = _this$errorList2[0]) === null || _this$errorList2 === void 0 ? void 0 : _this$errorList2.type) || "error" : void 0,
          "tips": errorMessage
        }
      }, {
        "props": this.componentProps
      }, {}, {
        "on": _objectSpread$s(_objectSpread$s({}, this.listeners), tmpEditOnListeners)
      }, {
        "attrs": {
          "value": this.editValue
        },
        "on": {
          "change": this.onEditChange
        }
      }]))]);
    }
  });

  function useEditableCell(props, context, events) {
    var renderEditableCell = function renderEditableCell(h, p) {
      return h(EditableCell, helper([{}, {
        "props": p
      }, {}, {
        "on": events
      }, {
        "scopedSlots": context.slots
      }]));
    };
    return {
      renderEditableCell: renderEditableCell
    };
  }

  function ownKeys$r(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$r(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$r(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$r(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function useRowEdit(props, context) {
    var _toRefs = VueCompositionAPI.toRefs(props),
      editableRowKeys = _toRefs.editableRowKeys;
    var cellRuleMap = /* @__PURE__ */new Map();
    var errorListMap = VueCompositionAPI.ref({});
    var editableKeysMap = VueCompositionAPI.computed(function () {
      return getEditableKeysMap(props.editableRowKeys, props.data, props.rowKey || "id");
    });
    var editingCells = VueCompositionAPI.ref({});
    var editedFormData = VueCompositionAPI.ref({});
    var getErrorListMapByErrors = function getErrorListMapByErrors(errors) {
      var errorMap = {};
      errors.forEach(function (_ref) {
        var row = _ref.row,
          col = _ref.col,
          errorList = _ref.errorList;
        var rowValue = get(row, props.rowKey || "id");
        var key = [rowValue, col.colKey].join("__");
        if (errorList !== null && errorList !== void 0 && errorList.length) {
          errorMap[key] = errorList;
        } else {
          delete errorMap[key];
        }
      });
      return errorMap;
    };
    var validateOneRowData = function validateOneRowData(rowValue) {
      var rowRules = cellRuleMap.get(rowValue);
      if (!rowRules) return;
      var list = rowRules.map(function (item) {
        return new Promise(function (resolve) {
          var editedRow = item.editedRow,
            col = item.col;
          var rules = isFunction(col.edit.rules) ? col.edit.rules(item) : col.edit.rules;
          if (!col.edit || !rules || !rules.length) {
            resolve(_objectSpread$r(_objectSpread$r({}, item), {}, {
              errorList: []
            }));
            return;
          }
          validate(get(editedRow, col.colKey), rules).then(function (r) {
            resolve(_objectSpread$r(_objectSpread$r({}, item), {}, {
              errorList: r.filter(function (t) {
                return !t.result;
              })
            }));
          });
        });
      });
      return new Promise(function (resolve, reject) {
        Promise.all(list).then(function (errors) {
          resolve({
            errors: errors.filter(function (t) {
              var _t$errorList;
              return (_t$errorList = t.errorList) === null || _t$errorList === void 0 ? void 0 : _t$errorList.length;
            }),
            errorMap: getErrorListMapByErrors(errors)
          });
        }, reject);
      });
    };
    var validateRowData = function validateRowData(rowValue) {
      return new Promise(function (resolve, reject) {
        validateOneRowData(rowValue).then(function (_ref2) {
          var _props$onRowValidate;
          var errors = _ref2.errors,
            errorMap = _ref2.errorMap;
          errorListMap.value = errorMap;
          var tTrigger = "parent";
          (_props$onRowValidate = props.onRowValidate) === null || _props$onRowValidate === void 0 || _props$onRowValidate.call(props, {
            trigger: tTrigger,
            result: errors
          });
          resolve({
            trigger: tTrigger,
            result: errors
          });
        }, reject);
      });
    };
    var validateTableCellData = function validateTableCellData() {
      var cellKeys = Object.keys(editingCells.value);
      var promiseList = cellKeys.map(function (cellKey) {
        return editingCells.value[cellKey].validateEdit("parent");
      });
      return new Promise(function (resolve, reject) {
        Promise.all(promiseList).then(function (arr) {
          var allErrorListMap = {};
          arr.forEach(function (result, index) {
            if (result === true) return;
            allErrorListMap[cellKeys[index]] = result;
          });
          resolve({
            result: allErrorListMap
          });
        }, reject);
      });
    };
    var validateTableData = function validateTableData() {
      if (Object.keys(editingCells.value).length) {
        return validateTableCellData();
      }
      var promiseList = [];
      var data = props.data || [];
      for (var i = 0, len = data.length; i < len; i++) {
        var rowValue = get(data[i], props.rowKey || "id");
        promiseList.push(validateOneRowData(rowValue));
      }
      return new Promise(function (resolve, reject) {
        Promise.all(promiseList).then(function (rList) {
          var _props$onValidate;
          var allErrorListMap = {};
          rList.forEach(function () {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                errors: [],
                errorMap: {}
              },
              errorMap = _ref3.errorMap;
            errorMap && Object.assign(allErrorListMap, errorMap);
          });
          errorListMap.value = allErrorListMap;
          (_props$onValidate = props.onValidate) === null || _props$onValidate === void 0 || _props$onValidate.call(props, {
            result: allErrorListMap
          });
          resolve({
            result: allErrorListMap
          });
        }, reject);
      });
    };
    var onUpdateEditedCell = function onUpdateEditedCell(rowValue, lastRowData, data) {
      if (!editedFormData.value[rowValue]) {
        editedFormData.value[rowValue] = cloneDeep(lastRowData);
      }
      var tmpEditedData = _objectSpread$r({}, editedFormData.value);
      Object.entries(data).forEach(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
          key = _ref5[0],
          val = _ref5[1];
        set(tmpEditedData[rowValue], key, val);
      });
      editedFormData.value = tmpEditedData;
    };
    var onRuleChange = function onRuleChange(context2) {
      if (props.editableRowKeys) {
        var rowValue = get(context2.row, props.rowKey || "id");
        var rules = cellRuleMap.get(rowValue);
        if (rules) {
          var index = rules.findIndex(function (t) {
            return t.col.colKey === context2.col.colKey;
          });
          if (index === -1) {
            rules.push(context2);
          } else {
            rules[index] = context2;
          }
          cellRuleMap.set(rowValue, rules);
        } else {
          cellRuleMap.set(rowValue, [context2]);
        }
      }
    };
    var clearValidateData = function clearValidateData() {
      errorListMap.value = {};
    };
    var onPrimaryTableCellEditChange = function onPrimaryTableCellEditChange(params) {
      var cellKey = getCellKey(params.row, props.rowKey, params.col.colKey, params.colIndex);
      if (params.isEdit) {
        editingCells.value[cellKey] = params;
      } else {
        delete editingCells.value[cellKey];
      }
    };
    var onPrimaryTableRowEdit = function onPrimaryTableRowEdit(params) {
      var _props$onRowEdit;
      (_props$onRowEdit = props.onRowEdit) === null || _props$onRowEdit === void 0 || _props$onRowEdit.call(props, params);
      context.emit("row-edit", params);
    };
    var onPrimaryTableRowValidate = function onPrimaryTableRowValidate(params) {
      var _props$onRowValidate2;
      (_props$onRowValidate2 = props.onRowValidate) === null || _props$onRowValidate2 === void 0 || _props$onRowValidate2.call(props, params);
      context.emit("row-validate", params);
    };
    var getEditRowData = function getEditRowData(_ref6) {
      var _props$editableRowKey;
      var row = _ref6.row,
        col = _ref6.col;
      var rowValue = get(row, props.rowKey || "id");
      var editedRowData = editedFormData.value[rowValue];
      if (editedRowData && (_props$editableRowKey = props.editableRowKeys) !== null && _props$editableRowKey !== void 0 && _props$editableRowKey.includes(rowValue)) {
        var tmpRow = _objectSpread$r({}, editedRowData);
        set(tmpRow, col.colKey, get(editedRowData, col.colKey));
        return tmpRow;
      }
      return row;
    };
    VueCompositionAPI.watch(function () {
      var _editableRowKeys$valu;
      return (_editableRowKeys$valu = editableRowKeys.value) === null || _editableRowKeys$valu === void 0 ? void 0 : _editableRowKeys$valu.join(",");
    }, function (keyStr) {
      var editableRowKeys2 = keyStr.split(",");
      var rowValueList = Object.keys(editedFormData.value);
      rowValueList.forEach(function (key) {
        if (!editableRowKeys2.includes(key)) {
          delete editedFormData.value[key];
        }
      });
    });
    return {
      editedFormData: editedFormData,
      errorListMap: errorListMap,
      editableKeysMap: editableKeysMap,
      validateTableData: validateTableData,
      validateRowData: validateRowData,
      onRuleChange: onRuleChange,
      clearValidateData: clearValidateData,
      getEditRowData: getEditRowData,
      onUpdateEditedCell: onUpdateEditedCell,
      onPrimaryTableRowEdit: onPrimaryTableRowEdit,
      onPrimaryTableRowValidate: onPrimaryTableRowValidate,
      onPrimaryTableCellEditChange: onPrimaryTableCellEditChange
    };
  }

  function ownKeys$q(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$q(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$q(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$q(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var OMIT_PROPS = ["hideSortTips", "dragSort", "defaultExpandedRowKeys", "defaultSelectedRowKeys", "columnController", "filterRow", "sortOnRowDraggable", "expandOnRowClick", "multipleSort", "expandIcon", "reserveSelectedRowOnPaginate", "selectOnRowClick", "onChange", "onAsyncLoadingClick", "onChange", "onColumnChange", "onColumnControllerVisibleChange", "onDataChange", "onDisplayColumnsChange", "onDragSort", "onExpandChange", "onFilterChange", "onSelectChange", "onSortChange"];
  var _PrimaryTable = VueCompositionAPI.defineComponent({
    name: "TPrimaryTable",
    props: _objectSpread$q(_objectSpread$q({}, baseTableProps), primaryTableProps),
    setup: function setup(props, context) {
      var renderTNode = useTNodeJSX();
      var _toRefs = VueCompositionAPI.toRefs(props),
        columns = _toRefs.columns;
      var primaryTableRef = VueCompositionAPI.ref(null);
      var showElement = VueCompositionAPI.ref(false);
      var _useClassName = useClassName(),
        classPrefix = _useClassName.classPrefix,
        tableDraggableClasses = _useClassName.tableDraggableClasses,
        tableBaseClass = _useClassName.tableBaseClass,
        tableSelectedClasses = _useClassName.tableSelectedClasses,
        tableSortClasses = _useClassName.tableSortClasses;
      var _useConfig = useConfig("table", props.locale),
        global = _useConfig.global;
      var _useStyle = useStyle(props),
        sizeClassNames = _useStyle.sizeClassNames;
      var tableSize = VueCompositionAPI.computed(function () {
        var _props$size;
        return (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : global.value.size;
      });
      var innerPagination = VueCompositionAPI.ref(props.pagination);
      var dataPagination = VueCompositionAPI.computed(function () {
        return innerPagination.value ? {
          current: innerPagination.value.current,
          pageSize: innerPagination.value.pageSize,
          defaultCurrent: innerPagination.value.defaultCurrent,
          defaultPageSize: innerPagination.value.defaultPageSize
        } : {};
      });
      var _useColumnController = useColumnController(props, context),
        tDisplayColumns = _useColumnController.tDisplayColumns,
        renderColumnController = _useColumnController.renderColumnController;
      var _useRowExpand = useRowExpand(props, context),
        showExpandedRow = _useRowExpand.showExpandedRow,
        showExpandIconColumn = _useRowExpand.showExpandIconColumn,
        getExpandColumn = _useRowExpand.getExpandColumn,
        renderExpandedRow = _useRowExpand.renderExpandedRow,
        onInnerExpandRowClick = _useRowExpand.onInnerExpandRowClick,
        getExpandedRowClass = _useRowExpand.getExpandedRowClass;
      var _useSorter = useSorter(props, context),
        renderSortIcon = _useSorter.renderSortIcon;
      var _useRowSelect = useRowSelect(props, tableSelectedClasses),
        selectColumn = _useRowSelect.selectColumn,
        showRowSelect = _useRowSelect.showRowSelect,
        selectedRowClassNames = _useRowSelect.selectedRowClassNames,
        currentPaginateData = _useRowSelect.currentPaginateData,
        formatToRowSelectColumn = _useRowSelect.formatToRowSelectColumn,
        setTSelectedRowKeys = _useRowSelect.setTSelectedRowKeys,
        onInnerSelectRowClick = _useRowSelect.onInnerSelectRowClick,
        handleRowSelectWithAreaSelection = _useRowSelect.handleRowSelectWithAreaSelection;
      var _useFilter = useFilter(props, context),
        hasEmptyCondition = _useFilter.hasEmptyCondition,
        isTableOverflowHidden = _useFilter.isTableOverflowHidden,
        renderFilterIcon = _useFilter.renderFilterIcon,
        renderFirstFilterRow = _useFilter.renderFirstFilterRow,
        setFilterPrimaryTableRef = _useFilter.setFilterPrimaryTableRef;
      var dragSortParams = VueCompositionAPI.computed(function () {
        return {
          showElement: showElement.value,
          pagination: dataPagination.value
        };
      });
      var _useDragSort = useDragSort(props, context, dragSortParams),
        isRowHandlerDraggable = _useDragSort.isRowHandlerDraggable,
        isRowDraggable = _useDragSort.isRowDraggable,
        isColDraggable = _useDragSort.isColDraggable,
        setDragSortPrimaryTableRef = _useDragSort.setDragSortPrimaryTableRef,
        setDragSortColumns = _useDragSort.setDragSortColumns;
      var _useTableHeader = useTableHeader(props),
        renderTitleWidthIcon = _useTableHeader.renderTitleWidthIcon;
      var _useAsyncLoading = useAsyncLoading(props, context),
        renderAsyncLoading = _useAsyncLoading.renderAsyncLoading;
      var _useEditableRow = useRowEdit(props, context),
        errorListMap = _useEditableRow.errorListMap,
        editableKeysMap = _useEditableRow.editableKeysMap,
        validateRowData = _useEditableRow.validateRowData,
        validateTableData = _useEditableRow.validateTableData,
        onRuleChange = _useEditableRow.onRuleChange,
        clearValidateData = _useEditableRow.clearValidateData,
        getEditRowData = _useEditableRow.getEditRowData,
        onUpdateEditedCell = _useEditableRow.onUpdateEditedCell,
        onPrimaryTableRowValidate = _useEditableRow.onPrimaryTableRowValidate,
        onPrimaryTableCellEditChange = _useEditableRow.onPrimaryTableCellEditChange;
      var _useEditableCell = useEditableCell(props, context, {
          "update-edited-cell": onUpdateEditedCell
        }),
        renderEditableCell = _useEditableCell.renderEditableCell;
      var innerKeyboardRowHover = VueCompositionAPI.computed(function () {
        return Boolean(showExpandedRow.value || showRowSelect.value);
      });
      var innerDisableSpaceInactiveRow = VueCompositionAPI.computed(function () {
        return Boolean(showExpandedRow.value || showRowSelect.value);
      });
      var primaryTableClasses = VueCompositionAPI.computed(function () {
        var _selectColumn$value;
        return _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({}, tableDraggableClasses.colDraggable, isColDraggable.value), tableDraggableClasses.rowHandlerDraggable, isRowHandlerDraggable.value), tableDraggableClasses.rowDraggable, isRowDraggable.value), tableBaseClass.overflowVisible, isTableOverflowHidden.value === false), tableBaseClass.tableRowEdit, props.editableRowKeys), "".concat(classPrefix, "-table--select-").concat((_selectColumn$value = selectColumn.value) === null || _selectColumn$value === void 0 ? void 0 : _selectColumn$value.type), selectColumn.value), "".concat(classPrefix, "-table--row-select"), showRowSelect.value), "".concat(classPrefix, "-table--row-expandable"), showExpandedRow.value);
      });
      var tRowClassNames = VueCompositionAPI.computed(function () {
        var tClassNames = [props.rowClassName, selectedRowClassNames.value, getExpandedRowClass];
        return tClassNames.filter(function (v) {
          return v;
        });
      });
      var tRowAttributes = VueCompositionAPI.computed(function () {
        var tAttributes = [props.rowAttributes];
        if (isRowHandlerDraggable.value || isRowDraggable.value) {
          tAttributes.push(function (_ref2) {
            var row = _ref2.row;
            return {
              "data-id": get(row, props.rowKey || "id")
            };
          });
        }
        return tAttributes.filter(function (v) {
          return v;
        });
      });
      VueCompositionAPI.onMounted(function () {
        setFilterPrimaryTableRef(primaryTableRef.value);
        setDragSortPrimaryTableRef(primaryTableRef.value);
      });
      VueCompositionAPI.watch(primaryTableRef, function () {
        setFilterPrimaryTableRef(primaryTableRef.value);
        setDragSortPrimaryTableRef(primaryTableRef.value);
      });
      var onEditableCellChange = function onEditableCellChange(params) {
        var _props$onRowEdit;
        (_props$onRowEdit = props.onRowEdit) === null || _props$onRowEdit === void 0 || _props$onRowEdit.call(props, params);
        context.emit("row-edit", params);
        var rowValue = get(params.editedRow, props.rowKey || "id");
        onUpdateEditedCell(rowValue, params.row, _defineProperty$2({}, params.col.colKey, params.value));
      };
      var _getColumns = function getColumns(columns2) {
        var parentDisplay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var arr = [];
        var _loop = function _loop() {
          var _item$children, _tDisplayColumns$valu, _item$edit, _item$children2, _item$children3;
          var item = _objectSpread$q({}, columns2[i]);
          var isDisplayColumn = ((_item$children = item.children) === null || _item$children === void 0 ? void 0 : _item$children.length) || ((_tDisplayColumns$valu = tDisplayColumns.value) === null || _tDisplayColumns$valu === void 0 ? void 0 : _tDisplayColumns$valu.includes(item.colKey));
          var isColumnController = Boolean(props.columnController || props.displayColumns || props.defaultDisplayColumns);
          if (!isDisplayColumn && isColumnController && !parentDisplay) return 1; // continue
          item = formatToRowSelectColumn(item);
          var sort = props.sort;
          if (item.sorter && props.showSortColumnBgColor) {
            var sorts = sort instanceof Array ? sort : [sort];
            var sortedColumn = sorts.find(function (sort2) {
              return sort2 && sort2.sortBy === item.colKey && sort2.descending !== void 0;
            });
            if (sortedColumn) {
              item.className = item.className instanceof Array ? item.className.concat(tableSortClasses.sortColumn) : [item.className, tableSortClasses.sortColumn];
            }
          }
          if (item.sorter || item.filter) {
            var titleContent = renderTitle(VueCompositionAPI.h, context.slots, item, i);
            var _item = item,
              ellipsisTitle = _item.ellipsisTitle;
            item.title = function (h2, p) {
              var _primaryTableRef$valu;
              var sortIcon = item.sorter ? renderSortIcon(h2, p) : null;
              var filterIcon = item.filter ? renderFilterIcon(h2, p) : null;
              var attach = (_primaryTableRef$valu = primaryTableRef.value) === null || _primaryTableRef$valu === void 0 || (_primaryTableRef$valu = _primaryTableRef$valu.$refs) === null || _primaryTableRef$valu === void 0 ? void 0 : _primaryTableRef$valu.tableContentRef;
              return renderTitleWidthIcon(h2, [titleContent, sortIcon, filterIcon], p.col, p.colIndex, ellipsisTitle, attach, {
                classPrefix: classPrefix,
                ellipsisOverlayClassName: tableSize.value !== "medium" ? sizeClassNames[tableSize.value] : ""
              });
            };
            item.ellipsisTitle = false;
          }
          if ((_item$edit = item.edit) !== null && _item$edit !== void 0 && _item$edit.component) {
            var oldCell = item.cell;
            item.cell = function (h2, p) {
              var cellProps = _objectSpread$q(_objectSpread$q({}, p), {}, {
                row: getEditRowData(p),
                rowKey: props.rowKey || "id",
                oldCell: oldCell,
                tableBaseClass: tableBaseClass,
                cellEmptyContent: props.cellEmptyContent,
                onChange: onEditableCellChange,
                onValidate: onPrimaryTableRowValidate,
                onRuleChange: onRuleChange,
                onEditableChange: onPrimaryTableCellEditChange
              });
              if (props.editableRowKeys) {
                var _errorListMap$value;
                var rowValue = get(p.row, props.rowKey || "id");
                cellProps.editable = editableKeysMap.value[rowValue] || false;
                var key = [rowValue, p.col.colKey].join("__");
                var errorList = (_errorListMap$value = errorListMap.value) === null || _errorListMap$value === void 0 ? void 0 : _errorListMap$value[key];
                errorList && (cellProps.errors = errorList);
              }
              if (props.editableCellState) {
                cellProps.readonly = !props.editableCellState(p);
              }
              return renderEditableCell(h2, cellProps);
            };
          }
          if ((_item$children2 = item.children) !== null && _item$children2 !== void 0 && _item$children2.length) {
            var _tDisplayColumns$valu2;
            item.children = _getColumns(item.children, parentDisplay || ((_tDisplayColumns$valu2 = tDisplayColumns.value) === null || _tDisplayColumns$valu2 === void 0 ? void 0 : _tDisplayColumns$valu2.includes(item.colKey)));
          }
          if (!item.children || (_item$children3 = item.children) !== null && _item$children3 !== void 0 && _item$children3.length) {
            arr.push(item);
          }
        };
        for (var i = 0, len = columns2.length; i < len; i++) {
          if (_loop()) continue;
        }
        return arr;
      };
      var tColumns = VueCompositionAPI.computed(function () {
        var cols = _getColumns(columns.value);
        if (showExpandIconColumn.value) {
          cols.unshift(getExpandColumn(VueCompositionAPI.h));
        }
        return cols;
      });
      var onInnerPageChange = function onInnerPageChange(pageInfo, newData) {
        var _props$onPageChange, _props$onChange;
        innerPagination.value = _objectSpread$q(_objectSpread$q({}, innerPagination.value), pageInfo);
        currentPaginateData.value = newData;
        (_props$onPageChange = props.onPageChange) === null || _props$onPageChange === void 0 || _props$onPageChange.call(props, pageInfo, newData);
        context.emit("page-change", pageInfo, newData);
        var changeParams = [{
          pagination: pageInfo
        }, {
          trigger: "pagination",
          currentData: newData
        }];
        (_props$onChange = props.onChange) === null || _props$onChange === void 0 || _props$onChange.call.apply(_props$onChange, [props].concat(changeParams));
        context.emit.apply(context, ["change"].concat(changeParams));
        if (!props.reserveSelectedRowOnPaginate) {
          setTSelectedRowKeys([], {
            selectedRowData: [],
            type: "uncheck",
            currentRowKey: "CLEAR_ON_PAGINATE"
          });
        }
      };
      var onInnerActiveRowAction = function onInnerActiveRowAction(params) {
        var _props$onActiveRowAct;
        (_props$onActiveRowAct = props.onActiveRowAction) === null || _props$onActiveRowAct === void 0 || _props$onActiveRowAct.call(props, params);
        handleRowSelectWithAreaSelection(params);
      };
      var onSingleRowClick = function onSingleRowClick(params) {
        if (props.expandOnRowClick) {
          onInnerExpandRowClick(params);
        }
        if (props.selectOnRowClick) {
          onInnerSelectRowClick(params);
        }
      };
      var timer;
      var DURATION = 250;
      var onInnerRowClick = function onInnerRowClick(params) {
        if (!context.listeners["row-dblclick"]) {
          onSingleRowClick(params);
          return;
        }
        if (timer) {
          clearTimeout(timer);
          timer = void 0;
        } else {
          timer = setTimeout(function () {
            onSingleRowClick(params);
            timer = void 0;
          }, DURATION);
        }
      };
      var onShowElementChange = function onShowElementChange(val) {
        showElement.value = val;
      };
      return {
        tColumns: tColumns,
        showExpandedRow: showExpandedRow,
        tRowClassNames: tRowClassNames,
        hasEmptyCondition: hasEmptyCondition,
        primaryTableRef: primaryTableRef,
        tRowAttributes: tRowAttributes,
        primaryTableClasses: primaryTableClasses,
        errorListMap: errorListMap,
        onShowElementChange: onShowElementChange,
        scrollToElement: function scrollToElement(data) {
          primaryTableRef.value.scrollToElement(data);
        },
        scrollColumnIntoView: function scrollColumnIntoView(colKey) {
          primaryTableRef.value.scrollColumnIntoView(colKey);
        },
        refreshTable: function refreshTable() {
          primaryTableRef.value.refreshTable();
        },
        validateRowData: validateRowData,
        validateTableData: validateTableData,
        clearValidateData: clearValidateData,
        renderTNode: renderTNode,
        renderColumnController: renderColumnController,
        renderExpandedRow: renderExpandedRow,
        onInnerExpandRowClick: onInnerExpandRowClick,
        onInnerRowClick: onInnerRowClick,
        renderFirstFilterRow: renderFirstFilterRow,
        renderAsyncLoading: renderAsyncLoading,
        onInnerPageChange: onInnerPageChange,
        setDragSortColumns: setDragSortColumns,
        onInnerActiveRowAction: onInnerActiveRowAction,
        innerKeyboardRowHover: innerKeyboardRowHover,
        innerDisableSpaceInactiveRow: innerDisableSpaceInactiveRow
      };
    },
    methods: {
      getListener: function getListener() {
        var _this = this;
        var listener = {};
        BASE_TABLE_ALL_EVENTS.forEach(function (key) {
          listener[key] = function () {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            _this.$emit.apply(_this, [key].concat(args));
          };
        });
        return listener;
      },
      formatNode: function formatNode(api, renderInnerNode, condition, extra) {
        var h = this.$createElement;
        if (!condition) return this[api];
        var innerNode = renderInnerNode(h);
        var propsNode = this.renderTNode(api);
        if (innerNode && !propsNode) return function () {
          return innerNode;
        };
        if (propsNode && !innerNode) return function () {
          return propsNode;
        };
        if (innerNode && propsNode) {
          return function () {
            return extra !== null && extra !== void 0 && extra.reverse ? h("div", [innerNode, propsNode]) : h("div", [propsNode, innerNode]);
          };
        }
        return null;
      }
    },
    render: function render() {
      var _this$keyboardRowHove, _this$disableSpaceIna;
      var h = arguments[0];
      var isColumnController = !!(this.columnController && Object.keys(this.columnController).length);
      var placement = isColumnController ? this.columnController.placement || "top-right" : "";
      var isBottomController = isColumnController && (placement === null || placement === void 0 ? void 0 : placement.indexOf("bottom")) !== -1;
      var topContent = this.formatNode("topContent", this.renderColumnController, isColumnController && !isBottomController);
      var bottomContent = this.formatNode("bottomContent", this.renderColumnController, isBottomController, {
        reverse: true
      });
      var firstFullRow = this.formatNode("firstFullRow", this.renderFirstFilterRow, !this.hasEmptyCondition);
      var lastFullRow = this.formatNode("lastFullRow", this.renderAsyncLoading, !!this.asyncLoading);
      var props = _objectSpread$q(_objectSpread$q({}, omit$2(this.$props, OMIT_PROPS)), {}, {
        rowClassName: this.tRowClassNames,
        rowAttributes: this.tRowAttributes,
        columns: this.tColumns,
        keyboardRowHover: (_this$keyboardRowHove = this.keyboardRowHover) !== null && _this$keyboardRowHove !== void 0 ? _this$keyboardRowHove : this.innerKeyboardRowHover,
        disableSpaceInactiveRow: (_this$disableSpaceIna = this.disableSpaceInactiveRow) !== null && _this$disableSpaceIna !== void 0 ? _this$disableSpaceIna : this.innerDisableSpaceInactiveRow,
        topContent: topContent,
        bottomContent: bottomContent,
        firstFullRow: firstFullRow,
        lastFullRow: lastFullRow,
        thDraggable: this.$props.dragSort === "col",
        renderExpandedRow: this.showExpandedRow ? this.renderExpandedRow : void 0,
        onActiveRowAction: this.onInnerActiveRowAction
      });
      var on = _objectSpread$q(_objectSpread$q({}, this.getListener()), {}, {
        "page-change": this.onInnerPageChange,
        "show-element-change": this.onShowElementChange
      });
      if (this.expandOnRowClick || this.selectOnRowClick) {
        on["row-click"] = this.onInnerRowClick;
      }
      on.LeafColumnsChange = this.setDragSortColumns;
      return h(_BaseTable, helper([{
        "ref": "primaryTableRef",
        "scopedSlots": this.$scopedSlots
      }, {
        "props": props
      }, {}, {
        "on": on
      }, {}, this.$attrs, {
        "class": this.primaryTableClasses
      }]));
    }
  });

  var enhancedTableProps = {
    beforeDragSort: {
      type: Function
    },
    expandedTreeNodes: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    defaultExpandedTreeNodes: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    tree: {
      type: Object
    },
    treeExpandAndFoldIcon: {
      type: Function
    },
    onAbnormalDragSort: Function,
    onExpandedTreeNodesChange: Function,
    onTreeExpandChange: Function
  };

  function ownKeys$p(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$p(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$p(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$p(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var TABLE_TREE_ERROR_CODE_NOT_SAME_LEVEL = {
    code: 1001,
    reason: "The same level of rows can not be swapped."
  };
  function getUniqueRowValue(row, colKey) {
    var rowIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var level = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var rowValue = get(row, colKey);
    return rowIndex || level ? "".concat(rowValue, "_").concat(rowIndex || 0, "_").concat(level || 0, "}") : rowValue;
  }
  var TableTreeStore = /*#__PURE__*/function () {
    function TableTreeStore() {
      _classCallCheck(this, TableTreeStore);
      _defineProperty$2(this, "treeDataMap", /* @__PURE__ */new Map());
      _defineProperty$2(this, "expandAllRowIndex", void 0);
      this.treeDataMap = /* @__PURE__ */new Map();
    }
    return _createClass(TableTreeStore, [{
      key: "initialTreeStore",
      value: function initialTreeStore(dataSource, columns, keys) {
        var _this$treeDataMap;
        (_this$treeDataMap = this.treeDataMap) === null || _this$treeDataMap === void 0 || _this$treeDataMap.clear();
        this.initialTreeDataMap(this.treeDataMap, dataSource, columns.find(function (col) {
          return col.colKey === "row-select";
        }), keys);
      }
    }, {
      key: "getAllUniqueKeys",
      value: function getAllUniqueKeys(data, keys) {
        var arr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        for (var i = 0, len = data.length; i < len; i++) {
          var item = data[i];
          arr.push(getUniqueRowValue(item, keys.rowKey));
          var children = get(item, keys.childrenKey);
          if (children !== null && children !== void 0 && children.length) {
            this.getAllUniqueKeys(children, keys, arr);
          }
        }
        return arr;
      }
    }, {
      key: "getExpandedChildrenKeys",
      value: function getExpandedChildrenKeys(data, keys) {
        var arr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        for (var i = 0, len = data.length; i < len; i++) {
          var item = data[i];
          var rowValue = getUniqueRowValue(item, keys.rowKey);
          var rowState = this.treeDataMap.get(rowValue);
          if (rowState.expanded) {
            arr.push(rowValue);
          }
          var children = get(item, keys.childrenKey);
          if (children !== null && children !== void 0 && children.length) {
            this.getExpandedChildrenKeys(children, keys, arr);
          }
        }
        return arr;
      }
    }, {
      key: "expandTreeNode",
      value: function expandTreeNode(rowList, dataSource, keys) {
        var _this = this;
        if (!rowList.length) return dataSource;
        rowList.forEach(function (rowValue) {
          var rowState = _this.treeDataMap.get(rowValue);
          if (!rowState) return;
          _this.toggleExpandData({
            row: rowState.row,
            rowIndex: rowState.rowIndex
          }, dataSource, keys, "expand");
        });
        return dataSource;
      }
    }, {
      key: "foldTreeNode",
      value: function foldTreeNode(rowList, dataSource, keys) {
        var _this2 = this;
        if (!rowList.length) return dataSource;
        rowList.forEach(function (rowValue) {
          var rowState = _this2.treeDataMap.get(rowValue);
          if (!rowState) return;
          _this2.toggleExpandData({
            row: rowState.row,
            rowIndex: rowState.rowIndex
          }, dataSource, keys, "fold");
        });
        return dataSource;
      }
    }, {
      key: "toggleExpandData",
      value: function toggleExpandData(p, dataSource, keys, type) {
        var _r$rowIndex;
        if (!p) {
          log.error("EnhancedTable", "the node toggleExpanded doest not exist in `data`");
          return dataSource;
        }
        var rowValue = get(p.row, keys.rowKey);
        if (isUndefined(rowValue)) {
          log.error("EnhancedTable", "`rowKey` could be wrong, can not get rowValue from `data` by `rowKey`.");
          return [];
        }
        var childrenNodes = get(p.row, keys.childrenKey);
        if (childrenNodes === true) return dataSource;
        var r = this.treeDataMap.get(rowValue);
        if (type === "expand" && r.expanded) return dataSource;
        if (type === "fold" && !r.expanded) return dataSource;
        r.rowIndex = (_r$rowIndex = r.rowIndex) !== null && _r$rowIndex !== void 0 ? _r$rowIndex : p.rowIndex;
        r.expanded = !r.expanded;
        this.treeDataMap.set(rowValue, r);
        return this.updateExpandRow(r, dataSource, keys);
      }
    }, {
      key: "updateExpandRow",
      value: function updateExpandRow(changeRow, dataSource, keys) {
        var row = changeRow.row,
          rowIndex = changeRow.rowIndex,
          expanded = changeRow.expanded;
        var treeDataMap = this.treeDataMap;
        var childrenNodes = get(row, keys.childrenKey);
        if (!row || !childrenNodes) return dataSource;
        if (expanded) {
          updateChildrenRowState(treeDataMap, changeRow, expanded, keys);
          updateRowExpandLength(treeDataMap, row, childrenNodes.length, "expand", keys);
          dataSource.splice.apply(dataSource, [rowIndex + 1, 0].concat(childrenNodes));
        } else {
          updateChildrenRowState(treeDataMap, changeRow, expanded, keys);
          var len = changeRow.expandChildrenLength || childrenNodes.length;
          updateRowExpandLength(treeDataMap, row, -1 * len, "fold", keys);
          dataSource.splice(rowIndex + 1, len);
        }
        updateRowIndex(treeDataMap, dataSource, {
          rowKey: keys.rowKey,
          minRowIndex: rowIndex + 1
        });
        return dataSource;
      }
    }, {
      key: "getData",
      value: function getData(key) {
        return this.treeDataMap.get(key);
      }
    }, {
      key: "updateData",
      value: function updateData(rowValue, newRowData, dataSource, keys) {
        var newRowValue = getUniqueRowValue(newRowData, keys.rowKey);
        var rowState = this.treeDataMap.get(rowValue);
        if (!rowState || rowState.rowIndex === -1) {
          updateRowData(dataSource, rowValue, newRowData, {
            rowKey: keys.rowKey,
            childrenKey: keys.childrenKey
          });
          return -1;
        }
        if (get(newRowData, keys.childrenKey) === true) {
          var oldChildren = get(rowState.row, keys.childrenKey);
          if (oldChildren !== null && oldChildren !== void 0 && oldChildren.length) {
            for (var i = 0, len = oldChildren.length; i < len; i++) {
              var rowValue2 = getUniqueRowValue(oldChildren[i], keys.rowKey);
              var state = this.treeDataMap.get(rowValue2);
              if (state) {
                this.treeDataMap["delete"](rowValue2);
              }
            }
          }
        }
        var currentRowIndex = rowState.rowIndex;
        rowState.row = newRowData;
        rowState.id = newRowValue;
        if (rowState.parent) {
          var siblings = get(rowState.parent.row, keys.childrenKey);
          var index = siblings.findIndex(function (item) {
            return getUniqueRowValue(item, keys.rowKey) === rowValue;
          });
          siblings[index] = newRowData;
        }
        this.treeDataMap.set(newRowValue, rowState);
        if (rowValue !== newRowValue) {
          this.treeDataMap["delete"](rowValue);
        }
        return currentRowIndex;
      }
    }, {
      key: "remove",
      value: function remove(key, dataSource, keys) {
        var r = this.treeDataMap.get(key);
        if (r && r.rowIndex >= 0) {
          var removeNumber = (r.expandChildrenLength || 0) + 1;
          dataSource.splice(r.rowIndex, removeNumber);
          if (r.parent) {
            var siblings = get(r.parent.row, keys.childrenKey);
            var index = siblings.findIndex(function (item) {
              return get(item, keys.rowKey) === key;
            });
            siblings.splice(index, 1);
            updateRowExpandLength(this.treeDataMap, r.parent.row, -1 * removeNumber, "delete", keys);
          }
          this.treeDataMap["delete"](key);
          updateRowIndex(this.treeDataMap, dataSource, {
            minRowIndex: r.rowIndex,
            rowKey: keys.rowKey,
            type: "remove"
          });
        } else {
          log.warn("EnhancedTable", "Can not remove this node, which is not appeared.");
        }
        return dataSource;
      }
    }, {
      key: "removeChildren",
      value: function removeChildren(key, dataSource, keys) {
        var r = this.treeDataMap.get(key);
        if (r && r.rowIndex >= 0) {
          var removeNumber = r.expandChildrenLength || 0;
          if (removeNumber) {
            dataSource.splice(r.rowIndex + 1, removeNumber);
          }
          if (r.parent) {
            updateRowExpandLength(this.treeDataMap, r.parent.row, -1 * removeNumber, "delete", keys);
          }
          r.expandChildrenLength = 0;
          r.expanded = false;
          set(r.row, keys.childrenKey, void 0);
          this.treeDataMap.set(key, r);
          if (removeNumber) {
            updateRowIndex(this.treeDataMap, dataSource, {
              minRowIndex: r.rowIndex + 1,
              rowKey: keys.rowKey,
              type: "remove"
            });
          }
        } else {
          log.warn("EnhancedTable", "Can not remove this node's children, which is not appeared.");
        }
        return dataSource;
      }
    }, {
      key: "appendTo",
      value: function appendTo(rowValue, newData, dataSource, keys) {
        var state = this.treeDataMap.get(rowValue);
        if (!this.validateDataExist(state, rowValue)) return dataSource;
        var children = get(state.row, keys.childrenKey);
        var isShowNewNode = state.expanded || !(children !== null && children !== void 0 && children.length);
        var tmpData = newData instanceof Array ? newData : [newData];
        var newChildrenData = [];
        var firstNewChildrenIndex = -1;
        for (var i = 0, len = tmpData.length; i < len; i++) {
          var oneData = tmpData[i];
          var newRowValue = getUniqueRowValue(oneData, keys.rowKey);
          var mapState = this.treeDataMap.get(newRowValue);
          if (!this.validateDataDoubleExist(mapState, newRowValue)) {
            log.warn("Table", "Duplicated Data `".concat(newRowValue, "` has been removed."));
          } else {
            var rowIndex = isShowNewNode ? state.rowIndex + (state.expandChildrenLength || 0) + (i + 1) : -1;
            if (i === 0) {
              firstNewChildrenIndex = rowIndex;
            }
            var newState = {
              id: newRowValue,
              row: oneData,
              rowIndex: rowIndex,
              level: state.level + 1,
              expanded: false,
              expandChildrenLength: 0,
              disabled: false,
              path: _toConsumableArray(state.path),
              parent: state
            };
            newState.path = newState.path.concat(newState);
            newChildrenData.push(oneData);
            this.treeDataMap.set(newRowValue, newState);
          }
        }
        if (!newChildrenData.length) return dataSource;
        if (children !== null && children !== void 0 && children.length) {
          state.row[keys.childrenKey] = state.row[keys.childrenKey].concat(newChildrenData);
        } else {
          state.row[keys.childrenKey] = newChildrenData;
          state.expanded = true;
        }
        if (isShowNewNode) {
          dataSource.splice.apply(dataSource, [firstNewChildrenIndex, 0].concat(newChildrenData));
          var newChildrenCount = newChildrenData.length || 1;
          updateRowExpandLength(this.treeDataMap, state.row, newChildrenCount, "insert", {
            rowKey: keys.rowKey,
            childrenKey: keys.childrenKey
          });
          updateRowIndex(this.treeDataMap, dataSource, {
            minRowIndex: firstNewChildrenIndex + newChildrenData.length - 1,
            rowKey: keys.rowKey,
            type: "add",
            count: 1
          });
        }
        return dataSource;
      }
    }, {
      key: "appendToRoot",
      value: function appendToRoot(newData, dataSource, keys) {
        var newDataSource = dataSource.concat(newData);
        var tmpNewData = newData instanceof Array ? newData : [newData];
        var dataSourceLen = dataSource.length;
        for (var i = 0, len = tmpNewData.length; i < len; i++) {
          var rowValue = get(tmpNewData[i], keys.rowKey);
          if (!rowValue) {
            log.error("Table", "`rowKey` could be wrong, can not get rowValue from `data` by `rowKey`.");
            continue;
          }
          var state = {
            id: rowValue,
            row: tmpNewData[i],
            rowIndex: dataSourceLen + i,
            level: 0,
            expanded: false,
            expandChildrenLength: 0,
            disabled: false
          };
          state.path = [state];
          this.treeDataMap.set(rowValue, state);
        }
        return newDataSource;
      }
    }, {
      key: "insertAfter",
      value: function insertAfter(rowValue, newData, dataSource, keys) {
        return this.insert(rowValue, newData, dataSource, keys, "after");
      }
    }, {
      key: "insertBefore",
      value: function insertBefore(rowValue, newData, dataSource, keys) {
        return this.insert(rowValue, newData, dataSource, keys, "before");
      }
    }, {
      key: "insert",
      value: function insert(rowValue, newData, dataSource, keys, type) {
        var state = this.treeDataMap.get(rowValue);
        if (!this.validateDataExist(state, rowValue)) return dataSource;
        var newRowValue = get(newData, keys.rowKey);
        var mapState = this.treeDataMap.get(newRowValue);
        if (!this.validateDataDoubleExist(mapState, newRowValue)) return dataSource;
        var rowIndex = type === "after" ? state.rowIndex + 1 : state.rowIndex;
        var newState = {
          id: newRowValue,
          row: newData,
          rowIndex: rowIndex,
          level: state.level,
          expanded: false,
          expandChildrenLength: 0,
          disabled: false,
          path: state.path.slice(0, -1),
          parent: state.parent
        };
        newState.path = newState.path.concat(newState);
        var dataIndex = type === "after" ? state.rowIndex + (state.expandChildrenLength + 1) : state.rowIndex;
        dataSource.splice(dataIndex, 0, newData);
        var distance = type === "after" ? 1 : 0;
        if (state.parent) {
          var childrenIndex = state.parent.row[keys.childrenKey].findIndex(function (t) {
            return rowValue === get(t, keys.rowKey);
          });
          state.parent.row[keys.childrenKey].splice(childrenIndex + distance, 0, newData);
          updateRowExpandLength(this.treeDataMap, state.parent.row, 1, "insert", keys);
        }
        this.treeDataMap.set(newRowValue, newState);
        updateRowIndex(this.treeDataMap, dataSource, {
          rowKey: keys.rowKey,
          minRowIndex: state.rowIndex + 1,
          type: "add"
        });
        return dataSource;
      }
    }, {
      key: "swapData",
      value: function swapData(dataSource, params, keys) {
        var startIndex = params.currentIndex;
        var endIndex = params.targetIndex;
        if (startIndex === endIndex) return {
          dataSource: dataSource,
          result: true
        };
        var startRowValue = get(params.current, keys.rowKey);
        var endRowValue = get(params.target, keys.rowKey);
        var startState = this.treeDataMap.get(startRowValue);
        var endState = this.treeDataMap.get(endRowValue);
        if (startState.level !== endState.level) {
          return {
            dataSource: dataSource,
            result: false,
            code: TABLE_TREE_ERROR_CODE_NOT_SAME_LEVEL.code,
            reason: TABLE_TREE_ERROR_CODE_NOT_SAME_LEVEL.reason
          };
        }
        var startLastIndex = startIndex + startState.expandChildrenLength + 1;
        var endLastIndex = endIndex + endState.expandChildrenLength + 1;
        var startRowList = dataSource.slice(startIndex, startLastIndex);
        var endRowList = dataSource.slice(endIndex, endLastIndex);
        if (startIndex > endIndex) {
          var middleRowList = dataSource.slice(endLastIndex, startIndex);
          var allSwapList = startRowList.concat(endRowList, middleRowList);
          dataSource.splice(endIndex, allSwapList.length);
          dataSource.splice.apply(dataSource, [endIndex, 0].concat(_toConsumableArray(allSwapList)));
          updateRowIndex(this.treeDataMap, dataSource, {
            rowKey: keys.rowKey,
            minRowIndex: endIndex,
            maxRowIndex: startLastIndex
          });
        } else {
          var _middleRowList = dataSource.slice(startLastIndex, endIndex);
          var _allSwapList = _middleRowList.concat(endRowList, startRowList);
          dataSource.splice(startIndex, _allSwapList.length);
          dataSource.splice.apply(dataSource, [startIndex, 0].concat(_toConsumableArray(_allSwapList)));
          updateRowIndex(this.treeDataMap, dataSource, {
            rowKey: keys.rowKey,
            minRowIndex: startIndex,
            maxRowIndex: endLastIndex
          });
        }
        if (startState.parent) {
          var children = startState.parent.row[keys.childrenKey];
          var count = 0;
          var targetIndex = -1;
          var currentIndex = -1;
          for (var i = 0, len = children.length; i < len; i++) {
            if (get(children[i], keys.rowKey) === startRowValue) {
              currentIndex = i;
              count += 1;
            }
            if (get(children[i], keys.rowKey) === endRowValue) {
              targetIndex = i;
              count += 1;
            }
            if (count >= 2) break;
          }
          if (currentIndex < targetIndex) {
            children.splice(targetIndex + 1, 0, params.current);
            children.splice(currentIndex, 1);
          } else {
            children.splice(currentIndex, 1);
            children.splice(targetIndex, 0, params.current);
          }
        }
        return {
          dataSource: dataSource,
          result: true
        };
      }
    }, {
      key: "expandAll",
      value: function expandAll(dataSource, keys) {
        var _this3 = this;
        this.expandAllRowIndex = 0;
        var newData = [];
        var _expandLoop = function expandLoop(dataSource2, keys2) {
          var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
          for (var i = 0, len = dataSource2.length; i < len; i++) {
            var item = dataSource2[i];
            var rowValue = get(item, keys2.rowKey);
            var state = _this3.treeDataMap.get(rowValue);
            var children = get(item, keys2.childrenKey);
            state.rowIndex = _this3.expandAllRowIndex;
            if (children !== true && children !== null && children !== void 0 && children.length) {
              state.expanded = true;
            }
            state.expandChildrenLength = (children === null || children === void 0 ? void 0 : children.length) || 0;
            _this3.expandAllRowIndex += 1;
            newData.push(item);
            _this3.treeDataMap.set(rowValue, state);
            if (children !== null && children !== void 0 && children.length) {
              var tmpParent = parent;
              while ((_tmpParent = tmpParent) !== null && _tmpParent !== void 0 && _tmpParent.row) {
                var _tmpParent;
                tmpParent.expandChildrenLength += children.length;
                _this3.treeDataMap.set(tmpParent.id, tmpParent);
                tmpParent = tmpParent.parent;
              }
              _expandLoop(children, keys2, state);
            }
          }
        };
        _expandLoop(dataSource, keys);
        return newData;
      }
    }, {
      key: "foldAll",
      value: function foldAll(dataSource, keys) {
        var newData = [];
        var index = 0;
        for (var i = 0, len = dataSource.length; i < len; i++) {
          var item = dataSource[i];
          var rowValue = get(item, keys.rowKey);
          var state = this.treeDataMap.get(rowValue);
          state.rowIndex = state.level === 0 ? index : -1;
          state.expanded = false;
          state.expandChildrenLength = 0;
          if (state.level === 0) {
            newData.push(item);
            index += 1;
          }
          var children = get(item, keys.childrenKey);
          if (children !== null && children !== void 0 && children.length) {
            this.foldAll(children, keys);
          }
        }
        return newData;
      }
    }, {
      key: "getTreeNode",
      value: function getTreeNode(dataSource, keys) {
        var treeData = [];
        for (var i = 0, len = dataSource.length; i < len; i++) {
          var item = dataSource[i];
          var rowValue = get(item, keys.rowKey);
          var state = this.treeDataMap.get(rowValue);
          if (state.level === 0) {
            treeData.push(item);
          }
        }
        return treeData;
      }
    }, {
      key: "getTreeExpandedRow",
      value: function getTreeExpandedRow(dataSource, keys) {
        var _this4 = this;
        var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "data";
        var arr = [];
        dataSource.forEach(function (item) {
          var rowValue = get(item, keys.rowKey);
          var rowState = _this4.treeDataMap.get(rowValue);
          if (!rowState.expanded) return;
          if (type === "unique") {
            arr.push(rowValue);
          } else if (type === "data") {
            arr.push(item);
          } else {
            arr.push(rowState);
          }
        });
        return arr;
      }
    }, {
      key: "initialTreeDataMap",
      value: function initialTreeDataMap(treeDataMap, dataSource, column, keys) {
        var level = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
        var parent = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
        for (var i = 0, len = dataSource.length; i < len; i++) {
          var item = dataSource[i];
          var rowValue = getUniqueRowValue(item, keys.rowKey);
          if (isUndefined(rowValue)) {
            log.error("EnhancedTable", "`rowKey` could be wrong, can not get rowValue from `data` by `rowKey`.");
            return;
          }
          var children = get(item, keys.childrenKey);
          var state = {
            id: rowValue,
            row: item,
            rowIndex: level === 0 ? i : -1,
            level: level,
            expanded: false,
            expandChildrenLength: 0,
            disabled: isRowSelectedDisabled(column, item, i),
            parent: parent
          };
          state.path = parent ? parent.path.concat(state) : [state];
          treeDataMap.set(rowValue, state);
          if (children !== null && children !== void 0 && children.length) {
            this.initialTreeDataMap(treeDataMap, children, column, keys, level + 1, state);
          }
        }
      }
    }, {
      key: "updateDisabledState",
      value: function updateDisabledState(dataSource, column, keys) {
        for (var i = 0, len = dataSource.length; i < len; i++) {
          var item = dataSource[i];
          var rowValue = get(item, keys.rowKey);
          if (isUndefined(rowValue)) {
            log.error("EnhancedTable", "`rowKey` could be wrong, can not get rowValue from `data` by `rowKey`.");
            return;
          }
          var state = this.treeDataMap.get(rowValue);
          state.disabled = isRowSelectedDisabled(column, item, i);
          this.treeDataMap.set(rowValue, state);
          var children = get(item, keys.childrenKey);
          if (children !== null && children !== void 0 && children.length) {
            this.updateDisabledState(children, column, keys);
          }
        }
      }
    }, {
      key: "validateDataExist",
      value: function validateDataExist(state, rowValue) {
        if (!state) {
          log.warn("EnhancedTable", "".concat(rowValue, " does not exist."));
          return false;
        }
        return true;
      }
    }, {
      key: "validateDataDoubleExist",
      value: function validateDataDoubleExist(state, rowValue) {
        if (state) {
          log.warn("EnhancedTable", "Duplicated Key. ".concat(rowValue, " already exists."));
          return false;
        }
        return true;
      }
    }]);
  }();
  function updateRowExpandLength(treeDataMap, row, distance, type, keys) {
    var tmp = row;
    while (tmp) {
      var _state$parent;
      var state = treeDataMap.get(get(tmp, keys.rowKey));
      var expandLen = (state.expandChildrenLength || 0) + distance;
      state.expandChildrenLength = Math.max(0, expandLen);
      tmp = state === null || state === void 0 || (_state$parent = state.parent) === null || _state$parent === void 0 ? void 0 : _state$parent.row;
    }
    if (type === "fold") {
      clearRowExpandLength(treeDataMap, row, keys);
    }
  }
  function clearRowExpandLength(treeDataMap, row, keys) {
    var children = get(row, keys.childrenKey);
    if (children !== null && children !== void 0 && children.length) {
      children.forEach(function (item) {
        var state = treeDataMap.get(get(item, keys.rowKey));
        if (!state) return;
        state.expandChildrenLength = 0;
        clearRowExpandLength(treeDataMap, state.row, keys);
      });
    }
  }
  function updateChildrenRowState(treeDataMap, rowState, expanded, keys) {
    var row = rowState.row,
      rowIndex = rowState.rowIndex;
    var childrenNodes = get(row, keys.childrenKey);
    childrenNodes.forEach(function (item, kidRowIndex) {
      var rowValue = get(item, keys.rowKey);
      var index = expanded ? rowIndex + 1 + kidRowIndex : -1;
      var curState = treeDataMap.get(rowValue);
      var newState = _objectSpread$p(_objectSpread$p({}, curState), {}, {
        row: item,
        rowIndex: index,
        expanded: false,
        parent: rowState
      });
      treeDataMap.set(rowValue, newState);
      if (!expanded) {
        var children = get(item, keys.childrenKey);
        if (children !== null && children !== void 0 && children.length) {
          updateChildrenRowState(treeDataMap, _objectSpread$p(_objectSpread$p({}, newState), {}, {
            rowIndex: -1,
            expanded: false
          }), expanded, keys);
        }
      }
    });
  }
  function updateRowData(data, key, newData, keys) {
    for (var i = 0, len = data.length; i < len; i++) {
      var item = data[i];
      if (get(item, keys.rowKey) === key) {
        data[i] = newData;
        return;
      }
      var children = get(item, keys.childrenKey) || [];
      if (children !== null && children !== void 0 && children.length) {
        updateRowData(children, key, newData, keys);
      }
    }
  }
  function updateRowIndex(treeDataMap, dataSource, extra) {
    var start = extra.minRowIndex || 0;
    var end = extra.maxRowIndex || dataSource.length;
    for (var rowIndex = start; rowIndex < end; rowIndex++) {
      var item = dataSource[rowIndex];
      var state = treeDataMap.get(get(item, extra.rowKey));
      if (!state) {
        log.warn("Table", "tree map went wrong");
      }
      state.rowIndex = rowIndex + ((extra === null || extra === void 0 ? void 0 : extra.count) || 1) - 1;
    }
  }
  function diffExpandedTreeNode() {
    var newExpandedNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var oldExpandedNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var removedList = [];
    var addedList = [];
    var newExpandedNodeMap = /* @__PURE__ */new Map();
    var oldExpandedNodeMap = /* @__PURE__ */new Map();
    for (var i = 0, len = newExpandedNode.length; i < len; i++) {
      newExpandedNodeMap.set(newExpandedNode[i], true);
    }
    for (var _i = 0, _len = oldExpandedNode.length; _i < _len; _i++) {
      oldExpandedNodeMap.set(oldExpandedNode[_i], true);
    }
    for (var _i2 = 0, _len2 = newExpandedNode.length; _i2 < _len2; _i2++) {
      if (!oldExpandedNodeMap.get(newExpandedNode[_i2])) {
        addedList.push(newExpandedNode[_i2]);
      }
    }
    for (var _i3 = 0, _len3 = oldExpandedNode.length; _i3 < _len3; _i3++) {
      if (!newExpandedNodeMap.get(oldExpandedNode[_i3])) {
        removedList.push(oldExpandedNode[_i3]);
      }
    }
    return {
      removedList: removedList,
      addedList: addedList
    };
  }

  function ownKeys$o(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$o(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$o(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$o(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function useTreeDataExpand(props, context, params) {
    var store = params.store,
      dataSource = params.dataSource,
      rowDataKeys = params.rowDataKeys;
    var _toRefs = VueCompositionAPI.toRefs(props),
      data = _toRefs.data,
      expandedTreeNodes = _toRefs.expandedTreeNodes,
      tree = _toRefs.tree;
    var isDefaultExpandAllExecute = VueCompositionAPI.ref(false);
    var isDefaultExpandedTreeNodesExecute = VueCompositionAPI.ref(false);
    var _useDefaultValue = useDefaultValue(expandedTreeNodes, props.defaultExpandedTreeNodes, props.onExpandedTreeNodesChange, "expandedTreeNodes", "expanded-tree-nodes-change"),
      _useDefaultValue2 = _slicedToArray(_useDefaultValue, 2),
      tExpandedTreeNode = _useDefaultValue2[0],
      setTExpandedTreeNode = _useDefaultValue2[1];
    var changedExpandTreeNode = VueCompositionAPI.ref({
      type: "props-change"
    });
    function expandAll() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "expand-all";
      var list = arguments.length > 1 ? arguments[1] : undefined;
      var newData = list || data.value;
      dataSource.value = store.value.expandAll(newData, rowDataKeys.value);
      var expandedNode = dataSource.value.map(function (t) {
        return getUniqueRowValue(t, rowDataKeys.value.rowKey);
      });
      setTExpandedTreeNode(expandedNode, {
        row: void 0,
        rowState: void 0,
        rowIndex: void 0,
        type: "expand",
        trigger: type
      });
      changedExpandTreeNode.value.type = "expand-all";
    }
    function foldAll() {
      dataSource.value = _toConsumableArray(store.value.foldAll(dataSource.value, rowDataKeys.value));
      setTExpandedTreeNode([], {
        row: void 0,
        rowState: void 0,
        rowIndex: void 0,
        type: "fold",
        trigger: "fold-all"
      });
    }
    function onExpandFoldIconClick(p, trigger) {
      var _props$onTreeExpandCh;
      var row = p.row,
        rowIndex = p.rowIndex;
      changedExpandTreeNode.value = _objectSpread$o({
        type: "user-reaction-change"
      }, p);
      var rowValue = getUniqueRowValue(row, rowDataKeys.value.rowKey);
      var rowState = store.value.treeDataMap.get(rowValue);
      var expandedNodes = _toConsumableArray(tExpandedTreeNode.value);
      if (rowState.expanded) {
        var expandedChildrenKeys = store.value.getExpandedChildrenKeys([row], rowDataKeys.value);
        for (var i = 0, len = expandedNodes.length; i < len; i++) {
          var nodeValue = expandedNodes[i];
          if (expandedChildrenKeys.includes(nodeValue)) {
            expandedNodes[i] = void 0;
          }
        }
        expandedNodes = expandedNodes.filter(Boolean);
      } else {
        expandedNodes.push(rowValue);
      }
      var params2 = {
        row: row,
        rowIndex: rowIndex,
        rowState: rowState,
        trigger: trigger
      };
      setTExpandedTreeNode(expandedNodes, _objectSpread$o(_objectSpread$o({}, params2), {}, {
        type: rowState.expanded ? "fold" : "expand"
      }));
      (_props$onTreeExpandCh = props.onTreeExpandChange) === null || _props$onTreeExpandCh === void 0 || _props$onTreeExpandCh.call(props, params2);
      context.emit("tree-expand-change", params2);
    }
    function updateExpandState(data2, tExpandedTreeNode2) {
      var oldExpandedTreeNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var _diffExpandedTreeNode = diffExpandedTreeNode(tExpandedTreeNode2, oldExpandedTreeNode),
        addedList = _diffExpandedTreeNode.addedList,
        removedList = _diffExpandedTreeNode.removedList;
      store.value.expandTreeNode(addedList, data2, rowDataKeys.value);
      store.value.foldTreeNode(removedList, data2, rowDataKeys.value);
      return data2;
    }
    VueCompositionAPI.watch([tExpandedTreeNode, data], function (_ref, _ref2) {
      var _ref3 = _slicedToArray(_ref, 1),
        tExpandedTreeNode2 = _ref3[0];
      var _ref4 = _slicedToArray(_ref2, 1),
        oldExpandedTreeNode = _ref4[0];
      if (!store.value.treeDataMap.size || !data.value.length) return;
      if (changedExpandTreeNode.value.type === "user-reaction-change") {
        var _ref5 = changedExpandTreeNode.value || {},
          row = _ref5.row,
          rowIndex = _ref5.rowIndex;
        dataSource.value = store.value.toggleExpandData({
          row: row,
          rowIndex: rowIndex
        }, dataSource.value, rowDataKeys.value);
      } else if (changedExpandTreeNode.value.type === "props-change") {
        updateExpandState(dataSource.value, tExpandedTreeNode2, oldExpandedTreeNode);
      }
      changedExpandTreeNode.value.type = "props-change";
    });
    var updateExpandOnDataChange = function updateExpandOnDataChange(data2) {
      var _tree$value, _tExpandedTreeNode$va;
      if ((_tree$value = tree.value) !== null && _tree$value !== void 0 && _tree$value.defaultExpandAll && !isDefaultExpandAllExecute.value) {
        expandAll("default-expand-all", _toConsumableArray(data2));
        isDefaultExpandAllExecute.value = true;
      } else if ((_tExpandedTreeNode$va = tExpandedTreeNode.value) !== null && _tExpandedTreeNode$va !== void 0 && _tExpandedTreeNode$va.length) {
        VueCompositionAPI.nextTick(function () {
          dataSource.value = updateExpandState(_toConsumableArray(data2), tExpandedTreeNode.value, []);
        });
      }
    };
    return {
      tExpandedTreeNode: tExpandedTreeNode,
      isDefaultExpandAllExecute: isDefaultExpandAllExecute,
      isDefaultExpandedTreeNodesExecute: isDefaultExpandedTreeNodesExecute,
      expandAll: expandAll,
      foldAll: foldAll,
      onExpandFoldIconClick: onExpandFoldIconClick,
      updateExpandOnDataChange: updateExpandOnDataChange
    };
  }

  function ownKeys$n(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$n(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$n(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$n(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function useTreeData(props, context) {
    var _toRefs = VueCompositionAPI.toRefs(props),
      data = _toRefs.data,
      columns = _toRefs.columns;
    var _useConfig = useConfig("table", props.locale),
      t = _useConfig.t,
      global = _useConfig.global;
    var _useGlobalIcon = useGlobalIcon({
        AddRectangleIcon: TdAddRectangleIcon,
        MinusRectangleIcon: TdMinusRectangleIcon
      }),
      AddRectangleIcon = _useGlobalIcon.AddRectangleIcon,
      MinusRectangleIcon = _useGlobalIcon.MinusRectangleIcon;
    var store = VueCompositionAPI.ref(new TableTreeStore());
    var treeNodeCol = VueCompositionAPI.shallowRef();
    var dataSource = VueCompositionAPI.ref([]);
    var _useClassName = useClassName(),
      tableTreeClasses = _useClassName.tableTreeClasses;
    var renderTNode = useTNodeDefault();
    var rowDataKeys = VueCompositionAPI.computed(function () {
      var _props$tree;
      return {
        rowKey: props.rowKey || "id",
        childrenKey: ((_props$tree = props.tree) === null || _props$tree === void 0 ? void 0 : _props$tree.childrenKey) || "children"
      };
    });
    var _useTreeDataExpand = useTreeDataExpand(props, context, {
        store: store,
        dataSource: dataSource,
        rowDataKeys: rowDataKeys
      }),
      tExpandedTreeNode = _useTreeDataExpand.tExpandedTreeNode,
      isDefaultExpandAllExecute = _useTreeDataExpand.isDefaultExpandAllExecute,
      isDefaultExpandedTreeNodesExecute = _useTreeDataExpand.isDefaultExpandedTreeNodesExecute,
      expandAll = _useTreeDataExpand.expandAll,
      foldAll = _useTreeDataExpand.foldAll,
      updateExpandOnDataChange = _useTreeDataExpand.updateExpandOnDataChange,
      onExpandFoldIconClick = _useTreeDataExpand.onExpandFoldIconClick;
    var checkedColumn = VueCompositionAPI.computed(function () {
      return columns.value.find(function (col) {
        return col.colKey === "row-select";
      });
    });
    VueCompositionAPI.watch(checkedColumn, function (column) {
      if (!store.value || !checkedColumn.value) return;
      store.value.updateDisabledState(dataSource.value, column, rowDataKeys.value);
    });
    function getFoldIcon(h, context2) {
      var params = _objectSpread$n(_objectSpread$n({}, context2), {}, {
        type: "fold"
      });
      var defaultFoldIcon = t(global.value.treeExpandAndFoldIcon, h, params) || h(MinusRectangleIcon);
      return renderTNode("treeExpandAndFoldIcon", {
        defaultNode: defaultFoldIcon,
        params: params
      });
    }
    function getExpandIcon(h, context2) {
      var params = _objectSpread$n(_objectSpread$n({}, context2), {}, {
        type: "expand"
      });
      var defaultExpandIcon = t(global.value.treeExpandAndFoldIcon, h, params) || h(AddRectangleIcon);
      return renderTNode("treeExpandAndFoldIcon", {
        defaultNode: defaultExpandIcon,
        params: params
      });
    }
    VueCompositionAPI.watch([data], function () {
      if (props.tree) {
        resetData(data.value);
      } else {
        dataSource.value = data.value;
      }
    }, {
      immediate: true
    });
    VueCompositionAPI.onUnmounted(function () {
      var _store$value$treeData;
      if (!props.tree) return;
      (_store$value$treeData = store.value.treeDataMap) === null || _store$value$treeData === void 0 || _store$value$treeData.clear();
      store.value = null;
    });
    VueCompositionAPI.watch(function () {
      var _props$tree2;
      return [columns.value, (_props$tree2 = props.tree) === null || _props$tree2 === void 0 ? void 0 : _props$tree2.treeNodeColumnIndex];
    }, function () {
      treeNodeCol.value = getTreeNodeColumnCol();
    }, {
      immediate: true
    });
    function resetData(data2) {
      var _tExpandedTreeNode$va;
      var columns2 = props.columns,
        expandedTreeNodes = props.expandedTreeNodes,
        defaultExpandedTreeNodes = props.defaultExpandedTreeNodes,
        tree = props.tree;
      store.value.initialTreeStore(data2, columns2, rowDataKeys.value);
      var defaultNeedExpand = Boolean(!isDefaultExpandedTreeNodesExecute.value && (defaultExpandedTreeNodes === null || defaultExpandedTreeNodes === void 0 ? void 0 : defaultExpandedTreeNodes.length));
      var needExpandAll = Boolean((tree === null || tree === void 0 ? void 0 : tree.defaultExpandAll) && !isDefaultExpandAllExecute.value);
      if ((_tExpandedTreeNode$va = tExpandedTreeNode.value) !== null && _tExpandedTreeNode$va !== void 0 && _tExpandedTreeNode$va.length && !!(expandedTreeNodes || defaultNeedExpand) || needExpandAll) {
        updateExpandOnDataChange(data2);
        isDefaultExpandedTreeNodesExecute.value = true;
      } else {
        dataSource.value = _toConsumableArray(data2);
      }
    }
    function getTreeNodeStyle(level) {
      var _props$tree3, _props$tree4;
      if (level === void 0) return;
      var indent = ((_props$tree3 = props.tree) === null || _props$tree3 === void 0 ? void 0 : _props$tree3.indent) === void 0 ? 24 : (_props$tree4 = props.tree) === null || _props$tree4 === void 0 ? void 0 : _props$tree4.indent;
      return indent ? {
        paddingLeft: "".concat(level * indent || 1, "px")
      } : {};
    }
    function toggleExpandData(p, trigger) {
      var _store$value, _props$onTreeExpandCh;
      var currentData = _objectSpread$n({}, p);
      if (p.row.__VIRTUAL_SCROLL_INDEX !== void 0) {
        currentData.rowIndex = p.row.__VIRTUAL_SCROLL_INDEX;
      }
      dataSource.value = _toConsumableArray(store.value.toggleExpandData(currentData, dataSource.value, rowDataKeys.value));
      var rowValue = get(p.row, rowDataKeys.value.rowKey);
      var rowState = (_store$value = store.value) === null || _store$value === void 0 || (_store$value = _store$value.treeDataMap) === null || _store$value === void 0 ? void 0 : _store$value.get(rowValue);
      var params = {
        row: p.row,
        rowIndex: p.rowIndex,
        rowState: rowState,
        trigger: trigger
      };
      (_props$onTreeExpandCh = props.onTreeExpandChange) === null || _props$onTreeExpandCh === void 0 || _props$onTreeExpandCh.call(props, params);
      context.emit("tree-expand-change", params);
    }
    function getTreeNodeColumnCol() {
      var _props$tree5;
      var columns2 = props.columns;
      var treeNodeColumnIndex = ((_props$tree5 = props.tree) === null || _props$tree5 === void 0 ? void 0 : _props$tree5.treeNodeColumnIndex) || 0;
      while ((_columns2$treeNodeCol = columns2[treeNodeColumnIndex]) !== null && _columns2$treeNodeCol !== void 0 && _columns2$treeNodeCol.type || ((_columns2$treeNodeCol2 = columns2[treeNodeColumnIndex]) === null || _columns2$treeNodeCol2 === void 0 ? void 0 : _columns2$treeNodeCol2.colKey) === "__EXPAND_ROW_ICON_COLUMN__") {
        var _columns2$treeNodeCol, _columns2$treeNodeCol2;
        treeNodeColumnIndex += 1;
      }
      return columns2[treeNodeColumnIndex];
    }
    function formatTreeColumn(col) {
      if (!props.tree || col.colKey !== treeNodeCol.value.colKey) return col;
      var newCol = _objectSpread$n({}, treeNodeCol.value);
      newCol.cell = function (h, p) {
        var cellInfo = renderCell(_objectSpread$n(_objectSpread$n({}, p), {}, {
          col: _objectSpread$n({}, treeNodeCol.value)
        }), context.slots, {
          cellEmptyContent: props.cellEmptyContent
        });
        var currentState = store.value.treeDataMap.get(get(p.row, rowDataKeys.value.rowKey));
        var colStyle = getTreeNodeStyle(currentState === null || currentState === void 0 ? void 0 : currentState.level);
        var classes = _defineProperty$2({}, tableTreeClasses.inlineCol, !!col.ellipsis);
        var childrenNodes = get(p.row, rowDataKeys.value.childrenKey);
        if (childrenNodes && childrenNodes instanceof Array || childrenNodes === true) {
          var _store$value$treeData2;
          var expanded = (_store$value$treeData2 = store.value.treeDataMap.get(get(p.row, rowDataKeys.value.rowKey))) === null || _store$value$treeData2 === void 0 ? void 0 : _store$value$treeData2.expanded;
          var iconNode = expanded ? getFoldIcon(h, p) : getExpandIcon(h, p);
          return h("div", {
            "class": [tableTreeClasses.col, classes],
            "style": colStyle
          }, [!!(childrenNodes.length || childrenNodes === true) && h("span", {
            "class": tableTreeClasses.icon,
            "on": {
              "click": function click(e) {
                onExpandFoldIconClick(p, "expand-fold-icon");
                e.stopPropagation();
              }
            }
          }, [iconNode]), cellInfo]);
        }
        return h("div", {
          "style": colStyle,
          "class": [classes, tableTreeClasses.leafNode]
        }, [h("span", {
          "class": tableTreeClasses.icon
        }), cellInfo]);
      };
      if (newCol.ellipsis === true) {
        newCol.ellipsis = function (h, p) {
          return renderCell(_objectSpread$n(_objectSpread$n({}, p), {}, {
            col: _objectSpread$n({}, treeNodeCol.value)
          }), context.slots);
        };
      }
      return newCol;
    }
    function setData(key, newRowData) {
      var rowIndex = store.value.updateData(key, newRowData, dataSource.value, rowDataKeys.value);
      var newData = _toConsumableArray(dataSource.value);
      newData[rowIndex] = newRowData;
      dataSource.value = newData;
    }
    function getData(key) {
      return store.value.getData(key);
    }
    function remove(key) {
      dataSource.value = _toConsumableArray(store.value.remove(key, dataSource.value, rowDataKeys.value));
    }
    function removeChildren(key) {
      dataSource.value = _toConsumableArray(store.value.removeChildren(key, dataSource.value, rowDataKeys.value));
    }
    function appendTo() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var newData = arguments.length > 1 ? arguments[1] : undefined;
      if (!key) {
        dataSource.value = store.value.appendToRoot(newData, dataSource.value, rowDataKeys.value);
        return;
      }
      dataSource.value = _toConsumableArray(store.value.appendTo(key, newData, dataSource.value, rowDataKeys.value));
    }
    function insertAfter(rowValue, newData) {
      dataSource.value = _toConsumableArray(store.value.insertAfter(rowValue, newData, dataSource.value, rowDataKeys.value));
    }
    function insertBefore(rowValue, newData) {
      dataSource.value = _toConsumableArray(store.value.insertBefore(rowValue, newData, dataSource.value, rowDataKeys.value));
    }
    function swapData(params) {
      var r = store.value.swapData(dataSource.value, params, rowDataKeys.value);
      if (r.result) {
        dataSource.value = _toConsumableArray(r.dataSource);
      } else {
        var _props$onAbnormalDrag;
        var params2 = {
          code: r.code,
          reason: r.reason
        };
        (_props$onAbnormalDrag = props.onAbnormalDragSort) === null || _props$onAbnormalDrag === void 0 || _props$onAbnormalDrag.call(props, params2);
        context.emit("abnormal-drag-sort", params2);
      }
    }
    function getTreeNode() {
      return store.value.getTreeNode(dataSource.value, rowDataKeys.value);
    }
    function getTreeExpandedRow() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "data";
      return store.value.getTreeExpandedRow(dataSource.value, rowDataKeys.value, type);
    }
    return {
      store: store,
      rowDataKeys: rowDataKeys,
      dataSource: dataSource,
      swapData: swapData,
      setData: setData,
      getData: getData,
      remove: remove,
      removeChildren: removeChildren,
      appendTo: appendTo,
      insertAfter: insertAfter,
      insertBefore: insertBefore,
      formatTreeColumn: formatTreeColumn,
      toggleExpandData: toggleExpandData,
      expandAll: expandAll,
      foldAll: foldAll,
      getTreeNode: getTreeNode,
      resetData: resetData,
      getTreeExpandedRow: getTreeExpandedRow,
      onExpandFoldIconClick: onExpandFoldIconClick
    };
  }

  function ownKeys$m(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$m(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$m(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$m(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var childrenMap = /* @__PURE__ */new Map();
  function getChildrenData(treeDataMap, data, keys, r) {
    if (childrenMap.get(data)) return childrenMap.get(data);
    var result = r || {
      allChildren: [],
      allChildrenKeys: [],
      leafNodeKeys: []
    };
    var children = get(data, keys.childrenKey);
    if (!children || !children.length) return result;
    var selectableChildren = children.filter(function (item) {
      var _treeDataMap$get;
      return !((_treeDataMap$get = treeDataMap.get(get(item, keys.rowKey))) !== null && _treeDataMap$get !== void 0 && _treeDataMap$get.disabled);
    });
    result.allChildren = _toConsumableArray(new Set(result.allChildren.concat(selectableChildren)));
    for (var i = 0, len = children.length; i < len; i++) {
      var tItem = children[i];
      var c = get(tItem, keys.childrenKey);
      if (c !== null && c !== void 0 && c.length) {
        var nextLevelData = getChildrenData(treeDataMap, tItem, keys, result);
        result.allChildren = _toConsumableArray(new Set(result.allChildren.concat(nextLevelData.allChildren)));
      }
    }
    for (var _i = 0, _len = result.allChildren.length; _i < _len; _i++) {
      var item = result.allChildren[_i];
      var children2 = get(item, keys.childrenKey);
      var rowValue = get(item, keys.rowKey);
      result.allChildrenKeys.push(rowValue);
      if (!children2 || !children2.length) {
        result.leafNodeKeys.push(rowValue);
      }
    }
    result.allChildrenKeys = _toConsumableArray(new Set(result.allChildrenKeys));
    result.leafNodeKeys = _toConsumableArray(new Set(result.leafNodeKeys));
    return result;
  }
  function removeChildrenKeys(p, r) {
    var selectedRowKeys = p.selectedRowKeys,
      removeKeys = p.removeKeys;
    var result = r || {
      data: [],
      keys: []
    };
    for (var i = 0, len = selectedRowKeys.length; i < len; i++) {
      var key = selectedRowKeys[i];
      if (!removeKeys.includes(key)) {
        result.keys.push(key);
      }
    }
    return result;
  }
  function getRowDataByKeys(p) {
    var treeDataMap = p.treeDataMap,
      selectedRowKeys = p.selectedRowKeys;
    var result = [];
    for (var i = 0, len = selectedRowKeys.length; i < len; i++) {
      var key = selectedRowKeys[i];
      result.push(treeDataMap.get(key));
    }
    return result;
  }
  function useTreeSelect(props, treeDataMap) {
    var _toRefs = VueCompositionAPI.toRefs(props),
      selectedRowKeys = _toRefs.selectedRowKeys,
      tree = _toRefs.tree,
      data = _toRefs.data,
      indeterminateSelectedRowKeys = _toRefs.indeterminateSelectedRowKeys;
    var tIndeterminateSelectedRowKeys = VueCompositionAPI.ref([]);
    var _useDefaultValue = useDefaultValue(selectedRowKeys, props.defaultSelectedRowKeys || [], props.onSelectChange, "selectedRowKeys", "select-change"),
      _useDefaultValue2 = _slicedToArray(_useDefaultValue, 2),
      tSelectedRowKeys = _useDefaultValue2[0],
      setTSelectedRowKeys = _useDefaultValue2[1];
    var rowDataKeys = VueCompositionAPI.computed(function () {
      var _props$tree;
      return {
        rowKey: props.rowKey || "id",
        childrenKey: ((_props$tree = props.tree) === null || _props$tree === void 0 ? void 0 : _props$tree.childrenKey) || "children"
      };
    });
    VueCompositionAPI.watch([tree, treeDataMap, data, tSelectedRowKeys], function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        tree2 = _ref2[0],
        treeDataMap2 = _ref2[1];
      if (!tree2 || !treeDataMap2.size || tree2.checkStrictly) return;
      updateIndeterminateState();
    });
    function updateIndeterminateState() {
      if (!tree.value || tree.value.checkStrictly) return;
      if (!tSelectedRowKeys.value.length) {
        tIndeterminateSelectedRowKeys.value = [];
        return;
      }
      var keys = [];
      var parentMap = {};
      for (var i = 0, len = tSelectedRowKeys.value.length; i < len; i++) {
        var rowValue = tSelectedRowKeys.value[i];
        var state = treeDataMap.value.get(rowValue);
        if (!state) continue;
        var children = get(state.row, rowDataKeys.value.childrenKey);
        if (!children || !children.length) {
          var parentTmp = state.parent;
          while (parentTmp) {
            if (!parentMap[parentTmp.id]) {
              parentMap[parentTmp.id] = [];
            }
            parentMap[parentTmp.id].push(state.row);
            var checkedLength = parentMap[parentTmp.id].length;
            var _getChildrenData = getChildrenData(treeDataMap.value, parentTmp.row, rowDataKeys.value),
              allChildrenKeys = _getChildrenData.allChildrenKeys;
            var parentTmpIndex = keys.indexOf(parentTmp.id);
            var selectedIndex = tSelectedRowKeys.value.indexOf(parentTmp.id);
            if (checkedLength > 0 && checkedLength < allChildrenKeys.length && selectedIndex === -1) {
              parentTmpIndex === -1 && keys.push(parentTmp.id);
            } else {
              parentTmpIndex !== -1 && keys.splice(parentTmpIndex, 1);
            }
            parentTmp = parentTmp.parent;
          }
        }
      }
      tIndeterminateSelectedRowKeys.value = keys;
    }
    function updateParentCheckedState(selectedKeys, currentRowKey, type) {
      if (!tree.value || tree.value.checkStrictly) return;
      var keys = _toConsumableArray(selectedKeys);
      var state = treeDataMap.value.get(currentRowKey);
      var parentTmp = state.parent;
      while (parentTmp) {
        var _getChildrenData2 = getChildrenData(treeDataMap.value, parentTmp.row, rowDataKeys.value),
          leafNodeKeys = _getChildrenData2.leafNodeKeys;
        var checkedChildrenKeys = intersection$1(leafNodeKeys, selectedKeys);
        var selectedIndex = keys.indexOf(parentTmp.id);
        if (type === "uncheck") {
          selectedIndex !== -1 && keys.splice(selectedIndex, 1);
        } else if (checkedChildrenKeys.length === leafNodeKeys.length) {
          selectedIndex === -1 && keys.push(parentTmp.id);
        }
        parentTmp = parentTmp.parent;
      }
      return keys;
    }
    function onInnerSelectChange(rowKeys, extraData) {
      if (!tree.value || tree.value.checkStrictly) {
        setTSelectedRowKeys(rowKeys, extraData);
        return;
      }
      if (extraData.currentRowKey === "CHECK_ALL_BOX") {
        handleSelectAll(extraData);
      } else {
        handleSelect(rowKeys, extraData);
      }
    }
    function handleSelectAll(extraData) {
      var newRowKeys = [];
      var newRowData = [];
      if (extraData.type === "check") {
        var arr = _toConsumableArray(treeDataMap.value.values());
        for (var i = 0, len = arr.length; i < len; i++) {
          var item = arr[i];
          if (!item.disabled) {
            newRowData.push(item.row);
            newRowKeys.push(get(item.row, rowDataKeys.value.rowKey));
          }
        }
      }
      var newExtraData = _objectSpread$m(_objectSpread$m({}, extraData), {}, {
        selectedRowData: newRowData || []
      });
      setTSelectedRowKeys(newRowKeys, newExtraData);
    }
    function handleSelect(rowKeys, extraData) {
      var _props$tree2;
      var newRowKeys = _toConsumableArray(rowKeys);
      if (((_props$tree2 = props.tree) === null || _props$tree2 === void 0 ? void 0 : _props$tree2.checkStrictly) === false) {
        if ((extraData === null || extraData === void 0 ? void 0 : extraData.type) === "check") {
          var result = getChildrenData(treeDataMap.value, extraData.currentRowData, rowDataKeys.value);
          var allChildrenKeys = result.allChildrenKeys;
          childrenMap.set(extraData.currentRowData, result);
          newRowKeys = _toConsumableArray(new Set(newRowKeys.concat(allChildrenKeys)));
        } else if ((extraData === null || extraData === void 0 ? void 0 : extraData.type) === "uncheck") {
          var children = getChildrenData(treeDataMap.value, extraData.currentRowData, rowDataKeys.value);
          var _result = removeChildrenKeys({
            selectedRowKeys: rowKeys,
            removeKeys: children.allChildrenKeys
          });
          newRowKeys = _result.keys;
        }
      }
      newRowKeys = updateParentCheckedState(newRowKeys, extraData.currentRowKey, extraData.type);
      var newRowData = getRowDataByKeys({
        treeDataMap: treeDataMap.value,
        selectedRowKeys: newRowKeys
      });
      var newExtraData = _objectSpread$m(_objectSpread$m({}, extraData), {}, {
        selectedRowData: newRowData
      });
      setTSelectedRowKeys(newRowKeys, newExtraData);
    }
    return {
      tIndeterminateSelectedRowKeys: indeterminateSelectedRowKeys.value ? indeterminateSelectedRowKeys : tIndeterminateSelectedRowKeys,
      onInnerSelectChange: onInnerSelectChange
    };
  }

  var _excluded$1 = ["store", "dataSource", "formatTreeColumn", "swapData", "onExpandFoldIconClick"];
  function ownKeys$l(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$l(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$l(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$l(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var PRIMARY_B_EVENTS = ["cell-click", "change", "page-change", "expand-change", "filter-change", "select-change", "sort-change", "data-change", "async-loading-click", "column-change", "column-controller-visible-change", "display-columns-change", "drag-sort", "row-edit", "row-validate", "validate"];
  var PRIMARY_ALL_EVENTS = BASE_TABLE_ALL_EVENTS.concat(PRIMARY_B_EVENTS);
  var _EnhancedTable = VueCompositionAPI.defineComponent({
    name: "TEnhancedTable",
    props: _objectSpread$l(_objectSpread$l(_objectSpread$l({}, baseTableProps), primaryTableProps), enhancedTableProps),
    setup: function setup(props, context) {
      var primaryTableRef = VueCompositionAPI.ref();
      var classPrefix = usePrefixClass();
      var _useTreeData = useTreeData(props, context),
        store = _useTreeData.store,
        dataSource = _useTreeData.dataSource,
        formatTreeColumn = _useTreeData.formatTreeColumn,
        swapData = _useTreeData.swapData,
        onExpandFoldIconClick = _useTreeData.onExpandFoldIconClick,
        treeInstanceFunctions = _objectWithoutProperties$2(_useTreeData, _excluded$1);
      var treeDataMap = VueCompositionAPI.ref(store.value.treeDataMap);
      var _useTreeSelect = useTreeSelect(props, treeDataMap),
        tIndeterminateSelectedRowKeys = _useTreeSelect.tIndeterminateSelectedRowKeys,
        onInnerSelectChange = _useTreeSelect.onInnerSelectChange;
      var _getColumns = function getColumns(columns) {
        var arr = [];
        for (var i = 0, len = columns.length; i < len; i++) {
          var _item$children, _item$children2;
          var item = _objectSpread$l({}, columns[i]);
          item = formatTreeColumn(item);
          if ((_item$children = item.children) !== null && _item$children !== void 0 && _item$children.length) {
            item.children = _getColumns(item.children);
          }
          if (!item.children || (_item$children2 = item.children) !== null && _item$children2 !== void 0 && _item$children2.length) {
            arr.push(item);
          }
        }
        return arr;
      };
      var tColumns = VueCompositionAPI.computed(function () {
        var isTreeData = !props.tree || !Object.keys(props.tree).length;
        return isTreeData ? props.columns : _getColumns(props.columns);
      });
      var onDragSortChange = function onDragSortChange(params) {
        var _props$onDragSort;
        if (props.beforeDragSort && !props.beforeDragSort(params)) return;
        swapData({
          current: params.current,
          target: params.target,
          currentIndex: params.currentIndex,
          targetIndex: params.targetIndex
        });
        (_props$onDragSort = props.onDragSort) === null || _props$onDragSort === void 0 || _props$onDragSort.call(props, params);
        context.emit("drag-sort", params);
      };
      var onEnhancedTableRowClick = function onEnhancedTableRowClick(p) {
        var _props$tree, _props$onRowClick;
        if ((_props$tree = props.tree) !== null && _props$tree !== void 0 && _props$tree.expandTreeNodeOnClick) {
          onExpandFoldIconClick({
            row: p.row,
            rowIndex: p.index
          }, "row-click");
        }
        (_props$onRowClick = props.onRowClick) === null || _props$onRowClick === void 0 || _props$onRowClick.call(props, p);
        context.emit("row-click", p);
      };
      var _getScrollRowIndex = function getScrollRowIndex(rowStateData, key) {
        if (!rowStateData) return -1;
        if (rowStateData.rowIndex >= 0) return rowStateData.rowIndex;
        if (rowStateData.rowIndex < 0) {
          return _getScrollRowIndex(rowStateData.parent);
        }
      };
      var scrollToElement = function scrollToElement(params) {
        var index = params.index;
        if (!index && index !== 0) {
          if (!params.key) {
            log.error("Table", "scrollToElement: one of `index` or `key` must exist.");
            return;
          }
          var rowStateData = treeDataMap.value.get(params.key);
          index = _getScrollRowIndex(rowStateData, params.key);
          if (index < 0 || index === void 0) {
            log.error("Table", "".concat(params.key, " does not exist in data, check `rowKey` or `data` please."));
          }
        }
        primaryTableRef.value.scrollToElement(_objectSpread$l(_objectSpread$l({}, params), {}, {
          index: index
        }));
      };
      return _objectSpread$l(_objectSpread$l({
        store: store,
        classPrefix: classPrefix,
        dataSource: dataSource,
        tColumns: tColumns,
        treeDataMap: treeDataMap,
        tIndeterminateSelectedRowKeys: tIndeterminateSelectedRowKeys,
        enhancedTableRef: primaryTableRef,
        primaryTableRef: primaryTableRef,
        onDragSortChange: onDragSortChange,
        onInnerSelectChange: onInnerSelectChange,
        onEnhancedTableRowClick: onEnhancedTableRowClick
      }, treeInstanceFunctions), {}, {
        scrollToElement: scrollToElement
      });
    },
    methods: {
      getListener: function getListener() {
        var _this = this;
        var listeners = {};
        PRIMARY_ALL_EVENTS.forEach(function (key) {
          listeners[key] = function () {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            _this.$emit.apply(_this, [key].concat(args));
            if (key === "display-columns-change") {
              _this.$emit.apply(_this, ["update:displayColumns"].concat(args));
            }
          };
        });
        return listeners;
      },
      getRowClassName: function getRowClassName(_ref) {
        var row = _ref.row;
        var rowValue = get(row, this.rowKey || "id");
        var rowState = this.treeDataMap.get(rowValue);
        if (!rowState) return [this.rowClassName];
        return ["".concat(this.classPrefix, "-table-tr--level-").concat(rowState.level), this.rowClassName];
      }
    },
    render: function render() {
      var _this$tree;
      var h = arguments[0];
      var props = _objectSpread$l(_objectSpread$l({
        rowKey: this.rowKey || "id"
      }, this.$options.propsData), {}, {
        data: this.dataSource,
        columns: this.tColumns,
        indeterminateSelectedRowKeys: this.tIndeterminateSelectedRowKeys,
        disableDataPage: Boolean(this.tree && Object.keys(this.tree).length),
        rowClassName: this.getRowClassName
      });
      var on = _objectSpread$l(_objectSpread$l({}, this.getListener()), {}, {
        "select-change": this.onInnerSelectChange,
        "drag-sort": this.onDragSortChange
      });
      if ((_this$tree = this.tree) !== null && _this$tree !== void 0 && _this$tree.expandTreeNodeOnClick) {
        on["row-click"] = this.onEnhancedTableRowClick;
      }
      return h(_PrimaryTable, helper([{
        "ref": "primaryTableRef",
        "scopedSlots": this.$scopedSlots
      }, {
        "props": props
      }, {}, {
        "on": on
      }, {}, this.$attrs]));
    }
  });

  function ownKeys$k(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$k(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$k(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$k(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var BaseTable = withInstall$1(_BaseTable, VueCompositionAPI__default["default"]);
  var PrimaryTable = withInstall$1(_PrimaryTable, VueCompositionAPI__default["default"]);
  var EnhancedTable = withInstall$1(_EnhancedTable, VueCompositionAPI__default["default"]);
  var Table = withInstall$1(_objectSpread$k(_objectSpread$k({}, _PrimaryTable), {}, {
    name: "TTable"
  }), VueCompositionAPI__default["default"]);

  function ownKeys$j(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$j(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$j(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$j(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function generateBase64Url(_ref, onFinish) {
    var width = _ref.width,
      height = _ref.height,
      gapX = _ref.gapX,
      gapY = _ref.gapY,
      offsetLeft = _ref.offsetLeft,
      offsetTop = _ref.offsetTop,
      rotate = _ref.rotate,
      alpha = _ref.alpha,
      watermarkContent = _ref.watermarkContent,
      lineSpace = _ref.lineSpace;
    var canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");
    if (!ctx) {
      console.warn("\u5F53\u524D\u73AF\u5883\u4E0D\u652F\u6301Canvas, \u65E0\u6CD5\u7ED8\u5236\u6C34\u5370");
      onFinish("");
      return;
    }
    var ratio = window.devicePixelRatio || 1;
    var canvasWidth = (gapX + width) * ratio;
    var canvasHeight = (gapY + height) * ratio;
    canvas.width = canvasWidth;
    canvas.height = canvasHeight;
    canvas.style.width = "".concat(gapX + width, "px");
    canvas.style.height = "".concat(gapY + height, "px");
    ctx.translate(offsetLeft * ratio, offsetTop * ratio);
    ctx.rotate(Math.PI / 180 * Number(rotate));
    ctx.globalAlpha = alpha;
    var markWidth = width * ratio;
    var markHeight = height * ratio;
    ctx.fillStyle = "transparent";
    ctx.fillRect(0, 0, markWidth, markHeight);
    var contents = Array.isArray(watermarkContent) ? watermarkContent : [_objectSpread$j({}, watermarkContent)];
    var top = 0;
    contents.forEach(function (item) {
      if (item.url) {
        var url = item.url,
          _item$isGrayscale = item.isGrayscale,
          isGrayscale = _item$isGrayscale === void 0 ? false : _item$isGrayscale;
        item.top = top;
        top += height;
        var img = new Image();
        img.crossOrigin = "anonymous";
        img.referrerPolicy = "no-referrer";
        img.src = url;
        img.onload = function () {
          ctx.drawImage(img, 0, item.top * ratio, width * ratio, height * ratio);
          if (isGrayscale) {
            var imgData = ctx.getImageData(0, 0, ctx.canvas.width, ctx.canvas.height);
            var pixels = imgData.data;
            for (var i = 0; i < pixels.length; i += 4) {
              var lightness = (pixels[i] + pixels[i + 1] + pixels[i + 2]) / 3;
              pixels[i] = lightness;
              pixels[i + 1] = lightness;
              pixels[i + 2] = lightness;
            }
            ctx.putImageData(imgData, 0, 0);
          }
          onFinish(canvas.toDataURL());
        };
      } else if (item.text) {
        var text = item.text,
          _item$fontColor = item.fontColor,
          fontColor = _item$fontColor === void 0 ? "rgba(0, 0, 0, 0.1)" : _item$fontColor,
          _item$fontSize = item.fontSize,
          fontSize = _item$fontSize === void 0 ? 16 : _item$fontSize,
          _item$fontFamily = item.fontFamily,
          fontFamily = _item$fontFamily === void 0 ? void 0 : _item$fontFamily,
          _item$fontWeight = item.fontWeight,
          fontWeight = _item$fontWeight === void 0 ? "normal" : _item$fontWeight;
        item.top = top;
        top += lineSpace;
        var markSize = Number(fontSize) * ratio;
        ctx.font = "normal normal ".concat(fontWeight, " ").concat(markSize, "px/").concat(markHeight, "px ").concat(fontFamily);
        ctx.textAlign = "start";
        ctx.textBaseline = "top";
        ctx.fillStyle = fontColor;
        ctx.fillText(text, 0, item.top * ratio);
      }
    });
    onFinish(canvas.toDataURL());
  }

  function randomMovingStyle() {
    var align = Math.floor(Math.random() * 4);
    var p1 = Math.floor(Math.random() * 70) + 30;
    var leftTopLimit = 0;
    var bottomLimit = 95;
    var rightLimit = 90;
    var keyframesStyle = "\n  @keyframes watermark {\n    0%   {left: ".concat(align === 1 ? rightLimit : align === 3 ? leftTopLimit : p1, "%; top: ").concat(align === 0 ? leftTopLimit : align === 2 ? bottomLimit : p1, "%;}\n    25% {left: ").concat(align === 0 ? rightLimit : align === 2 ? leftTopLimit : 100 - p1, "%; top: ").concat(align === 1 ? bottomLimit : align === 3 ? leftTopLimit : p1, "%;}\n    50% {left: ").concat(align === 1 ? leftTopLimit : align === 3 ? rightLimit : 100 - p1, "%; top: ").concat(align === 0 ? bottomLimit : align === 2 ? leftTopLimit : 100 - p1, "%; transform: translateX(-100%);}\n    75% {left: ").concat(align === 0 ? leftTopLimit : align === 2 ? rightLimit : p1, "%; top: ").concat(align === 1 ? leftTopLimit : align === 3 ? bottomLimit : 100 - p1, "%;}\n    100% {left: ").concat(align === 1 ? rightLimit : align === 3 ? leftTopLimit : p1, "%; top: ").concat(align === 0 ? leftTopLimit : align === 2 ? bottomLimit : p1, "%;}\n  }\n  ");
    return keyframesStyle;
  }

  var injectStyle = function injectStyle(style) {
    var styleElement = document.createElement("style");
    var styleSheet = null;
    document.head.appendChild(styleElement);
    styleSheet = styleElement.sheet;
    styleSheet.insertRule(style, styleSheet.cssRules.length);
  };

  var _excluded = ["window"];
  var defaultWindow = typeof window !== "undefined" ? window : void 0;
  function unrefElement(elRef) {
    var _plain$$el;
    var plain = VueCompositionAPI.unref(elRef);
    return (_plain$$el = plain === null || plain === void 0 ? void 0 : plain.$el) !== null && _plain$$el !== void 0 ? _plain$$el : plain;
  }
  function tryOnScopeDispose(fn) {
    if (VueCompositionAPI.getCurrentScope()) {
      VueCompositionAPI.onScopeDispose(fn);
      return true;
    }
    return false;
  }
  function useMutationObserver(target, callback) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _options$window = options.window,
      window2 = _options$window === void 0 ? defaultWindow : _options$window,
      mutationOptions = _objectWithoutProperties$2(options, _excluded);
    var observer;
    var isSupported = window2 && "MutationObserver" in window2;
    var cleanup = function cleanup() {
      if (observer) {
        observer.disconnect();
        observer = void 0;
      }
    };
    var stopWatch = VueCompositionAPI.watch(function () {
      return unrefElement(target);
    }, function (el) {
      cleanup();
      if (isSupported && window2 && el) {
        observer = new MutationObserver(callback);
        observer.observe(el, mutationOptions);
      }
    }, {
      immediate: true
    });
    var stop = function stop() {
      cleanup();
      stopWatch();
    };
    tryOnScopeDispose(stop);
    return {
      isSupported: isSupported,
      stop: stop
    };
  }

  var props$9 = {
    alpha: {
      type: Number,
      "default": 1
    },
    content: {
      type: [String, Function]
    },
    "default": {
      type: [String, Function]
    },
    height: {
      type: Number
    },
    isRepeat: {
      type: Boolean,
      "default": true
    },
    lineSpace: {
      type: Number,
      "default": 16
    },
    movable: Boolean,
    moveInterval: {
      type: Number,
      "default": 3e3
    },
    offset: {
      type: Array
    },
    removable: {
      type: Boolean,
      "default": true
    },
    rotate: {
      type: Number,
      "default": -22
    },
    watermarkContent: {
      type: [Object, Array]
    },
    width: {
      type: Number
    },
    x: {
      type: Number
    },
    y: {
      type: Number
    },
    zIndex: {
      type: Number
    }
  };

  function ownKeys$i(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$i(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$i(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$i(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _Watermark = VueCompositionAPI.defineComponent({
    name: "TWatermark",
    props: props$9,
    setup: function setup(props2) {
      var backgroundImage = VueCompositionAPI.ref("");
      var watermarkRef = VueCompositionAPI.ref();
      var watermarkContentRef = VueCompositionAPI.ref();
      var parent = VueCompositionAPI.ref();
      var gapX = VueCompositionAPI.computed(function () {
        return props2.movable ? 0 : props2.x;
      });
      var gapY = VueCompositionAPI.computed(function () {
        return props2.movable ? 0 : props2.y;
      });
      var rotate = VueCompositionAPI.computed(function () {
        return props2.movable ? 0 : props2.rotate;
      });
      var backgroundRepeat = VueCompositionAPI.computed(function () {
        if (props2.movable) {
          return "no-repeat";
        }
        return props2.isRepeat ? "repeat" : "no-repeat";
      });
      var offsetLeft = VueCompositionAPI.computed(function () {
        var _props2$offset;
        return ((_props2$offset = props2.offset) === null || _props2$offset === void 0 ? void 0 : _props2$offset[0]) || gapX.value / 2;
      });
      var offsetTop = VueCompositionAPI.computed(function () {
        var _props2$offset2;
        return ((_props2$offset2 = props2.offset) === null || _props2$offset2 === void 0 ? void 0 : _props2$offset2[1]) || gapY.value / 2;
      });
      var bgImageOptions = {
        width: props2.width,
        height: props2.height,
        rotate: rotate.value,
        lineSpace: props2.lineSpace,
        alpha: props2.alpha,
        gapX: gapX.value,
        gapY: gapY.value,
        watermarkContent: props2.watermarkContent,
        offsetLeft: offsetLeft.value,
        offsetTop: offsetTop.value
      };
      VueCompositionAPI.onMounted(function () {
        var _watermarkRef$value;
        generateBase64Url(bgImageOptions, function (base64Url) {
          backgroundImage.value = base64Url;
        });
        parent.value = (_watermarkRef$value = watermarkRef.value) === null || _watermarkRef$value === void 0 ? void 0 : _watermarkRef$value.parentElement;
        var keyframesStyle = randomMovingStyle();
        injectStyle(keyframesStyle);
        useMutationObserver(parent.value, function (mutations) {
          if (props2.removable) return;
          mutations.forEach(function (mutation) {
            if (mutation.type === "childList") {
              var removeNodes = mutation.removedNodes;
              removeNodes.forEach(function (node) {
                var element = node;
                if (element === watermarkRef.value) {
                  parent.value.appendChild(element);
                }
                if (element === watermarkContentRef.value) {
                  watermarkRef.value.appendChild(element);
                }
              });
            }
          });
        }, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      });
      return {
        gapX: gapX,
        gapY: gapY,
        backgroundRepeat: backgroundRepeat,
        backgroundImage: backgroundImage,
        watermarkRef: watermarkRef,
        watermarkContentRef: watermarkContentRef,
        bgImageOptions: bgImageOptions
      };
    },
    watch: {
      watermarkContent: function watermarkContent(content) {
        var _this = this;
        generateBase64Url(_objectSpread$i(_objectSpread$i({}, this.bgImageOptions), {}, {
          watermarkContent: content
        }), function (base64Url) {
          _this.backgroundImage = base64Url;
        });
      }
    },
    render: function render() {
      var h = arguments[0];
      var COMPONENT_NAME = usePrefixClass("watermark");
      var renderContent = useContent();
      return h("div", {
        "style": {
          position: "relative",
          overflow: "hidden",
          width: "100%"
        },
        "class": COMPONENT_NAME.value,
        "ref": "watermarkRef"
      }, [renderContent("default", "content"), h("div", {
        "ref": "watermarkContentRef",
        "style": {
          zIndex: this.zIndex,
          position: "absolute",
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          width: "100%",
          height: "100%",
          backgroundSize: "".concat(this.gapX + this.width, "px"),
          pointerEvents: "none",
          backgroundRepeat: this.backgroundRepeat,
          backgroundImage: "url('".concat(this.backgroundImage, "')"),
          animation: this.movable ? "watermark infinite ".concat(this.moveInterval * 4 / 60, "s") : "none"
        }
      })]);
    }
  });

  var Watermark = withInstall$1(_Watermark, VueCompositionAPI__default["default"]);

  var props$8 = {
    borderless: Boolean,
    defaultExpandAll: Boolean,
    disabled: Boolean,
    expandIcon: {
      type: [Boolean, Function],
      "default": true
    },
    expandIconPlacement: {
      type: String,
      "default": "left",
      validator: function validator(val) {
        if (!val) return true;
        return ["left", "right"].includes(val);
      }
    },
    expandMutex: Boolean,
    expandOnRowClick: {
      type: Boolean,
      "default": true
    },
    value: {
      type: Array,
      "default": void 0
    },
    defaultValue: {
      type: Array
    },
    onChange: Function
  };

  var _Collapse = VueCompositionAPI.defineComponent({
    name: "TCollapse",
    props: props$8,
    setup: function setup(props2) {
      var componentName = usePrefixClass("collapse");
      var borderlessClass = usePrefixClass("-border-less");
      var _toRefs = VueCompositionAPI.toRefs(props2),
        value = _toRefs.value,
        expandMutex = _toRefs.expandMutex,
        borderless = _toRefs.borderless;
      var _useVModel = useVModel$1(value, props2.defaultValue, props2.onChange, "change"),
        _useVModel2 = _slicedToArray(_useVModel, 2),
        collapseValue = _useVModel2[0],
        setCollapseValue = _useVModel2[1];
      var updateCollapseValue = function updateCollapseValue(value2) {
        var newValue = [].concat(collapseValue.value || []);
        var index = newValue.indexOf(value2);
        if (index >= 0) {
          newValue.splice(index, 1);
        } else if (expandMutex.value) {
          newValue = [value2];
        } else {
          newValue.push(value2);
        }
        setCollapseValue(newValue);
      };
      var classes = VueCompositionAPI.computed(function () {
        return [componentName.value, _defineProperty$2({}, borderlessClass.value, !!borderless.value)];
      });
      var getUniqId = function () {
        var index = 0;
        return function () {
          return index += 1;
        };
      }();
      VueCompositionAPI.provide("collapseValue", collapseValue);
      VueCompositionAPI.provide("updateCollapseValue", updateCollapseValue);
      VueCompositionAPI.provide("collapseProps", VueCompositionAPI.toRefs(props2));
      VueCompositionAPI.provide("getUniqId", getUniqId);
      VueCompositionAPI.provide("renderParentTNode", useTNodeJSX());
      return {
        classes: classes
      };
    },
    render: function render() {
      var _this$$scopedSlots, _this$$scopedSlots$de;
      var h = arguments[0];
      var nodes = ((_this$$scopedSlots = this.$scopedSlots) === null || _this$$scopedSlots === void 0 || (_this$$scopedSlots$de = _this$$scopedSlots["default"]) === null || _this$$scopedSlots$de === void 0 ? void 0 : _this$$scopedSlots$de.call(_this$$scopedSlots, {})) || null;
      return h("div", {
        "class": this.classes
      }, [nodes]);
    }
  });

  var props$7 = {
    content: {
      type: [String, Function]
    },
    "default": {
      type: [String, Function]
    },
    destroyOnCollapse: Boolean,
    disabled: {
      type: Boolean,
      "default": void 0
    },
    expandIcon: {
      type: [Boolean, Function],
      "default": void 0
    },
    header: {
      type: [String, Function]
    },
    headerRightContent: {
      type: [String, Function]
    },
    value: {
      type: [String, Number]
    }
  };

  var _CollapsePanel = VueCompositionAPI.defineComponent({
    name: "TCollapsePanel",
    props: props$7,
    setup: function setup(props2, _ref) {
      var slots = _ref.slots;
      var _toRefs = VueCompositionAPI.toRefs(props2),
        value = _toRefs.value,
        disabled = _toRefs.disabled;
      var componentName = usePrefixClass("collapse-panel");
      var disableClass = usePrefixClass("is-disabled");
      var clickableClass = usePrefixClass("is-clickable");
      var transitionClass = usePrefixClass("slide-down");
      var collapseValue = VueCompositionAPI.inject("collapseValue");
      var updateCollapseValue = VueCompositionAPI.inject("updateCollapseValue");
      var getUniqId = VueCompositionAPI.inject("getUniqId", function () {
        return void 0;
      }, false);
      var _inject = VueCompositionAPI.inject("collapseProps"),
        defaultExpandAll = _inject.defaultExpandAll,
        disableAll = _inject.disabled,
        expandIconPlacement = _inject.expandIconPlacement,
        expandOnRowClick = _inject.expandOnRowClick;
      var renderParentTNode = VueCompositionAPI.inject("renderParentTNode");
      var innerValue = value.value === void 0 ? getUniqId() : value.value;
      if (defaultExpandAll.value) {
        updateCollapseValue(innerValue);
      }
      var isDisabled = VueCompositionAPI.computed(function () {
        return disabled.value || disableAll.value;
      });
      var isActive = VueCompositionAPI.computed(function () {
        return collapseValue.value instanceof Array ? collapseValue.value.includes(innerValue) : collapseValue.value === innerValue;
      });
      var classes = VueCompositionAPI.computed(function () {
        return [componentName.value, _defineProperty$2({}, disableClass.value, isDisabled.value)];
      });
      var panelExpandIcon = VueCompositionAPI.computed(function () {
        return slots.expandIcon || props2.expandIcon;
      });
      var renderTNodeJSX = useTNodeJSX();
      var renderContent = useContent();
      return {
        isDisabled: isDisabled,
        classes: classes,
        isActive: isActive,
        updateCollapseValue: updateCollapseValue,
        innerValue: innerValue,
        expandIconPlacement: expandIconPlacement,
        expandOnRowClick: expandOnRowClick,
        componentName: componentName,
        clickableClass: clickableClass,
        transitionClass: transitionClass,
        panelExpandIcon: panelExpandIcon,
        renderParentTNode: renderParentTNode,
        renderTNodeJSX: renderTNodeJSX,
        renderContent: renderContent
      };
    },
    methods: {
      renderDefaultIcon: function renderDefaultIcon() {
        var h = this.$createElement;
        var componentName = this.componentName;
        return h(FakeArrow, {
          "attrs": {
            "overlayClassName": "".concat(componentName, "__icon--default")
          }
        });
      },
      renderIcon: function renderIcon() {
        var h = this.$createElement;
        var panelExpandIcon = this.panelExpandIcon,
          renderParentTNode = this.renderParentTNode,
          componentName = this.componentName,
          expandIconPlacement = this.expandIconPlacement,
          isActive = this.isActive,
          handleClick = this.handleClick,
          renderDefaultIcon = this.renderDefaultIcon,
          renderTNodeJSX = this.renderTNodeJSX;
        var tNodeRender = panelExpandIcon === void 0 ? renderParentTNode : renderTNodeJSX;
        return h("div", {
          "ref": "iconRef",
          "class": "".concat(componentName, "__icon ").concat(componentName, "__icon--").concat(expandIconPlacement, " ").concat(isActive ? "".concat(componentName, "__icon--active") : ""),
          "on": {
            "click": handleClick
          }
        }, [tNodeRender("expandIcon", renderDefaultIcon())]);
      },
      renderHeader: function renderHeader() {
        var h = this.$createElement;
        var isDisabled = this.isDisabled,
          handleClick = this.handleClick,
          renderIcon = this.renderIcon,
          renderBlank = this.renderBlank;
        var cls = ["".concat(this.componentName, "__header"), _defineProperty$2({}, this.clickableClass, this.expandOnRowClick && !isDisabled)];
        return h("div", {
          "class": cls,
          "on": {
            "click": handleClick
          }
        }, [h("div", {
          "class": "".concat(this.componentName, "__header-left")
        }, [this.expandIconPlacement === "left" && renderIcon()]), h("div", {
          "class": "".concat(this.componentName, "__header-content")
        }, [this.renderTNodeJSX("header")]), renderBlank(), h("div", {
          "class": "".concat(this.componentName, "__header-right")
        }, [h("div", {
          "class": "".concat(this.componentName, "__header-right-content"),
          "on": {
            "click": function click(e) {
              return e.stopPropagation();
            }
          }
        }, [this.renderTNodeJSX("headerRightContent")]), this.expandIconPlacement === "right" && renderIcon()])]);
      },
      renderBlank: function renderBlank() {
        var h = this.$createElement;
        return h("div", {
          "class": "".concat(this.componentName, "__header--blank")
        });
      },
      renderBody: function renderBody() {
        return this.destroyOnCollapse ? this.renderBodyDestroyOnCollapse() : this.renderBodyByNormal();
      },
      renderBodyByNormal: function renderBodyByNormal() {
        var h = this.$createElement;
        return h("div", {
          "directives": [{
            name: "show",
            value: this.isActive
          }],
          "class": "".concat(this.componentName, "__body")
        }, [h("div", {
          "class": "".concat(this.componentName, "__content")
        }, [this.renderContent("default", "content")])]);
      },
      renderBodyDestroyOnCollapse: function renderBodyDestroyOnCollapse() {
        var h = this.$createElement;
        return this.isActive ? h("div", {
          "class": "".concat(this.componentName, "__body")
        }, [h("div", {
          "class": "".concat(this.componentName, "__content")
        }, [this.renderContent("default", "content")])]) : null;
      },
      handleClick: function handleClick(e) {
        var expandOnRowClick = this.expandOnRowClick,
          updateCollapseValue = this.updateCollapseValue,
          innerValue = this.innerValue,
          isDisabled = this.isDisabled;
        var canExpand = expandOnRowClick || e.currentTarget === this.$refs.iconRef;
        if (canExpand && !isDisabled) {
          updateCollapseValue(innerValue);
        }
        e.stopPropagation();
      }
    },
    render: function render() {
      var h = arguments[0];
      var _useCollapseAnimation = useCollapseAnimation(),
        beforeEnter = _useCollapseAnimation.beforeEnter,
        enter = _useCollapseAnimation.enter,
        afterEnter = _useCollapseAnimation.afterEnter,
        beforeLeave = _useCollapseAnimation.beforeLeave,
        leave = _useCollapseAnimation.leave,
        afterLeave = _useCollapseAnimation.afterLeave;
      var classes = this.classes;
      return h("div", {
        "class": classes
      }, [h("div", {
        "class": "".concat(this.componentName, "__wrapper")
      }, [this.renderHeader(), h("transition", {
        "attrs": {
          "name": this.transitionClass
        },
        "on": {
          "beforeEnter": beforeEnter,
          "enter": enter,
          "afterEnter": afterEnter,
          "beforeLeave": beforeLeave,
          "leave": leave,
          "afterLeave": afterLeave
        }
      }, [this.renderBody()])])]);
    }
  });

  var Collapse = withInstall$1(_Collapse);
  var CollapsePanel = withInstall$1(_CollapsePanel);

  var props$6 = {
    allowHalf: Boolean,
    clearable: Boolean,
    color: {
      type: [String, Array],
      "default": "#ED7B2F"
    },
    count: {
      type: Number,
      "default": 5
    },
    disabled: {
      type: Boolean,
      "default": void 0
    },
    gap: {
      type: Number,
      "default": 4
    },
    icon: {
      type: Function
    },
    showText: Boolean,
    size: {
      type: String,
      "default": "24px"
    },
    texts: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    value: {
      type: Number,
      "default": void 0
    },
    defaultValue: {
      type: Number,
      "default": 0
    },
    onChange: Function
  };

  function ownKeys$h(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$h(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$h(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$h(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _Rate = VueCompositionAPI.defineComponent({
    name: "TRate",
    props: _objectSpread$h({}, props$6),
    setup: function setup(props2) {
      var activeColor = Array.isArray(props2.color) ? props2.color[0] : props2.color;
      var defaultColor = Array.isArray(props2.color) ? props2.color[1] : "var(--td-bg-color-component)";
      var _toRefs = VueCompositionAPI.toRefs(props2),
        inputValue = _toRefs.value;
      var _useVModel = useVModel$1(inputValue, props2.defaultValue, props2.onChange, "change"),
        _useVModel2 = _slicedToArray(_useVModel, 2),
        starValue = _useVModel2[0],
        setStarValue = _useVModel2[1];
      var hoverValue = VueCompositionAPI.ref(void 0);
      var rootRef = VueCompositionAPI.ref();
      var _useConfig = useConfig("classPrefix"),
        classPrefix = _useConfig.classPrefix;
      var _useConfig2 = useConfig("rate"),
        global = _useConfig2.global;
      var displayValue = VueCompositionAPI.computed(function () {
        return Number(hoverValue.value || starValue.value);
      });
      var displayText = VueCompositionAPI.computed(function () {
        return props2.texts.length === 0 ? global.value.rateText : props2.texts;
      });
      var getStarValue = function getStarValue(event, index) {
        if (props2.allowHalf) {
          var _rootRef$value, _rootRef$value$getBou2, _firstStar$getBoundin2;
          var _rootRef$value$getBou = (_rootRef$value = rootRef.value) === null || _rootRef$value === void 0 || (_rootRef$value$getBou2 = _rootRef$value.getBoundingClientRect) === null || _rootRef$value$getBou2 === void 0 ? void 0 : _rootRef$value$getBou2.call(_rootRef$value),
            left = _rootRef$value$getBou.left;
          var firstStar = rootRef.value.firstChild.nextSibling;
          var _firstStar$getBoundin = firstStar === null || firstStar === void 0 || (_firstStar$getBoundin2 = firstStar.getBoundingClientRect) === null || _firstStar$getBoundin2 === void 0 ? void 0 : _firstStar$getBoundin2.call(firstStar),
            width = _firstStar$getBoundin.width;
          var clientX = event.clientX;
          var starMiddle = width * (index - 0.5) + props2.gap * (index - 1);
          if (clientX - left >= starMiddle) return index;
          if (clientX - left < starMiddle) return index - 0.5;
        }
        return index;
      };
      var mouseEnterHandler = function mouseEnterHandler(event, index) {
        if (props2.disabled) return;
        hoverValue.value = getStarValue(event, index);
      };
      var mouseLeaveHandler = function mouseLeaveHandler() {
        if (props2.disabled) return;
        hoverValue.value = void 0;
      };
      var clickHandler = function clickHandler(event, index) {
        if (props2.disabled) return;
        var value = getStarValue(event, index);
        if (props2.clearable && value === starValue.value) {
          hoverValue.value = void 0;
          setStarValue(0);
        } else {
          setStarValue(value);
        }
      };
      var getStarCls = function getStarCls(index) {
        if (props2.allowHalf && index + 0.5 === displayValue.value) return "".concat(classPrefix.value, "-rate__item--half");
        if (index >= displayValue.value) return "";
        if (index < displayValue.value) return "".concat(classPrefix.value, "-rate__item--full");
      };
      var activeIconStyle = VueCompositionAPI.computed(function () {
        return {
          fontSize: props2.size,
          color: activeColor
        };
      });
      var inactiveIconStyle = VueCompositionAPI.computed(function () {
        return {
          fontSize: props2.size,
          color: defaultColor
        };
      });
      return {
        classPrefix: classPrefix,
        mouseLeaveHandler: mouseLeaveHandler,
        getStarCls: getStarCls,
        clickHandler: clickHandler,
        mouseEnterHandler: mouseEnterHandler,
        activeColor: activeColor,
        defaultColor: defaultColor,
        displayText: displayText,
        displayValue: displayValue,
        rootRef: rootRef,
        activeIconStyle: activeIconStyle,
        inactiveIconStyle: inactiveIconStyle
      };
    },
    methods: {
      renderRateIcon: function renderRateIcon() {
        var h = this.$createElement;
        return renderTNodeJSXDefault(this, "icon", h(StarFilledIcon));
      }
    },
    render: function render() {
      var _this = this;
      var h = arguments[0];
      var classPrefix = this.classPrefix,
        mouseLeaveHandler = this.mouseLeaveHandler,
        getStarCls = this.getStarCls,
        clickHandler = this.clickHandler,
        mouseEnterHandler = this.mouseEnterHandler,
        displayText = this.displayText,
        displayValue = this.displayValue;
      return h("div", {
        "class": "".concat(classPrefix, "-rate"),
        "on": {
          "mouseleave": mouseLeaveHandler
        }
      }, [h("ul", {
        "class": "".concat(classPrefix, "-rate__list"),
        "style": {
          gap: "".concat(this.gap, "px")
        },
        "ref": "rootRef"
      }, [_toConsumableArray(Array(Number(this.count))).map(function (_, index) {
        return h("li", {
          "key": index,
          "class": ["".concat(classPrefix, "-rate__item"), getStarCls(index)],
          "on": {
            "click": function click(event) {
              return clickHandler(event, index + 1);
            },
            "mousemove": function mousemove(event) {
              return mouseEnterHandler(event, index + 1);
            }
          }
        }, [_this.showText ? h(Tooltip, {
          "key": index,
          "attrs": {
            "content": displayText[displayValue - 1]
          }
        }, [h("div", {
          "class": "".concat(classPrefix, "-rate__star-top"),
          "style": _objectSpread$h({}, _this.activeIconStyle)
        }, [_this.renderRateIcon()]), h("div", {
          "class": "".concat(classPrefix, "-rate__star-bottom"),
          "style": _objectSpread$h({}, _this.inactiveIconStyle)
        }, [_this.renderRateIcon()])]) : h("div", [h("div", {
          "class": "".concat(classPrefix, "-rate__star-top"),
          "style": _objectSpread$h({}, _this.activeIconStyle)
        }, [_this.renderRateIcon()]), h("div", {
          "class": "".concat(classPrefix, "-rate__star-bottom"),
          "style": _objectSpread$h({}, _this.inactiveIconStyle)
        }, [_this.renderRateIcon()])])]);
      })]), this.showText && h("div", {
        "class": "".concat(classPrefix, "-rate__text")
      }, [displayText[displayValue - 1]])]);
    }
  });

  var Rate = withInstall$1(_Rate, VueCompositionAPI__default["default"]);

  var DefaultAlign = {
    vertical: ["left", "right"],
    horizontal: ["top", "bottom"]
  };
  function getRenderAlign(align) {
    var layout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "vertical";
    var renderAlign = layout === "vertical" ? "left" : "top";
    if (layout === "vertical" && align) {
      var index = DefaultAlign.horizontal.indexOf(align);
      var isError = index !== -1;
      isError && log.warn("Timeline", 'If layout is vertical, align should be "left","alternate" or "right" ');
      renderAlign = isError ? DefaultAlign.vertical[index] : align;
    }
    if (layout === "horizontal" && align) {
      var _index = DefaultAlign.vertical.indexOf(align);
      var _isError = _index !== -1;
      _isError && log.warn("Timeline", 'If layout is horizontal, align should be "top","alternate" or "bottom" ');
      renderAlign = _isError ? DefaultAlign.horizontal[_index] : align;
    }
    return renderAlign;
  }

  var TimelineItemProps = {
    content: {
      type: [String, Function]
    },
    dot: {
      type: Function
    },
    dotColor: {
      type: String,
      "default": "primary"
    },
    label: {
      type: [String, Function]
    },
    labelAlign: {
      type: String,
      validator: function validator(val) {
        if (!val) return true;
        return ["left", "right", "top", "bottom"].includes(val);
      }
    },
    loading: Boolean
  };

  function ownKeys$g(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$g(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$g(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$g(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var DEFAULT_THEME = ["primary", "warning", "error", "default"];
  var _TimelineItem = VueCompositionAPI.defineComponent({
    name: "TTimelineItem",
    components: {
      TLoading: Loading
    },
    props: _objectSpread$g({}, TimelineItemProps),
    setup: function setup(props, context) {
      var instance = VueCompositionAPI.getCurrentInstance();
      var classPrefix = usePrefixClass();
      var timelineProvider = VueCompositionAPI.inject("TTimeline", {
        layout: "vertical",
        reverse: false,
        theme: void 0,
        labelAlign: "left",
        mode: "alternate"
      });
      var layout = timelineProvider.layout,
        reverse = timelineProvider.reverse,
        theme = timelineProvider.theme,
        labelAlign = timelineProvider.labelAlign,
        mode = timelineProvider.mode;
      var _toRefs = VueCompositionAPI.toRefs(props),
        dotColor = _toRefs.dotColor,
        itemLabelAlign = _toRefs.labelAlign,
        loading = _toRefs.loading;
      var timelineItemAlign = VueCompositionAPI.computed(function () {
        var _itemLabelAlign$value;
        return (_itemLabelAlign$value = itemLabelAlign.value) !== null && _itemLabelAlign$value !== void 0 ? _itemLabelAlign$value : getRenderAlign(labelAlign === null || labelAlign === void 0 ? void 0 : labelAlign.value, layout === null || layout === void 0 ? void 0 : layout.value);
      });
      var uidArr = VueCompositionAPI.computed(function () {
        var _instance$parent$slot;
        var defaultSlots = (_instance$parent$slot = instance.parent.slots["default"]) !== null && _instance$parent$slot !== void 0 ? _instance$parent$slot : [null];
        return defaultSlots.map(function (item) {
          var _item$componentInstan;
          return item === null || item === void 0 || (_item$componentInstan = item.componentInstance) === null || _item$componentInstan === void 0 ? void 0 : _item$componentInstan._uid;
        });
      });
      var currentIndex = VueCompositionAPI.computed(function () {
        var index = 0;
        uidArr.value.forEach(function (item, itemIndex) {
          if (item === instance.uid) {
            index = itemIndex;
          }
        });
        return index;
      });
      var positionClassName = VueCompositionAPI.computed(function () {
        var left = (layout === null || layout === void 0 ? void 0 : layout.value) === "horizontal" ? "top" : "left";
        var right = (layout === null || layout === void 0 ? void 0 : layout.value) === "horizontal" ? "bottom" : "right";
        if (timelineItemAlign.value === "alternate") {
          return currentIndex.value % 2 === 0 ? "".concat(classPrefix.value, "-timeline-item-").concat(left) : "".concat(classPrefix.value, "-timeline-item-").concat(right);
        }
        if (timelineItemAlign.value === "left" || timelineItemAlign.value === "top") {
          return "".concat(classPrefix.value, "-timeline-item-").concat(left);
        }
        if (timelineItemAlign.value === "right" || timelineItemAlign.value === "bottom") {
          return "".concat(classPrefix.value, "-timeline-item-").concat(right);
        }
        return "";
      });
      var getItemClassName = VueCompositionAPI.computed(function () {
        var isLastChildren = uidArr.value.length - 1 === currentIndex.value;
        var lastClassName = isLastChildren ? "".concat(classPrefix.value, "-timeline-item--last") : "";
        return "".concat(classPrefix.value, "-timeline-item ").concat(positionClassName.value, " ").concat(lastClassName);
      });
      var tailClassName = VueCompositionAPI.computed(function () {
        var statusClassName = reverse ? "".concat(classPrefix.value, "-timeline-item__tail--status-").concat(dotColor === null || dotColor === void 0 ? void 0 : dotColor.value) : "";
        return "".concat(classPrefix.value, "-timeline-item__tail ").concat(classPrefix.value, "-timeline-item__tail--theme-").concat(theme === null || theme === void 0 ? void 0 : theme.value, " ").concat(statusClassName);
      });
      var dotElement = VueCompositionAPI.computed(function () {
        return Boolean(context.slots.dot || props.dot);
      });
      var dotClassName = VueCompositionAPI.computed(function () {
        var dotCustomClassName = !!dotElement.value || !dotElement.value && loading !== null && loading !== void 0 && loading.value ? "".concat(classPrefix.value, "-timeline-item__dot--custom") : "";
        var docColorClassName = DEFAULT_THEME.includes(dotColor === null || dotColor === void 0 ? void 0 : dotColor.value) ? "".concat(classPrefix.value, "-timeline-item__dot--").concat(dotColor === null || dotColor === void 0 ? void 0 : dotColor.value) : "";
        return "".concat(classPrefix.value, "-timeline-item__dot ").concat(dotCustomClassName, " ").concat(docColorClassName);
      });
      var labelClassName = VueCompositionAPI.computed(function () {
        return "".concat(classPrefix.value, "-timeline-item__label ").concat(classPrefix.value, "-timeline-item__label--").concat(mode === null || mode === void 0 ? void 0 : mode.value);
      });
      return {
        mode: mode,
        currentIndex: currentIndex,
        tailClassName: tailClassName,
        dotClassName: dotClassName,
        labelClassName: labelClassName,
        getItemClassName: getItemClassName,
        classPrefix: classPrefix
      };
    },
    render: function render() {
      var _dotElement$;
      var h = arguments[0];
      var dotColor = this.dotColor,
        dotClassName = this.dotClassName,
        _this$style = this.style,
        style = _this$style === void 0 ? {} : _this$style,
        labelClassName = this.labelClassName,
        mode = this.mode,
        loading = this.loading,
        tailClassName = this.tailClassName,
        getItemClassName = this.getItemClassName,
        _this$classPrefix = this.classPrefix,
        classPrefix = _this$classPrefix === void 0 ? "t" : _this$classPrefix;
      var dotElement = renderTNodeJSX(this, "dot");
      var labelNode = renderTNodeJSX(this, "label");
      var dotContentClass = "".concat(classPrefix, "-timeline-item__dot-content");
      if (Array.isArray(dotElement) && (_dotElement$ = dotElement[0]) !== null && _dotElement$ !== void 0 && _dotElement$.data) {
        var classes = dotElement[0].data["class"];
        dotElement[0].data["class"] = classes ? [classes, dotContentClass].join(" ") : dotContentClass;
      }
      return h("li", {
        "class": getItemClassName,
        "style": style
      }, [mode === "alternate" && labelNode && h("div", {
        "class": labelClassName
      }, [labelNode]), h("div", {
        "class": "".concat(classPrefix, "-timeline-item__wrapper")
      }, [h("div", {
        "class": dotClassName,
        "style": {
          borderColor: !DEFAULT_THEME.includes(dotColor) && dotColor
        }
      }, [!dotElement && loading && h(Loading, {
        "attrs": {
          "size": "12px"
        },
        "class": dotContentClass
      }), dotElement]), h("div", {
        "class": tailClassName
      })]), h("div", {
        "class": "".concat(classPrefix, "-timeline-item__content")
      }, [renderContent(this, "content", "default"), mode === "same" && labelNode && h("div", {
        "class": labelClassName
      }, [labelNode])])]);
    }
  });

  var TimelineProps = {
    labelAlign: {
      type: String,
      "default": "left",
      validator: function validator(val) {
        if (!val) return true;
        return ["left", "right", "alternate", "top", "bottom"].includes(val);
      }
    },
    layout: {
      type: String,
      "default": "vertical",
      validator: function validator(val) {
        if (!val) return true;
        return ["horizontal", "vertical"].includes(val);
      }
    },
    mode: {
      type: String,
      "default": "alternate",
      validator: function validator(val) {
        if (!val) return true;
        return ["alternate", "same"].includes(val);
      }
    },
    reverse: Boolean,
    theme: {
      type: String,
      "default": "default",
      validator: function validator(val) {
        if (!val) return true;
        return ["default", "dot"].includes(val);
      }
    }
  };

  function ownKeys$f(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$f(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$f(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$f(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _Timeline = VueCompositionAPI.defineComponent({
    name: "TTimeline",
    components: {
      TimelineItem: _TimelineItem
    },
    props: _objectSpread$f({}, TimelineProps),
    setup: function setup(props) {
      var _toRefs = VueCompositionAPI.toRefs(props),
        theme = _toRefs.theme,
        labelAlign = _toRefs.labelAlign,
        reverse = _toRefs.reverse,
        layout = _toRefs.layout,
        mode = _toRefs.mode;
      var instance = VueCompositionAPI.getCurrentInstance();
      var classPrefix = usePrefixClass();
      var hasLabelItem = VueCompositionAPI.computed(function () {
        var defaultSlots = instance.slots["default"] ? instance.slots["default"] : [null];
        return defaultSlots.some(function (item) {
          var _item$componentOption;
          return !!(item !== null && item !== void 0 && (_item$componentOption = item.componentOptions) !== null && _item$componentOption !== void 0 && (_item$componentOption = _item$componentOption.propsData) !== null && _item$componentOption !== void 0 && _item$componentOption.label);
        });
      });
      var timelineClassName = VueCompositionAPI.computed(function () {
        var renderAlign = getRenderAlign(labelAlign === null || labelAlign === void 0 ? void 0 : labelAlign.value, layout === null || layout === void 0 ? void 0 : layout.value);
        var classNames = ["".concat(classPrefix.value, "-timeline"), "".concat(classPrefix.value, "-timeline-").concat(renderAlign), "".concat(classPrefix.value, "-timeline-").concat(layout === null || layout === void 0 ? void 0 : layout.value), "".concat(classPrefix.value, "-timeline-label--").concat(mode === null || mode === void 0 ? void 0 : mode.value)];
        if (reverse !== null && reverse !== void 0 && reverse.value) {
          classNames.push("".concat(classPrefix.value, "-timeline-reverse"));
        }
        if (hasLabelItem !== null && hasLabelItem !== void 0 && hasLabelItem.value) {
          classNames.push("".concat(classPrefix.value, "-timeline-label"));
        }
        return classNames.join(" ");
      });
      VueCompositionAPI.provide("TTimeline", {
        theme: theme,
        labelAlign: labelAlign,
        reverse: reverse,
        layout: layout,
        mode: mode,
        timelineClassName: timelineClassName.value
      });
      return {
        timelineClassName: timelineClassName
      };
    },
    render: function render() {
      var h = arguments[0];
      var reverse = this.reverse;
      var defaultSlot = this.$scopedSlots["default"] ? this.$scopedSlots["default"](null) : [null];
      if (reverse) {
        defaultSlot.reverse();
      }
      var timelineClassName = this.timelineClassName,
        style = this.style;
      return h("ul", {
        "class": timelineClassName,
        "style": style
      }, [defaultSlot]);
    }
  });

  var Timeline = withInstall$1(_Timeline, VueCompositionAPI__default["default"]);
  var TimelineItem = withInstall$1(_TimelineItem, VueCompositionAPI__default["default"]);

  var props$5 = {
    close: {
      type: [String, Boolean, Function],
      "default": false
    },
    "default": {
      type: [String, Function]
    },
    icon: {
      type: Function
    },
    maxLine: {
      type: Number,
      "default": 0
    },
    message: {
      type: [String, Function]
    },
    operation: {
      type: Function
    },
    theme: {
      type: String,
      "default": "info",
      validator: function validator(val) {
        return ["success", "info", "warning", "error"].includes(val);
      }
    },
    title: {
      type: [String, Function]
    },
    onClose: Function,
    onClosed: Function
  };

  function ownKeys$e(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$e(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$e(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$e(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _Alert = mixins(getConfigReceiverMixins("alert"), getGlobalIconMixins()).extend({
    name: "TAlert",
    data: function data() {
      return {
        visible: true,
        collapsed: true
      };
    },
    props: _objectSpread$e({}, props$5),
    render: function render() {
      var h = arguments[0];
      var compClass = [this.componentName, "".concat(this.componentName, "--").concat(this.theme), _defineProperty$2({}, "".concat(this.classPrefix, "-is-hidden"), !this.visible)];
      return h("div", {
        "class": compClass
      }, [this.renderIcon(), this.renderContent(), this.renderClose()]);
    },
    mounted: function mounted() {
      on$1(this.$el, "transitionend", this.handleCloseEnd);
    },
    beforeDestroy: function beforeDestroy() {
      off$1(this.$el, "transitionend", this.handleCloseEnd);
    },
    methods: {
      renderIcon: function renderIcon() {
        var h = this.$createElement;
        var iconContent;
        if (typeof this.icon === "function") {
          iconContent = this.icon(this.$createElement);
        } else if (this.$scopedSlots.icon) {
          iconContent = this.$scopedSlots.icon && this.$scopedSlots.icon(null)[0];
        } else {
          var _this$useGlobalIcon = this.useGlobalIcon({
              InfoCircleFilledIcon: TdInfoCircleFilledIcon,
              CheckCircleFilledIcon: TdCheckCircleFilledIcon,
              ErrorCircleFilledIcon: TdErrorCircleFilledIcon
            }),
            InfoCircleFilledIcon = _this$useGlobalIcon.InfoCircleFilledIcon,
            CheckCircleFilledIcon = _this$useGlobalIcon.CheckCircleFilledIcon,
            ErrorCircleFilledIcon = _this$useGlobalIcon.ErrorCircleFilledIcon;
          var component = {
            info: InfoCircleFilledIcon,
            success: CheckCircleFilledIcon,
            warning: ErrorCircleFilledIcon,
            error: ErrorCircleFilledIcon
          }[this.theme];
          iconContent = h(component);
        }
        return iconContent ? h("div", {
          "class": "".concat(this.componentName, "__icon")
        }, [iconContent]) : null;
      },
      renderClose: function renderClose() {
        var h = this.$createElement;
        var _this$useGlobalIcon2 = this.useGlobalIcon({
            CloseIcon: TdCloseIcon
          }),
          CloseIcon = _this$useGlobalIcon2.CloseIcon;
        var closeContent = null;
        if (this.close === true || this.close === "") {
          closeContent = h(CloseIcon);
        } else if (typeof this.close === "string") {
          closeContent = this.close;
        } else if (typeof this.close === "function") {
          closeContent = this.close(this.$createElement);
        } else {
          closeContent = this.$scopedSlots.close && this.$scopedSlots.close(null)[0];
        }
        return closeContent ? h("div", {
          "class": "".concat(this.componentName, "__close"),
          "on": {
            "click": this.handleClose
          }
        }, [closeContent]) : null;
      },
      renderContent: function renderContent() {
        var h = this.$createElement;
        return h("div", {
          "class": "".concat(this.componentName, "__content")
        }, [this.renderTitle(), this.renderMessage()]);
      },
      renderTitle: function renderTitle() {
        var h = this.$createElement;
        var titleContent = renderTNodeJSX(this, "title");
        return titleContent ? h("div", {
          "class": "".concat(this.componentName, "__title")
        }, [" ", titleContent]) : null;
      },
      renderMessage: function renderMessage() {
        var h = this.$createElement;
        var operationContent = renderTNodeJSX(this, "operation");
        return h("div", {
          "class": "".concat(this.componentName, "__message")
        }, [this.renderDescription(), operationContent ? h("div", {
          "class": "".concat(this.componentName, "__operation")
        }, [operationContent]) : null]);
      },
      renderDescription: function renderDescription() {
        var _this = this;
        var h = this.$createElement;
        var messageContent;
        messageContent = renderTNodeJSX(this, "default");
        if (!messageContent) {
          messageContent = renderTNodeJSX(this, "message");
        }
        var contentLength = Object.prototype.toString.call(messageContent) === "[object Array]" ? messageContent.length : 1;
        var hasCollapse = this.maxLine > 0 && this.maxLine < contentLength;
        if (hasCollapse && this.collapsed) {
          messageContent = messageContent.slice(0, this.maxLine);
        }
        return h("div", {
          "class": "".concat(this.componentName, "__description")
        }, [hasCollapse ? messageContent.map(function (content) {
          return h("div", [content]);
        }) : messageContent, hasCollapse ? h("div", {
          "class": "".concat(this.componentName, "__collapse"),
          "on": {
            "click": function click() {
              _this.collapsed = !_this.collapsed;
            }
          }
        }, [this.collapsed ? this.global.expandText : this.global.collapseText]) : null]);
      },
      handleClose: function handleClose(e) {
        this.$emit("close", {
          e: e
        });
        if (this.onClose) {
          this.onClose({
            e: e
          });
        }
        addClass(this.$el, "".concat(this.componentName, "--closing"));
      },
      handleCloseEnd: function handleCloseEnd(e) {
        if (e.propertyName === "opacity" && e.target === this.$el) {
          this.visible = false;
          this.$emit("closed", {
            e: e
          });
          if (this.onClosed) {
            this.onClosed({
              e: e
            });
          }
        }
      }
    }
  });

  var Alert = withInstall$1(_Alert);

  var props$4 = {
    attach: {
      type: [String, Function]
    },
    body: {
      type: [String, Function]
    },
    cancelBtn: {
      type: [String, Object, Function]
    },
    closeBtn: {
      type: [String, Boolean, Function]
    },
    closeOnEscKeydown: {
      type: Boolean,
      "default": void 0
    },
    closeOnOverlayClick: {
      type: Boolean,
      "default": true
    },
    confirmBtn: {
      type: [String, Object, Function]
    },
    "default": {
      type: [String, Function]
    },
    destroyOnClose: Boolean,
    footer: {
      type: [Boolean, Function],
      "default": true
    },
    header: {
      type: [String, Boolean, Function],
      "default": true
    },
    mode: {
      type: String,
      "default": "overlay",
      validator: function validator(val) {
        if (!val) return true;
        return ["overlay", "push"].includes(val);
      }
    },
    placement: {
      type: String,
      "default": "right",
      validator: function validator(val) {
        if (!val) return true;
        return ["left", "right", "top", "bottom"].includes(val);
      }
    },
    preventScrollThrough: {
      type: Boolean,
      "default": true
    },
    showInAttachedElement: Boolean,
    showOverlay: {
      type: Boolean,
      "default": true
    },
    size: {
      type: String,
      "default": void 0
    },
    sizeDraggable: {
      type: [Boolean, Object],
      "default": false
    },
    visible: Boolean,
    zIndex: {
      type: Number
    },
    onBeforeClose: Function,
    onBeforeOpen: Function,
    onCancel: Function,
    onClose: Function,
    onCloseBtnClick: Function,
    onConfirm: Function,
    onEscKeydown: Function,
    onOverlayClick: Function,
    onSizeDragEnd: Function
  };

  function getSizeDraggable(sizeDraggable, limit) {
    if (typeof sizeDraggable === "boolean") {
      return {
        allowSizeDraggable: sizeDraggable,
        max: limit.max,
        min: limit.min
      };
    }
    return {
      allowSizeDraggable: true,
      max: sizeDraggable.max,
      min: sizeDraggable.min
    };
  }
  function calcSizeRange(size, min, max) {
    return Math.min(Math.max(size, min), max);
  }
  function calcMoveSize(placement, opts) {
    var x = opts.x,
      y = opts.y,
      max = opts.max,
      min = opts.min,
      maxWidth = opts.maxWidth,
      maxHeight = opts.maxHeight;
    var moveSize;
    switch (placement) {
      case "right":
        moveSize = calcSizeRange(maxWidth - x, min, max);
        break;
      case "left":
        moveSize = calcSizeRange(x, min, max);
        break;
      case "top":
        moveSize = calcSizeRange(y, min, max);
        break;
      case "bottom":
        moveSize = calcSizeRange(maxHeight - y, min, max);
        break;
      default:
        return moveSize;
    }
    return moveSize;
  }

  var key = 1;
  var _Drawer = mixins(ActionMixin, getConfigReceiverMixins("drawer"), getGlobalIconMixins(), getAttachConfigMixins("drawer")).extend({
    name: "TDrawer",
    components: {
      TButton: Button
    },
    props: props$4,
    directives: {
      TransferDom: TransferDom
    },
    data: function data() {
      return {
        isSizeDragging: false,
        draggedSizeValue: null,
        animationStart: false,
        animationEnd: true,
        styleTimer: null,
        styleEl: null
      };
    },
    computed: {
      drawerClasses: function drawerClasses() {
        return [this.componentName, "".concat(this.componentName, "--").concat(this.placement), _defineProperty$2(_defineProperty$2(_defineProperty$2({}, "".concat(this.componentName, "--open"), this.visible), "".concat(this.componentName, "--attach"), this.showInAttachedElement), "".concat(this.componentName, "--without-mask"), !this.showOverlay)];
      },
      sizeValue: function sizeValue() {
        var _this$size;
        if (this.draggedSizeValue) return this.draggedSizeValue;
        var size = (_this$size = this.size) !== null && _this$size !== void 0 ? _this$size : this.global.size;
        var defaultSize = isNaN(Number(size)) ? size : "".concat(size, "px");
        return {
          small: "300px",
          medium: "500px",
          large: "760px"
        }[size] || defaultSize;
      },
      wrapperStyles: function wrapperStyles() {
        return {
          transform: this.visible && this.animationStart ? "translateX(0)" : void 0,
          width: this.isHorizontal ? this.sizeValue : "",
          height: this.isVertical ? this.sizeValue : ""
        };
      },
      wrapperClasses: function wrapperClasses() {
        return ["".concat(this.componentName, "__content-wrapper"), "".concat(this.componentName, "__content-wrapper--").concat(this.placement)];
      },
      parentNode: function parentNode() {
        return this.$el && this.$el.parentNode;
      },
      modeAndPlacement: function modeAndPlacement() {
        return [this.mode, this.placement].join();
      },
      footerStyle: function footerStyle() {
        return {
          display: "flex",
          justifyContent: this.placement === "right" ? "flex-start" : "flex-end"
        };
      },
      isHorizontal: function isHorizontal() {
        return ["right", "left"].includes(this.placement);
      },
      isVertical: function isVertical() {
        return ["top", "bottom"].includes(this.placement);
      },
      draggableLineStyles: function draggableLineStyles() {
        var oppositeMap = {
          left: "right",
          right: "left",
          top: "bottom",
          bottom: "top"
        };
        return _defineProperty$2(_defineProperty$2(_defineProperty$2(_defineProperty$2({
          zIndex: 1,
          position: "absolute",
          background: "transparent"
        }, oppositeMap[this.placement], 0), "width", this.isHorizontal ? "16px" : "100%"), "height", this.isHorizontal ? "100%" : "16px"), "cursor", this.isHorizontal ? "col-resize" : "row-resize");
      },
      computedAttach: function computedAttach() {
        return this.showInAttachedElement ? void 0 : this.attach || this.globalAttach();
      }
    },
    watch: {
      modeAndPlacement: {
        handler: function handler() {
          this.handlePushMode();
        },
        immediate: true
      },
      visible: {
        handler: function handler(val) {
          var _this = this;
          if (val) {
            this.$nextTick(function () {
              var _this$$refs$drawerCon, _this$$refs$drawerCon2;
              (_this$$refs$drawerCon = _this.$refs.drawerContainer) === null || _this$$refs$drawerCon === void 0 || (_this$$refs$drawerCon2 = _this$$refs$drawerCon.focus) === null || _this$$refs$drawerCon2 === void 0 || _this$$refs$drawerCon2.call(_this$$refs$drawerCon);
            });
          }
          this.handleScrollThrough(val);
        }
      }
    },
    updated: function updated() {
      this.updatePushMode();
    },
    mounted: function mounted() {
      var hasScrollBar = window.innerWidth > document.documentElement.clientWidth;
      var scrollWidth = hasScrollBar ? getScrollbarWidth() : 0;
      this.styleEl = document.createElement("style");
      this.styleEl.dataset.id = "td_drawer_".concat(+new Date(), "_").concat(key += 1);
      this.styleEl.innerHTML = "\n      html body {\n        overflow-y: hidden;\n        transition: margin 300ms cubic-bezier(0.7, 0.3, 0.1, 1) 0s;\n        ".concat(this.mode === "push" ? "" : "width: calc(100% - ".concat(scrollWidth, "px);"), "\n      }\n    ");
      this.handleScrollThrough(this.visible);
    },
    beforeDestroy: function beforeDestroy() {
      this.clearStyleFunc();
    },
    render: function render() {
      var h = arguments[0];
      if (this.destroyOnClose && !this.visible && this.animationEnd) return null;
      var _this$useGlobalIcon = this.useGlobalIcon({
          CloseIcon: TdCloseIcon
        }),
        CloseIcon = _this$useGlobalIcon.CloseIcon;
      var defaultCloseBtn = h(CloseIcon, {
        "class": "".concat(this.classPrefix, "-submenu-icon")
      });
      var body = renderContent(this, "default", "body");
      var defaultFooter = this.getDefaultFooter();
      return h("transition", {
        "on": {
          "appear": this.afterEnter,
          "beforeEnter": this.beforeEnter,
          "beforeLeave": this.beforeLeave,
          "afterEnter": this.afterEnter,
          "afterLeave": this.afterLeave
        },
        "attrs": {
          "duration": {
            enter: 10,
            leave: 300
          }
        }
      }, [h("div", {
        "class": this.drawerClasses,
        "style": {
          zIndex: this.zIndex
        },
        "on": {
          "keydown": this.onKeyDown
        },
        "directives": [{
          name: "transfer-dom",
          value: this.computedAttach
        }, {
          name: "show",
          value: this.visible
        }],
        "ref": "drawerContainer",
        "attrs": {
          "tabindex": 0
        }
      }, [this.showOverlay && h("transition", {
        "attrs": {
          "duration": 300,
          "name": "".concat(this.componentName, "-fade")
        }
      }, [h("div", {
        "key": "mask",
        "class": "".concat(this.componentName, "__mask"),
        "on": {
          "click": this.handleWrapperClick
        },
        "directives": [{
          name: "show",
          value: this.visible
        }]
      })]), h("div", {
        "class": this.wrapperClasses,
        "style": this.wrapperStyles
      }, [this.header !== false ? h("div", {
        "class": "".concat(this.componentName, "__header")
      }, [renderTNodeJSX(this, "header", h("div"))]) : null, this.closeBtn !== false ? h("div", {
        "class": "".concat(this.componentName, "__close-btn"),
        "on": {
          "click": this.handleCloseBtnClick
        }
      }, [renderTNodeJSX(this, "closeBtn", defaultCloseBtn)]) : null, h("div", {
        "class": "".concat(this.componentName, "__body")
      }, [body]), this.footer !== false ? h("div", {
        "class": "".concat(this.componentName, "__footer")
      }, [renderTNodeJSX(this, "footer", defaultFooter)]) : null, this.sizeDraggable && h("div", {
        "style": this.draggableLineStyles,
        "on": {
          "mousedown": this.enableDrag
        }
      })])])]);
    },
    methods: {
      clearStyleFunc: function clearStyleFunc() {
        var _this2 = this;
        clearTimeout(this.styleTimer);
        this.styleTimer = setTimeout(function () {
          var _this2$styleEl$parent, _this2$styleEl$parent2;
          (_this2$styleEl$parent = _this2.styleEl.parentNode) === null || _this2$styleEl$parent === void 0 || (_this2$styleEl$parent2 = _this2$styleEl$parent.removeChild) === null || _this2$styleEl$parent2 === void 0 || _this2$styleEl$parent2.call(_this2$styleEl$parent, _this2.styleEl);
        }, 150);
      },
      beforeEnter: function beforeEnter() {
        emitEvent$1(this, "before-open");
      },
      afterEnter: function afterEnter() {
        this.animationStart = true;
        this.animationEnd = false;
      },
      beforeLeave: function beforeLeave() {
        emitEvent$1(this, "before-close");
      },
      afterLeave: function afterLeave() {
        this.animationStart = false;
        this.animationEnd = true;
      },
      enableDrag: function enableDrag() {
        document.addEventListener("mouseup", this.handleMouseup, true);
        document.addEventListener("mousemove", this.handleMousemove, true);
        this.isSizeDragging = true;
      },
      handleMouseup: function handleMouseup() {
        document.removeEventListener("mouseup", this.handleMouseup, true);
        document.removeEventListener("mousemove", this.handleMousemove, true);
        this.isSizeDragging = false;
      },
      handleMousemove: function handleMousemove(e) {
        var x = e.x,
          y = e.y;
        var maxHeight = document.documentElement.clientHeight;
        var maxWidth = document.documentElement.clientWidth;
        var offsetHeight = 8;
        var offsetWidth = 8;
        var max = this.placement === "left" || this.placement === "right" ? maxWidth : maxHeight;
        var min = this.placement === "left" || this.placement === "right" ? offsetWidth : offsetHeight;
        var _getSizeDraggable = getSizeDraggable(this.sizeDraggable, {
            max: max,
            min: min
          }),
          allowSizeDraggable = _getSizeDraggable.allowSizeDraggable,
          limitMax = _getSizeDraggable.max,
          limitMin = _getSizeDraggable.min;
        if (!this.isSizeDragging || !allowSizeDraggable) return;
        var moveSize = calcMoveSize(this.placement, {
          x: x,
          y: y,
          maxWidth: maxWidth,
          maxHeight: maxHeight,
          max: limitMax,
          min: limitMin
        });
        if (typeof moveSize === "undefined") return;
        this.draggedSizeValue = "".concat(moveSize, "px");
      },
      handleScrollThrough: function handleScrollThrough(visible) {
        if (!document || !document.body || !this.preventScrollThrough) return;
        if (visible) {
          if (!this.showInAttachedElement && this.preventScrollThrough) {
            document.head.appendChild(this.styleEl);
          }
        } else {
          this.clearStyleFunc();
        }
      },
      handlePushMode: function handlePushMode() {
        var _this3 = this;
        if (this.mode !== "push") return;
        this.$nextTick(function () {
          if (!_this3.parentNode) return;
          _this3.parentNode.style.cssText = "transition: margin 300ms cubic-bezier(0.7, 0.3, 0.1, 1) 0s;";
        });
      },
      updatePushMode: function updatePushMode() {
        if (!this.parentNode) return;
        if (this.mode !== "push" || !this.parentNode) return;
        var marginStr = {
          left: "margin: 0 0 0 ".concat(this.sizeValue),
          right: "margin: 0 0 0 -".concat(this.sizeValue),
          top: "margin: ".concat(this.sizeValue, " 0 0 0"),
          bottom: "margin: -".concat(this.sizeValue, " 0 0 0")
        }[this.placement];
        if (this.visible) {
          this.parentNode.style.cssText += marginStr;
        } else {
          this.parentNode.style.cssText = this.parentNode.style.cssText.replace(/margin:.+;/, "");
        }
      },
      getDefaultBtn: function getDefaultBtn(btnType, btnApi) {
        var h = this.$createElement;
        var isCancel = btnType === "cancel";
        var clickAction = isCancel ? this.cancelBtnAction : this.confirmBtnAction;
        var theme = isCancel ? "default" : "primary";
        var isApiObject = _typeof$2(btnApi) === "object";
        return h("t-button", helper([{
          "attrs": {
            "theme": theme
          },
          "on": {
            "click": clickAction
          }
        }, {
          "props": isApiObject ? btnApi : {}
        }, {
          "class": "".concat(this.componentName, "-").concat(btnType)
        }]), [btnApi && _typeof$2(btnApi) === "object" ? btnApi.content : btnApi]);
      },
      isUseDefault: function isUseDefault(btnApi) {
        var baseTypes = ["string", "object"];
        return Boolean(btnApi && baseTypes.includes(_typeof$2(btnApi)));
      },
      getDefaultFooter: function getDefaultFooter() {
        var h = this.$createElement;
        var confirmBtn = this.getConfirmBtn({
          confirmBtn: this.confirmBtn,
          globalConfirm: this.global.confirm,
          className: "".concat(this.componentName, "__confirm")
        });
        var cancelBtn = this.getCancelBtn({
          cancelBtn: this.cancelBtn,
          globalCancel: this.global.cancel,
          className: "".concat(this.componentName, "__cancel")
        });
        return h("div", {
          "style": this.footerStyle
        }, [this.placement === "right" ? confirmBtn : null, cancelBtn, this.placement !== "right" ? confirmBtn : null]);
      },
      handleCloseBtnClick: function handleCloseBtnClick(e) {
        emitEvent$1(this, "close-btn-click", {
          e: e
        });
        this.closeDrawer({
          trigger: "close-btn",
          e: e
        });
      },
      handleWrapperClick: function handleWrapperClick(e) {
        var _this$closeOnOverlayC;
        emitEvent$1(this, "overlay-click", {
          e: e
        });
        if ((_this$closeOnOverlayC = this.closeOnOverlayClick) !== null && _this$closeOnOverlayC !== void 0 ? _this$closeOnOverlayC : this.global.closeOnOverlayClick) {
          this.closeDrawer({
            trigger: "overlay",
            e: e
          });
        }
      },
      onKeyDown: function onKeyDown(e) {
        if (e.key === "Escape") {
          var _this$closeOnEscKeydo;
          emitEvent$1(this, "esc-keydown", {
            e: e
          });
          if ((_this$closeOnEscKeydo = this.closeOnEscKeydown) !== null && _this$closeOnEscKeydo !== void 0 ? _this$closeOnEscKeydo : this.global.closeOnEscKeydown) {
            this.closeDrawer({
              trigger: "esc",
              e: e
            });
          }
        }
      },
      confirmBtnAction: function confirmBtnAction(e) {
        emitEvent$1(this, "confirm", {
          e: e
        });
      },
      cancelBtnAction: function cancelBtnAction(e) {
        emitEvent$1(this, "cancel", {
          e: e
        });
        this.closeDrawer({
          trigger: "cancel",
          e: e
        });
      },
      closeDrawer: function closeDrawer(params) {
        emitEvent$1(this, "close", params);
        this.$emit("update:visible", false);
      }
    }
  });

  var Drawer = withInstall$1(_Drawer);

  function getScrollParent(element) {
    var style = window.getComputedStyle(element);
    var excludeStaticParent = style.position === "absolute";
    var overflowRegex = /(auto|scroll)/;
    if (style.position === "fixed") return document.body;
    for (var parent = element; parent.parentElement;) {
      parent = parent.parentElement;
      style = window.getComputedStyle(parent);
      if (excludeStaticParent && style.position === "static") {
        continue;
      }
      if (overflowRegex.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.body;
  }
  function scrollToParentVisibleArea(element) {
    var parent = getScrollParent(element);
    if (parent === document.body) return;
    if (elementInViewport(element, parent)) return;
    parent.scrollTop = element.offsetTop - parent.offsetTop;
  }

  function getRelativePosition(elm) {
    var relativeElm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;
    var _getWindowScroll = getWindowScroll$1(),
      scrollTop = _getWindowScroll.scrollTop,
      scrollLeft = _getWindowScroll.scrollLeft;
    var _elm$getBoundingClien = elm.getBoundingClientRect(),
      elmTop = _elm$getBoundingClien.top,
      elmLeft = _elm$getBoundingClien.left;
    var _relativeElm$getBound = relativeElm.getBoundingClientRect(),
      relElmTop = _relativeElm$getBound.top,
      relElmLeft = _relativeElm$getBound.left;
    var relativeElmPosition = getElmCssPropValue(relativeElm, "position");
    if (relativeElm.tagName.toLowerCase() !== "body" && relativeElmPosition === "relative" || relativeElmPosition === "sticky") {
      return {
        top: elmTop - relElmTop,
        left: elmLeft - relElmLeft
      };
    }
    if (isFixed(elm)) {
      return {
        top: elmTop,
        left: elmLeft
      };
    }
    return {
      top: elmTop + scrollTop,
      left: elmLeft + scrollLeft
    };
  }

  function getTargetElm(elm) {
    if (elm) {
      var _process$env;
      var targetElement = null;
      if (typeof elm === "string") {
        targetElement = document.querySelector(elm);
      } else if (typeof elm === "function") {
        targetElement = elm();
      } else {
        throw new Error("elm should be string or function");
      }
      if (targetElement) {
        return targetElement;
      }
      var isTestEnv = typeof process !== "undefined" && ((_process$env = process.env) === null || _process$env === void 0 ? void 0 : _process$env.NODE_ENV) === "test";
      if (!isTestEnv) {
        throw new Error("There is no element with given.");
      }
    } else {
      return document.body;
    }
  }

  function scrollToElm(elm) {
    var rect = elm.getBoundingClientRect();
    if (!elementInViewport(elm)) {
      var winHeight = getWindowSize().height;
      scrollTo(rect.top - (winHeight / 2 - rect.height / 2), {});
    }
  }

  var props$3 = {
    counter: {
      type: Function
    },
    current: {
      type: Number
    },
    defaultCurrent: {
      type: Number
    },
    finishButtonProps: {
      type: Object
    },
    hideCounter: Boolean,
    hidePrev: Boolean,
    hideSkip: Boolean,
    highlightPadding: {
      type: Number,
      "default": 8
    },
    mode: {
      type: String,
      "default": "popup",
      validator: function validator(val) {
        if (!val) return true;
        return ["popup", "dialog"].includes(val);
      }
    },
    nextButtonProps: {
      type: Object
    },
    prevButtonProps: {
      type: Object
    },
    showOverlay: {
      type: Boolean,
      "default": true
    },
    skipButtonProps: {
      type: Object
    },
    steps: {
      type: Array
    },
    zIndex: {
      type: Number,
      "default": 999999
    },
    onChange: Function,
    onFinish: Function,
    onNextStepClick: Function,
    onPrevStepClick: Function,
    onSkip: Function
  };

  function ownKeys$d(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$d(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$d(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$d(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _Guide = VueCompositionAPI.defineComponent({
    name: "TGuide",
    directives: {
      TransferDom: TransferDom
    },
    props: _objectSpread$d({}, props$3),
    setup: function setup(props2, context) {
      var COMPONENT_NAME = usePrefixClass("guide");
      var LOCK_CLASS = usePrefixClass("guide--lock");
      var _useConfig = useConfig("guide"),
        global = _useConfig.global;
      var _toRefs = VueCompositionAPI.toRefs(props2),
        current = _toRefs.current;
      var _useCommonClassName = useCommonClassName$1(),
        classPrefix = _useCommonClassName.classPrefix;
      var _useDefaultValue = useDefaultValue(current, props2.defaultCurrent, props2.onChange, "current", "change"),
        _useDefaultValue2 = _slicedToArray(_useDefaultValue, 2),
        innerCurrent = _useDefaultValue2[0],
        setInnerCurrent = _useDefaultValue2[1];
      var overlayLayerRef = VueCompositionAPI.ref();
      var highlightLayerRef = VueCompositionAPI.ref();
      var referenceLayerRef = VueCompositionAPI.ref();
      var currentHighlightLayerElm = VueCompositionAPI.ref();
      var dialogWrapperRef = VueCompositionAPI.ref();
      var dialogTooltipRef = VueCompositionAPI.ref();
      var activated = VueCompositionAPI.ref(false);
      var stepsTotal = VueCompositionAPI.computed(function () {
        return props2.steps.length;
      });
      var currentStepInfo = VueCompositionAPI.computed(function () {
        var _props2$steps;
        return (_props2$steps = props2.steps) === null || _props2$steps === void 0 ? void 0 : _props2$steps[innerCurrent.value];
      });
      var isPopup = VueCompositionAPI.computed(function () {
        return getCurrentCrossProps("mode") === "popup";
      });
      var currentElmIsFixed = VueCompositionAPI.computed(function () {
        return isFixed(currentHighlightLayerElm.value || document.body);
      });
      var getCurrentCrossProps = function getCurrentCrossProps(propsName) {
        var _currentStepInfo$valu;
        return (_currentStepInfo$valu = currentStepInfo.value[propsName]) !== null && _currentStepInfo$valu !== void 0 ? _currentStepInfo$valu : props2[propsName];
      };
      var setHighlightLayerPosition = function setHighlightLayerPosition(highlightLayer) {
        var _getRelativePosition = getRelativePosition(currentHighlightLayerElm.value),
          top = _getRelativePosition.top,
          left = _getRelativePosition.left;
        var _currentHighlightLaye = currentHighlightLayerElm.value.getBoundingClientRect(),
          width = _currentHighlightLaye.width,
          height = _currentHighlightLaye.height;
        var highlightPadding = getCurrentCrossProps("highlightPadding");
        if (isPopup.value) {
          width += highlightPadding * 2;
          height += highlightPadding * 2;
          top -= highlightPadding;
          left -= highlightPadding;
        } else {
          var _getWindowScroll = getWindowScroll$1(),
            scrollTop = _getWindowScroll.scrollTop,
            scrollLeft = _getWindowScroll.scrollLeft;
          top += scrollTop;
          left += scrollLeft;
        }
        setStyle(highlightLayer, {
          width: "".concat(width, "px"),
          height: "".concat(height, "px"),
          top: "".concat(top, "px"),
          left: "".concat(left, "px")
        });
      };
      var showPopupGuide = function showPopupGuide() {
        VueCompositionAPI.nextTick(function () {
          currentHighlightLayerElm.value = getTargetElm(currentStepInfo.value.element);
          if (!currentHighlightLayerElm.value) return;
          scrollToParentVisibleArea(currentHighlightLayerElm.value);
          setHighlightLayerPosition(highlightLayerRef.value);
          setHighlightLayerPosition(referenceLayerRef.value);
          scrollToElm(currentHighlightLayerElm.value);
        });
      };
      var destroyTooltipElm = function destroyTooltipElm() {
        var _referenceLayerRef$va;
        (_referenceLayerRef$va = referenceLayerRef.value) === null || _referenceLayerRef$va === void 0 || _referenceLayerRef$va.parentNode.removeChild(referenceLayerRef.value);
      };
      var showDialogGuide = function showDialogGuide() {
        VueCompositionAPI.nextTick(function () {
          currentHighlightLayerElm.value = dialogTooltipRef.value;
          scrollToParentVisibleArea(currentHighlightLayerElm.value);
          setHighlightLayerPosition(highlightLayerRef.value);
          scrollToElm(currentHighlightLayerElm.value);
        });
      };
      var destroyDialogTooltipElm = function destroyDialogTooltipElm() {
        var _dialogTooltipRef$val, _dialogWrapperRef$val;
        (_dialogTooltipRef$val = dialogTooltipRef.value) === null || _dialogTooltipRef$val === void 0 || _dialogTooltipRef$val.parentNode.removeChild(dialogTooltipRef.value);
        (_dialogWrapperRef$val = dialogWrapperRef.value) === null || _dialogWrapperRef$val === void 0 || _dialogWrapperRef$val.parentNode.removeChild(dialogWrapperRef.value);
      };
      var showGuide = function showGuide() {
        if (isPopup.value) {
          destroyDialogTooltipElm();
          showPopupGuide();
        } else {
          destroyTooltipElm();
          showDialogGuide();
        }
      };
      var destroyGuide = function destroyGuide() {
        var _highlightLayerRef$va, _overlayLayerRef$valu;
        destroyTooltipElm();
        destroyDialogTooltipElm();
        (_highlightLayerRef$va = highlightLayerRef.value) === null || _highlightLayerRef$va === void 0 || _highlightLayerRef$va.parentNode.removeChild(highlightLayerRef.value);
        (_overlayLayerRef$valu = overlayLayerRef.value) === null || _overlayLayerRef$valu === void 0 || _overlayLayerRef$valu.parentNode.removeChild(overlayLayerRef.value);
        removeClass(document.body, LOCK_CLASS.value);
      };
      var handleSkip = function handleSkip(e) {
        var _props2$onSkip;
        var total = stepsTotal.value;
        activated.value = false;
        setInnerCurrent(-1, {
          e: e,
          total: total
        });
        var eventParams = {
          e: e,
          current: innerCurrent.value,
          total: total
        };
        (_props2$onSkip = props2.onSkip) === null || _props2$onSkip === void 0 || _props2$onSkip.call(props2, eventParams);
        context.emit("skip", eventParams);
      };
      var handlePrev = function handlePrev(e) {
        var _props2$onPrevStepCli;
        var total = stepsTotal.value;
        setInnerCurrent(innerCurrent.value - 1, {
          e: e,
          total: total
        });
        var eventParams = {
          e: e,
          prev: innerCurrent.value - 1,
          current: innerCurrent.value,
          total: total
        };
        (_props2$onPrevStepCli = props2.onPrevStepClick) === null || _props2$onPrevStepCli === void 0 || _props2$onPrevStepCli.call(props2, eventParams);
        context.emit("prev-step-click", eventParams);
      };
      var handleNext = function handleNext(e) {
        var _props2$onNextStepCli;
        var total = stepsTotal.value;
        setInnerCurrent(innerCurrent.value + 1, {
          e: e,
          total: total
        });
        var eventParams = {
          e: e,
          next: innerCurrent.value + 1,
          current: innerCurrent.value,
          total: total
        };
        (_props2$onNextStepCli = props2.onNextStepClick) === null || _props2$onNextStepCli === void 0 || _props2$onNextStepCli.call(props2, eventParams);
        context.emit("next-step-click", eventParams);
      };
      var handleFinish = function handleFinish(e) {
        var _props2$onFinish;
        var total = stepsTotal.value;
        activated.value = false;
        setInnerCurrent(-1, {
          e: e,
          total: total
        });
        (_props2$onFinish = props2.onFinish) === null || _props2$onFinish === void 0 || _props2$onFinish.call(props2, {
          e: e,
          current: innerCurrent.value,
          total: total
        });
        context.emit("finish", {
          e: e,
          current: innerCurrent.value,
          total: total
        });
      };
      var initGuide = function initGuide() {
        var _props2$steps2;
        if (innerCurrent.value >= 0 && innerCurrent.value < ((_props2$steps2 = props2.steps) === null || _props2$steps2 === void 0 ? void 0 : _props2$steps2.length)) {
          if (!activated.value) {
            activated.value = true;
            addClass(document.body, LOCK_CLASS.value);
          }
          showGuide();
        }
      };
      VueCompositionAPI.watch(innerCurrent, function (val) {
        var _props2$steps3;
        if (val >= 0 && val < ((_props2$steps3 = props2.steps) === null || _props2$steps3 === void 0 ? void 0 : _props2$steps3.length)) {
          initGuide();
        } else {
          activated.value = false;
          destroyGuide();
        }
      });
      VueCompositionAPI.onMounted(function () {
        initGuide();
      });
      return {
        classPrefix: classPrefix,
        componentName: COMPONENT_NAME,
        innerCurrent: innerCurrent,
        isPopup: isPopup,
        currentElmIsFixed: currentElmIsFixed,
        currentStepInfo: currentStepInfo,
        stepsTotal: stepsTotal,
        handlePrev: handlePrev,
        handleNext: handleNext,
        handleSkip: handleSkip,
        handleFinish: handleFinish,
        getCurrentCrossProps: getCurrentCrossProps,
        global: global,
        highlightLayerRef: highlightLayerRef,
        overlayLayerRef: overlayLayerRef,
        referenceLayerRef: referenceLayerRef,
        currentHighlightLayerElm: currentHighlightLayerElm,
        dialogWrapperRef: dialogWrapperRef,
        dialogTooltipRef: dialogTooltipRef,
        activated: activated
      };
    },
    render: function render(h) {
      var _this = this;
      var stepsTotal = this.stepsTotal;
      var currentStepInfo = this.currentStepInfo;
      var globalConfig = this.global;
      var getCurrentCrossProps = this.getCurrentCrossProps;
      var renderTooltipTitle = function renderTooltipTitle(h2) {
        var currentStepInfo2 = _this.currentStepInfo;
        var functionTitle = isFunction(currentStepInfo2.title) ? currentStepInfo2.title(h2) : void 0;
        var slotTitle = _this.$scopedSlots.title ? _this.$scopedSlots.title(h2) : void 0;
        var title = functionTitle || slotTitle || currentStepInfo2.title;
        return title ? h("div", {
          "class": "".concat(_this.componentName, "__title")
        }, [title]) : null;
      };
      var getHighlightContent = function getHighlightContent(h2) {
        var params = h2;
        params.currentStepInfo = _this.currentStepInfo;
        var highlightContent = _this.currentStepInfo.highlightContent;
        var node = highlightContent;
        if (isFunction(highlightContent)) {
          node = highlightContent(params);
        } else if (_this.$scopedSlots.highlightContent) {
          node = _this.$scopedSlots.highlightContent(params);
        } else if (_this.$scopedSlots["highlight-content"]) {
          node = _this.$scopedSlots["highlight-content"](params);
        } else if (highlightContent) {
          node = h(node);
        }
        if (node) {
          node.props = node.props || {};
          node.props["class"] = "".concat(_this.componentName, "__highlight--mask ").concat(node.props["class"] || "");
        }
        return node;
      };
      var renderOverlayLayer = function renderOverlayLayer() {
        return h("div", {
          "ref": "overlayLayerRef",
          "directives": [{
            name: "transfer-dom",
            value: "body"
          }],
          "class": "".concat(_this.componentName, "__overlay"),
          "style": {
            zIndex: _this.zIndex - 2
          }
        });
      };
      var renderAction = function renderAction(mode) {
        var _getCurrentCrossProps, _getCurrentCrossProps2, _getCurrentCrossProps3, _this$finishButtonPro;
        var isLast = _this.innerCurrent === stepsTotal - 1;
        var isFirst = _this.innerCurrent === 0;
        var buttonSize = mode === "popup" ? "small" : "medium";
        return h("div", {
          "class": "".concat(_this.componentName, "__action")
        }, [!_this.hideSkip && !isLast && h(Button, {
          "class": "".concat(_this.componentName, "__skip"),
          "props": _objectSpread$d({}, _objectSpread$d({
            theme: "default",
            size: buttonSize,
            variant: "base",
            onClick: _this.handleSkip
          }, (_getCurrentCrossProps = getCurrentCrossProps("skipButtonProps")) !== null && _getCurrentCrossProps !== void 0 ? _getCurrentCrossProps : globalConfig.skipButtonProps))
        }), !_this.hidePrev && !isFirst && h(Button, {
          "class": "".concat(_this.componentName, "__prev"),
          "props": _objectSpread$d({}, _objectSpread$d({
            theme: "primary",
            size: buttonSize,
            variant: "base",
            onClick: _this.handlePrev
          }, (_getCurrentCrossProps2 = getCurrentCrossProps("prevButtonProps")) !== null && _getCurrentCrossProps2 !== void 0 ? _getCurrentCrossProps2 : globalConfig.prevButtonProps))
        }), !isLast && h(Button, {
          "class": "".concat(_this.componentName, "__next"),
          "props": _objectSpread$d({}, _objectSpread$d({
            theme: "primary",
            size: buttonSize,
            variant: "base",
            onClick: _this.handleNext
          }, (_getCurrentCrossProps3 = getCurrentCrossProps("nextButtonProps")) !== null && _getCurrentCrossProps3 !== void 0 ? _getCurrentCrossProps3 : globalConfig.nextButtonProps))
        }), isLast && h(Button, {
          "class": "".concat(_this.componentName, "__finish"),
          "props": _objectSpread$d({}, _objectSpread$d({
            theme: "primary",
            size: buttonSize,
            variant: "base",
            onClick: _this.handleFinish
          }, (_this$finishButtonPro = _this.finishButtonProps) !== null && _this$finishButtonPro !== void 0 ? _this$finishButtonPro : globalConfig.finishButtonProps))
        })]);
      };
      var renderTooltipBody = function renderTooltipBody(h2) {
        var stepBody = _this.currentStepInfo.body;
        var descBody;
        if (isFunction(stepBody)) {
          descBody = stepBody(h2);
        } else if (_this.$scopedSlots.body) {
          var hParams = h2;
          Object.assign(hParams, {
            currentStepInfo: _this.currentStepInfo
          });
          descBody = _this.$scopedSlots.body(hParams);
        } else if (typeof stepBody === "string") {
          descBody = stepBody;
        } else {
          descBody = h(stepBody);
        }
        return descBody ? h("div", {
          "class": "".concat(_this.componentName, "__desc")
        }, [descBody]) : null;
      };
      var renderPopupContent = function renderPopupContent() {
        var footerClasses = ["".concat(_this.componentName, "__footer"), "".concat(_this.componentName, "__footer--popup")];
        var action = h("div", {
          "class": footerClasses
        }, [renderCounter(), renderAction("popup")]);
        return h("div", {
          "class": "".concat(_this.componentName, "__tooltip")
        }, [renderTooltipTitle(h), renderTooltipBody(h), action]);
      };
      var renderHighlightLayer = function renderHighlightLayer() {
        var style = {
          zIndex: _this.zIndex - 1
        };
        var highlightClass = ["".concat(_this.componentName, "__highlight"), "".concat(_this.componentName, "__highlight--").concat(_this.isPopup ? "popup" : "dialog"), "".concat(_this.componentName, "--").concat(_this.currentElmIsFixed && _this.isPopup ? "fixed" : "absolute")];
        var showOverlay = getCurrentCrossProps("showOverlay");
        var maskClass = ["".concat(_this.componentName, "__highlight--").concat(showOverlay ? "mask" : "nomask")];
        var innerHighlightContent = getHighlightContent(h);
        var showHighlightContent = Boolean(innerHighlightContent && _this.isPopup);
        return h("div", {
          "ref": "highlightLayerRef",
          "directives": [{
            name: "transfer-dom",
            value: "body"
          }],
          "class": highlightClass.concat(showHighlightContent ? [] : maskClass),
          "style": style
        }, [showHighlightContent && innerHighlightContent]);
      };
      var renderCounter = function renderCounter() {
        var popupSlotCounter = renderTNodeJSX(_this, "counter", {
          params: {
            total: _this.stepsTotal,
            current: _this.innerCurrent
          }
        });
        var popupDefaultCounter = h("div", {
          "class": "".concat(_this.componentName, "__counter")
        }, [popupSlotCounter || "".concat(_this.innerCurrent + 1, "/").concat(_this.stepsTotal)]);
        return !_this.hideCounter ? popupDefaultCounter : null;
      };
      var renderDialogGuide = function renderDialogGuide() {
        var style = {
          zIndex: _this.zIndex
        };
        var wrapperClasses = ["".concat(_this.componentName, "__wrapper"), _defineProperty$2({}, "".concat(_this.componentName, "__wrapper--center"), currentStepInfo.placement === "center")];
        var dialogClasses = ["".concat(_this.componentName, "__reference"), "".concat(_this.componentName, "--absolute"), "".concat(_this.componentName, "__dialog"), _defineProperty$2(_defineProperty$2({}, "".concat(_this.componentName, "__dialog--nomask"), !getCurrentCrossProps("showOverlay")), currentStepInfo.stepOverlayClass, !!currentStepInfo.stepOverlayClass)];
        var footerClasses = ["".concat(_this.componentName, "__footer"), "".concat(_this.componentName, "__footer--popup")];
        return h("div", [h("div", {
          "ref": "dialogWrapperRef",
          "directives": [{
            name: "transfer-dom",
            value: "body"
          }],
          "class": wrapperClasses,
          "style": style
        }, [h("div", {
          "ref": "dialogTooltipRef",
          "class": dialogClasses
        }, [renderTooltipTitle(h), renderTooltipBody(h), h("div", {
          "class": footerClasses
        }, [renderCounter(), renderAction("dialog")])])])]);
      };
      var renderPopupGuide = function renderPopupGuide() {
        var _currentStepInfo$popu;
        var content = currentStepInfo.content;
        var contentProps = {
          handlePrev: _this.handlePrev,
          handleNext: _this.handleNext,
          handleSkip: _this.handleSkip,
          handleFinish: _this.handleFinish,
          current: _this.innerCurrent,
          total: _this.stepsTotal
        };
        var hParams = h;
        hParams.currentStepInfo = _this.currentStepInfo;
        var renderBody;
        if (isFunction(content)) {
          renderBody = function renderBody() {
            return content(hParams);
          };
        } else if (_this.$scopedSlots.content) {
          renderBody = function renderBody() {
            return _this.$scopedSlots.content(hParams);
          };
        } else if (typeof content === "string") {
          renderBody = content;
        } else if (content) {
          renderBody = function renderBody() {
            return h(content, helper([{}, {
              "props": contentProps
            }]));
          };
        } else {
          renderBody = renderPopupContent;
        }
        var classes = ["".concat(_this.componentName, "__reference"), "".concat(_this.componentName, "--").concat(_this.currentElmIsFixed ? "fixed" : "absolute")];
        var innerClassName = [_defineProperty$2({}, "".concat(_this.classPrefix, "-guide__popup--content"), !!content)];
        return h(Popup, helper([{
          "attrs": {
            "visible": true,
            "show-arrow": !content,
            "zIndex": _this.zIndex,
            "placement": currentStepInfo.placement
          }
        }, {
          "props": currentStepInfo.popupProps
        }, {
          "attrs": {
            "content": renderBody,
            "overlayClassName": ["".concat(_this.componentName, "__popup"), currentStepInfo === null || currentStepInfo === void 0 ? void 0 : currentStepInfo.stepOverlayClass],
            "overlayInnerClassName": innerClassName.concat((_currentStepInfo$popu = currentStepInfo.popupProps) === null || _currentStepInfo$popu === void 0 ? void 0 : _currentStepInfo$popu.overlayInnerClassName)
          }
        }]), [h("div", {
          "ref": "referenceLayerRef",
          "directives": [{
            name: "transfer-dom",
            value: "body"
          }],
          "class": classes
        })]);
      };
      return this.activated ? h("div", [renderOverlayLayer(), renderHighlightLayer(), this.isPopup ? renderPopupGuide() : renderDialogGuide()]) : null;
    }
  });

  var Guide = withInstall$1(_Guide);

  var Message = withInstall$1(_Message);

  var props$2 = {
    closeBtn: {
      type: [String, Boolean, Function],
      "default": void 0
    },
    content: {
      type: [String, Function]
    },
    "default": {
      type: [String, Function]
    },
    duration: {
      type: Number,
      "default": 3e3
    },
    footer: {
      type: [String, Function]
    },
    icon: {
      type: [Boolean, Function],
      "default": true
    },
    theme: {
      type: String,
      "default": "info",
      validator: function validator(val) {
        if (!val) return true;
        return ["info", "success", "warning", "error"].includes(val);
      }
    },
    title: {
      type: [String, Function]
    },
    onCloseBtnClick: Function,
    onDurationEnd: Function
  };

  function ownKeys$c(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$c(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$c(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$c(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins$1 = getClassPrefixMixins("notification");
  var _Notification = mixins(classPrefixMixins$1, getGlobalIconMixins()).extend({
    name: "TNotification",
    props: _objectSpread$c({}, props$2),
    data: function data() {
      return {
        timer: null
      };
    },
    created: function created() {
      this.duration && this.setTimer();
    },
    methods: {
      setTimer: function setTimer() {
        var _this = this;
        if (!this.duration) {
          return;
        }
        this.timer = Number(setTimeout(function () {
          _this.clearTimer();
          _this.$emit("duration-end");
          if (_this.onDurationEnd) {
            _this.onDurationEnd();
          }
        }, this.duration));
      },
      clearTimer: function clearTimer() {
        this.duration && clearTimeout(this.timer);
      },
      close: function close(e) {
        this.$emit("close-btn-click", {
          e: e
        });
        if (this.onCloseBtnClick) {
          this.onCloseBtnClick({
            e: e
          });
        }
      },
      renderIcon: function renderIcon(h) {
        var icon;
        if (this.icon === false) return null;
        if (isFunction(this.icon)) {
          icon = this.icon(h);
        } else if (this.$scopedSlots.icon) {
          icon = this.$scopedSlots.icon(null);
        } else if (this.theme) {
          var _this$useGlobalIcon = this.useGlobalIcon({
              InfoCircleFilledIcon: TdInfoCircleFilledIcon,
              CheckCircleFilledIcon: TdCheckCircleFilledIcon
            }),
            InfoCircleFilledIcon = _this$useGlobalIcon.InfoCircleFilledIcon,
            CheckCircleFilledIcon = _this$useGlobalIcon.CheckCircleFilledIcon;
          var iconType = this.theme === "success" ? h(CheckCircleFilledIcon, {
            "class": "".concat(this.classPrefix, "-is-").concat(this.theme)
          }) : h(InfoCircleFilledIcon, {
            "class": "".concat(this.classPrefix, "-is-").concat(this.theme)
          });
          icon = h("div", {
            "class": "".concat(this.componentName, "__icon")
          }, [iconType]);
        }
        return icon;
      },
      renderClose: function renderClose() {
        var h = this.$createElement;
        var _this$useGlobalIcon2 = this.useGlobalIcon({
            CloseIcon: TdCloseIcon
          }),
          CloseIcon = _this$useGlobalIcon2.CloseIcon;
        var defaultClose = h(CloseIcon);
        return h("span", {
          "class": "".concat(this.classPrefix, "-message__close"),
          "on": {
            "click": this.close
          }
        }, [renderTNodeJSX(this, "closeBtn", defaultClose)]);
      },
      renderContent: function renderContent$1() {
        var h = this.$createElement;
        return h("div", {
          "class": "".concat(this.componentName, "__content")
        }, [renderContent(this, "default", "content")]);
      }
    },
    render: function render(h) {
      var icon = this.renderIcon(h);
      var close = this.renderClose();
      var content = this.renderContent();
      var footer = renderTNodeJSX(this, "footer");
      var title = renderTNodeJSX(this, "title");
      return h("div", {
        "class": "".concat(this.componentName),
        "on": {
          "mouseenter": this.clearTimer,
          "mouseleave": this.setTimer
        }
      }, [icon, h("div", {
        "class": "".concat(this.componentName, "__main")
      }, [h("div", {
        "class": "".concat(this.componentName, "__title__wrap")
      }, [h("span", {
        "class": "".concat(this.componentName, "__title")
      }, [title]), close]), content, footer])]);
    }
  });

  var DEFAULT_Z_INDEX = 6e3;
  var DISTANCE = "16px";
  var PLACEMENT_OFFSET = {
    "top-left": {
      left: DISTANCE,
      top: DISTANCE
    },
    "top-right": {
      right: DISTANCE,
      top: DISTANCE
    },
    "bottom-right": {
      right: DISTANCE,
      bottom: DISTANCE
    },
    "bottom-left": {
      left: DISTANCE,
      bottom: DISTANCE
    }
  };

  function ownKeys$b(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$b(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$b(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$b(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var classPrefixMixins = getClassPrefixMixins("notification");
  var NotificationList = mixins(classPrefixMixins).extend({
    components: {
      Notification: _Notification
    },
    props: {
      placement: {
        type: String,
        "default": "top-right",
        validator: function validator(v) {
          return ["top-left", "top-right", "bottom-left", "bottom-right"].indexOf(v) > -1;
        }
      }
    },
    data: function data() {
      return {
        list: []
      };
    },
    computed: {
      styles: function styles() {
        return _objectSpread$b({
          zIndex: DEFAULT_Z_INDEX
        }, PLACEMENT_OFFSET[this.placement]);
      }
    },
    methods: {
      add: function add(options) {
        this.list.push(options);
        return this.list.length - 1;
      },
      remove: function remove(index) {
        this.list.splice(index, 1);
      },
      removeAll: function removeAll() {
        this.list = [];
      },
      getOffset: function getOffset(val) {
        if (!val) return;
        return isNaN(Number(val)) ? val : "".concat(val, "px");
      },
      notificationStyles: function notificationStyles(item) {
        var styles = {
          marginBottom: DISTANCE
        };
        if (item.offset) {
          styles.position = "relative";
          styles.left = this.getOffset(item.offset[0]);
          styles.top = this.getOffset(item.offset[1]);
        }
        if (item.zIndex) styles["z-index"] = item.zIndex;
        return styles;
      },
      getListeners: function getListeners(index) {
        var _this = this;
        return {
          "close-btn-click": function closeBtnClick() {
            return _this.remove(index);
          },
          "duration-end": function durationEnd() {
            return _this.remove(index);
          }
        };
      }
    },
    render: function render() {
      var _this2 = this;
      var h = arguments[0];
      if (!this.list.length) return;
      return h("div", {
        "class": "".concat(this.componentName, "__show--").concat(this.placement),
        "style": this.styles
      }, [this.list.map(function (item, index) {
        return h("t-notification", {
          "key": item.id,
          "style": _this2.notificationStyles(item),
          "props": _objectSpread$b({}, item),
          "on": _objectSpread$b({}, _this2.getListeners(index))
        });
      })]);
    }
  });

  function ownKeys$a(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$a(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$a(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$a(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var seed = 0;
  var instanceMap = /* @__PURE__ */new Map();
  var NotificationFunction = function NotificationFunction(options) {
    seed += 1;
    var hackOptions = _objectSpread$a({
      placement: "top-right",
      zIndex: 6e3,
      attach: "body",
      id: seed
    }, options);
    hackOptions.content = options.content ? options.content : "";
    var attachEl = getAttach(hackOptions.attach);
    if (!instanceMap.get(attachEl)) {
      instanceMap.set(attachEl, {});
    }
    var tmpInstance = instanceMap.get(attachEl)[hackOptions.placement];
    if (!tmpInstance) {
      var list = new NotificationList({
        propsData: {
          placement: hackOptions.placement
        }
      });
      list.add(hackOptions);
      list.$mount();
      instanceMap.get(attachEl)[hackOptions.placement] = list;
      attachEl.appendChild(list.$el);
      tmpInstance = instanceMap.get(attachEl)[hackOptions.placement];
    } else {
      tmpInstance.add(hackOptions);
    }
    return new Promise(function (resolve) {
      tmpInstance.$nextTick(function () {
        var list = tmpInstance.$children;
        resolve(list[list.length - 1]);
      });
    });
  };
  var showThemeNotification = function showThemeNotification(theme, options) {
    var hackOptions = _objectSpread$a(_objectSpread$a({}, options), {}, {
      theme: theme
    });
    return NotificationFunction(hackOptions);
  };
  var extraApi = {
    info: function info(options) {
      return showThemeNotification("info", options);
    },
    success: function success(options) {
      return showThemeNotification("success", options);
    },
    warning: function warning(options) {
      return showThemeNotification("warning", options);
    },
    error: function error(options) {
      return showThemeNotification("error", options);
    },
    close: function close(promise) {
      promise.then(function (instance) {
        return instance.close();
      });
    },
    closeAll: function closeAll() {
      instanceMap.forEach(function (attach) {
        Object.keys(attach).forEach(function (placement) {
          attach[placement].removeAll();
        });
      });
    }
  };
  var NotificationPlugin = showThemeNotification;
  Object.keys(extraApi).forEach(function (funcName) {
    NotificationPlugin[funcName] = extraApi[funcName];
  });
  NotificationPlugin.install = function () {
    Vue__default["default"].prototype.$notify = NotificationPlugin;
    Vue__default["default"].prototype.$notification = NotificationPlugin;
  };
  var notify = NotificationPlugin;
  var NotifyPlugin = NotificationPlugin;

  var Notification = withInstall$1(_Notification);

  var props$1 = {
    cancelBtn: {
      type: [String, Object, Function],
      "default": ""
    },
    confirmBtn: {
      type: [String, Object, Function],
      "default": ""
    },
    content: {
      type: [String, Function]
    },
    "default": {
      type: [String, Function]
    },
    destroyOnClose: {
      type: Boolean,
      "default": true
    },
    icon: {
      type: Function
    },
    placement: {
      type: String,
      "default": "top",
      validator: function validator(val) {
        return ["top", "left", "right", "bottom", "top-left", "top-right", "bottom-left", "bottom-right", "left-top", "left-bottom", "right-top", "right-bottom"].includes(val);
      }
    },
    popupProps: {
      type: Object
    },
    showArrow: {
      type: Boolean,
      "default": true
    },
    theme: {
      type: String,
      "default": "default",
      validator: function validator(val) {
        return ["default", "warning", "danger"].includes(val);
      }
    },
    triggerElement: {
      type: [String, Function]
    },
    visible: Boolean,
    defaultVisible: Boolean,
    onCancel: Function,
    onConfirm: Function,
    onVisibleChange: Function
  };

  function ownKeys$9(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$9(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$9(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$9(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _Popconfirm = mixins(ActionMixin, getConfigReceiverMixins("popconfirm"), getGlobalIconMixins()).extend({
    name: "TPopconfirm",
    props: _objectSpread$9({}, props$1),
    model: {
      prop: "visible",
      event: "visible-change"
    },
    computed: {
      themeIcon: function themeIcon() {
        var _this$useGlobalIcon = this.useGlobalIcon({
            InfoCircleFilledIcon: TdInfoCircleFilledIcon,
            ErrorCircleFilledIcon: TdErrorCircleFilledIcon
          }),
          InfoCircleFilledIcon = _this$useGlobalIcon.InfoCircleFilledIcon,
          ErrorCircleFilledIcon = _this$useGlobalIcon.ErrorCircleFilledIcon;
        var iconMap = {
          "default": InfoCircleFilledIcon,
          warning: ErrorCircleFilledIcon,
          danger: ErrorCircleFilledIcon
        };
        return iconMap[this.theme];
      },
      iconCls: function iconCls() {
        var theme = this.theme || "default";
        return "".concat(this.componentName, "__icon--").concat(theme);
      },
      innerPopupProps: function innerPopupProps() {
        return _objectSpread$9({
          showArrow: this.showArrow,
          overlayClassName: [this.componentName, "".concat(this.componentName, "__popup--").concat(this.theme || "default")],
          trigger: "click",
          destroyOnClose: this.destroyOnClose,
          placement: this.placement
        }, this.popupProps);
      }
    },
    methods: {
      cancelBtnAction: function cancelBtnAction(e) {
        emitEvent$1(this, "cancel", {
          e: e
        });
        var cancelContext = {
          e: e,
          trigger: "cancel"
        };
        emitEvent$1(this, "visible-change", false, cancelContext);
      },
      confirmBtnAction: function confirmBtnAction(e) {
        emitEvent$1(this, "confirm", {
          e: e
        });
        var confirmContext = {
          e: e,
          trigger: "confirm"
        };
        emitEvent$1(this, "visible-change", false, confirmContext);
      },
      renderIcon: function renderIcon() {
        var h = this.$createElement;
        var Icon = this.themeIcon;
        return renderTNodeJSXDefault(this, "icon", h(Icon, {
          "class": this.iconCls
        }));
      },
      onPopupVisibleChange: function onPopupVisibleChange(val, context) {
        this.$emit("visible-change", val, context);
        this.onVisibleChange && this.onVisibleChange(val, context);
      }
    },
    render: function render() {
      var h = arguments[0];
      var triggerElement = renderContent(this, "default", "triggerElement");
      var cancelBtn = this.getCancelBtn({
        cancelBtn: this.cancelBtn,
        globalCancel: this.global.cancel,
        size: "small",
        className: "".concat(this.componentName, "__cancel")
      });
      var confirmBtn = this.getConfirmBtn({
        theme: this.theme,
        confirmBtn: this.confirmBtn,
        globalConfirm: this.global.confirm,
        size: "small",
        globalConfirmBtnTheme: this.global.confirmBtnTheme,
        className: "".concat(this.componentName, "__confirm")
      });
      return h(Popup, helper([{
        "ref": "popup",
        "attrs": {
          "visible": this.visible
        }
      }, {
        "props": this.innerPopupProps
      }, {}, {
        "on": {
          "visible-change": this.onPopupVisibleChange
        }
      }]), [h("template", {
        "slot": "content",
        "attrs": {
          "role": "popconfirm"
        }
      }, [h("div", {
        "class": "".concat(this.componentName, "__content")
      }, [h("div", {
        "class": "".concat(this.componentName, "__body")
      }, [this.renderIcon(), h("div", {
        "class": "".concat(this.componentName, "__inner")
      }, [renderTNodeJSX(this, "content")])]), Boolean(cancelBtn || confirmBtn) && h("div", {
        "class": "".concat(this.componentName, "__buttons")
      }, [cancelBtn, confirmBtn])])]), triggerElement]);
    }
  });

  var Popconfirm = withInstall$1(mapProps(["visible"], {
    model: {
      prop: "visible",
      event: "visible-change"
    }
  })(_Popconfirm));

  var props = {
    abridgeName: {
      type: Array
    },
    accept: {
      type: String,
      "default": ""
    },
    action: {
      type: String,
      "default": ""
    },
    allowUploadDuplicateFile: Boolean,
    autoUpload: {
      type: Boolean,
      "default": true
    },
    beforeAllFilesUpload: {
      type: Function
    },
    beforeUpload: {
      type: Function
    },
    cancelUploadButton: {
      type: [Object, Function]
    },
    data: {
      type: Object
    },
    "default": {
      type: [String, Function]
    },
    disabled: Boolean,
    dragContent: {
      type: [String, Function]
    },
    draggable: {
      type: Boolean,
      "default": void 0
    },
    fileListDisplay: {
      type: Function
    },
    files: {
      type: Array,
      "default": void 0
    },
    defaultFiles: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    format: {
      type: Function
    },
    formatRequest: {
      type: Function
    },
    formatResponse: {
      type: Function
    },
    headers: {
      type: Object
    },
    imageViewerProps: {
      type: Object
    },
    inputAttributes: {
      type: Object
    },
    isBatchUpload: Boolean,
    locale: {
      type: Object
    },
    max: {
      type: Number,
      "default": 0
    },
    method: {
      type: String,
      "default": "POST",
      validator: function validator(val) {
        if (!val) return true;
        return ["POST", "GET", "PUT", "OPTIONS", "PATCH", "post", "get", "put", "options", "patch"].includes(val);
      }
    },
    mockProgressDuration: {
      type: Number
    },
    multiple: Boolean,
    name: {
      type: String,
      "default": "file"
    },
    placeholder: {
      type: String,
      "default": ""
    },
    requestMethod: {
      type: Function
    },
    showImageFileName: {
      type: Boolean,
      "default": true
    },
    showThumbnail: Boolean,
    showUploadProgress: {
      type: Boolean,
      "default": true
    },
    sizeLimit: {
      type: [Number, Object]
    },
    status: {
      type: String,
      validator: function validator(val) {
        if (!val) return true;
        return ["default", "success", "warning", "error"].includes(val);
      }
    },
    theme: {
      type: String,
      "default": "file",
      validator: function validator(val) {
        if (!val) return true;
        return ["custom", "file", "file-input", "file-flow", "image", "image-flow"].includes(val);
      }
    },
    tips: {
      type: [String, Function]
    },
    trigger: {
      type: Function
    },
    triggerButtonProps: {
      type: Object
    },
    uploadAllFilesInOneRequest: Boolean,
    uploadButton: {
      type: [Object, Function]
    },
    uploadPastedFiles: {
      type: Boolean,
      "default": true
    },
    useMockProgress: {
      type: Boolean,
      "default": true
    },
    value: {
      type: Array,
      "default": void 0
    },
    defaultValue: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    withCredentials: Boolean,
    onCancelUpload: Function,
    onChange: Function,
    onDragenter: Function,
    onDragleave: Function,
    onDrop: Function,
    onFail: Function,
    onOneFileFail: Function,
    onOneFileSuccess: Function,
    onPreview: Function,
    onProgress: Function,
    onRemove: Function,
    onSelectChange: Function,
    onSuccess: Function,
    onValidate: Function,
    onWaitingUploadFilesChange: Function
  };

  var commonProps = {
    accept: String,
    files: Array,
    toUploadFiles: Array,
    displayFiles: Array,
    theme: String,
    abridgeName: Array,
    placeholder: String,
    classPrefix: String,
    tips: [String, Function],
    status: String,
    locale: Object,
    sizeOverLimitMessage: String,
    autoUpload: Boolean,
    disabled: Boolean,
    uploading: Boolean,
    tipsClasses: [String, Array, Object],
    errorClasses: [String, Array, Object],
    placeholderClass: [String, Array, Object],
    showUploadProgress: Boolean,
    "default": Function,
    fileListDisplay: Function,
    onRemove: Function,
    imageViewerProps: Object
  };

  function ownKeys$8(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$8(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$8(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$8(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var NormalFile = VueCompositionAPI.defineComponent({
    name: "UploadNormalFile",
    props: _objectSpread$8({
      multiple: Boolean
    }, commonProps),
    setup: function setup(props) {
      var icons = useGlobalIcon({
        CloseIcon: TdCloseIcon,
        TimeFilledIcon: TdTimeFilledIcon,
        CheckCircleFilledIcon: TdCheckCircleFilledIcon,
        ErrorCircleFilledIcon: TdErrorCircleFilledIcon,
        CloseCircleFilledIcon: TdCloseCircleFilledIcon
      });
      var uploadPrefix = VueCompositionAPI.computed(function () {
        return "".concat(props.classPrefix, "-upload");
      });
      var classes = VueCompositionAPI.computed(function () {
        return ["".concat(uploadPrefix.value, "__single"), "".concat(uploadPrefix.value, "__single-").concat(props.theme)];
      });
      return {
        classes: classes,
        uploadPrefix: uploadPrefix,
        icons: icons
      };
    },
    methods: {
      renderProgress: function renderProgress(percent) {
        var h = this.$createElement;
        return h("div", {
          "class": "".concat(this.uploadPrefix, "__single-progress")
        }, [h(Loading), h("span", {
          "class": "".concat(this.uploadPrefix, "__single-percent")
        }, [percent || 0, "%"])]);
      },
      renderFilePreviewAsText: function renderFilePreviewAsText(files) {
        var _files$,
          _this = this;
        var h = this.$createElement;
        if (this.theme !== "file") return null;
        if (!this.multiple && ((_files$ = files[0]) === null || _files$ === void 0 ? void 0 : _files$.status) === "fail" && this.autoUpload) {
          return null;
        }
        var _this$icons = this.icons,
          ErrorCircleFilledIcon = _this$icons.ErrorCircleFilledIcon,
          TimeFilledIcon = _this$icons.TimeFilledIcon,
          CloseIcon = _this$icons.CloseIcon;
        return files.map(function (file, index) {
          var fileName = _this.abridgeName && file.name ? abridgeName.apply(void 0, [file.name].concat(_toConsumableArray(_this.abridgeName))) : file.name;
          return h("div", {
            "class": "".concat(_this.uploadPrefix, "__single-display-text ").concat(_this.uploadPrefix, "__display-text--margin"),
            "key": file.name + index + file.percent + file.status
          }, [file.url ? h(Link, {
            "attrs": {
              "href": file.url,
              "target": "_blank",
              "hover": "color",
              "size": "small"
            },
            "class": "".concat(_this.uploadPrefix, "__single-name")
          }, [fileName]) : h("span", {
            "class": "".concat(_this.uploadPrefix, "__single-name")
          }, [fileName]), file.status === "fail" && h("div", {
            "class": "".concat(_this.uploadPrefix, "__flow-status ").concat(_this.uploadPrefix, "__file-fail")
          }, [h(ErrorCircleFilledIcon)]), file.status === "waiting" && h("div", {
            "class": "".concat(_this.uploadPrefix, "__flow-status ").concat(_this.uploadPrefix, "__file-waiting")
          }, [h(TimeFilledIcon)]), file.status === "progress" && _this.renderProgress(file.percent), !_this.disabled && file.status !== "progress" && h(CloseIcon, {
            "class": "".concat(_this.uploadPrefix, "__icon-delete"),
            "on": {
              "click": function click(_ref) {
                var e = _ref.e;
                return _this.onRemove({
                  e: e,
                  file: file,
                  index: index
                });
              }
            }
          })]);
        });
      },
      renderFilePreviewAsInput: function renderFilePreviewAsInput() {
        var _this$abridgeName,
          _this2 = this;
        var h = this.$createElement;
        if (this.theme !== "file-input") return;
        var _this$icons2 = this.icons,
          TimeFilledIcon = _this$icons2.TimeFilledIcon,
          CheckCircleFilledIcon = _this$icons2.CheckCircleFilledIcon,
          ErrorCircleFilledIcon = _this$icons2.ErrorCircleFilledIcon,
          CloseCircleFilledIcon = _this$icons2.CloseCircleFilledIcon;
        var file = this.displayFiles[0] || {};
        var inputTextClass = ["".concat(this.classPrefix, "-input__inner"), _defineProperty$2({}, "".concat(this.uploadPrefix, "__placeholder"), !this.displayFiles[0])];
        var disabledClass = this.disabled ? "".concat(this.classPrefix, "-is-disabled") : "";
        var fileName = (_this$abridgeName = this.abridgeName) !== null && _this$abridgeName !== void 0 && _this$abridgeName.length && file !== null && file !== void 0 && file.name ? abridgeName.apply(void 0, [file.name].concat(_toConsumableArray(this.abridgeName))) : file === null || file === void 0 ? void 0 : file.name;
        return h("div", {
          "class": "".concat(this.uploadPrefix, "__single-input-preview ").concat(this.classPrefix, "-input ").concat(disabledClass)
        }, [h("div", {
          "class": inputTextClass
        }, [h("span", {
          "class": ["".concat(this.uploadPrefix, "__single-input-text"), _defineProperty$2({}, this.placeholderClass, this.placeholder)]
        }, [file.name ? fileName : this.placeholder]), file.status === "progress" && this.renderProgress(file.percent), file.status === "waiting" && h(TimeFilledIcon, {
          "class": "".concat(this.uploadPrefix, "__status-icon ").concat(this.uploadPrefix, "__file-waiting")
        }), file.status === "success" && h(CheckCircleFilledIcon, {
          "class": "".concat(this.uploadPrefix, "__status-icon")
        }), file.name && file.status === "fail" && h(ErrorCircleFilledIcon, {
          "class": "".concat(this.uploadPrefix, "__status-icon ").concat(this.uploadPrefix, "__file-fail")
        }), Boolean(!this.disabled && file.name) && h(CloseCircleFilledIcon, {
          "class": "".concat(this.uploadPrefix, "__single-input-clear"),
          "on": {
            "click": function click(_ref4) {
              var e = _ref4.e;
              return _this2.onRemove({
                e: e,
                file: file,
                index: 0
              });
            }
          }
        })])]);
      }
    },
    render: function render() {
      var _this$$scopedSlots$de, _this$$scopedSlots, _this$displayFiles$, _this$displayFiles$0$;
      var h = arguments[0];
      var fileListDisplay = renderTNodeJSX(this, "fileListDisplay", {
        params: {
          onRemove: this.onRemove,
          toUploadFiles: this.toUploadFiles,
          sizeOverLimitMessage: this.sizeOverLimitMessage,
          locale: this.locale,
          files: this.displayFiles
        }
      });
      if (this.fileListDisplay === null || fileListDisplay === null) {
        fileListDisplay = null;
      }
      return h("div", {
        "class": this.classes
      }, [this.theme === "file-input" && this.renderFilePreviewAsInput(), (_this$$scopedSlots$de = (_this$$scopedSlots = this.$scopedSlots)["default"]) === null || _this$$scopedSlots$de === void 0 ? void 0 : _this$$scopedSlots$de.call(_this$$scopedSlots, null), this.theme === "file" && this.placeholder && !this.displayFiles[0] && h("small", {
        "class": [this.tipsClasses, this.placeholderClass]
      }, [this.placeholder]), fileListDisplay === null ? null : fileListDisplay || this.renderFilePreviewAsText(this.displayFiles), !this.multiple && ((_this$displayFiles$ = this.displayFiles[0]) === null || _this$displayFiles$ === void 0 ? void 0 : _this$displayFiles$.status) === "fail" && this.theme === "file" ? h("small", {
        "class": [this.errorClasses, this.placeholderClass]
      }, [((_this$displayFiles$0$ = this.displayFiles[0].response) === null || _this$displayFiles$0$ === void 0 ? void 0 : _this$displayFiles$0$.error) || this.locale.progress.failText]) : null]);
    }
  });

  function useDrag(props, accept) {
    var target = VueCompositionAPI.ref(null);
    var dragActive = VueCompositionAPI.ref(false);
    var handleDrop = function handleDrop(event) {
      var _props$onDragFileChan, _props$onDrop;
      event.preventDefault();
      dragActive.value = false;
      var files = event.dataTransfer.files;
      var dragFiles = getFileList(files, accept.value);
      if (!dragFiles.length) return;
      (_props$onDragFileChan = props.onDragFileChange) === null || _props$onDragFileChan === void 0 || _props$onDragFileChan.call(props, dragFiles);
      (_props$onDrop = props.onDrop) === null || _props$onDrop === void 0 || _props$onDrop.call(props, {
        e: event
      });
    };
    var handleDragenter = function handleDragenter(event) {
      var _props$onDragenter;
      event.preventDefault();
      target.value = event.target;
      (_props$onDragenter = props.onDragenter) === null || _props$onDragenter === void 0 || _props$onDragenter.call(props, {
        e: event
      });
      dragActive.value = true;
    };
    var handleDragleave = function handleDragleave(event) {
      var _props$onDragleave;
      if (event.target !== target.value) return;
      event.preventDefault();
      (_props$onDragleave = props.onDragleave) === null || _props$onDragleave === void 0 || _props$onDragleave.call(props, {
        e: event
      });
      dragActive.value = false;
    };
    var handleDragover = function handleDragover(event) {
      event.preventDefault();
    };
    return {
      target: target,
      dragActive: dragActive,
      handleDrop: handleDrop,
      handleDragenter: handleDragenter,
      handleDragleave: handleDragleave,
      handleDragover: handleDragover
    };
  }

  function ownKeys$7(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$7(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$7(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$7(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var DraggerFile = VueCompositionAPI.defineComponent({
    name: "UploadDraggerFile",
    props: _objectSpread$7(_objectSpread$7({}, commonProps), {}, {
      trigger: Function,
      triggerUpload: Function,
      uploadFiles: Function,
      cancelUpload: Function,
      dragEvents: Object
    }),
    setup: function setup(props) {
      var _toRefs = VueCompositionAPI.toRefs(props),
        displayFiles = _toRefs.displayFiles,
        accept = _toRefs.accept;
      var _useCommonClassName = useCommonClassName(),
        sizeClassNames = _useCommonClassName.sizeClassNames;
      var uploadPrefix = "".concat(props.classPrefix, "-upload");
      var drag = useDrag(props.dragEvents, accept);
      var dragActive = drag.dragActive;
      var draggerFileRef = VueCompositionAPI.ref();
      var classes = VueCompositionAPI.computed(function () {
        var _displayFiles$value$;
        return ["".concat(uploadPrefix, "__dragger"), _defineProperty$2({}, "".concat(uploadPrefix, "__dragger-center"), !displayFiles.value[0]), _defineProperty$2({}, "".concat(uploadPrefix, "__dragger-error"), ((_displayFiles$value$ = displayFiles.value[0]) === null || _displayFiles$value$ === void 0 ? void 0 : _displayFiles$value$.status) === "fail")];
      });
      var icons = useGlobalIcon({
        CheckCircleFilledIcon: TdCheckCircleFilledIcon,
        ErrorCircleFilledIcon: TdErrorCircleFilledIcon
      });
      return {
        drag: drag,
        dragActive: dragActive,
        draggerFileRef: draggerFileRef,
        classes: classes,
        sizeClassNames: sizeClassNames,
        uploadPrefix: uploadPrefix,
        icons: icons
      };
    },
    methods: {
      renderImage: function renderImage() {
        var _file$response;
        var h = this.$createElement;
        if (!this.displayFiles.length) return;
        var file = this.displayFiles[0];
        var url = (file === null || file === void 0 ? void 0 : file.url) || (file === null || file === void 0 || (_file$response = file.response) === null || _file$response === void 0 ? void 0 : _file$response.url);
        return h("div", {
          "class": "".concat(this.uploadPrefix, "__dragger-img-wrap")
        }, [h(ImageViewer, helper([{
          "attrs": {
            "images": [url],
            "trigger": function trigger(h2, _ref3) {
              var open = _ref3.open;
              return h(Image$1, {
                "attrs": {
                  "src": url || file.raw,
                  "error": "",
                  "loading": ""
                },
                "on": {
                  "click": open
                }
              });
            }
          }
        }, {
          "props": this.imageViewerProps
        }]))]);
      },
      renderUploading: function renderUploading() {
        var h = this.$createElement;
        if (!this.displayFiles.length) return;
        var file = this.displayFiles[0];
        if ((file === null || file === void 0 ? void 0 : file.status) === "progress") {
          return h("div", {
            "class": "".concat(this.uploadPrefix, "__single-progress")
          }, [h(Loading), h("span", {
            "class": "".concat(this.uploadPrefix, "__single-percent")
          }, [file.percent, "%"])]);
        }
      },
      renderMainPreview: function renderMainPreview() {
        var _this = this,
          _this$locale;
        var h = this.$createElement;
        var file = this.displayFiles[0];
        var _this$icons = this.icons,
          CheckCircleFilledIcon = _this$icons.CheckCircleFilledIcon,
          ErrorCircleFilledIcon = _this$icons.ErrorCircleFilledIcon;
        var fileName = this.abridgeName ? abridgeName.apply(void 0, [file.name].concat(_toConsumableArray(this.abridgeName))) : file.name;
        var fileInfo = [h("div", {
          "class": "".concat(this.uploadPrefix, "__dragger-text"),
          "key": "info"
        }, [h("span", {
          "class": "".concat(this.uploadPrefix, "__single-name")
        }, [fileName]), file.status === "progress" && this.renderUploading(), file.status === "success" && h(CheckCircleFilledIcon), file.status === "fail" && h(ErrorCircleFilledIcon)]), h("small", {
          "class": "".concat(this.sizeClassNames.small),
          "key": "size"
        }, [this.locale.file.fileSizeText, "\uFF1A", getFileSizeText(file.size)]), h("small", {
          "class": "".concat(this.sizeClassNames.small),
          "key": "time"
        }, [this.locale.file.fileOperationDateText, "\uFF1A", file.uploadTime || "-"])];
        return h("div", {
          "class": "".concat(this.uploadPrefix, "__dragger-progress")
        }, [this.theme === "image" && this.renderImage(), h("div", {
          "class": "".concat(this.uploadPrefix, "__dragger-progress-info")
        }, [renderTNodeJSX(this, "fileListDisplay", {
          params: {
            files: this.displayFiles,
            locale: this.locale,
            disabled: this.disabled,
            cancelUpload: this.cancelUpload,
            uploadFiles: this.uploadFiles,
            triggerUpload: this.triggerUpload,
            onDrop: this.drag.handleDrop,
            onDragenter: this.drag.handleDragenter,
            onDragover: this.drag.handleDragover,
            onDragleave: this.drag.handleDragleave
          }
        }) || fileInfo, h("div", {
          "class": "".concat(this.uploadPrefix, "__dragger-btns")
        }, [["progress", "waiting"].includes(file.status) && !this.disabled && h(Button, {
          "attrs": {
            "theme": "primary",
            "variant": "text"
          },
          "class": "".concat(this.uploadPrefix, "__dragger-progress-cancel"),
          "on": {
            "click": function click(e) {
              var _this$cancelUpload;
              return (_this$cancelUpload = _this.cancelUpload) === null || _this$cancelUpload === void 0 ? void 0 : _this$cancelUpload.call(_this, {
                e: e,
                file: _this.toUploadFiles[0] || _this.files[0]
              });
            }
          }
        }, [(_this$locale = this.locale) === null || _this$locale === void 0 ? void 0 : _this$locale.cancelUploadText]), !this.autoUpload && file.status === "waiting" && h(Button, {
          "attrs": {
            "theme": "primary",
            "variant": "text",
            "disabled": this.disabled
          },
          "on": {
            "click": function click() {
              var _this$uploadFiles;
              return (_this$uploadFiles = _this.uploadFiles) === null || _this$uploadFiles === void 0 ? void 0 : _this$uploadFiles.call(_this);
            }
          },
          "class": "".concat(this.uploadPrefix, "__dragger-upload-btn")
        }, [this.locale.triggerUploadText.normal])]), ["fail", "success"].includes(file === null || file === void 0 ? void 0 : file.status) && !this.disabled && h("div", {
          "class": "".concat(this.uploadPrefix, "__dragger-btns")
        }, [h(Button, {
          "attrs": {
            "theme": "primary",
            "variant": "text",
            "disabled": this.disabled
          },
          "class": "".concat(this.uploadPrefix, "__dragger-progress-cancel"),
          "on": {
            "click": this.triggerUpload
          }
        }, [this.locale.triggerUploadText.reupload]), h(Button, {
          "attrs": {
            "theme": "danger",
            "variant": "text",
            "disabled": this.disabled
          },
          "class": "".concat(this.uploadPrefix, "__dragger-delete-btn"),
          "on": {
            "click": function click(e) {
              var _this$onRemove;
              return (_this$onRemove = _this.onRemove) === null || _this$onRemove === void 0 ? void 0 : _this$onRemove.call(_this, {
                e: e,
                index: 0,
                file: file
              });
            }
          }
        }, [this.locale.triggerUploadText["delete"]])])])]);
      },
      renderDefaultDragElement: function renderDefaultDragElement() {
        var _this$locale$triggerU;
        var h = this.$createElement;
        var unActiveElement = h("div", [h("span", {
          "class": "".concat(this.uploadPrefix, "--highlight")
        }, [(_this$locale$triggerU = this.locale.triggerUploadText) === null || _this$locale$triggerU === void 0 ? void 0 : _this$locale$triggerU.normal]), h("span", ["\xA0\xA0/\xA0\xA0", this.locale.dragger.draggingText])]);
        var activeElement = h("div", [this.locale.dragger.dragDropText]);
        return this.dragActive ? activeElement : unActiveElement;
      },
      getContent: function getContent() {
        var _this$$scopedSlots$de, _this$$scopedSlots;
        var h = this.$createElement;
        var file = this.displayFiles[0];
        if (file && (["progress", "success", "fail", "waiting"].includes(file.status) || !file.status)) {
          return this.renderMainPreview();
        }
        return h("div", {
          "class": "".concat(this.uploadPrefix, "__trigger"),
          "on": {
            "click": this.triggerUpload
          }
        }, [((_this$$scopedSlots$de = (_this$$scopedSlots = this.$scopedSlots)["default"]) === null || _this$$scopedSlots$de === void 0 ? void 0 : _this$$scopedSlots$de.call(_this$$scopedSlots, null)) || this.renderDefaultDragElement()]);
      }
    },
    render: function render() {
      var _this$trigger;
      var h = arguments[0];
      return h("div", {
        "ref": "draggerFileRef",
        "class": this.classes,
        "on": {
          "drop": this.drag.handleDrop,
          "dragenter": this.drag.handleDragenter,
          "dragover": this.drag.handleDragover,
          "dragleave": this.drag.handleDragleave
        }
      }, [((_this$trigger = this.trigger) === null || _this$trigger === void 0 ? void 0 : _this$trigger.call(this, h, {
        files: this.displayFiles,
        dragActive: this.dragActive
      })) || this.getContent()]);
    }
  });

  function ownKeys$6(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$6(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$6(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$6(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var ImageCard = VueCompositionAPI.defineComponent({
    name: "UploadImageCard",
    props: _objectSpread$6(_objectSpread$6({}, commonProps), {}, {
      multiple: Boolean,
      max: Number,
      disabled: Boolean,
      showUploadProgress: Boolean,
      triggerUpload: Function,
      uploadFiles: Function,
      cancelUpload: Function,
      showImageFileName: Boolean
    }),
    setup: function setup(props) {
      var _toRefs = VueCompositionAPI.toRefs(props),
        displayFiles = _toRefs.displayFiles,
        multiple = _toRefs.multiple,
        max = _toRefs.max;
      var icons = useGlobalIcon({
        AddIcon: TdAddIcon,
        BrowseIcon: TdBrowseIcon,
        DeleteIcon: TdDeleteIcon,
        ErrorCircleFilledIcon: TdErrorCircleFilledIcon
      });
      var showTrigger = VueCompositionAPI.computed(function () {
        var _displayFiles$value;
        if (multiple.value) {
          return !max.value || displayFiles.value.length < max.value;
        }
        return !((_displayFiles$value = displayFiles.value) !== null && _displayFiles$value !== void 0 && _displayFiles$value[0]);
      });
      return {
        icons: icons,
        showTrigger: showTrigger
      };
    },
    methods: {
      renderMainContent: function renderMainContent(file, index) {
        var _this = this;
        var h = this.$createElement;
        var _this$icons = this.icons,
          BrowseIcon = _this$icons.BrowseIcon,
          DeleteIcon = _this$icons.DeleteIcon;
        return h("div", {
          "class": "".concat(this.classPrefix, "-upload__card-content ").concat(this.classPrefix, "-upload__card-box")
        }, [h(Image$1, {
          "class": "".concat(this.classPrefix, "-upload__card-image"),
          "attrs": {
            "src": file.url || file.raw,
            "error": "",
            "fit": "contain"
          }
        }), h("div", {
          "class": "".concat(this.classPrefix, "-upload__card-mask")
        }, [h("span", {
          "class": "".concat(this.classPrefix, "-upload__card-mask-item"),
          "on": {
            "click": function click(e) {
              return e.stopPropagation();
            }
          }
        }, [h(ImageViewer, helper([{
          "attrs": {
            "images": this.displayFiles.map(function (t) {
              return t.url || t.raw;
            }),
            "defaultIndex": index,
            "trigger": function trigger(h, _ref) {
              var open = _ref.open;
              return h(BrowseIcon, {
                "on": {
                  "click": function click(_ref2) {
                    var e = _ref2.e;
                    _this.$emit("preview", {
                      file: file,
                      index: index,
                      e: e
                    });
                    open();
                  }
                }
              });
            }
          }
        }, {
          "props": this.imageViewerProps
        }]))]), !this.disabled && [h("span", {
          "class": "".concat(this.classPrefix, "-upload__card-mask-item-divider")
        }), h("span", {
          "class": "".concat(this.classPrefix, "-upload__card-mask-item"),
          "on": {
            "click": function click(e) {
              return e.stopPropagation();
            }
          }
        }, [h(DeleteIcon, {
          "on": {
            "click": function click(_ref3) {
              var _this$onRemove;
              var e = _ref3.e;
              return (_this$onRemove = _this.onRemove) === null || _this$onRemove === void 0 ? void 0 : _this$onRemove.call(_this, {
                e: e,
                file: file,
                index: index
              });
            }
          }
        })])]])]);
      },
      renderProgressFile: function renderProgressFile(file, loadCard) {
        var _this$locale;
        var h = this.$createElement;
        return h("div", {
          "class": [loadCard, "".concat(this.classPrefix, "-upload__").concat(this.theme, "-").concat(file.status)]
        }, [h(Loading, {
          "attrs": {
            "loading": true,
            "size": "medium"
          }
        }), h("p", [(_this$locale = this.locale) === null || _this$locale === void 0 || (_this$locale = _this$locale.progress) === null || _this$locale === void 0 ? void 0 : _this$locale.uploadingText, this.showUploadProgress ? " ".concat(file.percent, "%") : ""])]);
      },
      renderFailFile: function renderFailFile(file, index, loadCard) {
        var _file$response,
          _this$locale2,
          _this2 = this;
        var h = this.$createElement;
        var _this$icons2 = this.icons,
          ErrorCircleFilledIcon = _this$icons2.ErrorCircleFilledIcon,
          DeleteIcon = _this$icons2.DeleteIcon;
        return h("div", {
          "class": loadCard
        }, [h(ErrorCircleFilledIcon), h("p", [((_file$response = file.response) === null || _file$response === void 0 ? void 0 : _file$response.error) || ((_this$locale2 = this.locale) === null || _this$locale2 === void 0 || (_this$locale2 = _this$locale2.progress) === null || _this$locale2 === void 0 ? void 0 : _this$locale2.failText)]), h("div", {
          "class": "".concat(this.classPrefix, "-upload__card-mask")
        }, [h("span", {
          "class": "".concat(this.classPrefix, "-upload__card-mask-item"),
          "on": {
            "click": function click(e) {
              return e.stopPropagation();
            }
          }
        }, [h(DeleteIcon, {
          "on": {
            "click": function click(_ref4) {
              var _this2$onRemove;
              var e = _ref4.e;
              return (_this2$onRemove = _this2.onRemove) === null || _this2$onRemove === void 0 ? void 0 : _this2$onRemove.call(_this2, {
                e: e,
                file: file,
                index: index
              });
            }
          }
        })])])]);
      }
    },
    render: function render() {
      var _this$displayFiles,
        _this3 = this,
        _this$locale3;
      var h = arguments[0];
      var customList = renderTNodeJSX(this, "fileListDisplay", {
        params: {
          files: this.displayFiles,
          onPreview: this.onPreview,
          toUploadFiles: this.toUploadFiles,
          sizeOverLimitMessage: this.sizeOverLimitMessage,
          locale: this.locale,
          triggerUpload: this.triggerUpload,
          uploadFiles: this.uploadFiles,
          cancelUpload: this.cancelUpload,
          onRemove: this.onRemove
        }
      });
      if (customList) return customList;
      var cardItemClasses = "".concat(this.classPrefix, "-upload__card-item ").concat(this.classPrefix, "-is-background");
      var AddIcon = this.icons.AddIcon;
      return h("div", [h("ul", {
        "class": "".concat(this.classPrefix, "-upload__card")
      }, [(_this$displayFiles = this.displayFiles) === null || _this$displayFiles === void 0 ? void 0 : _this$displayFiles.map(function (file, index) {
        var loadCard = "".concat(_this3.classPrefix, "-upload__card-container ").concat(_this3.classPrefix, "-upload__card-box");
        var fileName = _this3.abridgeName ? abridgeName.apply(void 0, [file.name].concat(_toConsumableArray(_this3.abridgeName))) : file.name;
        var fileNameClassName = "".concat(_this3.classPrefix, "-upload__card-name");
        return h("li", {
          "class": cardItemClasses,
          "key": index
        }, [file.status === "progress" && _this3.renderProgressFile(file, loadCard), file.status === "fail" && _this3.renderFailFile(file, index, loadCard), !["progress", "fail"].includes(file.status) && _this3.renderMainContent(file, index), fileName && _this3.showImageFileName && (file.url ? h(Link, {
          "attrs": {
            "href": file.url,
            "target": "_blank",
            "hover": "color",
            "size": "small"
          },
          "class": fileNameClassName
        }, [fileName]) : h("span", {
          "class": fileNameClassName
        }, [fileName]))]);
      }), this.showTrigger && h("li", {
        "class": cardItemClasses,
        "on": {
          "click": this.triggerUpload
        }
      }, [h("div", {
        "class": ["".concat(this.classPrefix, "-upload__image-add ").concat(this.classPrefix, "-upload__card-container ").concat(this.classPrefix, "-upload__card-box"), _defineProperty$2({}, "".concat(this.classPrefix, "-is-disabled"), this.disabled)]
      }, [h(AddIcon), h("p", {
        "class": "".concat(this.classPrefix, "-size-s ").concat(this.classPrefix, "-upload__add-text")
      }, [(_this$locale3 = this.locale) === null || _this$locale3 === void 0 || (_this$locale3 = _this$locale3.triggerUploadText) === null || _this$locale3 === void 0 ? void 0 : _this$locale3.image])])])])]);
    }
  });

  function ownKeys$5(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$5(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$5(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$5(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var MultipleFlowList = VueCompositionAPI.defineComponent({
    name: "UploadMultipleFlowList",
    props: _objectSpread$5(_objectSpread$5({}, commonProps), {}, {
      uploadFiles: Function,
      cancelUpload: Function,
      dragEvents: Object,
      disabled: Boolean,
      isBatchUpload: Boolean,
      draggable: Boolean,
      showThumbnail: Boolean,
      showImageFileName: Boolean,
      uploadButton: Object,
      cancelUploadButton: Object
    }),
    setup: function setup(props, context) {
      var _toRefs = VueCompositionAPI.toRefs(props),
        locale = _toRefs.locale,
        uploading = _toRefs.uploading,
        classPrefix = _toRefs.classPrefix,
        accept = _toRefs.accept;
      var uploadPrefix = "".concat(classPrefix.value, "-upload");
      var icons = useGlobalIcon({
        BrowseIcon: TdBrowseIcon,
        DeleteIcon: TdDeleteIcon,
        CheckCircleFilledIcon: TdCheckCircleFilledIcon,
        ErrorCircleFilledIcon: TdErrorCircleFilledIcon,
        TimeFilledIcon: TdTimeFilledIcon,
        FileExcelIcon: TdFileExcelIcon,
        FilePdfIcon: TdFilePdfIcon,
        FileWordIcon: TdFileWordIcon,
        FilePowerpointIcon: TdFilePowerpointIcon,
        FileIcon: TdFileIcon,
        VideoIcon: TdVideoIcon
      });
      var drag = useDrag(props.dragEvents, accept);
      var currentPreviewFile = VueCompositionAPI.ref([]);
      var previewIndex = VueCompositionAPI.ref(0);
      var uploadText = VueCompositionAPI.computed(function () {
        if (uploading.value) return "".concat(locale.value.progress.uploadingText);
        return locale.value.triggerUploadText.normal;
      });
      var innerDragEvents = VueCompositionAPI.computed(function () {
        var draggable = props.draggable === void 0 ? true : props.draggable;
        return draggable ? {
          drop: drag.handleDrop,
          dragenter: drag.handleDragenter,
          dragover: drag.handleDragover,
          dragleave: drag.handleDragleave
        } : {};
      });
      var browseIconClick = function browseIconClick(_ref) {
        var e = _ref.e,
          index = _ref.index,
          file = _ref.file,
          viewFiles = _ref.viewFiles;
        previewIndex.value = index;
        currentPreviewFile.value = viewFiles;
        context.emit("preview", {
          file: file,
          index: index,
          e: e
        });
      };
      var previewIndexChange = function previewIndexChange(index) {
        previewIndex.value = index;
      };
      var closePreview = function closePreview() {
        currentPreviewFile.value = [];
      };
      var onVue2Preview = function onVue2Preview(params) {
        context.emit("preview", params);
      };
      return {
        icons: icons,
        dragActive: drag.dragActive,
        uploadPrefix: uploadPrefix,
        uploadText: uploadText,
        innerDragEvents: innerDragEvents,
        currentPreviewFile: currentPreviewFile,
        previewIndex: previewIndex,
        onVue2Preview: onVue2Preview,
        browseIconClick: browseIconClick,
        closePreview: closePreview,
        previewIndexChange: previewIndexChange
      };
    },
    methods: {
      getStatusMap: function getStatusMap() {
        var h = this.$createElement;
        var _this$icons = this.icons,
          CheckCircleFilledIcon = _this$icons.CheckCircleFilledIcon,
          ErrorCircleFilledIcon = _this$icons.ErrorCircleFilledIcon,
          TimeFilledIcon = _this$icons.TimeFilledIcon;
        var iconMap = {
          success: h(CheckCircleFilledIcon),
          fail: h(ErrorCircleFilledIcon),
          progress: h(Loading),
          waiting: h(TimeFilledIcon)
        };
        var progress = this.locale.progress;
        var textMap = {
          success: progress === null || progress === void 0 ? void 0 : progress.successText,
          fail: progress === null || progress === void 0 ? void 0 : progress.failText,
          progress: progress === null || progress === void 0 ? void 0 : progress.uploadingText,
          waiting: progress === null || progress === void 0 ? void 0 : progress.waitingText
        };
        return {
          iconMap: iconMap,
          textMap: textMap
        };
      },
      renderEmpty: function renderEmpty() {
        var h = this.$createElement;
        return h("div", {
          "class": "".concat(this.uploadPrefix, "__flow-empty")
        }, [this.dragActive ? this.locale.dragger.dragDropText : this.locale.dragger.clickAndDragText]);
      },
      renderImgItem: function renderImgItem(file, index) {
        var _this = this;
        var h = this.$createElement;
        var _this$getStatusMap = this.getStatusMap(),
          iconMap = _this$getStatusMap.iconMap,
          textMap = _this$getStatusMap.textMap;
        var _this$icons2 = this.icons,
          BrowseIcon = _this$icons2.BrowseIcon,
          DeleteIcon = _this$icons2.DeleteIcon;
        var fileName = this.abridgeName && file.name ? abridgeName.apply(void 0, [file.name].concat(_toConsumableArray(this.abridgeName))) : file.name;
        return h("li", {
          "class": "".concat(this.uploadPrefix, "__card-item"),
          "key": file.name + index + file.percent + file.status
        }, [h("div", {
          "class": ["".concat(this.uploadPrefix, "__card-content"), _defineProperty$2({}, "".concat(this.classPrefix, "-is-bordered"), file.status !== "waiting")]
        }, [["fail", "progress"].includes(file.status) && h("div", {
          "class": "".concat(this.uploadPrefix, "__card-status-wrap ").concat(this.uploadPrefix, "__").concat(this.theme, "-").concat(file.status)
        }, [iconMap[file.status], h("p", [textMap[file.status], file.status === "progress" ? " ".concat(file.percent, "%") : ""])]), (["waiting", "success"].includes(file.status) || !file.status && file.url) && h(Image$1, {
          "class": "".concat(this.uploadPrefix, "__card-image"),
          "attrs": {
            "src": file.url || file.raw,
            "error": "",
            "loading": "",
            "fit": "contain"
          }
        }), h("div", {
          "class": "".concat(this.uploadPrefix, "__card-mask")
        }, [(file.url || file.raw) && !["progress", "fail"].includes(file.status) && h("span", {
          "class": "".concat(this.uploadPrefix, "__card-mask-item")
        }, [h(BrowseIcon, {
          "on": {
            "click": function click(_ref3) {
              var e = _ref3.e;
              _this.browseIconClick({
                e: e,
                index: index,
                file: file,
                viewFiles: _this.displayFiles
              });
            }
          }
        }), h("span", {
          "class": "".concat(this.uploadPrefix, "__card-mask-item-divider")
        })]), !this.disabled && h("span", {
          "class": "".concat(this.uploadPrefix, "__card-mask-item ").concat(this.uploadPrefix, "__delete"),
          "on": {
            "click": function click(e) {
              return _this.onRemove({
                e: e,
                index: index,
                file: file
              });
            }
          }
        }, [h(DeleteIcon)])])]), this.showImageFileName && h("p", {
          "class": ["".concat(this.uploadPrefix, "__card-name"), "".concat(this.uploadPrefix, "__flow-status")]
        }, [["success", "waiting"].includes(file.status) && iconMap[file.status], fileName])]);
      },
      renderStatus: function renderStatus(file) {
        var _file$response, _file$response2;
        var h = this.$createElement;
        var _this$getStatusMap2 = this.getStatusMap(),
          iconMap = _this$getStatusMap2.iconMap,
          textMap = _this$getStatusMap2.textMap;
        return h("div", {
          "class": "".concat(this.uploadPrefix, "__flow-status")
        }, [iconMap[file.status], h("span", {
          "class": "".concat(this.uploadPrefix, "__").concat(this.theme, "-").concat(file.status)
        }, [(_file$response = file.response) !== null && _file$response !== void 0 && _file$response.error ? ((_file$response2 = file.response) === null || _file$response2 === void 0 ? void 0 : _file$response2.error) || textMap[file.status] : textMap[file.status], this.showUploadProgress && file.status === "progress" ? " ".concat(file.percent || 0, "%") : ""])]);
      },
      renderNormalActionCol: function renderNormalActionCol(file, index) {
        var _this$locale,
          _this2 = this;
        var h = this.$createElement;
        return h("td", [h(Button, {
          "attrs": {
            "theme": "primary",
            "variant": "text",
            "content": (_this$locale = this.locale) === null || _this$locale === void 0 || (_this$locale = _this$locale.triggerUploadText) === null || _this$locale === void 0 ? void 0 : _this$locale["delete"]
          },
          "class": "".concat(this.uploadPrefix, "__delete"),
          "on": {
            "click": function click(e) {
              return _this2.onRemove({
                e: e,
                index: index,
                file: file
              });
            }
          }
        })]);
      },
      renderBatchActionCol: function renderBatchActionCol(index) {
        var _this$locale2,
          _this3 = this;
        var h = this.$createElement;
        return index === 0 ? h("td", {
          "attrs": {
            "rowSpan": this.displayFiles.length
          },
          "class": "".concat(this.uploadPrefix, "__flow-table__batch-row")
        }, [h(Button, {
          "attrs": {
            "theme": "primary",
            "variant": "text",
            "content": (_this$locale2 = this.locale) === null || _this$locale2 === void 0 || (_this$locale2 = _this$locale2.triggerUploadText) === null || _this$locale2 === void 0 ? void 0 : _this$locale2["delete"]
          },
          "class": "".concat(this.uploadPrefix, "__delete"),
          "on": {
            "click": function click(e) {
              return _this3.onRemove({
                e: e,
                index: -1,
                file: void 0
              });
            }
          }
        })]) : null;
      },
      renderFileList: function renderFileList() {
        var _this$locale$file,
          _this$locale$file2,
          _this$locale$file3,
          _this$locale$file4,
          _this4 = this;
        var h = this.$createElement;
        var list = renderTNodeJSX(this, "fileListDisplay", {
          params: {
            cancelUpload: this.cancelUpload,
            uploadFiles: this.uploadFiles,
            onRemove: this.onRemove,
            toUploadFiles: this.toUploadFiles,
            sizeOverLimitMessage: this.sizeOverLimitMessage,
            locale: this.locale,
            files: this.displayFiles,
            dragEvents: this.innerDragEvents
          }
        });
        if (list) return list;
        return h("table", helper([{
          "class": "".concat(this.uploadPrefix, "__flow-table")
        }, {
          "on": this.innerDragEvents
        }]), [h("thead", [h("tr", [h("th", [(_this$locale$file = this.locale.file) === null || _this$locale$file === void 0 ? void 0 : _this$locale$file.fileNameText]), h("th", {
          "style": {
            minWidth: "120px"
          }
        }, [(_this$locale$file2 = this.locale.file) === null || _this$locale$file2 === void 0 ? void 0 : _this$locale$file2.fileSizeText]), h("th", {
          "style": {
            minWidth: "120px"
          }
        }, [(_this$locale$file3 = this.locale.file) === null || _this$locale$file3 === void 0 ? void 0 : _this$locale$file3.fileStatusText]), this.disabled ? null : h("th", [(_this$locale$file4 = this.locale.file) === null || _this$locale$file4 === void 0 ? void 0 : _this$locale$file4.fileOperationText])])]), h("tbody", [!this.displayFiles.length && h("tr", [h("td", {
          "attrs": {
            "colSpan": 4
          }
        }, [this.renderEmpty()])]), this.displayFiles.map(function (file, index) {
          var _this4$abridgeName;
          var showBatchUploadAction = _this4.isBatchUpload;
          var deleteNode = showBatchUploadAction && _this4.displayFiles.every(function (item) {
            return item.status === "success" || !item.status;
          }) ? _this4.renderBatchActionCol(index) : _this4.renderNormalActionCol(file, index);
          var fileName = (_this4$abridgeName = _this4.abridgeName) !== null && _this4$abridgeName !== void 0 && _this4$abridgeName.length ? abridgeName.apply(void 0, [file.name].concat(_toConsumableArray(_this4.abridgeName))) : file.name;
          var thumbnailNode = _this4.showThumbnail ? h("div", {
            "class": "".concat(_this4.uploadPrefix, "__file-info")
          }, [_this4.renderFileThumbnail(file), fileName]) : fileName;
          var fileNameNode = file.url ? h(Link, {
            "attrs": {
              "href": file.url,
              "target": "_blank",
              "hover": "color"
            }
          }, [thumbnailNode]) : thumbnailNode;
          return h("tr", {
            "key": file.name + index
          }, [h("td", {
            "class": "".concat(_this4.uploadPrefix, "__file-name")
          }, [fileNameNode]), h("td", [returnFileSize(file.size)]), h("td", [_this4.renderStatus(file)]), _this4.disabled ? null : deleteNode]);
        })])]);
      },
      renderImageList: function renderImageList() {
        var _this5 = this;
        var h = this.$createElement;
        var customList = renderTNodeJSX(this, "fileListDisplay", {
          params: {
            cancelUpload: this.cancelUpload,
            uploadFiles: this.uploadFiles,
            onRemove: this.onRemove,
            onPreview: this.onVue2Preview,
            toUploadFiles: this.toUploadFiles,
            sizeOverLimitMessage: this.sizeOverLimitMessage,
            locale: this.locale,
            files: this.displayFiles,
            dragEvents: this.innerDragEvents
          }
        });
        if (customList) return customList;
        return h("ul", {
          "class": "".concat(this.uploadPrefix, "__card clearfix")
        }, [this.displayFiles.map(function (file, index) {
          return _this5.renderImgItem(file, index);
        })]);
      },
      getFileThumbnailIcon: function getFileThumbnailIcon(fileType) {
        var h = this.$createElement;
        var _this$icons3 = this.icons,
          FilePdfIcon = _this$icons3.FilePdfIcon,
          FileExcelIcon = _this$icons3.FileExcelIcon,
          FileWordIcon = _this$icons3.FileWordIcon,
          FilePowerpointIcon = _this$icons3.FilePowerpointIcon,
          VideoIcon = _this$icons3.VideoIcon,
          FileIcon = _this$icons3.FileIcon;
        if (FILE_PDF_REGEXP.test(fileType)) {
          return h(FilePdfIcon);
        }
        if (FILE_EXCEL_REGEXP.test(fileType)) {
          return h(FileExcelIcon);
        }
        if (FILE_WORD_REGEXP.test(fileType)) {
          return h(FileWordIcon);
        }
        if (FILE_PPT_REGEXP.test(fileType)) {
          return h(FilePowerpointIcon);
        }
        if (VIDEO_REGEXP.test(fileType)) {
          return h(VideoIcon);
        }
        return h(FileIcon);
      },
      renderFileThumbnail: function renderFileThumbnail(file) {
        var _this6 = this;
        var h = this.$createElement;
        if (!file || !file.raw && file.url) return null;
        var fileType = file.raw.type;
        var className = "".concat(this.uploadPrefix, "__file-thumbnail");
        if (IMAGE_REGEXP.test(fileType)) {
          return h(Image$1, {
            "class": className,
            "attrs": {
              "src": file.url || file.raw,
              "fit": "scale-down",
              "error": "",
              "loading": ""
            },
            "on": {
              "click": function click(e) {
                e.preventDefault();
                _this6.browseIconClick({
                  e: e,
                  index: 0,
                  file: file,
                  viewFiles: [file]
                });
              }
            }
          });
        }
        return h("div", {
          "class": className
        }, [this.getFileThumbnailIcon(fileType)]);
      }
    },
    render: function render() {
      var _this$$scopedSlots$de,
        _this$$scopedSlots,
        _this$locale3,
        _this$locale4,
        _this7 = this;
      var h = arguments[0];
      var cardClassName = "".concat(this.uploadPrefix, "__flow-card-area");
      var isShowBottomButton = !this.autoUpload && (this.uploadButton !== null || this.cancelUploadButton !== null);
      var cancelUploadDisabled = this.disabled || !this.uploading;
      var hasCancelUploadTNode = this.$scopedSlots.uploadButton || isFunction(this.uploadButton);
      var uploadButtonDisabled = Boolean(this.disabled || this.uploading || !this.displayFiles.length);
      var hasUploadButtonTNode = this.$scopedSlots.cancelUploadButton || isFunction(this.cancelUploadButton);
      return h("div", {
        "class": "".concat(this.uploadPrefix, "__flow ").concat(this.uploadPrefix, "__flow-").concat(this.theme)
      }, [h("div", {
        "class": "".concat(this.uploadPrefix, "__flow-op")
      }, [(_this$$scopedSlots$de = (_this$$scopedSlots = this.$scopedSlots)["default"]) === null || _this$$scopedSlots$de === void 0 ? void 0 : _this$$scopedSlots$de.call(_this$$scopedSlots, null), this.placeholder && h("small", {
        "class": "".concat(this.uploadPrefix, "__flow-placeholder ").concat(this.uploadPrefix, "__placeholder")
      }, [this.placeholder])]), this.theme === "image-flow" && h("div", helper([{
        "class": cardClassName
      }, {
        "on": this.innerDragEvents
      }]), [this.displayFiles.length ? this.renderImageList() : this.renderEmpty()]), this.theme === "file-flow" && (this.displayFiles.length ? this.renderFileList() : h("div", helper([{
        "class": cardClassName
      }, {
        "on": this.innerDragEvents
      }]), [this.renderEmpty()])), isShowBottomButton && h("div", {
        "class": "".concat(this.uploadPrefix, "__flow-bottom")
      }, [this.cancelUploadButton !== null && (hasCancelUploadTNode ? renderTNodeJSX(this, "cancelUploadButton", {
        params: {
          disabled: cancelUploadDisabled,
          cancelUploadText: (_this$locale3 = this.locale) === null || _this$locale3 === void 0 ? void 0 : _this$locale3.cancelUploadText,
          cancelUpload: this.cancelUpload
        }
      }) : h(Button, helper([{
        "attrs": {
          "theme": "default",
          "disabled": this.disabled || !this.uploading,
          "content": (_this$locale4 = this.locale) === null || _this$locale4 === void 0 ? void 0 : _this$locale4.cancelUploadText
        },
        "class": "".concat(this.uploadPrefix, "__cancel")
      }, {
        "props": isObject(this.cancelUploadButton) ? this.cancelUploadButton : {}
      }, {
        "on": {
          "click": function click(e) {
            var _this7$cancelUpload;
            return (_this7$cancelUpload = _this7.cancelUpload) === null || _this7$cancelUpload === void 0 ? void 0 : _this7$cancelUpload.call(_this7, {
              e: e
            });
          }
        }
      }]))), this.uploadButton !== null && (hasUploadButtonTNode ? renderTNodeJSX(this, "uploadButton", {
        params: {
          disabled: uploadButtonDisabled,
          uploading: this.uploading,
          uploadText: this.uploadText,
          uploadFiles: this.uploadFiles
        }
      }) : h(Button, helper([{
        "attrs": {
          "disabled": this.disabled || this.uploading || !this.displayFiles.length,
          "theme": "primary",
          "loading": this.uploading,
          "content": this.uploadText
        },
        "class": "".concat(this.uploadPrefix, "__continue")
      }, {
        "props": isObject(this.uploadButton) ? this.uploadButton : {}
      }, {
        "on": {
          "click": function click() {
            var _this7$uploadFiles;
            return (_this7$uploadFiles = _this7.uploadFiles) === null || _this7$uploadFiles === void 0 ? void 0 : _this7$uploadFiles.call(_this7);
          }
        }
      }])))]), h(ImageViewer, helper([{
        "attrs": {
          "images": this.currentPreviewFile.map(function (t) {
            return t.url || t.raw;
          }),
          "visible": !!this.currentPreviewFile.length,
          "index": this.previewIndex
        },
        "on": {
          "close": this.closePreview
        }
      }, {
        "on": {
          "index-change": this.previewIndexChange
        }
      }, {}, {
        "props": this.imageViewerProps
      }]))]);
    }
  });

  function ownKeys$4(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$4(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$4(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$4(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function xhr(_ref) {
    var _files$;
    var _ref$method = _ref.method,
      method = _ref$method === void 0 ? "POST" : _ref$method,
      action = _ref.action,
      _ref$withCredentials = _ref.withCredentials,
      withCredentials = _ref$withCredentials === void 0 ? false : _ref$withCredentials,
      _ref$headers = _ref.headers,
      headers = _ref$headers === void 0 ? {} : _ref$headers,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data,
      file = _ref.file,
      _ref$files = _ref.files,
      files = _ref$files === void 0 ? [] : _ref$files,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "file" : _ref$name,
      _ref$useMockProgress = _ref.useMockProgress,
      useMockProgress = _ref$useMockProgress === void 0 ? true : _ref$useMockProgress,
      _ref$mockProgressDura = _ref.mockProgressDuration,
      mockProgressDuration = _ref$mockProgressDura === void 0 ? 300 : _ref$mockProgressDura,
      formatRequest = _ref.formatRequest,
      onError = _ref.onError,
      onProgress = _ref.onProgress,
      onSuccess = _ref.onSuccess;
    var innerFiles = files || [];
    var percent = 0;
    var xhr2 = new XMLHttpRequest();
    if (withCredentials) {
      xhr2.withCredentials = true;
    }
    var timer1;
    var timer2;
    if (useMockProgress && ((_files$ = files[0]) === null || _files$ === void 0 ? void 0 : _files$.status) === "progress") {
      var timer22 = setTimeout(function () {
        timer1 = setInterval(function () {
          if (percent + 10 < 100) {
            percent = Math.max(percent + 10, percent);
            if (files[0] && percent !== files[0].percent) {
              files[0].percent = percent;
              onProgress({
                percent: percent,
                file: file || innerFiles[0],
                files: innerFiles.map(function (file2) {
                  return _objectSpread$4(_objectSpread$4({}, file2), {}, {
                    percent: percent
                  });
                }),
                type: "mock",
                XMLHttpRequest: xhr2
              });
            }
          } else {
            clearInterval(timer1);
          }
        }, mockProgressDuration);
        clearTimeout(timer22);
      }, mockProgressDuration);
    }
    var requestData = {};
    if (data) {
      var extraData = isFunction(data) ? data(innerFiles) : data;
      Object.assign(requestData, extraData);
    }
    innerFiles.forEach(function (file2, index) {
      var fileField = innerFiles.length > 1 ? "".concat(name, "[").concat(index, "]") : name;
      requestData[fileField] = file2.raw;
    });
    if (innerFiles.length === 1) {
      requestData[name] = innerFiles[0].raw;
    } else {
      requestData[name] = innerFiles.map(function (file2) {
        return file2.raw;
      });
    }
    requestData.length = innerFiles.length;
    if (formatRequest) {
      requestData = formatRequest(requestData);
    }
    var formData = new FormData();
    Object.keys(requestData).forEach(function (key) {
      formData.append(key, requestData[key]);
    });
    xhr2.open(method, action, true);
    Object.keys(headers).forEach(function (key) {
      xhr2.setRequestHeader(key, headers[key]);
    });
    xhr2.onerror = function (event) {
      onError({
        event: event,
        file: file,
        files: innerFiles,
        XMLHttpRequest: xhr2
      });
      clearInterval(timer1);
      clearTimeout(timer2);
    };
    xhr2.ontimeout = function (event) {
      onError({
        event: event,
        file: file,
        files: innerFiles,
        XMLHttpRequest: xhr2
      });
    };
    if (xhr2.upload) {
      xhr2.upload.onprogress = function (event) {
        var _innerFiles$;
        var realPercent = 0;
        if (event.total > 0) {
          realPercent = Math.round(event.loaded / event.total * 100);
        }
        percent = Math.max(realPercent, percent);
        if (percent !== realPercent && ((_innerFiles$ = innerFiles[0]) === null || _innerFiles$ === void 0 ? void 0 : _innerFiles$.percent) !== percent) {
          var progressFiles = innerFiles.map(function (item) {
            return _objectSpread$4(_objectSpread$4({}, item), {}, {
              percent: percent
            });
          });
          onProgress({
            event: event,
            percent: percent,
            file: file || progressFiles[0],
            files: progressFiles,
            type: "real",
            XMLHttpRequest: xhr2
          });
        }
      };
    }
    xhr2.onload = function (event) {
      var response = {};
      response.XMLHttpRequest = xhr2;
      var isFail = xhr2.status < 200 || xhr2.status >= 300;
      if (isFail) {
        return onError({
          event: event,
          file: file,
          files: innerFiles,
          response: response,
          XMLHttpRequest: xhr2
        });
      }
      var text = xhr2.responseText || xhr2.response;
      try {
        response = JSON.parse(text);
      } catch (e) {
        response = text;
        log.error("Upload", "response does not a valid json");
      }
      clearInterval(timer1);
      clearTimeout(timer2);
      innerFiles.forEach(function (file2) {
        var _response;
        file2.percent = 100;
        file2.status = "success";
        file2.uploadTime = ((_response = response) === null || _response === void 0 ? void 0 : _response.uploadTime) || getCurrentDate();
      });
      if (_typeof$2(response) === "object") {
        response.XMLHttpRequest = xhr2;
      }
      onSuccess({
        event: event,
        file: file || innerFiles[0],
        files: _toConsumableArray(innerFiles),
        XMLHttpRequest: xhr2,
        response: response
      });
    };
    xhr2.send(formData);
    xhr2.upload.requestParams = requestData;
    xhr2.upload.requestHeaders = headers;
    return xhr2;
  }

  function ownKeys$3(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$3(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$3(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function handleBeforeUpload(file, params) {
    var sizeLimit = params.sizeLimit,
      beforeUpload = params.beforeUpload;
    var sizePromise = new Promise(function (resolve) {
      var result = null;
      if (sizeLimit) {
        var sizeLimitObj = isNumber(sizeLimit) ? {
          size: sizeLimit,
          unit: "KB"
        } : sizeLimit;
        var limit = isOverSizeLimit(file.size, sizeLimitObj.size, sizeLimitObj.unit);
        if (limit) {
          result = sizeLimitObj;
        }
      }
      resolve(result);
    });
    var promiseList = [sizePromise, void 0];
    if (isFunction(beforeUpload)) {
      var r = beforeUpload(file);
      var p = r instanceof Promise ? r : new Promise(function (resolve) {
        return resolve(r);
      });
      promiseList[1] = p;
    }
    return new Promise(function (resolve) {
      Promise.all(promiseList).then(function (r) {
        resolve(r);
      });
    });
  }
  function handleError(options) {
    var event = options.event,
      files = options.files,
      response = options.response,
      XMLHttpRequest = options.XMLHttpRequest,
      formatResponse = options.formatResponse;
    var res = response;
    if (isFunction(formatResponse)) {
      res = formatResponse(response, {
        file: files[0],
        currentFiles: files
      });
    }
    files.forEach(function (file) {
      file.status = "fail";
      file.response = res;
    });
    return {
      response: res,
      event: event,
      files: files,
      XMLHttpRequest: XMLHttpRequest
    };
  }
  function handleSuccess(params) {
    var event = params.event,
      files = params.files,
      response = params.response,
      XMLHttpRequest = params.XMLHttpRequest;
    if ((files === null || files === void 0 ? void 0 : files.length) <= 0) {
      log.error("Upload", "Empty File in Success Callback");
    }
    files.forEach(function (file) {
      var _file$response;
      file.percent = 100;
      file.status = "success";
      (_file$response = file.response) === null || _file$response === void 0 || delete _file$response.error;
    });
    var res = response;
    files[0].url = res.url || files[0].url;
    return {
      response: res,
      event: event,
      files: files,
      XMLHttpRequest: XMLHttpRequest
    };
  }
  function handleRequestMethodResponse(res) {
    if (!res) {
      log.error("Upload", "`requestMethodResponse` is required.");
      return false;
    }
    if (!res.status) {
      log.error("Upload", "`requestMethodResponse.status` is missing, which value only can be `success` or `fail`");
      return false;
    }
    if (!["success", "fail"].includes(res.status)) {
      log.error("Upload", "`requestMethodResponse.status` must be `success` or `fail`, examples `{ status: 'success', response: { url: '' } }`");
      return false;
    }
    if (res.status === "success" && (!res.response || !res.response.url && !res.response.files)) {
      log.warn("Upload", "`requestMethodResponse.response.url` or `requestMethodResponse.response.files` is required if `status` is `success`");
    }
    return true;
  }
  function uploadOneRequest(params) {
    var action = params.action,
      toUploadFiles = params.toUploadFiles,
      requestMethod = params.requestMethod;
    return new Promise(function (resolve) {
      if (!action && !requestMethod) {
        log.error("Upload", "one of action and requestMethod must be exist.");
        resolve({});
        return;
      }
      if (!toUploadFiles || !toUploadFiles.length) {
        log.warn("Upload", "No files need to be uploaded");
        resolve({});
        return;
      }
      toUploadFiles.forEach(function (file) {
        file.status = "progress";
      });
      if (requestMethod) {
        requestMethod(params.multiple ? toUploadFiles : toUploadFiles[0]).then(function (res) {
          if (!handleRequestMethodResponse(res)) {
            resolve({});
            return;
          }
          var response = res.response || {};
          if (isFunction(params.formatResponse)) {
            response = params.formatResponse(response, {
              file: toUploadFiles[0],
              currentFiles: toUploadFiles
            });
          }
          if (res.status === "fail") {
            response.error = res.error || response.error;
          }
          var resultFiles = [];
          if (res.status === "success" && response.files) {
            resultFiles = response.files.map(function (file) {
              var fileInfo = toUploadFiles.find(function (toFile) {
                return file.name && toFile.name === file.name || file.raw && toFile.raw === file.raw;
              });
              return _objectSpread$3(_objectSpread$3(_objectSpread$3({}, fileInfo), file), {}, {
                status: res.status,
                response: response
              });
            });
          } else {
            toUploadFiles.forEach(function (file) {
              var _response;
              file.status = res.status;
              file.response = response;
              file.url = response.url;
              file.percent = res.status === "success" ? 100 : 0;
              file.uploadTime = ((_response = response) === null || _response === void 0 ? void 0 : _response.uploadTime) || getCurrentDate();
            });
            resultFiles = toUploadFiles;
          }
          var result = {
            response: response,
            file: resultFiles[0],
            files: resultFiles
          };
          if (res.status === "success") {
            var _params$onResponseSuc;
            (_params$onResponseSuc = params.onResponseSuccess) === null || _params$onResponseSuc === void 0 || _params$onResponseSuc.call(params, result);
          } else if (res.status === "fail") {
            var _params$onResponseErr;
            (_params$onResponseErr = params.onResponseError) === null || _params$onResponseErr === void 0 || _params$onResponseErr.call(params, result);
          }
          resolve({
            status: res.status,
            data: result
          });
        });
      } else {
        var _params$setXhrObject;
        var xhrReq = xhr({
          action: params.action,
          files: params.toUploadFiles,
          useMockProgress: params.useMockProgress,
          mockProgressDuration: params.mockProgressDuration,
          onError: function onError(p) {
            var _params$onResponseErr2;
            var r = handleError(_objectSpread$3(_objectSpread$3({}, p), {}, {
              formatResponse: params.formatResponse
            }));
            (_params$onResponseErr2 = params.onResponseError) === null || _params$onResponseErr2 === void 0 || _params$onResponseErr2.call(params, r);
            resolve({
              status: "fail",
              data: r
            });
          },
          onProgress: params.onResponseProgress,
          onSuccess: function onSuccess(p) {
            var formatResponse = params.formatResponse;
            var res = p.response;
            if (isFunction(formatResponse)) {
              res = formatResponse(p.response, {
                file: p.file,
                currentFiles: p.files
              });
            }
            if (res.error) {
              var _params$onResponseErr3;
              var r = handleError(_objectSpread$3(_objectSpread$3({}, p), {}, {
                response: res
              }));
              (_params$onResponseErr3 = params.onResponseError) === null || _params$onResponseErr3 === void 0 || _params$onResponseErr3.call(params, r);
              resolve({
                status: "fail",
                data: r
              });
            } else {
              var _params$onResponseSuc2;
              p.file.response = res;
              p.files[0].response = res;
              var _r = handleSuccess(_objectSpread$3(_objectSpread$3({}, p), {}, {
                response: res
              }));
              (_params$onResponseSuc2 = params.onResponseSuccess) === null || _params$onResponseSuc2 === void 0 || _params$onResponseSuc2.call(params, _r);
              resolve({
                status: "success",
                data: _r
              });
            }
          },
          formatRequest: params.formatRequest,
          data: params.data,
          name: params.name,
          headers: params.headers,
          withCredentials: params.withCredentials,
          method: params.method
        });
        (_params$setXhrObject = params.setXhrObject) === null || _params$setXhrObject === void 0 || _params$setXhrObject.call(params, {
          files: params.toUploadFiles,
          xhrReq: xhrReq
        });
      }
    });
  }
  function updateUploadedFiles(uploadFiles, resultFiles) {
    var existFiles = uploadFiles.filter(function (t) {
      return t.url;
    });
    var newFiles = existFiles;
    var _loop = function _loop() {
      var file = resultFiles[i];
      var index = uploadFiles.findIndex(function (item) {
        return item.raw && item.raw === file.raw || item.name && item.name === file.name;
      });
      var tmpFile = index >= 0 ? _objectSpread$3(_objectSpread$3({}, uploadFiles[index]), file) : file;
      newFiles.push(tmpFile);
    };
    for (var i = 0, len = resultFiles.length; i < len; i++) {
      _loop();
    }
    return newFiles;
  }
  function upload(params) {
    var uploadAllFilesInOneRequest = params.uploadAllFilesInOneRequest,
      toUploadFiles = params.toUploadFiles,
      uploadedFiles = params.uploadedFiles,
      isBatchUpload = params.isBatchUpload;
    var thisUploadFiles = toUploadFiles.filter(function (t) {
      return !t.response || t.response && !t.response.error;
    });
    return new Promise(function (resolve) {
      if (uploadAllFilesInOneRequest || !params.multiple) {
        uploadOneRequest(params).then(function (r) {
          if (r.status === "success") {
            r.data.files = isBatchUpload || !params.multiple ? r.data.files : updateUploadedFiles(uploadedFiles, r.data.files);
          }
          var failedFiles = r.status === "fail" ? r.data.files : [];
          resolve(_objectSpread$3(_objectSpread$3({}, r), {}, {
            failedFiles: failedFiles
          }));
        });
        return;
      }
      var list = thisUploadFiles.map(function (file) {
        return uploadOneRequest(_objectSpread$3(_objectSpread$3({}, params), {}, {
          toUploadFiles: [file]
        }));
      });
      Promise.all(list).then(function (arr) {
        var files = [];
        var failedFiles = [];
        arr.forEach(function (one) {
          if (one.status === "success") {
            files.push(one.data.files[0]);
          } else if (one.status === "fail") {
            failedFiles.push(one.data.files[0]);
          }
        });
        var tFiles = params.autoUpload ? uploadedFiles.concat(files) : uploadedFiles;
        var newFiles = isBatchUpload || !params.multiple ? files : tFiles;
        resolve({
          status: files.length ? "success" : "fail",
          data: {
            files: newFiles
          },
          failedFiles: failedFiles,
          list: arr
        });
      });
    });
  }
  function formatToUploadFile(files, format) {
    var status = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : void 0;
    var percent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    return files.map(function (fileRaw) {
      var file = fileRaw;
      if (isFunction(format)) {
        file = format(fileRaw);
      }
      var uploadFile = _objectSpread$3({
        raw: fileRaw,
        lastModified: fileRaw.lastModified,
        name: fileRaw.name,
        size: fileRaw.size,
        type: fileRaw.type,
        percent: percent,
        status: status
      }, file);
      return uploadFile;
    });
  }
  function validateFile(params) {
    var files = params.files,
      uploadValue = params.uploadValue,
      max = params.max,
      allowUploadDuplicateFile = params.allowUploadDuplicateFile;
    return new Promise(function (resolve) {
      var tmpFiles = files.filter(function (file) {
        var sameNameFile = uploadValue.find(function (t) {
          return t.name === file.name;
        });
        return allowUploadDuplicateFile || !sameNameFile;
      });
      var hasSameNameFile = false;
      if (tmpFiles.length < files.length) {
        hasSameNameFile = true;
      }
      if (!tmpFiles.length) {
        var tFiles = formatToUploadFile(files, params.format, params.autoUpload ? "progress" : "waiting");
        resolve({
          hasSameNameFile: hasSameNameFile,
          file: tFiles === null || tFiles === void 0 ? void 0 : tFiles[0],
          files: tFiles,
          validateResult: {
            type: "FILTER_FILE_SAME_NAME"
          }
        });
        return;
      }
      var lengthOverLimit = false;
      if (max && tmpFiles.length && !params.isBatchUpload) {
        var tmpFilesLenToBeAdded = tmpFiles.length;
        tmpFiles = tmpFiles.slice(0, max - uploadValue.length);
        if (tmpFilesLenToBeAdded + uploadValue.length > max) {
          lengthOverLimit = true;
        }
      }
      var formattedFiles = formatToUploadFile(tmpFiles, params.format, params.autoUpload ? "progress" : "waiting");
      var allFileValidatePromise;
      if (params.beforeAllFilesUpload) {
        var _params$beforeAllFile;
        var r = (_params$beforeAllFile = params.beforeAllFilesUpload) === null || _params$beforeAllFile === void 0 ? void 0 : _params$beforeAllFile.call(params, formattedFiles);
        allFileValidatePromise = r instanceof Promise ? r : new Promise(function (resolve2) {
          return resolve2(r);
        });
      }
      var promiseList = formattedFiles.map(function (file) {
        return new Promise(function (resolve2) {
          handleBeforeUpload(file, {
            beforeUpload: params.beforeUpload,
            sizeLimit: params.sizeLimit
          }).then(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
              sizeResult = _ref2[0],
              customResult = _ref2[1];
            if (sizeResult) {
              resolve2({
                file: file,
                validateResult: {
                  type: "FILE_OVER_SIZE_LIMIT",
                  extra: sizeResult
                }
              });
            } else if (customResult === false) {
              resolve2({
                file: file,
                validateResult: {
                  type: "CUSTOM_BEFORE_UPLOAD"
                }
              });
            }
            resolve2({
              file: file
            });
          });
        });
      });
      Promise.all([allFileValidatePromise].concat(promiseList)).then(function (results) {
        var _results = _toArray(results),
          allFilesResult = _results[0],
          others = _results.slice(1);
        if (allFilesResult === false) {
          resolve({
            lengthOverLimit: lengthOverLimit,
            hasSameNameFile: hasSameNameFile,
            validateResult: {
              type: "BEFORE_ALL_FILES_UPLOAD"
            },
            files: formattedFiles
          });
        } else {
          resolve({
            lengthOverLimit: lengthOverLimit,
            hasSameNameFile: hasSameNameFile,
            fileValidateList: others,
            files: formattedFiles
          });
        }
      });
    });
  }
  function getFilesAndErrors(fileValidateList, getError) {
    var sizeLimitErrors = [];
    var beforeUploadErrorFiles = [];
    var toFiles = [];
    fileValidateList.forEach(function (oneFile) {
      var _oneFile$validateResu, _oneFile$validateResu2;
      if (((_oneFile$validateResu = oneFile.validateResult) === null || _oneFile$validateResu === void 0 ? void 0 : _oneFile$validateResu.type) === "CUSTOM_BEFORE_UPLOAD") {
        beforeUploadErrorFiles.push(oneFile.file);
        return;
      }
      if (((_oneFile$validateResu2 = oneFile.validateResult) === null || _oneFile$validateResu2 === void 0 ? void 0 : _oneFile$validateResu2.type) === "FILE_OVER_SIZE_LIMIT") {
        if (!oneFile.file.response) {
          oneFile.file.response = {};
        }
        oneFile.file.response.error = oneFile.file.response.error || getError(oneFile.validateResult.extra);
        sizeLimitErrors.push(oneFile);
        return;
      }
      toFiles.push(oneFile.file);
    });
    return {
      sizeLimitErrors: sizeLimitErrors,
      beforeUploadErrorFiles: beforeUploadErrorFiles,
      toFiles: toFiles
    };
  }
  function getTriggerTextField(p) {
    if (p.isBatchUpload && p.status) return "reupload";
    if (p.status === "fail") return "reupload";
    if (p.status === "progress") return "uploading";
    if (p.status === "success" || !p.autoUpload && p.status === "waiting") {
      return p.multiple ? "continueUpload" : "reupload";
    }
    return "fileInput";
  }
  function getDisplayFiles(params) {
    var multiple = params.multiple,
      uploadValue = params.uploadValue,
      toUploadFiles = params.toUploadFiles,
      autoUpload = params.autoUpload;
    var waitingUploadFiles = autoUpload ? toUploadFiles : toUploadFiles.filter(function (file) {
      return file.status !== "success";
    });
    if (multiple && !params.isBatchUpload) {
      if (!autoUpload) return uploadValue;
      return (waitingUploadFiles.length ? uploadValue.concat(waitingUploadFiles) : uploadValue) || [];
    }
    return (waitingUploadFiles.length ? waitingUploadFiles : uploadValue) || [];
  }

  function ownKeys$2(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function useUpload(props, context) {
    var inputRef = VueCompositionAPI.ref();
    var _toRefs = VueCompositionAPI.toRefs(props),
      autoUpload = _toRefs.autoUpload,
      isBatchUpload = _toRefs.isBatchUpload,
      multiple = _toRefs.multiple,
      value = _toRefs.value,
      defaultValue = _toRefs.defaultValue,
      files = _toRefs.files,
      defaultFiles = _toRefs.defaultFiles;
    var _useConfig = useConfig("upload"),
      global = _useConfig.global,
      t = _useConfig.t,
      classPrefix = _useConfig.classPrefix;
    var _useVModel = useVModel$1(value, defaultValue.value || defaultFiles.value, props.onChange, "change", "value", [{
        value: files,
        eventName: "change",
        propName: "files"
      }]),
      _useVModel2 = _slicedToArray(_useVModel, 2),
      uploadValue = _useVModel2[0],
      setUploadValue = _useVModel2[1];
    var xhrReq = VueCompositionAPI.ref([]);
    var toUploadFiles = VueCompositionAPI.ref([]);
    var sizeOverLimitMessage = VueCompositionAPI.ref("");
    var localeConfig = VueCompositionAPI.computed(function () {
      return merge$1({}, global.value, props.locale);
    });
    var innerDisabled = VueCompositionAPI.computed(function () {
      return props.disabled;
    });
    var tipsClasses = "".concat(classPrefix.value, "-upload__tips ").concat(classPrefix.value, "-size-s");
    var errorClasses = [tipsClasses].concat("".concat(classPrefix.value, "-upload__tips-error"));
    var placeholderClass = "".concat(classPrefix.value, "-upload__placeholder");
    var triggerUploadText = VueCompositionAPI.computed(function () {
      var _uploadValue$value;
      var field = getTriggerTextField({
        isBatchUpload: isBatchUpload.value,
        multiple: multiple.value,
        status: (_uploadValue$value = uploadValue.value) === null || _uploadValue$value === void 0 || (_uploadValue$value = _uploadValue$value[0]) === null || _uploadValue$value === void 0 ? void 0 : _uploadValue$value.status,
        autoUpload: autoUpload.value
      });
      return localeConfig.value.triggerUploadText[field];
    });
    var uploading = VueCompositionAPI.ref(false);
    var displayFiles = VueCompositionAPI.computed(function () {
      return getDisplayFiles({
        multiple: props.multiple,
        toUploadFiles: toUploadFiles.value,
        uploadValue: uploadValue.value,
        autoUpload: autoUpload.value,
        isBatchUpload: isBatchUpload.value
      });
    });
    var uploadFilePercent = function uploadFilePercent(params) {
      var file = params.file,
        percent = params.percent;
      var operationUploadFiles = autoUpload.value ? toUploadFiles : uploadValue;
      var index = operationUploadFiles.value.findIndex(function (item) {
        return file.raw === item.raw;
      });
      operationUploadFiles.value[index].percent = percent;
    };
    var updateFilesProgress = function updateFilesProgress() {
      if (props.autoUpload) {
        toUploadFiles.value = _toConsumableArray(toUploadFiles.value);
      }
    };
    var onResponseError = function onResponseError(p) {
      if (!p || !p.files || !p.files[0]) return;
      var response = p.response,
        event = p.event,
        files2 = p.files;
      if (props.multiple && !props.uploadAllFilesInOneRequest) {
        var _props$onOneFileFail;
        updateFilesProgress();
        var params = {
          e: event,
          file: files2 === null || files2 === void 0 ? void 0 : files2[0],
          currentFiles: files2,
          failedFiles: files2,
          response: response
        };
        (_props$onOneFileFail = props.onOneFileFail) === null || _props$onOneFileFail === void 0 || _props$onOneFileFail.call(props, params);
        context.emit("one-file-fail", params);
      }
      if (!props.multiple || props.isBatchUpload) {
        setUploadValue([], {
          trigger: "progress-fail",
          e: p.event,
          file: p.files[0]
        });
      }
    };
    var onResponseProgress = function onResponseProgress(p) {
      var _props$onProgress;
      updateFilesProgress();
      var params = {
        e: p.event,
        file: p.file,
        currentFiles: p.files,
        percent: p.percent,
        type: p.type,
        XMLHttpRequest: p.XMLHttpRequest
      };
      (_props$onProgress = props.onProgress) === null || _props$onProgress === void 0 || _props$onProgress.call(props, params);
      context.emit("progress", params);
    };
    var onResponseSuccess = function onResponseSuccess(p) {
      if (props.multiple && !props.uploadAllFilesInOneRequest) {
        var _props$onOneFileSucce;
        updateFilesProgress();
        var params = {
          e: p.event,
          file: p.files[0],
          response: p.response
        };
        (_props$onOneFileSucce = props.onOneFileSuccess) === null || _props$onOneFileSucce === void 0 || _props$onOneFileSucce.call(props, params);
        context.emit("one-file-success", params);
      }
    };
    function getSizeLimitError(sizeLimitObj) {
      var limit = sizeLimitObj;
      return limit.message ? t(limit.message, {
        sizeLimit: limit.size
      }) : "".concat(t(localeConfig.value.sizeLimitMessage, {
        sizeLimit: limit.size
      }), " ").concat(limit.unit);
    }
    var handleNotAutoUpload = function handleNotAutoUpload(toFiles) {
      var tmpFiles = props.multiple && !isBatchUpload.value ? uploadValue.value.concat(toFiles) : toFiles;
      if (!tmpFiles.length) return;
      setUploadValue(tmpFiles, {
        trigger: "add",
        index: uploadValue.value.length,
        file: toFiles[0],
        files: toFiles
      });
      toUploadFiles.value = [];
    };
    var onFileChange = function onFileChange(files2) {
      var _props$onSelectChange;
      if (innerDisabled.value) return;
      var params = {
        currentSelectedFiles: formatToUploadFile(_toConsumableArray(files2), props.format)
      };
      (_props$onSelectChange = props.onSelectChange) === null || _props$onSelectChange === void 0 || _props$onSelectChange.call(props, _toConsumableArray(files2), params);
      context.emit("select-change", _toConsumableArray(files2), params);
      validateFile({
        uploadValue: uploadValue.value,
        files: _toConsumableArray(files2),
        allowUploadDuplicateFile: props.allowUploadDuplicateFile,
        max: props.multiple ? props.max : 0,
        sizeLimit: props.sizeLimit,
        isBatchUpload: isBatchUpload.value,
        autoUpload: autoUpload.value,
        format: props.format,
        beforeUpload: props.beforeUpload,
        beforeAllFilesUpload: props.beforeAllFilesUpload
      }).then(function (args) {
        var _args$validateResult;
        if (((_args$validateResult = args.validateResult) === null || _args$validateResult === void 0 ? void 0 : _args$validateResult.type) === "BEFORE_ALL_FILES_UPLOAD") {
          var _props$onValidate;
          var params2 = {
            type: "BEFORE_ALL_FILES_UPLOAD",
            files: args.files
          };
          (_props$onValidate = props.onValidate) === null || _props$onValidate === void 0 || _props$onValidate.call(props, params2);
          context.emit("validate", params2);
          return;
        }
        if (args.lengthOverLimit) {
          var _props$onValidate2;
          var _params = {
            type: "FILES_OVER_LENGTH_LIMIT",
            files: args.files
          };
          (_props$onValidate2 = props.onValidate) === null || _props$onValidate2 === void 0 || _props$onValidate2.call(props, _params);
          context.emit("validate", _params);
          if (!args.files.length) return;
        }
        if (args.hasSameNameFile) {
          var _props$onValidate3;
          var _params2 = {
            type: "FILTER_FILE_SAME_NAME",
            files: args.files
          };
          (_props$onValidate3 = props.onValidate) === null || _props$onValidate3 === void 0 || _props$onValidate3.call(props, _params2);
          context.emit("validate", _params2);
        }
        if (args.fileValidateList instanceof Array) {
          var _props$onWaitingUploa;
          var _getFilesAndErrors = getFilesAndErrors(args.fileValidateList, getSizeLimitError),
            sizeLimitErrors = _getFilesAndErrors.sizeLimitErrors,
            beforeUploadErrorFiles = _getFilesAndErrors.beforeUploadErrorFiles,
            toFiles = _getFilesAndErrors.toFiles;
          var tmpWaitingFiles = autoUpload.value ? toFiles : toUploadFiles.value.concat(toFiles);
          toUploadFiles.value = tmpWaitingFiles;
          (_props$onWaitingUploa = props.onWaitingUploadFilesChange) === null || _props$onWaitingUploa === void 0 || _props$onWaitingUploa.call(props, {
            files: tmpWaitingFiles,
            trigger: "validate"
          });
          context.emit("waiting-upload-files-change", {
            files: tmpWaitingFiles,
            trigger: "validate"
          });
          if (sizeLimitErrors[0]) {
            var _props$onValidate4;
            sizeOverLimitMessage.value = sizeLimitErrors[0].file.response.error;
            (_props$onValidate4 = props.onValidate) === null || _props$onValidate4 === void 0 || _props$onValidate4.call(props, {
              type: "FILE_OVER_SIZE_LIMIT",
              files: sizeLimitErrors.map(function (t2) {
                return t2.file;
              })
            });
            context.emit("validate", {
              type: "FILE_OVER_SIZE_LIMIT",
              files: sizeLimitErrors.map(function (t2) {
                return t2.file;
              })
            });
          } else {
            sizeOverLimitMessage.value = "";
            if (beforeUploadErrorFiles.length) {
              var _props$onValidate5;
              var _params3 = {
                type: "CUSTOM_BEFORE_UPLOAD",
                files: beforeUploadErrorFiles
              };
              (_props$onValidate5 = props.onValidate) === null || _props$onValidate5 === void 0 || _props$onValidate5.call(props, _params3);
              context.emit("validate", _params3);
            }
          }
          if (autoUpload.value) {
            uploadFiles(tmpWaitingFiles);
          } else {
            handleNotAutoUpload(tmpWaitingFiles);
          }
        }
      });
      inputRef.value.value = null;
    };
    var onNormalFileChange = function onNormalFileChange(e) {
      var fileList = getFileList(e.target.files);
      onFileChange === null || onFileChange === void 0 || onFileChange(fileList);
    };
    function onDragFileChange(files2) {
      onFileChange === null || onFileChange === void 0 || onFileChange(files2);
    }
    function onPasteFileChange(e) {
      onFileChange === null || onFileChange === void 0 || onFileChange(_toConsumableArray(e.clipboardData.files));
    }
    function uploadFiles(toFiles) {
      var notUploadedFiles = uploadValue.value.filter(function (t2) {
        return t2.status !== "success";
      });
      var files2 = autoUpload.value ? toFiles || toUploadFiles.value : notUploadedFiles;
      if (!files2 || !files2.length) return;
      uploading.value = true;
      xhrReq.value = [];
      upload({
        action: props.action,
        headers: props.headers,
        method: props.method,
        name: props.name,
        withCredentials: props.withCredentials,
        uploadedFiles: uploadValue.value,
        toUploadFiles: files2,
        multiple: props.multiple,
        isBatchUpload: isBatchUpload.value,
        autoUpload: props.autoUpload,
        uploadAllFilesInOneRequest: props.uploadAllFilesInOneRequest,
        useMockProgress: props.useMockProgress,
        data: props.data,
        mockProgressDuration: props.mockProgressDuration,
        requestMethod: props.requestMethod,
        formatRequest: props.formatRequest,
        formatResponse: props.formatResponse,
        onResponseProgress: onResponseProgress,
        onResponseSuccess: onResponseSuccess,
        onResponseError: onResponseError,
        setXhrObject: function setXhrObject(xhr) {
          var _xhr$files$;
          if ((_xhr$files$ = xhr.files[0]) !== null && _xhr$files$ !== void 0 && _xhr$files$.raw && xhrReq.value.find(function (item) {
            var _item$files$;
            return ((_item$files$ = item.files[0]) === null || _item$files$ === void 0 ? void 0 : _item$files$.raw) === xhr.files[0].raw;
          })) return;
          xhrReq.value = xhrReq.value.concat(xhr);
        }
      }).then(function (_ref) {
        var status = _ref.status,
          data = _ref.data,
          list = _ref.list,
          failedFiles = _ref.failedFiles;
        uploading.value = false;
        if (status === "success") {
          var _props$onSuccess;
          if (props.autoUpload) {
            setUploadValue(_toConsumableArray(data.files), {
              trigger: "add",
              file: data.files[0]
            });
          }
          xhrReq.value = [];
          var params = {
            fileList: data.files,
            currentFiles: files2,
            file: files2[0],
            results: list === null || list === void 0 ? void 0 : list.map(function (t2) {
              return t2.data;
            }),
            response: data.response || list.map(function (t2) {
              return t2.data.response;
            }),
            XMLHttpRequest: data.XMLHttpRequest
          };
          (_props$onSuccess = props.onSuccess) === null || _props$onSuccess === void 0 || _props$onSuccess.call(props, params);
          context.emit("success", params);
        } else if (failedFiles !== null && failedFiles !== void 0 && failedFiles[0]) {
          var _props$onFail;
          var _params4 = {
            e: data.event,
            file: failedFiles[0],
            failedFiles: failedFiles,
            currentFiles: files2,
            response: data.response,
            XMLHttpRequest: data.XMLHttpRequest
          };
          (_props$onFail = props.onFail) === null || _props$onFail === void 0 || _props$onFail.call(props, _params4);
          context.emit("fail", _params4);
        }
        if (autoUpload.value) {
          var _props$onWaitingUploa2;
          toUploadFiles.value = failedFiles;
          (_props$onWaitingUploa2 = props.onWaitingUploadFilesChange) === null || _props$onWaitingUploa2 === void 0 || _props$onWaitingUploa2.call(props, {
            files: failedFiles,
            trigger: "uploaded"
          });
        }
      });
    }
    function onInnerRemove(p) {
      var _p$e$stopPropagation, _p$e, _props$onRemove;
      sizeOverLimitMessage.value = "";
      (_p$e$stopPropagation = (_p$e = p.e).stopPropagation) === null || _p$e$stopPropagation === void 0 || _p$e$stopPropagation.call(_p$e);
      var changePrams = {
        e: p.e,
        trigger: "remove",
        index: p.index,
        file: p.file
      };
      if (props.isBatchUpload || !props.multiple) {
        var _props$onWaitingUploa3;
        toUploadFiles.value = [];
        (_props$onWaitingUploa3 = props.onWaitingUploadFilesChange) === null || _props$onWaitingUploa3 === void 0 || _props$onWaitingUploa3.call(props, {
          files: [],
          trigger: "remove"
        });
        context.emit("waiting-upload-files-change", {
          files: [],
          trigger: "remove"
        });
        setUploadValue([], changePrams);
      } else if (!props.autoUpload) {
        uploadValue.value.splice(p.index, 1);
        setUploadValue(_toConsumableArray(uploadValue.value), changePrams);
      } else {
        if (p.index < uploadValue.value.length) {
          uploadValue.value.splice(p.index, 1);
          setUploadValue(_toConsumableArray(uploadValue.value), changePrams);
        } else {
          var _props$onWaitingUploa4;
          toUploadFiles.value.splice(p.index - uploadValue.value.length, 1);
          toUploadFiles.value = _toConsumableArray(toUploadFiles.value);
          (_props$onWaitingUploa4 = props.onWaitingUploadFilesChange) === null || _props$onWaitingUploa4 === void 0 || _props$onWaitingUploa4.call(props, {
            files: _toConsumableArray(toUploadFiles.value),
            trigger: "remove"
          });
          context.emit("waiting-upload-files-change", {
            files: _toConsumableArray(toUploadFiles.value),
            trigger: "remove"
          });
        }
      }
      (_props$onRemove = props.onRemove) === null || _props$onRemove === void 0 || _props$onRemove.call(props, p);
      context.emit("remove", p);
    }
    var triggerUpload = function triggerUpload(e) {
      var _e$stopPropagation;
      if (innerDisabled.value || !inputRef.value) return;
      e === null || e === void 0 || (_e$stopPropagation = e.stopPropagation) === null || _e$stopPropagation === void 0 || _e$stopPropagation.call(e);
      inputRef.value.click();
    };
    var innerCancelUpload = function innerCancelUpload() {
      var _props$onCancelUpload;
      (_props$onCancelUpload = props.onCancelUpload) === null || _props$onCancelUpload === void 0 || _props$onCancelUpload.call(props);
      context.emit("cancel-upload");
    };
    var cancelUpload = function cancelUpload(context2) {
      var _context2$e, _context2$e$stopPropa, _xhrReq$value;
      (_context2$e = context2.e) === null || _context2$e === void 0 || (_context2$e$stopPropa = _context2$e.stopPropagation) === null || _context2$e$stopPropa === void 0 || _context2$e$stopPropa.call(_context2$e);
      (_xhrReq$value = xhrReq.value) === null || _xhrReq$value === void 0 || _xhrReq$value.forEach(function (item) {
        var _item$xhrReq;
        (_item$xhrReq = item.xhrReq) === null || _item$xhrReq === void 0 || _item$xhrReq.abort();
      });
      uploading.value = false;
      if (autoUpload.value) {
        toUploadFiles.value = [];
      } else {
        setUploadValue(uploadValue.value.map(function (item) {
          if (item.status !== "success") {
            return _objectSpread$2(_objectSpread$2({}, item), {}, {
              status: "waiting"
            });
          }
          return item;
        }), {
          trigger: "abort"
        });
      }
      if (context2 !== null && context2 !== void 0 && context2.file && !autoUpload.value) {
        onInnerRemove === null || onInnerRemove === void 0 || onInnerRemove({
          file: context2.file,
          e: context2.e,
          index: 0
        });
      }
      innerCancelUpload();
    };
    var onInnerPreview = function onInnerPreview(p) {
      var _props$onPreview;
      (_props$onPreview = props.onPreview) === null || _props$onPreview === void 0 || _props$onPreview.call(props, p);
      context.emit("preview", p);
    };
    return {
      t: t,
      localeConfig: localeConfig,
      classPrefix: classPrefix,
      triggerUploadText: triggerUploadText,
      toUploadFiles: toUploadFiles,
      uploadValue: uploadValue,
      displayFiles: displayFiles,
      sizeOverLimitMessage: sizeOverLimitMessage,
      uploading: uploading,
      tipsClasses: tipsClasses,
      errorClasses: errorClasses,
      placeholderClass: placeholderClass,
      inputRef: inputRef,
      innerDisabled: innerDisabled,
      xhrReq: xhrReq,
      uploadFiles: uploadFiles,
      uploadFilePercent: uploadFilePercent,
      onFileChange: onFileChange,
      onNormalFileChange: onNormalFileChange,
      onDragFileChange: onDragFileChange,
      onInnerRemove: onInnerRemove,
      triggerUpload: triggerUpload,
      cancelUpload: cancelUpload,
      onInnerPreview: onInnerPreview,
      innerCancelUpload: innerCancelUpload,
      onPasteFileChange: onPasteFileChange
    };
  }

  function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var CustomFile = VueCompositionAPI.defineComponent({
    name: "UploadCustomFile",
    props: _objectSpread$1(_objectSpread$1({}, commonProps), {}, {
      dragEvents: Object,
      draggable: Boolean,
      dragContent: Function,
      trigger: Function,
      triggerUpload: Function,
      childrenNode: Function
    }),
    setup: function setup(props) {
      var _toRefs = VueCompositionAPI.toRefs(props),
        accept = _toRefs.accept;
      var drag = useDrag(props.dragEvents, accept);
      var dragActive = drag.dragActive;
      return _objectSpread$1({
        dragActive: dragActive
      }, drag);
    },
    render: function render() {
      var _this = this,
        _this$$scopedSlots$de,
        _this$$scopedSlots;
      var h = arguments[0];
      var renderDragContent = function renderDragContent() {
        var params = {
          dragActive: _this.dragActive || false,
          files: _this.displayFiles
        };
        return h("div", {
          "class": "".concat(_this.classPrefix, "-upload__dragger ").concat(_this.classPrefix, "-upload__dragger-center"),
          "on": {
            "drop": _this.handleDrop,
            "dragenter": _this.handleDragenter,
            "dragover": _this.handleDragover,
            "dragleave": _this.handleDragleave,
            "click": _this.triggerUpload
          }
        }, [h("div", {
          "class": "".concat(_this.classPrefix, "-upload__trigger")
        }, [renderContent(_this, "dragContent", "trigger", {
          params: params
        }) || isFunction(_this.childrenNode) && _this.childrenNode(params)])]);
      };
      return this.draggable ? renderDragContent() : h("div", {
        "class": "".concat(this.classPrefix, "-upload__trigger"),
        "on": {
          "click": this.triggerUpload
        }
      }, [isFunction(this.childrenNode) && this.childrenNode({
        files: this.displayFiles
      }) || ((_this$$scopedSlots$de = (_this$$scopedSlots = this.$scopedSlots)["default"]) === null || _this$$scopedSlots$de === void 0 ? void 0 : _this$$scopedSlots$de.call(_this$$scopedSlots, null))]);
    }
  });

  function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty$2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _Upload = VueCompositionAPI.defineComponent({
    name: "TUpload",
    props: props,
    setup: function setup(props2, context) {
      var uploadData = useUpload(props2, context);
      var _useFormDisabled = useFormDisabled(),
        formDisabled = _useFormDisabled.formDisabled;
      var localeConfig = uploadData.localeConfig,
        classPrefix = uploadData.classPrefix,
        toUploadFiles = uploadData.toUploadFiles,
        displayFiles = uploadData.displayFiles,
        uploadValue = uploadData.uploadValue,
        sizeOverLimitMessage = uploadData.sizeOverLimitMessage,
        uploading = uploadData.uploading,
        tipsClasses = uploadData.tipsClasses,
        errorClasses = uploadData.errorClasses,
        placeholderClass = uploadData.placeholderClass,
        innerDisabled = uploadData.innerDisabled,
        onInnerRemove = uploadData.onInnerRemove,
        onDragFileChange = uploadData.onDragFileChange,
        onPasteFileChange = uploadData.onPasteFileChange;
      var tDisabled = VueCompositionAPI.computed(function () {
        return formDisabled.value || innerDisabled.value;
      });
      var icons = useGlobalIcon({
        UploadIcon: TdUploadIcon
      });
      var commonDisplayFileProps = VueCompositionAPI.computed(function () {
        return {
          accept: props2.accept,
          files: uploadValue.value,
          toUploadFiles: toUploadFiles.value,
          displayFiles: displayFiles.value,
          theme: props2.theme,
          placeholder: props2.placeholder,
          disabled: tDisabled.value,
          tips: props2.tips,
          status: props2.status,
          sizeOverLimitMessage: sizeOverLimitMessage.value,
          uploading: uploading.value,
          classPrefix: classPrefix.value,
          tipsClasses: tipsClasses,
          errorClasses: errorClasses,
          placeholderClass: placeholderClass,
          locale: localeConfig.value,
          autoUpload: props2.autoUpload,
          showUploadProgress: props2.showUploadProgress,
          abridgeName: props2.abridgeName,
          imageViewerProps: props2.imageViewerProps,
          fileListDisplay: props2.fileListDisplay,
          onRemove: onInnerRemove
        };
      });
      var dragProps = VueCompositionAPI.computed(function () {
        return {
          onDragFileChange: onDragFileChange,
          onDragenter: function onDragenter(p) {
            var _props2$onDragenter;
            (_props2$onDragenter = props2.onDragenter) === null || _props2$onDragenter === void 0 || _props2$onDragenter.call(props2, p);
            context.emit("dragenter", p);
          },
          onDragleave: function onDragleave(p) {
            var _props2$onDragleave;
            (_props2$onDragleave = props2.onDragleave) === null || _props2$onDragleave === void 0 || _props2$onDragleave.call(props2, p);
            context.emit("dragleave", p);
          },
          onDrop: function onDrop(p) {
            var _props2$onDrop;
            (_props2$onDrop = props2.onDrop) === null || _props2$onDrop === void 0 || _props2$onDrop.call(props2, p);
            context.emit("drop", p);
          }
        };
      });
      var uploadClasses = VueCompositionAPI.computed(function () {
        return ["".concat(classPrefix.value, "-upload"), _defineProperty$2({}, "".concat(classPrefix.value, "-upload--theme-").concat(props2.theme), props2.theme === "file-input")];
      });
      var handlePasteFileChange = function handlePasteFileChange(e) {
        if (props2.uploadPastedFiles) {
          onPasteFileChange(e);
        }
      };
      return _objectSpread(_objectSpread({}, uploadData), {}, {
        handlePasteFileChange: handlePasteFileChange,
        commonDisplayFileProps: commonDisplayFileProps,
        dragProps: dragProps,
        uploadClasses: uploadClasses,
        sizeOverLimitMessage: sizeOverLimitMessage,
        tDisabled: tDisabled,
        icons: icons
      });
    },
    methods: {
      renderTrigger: function renderTrigger() {
        var _this = this;
        var h = this.$createElement;
        var UploadIcon = this.icons.UploadIcon;
        var getDefaultTrigger = function getDefaultTrigger() {
          if (_this.theme === "file-input") {
            return h(Button, helper([{
              "attrs": {
                "disabled": _this.tDisabled,
                "variant": "outline"
              }
            }, {
              "props": _this.triggerButtonProps
            }]), [_this.triggerUploadText]);
          }
          return h(Button, helper([{
            "attrs": {
              "disabled": _this.tDisabled,
              "variant": "outline",
              "icon": function icon() {
                return h(UploadIcon);
              }
            }
          }, {
            "props": _this.triggerButtonProps
          }]), [_this.triggerUploadText]);
        };
        return renderContent(this, "default", "trigger", {
          params: {
            dragActive: false,
            files: this.uploadValue,
            disabled: this.tDisabled
          }
        }) || getDefaultTrigger();
      },
      getNormalFileNode: function getNormalFileNode() {
        var h = this.$createElement;
        return h(NormalFile, helper([{}, {
          "props": this.commonDisplayFileProps
        }, {
          "attrs": {
            "multiple": this.multiple
          },
          "scopedSlots": {
            fileListDisplay: this.$scopedSlots.fileListDisplay,
            "file-list-display": this.$scopedSlots["file-list-display"]
          }
        }]), [h("div", {
          "class": "".concat(this.classPrefix, "-upload__trigger"),
          "on": {
            "click": this.triggerUpload
          }
        }, [this.renderTrigger()])]);
      },
      getSingleFileDraggerUploadNode: function getSingleFileDraggerUploadNode() {
        var h = this.$createElement;
        return h(DraggerFile, helper([{}, {
          "props": this.commonDisplayFileProps
        }, {
          "attrs": {
            "dragEvents": this.dragProps,
            "trigger": this.trigger,
            "cancelUpload": this.cancelUpload,
            "triggerUpload": this.triggerUpload,
            "uploadFiles": this.uploadFiles
          },
          "on": {
            "cancelUpload": this.innerCancelUpload
          },
          "scopedSlots": {
            fileListDisplay: this.$scopedSlots.fileListDisplay,
            "file-list-display": this.$scopedSlots["file-list-display"]
          }
        }]));
      },
      getImageCardUploadNode: function getImageCardUploadNode() {
        var h = this.$createElement;
        return h(ImageCard, helper([{}, {
          "props": this.commonDisplayFileProps
        }, {
          "attrs": {
            "multiple": this.multiple,
            "max": this.max,
            "showUploadProgress": this.showUploadProgress,
            "triggerUpload": this.triggerUpload,
            "uploadFiles": this.uploadFiles,
            "cancelUpload": this.cancelUpload,
            "showImageFileName": this.showImageFileName
          }
        }, {
          "on": {
            preview: this.onInnerPreview
          }
        }, {
          "scopedSlots": {
            fileListDisplay: this.$scopedSlots.fileListDisplay,
            "file-list-display": this.$scopedSlots["file-list-display"]
          }
        }]));
      },
      getFlowListNode: function getFlowListNode() {
        var h = this.$createElement;
        return h(MultipleFlowList, helper([{}, {
          "props": this.commonDisplayFileProps
        }, {
          "attrs": {
            "isBatchUpload": this.isBatchUpload,
            "draggable": this.draggable,
            "dragEvents": this.dragProps,
            "uploadFiles": this.uploadFiles,
            "cancelUpload": this.cancelUpload,
            "showThumbnail": this.showThumbnail,
            "showImageFileName": this.showImageFileName,
            "uploadButton": this.uploadButton,
            "cancelUploadButton": this.cancelUploadButton
          },
          "on": {
            "preview": this.onInnerPreview
          },
          "scopedSlots": {
            fileListDisplay: this.$scopedSlots.fileListDisplay,
            "file-list-display": this.$scopedSlots["file-list-display"],
            uploadButton: this.$scopedSlots.uploadButton,
            "upload-button": this.$scopedSlots["upload-button"],
            cancelUploadButton: this.$scopedSlots.cancelUploadButton,
            "cancel-upload-button": this.$scopedSlots["cancel-upload-button"]
          }
        }]), [h("div", {
          "class": "".concat(this.classPrefix, "-upload__trigger"),
          "on": {
            "click": this.triggerUpload
          }
        }, [this.renderTrigger()])]);
      },
      getCustomFile: function getCustomFile() {
        var h = this.$createElement;
        return h(CustomFile, helper([{}, {
          "props": this.commonDisplayFileProps
        }, {
          "attrs": {
            "draggable": this.draggable,
            "dragContent": this.dragContent,
            "dragEvents": this.dragProps,
            "triggerUpload": this.triggerUpload,
            "trigger": this.trigger,
            "childrenNode": this.$scopedSlots["default"]
          },
          "scopedSlots": {
            dragContent: this.$scopedSlots.dragContent,
            "drag-content": this.$scopedSlots["drag-content"],
            trigger: this.$scopedSlots.trigger
          }
        }]), [!this.draggable && this.renderTrigger()]);
      }
    },
    render: function render() {
      var h = arguments[0];
      return h("div", {
        "class": this.uploadClasses,
        "on": {
          "paste": this.handlePasteFileChange
        }
      }, [h("input", helper([{
        "ref": "inputRef",
        "attrs": {
          "type": "file",
          "disabled": this.tDisabled,
          "multiple": this.multiple,
          "accept": this.accept,
          "hidden": true
        },
        "on": {
          "change": this.onNormalFileChange
        }
      }, {
        "attrs": this.inputAttributes
      }])), ["file", "file-input"].includes(this.theme) && !this.draggable && this.getNormalFileNode(), ["file", "image"].includes(this.theme) && this.draggable && this.getSingleFileDraggerUploadNode(), this.theme === "image" && !this.draggable && this.getImageCardUploadNode(), ["image-flow", "file-flow"].includes(this.theme) && this.getFlowListNode(), this.theme === "custom" && this.getCustomFile(), Boolean(this.tips || this.$scopedSlots.tips) && h("small", {
        "class": [this.tipsClasses, _defineProperty$2({}, "".concat(this.classPrefix, "-upload__tips-").concat(this.status), this.status)]
      }, [renderTNodeJSX(this, "tips")]), this.sizeOverLimitMessage && h("small", {
        "class": this.errorClasses
      }, [this.sizeOverLimitMessage])]);
    }
  });

  var Upload = withInstall$1(_Upload, VueCompositionAPI__default["default"]);

  var ConfigProvider = withInstall$1(ConfigProvider$1);

  var components = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Button: Button,
    Icon: Icon,
    Link: Link,
    Col: Col,
    Row: Row,
    Aside: Aside,
    Layout: Layout,
    Header: Header,
    Footer: Footer,
    Content: Content,
    Divider: Divider,
    Space: Space,
    Affix: Affix,
    Anchor: Anchor,
    AnchorItem: AnchorItem,
    AnchorTarget: AnchorTarget,
    BackTop: BackTop,
    BreadcrumbItem: BreadcrumbItem,
    Breadcrumb: Breadcrumb,
    Dropdown: Dropdown,
    DropdownItem: DropdownItem,
    DropdownMenu: DropdownMenu,
    Menu: Menu,
    HeadMenu: HeadMenu,
    Submenu: Submenu,
    MenuItem: MenuItem,
    MenuGroup: MenuGroup,
    Pagination: Pagination,
    PaginationMini: PaginationMini,
    StepItem: StepItem,
    Steps: Steps,
    StickyItem: StickyItem,
    StickyTool: StickyTool,
    Tabs: Tabs,
    TabPanel: TabPanel,
    AutoComplete: AutoComplete,
    HighlightOption: HighlightOption,
    Cascader: Cascader,
    CascaderPanel: CascaderPanel,
    Checkbox: Checkbox,
    CheckboxGroup: CheckboxGroup,
    ColorPickerPanel: ColorPickerPanel,
    ColorPicker: ColorPicker,
    DatePicker: DatePicker,
    DatePickerPanel: DatePickerPanel,
    DateRangePicker: DateRangePicker,
    DateRangePickerPanel: DateRangePickerPanel,
    Form: Form,
    FormItem: FormItem,
    InputAdornment: InputAdornment,
    Input: Input,
    InputGroup: InputGroup,
    RangeInput: RangeInput,
    RangeInputPopup: RangeInputPopup,
    InputNumber: InputNumber,
    Radio: Radio,
    RadioGroup: RadioGroup,
    RadioButton: RadioButton,
    Select: Select,
    Option: Option,
    OptionGroup: OptionGroup,
    Slider: Slider,
    Switch: Switch,
    TagInput: TagInput,
    SelectInput: SelectInput,
    Textarea: Textarea,
    Transfer: Transfer,
    KeyboardDirection: KeyboardDirection,
    EPickerCols: EPickerCols,
    TimePicker: TimePicker,
    TimeRangePicker: TimeRangePicker,
    TimePickerPanel: TimePickerPanel,
    TreeSelect: TreeSelect,
    Avatar: Avatar,
    AvatarGroup: AvatarGroup,
    Badge: Badge,
    Calendar: Calendar,
    Card: Card,
    Comment: Comment,
    Descriptions: Descriptions,
    DescriptionsItem: DescriptionsItem,
    Empty: Empty,
    Image: Image$1,
    ImageViewer: ImageViewer,
    List: List,
    ListItem: ListItem,
    ListItemMeta: ListItemMeta,
    LoadingPlugin: LoadingPlugin,
    LoadingDirective: vLoading,
    Loading: Loading,
    Progress: Progress,
    Skeleton: Skeleton,
    Statistic: Statistic,
    Swiper: Swiper,
    SwiperItem: SwiperItem,
    BaseTable: BaseTable,
    PrimaryTable: PrimaryTable,
    EnhancedTable: EnhancedTable,
    Table: Table,
    Tag: Tag,
    CheckTag: CheckTag,
    CheckTagGroup: CheckTagGroup,
    Tooltip: Tooltip,
    Tree: Tree,
    Watermark: Watermark,
    Collapse: Collapse,
    CollapsePanel: CollapsePanel,
    Rate: Rate,
    Timeline: Timeline,
    TimelineItem: TimelineItem,
    Alert: Alert,
    DialogPlugin: DialogPlugin,
    Dialog: Dialog,
    Drawer: Drawer,
    Guide: Guide,
    MessagePlugin: MessagePlugin,
    message: message,
    Message: Message,
    NotificationPlugin: NotificationPlugin,
    notify: notify,
    NotifyPlugin: NotifyPlugin,
    Notification: Notification,
    Popconfirm: Popconfirm,
    createPopupPlugin: createPopupPlugin,
    PopupPlugin: PopupPlugin,
    Popup: Popup,
    Upload: Upload,
    ConfigProvider: ConfigProvider
  });

  function install(Vue, config) {
    if (Vue._installedPlugins.indexOf(VueCompositionAPI__default["default"]) === -1) {
      Vue.use(VueCompositionAPI__default["default"]);
    }
    Object.keys(components).forEach(function (key) {
      if (components[key]) {
        if (/directive/i.test(key)) return;
        /plugin/i.test(key) ? Vue.use(components[key]) : Vue.use(components[key], config);
      }
    });
  }
  if (typeof window !== "undefined" && window.Vue) {
    install(window.Vue);
  }
  var tdesign = {
    install: install,
    version: "1.11.0"
  };

  if (typeof console !== "undefined" && console.warn && typeof window !== "undefined") {
    console.warn("You are using a whole package of TDesign!");
  }

  exports.Affix = Affix;
  exports.Alert = Alert;
  exports.Anchor = Anchor;
  exports.AnchorItem = AnchorItem;
  exports.AnchorTarget = AnchorTarget;
  exports.Aside = Aside;
  exports.AutoComplete = AutoComplete;
  exports.Avatar = Avatar;
  exports.AvatarGroup = AvatarGroup;
  exports.BackTop = BackTop;
  exports.Badge = Badge;
  exports.BaseTable = BaseTable;
  exports.Breadcrumb = Breadcrumb;
  exports.BreadcrumbItem = BreadcrumbItem;
  exports.Button = Button;
  exports.Calendar = Calendar;
  exports.Card = Card;
  exports.Cascader = Cascader;
  exports.CascaderPanel = CascaderPanel;
  exports.CheckTag = CheckTag;
  exports.CheckTagGroup = CheckTagGroup;
  exports.Checkbox = Checkbox;
  exports.CheckboxGroup = CheckboxGroup;
  exports.Col = Col;
  exports.Collapse = Collapse;
  exports.CollapsePanel = CollapsePanel;
  exports.ColorPicker = ColorPicker;
  exports.ColorPickerPanel = ColorPickerPanel;
  exports.Comment = Comment;
  exports.ConfigProvider = ConfigProvider;
  exports.Content = Content;
  exports.DatePicker = DatePicker;
  exports.DatePickerPanel = DatePickerPanel;
  exports.DateRangePicker = DateRangePicker;
  exports.DateRangePickerPanel = DateRangePickerPanel;
  exports.Descriptions = Descriptions;
  exports.DescriptionsItem = DescriptionsItem;
  exports.Dialog = Dialog;
  exports.DialogPlugin = DialogPlugin;
  exports.Divider = Divider;
  exports.Drawer = Drawer;
  exports.Dropdown = Dropdown;
  exports.DropdownItem = DropdownItem;
  exports.DropdownMenu = DropdownMenu;
  exports.EPickerCols = EPickerCols;
  exports.Empty = Empty;
  exports.EnhancedTable = EnhancedTable;
  exports.Footer = Footer;
  exports.Form = Form;
  exports.FormItem = FormItem;
  exports.Guide = Guide;
  exports.HeadMenu = HeadMenu;
  exports.Header = Header;
  exports.HighlightOption = HighlightOption;
  exports.Icon = Icon;
  exports.Image = Image$1;
  exports.ImageViewer = ImageViewer;
  exports.Input = Input;
  exports.InputAdornment = InputAdornment;
  exports.InputGroup = InputGroup;
  exports.InputNumber = InputNumber;
  exports.KeyboardDirection = KeyboardDirection;
  exports.Layout = Layout;
  exports.Link = Link;
  exports.List = List;
  exports.ListItem = ListItem;
  exports.ListItemMeta = ListItemMeta;
  exports.Loading = Loading;
  exports.LoadingDirective = vLoading;
  exports.LoadingPlugin = LoadingPlugin;
  exports.Menu = Menu;
  exports.MenuGroup = MenuGroup;
  exports.MenuItem = MenuItem;
  exports.Message = Message;
  exports.MessagePlugin = MessagePlugin;
  exports.Notification = Notification;
  exports.NotificationPlugin = NotificationPlugin;
  exports.NotifyPlugin = NotifyPlugin;
  exports.Option = Option;
  exports.OptionGroup = OptionGroup;
  exports.Pagination = Pagination;
  exports.PaginationMini = PaginationMini;
  exports.Popconfirm = Popconfirm;
  exports.Popup = Popup;
  exports.PopupPlugin = PopupPlugin;
  exports.PrimaryTable = PrimaryTable;
  exports.Progress = Progress;
  exports.Radio = Radio;
  exports.RadioButton = RadioButton;
  exports.RadioGroup = RadioGroup;
  exports.RangeInput = RangeInput;
  exports.RangeInputPopup = RangeInputPopup;
  exports.Rate = Rate;
  exports.Row = Row;
  exports.Select = Select;
  exports.SelectInput = SelectInput;
  exports.Skeleton = Skeleton;
  exports.Slider = Slider;
  exports.Space = Space;
  exports.Statistic = Statistic;
  exports.StepItem = StepItem;
  exports.Steps = Steps;
  exports.StickyItem = StickyItem;
  exports.StickyTool = StickyTool;
  exports.Submenu = Submenu;
  exports.Swiper = Swiper;
  exports.SwiperItem = SwiperItem;
  exports.Switch = Switch;
  exports.TabPanel = TabPanel;
  exports.Table = Table;
  exports.Tabs = Tabs;
  exports.Tag = Tag;
  exports.TagInput = TagInput;
  exports.Textarea = Textarea;
  exports.TimePicker = TimePicker;
  exports.TimePickerPanel = TimePickerPanel;
  exports.TimeRangePicker = TimeRangePicker;
  exports.Timeline = Timeline;
  exports.TimelineItem = TimelineItem;
  exports.Tooltip = Tooltip;
  exports.Transfer = Transfer;
  exports.Tree = Tree;
  exports.TreeSelect = TreeSelect;
  exports.Upload = Upload;
  exports.Watermark = Watermark;
  exports.createPopupPlugin = createPopupPlugin;
  exports["default"] = tdesign;
  exports.message = message;
  exports.notify = notify;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=tdesign.js.map
